import type { Country } from '../../../src/helpers/country-codes'
import type { AppCurrency } from '../../../src/plugins/currency'
import type { Decimal } from '../../../src/types/decimal'
import type { Email } from '../../../src/types/email'
import type { Locale } from '../../../src/i18n/index'
import type { PhoneNumber } from '../../../src/types/phoneNumber'
import type { Time } from '../../../src/types/time'
import { cacheExchange } from '@urql/exchange-graphcache'
import type {
    Resolver as GraphCacheResolver,
    UpdateResolver as GraphCacheUpdateResolver,
    OptimisticMutationResolver as GraphCacheOptimisticMutationResolver,
} from '@urql/exchange-graphcache'

import type { DocumentNode } from 'graphql'
import * as Urql from '@urql/vue'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
    [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
    T extends { [key: string]: unknown },
    K extends keyof T,
> = { [_ in K]?: never }
export type Incremental<T> =
    | T
    | {
          [P in keyof T]?: P extends ' $fragmentName' | '__typename'
              ? T[P]
              : never
      }
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: { input: string; output: string }
    String: { input: string; output: string }
    Boolean: { input: boolean; output: boolean }
    Int: { input: number; output: number }
    Float: { input: number; output: number }
    CatalogueCode: { input: any; output: any }
    Country: { input: Country; output: Country }
    CountrySubdivision: { input: any; output: any }
    Currency: { input: AppCurrency; output: AppCurrency }
    Date: { input: string; output: string }
    DateTime: { input: string; output: string }
    Decimal: { input: Decimal; output: Decimal }
    Email: { input: Email; output: Email }
    GemsApi_StoneIdentifier: { input: string; output: string }
    GemsApi_Uri: { input: any; output: any }
    JSON: {
        input: Record<string | number, unknown>
        output: Record<string | number, unknown>
    }
    Locale: { input: Locale; output: Locale }
    PhoneNumber: { input: PhoneNumber; output: PhoneNumber }
    RenderableTemplate: { input: string; output: string }
    Time: { input: Time; output: Time }
    Upload: { input: any; output: any }
    Uri: { input: string; output: string }
    Void: { input: any; output: any }
}

export type AddToCartReadyToGoRingExistingCustomerResponse =
    AddToCartReadyToGoRingSuccessExistingCustomer

export type AddToCartReadyToGoRingInput = {
    baseInput?: InputMaybe<EnquiryBaseInput>
    catalogueReadyToGoRingCode: Scalars['CatalogueCode']['input']
    commissionJunction?: InputMaybe<CommissionJunctionInput>
    recommendedRingSizeId?: InputMaybe<Scalars['ID']['input']>
    uri: Scalars['Uri']['input']
}

export type AddToCartReadyToGoRingNewCustomerResponse =
    AddToCartReadyToGoRingSuccessNewCustomer

export type AddToCartReadyToGoRingSuccessExistingCustomer = {
    __typename: 'AddToCartReadyToGoRingSuccessExistingCustomer'
    order: Order
    product: OrderProduct
}

export type AddToCartReadyToGoRingSuccessNewCustomer = {
    __typename: 'AddToCartReadyToGoRingSuccessNewCustomer'
    customer: CustomerRegistrationResponse
    order: Order
    product: OrderProduct
}

export type Address = {
    __typename: 'Address'
    country: Maybe<Scalars['Country']['output']>
    phoneNumber: Maybe<PhoneNumberType>
}

export type AffirmCheckoutObjectInput = {
    cancelUrl: Scalars['Uri']['input']
    confirmationUrl: Scalars['Uri']['input']
}

export type AffirmCompleteTransactionInput = {
    /** checkoutToken=null means declined */
    checkoutToken?: InputMaybe<Scalars['String']['input']>
    transactionId: Scalars['ID']['input']
}

export type AffirmCompleteTransactionResponse = {
    __typename: 'AffirmCompleteTransactionResponse'
    errors: Array<Scalars['String']['output']>
    order: Order
}

export type AffirmFinanceOption = {
    __typename: 'AffirmFinanceOption'
    months: Scalars['Int']['output']
    perMonth: Money
    price: Money
}

export type AffirmPaymentInput = {
    transactionId: Scalars['ID']['input']
}

export type AffirmPaymentMethod = {
    __typename: 'AffirmPaymentMethod'
    publicKey: Scalars['String']['output']
    scriptUrl: Scalars['String']['output']
    systemCode: Scalars['ID']['output']
}

export type AffirmPaymentResponse = {
    __typename: 'AffirmPaymentResponse'
    errors: Array<Scalars['String']['output']>
    order: Order
}

export type AffirmTransaction = TransactionInterface & {
    __typename: 'AffirmTransaction'
    amount: Money
    /** After decoding you need to set .items.item_url to the product url */
    checkoutObject: Scalars['JSON']['output']
    createdAt: Scalars['DateTime']['output']
    id: Scalars['ID']['output']
    status: TransactionStatus
}

export type AffirmTransactionCheckoutObjectArgs = {
    input: AffirmCheckoutObjectInput
}

export type AffirmTransactionInput = {
    orderId: Scalars['ID']['input']
}

export type AllocationPaymentMethod = {
    __typename: 'AllocationPaymentMethod'
    maxAmount: Money
    systemCode: Scalars['ID']['output']
}

export type AllocationTransaction = TransactionInterface & {
    __typename: 'AllocationTransaction'
    amount: Money
    createdAt: Scalars['DateTime']['output']
    id: Scalars['ID']['output']
    status: TransactionStatus
}

export type AllocationTransactionInput = {
    amount: Scalars['Decimal']['input']
    orderId: Scalars['ID']['input']
}

export type ArticleGridItem = {
    __typename: 'ArticleGridItem'
    description: Scalars['String']['output']
    image: Image
    link: Link
    title: Scalars['String']['output']
}

export type ArticlePreview = {
    __typename: 'ArticlePreview'
    image: Image
    link: Link
    subtitle: Scalars['String']['output']
    title: Scalars['String']['output']
}

export type Asset = {
    __typename: 'Asset'
    id: Scalars['ID']['output']
    mimeType: Scalars['String']['output']
    size: MonolithImageSize
    sources: Array<ImageSrc>
    url: Scalars['String']['output']
}

export type AssetSizeArgs = {
    name: MonolithImageSizeName
}

export type Author = {
    __typename: 'Author'
    id: Scalars['ID']['output']
    image: Image
    name: Scalars['String']['output']
    postAggregation: PostsAggregation
    posts: Array<Post>
    slug: Scalars['String']['output']
}

export type AuthorPostAggregationArgs = {
    locale: Scalars['Locale']['input']
}

export type AuthorPostsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    locale: Scalars['Locale']['input']
    page?: InputMaybe<Scalars['Int']['input']>
}

export type AuthorsAggregation = {
    __typename: 'AuthorsAggregation'
    count: Scalars['Int']['output']
}

export type AvatarStackItem = {
    __typename: 'AvatarStackItem'
    image: Image
}

export type AvataxAddressInvalidError = {
    __typename: 'AvataxAddressInvalidError'
    message: Scalars['String']['output']
}

export type BankPaymentMethod = {
    __typename: 'BankPaymentMethod'
    systemCode: Scalars['ID']['output']
}

export type BankTransaction = TransactionInterface & {
    __typename: 'BankTransaction'
    amount: Money
    createdAt: Scalars['DateTime']['output']
    id: Scalars['ID']['output']
    status: TransactionStatus
}

export type Banner1 = {
    __typename: 'Banner1'
    backgroundColor: Color
    backgroundImage: Maybe<Image>
    button: Maybe<ComponentButton>
    preTitle: Maybe<Scalars['String']['output']>
    text: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type Banner2 = {
    __typename: 'Banner2'
    backgroundColor: Color
    button: Maybe<ComponentButton>
    image: Maybe<Image>
    preTitle: Maybe<Scalars['String']['output']>
    text: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export const BannerSkinnyBackgroundGraphic = {
    Graphic1: 'GRAPHIC1',
    Graphic2: 'GRAPHIC2',
    Graphic3: 'GRAPHIC3',
    Graphic4: 'GRAPHIC4',
    None: 'NONE',
} as const

export type BannerSkinnyBackgroundGraphic =
    (typeof BannerSkinnyBackgroundGraphic)[keyof typeof BannerSkinnyBackgroundGraphic]
export type Block = {
    __typename: 'Block'
    anchor: Maybe<BlockAnchor>
    backgroundColor: Color
    backgroundOverflow: Scalars['Boolean']['output']
    collapsibleTitle: Maybe<Scalars['String']['output']>
    components: Array<Component>
    display: Display
    isCollapsible: Scalars['Boolean']['output']
    isOpenByDefault: Scalars['Boolean']['output']
    verticalSpacing: VerticalSpacing
    width: Width
}

export type BlockAnchor = {
    __typename: 'BlockAnchor'
    slug: Scalars['String']['output']
    title: Scalars['String']['output']
}

export type BookingCancelConsultationInput = {
    id: Scalars['ID']['input']
}

export type BookingConsultation = {
    __typename: 'BookingConsultation'
    canBeCancelled: Scalars['Boolean']['output']
    consultant: Maybe<Consultant>
    consultationRoom: Maybe<BookingConsultationRoom>
    customer: Maybe<Customer>
    description: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    isCancelled: Scalars['Boolean']['output']
    method: BookingConsultationMethod
    note: Maybe<Scalars['String']['output']>
    order: Maybe<Order>
    purpose: BookingConsultationPurpose
    salesforceId: Maybe<Scalars['String']['output']>
    showroom: Showroom
    startsAt: Scalars['DateTime']['output']
    state: BookingConsultationState
}

export type BookingConsultationAvailableDate = {
    __typename: 'BookingConsultationAvailableDate'
    consultationAvailableShowrooms: Array<BookingConsultationAvailableShowroom>
    date: Scalars['DateTime']['output']
}

export type BookingConsultationAvailableShowroom = {
    __typename: 'BookingConsultationAvailableShowroom'
    consultationSlots: Maybe<Array<Maybe<BookingConsultationSlot>>>
}

export type BookingConsultationComplexity = {
    __typename: 'BookingConsultationComplexity'
    icon: Maybe<Asset>
    systemCode: BookingConsultationComplexityCode
    translation: BookingConsultationComplexityTranslation
}

export type BookingConsultationComplexityTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const BookingConsultationComplexityCode = {
    DiscussDesigns: 'DISCUSS_DESIGNS',
    NotSure: 'NOT_SURE',
    ViewDesigns: 'VIEW_DESIGNS',
} as const

export type BookingConsultationComplexityCode =
    (typeof BookingConsultationComplexityCode)[keyof typeof BookingConsultationComplexityCode]
export type BookingConsultationComplexityTranslation = {
    __typename: 'BookingConsultationComplexityTranslation'
    locale: Scalars['Locale']['output']
    name: Scalars['String']['output']
}

export type BookingConsultationMethod = {
    __typename: 'BookingConsultationMethod'
    icon: Maybe<Asset>
    /** @deprecated systemCode */
    id: Scalars['ID']['output']
    isVirtual: Scalars['Boolean']['output']
    name: Scalars['String']['output']
    systemCode: BookingConsultationMethodCode
    takesRoom: Scalars['Boolean']['output']
}

export const BookingConsultationMethodCode = {
    ByPhone: 'BY_PHONE',
    InPerson: 'IN_PERSON',
    Virtual: 'VIRTUAL',
} as const

export type BookingConsultationMethodCode =
    (typeof BookingConsultationMethodCode)[keyof typeof BookingConsultationMethodCode]
export type BookingConsultationMutableFields = {
    consultant?: InputMaybe<Scalars['ID']['input']>
    consultationRoomKind?: InputMaybe<BookingConsultationRoomKind>
    description?: InputMaybe<Scalars['String']['input']>
    note?: InputMaybe<Scalars['String']['input']>
    showroom: Scalars['ID']['input']
    startTime: Scalars['DateTime']['input']
}

export type BookingConsultationPurpose = {
    __typename: 'BookingConsultationPurpose'
    /** Duration in minutes */
    duration: Scalars['Int']['output']
    icon: Maybe<Asset>
    /** @deprecated systemCode */
    id: Scalars['ID']['output']
    methods: Array<BookingConsultationMethod>
    name: Scalars['String']['output']
    requireConsultant: Scalars['Boolean']['output']
    requireOrder: Maybe<BookingConsultationPurposeOrder>
    slotLengthInMinutes: Scalars['Int']['output']
    systemCode: BookingConsultationPurposeCode
    takesRoom: Scalars['Boolean']['output']
    type: BookingConsultationType
}

export const BookingConsultationPurposeCode = {
    Collection: 'COLLECTION',
    EngagementRing: 'ENGAGEMENT_RING',
    FullService: 'FULL_SERVICE',
    Inspection: 'INSPECTION',
    Other: 'OTHER',
    QuickCollection: 'QUICK_COLLECTION',
    QuickEngagementRing: 'QUICK_ENGAGEMENT_RING',
    QuickJewellery: 'QUICK_JEWELLERY',
    QuickWeddingRing: 'QUICK_WEDDING_RING',
    Repair: 'REPAIR',
    Resize: 'RESIZE',
    WeddingRing: 'WEDDING_RING',
} as const

export type BookingConsultationPurposeCode =
    (typeof BookingConsultationPurposeCode)[keyof typeof BookingConsultationPurposeCode]
export type BookingConsultationPurposeOrder = {
    __typename: 'BookingConsultationPurposeOrder'
    orders: Maybe<Array<Order>>
    statuses: Array<OrderStatus>
}

export type BookingConsultationRoom = {
    id: Scalars['ID']['output']
    kind: BookingConsultationRoomKind
    name: Scalars['String']['output']
}

export const BookingConsultationRoomKind = {
    Consultation: 'CONSULTATION',
    Reception: 'RECEPTION',
} as const

export type BookingConsultationRoomKind =
    (typeof BookingConsultationRoomKind)[keyof typeof BookingConsultationRoomKind]
export type BookingConsultationSlot = {
    __typename: 'BookingConsultationSlot'
    showroom: Showroom
    startTime: Scalars['DateTime']['output']
}

export type BookingConsultationSlotInput = {
    consultant: BookingSystemConsultant
    method: BookingConsultationMethodCode
    order?: InputMaybe<Scalars['ID']['input']>
    purpose: BookingConsultationPurposeCode
    region: RegionCode
}

export type BookingConsultationSlotsResponse = {
    __typename: 'BookingConsultationSlotsResponse'
    slots: Array<BookingConsultationSlot>
}

export const BookingConsultationState = {
    Cancelled: 'CANCELLED',
    Completed: 'COMPLETED',
    NoShow: 'NO_SHOW',
    Open: 'OPEN',
    Pending: 'PENDING',
} as const

export type BookingConsultationState =
    (typeof BookingConsultationState)[keyof typeof BookingConsultationState]
export const BookingConsultationTransition = {
    Cancel: 'CANCEL',
    Complete: 'COMPLETE',
    Initialise: 'INITIALISE',
    NoShow: 'NO_SHOW',
} as const

export type BookingConsultationTransition =
    (typeof BookingConsultationTransition)[keyof typeof BookingConsultationTransition]
export type BookingConsultationType = {
    __typename: 'BookingConsultationType'
    name: Maybe<Scalars['String']['output']>
    systemCode: BookingConsultationTypeCode
}

export const BookingConsultationTypeCode = {
    Aftercare: 'AFTERCARE',
    Collection: 'COLLECTION',
    Sales: 'SALES',
} as const

export type BookingConsultationTypeCode =
    (typeof BookingConsultationTypeCode)[keyof typeof BookingConsultationTypeCode]
export type BookingCreateConsultationConsultationOrderInput = {
    order: Scalars['ID']['input']
}

export type BookingCreateConsultationErrorNoAvailableConsultants = {
    __typename: 'BookingCreateConsultationErrorNoAvailableConsultants'
    message: Scalars['String']['output']
}

export type BookingCreateConsultationErrorNoAvailableConsultantsMessageArgs = {
    locale: Scalars['Locale']['input']
}

export type BookingCreateConsultationExistingCustomerResponse =
    | BookingCreateConsultationErrorNoAvailableConsultants
    | BookingCreateConsultationSuccessExistingCustomer

export type BookingCreateConsultationInput = {
    baseInput?: InputMaybe<EnquiryBaseInput>
    commissionJunction?: InputMaybe<CommissionJunctionInput>
    consultant: BookingSystemConsultant
    description?: InputMaybe<Scalars['String']['input']>
    method: BookingConsultationMethodCode
    orderInput?: InputMaybe<BookingCreateConsultationConsultationOrderInput>
    phone?: InputMaybe<PhoneNumberInput>
    purpose: BookingConsultationPurposeCode
    /** Required if purpose's type's code is SALES */
    salesConsultation?: InputMaybe<BookingCreateConsultationSalesConsultationInput>
    showroom: Scalars['ID']['input']
    startTime: Scalars['DateTime']['input']
    uri: Scalars['Uri']['input']
}

export type BookingCreateConsultationNewCustomerResponse =
    | BookingCreateConsultationErrorNoAvailableConsultants
    | BookingCreateConsultationSuccessNewCustomer

export type BookingCreateConsultationSalesConsultationInput = {
    complexity: BookingConsultationComplexityCode
}

export type BookingCreateConsultationSuccessExistingCustomer = {
    __typename: 'BookingCreateConsultationSuccessExistingCustomer'
    consultation: BookingConsultation
}

export type BookingCreateConsultationSuccessNewCustomer = {
    __typename: 'BookingCreateConsultationSuccessNewCustomer'
    consultation: BookingConsultation
    customerRegistrationResponse: CustomerRegistrationResponse
}

export type BookingInPersonConsultationRoom = BookingConsultationRoom & {
    __typename: 'BookingInPersonConsultationRoom'
    id: Scalars['ID']['output']
    kind: BookingConsultationRoomKind
    name: Scalars['String']['output']
}

export const BookingSystemConsultant = {
    All: 'ALL',
    Own: 'OWN',
} as const

export type BookingSystemConsultant =
    (typeof BookingSystemConsultant)[keyof typeof BookingSystemConsultant]
export type BookingVirtualConsultationRoom = BookingConsultationRoom & {
    __typename: 'BookingVirtualConsultationRoom'
    id: Scalars['ID']['output']
    kind: BookingConsultationRoomKind
    name: Scalars['String']['output']
}

export type ButtonEventTracking = {
    __typename: 'ButtonEventTracking'
    action: Maybe<Scalars['String']['output']>
    category: Maybe<Scalars['String']['output']>
    event: Scalars['String']['output']
    label: Maybe<Scalars['String']['output']>
}

export type ButtonIcon = {
    __typename: 'ButtonIcon'
    icon: Icon
    position: HorizontalAlignment
}

export const ButtonSize = {
    Medium: 'MEDIUM',
    Small: 'SMALL',
} as const

export type ButtonSize = (typeof ButtonSize)[keyof typeof ButtonSize]
export type ButtonStyle = {
    __typename: 'ButtonStyle'
    bottomSpacing: VerticalSpacing
    color: Color
    linkSize: Scalars['Int']['output']
    size: ButtonSize
    topSpacing: VerticalSpacing
    type: ButtonType
    width: ButtonWidth
}

export const ButtonType = {
    Bordered: 'BORDERED',
    Link: 'LINK',
    Solid: 'SOLID',
} as const

export type ButtonType = (typeof ButtonType)[keyof typeof ButtonType]
export const ButtonWidth = {
    Fixed: 'FIXED',
    Fluid: 'FLUID',
} as const

export type ButtonWidth = (typeof ButtonWidth)[keyof typeof ButtonWidth]
export type CalculateGemsApiStoneTotalSalePriceInput = {
    currency: CurrencyInput
    priceUsd: Scalars['Float']['input']
    region: RegionCode
}

export type CardCarouselCard = {
    __typename: 'CardCarouselCard'
    backgroundColor: Color
    description: Maybe<Scalars['String']['output']>
    image: Image
    link: Link
    title: Scalars['String']['output']
}

export type CarouselCustomProduct = {
    __typename: 'CarouselCustomProduct'
    description: Maybe<Scalars['String']['output']>
    image: Image
    link: Maybe<Link>
    title: Maybe<Scalars['String']['output']>
}

export type CatalogueAggregate = {
    __typename: 'CatalogueAggregate'
    count: Scalars['Int']['output']
}

export type CatalogueBandType = {
    __typename: 'CatalogueBandType'
    id: Scalars['ID']['output']
    translation: CatalogueBandTypeTranslation
}

export type CatalogueBandTypeTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export type CatalogueBandTypeTranslation = {
    __typename: 'CatalogueBandTypeTranslation'
    name: Scalars['String']['output']
}

export type CatalogueDesignStudioCheckoutEngagementRingAddedToDesignStudio = {
    __typename: 'CatalogueDesignStudioCheckoutEngagementRingAddedToDesignStudio'
    product: DesignStudioProductEngagementRing
}

export type CatalogueDesignStudioCheckoutEngagementRingAddedToDesignStudioAndCart =
    {
        __typename: 'CatalogueDesignStudioCheckoutEngagementRingAddedToDesignStudioAndCart'
        checkoutProduct: OrderProduct
        designStudioProduct: DesignStudioProductEngagementRing
        order: Order
    }

export type CatalogueDesignStudioCheckoutJewelleryExistingCustomerResponse =
    CatalogueDesignStudioCheckoutJewellerySuccessExistingCustomer

export type CatalogueDesignStudioCheckoutJewelleryNewCustomerResponse =
    CatalogueDesignStudioCheckoutJewellerySuccessNewCustomer

export type CatalogueDesignStudioCheckoutJewellerySuccessExistingCustomer = {
    __typename: 'CatalogueDesignStudioCheckoutJewellerySuccessExistingCustomer'
    order: Order
    product: OrderProduct
}

export type CatalogueDesignStudioCheckoutJewellerySuccessNewCustomer = {
    __typename: 'CatalogueDesignStudioCheckoutJewellerySuccessNewCustomer'
    customer: CustomerRegistrationResponse
    order: Order
    product: OrderProduct
}

export type CatalogueDesignStudioCheckoutWeddingRingExistingCustomerResponse =
    CatalogueDesignStudioCheckoutWeddingRingSuccessExistingCustomer

export type CatalogueDesignStudioCheckoutWeddingRingNewCustomerResponse =
    CatalogueDesignStudioCheckoutWeddingRingSuccessNewCustomer

export type CatalogueDesignStudioCheckoutWeddingRingSuccessExistingCustomer = {
    __typename: 'CatalogueDesignStudioCheckoutWeddingRingSuccessExistingCustomer'
    order: Order
    product: OrderProduct
}

export type CatalogueDesignStudioCheckoutWeddingRingSuccessNewCustomer = {
    __typename: 'CatalogueDesignStudioCheckoutWeddingRingSuccessNewCustomer'
    customer: CustomerRegistrationResponse
    order: Order
    product: OrderProduct
}

export type CatalogueEngagementRing = CatalogueProduct & {
    __typename: 'CatalogueEngagementRing'
    bandThickness: Scalars['Float']['output']
    bandWidth: Scalars['Float']['output']
    catalogueCode: Scalars['CatalogueCode']['output']
    centreStoneConstraints: CatalogueEngagementRingCentreStoneConstraints
    customTitleTag: Maybe<Scalars['String']['output']>
    deliveryDays: Scalars['Int']['output']
    designFeatures: Array<EngagementRingDesignFeatureLabel>
    designStyle: EngagementRingDesignStyleLabel
    financeOptionsAffirm: Maybe<AffirmFinanceOption>
    financeOptionsKlarna: Maybe<KlarnaFinanceOption>
    firstAvailableDeliveryDate: DeliveryDate
    images: Array<CatalogueImage>
    images360: Array<GenericImage>
    isAvailableForRingBuilder: Scalars['Boolean']['output']
    isResizeable: Scalars['Boolean']['output']
    isReturnable: Scalars['Boolean']['output']
    mainImage: Maybe<GenericImage>
    meleeItems: Array<CatalogueMelee>
    primaryMetal: Metal
    productName: Scalars['String']['output']
    relatedProducts: Array<CatalogueEngagementRing>
    reviews: Array<Review>
    ringBuilderProducts: Array<RingBuilder>
    ringStyles: Array<EngagementRingStyleLabel>
    salePrice: SalePrice
    segmentName: Scalars['String']['output']
    signatureStone: Maybe<Melee>
    signatureStones: Array<CatalogueEngagementRingAndSignatureStone>
    sizes: Array<RingSizeOrRecommendedRingSize>
    slug: Scalars['String']['output']
    suffix: Maybe<Scalars['String']['output']>
    suffixSlug: Maybe<Scalars['String']['output']>
    translation: CatalogueEngagementRingTranslation
    updatedAt: Maybe<Scalars['DateTime']['output']>
    variations: Array<CatalogueEngagementRing>
    variationsByCentreStoneShape: Array<CatalogueEngagementRing>
    variationsByPrimaryMetal: Array<CatalogueEngagementRing>
    video: Maybe<CatalogueVideo>
}

export type CatalogueEngagementRingDeliveryDaysArgs = {
    hasEngraving: InputMaybe<Scalars['Boolean']['input']>
    region: InputMaybe<RegionCode>
}

export type CatalogueEngagementRingFinanceOptionsAffirmArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueEngagementRingFinanceOptionsKlarnaArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueEngagementRingFirstAvailableDeliveryDateArgs = {
    hasEngraving: Scalars['Boolean']['input']
    region: RegionCode
}

export type CatalogueEngagementRingImagesArgs = {
    limit: InputMaybe<Scalars['Int']['input']>
}

export type CatalogueEngagementRingRingBuilderProductsArgs = {
    input: RingBuilderProductFilterInput
}

export type CatalogueEngagementRingSalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueEngagementRingSizesArgs = {
    region: RegionCode
}

export type CatalogueEngagementRingTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export type CatalogueEngagementRingAndSignatureStone = {
    __typename: 'CatalogueEngagementRingAndSignatureStone'
    salePrice: SalePrice
    signatureStone: CatalogueEngagementRingSignatureStone
}

export type CatalogueEngagementRingAndSignatureStoneSalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueEngagementRingCentreStoneConstraints = {
    __typename: 'CatalogueEngagementRingCentreStoneConstraints'
    shape: StoneShape
    weight: CatalogueEngagementRingCentreStoneWeightConstraint
}

export type CatalogueEngagementRingCentreStoneWeightConstraint = {
    __typename: 'CatalogueEngagementRingCentreStoneWeightConstraint'
    max: Scalars['Decimal']['output']
    min: Scalars['Decimal']['output']
}

export type CatalogueEngagementRingContainsProductsInput = {
    shape: StoneShapeCode
}

export type CatalogueEngagementRingFilterInput = {
    centreStoneShape: StoneShapeCode
    primaryMetalCode?: InputMaybe<MetalCode>
    slug: Scalars['String']['input']
    suffixSlug?: InputMaybe<Scalars['String']['input']>
}

export type CatalogueEngagementRingFilters = {
    __typename: 'CatalogueEngagementRingFilters'
    centreStoneShapes: Array<CatalogueFilterShapeItem>
    designFeatures: Array<CatalogueFilterEngagementRingDesignFeatureItem>
    designStyles: Array<CatalogueFilterEngagementRingDesingStyleItem>
    price: CataloguePriceRangeFilter
    primaryMetals: Array<CatalogueFilterMetalItem>
    ringStyles: Array<CatalogueFilterEngagementRingStylesItem>
}

export type CatalogueEngagementRingFiltersPriceArgs = {
    input: CatalogueFiltersPriceInput
}

export type CatalogueEngagementRingFiltersVariation = {
    __typename: 'CatalogueEngagementRingFiltersVariation'
    centreStoneShape: Maybe<StoneShapeCode>
    designFeature: Maybe<EngagementRingDesignFeatureLabelCode>
    designStyle: Maybe<EngagementRingDesignStyleLabelCode>
    primaryMetal: Maybe<MetalCode>
    ringStyle: Maybe<EngagementRingStyleLabelCode>
}

export type CatalogueEngagementRingSignatureStone = {
    __typename: 'CatalogueEngagementRingSignatureStone'
    color: StoneColor
    crystal: StoneCrystal
    id: Scalars['ID']['output']
    image: Scalars['Uri']['output']
    isDefault: Scalars['Boolean']['output']
    price: Money
    segmentName: Scalars['String']['output']
    width: Scalars['String']['output']
}

export type CatalogueEngagementRingSignatureStonePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueEngagementRingSignatureStoneInput = {
    color: StoneColorCode
    crystal: StoneCrystalCode
    width: Scalars['String']['input']
}

export type CatalogueEngagementRingTranslation = {
    __typename: 'CatalogueEngagementRingTranslation'
    description: Maybe<Scalars['String']['output']>
    locale: Scalars['Locale']['output']
    seoText: Maybe<Scalars['String']['output']>
}

export type CatalogueEngagementRingsFilterInput = {
    catalogueCode?: InputMaybe<Scalars['CatalogueCode']['input']>
    catalogueCodes?: InputMaybe<Array<Scalars['CatalogueCode']['input']>>
    centreStoneShapes?: InputMaybe<Array<StoneShapeCode>>
    designFeatures?: InputMaybe<Array<EngagementRingDesignFeatureLabelCode>>
    designStyles?: InputMaybe<Array<EngagementRingDesignStyleLabelCode>>
    includeHiddenFromProductList?: InputMaybe<Scalars['Boolean']['input']>
    price?: InputMaybe<CatalogueFilterPriceInput>
    primaryMetalCodes?: InputMaybe<Array<MetalCode>>
    ringStyles?: InputMaybe<Array<EngagementRingStyleLabelCode>>
    search?: InputMaybe<Scalars['String']['input']>
    slug?: InputMaybe<Scalars['String']['input']>
    suffixSlug?: InputMaybe<Scalars['String']['input']>
}

export type CatalogueFilterEngagementRingDesignFeatureItem = {
    __typename: 'CatalogueFilterEngagementRingDesignFeatureItem'
    label: EngagementRingDesignFeatureLabel
    totalResults: Scalars['Int']['output']
}

export type CatalogueFilterEngagementRingDesingStyleItem = {
    __typename: 'CatalogueFilterEngagementRingDesingStyleItem'
    label: EngagementRingDesignStyleLabel
    totalResults: Scalars['Int']['output']
}

export type CatalogueFilterEngagementRingStylesItem = {
    __typename: 'CatalogueFilterEngagementRingStylesItem'
    label: EngagementRingStyleLabel
    totalResults: Scalars['Int']['output']
}

export type CatalogueFilterInput = {
    catalogueCode?: InputMaybe<Scalars['CatalogueCode']['input']>
    catalogueCodes?: InputMaybe<Array<Scalars['CatalogueCode']['input']>>
    includeHiddenFromProductList?: InputMaybe<Scalars['Boolean']['input']>
    price?: InputMaybe<CatalogueFilterPriceInput>
    primaryMetalCodes?: InputMaybe<Array<MetalCode>>
    search?: InputMaybe<Scalars['String']['input']>
    slug?: InputMaybe<Scalars['String']['input']>
    suffixSlug?: InputMaybe<Scalars['String']['input']>
}

export type CatalogueFilterJewelleryBraceletProductStyleLabel = {
    __typename: 'CatalogueFilterJewelleryBraceletProductStyleLabel'
    label: JewelleryBraceletProductStyleLabel
    totalResults: Scalars['Int']['output']
}

export type CatalogueFilterJewelleryDesignFeatureLabel = {
    __typename: 'CatalogueFilterJewelleryDesignFeatureLabel'
    label: JewelleryDesignFeatureLabel
    totalResults: Scalars['Int']['output']
}

export type CatalogueFilterJewelleryDesignStyleLabel = {
    __typename: 'CatalogueFilterJewelleryDesignStyleLabel'
    label: JewelleryDesignStyleLabel
    totalResults: Scalars['Int']['output']
}

export type CatalogueFilterJewelleryEarringsProductStyleLabel = {
    __typename: 'CatalogueFilterJewelleryEarringsProductStyleLabel'
    label: JewelleryEarringsProductStyleLabel
    totalResults: Scalars['Int']['output']
}

export type CatalogueFilterJewelleryGemstoneLabel = {
    __typename: 'CatalogueFilterJewelleryGemstoneLabel'
    label: JewelleryGemstoneLabel
    totalResults: Scalars['Int']['output']
}

export type CatalogueFilterJewelleryNecklaceProductStyleLabel = {
    __typename: 'CatalogueFilterJewelleryNecklaceProductStyleLabel'
    label: JewelleryNecklaceProductStyleLabel
    totalResults: Scalars['Int']['output']
}

export type CatalogueFilterJewelleryRingProductStyleLabel = {
    __typename: 'CatalogueFilterJewelleryRingProductStyleLabel'
    label: JewelleryRingProductStyleLabel
    totalResults: Scalars['Int']['output']
}

export type CatalogueFilterMetalItem = {
    __typename: 'CatalogueFilterMetalItem'
    metal: Metal
    totalResults: Scalars['Int']['output']
}

export type CatalogueFilterPriceInput = {
    currency: CurrencyInput
    max?: InputMaybe<Scalars['Decimal']['input']>
    min?: InputMaybe<Scalars['Decimal']['input']>
    region: RegionCode
}

export type CatalogueFilterShapeItem = {
    __typename: 'CatalogueFilterShapeItem'
    shape: StoneShape
    totalResults: Scalars['Int']['output']
}

export type CatalogueFilterWeddingRingCategoriesItem = {
    __typename: 'CatalogueFilterWeddingRingCategoriesItem'
    label: WeddingRingCategoryLabel
    totalResults: Scalars['Int']['output']
}

export type CatalogueFilterWeddingRingStylesItem = {
    __typename: 'CatalogueFilterWeddingRingStylesItem'
    label: WeddingRingStyleLabel
    totalResults: Scalars['Int']['output']
}

export type CatalogueFiltersPriceInput = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueImage = {
    __typename: 'CatalogueImage'
    id: Scalars['ID']['output']
    mimeType: Scalars['String']['output']
    size: MonolithImageSize
    sources: Array<ImageSrc>
    url: Scalars['String']['output']
}

export type CatalogueImageSizeArgs = {
    name: MonolithImageSizeName
}

export type CatalogueJewelleriesBraceletsFilterInput = {
    catalogueCode?: InputMaybe<Scalars['CatalogueCode']['input']>
    catalogueCodes?: InputMaybe<Array<Scalars['CatalogueCode']['input']>>
    designFeatures?: InputMaybe<Array<JewelleryDesignFeature>>
    designStyles?: InputMaybe<Array<JewelleryDesignStyle>>
    gemstones?: InputMaybe<Array<JewelleryGemstoneCode>>
    includeHiddenFromProductList?: InputMaybe<Scalars['Boolean']['input']>
    price?: InputMaybe<CatalogueFilterPriceInput>
    primaryMetalCodes?: InputMaybe<Array<MetalCode>>
    productStyles?: InputMaybe<Array<JewelleryBraceletProductStyle>>
    search?: InputMaybe<Scalars['String']['input']>
    slug?: InputMaybe<Scalars['String']['input']>
    suffixSlug?: InputMaybe<Scalars['String']['input']>
}

export type CatalogueJewelleriesBraceletsFiltersVariation = {
    __typename: 'CatalogueJewelleriesBraceletsFiltersVariation'
    designFeature: Maybe<JewelleryDesignFeature>
    designStyle: Maybe<JewelleryDesignStyle>
    gemstone: Maybe<JewelleryGemstoneCode>
    primaryMetal: Maybe<MetalCode>
    productStyle: Maybe<JewelleryBraceletProductStyle>
}

export type CatalogueJewelleriesEarringsFilterInput = {
    catalogueCode?: InputMaybe<Scalars['CatalogueCode']['input']>
    catalogueCodes?: InputMaybe<Array<Scalars['CatalogueCode']['input']>>
    designFeatures?: InputMaybe<Array<JewelleryDesignFeature>>
    designStyles?: InputMaybe<Array<JewelleryDesignStyle>>
    gemstones?: InputMaybe<Array<JewelleryGemstoneCode>>
    includeHiddenFromProductList?: InputMaybe<Scalars['Boolean']['input']>
    price?: InputMaybe<CatalogueFilterPriceInput>
    primaryMetalCodes?: InputMaybe<Array<MetalCode>>
    productStyles?: InputMaybe<Array<JewelleryEarringsProductStyle>>
    search?: InputMaybe<Scalars['String']['input']>
    slug?: InputMaybe<Scalars['String']['input']>
    suffixSlug?: InputMaybe<Scalars['String']['input']>
}

export type CatalogueJewelleriesEarringsFiltersVariation = {
    __typename: 'CatalogueJewelleriesEarringsFiltersVariation'
    designFeature: Maybe<JewelleryDesignFeature>
    designStyle: Maybe<JewelleryDesignStyle>
    gemstone: Maybe<JewelleryGemstoneCode>
    primaryMetal: Maybe<MetalCode>
    productStyle: Maybe<JewelleryEarringsProductStyle>
}

export type CatalogueJewelleriesFilterInput = {
    catalogueCode?: InputMaybe<Scalars['CatalogueCode']['input']>
    catalogueCodes?: InputMaybe<Array<Scalars['CatalogueCode']['input']>>
    designFeatures?: InputMaybe<Array<JewelleryDesignFeature>>
    designStyles?: InputMaybe<Array<JewelleryDesignStyle>>
    gemstones?: InputMaybe<Array<JewelleryGemstoneCode>>
    includeHiddenFromProductList?: InputMaybe<Scalars['Boolean']['input']>
    price?: InputMaybe<CatalogueFilterPriceInput>
    primaryMetalCodes?: InputMaybe<Array<MetalCode>>
    search?: InputMaybe<Scalars['String']['input']>
    slug?: InputMaybe<Scalars['String']['input']>
    suffixSlug?: InputMaybe<Scalars['String']['input']>
}

export type CatalogueJewelleriesFilters = {
    __typename: 'CatalogueJewelleriesFilters'
    designFeatures: Array<CatalogueFilterJewelleryDesignFeatureLabel>
    designStyles: Array<CatalogueFilterJewelleryDesignStyleLabel>
    gemstones: Array<CatalogueFilterJewelleryGemstoneLabel>
    price: CataloguePriceRangeFilter
    primaryMetals: Array<CatalogueFilterMetalItem>
}

export type CatalogueJewelleriesFiltersPriceArgs = {
    input: CatalogueFiltersPriceInput
}

export type CatalogueJewelleriesFiltersVariation = {
    __typename: 'CatalogueJewelleriesFiltersVariation'
    designFeature: Maybe<JewelleryDesignFeature>
    designStyle: Maybe<JewelleryDesignStyle>
    gemstone: Maybe<JewelleryGemstoneCode>
    primaryMetal: Maybe<MetalCode>
}

export type CatalogueJewelleriesNecklacesFilterInput = {
    catalogueCode?: InputMaybe<Scalars['CatalogueCode']['input']>
    catalogueCodes?: InputMaybe<Array<Scalars['CatalogueCode']['input']>>
    designFeatures?: InputMaybe<Array<JewelleryDesignFeature>>
    designStyles?: InputMaybe<Array<JewelleryDesignStyle>>
    gemstones?: InputMaybe<Array<JewelleryGemstoneCode>>
    includeHiddenFromProductList?: InputMaybe<Scalars['Boolean']['input']>
    price?: InputMaybe<CatalogueFilterPriceInput>
    primaryMetalCodes?: InputMaybe<Array<MetalCode>>
    productStyles?: InputMaybe<Array<JewelleryNecklaceProductStyle>>
    search?: InputMaybe<Scalars['String']['input']>
    slug?: InputMaybe<Scalars['String']['input']>
    suffixSlug?: InputMaybe<Scalars['String']['input']>
}

export type CatalogueJewelleriesNecklacesFiltersVariation = {
    __typename: 'CatalogueJewelleriesNecklacesFiltersVariation'
    designFeature: Maybe<JewelleryDesignFeature>
    designStyle: Maybe<JewelleryDesignStyle>
    gemstone: Maybe<JewelleryGemstoneCode>
    primaryMetal: Maybe<MetalCode>
    productStyle: Maybe<JewelleryNecklaceProductStyle>
}

export type CatalogueJewelleriesRingsFilterInput = {
    catalogueCode?: InputMaybe<Scalars['CatalogueCode']['input']>
    catalogueCodes?: InputMaybe<Array<Scalars['CatalogueCode']['input']>>
    designFeatures?: InputMaybe<Array<JewelleryDesignFeature>>
    designStyles?: InputMaybe<Array<JewelleryDesignStyle>>
    gemstones?: InputMaybe<Array<JewelleryGemstoneCode>>
    includeHiddenFromProductList?: InputMaybe<Scalars['Boolean']['input']>
    price?: InputMaybe<CatalogueFilterPriceInput>
    primaryMetalCodes?: InputMaybe<Array<MetalCode>>
    productStyles?: InputMaybe<Array<JewelleryRingProductStyle>>
    search?: InputMaybe<Scalars['String']['input']>
    slug?: InputMaybe<Scalars['String']['input']>
    suffixSlug?: InputMaybe<Scalars['String']['input']>
}

export type CatalogueJewelleriesRingsFiltersVariation = {
    __typename: 'CatalogueJewelleriesRingsFiltersVariation'
    designFeature: Maybe<JewelleryDesignFeature>
    designStyle: Maybe<JewelleryDesignStyle>
    gemstone: Maybe<JewelleryGemstoneCode>
    primaryMetal: Maybe<MetalCode>
    productStyle: Maybe<JewelleryRingProductStyle>
}

export type CatalogueJewellery = {
    catalogueCode: Scalars['CatalogueCode']['output']
    customTitleTag: Maybe<Scalars['String']['output']>
    designFeatures: Array<JewelleryDesignFeatureLabel>
    designStyles: Array<JewelleryDesignStyleLabel>
    engravingDisabled: Scalars['Boolean']['output']
    financeOptionsAffirm: Maybe<AffirmFinanceOption>
    financeOptionsKlarna: Maybe<KlarnaFinanceOption>
    gemstones: Array<JewelleryGemstoneLabel>
    images: Array<CatalogueImage>
    images360: Array<GenericImage>
    isReturnable: Scalars['Boolean']['output']
    mainImage: Maybe<GenericImage>
    primaryMetal: Metal
    productName: Scalars['String']['output']
    relatedProducts: Array<CatalogueProduct>
    reviews: Array<Review>
    salePrice: SalePrice
    segmentName: Scalars['String']['output']
    sku: Maybe<Scalars['String']['output']>
    slug: Scalars['String']['output']
    suffix: Maybe<Scalars['String']['output']>
    suffixSlug: Maybe<Scalars['String']['output']>
    updatedAt: Maybe<Scalars['DateTime']['output']>
    video: Maybe<CatalogueVideo>
}

export type CatalogueJewelleryFinanceOptionsAffirmArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueJewelleryFinanceOptionsKlarnaArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueJewelleryImagesArgs = {
    limit: InputMaybe<Scalars['Int']['input']>
}

export type CatalogueJewellerySalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueJewelleryBracelet = CatalogueJewellery &
    CatalogueProduct & {
        __typename: 'CatalogueJewelleryBracelet'
        catalogueCode: Scalars['CatalogueCode']['output']
        customTitleTag: Maybe<Scalars['String']['output']>
        deliveryDays: Scalars['Int']['output']
        designFeatures: Array<JewelleryDesignFeatureLabel>
        designStyles: Array<JewelleryDesignStyleLabel>
        engravingDisabled: Scalars['Boolean']['output']
        financeOptionsAffirm: Maybe<AffirmFinanceOption>
        financeOptionsKlarna: Maybe<KlarnaFinanceOption>
        firstAvailableDeliveryDate: DeliveryDate
        gemstones: Array<JewelleryGemstoneLabel>
        images: Array<CatalogueImage>
        images360: Array<GenericImage>
        isReturnable: Scalars['Boolean']['output']
        mainImage: Maybe<GenericImage>
        primaryMetal: Metal
        productName: Scalars['String']['output']
        productStyles: Array<JewelleryBraceletProductStyleLabel>
        relatedProducts: Array<CatalogueJewelleryBracelet>
        reviews: Array<Review>
        salePrice: SalePrice
        segmentName: Scalars['String']['output']
        signatureStone: Maybe<Melee>
        sku: Maybe<Scalars['String']['output']>
        slug: Scalars['String']['output']
        suffix: Scalars['String']['output']
        suffixSlug: Maybe<Scalars['String']['output']>
        translation: CatalogueJewelleryBraceletTranslation
        updatedAt: Maybe<Scalars['DateTime']['output']>
        variations: Array<CatalogueJewelleryBracelet>
        video: Maybe<CatalogueVideo>
    }

export type CatalogueJewelleryBraceletDeliveryDaysArgs = {
    hasEngraving: InputMaybe<Scalars['Boolean']['input']>
    region: InputMaybe<RegionCode>
}

export type CatalogueJewelleryBraceletFinanceOptionsAffirmArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueJewelleryBraceletFinanceOptionsKlarnaArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueJewelleryBraceletFirstAvailableDeliveryDateArgs = {
    hasEngraving: Scalars['Boolean']['input']
    region: RegionCode
}

export type CatalogueJewelleryBraceletImagesArgs = {
    limit: InputMaybe<Scalars['Int']['input']>
}

export type CatalogueJewelleryBraceletSalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueJewelleryBraceletTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export type CatalogueJewelleryBraceletTranslation = {
    __typename: 'CatalogueJewelleryBraceletTranslation'
    description: Maybe<Scalars['String']['output']>
    seoText: Maybe<Scalars['String']['output']>
}

export type CatalogueJewelleryBraceletsFilters = {
    __typename: 'CatalogueJewelleryBraceletsFilters'
    designFeatures: Array<CatalogueFilterJewelleryDesignFeatureLabel>
    designStyles: Array<CatalogueFilterJewelleryDesignStyleLabel>
    gemstones: Array<CatalogueFilterJewelleryGemstoneLabel>
    price: CataloguePriceRangeFilter
    primaryMetals: Array<CatalogueFilterMetalItem>
    productStyles: Array<CatalogueFilterJewelleryBraceletProductStyleLabel>
}

export type CatalogueJewelleryBraceletsFiltersPriceArgs = {
    input: CatalogueFiltersPriceInput
}

export type CatalogueJewelleryEarrings = CatalogueJewellery &
    CatalogueProduct & {
        __typename: 'CatalogueJewelleryEarrings'
        catalogueCode: Scalars['CatalogueCode']['output']
        customTitleTag: Maybe<Scalars['String']['output']>
        deliveryDays: Scalars['Int']['output']
        designFeatures: Array<JewelleryDesignFeatureLabel>
        designStyles: Array<JewelleryDesignStyleLabel>
        engravingDisabled: Scalars['Boolean']['output']
        financeOptionsAffirm: Maybe<AffirmFinanceOption>
        financeOptionsKlarna: Maybe<KlarnaFinanceOption>
        firstAvailableDeliveryDate: DeliveryDate
        gemstones: Array<JewelleryGemstoneLabel>
        images: Array<CatalogueImage>
        images360: Array<GenericImage>
        isReturnable: Scalars['Boolean']['output']
        mainImage: Maybe<GenericImage>
        primaryMetal: Metal
        productName: Scalars['String']['output']
        productStyles: Array<JewelleryEarringsProductStyleLabel>
        relatedProducts: Array<CatalogueJewelleryEarrings>
        reviews: Array<Review>
        salePrice: SalePrice
        segmentName: Scalars['String']['output']
        signatureStone: Maybe<Melee>
        sku: Maybe<Scalars['String']['output']>
        slug: Scalars['String']['output']
        suffix: Scalars['String']['output']
        suffixSlug: Maybe<Scalars['String']['output']>
        translation: CatalogueJewelleryEarringsTranslation
        updatedAt: Maybe<Scalars['DateTime']['output']>
        variations: Array<CatalogueJewelleryEarrings>
        video: Maybe<CatalogueVideo>
    }

export type CatalogueJewelleryEarringsDeliveryDaysArgs = {
    hasEngraving: InputMaybe<Scalars['Boolean']['input']>
    region: InputMaybe<RegionCode>
}

export type CatalogueJewelleryEarringsFinanceOptionsAffirmArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueJewelleryEarringsFinanceOptionsKlarnaArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueJewelleryEarringsFirstAvailableDeliveryDateArgs = {
    hasEngraving: Scalars['Boolean']['input']
    region: RegionCode
}

export type CatalogueJewelleryEarringsImagesArgs = {
    limit: InputMaybe<Scalars['Int']['input']>
}

export type CatalogueJewelleryEarringsSalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueJewelleryEarringsTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export type CatalogueJewelleryEarringsFilters = {
    __typename: 'CatalogueJewelleryEarringsFilters'
    designFeatures: Array<CatalogueFilterJewelleryDesignFeatureLabel>
    designStyles: Array<CatalogueFilterJewelleryDesignStyleLabel>
    gemstones: Array<CatalogueFilterJewelleryGemstoneLabel>
    price: CataloguePriceRangeFilter
    primaryMetals: Array<CatalogueFilterMetalItem>
    productStyles: Array<CatalogueFilterJewelleryEarringsProductStyleLabel>
}

export type CatalogueJewelleryEarringsFiltersPriceArgs = {
    input: CatalogueFiltersPriceInput
}

export type CatalogueJewelleryEarringsTranslation = {
    __typename: 'CatalogueJewelleryEarringsTranslation'
    description: Maybe<Scalars['String']['output']>
    seoText: Maybe<Scalars['String']['output']>
}

export type CatalogueJewelleryFilterInput = {
    primaryMetalCode: MetalCode
    slug: Scalars['String']['input']
    suffixSlug?: InputMaybe<Scalars['String']['input']>
}

export type CatalogueJewelleryNecklace = CatalogueJewellery &
    CatalogueProduct & {
        __typename: 'CatalogueJewelleryNecklace'
        catalogueCode: Scalars['CatalogueCode']['output']
        customTitleTag: Maybe<Scalars['String']['output']>
        deliveryDays: Scalars['Int']['output']
        designFeatures: Array<JewelleryDesignFeatureLabel>
        designStyles: Array<JewelleryDesignStyleLabel>
        engravingDisabled: Scalars['Boolean']['output']
        financeOptionsAffirm: Maybe<AffirmFinanceOption>
        financeOptionsKlarna: Maybe<KlarnaFinanceOption>
        firstAvailableDeliveryDate: DeliveryDate
        gemstones: Array<JewelleryGemstoneLabel>
        images: Array<CatalogueImage>
        images360: Array<GenericImage>
        isReturnable: Scalars['Boolean']['output']
        mainImage: Maybe<GenericImage>
        primaryMetal: Metal
        productName: Scalars['String']['output']
        productStyles: Array<JewelleryNecklaceProductStyleLabel>
        relatedProducts: Array<CatalogueJewelleryNecklace>
        reviews: Array<Review>
        salePrice: SalePrice
        segmentName: Scalars['String']['output']
        signatureStone: Maybe<Melee>
        sku: Maybe<Scalars['String']['output']>
        slug: Scalars['String']['output']
        suffix: Scalars['String']['output']
        suffixSlug: Maybe<Scalars['String']['output']>
        translation: CatalogueJewelleryNecklaceTranslation
        updatedAt: Maybe<Scalars['DateTime']['output']>
        variations: Array<CatalogueJewelleryNecklace>
        video: Maybe<CatalogueVideo>
    }

export type CatalogueJewelleryNecklaceDeliveryDaysArgs = {
    hasEngraving: InputMaybe<Scalars['Boolean']['input']>
    region: InputMaybe<RegionCode>
}

export type CatalogueJewelleryNecklaceFinanceOptionsAffirmArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueJewelleryNecklaceFinanceOptionsKlarnaArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueJewelleryNecklaceFirstAvailableDeliveryDateArgs = {
    hasEngraving: Scalars['Boolean']['input']
    region: RegionCode
}

export type CatalogueJewelleryNecklaceImagesArgs = {
    limit: InputMaybe<Scalars['Int']['input']>
}

export type CatalogueJewelleryNecklaceSalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueJewelleryNecklaceTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export type CatalogueJewelleryNecklaceTranslation = {
    __typename: 'CatalogueJewelleryNecklaceTranslation'
    description: Maybe<Scalars['String']['output']>
    seoText: Maybe<Scalars['String']['output']>
}

export type CatalogueJewelleryNecklacesFilters = {
    __typename: 'CatalogueJewelleryNecklacesFilters'
    designFeatures: Array<CatalogueFilterJewelleryDesignFeatureLabel>
    designStyles: Array<CatalogueFilterJewelleryDesignStyleLabel>
    gemstones: Array<CatalogueFilterJewelleryGemstoneLabel>
    price: CataloguePriceRangeFilter
    primaryMetals: Array<CatalogueFilterMetalItem>
    productStyles: Array<CatalogueFilterJewelleryNecklaceProductStyleLabel>
}

export type CatalogueJewelleryNecklacesFiltersPriceArgs = {
    input: CatalogueFiltersPriceInput
}

export type CatalogueJewelleryRing = CatalogueJewellery &
    CatalogueProduct & {
        __typename: 'CatalogueJewelleryRing'
        catalogueCode: Scalars['CatalogueCode']['output']
        customTitleTag: Maybe<Scalars['String']['output']>
        deliveryDays: Scalars['Int']['output']
        designFeatures: Array<JewelleryDesignFeatureLabel>
        designStyles: Array<JewelleryDesignStyleLabel>
        engravingDisabled: Scalars['Boolean']['output']
        financeOptionsAffirm: Maybe<AffirmFinanceOption>
        financeOptionsKlarna: Maybe<KlarnaFinanceOption>
        firstAvailableDeliveryDate: DeliveryDate
        gemstones: Array<JewelleryGemstoneLabel>
        images: Array<CatalogueImage>
        images360: Array<GenericImage>
        isResizeable: Scalars['Boolean']['output']
        isReturnable: Scalars['Boolean']['output']
        mainImage: Maybe<GenericImage>
        primaryMetal: Metal
        productName: Scalars['String']['output']
        productStyles: Array<JewelleryRingProductStyleLabel>
        relatedProducts: Array<CatalogueJewelleryRing>
        reviews: Array<Review>
        salePrice: SalePrice
        segmentName: Scalars['String']['output']
        signatureStone: Maybe<Melee>
        sizes: Array<RingSizeOrRecommendedRingSize>
        sku: Maybe<Scalars['String']['output']>
        slug: Scalars['String']['output']
        suffix: Scalars['String']['output']
        suffixSlug: Maybe<Scalars['String']['output']>
        translation: CatalogueJewelleryRingTranslation
        updatedAt: Maybe<Scalars['DateTime']['output']>
        variations: Array<CatalogueJewelleryRing>
        video: Maybe<CatalogueVideo>
    }

export type CatalogueJewelleryRingDeliveryDaysArgs = {
    hasEngraving: InputMaybe<Scalars['Boolean']['input']>
    region: InputMaybe<RegionCode>
}

export type CatalogueJewelleryRingFinanceOptionsAffirmArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueJewelleryRingFinanceOptionsKlarnaArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueJewelleryRingFirstAvailableDeliveryDateArgs = {
    hasEngraving: Scalars['Boolean']['input']
    region: RegionCode
}

export type CatalogueJewelleryRingImagesArgs = {
    limit: InputMaybe<Scalars['Int']['input']>
}

export type CatalogueJewelleryRingSalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueJewelleryRingSizesArgs = {
    region: RegionCode
}

export type CatalogueJewelleryRingTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export type CatalogueJewelleryRingTranslation = {
    __typename: 'CatalogueJewelleryRingTranslation'
    description: Maybe<Scalars['String']['output']>
    seoText: Maybe<Scalars['String']['output']>
}

export type CatalogueJewelleryRingsFilters = {
    __typename: 'CatalogueJewelleryRingsFilters'
    designFeatures: Array<CatalogueFilterJewelleryDesignFeatureLabel>
    designStyles: Array<CatalogueFilterJewelleryDesignStyleLabel>
    gemstones: Array<CatalogueFilterJewelleryGemstoneLabel>
    price: CataloguePriceRangeFilter
    primaryMetals: Array<CatalogueFilterMetalItem>
    productStyles: Array<CatalogueFilterJewelleryRingProductStyleLabel>
}

export type CatalogueJewelleryRingsFiltersPriceArgs = {
    input: CatalogueFiltersPriceInput
}

export const CatalogueJewelleryType = {
    Bracelet: 'BRACELET',
    Earrings: 'EARRINGS',
    Necklace: 'NECKLACE',
    Ring: 'RING',
} as const

export type CatalogueJewelleryType =
    (typeof CatalogueJewelleryType)[keyof typeof CatalogueJewelleryType]
export type CatalogueMelee = {
    __typename: 'CatalogueMelee'
    melee: Melee
    quantity: Scalars['Int']['output']
}

export type CataloguePriceRange = {
    __typename: 'CataloguePriceRange'
    max: Money
    min: Money
}

export type CataloguePriceRangeBar = {
    __typename: 'CataloguePriceRangeBar'
    range: CataloguePriceRange
    totalResults: Scalars['Int']['output']
}

export type CataloguePriceRangeFilter = {
    __typename: 'CataloguePriceRangeFilter'
    absoluteRange: CataloguePriceRange
    bars: Array<CataloguePriceRangeBar>
    currentRange: CataloguePriceRange
}

export type CataloguePriceRangeFilterBarsArgs = {
    input: PriceRangeBarInput
}

export type CatalogueProduct = {
    catalogueCode: Scalars['CatalogueCode']['output']
    customTitleTag: Maybe<Scalars['String']['output']>
    financeOptionsAffirm: Maybe<AffirmFinanceOption>
    financeOptionsKlarna: Maybe<KlarnaFinanceOption>
    images: Array<CatalogueImage>
    isReturnable: Scalars['Boolean']['output']
    mainImage: Maybe<GenericImage>
    primaryMetal: Metal
    productName: Scalars['String']['output']
    relatedProducts: Array<CatalogueProduct>
    reviews: Array<Review>
    salePrice: SalePrice
    segmentName: Scalars['String']['output']
    slug: Scalars['String']['output']
    suffix: Maybe<Scalars['String']['output']>
    suffixSlug: Maybe<Scalars['String']['output']>
    updatedAt: Maybe<Scalars['DateTime']['output']>
}

export type CatalogueProductFinanceOptionsAffirmArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueProductFinanceOptionsKlarnaArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueProductImagesArgs = {
    limit: InputMaybe<Scalars['Int']['input']>
}

export type CatalogueProductSalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export const CatalogueProductType = {
    EngagementRing: 'ENGAGEMENT_RING',
    Jewellery: 'JEWELLERY',
    JewelleryBracelet: 'JEWELLERY_BRACELET',
    JewelleryEarrings: 'JEWELLERY_EARRINGS',
    JewelleryNecklace: 'JEWELLERY_NECKLACE',
    JewelleryRing: 'JEWELLERY_RING',
    ReadyToGo: 'READY_TO_GO',
    WeddingRing: 'WEDDING_RING',
} as const

export type CatalogueProductType =
    (typeof CatalogueProductType)[keyof typeof CatalogueProductType]
export type CatalogueReadyToGoRing = CatalogueProduct & {
    __typename: 'CatalogueReadyToGoRing'
    carat: Maybe<Scalars['Float']['output']>
    catalogueCode: Scalars['CatalogueCode']['output']
    customTitleTag: Maybe<Scalars['String']['output']>
    deliveryDays: Scalars['Int']['output']
    financeOptionsAffirm: Maybe<AffirmFinanceOption>
    financeOptionsKlarna: Maybe<KlarnaFinanceOption>
    firstAvailableDeliveryDate: DeliveryDate
    gemType: GemType
    images: Array<CatalogueImage>
    isReadyToShip: Scalars['Boolean']['output']
    isReturnable: Scalars['Boolean']['output']
    mainImage: Maybe<GenericImage>
    primaryMetal: Metal
    productName: Scalars['String']['output']
    relatedProducts: Array<CatalogueReadyToGoRing>
    reviews: Array<Review>
    salePrice: SalePrice
    segmentName: Scalars['String']['output']
    shortDescription: Maybe<Scalars['String']['output']>
    shortName: Scalars['String']['output']
    signatureStone: Maybe<Melee>
    sizes: Array<RecommendedRingSize>
    sku: Maybe<Scalars['String']['output']>
    slug: Scalars['String']['output']
    suffix: Maybe<Scalars['String']['output']>
    suffixSlug: Maybe<Scalars['String']['output']>
    translation: CatalogueReadyToGoRingTranslation
    updatedAt: Maybe<Scalars['DateTime']['output']>
    variations: Array<CatalogueReadyToGoRing>
}

export type CatalogueReadyToGoRingDeliveryDaysArgs = {
    region: InputMaybe<RegionCode>
}

export type CatalogueReadyToGoRingFinanceOptionsAffirmArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueReadyToGoRingFinanceOptionsKlarnaArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueReadyToGoRingFirstAvailableDeliveryDateArgs = {
    region: RegionCode
}

export type CatalogueReadyToGoRingImagesArgs = {
    limit: InputMaybe<Scalars['Int']['input']>
}

export type CatalogueReadyToGoRingSalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueReadyToGoRingTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export type CatalogueReadyToGoRingFilterInput = {
    primaryMetalCode: MetalCode
    slug: Scalars['String']['input']
}

export type CatalogueReadyToGoRingFilters = {
    __typename: 'CatalogueReadyToGoRingFilters'
    price: CataloguePriceRangeFilter
    primaryMetals: Array<CatalogueFilterMetalItem>
}

export type CatalogueReadyToGoRingFiltersPriceArgs = {
    input: CatalogueFiltersPriceInput
}

export type CatalogueReadyToGoRingTranslation = {
    __typename: 'CatalogueReadyToGoRingTranslation'
    description: Maybe<Scalars['String']['output']>
    seoText: Maybe<Scalars['String']['output']>
}

export type CatalogueReadyToGoRingsFilterInput = {
    catalogueCode?: InputMaybe<Scalars['CatalogueCode']['input']>
    catalogueCodes?: InputMaybe<Array<Scalars['CatalogueCode']['input']>>
    includeHiddenFromProductList?: InputMaybe<Scalars['Boolean']['input']>
    price?: InputMaybe<CatalogueFilterPriceInput>
    primaryMetalCodes?: InputMaybe<Array<MetalCode>>
    readyToShip?: InputMaybe<Scalars['Boolean']['input']>
    search?: InputMaybe<Scalars['String']['input']>
    slug?: InputMaybe<Scalars['String']['input']>
    suffixSlug?: InputMaybe<Scalars['String']['input']>
}

export type CatalogueSortInput = {
    by: CatalogueSortOrder
    currency: CurrencyInput
}

export const CatalogueSortOrder = {
    PriceAscending: 'PRICE_ASCENDING',
    PriceDescending: 'PRICE_DESCENDING',
    Recommended: 'RECOMMENDED',
} as const

export type CatalogueSortOrder =
    (typeof CatalogueSortOrder)[keyof typeof CatalogueSortOrder]
export type CatalogueVideo = {
    __typename: 'CatalogueVideo'
    type: Scalars['String']['output']
    uri: Scalars['Uri']['output']
}

export type CatalogueWeddingRing = CatalogueProduct & {
    __typename: 'CatalogueWeddingRing'
    bandThickness: Scalars['Float']['output']
    bandType: Maybe<CatalogueBandType>
    bandWidth: Scalars['Float']['output']
    catalogueCode: Scalars['CatalogueCode']['output']
    categories: Array<WeddingRingCategoryLabel>
    customTitleTag: Maybe<Scalars['String']['output']>
    deliveryDays: Scalars['Int']['output']
    financeOptionsAffirm: Maybe<AffirmFinanceOption>
    financeOptionsKlarna: Maybe<KlarnaFinanceOption>
    firstAvailableDeliveryDate: DeliveryDate
    images: Array<CatalogueImage>
    images360: Array<GenericImage>
    isResizeable: Scalars['Boolean']['output']
    isReturnable: Scalars['Boolean']['output']
    mainImage: Maybe<GenericImage>
    meleeItems: Array<CatalogueMelee>
    primaryMetal: Metal
    productName: Scalars['String']['output']
    relatedProducts: Array<CatalogueWeddingRing>
    reviews: Array<Review>
    ringStyles: Array<WeddingRingStyleLabel>
    salePrice: SalePrice
    segmentName: Scalars['String']['output']
    signatureStone: Maybe<Melee>
    sizes: Array<RingSizeOrRecommendedRingSize>
    slug: Scalars['String']['output']
    suffix: Maybe<Scalars['String']['output']>
    suffixSlug: Maybe<Scalars['String']['output']>
    translation: CatalogueWeddingRingTranslation
    updatedAt: Maybe<Scalars['DateTime']['output']>
    variations: Array<CatalogueWeddingRing>
    video: Maybe<CatalogueVideo>
}

export type CatalogueWeddingRingDeliveryDaysArgs = {
    hasEngraving: InputMaybe<Scalars['Boolean']['input']>
    region: InputMaybe<RegionCode>
}

export type CatalogueWeddingRingFinanceOptionsAffirmArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueWeddingRingFinanceOptionsKlarnaArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueWeddingRingFirstAvailableDeliveryDateArgs = {
    hasEngraving: Scalars['Boolean']['input']
    region: RegionCode
}

export type CatalogueWeddingRingImagesArgs = {
    limit: InputMaybe<Scalars['Int']['input']>
}

export type CatalogueWeddingRingSalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueWeddingRingSizesArgs = {
    region: RegionCode
}

export type CatalogueWeddingRingTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export type CatalogueWeddingRingFilterInput = {
    catalogueCode?: InputMaybe<Scalars['CatalogueCode']['input']>
    catalogueCodes?: InputMaybe<Array<Scalars['CatalogueCode']['input']>>
    categories?: InputMaybe<Array<WeddingRingCategoryLabelCode>>
    includeHiddenFromProductList?: InputMaybe<Scalars['Boolean']['input']>
    price?: InputMaybe<CatalogueFilterPriceInput>
    primaryMetalCodes?: InputMaybe<Array<MetalCode>>
    ringStyles?: InputMaybe<Array<WeddingRingStyleLabelCode>>
    search?: InputMaybe<Scalars['String']['input']>
    slug?: InputMaybe<Scalars['String']['input']>
    suffixSlug?: InputMaybe<Scalars['String']['input']>
}

export type CatalogueWeddingRingFilters = {
    __typename: 'CatalogueWeddingRingFilters'
    categories: Array<CatalogueFilterWeddingRingCategoriesItem>
    price: CataloguePriceRangeFilter
    primaryMetals: Array<CatalogueFilterMetalItem>
    ringStyles: Array<CatalogueFilterWeddingRingStylesItem>
}

export type CatalogueWeddingRingFiltersPriceArgs = {
    input: CatalogueFiltersPriceInput
}

export type CatalogueWeddingRingFiltersVariation = {
    __typename: 'CatalogueWeddingRingFiltersVariation'
    category: Maybe<WeddingRingCategoryLabelCode>
    primaryMetal: Maybe<MetalCode>
    ringStyle: Maybe<WeddingRingStyleLabelCode>
}

export type CatalogueWeddingRingTranslation = {
    __typename: 'CatalogueWeddingRingTranslation'
    description: Maybe<Scalars['String']['output']>
    locale: Scalars['Locale']['output']
    seoText: Maybe<Scalars['String']['output']>
}

export type CheckoutcomOperationDeclinedError = {
    __typename: 'CheckoutcomOperationDeclinedError'
    message: Scalars['String']['output']
}

export type CheckoutcomPaymentMethod = {
    __typename: 'CheckoutcomPaymentMethod'
    debugMode: Scalars['Boolean']['output']
    publicKey: Scalars['String']['output']
    systemCode: Scalars['ID']['output']
}

export type CheckoutcomTransaction = TransactionInterface & {
    __typename: 'CheckoutcomTransaction'
    amount: Money
    createdAt: Scalars['DateTime']['output']
    id: Scalars['ID']['output']
    status: TransactionStatus
}

export const CmsEnquiryFormType = {
    BlogPost: 'BLOG_POST',
    EngagementRing: 'ENGAGEMENT_RING',
    EngagementRingBrowse: 'ENGAGEMENT_RING_BROWSE',
    JewelleryProductLandingGeneric: 'JEWELLERY_PRODUCT_LANDING_GENERIC',
    WeddingRing: 'WEDDING_RING',
    WeddingRingBespokeLanding: 'WEDDING_RING_BESPOKE_LANDING',
} as const

export type CmsEnquiryFormType =
    (typeof CmsEnquiryFormType)[keyof typeof CmsEnquiryFormType]
export const CmsGemstoneColorCode = {
    GemstoneAchroiteColourless: 'GEMSTONE_ACHROITE_COLOURLESS',
    GemstoneBiColour: 'GEMSTONE_BI_COLOUR',
    GemstoneBlack: 'GEMSTONE_BLACK',
    GemstoneBlue: 'GEMSTONE_BLUE',
    GemstoneBlueGray: 'GEMSTONE_BLUE_GRAY',
    GemstoneBlueGreen: 'GEMSTONE_BLUE_GREEN',
    GemstoneBlueViolet: 'GEMSTONE_BLUE_VIOLET',
    GemstoneBluishGray: 'GEMSTONE_BLUISH_GRAY',
    GemstoneBluishGreen: 'GEMSTONE_BLUISH_GREEN',
    GemstoneBluishViolet: 'GEMSTONE_BLUISH_VIOLET',
    GemstoneBrown: 'GEMSTONE_BROWN',
    GemstoneBrownishGreen: 'GEMSTONE_BROWNISH_GREEN',
    GemstoneBrownishOrange: 'GEMSTONE_BROWNISH_ORANGE',
    GemstoneBrownishPink: 'GEMSTONE_BROWNISH_PINK',
    GemstoneBrownishPurple: 'GEMSTONE_BROWNISH_PURPLE',
    GemstoneBrownishRed: 'GEMSTONE_BROWNISH_RED',
    GemstoneBrownishYellow: 'GEMSTONE_BROWNISH_YELLOW',
    GemstoneBrownGreen: 'GEMSTONE_BROWN_GREEN',
    GemstoneBrownOrange: 'GEMSTONE_BROWN_ORANGE',
    GemstoneBrownPink: 'GEMSTONE_BROWN_PINK',
    GemstoneBrownPurple: 'GEMSTONE_BROWN_PURPLE',
    GemstoneBrownRed: 'GEMSTONE_BROWN_RED',
    GemstoneBrownYellow: 'GEMSTONE_BROWN_YELLOW',
    GemstoneCanaryYellow: 'GEMSTONE_CANARY_YELLOW',
    GemstoneCatsEye: 'GEMSTONE_CATS_EYE',
    GemstoneChameleon: 'GEMSTONE_CHAMELEON',
    GemstoneChampagne: 'GEMSTONE_CHAMPAGNE',
    GemstoneChocolate: 'GEMSTONE_CHOCOLATE',
    GemstoneChromeDeepGreen: 'GEMSTONE_CHROME_DEEP_GREEN',
    GemstoneCognac: 'GEMSTONE_COGNAC',
    GemstoneColorChange: 'GEMSTONE_COLOR_CHANGE',
    GemstoneDraviteBrown: 'GEMSTONE_DRAVITE_BROWN',
    GemstoneElbaite: 'GEMSTONE_ELBAITE',
    GemstoneGray: 'GEMSTONE_GRAY',
    GemstoneGrayishGreen: 'GEMSTONE_GRAYISH_GREEN',
    GemstoneGrayishPurple: 'GEMSTONE_GRAYISH_PURPLE',
    GemstoneGrayishViolet: 'GEMSTONE_GRAYISH_VIOLET',
    GemstoneGrayBlue: 'GEMSTONE_GRAY_BLUE',
    GemstoneGrayGreen: 'GEMSTONE_GRAY_GREEN',
    GemstoneGrayGreenishYellow: 'GEMSTONE_GRAY_GREENISH_YELLOW',
    GemstoneGrayPurple: 'GEMSTONE_GRAY_PURPLE',
    GemstoneGrayViolet: 'GEMSTONE_GRAY_VIOLET',
    GemstoneGrayYellowishGreen: 'GEMSTONE_GRAY_YELLOWISH_GREEN',
    GemstoneGreen: 'GEMSTONE_GREEN',
    GemstoneGreenishBlue: 'GEMSTONE_GREENISH_BLUE',
    GemstoneGreenishBrown: 'GEMSTONE_GREENISH_BROWN',
    GemstoneGreenishGray: 'GEMSTONE_GREENISH_GRAY',
    GemstoneGreenishYellow: 'GEMSTONE_GREENISH_YELLOW',
    GemstoneGreenBlue: 'GEMSTONE_GREEN_BLUE',
    GemstoneGreenBrown: 'GEMSTONE_GREEN_BROWN',
    GemstoneGreenGray: 'GEMSTONE_GREEN_GRAY',
    GemstoneGreenYellow: 'GEMSTONE_GREEN_YELLOW',
    GemstoneOrange: 'GEMSTONE_ORANGE',
    GemstoneOrangeBrown: 'GEMSTONE_ORANGE_BROWN',
    GemstoneOrangePink: 'GEMSTONE_ORANGE_PINK',
    GemstoneOrangeRed: 'GEMSTONE_ORANGE_RED',
    GemstoneOrangeYellow: 'GEMSTONE_ORANGE_YELLOW',
    GemstoneOrangyBrown: 'GEMSTONE_ORANGY_BROWN',
    GemstoneOrangyPink: 'GEMSTONE_ORANGY_PINK',
    GemstoneOrangyRed: 'GEMSTONE_ORANGY_RED',
    GemstoneOrangyYellow: 'GEMSTONE_ORANGY_YELLOW',
    GemstonePadparadscha: 'GEMSTONE_PADPARADSCHA',
    GemstoneParaiba: 'GEMSTONE_PARAIBA',
    GemstonePeach: 'GEMSTONE_PEACH',
    GemstonePink: 'GEMSTONE_PINK',
    GemstonePinkishBrown: 'GEMSTONE_PINKISH_BROWN',
    GemstonePinkishPurple: 'GEMSTONE_PINKISH_PURPLE',
    GemstonePinkishRed: 'GEMSTONE_PINKISH_RED',
    GemstonePinkBrown: 'GEMSTONE_PINK_BROWN',
    GemstonePinkPurple: 'GEMSTONE_PINK_PURPLE',
    GemstonePurple: 'GEMSTONE_PURPLE',
    GemstonePurpleGray: 'GEMSTONE_PURPLE_GRAY',
    GemstonePurplePink: 'GEMSTONE_PURPLE_PINK',
    GemstonePurpleRed: 'GEMSTONE_PURPLE_RED',
    GemstonePurplishGray: 'GEMSTONE_PURPLISH_GRAY',
    GemstonePurplishPink: 'GEMSTONE_PURPLISH_PINK',
    GemstonePurplishRed: 'GEMSTONE_PURPLISH_RED',
    GemstoneRed: 'GEMSTONE_RED',
    GemstoneReddishBrown: 'GEMSTONE_REDDISH_BROWN',
    GemstoneReddishOrange: 'GEMSTONE_REDDISH_ORANGE',
    GemstoneReddishPurple: 'GEMSTONE_REDDISH_PURPLE',
    GemstoneRedBrown: 'GEMSTONE_RED_BROWN',
    GemstoneRedOrange: 'GEMSTONE_RED_ORANGE',
    GemstoneRedPurple: 'GEMSTONE_RED_PURPLE',
    GemstoneRubellite: 'GEMSTONE_RUBELLITE',
    GemstoneSchorlBlack: 'GEMSTONE_SCHORL_BLACK',
    GemstoneSiberitePurple: 'GEMSTONE_SIBERITE_PURPLE',
    GemstoneTeal: 'GEMSTONE_TEAL',
    GemstoneTurquoise: 'GEMSTONE_TURQUOISE',
    GemstoneVerdelitePurple: 'GEMSTONE_VERDELITE_PURPLE',
    GemstoneViolet: 'GEMSTONE_VIOLET',
    GemstoneVioletishBlue: 'GEMSTONE_VIOLETISH_BLUE',
    GemstoneVioletishGray: 'GEMSTONE_VIOLETISH_GRAY',
    GemstoneVioletishPurple: 'GEMSTONE_VIOLETISH_PURPLE',
    GemstoneVioletBlue: 'GEMSTONE_VIOLET_BLUE',
    GemstoneVioletGray: 'GEMSTONE_VIOLET_GRAY',
    GemstoneWatermelon: 'GEMSTONE_WATERMELON',
    GemstoneWhite: 'GEMSTONE_WHITE',
    GemstoneYellow: 'GEMSTONE_YELLOW',
    GemstoneYellowishBrown: 'GEMSTONE_YELLOWISH_BROWN',
    GemstoneYellowishGray: 'GEMSTONE_YELLOWISH_GRAY',
    GemstoneYellowishGreen: 'GEMSTONE_YELLOWISH_GREEN',
    GemstoneYellowishOrange: 'GEMSTONE_YELLOWISH_ORANGE',
    GemstoneYellowBrown: 'GEMSTONE_YELLOW_BROWN',
    GemstoneYellowGray: 'GEMSTONE_YELLOW_GRAY',
    GemstoneYellowGreen: 'GEMSTONE_YELLOW_GREEN',
    GemstoneYellowOrange: 'GEMSTONE_YELLOW_ORANGE',
} as const

export type CmsGemstoneColorCode =
    (typeof CmsGemstoneColorCode)[keyof typeof CmsGemstoneColorCode]
export type CollectFromShowroomInput = {
    billingAddress: OrderBillingAddressInput
    deliveryData: OrderCollectFromShowroomDeliveryInput
    orderId: Scalars['ID']['input']
    showroomID: Scalars['ID']['input']
}

export const Color = {
    Blue: 'BLUE',
    Blush: 'BLUSH',
    Green: 'GREEN',
    Red: 'RED',
    Sage: 'SAGE',
    Slate: 'SLATE',
    Stone: 'STONE',
    Stone2: 'STONE2',
    Stone3: 'STONE3',
    Taaffeite: 'TAAFFEITE',
    White: 'WHITE',
} as const

export type Color = (typeof Color)[keyof typeof Color]
export type CommissionJunctionInput = {
    code: Scalars['String']['input']
}

export type CompleteCheckoutcomTransactionInput = {
    checkoutcomTransactionId: Scalars['ID']['input']
    ckoId: Scalars['String']['input']
}

export type CompleteCheckoutcomTransactionPost3dsError =
    | CheckoutcomOperationDeclinedError
    | DesiredDeliveryDateInvalidError
    | OrderAlreadyCompletedError
    | PaymentAmountInvalidError

export type CompleteCheckoutcomTransactionPost3dsFailureResponse = {
    __typename: 'CompleteCheckoutcomTransactionPost3dsFailureResponse'
    errors: Array<CompleteCheckoutcomTransactionPost3dsError>
}

export type CompleteCheckoutcomTransactionPost3dsResponse =
    | CompleteCheckoutcomTransactionPost3dsFailureResponse
    | CompleteCheckoutcomTransactionPost3dsSuccessResponse

export type CompleteCheckoutcomTransactionPost3dsSuccessResponse = {
    __typename: 'CompleteCheckoutcomTransactionPost3dsSuccessResponse'
    order: Order
}

export type Component =
    | ComponentArticleGrid
    | ComponentArticlePreviews
    | ComponentBannerSkinny
    | ComponentBannerTitle
    | ComponentCard
    | ComponentCardCarousel
    | ComponentCatalogueProductCarousel
    | ComponentContent
    | ComponentContentTwoColumns
    | ComponentContentWithGallery
    | ComponentCustomProductCarousel
    | ComponentFaq
    | ComponentFullWidthImage
    | ComponentGalleryCarousel
    | ComponentGalleryWithEnquiry
    | ComponentGlobalComponent
    | ComponentGlobalSpacer
    | ComponentIconCarousel
    | ComponentInstagramPosts
    | ComponentInstagramWithContent
    | ComponentLogos
    | ComponentLogosCarousel
    | ComponentMainCover
    | ComponentOnThisPage
    | ComponentQuote
    | ComponentRelatedProducts
    | ComponentReviewCarousel
    | ComponentRoundedImage
    | ComponentRoundedImageContent
    | ComponentShopWithConfidence
    | ComponentSideBySideImages
    | ComponentSquareBoxes
    | ComponentTable
    | ComponentTextCarousel
    | ComponentTextOverImage
    | ComponentTextWithImage
    | ComponentTextWithImageCarousel
    | ComponentVideo
    | ComponentVideoWithContent

export type ComponentArticleGrid = {
    __typename: 'ComponentArticleGrid'
    articles: Array<ArticleGridItem>
}

export type ComponentArticleGridArticlesArgs = {
    locale: Scalars['Locale']['input']
}

export type ComponentArticlePreviews = {
    __typename: 'ComponentArticlePreviews'
    articles: Array<ArticlePreview>
}

export type ComponentArticlePreviewsArticlesArgs = {
    locale: Scalars['Locale']['input']
}

export type ComponentBannerSkinny = {
    __typename: 'ComponentBannerSkinny'
    backgroundColor: Color
    backgroundGraphic: Maybe<BannerSkinnyBackgroundGraphic>
    backgroundImage: Maybe<Image>
    title: ComponentTitle
    useBackgroundImage: Maybe<Scalars['Boolean']['output']>
}

export type ComponentBannerTitle = {
    __typename: 'ComponentBannerTitle'
    date: Maybe<Scalars['String']['output']>
    description: Maybe<Scalars['String']['output']>
    image: Image
    tag: HtmlTag
    title: Scalars['String']['output']
}

export type ComponentButton = {
    __typename: 'ComponentButton'
    alignment: HorizontalAlignment
    eventTracking: Maybe<ButtonEventTracking>
    icon: Maybe<ButtonIcon>
    link: Link
    style: ButtonStyle
    text: Scalars['String']['output']
}

export type ComponentCard = {
    __typename: 'ComponentCard'
    backgroundColor: Color
    content: Array<ContentComponentItem>
    image: Maybe<Image>
}

export type ComponentCardCarousel = {
    __typename: 'ComponentCardCarousel'
    items: Array<CardCarouselCard>
}

export type ComponentCatalogueProductCarousel = {
    __typename: 'ComponentCatalogueProductCarousel'
    items: Array<ComponentCatalogueProductCarouselItem>
}

export type ComponentCatalogueProductCarouselItem = {
    __typename: 'ComponentCatalogueProductCarouselItem'
    catalogueCode: Scalars['String']['output']
    product: Maybe<CatalogueProduct>
}

export type ComponentContent = {
    __typename: 'ComponentContent'
    content: Array<ContentComponentItem>
}

export type ComponentContentTwoColumns = {
    __typename: 'ComponentContentTwoColumns'
    leftColumnBackgroundColor: Color
    leftColumnContent: Array<ContentComponentItem>
    rightColumnBackgroundColor: Color
    rightColumnContent: Array<ContentComponentItem>
}

export type ComponentContentWithGallery = {
    __typename: 'ComponentContentWithGallery'
    content: Array<ContentComponentItem>
    gallery: Array<GalleryItem>
}

export type ComponentCustomProductCarousel = {
    __typename: 'ComponentCustomProductCarousel'
    products: Array<CarouselCustomProduct>
}

export type ComponentFaq = {
    __typename: 'ComponentFaq'
    sections: Array<FaqSection>
    showNavigation: Scalars['Boolean']['output']
}

export type ComponentFullWidthImage = {
    __typename: 'ComponentFullWidthImage'
    image: Image
    link: Maybe<Link>
    width: ImageWidth
}

export type ComponentGalleryCarousel = {
    __typename: 'ComponentGalleryCarousel'
    items: Array<GalleryCarouselCard>
}

export type ComponentGalleryWithEnquiry = {
    __typename: 'ComponentGalleryWithEnquiry'
    items: Array<GalleryWithEnquiryCard>
    type: CmsEnquiryFormType
}

export type ComponentGlobalComponent = {
    __typename: 'ComponentGlobalComponent'
    backgroundColor: Color
    components: Array<Component>
}

export type ComponentGlobalSpacer = {
    __typename: 'ComponentGlobalSpacer'
    spacing: Spacing
}

export type ComponentIconCarousel = {
    __typename: 'ComponentIconCarousel'
    items: Array<IconCarouselItem>
}

export type ComponentImage = {
    __typename: 'ComponentImage'
    image: Image
}

export type ComponentInstagramPosts = {
    __typename: 'ComponentInstagramPosts'
    instagramUser: Scalars['String']['output']
    instagramUserLink: Scalars['String']['output']
    posts: Array<InstagramPost>
    preTitle: Maybe<Scalars['String']['output']>
    title: ComponentTitle
}

export type ComponentInstagramWithContent = {
    __typename: 'ComponentInstagramWithContent'
    content: Maybe<Array<ContentComponentItem>>
    instagramEmbedCode: Maybe<Scalars['String']['output']>
    instagramImage: Maybe<Image>
    instagramLink: Maybe<Scalars['String']['output']>
    instagramPosition: ImagePosition
    instagramUsername: Maybe<Scalars['String']['output']>
    useImage: Maybe<Scalars['Boolean']['output']>
    width: InstagramWithContentWidth
}

export type ComponentLogos = {
    __typename: 'ComponentLogos'
    logos: Array<Logo>
}

export type ComponentLogosCarousel = {
    __typename: 'ComponentLogosCarousel'
    logos: Array<Logo>
}

export type ComponentMainCover = {
    __typename: 'ComponentMainCover'
    backgroundImage: Image
    content: Array<ContentComponentItem>
    mobileBackgroundImage: Image
}

export type ComponentOnThisPage = {
    __typename: 'ComponentOnThisPage'
    null: Maybe<Scalars['String']['output']>
}

export type ComponentOrderedList = {
    __typename: 'ComponentOrderedList'
    items: Array<OrderedListItem>
}

export type ComponentQuote = {
    __typename: 'ComponentQuote'
    author: Maybe<Scalars['String']['output']>
    hasBackgroundImage: Scalars['Boolean']['output']
    image: Maybe<Image>
    quote: Scalars['String']['output']
    showQuotationMarks: Scalars['Boolean']['output']
    size: QuoteSize
}

export type ComponentRelatedProducts = {
    __typename: 'ComponentRelatedProducts'
    null: Maybe<Scalars['String']['output']>
}

export type ComponentReviewCarousel = {
    __typename: 'ComponentReviewCarousel'
    reviews: Array<ReviewCarouselCard>
}

export type ComponentRoundedImage = {
    __typename: 'ComponentRoundedImage'
    backgroundColor: Color
    backgroundImage: Maybe<Image>
    backgroundImageColor: Color
    roundedImage: Image
}

export type ComponentRoundedImageContent = {
    __typename: 'ComponentRoundedImageContent'
    content: Array<ContentComponentItem>
    roundedImage: ComponentRoundedImage
}

export type ComponentShopWithConfidence = {
    __typename: 'ComponentShopWithConfidence'
    components: Array<ShopWithConfidenceComponent>
    ethnicallySourcedDiamonds: Array<ContentComponentItem>
    financingOptions: Array<ContentComponentItem>
    greenlandRuby: Array<ContentComponentItem>
    handFinished: Array<ContentComponentItem>
    resize: Array<ContentComponentItem>
    returnPolicy: Array<ContentComponentItem>
    shipping: Array<ContentComponentItem>
    title: Maybe<ComponentTitle>
}

export type ComponentSideBySideImage = {
    __typename: 'ComponentSideBySideImage'
    caption: Maybe<Scalars['String']['output']>
    content: Array<ContentComponentItem>
    image: Image
    link: Maybe<Link>
}

export type ComponentSideBySideImages = {
    __typename: 'ComponentSideBySideImages'
    images: Array<ComponentSideBySideImage>
}

export type ComponentSpacer = {
    __typename: 'ComponentSpacer'
    spacing: Spacing
}

export type ComponentSquareBoxes = {
    __typename: 'ComponentSquareBoxes'
    items: Array<SquareBoxes>
}

export type ComponentTable = {
    __typename: 'ComponentTable'
    table: Maybe<Table>
}

export type ComponentText = {
    __typename: 'ComponentText'
    alignment: HorizontalAlignment
    text: Scalars['String']['output']
    textSize: TextSize
}

export type ComponentTextCarousel = {
    __typename: 'ComponentTextCarousel'
    items: Array<TextCarouselItem>
}

export type ComponentTextOverImage = {
    __typename: 'ComponentTextOverImage'
    content: Array<ContentComponentItem>
    image: Image
}

export type ComponentTextWithImage = {
    __typename: 'ComponentTextWithImage'
    content: Array<ContentComponentItem>
    image: Image
    imageFormat: ImageFormat
    imagePosition: ImagePosition
    padding: Padding
}

export type ComponentTextWithImageCarousel = {
    __typename: 'ComponentTextWithImageCarousel'
    slidePadding: SlidePadding
    slides: Array<ComponentTextWithImage>
}

export type ComponentTitle = {
    __typename: 'ComponentTitle'
    alignment: HorizontalAlignment
    color: Color
    tag: HtmlTag
    /** @deprecated use texts */
    text: Scalars['String']['output']
    texts: Array<ComponentTitleComponent>
    titleSize: TitleSize
    titleStyle: TitleStyle
    titleWidth: TitleWidth
}

export type ComponentTitleAmpersand = {
    __typename: 'ComponentTitleAmpersand'
    null: Maybe<Scalars['String']['output']>
}

export type ComponentTitleComponent =
    | ComponentTitleAmpersand
    | ComponentTitleText

export type ComponentTitleText = {
    __typename: 'ComponentTitleText'
    text: Scalars['String']['output']
}

export type ComponentVideo = {
    __typename: 'ComponentVideo'
    video: Video
    width: VideoWidth
}

export type ComponentVideoWithContent = {
    __typename: 'ComponentVideoWithContent'
    content: Array<ContentComponentItem>
    coverImage: Image
    video: Video
    videoPosition: VideoPosition
}

export type Consultant = {
    __typename: 'Consultant'
    /** @deprecated use avatarImage */
    avatar: Scalars['Uri']['output']
    avatarImage: GenericImage
    canTakeConsultations: Scalars['Boolean']['output']
    firstName: Scalars['String']['output']
    id: Scalars['ID']['output']
    showroom: Maybe<Showroom>
    user: User
}

export type ContentComponentItem =
    | ComponentButton
    | ComponentImage
    | ComponentOrderedList
    | ComponentSpacer
    | ComponentText
    | ComponentTitle

export type ConvertMoneyInput = {
    money: MoneyInput
    targetCurrency: Scalars['Currency']['input']
}

export type ConvertPriceBoundsForGems = {
    currency: CurrencyInput
    max?: InputMaybe<Scalars['Decimal']['input']>
    min?: InputMaybe<Scalars['Decimal']['input']>
    region: RegionCode
}

export type CreateCheckoutcomTransactionError =
    | AvataxAddressInvalidError
    | DesiredDeliveryDateInvalidError
    | OrderAddressNotConfirmedError
    | OrderAlreadyCompletedError
    | OrderEmptyError
    | PaymentAmountInvalidError
    | PaymentMethodNotAllowedError

export type CreateCheckoutcomTransactionFailureResponse = {
    __typename: 'CreateCheckoutcomTransactionFailureResponse'
    errors: Array<CreateCheckoutcomTransactionError>
}

export type CreateCheckoutcomTransactionInput = {
    cardToken: Scalars['String']['input']
    orderId: Scalars['ID']['input']
}

export type CreateCheckoutcomTransactionResponse =
    | CreateCheckoutcomTransactionFailureResponse
    | CreateCheckoutcomTransactionSuccessResponse

export type CreateCheckoutcomTransactionSuccessResponse = {
    __typename: 'CreateCheckoutcomTransactionSuccessResponse'
    transaction: CheckoutcomTransaction
}

export type CredentialsInput = {
    identifier: Scalars['Email']['input']
    password: Scalars['String']['input']
}

export type CurrencyInput = {
    currency?: InputMaybe<Scalars['Currency']['input']>
    region: RegionCode
}

export type Customer = {
    __typename: 'Customer'
    adminProfileUrl: Maybe<Scalars['Uri']['output']>
    billingAddress: Maybe<Address>
    cart: Order
    consultant: Maybe<Consultant>
    designInspiration: Maybe<DesignInspiration>
    designStudioProduct: Maybe<DesignStudioProduct>
    designStudioProducts: Array<DesignStudioProduct>
    disabledThirdPartyCookies: Scalars['Boolean']['output']
    engagementRingRecommendations: Maybe<UserCustomerEngagementRingRecommendations>
    enquiries: Array<Enquiry>
    id: Scalars['ID']['output']
    order: Maybe<Order>
    orders: Array<Order>
    ordersByConsultationPurpose: Array<Order>
    questionnaireByType: Maybe<QuestionnaireCompletedQuestionnaire>
    salesforceProfileUrl: Maybe<Scalars['Uri']['output']>
    shippingAddress: Maybe<Address>
    user: User
}

export type CustomerDesignStudioProductArgs = {
    id: Scalars['ID']['input']
}

export type CustomerOrderArgs = {
    id: Scalars['ID']['input']
}

export type CustomerOrdersByConsultationPurposeArgs = {
    purpose: BookingConsultationPurposeCode
}

export type CustomerQuestionnaireByTypeArgs = {
    type: QuestionnaireType
}

export type CustomerRegistrationByGoogleInput = {
    currency: CurrencyInput
    forgottenPasswordUrl: Scalars['Uri']['input']
    phone?: InputMaybe<PhoneNumberInput>
    region: RegionCode
    token: Scalars['String']['input']
}

export type CustomerRegistrationByManualInput = {
    currency: CurrencyInput
    email: Scalars['Email']['input']
    emailConsent: Scalars['Boolean']['input']
    firstName: Scalars['String']['input']
    forgottenPasswordUrl: Scalars['Uri']['input']
    lastName?: InputMaybe<Scalars['String']['input']>
    phone?: InputMaybe<PhoneNumberInput>
    privacyConsent: Scalars['Boolean']['input']
    region: RegionCode
}

export type CustomerRegistrationInput = {
    byGoogle?: InputMaybe<CustomerRegistrationByGoogleInput>
    byManual?: InputMaybe<CustomerRegistrationByManualInput>
}

export type CustomerRegistrationResponse = {
    __typename: 'CustomerRegistrationResponse'
    login: Maybe<LoginResponseSuccess>
}

export type DeliverToAddressInput = {
    /** null billingAddress signifies that billing address is the same as shipping address */
    billingAddress?: InputMaybe<OrderBillingAddressInput>
    /** null desiredDeliveryDate means ASAR */
    desiredDeliveryDate?: InputMaybe<Scalars['DateTime']['input']>
    orderId: Scalars['ID']['input']
    shippingAddress: OrderShipToAddressInput
}

export type DeliveryDate = {
    __typename: 'DeliveryDate'
    date: Scalars['DateTime']['output']
    validUntil: Scalars['DateTime']['output']
}

export type DesignInspiration = {
    __typename: 'DesignInspiration'
    id: Scalars['ID']['output']
    url: Scalars['String']['output']
}

export type DesignStudioCentreStone =
    | DesignStudioExternalCentreStone
    | DesignStudioInternalCentreStone

export type DesignStudioEngagementRingCentreStone = {
    __typename: 'DesignStudioEngagementRingCentreStone'
    approved: Scalars['Boolean']['output']
    comment: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    manualSurcharges: Array<QuotationManualSurcharge>
    percentageSurcharge: Maybe<QuotationPercentageSurcharge>
    salePrice: Money
    stone: DesignStudioCentreStone
}

export type DesignStudioEngagementRingError =
    | DesignStudioEngagementRingErrorGeneric
    | DesignStudioEngagementRingErrorMaxCaratWeight
    | DesignStudioEngagementRingErrorMinCaratWeight
    | DesignStudioEngagementRingErrorShapeMismatch

export type DesignStudioEngagementRingErrorGeneric = {
    __typename: 'DesignStudioEngagementRingErrorGeneric'
    message: Scalars['String']['output']
}

export type DesignStudioEngagementRingErrorGenericMessageArgs = {
    locale: Scalars['Locale']['input']
}

export type DesignStudioEngagementRingErrorMaxCaratWeight = {
    __typename: 'DesignStudioEngagementRingErrorMaxCaratWeight'
    message: Scalars['String']['output']
}

export type DesignStudioEngagementRingErrorMaxCaratWeightMessageArgs = {
    locale: Scalars['Locale']['input']
}

export type DesignStudioEngagementRingErrorMinCaratWeight = {
    __typename: 'DesignStudioEngagementRingErrorMinCaratWeight'
    message: Scalars['String']['output']
}

export type DesignStudioEngagementRingErrorMinCaratWeightMessageArgs = {
    locale: Scalars['Locale']['input']
}

export type DesignStudioEngagementRingErrorShapeMismatch = {
    __typename: 'DesignStudioEngagementRingErrorShapeMismatch'
    matchingVariation: Maybe<CatalogueEngagementRing>
    message: Scalars['String']['output']
}

export type DesignStudioEngagementRingErrorShapeMismatchMessageArgs = {
    locale: Scalars['Locale']['input']
}

export type DesignStudioEngagementRingFailure = {
    __typename: 'DesignStudioEngagementRingFailure'
    errors: Array<DesignStudioEngagementRingError>
}

export type DesignStudioEngagementRingMount = {
    __typename: 'DesignStudioEngagementRingMount'
    approved: Scalars['Boolean']['output']
    comment: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    manualSurcharges: Array<QuotationManualSurcharge>
    melees: Array<DesignStudioMeleeItem>
    metals: Array<Metal>
    percentageSurcharge: Maybe<QuotationPercentageSurcharge>
    salePrice: Money
    sideStones: Array<DesignStudioSideStone>
    signatureStones: Array<DesignStudioSignatureStone>
}

export type DesignStudioExternalCentreStone = {
    __typename: 'DesignStudioExternalCentreStone'
    crystal: Maybe<StoneCrystal>
    id: Scalars['ID']['output']
    weight: Maybe<Scalars['Decimal']['output']>
}

export type DesignStudioExternalSideStone = {
    __typename: 'DesignStudioExternalSideStone'
    crystal: Maybe<StoneCrystal>
    id: Scalars['ID']['output']
    weight: Maybe<Scalars['Decimal']['output']>
}

export type DesignStudioInternalCentreStone = {
    __typename: 'DesignStudioInternalCentreStone'
    id: Scalars['ID']['output']
    nonSku: Maybe<HistoricalNonSku>
    sku: Maybe<Stone>
}

export type DesignStudioInternalSideStone = {
    __typename: 'DesignStudioInternalSideStone'
    id: Scalars['ID']['output']
    item: DesignStudioSideStoneItem
    quantity: Scalars['Int']['output']
}

export type DesignStudioJewelleryInput = {
    baseInput?: InputMaybe<EnquiryBaseInput>
    catalogueJewelleryCode: Scalars['CatalogueCode']['input']
    commissionJunction?: InputMaybe<CommissionJunctionInput>
    engraving?: InputMaybe<Scalars['String']['input']>
    ringSize?: InputMaybe<RingSizeInput>
    uri: Scalars['Uri']['input']
}

export type DesignStudioMeleeItem = {
    __typename: 'DesignStudioMeleeItem'
    id: Scalars['ID']['output']
    melee: Melee
    quantity: Scalars['Int']['output']
}

export type DesignStudioProduct = {
    cantBeResized: Scalars['Boolean']['output']
    cantBeReturned: Scalars['Boolean']['output']
    finalQuotation: Maybe<Quotation>
    id: Scalars['ID']['output']
    isAutofinalizable: Scalars['Boolean']['output']
    name: Scalars['String']['output']
    orderProduct: OrderProduct
    quotations: Array<Quotation>
}

export type DesignStudioProductAdditionalResize = DesignStudioProduct & {
    __typename: 'DesignStudioProductAdditionalResize'
    cantBeResized: Scalars['Boolean']['output']
    cantBeReturned: Scalars['Boolean']['output']
    finalQuotation: Maybe<Quotation>
    id: Scalars['ID']['output']
    isAutofinalizable: Scalars['Boolean']['output']
    name: Scalars['String']['output']
    orderProduct: OrderProduct
    quotations: Array<Quotation>
}

export type DesignStudioProductCustom = DesignStudioProduct & {
    __typename: 'DesignStudioProductCustom'
    cantBeResized: Scalars['Boolean']['output']
    cantBeReturned: Scalars['Boolean']['output']
    finalQuotation: Maybe<Quotation>
    id: Scalars['ID']['output']
    isAutofinalizable: Scalars['Boolean']['output']
    name: Scalars['String']['output']
    orderProduct: OrderProduct
    quotations: Array<Quotation>
}

export type DesignStudioProductEngagementRing = DesignStudioProduct & {
    __typename: 'DesignStudioProductEngagementRing'
    availableSizes: Array<RingSizeOrRecommendedRingSize>
    cantBeResized: Scalars['Boolean']['output']
    cantBeReturned: Scalars['Boolean']['output']
    engraving: Maybe<Scalars['String']['output']>
    finalQuotation: Maybe<Quotation>
    id: Scalars['ID']['output']
    isAutofinalizable: Scalars['Boolean']['output']
    name: Scalars['String']['output']
    orderProduct: OrderProduct
    quotations: Array<QuotationEngagementRing>
    size: Maybe<RingSizeOrRecommendedRingSize>
}

export type DesignStudioProductEngagementRingUpdate = {
    engraving?: InputMaybe<Scalars['String']['input']>
    size?: InputMaybe<RingSizeInput>
}

export type DesignStudioProductGeneric = DesignStudioProduct & {
    __typename: 'DesignStudioProductGeneric'
    cantBeResized: Scalars['Boolean']['output']
    cantBeReturned: Scalars['Boolean']['output']
    customer: Customer
    finalQuotation: Maybe<Quotation>
    id: Scalars['ID']['output']
    isAutofinalizable: Scalars['Boolean']['output']
    name: Scalars['String']['output']
    orderProduct: OrderProduct
    quotations: Array<Quotation>
}

export type DesignStudioProductLooseStone = DesignStudioProduct & {
    __typename: 'DesignStudioProductLooseStone'
    cantBeResized: Scalars['Boolean']['output']
    cantBeReturned: Scalars['Boolean']['output']
    finalQuotation: Maybe<Quotation>
    id: Scalars['ID']['output']
    isAutofinalizable: Scalars['Boolean']['output']
    name: Scalars['String']['output']
    orderProduct: OrderProduct
    quotations: Array<Quotation>
}

export type DesignStudioProductWeddingRing = DesignStudioProduct & {
    __typename: 'DesignStudioProductWeddingRing'
    availableSizes: Array<RingSizeOrRecommendedRingSize>
    cantBeResized: Scalars['Boolean']['output']
    cantBeReturned: Scalars['Boolean']['output']
    engraving: Maybe<Scalars['String']['output']>
    finalQuotation: Maybe<Quotation>
    id: Scalars['ID']['output']
    isAutofinalizable: Scalars['Boolean']['output']
    name: Scalars['String']['output']
    orderProduct: OrderProduct
    quotations: Array<QuotationWeddingRing>
    size: Maybe<RingSizeOrRecommendedRingSize>
}

export type DesignStudioProductWeddingRingUpdate = {
    engraving?: InputMaybe<Scalars['String']['input']>
    size?: InputMaybe<RingSizeInput>
}

export type DesignStudioQuotationEngagementRingUpdate = {
    ringApproved?: InputMaybe<Scalars['Boolean']['input']>
    stoneApproved?: InputMaybe<Scalars['Boolean']['input']>
}

export type DesignStudioSideStone =
    | DesignStudioExternalSideStone
    | DesignStudioInternalSideStone

export type DesignStudioSideStoneItem = Melee | Stone

export type DesignStudioSignatureStone = {
    __typename: 'DesignStudioSignatureStone'
    id: Scalars['ID']['output']
    melee: Melee
}

export type DesignStudioWeddingRingInput = {
    baseInput?: InputMaybe<EnquiryBaseInput>
    catalogueWeddingRingCode: Scalars['CatalogueCode']['input']
    commissionJunction?: InputMaybe<CommissionJunctionInput>
    engraving?: InputMaybe<Scalars['String']['input']>
    ringSize: RingSizeInput
    uri: Scalars['Uri']['input']
}

export type DesiredDeliveryDateInvalidError = {
    __typename: 'DesiredDeliveryDateInvalidError'
    message: Scalars['String']['output']
}

export const Display = {
    Block: 'BLOCK',
    Flex: 'FLEX',
} as const

export type Display = (typeof Display)[keyof typeof Display]
export type EngagementRingDesignFeatureLabel = {
    __typename: 'EngagementRingDesignFeatureLabel'
    icon: Maybe<Asset>
    systemCode: EngagementRingDesignFeatureLabelCode
    translation: ProductLabelTranslation
}

export type EngagementRingDesignFeatureLabelTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const EngagementRingDesignFeatureLabelCode = {
    BeadSetting: 'BEAD_SETTING',
    BezelSetting: 'BEZEL_SETTING',
    BlueSapphire: 'BLUE_SAPPHIRE',
    CathedralSetting: 'CATHEDRAL_SETTING',
    ChannelSetting: 'CHANNEL_SETTING',
    Classic: 'CLASSIC',
    ColouredGemstones: 'COLOURED_GEMSTONES',
    Contemporary: 'CONTEMPORARY',
    DoubleHalo: 'DOUBLE_HALO',
    EagleClaws: 'EAGLE_CLAWS',
    Emerald: 'EMERALD',
    Fishtail: 'FISHTAIL',
    GreenSapphire: 'GREEN_SAPPHIRE',
    HandEngraving: 'HAND_ENGRAVING',
    Milgrain: 'MILGRAIN',
    MixedMetal: 'MIXED_METAL',
    PinkSapphire: 'PINK_SAPPHIRE',
    PurpleSapphire: 'PURPLE_SAPPHIRE',
    Ruby: 'RUBY',
    SplitShank: 'SPLIT_SHANK',
    TealSapphire: 'TEAL_SAPPHIRE',
    YellowSapphire: 'YELLOW_SAPPHIRE',
} as const

export type EngagementRingDesignFeatureLabelCode =
    (typeof EngagementRingDesignFeatureLabelCode)[keyof typeof EngagementRingDesignFeatureLabelCode]
export type EngagementRingDesignStyleLabel = {
    __typename: 'EngagementRingDesignStyleLabel'
    icon: Maybe<Asset>
    systemCode: EngagementRingDesignStyleLabelCode
    translation: ProductLabelTranslation
}

export type EngagementRingDesignStyleLabelTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const EngagementRingDesignStyleLabelCode = {
    ArtDeco: 'ART_DECO',
    Bezel: 'BEZEL',
    Cathedral: 'CATHEDRAL',
    Classic: 'CLASSIC',
    Cluster: 'CLUSTER',
    Contemporary: 'CONTEMPORARY',
    Dainty: 'DAINTY',
    EastWest: 'EAST_WEST',
    Filigree: 'FILIGREE',
    Floral: 'FLORAL',
    HiddenHalo: 'HIDDEN_HALO',
    MixedMetal: 'MIXED_METAL',
    Sapphire: 'SAPPHIRE',
    SplitShank: 'SPLIT_SHANK',
    Twisted: 'TWISTED',
    Unique: 'UNIQUE',
    Vintage: 'VINTAGE',
} as const

export type EngagementRingDesignStyleLabelCode =
    (typeof EngagementRingDesignStyleLabelCode)[keyof typeof EngagementRingDesignStyleLabelCode]
export type EngagementRingStoneRecommendationCard = {
    __typename: 'EngagementRingStoneRecommendationCard'
    description: Scalars['String']['output']
    notFoundContent: Array<ContentComponentItem>
    notSupportedContent: Array<ContentComponentItem>
    title: Scalars['String']['output']
}

export type EngagementRingStoneRecommendationNaturalDiamonds = {
    __typename: 'EngagementRingStoneRecommendationNaturalDiamonds'
    forBalanceCard: EngagementRingStoneRecommendationCard
    forSizeCard: EngagementRingStoneRecommendationCard
    labGrownAlternative: EngagementRingStoneRecommendationCard
}

export type EngagementRingStoneRecommendationNonSkuGemStoneCard = {
    __typename: 'EngagementRingStoneRecommendationNonSkuGemStoneCard'
    color: CmsGemstoneColorCode
    content: EngagementRingStoneRecommendationCard
}

export type EngagementRingStoneRecommendationNonSkuLabGrown = {
    __typename: 'EngagementRingStoneRecommendationNonSkuLabGrown'
    forPriceCard: EngagementRingStoneRecommendationCard
    forSizeCard: EngagementRingStoneRecommendationCard
    naturalDiamondAlternative: EngagementRingStoneRecommendationCard
}

export type EngagementRingStoneRecommendations = {
    __typename: 'EngagementRingStoneRecommendations'
    blocks: Array<Block>
    fullSearchButtonText: Scalars['String']['output']
    introductionText: Scalars['String']['output']
    naturalDiamonds: EngagementRingStoneRecommendationNaturalDiamonds
    nonSkuGemStones: Array<EngagementRingStoneRecommendationNonSkuGemStoneCard>
    nonSkuLabGrown: EngagementRingStoneRecommendationNonSkuLabGrown
}

export type EngagementRingStoneRecommendationsNonSkuGemStonesArgs = {
    colorCodes: InputMaybe<Array<CmsGemstoneColorCode>>
}

export type EngagementRingStyleLabel = {
    __typename: 'EngagementRingStyleLabel'
    icon: Maybe<Asset>
    systemCode: EngagementRingStyleLabelCode
    translation: ProductLabelTranslation
}

export type EngagementRingStyleLabelTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const EngagementRingStyleLabelCode = {
    GemstoneSides: 'GEMSTONE_SIDES',
    Halo: 'HALO',
    Pave: 'PAVE',
    Solitaire: 'SOLITAIRE',
    ToiMoi: 'TOI_MOI',
    Trilogy: 'TRILOGY',
} as const

export type EngagementRingStyleLabelCode =
    (typeof EngagementRingStyleLabelCode)[keyof typeof EngagementRingStyleLabelCode]
export type Enquiry =
    | EnquiryConsultation
    | EnquiryEngagementRingAddToCart
    | EnquiryWeddingRingAddToCart

export type EnquiryBaseInput = {
    currency: CurrencyInput
    region: RegionCode
    uri: Scalars['Uri']['input']
}

export type EnquiryConsultation = {
    __typename: 'EnquiryConsultation'
    consultation: BookingConsultation
    id: Scalars['ID']['output']
}

export const EnquiryContactUsEnquiryPurpose = {
    Aftercare: 'AFTERCARE',
    Product: 'PRODUCT',
    Returning: 'RETURNING',
} as const

export type EnquiryContactUsEnquiryPurpose =
    (typeof EnquiryContactUsEnquiryPurpose)[keyof typeof EnquiryContactUsEnquiryPurpose]
export type EnquiryContactUsInput = {
    baseInput?: InputMaybe<EnquiryBaseInput>
    commissionJunction?: InputMaybe<CommissionJunctionInput>
    instructions: Scalars['String']['input']
    purpose: EnquiryContactUsEnquiryPurpose
    uri: Scalars['Uri']['input']
}

export type EnquiryCustomEngagementRing = {
    baseInput?: InputMaybe<EnquiryBaseInput>
    catalogueEngagementRingFilter: CatalogueEngagementRingFilterInput
    commissionJunction?: InputMaybe<CommissionJunctionInput>
    uri: Scalars['Uri']['input']
}

export type EnquiryDiamondSearchProduct = {
    baseInput?: InputMaybe<EnquiryBaseInput>
    commissionJunction?: InputMaybe<CommissionJunctionInput>
    currency: CurrencyInput
    gemsApiStoneIdentifier: Scalars['ID']['input']
    region: RegionCode
    uri: Scalars['Uri']['input']
}

export type EnquiryEngagementRingAddToCart = {
    __typename: 'EnquiryEngagementRingAddToCart'
    product: DesignStudioProductEngagementRing
}

export type EnquiryEngagementRingCollectionInput = {
    baseInput?: InputMaybe<EnquiryBaseInput>
    catalogueEngagementRingFilter: CatalogueEngagementRingFilterInput
    commissionJunction?: InputMaybe<CommissionJunctionInput>
    uri: Scalars['Uri']['input']
}

export type EnquiryImageInput = {
    name: Scalars['String']['input']
    uri: Scalars['Uri']['input']
}

export type EnquiryInput = {
    baseInput?: InputMaybe<EnquiryBaseInput>
    commissionJunction?: InputMaybe<CommissionJunctionInput>
    image?: InputMaybe<EnquiryImageInput>
    type: EnquiryType
    uri: Scalars['Uri']['input']
}

export type EnquiryResponseExistingCustomer = {
    __typename: 'EnquiryResponseExistingCustomer'
    marketingCloudForm: Scalars['String']['output']
}

export type EnquiryResponseNewCustomer = {
    __typename: 'EnquiryResponseNewCustomer'
    customer: CustomerRegistrationResponse
    marketingCloudForm: Scalars['String']['output']
}

export const EnquiryType = {
    BlogPost: 'BLOG_POST',
    EngagementRing: 'ENGAGEMENT_RING',
    EngagementRingBrowse: 'ENGAGEMENT_RING_BROWSE',
    JewelleryProductLandingGeneric: 'JEWELLERY_PRODUCT_LANDING_GENERIC',
    WeddingRing: 'WEDDING_RING',
    WeddingRingBespokeLanding: 'WEDDING_RING_BESPOKE_LANDING',
} as const

export type EnquiryType = (typeof EnquiryType)[keyof typeof EnquiryType]
export type EnquiryWeddingRingAddToCart = {
    __typename: 'EnquiryWeddingRingAddToCart'
    product: DesignStudioProductWeddingRing
}

export type FaqQuestion = {
    __typename: 'FaqQuestion'
    content: Array<ContentComponentItem>
    expandedByDefault: Scalars['Boolean']['output']
    question: Scalars['String']['output']
}

export type FaqSection = {
    __typename: 'FaqSection'
    questions: Array<FaqQuestion>
    title: Maybe<Scalars['String']['output']>
}

export type Footer = {
    __typename: 'Footer'
    columns: Array<FooterColumn>
    copyright: Scalars['String']['output']
    logos: Array<FooterLogo>
}

export type FooterColumn = {
    __typename: 'FooterColumn'
    items: Array<FooterColumnItem>
}

export type FooterColumnItem =
    | FooterColumnItemLinkList
    | FooterColumnItemSeparator
    | FooterColumnItemText
    | FooterColumnItemTitle
    | FooterColumnItemWorkingHours

export type FooterColumnItemLink = {
    __typename: 'FooterColumnItemLink'
    link: Link
    text: Scalars['String']['output']
}

export type FooterColumnItemLinkList = {
    __typename: 'FooterColumnItemLinkList'
    links: Array<FooterColumnItemLink>
}

export type FooterColumnItemSeparator = {
    __typename: 'FooterColumnItemSeparator'
    line: Scalars['Boolean']['output']
}

export type FooterColumnItemText = {
    __typename: 'FooterColumnItemText'
    text: Scalars['String']['output']
}

export type FooterColumnItemTitle = {
    __typename: 'FooterColumnItemTitle'
    title: Scalars['String']['output']
}

export type FooterColumnItemWorkingHours = {
    __typename: 'FooterColumnItemWorkingHours'
    workingHours: Array<WorkingHours>
}

export type FooterColumnItemWorkingHoursWorkingHoursArgs = {
    locale: Scalars['Locale']['input']
}

export type FooterLogo = {
    __typename: 'FooterLogo'
    link: Maybe<Scalars['String']['output']>
    logo: Image
}

export type GalleryCarouselCard = {
    __typename: 'GalleryCarouselCard'
    image: Image
    link: Maybe<Link>
}

export type GalleryItem = {
    __typename: 'GalleryItem'
    image: Image
}

export type GalleryWithEnquiryCard = {
    __typename: 'GalleryWithEnquiryCard'
    caption: Scalars['String']['output']
    image: Image
    slug: Scalars['String']['output']
}

export const GemType = {
    LabGrownDiamond: 'LAB_GROWN_DIAMOND',
    NaturalDiamond: 'NATURAL_DIAMOND',
} as const

export type GemType = (typeof GemType)[keyof typeof GemType]
export type GemsApiPriceBounds = {
    __typename: 'GemsApiPriceBounds'
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
}

export type GemsApiStone = {
    __typename: 'GemsApiStone'
    identifier: Scalars['ID']['output']
    stone: Maybe<GemsApi_Stone>
}

export type GemsApi_Bounds = {
    __typename: 'GemsApi_Bounds'
    categories: Array<GemsApi_StoneCategoryInfo>
    category: Array<GemsApi_StoneCategory>
    clarities: Array<GemsApi_StoneClarityInfo>
    clarity: Array<GemsApi_StoneClarity>
    colors: Array<GemsApi_StoneColorInfo>
    colour: Array<GemsApi_StoneColour>
    crystal: Array<GemsApi_StoneCrystal>
    crystals: Array<GemsApi_StoneCrystalInfo>
    cut: Array<GemsApi_StoneCut>
    cuts: Array<GemsApi_StoneCutInfo>
    deliveryDays: GemsApi_IntRange
    depth: GemsApi_Range
    depthPercent: GemsApi_Range
    fluorescence: Array<GemsApi_StoneFluorescence>
    fluorescences: Array<GemsApi_StoneFluorescenceInfo>
    grade: Array<GemsApi_StoneGrade>
    grades: Array<GemsApi_StoneGradeInfo>
    length: GemsApi_Range
    originCountry: Array<GemsApi_Country>
    polish: Array<GemsApi_StonePolish>
    polishes: Array<GemsApi_StonePolishInfo>
    price: GemsApi_PriceRange
    priceByShape: Array<GemsApi_PriceRangeByShape>
    ratio: GemsApi_Range
    shape: Array<GemsApi_StoneShape>
    shapes: Array<GemsApi_StoneShapeInfo>
    shippingFromCountry: Array<GemsApi_Country>
    symmetries: Array<GemsApi_StoneSymmetryInfo>
    symmetry: Array<GemsApi_StoneSymmetry>
    tablePercent: GemsApi_Range
    weight: GemsApi_Range
    width: GemsApi_Range
}

export const GemsApi_CertificateLab = {
    Gcal: 'GCAL',
    Gia: 'GIA',
    Igi: 'IGI',
} as const

export type GemsApi_CertificateLab =
    (typeof GemsApi_CertificateLab)[keyof typeof GemsApi_CertificateLab]
export const GemsApi_Country = {
    Ad: 'AD',
    Ae: 'AE',
    Af: 'AF',
    Ag: 'AG',
    Ai: 'AI',
    Al: 'AL',
    Am: 'AM',
    Ao: 'AO',
    Aq: 'AQ',
    Ar: 'AR',
    As: 'AS',
    At: 'AT',
    Au: 'AU',
    Aw: 'AW',
    Ax: 'AX',
    Az: 'AZ',
    Ba: 'BA',
    Bb: 'BB',
    Bd: 'BD',
    Be: 'BE',
    Bf: 'BF',
    Bg: 'BG',
    Bh: 'BH',
    Bi: 'BI',
    Bj: 'BJ',
    Bl: 'BL',
    Bm: 'BM',
    Bn: 'BN',
    Bo: 'BO',
    Bq: 'BQ',
    Br: 'BR',
    Bs: 'BS',
    Bt: 'BT',
    Bv: 'BV',
    Bw: 'BW',
    By: 'BY',
    Bz: 'BZ',
    Ca: 'CA',
    Cc: 'CC',
    Cd: 'CD',
    Cf: 'CF',
    Cg: 'CG',
    Ch: 'CH',
    Ci: 'CI',
    Ck: 'CK',
    Cl: 'CL',
    Cm: 'CM',
    Cn: 'CN',
    Co: 'CO',
    Cr: 'CR',
    Cu: 'CU',
    Cv: 'CV',
    Cw: 'CW',
    Cx: 'CX',
    Cy: 'CY',
    Cz: 'CZ',
    De: 'DE',
    Dj: 'DJ',
    Dk: 'DK',
    Dm: 'DM',
    Do: 'DO',
    Dz: 'DZ',
    Ec: 'EC',
    Ee: 'EE',
    Eg: 'EG',
    Eh: 'EH',
    Er: 'ER',
    Es: 'ES',
    Et: 'ET',
    Fi: 'FI',
    Fj: 'FJ',
    Fk: 'FK',
    Fm: 'FM',
    Fo: 'FO',
    Fr: 'FR',
    Ga: 'GA',
    Gb: 'GB',
    Gd: 'GD',
    Ge: 'GE',
    Gf: 'GF',
    Gg: 'GG',
    Gh: 'GH',
    Gi: 'GI',
    Gl: 'GL',
    Gm: 'GM',
    Gn: 'GN',
    Gp: 'GP',
    Gq: 'GQ',
    Gr: 'GR',
    Gs: 'GS',
    Gt: 'GT',
    Gu: 'GU',
    Gw: 'GW',
    Gy: 'GY',
    Hk: 'HK',
    Hm: 'HM',
    Hn: 'HN',
    Hr: 'HR',
    Ht: 'HT',
    Hu: 'HU',
    Id: 'ID',
    Ie: 'IE',
    Il: 'IL',
    Im: 'IM',
    In: 'IN',
    Io: 'IO',
    Iq: 'IQ',
    Ir: 'IR',
    Is: 'IS',
    It: 'IT',
    Je: 'JE',
    Jm: 'JM',
    Jo: 'JO',
    Jp: 'JP',
    Ke: 'KE',
    Kg: 'KG',
    Kh: 'KH',
    Ki: 'KI',
    Km: 'KM',
    Kn: 'KN',
    Kp: 'KP',
    Kr: 'KR',
    Kw: 'KW',
    Ky: 'KY',
    Kz: 'KZ',
    La: 'LA',
    Lb: 'LB',
    Lc: 'LC',
    Li: 'LI',
    Lk: 'LK',
    Lr: 'LR',
    Ls: 'LS',
    Lt: 'LT',
    Lu: 'LU',
    Lv: 'LV',
    Ly: 'LY',
    Ma: 'MA',
    Mc: 'MC',
    Md: 'MD',
    Me: 'ME',
    Mf: 'MF',
    Mg: 'MG',
    Mh: 'MH',
    Mk: 'MK',
    Ml: 'ML',
    Mm: 'MM',
    Mn: 'MN',
    Mo: 'MO',
    Mp: 'MP',
    Mq: 'MQ',
    Mr: 'MR',
    Ms: 'MS',
    Mt: 'MT',
    Mu: 'MU',
    Mv: 'MV',
    Mw: 'MW',
    Mx: 'MX',
    My: 'MY',
    Mz: 'MZ',
    Na: 'NA',
    Nc: 'NC',
    Ne: 'NE',
    Nf: 'NF',
    Ng: 'NG',
    Ni: 'NI',
    Nl: 'NL',
    No: 'NO',
    Np: 'NP',
    Nr: 'NR',
    Nu: 'NU',
    Nz: 'NZ',
    Om: 'OM',
    Pa: 'PA',
    Pe: 'PE',
    Pf: 'PF',
    Pg: 'PG',
    Ph: 'PH',
    Pk: 'PK',
    Pl: 'PL',
    Pm: 'PM',
    Pn: 'PN',
    Pr: 'PR',
    Ps: 'PS',
    Pt: 'PT',
    Pw: 'PW',
    Py: 'PY',
    Qa: 'QA',
    Re: 'RE',
    Ro: 'RO',
    Rs: 'RS',
    Ru: 'RU',
    Rw: 'RW',
    Sa: 'SA',
    Sb: 'SB',
    Sc: 'SC',
    Sd: 'SD',
    Se: 'SE',
    Sg: 'SG',
    Sh: 'SH',
    Si: 'SI',
    Sj: 'SJ',
    Sk: 'SK',
    Sl: 'SL',
    Sm: 'SM',
    Sn: 'SN',
    So: 'SO',
    Sr: 'SR',
    Ss: 'SS',
    St: 'ST',
    Sv: 'SV',
    Sx: 'SX',
    Sy: 'SY',
    Sz: 'SZ',
    Tc: 'TC',
    Td: 'TD',
    Tf: 'TF',
    Tg: 'TG',
    Th: 'TH',
    Tj: 'TJ',
    Tk: 'TK',
    Tl: 'TL',
    Tm: 'TM',
    Tn: 'TN',
    To: 'TO',
    Tr: 'TR',
    Tt: 'TT',
    Tv: 'TV',
    Tw: 'TW',
    Tz: 'TZ',
    Ua: 'UA',
    Ug: 'UG',
    Um: 'UM',
    Us: 'US',
    Uy: 'UY',
    Uz: 'UZ',
    Va: 'VA',
    Vc: 'VC',
    Ve: 'VE',
    Vg: 'VG',
    Vi: 'VI',
    Vn: 'VN',
    Vu: 'VU',
    Wf: 'WF',
    Ws: 'WS',
    Ye: 'YE',
    Yt: 'YT',
    Za: 'ZA',
    Zm: 'ZM',
    Zw: 'ZW',
} as const

export type GemsApi_Country =
    (typeof GemsApi_Country)[keyof typeof GemsApi_Country]
export type GemsApi_IntRange = {
    __typename: 'GemsApi_IntRange'
    max: Scalars['Int']['output']
    min: Scalars['Int']['output']
}

export type GemsApi_Pagination = {
    __typename: 'GemsApi_Pagination'
    limit: Scalars['Int']['output']
    page: Scalars['Int']['output']
    pages: Scalars['Int']['output']
    total: Scalars['Int']['output']
}

export type GemsApi_PaginationInput = {
    limit?: InputMaybe<Scalars['Int']['input']>
    page?: InputMaybe<Scalars['Int']['input']>
}

export type GemsApi_PricePoint = {
    __typename: 'GemsApi_PricePoint'
    market: Scalars['String']['output']
    price: Scalars['Float']['output']
}

export type GemsApi_PriceRange = {
    __typename: 'GemsApi_PriceRange'
    max: Scalars['Float']['output']
    maxInCurrency: Maybe<Money>
    min: Scalars['Float']['output']
    minInCurrency: Maybe<Money>
}

export type GemsApi_PriceRangeMaxInCurrencyArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type GemsApi_PriceRangeMinInCurrencyArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type GemsApi_PriceRangeByShape = {
    __typename: 'GemsApi_PriceRangeByShape'
    range: GemsApi_PriceRange
    shape: GemsApi_StoneShape
}

export type GemsApi_Range = {
    __typename: 'GemsApi_Range'
    max: Scalars['Float']['output']
    min: Scalars['Float']['output']
}

export type GemsApi_RangeInput = {
    max?: InputMaybe<Scalars['Float']['input']>
    min?: InputMaybe<Scalars['Float']['input']>
}

export type GemsApi_SelectedRange = {
    __typename: 'GemsApi_SelectedRange'
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
}

export type GemsApi_SelectedSorting = {
    __typename: 'GemsApi_SelectedSorting'
    direction: Maybe<GemsApi_SortingDirection>
    field: Maybe<GemsApi_SortingField>
}

export type GemsApi_SelectedStoneFilters = {
    __typename: 'GemsApi_SelectedStoneFilters'
    category: Maybe<Array<GemsApi_StoneCategory>>
    clarity: Maybe<Array<GemsApi_StoneClarity>>
    collection: Maybe<Array<Scalars['String']['output']>>
    colour: Maybe<Array<GemsApi_StoneColour>>
    costPrice: Maybe<GemsApi_SelectedRange>
    crystal: Maybe<Array<GemsApi_StoneCrystal>>
    cut: Maybe<Array<GemsApi_StoneCut>>
    depth: Maybe<GemsApi_SelectedRange>
    depthPercent: Maybe<GemsApi_SelectedRange>
    fluorescence: Maybe<Array<GemsApi_StoneFluorescence>>
    grade: Maybe<Array<GemsApi_StoneGrade>>
    hasPhoto: Maybe<Scalars['Boolean']['output']>
    isCanadaMark: Maybe<Scalars['Boolean']['output']>
    isDtlReport: Maybe<Scalars['Boolean']['output']>
    isRtg: Maybe<Scalars['Boolean']['output']>
    isScsReport: Maybe<Scalars['Boolean']['output']>
    isStock: Maybe<Scalars['Boolean']['output']>
    lab: Maybe<Array<GemsApi_CertificateLab>>
    length: Maybe<GemsApi_SelectedRange>
    notClarity: Maybe<Array<GemsApi_StoneClarity>>
    notColour: Maybe<Array<GemsApi_StoneColour>>
    notSymmetry: Maybe<Array<GemsApi_StoneSymmetry>>
    originCountry: Maybe<Array<GemsApi_Country>>
    polish: Maybe<Array<GemsApi_StonePolish>>
    price: Maybe<GemsApi_SelectedRange>
    priceIndex: Maybe<Scalars['String']['output']>
    ratio: Maybe<GemsApi_SelectedRange>
    shape: Maybe<Array<GemsApi_StoneShape>>
    shippingFrom: Maybe<Array<GemsApi_Country>>
    sorting: Maybe<GemsApi_SelectedSorting>
    symmetry: Maybe<Array<GemsApi_StoneSymmetry>>
    tablePercent: Maybe<GemsApi_SelectedRange>
    weight: Maybe<GemsApi_SelectedRange>
    width: Maybe<GemsApi_SelectedRange>
    withOriginCountry: Maybe<Scalars['Boolean']['output']>
    withVideo: Maybe<Scalars['Boolean']['output']>
}

export const GemsApi_SortingDirection = {
    Asc: 'ASC',
    Desc: 'DESC',
} as const

export type GemsApi_SortingDirection =
    (typeof GemsApi_SortingDirection)[keyof typeof GemsApi_SortingDirection]
export const GemsApi_SortingField = {
    Price: 'PRICE',
    Rap: 'RAP',
    Weight: 'WEIGHT',
} as const

export type GemsApi_SortingField =
    (typeof GemsApi_SortingField)[keyof typeof GemsApi_SortingField]
export type GemsApi_Stone = {
    __typename: 'GemsApi_Stone'
    blackInclusion: Maybe<GemsApi_StoneBlackInclusion>
    category: GemsApi_StoneCategory
    categoryWithInfo: GemsApi_StoneCategoryInfo
    certificates: GemsApi_StoneCertificates
    clarity: GemsApi_StoneClarity
    clarityWithInfo: GemsApi_StoneClarityInfo
    colorWithInfo: GemsApi_StoneColorInfo
    colour: GemsApi_StoneColour
    colourShade: Maybe<GemsApi_StoneColourShade>
    containsEngagementRings: Maybe<Scalars['Boolean']['output']>
    crownAngle: Maybe<Scalars['Float']['output']>
    crownHeight: Maybe<Scalars['Float']['output']>
    crystal: GemsApi_StoneCrystal
    crystalWithInfo: GemsApi_StoneCrystalInfo
    culet: Maybe<GemsApi_StoneCulet>
    cut: Maybe<GemsApi_StoneCut>
    cutWithInfo: Maybe<GemsApi_StoneCutInfo>
    deliveryDays: Maybe<Scalars['Int']['output']>
    depth: Maybe<Scalars['Float']['output']>
    depthPercent: Maybe<Scalars['Float']['output']>
    dtlReport: Maybe<GemsApi_DtlReport>
    externalId: Scalars['String']['output']
    eyeClean: Maybe<GemsApi_StoneEyeClean>
    feedIdentifier: Scalars['String']['output']
    fluorescence: Maybe<GemsApi_StoneFluorescence>
    fluorescenceColour: Maybe<GemsApi_StoneFluorescenceColour>
    fluorescenceWithInfo: Maybe<GemsApi_StoneFluorescenceInfo>
    girdleMax: Maybe<GemsApi_StoneGirdle>
    girdleMin: Maybe<GemsApi_StoneGirdle>
    grade: Maybe<GemsApi_StoneGrade>
    gradeWithInfo: Maybe<GemsApi_StoneGradeInfo>
    growthMethod: Maybe<GemsApi_StoneGrowthMethod>
    hasPublicImages: Scalars['Boolean']['output']
    identifier: Scalars['GemsApi_StoneIdentifier']['output']
    image: Maybe<GemsApi_StoneImage>
    images: Array<GemsApi_StoneImage>
    isB2B: Scalars['Boolean']['output']
    isCanadaMark: Scalars['Boolean']['output']
    isCertificateVerified: Scalars['Boolean']['output']
    isHideCertificateNumber: Scalars['Boolean']['output']
    isHideMeasurements: Scalars['Boolean']['output']
    isMilky: Maybe<Scalars['Boolean']['output']>
    isTreated: Maybe<Scalars['Boolean']['output']>
    isValidB2C: Scalars['Boolean']['output']
    length: Maybe<Scalars['Float']['output']>
    originCountry: Maybe<GemsApi_Country>
    pavilionAngle: Maybe<Scalars['Float']['output']>
    pavilionDepth: Maybe<Scalars['Float']['output']>
    polish: Maybe<GemsApi_StonePolish>
    polishWithInfo: Maybe<GemsApi_StonePolishInfo>
    pricingNoVat: Array<GemsApi_PricePoint>
    ratio: Maybe<Scalars['Float']['output']>
    salePrice: Maybe<Money>
    scsReport: Maybe<Scalars['String']['output']>
    shape: GemsApi_StoneShape
    shapeWithInfo: GemsApi_StoneShapeInfo
    shippingFromCountry: GemsApi_Country
    symmetry: Maybe<GemsApi_StoneSymmetry>
    symmetryWithInfo: Maybe<GemsApi_StoneSymmetryInfo>
    tablePercent: Maybe<Scalars['Float']['output']>
    v360Url: Maybe<Scalars['String']['output']>
    weight: Scalars['Float']['output']
    width: Maybe<Scalars['Float']['output']>
}

export type GemsApi_StoneSalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export const GemsApi_StoneBlackInclusion = {
    Black: 'BLACK',
    Light: 'LIGHT',
    None: 'NONE',
    VeryLight: 'VERY_LIGHT',
} as const

export type GemsApi_StoneBlackInclusion =
    (typeof GemsApi_StoneBlackInclusion)[keyof typeof GemsApi_StoneBlackInclusion]
export const GemsApi_StoneCategory = {
    Diamond: 'DIAMOND',
    FancyDiamond: 'FANCY_DIAMOND',
    Gemstone: 'GEMSTONE',
    LabGrownDiamond: 'LAB_GROWN_DIAMOND',
    LabGrownFancyDiamond: 'LAB_GROWN_FANCY_DIAMOND',
} as const

export type GemsApi_StoneCategory =
    (typeof GemsApi_StoneCategory)[keyof typeof GemsApi_StoneCategory]
export type GemsApi_StoneCategoryInfo = {
    __typename: 'GemsApi_StoneCategoryInfo'
    code: GemsApi_StoneCategory
    info: Maybe<StoneCategory>
}

export type GemsApi_StoneCertificates = {
    __typename: 'GemsApi_StoneCertificates'
    gcal: Maybe<Scalars['String']['output']>
    gia: Maybe<Scalars['String']['output']>
    igi: Maybe<Scalars['String']['output']>
}

export const GemsApi_StoneClarity = {
    DiamondFl: 'DIAMOND_FL',
    DiamondIf: 'DIAMOND_IF',
    DiamondSi1: 'DIAMOND_SI1',
    DiamondSi2: 'DIAMOND_SI2',
    DiamondVs1: 'DIAMOND_VS1',
    DiamondVs2: 'DIAMOND_VS2',
    DiamondVvs1: 'DIAMOND_VVS1',
    DiamondVvs2: 'DIAMOND_VVS2',
    GemstoneEyeClean: 'GEMSTONE_EYE_CLEAN',
    GemstoneIncluded: 'GEMSTONE_INCLUDED',
    GemstoneLoupeClean: 'GEMSTONE_LOUPE_CLEAN',
    GemstoneSlightlyIncluded: 'GEMSTONE_SLIGHTLY_INCLUDED',
} as const

export type GemsApi_StoneClarity =
    (typeof GemsApi_StoneClarity)[keyof typeof GemsApi_StoneClarity]
export type GemsApi_StoneClarityInfo = {
    __typename: 'GemsApi_StoneClarityInfo'
    code: GemsApi_StoneClarity
    info: Maybe<StoneClarity>
}

export type GemsApi_StoneCollection = {
    __typename: 'GemsApi_StoneCollection'
    collection: Array<GemsApi_Stone>
    filters: GemsApi_SelectedStoneFilters
    pagination: GemsApi_Pagination
}

export type GemsApi_StoneColorInfo = {
    __typename: 'GemsApi_StoneColorInfo'
    code: GemsApi_StoneColour
    info: Maybe<StoneColor>
}

export const GemsApi_StoneColour = {
    DiamondD: 'DIAMOND_D',
    DiamondE: 'DIAMOND_E',
    DiamondF: 'DIAMOND_F',
    DiamondG: 'DIAMOND_G',
    DiamondH: 'DIAMOND_H',
    DiamondI: 'DIAMOND_I',
    DiamondJ: 'DIAMOND_J',
    DiamondK: 'DIAMOND_K',
    DiamondL: 'DIAMOND_L',
    DiamondM: 'DIAMOND_M',
    FancyDiamondAchrioteColourless: 'FANCY_DIAMOND_ACHRIOTE_COLOURLESS',
    FancyDiamondBlack: 'FANCY_DIAMOND_BLACK',
    FancyDiamondBlue: 'FANCY_DIAMOND_BLUE',
    FancyDiamondBlueGray: 'FANCY_DIAMOND_BLUE_GRAY',
    FancyDiamondBlueGreen: 'FANCY_DIAMOND_BLUE_GREEN',
    FancyDiamondBlueViolet: 'FANCY_DIAMOND_BLUE_VIOLET',
    FancyDiamondBluishGray: 'FANCY_DIAMOND_BLUISH_GRAY',
    FancyDiamondBluishGreen: 'FANCY_DIAMOND_BLUISH_GREEN',
    FancyDiamondBluishViolet: 'FANCY_DIAMOND_BLUISH_VIOLET',
    FancyDiamondBrown: 'FANCY_DIAMOND_BROWN',
    FancyDiamondBrownishGreen: 'FANCY_DIAMOND_BROWNISH_GREEN',
    FancyDiamondBrownishOrange: 'FANCY_DIAMOND_BROWNISH_ORANGE',
    FancyDiamondBrownishPink: 'FANCY_DIAMOND_BROWNISH_PINK',
    FancyDiamondBrownishPurple: 'FANCY_DIAMOND_BROWNISH_PURPLE',
    FancyDiamondBrownishRed: 'FANCY_DIAMOND_BROWNISH_RED',
    FancyDiamondBrownishYellow: 'FANCY_DIAMOND_BROWNISH_YELLOW',
    FancyDiamondBrownGreen: 'FANCY_DIAMOND_BROWN_GREEN',
    FancyDiamondBrownGreenishYellow: 'FANCY_DIAMOND_BROWN_GREENISH_YELLOW',
    FancyDiamondBrownOrange: 'FANCY_DIAMOND_BROWN_ORANGE',
    FancyDiamondBrownPink: 'FANCY_DIAMOND_BROWN_PINK',
    FancyDiamondBrownPurple: 'FANCY_DIAMOND_BROWN_PURPLE',
    FancyDiamondBrownRed: 'FANCY_DIAMOND_BROWN_RED',
    FancyDiamondBrownYellow: 'FANCY_DIAMOND_BROWN_YELLOW',
    FancyDiamondCanaryYellow: 'FANCY_DIAMOND_CANARY_YELLOW',
    FancyDiamondCatsEye: 'FANCY_DIAMOND_CATS_EYE',
    FancyDiamondChameleon: 'FANCY_DIAMOND_CHAMELEON',
    FancyDiamondChampagne: 'FANCY_DIAMOND_CHAMPAGNE',
    FancyDiamondChocolate: 'FANCY_DIAMOND_CHOCOLATE',
    FancyDiamondChromeDeepGreen: 'FANCY_DIAMOND_CHROME_DEEP_GREEN',
    FancyDiamondCognac: 'FANCY_DIAMOND_COGNAC',
    FancyDiamondColorChange: 'FANCY_DIAMOND_COLOR_CHANGE',
    FancyDiamondDraviteBrown: 'FANCY_DIAMOND_DRAVITE_BROWN',
    FancyDiamondElbaite: 'FANCY_DIAMOND_ELBAITE',
    FancyDiamondGray: 'FANCY_DIAMOND_GRAY',
    FancyDiamondGrayishBlue: 'FANCY_DIAMOND_GRAYISH_BLUE',
    FancyDiamondGrayishGreen: 'FANCY_DIAMOND_GRAYISH_GREEN',
    FancyDiamondGrayishPurple: 'FANCY_DIAMOND_GRAYISH_PURPLE',
    FancyDiamondGrayishViolet: 'FANCY_DIAMOND_GRAYISH_VIOLET',
    FancyDiamondGrayBlue: 'FANCY_DIAMOND_GRAY_BLUE',
    FancyDiamondGrayGreen: 'FANCY_DIAMOND_GRAY_GREEN',
    FancyDiamondGrayPurple: 'FANCY_DIAMOND_GRAY_PURPLE',
    FancyDiamondGrayViolet: 'FANCY_DIAMOND_GRAY_VIOLET',
    FancyDiamondGreen: 'FANCY_DIAMOND_GREEN',
    FancyDiamondGreenishBlue: 'FANCY_DIAMOND_GREENISH_BLUE',
    FancyDiamondGreenishBrown: 'FANCY_DIAMOND_GREENISH_BROWN',
    FancyDiamondGreenishGray: 'FANCY_DIAMOND_GREENISH_GRAY',
    FancyDiamondGreenishYellow: 'FANCY_DIAMOND_GREENISH_YELLOW',
    FancyDiamondGreenBlue: 'FANCY_DIAMOND_GREEN_BLUE',
    FancyDiamondGreenBrown: 'FANCY_DIAMOND_GREEN_BROWN',
    FancyDiamondGreenGray: 'FANCY_DIAMOND_GREEN_GRAY',
    FancyDiamondGreenYellow: 'FANCY_DIAMOND_GREEN_YELLOW',
    FancyDiamondGrey: 'FANCY_DIAMOND_GREY',
    FancyDiamondGreyBlue: 'FANCY_DIAMOND_GREY_BLUE',
    FancyDiamondGreyGreen: 'FANCY_DIAMOND_GREY_GREEN',
    FancyDiamondGreyGreenishYellow: 'FANCY_DIAMOND_GREY_GREENISH_YELLOW',
    FancyDiamondGreyPurple: 'FANCY_DIAMOND_GREY_PURPLE',
    FancyDiamondGreyViolet: 'FANCY_DIAMOND_GREY_VIOLET',
    FancyDiamondGreyYellowishGreen: 'FANCY_DIAMOND_GREY_YELLOWISH_GREEN',
    FancyDiamondOrange: 'FANCY_DIAMOND_ORANGE',
    FancyDiamondOrangeBrown: 'FANCY_DIAMOND_ORANGE_BROWN',
    FancyDiamondOrangePink: 'FANCY_DIAMOND_ORANGE_PINK',
    FancyDiamondOrangeRed: 'FANCY_DIAMOND_ORANGE_RED',
    FancyDiamondOrangeYellow: 'FANCY_DIAMOND_ORANGE_YELLOW',
    FancyDiamondOrangishBrown: 'FANCY_DIAMOND_ORANGISH_BROWN',
    FancyDiamondOrangishPink: 'FANCY_DIAMOND_ORANGISH_PINK',
    FancyDiamondOrangishRed: 'FANCY_DIAMOND_ORANGISH_RED',
    FancyDiamondOrangishYellow: 'FANCY_DIAMOND_ORANGISH_YELLOW',
    FancyDiamondOrangyBrown: 'FANCY_DIAMOND_ORANGY_BROWN',
    FancyDiamondOrangyPink: 'FANCY_DIAMOND_ORANGY_PINK',
    FancyDiamondOrangyRed: 'FANCY_DIAMOND_ORANGY_RED',
    FancyDiamondOrangyYellow: 'FANCY_DIAMOND_ORANGY_YELLOW',
    FancyDiamondPadparadscha: 'FANCY_DIAMOND_PADPARADSCHA',
    FancyDiamondParaiba: 'FANCY_DIAMOND_PARAIBA',
    FancyDiamondPeach: 'FANCY_DIAMOND_PEACH',
    FancyDiamondPink: 'FANCY_DIAMOND_PINK',
    FancyDiamondPinkishBrown: 'FANCY_DIAMOND_PINKISH_BROWN',
    FancyDiamondPinkishOrange: 'FANCY_DIAMOND_PINKISH_ORANGE',
    FancyDiamondPinkishPurple: 'FANCY_DIAMOND_PINKISH_PURPLE',
    FancyDiamondPinkishRed: 'FANCY_DIAMOND_PINKISH_RED',
    FancyDiamondPinkBrown: 'FANCY_DIAMOND_PINK_BROWN',
    FancyDiamondPinkOrange: 'FANCY_DIAMOND_PINK_ORANGE',
    FancyDiamondPinkPurple: 'FANCY_DIAMOND_PINK_PURPLE',
    FancyDiamondPurple: 'FANCY_DIAMOND_PURPLE',
    FancyDiamondPurpleGray: 'FANCY_DIAMOND_PURPLE_GRAY',
    FancyDiamondPurplePink: 'FANCY_DIAMOND_PURPLE_PINK',
    FancyDiamondPurpleRed: 'FANCY_DIAMOND_PURPLE_RED',
    FancyDiamondPurplishGray: 'FANCY_DIAMOND_PURPLISH_GRAY',
    FancyDiamondPurplishPink: 'FANCY_DIAMOND_PURPLISH_PINK',
    FancyDiamondPurplishRed: 'FANCY_DIAMOND_PURPLISH_RED',
    FancyDiamondRed: 'FANCY_DIAMOND_RED',
    FancyDiamondReddishBrown: 'FANCY_DIAMOND_REDDISH_BROWN',
    FancyDiamondReddishOrange: 'FANCY_DIAMOND_REDDISH_ORANGE',
    FancyDiamondReddishPurple: 'FANCY_DIAMOND_REDDISH_PURPLE',
    FancyDiamondRedBrown: 'FANCY_DIAMOND_RED_BROWN',
    FancyDiamondRedOrange: 'FANCY_DIAMOND_RED_ORANGE',
    FancyDiamondRedPurple: 'FANCY_DIAMOND_RED_PURPLE',
    FancyDiamondRubellite: 'FANCY_DIAMOND_RUBELLITE',
    FancyDiamondSchorlBlack: 'FANCY_DIAMOND_SCHORL_BLACK',
    FancyDiamondSiberitePurple: 'FANCY_DIAMOND_SIBERITE_PURPLE',
    FancyDiamondTeal: 'FANCY_DIAMOND_TEAL',
    FancyDiamondTurquoise: 'FANCY_DIAMOND_TURQUOISE',
    FancyDiamondVerdelitePurple: 'FANCY_DIAMOND_VERDELITE_PURPLE',
    FancyDiamondViolet: 'FANCY_DIAMOND_VIOLET',
    FancyDiamondVioletishBlue: 'FANCY_DIAMOND_VIOLETISH_BLUE',
    FancyDiamondVioletishGray: 'FANCY_DIAMOND_VIOLETISH_GRAY',
    FancyDiamondVioletBlue: 'FANCY_DIAMOND_VIOLET_BLUE',
    FancyDiamondVioletGray: 'FANCY_DIAMOND_VIOLET_GRAY',
    FancyDiamondWatermelon: 'FANCY_DIAMOND_WATERMELON',
    FancyDiamondWhite: 'FANCY_DIAMOND_WHITE',
    FancyDiamondYellow: 'FANCY_DIAMOND_YELLOW',
    FancyDiamondYellowishBrown: 'FANCY_DIAMOND_YELLOWISH_BROWN',
    FancyDiamondYellowishGray: 'FANCY_DIAMOND_YELLOWISH_GRAY',
    FancyDiamondYellowishGreen: 'FANCY_DIAMOND_YELLOWISH_GREEN',
    FancyDiamondYellowishOrange: 'FANCY_DIAMOND_YELLOWISH_ORANGE',
    FancyDiamondYellowBrown: 'FANCY_DIAMOND_YELLOW_BROWN',
    FancyDiamondYellowGray: 'FANCY_DIAMOND_YELLOW_GRAY',
    FancyDiamondYellowGreen: 'FANCY_DIAMOND_YELLOW_GREEN',
    FancyDiamondYellowOrange: 'FANCY_DIAMOND_YELLOW_ORANGE',
    GemstoneAchroiteColourless: 'GEMSTONE_ACHROITE_COLOURLESS',
    GemstoneBiColour: 'GEMSTONE_BI_COLOUR',
    GemstoneBlack: 'GEMSTONE_BLACK',
    GemstoneBlue: 'GEMSTONE_BLUE',
    GemstoneBlueGray: 'GEMSTONE_BLUE_GRAY',
    GemstoneBlueGreen: 'GEMSTONE_BLUE_GREEN',
    GemstoneBlueViolet: 'GEMSTONE_BLUE_VIOLET',
    GemstoneBluishGray: 'GEMSTONE_BLUISH_GRAY',
    GemstoneBluishGreen: 'GEMSTONE_BLUISH_GREEN',
    GemstoneBluishViolet: 'GEMSTONE_BLUISH_VIOLET',
    GemstoneBrown: 'GEMSTONE_BROWN',
    GemstoneBrownishGreen: 'GEMSTONE_BROWNISH_GREEN',
    GemstoneBrownishOrange: 'GEMSTONE_BROWNISH_ORANGE',
    GemstoneBrownishPink: 'GEMSTONE_BROWNISH_PINK',
    GemstoneBrownishPurple: 'GEMSTONE_BROWNISH_PURPLE',
    GemstoneBrownishRed: 'GEMSTONE_BROWNISH_RED',
    GemstoneBrownishYellow: 'GEMSTONE_BROWNISH_YELLOW',
    GemstoneBrownGreen: 'GEMSTONE_BROWN_GREEN',
    GemstoneBrownOrange: 'GEMSTONE_BROWN_ORANGE',
    GemstoneBrownPink: 'GEMSTONE_BROWN_PINK',
    GemstoneBrownPurple: 'GEMSTONE_BROWN_PURPLE',
    GemstoneBrownRed: 'GEMSTONE_BROWN_RED',
    GemstoneBrownYellow: 'GEMSTONE_BROWN_YELLOW',
    GemstoneCanaryYellow: 'GEMSTONE_CANARY_YELLOW',
    GemstoneCatsEye: 'GEMSTONE_CATS_EYE',
    GemstoneChameleon: 'GEMSTONE_CHAMELEON',
    GemstoneChampagne: 'GEMSTONE_CHAMPAGNE',
    GemstoneChocolate: 'GEMSTONE_CHOCOLATE',
    GemstoneChromeDeepGreen: 'GEMSTONE_CHROME_DEEP_GREEN',
    GemstoneCognac: 'GEMSTONE_COGNAC',
    GemstoneColorChange: 'GEMSTONE_COLOR_CHANGE',
    GemstoneDraviteBrown: 'GEMSTONE_DRAVITE_BROWN',
    GemstoneElbaite: 'GEMSTONE_ELBAITE',
    GemstoneElbaiteStandard: 'GEMSTONE_ELBAITE_STANDARD',
    GemstoneGray: 'GEMSTONE_GRAY',
    GemstoneGrayishGreen: 'GEMSTONE_GRAYISH_GREEN',
    GemstoneGrayishPurple: 'GEMSTONE_GRAYISH_PURPLE',
    GemstoneGrayishViolet: 'GEMSTONE_GRAYISH_VIOLET',
    GemstoneGrayBlue: 'GEMSTONE_GRAY_BLUE',
    GemstoneGrayGreen: 'GEMSTONE_GRAY_GREEN',
    GemstoneGrayGreenishYellow: 'GEMSTONE_GRAY_GREENISH_YELLOW',
    GemstoneGrayPurple: 'GEMSTONE_GRAY_PURPLE',
    GemstoneGrayViolet: 'GEMSTONE_GRAY_VIOLET',
    GemstoneGrayYellowishGreen: 'GEMSTONE_GRAY_YELLOWISH_GREEN',
    GemstoneGreen: 'GEMSTONE_GREEN',
    GemstoneGreenishBlue: 'GEMSTONE_GREENISH_BLUE',
    GemstoneGreenishBrown: 'GEMSTONE_GREENISH_BROWN',
    GemstoneGreenishGray: 'GEMSTONE_GREENISH_GRAY',
    GemstoneGreenishYellow: 'GEMSTONE_GREENISH_YELLOW',
    GemstoneGreenBlue: 'GEMSTONE_GREEN_BLUE',
    GemstoneGreenBlueOrBlueGreen: 'GEMSTONE_GREEN_BLUE_OR_BLUE_GREEN',
    GemstoneGreenBrown: 'GEMSTONE_GREEN_BROWN',
    GemstoneGreenGray: 'GEMSTONE_GREEN_GRAY',
    GemstoneGreenYellow: 'GEMSTONE_GREEN_YELLOW',
    GemstoneOrange: 'GEMSTONE_ORANGE',
    GemstoneOrangeBrown: 'GEMSTONE_ORANGE_BROWN',
    GemstoneOrangePink: 'GEMSTONE_ORANGE_PINK',
    GemstoneOrangeRed: 'GEMSTONE_ORANGE_RED',
    GemstoneOrangeYellow: 'GEMSTONE_ORANGE_YELLOW',
    GemstoneOrangishRed: 'GEMSTONE_ORANGISH_RED',
    GemstoneOrangishYellow: 'GEMSTONE_ORANGISH_YELLOW',
    GemstoneOrangyBrown: 'GEMSTONE_ORANGY_BROWN',
    GemstoneOrangyPink: 'GEMSTONE_ORANGY_PINK',
    GemstoneOrangyRed: 'GEMSTONE_ORANGY_RED',
    GemstoneOrangyYellow: 'GEMSTONE_ORANGY_YELLOW',
    GemstonePadparadscha: 'GEMSTONE_PADPARADSCHA',
    GemstoneParaiba: 'GEMSTONE_PARAIBA',
    GemstoneParaibaLightBlue: 'GEMSTONE_PARAIBA_LIGHT_BLUE',
    GemstonePeach: 'GEMSTONE_PEACH',
    GemstonePink: 'GEMSTONE_PINK',
    GemstonePinkishBrown: 'GEMSTONE_PINKISH_BROWN',
    GemstonePinkishPurple: 'GEMSTONE_PINKISH_PURPLE',
    GemstonePinkishRed: 'GEMSTONE_PINKISH_RED',
    GemstonePinkBrown: 'GEMSTONE_PINK_BROWN',
    GemstonePinkPurple: 'GEMSTONE_PINK_PURPLE',
    GemstonePurple: 'GEMSTONE_PURPLE',
    GemstonePurpleGray: 'GEMSTONE_PURPLE_GRAY',
    GemstonePurplePink: 'GEMSTONE_PURPLE_PINK',
    GemstonePurpleRed: 'GEMSTONE_PURPLE_RED',
    GemstonePurplishGray: 'GEMSTONE_PURPLISH_GRAY',
    GemstonePurplishPink: 'GEMSTONE_PURPLISH_PINK',
    GemstonePurplishRed: 'GEMSTONE_PURPLISH_RED',
    GemstoneRed: 'GEMSTONE_RED',
    GemstoneReddishBrown: 'GEMSTONE_REDDISH_BROWN',
    GemstoneReddishOrange: 'GEMSTONE_REDDISH_ORANGE',
    GemstoneReddishPurple: 'GEMSTONE_REDDISH_PURPLE',
    GemstoneRedBrown: 'GEMSTONE_RED_BROWN',
    GemstoneRedOrange: 'GEMSTONE_RED_ORANGE',
    GemstoneRedOrangeOrOrangeRed: 'GEMSTONE_RED_ORANGE_OR_ORANGE_RED',
    GemstoneRedPurple: 'GEMSTONE_RED_PURPLE',
    GemstoneRedPurpleOrPurpleRed: 'GEMSTONE_RED_PURPLE_OR_PURPLE_RED',
    GemstoneRubellite: 'GEMSTONE_RUBELLITE',
    GemstoneSchorlBlack: 'GEMSTONE_SCHORL_BLACK',
    GemstoneSiberitePurple: 'GEMSTONE_SIBERITE_PURPLE',
    GemstoneSlightlyPurplishRed: 'GEMSTONE_SLIGHTLY_PURPLISH_RED',
    GemstoneSlightlyYellowishGreen: 'GEMSTONE_SLIGHTLY_YELLOWISH_GREEN',
    GemstoneStronglyPurplishRed: 'GEMSTONE_STRONGLY_PURPLISH_RED',
    GemstoneStronglyYellowishGreen: 'GEMSTONE_STRONGLY_YELLOWISH_GREEN',
    GemstoneTeal: 'GEMSTONE_TEAL',
    GemstoneTurquoise: 'GEMSTONE_TURQUOISE',
    GemstoneVerdeliteGreen: 'GEMSTONE_VERDELITE_GREEN',
    GemstoneVerdelitePurple: 'GEMSTONE_VERDELITE_PURPLE',
    GemstoneVerySlightlyBluishGreen: 'GEMSTONE_VERY_SLIGHTLY_BLUISH_GREEN',
    GemstoneVerySlightlyGreenishBlue: 'GEMSTONE_VERY_SLIGHTLY_GREENISH_BLUE',
    GemstoneVeryStronglyBluishGreen: 'GEMSTONE_VERY_STRONGLY_BLUISH_GREEN',
    GemstoneVeryStronglyGreenishBlue: 'GEMSTONE_VERY_STRONGLY_GREENISH_BLUE',
    GemstoneViolet: 'GEMSTONE_VIOLET',
    GemstoneVioletishBlue: 'GEMSTONE_VIOLETISH_BLUE',
    GemstoneVioletishGray: 'GEMSTONE_VIOLETISH_GRAY',
    GemstoneVioletishPurple: 'GEMSTONE_VIOLETISH_PURPLE',
    GemstoneVioletBlue: 'GEMSTONE_VIOLET_BLUE',
    GemstoneVioletGray: 'GEMSTONE_VIOLET_GRAY',
    GemstoneWatermelon: 'GEMSTONE_WATERMELON',
    GemstoneWhite: 'GEMSTONE_WHITE',
    GemstoneYellow: 'GEMSTONE_YELLOW',
    GemstoneYellowishBrown: 'GEMSTONE_YELLOWISH_BROWN',
    GemstoneYellowishGray: 'GEMSTONE_YELLOWISH_GRAY',
    GemstoneYellowishGreen: 'GEMSTONE_YELLOWISH_GREEN',
    GemstoneYellowishOrange: 'GEMSTONE_YELLOWISH_ORANGE',
    GemstoneYellowBrown: 'GEMSTONE_YELLOW_BROWN',
    GemstoneYellowGray: 'GEMSTONE_YELLOW_GRAY',
    GemstoneYellowGreen: 'GEMSTONE_YELLOW_GREEN',
    GemstoneYellowGreenOrGreenYellow: 'GEMSTONE_YELLOW_GREEN_OR_GREEN_YELLOW',
    GemstoneYellowOrange: 'GEMSTONE_YELLOW_ORANGE',
} as const

export type GemsApi_StoneColour =
    (typeof GemsApi_StoneColour)[keyof typeof GemsApi_StoneColour]
export const GemsApi_StoneColourShade = {
    Blue: 'BLUE',
    Brown: 'BROWN',
    Fancy: 'FANCY',
    Gray: 'GRAY',
    Green: 'GREEN',
    Mixed: 'MIXED',
    None: 'NONE',
    Pink: 'PINK',
    Yellow: 'YELLOW',
} as const

export type GemsApi_StoneColourShade =
    (typeof GemsApi_StoneColourShade)[keyof typeof GemsApi_StoneColourShade]
export const GemsApi_StoneCrystal = {
    Diamond: 'DIAMOND',
    Emerald: 'EMERALD',
    FancyDiamond: 'FANCY_DIAMOND',
    LabGrownDiamond: 'LAB_GROWN_DIAMOND',
    LabGrownFancyDiamond: 'LAB_GROWN_FANCY_DIAMOND',
    Ruby: 'RUBY',
    Sapphire: 'SAPPHIRE',
    Spinel: 'SPINEL',
    Tanzanite: 'TANZANITE',
    Tourmaline: 'TOURMALINE',
    Tsavorite: 'TSAVORITE',
} as const

export type GemsApi_StoneCrystal =
    (typeof GemsApi_StoneCrystal)[keyof typeof GemsApi_StoneCrystal]
export type GemsApi_StoneCrystalInfo = {
    __typename: 'GemsApi_StoneCrystalInfo'
    code: GemsApi_StoneCrystal
    info: Maybe<StoneCrystal>
}

export const GemsApi_StoneCulet = {
    ExtremelyLarge: 'EXTREMELY_LARGE',
    Large: 'LARGE',
    Medium: 'MEDIUM',
    None: 'NONE',
    SlightlyLarge: 'SLIGHTLY_LARGE',
    Small: 'SMALL',
    VerySmall: 'VERY_SMALL',
} as const

export type GemsApi_StoneCulet =
    (typeof GemsApi_StoneCulet)[keyof typeof GemsApi_StoneCulet]
export const GemsApi_StoneCut = {
    Excellent: 'EXCELLENT',
    Good: 'GOOD',
    Ideal: 'IDEAL',
    VeryGood: 'VERY_GOOD',
} as const

export type GemsApi_StoneCut =
    (typeof GemsApi_StoneCut)[keyof typeof GemsApi_StoneCut]
export type GemsApi_StoneCutInfo = {
    __typename: 'GemsApi_StoneCutInfo'
    code: GemsApi_StoneCut
    info: Maybe<StoneCut>
}

export const GemsApi_StoneEyeClean = {
    Ec_50: 'EC_50',
    Ec_75: 'EC_75',
    Ec_100: 'EC_100',
} as const

export type GemsApi_StoneEyeClean =
    (typeof GemsApi_StoneEyeClean)[keyof typeof GemsApi_StoneEyeClean]
export type GemsApi_StoneFilters = {
    category?: InputMaybe<Array<GemsApi_StoneCategory>>
    clarity?: InputMaybe<Array<GemsApi_StoneClarity>>
    collection?: InputMaybe<Array<Scalars['String']['input']>>
    colour?: InputMaybe<Array<GemsApi_StoneColour>>
    costPrice?: InputMaybe<GemsApi_RangeInput>
    costPriceInCurrency?: InputMaybe<GemsApi_StonePriceFilter>
    crystal?: InputMaybe<Array<GemsApi_StoneCrystal>>
    cut?: InputMaybe<Array<GemsApi_StoneCut>>
    deliveryDays?: InputMaybe<Scalars['Int']['input']>
    depth?: InputMaybe<GemsApi_RangeInput>
    depthPercent?: InputMaybe<GemsApi_RangeInput>
    fluorescence?: InputMaybe<Array<GemsApi_StoneFluorescence>>
    grade?: InputMaybe<Array<GemsApi_StoneGrade>>
    hasPhoto?: InputMaybe<Scalars['Boolean']['input']>
    isCanadaMark?: InputMaybe<Scalars['Boolean']['input']>
    isConsultant?: InputMaybe<Scalars['Boolean']['input']>
    isDtlReport?: InputMaybe<Scalars['Boolean']['input']>
    isRtg?: InputMaybe<Scalars['Boolean']['input']>
    isScsReport?: InputMaybe<Scalars['Boolean']['input']>
    isStock?: InputMaybe<Scalars['Boolean']['input']>
    lab?: InputMaybe<Array<GemsApi_CertificateLab>>
    length?: InputMaybe<GemsApi_RangeInput>
    notClarity?: InputMaybe<Array<GemsApi_StoneClarity>>
    notColour?: InputMaybe<Array<GemsApi_StoneColour>>
    notSymmetry?: InputMaybe<Array<GemsApi_StoneSymmetry>>
    originCountry?: InputMaybe<Array<GemsApi_Country>>
    pagination?: InputMaybe<GemsApi_PaginationInput>
    polish?: InputMaybe<Array<GemsApi_StonePolish>>
    price?: InputMaybe<GemsApi_RangeInput>
    priceInCurrency?: InputMaybe<GemsApi_StonePriceFilter>
    priceIndex?: InputMaybe<Scalars['String']['input']>
    ratio?: InputMaybe<GemsApi_RangeInput>
    shape?: InputMaybe<Array<GemsApi_StoneShape>>
    shippingFrom?: InputMaybe<Array<GemsApi_Country>>
    sorting?: InputMaybe<GemsApi_StoneSorting>
    symmetry?: InputMaybe<Array<GemsApi_StoneSymmetry>>
    tablePercent?: InputMaybe<GemsApi_RangeInput>
    weight?: InputMaybe<GemsApi_RangeInput>
    width?: InputMaybe<GemsApi_RangeInput>
    withOriginCountry?: InputMaybe<Scalars['Boolean']['input']>
    withVideo?: InputMaybe<Scalars['Boolean']['input']>
}

export const GemsApi_StoneFluorescence = {
    Faint: 'FAINT',
    Medium: 'MEDIUM',
    None: 'NONE',
    Slight: 'SLIGHT',
    Strong: 'STRONG',
    VerySlight: 'VERY_SLIGHT',
    VeryStrong: 'VERY_STRONG',
} as const

export type GemsApi_StoneFluorescence =
    (typeof GemsApi_StoneFluorescence)[keyof typeof GemsApi_StoneFluorescence]
export const GemsApi_StoneFluorescenceColour = {
    Blue: 'BLUE',
} as const

export type GemsApi_StoneFluorescenceColour =
    (typeof GemsApi_StoneFluorescenceColour)[keyof typeof GemsApi_StoneFluorescenceColour]
export type GemsApi_StoneFluorescenceInfo = {
    __typename: 'GemsApi_StoneFluorescenceInfo'
    code: GemsApi_StoneFluorescence
    info: Maybe<StoneFluorescence>
}

export const GemsApi_StoneGirdle = {
    ExtremelyThick: 'EXTREMELY_THICK',
    ExtremelyThin: 'EXTREMELY_THIN',
    Medium: 'MEDIUM',
    SlightlyThick: 'SLIGHTLY_THICK',
    SlightlyThin: 'SLIGHTLY_THIN',
    Thick: 'THICK',
    Thin: 'THIN',
    VeryThick: 'VERY_THICK',
    VeryThin: 'VERY_THIN',
} as const

export type GemsApi_StoneGirdle =
    (typeof GemsApi_StoneGirdle)[keyof typeof GemsApi_StoneGirdle]
export const GemsApi_StoneGrade = {
    FancyDiamondFaint: 'FANCY_DIAMOND_FAINT',
    FancyDiamondFancy: 'FANCY_DIAMOND_FANCY',
    FancyDiamondFancyDark: 'FANCY_DIAMOND_FANCY_DARK',
    FancyDiamondFancyDeep: 'FANCY_DIAMOND_FANCY_DEEP',
    FancyDiamondFancyIntense: 'FANCY_DIAMOND_FANCY_INTENSE',
    FancyDiamondFancyLight: 'FANCY_DIAMOND_FANCY_LIGHT',
    FancyDiamondFancyVivid: 'FANCY_DIAMOND_FANCY_VIVID',
    FancyDiamondLight: 'FANCY_DIAMOND_LIGHT',
    FancyDiamondVeryLight: 'FANCY_DIAMOND_VERY_LIGHT',
    GemstoneDark: 'GEMSTONE_DARK',
    GemstoneHot: 'GEMSTONE_HOT',
    GemstoneLight: 'GEMSTONE_LIGHT',
    GemstoneMedium: 'GEMSTONE_MEDIUM',
    GemstoneMediumDark: 'GEMSTONE_MEDIUM_DARK',
    GemstoneMediumLight: 'GEMSTONE_MEDIUM_LIGHT',
    GemstoneVeryDark: 'GEMSTONE_VERY_DARK',
    GemstoneVeryLight: 'GEMSTONE_VERY_LIGHT',
} as const

export type GemsApi_StoneGrade =
    (typeof GemsApi_StoneGrade)[keyof typeof GemsApi_StoneGrade]
export type GemsApi_StoneGradeInfo = {
    __typename: 'GemsApi_StoneGradeInfo'
    code: GemsApi_StoneGrade
    info: Maybe<StoneGrade>
}

export const GemsApi_StoneGrowthMethod = {
    Cvd: 'CVD',
    Hpht: 'HPHT',
    Iia: 'IIA',
} as const

export type GemsApi_StoneGrowthMethod =
    (typeof GemsApi_StoneGrowthMethod)[keyof typeof GemsApi_StoneGrowthMethod]
export type GemsApi_StoneImage = {
    __typename: 'GemsApi_StoneImage'
    isB2B: Scalars['Boolean']['output']
    url: Scalars['GemsApi_Uri']['output']
}

export const GemsApi_StonePolish = {
    Excellent: 'EXCELLENT',
    Fair: 'FAIR',
    Good: 'GOOD',
    Ideal: 'IDEAL',
    VeryGood: 'VERY_GOOD',
} as const

export type GemsApi_StonePolish =
    (typeof GemsApi_StonePolish)[keyof typeof GemsApi_StonePolish]
export type GemsApi_StonePolishInfo = {
    __typename: 'GemsApi_StonePolishInfo'
    code: GemsApi_StonePolish
    info: Maybe<StonePolish>
}

export type GemsApi_StonePriceFilter = {
    max?: InputMaybe<MoneyInput>
    min?: InputMaybe<MoneyInput>
}

export const GemsApi_StoneShape = {
    Asscher: 'ASSCHER',
    BrilliantCutTrapezoid: 'BRILLIANT_CUT_TRAPEZOID',
    Bullet: 'BULLET',
    Cabochon: 'CABOCHON',
    Carre: 'CARRE',
    Circular: 'CIRCULAR',
    Cushion: 'CUSHION',
    Custom: 'CUSTOM',
    Emerald: 'EMERALD',
    European: 'EUROPEAN',
    Flower: 'FLOWER',
    HalfMoon: 'HALF_MOON',
    Heart: 'HEART',
    Hexagonal: 'HEXAGONAL',
    Kite: 'KITE',
    Marquise: 'MARQUISE',
    Octagonal: 'OCTAGONAL',
    OldMiners: 'OLD_MINERS',
    Oval: 'OVAL',
    Pear: 'PEAR',
    Princess: 'PRINCESS',
    Radiant: 'RADIANT',
    RectangularFrench: 'RECTANGULAR_FRENCH',
    Rose: 'ROSE',
    Round: 'ROUND',
    SquareFrench: 'SQUARE_FRENCH',
    StepCutTrapezoid: 'STEP_CUT_TRAPEZOID',
    StraightBaguette: 'STRAIGHT_BAGUETTE',
    TaperedBaguette: 'TAPERED_BAGUETTE',
    Trapezoid: 'TRAPEZOID',
    Triangular: 'TRIANGULAR',
    Trillion: 'TRILLION',
} as const

export type GemsApi_StoneShape =
    (typeof GemsApi_StoneShape)[keyof typeof GemsApi_StoneShape]
export type GemsApi_StoneShapeInfo = {
    __typename: 'GemsApi_StoneShapeInfo'
    code: GemsApi_StoneShape
    info: Maybe<StoneShape>
}

export type GemsApi_StoneSorting = {
    direction?: InputMaybe<GemsApi_SortingDirection>
    field?: InputMaybe<GemsApi_SortingField>
}

export const GemsApi_StoneSymmetry = {
    Excellent: 'EXCELLENT',
    Fair: 'FAIR',
    Good: 'GOOD',
    Ideal: 'IDEAL',
    VeryGood: 'VERY_GOOD',
} as const

export type GemsApi_StoneSymmetry =
    (typeof GemsApi_StoneSymmetry)[keyof typeof GemsApi_StoneSymmetry]
export type GemsApi_StoneSymmetryInfo = {
    __typename: 'GemsApi_StoneSymmetryInfo'
    code: GemsApi_StoneSymmetry
    info: Maybe<StoneSymmetry>
}

export type GemsApi_DtlReport = {
    __typename: 'GemsApi_dtlReport'
    code: Scalars['String']['output']
    url: Scalars['GemsApi_Uri']['output']
}

export type GenericImage = {
    __typename: 'GenericImage'
    mimeType: Scalars['String']['output']
    size: MonolithImageSize
    sources: Array<ImageSrc>
    url: Scalars['String']['output']
}

export type GenericImageSizeArgs = {
    name: MonolithImageSizeName
}

export type GeoPoint = {
    __typename: 'GeoPoint'
    id: Scalars['ID']['output']
    latitude: Scalars['Float']['output']
    longitude: Scalars['Float']['output']
}

export type HistoricalNonSku =
    | HistoricalNonSkuGemstone
    | HistoricalNonSkuLabGrown

export type HistoricalNonSkuGemstone = NonSkuGemStoneInterface &
    NonSkuInterface & {
        __typename: 'HistoricalNonSkuGemstone'
        caratWeight: Scalars['Decimal']['output']
        clarity: StoneClarity
        color: StoneColor
        colorGrade: StoneGrade
        crystal: StoneCrystal
        cut: StoneCut
        id: Scalars['ID']['output']
        image: Maybe<NonSkuImage>
        salePrice: Money
        shape: StoneShape
    }

export type HistoricalNonSkuGemstoneSalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type HistoricalNonSkuLabGrown = NonSkuInterface &
    NonSkuLabGrownInterface & {
        __typename: 'HistoricalNonSkuLabGrown'
        caratWeight: Scalars['Decimal']['output']
        clarity: StoneClarity
        color: StoneColor
        crystal: StoneCrystal
        cut: StoneCut
        id: Scalars['ID']['output']
        image: Maybe<NonSkuImage>
        salePrice: Money
        shape: StoneShape
    }

export type HistoricalNonSkuLabGrownSalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export const HorizontalAlignment = {
    Center: 'CENTER',
    Left: 'LEFT',
    Right: 'RIGHT',
} as const

export type HorizontalAlignment =
    (typeof HorizontalAlignment)[keyof typeof HorizontalAlignment]
export const HtmlTag = {
    Div: 'DIV',
    H1: 'H1',
    H2: 'H2',
    H3: 'H3',
    H4: 'H4',
    H5: 'H5',
    H6: 'H6',
} as const

export type HtmlTag = (typeof HtmlTag)[keyof typeof HtmlTag]
export const Icon = {
    Accessibility: 'ACCESSIBILITY',
    AngleDown: 'ANGLE_DOWN',
    AngleDownCircle: 'ANGLE_DOWN_CIRCLE',
    AngleLeft: 'ANGLE_LEFT',
    AngleLeftCircle: 'ANGLE_LEFT_CIRCLE',
    AngleRight: 'ANGLE_RIGHT',
    AngleRightCircle: 'ANGLE_RIGHT_CIRCLE',
    AngleTopCircle: 'ANGLE_TOP_CIRCLE',
    AngleUp: 'ANGLE_UP',
    Bag: 'BAG',
    Banner: 'BANNER',
    Bell: 'BELL',
    BlankPage: 'BLANK_PAGE',
    Box: 'BOX',
    BoxAlt: 'BOX_ALT',
    BoxReturn: 'BOX_RETURN',
    Calendar: 'CALENDAR',
    Camera: 'CAMERA',
    Cart: 'CART',
    CautionCircle: 'CAUTION_CIRCLE',
    CautionTriangle: 'CAUTION_TRIANGLE',
    Chart: 'CHART',
    ChartAlt: 'CHART_ALT',
    Checkmark: 'CHECKMARK',
    CheckmarkCircle: 'CHECKMARK_CIRCLE',
    Clock: 'CLOCK',
    ClockAlt: 'CLOCK_ALT',
    Close: 'CLOSE',
    Cog: 'COG',
    Comments: 'COMMENTS',
    CommentsAlt: 'COMMENTS_ALT',
    CommentDots: 'COMMENT_DOTS',
    CommentDotsAlt: 'COMMENT_DOTS_ALT',
    CommentEmpty: 'COMMENT_EMPTY',
    CommentEmptyAlt: 'COMMENT_EMPTY_ALT',
    CommentRows: 'COMMENT_ROWS',
    CommentRowsAlt: 'COMMENT_ROWS_ALT',
    CreditCard: 'CREDIT_CARD',
    Crosshair: 'CROSSHAIR',
    CrossCircle: 'CROSS_CIRCLE',
    Desktop: 'DESKTOP',
    Diamond: 'DIAMOND',
    DiamondAlt: 'DIAMOND_ALT',
    Dots: 'DOTS',
    DotsCircle: 'DOTS_CIRCLE',
    DotsVertical: 'DOTS_VERTICAL',
    Download: 'DOWNLOAD',
    Envelope: 'ENVELOPE',
    Eye: 'EYE',
    EyeStrikethrough: 'EYE_STRIKETHROUGH',
    Facebook: 'FACEBOOK',
    Filters: 'FILTERS',
    FiltersAlt: 'FILTERS_ALT',
    Globe: 'GLOBE',
    Hamburger: 'HAMBURGER',
    Hand: 'HAND',
    Heart: 'HEART',
    Help: 'HELP',
    House: 'HOUSE',
    IdCard: 'ID_CARD',
    Info: 'INFO',
    Instagram: 'INSTAGRAM',
    Key: 'KEY',
    Link: 'LINK',
    List: 'LIST',
    ListCircle: 'LIST_CIRCLE',
    LocationPin: 'LOCATION_PIN',
    Lock: 'LOCK',
    LockAlt: 'LOCK_ALT',
    Magnifier: 'MAGNIFIER',
    MagnifierAlt: 'MAGNIFIER_ALT',
    Map: 'MAP',
    Minus: 'MINUS',
    MinusCircle: 'MINUS_CIRCLE',
    Mta: 'MTA',
    Notebook: 'NOTEBOOK',
    Page: 'PAGE',
    Paperclip: 'PAPERCLIP',
    PaperAirplane: 'PAPER_AIRPLANE',
    Pencil: 'PENCIL',
    PencilAlt: 'PENCIL_ALT',
    PencilAlt_2: 'PENCIL_ALT_2',
    Phone: 'PHONE',
    Pin: 'PIN',
    Pinterest: 'PINTEREST',
    Play: 'PLAY',
    Plus: 'PLUS',
    PlusCircle: 'PLUS_CIRCLE',
    Power: 'POWER',
    Profile: 'PROFILE',
    Redo: 'REDO',
    Refresh: 'REFRESH',
    Rings: 'RINGS',
    ShapeAsscher: 'SHAPE_ASSCHER',
    ShapeCushion: 'SHAPE_CUSHION',
    ShapeEmerald: 'SHAPE_EMERALD',
    ShapeEuropean: 'SHAPE_EUROPEAN',
    ShapeHeart: 'SHAPE_HEART',
    ShapeHexagonal: 'SHAPE_HEXAGONAL',
    ShapeMarquise: 'SHAPE_MARQUISE',
    ShapeOval: 'SHAPE_OVAL',
    ShapePear: 'SHAPE_PEAR',
    ShapePrincess: 'SHAPE_PRINCESS',
    ShapeRadiant: 'SHAPE_RADIANT',
    ShapeRound: 'SHAPE_ROUND',
    ShapeRoundAlt: 'SHAPE_ROUND_ALT',
    Share: 'SHARE',
    Smartphone: 'SMARTPHONE',
    Speaker_1: 'SPEAKER_1',
    Speaker_2: 'SPEAKER_2',
    Speaker_3: 'SPEAKER_3',
    Speaker_4: 'SPEAKER_4',
    SpeakerMuted: 'SPEAKER_MUTED',
    Star: 'STAR',
    Stop: 'STOP',
    Tablet: 'TABLET',
    Text: 'TEXT',
    TextCircle: 'TEXT_CIRCLE',
    ThreeUsers: 'THREE_USERS',
    Thumbsup: 'THUMBSUP',
    Truck: 'TRUCK',
    Twitter: 'TWITTER',
    TwoUsers: 'TWO_USERS',
    Underground: 'UNDERGROUND',
    Undo: 'UNDO',
    Youtube: 'YOUTUBE',
} as const

export type Icon = (typeof Icon)[keyof typeof Icon]
export type IconCarouselItem = {
    __typename: 'IconCarouselItem'
    icon: Icon
    text: Maybe<Scalars['String']['output']>
}

export type Image = Media & {
    __typename: 'Image'
    alt: Maybe<Scalars['String']['output']>
    caption: Maybe<Scalars['String']['output']>
    description: Maybe<Scalars['String']['output']>
    filename: Scalars['String']['output']
    filesize: Scalars['Int']['output']
    height: Scalars['Int']['output']
    id: Scalars['ID']['output']
    mimeType: Scalars['String']['output']
    name: Scalars['String']['output']
    size: ImageSize
    sizes: Array<ImageSize>
    sources: Array<ImageSrc>
    title: Scalars['String']['output']
    url: Scalars['String']['output']
    width: Scalars['Int']['output']
}

export type ImageSizeArgs = {
    name: ImageSizeName
}

export const ImageFormat = {
    Landscape: 'LANDSCAPE',
    Portrait: 'PORTRAIT',
    Rounded: 'ROUNDED',
    Square: 'SQUARE',
} as const

export type ImageFormat = (typeof ImageFormat)[keyof typeof ImageFormat]
export const ImagePosition = {
    Left: 'LEFT',
    Right: 'RIGHT',
} as const

export type ImagePosition = (typeof ImagePosition)[keyof typeof ImagePosition]
export type ImageSize = {
    __typename: 'ImageSize'
    mimeType: Scalars['String']['output']
    name: ImageSizeName
    sources: Array<ImageSrc>
    url: Scalars['String']['output']
}

export const ImageSizeName = {
    Cover: 'COVER',
    CoverX2: 'COVER_X2',
    Large: 'LARGE',
    LargeX2: 'LARGE_X2',
    Medium: 'MEDIUM',
    MediumX2: 'MEDIUM_X2',
    Small: 'SMALL',
    SmallX2: 'SMALL_X2',
} as const

export type ImageSizeName = (typeof ImageSizeName)[keyof typeof ImageSizeName]
export type ImageSrc = {
    __typename: 'ImageSrc'
    mimeType: Scalars['String']['output']
    url: Scalars['String']['output']
}

export const ImageWidth = {
    Content: 'CONTENT',
    ExtendedContent: 'EXTENDED_CONTENT',
    Full: 'FULL',
} as const

export type ImageWidth = (typeof ImageWidth)[keyof typeof ImageWidth]
export type InstagramPost = {
    __typename: 'InstagramPost'
    image: Image
    link: Scalars['String']['output']
}

export const InstagramWithContentWidth = {
    Normal: 'NORMAL',
    Wide: 'WIDE',
} as const

export type InstagramWithContentWidth =
    (typeof InstagramWithContentWidth)[keyof typeof InstagramWithContentWidth]
export type InvalidateCacheResult = {
    __typename: 'InvalidateCacheResult'
    errors: Array<InvalidateCacheResultError>
    success: Array<InvalidateCacheResultSuccess>
}

export type InvalidateCacheResultError = {
    __typename: 'InvalidateCacheResultError'
    error: Scalars['String']['output']
    key: Scalars['String']['output']
}

export type InvalidateCacheResultSuccess = {
    __typename: 'InvalidateCacheResultSuccess'
    key: Scalars['String']['output']
}

export const JewelleryBraceletProductStyle = {
    Bangle: 'BANGLE',
    Chain: 'CHAIN',
    Diamond: 'DIAMOND',
    Gemstone: 'GEMSTONE',
    Permanent: 'PERMANENT',
    Tennis: 'TENNIS',
} as const

export type JewelleryBraceletProductStyle =
    (typeof JewelleryBraceletProductStyle)[keyof typeof JewelleryBraceletProductStyle]
export type JewelleryBraceletProductStyleLabel = {
    __typename: 'JewelleryBraceletProductStyleLabel'
    icon: Maybe<Asset>
    systemCode: JewelleryBraceletProductStyle
    translation: ProductLabelTranslation
}

export type JewelleryBraceletProductStyleLabelTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const JewelleryDesignFeature = {
    BezelSetting: 'BEZEL_SETTING',
    ColouredGemstones: 'COLOURED_GEMSTONES',
    FourClaw: 'FOUR_CLAW',
    Pave: 'PAVE',
    Petite: 'PETITE',
    Statement: 'STATEMENT',
} as const

export type JewelleryDesignFeature =
    (typeof JewelleryDesignFeature)[keyof typeof JewelleryDesignFeature]
export type JewelleryDesignFeatureLabel = {
    __typename: 'JewelleryDesignFeatureLabel'
    icon: Maybe<Asset>
    systemCode: JewelleryDesignFeature
    translation: ProductLabelTranslation
}

export type JewelleryDesignFeatureLabelTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const JewelleryDesignStyle = {
    ArtDeco: 'ART_DECO',
    Bezel: 'BEZEL',
    Birthstone: 'BIRTHSTONE',
    Bridal: 'BRIDAL',
    Butterfly: 'BUTTERFLY',
    Classic: 'CLASSIC',
    Clover: 'CLOVER',
    Cluster: 'CLUSTER',
    Contemporary: 'CONTEMPORARY',
    EvilEye: 'EVIL_EYE',
    Floral: 'FLORAL',
    Halo: 'HALO',
    Heart: 'HEART',
    Initials: 'INITIALS',
    Mothers: 'MOTHERS',
    Solitaire: 'SOLITAIRE',
    Unique: 'UNIQUE',
    Vintage: 'VINTAGE',
} as const

export type JewelleryDesignStyle =
    (typeof JewelleryDesignStyle)[keyof typeof JewelleryDesignStyle]
export type JewelleryDesignStyleLabel = {
    __typename: 'JewelleryDesignStyleLabel'
    icon: Maybe<Asset>
    systemCode: JewelleryDesignStyle
    translation: ProductLabelTranslation
}

export type JewelleryDesignStyleLabelTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const JewelleryEarringsProductStyle = {
    Cluster: 'CLUSTER',
    Drop: 'DROP',
    Hoops: 'HOOPS',
    Studs: 'STUDS',
} as const

export type JewelleryEarringsProductStyle =
    (typeof JewelleryEarringsProductStyle)[keyof typeof JewelleryEarringsProductStyle]
export type JewelleryEarringsProductStyleLabel = {
    __typename: 'JewelleryEarringsProductStyleLabel'
    icon: Maybe<Asset>
    systemCode: JewelleryEarringsProductStyle
    translation: ProductLabelTranslation
}

export type JewelleryEarringsProductStyleLabelTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const JewelleryGemstoneCode = {
    AlexandriteJun: 'ALEXANDRITE_JUN',
    AmethystFeb: 'AMETHYST_FEB',
    AquamarineMar: 'AQUAMARINE_MAR',
    DiamondApr: 'DIAMOND_APR',
    EmeraldMay: 'EMERALD_MAY',
    GarnetJan: 'GARNET_JAN',
    Pearl: 'PEARL',
    PeridotAug: 'PERIDOT_AUG',
    RubyJul: 'RUBY_JUL',
    SapphireSep: 'SAPPHIRE_SEP',
    TanzaniteDec: 'TANZANITE_DEC',
    TopazNov: 'TOPAZ_NOV',
    TourmalineOct: 'TOURMALINE_OCT',
} as const

export type JewelleryGemstoneCode =
    (typeof JewelleryGemstoneCode)[keyof typeof JewelleryGemstoneCode]
export type JewelleryGemstoneLabel = {
    __typename: 'JewelleryGemstoneLabel'
    icon: Maybe<Asset>
    systemCode: JewelleryGemstoneCode
    translation: ProductLabelTranslation
}

export type JewelleryGemstoneLabelTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const JewelleryNecklaceProductStyle = {
    Chain: 'CHAIN',
    Choker: 'CHOKER',
    Layered: 'LAYERED',
    Long: 'LONG',
    Short: 'SHORT',
    Solitaire: 'SOLITAIRE',
    Tennis: 'TENNIS',
} as const

export type JewelleryNecklaceProductStyle =
    (typeof JewelleryNecklaceProductStyle)[keyof typeof JewelleryNecklaceProductStyle]
export type JewelleryNecklaceProductStyleLabel = {
    __typename: 'JewelleryNecklaceProductStyleLabel'
    icon: Maybe<Asset>
    systemCode: JewelleryNecklaceProductStyle
    translation: ProductLabelTranslation
}

export type JewelleryNecklaceProductStyleLabelTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const JewelleryRingProductStyle = {
    Cocktail: 'COCKTAIL',
    Promise: 'PROMISE',
    Signet: 'SIGNET',
    Stackable: 'STACKABLE',
} as const

export type JewelleryRingProductStyle =
    (typeof JewelleryRingProductStyle)[keyof typeof JewelleryRingProductStyle]
export type JewelleryRingProductStyleLabel = {
    __typename: 'JewelleryRingProductStyleLabel'
    icon: Maybe<Asset>
    systemCode: JewelleryRingProductStyle
    translation: ProductLabelTranslation
}

export type JewelleryRingProductStyleLabelTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export type KlarnaFinanceOption = {
    __typename: 'KlarnaFinanceOption'
    months: Scalars['Int']['output']
    perMonth: Money
    price: Money
}

export type KlarnaPaymentInput = {
    data: Scalars['String']['input']
    orderId: Scalars['ID']['input']
}

export type KlarnaPaymentMethod = {
    __typename: 'KlarnaPaymentMethod'
    systemCode: Scalars['ID']['output']
}

export type KlarnaPaymentResponse = {
    __typename: 'KlarnaPaymentResponse'
    errors: Array<Scalars['String']['output']>
    order: Order
}

export type KlarnaTransaction = TransactionInterface & {
    __typename: 'KlarnaTransaction'
    amount: Money
    createdAt: Scalars['DateTime']['output']
    id: Scalars['ID']['output']
    sessionData: Scalars['JSON']['output']
    status: TransactionStatus
}

export type KlarnaTransactionInput = {
    /** deposit amount within 20% and 50% of order total */
    depositAmount: Scalars['Decimal']['input']
    orderId: Scalars['ID']['input']
}

export type Language = {
    __typename: 'Language'
    locale: Scalars['Locale']['output']
    translations: Array<Translation>
}

export type LegacyTransaction = TransactionInterface & {
    __typename: 'LegacyTransaction'
    amount: Money
    createdAt: Scalars['DateTime']['output']
    id: Scalars['ID']['output']
    paymentMethodName: Scalars['String']['output']
    status: TransactionStatus
}

export type LegacyTransactionPaymentMethodNameArgs = {
    locale: Scalars['Locale']['input']
}

export type Link = {
    __typename: 'Link'
    item: LinkItem
    target: LinkTarget
    text: Scalars['String']['output']
}

export type LinkItem =
    | LinkItemAffirm
    | LinkItemBookingForm
    | LinkItemCustom
    | LinkItemOpenContactForm
    | LinkItemOpenEnquiryForm
    | LinkItemOpenSpeakToExpertModal
    | Page
    | Post
    | Questionnaire

export type LinkItemAffirm = {
    __typename: 'LinkItemAffirm'
    emptyField: Maybe<Scalars['String']['output']>
}

export type LinkItemBookingForm = {
    __typename: 'LinkItemBookingForm'
    emptyField: Maybe<Scalars['String']['output']>
}

export type LinkItemCustom = {
    __typename: 'LinkItemCustom'
    url: Scalars['String']['output']
}

export type LinkItemOpenContactForm = {
    __typename: 'LinkItemOpenContactForm'
    emptyField: Maybe<Scalars['String']['output']>
}

export type LinkItemOpenEnquiryForm = {
    __typename: 'LinkItemOpenEnquiryForm'
    cmsEnquiryFormType: CmsEnquiryFormType
    enquiryType: EnquiryType
}

export type LinkItemOpenSpeakToExpertModal = {
    __typename: 'LinkItemOpenSpeakToExpertModal'
    emptyField: Maybe<Scalars['String']['output']>
}

export const LinkTarget = {
    Blank: 'BLANK',
    Self: 'SELF',
} as const

export type LinkTarget = (typeof LinkTarget)[keyof typeof LinkTarget]
export type LoginResponse = LoginResponseFailure | LoginResponseSuccess

export const LoginResponseErrorCode = {
    InvalidCredentials: 'INVALID_CREDENTIALS',
} as const

export type LoginResponseErrorCode =
    (typeof LoginResponseErrorCode)[keyof typeof LoginResponseErrorCode]
export type LoginResponseFailure = {
    __typename: 'LoginResponseFailure'
    code: LoginResponseErrorCode
    message: Scalars['String']['output']
}

export type LoginResponseFailureMessageArgs = {
    locale: Scalars['Locale']['input']
}

export type LoginResponseSuccess = {
    __typename: 'LoginResponseSuccess'
    jwt: Scalars['String']['output']
    refreshToken: Scalars['String']['output']
    user: User
}

export type Logo = {
    __typename: 'Logo'
    image: Image
    link: Scalars['String']['output']
}

export type MagicLinkConsume = {
    email: Scalars['Email']['input']
    expires: Scalars['Int']['input']
    hash: Scalars['String']['input']
}

export type MagicLinkConsumeError = {
    __typename: 'MagicLinkConsumeError'
    message: Scalars['String']['output']
}

export type MagicLinkConsumeResponse =
    | MagicLinkConsumeError
    | MagicLinkConsumeSuccess

export type MagicLinkConsumeSuccess = {
    __typename: 'MagicLinkConsumeSuccess'
    login: LoginResponseSuccess
}

export type MagicLinkRequest = {
    email: Scalars['Email']['input']
    redirect: Scalars['Uri']['input']
}

export type MarketingDataInput = {
    clientId?: InputMaybe<Scalars['String']['input']>
    fbclid?: InputMaybe<Scalars['String']['input']>
    fbp?: InputMaybe<Scalars['String']['input']>
    ftSetTime?: InputMaybe<Scalars['DateTime']['input']>
    ftUtm: UtmInput
    gclid?: InputMaybe<Scalars['String']['input']>
    ltUtm: UtmInput
    sessionId?: InputMaybe<Scalars['String']['input']>
}

export type MarketingDataResponse = {
    __typename: 'MarketingDataResponse'
    success: Scalars['Boolean']['output']
}

export type Media = {
    alt: Maybe<Scalars['String']['output']>
    caption: Maybe<Scalars['String']['output']>
    description: Maybe<Scalars['String']['output']>
    filename: Scalars['String']['output']
    filesize: Scalars['Int']['output']
    id: Scalars['ID']['output']
    mimeType: Scalars['String']['output']
    name: Scalars['String']['output']
    title: Scalars['String']['output']
    url: Scalars['String']['output']
}

export type Melee = {
    __typename: 'Melee'
    caratWeight: Scalars['Decimal']['output']
    clarities: Array<StoneClarity>
    colors: Array<StoneColor>
    crystal: StoneCrystal
    grade: Maybe<StoneGrade>
    id: Scalars['ID']['output']
    segmentName: Scalars['String']['output']
    shape: StoneShape
    width: Scalars['String']['output']
}

export type MenuItem = {
    __typename: 'MenuItem'
    hideOnDesktop: Scalars['Boolean']['output']
    hideOnMobile: Scalars['Boolean']['output']
    link: Link
    subMenu: Maybe<SubMenu>
    title: Scalars['String']['output']
}

export type Meta = {
    __typename: 'Meta'
    description: Scalars['String']['output']
    image: Maybe<Image>
    robots: Maybe<Robots>
    title: Scalars['String']['output']
}

export type Metal = {
    __typename: 'Metal'
    color: Maybe<MetalColor>
    element: MetalElement
    karat: Maybe<Scalars['Int']['output']>
    millesimalFineness: Scalars['Decimal']['output']
    orderIndex: Scalars['Int']['output']
    segmentName: Scalars['String']['output']
    systemCode: MetalCode
    translation: MetalTranslation
}

export type MetalTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const MetalCode = {
    EighteenKaratRoseGold: 'EIGHTEEN_KARAT_ROSE_GOLD',
    EighteenKaratWhiteGold: 'EIGHTEEN_KARAT_WHITE_GOLD',
    EighteenKaratYellowGold: 'EIGHTEEN_KARAT_YELLOW_GOLD',
    FourteenKaratRoseGold: 'FOURTEEN_KARAT_ROSE_GOLD',
    FourteenKaratWhiteGold: 'FOURTEEN_KARAT_WHITE_GOLD',
    FourteenKaratYellowGold: 'FOURTEEN_KARAT_YELLOW_GOLD',
    NineKaratRoseGold: 'NINE_KARAT_ROSE_GOLD',
    NineKaratWhiteGold: 'NINE_KARAT_WHITE_GOLD',
    NineKaratYellowGold: 'NINE_KARAT_YELLOW_GOLD',
    Platinum: 'PLATINUM',
    Silver: 'SILVER',
} as const

export type MetalCode = (typeof MetalCode)[keyof typeof MetalCode]
export type MetalColor = {
    __typename: 'MetalColor'
    systemCode: MetalColorCode
    translation: MetalColorTranslation
}

export type MetalColorTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const MetalColorCode = {
    Rose: 'ROSE',
    White: 'WHITE',
    Yellow: 'YELLOW',
} as const

export type MetalColorCode =
    (typeof MetalColorCode)[keyof typeof MetalColorCode]
export type MetalColorTranslation = {
    __typename: 'MetalColorTranslation'
    name: Scalars['String']['output']
}

export type MetalElement = {
    __typename: 'MetalElement'
    systemCode: MetalElementCode
    translation: MetalElementTranslation
}

export type MetalElementTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const MetalElementCode = {
    Gold: 'GOLD',
    Platinum: 'PLATINUM',
    Silver: 'SILVER',
} as const

export type MetalElementCode =
    (typeof MetalElementCode)[keyof typeof MetalElementCode]
export type MetalElementTranslation = {
    __typename: 'MetalElementTranslation'
    name: Scalars['String']['output']
}

export type MetalTranslation = {
    __typename: 'MetalTranslation'
    name: Scalars['String']['output']
}

export type Money = {
    __typename: 'Money'
    amount: Scalars['Decimal']['output']
    currency: Scalars['Currency']['output']
}

export type MoneyInput = {
    amount: Scalars['Decimal']['input']
    currency: CurrencyInput
}

export type MonolithImageSize = {
    __typename: 'MonolithImageSize'
    name: MonolithImageSizeName
    sources: Array<ImageSrc>
    url: Scalars['String']['output']
}

export const MonolithImageSizeName = {
    Cover: 'COVER',
    CoverX2: 'COVER_X2',
    Large: 'LARGE',
    LargeX2: 'LARGE_X2',
    Medium: 'MEDIUM',
    MediumX2: 'MEDIUM_X2',
    Small: 'SMALL',
    SmallX2: 'SMALL_X2',
} as const

export type MonolithImageSizeName =
    (typeof MonolithImageSizeName)[keyof typeof MonolithImageSizeName]
export type Mutation = {
    __typename: 'Mutation'
    addDesignStudioProductToMyCart: Order
    addToCartReadyToGoRingExistingCustomer: AddToCartReadyToGoRingExistingCustomerResponse
    addToCartReadyToGoRingNewCustomer: AddToCartReadyToGoRingNewCustomerResponse
    applyPromoCode: Maybe<PromoCodeApplicationResult>
    /** @deprecated Booking form has to be reworked from the ground. */
    applyTransitionToConsultationByConsultant: Maybe<BookingConsultation>
    autologin: LoginResponse
    cancelConsultation: Scalars['Boolean']['output']
    completeAffirmTransactionPostIframe: AffirmCompleteTransactionResponse
    completeCheckoutcomTransactionPost3ds: CompleteCheckoutcomTransactionPost3dsResponse
    createAffirmTransaction: AffirmTransaction
    createAllocationTransaction: AllocationTransaction
    createBankTransaction: BankTransaction
    createCheckoutcomTransaction: CreateCheckoutcomTransactionResponse
    /** @deprecated Booking form has to be reworked from the ground. */
    createConsultationByConsultant: Maybe<BookingConsultation>
    /** For logged user */
    createConsultationExistingCustomer: BookingCreateConsultationExistingCustomerResponse
    /** For not-logged user */
    createConsultationNewCustomer: BookingCreateConsultationNewCustomerResponse
    createDesignInspiration: DesignInspiration
    createDesignStudioProductAndAddToCartJewelleryExistingCustomer: CatalogueDesignStudioCheckoutJewelleryExistingCustomerResponse
    createDesignStudioProductAndAddToCartJewelleryNewCustomer: CatalogueDesignStudioCheckoutJewelleryNewCustomerResponse
    createDesignStudioProductAndAddToCartWeddingRingExistingCustomer: CatalogueDesignStudioCheckoutWeddingRingExistingCustomerResponse
    createDesignStudioProductAndAddToCartWeddingRingNewCustomer: CatalogueDesignStudioCheckoutWeddingRingNewCustomerResponse
    createEnquiryContactUsExistingCustomer: EnquiryResponseExistingCustomer
    createEnquiryContactUsNewCustomer: EnquiryResponseNewCustomer
    createEnquiryCustomEngagementRingExistingCustomer: EnquiryResponseExistingCustomer
    createEnquiryCustomEngagementRingNewCustomer: EnquiryResponseNewCustomer
    createEnquiryDiamondSearchProductExistingCustomer: EnquiryResponseExistingCustomer
    createEnquiryDiamondSearchProductNewCustomer: EnquiryResponseNewCustomer
    createEnquiryEngagementRingPreferAnotherShapeExistingCustomer: EnquiryResponseExistingCustomer
    createEnquiryEngagementRingPreferAnotherShapeNewCustomer: EnquiryResponseNewCustomer
    createEnquiryExistingCustomer: EnquiryResponseExistingCustomer
    createEnquiryNewCustomer: EnquiryResponseNewCustomer
    createKlarnaTransaction: KlarnaTransaction
    designStudioProductEngagementRingUpdate: DesignStudioProductEngagementRing
    designStudioProductWeddingRingUpdate: DesignStudioProductWeddingRing
    designStudioQuotationEngagementRingUpdate: QuotationEngagementRing
    impersonate: LoginResponse
    invalidateCache: InvalidateCacheResult
    login: LoginResponse
    loginWithGoogle: LoginResponse
    logout: Scalars['Boolean']['output']
    magicLinkConsume: MagicLinkConsumeResponse
    magicLinkRequest: Maybe<Scalars['Void']['output']>
    marketingData: MarketingDataResponse
    nonSkuGemStoneChangeImage: NonSkuGemstone
    /** @deprecated use nonSkuGemStoneCreateOrUpdate */
    nonSkuGemStoneCreate: NonSkuGemstone
    nonSkuGemStoneDelete: NonSkuGemstone
    nonSkuGemStoneDeleteImage: NonSkuGemstone
    nonSkuGemstoneCaratDimensionCreate: NonSkuGemstoneCaratDimension
    nonSkuGemstoneCaratDimensionDelete: NonSkuGemstoneCaratDimension
    nonSkuGemstoneColorCrystalDimensionCreate: NonSkuGemstoneType
    nonSkuGemstoneColorCrystalDimensionDelete: NonSkuGemstoneType
    nonSkuGemstoneGradeClarityDimensionCreate: NonSkuGemstoneGradeClarityDimension
    nonSkuGemstoneGradeClarityDimensionDelete: NonSkuGemstoneGradeClarityDimension
    nonSkuGemstoneImageCreate: NonSkuGemstoneImage
    nonSkuGemstoneImageDelete: NonSkuGemstoneImage
    nonSkuGemstoneImageUpdate: NonSkuGemstoneImage
    nonSkuGemstoneShapeDimensionCreate: NonSkuGemstoneShapeDimension
    nonSkuGemstoneShapeDimensionDelete: NonSkuGemstoneShapeDimension
    nonSkuLabGrownCaratDimensionCreate: NonSkuLabGrownCaratDimension
    nonSkuLabGrownCaratDimensionDelete: NonSkuLabGrownCaratDimension
    nonSkuLabGrownDiamondChangeImage: NonSkuLabGrown
    /** @deprecated use nonSkuLabGrownDiamondCreateOrUpdate */
    nonSkuLabGrownDiamondCreate: NonSkuLabGrown
    nonSkuLabGrownDiamondDelete: NonSkuLabGrown
    nonSkuLabGrownDiamondDeleteImage: NonSkuLabGrown
    nonSkuLabGrownGradeDimensionCreate: NonSkuLabGrownGradeDimension
    nonSkuLabGrownGradeDimensionDelete: NonSkuLabGrownGradeDimension
    nonSkuLabGrownShapeDimensionCreate: NonSkuLabGrownShapeDimension
    nonSkuLabGrownShapeDimensionDelete: NonSkuLabGrownShapeDimension
    nonSkuLabGrownShapeDimensionUpdate: NonSkuLabGrownShapeDimension
    payViaAffirm: AffirmPaymentResponse
    payViaAllocation: Order
    payViaBank: Order
    payViaCheckoutcom: PayViaCheckoutcomResponse
    payViaKlarna: KlarnaPaymentResponse
    payViaNoPayment: Order
    ping: Scalars['String']['output']
    questionnaireCompleteExistingCustomer: QuestionnaireCompletedExistingCustomerResponse
    questionnaireCompleteNewCustomer: QuestionnaireCompletedNewCustomerResponse
    refreshToken: LoginResponse
    removeFromMyCart: Order
    ringBuilder: RingBuilder
    ringBuilderResolveExistingCustomer: RingBuilderResolvedExistingCustomer
    ringBuilderResolveNewCustomer: RingBuilderResolvedNewCustomer
    ringBuilderSet: RingBuilderSetResult
    setOrderCollectFromShowroomInformation: SetDeliveryInformationResponse
    setOrderDeliverToAddressInformation: SetDeliveryInformationResponse
    /** @deprecated Booking form has to be reworked from the ground. */
    updateConsultationByConsultant: Maybe<BookingConsultation>
}

export type MutationAddDesignStudioProductToMyCartArgs = {
    productId: Scalars['ID']['input']
}

export type MutationAddToCartReadyToGoRingExistingCustomerArgs = {
    input: AddToCartReadyToGoRingInput
}

export type MutationAddToCartReadyToGoRingNewCustomerArgs = {
    customer: CustomerRegistrationInput
    input: AddToCartReadyToGoRingInput
}

export type MutationApplyPromoCodeArgs = {
    promoCode: Scalars['String']['input']
}

export type MutationApplyTransitionToConsultationByConsultantArgs = {
    id: Scalars['ID']['input']
    transition: Scalars['String']['input']
}

export type MutationAutologinArgs = {
    authToken: Scalars['String']['input']
}

export type MutationCancelConsultationArgs = {
    input: BookingCancelConsultationInput
}

export type MutationCompleteAffirmTransactionPostIframeArgs = {
    input: AffirmCompleteTransactionInput
}

export type MutationCompleteCheckoutcomTransactionPost3dsArgs = {
    input: CompleteCheckoutcomTransactionInput
}

export type MutationCreateAffirmTransactionArgs = {
    input: AffirmTransactionInput
}

export type MutationCreateAllocationTransactionArgs = {
    input: AllocationTransactionInput
}

export type MutationCreateBankTransactionArgs = {
    orderId: Scalars['ID']['input']
}

export type MutationCreateCheckoutcomTransactionArgs = {
    input: CreateCheckoutcomTransactionInput
}

export type MutationCreateConsultationByConsultantArgs = {
    autoAssignConsultant: Scalars['Boolean']['input']
    consultationMethod: Scalars['ID']['input']
    consultationPurpose: Scalars['ID']['input']
    customer: Scalars['ID']['input']
    input: BookingConsultationMutableFields
    opportunity: InputMaybe<Scalars['String']['input']>
    order: InputMaybe<Scalars['ID']['input']>
    reassignOpportunity: Scalars['Boolean']['input']
}

export type MutationCreateConsultationExistingCustomerArgs = {
    input: BookingCreateConsultationInput
}

export type MutationCreateConsultationNewCustomerArgs = {
    customer: CustomerRegistrationInput
    input: BookingCreateConsultationInput
}

export type MutationCreateDesignInspirationArgs = {
    file: Scalars['Upload']['input']
}

export type MutationCreateDesignStudioProductAndAddToCartJewelleryExistingCustomerArgs =
    {
        input: DesignStudioJewelleryInput
    }

export type MutationCreateDesignStudioProductAndAddToCartJewelleryNewCustomerArgs =
    {
        customer: CustomerRegistrationInput
        input: DesignStudioJewelleryInput
    }

export type MutationCreateDesignStudioProductAndAddToCartWeddingRingExistingCustomerArgs =
    {
        input: DesignStudioWeddingRingInput
    }

export type MutationCreateDesignStudioProductAndAddToCartWeddingRingNewCustomerArgs =
    {
        customer: CustomerRegistrationInput
        input: DesignStudioWeddingRingInput
    }

export type MutationCreateEnquiryContactUsExistingCustomerArgs = {
    input: EnquiryContactUsInput
}

export type MutationCreateEnquiryContactUsNewCustomerArgs = {
    customer: CustomerRegistrationInput
    input: EnquiryContactUsInput
}

export type MutationCreateEnquiryCustomEngagementRingExistingCustomerArgs = {
    input: EnquiryCustomEngagementRing
}

export type MutationCreateEnquiryCustomEngagementRingNewCustomerArgs = {
    customer: CustomerRegistrationInput
    input: EnquiryCustomEngagementRing
}

export type MutationCreateEnquiryDiamondSearchProductExistingCustomerArgs = {
    input: EnquiryDiamondSearchProduct
}

export type MutationCreateEnquiryDiamondSearchProductNewCustomerArgs = {
    customer: CustomerRegistrationInput
    input: EnquiryDiamondSearchProduct
}

export type MutationCreateEnquiryEngagementRingPreferAnotherShapeExistingCustomerArgs =
    {
        input: EnquiryEngagementRingCollectionInput
    }

export type MutationCreateEnquiryEngagementRingPreferAnotherShapeNewCustomerArgs =
    {
        customer: CustomerRegistrationInput
        input: EnquiryEngagementRingCollectionInput
    }

export type MutationCreateEnquiryExistingCustomerArgs = {
    input: EnquiryInput
}

export type MutationCreateEnquiryNewCustomerArgs = {
    customer: CustomerRegistrationInput
    input: EnquiryInput
}

export type MutationCreateKlarnaTransactionArgs = {
    input: KlarnaTransactionInput
}

export type MutationDesignStudioProductEngagementRingUpdateArgs = {
    id: Scalars['ID']['input']
    input: DesignStudioProductEngagementRingUpdate
}

export type MutationDesignStudioProductWeddingRingUpdateArgs = {
    id: Scalars['ID']['input']
    input: DesignStudioProductWeddingRingUpdate
}

export type MutationDesignStudioQuotationEngagementRingUpdateArgs = {
    id: Scalars['ID']['input']
    input: DesignStudioQuotationEngagementRingUpdate
}

export type MutationImpersonateArgs = {
    identifier: Scalars['String']['input']
}

export type MutationInvalidateCacheArgs = {
    tags: InputMaybe<Array<Scalars['String']['input']>>
}

export type MutationLoginArgs = {
    credentials: CredentialsInput
}

export type MutationLoginWithGoogleArgs = {
    credentials: CustomerRegistrationByGoogleInput
}

export type MutationMagicLinkConsumeArgs = {
    input: MagicLinkConsume
}

export type MutationMagicLinkRequestArgs = {
    input: MagicLinkRequest
}

export type MutationMarketingDataArgs = {
    input: MarketingDataInput
}

export type MutationNonSkuGemStoneChangeImageArgs = {
    id: Scalars['ID']['input']
    image: Scalars['Upload']['input']
}

export type MutationNonSkuGemStoneCreateArgs = {
    input: NonSkuGemStoneCreateInput
}

export type MutationNonSkuGemStoneDeleteArgs = {
    id: Scalars['ID']['input']
}

export type MutationNonSkuGemStoneDeleteImageArgs = {
    id: Scalars['ID']['input']
}

export type MutationNonSkuGemstoneCaratDimensionCreateArgs = {
    input: NonSkuGemstoneCaratDimensionCreateInput
}

export type MutationNonSkuGemstoneCaratDimensionDeleteArgs = {
    id: Scalars['ID']['input']
}

export type MutationNonSkuGemstoneColorCrystalDimensionCreateArgs = {
    input: NonSkuGemstoneColorCrystalDimensionCreateInput
}

export type MutationNonSkuGemstoneColorCrystalDimensionDeleteArgs = {
    id: Scalars['ID']['input']
}

export type MutationNonSkuGemstoneGradeClarityDimensionCreateArgs = {
    input: NonSkuGemstoneGradeClarityDimensionCreateInput
}

export type MutationNonSkuGemstoneGradeClarityDimensionDeleteArgs = {
    id: Scalars['ID']['input']
}

export type MutationNonSkuGemstoneImageCreateArgs = {
    input: NonSkuGemstoneImageCreateInput
}

export type MutationNonSkuGemstoneImageDeleteArgs = {
    id: Scalars['ID']['input']
}

export type MutationNonSkuGemstoneImageUpdateArgs = {
    id: Scalars['ID']['input']
    input: NonSkuGemstoneImageUpdateInput
}

export type MutationNonSkuGemstoneShapeDimensionCreateArgs = {
    input: NonSkuGemstoneShapeDimensionCreateInput
}

export type MutationNonSkuGemstoneShapeDimensionDeleteArgs = {
    id: Scalars['ID']['input']
}

export type MutationNonSkuLabGrownCaratDimensionCreateArgs = {
    input: NonSkuLabGrownCaratDimensionCreateInput
}

export type MutationNonSkuLabGrownCaratDimensionDeleteArgs = {
    id: Scalars['ID']['input']
}

export type MutationNonSkuLabGrownDiamondChangeImageArgs = {
    id: Scalars['ID']['input']
    image: Scalars['Upload']['input']
}

export type MutationNonSkuLabGrownDiamondCreateArgs = {
    input: NonSkuLabGrownDiamondCreateInput
}

export type MutationNonSkuLabGrownDiamondDeleteArgs = {
    id: Scalars['ID']['input']
}

export type MutationNonSkuLabGrownDiamondDeleteImageArgs = {
    id: Scalars['ID']['input']
}

export type MutationNonSkuLabGrownGradeDimensionCreateArgs = {
    input: NonSkuLabGrownGradeDimensionCreateInput
}

export type MutationNonSkuLabGrownGradeDimensionDeleteArgs = {
    id: Scalars['ID']['input']
}

export type MutationNonSkuLabGrownShapeDimensionCreateArgs = {
    input: NonSkuLabGrownShapeDimensionCreateInput
}

export type MutationNonSkuLabGrownShapeDimensionDeleteArgs = {
    id: Scalars['ID']['input']
}

export type MutationNonSkuLabGrownShapeDimensionUpdateArgs = {
    id: Scalars['ID']['input']
    input: NonSkuLabGrownShapeDimensionUpdateInput
}

export type MutationPayViaAffirmArgs = {
    input: AffirmPaymentInput
}

export type MutationPayViaAllocationArgs = {
    allocationTransactionId: Scalars['ID']['input']
}

export type MutationPayViaBankArgs = {
    bankTransactionId: Scalars['ID']['input']
}

export type MutationPayViaCheckoutcomArgs = {
    input: PayViaCheckoutcomInput
}

export type MutationPayViaKlarnaArgs = {
    input: KlarnaPaymentInput
}

export type MutationPayViaNoPaymentArgs = {
    orderId: Scalars['ID']['input']
}

export type MutationQuestionnaireCompleteExistingCustomerArgs = {
    input: QuestionnaireCompleteInput
}

export type MutationQuestionnaireCompleteNewCustomerArgs = {
    customer: CustomerRegistrationInput
    input: QuestionnaireCompleteInput
}

export type MutationRefreshTokenArgs = {
    token: Scalars['String']['input']
}

export type MutationRemoveFromMyCartArgs = {
    productId: Scalars['ID']['input']
}

export type MutationRingBuilderArgs = {
    input: RingBuilderInput
}

export type MutationRingBuilderResolveExistingCustomerArgs = {
    input: RingBuilderResolveInput
}

export type MutationRingBuilderResolveNewCustomerArgs = {
    customer: CustomerRegistrationInput
    input: RingBuilderResolveInput
}

export type MutationRingBuilderSetArgs = {
    input: RingBuilderInput
}

export type MutationSetOrderCollectFromShowroomInformationArgs = {
    input: CollectFromShowroomInput
}

export type MutationSetOrderDeliverToAddressInformationArgs = {
    input: DeliverToAddressInput
}

export type MutationUpdateConsultationByConsultantArgs = {
    consultationRoom: InputMaybe<Scalars['ID']['input']>
    id: Scalars['ID']['input']
    input: BookingConsultationMutableFields
    reassignOpportunity: Scalars['Boolean']['input']
}

export type NoPaymentMethod = {
    __typename: 'NoPaymentMethod'
    systemCode: Scalars['ID']['output']
}

export type NonSkuCaratWeightRange = {
    __typename: 'NonSkuCaratWeightRange'
    max: Scalars['Decimal']['output']
    min: Scalars['Decimal']['output']
}

export type NonSkuCaratWeightRangeInput = {
    max?: InputMaybe<Scalars['Decimal']['input']>
    min?: InputMaybe<Scalars['Decimal']['input']>
}

export type NonSkuGemStoneCreateInput = {
    caratDimensionId: Scalars['ID']['input']
    colorCrystalDimensionId: Scalars['ID']['input']
    gradeClarityDimensionId: Scalars['ID']['input']
    image?: InputMaybe<Scalars['Upload']['input']>
    shapeDimensionId: Scalars['ID']['input']
}

export type NonSkuGemStoneInterface = {
    caratWeight: Scalars['Decimal']['output']
    clarity: StoneClarity
    color: StoneColor
    colorGrade: StoneGrade
    crystal: StoneCrystal
    cut: StoneCut
}

export type NonSkuGemStonesPricingCellFilters = {
    colorCrystalDimensionId?: InputMaybe<Scalars['ID']['input']>
    gradeClarityDimensionId?: InputMaybe<Scalars['ID']['input']>
}

export type NonSkuGemstone = NonSkuGemStoneInterface &
    NonSkuInterface & {
        __typename: 'NonSkuGemstone'
        caratDimension: NonSkuGemstoneCaratDimension
        caratWeight: Scalars['Decimal']['output']
        clarity: StoneClarity
        color: StoneColor
        colorCrystalDimension: NonSkuGemstoneType
        colorGrade: StoneGrade
        crystal: StoneCrystal
        cut: StoneCut
        gradeClarityDimension: NonSkuGemstoneGradeClarityDimension
        id: Scalars['ID']['output']
        image: Maybe<NonSkuImage>
        salePrice: Maybe<Money>
        sampleImage: Maybe<NonSkuImage>
        shape: StoneShape
        shapeDimension: NonSkuGemstoneShapeDimension
        uniqueImage: Maybe<NonSkuImage>
    }

export type NonSkuGemstoneSalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type NonSkuGemstoneCaratDimension = {
    __typename: 'NonSkuGemstoneCaratDimension'
    caratWeight: Scalars['Decimal']['output']
    id: Scalars['ID']['output']
}

export type NonSkuGemstoneCaratDimensionCreateInput = {
    caratWeight: Scalars['Decimal']['input']
}

export type NonSkuGemstoneColorCrystalDimensionCreateInput = {
    color: StoneColorCode
    crystal: StoneCrystalCode
}

export type NonSkuGemstoneFilterInput = {
    carat: Scalars['Decimal']['input']
    clarity: StoneClarityCode
    color: StoneColorCode
    crystal: StoneCrystalCode
    grade: StoneGradeCode
    shape: StoneShapeCode
}

export type NonSkuGemstoneFilters = {
    caratWeightRange?: InputMaybe<NonSkuCaratWeightRangeInput>
    priceRange?: InputMaybe<NonSkuPriceRangeInput>
    shape?: InputMaybe<StoneShapeCode>
    types?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type NonSkuGemstoneGradeClarityDimension = {
    __typename: 'NonSkuGemstoneGradeClarityDimension'
    clarity: StoneClarity
    grade: StoneGrade
    id: Scalars['ID']['output']
}

export type NonSkuGemstoneGradeClarityDimensionCreateInput = {
    clarity: StoneClarityCode
    grade: StoneGradeCode
}

export type NonSkuGemstoneImage = {
    __typename: 'NonSkuGemstoneImage'
    colorCrystalDimension: Maybe<NonSkuGemstoneType>
    id: Scalars['ID']['output']
    image: Maybe<NonSkuImage>
    shapeDimension: Maybe<NonSkuGemstoneShapeDimension>
}

export type NonSkuGemstoneImageCreateInput = {
    colorCrystalDimensionId: Scalars['ID']['input']
    image?: InputMaybe<Scalars['Upload']['input']>
    shapeDimensionId: Scalars['ID']['input']
}

export type NonSkuGemstoneImageUpdateInput = {
    image?: InputMaybe<Scalars['Upload']['input']>
}

export type NonSkuGemstoneShapeDimension = {
    __typename: 'NonSkuGemstoneShapeDimension'
    id: Scalars['ID']['output']
    shape: StoneShape
}

export type NonSkuGemstoneShapeDimensionCreateInput = {
    shape: StoneShapeCode
}

export const NonSkuGemstoneSortField = {
    Carat: 'CARAT',
    Price: 'PRICE',
} as const

export type NonSkuGemstoneSortField =
    (typeof NonSkuGemstoneSortField)[keyof typeof NonSkuGemstoneSortField]
export type NonSkuGemstoneSortInput = {
    direction: NonSkuSortDirection
    field: NonSkuGemstoneSortField
}

export type NonSkuGemstoneType = {
    __typename: 'NonSkuGemstoneType'
    color: StoneColor
    crystal: StoneCrystal
    id: Scalars['ID']['output']
}

export type NonSkuGemstonesBounds = {
    __typename: 'NonSkuGemstonesBounds'
    caratWeight: NonSkuCaratWeightRange
    price: Maybe<NonSkuPriceRange>
    shapes: Array<StoneShape>
    types: Array<NonSkuGemstoneType>
}

export type NonSkuGemstonesBoundsPriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type NonSkuImage = {
    __typename: 'NonSkuImage'
    id: Scalars['ID']['output']
    mimeType: Scalars['String']['output']
    size: MonolithImageSize
    sources: Array<ImageSrc>
    url: Scalars['Uri']['output']
}

export type NonSkuImageSizeArgs = {
    name: MonolithImageSizeName
}

export type NonSkuInterface = {
    caratWeight: Scalars['Decimal']['output']
    image: Maybe<NonSkuImage>
    shape: StoneShape
}

export type NonSkuLabGrown = NonSkuInterface &
    NonSkuLabGrownInterface & {
        __typename: 'NonSkuLabGrown'
        caratDimension: NonSkuLabGrownCaratDimension
        caratWeight: Scalars['Decimal']['output']
        clarity: StoneClarity
        color: StoneColor
        crystal: StoneCrystal
        cut: StoneCut
        gradeDimension: NonSkuLabGrownGradeDimension
        id: Scalars['ID']['output']
        image: Maybe<NonSkuImage>
        salePrice: Maybe<Money>
        sampleImage: Maybe<NonSkuImage>
        shape: StoneShape
        shapeDimension: NonSkuLabGrownShapeDimension
        uniqueImage: Maybe<NonSkuImage>
    }

export type NonSkuLabGrownSalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type NonSkuLabGrownCaratDimension = {
    __typename: 'NonSkuLabGrownCaratDimension'
    caratWeight: Scalars['Decimal']['output']
    id: Scalars['ID']['output']
}

export type NonSkuLabGrownCaratDimensionCreateInput = {
    caratWeight: Scalars['Decimal']['input']
}

export type NonSkuLabGrownDiamondCreateInput = {
    caratDimensionId: Scalars['ID']['input']
    gradeDimensionId: Scalars['ID']['input']
    image?: InputMaybe<Scalars['Upload']['input']>
    shapeDimensionId: Scalars['ID']['input']
}

export type NonSkuLabGrownDiamondFilterInput = {
    carat: Scalars['Decimal']['input']
    clarity: StoneClarityCode
    color: StoneColorCode
    shape: StoneShapeCode
}

export type NonSkuLabGrownDiamondSortInput = {
    direction: NonSkuSortDirection
    field: NonSkuLabGrownSortField
}

export type NonSkuLabGrownDiamondsBounds = {
    __typename: 'NonSkuLabGrownDiamondsBounds'
    caratWeight: NonSkuCaratWeightRange
    colors: Array<StoneColor>
    price: Maybe<NonSkuPriceRange>
    shapes: Array<StoneShape>
}

export type NonSkuLabGrownDiamondsBoundsPriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type NonSkuLabGrownDiamondsFilters = {
    caratWeightRange?: InputMaybe<NonSkuCaratWeightRangeInput>
    colors?: InputMaybe<Array<StoneColorCode>>
    priceRange?: InputMaybe<NonSkuPriceRangeInput>
    shape?: InputMaybe<StoneShapeCode>
}

export type NonSkuLabGrownGradeDimension = {
    __typename: 'NonSkuLabGrownGradeDimension'
    clarity: StoneClarity
    color: StoneColor
    id: Scalars['ID']['output']
}

export type NonSkuLabGrownGradeDimensionCreateInput = {
    clarity: StoneClarityCode
    color: StoneColorCode
}

export type NonSkuLabGrownInterface = {
    clarity: StoneClarity
    color: StoneColor
    crystal: StoneCrystal
    cut: StoneCut
}

export type NonSkuLabGrownPricingCellFilters = {
    gradeDimensionId?: InputMaybe<Scalars['ID']['input']>
}

export type NonSkuLabGrownShapeDimension = {
    __typename: 'NonSkuLabGrownShapeDimension'
    id: Scalars['ID']['output']
    image: Maybe<NonSkuImage>
    shape: StoneShape
}

export type NonSkuLabGrownShapeDimensionCreateInput = {
    image?: InputMaybe<Scalars['Upload']['input']>
    shape: StoneShapeCode
}

export type NonSkuLabGrownShapeDimensionUpdateInput = {
    image?: InputMaybe<Scalars['Upload']['input']>
}

export const NonSkuLabGrownSortField = {
    Carat: 'CARAT',
    Price: 'PRICE',
} as const

export type NonSkuLabGrownSortField =
    (typeof NonSkuLabGrownSortField)[keyof typeof NonSkuLabGrownSortField]
export type NonSkuPriceRange = {
    __typename: 'NonSkuPriceRange'
    max: Money
    min: Money
}

export type NonSkuPriceRangeInput = {
    max?: InputMaybe<MoneyInput>
    min?: InputMaybe<MoneyInput>
}

export const NonSkuSortDirection = {
    Asc: 'ASC',
    Desc: 'DESC',
} as const

export type NonSkuSortDirection =
    (typeof NonSkuSortDirection)[keyof typeof NonSkuSortDirection]
export type Order = {
    __typename: 'Order'
    /** mask */
    allowedWeekdays: Scalars['Int']['output']
    availableShowroomsForCollection: Array<Showroom>
    billingAddress: OrderAddress
    customer: Customer
    /** null desiredDeliveryDate means ASAR */
    desiredDeliveryDate: Maybe<Scalars['DateTime']['output']>
    disabledDates: Array<Scalars['DateTime']['output']>
    firstAvailableDeliveryDate: DeliveryDate
    id: Scalars['ID']['output']
    isAsarEnabled: Scalars['Boolean']['output']
    isCompleted: Scalars['Boolean']['output']
    isDeliveryConfirmed: Scalars['Boolean']['output']
    isPayable: Scalars['Boolean']['output']
    isShippingAddressReadonly: Scalars['Boolean']['output']
    paidAmount: Money
    paymentMethods: PaymentMethodContainer
    paymentPlan: PaymentPlan
    placementDate: Maybe<Scalars['DateTime']['output']>
    prediscountSubtotalAmount: Money
    prediscountTotalAmount: Money
    products: Array<OrderProduct>
    promoCode: Maybe<PromoCode>
    remainingAmount: Money
    salesTaxAmount: Money
    savedAmount: Money
    /**  null before order is dispatched and for collection orders */
    shipmentTrackingInformation: Maybe<ShipmentTrackingInformation>
    shippingAddress: OrderAddress
    shippingAmount: Money
    status: OrderStatus
    subtotalAmount: Money
    totalAmount: Money
    transactions: Array<TransactionInterface>
    vatAmount: Money
}

export type OrderAddress = {
    __typename: 'OrderAddress'
    addressLine1: Maybe<Scalars['String']['output']>
    addressLine2: Maybe<Scalars['String']['output']>
    city: Maybe<Scalars['String']['output']>
    country: Scalars['Country']['output']
    deliveryInstructions: Maybe<Scalars['String']['output']>
    email: Scalars['String']['output']
    firstName: Scalars['String']['output']
    id: Scalars['ID']['output']
    lastName: Scalars['String']['output']
    phoneNumber: Maybe<PhoneNumberType>
    postalCode: Maybe<Scalars['String']['output']>
    subdivision: Maybe<Scalars['CountrySubdivision']['output']>
}

export type OrderAddressNotConfirmedError = {
    __typename: 'OrderAddressNotConfirmedError'
    message: Scalars['String']['output']
}

export type OrderAlreadyCompletedError = {
    __typename: 'OrderAlreadyCompletedError'
    message: Scalars['String']['output']
}

export type OrderBillingAddressInput = {
    addressLine1: Scalars['String']['input']
    addressLine2?: InputMaybe<Scalars['String']['input']>
    city: Scalars['String']['input']
    country: Scalars['Country']['input']
    firstName: Scalars['String']['input']
    lastName: Scalars['String']['input']
    phoneNumber?: InputMaybe<PhoneNumberInput>
    postalCode: Scalars['String']['input']
    subdivision?: InputMaybe<Scalars['CountrySubdivision']['input']>
}

export type OrderCollectFromShowroomDeliveryInput = {
    deliveryInstructions: Scalars['String']['input']
    email: Scalars['Email']['input']
    firstName: Scalars['String']['input']
    lastName: Scalars['String']['input']
    phoneNumber: PhoneNumberInput
}

export type OrderEmptyError = {
    __typename: 'OrderEmptyError'
    message: Scalars['String']['output']
}

export type OrderProduct = {
    __typename: 'OrderProduct'
    customer: Customer
    designStudioProduct: Maybe<DesignStudioProduct>
    id: Scalars['ID']['output']
    image: Maybe<Scalars['String']['output']>
    name: Scalars['String']['output']
    order: Order
    prediscountTotalSaleAmount: Money
    totalSaleAmount: Money
}

export type OrderShipToAddressInput = {
    addressLine1: Scalars['String']['input']
    addressLine2?: InputMaybe<Scalars['String']['input']>
    city: Scalars['String']['input']
    deliveryInstructions?: InputMaybe<Scalars['String']['input']>
    email: Scalars['Email']['input']
    firstName: Scalars['String']['input']
    lastName: Scalars['String']['input']
    phoneNumber: PhoneNumberInput
    postalCode: Scalars['String']['input']
    subdivision?: InputMaybe<Scalars['CountrySubdivision']['input']>
}

export type OrderStatus = {
    __typename: 'OrderStatus'
    name: Scalars['String']['output']
    systemCode: OrderStatusCode
}

export type OrderStatusNameArgs = {
    locale: Scalars['Locale']['input']
}

export const OrderStatusCode = {
    AwaitingInitialPaymentConfirmation: 'AWAITING_INITIAL_PAYMENT_CONFIRMATION',
    Cancelled: 'CANCELLED',
    Cart: 'CART',
    Dispatched: 'DISPATCHED',
    InProgress: 'IN_PROGRESS',
    Refunded: 'REFUNDED',
} as const

export type OrderStatusCode =
    (typeof OrderStatusCode)[keyof typeof OrderStatusCode]
export type OrderedListItem = {
    __typename: 'OrderedListItem'
    description: Maybe<Scalars['String']['output']>
    title: Scalars['String']['output']
}

export const Padding = {
    Large: 'LARGE',
    Medium: 'MEDIUM',
    None: 'NONE',
    Small: 'SMALL',
} as const

export type Padding = (typeof Padding)[keyof typeof Padding]
export type Page = {
    __typename: 'Page'
    author: Author
    blocks: Array<Block>
    id: Scalars['ID']['output']
    meta: Meta
    pageSettings: PageSettings
    parent: Maybe<Page>
    path: Scalars['String']['output']
    slug: Scalars['String']['output']
    title: Scalars['String']['output']
}

export type PageSettings = {
    __typename: 'PageSettings'
    showRingBuilder: Scalars['Boolean']['output']
}

export type PageTooltip = {
    __typename: 'PageTooltip'
    tooltip: Tooltip
    triggerText: Maybe<Scalars['String']['output']>
}

export type PaginationInput = {
    limit: Scalars['Int']['input']
    page: Scalars['Int']['input']
}

export type PayViaCheckoutcomError =
    | CheckoutcomOperationDeclinedError
    | DesiredDeliveryDateInvalidError
    | OrderAlreadyCompletedError
    | PaymentAmountInvalidError

export type PayViaCheckoutcomFailureResponse = {
    __typename: 'PayViaCheckoutcomFailureResponse'
    errors: Array<PayViaCheckoutcomError>
}

export type PayViaCheckoutcomInput = {
    checkoutcomTransactionId: Scalars['ID']['input']
    returnUrl: Scalars['Uri']['input']
}

export type PayViaCheckoutcomResponse =
    | PayViaCheckoutcomFailureResponse
    | PayViaCheckoutcomSuccessResponse

export type PayViaCheckoutcomSuccessResponse = {
    __typename: 'PayViaCheckoutcomSuccessResponse'
    order: Order
    redirectUrl: Scalars['String']['output']
}

export type PaymentAmountInvalidError = {
    __typename: 'PaymentAmountInvalidError'
    message: Scalars['String']['output']
}

export type PaymentIcon = {
    __typename: 'PaymentIcon'
    icon: Image
    name: Scalars['String']['output']
}

export type PaymentMethodContainer = {
    __typename: 'PaymentMethodContainer'
    affirmPayment: Maybe<AffirmPaymentMethod>
    allocationPayment: Maybe<AllocationPaymentMethod>
    bankPayment: Maybe<BankPaymentMethod>
    checkoutcomPayment: Maybe<CheckoutcomPaymentMethod>
    klarnaPayment: Maybe<KlarnaPaymentMethod>
    noPayment: Maybe<NoPaymentMethod>
}

export type PaymentMethodNotAllowedError = {
    __typename: 'PaymentMethodNotAllowedError'
    message: Scalars['String']['output']
}

export type PaymentPlan = {
    __typename: 'PaymentPlan'
    current: Maybe<PaymentPlanUpcomingRecord>
    paid: Array<PaymentPlanPaidRecord>
    upcoming: Array<PaymentPlanUpcomingRecord>
}

export type PaymentPlanPaidRecord = {
    __typename: 'PaymentPlanPaidRecord'
    amount: Money
    paidOn: Scalars['DateTime']['output']
}

export type PaymentPlanUpcomingRecord = {
    __typename: 'PaymentPlanUpcomingRecord'
    amount: Money
}

export const PhoneNumberFormat = {
    E164: 'E164',
    International: 'INTERNATIONAL',
    National: 'NATIONAL',
    Rfc3966: 'RFC3966',
} as const

export type PhoneNumberFormat =
    (typeof PhoneNumberFormat)[keyof typeof PhoneNumberFormat]
export type PhoneNumberInput = {
    countryCode: Scalars['String']['input']
    nationalNumber: Scalars['String']['input']
}

export type PhoneNumberType = {
    __typename: 'PhoneNumberType'
    countryCode: Maybe<Scalars['String']['output']>
    e164: Scalars['PhoneNumber']['output']
    formatted: Scalars['String']['output']
    nationalNumber: Maybe<Scalars['String']['output']>
}

export type PhoneNumberTypeFormattedArgs = {
    format: PhoneNumberFormat
}

export type Post = {
    __typename: 'Post'
    author: Author
    blocks: Array<Block>
    categories: Array<PostCategory>
    createdAt: Scalars['Date']['output']
    date: Scalars['Date']['output']
    excerpt: Scalars['String']['output']
    featuredImage: Image
    id: Scalars['ID']['output']
    meta: Meta
    modifiedAt: Scalars['Date']['output']
    relatedPosts: Maybe<Array<Post>>
    showModifiedDate: Scalars['Boolean']['output']
    slug: Scalars['String']['output']
    tags: Array<PostTag>
    title: Scalars['String']['output']
}

export type PostAuthorArgs = {
    locale: Scalars['Locale']['input']
}

export type PostCategoriesArgs = {
    locale: Scalars['Locale']['input']
}

export type PostRelatedPostsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    locale: Scalars['Locale']['input']
}

export type PostTagsArgs = {
    locale: Scalars['Locale']['input']
}

export type PostCategoriesAggregation = {
    __typename: 'PostCategoriesAggregation'
    count: Scalars['Int']['output']
}

export type PostCategory = {
    __typename: 'PostCategory'
    children: Maybe<Array<PostCategory>>
    id: Scalars['ID']['output']
    name: Scalars['String']['output']
    parent: Maybe<PostCategory>
    postAggregation: PostsAggregation
    posts: Array<Post>
    slug: Scalars['String']['output']
}

export type PostCategoryChildrenArgs = {
    locale: Scalars['Locale']['input']
}

export type PostCategoryParentArgs = {
    locale: Scalars['Locale']['input']
}

export type PostCategoryPostAggregationArgs = {
    locale: Scalars['Locale']['input']
}

export type PostCategoryPostsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    locale: Scalars['Locale']['input']
    page?: InputMaybe<Scalars['Int']['input']>
}

export type PostFilterInput = {
    categories?: InputMaybe<Array<Scalars['ID']['input']>>
    locale: Scalars['Locale']['input']
    search?: InputMaybe<Scalars['String']['input']>
    tags?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type PostTag = {
    __typename: 'PostTag'
    id: Scalars['ID']['output']
    name: Scalars['String']['output']
    postAggregation: PostsAggregation
    posts: Array<Post>
    slug: Scalars['String']['output']
}

export type PostTagPostAggregationArgs = {
    locale: Scalars['Locale']['input']
}

export type PostTagPostsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    locale: Scalars['Locale']['input']
    page?: InputMaybe<Scalars['Int']['input']>
}

export type PostTagsAggregation = {
    __typename: 'PostTagsAggregation'
    count: Scalars['Int']['output']
}

export type PostsAggregation = {
    __typename: 'PostsAggregation'
    count: Scalars['Int']['output']
}

export type PreHeader = {
    __typename: 'PreHeader'
    link: Link
}

export type PriceRangeBarInput = {
    count?: InputMaybe<Scalars['Int']['input']>
}

export type ProductLabelTranslation = {
    __typename: 'ProductLabelTranslation'
    facetedContentName: Maybe<Scalars['String']['output']>
    name: Scalars['String']['output']
}

export type ProductPageDetails = {
    __typename: 'ProductPageDetails'
    blocks: Array<Block>
    id: Scalars['ID']['output']
    meta: Meta
    path: Scalars['String']['output']
    priceExplainedTooltip: Maybe<PageTooltip>
    slug: Scalars['String']['output']
    title: Scalars['String']['output']
}

export type ProductPageFacetedContent = {
    __typename: 'ProductPageFacetedContent'
    contentTitle: Scalars['RenderableTemplate']['output']
    description: Scalars['RenderableTemplate']['output']
    longDescription: Maybe<ProductPageFacetedContentLongDescription>
    meta: Meta
    productString: Scalars['RenderableTemplate']['output']
    title: Scalars['RenderableTemplate']['output']
}

export type ProductPageFacetedContentInput = {
    diamondSearch?: InputMaybe<ProductPageFacetedContentInputDiamondSearch>
    engagementRings?: InputMaybe<ProductPageFacetedContentInputEngagementRings>
    gemstoneNonSku?: InputMaybe<ProductPageFacetedContentInputGemstoneNonSku>
    jewellery?: InputMaybe<ProductPageFacetedContentInputJewellery>
    labGrownNonSku?: InputMaybe<ProductPageFacetedContentInputLabGrownNonSku>
    weddingRings?: InputMaybe<ProductPageFacetedContentInputWeddingRings>
}

export type ProductPageFacetedContentInputDiamondSearch = {
    shape?: InputMaybe<Scalars['String']['input']>
}

export type ProductPageFacetedContentInputEngagementRings = {
    designStyle?: InputMaybe<Scalars['String']['input']>
    metal?: InputMaybe<Scalars['String']['input']>
    ringStyle?: InputMaybe<Scalars['String']['input']>
    shape?: InputMaybe<Scalars['String']['input']>
}

export type ProductPageFacetedContentInputGemstoneNonSku = {
    shape?: InputMaybe<Scalars['String']['input']>
}

export type ProductPageFacetedContentInputJewellery = {
    category?: InputMaybe<Scalars['String']['input']>
    designStyle?: InputMaybe<Scalars['String']['input']>
    gemstone?: InputMaybe<Scalars['String']['input']>
    metal?: InputMaybe<Scalars['String']['input']>
    productStyle?: InputMaybe<Scalars['String']['input']>
}

export type ProductPageFacetedContentInputLabGrownNonSku = {
    shape?: InputMaybe<Scalars['String']['input']>
}

export type ProductPageFacetedContentInputWeddingRings = {
    category?: InputMaybe<Scalars['String']['input']>
    metal?: InputMaybe<Scalars['String']['input']>
    ringStyle?: InputMaybe<Scalars['String']['input']>
}

export type ProductPageFacetedContentLongDescription =
    | ProductPageFacetedContentLongDescriptionBlock
    | ProductPageFacetedContentLongDescriptionText

export type ProductPageFacetedContentLongDescriptionBlock = {
    __typename: 'ProductPageFacetedContentLongDescriptionBlock'
    blocks: Array<Block>
}

export type ProductPageFacetedContentLongDescriptionText = {
    __typename: 'ProductPageFacetedContentLongDescriptionText'
    text: Scalars['RenderableTemplate']['output']
}

export type ProductPageListing = {
    __typename: 'ProductPageListing'
    afterGrid: Array<Block>
    banner1: Maybe<Banner1>
    banner2: Maybe<Banner2>
    beforeFilters: Array<Block>
    id: Scalars['ID']['output']
    meta: Meta
    path: Scalars['String']['output']
    slug: Scalars['String']['output']
    title: Scalars['String']['output']
}

export type PromoCode = {
    __typename: 'PromoCode'
    code: Scalars['String']['output']
    id: Scalars['ID']['output']
}

export const PromoCodeApplicationError = {
    ErrorAfterFirstSaleOnly: 'ERROR_AFTER_FIRST_SALE_ONLY',
    ErrorCodeAlreadyUsed: 'ERROR_CODE_ALREADY_USED',
    ErrorDisabled: 'ERROR_DISABLED',
    ErrorDoesNotExist: 'ERROR_DOES_NOT_EXIST',
    ErrorExpired: 'ERROR_EXPIRED',
    ErrorFirstSaleOnly: 'ERROR_FIRST_SALE_ONLY',
    ErrorSingleUseCodeAlreadyUsed: 'ERROR_SINGLE_USE_CODE_ALREADY_USED',
    ErrorSingleUseOnly: 'ERROR_SINGLE_USE_ONLY',
} as const

export type PromoCodeApplicationError =
    (typeof PromoCodeApplicationError)[keyof typeof PromoCodeApplicationError]
export type PromoCodeApplicationResult = {
    __typename: 'PromoCodeApplicationResult'
    error: Maybe<PromoCodeApplicationError>
}

export type Query = {
    __typename: 'Query'
    GemsApi_findStones: Maybe<GemsApi_StoneCollection>
    GemsApi_getBounds: Maybe<GemsApi_Bounds>
    GemsApi_getGiaStone: Maybe<GemsApi_Stone>
    GemsApi_getStone: Maybe<GemsApi_Stone>
    GemsApi_getStoneByExternalId: Maybe<GemsApi_Stone>
    GemsApi_getStones: Array<Maybe<GemsApi_Stone>>
    authorById: Maybe<Author>
    authorBySlug: Maybe<Author>
    authors: Array<Author>
    authorsAggregation: Maybe<AuthorsAggregation>
    avatarStack: Array<AvatarStackItem>
    /** @deprecated Booking form has to be reworked from the ground. */
    bookingAvailableTransitions: Array<Maybe<BookingConsultationTransition>>
    /** @deprecated Booking form has to be reworked from the ground. */
    bookingConsultants: Array<Consultant>
    /** @deprecated Booking form has to be reworked from the ground. */
    bookingConsultation: Maybe<BookingConsultation>
    bookingConsultationAvailableSlots: BookingConsultationSlotsResponse
    /** @deprecated Booking form has to be reworked from the ground. */
    bookingConsultationAvailableSlotsByConsultant: Array<BookingConsultationAvailableDate>
    bookingConsultationComplexities: Array<BookingConsultationComplexity>
    bookingConsultationPurposes: Array<BookingConsultationPurpose>
    /** If this returns true: prompt user for phone */
    bookingConsultationShowPhone: Scalars['Boolean']['output']
    /** @deprecated Booking form has to be reworked from the ground. */
    bookingCustomer: Customer
    /** @deprecated Booking form has to be reworked from the ground. */
    bookingInPersonConsultationRooms: Array<BookingConsultationRoom>
    /** @deprecated Booking form has to be reworked from the ground. */
    bookingShowrooms: Array<Showroom>
    /** @deprecated Booking form has to be reworked from the ground. */
    bookingVirtualConsultationRooms: Array<BookingConsultationRoom>
    calculateGemsApiStoneTotalSalePrices: Array<Money>
    catalogueEngagementRing: Maybe<CatalogueEngagementRing>
    catalogueEngagementRingContainsProducts: Array<Scalars['Boolean']['output']>
    catalogueEngagementRingFilters: CatalogueEngagementRingFilters
    catalogueEngagementRingFiltersVariations: Array<CatalogueEngagementRingFiltersVariation>
    catalogueEngagementRings: Array<CatalogueEngagementRing>
    catalogueEngagementRingsAggregate: CatalogueAggregate
    catalogueJewelleries: Array<CatalogueJewellery>
    catalogueJewelleriesAggregate: CatalogueAggregate
    catalogueJewelleriesFilters: CatalogueJewelleriesFilters
    catalogueJewelleriesFiltersVariations: Array<CatalogueJewelleriesFiltersVariation>
    catalogueJewellery: Maybe<CatalogueJewellery>
    catalogueJewelleryBracelet: Maybe<CatalogueJewelleryBracelet>
    catalogueJewelleryBraceletFiltersVariations: Array<CatalogueJewelleriesBraceletsFiltersVariation>
    catalogueJewelleryBracelets: Array<CatalogueJewelleryBracelet>
    catalogueJewelleryBraceletsAggregate: CatalogueAggregate
    catalogueJewelleryBraceletsFilters: CatalogueJewelleryBraceletsFilters
    catalogueJewelleryEarring: Maybe<CatalogueJewelleryEarrings>
    catalogueJewelleryEarrings: Array<CatalogueJewelleryEarrings>
    catalogueJewelleryEarringsAggregate: CatalogueAggregate
    catalogueJewelleryEarringsFilters: CatalogueJewelleryEarringsFilters
    catalogueJewelleryEarringsFiltersVariations: Array<CatalogueJewelleriesEarringsFiltersVariation>
    catalogueJewelleryNecklace: Maybe<CatalogueJewelleryNecklace>
    catalogueJewelleryNecklaces: Array<CatalogueJewelleryNecklace>
    catalogueJewelleryNecklacesAggregate: CatalogueAggregate
    catalogueJewelleryNecklacesFilters: CatalogueJewelleryNecklacesFilters
    catalogueJewelleryNecklacesFiltersVariations: Array<CatalogueJewelleriesNecklacesFiltersVariation>
    catalogueJewelleryRing: Maybe<CatalogueJewelleryRing>
    catalogueJewelleryRings: Array<CatalogueJewelleryRing>
    catalogueJewelleryRingsAggregate: CatalogueAggregate
    catalogueJewelleryRingsFilters: CatalogueJewelleryRingsFilters
    catalogueJewelleryRingsFiltersVariations: Array<CatalogueJewelleriesRingsFiltersVariation>
    catalogueProducts: Array<CatalogueProduct>
    catalogueReadyToGoRing: Maybe<CatalogueReadyToGoRing>
    catalogueReadyToGoRings: Array<CatalogueReadyToGoRing>
    catalogueReadyToGoRingsAggregate: CatalogueAggregate
    catalogueReadyToGoRingsFilters: CatalogueReadyToGoRingFilters
    catalogueWeddingRing: Maybe<CatalogueWeddingRing>
    catalogueWeddingRingFilterVariations: Array<CatalogueWeddingRingFiltersVariation>
    catalogueWeddingRingFilters: CatalogueWeddingRingFilters
    catalogueWeddingRings: Array<CatalogueWeddingRing>
    catalogueWeddingRingsAggregate: CatalogueAggregate
    convertPriceBoundsForGems: GemsApiPriceBounds
    convertPriceBoundsForGemsMulti: Array<GemsApiPriceBounds>
    customerExists: Scalars['Boolean']['output']
    defaultAlternateRegion: Region
    defaultRegion: Region
    deliveryDaysForBespokeEngagementRings: Scalars['Int']['output']
    engagementRingStoneRecommendations: Maybe<EngagementRingStoneRecommendations>
    footer: Maybe<Footer>
    language: Maybe<Language>
    languages: Array<Language>
    mainMenu: Array<MenuItem>
    me: Maybe<User>
    metals: Array<Metal>
    nonSkuGemStone: Maybe<NonSkuGemstone>
    nonSkuGemStones: Array<NonSkuGemstone>
    nonSkuGemStonesBounds: NonSkuGemstonesBounds
    nonSkuGemStonesPricingCells: Array<NonSkuGemstone>
    nonSkuGemstoneCaratDimensions: Array<NonSkuGemstoneCaratDimension>
    nonSkuGemstoneColorCrystalDimensions: Array<NonSkuGemstoneType>
    nonSkuGemstoneGradeClarityDimensions: Array<NonSkuGemstoneGradeClarityDimension>
    nonSkuGemstoneImages: Array<NonSkuGemstoneImage>
    nonSkuGemstoneShapeDimensions: Array<NonSkuGemstoneShapeDimension>
    nonSkuLabGrownCaratDimensions: Array<NonSkuLabGrownCaratDimension>
    nonSkuLabGrownDiamond: Maybe<NonSkuLabGrown>
    nonSkuLabGrownDiamonds: Array<NonSkuLabGrown>
    nonSkuLabGrownDiamondsBounds: NonSkuLabGrownDiamondsBounds
    nonSkuLabGrownGradeDimensions: Array<NonSkuLabGrownGradeDimension>
    nonSkuLabGrownPricingCells: Array<NonSkuLabGrown>
    nonSkuLabGrownShapeDimensions: Array<NonSkuLabGrownShapeDimension>
    pageByPath: Maybe<Page>
    pageProductDetails: Maybe<ProductPageDetails>
    pageProductListing: Maybe<ProductPageListing>
    pageProductListingFacetedContent: Maybe<ProductPageFacetedContent>
    pages: Array<Page>
    paymentIcons: Array<PaymentIcon>
    ping: Scalars['String']['output']
    postBySlug: Maybe<Post>
    postCategories: Array<PostCategory>
    postCategoriesAggregation: PostCategoriesAggregation
    postCategoryBySlug: Maybe<PostCategory>
    postTagAggregation: PostTagsAggregation
    postTagBySlug: Maybe<PostTag>
    postTags: Array<PostTag>
    posts: Array<Post>
    postsAggregation: PostsAggregation
    preHeader: Maybe<PreHeader>
    questionnaire: Maybe<Questionnaire>
    questionnaires: Array<Questionnaire>
    region: Region
    regionSuggest: Region
    regions: Array<Region>
    reviews: Array<Review>
    ringBuilder: RingBuilder
    searchEverywhere: SearchEverywhereResponse
    socialNetworks: Array<SocialNetwork>
    stoneCategoriesBySystemCode: Array<StoneCategory>
    stoneCategoryBySystemCode: StoneCategory
    stoneClarities: Array<StoneClarity>
    stoneClaritiesBySystemCode: Array<StoneClarity>
    stoneClarityBySystemCode: StoneClarity
    stoneColorBySystemCode: StoneColor
    stoneColors: Array<StoneColor>
    stoneColorsBySystemCode: Array<StoneColor>
    stoneCrystals: Array<StoneCrystal>
    stoneCrystalsBySystemCode: Array<StoneCrystal>
    stoneCutsBySystemCodes: Array<StoneCut>
    stoneFluorescencesBySystemCodes: Array<StoneFluorescence>
    stoneGrades: Array<StoneGrade>
    stoneGradesBySystemCodes: Array<StoneGrade>
    stonePolishesBySystemCodes: Array<StonePolish>
    stoneShapeBySystemCodes: Array<StoneShape>
    stoneShapes: Array<StoneShape>
    stoneSymmetriesBySystemCodes: Array<StoneSymmetry>
    tooltip: Maybe<Tooltip>
    topBar: Maybe<TopBar>
    validateConsultationInput: Scalars['Boolean']['output']
    validateCustomerRegistrationInput: Scalars['Boolean']['output']
    workingHours: Array<WorkingHours>
}

export type QueryGemsApi_FindStonesArgs = {
    filters: InputMaybe<GemsApi_StoneFilters>
}

export type QueryGemsApi_GetBoundsArgs = {
    categories: Array<GemsApi_StoneCategory>
    isConsultant: InputMaybe<Scalars['Boolean']['input']>
    market: Scalars['String']['input']
    notClarity: InputMaybe<Array<GemsApi_StoneClarity>>
    notColour: InputMaybe<Array<GemsApi_StoneColour>>
    notSymmetry: InputMaybe<Array<GemsApi_StoneSymmetry>>
}

export type QueryGemsApi_GetGiaStoneArgs = {
    giaCertificate: Scalars['String']['input']
}

export type QueryGemsApi_GetStoneArgs = {
    identifier: Scalars['GemsApi_StoneIdentifier']['input']
}

export type QueryGemsApi_GetStoneByExternalIdArgs = {
    externalId: Scalars['String']['input']
    feedIdentifier: Scalars['String']['input']
}

export type QueryGemsApi_GetStonesArgs = {
    identifiers: Array<Scalars['GemsApi_StoneIdentifier']['input']>
}

export type QueryAuthorByIdArgs = {
    id: Scalars['String']['input']
    locale: Scalars['Locale']['input']
}

export type QueryAuthorBySlugArgs = {
    locale: Scalars['Locale']['input']
    slug: Scalars['String']['input']
}

export type QueryAuthorsArgs = {
    locale: Scalars['Locale']['input']
    pagination?: PaginationInput
}

export type QueryAuthorsAggregationArgs = {
    locale: Scalars['Locale']['input']
}

export type QueryAvatarStackArgs = {
    locale: Scalars['Locale']['input']
}

export type QueryBookingAvailableTransitionsArgs = {
    id: Scalars['ID']['input']
}

export type QueryBookingConsultationArgs = {
    id: Scalars['ID']['input']
}

export type QueryBookingConsultationAvailableSlotsArgs = {
    input: BookingConsultationSlotInput
}

export type QueryBookingConsultationAvailableSlotsByConsultantArgs = {
    consultant: InputMaybe<Scalars['ID']['input']>
    consultationMethod: Scalars['ID']['input']
    consultationPurpose: Scalars['ID']['input']
    consultationRoom: InputMaybe<Scalars['ID']['input']>
    consultationRoomKind: BookingConsultationRoomKind
    ignoreConsultation: InputMaybe<Scalars['ID']['input']>
    order: InputMaybe<Scalars['ID']['input']>
    showroom: Scalars['ID']['input']
}

export type QueryBookingCustomerArgs = {
    id: Scalars['ID']['input']
}

export type QueryBookingInPersonConsultationRoomsArgs = {
    consultationPurposeId: Scalars['ID']['input']
    kind: BookingConsultationRoomKind
    showroomId: Scalars['ID']['input']
}

export type QueryBookingVirtualConsultationRoomsArgs = {
    consultationPurposeId: Scalars['ID']['input']
    kind: BookingConsultationRoomKind
    showroomId: Scalars['ID']['input']
}

export type QueryCalculateGemsApiStoneTotalSalePricesArgs = {
    input: Array<CalculateGemsApiStoneTotalSalePriceInput>
}

export type QueryCatalogueEngagementRingArgs = {
    filter: CatalogueEngagementRingFilterInput
}

export type QueryCatalogueEngagementRingContainsProductsArgs = {
    input: Array<CatalogueEngagementRingContainsProductsInput>
}

export type QueryCatalogueEngagementRingFiltersArgs = {
    input: CatalogueEngagementRingsFilterInput
}

export type QueryCatalogueEngagementRingFiltersVariationsArgs = {
    maxSlots: InputMaybe<Scalars['Int']['input']>
}

export type QueryCatalogueEngagementRingsArgs = {
    filter: InputMaybe<CatalogueEngagementRingsFilterInput>
    pagination: InputMaybe<PaginationInput>
    sort: InputMaybe<CatalogueSortInput>
}

export type QueryCatalogueEngagementRingsAggregateArgs = {
    filter: InputMaybe<CatalogueEngagementRingsFilterInput>
}

export type QueryCatalogueJewelleriesArgs = {
    filter: InputMaybe<CatalogueJewelleriesFilterInput>
    pagination: InputMaybe<PaginationInput>
    sort: InputMaybe<CatalogueSortInput>
}

export type QueryCatalogueJewelleriesAggregateArgs = {
    filter: InputMaybe<CatalogueJewelleriesFilterInput>
}

export type QueryCatalogueJewelleriesFiltersArgs = {
    input: InputMaybe<CatalogueJewelleriesFilterInput>
}

export type QueryCatalogueJewelleriesFiltersVariationsArgs = {
    maxSlots: InputMaybe<Scalars['Int']['input']>
}

export type QueryCatalogueJewelleryArgs = {
    filter: CatalogueJewelleryFilterInput
    type: InputMaybe<CatalogueJewelleryType>
}

export type QueryCatalogueJewelleryBraceletArgs = {
    filter: CatalogueJewelleryFilterInput
}

export type QueryCatalogueJewelleryBraceletFiltersVariationsArgs = {
    maxSlots: InputMaybe<Scalars['Int']['input']>
}

export type QueryCatalogueJewelleryBraceletsArgs = {
    filter: InputMaybe<CatalogueJewelleriesBraceletsFilterInput>
    pagination: InputMaybe<PaginationInput>
    sort: InputMaybe<CatalogueSortInput>
}

export type QueryCatalogueJewelleryBraceletsAggregateArgs = {
    filter: InputMaybe<CatalogueJewelleriesBraceletsFilterInput>
}

export type QueryCatalogueJewelleryBraceletsFiltersArgs = {
    input: InputMaybe<CatalogueJewelleriesBraceletsFilterInput>
}

export type QueryCatalogueJewelleryEarringArgs = {
    filter: CatalogueJewelleryFilterInput
}

export type QueryCatalogueJewelleryEarringsArgs = {
    filter: InputMaybe<CatalogueJewelleriesEarringsFilterInput>
    pagination: InputMaybe<PaginationInput>
    sort: InputMaybe<CatalogueSortInput>
}

export type QueryCatalogueJewelleryEarringsAggregateArgs = {
    filter: InputMaybe<CatalogueJewelleriesEarringsFilterInput>
}

export type QueryCatalogueJewelleryEarringsFiltersArgs = {
    input: InputMaybe<CatalogueJewelleriesEarringsFilterInput>
}

export type QueryCatalogueJewelleryEarringsFiltersVariationsArgs = {
    maxSlots: InputMaybe<Scalars['Int']['input']>
}

export type QueryCatalogueJewelleryNecklaceArgs = {
    filter: CatalogueJewelleryFilterInput
}

export type QueryCatalogueJewelleryNecklacesArgs = {
    filter: InputMaybe<CatalogueJewelleriesNecklacesFilterInput>
    pagination: InputMaybe<PaginationInput>
    sort: InputMaybe<CatalogueSortInput>
}

export type QueryCatalogueJewelleryNecklacesAggregateArgs = {
    filter: InputMaybe<CatalogueJewelleriesNecklacesFilterInput>
}

export type QueryCatalogueJewelleryNecklacesFiltersArgs = {
    input: InputMaybe<CatalogueJewelleriesNecklacesFilterInput>
}

export type QueryCatalogueJewelleryNecklacesFiltersVariationsArgs = {
    maxSlots: InputMaybe<Scalars['Int']['input']>
}

export type QueryCatalogueJewelleryRingArgs = {
    filter: CatalogueJewelleryFilterInput
}

export type QueryCatalogueJewelleryRingsArgs = {
    filter: InputMaybe<CatalogueJewelleriesRingsFilterInput>
    pagination: InputMaybe<PaginationInput>
    sort: InputMaybe<CatalogueSortInput>
}

export type QueryCatalogueJewelleryRingsAggregateArgs = {
    filter: InputMaybe<CatalogueJewelleriesRingsFilterInput>
}

export type QueryCatalogueJewelleryRingsFiltersArgs = {
    input: InputMaybe<CatalogueJewelleriesRingsFilterInput>
}

export type QueryCatalogueJewelleryRingsFiltersVariationsArgs = {
    maxSlots: InputMaybe<Scalars['Int']['input']>
}

export type QueryCatalogueProductsArgs = {
    filter: InputMaybe<CatalogueFilterInput>
    pagination: InputMaybe<PaginationInput>
    sort: InputMaybe<CatalogueSortInput>
}

export type QueryCatalogueReadyToGoRingArgs = {
    filter: CatalogueReadyToGoRingFilterInput
}

export type QueryCatalogueReadyToGoRingsArgs = {
    filter: InputMaybe<CatalogueReadyToGoRingsFilterInput>
    pagination: InputMaybe<PaginationInput>
    sort: InputMaybe<CatalogueSortInput>
}

export type QueryCatalogueReadyToGoRingsAggregateArgs = {
    filter: InputMaybe<CatalogueReadyToGoRingsFilterInput>
}

export type QueryCatalogueReadyToGoRingsFiltersArgs = {
    input: CatalogueReadyToGoRingsFilterInput
}

export type QueryCatalogueWeddingRingArgs = {
    filter: CatalogueWeddingRingFilterInput
}

export type QueryCatalogueWeddingRingFilterVariationsArgs = {
    maxSlots: InputMaybe<Scalars['Int']['input']>
}

export type QueryCatalogueWeddingRingFiltersArgs = {
    input: CatalogueWeddingRingFilterInput
}

export type QueryCatalogueWeddingRingsArgs = {
    filter: InputMaybe<CatalogueWeddingRingFilterInput>
    pagination: InputMaybe<PaginationInput>
    sort: InputMaybe<CatalogueSortInput>
}

export type QueryCatalogueWeddingRingsAggregateArgs = {
    filter: InputMaybe<CatalogueWeddingRingFilterInput>
}

export type QueryConvertPriceBoundsForGemsArgs = {
    input: ConvertPriceBoundsForGems
}

export type QueryConvertPriceBoundsForGemsMultiArgs = {
    input: Array<ConvertPriceBoundsForGems>
}

export type QueryCustomerExistsArgs = {
    email: Scalars['Email']['input']
}

export type QueryEngagementRingStoneRecommendationsArgs = {
    locale: Scalars['Locale']['input']
}

export type QueryFooterArgs = {
    locale: Scalars['Locale']['input']
}

export type QueryLanguageArgs = {
    locale: Scalars['Locale']['input']
}

export type QueryMainMenuArgs = {
    locale: Scalars['Locale']['input']
}

export type QueryNonSkuGemStoneArgs = {
    filter: NonSkuGemstoneFilterInput
}

export type QueryNonSkuGemStonesArgs = {
    currency: CurrencyInput
    filters: InputMaybe<NonSkuGemstoneFilters>
    region: RegionCode
    sort: InputMaybe<NonSkuGemstoneSortInput>
}

export type QueryNonSkuGemStonesPricingCellsArgs = {
    filters: InputMaybe<NonSkuGemStonesPricingCellFilters>
}

export type QueryNonSkuLabGrownDiamondArgs = {
    filter: NonSkuLabGrownDiamondFilterInput
}

export type QueryNonSkuLabGrownDiamondsArgs = {
    currency: CurrencyInput
    filters: InputMaybe<NonSkuLabGrownDiamondsFilters>
    region: RegionCode
    sort: InputMaybe<NonSkuLabGrownDiamondSortInput>
}

export type QueryNonSkuLabGrownPricingCellsArgs = {
    filters: InputMaybe<NonSkuLabGrownPricingCellFilters>
}

export type QueryPageByPathArgs = {
    locale: Scalars['Locale']['input']
    path: Scalars['String']['input']
}

export type QueryPageProductDetailsArgs = {
    fallback: Scalars['String']['input']
    locale: Scalars['Locale']['input']
    path: Scalars['String']['input']
}

export type QueryPageProductListingArgs = {
    locale: Scalars['Locale']['input']
    path: Scalars['String']['input']
}

export type QueryPageProductListingFacetedContentArgs = {
    input: ProductPageFacetedContentInput
    locale: Scalars['Locale']['input']
}

export type QueryPagesArgs = {
    locale: Scalars['Locale']['input']
    pagination: InputMaybe<PaginationInput>
}

export type QueryPaymentIconsArgs = {
    locale: Scalars['Locale']['input']
}

export type QueryPostBySlugArgs = {
    locale: Scalars['Locale']['input']
    slug: Scalars['String']['input']
}

export type QueryPostCategoriesArgs = {
    locale: Scalars['Locale']['input']
    pagination?: PaginationInput
}

export type QueryPostCategoriesAggregationArgs = {
    locale: Scalars['Locale']['input']
}

export type QueryPostCategoryBySlugArgs = {
    locale: Scalars['Locale']['input']
    slug: Scalars['String']['input']
}

export type QueryPostTagAggregationArgs = {
    locale: Scalars['Locale']['input']
}

export type QueryPostTagBySlugArgs = {
    locale: Scalars['Locale']['input']
    slug: Scalars['String']['input']
}

export type QueryPostTagsArgs = {
    locale: Scalars['Locale']['input']
    pagination?: PaginationInput
}

export type QueryPostsArgs = {
    filter: InputMaybe<PostFilterInput>
    pagination?: PaginationInput
}

export type QueryPostsAggregationArgs = {
    filter: InputMaybe<PostFilterInput>
}

export type QueryPreHeaderArgs = {
    locale: Scalars['Locale']['input']
}

export type QueryQuestionnaireArgs = {
    id: Scalars['ID']['input']
}

export type QueryRegionArgs = {
    code: RegionCode
}

export type QueryReviewsArgs = {
    filter: InputMaybe<ReviewFilter>
}

export type QueryRingBuilderArgs = {
    input: InputMaybe<RingBuilderGetInput>
}

export type QuerySearchEverywhereArgs = {
    justMe: Scalars['Boolean']['input']
    query: Scalars['String']['input']
}

export type QuerySocialNetworksArgs = {
    locale: Scalars['Locale']['input']
}

export type QueryStoneCategoriesBySystemCodeArgs = {
    systemCodes: Array<StoneCategoryCode>
}

export type QueryStoneCategoryBySystemCodeArgs = {
    systemCode: StoneCategoryCode
}

export type QueryStoneClaritiesArgs = {
    filter: InputMaybe<StoneClarityFilterInput>
}

export type QueryStoneClaritiesBySystemCodeArgs = {
    systemCodes: Array<StoneClarityCode>
}

export type QueryStoneClarityBySystemCodeArgs = {
    systemCode: StoneClarityCode
}

export type QueryStoneColorBySystemCodeArgs = {
    systemCode: StoneColorCode
}

export type QueryStoneColorsArgs = {
    filter: InputMaybe<StoneColorsFilterInput>
}

export type QueryStoneColorsBySystemCodeArgs = {
    systemCodes: Array<StoneColorCode>
}

export type QueryStoneCrystalsArgs = {
    filter: InputMaybe<StoneCrystalsFilterInput>
}

export type QueryStoneCrystalsBySystemCodeArgs = {
    systemCodes: Array<StoneCrystalCode>
}

export type QueryStoneCutsBySystemCodesArgs = {
    systemCodes: Array<StoneCutCode>
}

export type QueryStoneFluorescencesBySystemCodesArgs = {
    systemCodes: Array<StoneFluorescenceCode>
}

export type QueryStoneGradesArgs = {
    filter: InputMaybe<StoneGradesFilterInput>
}

export type QueryStoneGradesBySystemCodesArgs = {
    systemCodes: Array<StoneGradeCode>
}

export type QueryStonePolishesBySystemCodesArgs = {
    systemCodes: Array<StonePolishCode>
}

export type QueryStoneShapeBySystemCodesArgs = {
    systemCodes: Array<StoneShapeCode>
}

export type QueryStoneShapesArgs = {
    filter: InputMaybe<StoneShapeFilterInput>
}

export type QueryStoneSymmetriesBySystemCodesArgs = {
    systemCodes: Array<StoneSymmetryCode>
}

export type QueryTooltipArgs = {
    locale: Scalars['Locale']['input']
    path: Scalars['String']['input']
}

export type QueryTopBarArgs = {
    locale: Scalars['Locale']['input']
}

export type QueryValidateConsultationInputArgs = {
    input: BookingCreateConsultationInput
}

export type QueryValidateCustomerRegistrationInputArgs = {
    input: CustomerRegistrationInput
}

export type QueryWorkingHoursArgs = {
    locale: Scalars['Locale']['input']
}

export type Questionnaire = {
    __typename: 'Questionnaire'
    id: Scalars['ID']['output']
    redirectLink: LinkItem
    signUpStep: QuestionnaireSignUpStep
    steps: Array<QuestionnaireStep>
    title: Scalars['String']['output']
    type: QuestionnaireType
}

export type QuestionnaireAnswer = {
    id: Scalars['ID']['output']
    question: QuestionnaireQuestionSnapshot
}

export type QuestionnaireAnswerInput = {
    answer: QuestionnaireAnswerValueInput
    question: QuestionnaireQuestionInput
}

export type QuestionnaireAnswerValueInput = {
    multiChoice?: InputMaybe<Array<QuestionnaireQuestionChoiceInput>>
    number?: InputMaybe<QuestionnaireQuestionFloatInput>
    singleChoice?: InputMaybe<QuestionnaireQuestionChoiceInput>
    text?: InputMaybe<QuestionnaireQuestionTextInput>
}

export const QuestionnaireBackgroundColor = {
    Blue: 'BLUE',
    Blush: 'BLUSH',
    Green: 'GREEN',
    Red: 'RED',
    Sage: 'SAGE',
    Slate: 'SLATE',
    Stone: 'STONE',
    Stone2: 'STONE2',
    Stone3: 'STONE3',
    Taaffeite: 'TAAFFEITE',
    White: 'WHITE',
} as const

export type QuestionnaireBackgroundColor =
    (typeof QuestionnaireBackgroundColor)[keyof typeof QuestionnaireBackgroundColor]
export type QuestionnaireCompleteInput = {
    referenceId: Scalars['ID']['input']
    steps: Array<QuestionnaireCompleteStepInput>
    type: QuestionnaireType
}

export type QuestionnaireCompleteStepInput = {
    answers: Array<QuestionnaireAnswerInput>
    title: Scalars['String']['input']
}

export type QuestionnaireCompletedExistingCustomerResponse = {
    __typename: 'QuestionnaireCompletedExistingCustomerResponse'
    questionnaire: QuestionnaireCompletedQuestionnaire
}

export type QuestionnaireCompletedNewCustomerResponse = {
    __typename: 'QuestionnaireCompletedNewCustomerResponse'
    customer: CustomerRegistrationResponse
    questionnaire: QuestionnaireCompletedQuestionnaire
}

export type QuestionnaireCompletedQuestionnaire = {
    __typename: 'QuestionnaireCompletedQuestionnaire'
    id: Scalars['ID']['output']
    referenceId: Scalars['ID']['output']
    steps: Array<QuestionnaireCompletedQuestionnaireStepSnapshot>
    type: QuestionnaireType
}

export type QuestionnaireCompletedQuestionnaireStepSnapshot = {
    __typename: 'QuestionnaireCompletedQuestionnaireStepSnapshot'
    answers: Array<QuestionnaireAnswer>
    id: Scalars['ID']['output']
    title: Scalars['String']['output']
}

export type QuestionnaireCondition = {
    __typename: 'QuestionnaireCondition'
    rules: Array<QuestionnaireConditionRule>
    type: QuestionnaireConditionType
}

export type QuestionnaireConditionEqualToChoice = {
    __typename: 'QuestionnaireConditionEqualToChoice'
    choice: Maybe<QuestionnaireQuestionChoiceOption>
    question: QuestionnaireQuestion
}

export type QuestionnaireConditionIsEmpty = {
    __typename: 'QuestionnaireConditionIsEmpty'
    question: QuestionnaireQuestion
}

export type QuestionnaireConditionIsEqualTo = {
    __typename: 'QuestionnaireConditionIsEqualTo'
    question: QuestionnaireQuestion
    value: Scalars['String']['output']
}

export type QuestionnaireConditionIsGreaterThan = {
    __typename: 'QuestionnaireConditionIsGreaterThan'
    question: QuestionnaireQuestion
    value: Scalars['Float']['output']
}

export type QuestionnaireConditionIsLessThan = {
    __typename: 'QuestionnaireConditionIsLessThan'
    question: QuestionnaireQuestion
    value: Scalars['Float']['output']
}

export type QuestionnaireConditionIsNotEmpty = {
    __typename: 'QuestionnaireConditionIsNotEmpty'
    question: QuestionnaireQuestion
}

export type QuestionnaireConditionNotIsEqualTo = {
    __typename: 'QuestionnaireConditionNotIsEqualTo'
    question: QuestionnaireQuestion
    value: Scalars['String']['output']
}

export type QuestionnaireConditionRule =
    | QuestionnaireConditionEqualToChoice
    | QuestionnaireConditionIsEmpty
    | QuestionnaireConditionIsEqualTo
    | QuestionnaireConditionIsGreaterThan
    | QuestionnaireConditionIsLessThan
    | QuestionnaireConditionIsNotEmpty
    | QuestionnaireConditionNotIsEqualTo

export const QuestionnaireConditionType = {
    And: 'AND',
    Or: 'OR',
} as const

export type QuestionnaireConditionType =
    (typeof QuestionnaireConditionType)[keyof typeof QuestionnaireConditionType]
export type QuestionnaireCustomerNotification = {
    __typename: 'QuestionnaireCustomerNotification'
    subject: Scalars['String']['output']
    text: Scalars['String']['output']
}

export type QuestionnaireCustomerNotificationInput = {
    subject: Scalars['String']['input']
    text: Scalars['String']['input']
}

export type QuestionnaireQuestion = {
    id: Scalars['ID']['output']
    required: Scalars['Boolean']['output']
    title: Maybe<Scalars['String']['output']>
}

export type QuestionnaireQuestionAnswerMultiChoice = QuestionnaireAnswer & {
    __typename: 'QuestionnaireQuestionAnswerMultiChoice'
    choices: Array<QuestionnaireQuestionChoiceOptionSnapshot>
    id: Scalars['ID']['output']
    question: QuestionnaireQuestionSnapshot
}

export type QuestionnaireQuestionAnswerNumber = QuestionnaireAnswer & {
    __typename: 'QuestionnaireQuestionAnswerNumber'
    id: Scalars['ID']['output']
    number: Scalars['Float']['output']
    question: QuestionnaireQuestionSnapshot
}

export type QuestionnaireQuestionAnswerSingleChoice = QuestionnaireAnswer & {
    __typename: 'QuestionnaireQuestionAnswerSingleChoice'
    choice: QuestionnaireQuestionChoiceOptionSnapshot
    id: Scalars['ID']['output']
    question: QuestionnaireQuestionSnapshot
}

export type QuestionnaireQuestionAnswerText = QuestionnaireAnswer & {
    __typename: 'QuestionnaireQuestionAnswerText'
    id: Scalars['ID']['output']
    question: QuestionnaireQuestionSnapshot
    text: Scalars['String']['output']
}

export type QuestionnaireQuestionChoice = QuestionnaireQuestion & {
    __typename: 'QuestionnaireQuestionChoice'
    id: Scalars['ID']['output']
    multiple: Scalars['Boolean']['output']
    options: Array<QuestionnaireQuestionChoiceOption>
    required: Scalars['Boolean']['output']
    title: Maybe<Scalars['String']['output']>
}

export type QuestionnaireQuestionChoiceBehaviourInput = {
    designFeatureSystemCode?: InputMaybe<EngagementRingDesignFeatureLabelCode>
    designStyleSystemCode?: InputMaybe<EngagementRingDesignStyleLabelCode>
    metalSystemCode?: InputMaybe<MetalCode>
    ringStyleSystemCode?: InputMaybe<EngagementRingStyleLabelCode>
    shape?: InputMaybe<StoneShapeCode>
}

export type QuestionnaireQuestionChoiceInput = {
    layout: QuestionnaireQuestionChoiceLayoutInput
    referenceId: Scalars['ID']['input']
}

export type QuestionnaireQuestionChoiceLayoutIconCardInput = {
    backgroundColor: QuestionnaireBackgroundColor
    description?: InputMaybe<Scalars['String']['input']>
    image: Scalars['Uri']['input']
    title: Scalars['String']['input']
}

export type QuestionnaireQuestionChoiceLayoutImageCardInput = {
    description?: InputMaybe<Scalars['String']['input']>
    image: Scalars['Uri']['input']
    title: Scalars['String']['input']
}

export type QuestionnaireQuestionChoiceLayoutImageInput = {
    image: Scalars['Uri']['input']
}

export type QuestionnaireQuestionChoiceLayoutInput = {
    iconCard?: InputMaybe<QuestionnaireQuestionChoiceLayoutIconCardInput>
    image?: InputMaybe<QuestionnaireQuestionChoiceLayoutImageInput>
    imageCard?: InputMaybe<QuestionnaireQuestionChoiceLayoutImageCardInput>
    text?: InputMaybe<QuestionnaireQuestionChoiceLayoutTextInput>
}

export type QuestionnaireQuestionChoiceLayoutTextInput = {
    description?: InputMaybe<Scalars['String']['input']>
    title: Scalars['String']['input']
}

export type QuestionnaireQuestionChoiceOption = {
    __typename: 'QuestionnaireQuestionChoiceOption'
    behaviour: Maybe<QuestionnaireQuestionChoiceOptionBehaviour>
    content: QuestionnaireQuestionChoiceOptionContent
    id: Scalars['ID']['output']
    systemCode: Maybe<QuestionnaireQuestionChoiceSystemCode>
}

export type QuestionnaireQuestionChoiceOptionBehaviour = {
    __typename: 'QuestionnaireQuestionChoiceOptionBehaviour'
    designFeature: Maybe<QuestionnaireQuestionChoiceOptionBehaviourEngagementDesignFeatureCode>
    designStyle: Maybe<QuestionnaireQuestionChoiceOptionBehaviourEngagementDesignStyleCode>
    metal: Maybe<QuestionnaireQuestionChoiceOptionBehaviourEngagementRingMetalCode>
    ringStyle: Maybe<QuestionnaireQuestionChoiceOptionBehaviourEngagementRingStyleCode>
    shape: Maybe<QuestionnaireQuestionChoiceOptionBehaviourEngagementShapeCode>
}

export const QuestionnaireQuestionChoiceOptionBehaviourEngagementDesignFeatureCode =
    {
        BeadSetting: 'BEAD_SETTING',
        BezelSetting: 'BEZEL_SETTING',
        DoubleHalo: 'DOUBLE_HALO',
        EagleClaws: 'EAGLE_CLAWS',
        Fishtail: 'FISHTAIL',
        MixedMetal: 'MIXED_METAL',
        SplitShank: 'SPLIT_SHANK',
    } as const

export type QuestionnaireQuestionChoiceOptionBehaviourEngagementDesignFeatureCode =
    (typeof QuestionnaireQuestionChoiceOptionBehaviourEngagementDesignFeatureCode)[keyof typeof QuestionnaireQuestionChoiceOptionBehaviourEngagementDesignFeatureCode]
export const QuestionnaireQuestionChoiceOptionBehaviourEngagementDesignStyleCode =
    {
        ArtDeco: 'ART_DECO',
        Classic: 'CLASSIC',
        Contemporary: 'CONTEMPORARY',
        Floral: 'FLORAL',
        Unique: 'UNIQUE',
        Vintage: 'VINTAGE',
    } as const

export type QuestionnaireQuestionChoiceOptionBehaviourEngagementDesignStyleCode =
    (typeof QuestionnaireQuestionChoiceOptionBehaviourEngagementDesignStyleCode)[keyof typeof QuestionnaireQuestionChoiceOptionBehaviourEngagementDesignStyleCode]
export const QuestionnaireQuestionChoiceOptionBehaviourEngagementRingMetalCode =
    {
        EighteenKaratRoseGold: 'EIGHTEEN_KARAT_ROSE_GOLD',
        EighteenKaratWhiteGold: 'EIGHTEEN_KARAT_WHITE_GOLD',
        EighteenKaratYellowGold: 'EIGHTEEN_KARAT_YELLOW_GOLD',
        Platinum: 'PLATINUM',
    } as const

export type QuestionnaireQuestionChoiceOptionBehaviourEngagementRingMetalCode =
    (typeof QuestionnaireQuestionChoiceOptionBehaviourEngagementRingMetalCode)[keyof typeof QuestionnaireQuestionChoiceOptionBehaviourEngagementRingMetalCode]
export const QuestionnaireQuestionChoiceOptionBehaviourEngagementRingStyleCode =
    {
        Halo: 'HALO',
        Pave: 'PAVE',
        Solitaire: 'SOLITAIRE',
        Trilogy: 'TRILOGY',
    } as const

export type QuestionnaireQuestionChoiceOptionBehaviourEngagementRingStyleCode =
    (typeof QuestionnaireQuestionChoiceOptionBehaviourEngagementRingStyleCode)[keyof typeof QuestionnaireQuestionChoiceOptionBehaviourEngagementRingStyleCode]
export const QuestionnaireQuestionChoiceOptionBehaviourEngagementShapeCode = {
    Asscher: 'ASSCHER',
    BrilliantCutTrapezoid: 'BRILLIANT_CUT_TRAPEZOID',
    Bullet: 'BULLET',
    Cabochon: 'CABOCHON',
    Carre: 'CARRE',
    Circular: 'CIRCULAR',
    Cushion: 'CUSHION',
    Custom: 'CUSTOM',
    Emerald: 'EMERALD',
    European: 'EUROPEAN',
    HalfMoon: 'HALF_MOON',
    Heart: 'HEART',
    Hexagonal: 'HEXAGONAL',
    Kite: 'KITE',
    Marquise: 'MARQUISE',
    Octagonal: 'OCTAGONAL',
    OldMiners: 'OLD_MINERS',
    Oval: 'OVAL',
    Pear: 'PEAR',
    Princess: 'PRINCESS',
    Radiant: 'RADIANT',
    RectangularFrench: 'RECTANGULAR_FRENCH',
    Rose: 'ROSE',
    Round: 'ROUND',
    SquareFrench: 'SQUARE_FRENCH',
    StepCutTrapezoid: 'STEP_CUT_TRAPEZOID',
    StraightBaguette: 'STRAIGHT_BAGUETTE',
    TaperedBaguette: 'TAPERED_BAGUETTE',
    Trapezoid: 'TRAPEZOID',
    Triangular: 'TRIANGULAR',
    Trillion: 'TRILLION',
} as const

export type QuestionnaireQuestionChoiceOptionBehaviourEngagementShapeCode =
    (typeof QuestionnaireQuestionChoiceOptionBehaviourEngagementShapeCode)[keyof typeof QuestionnaireQuestionChoiceOptionBehaviourEngagementShapeCode]
export type QuestionnaireQuestionChoiceOptionContent =
    | QuestionnaireQuestionChoiceOptionContentIconCard
    | QuestionnaireQuestionChoiceOptionContentImage
    | QuestionnaireQuestionChoiceOptionContentImageCard
    | QuestionnaireQuestionChoiceOptionContentText

export type QuestionnaireQuestionChoiceOptionContentIconCard =
    QuestionnaireQuestionChoiceOptionContentIconCardInterface & {
        __typename: 'QuestionnaireQuestionChoiceOptionContentIconCard'
        backgroundColor: Color
        conditionalContent: Array<QuestionnaireQuestionChoiceOptionContentIconCardConditional>
        description: Maybe<Scalars['String']['output']>
        icon: Image
        title: Scalars['String']['output']
    }

export type QuestionnaireQuestionChoiceOptionContentIconCardConditional =
    QuestionnaireQuestionChoiceOptionContentIconCardInterface & {
        __typename: 'QuestionnaireQuestionChoiceOptionContentIconCardConditional'
        backgroundColor: Color
        conditions: Array<QuestionnaireCondition>
        description: Maybe<Scalars['String']['output']>
        icon: Image
        title: Scalars['String']['output']
    }

export type QuestionnaireQuestionChoiceOptionContentIconCardInterface = {
    backgroundColor: Color
    description: Maybe<Scalars['String']['output']>
    icon: Image
    title: Scalars['String']['output']
}

export type QuestionnaireQuestionChoiceOptionContentImage =
    QuestionnaireQuestionChoiceOptionContentImageInterface & {
        __typename: 'QuestionnaireQuestionChoiceOptionContentImage'
        conditionalContent: Array<QuestionnaireQuestionChoiceOptionContentImageConditional>
        image: Image
    }

export type QuestionnaireQuestionChoiceOptionContentImageCard =
    QuestionnaireQuestionChoiceOptionContentImageCardInterface & {
        __typename: 'QuestionnaireQuestionChoiceOptionContentImageCard'
        conditionalContent: Array<QuestionnaireQuestionChoiceOptionContentImageCardConditional>
        description: Maybe<Scalars['String']['output']>
        image: Image
        title: Scalars['String']['output']
    }

export type QuestionnaireQuestionChoiceOptionContentImageCardConditional =
    QuestionnaireQuestionChoiceOptionContentImageCardInterface & {
        __typename: 'QuestionnaireQuestionChoiceOptionContentImageCardConditional'
        conditions: Array<QuestionnaireCondition>
        description: Maybe<Scalars['String']['output']>
        image: Image
        title: Scalars['String']['output']
    }

export type QuestionnaireQuestionChoiceOptionContentImageCardInterface = {
    description: Maybe<Scalars['String']['output']>
    image: Image
    title: Scalars['String']['output']
}

export type QuestionnaireQuestionChoiceOptionContentImageConditional =
    QuestionnaireQuestionChoiceOptionContentImageInterface & {
        __typename: 'QuestionnaireQuestionChoiceOptionContentImageConditional'
        conditions: Array<QuestionnaireCondition>
        image: Image
    }

export type QuestionnaireQuestionChoiceOptionContentImageInterface = {
    image: Image
}

export type QuestionnaireQuestionChoiceOptionContentText =
    QuestionnaireQuestionChoiceOptionContentTextInterface & {
        __typename: 'QuestionnaireQuestionChoiceOptionContentText'
        conditionalContent: Array<QuestionnaireQuestionChoiceOptionContentTextConditional>
        description: Maybe<Scalars['String']['output']>
        title: Scalars['String']['output']
    }

export type QuestionnaireQuestionChoiceOptionContentTextConditional =
    QuestionnaireQuestionChoiceOptionContentTextInterface & {
        __typename: 'QuestionnaireQuestionChoiceOptionContentTextConditional'
        conditions: Array<QuestionnaireCondition>
        description: Maybe<Scalars['String']['output']>
        title: Scalars['String']['output']
    }

export type QuestionnaireQuestionChoiceOptionContentTextInterface = {
    description: Maybe<Scalars['String']['output']>
    title: Scalars['String']['output']
}

export type QuestionnaireQuestionChoiceOptionLayoutSnapshot =
    | QuestionnaireQuestionChoiceOptionLayoutSnapshotIconCard
    | QuestionnaireQuestionChoiceOptionLayoutSnapshotImage
    | QuestionnaireQuestionChoiceOptionLayoutSnapshotImageCard
    | QuestionnaireQuestionChoiceOptionLayoutSnapshotText

export type QuestionnaireQuestionChoiceOptionLayoutSnapshotIconCard = {
    __typename: 'QuestionnaireQuestionChoiceOptionLayoutSnapshotIconCard'
    backgroundColor: QuestionnaireBackgroundColor
    description: Maybe<Scalars['String']['output']>
    icon: Maybe<Asset>
    title: Scalars['String']['output']
}

export type QuestionnaireQuestionChoiceOptionLayoutSnapshotImage = {
    __typename: 'QuestionnaireQuestionChoiceOptionLayoutSnapshotImage'
    icon: Maybe<Asset>
}

export type QuestionnaireQuestionChoiceOptionLayoutSnapshotImageCard = {
    __typename: 'QuestionnaireQuestionChoiceOptionLayoutSnapshotImageCard'
    description: Maybe<Scalars['String']['output']>
    icon: Maybe<Asset>
    title: Scalars['String']['output']
}

export type QuestionnaireQuestionChoiceOptionLayoutSnapshotText = {
    __typename: 'QuestionnaireQuestionChoiceOptionLayoutSnapshotText'
    description: Maybe<Scalars['String']['output']>
    title: Scalars['String']['output']
}

export type QuestionnaireQuestionChoiceOptionSnapshot = {
    __typename: 'QuestionnaireQuestionChoiceOptionSnapshot'
    id: Scalars['ID']['output']
    layout: QuestionnaireQuestionChoiceOptionLayoutSnapshot
    referenceId: Scalars['ID']['output']
}

export const QuestionnaireQuestionChoiceSystemCode = {
    AftercareSpecificService: 'AFTERCARE_SPECIFIC_SERVICE',
    CustomerShippingCountry: 'CUSTOMER_SHIPPING_COUNTRY',
    CustomerShippingFromCountry: 'CUSTOMER_SHIPPING_FROM_COUNTRY',
    CustomerToThMethod: 'CUSTOMER_TO_TH_METHOD',
    DropOffOffice: 'DROP_OFF_OFFICE',
    ErChoosingFor: 'ER_CHOOSING_FOR',
    ErDesignFeatures: 'ER_DESIGN_FEATURES',
    ErDesignStyle: 'ER_DESIGN_STYLE',
    ErMetal: 'ER_METAL',
    ErRingStyle: 'ER_RING_STYLE',
    ErStoneCategory: 'ER_STONE_CATEGORY',
    ErStoneShape: 'ER_STONE_SHAPE',
    PickUpOffice: 'PICK_UP_OFFICE',
    ServiceRequestType: 'SERVICE_REQUEST_TYPE',
    SignificantMonth: 'SIGNIFICANT_MONTH',
    StoneCategory: 'STONE_CATEGORY',
    StoneShape: 'STONE_SHAPE',
    ThToCustomerMethod: 'TH_TO_CUSTOMER_METHOD',
} as const

export type QuestionnaireQuestionChoiceSystemCode =
    (typeof QuestionnaireQuestionChoiceSystemCode)[keyof typeof QuestionnaireQuestionChoiceSystemCode]
export type QuestionnaireQuestionFloatInput = {
    number: Scalars['Float']['input']
}

export type QuestionnaireQuestionInput = {
    referenceId: Scalars['ID']['input']
    systemCode?: InputMaybe<QuestionnaireQuestionSystemCode>
    title?: InputMaybe<Scalars['String']['input']>
}

export type QuestionnaireQuestionPrice = QuestionnaireQuestion & {
    __typename: 'QuestionnaireQuestionPrice'
    id: Scalars['ID']['output']
    max: Scalars['Float']['output']
    min: Scalars['Float']['output']
    required: Scalars['Boolean']['output']
    systemCode: Maybe<QuestionnaireQuestionPriceSystemCode>
    title: Maybe<Scalars['String']['output']>
    tooltip: Scalars['RenderableTemplate']['output']
}

export const QuestionnaireQuestionPriceSystemCode = {
    ErBudget: 'ER_BUDGET',
    StoneBudget: 'STONE_BUDGET',
} as const

export type QuestionnaireQuestionPriceSystemCode =
    (typeof QuestionnaireQuestionPriceSystemCode)[keyof typeof QuestionnaireQuestionPriceSystemCode]
export type QuestionnaireQuestionSnapshot = {
    __typename: 'QuestionnaireQuestionSnapshot'
    referenceId: Scalars['ID']['output']
    title: Maybe<Scalars['String']['output']>
}

export const QuestionnaireQuestionSystemCode = {
    AdditionalComments: 'ADDITIONAL_COMMENTS',
    AftercareSpecificService: 'AFTERCARE_SPECIFIC_SERVICE',
    CustomerShippingAddress: 'CUSTOMER_SHIPPING_ADDRESS',
    CustomerShippingCountry: 'CUSTOMER_SHIPPING_COUNTRY',
    CustomerShippingFromCountry: 'CUSTOMER_SHIPPING_FROM_COUNTRY',
    CustomerToThMethod: 'CUSTOMER_TO_TH_METHOD',
    DropOffOffice: 'DROP_OFF_OFFICE',
    EngravingValue: 'ENGRAVING_VALUE',
    ErBudget: 'ER_BUDGET',
    ErChoosingFor: 'ER_CHOOSING_FOR',
    ErDesignFeatures: 'ER_DESIGN_FEATURES',
    ErDesignStyle: 'ER_DESIGN_STYLE',
    ErMetal: 'ER_METAL',
    ErRingStyle: 'ER_RING_STYLE',
    ErSomeoneElseName: 'ER_SOMEONE_ELSE_NAME',
    ErStoneCategory: 'ER_STONE_CATEGORY',
    ErStoneShape: 'ER_STONE_SHAPE',
    ExchangeReason: 'EXCHANGE_REASON',
    FullName: 'FULL_NAME',
    OrderNumber: 'ORDER_NUMBER',
    PartnerName: 'PARTNER_NAME',
    PickUpOffice: 'PICK_UP_OFFICE',
    RepairComments: 'REPAIR_COMMENTS',
    ResizeValue: 'RESIZE_VALUE',
    ReturnReason: 'RETURN_REASON',
    ServiceRequestType: 'SERVICE_REQUEST_TYPE',
    SignificantMonth: 'SIGNIFICANT_MONTH',
    StoneBudget: 'STONE_BUDGET',
    StoneCategory: 'STONE_CATEGORY',
    StoneShape: 'STONE_SHAPE',
    TellUsSomethingElse: 'TELL_US_SOMETHING_ELSE',
    ThToCustomerMethod: 'TH_TO_CUSTOMER_METHOD',
} as const

export type QuestionnaireQuestionSystemCode =
    (typeof QuestionnaireQuestionSystemCode)[keyof typeof QuestionnaireQuestionSystemCode]
export type QuestionnaireQuestionText = QuestionnaireQuestion & {
    __typename: 'QuestionnaireQuestionText'
    id: Scalars['ID']['output']
    required: Scalars['Boolean']['output']
    systemCode: Maybe<QuestionnaireQuestionTextSystemCode>
    textarea: Scalars['Boolean']['output']
    title: Maybe<Scalars['String']['output']>
}

export type QuestionnaireQuestionTextInput = {
    text: Scalars['String']['input']
}

export const QuestionnaireQuestionTextSystemCode = {
    AdditionalComments: 'ADDITIONAL_COMMENTS',
    CustomerShippingAddress: 'CUSTOMER_SHIPPING_ADDRESS',
    EngravingValue: 'ENGRAVING_VALUE',
    ErSomeoneElseName: 'ER_SOMEONE_ELSE_NAME',
    ExchangeReason: 'EXCHANGE_REASON',
    FullName: 'FULL_NAME',
    OrderNumber: 'ORDER_NUMBER',
    PartnerName: 'PARTNER_NAME',
    RepairComments: 'REPAIR_COMMENTS',
    ResizeValue: 'RESIZE_VALUE',
    ReturnReason: 'RETURN_REASON',
    TellUsSomethingElse: 'TELL_US_SOMETHING_ELSE',
} as const

export type QuestionnaireQuestionTextSystemCode =
    (typeof QuestionnaireQuestionTextSystemCode)[keyof typeof QuestionnaireQuestionTextSystemCode]
export type QuestionnaireSignUpStep = {
    __typename: 'QuestionnaireSignUpStep'
    backgroundColor: Color
    description: Maybe<Scalars['String']['output']>
    image: Image
    title: Scalars['String']['output']
}

export type QuestionnaireStep = {
    __typename: 'QuestionnaireStep'
    conditions: Array<QuestionnaireCondition>
    content: Array<QuestionnaireStepContent>
    description: Maybe<Scalars['String']['output']>
    excludeFromProgressIndicator: Maybe<Scalars['Boolean']['output']>
    help: Array<Block>
    title: Scalars['String']['output']
}

export type QuestionnaireStepContent =
    | QuestionnaireStepContentContent
    | QuestionnaireStepContentQuestions

export type QuestionnaireStepContentContent = {
    __typename: 'QuestionnaireStepContentContent'
    blocks: Array<Block>
    conditions: Array<QuestionnaireCondition>
}

export type QuestionnaireStepContentQuestions = {
    __typename: 'QuestionnaireStepContentQuestions'
    conditions: Array<QuestionnaireCondition>
    questions: Array<QuestionnaireQuestion>
}

export type QuestionnaireSubmissionNotification = {
    __typename: 'QuestionnaireSubmissionNotification'
    emails: Array<Scalars['String']['output']>
}

export type QuestionnaireSubmissionNotificationInput = {
    recipients: Array<Scalars['Email']['input']>
}

export const QuestionnaireType = {
    AftercareQuiz: 'AFTERCARE_QUIZ',
    DiamondQuiz: 'DIAMOND_QUIZ',
    GuidedJourney: 'GUIDED_JOURNEY',
    InspirationQuiz: 'INSPIRATION_QUIZ',
} as const

export type QuestionnaireType =
    (typeof QuestionnaireType)[keyof typeof QuestionnaireType]
export type Quotation = {
    baseTemplate: Maybe<Scalars['String']['output']>
    customName: Maybe<Scalars['String']['output']>
    finalUntil: Maybe<Scalars['DateTime']['output']>
    firstAvailableDeliveryDate: DeliveryDate
    id: Scalars['ID']['output']
    image: Maybe<Scalars['Uri']['output']>
    images: Array<Scalars['Uri']['output']>
    isRecommended: Scalars['Boolean']['output']
    isSalesTaxApplicable: Scalars['Boolean']['output']
    isVatApplicable: Scalars['Boolean']['output']
    totalSalePrice: Money
}

export type QuotationEngagementRing = Quotation & {
    __typename: 'QuotationEngagementRing'
    baseTemplate: Maybe<Scalars['String']['output']>
    centreStone: DesignStudioEngagementRingCentreStone
    customName: Maybe<Scalars['String']['output']>
    finalUntil: Maybe<Scalars['DateTime']['output']>
    firstAvailableDeliveryDate: DeliveryDate
    id: Scalars['ID']['output']
    image: Maybe<Scalars['Uri']['output']>
    images: Array<Scalars['Uri']['output']>
    isRecommended: Scalars['Boolean']['output']
    isSalesTaxApplicable: Scalars['Boolean']['output']
    isVatApplicable: Scalars['Boolean']['output']
    mount: DesignStudioEngagementRingMount
    totalSalePrice: Money
}

export type QuotationManualSurcharge = {
    __typename: 'QuotationManualSurcharge'
    amount: Money
    description: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
}

export type QuotationPercentageSurcharge = {
    __typename: 'QuotationPercentageSurcharge'
    description: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    percent: Scalars['Decimal']['output']
}

export type QuotationWeddingRing = Quotation & {
    __typename: 'QuotationWeddingRing'
    baseTemplate: Maybe<Scalars['String']['output']>
    comment: Maybe<Scalars['String']['output']>
    customName: Maybe<Scalars['String']['output']>
    finalUntil: Maybe<Scalars['DateTime']['output']>
    firstAvailableDeliveryDate: DeliveryDate
    id: Scalars['ID']['output']
    image: Maybe<Scalars['Uri']['output']>
    images: Array<Scalars['Uri']['output']>
    isRecommended: Scalars['Boolean']['output']
    isSalesTaxApplicable: Scalars['Boolean']['output']
    isVatApplicable: Scalars['Boolean']['output']
    manualSurcharges: Array<QuotationManualSurcharge>
    metals: Array<Metal>
    percentageSurcharge: Maybe<QuotationPercentageSurcharge>
    signatureStones: Array<DesignStudioSignatureStone>
    totalSalePrice: Money
}

export const QuoteSize = {
    Large: 'LARGE',
    Small: 'SMALL',
} as const

export type QuoteSize = (typeof QuoteSize)[keyof typeof QuoteSize]
export type RecommendedRingSize = {
    __typename: 'RecommendedRingSize'
    id: Scalars['ID']['output']
    label: Scalars['String']['output']
    ringSize: RingSize
}

export type RecommendedRingSizeLabelArgs = {
    locale: Scalars['Locale']['input']
    region: RegionCode
}

export type Region = {
    __typename: 'Region'
    code: RegionCode
    currency: Scalars['Currency']['output']
    isActive: Scalars['Boolean']['output']
    language: Language
    locales: Array<Scalars['Locale']['output']>
    representingCountry: Scalars['Country']['output']
}

export const RegionCode = {
    Au: 'AU',
    Ca: 'CA',
    Eu: 'EU',
    Ie: 'IE',
    Int: 'INT',
    Nz: 'NZ',
    Uk: 'UK',
    Us: 'US',
    Za: 'ZA',
} as const

export type RegionCode = (typeof RegionCode)[keyof typeof RegionCode]
export type Review = {
    __typename: 'Review'
    comment: Scalars['String']['output']
    date: Scalars['DateTime']['output']
    id: Scalars['ID']['output']
    name: Maybe<Scalars['String']['output']>
    picture: Maybe<Asset>
    products: Array<CatalogueProduct>
    rating: Scalars['Int']['output']
}

export type ReviewProductsArgs = {
    types: InputMaybe<Array<CatalogueProductType>>
}

export type ReviewCarouselCard = {
    __typename: 'ReviewCarouselCard'
    author: Maybe<Scalars['String']['output']>
    date: Scalars['String']['output']
    review: Scalars['String']['output']
    starsCount: Scalars['Int']['output']
}

export type ReviewFilter = {
    withProductsOfType?: InputMaybe<Array<CatalogueProductType>>
}

export type RingBuilder = {
    __typename: 'RingBuilder'
    failure: Maybe<DesignStudioEngagementRingFailure>
    financeOptionsAffirm: Maybe<AffirmFinanceOption>
    financeOptionsKlarna: Maybe<KlarnaFinanceOption>
    id: Scalars['ID']['output']
    image: Maybe<GenericImage>
    position1: Maybe<RingBuilderFragment>
    position2: Maybe<RingBuilderFragment>
    productId: Maybe<Scalars['String']['output']>
    salePrice: SalePrice
    stoneRecommendations: StoneRecommendationsResponse
    totalSalePrice: Money
}

export type RingBuilderFinanceOptionsAffirmArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type RingBuilderFinanceOptionsKlarnaArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type RingBuilderSalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type RingBuilderStoneRecommendationsArgs = {
    currency: CurrencyInput
    maxPrice: InputMaybe<MoneyInput>
    minPrice: InputMaybe<MoneyInput>
    region: RegionCode
}

export type RingBuilderTotalSalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type RingBuilderCentreStone =
    | GemsApiStone
    | NonSkuGemstone
    | NonSkuLabGrown

export type RingBuilderCentreStoneFragment = {
    __typename: 'RingBuilderCentreStoneFragment'
    id: Scalars['ID']['output']
    stone: Maybe<RingBuilderCentreStone>
    totalSalePrice: Money
}

export type RingBuilderCentreStoneFragmentTotalSalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type RingBuilderCentreStoneFragmentInput = {
    gemsApiIdentifier?: InputMaybe<Scalars['ID']['input']>
    nonSkuGemstone?: InputMaybe<NonSkuGemstoneFilterInput>
    nonSkuLabGrownDiamond?: InputMaybe<NonSkuLabGrownDiamondFilterInput>
}

export type RingBuilderFragment =
    | RingBuilderCentreStoneFragment
    | RingBuilderMountFragment

export type RingBuilderGetInput = {
    currency: CurrencyInput
    region: RegionCode
}

export type RingBuilderInput = {
    centreStone?: InputMaybe<RingBuilderCentreStoneFragmentInput>
    /** THIS WILL BECOME REQUIRED */
    getInput?: InputMaybe<RingBuilderGetInput>
    mount?: InputMaybe<RingBuilderMountFragmentInput>
}

export type RingBuilderMountFragment = {
    __typename: 'RingBuilderMountFragment'
    id: Scalars['ID']['output']
    ring: Maybe<CatalogueEngagementRing>
    signatureStone: Maybe<CatalogueEngagementRingSignatureStone>
    stoneRecommendations: StoneRecommendationsResponse
    totalSalePrice: Money
}

export type RingBuilderMountFragmentStoneRecommendationsArgs = {
    currency: CurrencyInput
    maxPrice: InputMaybe<MoneyInput>
    minPrice: InputMaybe<MoneyInput>
    region: RegionCode
}

export type RingBuilderMountFragmentTotalSalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type RingBuilderMountFragmentInput = {
    engagementRing?: InputMaybe<CatalogueEngagementRingFilterInput>
    signatureStone?: InputMaybe<CatalogueEngagementRingSignatureStoneInput>
}

export type RingBuilderProductFilterInput = {
    currency: CurrencyInput
    region: RegionCode
    type?: InputMaybe<RingBuilderProductType>
}

export const RingBuilderProductType = {
    NonSkuGemstone: 'NON_SKU_GEMSTONE',
    NonSkuLabGrownDiamond: 'NON_SKU_LAB_GROWN_DIAMOND',
} as const

export type RingBuilderProductType =
    (typeof RingBuilderProductType)[keyof typeof RingBuilderProductType]
export type RingBuilderResolveInput = {
    baseInput?: InputMaybe<EnquiryBaseInput>
    centreStoneUri: Scalars['Uri']['input']
    commissionJunction?: InputMaybe<CommissionJunctionInput>
    currency: CurrencyInput
    engraving?: InputMaybe<Scalars['String']['input']>
    /** THIS WILL BECOME REQUIRED */
    getInput?: InputMaybe<RingBuilderGetInput>
    mode: RingBuilderResolveMode
    region: RegionCode
    ringSize: RingSizeInput
    uri: Scalars['Uri']['input']
}

export const RingBuilderResolveMode = {
    AddToCart: 'ADD_TO_CART',
    Customize: 'CUSTOMIZE',
    Enquiry: 'ENQUIRY',
} as const

export type RingBuilderResolveMode =
    (typeof RingBuilderResolveMode)[keyof typeof RingBuilderResolveMode]
export type RingBuilderResolveResult =
    | CatalogueDesignStudioCheckoutEngagementRingAddedToDesignStudio
    | CatalogueDesignStudioCheckoutEngagementRingAddedToDesignStudioAndCart
    | DesignStudioEngagementRingFailure

export type RingBuilderResolvedExistingCustomer =
    | RingBuilderResolvedExistingCustomerSuccess
    | RingBuilderResolvedFailure

export type RingBuilderResolvedExistingCustomerSuccess = {
    __typename: 'RingBuilderResolvedExistingCustomerSuccess'
    data: RingBuilderResolveResult
    redirect: Maybe<Scalars['Uri']['output']>
    ringBuilder: RingBuilder
}

export type RingBuilderResolvedFailure = {
    __typename: 'RingBuilderResolvedFailure'
    errors: Array<RingBuilderResolvedFailureError>
    ringBuilder: RingBuilder
}

export const RingBuilderResolvedFailureError = {
    CentreStoneMissing: 'CENTRE_STONE_MISSING',
    MountMissing: 'MOUNT_MISSING',
} as const

export type RingBuilderResolvedFailureError =
    (typeof RingBuilderResolvedFailureError)[keyof typeof RingBuilderResolvedFailureError]
export type RingBuilderResolvedNewCustomer =
    | RingBuilderResolvedFailure
    | RingBuilderResolvedNewCustomerSuccess

export type RingBuilderResolvedNewCustomerSuccess = {
    __typename: 'RingBuilderResolvedNewCustomerSuccess'
    customer: CustomerRegistrationResponse
    data: RingBuilderResolveResult
    redirect: Maybe<Scalars['Uri']['output']>
    ringBuilder: RingBuilder
}

export const RingBuilderSetError = {
    CentreStoneNotFound: 'CENTRE_STONE_NOT_FOUND',
    EngagementRingNotFound: 'ENGAGEMENT_RING_NOT_FOUND',
    SignatureStoneNotFound: 'SIGNATURE_STONE_NOT_FOUND',
} as const

export type RingBuilderSetError =
    (typeof RingBuilderSetError)[keyof typeof RingBuilderSetError]
export type RingBuilderSetResult = {
    __typename: 'RingBuilderSetResult'
    errors: Array<RingBuilderSetError>
    ringBuilder: RingBuilder
}

export type RingSize = {
    __typename: 'RingSize'
    id: Scalars['ID']['output']
    label: Maybe<Scalars['String']['output']>
}

export type RingSizeLabelArgs = {
    region: RegionCode
}

export type RingSizeInput = {
    recommendedRingSizeId?: InputMaybe<Scalars['ID']['input']>
    ringSizeId?: InputMaybe<Scalars['ID']['input']>
}

export type RingSizeOrRecommendedRingSize = RecommendedRingSize | RingSize

export const Robots = {
    NoindexFollow: 'NOINDEX_FOLLOW',
} as const

export type Robots = (typeof Robots)[keyof typeof Robots]
export type SalePrice = {
    __typename: 'SalePrice'
    tax: Maybe<Tax>
    total: Money
}

export type SearchEverywhereResponse = {
    __typename: 'SearchEverywhereResponse'
    customers: Array<Customer>
    orders: Array<Order>
    products: Array<DesignStudioProductGeneric>
}

export type SetDeliveryInformationError = OrderAlreadyCompletedError

export type SetDeliveryInformationFailureResponse = {
    __typename: 'SetDeliveryInformationFailureResponse'
    errors: Array<SetDeliveryInformationError>
}

export type SetDeliveryInformationResponse =
    | SetDeliveryInformationFailureResponse
    | SetDeliveryInformationSuccessResponse

export type SetDeliveryInformationSuccessResponse = {
    __typename: 'SetDeliveryInformationSuccessResponse'
    order: Order
}

export type ShipmentTrackingInformation = {
    __typename: 'ShipmentTrackingInformation'
    /** not to be confused with the order's dispatched at date */
    dispatchedAt: Scalars['DateTime']['output']
    shippingCompany: Scalars['String']['output']
    trackingNumber: Scalars['String']['output']
    trackingUrl: Scalars['String']['output']
}

export type ShopWithConfidenceComponent = {
    content: Array<ContentComponentItem>
}

export type ShopWithConfidenceEthnicallySourcedDiamonds =
    ShopWithConfidenceComponent & {
        __typename: 'ShopWithConfidenceEthnicallySourcedDiamonds'
        content: Array<ContentComponentItem>
    }

export type ShopWithConfidenceFinancingOptions = ShopWithConfidenceComponent & {
    __typename: 'ShopWithConfidenceFinancingOptions'
    content: Array<ContentComponentItem>
}

export type ShopWithConfidenceGreenlandRuby = ShopWithConfidenceComponent & {
    __typename: 'ShopWithConfidenceGreenlandRuby'
    content: Array<ContentComponentItem>
}

export type ShopWithConfidenceHandFinished = ShopWithConfidenceComponent & {
    __typename: 'ShopWithConfidenceHandFinished'
    content: Array<ContentComponentItem>
}

export type ShopWithConfidenceResize = ShopWithConfidenceComponent & {
    __typename: 'ShopWithConfidenceResize'
    content: Array<ContentComponentItem>
}

export type ShopWithConfidenceReturnPolicy = ShopWithConfidenceComponent & {
    __typename: 'ShopWithConfidenceReturnPolicy'
    content: Array<ContentComponentItem>
}

export type ShopWithConfidenceShipping = ShopWithConfidenceComponent & {
    __typename: 'ShopWithConfidenceShipping'
    content: Array<ContentComponentItem>
}

export type Showroom = {
    __typename: 'Showroom'
    id: Scalars['ID']['output']
    isAccessible: Scalars['Boolean']['output']
    location: ShowroomLocation
    timezone: Scalars['String']['output']
    translation: ShowroomTranslation
}

export type ShowroomTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export type ShowroomLocation = {
    __typename: 'ShowroomLocation'
    addressLine1: Scalars['String']['output']
    addressLine2: Maybe<Scalars['String']['output']>
    city: Scalars['String']['output']
    country: Scalars['Country']['output']
    geoLocation: Maybe<GeoPoint>
    id: Scalars['ID']['output']
    postalCode: Maybe<Scalars['String']['output']>
    subdivision: Maybe<Scalars['CountrySubdivision']['output']>
}

export type ShowroomTranslation = {
    __typename: 'ShowroomTranslation'
    name: Scalars['String']['output']
}

export const SlidePadding = {
    Large: 'LARGE',
    Medium: 'MEDIUM',
    None: 'NONE',
    Small: 'SMALL',
} as const

export type SlidePadding = (typeof SlidePadding)[keyof typeof SlidePadding]
export type SocialNetwork = {
    __typename: 'SocialNetwork'
    icon: Icon
    link: Scalars['String']['output']
    name: Scalars['String']['output']
}

export const Spacing = {
    ExtraLarge: 'EXTRA_LARGE',
    Large: 'LARGE',
    Medium: 'MEDIUM',
    Small: 'SMALL',
} as const

export type Spacing = (typeof Spacing)[keyof typeof Spacing]
export type SquareBoxes = SquareImageBox | SquareTextBox

export type SquareImageBox = {
    __typename: 'SquareImageBox'
    image: Image
    link: Maybe<Link>
}

export type SquareTextBox = {
    __typename: 'SquareTextBox'
    backgroundColor: Color
    content: Array<ContentComponentItem>
}

export type Stone = {
    __typename: 'Stone'
    caratWeight: Scalars['Decimal']['output']
    certificate: Maybe<StoneCertificate>
    clarity: Maybe<StoneClarity>
    color: Maybe<StoneColor>
    colorGrade: Maybe<StoneGrade>
    crystal: Maybe<StoneCrystal>
    cut: Maybe<StoneCut>
    depthPercent: Scalars['Decimal']['output']
    fluorescence: Maybe<StoneFluorescence>
    id: Scalars['ID']['output']
    measurements: StoneMeasurements
    photo: Maybe<Scalars['Uri']['output']>
    polish: Maybe<StonePolish>
    ratio: Maybe<Scalars['Decimal']['output']>
    shape: Maybe<StoneShape>
    symmetry: Maybe<StoneSymmetry>
    tablePercent: Scalars['Decimal']['output']
}

export type StoneCategory = {
    __typename: 'StoneCategory'
    systemCode: StoneCategoryCode
    translation: StoneCategoryTranslation
}

export type StoneCategoryTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const StoneCategoryCode = {
    Diamond: 'DIAMOND',
    FancyDiamond: 'FANCY_DIAMOND',
    Gemstone: 'GEMSTONE',
    LabGrownDiamond: 'LAB_GROWN_DIAMOND',
} as const

export type StoneCategoryCode =
    (typeof StoneCategoryCode)[keyof typeof StoneCategoryCode]
export type StoneCategoryTranslation = {
    __typename: 'StoneCategoryTranslation'
    name: Scalars['String']['output']
}

export type StoneCertificate = {
    __typename: 'StoneCertificate'
    number: Scalars['String']['output']
    uri: Scalars['Uri']['output']
}

export type StoneClarity = {
    __typename: 'StoneClarity'
    abbreviation: Scalars['String']['output']
    systemCode: StoneClarityCode
    translation: StoneClarityTranslation
}

export type StoneClarityTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const StoneClarityCode = {
    DiamondFl: 'DIAMOND_FL',
    DiamondIf: 'DIAMOND_IF',
    DiamondSi1: 'DIAMOND_SI1',
    DiamondSi2: 'DIAMOND_SI2',
    DiamondVs1: 'DIAMOND_VS1',
    DiamondVs2: 'DIAMOND_VS2',
    DiamondVvs1: 'DIAMOND_VVS1',
    DiamondVvs2: 'DIAMOND_VVS2',
    GemstoneEyeClean: 'GEMSTONE_EYE_CLEAN',
    GemstoneIncluded: 'GEMSTONE_INCLUDED',
    GemstoneLoupeClean: 'GEMSTONE_LOUPE_CLEAN',
    GemstoneSlightlyIncluded: 'GEMSTONE_SLIGHTLY_INCLUDED',
} as const

export type StoneClarityCode =
    (typeof StoneClarityCode)[keyof typeof StoneClarityCode]
export type StoneClarityFilterInput = {
    category?: InputMaybe<StoneCategoryCode>
}

export type StoneClarityTranslation = {
    __typename: 'StoneClarityTranslation'
    name: Scalars['String']['output']
}

export type StoneColor = {
    __typename: 'StoneColor'
    systemCode: StoneColorCode
    translation: StoneColorTranslation
}

export type StoneColorTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const StoneColorCode = {
    DiamondD: 'DIAMOND_D',
    DiamondE: 'DIAMOND_E',
    DiamondF: 'DIAMOND_F',
    DiamondG: 'DIAMOND_G',
    DiamondH: 'DIAMOND_H',
    DiamondI: 'DIAMOND_I',
    DiamondJ: 'DIAMOND_J',
    DiamondK: 'DIAMOND_K',
    DiamondL: 'DIAMOND_L',
    DiamondM: 'DIAMOND_M',
    FancyDiamondAchrioteColourless: 'FANCY_DIAMOND_ACHRIOTE_COLOURLESS',
    FancyDiamondBlack: 'FANCY_DIAMOND_BLACK',
    FancyDiamondBlue: 'FANCY_DIAMOND_BLUE',
    FancyDiamondBlueGray: 'FANCY_DIAMOND_BLUE_GRAY',
    FancyDiamondBlueGreen: 'FANCY_DIAMOND_BLUE_GREEN',
    FancyDiamondBlueViolet: 'FANCY_DIAMOND_BLUE_VIOLET',
    FancyDiamondBluishGray: 'FANCY_DIAMOND_BLUISH_GRAY',
    FancyDiamondBluishGreen: 'FANCY_DIAMOND_BLUISH_GREEN',
    FancyDiamondBluishViolet: 'FANCY_DIAMOND_BLUISH_VIOLET',
    FancyDiamondBrown: 'FANCY_DIAMOND_BROWN',
    FancyDiamondBrownishGreen: 'FANCY_DIAMOND_BROWNISH_GREEN',
    FancyDiamondBrownishOrange: 'FANCY_DIAMOND_BROWNISH_ORANGE',
    FancyDiamondBrownishPink: 'FANCY_DIAMOND_BROWNISH_PINK',
    FancyDiamondBrownishPurple: 'FANCY_DIAMOND_BROWNISH_PURPLE',
    FancyDiamondBrownishRed: 'FANCY_DIAMOND_BROWNISH_RED',
    FancyDiamondBrownishYellow: 'FANCY_DIAMOND_BROWNISH_YELLOW',
    FancyDiamondBrownGreen: 'FANCY_DIAMOND_BROWN_GREEN',
    FancyDiamondBrownOrange: 'FANCY_DIAMOND_BROWN_ORANGE',
    FancyDiamondBrownPink: 'FANCY_DIAMOND_BROWN_PINK',
    FancyDiamondBrownPurple: 'FANCY_DIAMOND_BROWN_PURPLE',
    FancyDiamondBrownRed: 'FANCY_DIAMOND_BROWN_RED',
    FancyDiamondBrownYellow: 'FANCY_DIAMOND_BROWN_YELLOW',
    FancyDiamondCanaryYellow: 'FANCY_DIAMOND_CANARY_YELLOW',
    FancyDiamondCatsEye: 'FANCY_DIAMOND_CATS_EYE',
    FancyDiamondChameleon: 'FANCY_DIAMOND_CHAMELEON',
    FancyDiamondChampagne: 'FANCY_DIAMOND_CHAMPAGNE',
    FancyDiamondChocolate: 'FANCY_DIAMOND_CHOCOLATE',
    FancyDiamondChromeDeepGreen: 'FANCY_DIAMOND_CHROME_DEEP_GREEN',
    FancyDiamondCognac: 'FANCY_DIAMOND_COGNAC',
    FancyDiamondColorChange: 'FANCY_DIAMOND_COLOR_CHANGE',
    FancyDiamondDraviteBrown: 'FANCY_DIAMOND_DRAVITE_BROWN',
    FancyDiamondElbaite: 'FANCY_DIAMOND_ELBAITE',
    FancyDiamondGray: 'FANCY_DIAMOND_GRAY',
    FancyDiamondGrayishBlue: 'FANCY_DIAMOND_GRAYISH_BLUE',
    FancyDiamondGrayishGreen: 'FANCY_DIAMOND_GRAYISH_GREEN',
    FancyDiamondGrayishPurple: 'FANCY_DIAMOND_GRAYISH_PURPLE',
    FancyDiamondGrayishViolet: 'FANCY_DIAMOND_GRAYISH_VIOLET',
    FancyDiamondGrayBlue: 'FANCY_DIAMOND_GRAY_BLUE',
    FancyDiamondGrayGreen: 'FANCY_DIAMOND_GRAY_GREEN',
    FancyDiamondGrayPurple: 'FANCY_DIAMOND_GRAY_PURPLE',
    FancyDiamondGrayViolet: 'FANCY_DIAMOND_GRAY_VIOLET',
    FancyDiamondGreen: 'FANCY_DIAMOND_GREEN',
    FancyDiamondGreenishBlue: 'FANCY_DIAMOND_GREENISH_BLUE',
    FancyDiamondGreenishBrown: 'FANCY_DIAMOND_GREENISH_BROWN',
    FancyDiamondGreenishGray: 'FANCY_DIAMOND_GREENISH_GRAY',
    FancyDiamondGreenishYellow: 'FANCY_DIAMOND_GREENISH_YELLOW',
    FancyDiamondGreenBlue: 'FANCY_DIAMOND_GREEN_BLUE',
    FancyDiamondGreenBrown: 'FANCY_DIAMOND_GREEN_BROWN',
    FancyDiamondGreenGray: 'FANCY_DIAMOND_GREEN_GRAY',
    FancyDiamondGreenYellow: 'FANCY_DIAMOND_GREEN_YELLOW',
    FancyDiamondOrange: 'FANCY_DIAMOND_ORANGE',
    FancyDiamondOrangeBrown: 'FANCY_DIAMOND_ORANGE_BROWN',
    FancyDiamondOrangePink: 'FANCY_DIAMOND_ORANGE_PINK',
    FancyDiamondOrangeRed: 'FANCY_DIAMOND_ORANGE_RED',
    FancyDiamondOrangeYellow: 'FANCY_DIAMOND_ORANGE_YELLOW',
    FancyDiamondOrangishBrown: 'FANCY_DIAMOND_ORANGISH_BROWN',
    FancyDiamondOrangishPink: 'FANCY_DIAMOND_ORANGISH_PINK',
    FancyDiamondOrangishRed: 'FANCY_DIAMOND_ORANGISH_RED',
    FancyDiamondOrangishYellow: 'FANCY_DIAMOND_ORANGISH_YELLOW',
    FancyDiamondOrangyBrown: 'FANCY_DIAMOND_ORANGY_BROWN',
    FancyDiamondOrangyPink: 'FANCY_DIAMOND_ORANGY_PINK',
    FancyDiamondOrangyRed: 'FANCY_DIAMOND_ORANGY_RED',
    FancyDiamondOrangyYellow: 'FANCY_DIAMOND_ORANGY_YELLOW',
    FancyDiamondPadparadscha: 'FANCY_DIAMOND_PADPARADSCHA',
    FancyDiamondParaiba: 'FANCY_DIAMOND_PARAIBA',
    FancyDiamondPeach: 'FANCY_DIAMOND_PEACH',
    FancyDiamondPink: 'FANCY_DIAMOND_PINK',
    FancyDiamondPinkishBrown: 'FANCY_DIAMOND_PINKISH_BROWN',
    FancyDiamondPinkishOrange: 'FANCY_DIAMOND_PINKISH_ORANGE',
    FancyDiamondPinkishPurple: 'FANCY_DIAMOND_PINKISH_PURPLE',
    FancyDiamondPinkishRed: 'FANCY_DIAMOND_PINKISH_RED',
    FancyDiamondPinkBrown: 'FANCY_DIAMOND_PINK_BROWN',
    FancyDiamondPinkOrange: 'FANCY_DIAMOND_PINK_ORANGE',
    FancyDiamondPinkPurple: 'FANCY_DIAMOND_PINK_PURPLE',
    FancyDiamondPurple: 'FANCY_DIAMOND_PURPLE',
    FancyDiamondPurpleGray: 'FANCY_DIAMOND_PURPLE_GRAY',
    FancyDiamondPurplePink: 'FANCY_DIAMOND_PURPLE_PINK',
    FancyDiamondPurpleRed: 'FANCY_DIAMOND_PURPLE_RED',
    FancyDiamondPurplishGray: 'FANCY_DIAMOND_PURPLISH_GRAY',
    FancyDiamondPurplishPink: 'FANCY_DIAMOND_PURPLISH_PINK',
    FancyDiamondPurplishRed: 'FANCY_DIAMOND_PURPLISH_RED',
    FancyDiamondRed: 'FANCY_DIAMOND_RED',
    FancyDiamondReddishBrown: 'FANCY_DIAMOND_REDDISH_BROWN',
    FancyDiamondReddishOrange: 'FANCY_DIAMOND_REDDISH_ORANGE',
    FancyDiamondReddishPurple: 'FANCY_DIAMOND_REDDISH_PURPLE',
    FancyDiamondRedBrown: 'FANCY_DIAMOND_RED_BROWN',
    FancyDiamondRedOrange: 'FANCY_DIAMOND_RED_ORANGE',
    FancyDiamondRedPurple: 'FANCY_DIAMOND_RED_PURPLE',
    FancyDiamondRubellite: 'FANCY_DIAMOND_RUBELLITE',
    FancyDiamondSchorlBlack: 'FANCY_DIAMOND_SCHORL_BLACK',
    FancyDiamondSiberitePurple: 'FANCY_DIAMOND_SIBERITE_PURPLE',
    FancyDiamondTeal: 'FANCY_DIAMOND_TEAL',
    FancyDiamondTurquoise: 'FANCY_DIAMOND_TURQUOISE',
    FancyDiamondVerdelitePurple: 'FANCY_DIAMOND_VERDELITE_PURPLE',
    FancyDiamondViolet: 'FANCY_DIAMOND_VIOLET',
    FancyDiamondVioletishBlue: 'FANCY_DIAMOND_VIOLETISH_BLUE',
    FancyDiamondVioletishGray: 'FANCY_DIAMOND_VIOLETISH_GRAY',
    FancyDiamondVioletBlue: 'FANCY_DIAMOND_VIOLET_BLUE',
    FancyDiamondVioletGray: 'FANCY_DIAMOND_VIOLET_GRAY',
    FancyDiamondWatermelon: 'FANCY_DIAMOND_WATERMELON',
    FancyDiamondWhite: 'FANCY_DIAMOND_WHITE',
    FancyDiamondYellow: 'FANCY_DIAMOND_YELLOW',
    FancyDiamondYellowishBrown: 'FANCY_DIAMOND_YELLOWISH_BROWN',
    FancyDiamondYellowishGray: 'FANCY_DIAMOND_YELLOWISH_GRAY',
    FancyDiamondYellowishGreen: 'FANCY_DIAMOND_YELLOWISH_GREEN',
    FancyDiamondYellowishOrange: 'FANCY_DIAMOND_YELLOWISH_ORANGE',
    FancyDiamondYellowBrown: 'FANCY_DIAMOND_YELLOW_BROWN',
    FancyDiamondYellowGray: 'FANCY_DIAMOND_YELLOW_GRAY',
    FancyDiamondYellowGreen: 'FANCY_DIAMOND_YELLOW_GREEN',
    FancyDiamondYellowOrange: 'FANCY_DIAMOND_YELLOW_ORANGE',
    GemstoneAchroiteColourless: 'GEMSTONE_ACHROITE_COLOURLESS',
    GemstoneBiColour: 'GEMSTONE_BI_COLOUR',
    GemstoneBlack: 'GEMSTONE_BLACK',
    GemstoneBlue: 'GEMSTONE_BLUE',
    GemstoneBlueGray: 'GEMSTONE_BLUE_GRAY',
    GemstoneBlueGreen: 'GEMSTONE_BLUE_GREEN',
    GemstoneBlueViolet: 'GEMSTONE_BLUE_VIOLET',
    GemstoneBluishGray: 'GEMSTONE_BLUISH_GRAY',
    GemstoneBluishGreen: 'GEMSTONE_BLUISH_GREEN',
    GemstoneBluishViolet: 'GEMSTONE_BLUISH_VIOLET',
    GemstoneBrown: 'GEMSTONE_BROWN',
    GemstoneBrownishGreen: 'GEMSTONE_BROWNISH_GREEN',
    GemstoneBrownishOrange: 'GEMSTONE_BROWNISH_ORANGE',
    GemstoneBrownishPink: 'GEMSTONE_BROWNISH_PINK',
    GemstoneBrownishPurple: 'GEMSTONE_BROWNISH_PURPLE',
    GemstoneBrownishRed: 'GEMSTONE_BROWNISH_RED',
    GemstoneBrownishYellow: 'GEMSTONE_BROWNISH_YELLOW',
    GemstoneBrownGreen: 'GEMSTONE_BROWN_GREEN',
    GemstoneBrownOrange: 'GEMSTONE_BROWN_ORANGE',
    GemstoneBrownPink: 'GEMSTONE_BROWN_PINK',
    GemstoneBrownPurple: 'GEMSTONE_BROWN_PURPLE',
    GemstoneBrownRed: 'GEMSTONE_BROWN_RED',
    GemstoneBrownYellow: 'GEMSTONE_BROWN_YELLOW',
    GemstoneCanaryYellow: 'GEMSTONE_CANARY_YELLOW',
    GemstoneCatsEye: 'GEMSTONE_CATS_EYE',
    GemstoneChameleon: 'GEMSTONE_CHAMELEON',
    GemstoneChampagne: 'GEMSTONE_CHAMPAGNE',
    GemstoneChocolate: 'GEMSTONE_CHOCOLATE',
    GemstoneChromeDeepGreen: 'GEMSTONE_CHROME_DEEP_GREEN',
    GemstoneCognac: 'GEMSTONE_COGNAC',
    GemstoneColorChange: 'GEMSTONE_COLOR_CHANGE',
    GemstoneDraviteBrown: 'GEMSTONE_DRAVITE_BROWN',
    GemstoneElbaite: 'GEMSTONE_ELBAITE',
    GemstoneGray: 'GEMSTONE_GRAY',
    GemstoneGrayishGreen: 'GEMSTONE_GRAYISH_GREEN',
    GemstoneGrayishPurple: 'GEMSTONE_GRAYISH_PURPLE',
    GemstoneGrayishViolet: 'GEMSTONE_GRAYISH_VIOLET',
    GemstoneGrayBlue: 'GEMSTONE_GRAY_BLUE',
    GemstoneGrayGreen: 'GEMSTONE_GRAY_GREEN',
    GemstoneGrayGreenishYellow: 'GEMSTONE_GRAY_GREENISH_YELLOW',
    GemstoneGrayPurple: 'GEMSTONE_GRAY_PURPLE',
    GemstoneGrayViolet: 'GEMSTONE_GRAY_VIOLET',
    GemstoneGrayYellowishGreen: 'GEMSTONE_GRAY_YELLOWISH_GREEN',
    GemstoneGreen: 'GEMSTONE_GREEN',
    GemstoneGreenishBlue: 'GEMSTONE_GREENISH_BLUE',
    GemstoneGreenishBrown: 'GEMSTONE_GREENISH_BROWN',
    GemstoneGreenishGray: 'GEMSTONE_GREENISH_GRAY',
    GemstoneGreenishYellow: 'GEMSTONE_GREENISH_YELLOW',
    GemstoneGreenBlue: 'GEMSTONE_GREEN_BLUE',
    GemstoneGreenBrown: 'GEMSTONE_GREEN_BROWN',
    GemstoneGreenGray: 'GEMSTONE_GREEN_GRAY',
    GemstoneGreenYellow: 'GEMSTONE_GREEN_YELLOW',
    GemstoneOrange: 'GEMSTONE_ORANGE',
    GemstoneOrangeBrown: 'GEMSTONE_ORANGE_BROWN',
    GemstoneOrangePink: 'GEMSTONE_ORANGE_PINK',
    GemstoneOrangeRed: 'GEMSTONE_ORANGE_RED',
    GemstoneOrangeYellow: 'GEMSTONE_ORANGE_YELLOW',
    GemstoneOrangyBrown: 'GEMSTONE_ORANGY_BROWN',
    GemstoneOrangyPink: 'GEMSTONE_ORANGY_PINK',
    GemstoneOrangyRed: 'GEMSTONE_ORANGY_RED',
    GemstoneOrangyYellow: 'GEMSTONE_ORANGY_YELLOW',
    GemstonePadparadscha: 'GEMSTONE_PADPARADSCHA',
    GemstoneParaiba: 'GEMSTONE_PARAIBA',
    GemstonePeach: 'GEMSTONE_PEACH',
    GemstonePink: 'GEMSTONE_PINK',
    GemstonePinkishBrown: 'GEMSTONE_PINKISH_BROWN',
    GemstonePinkishPurple: 'GEMSTONE_PINKISH_PURPLE',
    GemstonePinkishRed: 'GEMSTONE_PINKISH_RED',
    GemstonePinkBrown: 'GEMSTONE_PINK_BROWN',
    GemstonePinkPurple: 'GEMSTONE_PINK_PURPLE',
    GemstonePurple: 'GEMSTONE_PURPLE',
    GemstonePurpleGray: 'GEMSTONE_PURPLE_GRAY',
    GemstonePurplePink: 'GEMSTONE_PURPLE_PINK',
    GemstonePurpleRed: 'GEMSTONE_PURPLE_RED',
    GemstonePurplishGray: 'GEMSTONE_PURPLISH_GRAY',
    GemstonePurplishPink: 'GEMSTONE_PURPLISH_PINK',
    GemstonePurplishRed: 'GEMSTONE_PURPLISH_RED',
    GemstoneRed: 'GEMSTONE_RED',
    GemstoneReddishBrown: 'GEMSTONE_REDDISH_BROWN',
    GemstoneReddishOrange: 'GEMSTONE_REDDISH_ORANGE',
    GemstoneReddishPurple: 'GEMSTONE_REDDISH_PURPLE',
    GemstoneRedBrown: 'GEMSTONE_RED_BROWN',
    GemstoneRedOrange: 'GEMSTONE_RED_ORANGE',
    GemstoneRedPurple: 'GEMSTONE_RED_PURPLE',
    GemstoneRubellite: 'GEMSTONE_RUBELLITE',
    GemstoneSchorlBlack: 'GEMSTONE_SCHORL_BLACK',
    GemstoneSiberitePurple: 'GEMSTONE_SIBERITE_PURPLE',
    GemstoneTeal: 'GEMSTONE_TEAL',
    GemstoneTurquoise: 'GEMSTONE_TURQUOISE',
    GemstoneVerdelitePurple: 'GEMSTONE_VERDELITE_PURPLE',
    GemstoneViolet: 'GEMSTONE_VIOLET',
    GemstoneVioletishBlue: 'GEMSTONE_VIOLETISH_BLUE',
    GemstoneVioletishGray: 'GEMSTONE_VIOLETISH_GRAY',
    GemstoneVioletishPurple: 'GEMSTONE_VIOLETISH_PURPLE',
    GemstoneVioletBlue: 'GEMSTONE_VIOLET_BLUE',
    GemstoneVioletGray: 'GEMSTONE_VIOLET_GRAY',
    GemstoneWatermelon: 'GEMSTONE_WATERMELON',
    GemstoneWhite: 'GEMSTONE_WHITE',
    GemstoneYellow: 'GEMSTONE_YELLOW',
    GemstoneYellowishBrown: 'GEMSTONE_YELLOWISH_BROWN',
    GemstoneYellowishGray: 'GEMSTONE_YELLOWISH_GRAY',
    GemstoneYellowishGreen: 'GEMSTONE_YELLOWISH_GREEN',
    GemstoneYellowishOrange: 'GEMSTONE_YELLOWISH_ORANGE',
    GemstoneYellowBrown: 'GEMSTONE_YELLOW_BROWN',
    GemstoneYellowGray: 'GEMSTONE_YELLOW_GRAY',
    GemstoneYellowGreen: 'GEMSTONE_YELLOW_GREEN',
    GemstoneYellowOrange: 'GEMSTONE_YELLOW_ORANGE',
} as const

export type StoneColorCode =
    (typeof StoneColorCode)[keyof typeof StoneColorCode]
export type StoneColorTranslation = {
    __typename: 'StoneColorTranslation'
    name: Scalars['String']['output']
}

export type StoneColorsFilterInput = {
    category?: InputMaybe<StoneCategoryCode>
}

export type StoneCrystal = {
    __typename: 'StoneCrystal'
    systemCode: StoneCrystalCode
    translation: StoneCrystalTranslation
}

export type StoneCrystalTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const StoneCrystalCode = {
    Alexandrite: 'ALEXANDRITE',
    Amethyst: 'AMETHYST',
    Aquamarine: 'AQUAMARINE',
    Citrine: 'CITRINE',
    Diamond: 'DIAMOND',
    Emerald: 'EMERALD',
    FancyDiamond: 'FANCY_DIAMOND',
    Garnet: 'GARNET',
    LabGrownDiamond: 'LAB_GROWN_DIAMOND',
    Morganite: 'MORGANITE',
    Peridot: 'PERIDOT',
    Ruby: 'RUBY',
    Sapphire: 'SAPPHIRE',
    Spinel: 'SPINEL',
    Tanzanite: 'TANZANITE',
    Topaz: 'TOPAZ',
    Tourmaline: 'TOURMALINE',
    Tsavorite: 'TSAVORITE',
    Zircon: 'ZIRCON',
} as const

export type StoneCrystalCode =
    (typeof StoneCrystalCode)[keyof typeof StoneCrystalCode]
export type StoneCrystalTranslation = {
    __typename: 'StoneCrystalTranslation'
    name: Scalars['String']['output']
}

export type StoneCrystalsFilterInput = {
    category?: InputMaybe<StoneCategoryCode>
}

export type StoneCut = {
    __typename: 'StoneCut'
    abbreviation: Scalars['String']['output']
    systemCode: StoneCutCode
    translation: StoneCutTranslation
}

export type StoneCutTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const StoneCutCode = {
    Excellent: 'EXCELLENT',
    Good: 'GOOD',
    Ideal: 'IDEAL',
    VeryGood: 'VERY_GOOD',
} as const

export type StoneCutCode = (typeof StoneCutCode)[keyof typeof StoneCutCode]
export type StoneCutTranslation = {
    __typename: 'StoneCutTranslation'
    name: Scalars['String']['output']
}

export type StoneFluorescence = {
    __typename: 'StoneFluorescence'
    abbreviation: Scalars['String']['output']
    systemCode: StoneFluorescenceCode
    translation: StoneFluorescenceTranslation
}

export type StoneFluorescenceTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const StoneFluorescenceCode = {
    Faint: 'FAINT',
    Medium: 'MEDIUM',
    None: 'NONE',
    Strong: 'STRONG',
    VeryStrong: 'VERY_STRONG',
} as const

export type StoneFluorescenceCode =
    (typeof StoneFluorescenceCode)[keyof typeof StoneFluorescenceCode]
export type StoneFluorescenceTranslation = {
    __typename: 'StoneFluorescenceTranslation'
    name: Scalars['String']['output']
}

export type StoneGrade = {
    __typename: 'StoneGrade'
    category: StoneCategory
    systemCode: StoneGradeCode
    translation: StoneGradeTranslation
}

export type StoneGradeTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const StoneGradeCode = {
    FancyDiamondFaint: 'FANCY_DIAMOND_FAINT',
    FancyDiamondFancy: 'FANCY_DIAMOND_FANCY',
    FancyDiamondFancyDark: 'FANCY_DIAMOND_FANCY_DARK',
    FancyDiamondFancyDeep: 'FANCY_DIAMOND_FANCY_DEEP',
    FancyDiamondFancyIntense: 'FANCY_DIAMOND_FANCY_INTENSE',
    FancyDiamondFancyLight: 'FANCY_DIAMOND_FANCY_LIGHT',
    FancyDiamondFancyVivid: 'FANCY_DIAMOND_FANCY_VIVID',
    FancyDiamondLight: 'FANCY_DIAMOND_LIGHT',
    FancyDiamondVeryLight: 'FANCY_DIAMOND_VERY_LIGHT',
    GemstoneDark: 'GEMSTONE_DARK',
    GemstoneHot: 'GEMSTONE_HOT',
    GemstoneLight: 'GEMSTONE_LIGHT',
    GemstoneMedium: 'GEMSTONE_MEDIUM',
    GemstoneMediumDark: 'GEMSTONE_MEDIUM_DARK',
    GemstoneMediumLight: 'GEMSTONE_MEDIUM_LIGHT',
    GemstoneVeryDark: 'GEMSTONE_VERY_DARK',
    GemstoneVeryLight: 'GEMSTONE_VERY_LIGHT',
} as const

export type StoneGradeCode =
    (typeof StoneGradeCode)[keyof typeof StoneGradeCode]
export type StoneGradeTranslation = {
    __typename: 'StoneGradeTranslation'
    name: Scalars['String']['output']
}

export type StoneGradesFilterInput = {
    category?: InputMaybe<StoneCategoryCode>
}

export type StoneMeasurements = {
    __typename: 'StoneMeasurements'
    depth: Scalars['Decimal']['output']
    length: Scalars['Decimal']['output']
    width: Scalars['Decimal']['output']
}

export type StonePolish = {
    __typename: 'StonePolish'
    abbreviation: Scalars['String']['output']
    systemCode: StonePolishCode
    translation: StonePolishTranslation
}

export type StonePolishTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const StonePolishCode = {
    Excellent: 'EXCELLENT',
    Fair: 'FAIR',
    Good: 'GOOD',
    Ideal: 'IDEAL',
    VeryGood: 'VERY_GOOD',
} as const

export type StonePolishCode =
    (typeof StonePolishCode)[keyof typeof StonePolishCode]
export type StonePolishTranslation = {
    __typename: 'StonePolishTranslation'
    name: Scalars['String']['output']
}

export type StoneRecommendationGemsApiStone =
    | GemsApi_Stone
    | StoneRecommendationNotFound

export type StoneRecommendationNonSkuGemstone = {
    __typename: 'StoneRecommendationNonSkuGemstone'
    color: StoneColor
    item: StoneRecommendationNonSkuGemstoneItem
}

export type StoneRecommendationNonSkuGemstoneItem =
    | NonSkuGemstone
    | StoneRecommendationNotFound

export type StoneRecommendationNonSkuLabGrownItem =
    | NonSkuLabGrown
    | StoneRecommendationNotFound

export type StoneRecommendationNotFound = {
    __typename: 'StoneRecommendationNotFound'
    haveWithoutPricingRange: Scalars['Boolean']['output']
}

export type StoneRecommendationsNaturalDiamondFilters = {
    __typename: 'StoneRecommendationsNaturalDiamondFilters'
    clarities: Array<StoneClarity>
    colors: Array<StoneColor>
    cuts: Array<StoneCut>
    depthPercentRange: Maybe<StoneRecommendationsPercentRange>
    fluorescences: Array<StoneFluorescence>
    maxCaratWeight: Scalars['Decimal']['output']
    minCaratWeight: Scalars['Decimal']['output']
    polishes: Array<StonePolish>
    priceMax: Money
    priceMin: Money
    region: Region
    shape: StoneShape
    symmetries: Array<StoneSymmetry>
    tablePercentRange: Maybe<StoneRecommendationsPercentRange>
}

export type StoneRecommendationsNaturalDiamondFiltersPriceMaxArgs = {
    currency: CurrencyInput
}

export type StoneRecommendationsNaturalDiamondFiltersPriceMinArgs = {
    currency: CurrencyInput
}

export type StoneRecommendationsPercentRange = {
    __typename: 'StoneRecommendationsPercentRange'
    max: Scalars['Int']['output']
    min: Scalars['Int']['output']
}

export type StoneRecommendationsPriceRange = {
    __typename: 'StoneRecommendationsPriceRange'
    max: Money
    min: Money
}

export type StoneRecommendationsResponse =
    | StoneRecommendationsResponseFailure
    | StoneRecommendationsResponseSuccess

export const StoneRecommendationsResponseError = {
    MountMissing: 'MOUNT_MISSING',
} as const

export type StoneRecommendationsResponseError =
    (typeof StoneRecommendationsResponseError)[keyof typeof StoneRecommendationsResponseError]
export type StoneRecommendationsResponseFailure = {
    __typename: 'StoneRecommendationsResponseFailure'
    error: Maybe<StoneRecommendationsResponseError>
}

export type StoneRecommendationsResponseSuccess = {
    __typename: 'StoneRecommendationsResponseSuccess'
    naturalDiamondBestForBalance: StoneRecommendationGemsApiStone
    naturalDiamondBestForBalanceFilters: StoneRecommendationsNaturalDiamondFilters
    naturalDiamondBestForSize: StoneRecommendationGemsApiStone
    naturalDiamondBestForSizeFilters: StoneRecommendationsNaturalDiamondFilters
    nonSkuGemStones: Array<StoneRecommendationNonSkuGemstone>
    nonSkuLabGrownBestForPrice: StoneRecommendationNonSkuLabGrownItem
    nonSkuLabGrownBestForSize: StoneRecommendationNonSkuLabGrownItem
    priceBounds: StoneRecommendationsPriceRange
    priceInitialValues: StoneRecommendationsPriceRange
}

export type StoneRecommendationsResponseSuccessNonSkuGemStonesArgs = {
    colorCodes: InputMaybe<Array<StoneColorCode>>
}

export type StoneShape = {
    __typename: 'StoneShape'
    icon: Maybe<Asset>
    samplePhoto: Maybe<Asset>
    systemCode: StoneShapeCode
    translation: StoneShapeTranslation
}

export type StoneShapeTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const StoneShapeCode = {
    Asscher: 'ASSCHER',
    BrilliantCutTrapezoid: 'BRILLIANT_CUT_TRAPEZOID',
    Bullet: 'BULLET',
    Cabochon: 'CABOCHON',
    Carre: 'CARRE',
    Circular: 'CIRCULAR',
    Cushion: 'CUSHION',
    Custom: 'CUSTOM',
    Emerald: 'EMERALD',
    European: 'EUROPEAN',
    HalfMoon: 'HALF_MOON',
    Heart: 'HEART',
    Hexagonal: 'HEXAGONAL',
    Kite: 'KITE',
    Marquise: 'MARQUISE',
    Octagonal: 'OCTAGONAL',
    OldMiners: 'OLD_MINERS',
    Oval: 'OVAL',
    Pear: 'PEAR',
    Princess: 'PRINCESS',
    Radiant: 'RADIANT',
    RectangularFrench: 'RECTANGULAR_FRENCH',
    Rose: 'ROSE',
    Round: 'ROUND',
    SquareFrench: 'SQUARE_FRENCH',
    StepCutTrapezoid: 'STEP_CUT_TRAPEZOID',
    StraightBaguette: 'STRAIGHT_BAGUETTE',
    TaperedBaguette: 'TAPERED_BAGUETTE',
    Trapezoid: 'TRAPEZOID',
    Triangular: 'TRIANGULAR',
    Trillion: 'TRILLION',
} as const

export type StoneShapeCode =
    (typeof StoneShapeCode)[keyof typeof StoneShapeCode]
export type StoneShapeFilterInput = {
    category?: InputMaybe<StoneCategoryCode>
}

export type StoneShapeTranslation = {
    __typename: 'StoneShapeTranslation'
    name: Scalars['String']['output']
}

export type StoneSymmetry = {
    __typename: 'StoneSymmetry'
    abbreviation: Scalars['String']['output']
    systemCode: StoneSymmetryCode
    translation: StoneSymmetryTranslation
}

export type StoneSymmetryTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const StoneSymmetryCode = {
    Excellent: 'EXCELLENT',
    Fair: 'FAIR',
    Good: 'GOOD',
    Ideal: 'IDEAL',
    VeryGood: 'VERY_GOOD',
} as const

export type StoneSymmetryCode =
    (typeof StoneSymmetryCode)[keyof typeof StoneSymmetryCode]
export type StoneSymmetryTranslation = {
    __typename: 'StoneSymmetryTranslation'
    name: Scalars['String']['output']
}

export type StripeTransaction = TransactionInterface & {
    __typename: 'StripeTransaction'
    amount: Money
    createdAt: Scalars['DateTime']['output']
    id: Scalars['ID']['output']
    status: TransactionStatus
}

export type SubMenu = {
    __typename: 'SubMenu'
    description: Maybe<Scalars['String']['output']>
    editorialContent: Maybe<SubMenuEditorialContent>
    sections: Array<SubMenuSection>
    title: Maybe<Scalars['String']['output']>
    useLargeFormatItems: Scalars['Boolean']['output']
}

export type SubMenuEditorialContent = {
    __typename: 'SubMenuEditorialContent'
    image: Image
    link: Link
    text: Scalars['String']['output']
}

export type SubMenuItem = {
    __typename: 'SubMenuItem'
    icon: Maybe<Image>
    link: Link
    media: Maybe<Image>
    style: SubMenuItemStyle
    title: Scalars['String']['output']
}

export const SubMenuItemStyle = {
    Large: 'LARGE',
    Normal: 'NORMAL',
} as const

export type SubMenuItemStyle =
    (typeof SubMenuItemStyle)[keyof typeof SubMenuItemStyle]
export type SubMenuSection = {
    __typename: 'SubMenuSection'
    items: Array<SubMenuItem>
    title: Maybe<Scalars['String']['output']>
}

export type Table = {
    __typename: 'Table'
    body: Maybe<TableBody>
    header: Maybe<TableHeader>
}

export type TableBody = {
    __typename: 'TableBody'
    rows: Maybe<Array<Maybe<TableRow>>>
}

export type TableHeader = {
    __typename: 'TableHeader'
    cells: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export type TableRow = {
    __typename: 'TableRow'
    cells: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export type Tax = {
    __typename: 'Tax'
    price: Money
    type: TaxType
}

export const TaxType = {
    Gst: 'GST',
    Sales: 'SALES',
    Vat: 'VAT',
} as const

export type TaxType = (typeof TaxType)[keyof typeof TaxType]
export type TextCarouselItem = {
    __typename: 'TextCarouselItem'
    text: Scalars['String']['output']
    title: Scalars['String']['output']
}

export const TextSize = {
    ExtraLarge: 'EXTRA_LARGE',
    Large: 'LARGE',
    Medium: 'MEDIUM',
    Small: 'SMALL',
} as const

export type TextSize = (typeof TextSize)[keyof typeof TextSize]
export const TitleSize = {
    ExtraLarge: 'EXTRA_LARGE',
    Large: 'LARGE',
    Medium: 'MEDIUM',
    Small: 'SMALL',
    Tiny: 'TINY',
} as const

export type TitleSize = (typeof TitleSize)[keyof typeof TitleSize]
export const TitleStyle = {
    Primary: 'PRIMARY',
    Secondary: 'SECONDARY',
    Tertiary: 'TERTIARY',
} as const

export type TitleStyle = (typeof TitleStyle)[keyof typeof TitleStyle]
export const TitleWidth = {
    Normal: 'NORMAL',
    Wide: 'WIDE',
} as const

export type TitleWidth = (typeof TitleWidth)[keyof typeof TitleWidth]
export type Tooltip = {
    __typename: 'Tooltip'
    content: Array<ContentComponentItem>
    title: Scalars['String']['output']
}

export type TopBar = {
    __typename: 'TopBar'
    consultationPrompt: Maybe<TopBarConsultationPrompt>
    siteWideMessage: Maybe<TopBarSiteWideMessage>
}

export type TopBarConsultationPrompt = {
    __typename: 'TopBarConsultationPrompt'
    link: Link
}

export type TopBarSiteWideMessage = {
    __typename: 'TopBarSiteWideMessage'
    link: Link
    message: Maybe<Scalars['String']['output']>
}

export type TransactionInterface = {
    amount: Money
    createdAt: Scalars['DateTime']['output']
    id: Scalars['ID']['output']
    status: TransactionStatus
}

export type TransactionStatus = {
    __typename: 'TransactionStatus'
    name: Scalars['String']['output']
    systemCode: TransactionStatusCode
}

export type TransactionStatusNameArgs = {
    locale: Scalars['Locale']['input']
}

export const TransactionStatusCode = {
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Declined: 'DECLINED',
    Expired: 'EXPIRED',
    Initialised: 'INITIALISED',
    Pending: 'PENDING',
    Voided: 'VOIDED',
} as const

export type TransactionStatusCode =
    (typeof TransactionStatusCode)[keyof typeof TransactionStatusCode]
export type Translation = {
    __typename: 'Translation'
    token: Scalars['ID']['output']
    translation: Scalars['String']['output']
}

export type User = {
    __typename: 'User'
    createdAt: Scalars['DateTime']['output']
    customer: Maybe<Customer>
    email: Scalars['Email']['output']
    firstName: Scalars['String']['output']
    id: Scalars['ID']['output']
    isConsultant: Scalars['Boolean']['output']
    lastName: Scalars['String']['output']
}

export type UserCustomerEngagementRingRecommendations = {
    __typename: 'UserCustomerEngagementRingRecommendations'
    designFeature: Maybe<EngagementRingDesignFeatureLabel>
    designStyle: Maybe<EngagementRingDesignStyleLabel>
    items: Array<CatalogueEngagementRing>
    metal: Maybe<Metal>
    ringStyle: Maybe<EngagementRingStyleLabel>
    shape: Maybe<StoneShape>
}

export type UserCustomerEngagementRingRecommendationsItemsArgs = {
    limit?: Scalars['Int']['input']
    page?: Scalars['Int']['input']
}

export type UtmInput = {
    campaign?: InputMaybe<Scalars['String']['input']>
    medium: Scalars['String']['input']
    source: Scalars['String']['input']
}

export const VerticalSpacing = {
    Large: 'LARGE',
    None: 'NONE',
    Normal: 'NORMAL',
} as const

export type VerticalSpacing =
    (typeof VerticalSpacing)[keyof typeof VerticalSpacing]
export type Video = Media & {
    __typename: 'Video'
    alt: Maybe<Scalars['String']['output']>
    caption: Maybe<Scalars['String']['output']>
    description: Maybe<Scalars['String']['output']>
    filename: Scalars['String']['output']
    filesize: Scalars['Int']['output']
    height: Scalars['Int']['output']
    id: Scalars['ID']['output']
    mimeType: Scalars['String']['output']
    name: Scalars['String']['output']
    title: Scalars['String']['output']
    url: Scalars['String']['output']
    width: Scalars['Int']['output']
}

export const VideoPosition = {
    Left: 'LEFT',
    Right: 'RIGHT',
} as const

export type VideoPosition = (typeof VideoPosition)[keyof typeof VideoPosition]
export const VideoWidth = {
    Content: 'CONTENT',
    ExtendedContent: 'EXTENDED_CONTENT',
    Full: 'FULL',
} as const

export type VideoWidth = (typeof VideoWidth)[keyof typeof VideoWidth]
export type WeddingRingCategoryLabel = {
    __typename: 'WeddingRingCategoryLabel'
    icon: Maybe<Asset>
    systemCode: WeddingRingCategoryLabelCode
    translation: ProductLabelTranslation
}

export type WeddingRingCategoryLabelTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const WeddingRingCategoryLabelCode = {
    Ladies: 'LADIES',
    Mens: 'MENS',
} as const

export type WeddingRingCategoryLabelCode =
    (typeof WeddingRingCategoryLabelCode)[keyof typeof WeddingRingCategoryLabelCode]
export type WeddingRingStyleLabel = {
    __typename: 'WeddingRingStyleLabel'
    icon: Maybe<Asset>
    systemCode: WeddingRingStyleLabelCode
    translation: ProductLabelTranslation
}

export type WeddingRingStyleLabelTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const WeddingRingStyleLabelCode = {
    Baguette: 'BAGUETTE',
    BezelSet: 'BEZEL_SET',
    ChannelSet: 'CHANNEL_SET',
    Chevron: 'CHEVRON',
    Curved: 'CURVED',
    Diamond: 'DIAMOND',
    Pave: 'PAVE',
    Plain: 'PLAIN',
    Sapphire: 'SAPPHIRE',
    Twisted: 'TWISTED',
} as const

export type WeddingRingStyleLabelCode =
    (typeof WeddingRingStyleLabelCode)[keyof typeof WeddingRingStyleLabelCode]
export const WeekDay = {
    Friday: 'FRIDAY',
    Monday: 'MONDAY',
    Saturday: 'SATURDAY',
    Sunday: 'SUNDAY',
    Thursday: 'THURSDAY',
    Tuesday: 'TUESDAY',
    Wednesday: 'WEDNESDAY',
} as const

export type WeekDay = (typeof WeekDay)[keyof typeof WeekDay]
export const Width = {
    Full: 'FULL',
    Normal: 'NORMAL',
} as const

export type Width = (typeof Width)[keyof typeof Width]
export type WorkingHours = {
    __typename: 'WorkingHours'
    closing: Scalars['Time']['output']
    opening: Scalars['Time']['output']
    weekDays: Array<WeekDay>
}

export type BlockAnchorFragment = { __typename: 'BlockAnchor' } & Pick<
    BlockAnchor,
    'title' | 'slug'
>

export type BlockFragment = { __typename: 'Block' } & Pick<
    Block,
    | 'width'
    | 'backgroundColor'
    | 'backgroundOverflow'
    | 'verticalSpacing'
    | 'display'
    | 'isCollapsible'
    | 'collapsibleTitle'
    | 'isOpenByDefault'
> & {
        anchor: Maybe<{ __typename: 'BlockAnchor' } & BlockAnchorFragment>
        components: Array<
            | ({
                  __typename: 'ComponentArticleGrid'
              } & Component_ComponentArticleGrid_Fragment)
            | ({
                  __typename: 'ComponentArticlePreviews'
              } & Component_ComponentArticlePreviews_Fragment)
            | ({
                  __typename: 'ComponentBannerSkinny'
              } & Component_ComponentBannerSkinny_Fragment)
            | ({
                  __typename: 'ComponentBannerTitle'
              } & Component_ComponentBannerTitle_Fragment)
            | ({
                  __typename: 'ComponentCard'
              } & Component_ComponentCard_Fragment)
            | ({
                  __typename: 'ComponentCardCarousel'
              } & Component_ComponentCardCarousel_Fragment)
            | ({
                  __typename: 'ComponentCatalogueProductCarousel'
              } & Component_ComponentCatalogueProductCarousel_Fragment)
            | ({
                  __typename: 'ComponentContent'
              } & Component_ComponentContent_Fragment)
            | ({
                  __typename: 'ComponentContentTwoColumns'
              } & Component_ComponentContentTwoColumns_Fragment)
            | ({
                  __typename: 'ComponentContentWithGallery'
              } & Component_ComponentContentWithGallery_Fragment)
            | ({
                  __typename: 'ComponentCustomProductCarousel'
              } & Component_ComponentCustomProductCarousel_Fragment)
            | ({ __typename: 'ComponentFaq' } & Component_ComponentFaq_Fragment)
            | ({
                  __typename: 'ComponentFullWidthImage'
              } & Component_ComponentFullWidthImage_Fragment)
            | ({
                  __typename: 'ComponentGalleryCarousel'
              } & Component_ComponentGalleryCarousel_Fragment)
            | ({
                  __typename: 'ComponentGalleryWithEnquiry'
              } & Component_ComponentGalleryWithEnquiry_Fragment)
            | ({
                  __typename: 'ComponentGlobalComponent'
              } & ComponentGlobalComponentFragment &
                  Component_ComponentGlobalComponent_Fragment)
            | ({
                  __typename: 'ComponentGlobalSpacer'
              } & Component_ComponentGlobalSpacer_Fragment)
            | ({
                  __typename: 'ComponentIconCarousel'
              } & Component_ComponentIconCarousel_Fragment)
            | ({
                  __typename: 'ComponentInstagramPosts'
              } & Component_ComponentInstagramPosts_Fragment)
            | ({
                  __typename: 'ComponentInstagramWithContent'
              } & Component_ComponentInstagramWithContent_Fragment)
            | ({
                  __typename: 'ComponentLogos'
              } & Component_ComponentLogos_Fragment)
            | ({
                  __typename: 'ComponentLogosCarousel'
              } & Component_ComponentLogosCarousel_Fragment)
            | ({
                  __typename: 'ComponentMainCover'
              } & Component_ComponentMainCover_Fragment)
            | ({
                  __typename: 'ComponentOnThisPage'
              } & Component_ComponentOnThisPage_Fragment)
            | ({
                  __typename: 'ComponentQuote'
              } & Component_ComponentQuote_Fragment)
            | ({
                  __typename: 'ComponentRelatedProducts'
              } & Component_ComponentRelatedProducts_Fragment)
            | ({
                  __typename: 'ComponentReviewCarousel'
              } & Component_ComponentReviewCarousel_Fragment)
            | ({
                  __typename: 'ComponentRoundedImage'
              } & Component_ComponentRoundedImage_Fragment)
            | ({
                  __typename: 'ComponentRoundedImageContent'
              } & Component_ComponentRoundedImageContent_Fragment)
            | ({
                  __typename: 'ComponentShopWithConfidence'
              } & Component_ComponentShopWithConfidence_Fragment)
            | ({
                  __typename: 'ComponentSideBySideImages'
              } & Component_ComponentSideBySideImages_Fragment)
            | ({
                  __typename: 'ComponentSquareBoxes'
              } & Component_ComponentSquareBoxes_Fragment)
            | ({
                  __typename: 'ComponentTable'
              } & Component_ComponentTable_Fragment)
            | ({
                  __typename: 'ComponentTextCarousel'
              } & Component_ComponentTextCarousel_Fragment)
            | ({
                  __typename: 'ComponentTextOverImage'
              } & Component_ComponentTextOverImage_Fragment)
            | ({
                  __typename: 'ComponentTextWithImage'
              } & Component_ComponentTextWithImage_Fragment)
            | ({
                  __typename: 'ComponentTextWithImageCarousel'
              } & Component_ComponentTextWithImageCarousel_Fragment)
            | ({
                  __typename: 'ComponentVideo'
              } & Component_ComponentVideo_Fragment)
            | ({
                  __typename: 'ComponentVideoWithContent'
              } & Component_ComponentVideoWithContent_Fragment)
        >
    }

type Component_ComponentArticleGrid_Fragment = {
    __typename: 'ComponentArticleGrid'
} & ComponentArticleGridFragment

type Component_ComponentArticlePreviews_Fragment = {
    __typename: 'ComponentArticlePreviews'
} & ComponentArticlePreviewsFragment

type Component_ComponentBannerSkinny_Fragment = {
    __typename: 'ComponentBannerSkinny'
} & ComponentBannerSkinnyFragment

type Component_ComponentBannerTitle_Fragment = {
    __typename: 'ComponentBannerTitle'
} & ComponentBannerTitleFragment

type Component_ComponentCard_Fragment = {
    __typename: 'ComponentCard'
} & ComponentCardFragment

type Component_ComponentCardCarousel_Fragment = {
    __typename: 'ComponentCardCarousel'
} & ComponentCardCarouselFragment

type Component_ComponentCatalogueProductCarousel_Fragment = {
    __typename: 'ComponentCatalogueProductCarousel'
} & ComponentCatalogueProductCarouselFragment

type Component_ComponentContent_Fragment = {
    __typename: 'ComponentContent'
} & ComponentContentFragment

type Component_ComponentContentTwoColumns_Fragment = {
    __typename: 'ComponentContentTwoColumns'
} & ComponentContentTwoColumnsFragment

type Component_ComponentContentWithGallery_Fragment = {
    __typename: 'ComponentContentWithGallery'
} & ComponentContentWithGalleryFragment

type Component_ComponentCustomProductCarousel_Fragment = {
    __typename: 'ComponentCustomProductCarousel'
} & ComponentCustomProductCarouselFragment

type Component_ComponentFaq_Fragment = {
    __typename: 'ComponentFaq'
} & ComponentFaqFragment

type Component_ComponentFullWidthImage_Fragment = {
    __typename: 'ComponentFullWidthImage'
} & ComponentFullWidthImageFragment

type Component_ComponentGalleryCarousel_Fragment = {
    __typename: 'ComponentGalleryCarousel'
} & ComponentGalleryCarouselFragment

type Component_ComponentGalleryWithEnquiry_Fragment = {
    __typename: 'ComponentGalleryWithEnquiry'
} & ComponentGalleryWithEnquiryFragment

type Component_ComponentGlobalComponent_Fragment = {
    __typename: 'ComponentGlobalComponent'
}

type Component_ComponentGlobalSpacer_Fragment = {
    __typename: 'ComponentGlobalSpacer'
} & ComponentGlobalSpacerFragment

type Component_ComponentIconCarousel_Fragment = {
    __typename: 'ComponentIconCarousel'
} & ComponentIconCarouselFragment

type Component_ComponentInstagramPosts_Fragment = {
    __typename: 'ComponentInstagramPosts'
} & ComponentInstagramPostsFragment

type Component_ComponentInstagramWithContent_Fragment = {
    __typename: 'ComponentInstagramWithContent'
} & ComponentInstagramWithContentFragment

type Component_ComponentLogos_Fragment = {
    __typename: 'ComponentLogos'
} & ComponentLogosFragment

type Component_ComponentLogosCarousel_Fragment = {
    __typename: 'ComponentLogosCarousel'
} & ComponentLogosCarouselFragment

type Component_ComponentMainCover_Fragment = {
    __typename: 'ComponentMainCover'
} & ComponentMainCoverFragment

type Component_ComponentOnThisPage_Fragment = {
    __typename: 'ComponentOnThisPage'
} & ComponentOnThisPageFragment

type Component_ComponentQuote_Fragment = {
    __typename: 'ComponentQuote'
} & ComponentQuoteFragment

type Component_ComponentRelatedProducts_Fragment = {
    __typename: 'ComponentRelatedProducts'
}

type Component_ComponentReviewCarousel_Fragment = {
    __typename: 'ComponentReviewCarousel'
} & ComponentReviewCarouselFragment

type Component_ComponentRoundedImage_Fragment = {
    __typename: 'ComponentRoundedImage'
} & ComponentRoundedImageFragment &
    ComponentRoundedImageFragment

type Component_ComponentRoundedImageContent_Fragment = {
    __typename: 'ComponentRoundedImageContent'
} & ComponentRoundedImageContentFragment

type Component_ComponentShopWithConfidence_Fragment = {
    __typename: 'ComponentShopWithConfidence'
} & ComponentShopWithConfidenceFragment

type Component_ComponentSideBySideImages_Fragment = {
    __typename: 'ComponentSideBySideImages'
} & ComponentSideBySideImagesFragment

type Component_ComponentSquareBoxes_Fragment = {
    __typename: 'ComponentSquareBoxes'
} & ComponentSquareBoxesFragment

type Component_ComponentTable_Fragment = {
    __typename: 'ComponentTable'
} & ComponentTableFragment

type Component_ComponentTextCarousel_Fragment = {
    __typename: 'ComponentTextCarousel'
} & ComponentTextCarouselFragment

type Component_ComponentTextOverImage_Fragment = {
    __typename: 'ComponentTextOverImage'
} & ComponentTextOverImageFragment

type Component_ComponentTextWithImage_Fragment = {
    __typename: 'ComponentTextWithImage'
} & ComponentTextWithImageFragment

type Component_ComponentTextWithImageCarousel_Fragment = {
    __typename: 'ComponentTextWithImageCarousel'
} & ComponentTextWithImageCarouselFragment

type Component_ComponentVideo_Fragment = {
    __typename: 'ComponentVideo'
} & ComponentVideoFragment

type Component_ComponentVideoWithContent_Fragment = {
    __typename: 'ComponentVideoWithContent'
} & ComponentVideoWithContentFragment

export type ComponentFragment =
    | Component_ComponentArticleGrid_Fragment
    | Component_ComponentArticlePreviews_Fragment
    | Component_ComponentBannerSkinny_Fragment
    | Component_ComponentBannerTitle_Fragment
    | Component_ComponentCard_Fragment
    | Component_ComponentCardCarousel_Fragment
    | Component_ComponentCatalogueProductCarousel_Fragment
    | Component_ComponentContent_Fragment
    | Component_ComponentContentTwoColumns_Fragment
    | Component_ComponentContentWithGallery_Fragment
    | Component_ComponentCustomProductCarousel_Fragment
    | Component_ComponentFaq_Fragment
    | Component_ComponentFullWidthImage_Fragment
    | Component_ComponentGalleryCarousel_Fragment
    | Component_ComponentGalleryWithEnquiry_Fragment
    | Component_ComponentGlobalComponent_Fragment
    | Component_ComponentGlobalSpacer_Fragment
    | Component_ComponentIconCarousel_Fragment
    | Component_ComponentInstagramPosts_Fragment
    | Component_ComponentInstagramWithContent_Fragment
    | Component_ComponentLogos_Fragment
    | Component_ComponentLogosCarousel_Fragment
    | Component_ComponentMainCover_Fragment
    | Component_ComponentOnThisPage_Fragment
    | Component_ComponentQuote_Fragment
    | Component_ComponentRelatedProducts_Fragment
    | Component_ComponentReviewCarousel_Fragment
    | Component_ComponentRoundedImage_Fragment
    | Component_ComponentRoundedImageContent_Fragment
    | Component_ComponentShopWithConfidence_Fragment
    | Component_ComponentSideBySideImages_Fragment
    | Component_ComponentSquareBoxes_Fragment
    | Component_ComponentTable_Fragment
    | Component_ComponentTextCarousel_Fragment
    | Component_ComponentTextOverImage_Fragment
    | Component_ComponentTextWithImage_Fragment
    | Component_ComponentTextWithImageCarousel_Fragment
    | Component_ComponentVideo_Fragment
    | Component_ComponentVideoWithContent_Fragment

export type ImageCoverFragment = { __typename: 'Image' } & {
    size: { __typename: 'ImageSize' } & ImageSizeFragment
    size_x2: { __typename: 'ImageSize' } & ImageSizeFragment
} & ImageCommonFragment

export type ImageLargeFragment = { __typename: 'Image' } & {
    size: { __typename: 'ImageSize' } & ImageSizeFragment
    size_x2: { __typename: 'ImageSize' } & ImageSizeFragment
} & ImageCommonFragment

export type ImageMediumFragment = { __typename: 'Image' } & {
    size: { __typename: 'ImageSize' } & ImageSizeFragment
    size_x2: { __typename: 'ImageSize' } & ImageSizeFragment
} & ImageCommonFragment

export type ImageCommonFragment = { __typename: 'Image' } & Pick<
    Image,
    'id' | 'alt'
>

export type ImageSizeFragment = { __typename: 'ImageSize' } & Pick<
    ImageSize,
    'url'
> & {
        sources: Array<
            { __typename: 'ImageSrc' } & Pick<ImageSrc, 'url' | 'mimeType'>
        >
    }

export type WorkingHoursFragment = { __typename: 'WorkingHours' } & Pick<
    WorkingHours,
    'weekDays' | 'opening' | 'closing'
>

export type ComponentCardFragment = { __typename: 'ComponentCard' } & Pick<
    ComponentCard,
    'backgroundColor'
> & {
        cardImage: Maybe<{ __typename: 'Image' } & ImageLargeFragment>
        content: Array<
            | ({
                  __typename: 'ComponentButton'
              } & ContentComponentItem_ComponentButton_Fragment)
            | ({
                  __typename: 'ComponentImage'
              } & ContentComponentItem_ComponentImage_Fragment)
            | ({
                  __typename: 'ComponentOrderedList'
              } & ContentComponentItem_ComponentOrderedList_Fragment)
            | ({
                  __typename: 'ComponentSpacer'
              } & ContentComponentItem_ComponentSpacer_Fragment)
            | ({
                  __typename: 'ComponentText'
              } & ContentComponentItem_ComponentText_Fragment)
            | ({
                  __typename: 'ComponentTitle'
              } & ContentComponentItem_ComponentTitle_Fragment)
        >
    }

export type ComponentArticleGridFragment = {
    __typename: 'ComponentArticleGrid'
} & {
    articles: Array<{ __typename: 'ArticleGridItem' } & ArticleGridItemFragment>
}

export type ComponentArticlePreviewsFragment = {
    __typename: 'ComponentArticlePreviews'
} & {
    articles: Array<{ __typename: 'ArticlePreview' } & ArticlePreviewFragment>
}

export type ComponentBannerSkinnyFragment = {
    __typename: 'ComponentBannerSkinny'
} & Pick<
    ComponentBannerSkinny,
    'useBackgroundImage' | 'backgroundColor' | 'backgroundGraphic'
> & {
        backgroundImage: Maybe<{ __typename: 'Image' } & ImageCoverFragment>
        title: { __typename: 'ComponentTitle' } & ComponentTitleFragment
    }

export type ComponentBannerTitleFragment = {
    __typename: 'ComponentBannerTitle'
} & Pick<ComponentBannerTitle, 'date' | 'description' | 'tag'> & {
        bannerTitle: ComponentBannerTitle['title']
    } & { image: { __typename: 'Image' } & ImageLargeFragment }

export type ComponentCatalogueProductCarouselFragment = {
    __typename: 'ComponentCatalogueProductCarousel'
} & {
    items: Array<
        { __typename: 'ComponentCatalogueProductCarouselItem' } & Pick<
            ComponentCatalogueProductCarouselItem,
            'catalogueCode'
        > & {
                product: Maybe<
                    | ({ __typename: 'CatalogueEngagementRing' } & {
                          variationsByPrimaryMetal: Array<
                              {
                                  __typename: 'CatalogueEngagementRing'
                              } & ProductCard_CatalogueEngagementRing_Fragment
                          >
                      } & ProductCard_CatalogueEngagementRing_Fragment)
                    | ({ __typename: 'CatalogueJewelleryBracelet' } & {
                          variations: Array<
                              {
                                  __typename: 'CatalogueJewelleryBracelet'
                              } & ProductCard_CatalogueJewelleryBracelet_Fragment
                          >
                      } & ProductCard_CatalogueJewelleryBracelet_Fragment)
                    | ({ __typename: 'CatalogueJewelleryEarrings' } & {
                          variations: Array<
                              {
                                  __typename: 'CatalogueJewelleryEarrings'
                              } & ProductCard_CatalogueJewelleryEarrings_Fragment
                          >
                      } & ProductCard_CatalogueJewelleryEarrings_Fragment)
                    | ({ __typename: 'CatalogueJewelleryNecklace' } & {
                          variations: Array<
                              {
                                  __typename: 'CatalogueJewelleryNecklace'
                              } & ProductCard_CatalogueJewelleryNecklace_Fragment
                          >
                      } & ProductCard_CatalogueJewelleryNecklace_Fragment)
                    | ({ __typename: 'CatalogueJewelleryRing' } & {
                          variations: Array<
                              {
                                  __typename: 'CatalogueJewelleryRing'
                              } & ProductCard_CatalogueJewelleryRing_Fragment
                          >
                      } & ProductCard_CatalogueJewelleryRing_Fragment)
                    | ({
                          __typename: 'CatalogueReadyToGoRing'
                      } & ProductCard_CatalogueReadyToGoRing_Fragment)
                    | ({ __typename: 'CatalogueWeddingRing' } & {
                          variations: Array<
                              {
                                  __typename: 'CatalogueWeddingRing'
                              } & ProductCard_CatalogueWeddingRing_Fragment
                          >
                      } & ProductCard_CatalogueWeddingRing_Fragment)
                >
            }
    >
}

export type ComponentContentFragment = { __typename: 'ComponentContent' } & {
    content: Array<
        | ({
              __typename: 'ComponentButton'
          } & ContentComponentItem_ComponentButton_Fragment)
        | ({
              __typename: 'ComponentImage'
          } & ContentComponentItem_ComponentImage_Fragment)
        | ({
              __typename: 'ComponentOrderedList'
          } & ContentComponentItem_ComponentOrderedList_Fragment)
        | ({
              __typename: 'ComponentSpacer'
          } & ContentComponentItem_ComponentSpacer_Fragment)
        | ({
              __typename: 'ComponentText'
          } & ContentComponentItem_ComponentText_Fragment)
        | ({
              __typename: 'ComponentTitle'
          } & ContentComponentItem_ComponentTitle_Fragment)
    >
}

export type ComponentContentTwoColumnsFragment = {
    __typename: 'ComponentContentTwoColumns'
} & Pick<
    ComponentContentTwoColumns,
    'leftColumnBackgroundColor' | 'rightColumnBackgroundColor'
> & {
        leftColumnContent: Array<
            | ({
                  __typename: 'ComponentButton'
              } & ContentComponentItem_ComponentButton_Fragment)
            | ({
                  __typename: 'ComponentImage'
              } & ContentComponentItem_ComponentImage_Fragment)
            | ({
                  __typename: 'ComponentOrderedList'
              } & ContentComponentItem_ComponentOrderedList_Fragment)
            | ({
                  __typename: 'ComponentSpacer'
              } & ContentComponentItem_ComponentSpacer_Fragment)
            | ({
                  __typename: 'ComponentText'
              } & ContentComponentItem_ComponentText_Fragment)
            | ({
                  __typename: 'ComponentTitle'
              } & ContentComponentItem_ComponentTitle_Fragment)
        >
        rightColumnContent: Array<
            | ({
                  __typename: 'ComponentButton'
              } & ContentComponentItem_ComponentButton_Fragment)
            | ({
                  __typename: 'ComponentImage'
              } & ContentComponentItem_ComponentImage_Fragment)
            | ({
                  __typename: 'ComponentOrderedList'
              } & ContentComponentItem_ComponentOrderedList_Fragment)
            | ({
                  __typename: 'ComponentSpacer'
              } & ContentComponentItem_ComponentSpacer_Fragment)
            | ({
                  __typename: 'ComponentText'
              } & ContentComponentItem_ComponentText_Fragment)
            | ({
                  __typename: 'ComponentTitle'
              } & ContentComponentItem_ComponentTitle_Fragment)
        >
    }

export type ComponentContentWithGalleryFragment = {
    __typename: 'ComponentContentWithGallery'
} & {
    content: Array<
        | ({
              __typename: 'ComponentButton'
          } & ContentComponentItem_ComponentButton_Fragment)
        | ({
              __typename: 'ComponentImage'
          } & ContentComponentItem_ComponentImage_Fragment)
        | ({
              __typename: 'ComponentOrderedList'
          } & ContentComponentItem_ComponentOrderedList_Fragment)
        | ({
              __typename: 'ComponentSpacer'
          } & ContentComponentItem_ComponentSpacer_Fragment)
        | ({
              __typename: 'ComponentText'
          } & ContentComponentItem_ComponentText_Fragment)
        | ({
              __typename: 'ComponentTitle'
          } & ContentComponentItem_ComponentTitle_Fragment)
    >
    gallery: Array<
        { __typename: 'GalleryItem' } & {
            image: { __typename: 'Image' } & ImageLargeFragment
        }
    >
}

export type ComponentCustomProductCarouselFragment = {
    __typename: 'ComponentCustomProductCarousel'
} & {
    products: Array<
        {
            __typename: 'CarouselCustomProduct'
        } & CustomProductCarouselCardFragment
    >
}

export type ComponentFaqFragment = { __typename: 'ComponentFaq' } & Pick<
    ComponentFaq,
    'showNavigation'
> & { sections: Array<{ __typename: 'FaqSection' } & FaqSectionFragment> }

export type ComponentFullWidthImageFragment = {
    __typename: 'ComponentFullWidthImage'
} & Pick<ComponentFullWidthImage, 'width'> & {
        image: { __typename: 'Image' } & ImageLargeFragment
        link: Maybe<{ __typename: 'Link' } & LinkFragment>
    }

export type ComponentGalleryCarouselFragment = {
    __typename: 'ComponentGalleryCarousel'
} & {
    items: Array<
        { __typename: 'GalleryCarouselCard' } & GalleryCarouselCardFragment
    >
}

export type ComponentGlobalComponentFragment = {
    __typename: 'ComponentGlobalComponent'
} & Pick<ComponentGlobalComponent, 'backgroundColor'> & {
        components: Array<
            | ({
                  __typename: 'ComponentArticleGrid'
              } & Component_ComponentArticleGrid_Fragment)
            | ({
                  __typename: 'ComponentArticlePreviews'
              } & Component_ComponentArticlePreviews_Fragment)
            | ({
                  __typename: 'ComponentBannerSkinny'
              } & Component_ComponentBannerSkinny_Fragment)
            | ({
                  __typename: 'ComponentBannerTitle'
              } & Component_ComponentBannerTitle_Fragment)
            | ({
                  __typename: 'ComponentCard'
              } & Component_ComponentCard_Fragment)
            | ({
                  __typename: 'ComponentCardCarousel'
              } & Component_ComponentCardCarousel_Fragment)
            | ({
                  __typename: 'ComponentCatalogueProductCarousel'
              } & Component_ComponentCatalogueProductCarousel_Fragment)
            | ({
                  __typename: 'ComponentContent'
              } & Component_ComponentContent_Fragment)
            | ({
                  __typename: 'ComponentContentTwoColumns'
              } & Component_ComponentContentTwoColumns_Fragment)
            | ({
                  __typename: 'ComponentContentWithGallery'
              } & Component_ComponentContentWithGallery_Fragment)
            | ({
                  __typename: 'ComponentCustomProductCarousel'
              } & Component_ComponentCustomProductCarousel_Fragment)
            | ({ __typename: 'ComponentFaq' } & Component_ComponentFaq_Fragment)
            | ({
                  __typename: 'ComponentFullWidthImage'
              } & Component_ComponentFullWidthImage_Fragment)
            | ({
                  __typename: 'ComponentGalleryCarousel'
              } & Component_ComponentGalleryCarousel_Fragment)
            | ({
                  __typename: 'ComponentGalleryWithEnquiry'
              } & Component_ComponentGalleryWithEnquiry_Fragment)
            | ({
                  __typename: 'ComponentGlobalComponent'
              } & Component_ComponentGlobalComponent_Fragment)
            | ({
                  __typename: 'ComponentGlobalSpacer'
              } & Component_ComponentGlobalSpacer_Fragment)
            | ({
                  __typename: 'ComponentIconCarousel'
              } & Component_ComponentIconCarousel_Fragment)
            | ({
                  __typename: 'ComponentInstagramPosts'
              } & Component_ComponentInstagramPosts_Fragment)
            | ({
                  __typename: 'ComponentInstagramWithContent'
              } & Component_ComponentInstagramWithContent_Fragment)
            | ({
                  __typename: 'ComponentLogos'
              } & Component_ComponentLogos_Fragment)
            | ({
                  __typename: 'ComponentLogosCarousel'
              } & Component_ComponentLogosCarousel_Fragment)
            | ({
                  __typename: 'ComponentMainCover'
              } & Component_ComponentMainCover_Fragment)
            | ({
                  __typename: 'ComponentOnThisPage'
              } & Component_ComponentOnThisPage_Fragment)
            | ({
                  __typename: 'ComponentQuote'
              } & Component_ComponentQuote_Fragment)
            | ({
                  __typename: 'ComponentRelatedProducts'
              } & Component_ComponentRelatedProducts_Fragment)
            | ({
                  __typename: 'ComponentReviewCarousel'
              } & Component_ComponentReviewCarousel_Fragment)
            | ({
                  __typename: 'ComponentRoundedImage'
              } & Component_ComponentRoundedImage_Fragment)
            | ({
                  __typename: 'ComponentRoundedImageContent'
              } & Component_ComponentRoundedImageContent_Fragment)
            | ({
                  __typename: 'ComponentShopWithConfidence'
              } & Component_ComponentShopWithConfidence_Fragment)
            | ({
                  __typename: 'ComponentSideBySideImages'
              } & Component_ComponentSideBySideImages_Fragment)
            | ({
                  __typename: 'ComponentSquareBoxes'
              } & Component_ComponentSquareBoxes_Fragment)
            | ({
                  __typename: 'ComponentTable'
              } & Component_ComponentTable_Fragment)
            | ({
                  __typename: 'ComponentTextCarousel'
              } & Component_ComponentTextCarousel_Fragment)
            | ({
                  __typename: 'ComponentTextOverImage'
              } & Component_ComponentTextOverImage_Fragment)
            | ({
                  __typename: 'ComponentTextWithImage'
              } & Component_ComponentTextWithImage_Fragment)
            | ({
                  __typename: 'ComponentTextWithImageCarousel'
              } & Component_ComponentTextWithImageCarousel_Fragment)
            | ({
                  __typename: 'ComponentVideo'
              } & Component_ComponentVideo_Fragment)
            | ({
                  __typename: 'ComponentVideoWithContent'
              } & Component_ComponentVideoWithContent_Fragment)
        >
    }

export type ComponentGlobalSpacerFragment = {
    __typename: 'ComponentGlobalSpacer'
} & Pick<ComponentGlobalSpacer, 'spacing'>

export type ComponentIconCarouselFragment = {
    __typename: 'ComponentIconCarousel'
} & {
    items: Array<
        { __typename: 'IconCarouselItem' } & Pick<
            IconCarouselItem,
            'icon' | 'text'
        >
    >
}

export type ComponentInstagramPostsFragment = {
    __typename: 'ComponentInstagramPosts'
} & Pick<
    ComponentInstagramPosts,
    'preTitle' | 'instagramUser' | 'instagramUserLink'
> & {
        title: { __typename: 'ComponentTitle' } & ComponentTitleFragment
        posts: Array<
            { __typename: 'InstagramPost' } & Pick<InstagramPost, 'link'> & {
                    image: { __typename: 'Image' } & ImageLargeFragment
                }
        >
    }

export type ComponentInstagramWithContentFragment = {
    __typename: 'ComponentInstagramWithContent'
} & Pick<
    ComponentInstagramWithContent,
    | 'useImage'
    | 'instagramEmbedCode'
    | 'instagramUsername'
    | 'instagramLink'
    | 'instagramPosition'
> & { instagramWithContentWidth: ComponentInstagramWithContent['width'] } & {
        instagramImage: Maybe<{ __typename: 'Image' } & ImageLargeFragment>
        optionalContent: Maybe<
            Array<
                | ({
                      __typename: 'ComponentButton'
                  } & ContentComponentItem_ComponentButton_Fragment)
                | ({
                      __typename: 'ComponentImage'
                  } & ContentComponentItem_ComponentImage_Fragment)
                | ({
                      __typename: 'ComponentOrderedList'
                  } & ContentComponentItem_ComponentOrderedList_Fragment)
                | ({
                      __typename: 'ComponentSpacer'
                  } & ContentComponentItem_ComponentSpacer_Fragment)
                | ({
                      __typename: 'ComponentText'
                  } & ContentComponentItem_ComponentText_Fragment)
                | ({
                      __typename: 'ComponentTitle'
                  } & ContentComponentItem_ComponentTitle_Fragment)
            >
        >
    }

export type ComponentLogosFragment = { __typename: 'ComponentLogos' } & {
    logos: Array<
        { __typename: 'Logo' } & Pick<Logo, 'link'> & {
                image: { __typename: 'Image' } & ImageLargeFragment
            }
    >
}

export type ComponentLogosCarouselFragment = {
    __typename: 'ComponentLogosCarousel'
} & {
    logos: Array<
        { __typename: 'Logo' } & Pick<Logo, 'link'> & {
                image: { __typename: 'Image' } & ImageLargeFragment
            }
    >
}

export type ComponentMainCoverFragment = {
    __typename: 'ComponentMainCover'
} & {
    mainCoverImage: { __typename: 'Image' } & ImageCoverFragment
    mobileBackgroundImage: { __typename: 'Image' } & ImageLargeFragment
    content: Array<
        | ({
              __typename: 'ComponentButton'
          } & ContentComponentItem_ComponentButton_Fragment)
        | ({
              __typename: 'ComponentImage'
          } & ContentComponentItem_ComponentImage_Fragment)
        | ({
              __typename: 'ComponentOrderedList'
          } & ContentComponentItem_ComponentOrderedList_Fragment)
        | ({
              __typename: 'ComponentSpacer'
          } & ContentComponentItem_ComponentSpacer_Fragment)
        | ({
              __typename: 'ComponentText'
          } & ContentComponentItem_ComponentText_Fragment)
        | ({
              __typename: 'ComponentTitle'
          } & ContentComponentItem_ComponentTitle_Fragment)
    >
}

export type ComponentOnThisPageFragment = { __typename: 'ComponentOnThisPage' }

export type ComponentQuoteFragment = { __typename: 'ComponentQuote' } & Pick<
    ComponentQuote,
    'hasBackgroundImage' | 'quote' | 'author' | 'size' | 'showQuotationMarks'
> & { quoteImage: Maybe<{ __typename: 'Image' } & ImageLargeFragment> }

export type ComponentReviewCarouselFragment = {
    __typename: 'ComponentReviewCarousel'
} & {
    reviews: Array<
        { __typename: 'ReviewCarouselCard' } & Pick<
            ReviewCarouselCard,
            'author' | 'date' | 'review' | 'starsCount'
        >
    >
}

export type ComponentRoundedImageFragment = {
    __typename: 'ComponentRoundedImage'
} & Pick<ComponentRoundedImage, 'backgroundColor' | 'backgroundImageColor'> & {
        backgroundImage: Maybe<{ __typename: 'Image' } & ImageMediumFragment>
        roundedImage: { __typename: 'Image' } & ImageMediumFragment
    }

export type ComponentRoundedImageContentFragment = {
    __typename: 'ComponentRoundedImageContent'
} & {
    content: Array<
        | ({
              __typename: 'ComponentButton'
          } & ContentComponentItem_ComponentButton_Fragment)
        | ({
              __typename: 'ComponentImage'
          } & ContentComponentItem_ComponentImage_Fragment)
        | ({
              __typename: 'ComponentOrderedList'
          } & ContentComponentItem_ComponentOrderedList_Fragment)
        | ({
              __typename: 'ComponentSpacer'
          } & ContentComponentItem_ComponentSpacer_Fragment)
        | ({
              __typename: 'ComponentText'
          } & ContentComponentItem_ComponentText_Fragment)
        | ({
              __typename: 'ComponentTitle'
          } & ContentComponentItem_ComponentTitle_Fragment)
    >
    roundedImage: {
        __typename: 'ComponentRoundedImage'
    } & ComponentRoundedImageFragment
}

export type ComponentShopWithConfidenceFragment = {
    __typename: 'ComponentShopWithConfidence'
} & {
    shopWithConfidenceTitle: Maybe<
        { __typename: 'ComponentTitle' } & ComponentTitleFragment
    >
    components: Array<
        | ({ __typename: 'ShopWithConfidenceEthnicallySourcedDiamonds' } & {
              content: Array<
                  | ({
                        __typename: 'ComponentButton'
                    } & ContentComponentItem_ComponentButton_Fragment)
                  | ({
                        __typename: 'ComponentImage'
                    } & ContentComponentItem_ComponentImage_Fragment)
                  | ({
                        __typename: 'ComponentOrderedList'
                    } & ContentComponentItem_ComponentOrderedList_Fragment)
                  | ({
                        __typename: 'ComponentSpacer'
                    } & ContentComponentItem_ComponentSpacer_Fragment)
                  | ({
                        __typename: 'ComponentText'
                    } & ContentComponentItem_ComponentText_Fragment)
                  | ({
                        __typename: 'ComponentTitle'
                    } & ContentComponentItem_ComponentTitle_Fragment)
              >
          })
        | ({ __typename: 'ShopWithConfidenceFinancingOptions' } & {
              content: Array<
                  | ({
                        __typename: 'ComponentButton'
                    } & ContentComponentItem_ComponentButton_Fragment)
                  | ({
                        __typename: 'ComponentImage'
                    } & ContentComponentItem_ComponentImage_Fragment)
                  | ({
                        __typename: 'ComponentOrderedList'
                    } & ContentComponentItem_ComponentOrderedList_Fragment)
                  | ({
                        __typename: 'ComponentSpacer'
                    } & ContentComponentItem_ComponentSpacer_Fragment)
                  | ({
                        __typename: 'ComponentText'
                    } & ContentComponentItem_ComponentText_Fragment)
                  | ({
                        __typename: 'ComponentTitle'
                    } & ContentComponentItem_ComponentTitle_Fragment)
              >
          })
        | ({ __typename: 'ShopWithConfidenceGreenlandRuby' } & {
              content: Array<
                  | ({
                        __typename: 'ComponentButton'
                    } & ContentComponentItem_ComponentButton_Fragment)
                  | ({
                        __typename: 'ComponentImage'
                    } & ContentComponentItem_ComponentImage_Fragment)
                  | ({
                        __typename: 'ComponentOrderedList'
                    } & ContentComponentItem_ComponentOrderedList_Fragment)
                  | ({
                        __typename: 'ComponentSpacer'
                    } & ContentComponentItem_ComponentSpacer_Fragment)
                  | ({
                        __typename: 'ComponentText'
                    } & ContentComponentItem_ComponentText_Fragment)
                  | ({
                        __typename: 'ComponentTitle'
                    } & ContentComponentItem_ComponentTitle_Fragment)
              >
          })
        | ({ __typename: 'ShopWithConfidenceHandFinished' } & {
              content: Array<
                  | ({
                        __typename: 'ComponentButton'
                    } & ContentComponentItem_ComponentButton_Fragment)
                  | ({
                        __typename: 'ComponentImage'
                    } & ContentComponentItem_ComponentImage_Fragment)
                  | ({
                        __typename: 'ComponentOrderedList'
                    } & ContentComponentItem_ComponentOrderedList_Fragment)
                  | ({
                        __typename: 'ComponentSpacer'
                    } & ContentComponentItem_ComponentSpacer_Fragment)
                  | ({
                        __typename: 'ComponentText'
                    } & ContentComponentItem_ComponentText_Fragment)
                  | ({
                        __typename: 'ComponentTitle'
                    } & ContentComponentItem_ComponentTitle_Fragment)
              >
          })
        | ({ __typename: 'ShopWithConfidenceResize' } & {
              content: Array<
                  | ({
                        __typename: 'ComponentButton'
                    } & ContentComponentItem_ComponentButton_Fragment)
                  | ({
                        __typename: 'ComponentImage'
                    } & ContentComponentItem_ComponentImage_Fragment)
                  | ({
                        __typename: 'ComponentOrderedList'
                    } & ContentComponentItem_ComponentOrderedList_Fragment)
                  | ({
                        __typename: 'ComponentSpacer'
                    } & ContentComponentItem_ComponentSpacer_Fragment)
                  | ({
                        __typename: 'ComponentText'
                    } & ContentComponentItem_ComponentText_Fragment)
                  | ({
                        __typename: 'ComponentTitle'
                    } & ContentComponentItem_ComponentTitle_Fragment)
              >
          })
        | ({ __typename: 'ShopWithConfidenceReturnPolicy' } & {
              content: Array<
                  | ({
                        __typename: 'ComponentButton'
                    } & ContentComponentItem_ComponentButton_Fragment)
                  | ({
                        __typename: 'ComponentImage'
                    } & ContentComponentItem_ComponentImage_Fragment)
                  | ({
                        __typename: 'ComponentOrderedList'
                    } & ContentComponentItem_ComponentOrderedList_Fragment)
                  | ({
                        __typename: 'ComponentSpacer'
                    } & ContentComponentItem_ComponentSpacer_Fragment)
                  | ({
                        __typename: 'ComponentText'
                    } & ContentComponentItem_ComponentText_Fragment)
                  | ({
                        __typename: 'ComponentTitle'
                    } & ContentComponentItem_ComponentTitle_Fragment)
              >
          })
        | ({ __typename: 'ShopWithConfidenceShipping' } & {
              content: Array<
                  | ({
                        __typename: 'ComponentButton'
                    } & ContentComponentItem_ComponentButton_Fragment)
                  | ({
                        __typename: 'ComponentImage'
                    } & ContentComponentItem_ComponentImage_Fragment)
                  | ({
                        __typename: 'ComponentOrderedList'
                    } & ContentComponentItem_ComponentOrderedList_Fragment)
                  | ({
                        __typename: 'ComponentSpacer'
                    } & ContentComponentItem_ComponentSpacer_Fragment)
                  | ({
                        __typename: 'ComponentText'
                    } & ContentComponentItem_ComponentText_Fragment)
                  | ({
                        __typename: 'ComponentTitle'
                    } & ContentComponentItem_ComponentTitle_Fragment)
              >
          })
    >
}

type ShopWithConfidenceProduct_CatalogueEngagementRing_Fragment = {
    __typename: 'CatalogueEngagementRing'
} & Pick<CatalogueEngagementRing, 'isResizeable' | 'isReturnable'> & {
        signatureStone: Maybe<{ __typename: 'Melee' }>
    }

type ShopWithConfidenceProduct_CatalogueJewelleryBracelet_Fragment = {
    __typename: 'CatalogueJewelleryBracelet'
} & Pick<CatalogueJewelleryBracelet, 'isReturnable'> & {
        signatureStone: Maybe<{ __typename: 'Melee' }>
    }

type ShopWithConfidenceProduct_CatalogueJewelleryEarrings_Fragment = {
    __typename: 'CatalogueJewelleryEarrings'
} & Pick<CatalogueJewelleryEarrings, 'isReturnable'> & {
        signatureStone: Maybe<{ __typename: 'Melee' }>
    }

type ShopWithConfidenceProduct_CatalogueJewelleryNecklace_Fragment = {
    __typename: 'CatalogueJewelleryNecklace'
} & Pick<CatalogueJewelleryNecklace, 'isReturnable'> & {
        signatureStone: Maybe<{ __typename: 'Melee' }>
    }

type ShopWithConfidenceProduct_CatalogueJewelleryRing_Fragment = {
    __typename: 'CatalogueJewelleryRing'
} & Pick<CatalogueJewelleryRing, 'isResizeable' | 'isReturnable'> & {
        signatureStone: Maybe<{ __typename: 'Melee' }>
    }

type ShopWithConfidenceProduct_CatalogueReadyToGoRing_Fragment = {
    __typename: 'CatalogueReadyToGoRing'
} & Pick<CatalogueReadyToGoRing, 'isReturnable'> & {
        signatureStone: Maybe<{ __typename: 'Melee' }>
    }

type ShopWithConfidenceProduct_CatalogueWeddingRing_Fragment = {
    __typename: 'CatalogueWeddingRing'
} & Pick<CatalogueWeddingRing, 'isResizeable' | 'isReturnable'> & {
        signatureStone: Maybe<{ __typename: 'Melee' }>
    }

export type ShopWithConfidenceProductFragment =
    | ShopWithConfidenceProduct_CatalogueEngagementRing_Fragment
    | ShopWithConfidenceProduct_CatalogueJewelleryBracelet_Fragment
    | ShopWithConfidenceProduct_CatalogueJewelleryEarrings_Fragment
    | ShopWithConfidenceProduct_CatalogueJewelleryNecklace_Fragment
    | ShopWithConfidenceProduct_CatalogueJewelleryRing_Fragment
    | ShopWithConfidenceProduct_CatalogueReadyToGoRing_Fragment
    | ShopWithConfidenceProduct_CatalogueWeddingRing_Fragment

export type ComponentSideBySideImagesFragment = {
    __typename: 'ComponentSideBySideImages'
} & {
    images: Array<
        {
            __typename: 'ComponentSideBySideImage'
        } & ComponentSideBySideImageFragment
    >
}

export type ComponentTableFragment = { __typename: 'ComponentTable' } & {
    table: Maybe<
        { __typename: 'Table' } & {
            header: Maybe<
                { __typename: 'TableHeader' } & Pick<TableHeader, 'cells'>
            >
            body: Maybe<
                { __typename: 'TableBody' } & {
                    rows: Maybe<
                        Array<
                            Maybe<
                                { __typename: 'TableRow' } & Pick<
                                    TableRow,
                                    'cells'
                                >
                            >
                        >
                    >
                }
            >
        }
    >
}

export type ComponentTextCarouselFragment = {
    __typename: 'ComponentTextCarousel'
} & {
    items: Array<
        { __typename: 'TextCarouselItem' } & Pick<TextCarouselItem, 'title'> & {
                carouselItemText: TextCarouselItem['text']
            }
    >
}

export type ComponentTextOverImageFragment = {
    __typename: 'ComponentTextOverImage'
} & {
    content: Array<
        | ({
              __typename: 'ComponentButton'
          } & ContentComponentItem_ComponentButton_Fragment)
        | ({
              __typename: 'ComponentImage'
          } & ContentComponentItem_ComponentImage_Fragment)
        | ({
              __typename: 'ComponentOrderedList'
          } & ContentComponentItem_ComponentOrderedList_Fragment)
        | ({
              __typename: 'ComponentSpacer'
          } & ContentComponentItem_ComponentSpacer_Fragment)
        | ({
              __typename: 'ComponentText'
          } & ContentComponentItem_ComponentText_Fragment)
        | ({
              __typename: 'ComponentTitle'
          } & ContentComponentItem_ComponentTitle_Fragment)
    >
    image: { __typename: 'Image' } & ImageLargeFragment
}

export type ComponentTextWithImageFragment = {
    __typename: 'ComponentTextWithImage'
} & Pick<
    ComponentTextWithImage,
    'padding' | 'imageFormat' | 'imagePosition'
> & {
        image: { __typename: 'Image' } & ImageLargeFragment
        content: Array<
            | ({
                  __typename: 'ComponentButton'
              } & ContentComponentItem_ComponentButton_Fragment)
            | ({
                  __typename: 'ComponentImage'
              } & ContentComponentItem_ComponentImage_Fragment)
            | ({
                  __typename: 'ComponentOrderedList'
              } & ContentComponentItem_ComponentOrderedList_Fragment)
            | ({
                  __typename: 'ComponentSpacer'
              } & ContentComponentItem_ComponentSpacer_Fragment)
            | ({
                  __typename: 'ComponentText'
              } & ContentComponentItem_ComponentText_Fragment)
            | ({
                  __typename: 'ComponentTitle'
              } & ContentComponentItem_ComponentTitle_Fragment)
        >
    }

export type ComponentTextWithImageCarouselFragment = {
    __typename: 'ComponentTextWithImageCarousel'
} & Pick<ComponentTextWithImageCarousel, 'slidePadding'> & {
        slides: Array<
            {
                __typename: 'ComponentTextWithImage'
            } & ComponentTextWithImageFragment
        >
    }

export type ComponentVideoFragment = { __typename: 'ComponentVideo' } & {
    videoWidth: ComponentVideo['width']
} & { video: { __typename: 'Video' } & VideoFragment }

export type ComponentVideoWithContentFragment = {
    __typename: 'ComponentVideoWithContent'
} & Pick<ComponentVideoWithContent, 'videoPosition'> & {
        coverImage: { __typename: 'Image' } & ImageLargeFragment
        content: Array<
            | ({
                  __typename: 'ComponentButton'
              } & ContentComponentItem_ComponentButton_Fragment)
            | ({
                  __typename: 'ComponentImage'
              } & ContentComponentItem_ComponentImage_Fragment)
            | ({
                  __typename: 'ComponentOrderedList'
              } & ContentComponentItem_ComponentOrderedList_Fragment)
            | ({
                  __typename: 'ComponentSpacer'
              } & ContentComponentItem_ComponentSpacer_Fragment)
            | ({
                  __typename: 'ComponentText'
              } & ContentComponentItem_ComponentText_Fragment)
            | ({
                  __typename: 'ComponentTitle'
              } & ContentComponentItem_ComponentTitle_Fragment)
        >
        video: { __typename: 'Video' } & VideoFragment
    }

type ContentComponentItem_ComponentButton_Fragment = {
    __typename: 'ComponentButton'
} & ComponentButtonFragment

type ContentComponentItem_ComponentImage_Fragment = {
    __typename: 'ComponentImage'
} & ComponentImageFragment

type ContentComponentItem_ComponentOrderedList_Fragment = {
    __typename: 'ComponentOrderedList'
} & ComponentOrderedListFragment

type ContentComponentItem_ComponentSpacer_Fragment = {
    __typename: 'ComponentSpacer'
} & ComponentSpacerFragment

type ContentComponentItem_ComponentText_Fragment = {
    __typename: 'ComponentText'
} & ComponentTextFragment

type ContentComponentItem_ComponentTitle_Fragment = {
    __typename: 'ComponentTitle'
} & ComponentTitleFragment

export type ContentComponentItemFragment =
    | ContentComponentItem_ComponentButton_Fragment
    | ContentComponentItem_ComponentImage_Fragment
    | ContentComponentItem_ComponentOrderedList_Fragment
    | ContentComponentItem_ComponentSpacer_Fragment
    | ContentComponentItem_ComponentText_Fragment
    | ContentComponentItem_ComponentTitle_Fragment

export type ArticleGridItemFragment = { __typename: 'ArticleGridItem' } & Pick<
    ArticleGridItem,
    'title' | 'description'
> & {
        image: { __typename: 'Image' } & ImageLargeFragment
        link: { __typename: 'Link' } & LinkFragment
    }

export type ArticlePreviewFragment = { __typename: 'ArticlePreview' } & Pick<
    ArticlePreview,
    'title' | 'subtitle'
> & {
        image: { __typename: 'Image' } & ImageLargeFragment
        link: { __typename: 'Link' } & LinkFragment
    }

export type BlogMenuFragment = { __typename: 'PostCategory' } & Pick<
    PostCategory,
    'id' | 'name' | 'slug'
> & {
        children: Maybe<
            Array<
                { __typename: 'PostCategory' } & Pick<
                    PostCategory,
                    'id' | 'name' | 'slug'
                >
            >
        >
    }

export type BlogPostPreviewFragment = { __typename: 'Post' } & Pick<
    Post,
    'id' | 'title' | 'slug' | 'excerpt' | 'date'
> & { featuredImage: { __typename: 'Image' } & ImageLargeFragment }

export type CardCarouselCardFragment = {
    __typename: 'CardCarouselCard'
} & Pick<CardCarouselCard, 'backgroundColor' | 'title' | 'description'> & {
        image: { __typename: 'Image' } & ImageLargeFragment
    }

export type ComponentCardCarouselFragment = {
    __typename: 'ComponentCardCarousel'
} & {
    items: Array<{ __typename: 'CardCarouselCard' } & CardCarouselCardFragment>
}

export type CustomProductCarouselCardFragment = {
    __typename: 'CarouselCustomProduct'
} & Pick<CarouselCustomProduct, 'description' | 'title'> & {
        image: { __typename: 'Image' } & ImageLargeFragment
        link: Maybe<{ __typename: 'Link' } & LinkFragment>
    }

export type GalleryCarouselCardFragment = {
    __typename: 'GalleryCarouselCard'
} & {
    image: { __typename: 'Image' } & ImageLargeFragment
    link: Maybe<{ __typename: 'Link' } & LinkFragment>
}

export type ComponentButtonFragment = { __typename: 'ComponentButton' } & Pick<
    ComponentButton,
    'text' | 'alignment'
> & {
        link: { __typename: 'Link' } & LinkFragment
        style: { __typename: 'ButtonStyle' } & Pick<
            ButtonStyle,
            | 'type'
            | 'size'
            | 'color'
            | 'width'
            | 'linkSize'
            | 'topSpacing'
            | 'bottomSpacing'
        >
        icon: Maybe<
            { __typename: 'ButtonIcon' } & Pick<ButtonIcon, 'position' | 'icon'>
        >
        eventTracking: Maybe<
            { __typename: 'ButtonEventTracking' } & Pick<
                ButtonEventTracking,
                'event' | 'category' | 'action' | 'label'
            >
        >
    }

export type ComponentImageFragment = { __typename: 'ComponentImage' } & {
    image: { __typename: 'Image' } & ImageLargeFragment
}

export type ComponentOrderedListFragment = {
    __typename: 'ComponentOrderedList'
} & {
    items: Array<{ __typename: 'OrderedListItem' } & OrderedListItemFragment>
}

export type ComponentSpacerFragment = { __typename: 'ComponentSpacer' } & Pick<
    ComponentSpacer,
    'spacing'
>

export type ComponentTextFragment = { __typename: 'ComponentText' } & Pick<
    ComponentText,
    'alignment' | 'text' | 'textSize'
>

export type ComponentTitleFragment = { __typename: 'ComponentTitle' } & Pick<
    ComponentTitle,
    | 'alignment'
    | 'tag'
    | 'text'
    | 'color'
    | 'titleSize'
    | 'titleStyle'
    | 'titleWidth'
> & {
        texts: Array<
            | ({
                  __typename: 'ComponentTitleAmpersand'
              } & ComponentTitleComponent_ComponentTitleAmpersand_Fragment)
            | ({
                  __typename: 'ComponentTitleText'
              } & ComponentTitleComponent_ComponentTitleText_Fragment)
        >
    }

export type ComponentTitleAmpersandFragment = {
    __typename: 'ComponentTitleAmpersand'
} & Pick<ComponentTitleAmpersand, 'null'>

type ComponentTitleComponent_ComponentTitleAmpersand_Fragment = {
    __typename: 'ComponentTitleAmpersand'
} & ComponentTitleAmpersandFragment

type ComponentTitleComponent_ComponentTitleText_Fragment = {
    __typename: 'ComponentTitleText'
} & ComponentTitleTextFragment

export type ComponentTitleComponentFragment =
    | ComponentTitleComponent_ComponentTitleAmpersand_Fragment
    | ComponentTitleComponent_ComponentTitleText_Fragment

export type ComponentTitleTextFragment = {
    __typename: 'ComponentTitleText'
} & Pick<ComponentTitleText, 'text'>

export type OrderedListItemFragment = { __typename: 'OrderedListItem' } & Pick<
    OrderedListItem,
    'title' | 'description'
>

export type FaqQuestionFragment = { __typename: 'FaqQuestion' } & Pick<
    FaqQuestion,
    'question' | 'expandedByDefault'
> & {
        content: Array<
            | ({
                  __typename: 'ComponentButton'
              } & ContentComponentItem_ComponentButton_Fragment)
            | ({
                  __typename: 'ComponentImage'
              } & ContentComponentItem_ComponentImage_Fragment)
            | ({
                  __typename: 'ComponentOrderedList'
              } & ContentComponentItem_ComponentOrderedList_Fragment)
            | ({
                  __typename: 'ComponentSpacer'
              } & ContentComponentItem_ComponentSpacer_Fragment)
            | ({
                  __typename: 'ComponentText'
              } & ContentComponentItem_ComponentText_Fragment)
            | ({
                  __typename: 'ComponentTitle'
              } & ContentComponentItem_ComponentTitle_Fragment)
        >
    }

export type FaqSectionFragment = { __typename: 'FaqSection' } & Pick<
    FaqSection,
    'title'
> & { questions: Array<{ __typename: 'FaqQuestion' } & FaqQuestionFragment> }

export type ComponentGalleryWithEnquiryFragment = {
    __typename: 'ComponentGalleryWithEnquiry'
} & Pick<ComponentGalleryWithEnquiry, 'type'> & {
        items: Array<
            {
                __typename: 'GalleryWithEnquiryCard'
            } & GalleryWithEnquiryCardFragment
        >
    }

export type GalleryWithEnquiryCardFragment = {
    __typename: 'GalleryWithEnquiryCard'
} & Pick<GalleryWithEnquiryCard, 'caption' | 'slug'> & {
        image: { __typename: 'Image' } & ImageLargeFragment
    }

export type QuestionnaireFragment = { __typename: 'Questionnaire' } & Pick<
    Questionnaire,
    'id' | 'title' | 'type'
> & {
        steps: Array<
            { __typename: 'QuestionnaireStep' } & QuestionnaireStepFragment
        >
        signUpStep: {
            __typename: 'QuestionnaireSignUpStep'
        } & QuestionnaireSignUpStepFragment
        redirectLink:
            | ({
                  __typename: 'LinkItemAffirm'
              } & LinkItem_LinkItemAffirm_Fragment)
            | ({
                  __typename: 'LinkItemBookingForm'
              } & LinkItem_LinkItemBookingForm_Fragment)
            | ({
                  __typename: 'LinkItemCustom'
              } & LinkItem_LinkItemCustom_Fragment)
            | ({
                  __typename: 'LinkItemOpenContactForm'
              } & LinkItem_LinkItemOpenContactForm_Fragment)
            | ({
                  __typename: 'LinkItemOpenEnquiryForm'
              } & LinkItem_LinkItemOpenEnquiryForm_Fragment)
            | ({
                  __typename: 'LinkItemOpenSpeakToExpertModal'
              } & LinkItem_LinkItemOpenSpeakToExpertModal_Fragment)
            | ({ __typename: 'Page' } & LinkItem_Page_Fragment)
            | ({ __typename: 'Post' } & LinkItem_Post_Fragment)
            | ({
                  __typename: 'Questionnaire'
              } & LinkItem_Questionnaire_Fragment)
    }

export type QuestionnaireSignUpStepFragment = {
    __typename: 'QuestionnaireSignUpStep'
} & Pick<
    QuestionnaireSignUpStep,
    'title' | 'description' | 'backgroundColor'
> & { image: { __typename: 'Image' } & ImageLargeFragment }

export type QuestionnaireStepFragment = {
    __typename: 'QuestionnaireStep'
} & Pick<
    QuestionnaireStep,
    'title' | 'description' | 'excludeFromProgressIndicator'
> & {
        content: Array<
            | ({
                  __typename: 'QuestionnaireStepContentContent'
              } & QuestionnaireStepContentContentFragment)
            | ({
                  __typename: 'QuestionnaireStepContentQuestions'
              } & QuestionnaireStepContentQuestionsFragment)
        >
        conditions: Array<
            {
                __typename: 'QuestionnaireCondition'
            } & QuestionnaireConditionFragment
        >
        help: Array<{ __typename: 'Block' } & BlockFragment>
    }

export type QuestionnaireConditionFragment = {
    __typename: 'QuestionnaireCondition'
} & Pick<QuestionnaireCondition, 'type'> & {
        rules: Array<
            | ({
                  __typename: 'QuestionnaireConditionEqualToChoice'
              } & QuestionnaireConditionEqualToChoiceFragment)
            | ({
                  __typename: 'QuestionnaireConditionIsEmpty'
              } & QuestionnaireConditionIsEmptyFragment)
            | ({
                  __typename: 'QuestionnaireConditionIsEqualTo'
              } & QuestionnaireConditionIsEqualToFragment)
            | ({
                  __typename: 'QuestionnaireConditionIsGreaterThan'
              } & QuestionnaireConditionIsGreaterThanFragment)
            | ({
                  __typename: 'QuestionnaireConditionIsLessThan'
              } & QuestionnaireConditionIsLessThanFragment)
            | ({
                  __typename: 'QuestionnaireConditionIsNotEmpty'
              } & QuestionnaireConditionIsNotEmptyFragment)
            | ({
                  __typename: 'QuestionnaireConditionNotIsEqualTo'
              } & QuestionnaireConditionNotIsEqualToFragment)
        >
    }

export type QuestionnaireConditionEqualToChoiceFragment = {
    __typename: 'QuestionnaireConditionEqualToChoice'
} & {
    question:
        | ({ __typename: 'QuestionnaireQuestionChoice' } & Pick<
              QuestionnaireQuestionChoice,
              'id'
          >)
        | ({ __typename: 'QuestionnaireQuestionPrice' } & Pick<
              QuestionnaireQuestionPrice,
              'id'
          >)
        | ({ __typename: 'QuestionnaireQuestionText' } & Pick<
              QuestionnaireQuestionText,
              'id'
          >)
    choice: Maybe<
        { __typename: 'QuestionnaireQuestionChoiceOption' } & Pick<
            QuestionnaireQuestionChoiceOption,
            'id'
        >
    >
}

export type QuestionnaireConditionIsEmptyFragment = {
    __typename: 'QuestionnaireConditionIsEmpty'
} & {
    question:
        | ({ __typename: 'QuestionnaireQuestionChoice' } & Pick<
              QuestionnaireQuestionChoice,
              'id'
          >)
        | ({ __typename: 'QuestionnaireQuestionPrice' } & Pick<
              QuestionnaireQuestionPrice,
              'id'
          >)
        | ({ __typename: 'QuestionnaireQuestionText' } & Pick<
              QuestionnaireQuestionText,
              'id'
          >)
}

export type QuestionnaireConditionIsEqualToFragment = {
    __typename: 'QuestionnaireConditionIsEqualTo'
} & { valueString: QuestionnaireConditionIsEqualTo['value'] } & {
    question:
        | ({ __typename: 'QuestionnaireQuestionChoice' } & Pick<
              QuestionnaireQuestionChoice,
              'id'
          >)
        | ({ __typename: 'QuestionnaireQuestionPrice' } & Pick<
              QuestionnaireQuestionPrice,
              'id'
          >)
        | ({ __typename: 'QuestionnaireQuestionText' } & Pick<
              QuestionnaireQuestionText,
              'id'
          >)
}

export type QuestionnaireConditionIsGreaterThanFragment = {
    __typename: 'QuestionnaireConditionIsGreaterThan'
} & Pick<QuestionnaireConditionIsGreaterThan, 'value'> & {
        question:
            | ({ __typename: 'QuestionnaireQuestionChoice' } & Pick<
                  QuestionnaireQuestionChoice,
                  'id'
              >)
            | ({ __typename: 'QuestionnaireQuestionPrice' } & Pick<
                  QuestionnaireQuestionPrice,
                  'id'
              >)
            | ({ __typename: 'QuestionnaireQuestionText' } & Pick<
                  QuestionnaireQuestionText,
                  'id'
              >)
    }

export type QuestionnaireConditionIsLessThanFragment = {
    __typename: 'QuestionnaireConditionIsLessThan'
} & Pick<QuestionnaireConditionIsLessThan, 'value'> & {
        question:
            | ({ __typename: 'QuestionnaireQuestionChoice' } & Pick<
                  QuestionnaireQuestionChoice,
                  'id'
              >)
            | ({ __typename: 'QuestionnaireQuestionPrice' } & Pick<
                  QuestionnaireQuestionPrice,
                  'id'
              >)
            | ({ __typename: 'QuestionnaireQuestionText' } & Pick<
                  QuestionnaireQuestionText,
                  'id'
              >)
    }

export type QuestionnaireConditionIsNotEmptyFragment = {
    __typename: 'QuestionnaireConditionIsNotEmpty'
} & {
    question:
        | ({ __typename: 'QuestionnaireQuestionChoice' } & Pick<
              QuestionnaireQuestionChoice,
              'id'
          >)
        | ({ __typename: 'QuestionnaireQuestionPrice' } & Pick<
              QuestionnaireQuestionPrice,
              'id'
          >)
        | ({ __typename: 'QuestionnaireQuestionText' } & Pick<
              QuestionnaireQuestionText,
              'id'
          >)
}

export type QuestionnaireConditionNotIsEqualToFragment = {
    __typename: 'QuestionnaireConditionNotIsEqualTo'
} & { valueString: QuestionnaireConditionNotIsEqualTo['value'] } & {
    question:
        | ({ __typename: 'QuestionnaireQuestionChoice' } & Pick<
              QuestionnaireQuestionChoice,
              'id'
          >)
        | ({ __typename: 'QuestionnaireQuestionPrice' } & Pick<
              QuestionnaireQuestionPrice,
              'id'
          >)
        | ({ __typename: 'QuestionnaireQuestionText' } & Pick<
              QuestionnaireQuestionText,
              'id'
          >)
}

export type QuestionnaireStepContentContentFragment = {
    __typename: 'QuestionnaireStepContentContent'
} & {
    blocks: Array<{ __typename: 'Block' } & BlockFragment>
    conditions: Array<
        {
            __typename: 'QuestionnaireCondition'
        } & QuestionnaireConditionFragment
    >
}

type QuestionnaireQuestion_QuestionnaireQuestionChoice_Fragment = {
    __typename: 'QuestionnaireQuestionChoice'
} & Pick<QuestionnaireQuestionChoice, 'id' | 'title' | 'required'> &
    QuestionnaireQuestionChoiceFragment

type QuestionnaireQuestion_QuestionnaireQuestionPrice_Fragment = {
    __typename: 'QuestionnaireQuestionPrice'
} & Pick<QuestionnaireQuestionPrice, 'id' | 'title' | 'required'> &
    QuestionnaireQuestionPriceFragment

type QuestionnaireQuestion_QuestionnaireQuestionText_Fragment = {
    __typename: 'QuestionnaireQuestionText'
} & Pick<QuestionnaireQuestionText, 'id' | 'title' | 'required'> &
    QuestionnaireQuestionTextFragment

export type QuestionnaireQuestionFragment =
    | QuestionnaireQuestion_QuestionnaireQuestionChoice_Fragment
    | QuestionnaireQuestion_QuestionnaireQuestionPrice_Fragment
    | QuestionnaireQuestion_QuestionnaireQuestionText_Fragment

export type QuestionnaireQuestionChoiceFragment = {
    __typename: 'QuestionnaireQuestionChoice'
} & Pick<
    QuestionnaireQuestionChoice,
    'id' | 'title' | 'multiple' | 'required'
> & {
        options: Array<
            {
                __typename: 'QuestionnaireQuestionChoiceOption'
            } & QuestionnaireQuestionChoiceOptionFragment
        >
    }

export type QuestionnaireQuestionPriceFragment = {
    __typename: 'QuestionnaireQuestionPrice'
} & Pick<
    QuestionnaireQuestionPrice,
    'id' | 'title' | 'required' | 'tooltip' | 'min' | 'max'
>

export type QuestionnaireQuestionTextFragment = {
    __typename: 'QuestionnaireQuestionText'
} & Pick<QuestionnaireQuestionText, 'id' | 'title' | 'required' | 'textarea'>

export type QuestionnaireStepContentQuestionsFragment = {
    __typename: 'QuestionnaireStepContentQuestions'
} & {
    questions: Array<
        | ({
              __typename: 'QuestionnaireQuestionChoice'
          } & QuestionnaireQuestion_QuestionnaireQuestionChoice_Fragment)
        | ({
              __typename: 'QuestionnaireQuestionPrice'
          } & QuestionnaireQuestion_QuestionnaireQuestionPrice_Fragment)
        | ({
              __typename: 'QuestionnaireQuestionText'
          } & QuestionnaireQuestion_QuestionnaireQuestionText_Fragment)
    >
    conditions: Array<
        {
            __typename: 'QuestionnaireCondition'
        } & QuestionnaireConditionFragment
    >
}

export type QuestionnaireQuestionChoiceOptionFragment = {
    __typename: 'QuestionnaireQuestionChoiceOption'
} & Pick<QuestionnaireQuestionChoiceOption, 'id'> & {
        content:
            | ({
                  __typename: 'QuestionnaireQuestionChoiceOptionContentIconCard'
              } & QuestionnaireQuestionChoiceOptionContent_QuestionnaireQuestionChoiceOptionContentIconCard_Fragment)
            | ({
                  __typename: 'QuestionnaireQuestionChoiceOptionContentImage'
              } & QuestionnaireQuestionChoiceOptionContent_QuestionnaireQuestionChoiceOptionContentImage_Fragment)
            | ({
                  __typename: 'QuestionnaireQuestionChoiceOptionContentImageCard'
              } & QuestionnaireQuestionChoiceOptionContent_QuestionnaireQuestionChoiceOptionContentImageCard_Fragment)
            | ({
                  __typename: 'QuestionnaireQuestionChoiceOptionContentText'
              } & QuestionnaireQuestionChoiceOptionContent_QuestionnaireQuestionChoiceOptionContentText_Fragment)
        behaviour: Maybe<
            {
                __typename: 'QuestionnaireQuestionChoiceOptionBehaviour'
            } & QuestionnaireQuestionChoiceOptionBehaviourFragment
        >
    }

type QuestionnaireQuestionChoiceOptionContent_QuestionnaireQuestionChoiceOptionContentIconCard_Fragment =
    {
        __typename: 'QuestionnaireQuestionChoiceOptionContentIconCard'
    } & QuestionnaireQuestionChoiceOptionContentIconCardFragment

type QuestionnaireQuestionChoiceOptionContent_QuestionnaireQuestionChoiceOptionContentImage_Fragment =
    {
        __typename: 'QuestionnaireQuestionChoiceOptionContentImage'
    } & QuestionnaireQuestionChoiceOptionContentImageFragment

type QuestionnaireQuestionChoiceOptionContent_QuestionnaireQuestionChoiceOptionContentImageCard_Fragment =
    {
        __typename: 'QuestionnaireQuestionChoiceOptionContentImageCard'
    } & QuestionnaireQuestionChoiceOptionContentImageCardFragment

type QuestionnaireQuestionChoiceOptionContent_QuestionnaireQuestionChoiceOptionContentText_Fragment =
    {
        __typename: 'QuestionnaireQuestionChoiceOptionContentText'
    } & QuestionnaireQuestionChoiceOptionContentTextFragment

export type QuestionnaireQuestionChoiceOptionContentFragment =
    | QuestionnaireQuestionChoiceOptionContent_QuestionnaireQuestionChoiceOptionContentIconCard_Fragment
    | QuestionnaireQuestionChoiceOptionContent_QuestionnaireQuestionChoiceOptionContentImage_Fragment
    | QuestionnaireQuestionChoiceOptionContent_QuestionnaireQuestionChoiceOptionContentImageCard_Fragment
    | QuestionnaireQuestionChoiceOptionContent_QuestionnaireQuestionChoiceOptionContentText_Fragment

export type QuestionnaireQuestionChoiceOptionContentIconCardFragment = {
    __typename: 'QuestionnaireQuestionChoiceOptionContentIconCard'
} & Pick<
    QuestionnaireQuestionChoiceOptionContentIconCard,
    'title' | 'description' | 'backgroundColor'
> & {
        icon: { __typename: 'Image' } & Pick<Image, 'url'> & ImageLargeFragment
        conditionalContent: Array<
            {
                __typename: 'QuestionnaireQuestionChoiceOptionContentIconCardConditional'
            } & QuestionnaireQuestionChoiceOptionContentIconCardConditionalFragment
        >
    }

export type QuestionnaireQuestionChoiceOptionContentIconCardConditionalFragment =
    {
        __typename: 'QuestionnaireQuestionChoiceOptionContentIconCardConditional'
    } & Pick<
        QuestionnaireQuestionChoiceOptionContentIconCardConditional,
        'title' | 'description'
    > & {
            icon: { __typename: 'Image' } & ImageLargeFragment
            conditions: Array<
                {
                    __typename: 'QuestionnaireCondition'
                } & QuestionnaireConditionFragment
            >
        }

export type QuestionnaireQuestionChoiceOptionContentImageFragment = {
    __typename: 'QuestionnaireQuestionChoiceOptionContentImage'
} & {
    image: { __typename: 'Image' } & Pick<Image, 'url'> & ImageLargeFragment
    conditionalContent: Array<
        {
            __typename: 'QuestionnaireQuestionChoiceOptionContentImageConditional'
        } & QuestionnaireQuestionChoiceOptionContentImageConditionalFragment
    >
}

export type QuestionnaireQuestionChoiceOptionContentImageCardFragment = {
    __typename: 'QuestionnaireQuestionChoiceOptionContentImageCard'
} & Pick<
    QuestionnaireQuestionChoiceOptionContentImageCard,
    'title' | 'description'
> & {
        image: { __typename: 'Image' } & Pick<Image, 'url'> & ImageLargeFragment
        conditionalContent: Array<
            {
                __typename: 'QuestionnaireQuestionChoiceOptionContentImageCardConditional'
            } & QuestionnaireQuestionChoiceOptionContentImageCardConditionalFragment
        >
    }

export type QuestionnaireQuestionChoiceOptionContentImageCardConditionalFragment =
    {
        __typename: 'QuestionnaireQuestionChoiceOptionContentImageCardConditional'
    } & Pick<
        QuestionnaireQuestionChoiceOptionContentImageCardConditional,
        'title' | 'description'
    > & {
            image: { __typename: 'Image' } & ImageLargeFragment
            conditions: Array<
                {
                    __typename: 'QuestionnaireCondition'
                } & QuestionnaireConditionFragment
            >
        }

export type QuestionnaireQuestionChoiceOptionContentImageConditionalFragment = {
    __typename: 'QuestionnaireQuestionChoiceOptionContentImageConditional'
} & {
    image: { __typename: 'Image' } & ImageLargeFragment
    conditions: Array<
        {
            __typename: 'QuestionnaireCondition'
        } & QuestionnaireConditionFragment
    >
}

export type QuestionnaireQuestionChoiceOptionContentTextFragment = {
    __typename: 'QuestionnaireQuestionChoiceOptionContentText'
} & Pick<
    QuestionnaireQuestionChoiceOptionContentText,
    'title' | 'description'
> & {
        conditionalContent: Array<
            {
                __typename: 'QuestionnaireQuestionChoiceOptionContentTextConditional'
            } & QuestionnaireQuestionChoiceOptionContentTextConditionalFragment
        >
    }

export type QuestionnaireQuestionChoiceOptionContentTextConditionalFragment = {
    __typename: 'QuestionnaireQuestionChoiceOptionContentTextConditional'
} & Pick<
    QuestionnaireQuestionChoiceOptionContentTextConditional,
    'title' | 'description'
> & {
        conditions: Array<
            {
                __typename: 'QuestionnaireCondition'
            } & QuestionnaireConditionFragment
        >
    }

export type QuestionnaireQuestionChoiceOptionBehaviourFragment = {
    __typename: 'QuestionnaireQuestionChoiceOptionBehaviour'
} & Pick<
    QuestionnaireQuestionChoiceOptionBehaviour,
    'metal' | 'ringStyle' | 'designStyle' | 'designFeature' | 'shape'
>

export type ComponentSideBySideImageFragment = {
    __typename: 'ComponentSideBySideImage'
} & Pick<ComponentSideBySideImage, 'caption'> & {
        image: { __typename: 'Image' } & ImageLargeFragment
        content: Array<
            | ({
                  __typename: 'ComponentButton'
              } & ContentComponentItem_ComponentButton_Fragment)
            | ({
                  __typename: 'ComponentImage'
              } & ContentComponentItem_ComponentImage_Fragment)
            | ({
                  __typename: 'ComponentOrderedList'
              } & ContentComponentItem_ComponentOrderedList_Fragment)
            | ({
                  __typename: 'ComponentSpacer'
              } & ContentComponentItem_ComponentSpacer_Fragment)
            | ({
                  __typename: 'ComponentText'
              } & ContentComponentItem_ComponentText_Fragment)
            | ({
                  __typename: 'ComponentTitle'
              } & ContentComponentItem_ComponentTitle_Fragment)
        >
        link: Maybe<{ __typename: 'Link' } & LinkFragment>
    }

export type ComponentSquareBoxesFragment = {
    __typename: 'ComponentSquareBoxes'
} & {
    items: Array<
        | ({
              __typename: 'SquareImageBox'
          } & SquareBoxes_SquareImageBox_Fragment)
        | ({ __typename: 'SquareTextBox' } & SquareBoxes_SquareTextBox_Fragment)
    >
}

export type SquareImageBoxFragment = { __typename: 'SquareImageBox' } & {
    image: { __typename: 'Image' } & ImageMediumFragment
    link: Maybe<{ __typename: 'Link' } & LinkFragment>
}

export type SquareTextBoxFragment = { __typename: 'SquareTextBox' } & Pick<
    SquareTextBox,
    'backgroundColor'
> & {
        content: Array<
            | ({
                  __typename: 'ComponentButton'
              } & ContentComponentItem_ComponentButton_Fragment)
            | ({
                  __typename: 'ComponentImage'
              } & ContentComponentItem_ComponentImage_Fragment)
            | ({
                  __typename: 'ComponentOrderedList'
              } & ContentComponentItem_ComponentOrderedList_Fragment)
            | ({
                  __typename: 'ComponentSpacer'
              } & ContentComponentItem_ComponentSpacer_Fragment)
            | ({
                  __typename: 'ComponentText'
              } & ContentComponentItem_ComponentText_Fragment)
            | ({
                  __typename: 'ComponentTitle'
              } & ContentComponentItem_ComponentTitle_Fragment)
        >
    }

type SquareBoxes_SquareImageBox_Fragment = {
    __typename: 'SquareImageBox'
} & SquareImageBoxFragment

type SquareBoxes_SquareTextBox_Fragment = {
    __typename: 'SquareTextBox'
} & SquareTextBoxFragment

export type SquareBoxesFragment =
    | SquareBoxes_SquareImageBox_Fragment
    | SquareBoxes_SquareTextBox_Fragment

export type VideoFragment = { __typename: 'Video' } & Pick<Video, 'id' | 'url'>

export type EnquiryResponseExistingCustomerFragment = {
    __typename: 'EnquiryResponseExistingCustomer'
} & Pick<EnquiryResponseExistingCustomer, 'marketingCloudForm'>

export type EnquiryResponseNewCustomerFragment = {
    __typename: 'EnquiryResponseNewCustomer'
} & {
    customer: {
        __typename: 'CustomerRegistrationResponse'
    } & CustomerRegistrationResponseFragment
}

export type CreateEnquiryContactUsExistingCustomerMutationVariables = Exact<{
    input: EnquiryContactUsInput
}>

export type CreateEnquiryContactUsExistingCustomerMutation = {
    __typename: 'Mutation'
} & {
    createEnquiryContactUsExistingCustomer: {
        __typename: 'EnquiryResponseExistingCustomer'
    }
}

export type CreateEnquiryContactUsNewCustomerMutationVariables = Exact<{
    input: EnquiryContactUsInput
    customer: CustomerRegistrationInput
    isConsultant: Scalars['Boolean']['input']
}>

export type CreateEnquiryContactUsNewCustomerMutation = {
    __typename: 'Mutation'
} & {
    createEnquiryContactUsNewCustomer: {
        __typename: 'EnquiryResponseNewCustomer'
    } & EnquiryResponseNewCustomerFragment
}

export type CreateEnquiryExistingCustomerMutationVariables = Exact<{
    input: EnquiryInput
}>

export type CreateEnquiryExistingCustomerMutation = {
    __typename: 'Mutation'
} & {
    createEnquiryExistingCustomer: {
        __typename: 'EnquiryResponseExistingCustomer'
    }
}

export type CreateEnquiryNewCustomerMutationVariables = Exact<{
    input: EnquiryInput
    customer: CustomerRegistrationInput
    isConsultant: Scalars['Boolean']['input']
}>

export type CreateEnquiryNewCustomerMutation = { __typename: 'Mutation' } & {
    createEnquiryNewCustomer: {
        __typename: 'EnquiryResponseNewCustomer'
    } & EnquiryResponseNewCustomerFragment
}

export type AvatarStackItemFragment = { __typename: 'AvatarStackItem' } & {
    image: { __typename: 'Image' } & ImageLargeFragment
}

type ProductCard_CatalogueEngagementRing_Fragment = {
    __typename: 'CatalogueEngagementRing'
} & Pick<CatalogueEngagementRing, 'catalogueCode' | 'productName'> & {
        centreStoneConstraints: {
            __typename: 'CatalogueEngagementRingCentreStoneConstraints'
        } & {
            shape: { __typename: 'StoneShape' } & Pick<StoneShape, 'systemCode'>
        }
        translation: {
            __typename: 'CatalogueEngagementRingTranslation'
        } & Pick<CatalogueEngagementRingTranslation, 'seoText' | 'description'>
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'url'> & {
                    medium: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                    medium_x2: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                }
        >
    } & ProductLink_CatalogueEngagementRing_Fragment &
    MetalVariation_CatalogueEngagementRing_Fragment &
    GetIsLabGrown_CatalogueEngagementRing_Fragment

type ProductCard_CatalogueJewelleryBracelet_Fragment = {
    __typename: 'CatalogueJewelleryBracelet'
} & Pick<CatalogueJewelleryBracelet, 'catalogueCode' | 'productName'> & {
        translation: {
            __typename: 'CatalogueJewelleryBraceletTranslation'
        } & Pick<CatalogueJewelleryBraceletTranslation, 'description'>
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'url'> & {
                    medium: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                    medium_x2: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                }
        >
    } & ProductLink_CatalogueJewelleryBracelet_Fragment &
    MetalVariation_CatalogueJewelleryBracelet_Fragment &
    GetIsLabGrown_CatalogueJewelleryBracelet_Fragment

type ProductCard_CatalogueJewelleryEarrings_Fragment = {
    __typename: 'CatalogueJewelleryEarrings'
} & Pick<CatalogueJewelleryEarrings, 'catalogueCode' | 'productName'> & {
        translation: {
            __typename: 'CatalogueJewelleryEarringsTranslation'
        } & Pick<CatalogueJewelleryEarringsTranslation, 'description'>
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'url'> & {
                    medium: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                    medium_x2: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                }
        >
    } & ProductLink_CatalogueJewelleryEarrings_Fragment &
    MetalVariation_CatalogueJewelleryEarrings_Fragment &
    GetIsLabGrown_CatalogueJewelleryEarrings_Fragment

type ProductCard_CatalogueJewelleryNecklace_Fragment = {
    __typename: 'CatalogueJewelleryNecklace'
} & Pick<CatalogueJewelleryNecklace, 'catalogueCode' | 'productName'> & {
        translation: {
            __typename: 'CatalogueJewelleryNecklaceTranslation'
        } & Pick<CatalogueJewelleryNecklaceTranslation, 'description'>
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'url'> & {
                    medium: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                    medium_x2: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                }
        >
    } & ProductLink_CatalogueJewelleryNecklace_Fragment &
    MetalVariation_CatalogueJewelleryNecklace_Fragment &
    GetIsLabGrown_CatalogueJewelleryNecklace_Fragment

type ProductCard_CatalogueJewelleryRing_Fragment = {
    __typename: 'CatalogueJewelleryRing'
} & Pick<CatalogueJewelleryRing, 'catalogueCode' | 'productName'> & {
        translation: { __typename: 'CatalogueJewelleryRingTranslation' } & Pick<
            CatalogueJewelleryRingTranslation,
            'description'
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'url'> & {
                    medium: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                    medium_x2: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                }
        >
    } & ProductLink_CatalogueJewelleryRing_Fragment &
    MetalVariation_CatalogueJewelleryRing_Fragment &
    GetIsLabGrown_CatalogueJewelleryRing_Fragment

type ProductCard_CatalogueReadyToGoRing_Fragment = {
    __typename: 'CatalogueReadyToGoRing'
} & Pick<
    CatalogueReadyToGoRing,
    'shortName' | 'shortDescription' | 'catalogueCode' | 'productName'
> & {
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'url'> & {
                    medium: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                    medium_x2: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                }
        >
    } & ProductLink_CatalogueReadyToGoRing_Fragment &
    MetalVariation_CatalogueReadyToGoRing_Fragment &
    GetIsLabGrown_CatalogueReadyToGoRing_Fragment

type ProductCard_CatalogueWeddingRing_Fragment = {
    __typename: 'CatalogueWeddingRing'
} & Pick<CatalogueWeddingRing, 'catalogueCode' | 'productName'> & {
        translation: { __typename: 'CatalogueWeddingRingTranslation' } & Pick<
            CatalogueWeddingRingTranslation,
            'seoText' | 'description'
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'url'> & {
                    medium: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                    medium_x2: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                }
        >
    } & ProductLink_CatalogueWeddingRing_Fragment &
    MetalVariation_CatalogueWeddingRing_Fragment &
    GetIsLabGrown_CatalogueWeddingRing_Fragment

export type ProductCardFragment =
    | ProductCard_CatalogueEngagementRing_Fragment
    | ProductCard_CatalogueJewelleryBracelet_Fragment
    | ProductCard_CatalogueJewelleryEarrings_Fragment
    | ProductCard_CatalogueJewelleryNecklace_Fragment
    | ProductCard_CatalogueJewelleryRing_Fragment
    | ProductCard_CatalogueReadyToGoRing_Fragment
    | ProductCard_CatalogueWeddingRing_Fragment

export type FooterFragment = { __typename: 'Footer' } & Pick<
    Footer,
    'copyright'
> & {
        columns: Array<{ __typename: 'FooterColumn' } & FooterMenuFragment>
        logos: Array<
            { __typename: 'FooterLogo' } & Pick<FooterLogo, 'link'> & {
                    logo: { __typename: 'Image' } & ImageLargeFragment
                }
        >
    }

export type FooterItemDividerFragment = {
    __typename: 'FooterColumnItemSeparator'
} & Pick<FooterColumnItemSeparator, 'line'>

export type FooterItemLinkListFragment = {
    __typename: 'FooterColumnItemLinkList'
} & {
    links: Array<
        { __typename: 'FooterColumnItemLink' } & Pick<
            FooterColumnItemLink,
            'text'
        > & { link: { __typename: 'Link' } & LinkFragment }
    >
}

export type FooterItemTextFragment = {
    __typename: 'FooterColumnItemText'
} & Pick<FooterColumnItemText, 'text'>

export type FooterItemTitleFragment = {
    __typename: 'FooterColumnItemTitle'
} & Pick<FooterColumnItemTitle, 'title'>

export type FooterItemWorkingHoursFragment = {
    __typename: 'FooterColumnItemWorkingHours'
} & {
    workingHours: Array<{ __typename: 'WorkingHours' } & WorkingHoursFragment>
}

export type FooterMenuFragment = { __typename: 'FooterColumn' } & {
    items: Array<
        | ({
              __typename: 'FooterColumnItemLinkList'
          } & FooterMenuItem_FooterColumnItemLinkList_Fragment)
        | ({
              __typename: 'FooterColumnItemSeparator'
          } & FooterMenuItem_FooterColumnItemSeparator_Fragment)
        | ({
              __typename: 'FooterColumnItemText'
          } & FooterMenuItem_FooterColumnItemText_Fragment)
        | ({
              __typename: 'FooterColumnItemTitle'
          } & FooterMenuItem_FooterColumnItemTitle_Fragment)
        | ({
              __typename: 'FooterColumnItemWorkingHours'
          } & FooterMenuItem_FooterColumnItemWorkingHours_Fragment)
    >
}

type FooterMenuItem_FooterColumnItemLinkList_Fragment = {
    __typename: 'FooterColumnItemLinkList'
} & FooterItemLinkListFragment

type FooterMenuItem_FooterColumnItemSeparator_Fragment = {
    __typename: 'FooterColumnItemSeparator'
} & FooterItemDividerFragment

type FooterMenuItem_FooterColumnItemText_Fragment = {
    __typename: 'FooterColumnItemText'
} & FooterItemTextFragment

type FooterMenuItem_FooterColumnItemTitle_Fragment = {
    __typename: 'FooterColumnItemTitle'
} & FooterItemTitleFragment

type FooterMenuItem_FooterColumnItemWorkingHours_Fragment = {
    __typename: 'FooterColumnItemWorkingHours'
} & FooterItemWorkingHoursFragment

export type FooterMenuItemFragment =
    | FooterMenuItem_FooterColumnItemLinkList_Fragment
    | FooterMenuItem_FooterColumnItemSeparator_Fragment
    | FooterMenuItem_FooterColumnItemText_Fragment
    | FooterMenuItem_FooterColumnItemTitle_Fragment
    | FooterMenuItem_FooterColumnItemWorkingHours_Fragment

type ProductGallery_CatalogueEngagementRing_Fragment = {
    __typename: 'CatalogueEngagementRing'
} & Pick<CatalogueEngagementRing, 'productName' | 'suffix'> & {
        images360: Array<{ __typename: 'GenericImage' } & ThreeSixtyFragment>
        video: Maybe<{ __typename: 'CatalogueVideo' } & CatalogueVideoFragment>
        centreStoneConstraints: {
            __typename: 'CatalogueEngagementRingCentreStoneConstraints'
        } & {
            shape: { __typename: 'StoneShape' } & {
                translation: { __typename: 'StoneShapeTranslation' } & Pick<
                    StoneShapeTranslation,
                    'name'
                >
            }
        }
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'id'> & {
                    large: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                    large_x2: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                }
        >
    }

type ProductGallery_CatalogueJewelleryBracelet_Fragment = {
    __typename: 'CatalogueJewelleryBracelet'
} & Pick<CatalogueJewelleryBracelet, 'productName' | 'suffix'> & {
        images360: Array<{ __typename: 'GenericImage' } & ThreeSixtyFragment>
        video: Maybe<{ __typename: 'CatalogueVideo' } & CatalogueVideoFragment>
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'id'> & {
                    large: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                    large_x2: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                }
        >
    }

type ProductGallery_CatalogueJewelleryEarrings_Fragment = {
    __typename: 'CatalogueJewelleryEarrings'
} & Pick<CatalogueJewelleryEarrings, 'productName' | 'suffix'> & {
        images360: Array<{ __typename: 'GenericImage' } & ThreeSixtyFragment>
        video: Maybe<{ __typename: 'CatalogueVideo' } & CatalogueVideoFragment>
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'id'> & {
                    large: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                    large_x2: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                }
        >
    }

type ProductGallery_CatalogueJewelleryNecklace_Fragment = {
    __typename: 'CatalogueJewelleryNecklace'
} & Pick<CatalogueJewelleryNecklace, 'productName' | 'suffix'> & {
        images360: Array<{ __typename: 'GenericImage' } & ThreeSixtyFragment>
        video: Maybe<{ __typename: 'CatalogueVideo' } & CatalogueVideoFragment>
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'id'> & {
                    large: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                    large_x2: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                }
        >
    }

type ProductGallery_CatalogueJewelleryRing_Fragment = {
    __typename: 'CatalogueJewelleryRing'
} & Pick<CatalogueJewelleryRing, 'productName' | 'suffix'> & {
        images360: Array<{ __typename: 'GenericImage' } & ThreeSixtyFragment>
        video: Maybe<{ __typename: 'CatalogueVideo' } & CatalogueVideoFragment>
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'id'> & {
                    large: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                    large_x2: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                }
        >
    }

type ProductGallery_CatalogueReadyToGoRing_Fragment = {
    __typename: 'CatalogueReadyToGoRing'
} & Pick<CatalogueReadyToGoRing, 'productName' | 'suffix'> & {
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'id'> & {
                    large: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                    large_x2: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                }
        >
    }

type ProductGallery_CatalogueWeddingRing_Fragment = {
    __typename: 'CatalogueWeddingRing'
} & Pick<CatalogueWeddingRing, 'productName' | 'suffix'> & {
        images360: Array<{ __typename: 'GenericImage' } & ThreeSixtyFragment>
        video: Maybe<{ __typename: 'CatalogueVideo' } & CatalogueVideoFragment>
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'id'> & {
                    large: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                    large_x2: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                }
        >
    }

export type ProductGalleryFragment =
    | ProductGallery_CatalogueEngagementRing_Fragment
    | ProductGallery_CatalogueJewelleryBracelet_Fragment
    | ProductGallery_CatalogueJewelleryEarrings_Fragment
    | ProductGallery_CatalogueJewelleryNecklace_Fragment
    | ProductGallery_CatalogueJewelleryRing_Fragment
    | ProductGallery_CatalogueReadyToGoRing_Fragment
    | ProductGallery_CatalogueWeddingRing_Fragment

export type HeaderMenuFragment = { __typename: 'MenuItem' } & Pick<
    MenuItem,
    'title' | 'hideOnMobile' | 'hideOnDesktop'
> & {
        link: { __typename: 'Link' } & LinkFragment
        subMenu: Maybe<{ __typename: 'SubMenu' } & SubMenuFragment>
    }

export type PreHeaderFragment = { __typename: 'PreHeader' } & {
    link: { __typename: 'Link' } & LinkFragment
}

export type SubMenuFragment = { __typename: 'SubMenu' } & Pick<
    SubMenu,
    'title' | 'description' | 'useLargeFormatItems'
> & {
        sections: Array<
            { __typename: 'SubMenuSection' } & SubMenuSectionFragment
        >
        editorialContent: Maybe<
            {
                __typename: 'SubMenuEditorialContent'
            } & SubMenuEditorialContentFragment
        >
    }

export type SubMenuEditorialContentFragment = {
    __typename: 'SubMenuEditorialContent'
} & Pick<SubMenuEditorialContent, 'text'> & {
        link: { __typename: 'Link' } & LinkFragment
        image: { __typename: 'Image' } & ImageLargeFragment
    }

export type SubMenuItemFragment = { __typename: 'SubMenuItem' } & Pick<
    SubMenuItem,
    'title' | 'style'
> & {
        link: { __typename: 'Link' } & LinkFragment
        media: Maybe<{ __typename: 'Image' } & ImageLargeFragment>
        icon: Maybe<{ __typename: 'Image' } & ImageLargeFragment>
    }

export type SubMenuSectionFragment = { __typename: 'SubMenuSection' } & Pick<
    SubMenuSection,
    'title'
> & { items: Array<{ __typename: 'SubMenuItem' } & SubMenuItemFragment> }

export type TopBarFragment = { __typename: 'TopBar' } & {
    siteWideMessage: Maybe<
        { __typename: 'TopBarSiteWideMessage' } & TopBarSiteWideMessageFragment
    >
    consultationPrompt: Maybe<
        {
            __typename: 'TopBarConsultationPrompt'
        } & TopBarConsultationPromptFragment
    >
}

export type TopBarConsultationPromptFragment = {
    __typename: 'TopBarConsultationPrompt'
} & { link: { __typename: 'Link' } & LinkFragment }

export type TopBarSiteWideMessageFragment = {
    __typename: 'TopBarSiteWideMessage'
} & Pick<TopBarSiteWideMessage, 'message'> & {
        link: { __typename: 'Link' } & LinkFragment
    }

export type ThreeSixtyFragment = { __typename: 'GenericImage' } & Pick<
    GenericImage,
    'url'
> & {
        size: { __typename: 'MonolithImageSize' } & MonolithImageSizeFragment
        size_x2: { __typename: 'MonolithImageSize' } & MonolithImageSizeFragment
    }

export type PageTooltipFragment = { __typename: 'PageTooltip' } & Pick<
    PageTooltip,
    'triggerText'
> & { tooltip: { __typename: 'Tooltip' } & TooltipFragment }

export type DeliveryTimeframeFragment = { __typename: 'DeliveryDate' } & Pick<
    DeliveryDate,
    'date' | 'validUntil'
>

type MetalVariation_CatalogueEngagementRing_Fragment = {
    __typename: 'CatalogueEngagementRing'
} & { primaryMetal: { __typename: 'Metal' } & MetalFilterMetalFragment }

type MetalVariation_CatalogueJewelleryBracelet_Fragment = {
    __typename: 'CatalogueJewelleryBracelet'
} & { primaryMetal: { __typename: 'Metal' } & MetalFilterMetalFragment }

type MetalVariation_CatalogueJewelleryEarrings_Fragment = {
    __typename: 'CatalogueJewelleryEarrings'
} & { primaryMetal: { __typename: 'Metal' } & MetalFilterMetalFragment }

type MetalVariation_CatalogueJewelleryNecklace_Fragment = {
    __typename: 'CatalogueJewelleryNecklace'
} & { primaryMetal: { __typename: 'Metal' } & MetalFilterMetalFragment }

type MetalVariation_CatalogueJewelleryRing_Fragment = {
    __typename: 'CatalogueJewelleryRing'
} & { primaryMetal: { __typename: 'Metal' } & MetalFilterMetalFragment }

type MetalVariation_CatalogueReadyToGoRing_Fragment = {
    __typename: 'CatalogueReadyToGoRing'
} & { primaryMetal: { __typename: 'Metal' } & MetalFilterMetalFragment }

type MetalVariation_CatalogueWeddingRing_Fragment = {
    __typename: 'CatalogueWeddingRing'
} & { primaryMetal: { __typename: 'Metal' } & MetalFilterMetalFragment }

export type MetalVariationFragment =
    | MetalVariation_CatalogueEngagementRing_Fragment
    | MetalVariation_CatalogueJewelleryBracelet_Fragment
    | MetalVariation_CatalogueJewelleryEarrings_Fragment
    | MetalVariation_CatalogueJewelleryNecklace_Fragment
    | MetalVariation_CatalogueJewelleryRing_Fragment
    | MetalVariation_CatalogueReadyToGoRing_Fragment
    | MetalVariation_CatalogueWeddingRing_Fragment

type RelatedProduct_CatalogueEngagementRing_Fragment = {
    __typename: 'CatalogueEngagementRing'
} & {
    variationsByPrimaryMetal: Array<
        {
            __typename: 'CatalogueEngagementRing'
        } & ProductCard_CatalogueEngagementRing_Fragment
    >
} & ProductCard_CatalogueEngagementRing_Fragment

type RelatedProduct_CatalogueJewelleryBracelet_Fragment = {
    __typename: 'CatalogueJewelleryBracelet'
} & {
    variations: Array<
        {
            __typename: 'CatalogueJewelleryBracelet'
        } & ProductCard_CatalogueJewelleryBracelet_Fragment
    >
} & ProductCard_CatalogueJewelleryBracelet_Fragment

type RelatedProduct_CatalogueJewelleryEarrings_Fragment = {
    __typename: 'CatalogueJewelleryEarrings'
} & {
    variations: Array<
        {
            __typename: 'CatalogueJewelleryEarrings'
        } & ProductCard_CatalogueJewelleryEarrings_Fragment
    >
} & ProductCard_CatalogueJewelleryEarrings_Fragment

type RelatedProduct_CatalogueJewelleryNecklace_Fragment = {
    __typename: 'CatalogueJewelleryNecklace'
} & {
    variations: Array<
        {
            __typename: 'CatalogueJewelleryNecklace'
        } & ProductCard_CatalogueJewelleryNecklace_Fragment
    >
} & ProductCard_CatalogueJewelleryNecklace_Fragment

type RelatedProduct_CatalogueJewelleryRing_Fragment = {
    __typename: 'CatalogueJewelleryRing'
} & {
    variations: Array<
        {
            __typename: 'CatalogueJewelleryRing'
        } & ProductCard_CatalogueJewelleryRing_Fragment
    >
} & ProductCard_CatalogueJewelleryRing_Fragment

type RelatedProduct_CatalogueReadyToGoRing_Fragment = {
    __typename: 'CatalogueReadyToGoRing'
} & ProductCard_CatalogueReadyToGoRing_Fragment

type RelatedProduct_CatalogueWeddingRing_Fragment = {
    __typename: 'CatalogueWeddingRing'
} & {
    variations: Array<
        {
            __typename: 'CatalogueWeddingRing'
        } & ProductCard_CatalogueWeddingRing_Fragment
    >
} & ProductCard_CatalogueWeddingRing_Fragment

export type RelatedProductFragment =
    | RelatedProduct_CatalogueEngagementRing_Fragment
    | RelatedProduct_CatalogueJewelleryBracelet_Fragment
    | RelatedProduct_CatalogueJewelleryEarrings_Fragment
    | RelatedProduct_CatalogueJewelleryNecklace_Fragment
    | RelatedProduct_CatalogueJewelleryRing_Fragment
    | RelatedProduct_CatalogueReadyToGoRing_Fragment
    | RelatedProduct_CatalogueWeddingRing_Fragment

export type ReviewsFragment = { __typename: 'Review' } & Pick<
    Review,
    'id' | 'name' | 'comment' | 'date' | 'rating'
> & {
        picture: Maybe<
            { __typename: 'Asset' } & Pick<Asset, 'id'> & {
                    small: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                    small_x2: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                }
        >
    }

export type TaxSnippetFragment = { __typename: 'SalePrice' } & {
    total: { __typename: 'Money' } & MoneyFragment
    tax: Maybe<{ __typename: 'Tax' } & Pick<Tax, 'type'>>
}

type ProductGrid_CatalogueEngagementRing_Fragment = {
    __typename: 'CatalogueEngagementRing'
} & {
    variationsByPrimaryMetal: Array<
        {
            __typename: 'CatalogueEngagementRing'
        } & ProductCard_CatalogueEngagementRing_Fragment &
            ProductListAnalytics_CatalogueEngagementRing_Fragment
    >
} & ProductCard_CatalogueEngagementRing_Fragment &
    ProductListAnalytics_CatalogueEngagementRing_Fragment

type ProductGrid_CatalogueJewelleryBracelet_Fragment = {
    __typename: 'CatalogueJewelleryBracelet'
} & {
    variations: Array<
        {
            __typename: 'CatalogueJewelleryBracelet'
        } & ProductCard_CatalogueJewelleryBracelet_Fragment &
            ProductListAnalytics_CatalogueJewelleryBracelet_Fragment
    >
} & ProductCard_CatalogueJewelleryBracelet_Fragment &
    ProductListAnalytics_CatalogueJewelleryBracelet_Fragment

type ProductGrid_CatalogueJewelleryEarrings_Fragment = {
    __typename: 'CatalogueJewelleryEarrings'
} & {
    variations: Array<
        {
            __typename: 'CatalogueJewelleryEarrings'
        } & ProductCard_CatalogueJewelleryEarrings_Fragment &
            ProductListAnalytics_CatalogueJewelleryEarrings_Fragment
    >
} & ProductCard_CatalogueJewelleryEarrings_Fragment &
    ProductListAnalytics_CatalogueJewelleryEarrings_Fragment

type ProductGrid_CatalogueJewelleryNecklace_Fragment = {
    __typename: 'CatalogueJewelleryNecklace'
} & {
    variations: Array<
        {
            __typename: 'CatalogueJewelleryNecklace'
        } & ProductCard_CatalogueJewelleryNecklace_Fragment &
            ProductListAnalytics_CatalogueJewelleryNecklace_Fragment
    >
} & ProductCard_CatalogueJewelleryNecklace_Fragment &
    ProductListAnalytics_CatalogueJewelleryNecklace_Fragment

type ProductGrid_CatalogueJewelleryRing_Fragment = {
    __typename: 'CatalogueJewelleryRing'
} & {
    variations: Array<
        {
            __typename: 'CatalogueJewelleryRing'
        } & ProductCard_CatalogueJewelleryRing_Fragment &
            ProductListAnalytics_CatalogueJewelleryRing_Fragment
    >
} & ProductCard_CatalogueJewelleryRing_Fragment &
    ProductListAnalytics_CatalogueJewelleryRing_Fragment

type ProductGrid_CatalogueReadyToGoRing_Fragment = {
    __typename: 'CatalogueReadyToGoRing'
} & ProductCard_CatalogueReadyToGoRing_Fragment &
    ProductListAnalytics_CatalogueReadyToGoRing_Fragment

type ProductGrid_CatalogueWeddingRing_Fragment = {
    __typename: 'CatalogueWeddingRing'
} & {
    variations: Array<
        {
            __typename: 'CatalogueWeddingRing'
        } & ProductCard_CatalogueWeddingRing_Fragment &
            ProductListAnalytics_CatalogueWeddingRing_Fragment
    >
} & ProductCard_CatalogueWeddingRing_Fragment &
    ProductListAnalytics_CatalogueWeddingRing_Fragment

export type ProductGridFragment =
    | ProductGrid_CatalogueEngagementRing_Fragment
    | ProductGrid_CatalogueJewelleryBracelet_Fragment
    | ProductGrid_CatalogueJewelleryEarrings_Fragment
    | ProductGrid_CatalogueJewelleryNecklace_Fragment
    | ProductGrid_CatalogueJewelleryRing_Fragment
    | ProductGrid_CatalogueReadyToGoRing_Fragment
    | ProductGrid_CatalogueWeddingRing_Fragment

export type MonolithImageSizeFragment = {
    __typename: 'MonolithImageSize'
} & Pick<MonolithImageSize, 'url'> & {
        sources: Array<
            { __typename: 'ImageSrc' } & Pick<ImageSrc, 'url' | 'mimeType'>
        >
    }

export type MarketingDataMutationVariables = Exact<{
    input: MarketingDataInput
}>

export type MarketingDataMutation = { __typename: 'Mutation' } & {
    marketingData: { __typename: 'MarketingDataResponse' } & Pick<
        MarketingDataResponse,
        'success'
    >
}

export type InitQueryVariables = Exact<{
    locale: Scalars['Locale']['input']
    currency: CurrencyInput
    region: RegionCode
    fetchRegionSuggest: Scalars['Boolean']['input']
    isConsultant: Scalars['Boolean']['input']
}>

export type InitQuery = { __typename: 'Query' } & {
    ringBuilder: { __typename: 'RingBuilder' } & RbFragment
    me: Maybe<{ __typename: 'User' } & MeFragment>
    workingHours: Array<
        { __typename: 'WorkingHours' } & Pick<
            WorkingHours,
            'weekDays' | 'opening' | 'closing'
        >
    >
    regionSuggest?: { __typename: 'Region' } & Pick<Region, 'code'>
    defaultAlternateRegion: { __typename: 'Region' } & AlternateTagFragment
    regions: Array<
        { __typename: 'Region' } & AlternateTagFragment & RegionPluginFragment
    >
    language: Maybe<
        { __typename: 'Language' } & Pick<Language, 'locale'> & {
                translations: Array<
                    { __typename: 'Translation' } & TranslationFragment
                >
            }
    >
    topBar: Maybe<{ __typename: 'TopBar' } & TopBarFragment>
    preHeader: Maybe<{ __typename: 'PreHeader' } & PreHeaderFragment>
    mainMenu: Array<{ __typename: 'MenuItem' } & HeaderMenuFragment>
    socialNetworks: Array<
        { __typename: 'SocialNetwork' } & SocialNetworkFragment
    >
    paymentIcons: Array<{ __typename: 'PaymentIcon' } & PaymentIconFragment>
    footer: Maybe<{ __typename: 'Footer' } & FooterFragment>
    avatarStack: Array<
        { __typename: 'AvatarStackItem' } & AvatarStackItemFragment
    >
}

export type AlternateTagFragment = { __typename: 'Region' } & Pick<
    Region,
    'code' | 'locales'
>

export type RegionPluginFragment = { __typename: 'Region' } & Pick<
    Region,
    'code' | 'isActive' | 'currency'
> & { language: { __typename: 'Language' } & Pick<Language, 'locale'> }

export type TooltipFragment = { __typename: 'Tooltip' } & Pick<
    Tooltip,
    'title'
> & {
        content: Array<
            | ({
                  __typename: 'ComponentButton'
              } & ContentComponentItem_ComponentButton_Fragment)
            | ({
                  __typename: 'ComponentImage'
              } & ContentComponentItem_ComponentImage_Fragment)
            | ({
                  __typename: 'ComponentOrderedList'
              } & ContentComponentItem_ComponentOrderedList_Fragment)
            | ({
                  __typename: 'ComponentSpacer'
              } & ContentComponentItem_ComponentSpacer_Fragment)
            | ({
                  __typename: 'ComponentText'
              } & ContentComponentItem_ComponentText_Fragment)
            | ({
                  __typename: 'ComponentTitle'
              } & ContentComponentItem_ComponentTitle_Fragment)
        >
    }

type GetIsLabGrown_CatalogueEngagementRing_Fragment = {
    __typename: 'CatalogueEngagementRing'
} & Pick<CatalogueEngagementRing, 'suffix'>

type GetIsLabGrown_CatalogueJewelleryBracelet_Fragment = {
    __typename: 'CatalogueJewelleryBracelet'
} & Pick<CatalogueJewelleryBracelet, 'suffix'>

type GetIsLabGrown_CatalogueJewelleryEarrings_Fragment = {
    __typename: 'CatalogueJewelleryEarrings'
} & Pick<CatalogueJewelleryEarrings, 'suffix'>

type GetIsLabGrown_CatalogueJewelleryNecklace_Fragment = {
    __typename: 'CatalogueJewelleryNecklace'
} & Pick<CatalogueJewelleryNecklace, 'suffix'>

type GetIsLabGrown_CatalogueJewelleryRing_Fragment = {
    __typename: 'CatalogueJewelleryRing'
} & Pick<CatalogueJewelleryRing, 'suffix'>

type GetIsLabGrown_CatalogueReadyToGoRing_Fragment = {
    __typename: 'CatalogueReadyToGoRing'
} & Pick<CatalogueReadyToGoRing, 'suffix'>

type GetIsLabGrown_CatalogueWeddingRing_Fragment = {
    __typename: 'CatalogueWeddingRing'
} & Pick<CatalogueWeddingRing, 'suffix'>

export type GetIsLabGrownFragment =
    | GetIsLabGrown_CatalogueEngagementRing_Fragment
    | GetIsLabGrown_CatalogueJewelleryBracelet_Fragment
    | GetIsLabGrown_CatalogueJewelleryEarrings_Fragment
    | GetIsLabGrown_CatalogueJewelleryNecklace_Fragment
    | GetIsLabGrown_CatalogueJewelleryRing_Fragment
    | GetIsLabGrown_CatalogueReadyToGoRing_Fragment
    | GetIsLabGrown_CatalogueWeddingRing_Fragment

export type FacetedContentProductLabelTranslationFragment = {
    __typename: 'ProductLabelTranslation'
} & Pick<ProductLabelTranslation, 'name' | 'facetedContentName'>

export type GemsApiCertificateFragment = { __typename: 'GemsApi_Stone' } & {
    certificates: { __typename: 'GemsApi_StoneCertificates' } & Pick<
        GemsApi_StoneCertificates,
        'gcal' | 'gia' | 'igi'
    >
}

export type NonSkuLabGrownStoneImageFragment = {
    __typename: 'NonSkuLabGrown'
} & {
    image: Maybe<
        { __typename: 'NonSkuImage' } & Pick<NonSkuImage, 'id' | 'url'>
    >
    shapeDimension: { __typename: 'NonSkuLabGrownShapeDimension' } & Pick<
        NonSkuLabGrownShapeDimension,
        'id'
    > & {
            image: Maybe<
                { __typename: 'NonSkuImage' } & Pick<NonSkuImage, 'id' | 'url'>
            >
            shape: { __typename: 'StoneShape' } & Pick<
                StoneShape,
                'systemCode'
            > & {
                    samplePhoto: Maybe<
                        { __typename: 'Asset' } & Pick<Asset, 'id' | 'url'>
                    >
                }
        }
}

export type NonSkuGemstoneImageFragment = { __typename: 'NonSkuGemstone' } & {
    image: Maybe<
        { __typename: 'NonSkuImage' } & Pick<NonSkuImage, 'id' | 'url'>
    >
    shapeDimension: { __typename: 'NonSkuGemstoneShapeDimension' } & Pick<
        NonSkuGemstoneShapeDimension,
        'id'
    > & {
            shape: { __typename: 'StoneShape' } & Pick<
                StoneShape,
                'systemCode'
            > & {
                    samplePhoto: Maybe<
                        { __typename: 'Asset' } & Pick<Asset, 'id' | 'url'>
                    >
                }
        }
}

export type AutologinMutationVariables = Exact<{
    authToken: Scalars['String']['input']
    isConsultant: Scalars['Boolean']['input']
}>

export type AutologinMutation = { __typename: 'Mutation' } & {
    autologin:
        | { __typename: 'LoginResponseFailure' }
        | ({
              __typename: 'LoginResponseSuccess'
          } & LoginResponseSuccessFragment)
}

export type CustomerRegistrationResponseFragment = {
    __typename: 'CustomerRegistrationResponse'
} & {
    login: Maybe<
        { __typename: 'LoginResponseSuccess' } & LoginResponseSuccessFragment
    >
}

type LoginResponse_LoginResponseFailure_Fragment = {
    __typename: 'LoginResponseFailure'
} & LoginResponseFailureFragment

type LoginResponse_LoginResponseSuccess_Fragment = {
    __typename: 'LoginResponseSuccess'
} & LoginResponseSuccessFragment

export type LoginResponseFragment =
    | LoginResponse_LoginResponseFailure_Fragment
    | LoginResponse_LoginResponseSuccess_Fragment

export type LoginResponseFailureFragment = {
    __typename: 'LoginResponseFailure'
} & Pick<LoginResponseFailure, 'code' | 'message'>

export type LoginResponseSuccessFragment = {
    __typename: 'LoginResponseSuccess'
} & Pick<LoginResponseSuccess, 'jwt'> & {
        user: { __typename: 'User' } & MeFragment
    }

export type LoginMutationVariables = Exact<{
    credentials: CredentialsInput
    locale: Scalars['Locale']['input']
    isConsultant: Scalars['Boolean']['input']
}>

export type LoginMutation = { __typename: 'Mutation' } & {
    login:
        | ({
              __typename: 'LoginResponseFailure'
          } & LoginResponse_LoginResponseFailure_Fragment)
        | ({
              __typename: 'LoginResponseSuccess'
          } & LoginResponse_LoginResponseSuccess_Fragment)
}

export type LoginWithGoogleMutationVariables = Exact<{
    credentials: CustomerRegistrationByGoogleInput
    locale: Scalars['Locale']['input']
    isConsultant: Scalars['Boolean']['input']
}>

export type LoginWithGoogleMutation = { __typename: 'Mutation' } & {
    loginWithGoogle:
        | ({
              __typename: 'LoginResponseFailure'
          } & LoginResponse_LoginResponseFailure_Fragment)
        | ({
              __typename: 'LoginResponseSuccess'
          } & LoginResponse_LoginResponseSuccess_Fragment)
}

export type LogoutMutationVariables = Exact<{ [key: string]: never }>

export type LogoutMutation = { __typename: 'Mutation' } & Pick<
    Mutation,
    'logout'
>

export type RefreshTokenMutationVariables = Exact<{
    token: Scalars['String']['input']
    locale: Scalars['Locale']['input']
}>

export type RefreshTokenMutation = { __typename: 'Mutation' } & {
    refreshToken:
        | ({ __typename: 'LoginResponseFailure' } & Pick<
              LoginResponseFailure,
              'code' | 'message'
          >)
        | ({ __typename: 'LoginResponseSuccess' } & Pick<
              LoginResponseSuccess,
              'refreshToken'
          >)
}

export type BookingConsultationAvailableSlotsQueryVariables = Exact<{
    input: BookingConsultationSlotInput
    locale: Scalars['Locale']['input']
}>

export type BookingConsultationAvailableSlotsQuery = { __typename: 'Query' } & {
    bookingConsultationAvailableSlots: {
        __typename: 'BookingConsultationSlotsResponse'
    } & BookingConsultationSlotsResponseFragment
}

export type BookingConsultationSlotsResponseFragment = {
    __typename: 'BookingConsultationSlotsResponse'
} & {
    slots: Array<
        {
            __typename: 'BookingConsultationSlot'
        } & BookingConsultationSlotFragment
    >
}

export type BookingConsultationSlotFragment = {
    __typename: 'BookingConsultationSlot'
} & Pick<BookingConsultationSlot, 'startTime'> & {
        showroom: { __typename: 'Showroom' } & ShowroomFragment
    }

export type BookingInitQueryVariables = Exact<{
    locale: Scalars['Locale']['input']
}>

export type BookingInitQuery = { __typename: 'Query' } & Pick<
    Query,
    'bookingConsultationShowPhone'
> & {
        bookingConsultationPurposes: Array<
            {
                __typename: 'BookingConsultationPurpose'
            } & BookingConsultationPurposeFragment
        >
        bookingConsultationComplexities: Array<
            {
                __typename: 'BookingConsultationComplexity'
            } & BookingConsultationComplexityFragment
        >
    }

export type BookingConsultationPurposeFragment = {
    __typename: 'BookingConsultationPurpose'
} & Pick<BookingConsultationPurpose, 'systemCode' | 'name' | 'duration'> & {
        icon: Maybe<{ __typename: 'Asset' } & AssetFragment>
        type: { __typename: 'BookingConsultationType' } & Pick<
            BookingConsultationType,
            'systemCode' | 'name'
        >
    }

export type BookingConsultationComplexityFragment = {
    __typename: 'BookingConsultationComplexity'
} & Pick<BookingConsultationComplexity, 'systemCode'> & {
        translation: {
            __typename: 'BookingConsultationComplexityTranslation'
        } & Pick<BookingConsultationComplexityTranslation, 'name'>
        icon: Maybe<{ __typename: 'Asset' } & AssetFragment>
    }

export type CreateConsultationExistingCustomerMutationVariables = Exact<{
    input: BookingCreateConsultationInput
    locale: Scalars['Locale']['input']
}>

export type CreateConsultationExistingCustomerMutation = {
    __typename: 'Mutation'
} & {
    createConsultationExistingCustomer:
        | ({
              __typename: 'BookingCreateConsultationErrorNoAvailableConsultants'
          } & BookingCreateConsultationExistingCustomerResponse_BookingCreateConsultationErrorNoAvailableConsultants_Fragment)
        | ({
              __typename: 'BookingCreateConsultationSuccessExistingCustomer'
          } & BookingCreateConsultationExistingCustomerResponse_BookingCreateConsultationSuccessExistingCustomer_Fragment)
}

type BookingCreateConsultationExistingCustomerResponse_BookingCreateConsultationErrorNoAvailableConsultants_Fragment =
    {
        __typename: 'BookingCreateConsultationErrorNoAvailableConsultants'
    } & BookingCreateConsultationErrorNoAvailableConsultantsFragment

type BookingCreateConsultationExistingCustomerResponse_BookingCreateConsultationSuccessExistingCustomer_Fragment =
    {
        __typename: 'BookingCreateConsultationSuccessExistingCustomer'
    } & BookingCreateConsultationSuccessExistingCustomerFragment

export type BookingCreateConsultationExistingCustomerResponseFragment =
    | BookingCreateConsultationExistingCustomerResponse_BookingCreateConsultationErrorNoAvailableConsultants_Fragment
    | BookingCreateConsultationExistingCustomerResponse_BookingCreateConsultationSuccessExistingCustomer_Fragment

export type BookingCreateConsultationSuccessExistingCustomerFragment = {
    __typename: 'BookingCreateConsultationSuccessExistingCustomer'
} & {
    consultation: {
        __typename: 'BookingConsultation'
    } & BookingConsultationFragment
}

export type CreateConsultationNewCustomerMutationVariables = Exact<{
    input: BookingCreateConsultationInput
    customer: CustomerRegistrationInput
    locale: Scalars['Locale']['input']
    isConsultant: Scalars['Boolean']['input']
}>

export type CreateConsultationNewCustomerMutation = {
    __typename: 'Mutation'
} & {
    createConsultationNewCustomer:
        | ({
              __typename: 'BookingCreateConsultationErrorNoAvailableConsultants'
          } & BookingCreateConsultationNewCustomerResponse_BookingCreateConsultationErrorNoAvailableConsultants_Fragment)
        | ({
              __typename: 'BookingCreateConsultationSuccessNewCustomer'
          } & BookingCreateConsultationNewCustomerResponse_BookingCreateConsultationSuccessNewCustomer_Fragment)
}

type BookingCreateConsultationNewCustomerResponse_BookingCreateConsultationErrorNoAvailableConsultants_Fragment =
    {
        __typename: 'BookingCreateConsultationErrorNoAvailableConsultants'
    } & BookingCreateConsultationErrorNoAvailableConsultantsFragment

type BookingCreateConsultationNewCustomerResponse_BookingCreateConsultationSuccessNewCustomer_Fragment =
    {
        __typename: 'BookingCreateConsultationSuccessNewCustomer'
    } & BookingCreateConsultationSuccessNewCustomerFragment

export type BookingCreateConsultationNewCustomerResponseFragment =
    | BookingCreateConsultationNewCustomerResponse_BookingCreateConsultationErrorNoAvailableConsultants_Fragment
    | BookingCreateConsultationNewCustomerResponse_BookingCreateConsultationSuccessNewCustomer_Fragment

export type BookingCreateConsultationSuccessNewCustomerFragment = {
    __typename: 'BookingCreateConsultationSuccessNewCustomer'
} & {
    customerRegistrationResponse: {
        __typename: 'CustomerRegistrationResponse'
    } & CustomerRegistrationResponseFragment
    consultation: {
        __typename: 'BookingConsultation'
    } & BookingConsultationFragment
}

export type CustomerExistsQueryVariables = Exact<{
    email: Scalars['Email']['input']
}>

export type CustomerExistsQuery = { __typename: 'Query' } & Pick<
    Query,
    'customerExists'
>

export type BookingConsultationFragment = {
    __typename: 'BookingConsultation'
} & Pick<
    BookingConsultation,
    'id' | 'description' | 'startsAt' | 'isCancelled' | 'canBeCancelled'
> & {
        purpose: {
            __typename: 'BookingConsultationPurpose'
        } & BookingConsultationPurposeFragment
        method: {
            __typename: 'BookingConsultationMethod'
        } & BookingConsultationMethodFragment
        showroom: { __typename: 'Showroom' } & ShowroomFragment
    }

export type BookingConsultationMethodFragment = {
    __typename: 'BookingConsultationMethod'
} & Pick<BookingConsultationMethod, 'systemCode' | 'name'> & {
        icon: Maybe<{ __typename: 'Asset' } & AssetFragment>
    }

export type BookingCreateConsultationErrorNoAvailableConsultantsFragment = {
    __typename: 'BookingCreateConsultationErrorNoAvailableConsultants'
} & Pick<BookingCreateConsultationErrorNoAvailableConsultants, 'message'>

export type BookingOrdersFragment = { __typename: 'Order' } & Pick<Order, 'id'>

export type OrdersQueryVariables = Exact<{ [key: string]: never }>

export type OrdersQuery = { __typename: 'Query' } & {
    me: Maybe<
        { __typename: 'User' } & Pick<User, 'id'> & {
                customer: Maybe<
                    { __typename: 'Customer' } & Pick<Customer, 'id'> & {
                            orders: Array<
                                { __typename: 'Order' } & BookingOrdersFragment
                            >
                        }
                >
            }
    >
}

export type ValidateConsultationInputQueryVariables = Exact<{
    input: BookingCreateConsultationInput
}>

export type ValidateConsultationInputQuery = { __typename: 'Query' } & Pick<
    Query,
    'validateConsultationInput'
>

export type ValidateCustomerRegistrationInputQueryVariables = Exact<{
    input: CustomerRegistrationInput
}>

export type ValidateCustomerRegistrationInputQuery = {
    __typename: 'Query'
} & Pick<Query, 'validateCustomerRegistrationInput'>

export type CartQueryVariables = Exact<{
    locale: Scalars['Locale']['input']
}>

export type CartQuery = { __typename: 'Query' } & {
    me: Maybe<
        { __typename: 'User' } & {
            customer: Maybe<
                { __typename: 'Customer' } & {
                    cart: { __typename: 'Order' } & OrderFragment
                }
            >
        }
    >
}

export type DesignStudioEngagementRingErrorRootShapeMismatchFragment = {
    __typename: 'DesignStudioEngagementRingErrorShapeMismatch'
} & Pick<DesignStudioEngagementRingErrorShapeMismatch, 'message'>

export type AddToCartJewelleryExistingCustomerMutationVariables = Exact<{
    input: DesignStudioJewelleryInput
}>

export type AddToCartJewelleryExistingCustomerMutation = {
    __typename: 'Mutation'
} & {
    createDesignStudioProductAndAddToCartJewelleryExistingCustomer: {
        __typename: 'CatalogueDesignStudioCheckoutJewellerySuccessExistingCustomer'
    }
}

export type AddToCartJewelleryNewCustomerMutationVariables = Exact<{
    input: DesignStudioJewelleryInput
    customer: CustomerRegistrationInput
    isConsultant: Scalars['Boolean']['input']
}>

export type AddToCartJewelleryNewCustomerMutation = {
    __typename: 'Mutation'
} & {
    createDesignStudioProductAndAddToCartJewelleryNewCustomer: {
        __typename: 'CatalogueDesignStudioCheckoutJewellerySuccessNewCustomer'
    } & {
        customer: {
            __typename: 'CustomerRegistrationResponse'
        } & CustomerRegistrationResponseFragment
    }
}

export type OrderByIdQueryVariables = Exact<{
    id: Scalars['ID']['input']
    locale: Scalars['Locale']['input']
}>

export type OrderByIdQuery = { __typename: 'Query' } & {
    me: Maybe<
        { __typename: 'User' } & {
            customer: Maybe<
                { __typename: 'Customer' } & {
                    order: Maybe<{ __typename: 'Order' } & OrderFragment>
                }
            >
        }
    >
}

export type AddToCartReadyToGoRingNewCustomerResponseFragment = {
    __typename: 'AddToCartReadyToGoRingSuccessNewCustomer'
} & AddToCartReadyToGoRingSuccessNewCustomerFragment

export type AddToCartReadyToGoRingSuccessNewCustomerFragment = {
    __typename: 'AddToCartReadyToGoRingSuccessNewCustomer'
} & {
    customer: {
        __typename: 'CustomerRegistrationResponse'
    } & CustomerRegistrationResponseFragment
}

export type AddToCartReadyToGoRingExistingCustomerMutationVariables = Exact<{
    input: AddToCartReadyToGoRingInput
}>

export type AddToCartReadyToGoRingExistingCustomerMutation = {
    __typename: 'Mutation'
} & {
    addToCartReadyToGoRingExistingCustomer: {
        __typename: 'AddToCartReadyToGoRingSuccessExistingCustomer'
    }
}

export type AddToCartReadyToGoRingNewCustomerMutationVariables = Exact<{
    input: AddToCartReadyToGoRingInput
    customer: CustomerRegistrationInput
    isConsultant: Scalars['Boolean']['input']
}>

export type AddToCartReadyToGoRingNewCustomerMutation = {
    __typename: 'Mutation'
} & {
    addToCartReadyToGoRingNewCustomer: {
        __typename: 'AddToCartReadyToGoRingSuccessNewCustomer'
    } & AddToCartReadyToGoRingNewCustomerResponseFragment
}

export type DesignStudioWeddingRingNewCustomerResponseFragment = {
    __typename: 'CatalogueDesignStudioCheckoutWeddingRingSuccessNewCustomer'
} & DesignStudioWeddingRingSuccessNewCustomerFragment

export type DesignStudioWeddingRingSuccessNewCustomerFragment = {
    __typename: 'CatalogueDesignStudioCheckoutWeddingRingSuccessNewCustomer'
} & {
    customer: {
        __typename: 'CustomerRegistrationResponse'
    } & CustomerRegistrationResponseFragment
}

export type CreateDesignStudioProductAndAddToCartWeddingRingExistingCustomerMutationVariables =
    Exact<{
        input: DesignStudioWeddingRingInput
    }>

export type CreateDesignStudioProductAndAddToCartWeddingRingExistingCustomerMutation =
    { __typename: 'Mutation' } & {
        createDesignStudioProductAndAddToCartWeddingRingExistingCustomer: {
            __typename: 'CatalogueDesignStudioCheckoutWeddingRingSuccessExistingCustomer'
        }
    }

export type CreateDesignStudioProductAndAddToCartWeddingRingNewCustomerMutationVariables =
    Exact<{
        input: DesignStudioWeddingRingInput
        customer: CustomerRegistrationInput
        isConsultant: Scalars['Boolean']['input']
    }>

export type CreateDesignStudioProductAndAddToCartWeddingRingNewCustomerMutation =
    { __typename: 'Mutation' } & {
        createDesignStudioProductAndAddToCartWeddingRingNewCustomer: {
            __typename: 'CatalogueDesignStudioCheckoutWeddingRingSuccessNewCustomer'
        } & DesignStudioWeddingRingNewCustomerResponseFragment
    }

export type AddressFragment = { __typename: 'Address' } & Pick<
    Address,
    'country'
>

export type ConsultantFragment = { __typename: 'Consultant' } & Pick<
    Consultant,
    'id' | 'firstName' | 'avatar'
> & { user: { __typename: 'User' } & MeFragment }

export type CustomerFragment = { __typename: 'Customer' } & {
    shippingAddress: Maybe<{ __typename: 'Address' } & AddressFragment>
    billingAddress: Maybe<{ __typename: 'Address' } & AddressFragment>
    cart: { __typename: 'Order' } & OrderFragment
    consultant: Maybe<{ __typename: 'Consultant' } & ConsultantFragment>
    orders: Array<{ __typename: 'Order' } & OrderFragment>
}

export type SetOrderCollectFromShowroomInformationMutationVariables = Exact<{
    input: CollectFromShowroomInput
    locale: Scalars['Locale']['input']
}>

export type SetOrderCollectFromShowroomInformationMutation = {
    __typename: 'Mutation'
} & {
    setOrderCollectFromShowroomInformation:
        | ({
              __typename: 'SetDeliveryInformationFailureResponse'
          } & SetDeliveryInformationResponse_SetDeliveryInformationFailureResponse_Fragment)
        | ({
              __typename: 'SetDeliveryInformationSuccessResponse'
          } & SetDeliveryInformationResponse_SetDeliveryInformationSuccessResponse_Fragment)
}

export type SetOrderDeliverToAddressInformationMutationVariables = Exact<{
    input: DeliverToAddressInput
    locale: Scalars['Locale']['input']
}>

export type SetOrderDeliverToAddressInformationMutation = {
    __typename: 'Mutation'
} & {
    setOrderDeliverToAddressInformation:
        | ({
              __typename: 'SetDeliveryInformationFailureResponse'
          } & SetDeliveryInformationResponse_SetDeliveryInformationFailureResponse_Fragment)
        | ({
              __typename: 'SetDeliveryInformationSuccessResponse'
          } & SetDeliveryInformationResponse_SetDeliveryInformationSuccessResponse_Fragment)
}

type SetDeliveryInformationResponse_SetDeliveryInformationFailureResponse_Fragment =
    {
        __typename: 'SetDeliveryInformationFailureResponse'
    } & SetDeliveryInformationFailureResponseFragment

type SetDeliveryInformationResponse_SetDeliveryInformationSuccessResponse_Fragment =
    {
        __typename: 'SetDeliveryInformationSuccessResponse'
    } & SetDeliveryInformationSuccessResponseFragment

export type SetDeliveryInformationResponseFragment =
    | SetDeliveryInformationResponse_SetDeliveryInformationFailureResponse_Fragment
    | SetDeliveryInformationResponse_SetDeliveryInformationSuccessResponse_Fragment

export type SetDeliveryInformationFailureResponseFragment = {
    __typename: 'SetDeliveryInformationFailureResponse'
} & {
    errors: Array<
        {
            __typename: 'OrderAlreadyCompletedError'
        } & SetDeliveryInformationErrorFragment
    >
}

export type SetDeliveryInformationSuccessResponseFragment = {
    __typename: 'SetDeliveryInformationSuccessResponse'
} & { order: { __typename: 'Order' } & OrderFragment }

export type SetDeliveryInformationErrorFragment = {
    __typename: 'OrderAlreadyCompletedError'
} & Pick<OrderAlreadyCompletedError, 'message'>

export type OrderFragment = { __typename: 'Order' } & Pick<
    Order,
    | 'id'
    | 'placementDate'
    | 'desiredDeliveryDate'
    | 'isAsarEnabled'
    | 'isShippingAddressReadonly'
    | 'isDeliveryConfirmed'
    | 'isCompleted'
    | 'allowedWeekdays'
    | 'disabledDates'
> & {
        products: Array<{ __typename: 'OrderProduct' } & OrderProductFragment>
        paymentPlan: { __typename: 'PaymentPlan' } & PaymentPlanFragment
        subtotalAmount: { __typename: 'Money' } & MoneyFragment
        prediscountSubtotalAmount: { __typename: 'Money' } & MoneyFragment
        prediscountTotalAmount: { __typename: 'Money' } & MoneyFragment
        savedAmount: { __typename: 'Money' } & MoneyFragment
        vatAmount: { __typename: 'Money' } & MoneyFragment
        salesTaxAmount: { __typename: 'Money' } & MoneyFragment
        shippingAmount: { __typename: 'Money' } & MoneyFragment
        totalAmount: { __typename: 'Money' } & MoneyFragment
        paidAmount: { __typename: 'Money' } & MoneyFragment
        transactions: Array<
            | ({
                  __typename: 'AffirmTransaction'
              } & TransactionInterface_AffirmTransaction_Fragment)
            | ({
                  __typename: 'AllocationTransaction'
              } & TransactionInterface_AllocationTransaction_Fragment)
            | ({
                  __typename: 'BankTransaction'
              } & TransactionInterface_BankTransaction_Fragment)
            | ({
                  __typename: 'CheckoutcomTransaction'
              } & TransactionInterface_CheckoutcomTransaction_Fragment)
            | ({
                  __typename: 'KlarnaTransaction'
              } & TransactionInterface_KlarnaTransaction_Fragment)
            | ({
                  __typename: 'LegacyTransaction'
              } & TransactionInterface_LegacyTransaction_Fragment)
            | ({
                  __typename: 'StripeTransaction'
              } & TransactionInterface_StripeTransaction_Fragment)
        >
        promoCode: Maybe<{ __typename: 'PromoCode' } & PromoCodeFragment>
        paymentMethods: {
            __typename: 'PaymentMethodContainer'
        } & PaymentMethodContainerFragment
        availableShowroomsForCollection: Array<
            { __typename: 'Showroom' } & ShowroomFragment
        >
        shippingAddress: { __typename: 'OrderAddress' } & OrderAddressFragment
        billingAddress: { __typename: 'OrderAddress' } & OrderAddressFragment
        shipmentTrackingInformation: Maybe<
            {
                __typename: 'ShipmentTrackingInformation'
            } & ShipmentTrackingInformationFragment
        >
        firstAvailableDeliveryDate: {
            __typename: 'DeliveryDate'
        } & DeliveryTimeframeFragment
        status: { __typename: 'OrderStatus' } & Pick<OrderStatus, 'name'>
    }

export type OrderAddressFragment = { __typename: 'OrderAddress' } & Pick<
    OrderAddress,
    | 'firstName'
    | 'lastName'
    | 'email'
    | 'addressLine1'
    | 'addressLine2'
    | 'city'
    | 'postalCode'
    | 'country'
    | 'subdivision'
    | 'deliveryInstructions'
> & {
        phoneNumber: Maybe<
            { __typename: 'PhoneNumberType' } & Pick<
                PhoneNumberType,
                'countryCode' | 'nationalNumber' | 'e164'
            >
        >
    }

export type OrderProductFragment = { __typename: 'OrderProduct' } & Pick<
    OrderProduct,
    'id' | 'image' | 'name'
> & {
        prediscountTotalSaleAmount: { __typename: 'Money' } & MoneyFragment
        totalSaleAmount: { __typename: 'Money' } & MoneyFragment
    }

export type AffirmCompleteTransactionResponseFragment = {
    __typename: 'AffirmCompleteTransactionResponse'
} & Pick<AffirmCompleteTransactionResponse, 'errors'> & {
        order: { __typename: 'Order' } & OrderFragment
    }

export type AffirmFinanceOptionsFragment = {
    __typename: 'AffirmFinanceOption'
} & { price: { __typename: 'Money' } & MoneyFragment }

export type AffirmPaymentMethodFragment = {
    __typename: 'AffirmPaymentMethod'
} & Pick<AffirmPaymentMethod, 'systemCode' | 'publicKey' | 'scriptUrl'>

export type AffirmPaymentResponseFragment = {
    __typename: 'AffirmPaymentResponse'
} & Pick<AffirmPaymentResponse, 'errors'> & {
        order: { __typename: 'Order' } & OrderFragment
    }

export type AffirmTransactionFragment = {
    __typename: 'AffirmTransaction'
} & Pick<AffirmTransaction, 'checkoutObject'> &
    TransactionInterface_AffirmTransaction_Fragment

export type AllocationPaymentMethodFragment = {
    __typename: 'AllocationPaymentMethod'
} & Pick<AllocationPaymentMethod, 'systemCode'> & {
        maxAmount: { __typename: 'Money' } & MoneyFragment
    }

export type AllocationTransactionFragment = {
    __typename: 'AllocationTransaction'
} & TransactionInterface_AllocationTransaction_Fragment

export type BankPaymentMethodFragment = {
    __typename: 'BankPaymentMethod'
} & Pick<BankPaymentMethod, 'systemCode'>

export type BankTransactionFragment = {
    __typename: 'BankTransaction'
} & TransactionInterface_BankTransaction_Fragment

export type CheckoutcomPaymentMethodFragment = {
    __typename: 'CheckoutcomPaymentMethod'
} & Pick<CheckoutcomPaymentMethod, 'systemCode' | 'debugMode' | 'publicKey'>

export type KlarnaFinanceOptionsFragment = {
    __typename: 'KlarnaFinanceOption'
} & { perMonth: { __typename: 'Money' } & MoneyFragment }

export type KlarnaPaymentMethodFragment = {
    __typename: 'KlarnaPaymentMethod'
} & Pick<KlarnaPaymentMethod, 'systemCode'>

export type KlarnaPaymentResponseFragment = {
    __typename: 'KlarnaPaymentResponse'
} & Pick<KlarnaPaymentResponse, 'errors'> & {
        order: { __typename: 'Order' } & OrderFragment
    }

export type KlarnaTransactionFragment = {
    __typename: 'KlarnaTransaction'
} & Pick<KlarnaTransaction, 'sessionData'> &
    TransactionInterface_KlarnaTransaction_Fragment

export type LegacyTransactionFragment = {
    __typename: 'LegacyTransaction'
} & Pick<LegacyTransaction, 'paymentMethodName'> &
    TransactionInterface_LegacyTransaction_Fragment

export type NoPaymentMethodFragment = { __typename: 'NoPaymentMethod' } & Pick<
    NoPaymentMethod,
    'systemCode'
>

export type PaymentMethodContainerFragment = {
    __typename: 'PaymentMethodContainer'
} & {
    noPayment: Maybe<
        { __typename: 'NoPaymentMethod' } & NoPaymentMethodFragment
    >
    bankPayment: Maybe<
        { __typename: 'BankPaymentMethod' } & BankPaymentMethodFragment
    >
    allocationPayment: Maybe<
        {
            __typename: 'AllocationPaymentMethod'
        } & AllocationPaymentMethodFragment
    >
    checkoutcomPayment: Maybe<
        {
            __typename: 'CheckoutcomPaymentMethod'
        } & CheckoutcomPaymentMethodFragment
    >
    affirmPayment: Maybe<
        { __typename: 'AffirmPaymentMethod' } & AffirmPaymentMethodFragment
    >
    klarnaPayment: Maybe<
        { __typename: 'KlarnaPaymentMethod' } & KlarnaPaymentMethodFragment
    >
}

export type PaymentPlanFragment = { __typename: 'PaymentPlan' } & {
    paid: Array<
        { __typename: 'PaymentPlanPaidRecord' } & PaymentPlanPaidRecordFragment
    >
    current: Maybe<
        {
            __typename: 'PaymentPlanUpcomingRecord'
        } & PaymentPlanUpcomingRecordFragment
    >
    upcoming: Array<
        {
            __typename: 'PaymentPlanUpcomingRecord'
        } & PaymentPlanUpcomingRecordFragment
    >
}

export type PaymentPlanPaidRecordFragment = {
    __typename: 'PaymentPlanPaidRecord'
} & Pick<PaymentPlanPaidRecord, 'paidOn'> & {
        amount: { __typename: 'Money' } & MoneyFragment
    }

export type PaymentPlanUpcomingRecordFragment = {
    __typename: 'PaymentPlanUpcomingRecord'
} & { amount: { __typename: 'Money' } & MoneyFragment }

type TransactionInterface_AffirmTransaction_Fragment = {
    __typename: 'AffirmTransaction'
} & Pick<AffirmTransaction, 'id' | 'createdAt'> & {
        amount: { __typename: 'Money' } & MoneyFragment
        status: { __typename: 'TransactionStatus' } & TransactionStatusFragment
    }

type TransactionInterface_AllocationTransaction_Fragment = {
    __typename: 'AllocationTransaction'
} & Pick<AllocationTransaction, 'id' | 'createdAt'> & {
        amount: { __typename: 'Money' } & MoneyFragment
        status: { __typename: 'TransactionStatus' } & TransactionStatusFragment
    }

type TransactionInterface_BankTransaction_Fragment = {
    __typename: 'BankTransaction'
} & Pick<BankTransaction, 'id' | 'createdAt'> & {
        amount: { __typename: 'Money' } & MoneyFragment
        status: { __typename: 'TransactionStatus' } & TransactionStatusFragment
    }

type TransactionInterface_CheckoutcomTransaction_Fragment = {
    __typename: 'CheckoutcomTransaction'
} & Pick<CheckoutcomTransaction, 'id' | 'createdAt'> & {
        amount: { __typename: 'Money' } & MoneyFragment
        status: { __typename: 'TransactionStatus' } & TransactionStatusFragment
    }

type TransactionInterface_KlarnaTransaction_Fragment = {
    __typename: 'KlarnaTransaction'
} & Pick<KlarnaTransaction, 'id' | 'createdAt'> & {
        amount: { __typename: 'Money' } & MoneyFragment
        status: { __typename: 'TransactionStatus' } & TransactionStatusFragment
    }

type TransactionInterface_LegacyTransaction_Fragment = {
    __typename: 'LegacyTransaction'
} & Pick<LegacyTransaction, 'paymentMethodName' | 'id' | 'createdAt'> & {
        amount: { __typename: 'Money' } & MoneyFragment
        status: { __typename: 'TransactionStatus' } & TransactionStatusFragment
    }

type TransactionInterface_StripeTransaction_Fragment = {
    __typename: 'StripeTransaction'
} & Pick<StripeTransaction, 'id' | 'createdAt'> & {
        amount: { __typename: 'Money' } & MoneyFragment
        status: { __typename: 'TransactionStatus' } & TransactionStatusFragment
    }

export type TransactionInterfaceFragment =
    | TransactionInterface_AffirmTransaction_Fragment
    | TransactionInterface_AllocationTransaction_Fragment
    | TransactionInterface_BankTransaction_Fragment
    | TransactionInterface_CheckoutcomTransaction_Fragment
    | TransactionInterface_KlarnaTransaction_Fragment
    | TransactionInterface_LegacyTransaction_Fragment
    | TransactionInterface_StripeTransaction_Fragment

export type TransactionStatusFragment = {
    __typename: 'TransactionStatus'
} & Pick<TransactionStatus, 'name'>

export type PromoCodeFragment = { __typename: 'PromoCode' } & Pick<
    PromoCode,
    'id' | 'code'
>

export type PromoCodeApplicationResultFragment = {
    __typename: 'PromoCodeApplicationResult'
} & Pick<PromoCodeApplicationResult, 'error'>

export type ShipmentTrackingInformationFragment = {
    __typename: 'ShipmentTrackingInformation'
} & Pick<
    ShipmentTrackingInformation,
    'dispatchedAt' | 'shippingCompany' | 'trackingNumber' | 'trackingUrl'
>

export type ShowroomFragment = { __typename: 'Showroom' } & Pick<
    Showroom,
    'id' | 'isAccessible'
> & {
        location: { __typename: 'ShowroomLocation' } & ShowroomLocationFragment
        translation: { __typename: 'ShowroomTranslation' } & Pick<
            ShowroomTranslation,
            'name'
        >
    }

export type ShowroomLocationFragment = {
    __typename: 'ShowroomLocation'
} & Pick<
    ShowroomLocation,
    | 'postalCode'
    | 'city'
    | 'addressLine1'
    | 'addressLine2'
    | 'country'
    | 'subdivision'
> & {
        geoLocation: Maybe<
            { __typename: 'GeoPoint' } & Pick<
                GeoPoint,
                'id' | 'latitude' | 'longitude'
            >
        >
    }

export type BlogQueryVariables = Exact<{
    path: Scalars['String']['input']
    page: Scalars['Int']['input']
    limit: Scalars['Int']['input']
    locale: Scalars['Locale']['input']
    currency: CurrencyInput
    region: RegionCode
}>

export type BlogQuery = { __typename: 'Query' } & {
    pageByPath: Maybe<{ __typename: 'Page' } & PageFragment>
} & BlogPostsFragment

export type AuthorPostsFragment = { __typename: 'Author' } & Pick<
    Author,
    'id' | 'name' | 'slug'
> & {
        posts: Array<{ __typename: 'Post' } & BlogPostPreviewFragment>
        postAggregation: { __typename: 'PostsAggregation' } & Pick<
            PostsAggregation,
            'count'
        >
    }

export type BlogAuthorRouteFragment = { __typename: 'Author' } & Pick<
    Author,
    'slug'
>

export type BlogCategoryRouteFragment = { __typename: 'PostCategory' } & Pick<
    PostCategory,
    'slug'
>

export type BlogPostsFragment = { __typename: 'Query' } & {
    posts: Array<{ __typename: 'Post' } & BlogPostPreviewFragment>
    postsAggregation: { __typename: 'PostsAggregation' } & Pick<
        PostsAggregation,
        'count'
    >
} & PostCategoriesFragment

export type BlogTagRouteFragment = { __typename: 'PostTag' } & Pick<
    PostTag,
    'slug'
>

export type CategoryPostsFragment = { __typename: 'PostCategory' } & Pick<
    PostCategory,
    'id' | 'name' | 'slug'
> & {
        posts: Array<{ __typename: 'Post' } & BlogPostPreviewFragment>
        postAggregation: { __typename: 'PostsAggregation' } & Pick<
            PostsAggregation,
            'count'
        >
    }

export type PostCategoriesFragment = { __typename: 'Query' } & {
    postCategories: Array<{ __typename: 'PostCategory' } & BlogMenuFragment>
}

export type TagPostsFragment = { __typename: 'PostTag' } & Pick<
    PostTag,
    'id' | 'name' | 'slug'
> & {
        posts: Array<{ __typename: 'Post' } & BlogPostPreviewFragment>
        postAggregation: { __typename: 'PostsAggregation' } & Pick<
            PostsAggregation,
            'count'
        >
    }

export type PostsByCategoryQueryVariables = Exact<{
    slug: Scalars['String']['input']
    page: Scalars['Int']['input']
    limit: Scalars['Int']['input']
    locale: Scalars['Locale']['input']
}>

export type PostsByCategoryQuery = { __typename: 'Query' } & {
    collection: Maybe<{ __typename: 'PostCategory' } & CategoryPostsFragment>
} & PostCategoriesFragment

export type PostsByTagQueryVariables = Exact<{
    slug: Scalars['String']['input']
    page: Scalars['Int']['input']
    limit: Scalars['Int']['input']
    locale: Scalars['Locale']['input']
}>

export type PostsByTagQuery = { __typename: 'Query' } & {
    collection: Maybe<{ __typename: 'PostTag' } & TagPostsFragment>
} & PostCategoriesFragment

export type LinkFragment = { __typename: 'Link' } & Pick<
    Link,
    'text' | 'target'
> & {
        item:
            | ({
                  __typename: 'LinkItemAffirm'
              } & LinkItem_LinkItemAffirm_Fragment)
            | ({
                  __typename: 'LinkItemBookingForm'
              } & LinkItem_LinkItemBookingForm_Fragment)
            | ({
                  __typename: 'LinkItemCustom'
              } & LinkItem_LinkItemCustom_Fragment)
            | ({
                  __typename: 'LinkItemOpenContactForm'
              } & LinkItem_LinkItemOpenContactForm_Fragment)
            | ({
                  __typename: 'LinkItemOpenEnquiryForm'
              } & LinkItem_LinkItemOpenEnquiryForm_Fragment)
            | ({
                  __typename: 'LinkItemOpenSpeakToExpertModal'
              } & LinkItem_LinkItemOpenSpeakToExpertModal_Fragment)
            | ({ __typename: 'Page' } & LinkItem_Page_Fragment)
            | ({ __typename: 'Post' } & LinkItem_Post_Fragment)
            | ({
                  __typename: 'Questionnaire'
              } & LinkItem_Questionnaire_Fragment)
    }

type LinkItem_LinkItemAffirm_Fragment = { __typename: 'LinkItemAffirm' }

type LinkItem_LinkItemBookingForm_Fragment = {
    __typename: 'LinkItemBookingForm'
}

type LinkItem_LinkItemCustom_Fragment = {
    __typename: 'LinkItemCustom'
} & CustomLinkFragment

type LinkItem_LinkItemOpenContactForm_Fragment = {
    __typename: 'LinkItemOpenContactForm'
} & LinkItemOpenContactFormFragment

type LinkItem_LinkItemOpenEnquiryForm_Fragment = {
    __typename: 'LinkItemOpenEnquiryForm'
} & LinkItemOpenEnquiryFormFragment

type LinkItem_LinkItemOpenSpeakToExpertModal_Fragment = {
    __typename: 'LinkItemOpenSpeakToExpertModal'
} & LinkItemOpenSpeakToExpertModalFragment

type LinkItem_Page_Fragment = { __typename: 'Page' } & PageLinkFragment

type LinkItem_Post_Fragment = { __typename: 'Post' } & PostLinkFragment

type LinkItem_Questionnaire_Fragment = {
    __typename: 'Questionnaire'
} & LinkQuestionnaireFragment

export type LinkItemFragment =
    | LinkItem_LinkItemAffirm_Fragment
    | LinkItem_LinkItemBookingForm_Fragment
    | LinkItem_LinkItemCustom_Fragment
    | LinkItem_LinkItemOpenContactForm_Fragment
    | LinkItem_LinkItemOpenEnquiryForm_Fragment
    | LinkItem_LinkItemOpenSpeakToExpertModal_Fragment
    | LinkItem_Page_Fragment
    | LinkItem_Post_Fragment
    | LinkItem_Questionnaire_Fragment

export type PageLinkFragment = { __typename: 'Page' } & Pick<
    Page,
    'id' | 'path'
>

export type PostLinkFragment = { __typename: 'Post' } & Pick<
    Post,
    'id' | 'slug'
>

export type CustomLinkFragment = { __typename: 'LinkItemCustom' } & Pick<
    LinkItemCustom,
    'url'
>

export type LinkQuestionnaireFragment = { __typename: 'Questionnaire' } & Pick<
    Questionnaire,
    'id'
>

export type LinkItemOpenEnquiryFormFragment = {
    __typename: 'LinkItemOpenEnquiryForm'
} & Pick<LinkItemOpenEnquiryForm, 'enquiryType'>

export type LinkItemOpenContactFormFragment = {
    __typename: 'LinkItemOpenContactForm'
}

export type LinkItemOpenSpeakToExpertModalFragment = {
    __typename: 'LinkItemOpenSpeakToExpertModal'
}

type LinkDesignStudioProduct_DesignStudioProductAdditionalResize_Fragment = {
    __typename: 'DesignStudioProductAdditionalResize'
} & Pick<DesignStudioProductAdditionalResize, 'id'>

type LinkDesignStudioProduct_DesignStudioProductCustom_Fragment = {
    __typename: 'DesignStudioProductCustom'
} & Pick<DesignStudioProductCustom, 'id'>

type LinkDesignStudioProduct_DesignStudioProductEngagementRing_Fragment = {
    __typename: 'DesignStudioProductEngagementRing'
} & Pick<DesignStudioProductEngagementRing, 'id'>

type LinkDesignStudioProduct_DesignStudioProductGeneric_Fragment = {
    __typename: 'DesignStudioProductGeneric'
} & Pick<DesignStudioProductGeneric, 'id'>

type LinkDesignStudioProduct_DesignStudioProductLooseStone_Fragment = {
    __typename: 'DesignStudioProductLooseStone'
} & Pick<DesignStudioProductLooseStone, 'id'>

type LinkDesignStudioProduct_DesignStudioProductWeddingRing_Fragment = {
    __typename: 'DesignStudioProductWeddingRing'
} & Pick<DesignStudioProductWeddingRing, 'id'>

export type LinkDesignStudioProductFragment =
    | LinkDesignStudioProduct_DesignStudioProductAdditionalResize_Fragment
    | LinkDesignStudioProduct_DesignStudioProductCustom_Fragment
    | LinkDesignStudioProduct_DesignStudioProductEngagementRing_Fragment
    | LinkDesignStudioProduct_DesignStudioProductGeneric_Fragment
    | LinkDesignStudioProduct_DesignStudioProductLooseStone_Fragment
    | LinkDesignStudioProduct_DesignStudioProductWeddingRing_Fragment

export type LinkOrderFragment = { __typename: 'Order' } & Pick<Order, 'id'>

export type PageFragment = { __typename: 'Page' } & Pick<
    Page,
    'id' | 'title' | 'path'
> & {
        blocks: Array<{ __typename: 'Block' } & BlockFragment>
        meta: { __typename: 'Meta' } & MetaFragment
        pageSettings: { __typename: 'PageSettings' } & Pick<
            PageSettings,
            'showRingBuilder'
        >
    }

export type PageByPathQueryVariables = Exact<{
    path: Scalars['String']['input']
    locale: Scalars['Locale']['input']
    currency: CurrencyInput
    region: RegionCode
}>

export type PageByPathQuery = { __typename: 'Query' } & {
    pageByPath: Maybe<{ __typename: 'Page' } & PageFragment>
}

export type ProductPageListingFragment = {
    __typename: 'ProductPageListing'
} & Pick<ProductPageListing, 'id'> & {
        beforeFilters: Array<{ __typename: 'Block' } & BlockFragment>
        afterGrid: Array<{ __typename: 'Block' } & BlockFragment>
        banner1: Maybe<{ __typename: 'Banner1' } & Banner1Fragment>
        banner2: Maybe<{ __typename: 'Banner2' } & Banner2Fragment>
        meta: { __typename: 'Meta' } & MetaFragment
    }

export type TooltipQueryVariables = Exact<{
    path: Scalars['String']['input']
    locale: Scalars['Locale']['input']
}>

export type TooltipQuery = { __typename: 'Query' } & {
    tooltip: Maybe<
        { __typename: 'Tooltip' } & Pick<Tooltip, 'title'> & {
                content: Array<
                    | ({
                          __typename: 'ComponentButton'
                      } & ContentComponentItem_ComponentButton_Fragment)
                    | ({
                          __typename: 'ComponentImage'
                      } & ContentComponentItem_ComponentImage_Fragment)
                    | ({
                          __typename: 'ComponentOrderedList'
                      } & ContentComponentItem_ComponentOrderedList_Fragment)
                    | ({
                          __typename: 'ComponentSpacer'
                      } & ContentComponentItem_ComponentSpacer_Fragment)
                    | ({
                          __typename: 'ComponentText'
                      } & ContentComponentItem_ComponentText_Fragment)
                    | ({
                          __typename: 'ComponentTitle'
                      } & ContentComponentItem_ComponentTitle_Fragment)
                >
            }
    >
}

export type AssetFragment = { __typename: 'Asset' } & Pick<Asset, 'id' | 'url'>

export type Banner1Fragment = { __typename: 'Banner1' } & Pick<
    Banner1,
    'backgroundColor' | 'preTitle' | 'title' | 'text'
> & {
        backgroundImage: Maybe<{ __typename: 'Image' } & ImageMediumFragment>
        button: Maybe<
            { __typename: 'ComponentButton' } & ComponentButtonFragment
        >
    }

export type Banner2Fragment = { __typename: 'Banner2' } & Pick<
    Banner2,
    'backgroundColor' | 'preTitle' | 'title' | 'text'
> & {
        button: Maybe<
            { __typename: 'ComponentButton' } & ComponentButtonFragment
        >
        image: Maybe<{ __typename: 'Image' } & ImageMediumFragment>
    }

export type CostumerConsultantFragment = { __typename: 'Consultant' } & Pick<
    Consultant,
    'id' | 'firstName'
> & {
        avatarImage: { __typename: 'GenericImage' } & Pick<GenericImage, 'url'>
        user: { __typename: 'User' } & Pick<User, 'id' | 'email'>
    }

export type MeFragment = { __typename: 'User' } & Pick<
    User,
    'id' | 'firstName' | 'lastName' | 'email' | 'isConsultant' | 'createdAt'
> & {
        customer: Maybe<
            { __typename: 'Customer' } & MakeMaybe<
                Pick<
                    Customer,
                    | 'id'
                    | 'disabledThirdPartyCookies'
                    | 'adminProfileUrl'
                    | 'salesforceProfileUrl'
                >,
                'adminProfileUrl' | 'salesforceProfileUrl'
            > & {
                    billingAddress: Maybe<
                        { __typename: 'Address' } & {
                            phoneNumber: Maybe<
                                { __typename: 'PhoneNumberType' } & Pick<
                                    PhoneNumberType,
                                    'e164' | 'nationalNumber' | 'countryCode'
                                >
                            >
                        }
                    >
                    consultant: Maybe<
                        {
                            __typename: 'Consultant'
                        } & CostumerConsultantFragment
                    >
                }
        >
    }

export type MetaFragment = { __typename: 'Meta' } & Pick<
    Meta,
    'title' | 'description'
> & { image: Maybe<{ __typename: 'Image' } & ImageLargeFragment> }

export type MoneyFragment = { __typename: 'Money' } & Pick<
    Money,
    'amount' | 'currency'
>

export type PaymentIconFragment = { __typename: 'PaymentIcon' } & Pick<
    PaymentIcon,
    'name'
> & { icon: { __typename: 'Image' } & ImageLargeFragment }

export type SocialNetworkFragment = { __typename: 'SocialNetwork' } & Pick<
    SocialNetwork,
    'name' | 'icon' | 'link'
>

export type TranslationFragment = { __typename: 'Translation' } & Pick<
    Translation,
    'translation' | 'token'
>

export type MagicLinkConsumeMutationVariables = Exact<{
    input: MagicLinkConsume
    isConsultant: Scalars['Boolean']['input']
}>

export type MagicLinkConsumeMutation = { __typename: 'Mutation' } & {
    magicLinkConsume:
        | ({ __typename: 'MagicLinkConsumeError' } & Pick<
              MagicLinkConsumeError,
              'message'
          >)
        | ({ __typename: 'MagicLinkConsumeSuccess' } & {
              login: {
                  __typename: 'LoginResponseSuccess'
              } & LoginResponseSuccessFragment
          })
}

export type MagicLinkRequestMutationVariables = Exact<{
    input: MagicLinkRequest
}>

export type MagicLinkRequestMutation = { __typename: 'Mutation' } & Pick<
    Mutation,
    'magicLinkRequest'
>

export type ApplyPromoCodeMutationVariables = Exact<{
    promoCode: Scalars['String']['input']
}>

export type ApplyPromoCodeMutation = { __typename: 'Mutation' } & {
    applyPromoCode: Maybe<
        {
            __typename: 'PromoCodeApplicationResult'
        } & PromoCodeApplicationResultFragment
    >
}

export type CompleteAffirmTransactionPostIframeMutationVariables = Exact<{
    input: AffirmCompleteTransactionInput
    locale: Scalars['Locale']['input']
}>

export type CompleteAffirmTransactionPostIframeMutation = {
    __typename: 'Mutation'
} & {
    completeAffirmTransactionPostIframe: {
        __typename: 'AffirmCompleteTransactionResponse'
    } & AffirmCompleteTransactionResponseFragment
}

export type CreateAffirmTransactionMutationVariables = Exact<{
    input: AffirmTransactionInput
    locale: Scalars['Locale']['input']
}>

export type CreateAffirmTransactionMutation = { __typename: 'Mutation' } & {
    createAffirmTransaction: {
        __typename: 'AffirmTransaction'
    } & AffirmTransactionFragment
}

export type PayViaAffirmMutationVariables = Exact<{
    input: AffirmPaymentInput
    locale: Scalars['Locale']['input']
}>

export type PayViaAffirmMutation = { __typename: 'Mutation' } & {
    payViaAffirm: {
        __typename: 'AffirmPaymentResponse'
    } & AffirmPaymentResponseFragment
}

export type CreateAllocationTransactionMutationVariables = Exact<{
    input: AllocationTransactionInput
    locale: Scalars['Locale']['input']
}>

export type CreateAllocationTransactionMutation = { __typename: 'Mutation' } & {
    createAllocationTransaction: {
        __typename: 'AllocationTransaction'
    } & AllocationTransactionFragment
}

export type PayViaAllocationMutationVariables = Exact<{
    allocationTransactionId: Scalars['ID']['input']
    locale: Scalars['Locale']['input']
}>

export type PayViaAllocationMutation = { __typename: 'Mutation' } & {
    payViaAllocation: { __typename: 'Order' } & OrderFragment
}

export type CreateBankTransactionMutationVariables = Exact<{
    orderId: Scalars['ID']['input']
    locale: Scalars['Locale']['input']
}>

export type CreateBankTransactionMutation = { __typename: 'Mutation' } & {
    createBankTransaction: {
        __typename: 'BankTransaction'
    } & BankTransactionFragment
}

export type PayViaBankMutationVariables = Exact<{
    bankTransactionId: Scalars['ID']['input']
    locale: Scalars['Locale']['input']
}>

export type PayViaBankMutation = { __typename: 'Mutation' } & {
    payViaBank: { __typename: 'Order' } & OrderFragment
}

export type CompleteCheckoutcomTransactionPost3dsMutationVariables = Exact<{
    input: CompleteCheckoutcomTransactionInput
    locale: Scalars['Locale']['input']
}>

export type CompleteCheckoutcomTransactionPost3dsMutation = {
    __typename: 'Mutation'
} & {
    completeCheckoutcomTransactionPost3ds:
        | ({
              __typename: 'CompleteCheckoutcomTransactionPost3dsFailureResponse'
          } & {
              errors: Array<
                  | { __typename: 'CheckoutcomOperationDeclinedError' }
                  | { __typename: 'DesiredDeliveryDateInvalidError' }
                  | { __typename: 'OrderAlreadyCompletedError' }
                  | { __typename: 'PaymentAmountInvalidError' }
              >
          })
        | ({
              __typename: 'CompleteCheckoutcomTransactionPost3dsSuccessResponse'
          } & { order: { __typename: 'Order' } & OrderFragment })
}

export type CreateCheckoutcomTransactionMutationVariables = Exact<{
    input: CreateCheckoutcomTransactionInput
    locale: Scalars['Locale']['input']
}>

export type CreateCheckoutcomTransactionMutation = {
    __typename: 'Mutation'
} & {
    createCheckoutcomTransaction:
        | ({ __typename: 'CreateCheckoutcomTransactionFailureResponse' } & {
              errors: Array<
                  | { __typename: 'AvataxAddressInvalidError' }
                  | { __typename: 'DesiredDeliveryDateInvalidError' }
                  | { __typename: 'OrderAddressNotConfirmedError' }
                  | { __typename: 'OrderAlreadyCompletedError' }
                  | { __typename: 'OrderEmptyError' }
                  | { __typename: 'PaymentAmountInvalidError' }
                  | { __typename: 'PaymentMethodNotAllowedError' }
              >
          })
        | ({ __typename: 'CreateCheckoutcomTransactionSuccessResponse' } & {
              transaction: {
                  __typename: 'CheckoutcomTransaction'
              } & TransactionInterface_CheckoutcomTransaction_Fragment
          })
}

export type PayViaCheckoutcomMutationVariables = Exact<{
    input: PayViaCheckoutcomInput
    locale: Scalars['Locale']['input']
}>

export type PayViaCheckoutcomMutation = { __typename: 'Mutation' } & {
    payViaCheckoutcom:
        | ({ __typename: 'PayViaCheckoutcomFailureResponse' } & {
              errors: Array<
                  | { __typename: 'CheckoutcomOperationDeclinedError' }
                  | { __typename: 'DesiredDeliveryDateInvalidError' }
                  | { __typename: 'OrderAlreadyCompletedError' }
                  | { __typename: 'PaymentAmountInvalidError' }
              >
          })
        | ({ __typename: 'PayViaCheckoutcomSuccessResponse' } & Pick<
              PayViaCheckoutcomSuccessResponse,
              'redirectUrl'
          > & { order: { __typename: 'Order' } & OrderFragment })
}

export type CreateKlarnaTransactionMutationVariables = Exact<{
    input: KlarnaTransactionInput
    locale: Scalars['Locale']['input']
}>

export type CreateKlarnaTransactionMutation = { __typename: 'Mutation' } & {
    createKlarnaTransaction: {
        __typename: 'KlarnaTransaction'
    } & KlarnaTransactionFragment
}

export type PayViaKlarnaMutationVariables = Exact<{
    input: KlarnaPaymentInput
    locale: Scalars['Locale']['input']
}>

export type PayViaKlarnaMutation = { __typename: 'Mutation' } & {
    payViaKlarna: {
        __typename: 'KlarnaPaymentResponse'
    } & KlarnaPaymentResponseFragment
}

export type PayViaNoPaymentMutationVariables = Exact<{
    orderId: Scalars['ID']['input']
    locale: Scalars['Locale']['input']
}>

export type PayViaNoPaymentMutation = { __typename: 'Mutation' } & {
    payViaNoPayment: { __typename: 'Order' } & OrderFragment
}

export type RemoveFromMyCartMutationVariables = Exact<{
    productId: Scalars['ID']['input']
    locale: Scalars['Locale']['input']
}>

export type RemoveFromMyCartMutation = { __typename: 'Mutation' } & {
    removeFromMyCart: { __typename: 'Order' } & OrderFragment
}

export type DesignStudioUploadMutationVariables = Exact<{
    file: Scalars['Upload']['input']
}>

export type DesignStudioUploadMutation = { __typename: 'Mutation' } & {
    createDesignInspiration: { __typename: 'DesignInspiration' } & Pick<
        DesignInspiration,
        'id' | 'url'
    >
}

export type QuestionnaireCompleteExistingCustomerMutationVariables = Exact<{
    input: QuestionnaireCompleteInput
}>

export type QuestionnaireCompleteExistingCustomerMutation = {
    __typename: 'Mutation'
} & {
    questionnaireCompleteExistingCustomer: {
        __typename: 'QuestionnaireCompletedExistingCustomerResponse'
    }
}

export type QuestionnaireCompleteNewCustomerMutationVariables = Exact<{
    input: QuestionnaireCompleteInput
    customer: CustomerRegistrationInput
    isConsultant: Scalars['Boolean']['input']
}>

export type QuestionnaireCompleteNewCustomerMutation = {
    __typename: 'Mutation'
} & {
    questionnaireCompleteNewCustomer: {
        __typename: 'QuestionnaireCompletedNewCustomerResponse'
    } & {
        customer: {
            __typename: 'CustomerRegistrationResponse'
        } & CustomerRegistrationResponseFragment
    }
}

export type RingBuilderResolveExistingCustomerMutationVariables = Exact<{
    input: RingBuilderResolveInput
    currency: CurrencyInput
    region: RegionCode
    locale: Scalars['Locale']['input']
}>

export type RingBuilderResolveExistingCustomerMutation = {
    __typename: 'Mutation'
} & {
    ringBuilderResolveExistingCustomer:
        | ({ __typename: 'RingBuilderResolvedExistingCustomerSuccess' } & Pick<
              RingBuilderResolvedExistingCustomerSuccess,
              'redirect'
          > & { ringBuilder: { __typename: 'RingBuilder' } & RbFragment })
        | { __typename: 'RingBuilderResolvedFailure' }
}

export type RingBuilderResolveNewCustomerMutationVariables = Exact<{
    input: RingBuilderResolveInput
    customer: CustomerRegistrationInput
    currency: CurrencyInput
    region: RegionCode
    locale: Scalars['Locale']['input']
    isConsultant: Scalars['Boolean']['input']
}>

export type RingBuilderResolveNewCustomerMutation = {
    __typename: 'Mutation'
} & {
    ringBuilderResolveNewCustomer:
        | { __typename: 'RingBuilderResolvedFailure' }
        | ({ __typename: 'RingBuilderResolvedNewCustomerSuccess' } & Pick<
              RingBuilderResolvedNewCustomerSuccess,
              'redirect'
          > & {
                  customer: {
                      __typename: 'CustomerRegistrationResponse'
                  } & CustomerRegistrationResponseFragment
                  ringBuilder: { __typename: 'RingBuilder' } & RbFragment
              })
}

export type RingBuilderSetMutationVariables = Exact<{
    input: RingBuilderInput
    currency: CurrencyInput
    region: RegionCode
    locale: Scalars['Locale']['input']
}>

export type RingBuilderSetMutation = { __typename: 'Mutation' } & {
    ringBuilderSet: { __typename: 'RingBuilderSetResult' } & {
        ringBuilder: { __typename: 'RingBuilder' } & RbFragment
    }
}

type CatalogueProduct_CatalogueEngagementRing_Fragment = {
    __typename: 'CatalogueEngagementRing'
} & Pick<
    CatalogueEngagementRing,
    'catalogueCode' | 'productName' | 'suffix' | 'customTitleTag'
> & {
        relatedProducts: Array<
            {
                __typename: 'CatalogueEngagementRing'
            } & RelatedProduct_CatalogueEngagementRing_Fragment
        >
    } & MetalVariation_CatalogueEngagementRing_Fragment

type CatalogueProduct_CatalogueJewelleryBracelet_Fragment = {
    __typename: 'CatalogueJewelleryBracelet'
} & Pick<
    CatalogueJewelleryBracelet,
    'catalogueCode' | 'productName' | 'suffix' | 'customTitleTag'
> & {
        relatedProducts: Array<
            {
                __typename: 'CatalogueJewelleryBracelet'
            } & RelatedProduct_CatalogueJewelleryBracelet_Fragment
        >
    } & MetalVariation_CatalogueJewelleryBracelet_Fragment

type CatalogueProduct_CatalogueJewelleryEarrings_Fragment = {
    __typename: 'CatalogueJewelleryEarrings'
} & Pick<
    CatalogueJewelleryEarrings,
    'catalogueCode' | 'productName' | 'suffix' | 'customTitleTag'
> & {
        relatedProducts: Array<
            {
                __typename: 'CatalogueJewelleryEarrings'
            } & RelatedProduct_CatalogueJewelleryEarrings_Fragment
        >
    } & MetalVariation_CatalogueJewelleryEarrings_Fragment

type CatalogueProduct_CatalogueJewelleryNecklace_Fragment = {
    __typename: 'CatalogueJewelleryNecklace'
} & Pick<
    CatalogueJewelleryNecklace,
    'catalogueCode' | 'productName' | 'suffix' | 'customTitleTag'
> & {
        relatedProducts: Array<
            {
                __typename: 'CatalogueJewelleryNecklace'
            } & RelatedProduct_CatalogueJewelleryNecklace_Fragment
        >
    } & MetalVariation_CatalogueJewelleryNecklace_Fragment

type CatalogueProduct_CatalogueJewelleryRing_Fragment = {
    __typename: 'CatalogueJewelleryRing'
} & Pick<
    CatalogueJewelleryRing,
    'catalogueCode' | 'productName' | 'suffix' | 'customTitleTag'
> & {
        relatedProducts: Array<
            {
                __typename: 'CatalogueJewelleryRing'
            } & RelatedProduct_CatalogueJewelleryRing_Fragment
        >
    } & MetalVariation_CatalogueJewelleryRing_Fragment

type CatalogueProduct_CatalogueReadyToGoRing_Fragment = {
    __typename: 'CatalogueReadyToGoRing'
} & Pick<
    CatalogueReadyToGoRing,
    'catalogueCode' | 'productName' | 'suffix' | 'customTitleTag'
> & {
        relatedProducts: Array<
            {
                __typename: 'CatalogueReadyToGoRing'
            } & RelatedProduct_CatalogueReadyToGoRing_Fragment
        >
    } & MetalVariation_CatalogueReadyToGoRing_Fragment

type CatalogueProduct_CatalogueWeddingRing_Fragment = {
    __typename: 'CatalogueWeddingRing'
} & Pick<
    CatalogueWeddingRing,
    'catalogueCode' | 'productName' | 'suffix' | 'customTitleTag'
> & {
        relatedProducts: Array<
            {
                __typename: 'CatalogueWeddingRing'
            } & RelatedProduct_CatalogueWeddingRing_Fragment
        >
    } & MetalVariation_CatalogueWeddingRing_Fragment

export type CatalogueProductFragment =
    | CatalogueProduct_CatalogueEngagementRing_Fragment
    | CatalogueProduct_CatalogueJewelleryBracelet_Fragment
    | CatalogueProduct_CatalogueJewelleryEarrings_Fragment
    | CatalogueProduct_CatalogueJewelleryNecklace_Fragment
    | CatalogueProduct_CatalogueJewelleryRing_Fragment
    | CatalogueProduct_CatalogueReadyToGoRing_Fragment
    | CatalogueProduct_CatalogueWeddingRing_Fragment

export type CatalogueVideoFragment = { __typename: 'CatalogueVideo' } & Pick<
    CatalogueVideo,
    'uri' | 'type'
>

export type ProductPageFacetedContentFragment = {
    __typename: 'ProductPageFacetedContent'
} & Pick<
    ProductPageFacetedContent,
    'title' | 'contentTitle' | 'description' | 'productString'
> & {
        longDescription: Maybe<
            | ({
                  __typename: 'ProductPageFacetedContentLongDescriptionBlock'
              } & ProductPageFacetedContentLongDescription_ProductPageFacetedContentLongDescriptionBlock_Fragment)
            | ({
                  __typename: 'ProductPageFacetedContentLongDescriptionText'
              } & ProductPageFacetedContentLongDescription_ProductPageFacetedContentLongDescriptionText_Fragment)
        >
        meta: { __typename: 'Meta' } & MetaFragment
    }

type ProductPageFacetedContentLongDescription_ProductPageFacetedContentLongDescriptionBlock_Fragment =
    { __typename: 'ProductPageFacetedContentLongDescriptionBlock' } & {
        blocks: Array<{ __typename: 'Block' } & BlockFragment>
    }

type ProductPageFacetedContentLongDescription_ProductPageFacetedContentLongDescriptionText_Fragment =
    { __typename: 'ProductPageFacetedContentLongDescriptionText' } & Pick<
        ProductPageFacetedContentLongDescriptionText,
        'text'
    >

export type ProductPageFacetedContentLongDescriptionFragment =
    | ProductPageFacetedContentLongDescription_ProductPageFacetedContentLongDescriptionBlock_Fragment
    | ProductPageFacetedContentLongDescription_ProductPageFacetedContentLongDescriptionText_Fragment

export type ProductPageFacetedContentLongDescriptionBlockFragment = {
    __typename: 'ProductPageFacetedContentLongDescriptionBlock'
} & { blocks: Array<{ __typename: 'Block' } & BlockFragment> }

export type CreateEnquiryCustomEngagementRingExistingCustomerMutationVariables =
    Exact<{
        input: EnquiryCustomEngagementRing
    }>

export type CreateEnquiryCustomEngagementRingExistingCustomerMutation = {
    __typename: 'Mutation'
} & {
    createEnquiryCustomEngagementRingExistingCustomer: {
        __typename: 'EnquiryResponseExistingCustomer'
    }
}

export type CreateEnquiryCustomEngagementRingNewCustomerMutationVariables =
    Exact<{
        input: EnquiryCustomEngagementRing
        customer: CustomerRegistrationInput
        locale: Scalars['Locale']['input']
        isConsultant: Scalars['Boolean']['input']
    }>

export type CreateEnquiryCustomEngagementRingNewCustomerMutation = {
    __typename: 'Mutation'
} & {
    createEnquiryCustomEngagementRingNewCustomer: {
        __typename: 'EnquiryResponseNewCustomer'
    } & EnquiryResponseNewCustomerFragment
}

export type EngagementRingFiltersFragment = {
    __typename: 'CatalogueEngagementRingFilters'
} & {
    price: {
        __typename: 'CataloguePriceRangeFilter'
    } & FilterPriceRangeFragment
    ringStyles: Array<
        {
            __typename: 'CatalogueFilterEngagementRingStylesItem'
        } & FilterEngagementRingStyleFragment
    >
    designFeatures: Array<
        {
            __typename: 'CatalogueFilterEngagementRingDesignFeatureItem'
        } & FilterEngagementRingDesignFeatureFragment
    >
    designStyles: Array<
        {
            __typename: 'CatalogueFilterEngagementRingDesingStyleItem'
        } & FilterEngagementRingDesignStyleFragment
    >
    centreStoneShapes: Array<
        { __typename: 'CatalogueFilterShapeItem' } & FilterShapeFragment
    >
    primaryMetals: Array<
        { __typename: 'CatalogueFilterMetalItem' } & MetalFilterFragment
    >
}

export type FilterShapeFragment = {
    __typename: 'CatalogueFilterShapeItem'
} & Pick<CatalogueFilterShapeItem, 'totalResults'> & {
        shape: { __typename: 'StoneShape' } & Pick<StoneShape, 'systemCode'> & {
                translation: { __typename: 'StoneShapeTranslation' } & Pick<
                    StoneShapeTranslation,
                    'name'
                >
                icon: Maybe<{ __typename: 'Asset' } & Pick<Asset, 'id' | 'url'>>
            }
    }

export type SignatureStoneInputFragment = {
    __typename: 'CatalogueEngagementRingSignatureStone'
} & Pick<CatalogueEngagementRingSignatureStone, 'width'> & {
        color: { __typename: 'StoneColor' } & Pick<StoneColor, 'systemCode'>
        crystal: { __typename: 'StoneCrystal' } & Pick<
            StoneCrystal,
            'systemCode'
        >
    }

export type CreateShapeEnquiryEngagementRingCollectionExistingCustomerMutationVariables =
    Exact<{
        input: EnquiryEngagementRingCollectionInput
    }>

export type CreateShapeEnquiryEngagementRingCollectionExistingCustomerMutation =
    { __typename: 'Mutation' } & {
        createEnquiryEngagementRingPreferAnotherShapeExistingCustomer: {
            __typename: 'EnquiryResponseExistingCustomer'
        }
    }

export type CreateShapeEnquiryEngagementRingCollectionNewCustomerMutationVariables =
    Exact<{
        input: EnquiryEngagementRingCollectionInput
        customer: CustomerRegistrationInput
        isConsultant: Scalars['Boolean']['input']
    }>

export type CreateShapeEnquiryEngagementRingCollectionNewCustomerMutation = {
    __typename: 'Mutation'
} & {
    createEnquiryEngagementRingPreferAnotherShapeNewCustomer: {
        __typename: 'EnquiryResponseNewCustomer'
    } & EnquiryResponseNewCustomerFragment
}

export type FilterEngagementRingDesignFeatureFragment = {
    __typename: 'CatalogueFilterEngagementRingDesignFeatureItem'
} & Pick<CatalogueFilterEngagementRingDesignFeatureItem, 'totalResults'> & {
        label: { __typename: 'EngagementRingDesignFeatureLabel' } & Pick<
            EngagementRingDesignFeatureLabel,
            'systemCode'
        > & {
                translation: { __typename: 'ProductLabelTranslation' } & Pick<
                    ProductLabelTranslation,
                    'name'
                > &
                    FacetedContentProductLabelTranslationFragment
                icon: Maybe<{ __typename: 'Asset' } & Pick<Asset, 'id' | 'url'>>
            }
    }

export type FilterEngagementRingDesignStyleFragment = {
    __typename: 'CatalogueFilterEngagementRingDesingStyleItem'
} & Pick<CatalogueFilterEngagementRingDesingStyleItem, 'totalResults'> & {
        label: { __typename: 'EngagementRingDesignStyleLabel' } & Pick<
            EngagementRingDesignStyleLabel,
            'systemCode'
        > & {
                translation: { __typename: 'ProductLabelTranslation' } & Pick<
                    ProductLabelTranslation,
                    'name'
                > &
                    FacetedContentProductLabelTranslationFragment
                icon: Maybe<{ __typename: 'Asset' } & Pick<Asset, 'id' | 'url'>>
            }
    }

export type FilterEngagementRingStyleFragment = {
    __typename: 'CatalogueFilterEngagementRingStylesItem'
} & Pick<CatalogueFilterEngagementRingStylesItem, 'totalResults'> & {
        label: { __typename: 'EngagementRingStyleLabel' } & Pick<
            EngagementRingStyleLabel,
            'systemCode'
        > & {
                translation: { __typename: 'ProductLabelTranslation' } & Pick<
                    ProductLabelTranslation,
                    'name'
                > &
                    FacetedContentProductLabelTranslationFragment
                icon: Maybe<{ __typename: 'Asset' } & Pick<Asset, 'id' | 'url'>>
            }
    }

export type FilterPriceRangeFragment = {
    __typename: 'CataloguePriceRangeFilter'
} & {
    currentRange: { __typename: 'CataloguePriceRange' } & {
        min: { __typename: 'Money' } & MoneyFragment
        max: { __typename: 'Money' } & MoneyFragment
    }
}

export type FilterWeddingRingCategoryFragment = {
    __typename: 'CatalogueFilterWeddingRingCategoriesItem'
} & Pick<CatalogueFilterWeddingRingCategoriesItem, 'totalResults'> & {
        label: { __typename: 'WeddingRingCategoryLabel' } & Pick<
            WeddingRingCategoryLabel,
            'systemCode'
        > & {
                translation: { __typename: 'ProductLabelTranslation' } & Pick<
                    ProductLabelTranslation,
                    'name'
                > &
                    FacetedContentProductLabelTranslationFragment
                icon: Maybe<{ __typename: 'Asset' } & Pick<Asset, 'id' | 'url'>>
            }
    }

export type FilterWeddingRingStyleFragment = {
    __typename: 'CatalogueFilterWeddingRingStylesItem'
} & Pick<CatalogueFilterWeddingRingStylesItem, 'totalResults'> & {
        label: { __typename: 'WeddingRingStyleLabel' } & Pick<
            WeddingRingStyleLabel,
            'systemCode'
        > & {
                translation: { __typename: 'ProductLabelTranslation' } & Pick<
                    ProductLabelTranslation,
                    'name'
                > &
                    FacetedContentProductLabelTranslationFragment
                icon: Maybe<{ __typename: 'Asset' } & Pick<Asset, 'id' | 'url'>>
            }
    }

export type MetalFilterFragment = {
    __typename: 'CatalogueFilterMetalItem'
} & Pick<CatalogueFilterMetalItem, 'totalResults'> & {
        metal: { __typename: 'Metal' } & MetalFilterMetalFragment
    }

export type MetalFilterMetalFragment = { __typename: 'Metal' } & Pick<
    Metal,
    'systemCode' | 'karat'
> & {
        translation: { __typename: 'MetalTranslation' } & Pick<
            MetalTranslation,
            'name'
        >
        color: Maybe<
            { __typename: 'MetalColor' } & Pick<MetalColor, 'systemCode'> & {
                    translation: { __typename: 'MetalColorTranslation' } & Pick<
                        MetalColorTranslation,
                        'name'
                    >
                }
        >
        element: { __typename: 'MetalElement' } & Pick<
            MetalElement,
            'systemCode'
        > & {
                translation: { __typename: 'MetalElementTranslation' } & Pick<
                    MetalElementTranslation,
                    'name'
                >
            }
    }

export type RecommendedRingSizeFragment = {
    __typename: 'RecommendedRingSize'
} & Pick<RecommendedRingSize, 'id' | 'label'> & {
        ringSize: { __typename: 'RingSize' } & RingSizeFragment
    }

export type RingSizeFragment = { __typename: 'RingSize' } & Pick<
    RingSize,
    'id'
> & { ringSizeLabel: RingSize['label'] }

type Jewellery_CatalogueJewelleryBracelet_Fragment = {
    __typename: 'CatalogueJewelleryBracelet'
} & Pick<CatalogueJewelleryBracelet, 'engravingDisabled'> & {
        translation: {
            __typename: 'CatalogueJewelleryBraceletTranslation'
        } & Pick<
            CatalogueJewelleryBraceletTranslation,
            'description' | 'seoText'
        >
        braceletProductStyles: Array<
            {
                __typename: 'JewelleryBraceletProductStyleLabel'
            } & JewelleryBraceletProductStyleLabelFragment
        >
        firstAvailableDeliveryDateHasEngraving: {
            __typename: 'DeliveryDate'
        } & DeliveryTimeframeFragment
        firstAvailableDeliveryDate: {
            __typename: 'DeliveryDate'
        } & DeliveryTimeframeFragment
        variations: Array<
            {
                __typename: 'CatalogueJewelleryBracelet'
            } & MetalVariation_CatalogueJewelleryBracelet_Fragment &
                JewelleryLink_CatalogueJewelleryBracelet_Fragment
        >
        designStyles: Array<
            {
                __typename: 'JewelleryDesignStyleLabel'
            } & JewelleryDesignStyleLabelFragment
        >
        gemstones: Array<
            { __typename: 'JewelleryGemstoneLabel' } & Pick<
                JewelleryGemstoneLabel,
                'systemCode'
            > & {
                    translation: {
                        __typename: 'ProductLabelTranslation'
                    } & Pick<ProductLabelTranslation, 'name'>
                }
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        } & TaxSnippetFragment
    } & CatalogueProduct_CatalogueJewelleryBracelet_Fragment &
    ProductGallery_CatalogueJewelleryBracelet_Fragment &
    ProductAnalytics_CatalogueJewelleryBracelet_Fragment &
    ProductPageMeta_CatalogueJewelleryBracelet_Fragment

type Jewellery_CatalogueJewelleryEarrings_Fragment = {
    __typename: 'CatalogueJewelleryEarrings'
} & Pick<CatalogueJewelleryEarrings, 'engravingDisabled'> & {
        translation: {
            __typename: 'CatalogueJewelleryEarringsTranslation'
        } & Pick<
            CatalogueJewelleryEarringsTranslation,
            'description' | 'seoText'
        >
        earringsProductStyles: Array<
            {
                __typename: 'JewelleryEarringsProductStyleLabel'
            } & JewelleryEarringsProductStyleLabelFragment
        >
        firstAvailableDeliveryDateHasEngraving: {
            __typename: 'DeliveryDate'
        } & DeliveryTimeframeFragment
        firstAvailableDeliveryDate: {
            __typename: 'DeliveryDate'
        } & DeliveryTimeframeFragment
        variations: Array<
            {
                __typename: 'CatalogueJewelleryEarrings'
            } & MetalVariation_CatalogueJewelleryEarrings_Fragment &
                JewelleryLink_CatalogueJewelleryEarrings_Fragment
        >
        designStyles: Array<
            {
                __typename: 'JewelleryDesignStyleLabel'
            } & JewelleryDesignStyleLabelFragment
        >
        gemstones: Array<
            { __typename: 'JewelleryGemstoneLabel' } & Pick<
                JewelleryGemstoneLabel,
                'systemCode'
            > & {
                    translation: {
                        __typename: 'ProductLabelTranslation'
                    } & Pick<ProductLabelTranslation, 'name'>
                }
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        } & TaxSnippetFragment
    } & CatalogueProduct_CatalogueJewelleryEarrings_Fragment &
    ProductGallery_CatalogueJewelleryEarrings_Fragment &
    ProductAnalytics_CatalogueJewelleryEarrings_Fragment &
    ProductPageMeta_CatalogueJewelleryEarrings_Fragment

type Jewellery_CatalogueJewelleryNecklace_Fragment = {
    __typename: 'CatalogueJewelleryNecklace'
} & Pick<CatalogueJewelleryNecklace, 'engravingDisabled'> & {
        translation: {
            __typename: 'CatalogueJewelleryNecklaceTranslation'
        } & Pick<
            CatalogueJewelleryNecklaceTranslation,
            'description' | 'seoText'
        >
        necklaceProductStyles: Array<
            {
                __typename: 'JewelleryNecklaceProductStyleLabel'
            } & JewelleryNecklaceProductStyleLabelFragment
        >
        firstAvailableDeliveryDateHasEngraving: {
            __typename: 'DeliveryDate'
        } & DeliveryTimeframeFragment
        firstAvailableDeliveryDate: {
            __typename: 'DeliveryDate'
        } & DeliveryTimeframeFragment
        variations: Array<
            {
                __typename: 'CatalogueJewelleryNecklace'
            } & MetalVariation_CatalogueJewelleryNecklace_Fragment &
                JewelleryLink_CatalogueJewelleryNecklace_Fragment
        >
        designStyles: Array<
            {
                __typename: 'JewelleryDesignStyleLabel'
            } & JewelleryDesignStyleLabelFragment
        >
        gemstones: Array<
            { __typename: 'JewelleryGemstoneLabel' } & Pick<
                JewelleryGemstoneLabel,
                'systemCode'
            > & {
                    translation: {
                        __typename: 'ProductLabelTranslation'
                    } & Pick<ProductLabelTranslation, 'name'>
                }
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        } & TaxSnippetFragment
    } & CatalogueProduct_CatalogueJewelleryNecklace_Fragment &
    ProductGallery_CatalogueJewelleryNecklace_Fragment &
    ProductAnalytics_CatalogueJewelleryNecklace_Fragment &
    ProductPageMeta_CatalogueJewelleryNecklace_Fragment

type Jewellery_CatalogueJewelleryRing_Fragment = {
    __typename: 'CatalogueJewelleryRing'
} & Pick<CatalogueJewelleryRing, 'engravingDisabled'> & {
        translation: { __typename: 'CatalogueJewelleryRingTranslation' } & Pick<
            CatalogueJewelleryRingTranslation,
            'description' | 'seoText'
        >
        jewelleryRingProductStyles: Array<
            {
                __typename: 'JewelleryRingProductStyleLabel'
            } & JewelleryRingProductStyleLabelFragment
        >
        firstAvailableDeliveryDateHasEngraving: {
            __typename: 'DeliveryDate'
        } & DeliveryTimeframeFragment
        firstAvailableDeliveryDate: {
            __typename: 'DeliveryDate'
        } & DeliveryTimeframeFragment
        variations: Array<
            {
                __typename: 'CatalogueJewelleryRing'
            } & MetalVariation_CatalogueJewelleryRing_Fragment &
                JewelleryLink_CatalogueJewelleryRing_Fragment
        >
        sizes: Array<
            | ({
                  __typename: 'RecommendedRingSize'
              } & RecommendedRingSizeFragment)
            | ({ __typename: 'RingSize' } & RingSizeFragment)
        >
        designStyles: Array<
            {
                __typename: 'JewelleryDesignStyleLabel'
            } & JewelleryDesignStyleLabelFragment
        >
        gemstones: Array<
            { __typename: 'JewelleryGemstoneLabel' } & Pick<
                JewelleryGemstoneLabel,
                'systemCode'
            > & {
                    translation: {
                        __typename: 'ProductLabelTranslation'
                    } & Pick<ProductLabelTranslation, 'name'>
                }
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        } & TaxSnippetFragment
    } & CatalogueProduct_CatalogueJewelleryRing_Fragment &
    ProductGallery_CatalogueJewelleryRing_Fragment &
    ProductAnalytics_CatalogueJewelleryRing_Fragment &
    ProductPageMeta_CatalogueJewelleryRing_Fragment

export type JewelleryFragment =
    | Jewellery_CatalogueJewelleryBracelet_Fragment
    | Jewellery_CatalogueJewelleryEarrings_Fragment
    | Jewellery_CatalogueJewelleryNecklace_Fragment
    | Jewellery_CatalogueJewelleryRing_Fragment

export type CatalogueReadyToGoRingTranslationFragment = {
    __typename: 'CatalogueReadyToGoRingTranslation'
} & Pick<CatalogueReadyToGoRingTranslation, 'description' | 'seoText'>

export type ReadyToGoRingFiltersFragment = {
    __typename: 'CatalogueReadyToGoRingFilters'
} & {
    price: {
        __typename: 'CataloguePriceRangeFilter'
    } & FilterPriceRangeFragment
    primaryMetals: Array<
        { __typename: 'CatalogueFilterMetalItem' } & MetalFilterFragment
    >
}

export type ReadyToGoRingVariationsFragment = {
    __typename: 'CatalogueReadyToGoRing'
} & Pick<CatalogueReadyToGoRing, 'catalogueCode' | 'gemType' | 'carat'> &
    ReadyToGoRingLinkFragment

export type WeddingRingFiltersFragment = {
    __typename: 'CatalogueWeddingRingFilters'
} & {
    price: {
        __typename: 'CataloguePriceRangeFilter'
    } & FilterPriceRangeFragment
    ringStyles: Array<
        {
            __typename: 'CatalogueFilterWeddingRingStylesItem'
        } & FilterWeddingRingStyleFragment
    >
    categories: Array<
        {
            __typename: 'CatalogueFilterWeddingRingCategoriesItem'
        } & FilterWeddingRingCategoryFragment
    >
    primaryMetals: Array<
        { __typename: 'CatalogueFilterMetalItem' } & MetalFilterFragment
    >
}

export type CreateDiamondSearchProductEnquiryExistingCustomerMutationVariables =
    Exact<{
        input: EnquiryDiamondSearchProduct
    }>

export type CreateDiamondSearchProductEnquiryExistingCustomerMutation = {
    __typename: 'Mutation'
} & {
    createEnquiryDiamondSearchProductExistingCustomer: {
        __typename: 'EnquiryResponseExistingCustomer'
    }
}

export type CreateDiamondSearchProductEnquiryNewCustomerMutationVariables =
    Exact<{
        input: EnquiryDiamondSearchProduct
        customer: CustomerRegistrationInput
        locale: Scalars['Locale']['input']
        isConsultant: Scalars['Boolean']['input']
    }>

export type CreateDiamondSearchProductEnquiryNewCustomerMutation = {
    __typename: 'Mutation'
} & {
    createEnquiryDiamondSearchProductNewCustomer: {
        __typename: 'EnquiryResponseNewCustomer'
    } & EnquiryResponseNewCustomerFragment
}

export type QuestionnaireQueryVariables = Exact<{
    id: Scalars['ID']['input']
    locale: Scalars['Locale']['input']
    currency: CurrencyInput
    region: RegionCode
}>

export type QuestionnaireQuery = { __typename: 'Query' } & {
    questionnaire: Maybe<
        { __typename: 'Questionnaire' } & QuestionnaireFragment
    >
}

export type CatalogueEngagementRingInputFragment = {
    __typename: 'CatalogueEngagementRing'
} & Pick<CatalogueEngagementRing, 'catalogueCode' | 'slug' | 'suffixSlug'> & {
        centreStoneConstraints: {
            __typename: 'CatalogueEngagementRingCentreStoneConstraints'
        } & {
            shape: { __typename: 'StoneShape' } & Pick<StoneShape, 'systemCode'>
        }
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'systemCode'>
    }

export type RbFragment = { __typename: 'RingBuilder' } & Pick<
    RingBuilder,
    'id' | 'productId'
> & {
        position1: Maybe<
            | ({
                  __typename: 'RingBuilderCentreStoneFragment'
              } & RingBuilderFragment_RingBuilderCentreStoneFragment_Fragment)
            | ({
                  __typename: 'RingBuilderMountFragment'
              } & RingBuilderFragment_RingBuilderMountFragment_Fragment)
        >
        position2: Maybe<
            | ({
                  __typename: 'RingBuilderCentreStoneFragment'
              } & RingBuilderFragment_RingBuilderCentreStoneFragment_Fragment)
            | ({
                  __typename: 'RingBuilderMountFragment'
              } & RingBuilderFragment_RingBuilderMountFragment_Fragment)
        >
        image: Maybe<
            { __typename: 'GenericImage' } & {
                small_x2: {
                    __typename: 'MonolithImageSize'
                } & MonolithImageSizeFragment
                large_x2: {
                    __typename: 'MonolithImageSize'
                } & MonolithImageSizeFragment
            }
        >
        salePrice: { __typename: 'SalePrice' } & TaxSnippetFragment
        financeOptionsAffirm: Maybe<
            { __typename: 'AffirmFinanceOption' } & AffirmFinanceOptionsFragment
        >
        financeOptionsKlarna: Maybe<
            { __typename: 'KlarnaFinanceOption' } & KlarnaFinanceOptionsFragment
        >
        failure: Maybe<
            { __typename: 'DesignStudioEngagementRingFailure' } & {
                errors: Array<
                    | { __typename: 'DesignStudioEngagementRingErrorGeneric' }
                    | {
                          __typename: 'DesignStudioEngagementRingErrorMaxCaratWeight'
                      }
                    | {
                          __typename: 'DesignStudioEngagementRingErrorMinCaratWeight'
                      }
                    | {
                          __typename: 'DesignStudioEngagementRingErrorShapeMismatch'
                      }
                >
            }
        >
    }

type RingBuilderFragment_RingBuilderCentreStoneFragment_Fragment = {
    __typename: 'RingBuilderCentreStoneFragment'
} & RingBuilderCentreStoneFragmentFragment

type RingBuilderFragment_RingBuilderMountFragment_Fragment = {
    __typename: 'RingBuilderMountFragment'
} & RingBuilderMountFragmentFragment

export type RingBuilderFragmentFragment =
    | RingBuilderFragment_RingBuilderCentreStoneFragment_Fragment
    | RingBuilderFragment_RingBuilderMountFragment_Fragment

export type RingBuilderMountFragmentFragment = {
    __typename: 'RingBuilderMountFragment'
} & Pick<RingBuilderMountFragment, 'id'> & {
        ring: Maybe<
            { __typename: 'CatalogueEngagementRing' } & {
                variationsByCentreStoneShape: Array<
                    { __typename: 'CatalogueEngagementRing' } & {
                        centreStoneConstraints: {
                            __typename: 'CatalogueEngagementRingCentreStoneConstraints'
                        } & {
                            shape: { __typename: 'StoneShape' } & Pick<
                                StoneShape,
                                'systemCode'
                            >
                        }
                    } & CatalogueEngagementRingInputFragment
                >
            } & RingBuilderMountEngagementRingFragment &
                EngagementRingLinkFragment &
                ProductPageMeta_CatalogueEngagementRing_Fragment
        >
        signatureStone: Maybe<
            { __typename: 'CatalogueEngagementRingSignatureStone' } & Pick<
                CatalogueEngagementRingSignatureStone,
                'image' | 'segmentName'
            > & {
                    crystal: { __typename: 'StoneCrystal' } & {
                        translation: {
                            __typename: 'StoneCrystalTranslation'
                        } & Pick<StoneCrystalTranslation, 'name'>
                    }
                    color: { __typename: 'StoneColor' } & {
                        translation: {
                            __typename: 'StoneColorTranslation'
                        } & Pick<StoneColorTranslation, 'name'>
                    }
                } & SignatureStoneInputFragment
        >
        totalSalePrice: { __typename: 'Money' } & MoneyFragment
    }

export type RingBuilderCentreStoneFragmentFragment = {
    __typename: 'RingBuilderCentreStoneFragment'
} & Pick<RingBuilderCentreStoneFragment, 'id'> & {
        stone: Maybe<
            | ({ __typename: 'GemsApiStone' } & {
                  stone: Maybe<
                      { __typename: 'GemsApi_Stone' } & StoneFragment &
                          GemsApiStoneAnalyticsFragment &
                          GemsApiCertificateFragment
                  >
              })
            | ({ __typename: 'NonSkuGemstone' } & NonSkuGemstoneFragment &
                  NonSkuGemstoneAnalyticsFragment)
            | ({ __typename: 'NonSkuLabGrown' } & NonSkuLabGrownFragment &
                  NonSkuLabGrownAnalyticsFragment)
        >
        totalSalePrice: { __typename: 'Money' } & MoneyFragment
    }

export type RingBuilderMountEngagementRingFragment = {
    __typename: 'CatalogueEngagementRing'
} & Pick<
    CatalogueEngagementRing,
    'productName' | 'catalogueCode' | 'suffix'
> & {
        images: Array<
            { __typename: 'CatalogueImage' } & {
                small_x2: {
                    __typename: 'MonolithImageSize'
                } & MonolithImageSizeFragment
                large_x2: {
                    __typename: 'MonolithImageSize'
                } & MonolithImageSizeFragment
            }
        >
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'systemCode'> & {
                translation: { __typename: 'MetalTranslation' } & Pick<
                    MetalTranslation,
                    'name'
                >
            }
        centreStoneConstraints: {
            __typename: 'CatalogueEngagementRingCentreStoneConstraints'
        } & {
            shape: { __typename: 'StoneShape' } & Pick<
                StoneShape,
                'systemCode'
            > & {
                    translation: { __typename: 'StoneShapeTranslation' } & Pick<
                        StoneShapeTranslation,
                        'name'
                    >
                }
            weight: {
                __typename: 'CatalogueEngagementRingCentreStoneWeightConstraint'
            } & Pick<
                CatalogueEngagementRingCentreStoneWeightConstraint,
                'max' | 'min'
            >
        }
        sizes: Array<
            | ({
                  __typename: 'RecommendedRingSize'
              } & RecommendedRingSizeFragment)
            | ({ __typename: 'RingSize' } & RingSizeFragment)
        >
    } & EngagementRingLinkFragment &
    CatalogueEngagementRingInputFragment

export type GemsFindStonesQueryVariables = Exact<{
    filters: InputMaybe<GemsApi_StoneFilters>
    market: Scalars['String']['input']
    categories: Array<GemsApi_StoneCategory> | GemsApi_StoneCategory
    notClarity: Array<GemsApi_StoneClarity> | GemsApi_StoneClarity
    notColour: Array<GemsApi_StoneColour> | GemsApi_StoneColour
    notSymmetry: Array<GemsApi_StoneSymmetry> | GemsApi_StoneSymmetry
    locale: Scalars['Locale']['input']
    currency: CurrencyInput
    region: RegionCode
    getBound: Scalars['Boolean']['input']
    getStones: Scalars['Boolean']['input']
    isConsultant: InputMaybe<Scalars['Boolean']['input']>
    contentPath: Scalars['String']['input']
}>

export type GemsFindStonesQuery = { __typename: 'Query' } & {
    GemsApi_findStones?: Maybe<
        { __typename: 'GemsApi_StoneCollection' } & {
            collection: Array<{ __typename: 'GemsApi_Stone' } & StoneFragment>
            pagination: { __typename: 'GemsApi_Pagination' } & Pick<
                GemsApi_Pagination,
                'limit' | 'pages' | 'total'
            >
            filters: {
                __typename: 'GemsApi_SelectedStoneFilters'
            } & GemsSelectedFiltersFragment
        }
    >
    GemsApi_getBounds?: Maybe<
        { __typename: 'GemsApi_Bounds' } & GemsBoundsFragment
    >
    pageProductListing: Maybe<
        { __typename: 'ProductPageListing' } & ProductPageListingFragment
    >
}

export type GetBoundsQueryVariables = Exact<{
    currency: CurrencyInput
    region: RegionCode
    market: Scalars['String']['input']
    categories: Array<GemsApi_StoneCategory> | GemsApi_StoneCategory
    locale: Scalars['Locale']['input']
}>

export type GetBoundsQuery = { __typename: 'Query' } & {
    GemsApi_getBounds: Maybe<
        { __typename: 'GemsApi_Bounds' } & GemsBoundsFragment
    >
}

export type GetStoneQueryVariables = Exact<{
    identifier: Scalars['GemsApi_StoneIdentifier']['input']
    locale: Scalars['Locale']['input']
    currency: CurrencyInput
    region: RegionCode
}>

export type GetStoneQuery = { __typename: 'Query' } & {
    GemsApi_getStone: Maybe<
        { __typename: 'GemsApi_Stone' } & Pick<
            GemsApi_Stone,
            'containsEngagementRings'
        > &
            StoneFragment
    >
}

export type GetStoneByGiaQueryVariables = Exact<{
    giaNumber: Scalars['String']['input']
    locale: Scalars['Locale']['input']
    currency: CurrencyInput
    region: RegionCode
}>

export type GetStoneByGiaQuery = { __typename: 'Query' } & {
    GemsApi_getGiaStone: Maybe<{ __typename: 'GemsApi_Stone' } & StoneFragment>
}

export type FindStoneByExternalIdQueryVariables = Exact<{
    feedIdentifier: Scalars['String']['input']
    externalId: Scalars['String']['input']
    locale: Scalars['Locale']['input']
    currency: CurrencyInput
    region: RegionCode
}>

export type FindStoneByExternalIdQuery = { __typename: 'Query' } & {
    GemsApi_getStoneByExternalId: Maybe<
        { __typename: 'GemsApi_Stone' } & StoneFragment
    >
}

export type ClarityTranslationFragment = {
    __typename: 'StoneClarityTranslation'
} & Pick<StoneClarityTranslation, 'name'>

export type GemsApiStoneCrystalWithInfoFragment = {
    __typename: 'GemsApi_StoneCrystalInfo'
} & Pick<GemsApi_StoneCrystalInfo, 'code'> & {
        info: Maybe<
            { __typename: 'StoneCrystal' } & Pick<StoneCrystal, 'systemCode'>
        >
    }

export type GemsApiStoneShapeWithInfoFragment = {
    __typename: 'GemsApi_StoneShapeInfo'
} & Pick<GemsApi_StoneShapeInfo, 'code'> & {
        info: Maybe<{ __typename: 'StoneShape' } & StoneShapeFragment>
    }

export type StoneCategoryFragment = { __typename: 'StoneCategory' } & Pick<
    StoneCategory,
    'systemCode'
> & {
        translation: {
            __typename: 'StoneCategoryTranslation'
        } & StoneCategoryTranslationFragment
    }

export type StoneCategoryTranslationFragment = {
    __typename: 'StoneCategoryTranslation'
} & Pick<StoneCategoryTranslation, 'name'>

export type StoneColorFragment = { __typename: 'StoneColor' } & Pick<
    StoneColor,
    'systemCode'
> & {
        translation: {
            __typename: 'StoneColorTranslation'
        } & StoneColorTranslationFragment
    }

export type StoneColorTranslationFragment = {
    __typename: 'StoneColorTranslation'
} & Pick<StoneColorTranslation, 'name'>

export type GemsBoundsFragment = { __typename: 'GemsApi_Bounds' } & Pick<
    GemsApi_Bounds,
    | 'colour'
    | 'grade'
    | 'shape'
    | 'clarity'
    | 'fluorescence'
    | 'cut'
    | 'polish'
    | 'symmetry'
    | 'shippingFromCountry'
    | 'originCountry'
    | 'category'
    | 'crystal'
> & {
        shapes: Array<
            {
                __typename: 'GemsApi_StoneShapeInfo'
            } & GemsApiStoneShapeWithInfoFragment
        >
        weight: { __typename: 'GemsApi_Range' } & GemsRangeFragment
        depthPercent: { __typename: 'GemsApi_Range' } & GemsRangeFragment
        tablePercent: { __typename: 'GemsApi_Range' } & GemsRangeFragment
        ratio: { __typename: 'GemsApi_Range' } & GemsRangeFragment
        length: { __typename: 'GemsApi_Range' } & GemsRangeFragment
        width: { __typename: 'GemsApi_Range' } & GemsRangeFragment
        depth: { __typename: 'GemsApi_Range' } & GemsRangeFragment
        deliveryDays: { __typename: 'GemsApi_IntRange' } & GemsIntRangeFragment
        price: {
            __typename: 'GemsApi_PriceRange'
        } & GemsPriceRangeInLocalCurrencyFragment
        priceByShape: Array<
            { __typename: 'GemsApi_PriceRangeByShape' } & Pick<
                GemsApi_PriceRangeByShape,
                'shape'
            > & {
                    range: {
                        __typename: 'GemsApi_PriceRange'
                    } & GemsPriceRangeInLocalCurrencyFragment
                }
        >
    }

export type StoneImageFragment = { __typename: 'GemsApi_StoneImage' } & Pick<
    GemsApi_StoneImage,
    'url' | 'isB2B'
>

export type GemsIntRangeFragment = { __typename: 'GemsApi_IntRange' } & Pick<
    GemsApi_IntRange,
    'min' | 'max'
>

export type GemsPriceRangeInLocalCurrencyFragment = {
    __typename: 'GemsApi_PriceRange'
} & Pick<GemsApi_PriceRange, 'min' | 'max'> & {
        minInCurrency: Maybe<{ __typename: 'Money' } & MoneyFragment>
        maxInCurrency: Maybe<{ __typename: 'Money' } & MoneyFragment>
    }

export type GemsPriceRangeFragment = {
    __typename: 'GemsApi_PriceRange'
} & Pick<GemsApi_PriceRange, 'min' | 'max'>

export type GemsRangeFragment = { __typename: 'GemsApi_Range' } & Pick<
    GemsApi_Range,
    'min' | 'max'
>

export type GemsSelectedFiltersFragment = {
    __typename: 'GemsApi_SelectedStoneFilters'
} & Pick<
    GemsApi_SelectedStoneFilters,
    | 'category'
    | 'crystal'
    | 'colour'
    | 'grade'
    | 'shape'
    | 'clarity'
    | 'fluorescence'
    | 'symmetry'
    | 'cut'
    | 'polish'
    | 'shippingFrom'
    | 'originCountry'
    | 'notColour'
    | 'notClarity'
    | 'notSymmetry'
    | 'lab'
    | 'collection'
    | 'hasPhoto'
    | 'isCanadaMark'
    | 'isDtlReport'
    | 'isScsReport'
    | 'withVideo'
    | 'withOriginCountry'
    | 'isStock'
    | 'isRtg'
    | 'priceIndex'
> & {
        price: Maybe<
            { __typename: 'GemsApi_SelectedRange' } & GemsSelectedRangeFragment
        >
        costPrice: Maybe<
            { __typename: 'GemsApi_SelectedRange' } & GemsSelectedRangeFragment
        >
        weight: Maybe<
            { __typename: 'GemsApi_SelectedRange' } & GemsSelectedRangeFragment
        >
        depthPercent: Maybe<
            { __typename: 'GemsApi_SelectedRange' } & GemsSelectedRangeFragment
        >
        tablePercent: Maybe<
            { __typename: 'GemsApi_SelectedRange' } & GemsSelectedRangeFragment
        >
        ratio: Maybe<
            { __typename: 'GemsApi_SelectedRange' } & GemsSelectedRangeFragment
        >
        length: Maybe<
            { __typename: 'GemsApi_SelectedRange' } & GemsSelectedRangeFragment
        >
        width: Maybe<
            { __typename: 'GemsApi_SelectedRange' } & GemsSelectedRangeFragment
        >
        depth: Maybe<
            { __typename: 'GemsApi_SelectedRange' } & GemsSelectedRangeFragment
        >
        sorting: Maybe<
            { __typename: 'GemsApi_SelectedSorting' } & Pick<
                GemsApi_SelectedSorting,
                'field' | 'direction'
            >
        >
    }

export type GemsSelectedRangeFragment = {
    __typename: 'GemsApi_SelectedRange'
} & Pick<GemsApi_SelectedRange, 'min' | 'max'>

export type StoneFragment = { __typename: 'GemsApi_Stone' } & Pick<
    GemsApi_Stone,
    | 'identifier'
    | 'blackInclusion'
    | 'colourShade'
    | 'crystal'
    | 'culet'
    | 'eyeClean'
    | 'fluorescenceColour'
    | 'girdleMin'
    | 'girdleMax'
    | 'growthMethod'
    | 'shippingFromCountry'
    | 'originCountry'
    | 'length'
    | 'width'
    | 'depth'
    | 'weight'
    | 'ratio'
    | 'pavilionDepth'
    | 'pavilionAngle'
    | 'tablePercent'
    | 'depthPercent'
    | 'crownAngle'
    | 'crownHeight'
    | 'v360Url'
    | 'isMilky'
    | 'isTreated'
    | 'isCertificateVerified'
    | 'isCanadaMark'
    | 'isB2B'
    | 'isValidB2C'
    | 'isHideCertificateNumber'
    | 'isHideMeasurements'
    | 'deliveryDays'
    | 'scsReport'
> & {
        categoryWithInfo: { __typename: 'GemsApi_StoneCategoryInfo' } & Pick<
            GemsApi_StoneCategoryInfo,
            'code'
        > & {
                info: Maybe<
                    { __typename: 'StoneCategory' } & StoneCategoryFragment
                >
            }
        clarityWithInfo: { __typename: 'GemsApi_StoneClarityInfo' } & Pick<
            GemsApi_StoneClarityInfo,
            'code'
        > & {
                info: Maybe<
                    { __typename: 'StoneClarity' } & StoneClarityFragment
                >
            }
        colorWithInfo: { __typename: 'GemsApi_StoneColorInfo' } & Pick<
            GemsApi_StoneColorInfo,
            'code'
        > & { info: Maybe<{ __typename: 'StoneColor' } & StoneColorFragment> }
        cutWithInfo: Maybe<
            { __typename: 'GemsApi_StoneCutInfo' } & Pick<
                GemsApi_StoneCutInfo,
                'code'
            > & {
                    info: Maybe<
                        { __typename: 'StoneCut' } & Pick<
                            StoneCut,
                            'abbreviation' | 'systemCode'
                        > & {
                                translation: {
                                    __typename: 'StoneCutTranslation'
                                } & Pick<StoneCutTranslation, 'name'>
                            }
                    >
                }
        >
        fluorescenceWithInfo: Maybe<
            { __typename: 'GemsApi_StoneFluorescenceInfo' } & Pick<
                GemsApi_StoneFluorescenceInfo,
                'code'
            > & {
                    info: Maybe<
                        { __typename: 'StoneFluorescence' } & Pick<
                            StoneFluorescence,
                            'abbreviation' | 'systemCode'
                        > & {
                                translation: {
                                    __typename: 'StoneFluorescenceTranslation'
                                } & Pick<StoneFluorescenceTranslation, 'name'>
                            }
                    >
                }
        >
        gradeWithInfo: Maybe<
            { __typename: 'GemsApi_StoneGradeInfo' } & Pick<
                GemsApi_StoneGradeInfo,
                'code'
            > & {
                    info: Maybe<
                        { __typename: 'StoneGrade' } & Pick<
                            StoneGrade,
                            'systemCode'
                        > & {
                                translation: {
                                    __typename: 'StoneGradeTranslation'
                                } & Pick<StoneGradeTranslation, 'name'>
                            }
                    >
                }
        >
        polishWithInfo: Maybe<
            { __typename: 'GemsApi_StonePolishInfo' } & Pick<
                GemsApi_StonePolishInfo,
                'code'
            > & {
                    info: Maybe<
                        { __typename: 'StonePolish' } & Pick<
                            StonePolish,
                            'abbreviation' | 'systemCode'
                        > & {
                                translation: {
                                    __typename: 'StonePolishTranslation'
                                } & Pick<StonePolishTranslation, 'name'>
                            }
                    >
                }
        >
        shapeWithInfo: { __typename: 'GemsApi_StoneShapeInfo' } & Pick<
            GemsApi_StoneShapeInfo,
            'code'
        > & {
                info: Maybe<
                    { __typename: 'StoneShape' } & Pick<
                        StoneShape,
                        'systemCode'
                    > & {
                            samplePhoto: Maybe<
                                { __typename: 'Asset' } & Pick<
                                    Asset,
                                    'id' | 'url'
                                >
                            >
                            icon: Maybe<
                                { __typename: 'Asset' } & Pick<
                                    Asset,
                                    'id' | 'url'
                                >
                            >
                            translation: {
                                __typename: 'StoneShapeTranslation'
                            } & Pick<StoneShapeTranslation, 'name'>
                        }
                >
            }
        symmetryWithInfo: Maybe<
            { __typename: 'GemsApi_StoneSymmetryInfo' } & Pick<
                GemsApi_StoneSymmetryInfo,
                'code'
            > & {
                    info: Maybe<
                        { __typename: 'StoneSymmetry' } & Pick<
                            StoneSymmetry,
                            'abbreviation' | 'systemCode'
                        > & {
                                translation: {
                                    __typename: 'StoneSymmetryTranslation'
                                } & Pick<StoneSymmetryTranslation, 'name'>
                            }
                    >
                }
        >
        image: Maybe<{ __typename: 'GemsApi_StoneImage' } & StoneImageFragment>
        images: Array<{ __typename: 'GemsApi_StoneImage' } & StoneImageFragment>
        dtlReport: Maybe<
            { __typename: 'GemsApi_dtlReport' } & Pick<
                GemsApi_DtlReport,
                'url' | 'code'
            >
        >
        salePrice: Maybe<{ __typename: 'Money' } & MoneyFragment>
    } & GemsApiCertificateFragment

export type StoneClarityFragment = { __typename: 'StoneClarity' } & Pick<
    StoneClarity,
    'abbreviation' | 'systemCode'
> & {
        translation: {
            __typename: 'StoneClarityTranslation'
        } & ClarityTranslationFragment
    }

export type StoneRecommendationsNotFoundFragment = {
    __typename: 'StoneRecommendationNotFound'
} & Pick<StoneRecommendationNotFound, 'haveWithoutPricingRange'>

export type NonSkuCaratWeightRangeFragment = {
    __typename: 'NonSkuCaratWeightRange'
} & Pick<NonSkuCaratWeightRange, 'min' | 'max'>

export type NonSkuGemstoneFragment = { __typename: 'NonSkuGemstone' } & Pick<
    NonSkuGemstone,
    'id' | 'caratWeight'
> & {
        shape: { __typename: 'StoneShape' } & StoneShapeFragment
        salePrice: Maybe<{ __typename: 'Money' } & MoneyFragment>
        cut: { __typename: 'StoneCut' } & StoneCutFragment
        crystal: { __typename: 'StoneCrystal' } & StoneCrystalFragment
        color: { __typename: 'StoneColor' } & StoneColorFragment
        colorGrade: { __typename: 'StoneGrade' } & StoneGradeFragment
        clarity: { __typename: 'StoneClarity' } & StoneClarityFragment
        image: Maybe<{ __typename: 'NonSkuImage' } & Pick<NonSkuImage, 'url'>>
    } & NonSkuGemstoneImageFragment

export type NonSkuGemstoneBoundsFragment = {
    __typename: 'NonSkuGemstonesBounds'
} & {
    caratWeight: {
        __typename: 'NonSkuCaratWeightRange'
    } & NonSkuCaratWeightRangeFragment
    price: Maybe<{ __typename: 'NonSkuPriceRange' } & NonSkuPriceRangeFragment>
    shapes: Array<{ __typename: 'StoneShape' } & StoneShapeFragment>
    types: Array<
        { __typename: 'NonSkuGemstoneType' } & Pick<
            NonSkuGemstoneType,
            'id'
        > & {
                crystal: { __typename: 'StoneCrystal' } & StoneCrystalFragment
                color: { __typename: 'StoneColor' } & StoneColorFragment
            }
    >
}

export type NonSkuLabGrownFragment = { __typename: 'NonSkuLabGrown' } & Pick<
    NonSkuLabGrown,
    'id' | 'caratWeight'
> & {
        salePrice: Maybe<{ __typename: 'Money' } & MoneyFragment>
        shape: { __typename: 'StoneShape' } & StoneShapeFragment
        color: { __typename: 'StoneColor' } & StoneColorFragment
        clarity: { __typename: 'StoneClarity' } & StoneClarityFragment
        image: Maybe<{ __typename: 'NonSkuImage' } & Pick<NonSkuImage, 'url'>>
    } & NonSkuLabGrownStoneImageFragment

export type NonSkuLabGrownDiamondBoundsFragment = {
    __typename: 'NonSkuLabGrownDiamondsBounds'
} & {
    caratWeight: {
        __typename: 'NonSkuCaratWeightRange'
    } & NonSkuCaratWeightRangeFragment
    price: Maybe<{ __typename: 'NonSkuPriceRange' } & NonSkuPriceRangeFragment>
    shapes: Array<{ __typename: 'StoneShape' } & StoneShapeFragment>
    colors: Array<{ __typename: 'StoneColor' } & StoneColorFragment>
}

export type NonSkuPriceRangeFragment = { __typename: 'NonSkuPriceRange' } & {
    min: { __typename: 'Money' } & MoneyFragment
    max: { __typename: 'Money' } & MoneyFragment
}

export type StoneCrystalFragment = { __typename: 'StoneCrystal' } & Pick<
    StoneCrystal,
    'systemCode'
> & {
        translation: {
            __typename: 'StoneCrystalTranslation'
        } & StoneCrystalTranslationFragment
    }

export type StoneCrystalTranslationFragment = {
    __typename: 'StoneCrystalTranslation'
} & Pick<StoneCrystalTranslation, 'name'>

export type StoneCutFragment = { __typename: 'StoneCut' } & Pick<
    StoneCut,
    'systemCode'
> & {
        translation: {
            __typename: 'StoneCutTranslation'
        } & StoneCutTranslationFragment
    }

export type StoneCutTranslationFragment = {
    __typename: 'StoneCutTranslation'
} & Pick<StoneCutTranslation, 'name'>

export type StoneGradeFragment = { __typename: 'StoneGrade' } & Pick<
    StoneGrade,
    'systemCode'
> & {
        translation: { __typename: 'StoneGradeTranslation' } & Pick<
            StoneGradeTranslation,
            'name'
        >
        category: { __typename: 'StoneCategory' } & StoneCategoryFragment
    }

export type StoneShapeFragment = { __typename: 'StoneShape' } & Pick<
    StoneShape,
    'systemCode'
> & {
        icon: Maybe<{ __typename: 'Asset' } & AssetFragment>
        samplePhoto: Maybe<{ __typename: 'Asset' } & AssetFragment>
        translation: {
            __typename: 'StoneShapeTranslation'
        } & StoneShapeTranslationFragment
    }

export type StoneShapeTranslationFragment = {
    __typename: 'StoneShapeTranslation'
} & Pick<StoneShapeTranslation, 'name'>

type ProductLink_CatalogueEngagementRing_Fragment = {
    __typename: 'CatalogueEngagementRing'
} & EngagementRingLinkFragment

type ProductLink_CatalogueJewelleryBracelet_Fragment = {
    __typename: 'CatalogueJewelleryBracelet'
} & JewelleryLink_CatalogueJewelleryBracelet_Fragment

type ProductLink_CatalogueJewelleryEarrings_Fragment = {
    __typename: 'CatalogueJewelleryEarrings'
} & JewelleryLink_CatalogueJewelleryEarrings_Fragment

type ProductLink_CatalogueJewelleryNecklace_Fragment = {
    __typename: 'CatalogueJewelleryNecklace'
} & JewelleryLink_CatalogueJewelleryNecklace_Fragment

type ProductLink_CatalogueJewelleryRing_Fragment = {
    __typename: 'CatalogueJewelleryRing'
} & JewelleryLink_CatalogueJewelleryRing_Fragment

type ProductLink_CatalogueReadyToGoRing_Fragment = {
    __typename: 'CatalogueReadyToGoRing'
} & ReadyToGoRingLinkFragment

type ProductLink_CatalogueWeddingRing_Fragment = {
    __typename: 'CatalogueWeddingRing'
} & WeddingRingLinkFragment

export type ProductLinkFragment =
    | ProductLink_CatalogueEngagementRing_Fragment
    | ProductLink_CatalogueJewelleryBracelet_Fragment
    | ProductLink_CatalogueJewelleryEarrings_Fragment
    | ProductLink_CatalogueJewelleryNecklace_Fragment
    | ProductLink_CatalogueJewelleryRing_Fragment
    | ProductLink_CatalogueReadyToGoRing_Fragment
    | ProductLink_CatalogueWeddingRing_Fragment

export type EngagementRingLinkFragment = {
    __typename: 'CatalogueEngagementRing'
} & Pick<CatalogueEngagementRing, 'catalogueCode' | 'suffixSlug' | 'slug'> & {
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'systemCode'>
        centreStoneConstraints: {
            __typename: 'CatalogueEngagementRingCentreStoneConstraints'
        } & {
            shape: { __typename: 'StoneShape' } & Pick<StoneShape, 'systemCode'>
        }
    }

type JewelleryLink_CatalogueJewelleryBracelet_Fragment = {
    __typename: 'CatalogueJewelleryBracelet'
} & Pick<CatalogueJewelleryBracelet, 'slug' | 'suffixSlug'> & {
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'systemCode'>
    }

type JewelleryLink_CatalogueJewelleryEarrings_Fragment = {
    __typename: 'CatalogueJewelleryEarrings'
} & Pick<CatalogueJewelleryEarrings, 'slug' | 'suffixSlug'> & {
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'systemCode'>
    }

type JewelleryLink_CatalogueJewelleryNecklace_Fragment = {
    __typename: 'CatalogueJewelleryNecklace'
} & Pick<CatalogueJewelleryNecklace, 'slug' | 'suffixSlug'> & {
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'systemCode'>
    }

type JewelleryLink_CatalogueJewelleryRing_Fragment = {
    __typename: 'CatalogueJewelleryRing'
} & Pick<CatalogueJewelleryRing, 'slug' | 'suffixSlug'> & {
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'systemCode'>
    }

export type JewelleryLinkFragment =
    | JewelleryLink_CatalogueJewelleryBracelet_Fragment
    | JewelleryLink_CatalogueJewelleryEarrings_Fragment
    | JewelleryLink_CatalogueJewelleryNecklace_Fragment
    | JewelleryLink_CatalogueJewelleryRing_Fragment

export type ReadyToGoRingLinkFragment = {
    __typename: 'CatalogueReadyToGoRing'
} & Pick<CatalogueReadyToGoRing, 'slug'> & {
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'systemCode'>
    }

export type WeddingRingLinkFragment = {
    __typename: 'CatalogueWeddingRing'
} & Pick<CatalogueWeddingRing, 'catalogueCode' | 'suffixSlug' | 'slug'> & {
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'systemCode'>
    }

export type GemstoneRouteFragment = { __typename: 'NonSkuGemstone' } & Pick<
    NonSkuGemstone,
    'caratWeight'
> & {
        color: { __typename: 'StoneColor' } & Pick<StoneColor, 'systemCode'>
        crystal: { __typename: 'StoneCrystal' } & Pick<
            StoneCrystal,
            'systemCode'
        >
        colorGrade: { __typename: 'StoneGrade' } & Pick<
            StoneGrade,
            'systemCode'
        >
        clarity: { __typename: 'StoneClarity' } & Pick<
            StoneClarity,
            'systemCode'
        >
    }

export type LabGrownRouteFragment = { __typename: 'NonSkuLabGrown' } & Pick<
    NonSkuLabGrown,
    'caratWeight'
> & {
        color: { __typename: 'StoneColor' } & Pick<StoneColor, 'systemCode'>
        clarity: { __typename: 'StoneClarity' } & Pick<
            StoneClarity,
            'systemCode'
        >
    }

export type BraceletExportQueryVariables = Exact<{
    locale: Scalars['Locale']['input']
    region: RegionCode
    rbProduct: Scalars['Boolean']['input']
}>

export type BraceletExportQuery = { __typename: 'Query' } & {
    catalogueJewelleryBracelets: Array<
        {
            __typename: 'CatalogueJewelleryBracelet'
        } & ProductExport_CatalogueJewelleryBracelet_Fragment
    >
}

export type EarringsExportQueryVariables = Exact<{
    locale: Scalars['Locale']['input']
    region: RegionCode
    rbProduct: Scalars['Boolean']['input']
}>

export type EarringsExportQuery = { __typename: 'Query' } & {
    catalogueJewelleryEarrings: Array<
        {
            __typename: 'CatalogueJewelleryEarrings'
        } & ProductExport_CatalogueJewelleryEarrings_Fragment
    >
}

export type EngagementRingsExportQueryVariables = Exact<{
    locale: Scalars['Locale']['input']
    region: RegionCode
    rbProduct: Scalars['Boolean']['input']
}>

export type EngagementRingsExportQuery = { __typename: 'Query' } & {
    catalogueEngagementRings: Array<
        {
            __typename: 'CatalogueEngagementRing'
        } & ProductExport_CatalogueEngagementRing_Fragment
    >
}

export type EngagementRingsGemstoneExportQueryVariables = Exact<{
    locale: Scalars['Locale']['input']
    region: RegionCode
    rbProduct: Scalars['Boolean']['input']
    type: RingBuilderProductType
}>

export type EngagementRingsGemstoneExportQuery = { __typename: 'Query' } & {
    catalogueEngagementRings: Array<
        {
            __typename: 'CatalogueEngagementRing'
        } & EngagementRingRingBuilderExportFragment
    >
}

export type EngagementRingsLabGrownExportQueryVariables = Exact<{
    locale: Scalars['Locale']['input']
    region: RegionCode
    rbProduct: Scalars['Boolean']['input']
    type: RingBuilderProductType
}>

export type EngagementRingsLabGrownExportQuery = { __typename: 'Query' } & {
    catalogueEngagementRings: Array<
        {
            __typename: 'CatalogueEngagementRing'
        } & EngagementRingRingBuilderExportFragment
    >
}

type ProductExport_CatalogueEngagementRing_Fragment = {
    __typename: 'CatalogueEngagementRing'
} & Pick<CatalogueEngagementRing, 'catalogueCode' | 'productName'> & {
        translation: {
            __typename: 'CatalogueEngagementRingTranslation'
        } & Pick<CatalogueEngagementRingTranslation, 'description'>
        salePrice?: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
        mainImage: Maybe<
            { __typename: 'GenericImage' } & Pick<GenericImage, 'url'>
        >
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'url'>
        >
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'systemCode'> & {
                element: { __typename: 'MetalElement' } & Pick<
                    MetalElement,
                    'systemCode'
                > & {
                        translation: {
                            __typename: 'MetalElementTranslation'
                        } & Pick<MetalElementTranslation, 'name'>
                    }
                color: Maybe<
                    { __typename: 'MetalColor' } & Pick<
                        MetalColor,
                        'systemCode'
                    > & {
                            translation: {
                                __typename: 'MetalColorTranslation'
                            } & Pick<MetalColorTranslation, 'name'>
                        }
                >
            }
    } & ProductLink_CatalogueEngagementRing_Fragment

type ProductExport_CatalogueJewelleryBracelet_Fragment = {
    __typename: 'CatalogueJewelleryBracelet'
} & Pick<CatalogueJewelleryBracelet, 'catalogueCode' | 'productName'> & {
        translation: {
            __typename: 'CatalogueJewelleryBraceletTranslation'
        } & Pick<CatalogueJewelleryBraceletTranslation, 'description'>
        salePrice?: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
        mainImage: Maybe<
            { __typename: 'GenericImage' } & Pick<GenericImage, 'url'>
        >
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'url'>
        >
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'systemCode'> & {
                element: { __typename: 'MetalElement' } & Pick<
                    MetalElement,
                    'systemCode'
                > & {
                        translation: {
                            __typename: 'MetalElementTranslation'
                        } & Pick<MetalElementTranslation, 'name'>
                    }
                color: Maybe<
                    { __typename: 'MetalColor' } & Pick<
                        MetalColor,
                        'systemCode'
                    > & {
                            translation: {
                                __typename: 'MetalColorTranslation'
                            } & Pick<MetalColorTranslation, 'name'>
                        }
                >
            }
    } & ProductLink_CatalogueJewelleryBracelet_Fragment

type ProductExport_CatalogueJewelleryEarrings_Fragment = {
    __typename: 'CatalogueJewelleryEarrings'
} & Pick<CatalogueJewelleryEarrings, 'catalogueCode' | 'productName'> & {
        translation: {
            __typename: 'CatalogueJewelleryEarringsTranslation'
        } & Pick<CatalogueJewelleryEarringsTranslation, 'description'>
        salePrice?: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
        mainImage: Maybe<
            { __typename: 'GenericImage' } & Pick<GenericImage, 'url'>
        >
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'url'>
        >
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'systemCode'> & {
                element: { __typename: 'MetalElement' } & Pick<
                    MetalElement,
                    'systemCode'
                > & {
                        translation: {
                            __typename: 'MetalElementTranslation'
                        } & Pick<MetalElementTranslation, 'name'>
                    }
                color: Maybe<
                    { __typename: 'MetalColor' } & Pick<
                        MetalColor,
                        'systemCode'
                    > & {
                            translation: {
                                __typename: 'MetalColorTranslation'
                            } & Pick<MetalColorTranslation, 'name'>
                        }
                >
            }
    } & ProductLink_CatalogueJewelleryEarrings_Fragment

type ProductExport_CatalogueJewelleryNecklace_Fragment = {
    __typename: 'CatalogueJewelleryNecklace'
} & Pick<CatalogueJewelleryNecklace, 'catalogueCode' | 'productName'> & {
        translation: {
            __typename: 'CatalogueJewelleryNecklaceTranslation'
        } & Pick<CatalogueJewelleryNecklaceTranslation, 'description'>
        salePrice?: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
        mainImage: Maybe<
            { __typename: 'GenericImage' } & Pick<GenericImage, 'url'>
        >
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'url'>
        >
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'systemCode'> & {
                element: { __typename: 'MetalElement' } & Pick<
                    MetalElement,
                    'systemCode'
                > & {
                        translation: {
                            __typename: 'MetalElementTranslation'
                        } & Pick<MetalElementTranslation, 'name'>
                    }
                color: Maybe<
                    { __typename: 'MetalColor' } & Pick<
                        MetalColor,
                        'systemCode'
                    > & {
                            translation: {
                                __typename: 'MetalColorTranslation'
                            } & Pick<MetalColorTranslation, 'name'>
                        }
                >
            }
    } & ProductLink_CatalogueJewelleryNecklace_Fragment

type ProductExport_CatalogueJewelleryRing_Fragment = {
    __typename: 'CatalogueJewelleryRing'
} & Pick<CatalogueJewelleryRing, 'catalogueCode' | 'productName'> & {
        translation: { __typename: 'CatalogueJewelleryRingTranslation' } & Pick<
            CatalogueJewelleryRingTranslation,
            'description'
        >
        salePrice?: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
        mainImage: Maybe<
            { __typename: 'GenericImage' } & Pick<GenericImage, 'url'>
        >
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'url'>
        >
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'systemCode'> & {
                element: { __typename: 'MetalElement' } & Pick<
                    MetalElement,
                    'systemCode'
                > & {
                        translation: {
                            __typename: 'MetalElementTranslation'
                        } & Pick<MetalElementTranslation, 'name'>
                    }
                color: Maybe<
                    { __typename: 'MetalColor' } & Pick<
                        MetalColor,
                        'systemCode'
                    > & {
                            translation: {
                                __typename: 'MetalColorTranslation'
                            } & Pick<MetalColorTranslation, 'name'>
                        }
                >
            }
    } & ProductLink_CatalogueJewelleryRing_Fragment

type ProductExport_CatalogueReadyToGoRing_Fragment = {
    __typename: 'CatalogueReadyToGoRing'
} & Pick<CatalogueReadyToGoRing, 'catalogueCode' | 'productName'> & {
        translation: { __typename: 'CatalogueReadyToGoRingTranslation' } & Pick<
            CatalogueReadyToGoRingTranslation,
            'description'
        >
        salePrice?: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
        mainImage: Maybe<
            { __typename: 'GenericImage' } & Pick<GenericImage, 'url'>
        >
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'url'>
        >
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'systemCode'> & {
                element: { __typename: 'MetalElement' } & Pick<
                    MetalElement,
                    'systemCode'
                > & {
                        translation: {
                            __typename: 'MetalElementTranslation'
                        } & Pick<MetalElementTranslation, 'name'>
                    }
                color: Maybe<
                    { __typename: 'MetalColor' } & Pick<
                        MetalColor,
                        'systemCode'
                    > & {
                            translation: {
                                __typename: 'MetalColorTranslation'
                            } & Pick<MetalColorTranslation, 'name'>
                        }
                >
            }
    } & ProductLink_CatalogueReadyToGoRing_Fragment

type ProductExport_CatalogueWeddingRing_Fragment = {
    __typename: 'CatalogueWeddingRing'
} & Pick<CatalogueWeddingRing, 'catalogueCode' | 'productName'> & {
        translation: { __typename: 'CatalogueWeddingRingTranslation' } & Pick<
            CatalogueWeddingRingTranslation,
            'description'
        >
        categories: Array<
            { __typename: 'WeddingRingCategoryLabel' } & Pick<
                WeddingRingCategoryLabel,
                'systemCode'
            >
        >
        salePrice?: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
        mainImage: Maybe<
            { __typename: 'GenericImage' } & Pick<GenericImage, 'url'>
        >
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'url'>
        >
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'systemCode'> & {
                element: { __typename: 'MetalElement' } & Pick<
                    MetalElement,
                    'systemCode'
                > & {
                        translation: {
                            __typename: 'MetalElementTranslation'
                        } & Pick<MetalElementTranslation, 'name'>
                    }
                color: Maybe<
                    { __typename: 'MetalColor' } & Pick<
                        MetalColor,
                        'systemCode'
                    > & {
                            translation: {
                                __typename: 'MetalColorTranslation'
                            } & Pick<MetalColorTranslation, 'name'>
                        }
                >
            }
    } & ProductLink_CatalogueWeddingRing_Fragment

export type ProductExportFragment =
    | ProductExport_CatalogueEngagementRing_Fragment
    | ProductExport_CatalogueJewelleryBracelet_Fragment
    | ProductExport_CatalogueJewelleryEarrings_Fragment
    | ProductExport_CatalogueJewelleryNecklace_Fragment
    | ProductExport_CatalogueJewelleryRing_Fragment
    | ProductExport_CatalogueReadyToGoRing_Fragment
    | ProductExport_CatalogueWeddingRing_Fragment

export type EngagementRingRingBuilderExportFragment = {
    __typename: 'CatalogueEngagementRing'
} & {
    ringStyles: Array<
        { __typename: 'EngagementRingStyleLabel' } & {
            translation: { __typename: 'ProductLabelTranslation' } & Pick<
                ProductLabelTranslation,
                'name'
            >
        }
    >
    ringBuilderProducts: Array<
        { __typename: 'RingBuilder' } & Pick<
            RingBuilder,
            'id' | 'productId'
        > & {
                position1: Maybe<
                    | ({
                          __typename: 'RingBuilderCentreStoneFragment'
                      } & ExportsRingBuilderPosition_RingBuilderCentreStoneFragment_Fragment)
                    | ({
                          __typename: 'RingBuilderMountFragment'
                      } & ExportsRingBuilderPosition_RingBuilderMountFragment_Fragment)
                >
                position2: Maybe<
                    | ({
                          __typename: 'RingBuilderCentreStoneFragment'
                      } & ExportsRingBuilderPosition_RingBuilderCentreStoneFragment_Fragment)
                    | ({
                          __typename: 'RingBuilderMountFragment'
                      } & ExportsRingBuilderPosition_RingBuilderMountFragment_Fragment)
                >
                image: Maybe<
                    { __typename: 'GenericImage' } & Pick<GenericImage, 'url'>
                >
                totalSalePrice: { __typename: 'Money' } & MoneyFragment
            }
    >
} & ProductExport_CatalogueEngagementRing_Fragment

type ExportsRingBuilderPosition_RingBuilderCentreStoneFragment_Fragment = {
    __typename: 'RingBuilderCentreStoneFragment'
} & {
    stone: Maybe<
        | { __typename: 'GemsApiStone' }
        | ({ __typename: 'NonSkuGemstone' } & {
              shape: { __typename: 'StoneShape' } & {
                  translation: { __typename: 'StoneShapeTranslation' } & Pick<
                      StoneShapeTranslation,
                      'name'
                  >
              }
              color: { __typename: 'StoneColor' } & {
                  translation: { __typename: 'StoneColorTranslation' } & Pick<
                      StoneColorTranslation,
                      'name'
                  >
              }
              crystal: { __typename: 'StoneCrystal' } & {
                  translation: { __typename: 'StoneCrystalTranslation' } & Pick<
                      StoneCrystalTranslation,
                      'name'
                  >
              }
          } & GemstoneRouteFragment)
        | ({ __typename: 'NonSkuLabGrown' } & {
              shape: { __typename: 'StoneShape' } & {
                  translation: { __typename: 'StoneShapeTranslation' } & Pick<
                      StoneShapeTranslation,
                      'name'
                  >
              }
          } & LabGrownRouteFragment)
    >
}

type ExportsRingBuilderPosition_RingBuilderMountFragment_Fragment = {
    __typename: 'RingBuilderMountFragment'
}

export type ExportsRingBuilderPositionFragment =
    | ExportsRingBuilderPosition_RingBuilderCentreStoneFragment_Fragment
    | ExportsRingBuilderPosition_RingBuilderMountFragment_Fragment

export type NecklaceExportQueryVariables = Exact<{
    locale: Scalars['Locale']['input']
    region: RegionCode
    rbProduct: Scalars['Boolean']['input']
}>

export type NecklaceExportQuery = { __typename: 'Query' } & {
    catalogueJewelleryNecklaces: Array<
        {
            __typename: 'CatalogueJewelleryNecklace'
        } & ProductExport_CatalogueJewelleryNecklace_Fragment
    >
}

export type RingExportsQueryVariables = Exact<{
    locale: Scalars['Locale']['input']
    region: RegionCode
    rbProduct: Scalars['Boolean']['input']
}>

export type RingExportsQuery = { __typename: 'Query' } & {
    catalogueJewelleryRings: Array<
        {
            __typename: 'CatalogueJewelleryRing'
        } & ProductExport_CatalogueJewelleryRing_Fragment
    >
}

export type WeddingRingsExportQueryVariables = Exact<{
    locale: Scalars['Locale']['input']
    region: RegionCode
    rbProduct: Scalars['Boolean']['input']
}>

export type WeddingRingsExportQuery = { __typename: 'Query' } & {
    catalogueWeddingRings: Array<
        {
            __typename: 'CatalogueWeddingRing'
        } & ProductExport_CatalogueWeddingRing_Fragment
    >
}

export type ReviewFeedFragment = { __typename: 'Review' } & Pick<
    Review,
    'id' | 'name' | 'date' | 'comment' | 'rating'
> & { picture: Maybe<{ __typename: 'Asset' } & Pick<Asset, 'id' | 'url'>> }

export type ReviewsFeedQueryVariables = Exact<{ [key: string]: never }>

export type ReviewsFeedQuery = { __typename: 'Query' } & {
    reviews: Array<
        { __typename: 'Review' } & {
            products: Array<
                | ({ __typename: 'CatalogueEngagementRing' } & Pick<
                      CatalogueEngagementRing,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueEngagementRing_Fragment)
                | ({ __typename: 'CatalogueJewelleryBracelet' } & Pick<
                      CatalogueJewelleryBracelet,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueJewelleryBracelet_Fragment)
                | ({ __typename: 'CatalogueJewelleryEarrings' } & Pick<
                      CatalogueJewelleryEarrings,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueJewelleryEarrings_Fragment)
                | ({ __typename: 'CatalogueJewelleryNecklace' } & Pick<
                      CatalogueJewelleryNecklace,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueJewelleryNecklace_Fragment)
                | ({ __typename: 'CatalogueJewelleryRing' } & Pick<
                      CatalogueJewelleryRing,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueJewelleryRing_Fragment)
                | ({ __typename: 'CatalogueReadyToGoRing' } & Pick<
                      CatalogueReadyToGoRing,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueReadyToGoRing_Fragment)
                | ({ __typename: 'CatalogueWeddingRing' } & Pick<
                      CatalogueWeddingRing,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueWeddingRing_Fragment)
            >
        } & ReviewFeedFragment
    >
}

export type ReviewsFeedEngagementRingGemstoneQueryVariables = Exact<{
    [key: string]: never
}>

export type ReviewsFeedEngagementRingGemstoneQuery = { __typename: 'Query' } & {
    reviews: Array<
        { __typename: 'Review' } & {
            products: Array<
                | ({ __typename: 'CatalogueEngagementRing' } & Pick<
                      CatalogueEngagementRing,
                      'catalogueCode' | 'productName'
                  > & {
                          ringBuilderProducts: Array<
                              { __typename: 'RingBuilder' } & Pick<
                                  RingBuilder,
                                  'productId'
                              > & {
                                      position1: Maybe<
                                          | ({
                                                __typename: 'RingBuilderCentreStoneFragment'
                                            } & {
                                                stone: Maybe<
                                                    | {
                                                          __typename: 'GemsApiStone'
                                                      }
                                                    | ({
                                                          __typename: 'NonSkuGemstone'
                                                      } & GemstoneRouteFragment)
                                                    | ({
                                                          __typename: 'NonSkuLabGrown'
                                                      } & LabGrownRouteFragment)
                                                >
                                            })
                                          | {
                                                __typename: 'RingBuilderMountFragment'
                                            }
                                      >
                                  }
                          >
                      } & ProductLink_CatalogueEngagementRing_Fragment)
                | ({ __typename: 'CatalogueJewelleryBracelet' } & Pick<
                      CatalogueJewelleryBracelet,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueJewelleryBracelet_Fragment)
                | ({ __typename: 'CatalogueJewelleryEarrings' } & Pick<
                      CatalogueJewelleryEarrings,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueJewelleryEarrings_Fragment)
                | ({ __typename: 'CatalogueJewelleryNecklace' } & Pick<
                      CatalogueJewelleryNecklace,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueJewelleryNecklace_Fragment)
                | ({ __typename: 'CatalogueJewelleryRing' } & Pick<
                      CatalogueJewelleryRing,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueJewelleryRing_Fragment)
                | ({ __typename: 'CatalogueReadyToGoRing' } & Pick<
                      CatalogueReadyToGoRing,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueReadyToGoRing_Fragment)
                | ({ __typename: 'CatalogueWeddingRing' } & Pick<
                      CatalogueWeddingRing,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueWeddingRing_Fragment)
            >
        } & ReviewFeedFragment
    >
}

export type ReviewsFeedEngagementRingLabGrownQueryVariables = Exact<{
    [key: string]: never
}>

export type ReviewsFeedEngagementRingLabGrownQuery = { __typename: 'Query' } & {
    reviews: Array<
        { __typename: 'Review' } & {
            products: Array<
                | ({ __typename: 'CatalogueEngagementRing' } & Pick<
                      CatalogueEngagementRing,
                      'catalogueCode' | 'productName'
                  > & {
                          ringBuilderProducts: Array<
                              { __typename: 'RingBuilder' } & Pick<
                                  RingBuilder,
                                  'productId'
                              > & {
                                      position1: Maybe<
                                          | ({
                                                __typename: 'RingBuilderCentreStoneFragment'
                                            } & {
                                                stone: Maybe<
                                                    | {
                                                          __typename: 'GemsApiStone'
                                                      }
                                                    | ({
                                                          __typename: 'NonSkuGemstone'
                                                      } & GemstoneRouteFragment)
                                                    | ({
                                                          __typename: 'NonSkuLabGrown'
                                                      } & LabGrownRouteFragment)
                                                >
                                            })
                                          | {
                                                __typename: 'RingBuilderMountFragment'
                                            }
                                      >
                                  }
                          >
                      } & ProductLink_CatalogueEngagementRing_Fragment)
                | ({ __typename: 'CatalogueJewelleryBracelet' } & Pick<
                      CatalogueJewelleryBracelet,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueJewelleryBracelet_Fragment)
                | ({ __typename: 'CatalogueJewelleryEarrings' } & Pick<
                      CatalogueJewelleryEarrings,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueJewelleryEarrings_Fragment)
                | ({ __typename: 'CatalogueJewelleryNecklace' } & Pick<
                      CatalogueJewelleryNecklace,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueJewelleryNecklace_Fragment)
                | ({ __typename: 'CatalogueJewelleryRing' } & Pick<
                      CatalogueJewelleryRing,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueJewelleryRing_Fragment)
                | ({ __typename: 'CatalogueReadyToGoRing' } & Pick<
                      CatalogueReadyToGoRing,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueReadyToGoRing_Fragment)
                | ({ __typename: 'CatalogueWeddingRing' } & Pick<
                      CatalogueWeddingRing,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueWeddingRing_Fragment)
            >
        } & ReviewFeedFragment
    >
}

export type SitemapEngagementRingQueryVariables = Exact<{
    [key: string]: never
}>

export type SitemapEngagementRingQuery = { __typename: 'Query' } & {
    regions: Array<{ __typename: 'Region' } & SitemapRegionFragment>
    catalogueEngagementRingFiltersVariations: Array<
        { __typename: 'CatalogueEngagementRingFiltersVariation' } & Pick<
            CatalogueEngagementRingFiltersVariation,
            'primaryMetal' | 'ringStyle' | 'centreStoneShape' | 'designStyle'
        >
    >
    catalogueEngagementRings: Array<
        { __typename: 'CatalogueEngagementRing' } & Pick<
            CatalogueEngagementRing,
            'productName'
        > & {
                images: Array<
                    { __typename: 'CatalogueImage' } & Pick<
                        CatalogueImage,
                        'url'
                    >
                >
                images360: Array<
                    { __typename: 'GenericImage' } & Pick<GenericImage, 'url'>
                >
            } & EngagementRingLinkFragment
    >
}

export type SitemapJewelleryQueryVariables = Exact<{ [key: string]: never }>

export type SitemapJewelleryQuery = { __typename: 'Query' } & {
    regions: Array<{ __typename: 'Region' } & SitemapRegionFragment>
    catalogueJewelleriesFiltersVariations: Array<
        { __typename: 'CatalogueJewelleriesFiltersVariation' } & Pick<
            CatalogueJewelleriesFiltersVariation,
            'primaryMetal' | 'designStyle' | 'gemstone'
        >
    >
    catalogueJewelleryNecklacesFiltersVariations: Array<
        { __typename: 'CatalogueJewelleriesNecklacesFiltersVariation' } & Pick<
            CatalogueJewelleriesNecklacesFiltersVariation,
            'primaryMetal' | 'productStyle' | 'designStyle' | 'gemstone'
        >
    >
    catalogueJewelleryEarringsFiltersVariations: Array<
        { __typename: 'CatalogueJewelleriesEarringsFiltersVariation' } & Pick<
            CatalogueJewelleriesEarringsFiltersVariation,
            'primaryMetal' | 'productStyle' | 'designStyle' | 'gemstone'
        >
    >
    catalogueJewelleryBraceletFiltersVariations: Array<
        { __typename: 'CatalogueJewelleriesBraceletsFiltersVariation' } & Pick<
            CatalogueJewelleriesBraceletsFiltersVariation,
            'primaryMetal' | 'productStyle' | 'designStyle' | 'gemstone'
        >
    >
    catalogueJewelleryRingsFiltersVariations: Array<
        { __typename: 'CatalogueJewelleriesRingsFiltersVariation' } & Pick<
            CatalogueJewelleriesRingsFiltersVariation,
            'primaryMetal' | 'productStyle' | 'designStyle' | 'gemstone'
        >
    >
    catalogueJewelleries: Array<
        | ({ __typename: 'CatalogueJewelleryBracelet' } & Pick<
              CatalogueJewelleryBracelet,
              'productName'
          > & {
                  images: Array<
                      { __typename: 'CatalogueImage' } & Pick<
                          CatalogueImage,
                          'url'
                      >
                  >
                  images360: Array<
                      { __typename: 'GenericImage' } & Pick<GenericImage, 'url'>
                  >
              } & JewelleryLink_CatalogueJewelleryBracelet_Fragment)
        | ({ __typename: 'CatalogueJewelleryEarrings' } & Pick<
              CatalogueJewelleryEarrings,
              'productName'
          > & {
                  images: Array<
                      { __typename: 'CatalogueImage' } & Pick<
                          CatalogueImage,
                          'url'
                      >
                  >
                  images360: Array<
                      { __typename: 'GenericImage' } & Pick<GenericImage, 'url'>
                  >
              } & JewelleryLink_CatalogueJewelleryEarrings_Fragment)
        | ({ __typename: 'CatalogueJewelleryNecklace' } & Pick<
              CatalogueJewelleryNecklace,
              'productName'
          > & {
                  images: Array<
                      { __typename: 'CatalogueImage' } & Pick<
                          CatalogueImage,
                          'url'
                      >
                  >
                  images360: Array<
                      { __typename: 'GenericImage' } & Pick<GenericImage, 'url'>
                  >
              } & JewelleryLink_CatalogueJewelleryNecklace_Fragment)
        | ({ __typename: 'CatalogueJewelleryRing' } & Pick<
              CatalogueJewelleryRing,
              'productName'
          > & {
                  images: Array<
                      { __typename: 'CatalogueImage' } & Pick<
                          CatalogueImage,
                          'url'
                      >
                  >
                  images360: Array<
                      { __typename: 'GenericImage' } & Pick<GenericImage, 'url'>
                  >
              } & JewelleryLink_CatalogueJewelleryRing_Fragment)
    >
}

export type SitemapPagesQueryVariables = Exact<{
    locale: Scalars['Locale']['input']
}>

export type SitemapPagesQuery = { __typename: 'Query' } & {
    regions: Array<{ __typename: 'Region' } & SitemapRegionFragment>
    pages: Array<
        { __typename: 'Page' } & {
            meta: { __typename: 'Meta' } & Pick<Meta, 'robots'>
            blocks: Array<
                { __typename: 'Block' } & {
                    components: Array<
                        | { __typename: 'ComponentArticleGrid' }
                        | { __typename: 'ComponentArticlePreviews' }
                        | { __typename: 'ComponentBannerSkinny' }
                        | { __typename: 'ComponentBannerTitle' }
                        | { __typename: 'ComponentCard' }
                        | { __typename: 'ComponentCardCarousel' }
                        | { __typename: 'ComponentCatalogueProductCarousel' }
                        | { __typename: 'ComponentContent' }
                        | { __typename: 'ComponentContentTwoColumns' }
                        | ({ __typename: 'ComponentContentWithGallery' } & {
                              content: Array<
                                  | ({
                                        __typename: 'ComponentButton'
                                    } & ContentImageSitemap_ComponentButton_Fragment)
                                  | ({
                                        __typename: 'ComponentImage'
                                    } & ContentImageSitemap_ComponentImage_Fragment)
                                  | ({
                                        __typename: 'ComponentOrderedList'
                                    } & ContentImageSitemap_ComponentOrderedList_Fragment)
                                  | ({
                                        __typename: 'ComponentSpacer'
                                    } & ContentImageSitemap_ComponentSpacer_Fragment)
                                  | ({
                                        __typename: 'ComponentText'
                                    } & ContentImageSitemap_ComponentText_Fragment)
                                  | ({
                                        __typename: 'ComponentTitle'
                                    } & ContentImageSitemap_ComponentTitle_Fragment)
                              >
                              gallery: Array<
                                  { __typename: 'GalleryItem' } & {
                                      image: { __typename: 'Image' } & Pick<
                                          Image,
                                          'url' | 'title' | 'caption'
                                      >
                                  }
                              >
                          })
                        | { __typename: 'ComponentCustomProductCarousel' }
                        | { __typename: 'ComponentFaq' }
                        | ({ __typename: 'ComponentFullWidthImage' } & {
                              image: { __typename: 'Image' } & Pick<
                                  Image,
                                  'url' | 'title' | 'caption'
                              >
                          })
                        | ({ __typename: 'ComponentGalleryCarousel' } & {
                              items: Array<
                                  { __typename: 'GalleryCarouselCard' } & {
                                      image: { __typename: 'Image' } & Pick<
                                          Image,
                                          'url' | 'title' | 'caption'
                                      >
                                  }
                              >
                          })
                        | ({ __typename: 'ComponentGalleryWithEnquiry' } & {
                              items: Array<
                                  {
                                      __typename: 'GalleryWithEnquiryCard'
                                  } & Pick<
                                      GalleryWithEnquiryCard,
                                      'caption'
                                  > & {
                                          image: { __typename: 'Image' } & Pick<
                                              Image,
                                              'url' | 'title' | 'caption'
                                          >
                                      }
                              >
                          })
                        | { __typename: 'ComponentGlobalComponent' }
                        | { __typename: 'ComponentGlobalSpacer' }
                        | { __typename: 'ComponentIconCarousel' }
                        | { __typename: 'ComponentInstagramPosts' }
                        | { __typename: 'ComponentInstagramWithContent' }
                        | { __typename: 'ComponentLogos' }
                        | { __typename: 'ComponentLogosCarousel' }
                        | { __typename: 'ComponentMainCover' }
                        | { __typename: 'ComponentOnThisPage' }
                        | { __typename: 'ComponentQuote' }
                        | { __typename: 'ComponentRelatedProducts' }
                        | { __typename: 'ComponentReviewCarousel' }
                        | ({ __typename: 'ComponentRoundedImage' } & {
                              backgroundImage: Maybe<
                                  { __typename: 'Image' } & Pick<
                                      Image,
                                      'url' | 'title' | 'caption'
                                  >
                              >
                              roundedImage: { __typename: 'Image' } & Pick<
                                  Image,
                                  'url' | 'title' | 'caption'
                              >
                          })
                        | ({ __typename: 'ComponentRoundedImageContent' } & {
                              content: Array<
                                  | ({
                                        __typename: 'ComponentButton'
                                    } & ContentImageSitemap_ComponentButton_Fragment)
                                  | ({
                                        __typename: 'ComponentImage'
                                    } & ContentImageSitemap_ComponentImage_Fragment)
                                  | ({
                                        __typename: 'ComponentOrderedList'
                                    } & ContentImageSitemap_ComponentOrderedList_Fragment)
                                  | ({
                                        __typename: 'ComponentSpacer'
                                    } & ContentImageSitemap_ComponentSpacer_Fragment)
                                  | ({
                                        __typename: 'ComponentText'
                                    } & ContentImageSitemap_ComponentText_Fragment)
                                  | ({
                                        __typename: 'ComponentTitle'
                                    } & ContentImageSitemap_ComponentTitle_Fragment)
                              >
                              roundedImage: {
                                  __typename: 'ComponentRoundedImage'
                              } & {
                                  roundedImage: { __typename: 'Image' } & Pick<
                                      Image,
                                      'url' | 'title' | 'caption'
                                  >
                                  backgroundImage: Maybe<
                                      { __typename: 'Image' } & Pick<
                                          Image,
                                          'url' | 'title' | 'caption'
                                      >
                                  >
                              }
                          })
                        | { __typename: 'ComponentShopWithConfidence' }
                        | ({ __typename: 'ComponentSideBySideImages' } & {
                              images: Array<
                                  {
                                      __typename: 'ComponentSideBySideImage'
                                  } & Pick<
                                      ComponentSideBySideImage,
                                      'caption'
                                  > & {
                                          image: { __typename: 'Image' } & Pick<
                                              Image,
                                              'url' | 'title' | 'caption'
                                          >
                                      }
                              >
                          })
                        | { __typename: 'ComponentSquareBoxes' }
                        | { __typename: 'ComponentTable' }
                        | { __typename: 'ComponentTextCarousel' }
                        | ({ __typename: 'ComponentTextOverImage' } & {
                              content: Array<
                                  | ({
                                        __typename: 'ComponentButton'
                                    } & ContentImageSitemap_ComponentButton_Fragment)
                                  | ({
                                        __typename: 'ComponentImage'
                                    } & ContentImageSitemap_ComponentImage_Fragment)
                                  | ({
                                        __typename: 'ComponentOrderedList'
                                    } & ContentImageSitemap_ComponentOrderedList_Fragment)
                                  | ({
                                        __typename: 'ComponentSpacer'
                                    } & ContentImageSitemap_ComponentSpacer_Fragment)
                                  | ({
                                        __typename: 'ComponentText'
                                    } & ContentImageSitemap_ComponentText_Fragment)
                                  | ({
                                        __typename: 'ComponentTitle'
                                    } & ContentImageSitemap_ComponentTitle_Fragment)
                              >
                              image: { __typename: 'Image' } & Pick<
                                  Image,
                                  'url' | 'title' | 'caption'
                              >
                          })
                        | ({ __typename: 'ComponentTextWithImage' } & {
                              content: Array<
                                  | ({
                                        __typename: 'ComponentButton'
                                    } & ContentImageSitemap_ComponentButton_Fragment)
                                  | ({
                                        __typename: 'ComponentImage'
                                    } & ContentImageSitemap_ComponentImage_Fragment)
                                  | ({
                                        __typename: 'ComponentOrderedList'
                                    } & ContentImageSitemap_ComponentOrderedList_Fragment)
                                  | ({
                                        __typename: 'ComponentSpacer'
                                    } & ContentImageSitemap_ComponentSpacer_Fragment)
                                  | ({
                                        __typename: 'ComponentText'
                                    } & ContentImageSitemap_ComponentText_Fragment)
                                  | ({
                                        __typename: 'ComponentTitle'
                                    } & ContentImageSitemap_ComponentTitle_Fragment)
                              >
                              image: { __typename: 'Image' } & Pick<
                                  Image,
                                  'url' | 'title' | 'caption'
                              >
                          })
                        | ({ __typename: 'ComponentTextWithImageCarousel' } & {
                              slides: Array<
                                  { __typename: 'ComponentTextWithImage' } & {
                                      content: Array<
                                          | ({
                                                __typename: 'ComponentButton'
                                            } & ContentImageSitemap_ComponentButton_Fragment)
                                          | ({
                                                __typename: 'ComponentImage'
                                            } & ContentImageSitemap_ComponentImage_Fragment)
                                          | ({
                                                __typename: 'ComponentOrderedList'
                                            } & ContentImageSitemap_ComponentOrderedList_Fragment)
                                          | ({
                                                __typename: 'ComponentSpacer'
                                            } & ContentImageSitemap_ComponentSpacer_Fragment)
                                          | ({
                                                __typename: 'ComponentText'
                                            } & ContentImageSitemap_ComponentText_Fragment)
                                          | ({
                                                __typename: 'ComponentTitle'
                                            } & ContentImageSitemap_ComponentTitle_Fragment)
                                      >
                                      image: { __typename: 'Image' } & Pick<
                                          Image,
                                          'url' | 'title' | 'caption'
                                      >
                                  }
                              >
                          })
                        | { __typename: 'ComponentVideo' }
                        | { __typename: 'ComponentVideoWithContent' }
                    >
                }
            >
        } & PageLinkFragment
    >
}

type ContentImageSitemap_ComponentButton_Fragment = {
    __typename: 'ComponentButton'
}

type ContentImageSitemap_ComponentImage_Fragment = {
    __typename: 'ComponentImage'
}

type ContentImageSitemap_ComponentOrderedList_Fragment = {
    __typename: 'ComponentOrderedList'
}

type ContentImageSitemap_ComponentSpacer_Fragment = {
    __typename: 'ComponentSpacer'
}

type ContentImageSitemap_ComponentText_Fragment = {
    __typename: 'ComponentText'
}

type ContentImageSitemap_ComponentTitle_Fragment = {
    __typename: 'ComponentTitle'
} & {
    texts: Array<
        | { __typename: 'ComponentTitleAmpersand' }
        | ({ __typename: 'ComponentTitleText' } & Pick<
              ComponentTitleText,
              'text'
          >)
    >
}

export type ContentImageSitemapFragment =
    | ContentImageSitemap_ComponentButton_Fragment
    | ContentImageSitemap_ComponentImage_Fragment
    | ContentImageSitemap_ComponentOrderedList_Fragment
    | ContentImageSitemap_ComponentSpacer_Fragment
    | ContentImageSitemap_ComponentText_Fragment
    | ContentImageSitemap_ComponentTitle_Fragment

export type SitemapReadyToGoQueryVariables = Exact<{ [key: string]: never }>

export type SitemapReadyToGoQuery = { __typename: 'Query' } & {
    regions: Array<{ __typename: 'Region' } & SitemapRegionFragment>
    catalogueReadyToGoRingsFilters: {
        __typename: 'CatalogueReadyToGoRingFilters'
    } & {
        primaryMetals: Array<
            { __typename: 'CatalogueFilterMetalItem' } & {
                metal: { __typename: 'Metal' } & Pick<Metal, 'systemCode'>
            }
        >
    }
    catalogueReadyToGoRings: Array<
        { __typename: 'CatalogueReadyToGoRing' } & Pick<
            CatalogueReadyToGoRing,
            'productName'
        > & {
                images: Array<
                    { __typename: 'CatalogueImage' } & Pick<
                        CatalogueImage,
                        'url'
                    >
                >
            } & ReadyToGoRingLinkFragment
    >
}

export type SitemapRegionFragment = { __typename: 'Region' } & Pick<
    Region,
    'code' | 'isActive'
>

export type SitemapWeddingRingQueryVariables = Exact<{ [key: string]: never }>

export type SitemapWeddingRingQuery = { __typename: 'Query' } & {
    regions: Array<{ __typename: 'Region' } & SitemapRegionFragment>
    catalogueWeddingRingFilterVariations: Array<
        { __typename: 'CatalogueWeddingRingFiltersVariation' } & Pick<
            CatalogueWeddingRingFiltersVariation,
            'primaryMetal' | 'ringStyle' | 'category'
        >
    >
    catalogueWeddingRings: Array<
        { __typename: 'CatalogueWeddingRing' } & Pick<
            CatalogueWeddingRing,
            'productName'
        > & {
                images: Array<
                    { __typename: 'CatalogueImage' } & Pick<
                        CatalogueImage,
                        'url'
                    >
                >
                images360: Array<
                    { __typename: 'GenericImage' } & Pick<GenericImage, 'url'>
                >
            } & WeddingRingLinkFragment
    >
}

export type BlogAuthorQueryVariables = Exact<{
    slug: Scalars['String']['input']
    page: Scalars['Int']['input']
    limit: Scalars['Int']['input']
    locale: Scalars['Locale']['input']
}>

export type BlogAuthorQuery = { __typename: 'Query' } & {
    collection: Maybe<{ __typename: 'Author' } & AuthorPostsFragment>
} & PostCategoriesFragment

export type BlogPostQueryVariables = Exact<{
    slug: Scalars['String']['input']
    locale: Scalars['Locale']['input']
    currency: CurrencyInput
    region: RegionCode
}>

export type BlogPostQuery = { __typename: 'Query' } & {
    postBySlug: Maybe<
        { __typename: 'Post' } & Pick<
            Post,
            'id' | 'title' | 'slug' | 'excerpt' | 'date'
        > & {
                featuredImage: { __typename: 'Image' } & ImageLargeFragment
                blocks: Array<{ __typename: 'Block' } & BlockFragment>
                tags: Array<
                    { __typename: 'PostTag' } & Pick<
                        PostTag,
                        'id' | 'name' | 'slug'
                    >
                >
                author: { __typename: 'Author' } & Pick<
                    Author,
                    'id' | 'name'
                > & {
                        image: { __typename: 'Image' } & ImageLargeFragment
                    } & BlogAuthorRouteFragment
                categories: Array<
                    { __typename: 'PostCategory' } & Pick<
                        PostCategory,
                        'id' | 'name' | 'slug'
                    >
                >
                relatedPosts: Maybe<
                    Array<{ __typename: 'Post' } & BlogPostPreviewFragment>
                >
                meta: { __typename: 'Meta' } & MetaFragment
            } & PostLinkFragment
    >
} & PostCategoriesFragment

type ProductAnalytics_CatalogueEngagementRing_Fragment = {
    __typename: 'CatalogueEngagementRing'
} & Pick<
    CatalogueEngagementRing,
    | 'bandWidth'
    | 'segmentName'
    | 'deliveryDays'
    | 'catalogueCode'
    | 'productName'
    | 'suffix'
> & {
        translation: {
            __typename: 'CatalogueEngagementRingTranslation'
        } & Pick<CatalogueEngagementRingTranslation, 'description'>
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & Pick<Money, 'currency' | 'amount'>
        }
        primaryMetal: { __typename: 'Metal' } & Pick<
            Metal,
            'systemCode' | 'millesimalFineness' | 'karat' | 'segmentName'
        > & {
                element: { __typename: 'MetalElement' } & Pick<
                    MetalElement,
                    'systemCode'
                >
            }
    }

type ProductAnalytics_CatalogueJewelleryBracelet_Fragment = {
    __typename: 'CatalogueJewelleryBracelet'
} & Pick<
    CatalogueJewelleryBracelet,
    'segmentName' | 'deliveryDays' | 'catalogueCode' | 'productName' | 'suffix'
> & { jewellerySku: CatalogueJewelleryBracelet['sku'] } & {
        designStyles: Array<
            { __typename: 'JewelleryDesignStyleLabel' } & Pick<
                JewelleryDesignStyleLabel,
                'systemCode'
            >
        >
        translation: {
            __typename: 'CatalogueJewelleryBraceletTranslation'
        } & Pick<CatalogueJewelleryBraceletTranslation, 'description'>
        braceletProductStyles: Array<
            { __typename: 'JewelleryBraceletProductStyleLabel' } & Pick<
                JewelleryBraceletProductStyleLabel,
                'systemCode'
            >
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & Pick<Money, 'currency' | 'amount'>
        }
        primaryMetal: { __typename: 'Metal' } & Pick<
            Metal,
            'systemCode' | 'millesimalFineness' | 'karat' | 'segmentName'
        > & {
                element: { __typename: 'MetalElement' } & Pick<
                    MetalElement,
                    'systemCode'
                >
            }
    }

type ProductAnalytics_CatalogueJewelleryEarrings_Fragment = {
    __typename: 'CatalogueJewelleryEarrings'
} & Pick<
    CatalogueJewelleryEarrings,
    'segmentName' | 'deliveryDays' | 'catalogueCode' | 'productName' | 'suffix'
> & { jewellerySku: CatalogueJewelleryEarrings['sku'] } & {
        designStyles: Array<
            { __typename: 'JewelleryDesignStyleLabel' } & Pick<
                JewelleryDesignStyleLabel,
                'systemCode'
            >
        >
        translation: {
            __typename: 'CatalogueJewelleryEarringsTranslation'
        } & Pick<CatalogueJewelleryEarringsTranslation, 'description'>
        earringsProductStyles: Array<
            { __typename: 'JewelleryEarringsProductStyleLabel' } & Pick<
                JewelleryEarringsProductStyleLabel,
                'systemCode'
            >
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & Pick<Money, 'currency' | 'amount'>
        }
        primaryMetal: { __typename: 'Metal' } & Pick<
            Metal,
            'systemCode' | 'millesimalFineness' | 'karat' | 'segmentName'
        > & {
                element: { __typename: 'MetalElement' } & Pick<
                    MetalElement,
                    'systemCode'
                >
            }
    }

type ProductAnalytics_CatalogueJewelleryNecklace_Fragment = {
    __typename: 'CatalogueJewelleryNecklace'
} & Pick<
    CatalogueJewelleryNecklace,
    'segmentName' | 'deliveryDays' | 'catalogueCode' | 'productName' | 'suffix'
> & { jewellerySku: CatalogueJewelleryNecklace['sku'] } & {
        designStyles: Array<
            { __typename: 'JewelleryDesignStyleLabel' } & Pick<
                JewelleryDesignStyleLabel,
                'systemCode'
            >
        >
        translation: {
            __typename: 'CatalogueJewelleryNecklaceTranslation'
        } & Pick<CatalogueJewelleryNecklaceTranslation, 'description'>
        necklaceProductStyles: Array<
            { __typename: 'JewelleryNecklaceProductStyleLabel' } & Pick<
                JewelleryNecklaceProductStyleLabel,
                'systemCode'
            >
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & Pick<Money, 'currency' | 'amount'>
        }
        primaryMetal: { __typename: 'Metal' } & Pick<
            Metal,
            'systemCode' | 'millesimalFineness' | 'karat' | 'segmentName'
        > & {
                element: { __typename: 'MetalElement' } & Pick<
                    MetalElement,
                    'systemCode'
                >
            }
    }

type ProductAnalytics_CatalogueJewelleryRing_Fragment = {
    __typename: 'CatalogueJewelleryRing'
} & Pick<
    CatalogueJewelleryRing,
    'segmentName' | 'deliveryDays' | 'catalogueCode' | 'productName' | 'suffix'
> & { jewellerySku: CatalogueJewelleryRing['sku'] } & {
        designStyles: Array<
            { __typename: 'JewelleryDesignStyleLabel' } & Pick<
                JewelleryDesignStyleLabel,
                'systemCode'
            >
        >
        translation: { __typename: 'CatalogueJewelleryRingTranslation' } & Pick<
            CatalogueJewelleryRingTranslation,
            'description'
        >
        jewelleryRingProductStyles: Array<
            { __typename: 'JewelleryRingProductStyleLabel' } & Pick<
                JewelleryRingProductStyleLabel,
                'systemCode'
            >
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & Pick<Money, 'currency' | 'amount'>
        }
        primaryMetal: { __typename: 'Metal' } & Pick<
            Metal,
            'systemCode' | 'millesimalFineness' | 'karat' | 'segmentName'
        > & {
                element: { __typename: 'MetalElement' } & Pick<
                    MetalElement,
                    'systemCode'
                >
            }
    }

type ProductAnalytics_CatalogueReadyToGoRing_Fragment = {
    __typename: 'CatalogueReadyToGoRing'
} & Pick<
    CatalogueReadyToGoRing,
    'segmentName' | 'deliveryDays' | 'catalogueCode' | 'productName' | 'suffix'
> & {
        translation: { __typename: 'CatalogueReadyToGoRingTranslation' } & Pick<
            CatalogueReadyToGoRingTranslation,
            'description'
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & Pick<Money, 'currency' | 'amount'>
        }
        primaryMetal: { __typename: 'Metal' } & Pick<
            Metal,
            'systemCode' | 'millesimalFineness' | 'karat' | 'segmentName'
        > & {
                element: { __typename: 'MetalElement' } & Pick<
                    MetalElement,
                    'systemCode'
                >
            }
    }

type ProductAnalytics_CatalogueWeddingRing_Fragment = {
    __typename: 'CatalogueWeddingRing'
} & Pick<
    CatalogueWeddingRing,
    | 'segmentName'
    | 'deliveryDays'
    | 'bandWidth'
    | 'catalogueCode'
    | 'productName'
    | 'suffix'
> & {
        categories: Array<
            { __typename: 'WeddingRingCategoryLabel' } & Pick<
                WeddingRingCategoryLabel,
                'systemCode'
            >
        >
        translation: { __typename: 'CatalogueWeddingRingTranslation' } & Pick<
            CatalogueWeddingRingTranslation,
            'description'
        >
        ringStyles: Array<
            { __typename: 'WeddingRingStyleLabel' } & Pick<
                WeddingRingStyleLabel,
                'systemCode'
            >
        >
        signatureStone: Maybe<
            { __typename: 'Melee' } & Pick<
                Melee,
                'id' | 'width' | 'caratWeight'
            > & {
                    shape: { __typename: 'StoneShape' } & Pick<
                        StoneShape,
                        'systemCode'
                    > & {
                            translation: {
                                __typename: 'StoneShapeTranslation'
                            } & Pick<StoneShapeTranslation, 'name'>
                        }
                    crystal: { __typename: 'StoneCrystal' } & Pick<
                        StoneCrystal,
                        'systemCode'
                    > & {
                            translation: {
                                __typename: 'StoneCrystalTranslation'
                            } & Pick<StoneCrystalTranslation, 'name'>
                        }
                    grade: Maybe<
                        { __typename: 'StoneGrade' } & Pick<
                            StoneGrade,
                            'systemCode'
                        > & {
                                translation: {
                                    __typename: 'StoneGradeTranslation'
                                } & Pick<StoneGradeTranslation, 'name'>
                            }
                    >
                    colors: Array<
                        { __typename: 'StoneColor' } & Pick<
                            StoneColor,
                            'systemCode'
                        > & {
                                translation: {
                                    __typename: 'StoneColorTranslation'
                                } & Pick<StoneColorTranslation, 'name'>
                            }
                    >
                    clarities: Array<
                        { __typename: 'StoneClarity' } & Pick<
                            StoneClarity,
                            'systemCode'
                        > & {
                                translation: {
                                    __typename: 'StoneClarityTranslation'
                                } & Pick<StoneClarityTranslation, 'name'>
                            }
                    >
                }
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & Pick<Money, 'currency' | 'amount'>
        }
        primaryMetal: { __typename: 'Metal' } & Pick<
            Metal,
            'systemCode' | 'millesimalFineness' | 'karat' | 'segmentName'
        > & {
                element: { __typename: 'MetalElement' } & Pick<
                    MetalElement,
                    'systemCode'
                >
            }
    }

export type ProductAnalyticsFragment =
    | ProductAnalytics_CatalogueEngagementRing_Fragment
    | ProductAnalytics_CatalogueJewelleryBracelet_Fragment
    | ProductAnalytics_CatalogueJewelleryEarrings_Fragment
    | ProductAnalytics_CatalogueJewelleryNecklace_Fragment
    | ProductAnalytics_CatalogueJewelleryRing_Fragment
    | ProductAnalytics_CatalogueReadyToGoRing_Fragment
    | ProductAnalytics_CatalogueWeddingRing_Fragment

type ProductListAnalytics_CatalogueEngagementRing_Fragment = {
    __typename: 'CatalogueEngagementRing'
} & Pick<CatalogueEngagementRing, 'catalogueCode' | 'segmentName'> & {
        translation: {
            __typename: 'CatalogueEngagementRingTranslation'
        } & Pick<CatalogueEngagementRingTranslation, 'description'>
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & Pick<Money, 'currency' | 'amount'>
        }
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'segmentName'>
    } & ProductLink_CatalogueEngagementRing_Fragment

type ProductListAnalytics_CatalogueJewelleryBracelet_Fragment = {
    __typename: 'CatalogueJewelleryBracelet'
} & Pick<CatalogueJewelleryBracelet, 'catalogueCode' | 'segmentName'> & {
        jewellerySku: CatalogueJewelleryBracelet['sku']
    } & {
        translation: {
            __typename: 'CatalogueJewelleryBraceletTranslation'
        } & Pick<CatalogueJewelleryBraceletTranslation, 'description'>
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & Pick<Money, 'currency' | 'amount'>
        }
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'segmentName'>
    } & ProductLink_CatalogueJewelleryBracelet_Fragment

type ProductListAnalytics_CatalogueJewelleryEarrings_Fragment = {
    __typename: 'CatalogueJewelleryEarrings'
} & Pick<CatalogueJewelleryEarrings, 'catalogueCode' | 'segmentName'> & {
        jewellerySku: CatalogueJewelleryEarrings['sku']
    } & {
        translation: {
            __typename: 'CatalogueJewelleryEarringsTranslation'
        } & Pick<CatalogueJewelleryEarringsTranslation, 'description'>
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & Pick<Money, 'currency' | 'amount'>
        }
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'segmentName'>
    } & ProductLink_CatalogueJewelleryEarrings_Fragment

type ProductListAnalytics_CatalogueJewelleryNecklace_Fragment = {
    __typename: 'CatalogueJewelleryNecklace'
} & Pick<CatalogueJewelleryNecklace, 'catalogueCode' | 'segmentName'> & {
        jewellerySku: CatalogueJewelleryNecklace['sku']
    } & {
        translation: {
            __typename: 'CatalogueJewelleryNecklaceTranslation'
        } & Pick<CatalogueJewelleryNecklaceTranslation, 'description'>
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & Pick<Money, 'currency' | 'amount'>
        }
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'segmentName'>
    } & ProductLink_CatalogueJewelleryNecklace_Fragment

type ProductListAnalytics_CatalogueJewelleryRing_Fragment = {
    __typename: 'CatalogueJewelleryRing'
} & Pick<CatalogueJewelleryRing, 'catalogueCode' | 'segmentName'> & {
        jewellerySku: CatalogueJewelleryRing['sku']
    } & {
        translation: { __typename: 'CatalogueJewelleryRingTranslation' } & Pick<
            CatalogueJewelleryRingTranslation,
            'description'
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & Pick<Money, 'currency' | 'amount'>
        }
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'segmentName'>
    } & ProductLink_CatalogueJewelleryRing_Fragment

type ProductListAnalytics_CatalogueReadyToGoRing_Fragment = {
    __typename: 'CatalogueReadyToGoRing'
} & Pick<CatalogueReadyToGoRing, 'catalogueCode' | 'segmentName'> & {
        translation: { __typename: 'CatalogueReadyToGoRingTranslation' } & Pick<
            CatalogueReadyToGoRingTranslation,
            'description'
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & Pick<Money, 'currency' | 'amount'>
        }
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'segmentName'>
    } & ProductLink_CatalogueReadyToGoRing_Fragment

type ProductListAnalytics_CatalogueWeddingRing_Fragment = {
    __typename: 'CatalogueWeddingRing'
} & Pick<CatalogueWeddingRing, 'catalogueCode' | 'segmentName'> & {
        translation: { __typename: 'CatalogueWeddingRingTranslation' } & Pick<
            CatalogueWeddingRingTranslation,
            'description'
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & Pick<Money, 'currency' | 'amount'>
        }
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'segmentName'>
    } & ProductLink_CatalogueWeddingRing_Fragment

export type ProductListAnalyticsFragment =
    | ProductListAnalytics_CatalogueEngagementRing_Fragment
    | ProductListAnalytics_CatalogueJewelleryBracelet_Fragment
    | ProductListAnalytics_CatalogueJewelleryEarrings_Fragment
    | ProductListAnalytics_CatalogueJewelleryNecklace_Fragment
    | ProductListAnalytics_CatalogueJewelleryRing_Fragment
    | ProductListAnalytics_CatalogueReadyToGoRing_Fragment
    | ProductListAnalytics_CatalogueWeddingRing_Fragment

export type GemsApiStoneAnalyticsFragment = {
    __typename: 'GemsApi_Stone'
} & Pick<GemsApi_Stone, 'weight' | 'originCountry'> & {
        crystalWithInfo: { __typename: 'GemsApi_StoneCrystalInfo' } & {
            info: Maybe<
                { __typename: 'StoneCrystal' } & Pick<
                    StoneCrystal,
                    'systemCode'
                > & {
                        translation: {
                            __typename: 'StoneCrystalTranslation'
                        } & Pick<StoneCrystalTranslation, 'name'>
                    }
            >
        }
        shapeWithInfo: { __typename: 'GemsApi_StoneShapeInfo' } & {
            info: Maybe<
                { __typename: 'StoneShape' } & Pick<
                    StoneShape,
                    'systemCode'
                > & {
                        translation: {
                            __typename: 'StoneShapeTranslation'
                        } & Pick<StoneShapeTranslation, 'name'>
                    }
            >
        }
        colorWithInfo: { __typename: 'GemsApi_StoneColorInfo' } & {
            info: Maybe<
                { __typename: 'StoneColor' } & Pick<
                    StoneColor,
                    'systemCode'
                > & {
                        translation: {
                            __typename: 'StoneColorTranslation'
                        } & Pick<StoneColorTranslation, 'name'>
                    }
            >
        }
        clarityWithInfo: { __typename: 'GemsApi_StoneClarityInfo' } & {
            info: Maybe<
                { __typename: 'StoneClarity' } & Pick<
                    StoneClarity,
                    'systemCode'
                > & {
                        translation: {
                            __typename: 'StoneClarityTranslation'
                        } & Pick<StoneClarityTranslation, 'name'>
                    }
            >
        }
        cutWithInfo: Maybe<
            { __typename: 'GemsApi_StoneCutInfo' } & {
                info: Maybe<
                    { __typename: 'StoneCut' } & Pick<
                        StoneCut,
                        'systemCode'
                    > & {
                            translation: {
                                __typename: 'StoneCutTranslation'
                            } & Pick<StoneCutTranslation, 'name'>
                        }
                >
            }
        >
        gradeWithInfo: Maybe<
            { __typename: 'GemsApi_StoneGradeInfo' } & {
                info: Maybe<
                    { __typename: 'StoneGrade' } & Pick<
                        StoneGrade,
                        'systemCode'
                    > & {
                            translation: {
                                __typename: 'StoneGradeTranslation'
                            } & Pick<StoneGradeTranslation, 'name'>
                        }
                >
            }
        >
    }

export type NonSkuGemstoneAnalyticsFragment = {
    __typename: 'NonSkuGemstone'
} & Pick<NonSkuGemstone, 'caratWeight'> & {
        crystal: { __typename: 'StoneCrystal' } & Pick<
            StoneCrystal,
            'systemCode'
        > & {
                translation: { __typename: 'StoneCrystalTranslation' } & Pick<
                    StoneCrystalTranslation,
                    'name'
                >
            }
        shape: { __typename: 'StoneShape' } & Pick<StoneShape, 'systemCode'> & {
                translation: { __typename: 'StoneShapeTranslation' } & Pick<
                    StoneShapeTranslation,
                    'name'
                >
            }
        color: { __typename: 'StoneColor' } & Pick<StoneColor, 'systemCode'> & {
                translation: { __typename: 'StoneColorTranslation' } & Pick<
                    StoneColorTranslation,
                    'name'
                >
            }
        clarity: { __typename: 'StoneClarity' } & Pick<
            StoneClarity,
            'systemCode'
        > & {
                translation: { __typename: 'StoneClarityTranslation' } & Pick<
                    StoneClarityTranslation,
                    'name'
                >
            }
        cut: { __typename: 'StoneCut' } & Pick<StoneCut, 'systemCode'> & {
                translation: { __typename: 'StoneCutTranslation' } & Pick<
                    StoneCutTranslation,
                    'name'
                >
            }
        colorGrade: { __typename: 'StoneGrade' } & Pick<
            StoneGrade,
            'systemCode'
        > & {
                translation: { __typename: 'StoneGradeTranslation' } & Pick<
                    StoneGradeTranslation,
                    'name'
                >
            }
    }

export type NonSkuLabGrownAnalyticsFragment = {
    __typename: 'NonSkuLabGrown'
} & Pick<NonSkuLabGrown, 'caratWeight'> & {
        crystal: { __typename: 'StoneCrystal' } & Pick<
            StoneCrystal,
            'systemCode'
        > & {
                translation: { __typename: 'StoneCrystalTranslation' } & Pick<
                    StoneCrystalTranslation,
                    'name'
                >
            }
        shape: { __typename: 'StoneShape' } & Pick<StoneShape, 'systemCode'> & {
                translation: { __typename: 'StoneShapeTranslation' } & Pick<
                    StoneShapeTranslation,
                    'name'
                >
            }
        color: { __typename: 'StoneColor' } & Pick<StoneColor, 'systemCode'> & {
                translation: { __typename: 'StoneColorTranslation' } & Pick<
                    StoneColorTranslation,
                    'name'
                >
            }
        clarity: { __typename: 'StoneClarity' } & Pick<
            StoneClarity,
            'systemCode'
        > & {
                translation: { __typename: 'StoneClarityTranslation' } & Pick<
                    StoneClarityTranslation,
                    'name'
                >
            }
        cut: { __typename: 'StoneCut' } & Pick<StoneCut, 'systemCode'> & {
                translation: { __typename: 'StoneCutTranslation' } & Pick<
                    StoneCutTranslation,
                    'name'
                >
            }
    }

export type MeleeFragment = { __typename: 'CatalogueMelee' } & Pick<
    CatalogueMelee,
    'quantity'
> & {
        melee: { __typename: 'Melee' } & Pick<
            Melee,
            'caratWeight' | 'width'
        > & {
                grade: Maybe<
                    { __typename: 'StoneGrade' } & {
                        category: { __typename: 'StoneCategory' } & Pick<
                            StoneCategory,
                            'systemCode'
                        >
                    }
                >
                colors: Array<
                    { __typename: 'StoneColor' } & Pick<
                        StoneColor,
                        'systemCode'
                    > & {
                            translation: {
                                __typename: 'StoneColorTranslation'
                            } & Pick<StoneColorTranslation, 'name'>
                        }
                >
                clarities: Array<
                    { __typename: 'StoneClarity' } & Pick<
                        StoneClarity,
                        'systemCode'
                    > & {
                            translation: {
                                __typename: 'StoneClarityTranslation'
                            } & Pick<StoneClarityTranslation, 'name'>
                        }
                >
            }
    }

type ProductPageMeta_CatalogueEngagementRing_Fragment = {
    __typename: 'CatalogueEngagementRing'
} & Pick<
    CatalogueEngagementRing,
    'catalogueCode' | 'productName' | 'customTitleTag'
> & {
        erRingStyles: Array<
            { __typename: 'EngagementRingStyleLabel' } & Pick<
                EngagementRingStyleLabel,
                'systemCode'
            > & {
                    translation: {
                        __typename: 'ProductLabelTranslation'
                    } & Pick<ProductLabelTranslation, 'name'>
                }
        >
        translation: {
            __typename: 'CatalogueEngagementRingTranslation'
        } & Pick<CatalogueEngagementRingTranslation, 'description'>
        reviews: Array<
            { __typename: 'Review' } & Pick<
                Review,
                'id' | 'name' | 'comment' | 'date' | 'rating'
            > & { picture: Maybe<{ __typename: 'Asset' } & AssetFragment> }
        >
        primaryMetal: { __typename: 'Metal' } & MetalFilterMetalFragment
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<
                CatalogueImage,
                'id' | 'url'
            >
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
    }

type ProductPageMeta_CatalogueJewelleryBracelet_Fragment = {
    __typename: 'CatalogueJewelleryBracelet'
} & Pick<
    CatalogueJewelleryBracelet,
    'catalogueCode' | 'productName' | 'customTitleTag'
> & {
        translation: {
            __typename: 'CatalogueJewelleryBraceletTranslation'
        } & Pick<CatalogueJewelleryBraceletTranslation, 'description'>
        reviews: Array<
            { __typename: 'Review' } & Pick<
                Review,
                'id' | 'name' | 'comment' | 'date' | 'rating'
            > & { picture: Maybe<{ __typename: 'Asset' } & AssetFragment> }
        >
        primaryMetal: { __typename: 'Metal' } & MetalFilterMetalFragment
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<
                CatalogueImage,
                'id' | 'url'
            >
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
    }

type ProductPageMeta_CatalogueJewelleryEarrings_Fragment = {
    __typename: 'CatalogueJewelleryEarrings'
} & Pick<
    CatalogueJewelleryEarrings,
    'catalogueCode' | 'productName' | 'customTitleTag'
> & {
        translation: {
            __typename: 'CatalogueJewelleryEarringsTranslation'
        } & Pick<CatalogueJewelleryEarringsTranslation, 'description'>
        reviews: Array<
            { __typename: 'Review' } & Pick<
                Review,
                'id' | 'name' | 'comment' | 'date' | 'rating'
            > & { picture: Maybe<{ __typename: 'Asset' } & AssetFragment> }
        >
        primaryMetal: { __typename: 'Metal' } & MetalFilterMetalFragment
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<
                CatalogueImage,
                'id' | 'url'
            >
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
    }

type ProductPageMeta_CatalogueJewelleryNecklace_Fragment = {
    __typename: 'CatalogueJewelleryNecklace'
} & Pick<
    CatalogueJewelleryNecklace,
    'catalogueCode' | 'productName' | 'customTitleTag'
> & {
        translation: {
            __typename: 'CatalogueJewelleryNecklaceTranslation'
        } & Pick<CatalogueJewelleryNecklaceTranslation, 'description'>
        reviews: Array<
            { __typename: 'Review' } & Pick<
                Review,
                'id' | 'name' | 'comment' | 'date' | 'rating'
            > & { picture: Maybe<{ __typename: 'Asset' } & AssetFragment> }
        >
        primaryMetal: { __typename: 'Metal' } & MetalFilterMetalFragment
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<
                CatalogueImage,
                'id' | 'url'
            >
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
    }

type ProductPageMeta_CatalogueJewelleryRing_Fragment = {
    __typename: 'CatalogueJewelleryRing'
} & Pick<
    CatalogueJewelleryRing,
    'catalogueCode' | 'productName' | 'customTitleTag'
> & {
        translation: { __typename: 'CatalogueJewelleryRingTranslation' } & Pick<
            CatalogueJewelleryRingTranslation,
            'description'
        >
        reviews: Array<
            { __typename: 'Review' } & Pick<
                Review,
                'id' | 'name' | 'comment' | 'date' | 'rating'
            > & { picture: Maybe<{ __typename: 'Asset' } & AssetFragment> }
        >
        primaryMetal: { __typename: 'Metal' } & MetalFilterMetalFragment
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<
                CatalogueImage,
                'id' | 'url'
            >
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
    }

type ProductPageMeta_CatalogueReadyToGoRing_Fragment = {
    __typename: 'CatalogueReadyToGoRing'
} & Pick<
    CatalogueReadyToGoRing,
    'sku' | 'catalogueCode' | 'productName' | 'customTitleTag'
> & {
        translation: { __typename: 'CatalogueReadyToGoRingTranslation' } & Pick<
            CatalogueReadyToGoRingTranslation,
            'description'
        >
        reviews: Array<
            { __typename: 'Review' } & Pick<
                Review,
                'id' | 'name' | 'comment' | 'date' | 'rating'
            > & { picture: Maybe<{ __typename: 'Asset' } & AssetFragment> }
        >
        primaryMetal: { __typename: 'Metal' } & MetalFilterMetalFragment
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<
                CatalogueImage,
                'id' | 'url'
            >
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
    }

type ProductPageMeta_CatalogueWeddingRing_Fragment = {
    __typename: 'CatalogueWeddingRing'
} & Pick<
    CatalogueWeddingRing,
    'catalogueCode' | 'productName' | 'customTitleTag'
> & {
        translation: { __typename: 'CatalogueWeddingRingTranslation' } & Pick<
            CatalogueWeddingRingTranslation,
            'description'
        >
        categories: Array<
            { __typename: 'WeddingRingCategoryLabel' } & Pick<
                WeddingRingCategoryLabel,
                'systemCode'
            > & {
                    translation: {
                        __typename: 'ProductLabelTranslation'
                    } & Pick<ProductLabelTranslation, 'name'>
                }
        >
        wrRingStyles: Array<
            { __typename: 'WeddingRingStyleLabel' } & Pick<
                WeddingRingStyleLabel,
                'systemCode'
            > & {
                    translation: {
                        __typename: 'ProductLabelTranslation'
                    } & Pick<ProductLabelTranslation, 'name'>
                }
        >
        reviews: Array<
            { __typename: 'Review' } & Pick<
                Review,
                'id' | 'name' | 'comment' | 'date' | 'rating'
            > & { picture: Maybe<{ __typename: 'Asset' } & AssetFragment> }
        >
        primaryMetal: { __typename: 'Metal' } & MetalFilterMetalFragment
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<
                CatalogueImage,
                'id' | 'url'
            >
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
    }

export type ProductPageMetaFragment =
    | ProductPageMeta_CatalogueEngagementRing_Fragment
    | ProductPageMeta_CatalogueJewelleryBracelet_Fragment
    | ProductPageMeta_CatalogueJewelleryEarrings_Fragment
    | ProductPageMeta_CatalogueJewelleryNecklace_Fragment
    | ProductPageMeta_CatalogueJewelleryRing_Fragment
    | ProductPageMeta_CatalogueReadyToGoRing_Fragment
    | ProductPageMeta_CatalogueWeddingRing_Fragment

export type EngagementRingPageQueryVariables = Exact<{
    locale: Scalars['Locale']['input']
    currency: CurrencyInput
    region: RegionCode
    page: Scalars['String']['input']
    pageFallback: Scalars['String']['input']
    engagementRingFilter: CatalogueEngagementRingFilterInput
}>

export type EngagementRingPageQuery = { __typename: 'Query' } & {
    catalogueEngagementRing: Maybe<
        { __typename: 'CatalogueEngagementRing' } & Pick<
            CatalogueEngagementRing,
            'catalogueCode' | 'productName' | 'bandWidth'
        > & {
                meleeItems: Array<
                    { __typename: 'CatalogueMelee' } & MeleeFragment
                >
                noEngravingDeliveryDate: {
                    __typename: 'DeliveryDate'
                } & DeliveryTimeframeFragment
                hasEngravingDeliveryDate: {
                    __typename: 'DeliveryDate'
                } & DeliveryTimeframeFragment
                reviews: Array<{ __typename: 'Review' } & ReviewsFragment>
                salePrice: { __typename: 'SalePrice' } & TaxSnippetFragment
                variationsByCentreStoneShape: Array<
                    { __typename: 'CatalogueEngagementRing' } & {
                        centreStoneConstraints: {
                            __typename: 'CatalogueEngagementRingCentreStoneConstraints'
                        } & {
                            shape: { __typename: 'StoneShape' } & Pick<
                                StoneShape,
                                'systemCode'
                            > & {
                                    translation: {
                                        __typename: 'StoneShapeTranslation'
                                    } & Pick<StoneShapeTranslation, 'name'>
                                    icon: Maybe<
                                        { __typename: 'Asset' } & Pick<
                                            Asset,
                                            'id' | 'url'
                                        >
                                    >
                                }
                        }
                    } & EngagementRingLinkFragment
                >
                variationsByPrimaryMetal: Array<
                    {
                        __typename: 'CatalogueEngagementRing'
                    } & MetalVariation_CatalogueEngagementRing_Fragment &
                        EngagementRingLinkFragment
                >
                relatedProducts: Array<
                    {
                        __typename: 'CatalogueEngagementRing'
                    } & RelatedProduct_CatalogueEngagementRing_Fragment
                >
                primaryMetal: { __typename: 'Metal' } & {
                    translation: { __typename: 'MetalTranslation' } & Pick<
                        MetalTranslation,
                        'name'
                    >
                }
                translation: {
                    __typename: 'CatalogueEngagementRingTranslation'
                } & Pick<CatalogueEngagementRingTranslation, 'seoText'>
                centreStoneConstraints: {
                    __typename: 'CatalogueEngagementRingCentreStoneConstraints'
                } & {
                    shape: { __typename: 'StoneShape' } & {
                        translation: {
                            __typename: 'StoneShapeTranslation'
                        } & Pick<StoneShapeTranslation, 'name'>
                    }
                }
                signatureStone: Maybe<
                    { __typename: 'Melee' } & Pick<Melee, 'width'> & {
                            colors: Array<
                                { __typename: 'StoneColor' } & Pick<
                                    StoneColor,
                                    'systemCode'
                                >
                            >
                            crystal: { __typename: 'StoneCrystal' } & Pick<
                                StoneCrystal,
                                'systemCode'
                            >
                        }
                >
                signatureStones: Array<
                    {
                        __typename: 'CatalogueEngagementRingAndSignatureStone'
                    } & EngagementRingAndSignatureStoneFragment
                >
            } & EngagementRingLinkFragment &
            ProductPageMeta_CatalogueEngagementRing_Fragment &
            ProductGallery_CatalogueEngagementRing_Fragment &
            ProductAnalytics_CatalogueEngagementRing_Fragment &
            ShopWithConfidenceProduct_CatalogueEngagementRing_Fragment
    >
    pageProductDetails: Maybe<
        { __typename: 'ProductPageDetails' } & Pick<
            ProductPageDetails,
            'id'
        > & {
                blocks: Array<{ __typename: 'Block' } & BlockFragment>
                meta: { __typename: 'Meta' } & MetaFragment
                priceExplainedTooltip: Maybe<
                    { __typename: 'PageTooltip' } & PageTooltipFragment
                >
            }
    >
}

export type EngagementRingAndSignatureStoneFragment = {
    __typename: 'CatalogueEngagementRingAndSignatureStone'
} & {
    salePrice: { __typename: 'SalePrice' } & TaxSnippetFragment
    signatureStone: {
        __typename: 'CatalogueEngagementRingSignatureStone'
    } & Pick<CatalogueEngagementRingSignatureStone, 'isDefault' | 'image'> & {
            crystal: { __typename: 'StoneCrystal' } & Pick<
                StoneCrystal,
                'systemCode'
            > & {
                    translation: {
                        __typename: 'StoneCrystalTranslation'
                    } & Pick<StoneCrystalTranslation, 'name'>
                }
            color: { __typename: 'StoneColor' } & Pick<
                StoneColor,
                'systemCode'
            > & {
                    translation: { __typename: 'StoneColorTranslation' } & Pick<
                        StoneColorTranslation,
                        'name'
                    >
                }
            price: { __typename: 'Money' } & MoneyFragment
        } & SignatureStoneInputFragment
}

export type EngagementRingBrowseQueryVariables = Exact<{
    currency: CurrencyInput
    region: RegionCode
    filter: CatalogueEngagementRingsFilterInput
    page: Scalars['Int']['input']
    locale: Scalars['Locale']['input']
    limit: Scalars['Int']['input']
    path: Scalars['String']['input']
    facetedContentInput: ProductPageFacetedContentInput
    sortBy: CatalogueSortOrder
}>

export type EngagementRingBrowseQuery = { __typename: 'Query' } & {
    catalogueEngagementRingFilters: {
        __typename: 'CatalogueEngagementRingFilters'
    } & EngagementRingFiltersFragment
    catalogueEngagementRingsAggregate: {
        __typename: 'CatalogueAggregate'
    } & Pick<CatalogueAggregate, 'count'>
    catalogueEngagementRings: Array<
        {
            __typename: 'CatalogueEngagementRing'
        } & ProductGrid_CatalogueEngagementRing_Fragment
    >
    pageProductListingFacetedContent: Maybe<
        {
            __typename: 'ProductPageFacetedContent'
        } & ProductPageFacetedContentFragment
    >
    pageProductListing: Maybe<
        { __typename: 'ProductPageListing' } & ProductPageListingFragment
    >
}

export type StoneRecommendationsQueryVariables = Exact<{
    minPrice: InputMaybe<MoneyInput>
    maxPrice: InputMaybe<MoneyInput>
    locale: Scalars['Locale']['input']
    currency: CurrencyInput
    region: RegionCode
    hasPrice: Scalars['Boolean']['input']
    colorCodes: InputMaybe<Array<StoneColorCode> | StoneColorCode>
    colorCodesCms: InputMaybe<
        Array<CmsGemstoneColorCode> | CmsGemstoneColorCode
    >
}>

export type StoneRecommendationsQuery = { __typename: 'Query' } & {
    ringBuilder: { __typename: 'RingBuilder' } & Pick<RingBuilder, 'id'> & {
            position1: Maybe<
                | ({
                      __typename: 'RingBuilderCentreStoneFragment'
                  } & RingBuilderStoneRecommendations_RingBuilderCentreStoneFragment_Fragment)
                | ({
                      __typename: 'RingBuilderMountFragment'
                  } & RingBuilderStoneRecommendations_RingBuilderMountFragment_Fragment)
            >
            position2: Maybe<
                | ({
                      __typename: 'RingBuilderCentreStoneFragment'
                  } & RingBuilderStoneRecommendations_RingBuilderCentreStoneFragment_Fragment)
                | ({
                      __typename: 'RingBuilderMountFragment'
                  } & RingBuilderStoneRecommendations_RingBuilderMountFragment_Fragment)
            >
        }
    cms: Maybe<
        { __typename: 'EngagementRingStoneRecommendations' } & Pick<
            EngagementRingStoneRecommendations,
            'fullSearchButtonText'
        > & {
                blocks: Array<{ __typename: 'Block' } & BlockFragment>
                naturalDiamonds: {
                    __typename: 'EngagementRingStoneRecommendationNaturalDiamonds'
                } & {
                    forSizeCard: {
                        __typename: 'EngagementRingStoneRecommendationCard'
                    } & EngagementRingStoneRecommendationCardFragment
                    forBalanceCard: {
                        __typename: 'EngagementRingStoneRecommendationCard'
                    } & EngagementRingStoneRecommendationCardFragment
                    labGrownAlternative: {
                        __typename: 'EngagementRingStoneRecommendationCard'
                    } & EngagementRingStoneRecommendationCardFragment
                }
                nonSkuLabGrown: {
                    __typename: 'EngagementRingStoneRecommendationNonSkuLabGrown'
                } & {
                    forSizeCard: {
                        __typename: 'EngagementRingStoneRecommendationCard'
                    } & EngagementRingStoneRecommendationCardFragment
                    forPriceCard: {
                        __typename: 'EngagementRingStoneRecommendationCard'
                    } & EngagementRingStoneRecommendationCardFragment
                    naturalDiamondAlternative: {
                        __typename: 'EngagementRingStoneRecommendationCard'
                    } & EngagementRingStoneRecommendationCardFragment
                }
                nonSkuGemStones: Array<
                    {
                        __typename: 'EngagementRingStoneRecommendationNonSkuGemStoneCard'
                    } & Pick<
                        EngagementRingStoneRecommendationNonSkuGemStoneCard,
                        'color'
                    > & {
                            content: {
                                __typename: 'EngagementRingStoneRecommendationCard'
                            } & EngagementRingStoneRecommendationCardFragment
                        }
                >
            }
    >
}

type RingBuilderStoneRecommendations_RingBuilderCentreStoneFragment_Fragment = {
    __typename: 'RingBuilderCentreStoneFragment'
} & Pick<RingBuilderCentreStoneFragment, 'id'>

type RingBuilderStoneRecommendations_RingBuilderMountFragment_Fragment = {
    __typename: 'RingBuilderMountFragment'
} & Pick<RingBuilderMountFragment, 'id'> & {
        stoneRecommendations:
            | ({
                  __typename: 'StoneRecommendationsResponseFailure'
              } & StoneRecommendations_StoneRecommendationsResponseFailure_Fragment)
            | ({
                  __typename: 'StoneRecommendationsResponseSuccess'
              } & StoneRecommendations_StoneRecommendationsResponseSuccess_Fragment)
    }

export type RingBuilderStoneRecommendationsFragment =
    | RingBuilderStoneRecommendations_RingBuilderCentreStoneFragment_Fragment
    | RingBuilderStoneRecommendations_RingBuilderMountFragment_Fragment

type StoneRecommendations_StoneRecommendationsResponseFailure_Fragment = {
    __typename: 'StoneRecommendationsResponseFailure'
} & Pick<StoneRecommendationsResponseFailure, 'error'>

type StoneRecommendations_StoneRecommendationsResponseSuccess_Fragment = {
    __typename: 'StoneRecommendationsResponseSuccess'
} & {
    priceBounds: { __typename: 'StoneRecommendationsPriceRange' } & {
        min: { __typename: 'Money' } & MoneyFragment
        max: { __typename: 'Money' } & MoneyFragment
    }
    priceInitialValues?: { __typename: 'StoneRecommendationsPriceRange' } & {
        min: { __typename: 'Money' } & MoneyFragment
        max: { __typename: 'Money' } & MoneyFragment
    }
    naturalDiamondBestForBalance:
        | ({ __typename: 'GemsApi_Stone' } & StoneFragment)
        | ({
              __typename: 'StoneRecommendationNotFound'
          } & StoneRecommendationsNotFoundFragment)
    naturalDiamondBestForSize:
        | ({ __typename: 'GemsApi_Stone' } & StoneFragment)
        | ({
              __typename: 'StoneRecommendationNotFound'
          } & StoneRecommendationsNotFoundFragment)
    nonSkuGemStones: Array<
        { __typename: 'StoneRecommendationNonSkuGemstone' } & {
            color: { __typename: 'StoneColor' } & Pick<
                StoneColor,
                'systemCode'
            > & {
                    translation: { __typename: 'StoneColorTranslation' } & Pick<
                        StoneColorTranslation,
                        'name'
                    >
                }
            item:
                | ({ __typename: 'NonSkuGemstone' } & NonSkuGemstoneFragment)
                | ({
                      __typename: 'StoneRecommendationNotFound'
                  } & StoneRecommendationsNotFoundFragment)
        }
    >
    nonSkuLabGrownBestForPrice:
        | ({ __typename: 'NonSkuLabGrown' } & NonSkuLabGrownFragment)
        | ({
              __typename: 'StoneRecommendationNotFound'
          } & StoneRecommendationsNotFoundFragment)
    nonSkuLabGrownBestForSize:
        | ({ __typename: 'NonSkuLabGrown' } & NonSkuLabGrownFragment)
        | ({
              __typename: 'StoneRecommendationNotFound'
          } & StoneRecommendationsNotFoundFragment)
}

export type StoneRecommendationsFragment =
    | StoneRecommendations_StoneRecommendationsResponseFailure_Fragment
    | StoneRecommendations_StoneRecommendationsResponseSuccess_Fragment

export type EngagementRingStoneRecommendationCardFragment = {
    __typename: 'EngagementRingStoneRecommendationCard'
} & Pick<EngagementRingStoneRecommendationCard, 'title' | 'description'> & {
        notSupportedContent: Array<
            | ({
                  __typename: 'ComponentButton'
              } & ContentComponentItem_ComponentButton_Fragment)
            | ({
                  __typename: 'ComponentImage'
              } & ContentComponentItem_ComponentImage_Fragment)
            | ({
                  __typename: 'ComponentOrderedList'
              } & ContentComponentItem_ComponentOrderedList_Fragment)
            | ({
                  __typename: 'ComponentSpacer'
              } & ContentComponentItem_ComponentSpacer_Fragment)
            | ({
                  __typename: 'ComponentText'
              } & ContentComponentItem_ComponentText_Fragment)
            | ({
                  __typename: 'ComponentTitle'
              } & ContentComponentItem_ComponentTitle_Fragment)
        >
        notFoundContent: Array<
            | ({
                  __typename: 'ComponentButton'
              } & ContentComponentItem_ComponentButton_Fragment)
            | ({
                  __typename: 'ComponentImage'
              } & ContentComponentItem_ComponentImage_Fragment)
            | ({
                  __typename: 'ComponentOrderedList'
              } & ContentComponentItem_ComponentOrderedList_Fragment)
            | ({
                  __typename: 'ComponentSpacer'
              } & ContentComponentItem_ComponentSpacer_Fragment)
            | ({
                  __typename: 'ComponentText'
              } & ContentComponentItem_ComponentText_Fragment)
            | ({
                  __typename: 'ComponentTitle'
              } & ContentComponentItem_ComponentTitle_Fragment)
        >
    }

export type JewelleryBrowseQueryVariables = Exact<{
    currency: CurrencyInput
    region: RegionCode
    filter: CatalogueJewelleriesFilterInput
    braceletFilter: CatalogueJewelleriesBraceletsFilterInput
    necklaceFilter: CatalogueJewelleriesNecklacesFilterInput
    earringsFilter: CatalogueJewelleriesEarringsFilterInput
    ringsFilter: CatalogueJewelleriesRingsFilterInput
    isJewellery: Scalars['Boolean']['input']
    isBracelet: Scalars['Boolean']['input']
    isNecklace: Scalars['Boolean']['input']
    isEarrings: Scalars['Boolean']['input']
    isRing: Scalars['Boolean']['input']
    page: Scalars['Int']['input']
    locale: Scalars['Locale']['input']
    limit?: InputMaybe<Scalars['Int']['input']>
    path: Scalars['String']['input']
    facetedContentInput: ProductPageFacetedContentInput
    sortBy: CatalogueSortOrder
}>

export type JewelleryBrowseQuery = { __typename: 'Query' } & {
    catalogueJewelleriesFilters?: {
        __typename: 'CatalogueJewelleriesFilters'
    } & JewelleryFiltersFragment
    catalogueJewelleries?: Array<
        | ({
              __typename: 'CatalogueJewelleryBracelet'
          } & ProductGrid_CatalogueJewelleryBracelet_Fragment)
        | ({
              __typename: 'CatalogueJewelleryEarrings'
          } & ProductGrid_CatalogueJewelleryEarrings_Fragment)
        | ({
              __typename: 'CatalogueJewelleryNecklace'
          } & ProductGrid_CatalogueJewelleryNecklace_Fragment)
        | ({
              __typename: 'CatalogueJewelleryRing'
          } & ProductGrid_CatalogueJewelleryRing_Fragment)
    >
    catalogueJewelleryNecklacesFilters?: {
        __typename: 'CatalogueJewelleryNecklacesFilters'
    } & JewelleryNecklaceFiltersFragment
    catalogueJewelleryNecklaces?: Array<
        {
            __typename: 'CatalogueJewelleryNecklace'
        } & ProductGrid_CatalogueJewelleryNecklace_Fragment
    >
    catalogueJewelleryBraceletsFilters?: {
        __typename: 'CatalogueJewelleryBraceletsFilters'
    } & JewelleryBraceletFiltersFragment
    catalogueJewelleryBracelets?: Array<
        {
            __typename: 'CatalogueJewelleryBracelet'
        } & ProductGrid_CatalogueJewelleryBracelet_Fragment
    >
    catalogueJewelleryEarringsFilters?: {
        __typename: 'CatalogueJewelleryEarringsFilters'
    } & JewelleryEarringsFiltersFragment
    catalogueJewelleryEarrings?: Array<
        {
            __typename: 'CatalogueJewelleryEarrings'
        } & ProductGrid_CatalogueJewelleryEarrings_Fragment
    >
    catalogueJewelleryRingsFilters?: {
        __typename: 'CatalogueJewelleryRingsFilters'
    } & JewelleryRingsFiltersFragment
    catalogueJewelleryRings?: Array<
        {
            __typename: 'CatalogueJewelleryRing'
        } & ProductGrid_CatalogueJewelleryRing_Fragment
    >
    catalogueJewelleriesAggregate: { __typename: 'CatalogueAggregate' } & Pick<
        CatalogueAggregate,
        'count'
    >
    catalogueJewelleryBraceletsAggregate: {
        __typename: 'CatalogueAggregate'
    } & Pick<CatalogueAggregate, 'count'>
    catalogueJewelleryEarringsAggregate: {
        __typename: 'CatalogueAggregate'
    } & Pick<CatalogueAggregate, 'count'>
    catalogueJewelleryNecklacesAggregate: {
        __typename: 'CatalogueAggregate'
    } & Pick<CatalogueAggregate, 'count'>
    catalogueJewelleryRingsAggregate: {
        __typename: 'CatalogueAggregate'
    } & Pick<CatalogueAggregate, 'count'>
    pageProductListingFacetedContent: Maybe<
        {
            __typename: 'ProductPageFacetedContent'
        } & ProductPageFacetedContentFragment
    >
    pageProductListing: Maybe<
        { __typename: 'ProductPageListing' } & ProductPageListingFragment
    >
}

export type JewelleryFiltersFragment = {
    __typename: 'CatalogueJewelleriesFilters'
} & {
    price: {
        __typename: 'CataloguePriceRangeFilter'
    } & FilterPriceRangeFragment
    primaryMetals: Array<
        { __typename: 'CatalogueFilterMetalItem' } & MetalFilterFragment
    >
    designStyles: Array<
        {
            __typename: 'CatalogueFilterJewelleryDesignStyleLabel'
        } & JewelleryDesignStyleFilterFragment
    >
    designFeatures: Array<
        {
            __typename: 'CatalogueFilterJewelleryDesignFeatureLabel'
        } & CatalogueFilterJewelleryDesignFeatureLabelFragment
    >
    gemstones: Array<
        {
            __typename: 'CatalogueFilterJewelleryGemstoneLabel'
        } & CatalogueFilterJewelleryGemstoneLabelFragment
    >
}

export type JewelleryNecklaceFiltersFragment = {
    __typename: 'CatalogueJewelleryNecklacesFilters'
} & {
    price: {
        __typename: 'CataloguePriceRangeFilter'
    } & FilterPriceRangeFragment
    primaryMetals: Array<
        { __typename: 'CatalogueFilterMetalItem' } & MetalFilterFragment
    >
    productStyles: Array<
        {
            __typename: 'CatalogueFilterJewelleryNecklaceProductStyleLabel'
        } & Pick<
            CatalogueFilterJewelleryNecklaceProductStyleLabel,
            'totalResults'
        > & {
                label: {
                    __typename: 'JewelleryNecklaceProductStyleLabel'
                } & JewelleryNecklaceProductStyleLabelFragment
            }
    >
    designStyles: Array<
        {
            __typename: 'CatalogueFilterJewelleryDesignStyleLabel'
        } & JewelleryDesignStyleFilterFragment
    >
    designFeatures: Array<
        {
            __typename: 'CatalogueFilterJewelleryDesignFeatureLabel'
        } & CatalogueFilterJewelleryDesignFeatureLabelFragment
    >
    gemstones: Array<
        {
            __typename: 'CatalogueFilterJewelleryGemstoneLabel'
        } & CatalogueFilterJewelleryGemstoneLabelFragment
    >
}

export type JewelleryBraceletFiltersFragment = {
    __typename: 'CatalogueJewelleryBraceletsFilters'
} & {
    price: {
        __typename: 'CataloguePriceRangeFilter'
    } & FilterPriceRangeFragment
    primaryMetals: Array<
        { __typename: 'CatalogueFilterMetalItem' } & MetalFilterFragment
    >
    productStyles: Array<
        {
            __typename: 'CatalogueFilterJewelleryBraceletProductStyleLabel'
        } & Pick<
            CatalogueFilterJewelleryBraceletProductStyleLabel,
            'totalResults'
        > & {
                label: {
                    __typename: 'JewelleryBraceletProductStyleLabel'
                } & JewelleryBraceletProductStyleLabelFragment
            }
    >
    designStyles: Array<
        {
            __typename: 'CatalogueFilterJewelleryDesignStyleLabel'
        } & JewelleryDesignStyleFilterFragment
    >
    designFeatures: Array<
        {
            __typename: 'CatalogueFilterJewelleryDesignFeatureLabel'
        } & CatalogueFilterJewelleryDesignFeatureLabelFragment
    >
    gemstones: Array<
        {
            __typename: 'CatalogueFilterJewelleryGemstoneLabel'
        } & CatalogueFilterJewelleryGemstoneLabelFragment
    >
}

export type JewelleryEarringsFiltersFragment = {
    __typename: 'CatalogueJewelleryEarringsFilters'
} & {
    price: {
        __typename: 'CataloguePriceRangeFilter'
    } & FilterPriceRangeFragment
    primaryMetals: Array<
        { __typename: 'CatalogueFilterMetalItem' } & MetalFilterFragment
    >
    productStyles: Array<
        {
            __typename: 'CatalogueFilterJewelleryEarringsProductStyleLabel'
        } & Pick<
            CatalogueFilterJewelleryEarringsProductStyleLabel,
            'totalResults'
        > & {
                label: {
                    __typename: 'JewelleryEarringsProductStyleLabel'
                } & JewelleryEarringsProductStyleLabelFragment
            }
    >
    designStyles: Array<
        {
            __typename: 'CatalogueFilterJewelleryDesignStyleLabel'
        } & JewelleryDesignStyleFilterFragment
    >
    designFeatures: Array<
        {
            __typename: 'CatalogueFilterJewelleryDesignFeatureLabel'
        } & CatalogueFilterJewelleryDesignFeatureLabelFragment
    >
    gemstones: Array<
        {
            __typename: 'CatalogueFilterJewelleryGemstoneLabel'
        } & CatalogueFilterJewelleryGemstoneLabelFragment
    >
}

export type JewelleryRingsFiltersFragment = {
    __typename: 'CatalogueJewelleryRingsFilters'
} & {
    price: {
        __typename: 'CataloguePriceRangeFilter'
    } & FilterPriceRangeFragment
    primaryMetals: Array<
        { __typename: 'CatalogueFilterMetalItem' } & MetalFilterFragment
    >
    productStyles: Array<
        { __typename: 'CatalogueFilterJewelleryRingProductStyleLabel' } & Pick<
            CatalogueFilterJewelleryRingProductStyleLabel,
            'totalResults'
        > & {
                label: {
                    __typename: 'JewelleryRingProductStyleLabel'
                } & JewelleryRingProductStyleLabelFragment
            }
    >
    designStyles: Array<
        {
            __typename: 'CatalogueFilterJewelleryDesignStyleLabel'
        } & JewelleryDesignStyleFilterFragment
    >
    designFeatures: Array<
        {
            __typename: 'CatalogueFilterJewelleryDesignFeatureLabel'
        } & CatalogueFilterJewelleryDesignFeatureLabelFragment
    >
    gemstones: Array<
        {
            __typename: 'CatalogueFilterJewelleryGemstoneLabel'
        } & CatalogueFilterJewelleryGemstoneLabelFragment
    >
}

export type JewelleryDesignStyleFilterFragment = {
    __typename: 'CatalogueFilterJewelleryDesignStyleLabel'
} & Pick<CatalogueFilterJewelleryDesignStyleLabel, 'totalResults'> & {
        label: {
            __typename: 'JewelleryDesignStyleLabel'
        } & JewelleryDesignStyleLabelFragment
    }

export type JewelleryDesignStyleLabelFragment = {
    __typename: 'JewelleryDesignStyleLabel'
} & Pick<JewelleryDesignStyleLabel, 'systemCode'> & {
        translation: { __typename: 'ProductLabelTranslation' } & Pick<
            ProductLabelTranslation,
            'name'
        > &
            FacetedContentProductLabelTranslationFragment
        icon: Maybe<{ __typename: 'Asset' } & AssetFragment>
    }

export type JewelleryNecklaceProductStyleLabelFragment = {
    __typename: 'JewelleryNecklaceProductStyleLabel'
} & Pick<JewelleryNecklaceProductStyleLabel, 'systemCode'> & {
        translation: { __typename: 'ProductLabelTranslation' } & Pick<
            ProductLabelTranslation,
            'name'
        > &
            FacetedContentProductLabelTranslationFragment
        icon: Maybe<{ __typename: 'Asset' } & AssetFragment>
    }

export type JewelleryBraceletProductStyleLabelFragment = {
    __typename: 'JewelleryBraceletProductStyleLabel'
} & Pick<JewelleryBraceletProductStyleLabel, 'systemCode'> & {
        translation: { __typename: 'ProductLabelTranslation' } & Pick<
            ProductLabelTranslation,
            'name'
        > &
            FacetedContentProductLabelTranslationFragment
        icon: Maybe<{ __typename: 'Asset' } & AssetFragment>
    }

export type JewelleryEarringsProductStyleLabelFragment = {
    __typename: 'JewelleryEarringsProductStyleLabel'
} & Pick<JewelleryEarringsProductStyleLabel, 'systemCode'> & {
        translation: { __typename: 'ProductLabelTranslation' } & Pick<
            ProductLabelTranslation,
            'name'
        > &
            FacetedContentProductLabelTranslationFragment
        icon: Maybe<{ __typename: 'Asset' } & AssetFragment>
    }

export type JewelleryRingProductStyleLabelFragment = {
    __typename: 'JewelleryRingProductStyleLabel'
} & Pick<JewelleryRingProductStyleLabel, 'systemCode'> & {
        translation: { __typename: 'ProductLabelTranslation' } & Pick<
            ProductLabelTranslation,
            'name'
        > &
            FacetedContentProductLabelTranslationFragment
        icon: Maybe<{ __typename: 'Asset' } & AssetFragment>
    }

export type CatalogueFilterJewelleryDesignFeatureLabelFragment = {
    __typename: 'CatalogueFilterJewelleryDesignFeatureLabel'
} & Pick<CatalogueFilterJewelleryDesignFeatureLabel, 'totalResults'> & {
        label: {
            __typename: 'JewelleryDesignFeatureLabel'
        } & JewelleryDesignFeatureLabelFragment
    }

export type JewelleryDesignFeatureLabelFragment = {
    __typename: 'JewelleryDesignFeatureLabel'
} & Pick<JewelleryDesignFeatureLabel, 'systemCode'> & {
        translation: { __typename: 'ProductLabelTranslation' } & Pick<
            ProductLabelTranslation,
            'name'
        > &
            FacetedContentProductLabelTranslationFragment
        icon: Maybe<{ __typename: 'Asset' } & AssetFragment>
    }

export type CatalogueFilterJewelleryGemstoneLabelFragment = {
    __typename: 'CatalogueFilterJewelleryGemstoneLabel'
} & Pick<CatalogueFilterJewelleryGemstoneLabel, 'totalResults'> & {
        label: {
            __typename: 'JewelleryGemstoneLabel'
        } & JewelleryGemstoneLabelFragment
    }

export type JewelleryGemstoneLabelFragment = {
    __typename: 'JewelleryGemstoneLabel'
} & Pick<JewelleryGemstoneLabel, 'systemCode'> & {
        translation: { __typename: 'ProductLabelTranslation' } & Pick<
            ProductLabelTranslation,
            'name'
        > &
            FacetedContentProductLabelTranslationFragment
        icon: Maybe<{ __typename: 'Asset' } & AssetFragment>
    }

export type JewelleryDetailsQueryVariables = Exact<{
    slug: Scalars['String']['input']
    metal: MetalCode
    suffixSlug: InputMaybe<Scalars['String']['input']>
    locale: Scalars['Locale']['input']
    region: RegionCode
    currency: CurrencyInput
    page: Scalars['String']['input']
    pageFallback: Scalars['String']['input']
    type: CatalogueJewelleryType
}>

export type JewelleryDetailsQuery = { __typename: 'Query' } & {
    catalogueJewellery: Maybe<
        | ({ __typename: 'CatalogueJewelleryBracelet' } & {
              financeOptionsAffirm: Maybe<
                  {
                      __typename: 'AffirmFinanceOption'
                  } & AffirmFinanceOptionsFragment
              >
              financeOptionsKlarna: Maybe<
                  {
                      __typename: 'KlarnaFinanceOption'
                  } & KlarnaFinanceOptionsFragment
              >
              reviews: Array<{ __typename: 'Review' } & ReviewsFragment>
          } & Jewellery_CatalogueJewelleryBracelet_Fragment &
              JewelleryLink_CatalogueJewelleryBracelet_Fragment &
              ShopWithConfidenceProduct_CatalogueJewelleryBracelet_Fragment)
        | ({ __typename: 'CatalogueJewelleryEarrings' } & {
              financeOptionsAffirm: Maybe<
                  {
                      __typename: 'AffirmFinanceOption'
                  } & AffirmFinanceOptionsFragment
              >
              financeOptionsKlarna: Maybe<
                  {
                      __typename: 'KlarnaFinanceOption'
                  } & KlarnaFinanceOptionsFragment
              >
              reviews: Array<{ __typename: 'Review' } & ReviewsFragment>
          } & Jewellery_CatalogueJewelleryEarrings_Fragment &
              JewelleryLink_CatalogueJewelleryEarrings_Fragment &
              ShopWithConfidenceProduct_CatalogueJewelleryEarrings_Fragment)
        | ({ __typename: 'CatalogueJewelleryNecklace' } & {
              financeOptionsAffirm: Maybe<
                  {
                      __typename: 'AffirmFinanceOption'
                  } & AffirmFinanceOptionsFragment
              >
              financeOptionsKlarna: Maybe<
                  {
                      __typename: 'KlarnaFinanceOption'
                  } & KlarnaFinanceOptionsFragment
              >
              reviews: Array<{ __typename: 'Review' } & ReviewsFragment>
          } & Jewellery_CatalogueJewelleryNecklace_Fragment &
              JewelleryLink_CatalogueJewelleryNecklace_Fragment &
              ShopWithConfidenceProduct_CatalogueJewelleryNecklace_Fragment)
        | ({ __typename: 'CatalogueJewelleryRing' } & {
              financeOptionsAffirm: Maybe<
                  {
                      __typename: 'AffirmFinanceOption'
                  } & AffirmFinanceOptionsFragment
              >
              financeOptionsKlarna: Maybe<
                  {
                      __typename: 'KlarnaFinanceOption'
                  } & KlarnaFinanceOptionsFragment
              >
              reviews: Array<{ __typename: 'Review' } & ReviewsFragment>
          } & Jewellery_CatalogueJewelleryRing_Fragment &
              JewelleryLink_CatalogueJewelleryRing_Fragment &
              ShopWithConfidenceProduct_CatalogueJewelleryRing_Fragment)
    >
    pageProductDetails: Maybe<
        { __typename: 'ProductPageDetails' } & Pick<
            ProductPageDetails,
            'id'
        > & {
                blocks: Array<{ __typename: 'Block' } & BlockFragment>
                meta: { __typename: 'Meta' } & MetaFragment
                priceExplainedTooltip: Maybe<
                    { __typename: 'PageTooltip' } & PageTooltipFragment
                >
            }
    >
}

export type ReadyToGoRingFragment = {
    __typename: 'CatalogueReadyToGoRing'
} & Pick<
    CatalogueReadyToGoRing,
    'carat' | 'gemType' | 'sku' | 'isReadyToShip'
> & {
        salePrice: { __typename: 'SalePrice' } & TaxSnippetFragment
        sizes: Array<
            { __typename: 'RecommendedRingSize' } & RecommendedRingSizeFragment
        >
        variations: Array<
            {
                __typename: 'CatalogueReadyToGoRing'
            } & ReadyToGoRingVariationsFragment
        >
        translation: {
            __typename: 'CatalogueReadyToGoRingTranslation'
        } & CatalogueReadyToGoRingTranslationFragment
        reviews: Array<{ __typename: 'Review' } & ReviewsFragment>
    } & CatalogueProduct_CatalogueReadyToGoRing_Fragment &
    ProductGallery_CatalogueReadyToGoRing_Fragment &
    ReadyToGoRingLinkFragment &
    ProductPageMeta_CatalogueReadyToGoRing_Fragment

export type GetReadyToGoRingQueryVariables = Exact<{
    slug: Scalars['String']['input']
    metal: MetalCode
    currency: CurrencyInput
    region: RegionCode
    locale: Scalars['Locale']['input']
    page: Scalars['String']['input']
    pageFallback: Scalars['String']['input']
}>

export type GetReadyToGoRingQuery = { __typename: 'Query' } & {
    catalogueReadyToGoRing: Maybe<
        { __typename: 'CatalogueReadyToGoRing' } & {
            firstAvailableDeliveryDate: {
                __typename: 'DeliveryDate'
            } & DeliveryTimeframeFragment
            financeOptionsAffirm: Maybe<
                {
                    __typename: 'AffirmFinanceOption'
                } & AffirmFinanceOptionsFragment
            >
            financeOptionsKlarna: Maybe<
                {
                    __typename: 'KlarnaFinanceOption'
                } & KlarnaFinanceOptionsFragment
            >
            reviews: Array<{ __typename: 'Review' } & ReviewsFragment>
        } & ReadyToGoRingFragment &
            ShopWithConfidenceProduct_CatalogueReadyToGoRing_Fragment &
            ProductAnalytics_CatalogueReadyToGoRing_Fragment
    >
    pageProductDetails: Maybe<
        { __typename: 'ProductPageDetails' } & Pick<
            ProductPageDetails,
            'id'
        > & {
                blocks: Array<{ __typename: 'Block' } & BlockFragment>
                meta: { __typename: 'Meta' } & MetaFragment
            }
    >
}

export type ReadyToGoRingBrowseQueryVariables = Exact<{
    currency: CurrencyInput
    region: RegionCode
    filter: CatalogueReadyToGoRingsFilterInput
    page: Scalars['Int']['input']
    limit: Scalars['Int']['input']
    locale: Scalars['Locale']['input']
    path: Scalars['String']['input']
    sortBy: CatalogueSortOrder
}>

export type ReadyToGoRingBrowseQuery = { __typename: 'Query' } & {
    catalogueReadyToGoRingsFilters: {
        __typename: 'CatalogueReadyToGoRingFilters'
    } & ReadyToGoRingFiltersFragment
    catalogueReadyToGoRingsAggregate: {
        __typename: 'CatalogueAggregate'
    } & Pick<CatalogueAggregate, 'count'>
    catalogueReadyToGoRings: Array<
        {
            __typename: 'CatalogueReadyToGoRing'
        } & ProductGrid_CatalogueReadyToGoRing_Fragment
    >
    pageProductListing: Maybe<
        { __typename: 'ProductPageListing' } & ProductPageListingFragment
    >
}

export type WeddingRingFragment = { __typename: 'CatalogueWeddingRing' } & Pick<
    CatalogueWeddingRing,
    'bandWidth' | 'bandThickness'
> & {
        video: Maybe<{ __typename: 'CatalogueVideo' } & CatalogueVideoFragment>
        meleeItems: Array<{ __typename: 'CatalogueMelee' } & MeleeFragment>
        categories: Array<
            { __typename: 'WeddingRingCategoryLabel' } & Pick<
                WeddingRingCategoryLabel,
                'systemCode'
            > & {
                    translation: {
                        __typename: 'ProductLabelTranslation'
                    } & Pick<ProductLabelTranslation, 'name'>
                }
        >
        ringStyles: Array<
            { __typename: 'WeddingRingStyleLabel' } & Pick<
                WeddingRingStyleLabel,
                'systemCode'
            > & {
                    translation: {
                        __typename: 'ProductLabelTranslation'
                    } & Pick<ProductLabelTranslation, 'name'>
                }
        >
        variations: Array<
            { __typename: 'CatalogueWeddingRing' } & Pick<
                CatalogueWeddingRing,
                'catalogueCode' | 'suffix' | 'productName'
            > & {
                    primaryMetal: {
                        __typename: 'Metal'
                    } & MetalFilterMetalFragment
                } & WeddingRingLinkFragment
        >
        translation: { __typename: 'CatalogueWeddingRingTranslation' } & Pick<
            CatalogueWeddingRingTranslation,
            'seoText' | 'description'
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        } & TaxSnippetFragment
        sizes: Array<
            | ({
                  __typename: 'RecommendedRingSize'
              } & RecommendedRingSizeFragment)
            | ({ __typename: 'RingSize' } & RingSizeFragment)
        >
    } & CatalogueProduct_CatalogueWeddingRing_Fragment &
    ProductGallery_CatalogueWeddingRing_Fragment &
    ProductPageMeta_CatalogueWeddingRing_Fragment &
    WeddingRingLinkFragment

export type GetWeddingRingQueryVariables = Exact<{
    slug: Scalars['String']['input']
    metal: MetalCode
    suffixSlug: InputMaybe<Scalars['String']['input']>
    locale: Scalars['Locale']['input']
    currency: CurrencyInput
    region: RegionCode
    page: Scalars['String']['input']
    pageFallback: Scalars['String']['input']
}>

export type GetWeddingRingQuery = { __typename: 'Query' } & {
    catalogueWeddingRing: Maybe<
        { __typename: 'CatalogueWeddingRing' } & {
            firstAvailableDeliveryDateWithoutEngraving: {
                __typename: 'DeliveryDate'
            } & DeliveryTimeframeFragment
            firstAvailableDeliveryDateWithEngraving: {
                __typename: 'DeliveryDate'
            } & DeliveryTimeframeFragment
            financeOptionsAffirm: Maybe<
                {
                    __typename: 'AffirmFinanceOption'
                } & AffirmFinanceOptionsFragment
            >
            financeOptionsKlarna: Maybe<
                {
                    __typename: 'KlarnaFinanceOption'
                } & KlarnaFinanceOptionsFragment
            >
            reviews: Array<{ __typename: 'Review' } & ReviewsFragment>
        } & WeddingRingFragment &
            ShopWithConfidenceProduct_CatalogueWeddingRing_Fragment &
            ProductAnalytics_CatalogueWeddingRing_Fragment
    >
    pageProductDetails: Maybe<
        { __typename: 'ProductPageDetails' } & Pick<
            ProductPageDetails,
            'id'
        > & {
                blocks: Array<{ __typename: 'Block' } & BlockFragment>
                meta: { __typename: 'Meta' } & MetaFragment
                priceExplainedTooltip: Maybe<
                    { __typename: 'PageTooltip' } & PageTooltipFragment
                >
            }
    >
}

export type WeddingRingBrowseQueryVariables = Exact<{
    currency: CurrencyInput
    region: RegionCode
    filter: CatalogueWeddingRingFilterInput
    page: Scalars['Int']['input']
    locale: Scalars['Locale']['input']
    limit: Scalars['Int']['input']
    path: Scalars['String']['input']
    facetedContentInput: ProductPageFacetedContentInput
    sortBy: CatalogueSortOrder
}>

export type WeddingRingBrowseQuery = { __typename: 'Query' } & {
    catalogueWeddingRingFilters: {
        __typename: 'CatalogueWeddingRingFilters'
    } & WeddingRingFiltersFragment
    catalogueWeddingRingsAggregate: { __typename: 'CatalogueAggregate' } & Pick<
        CatalogueAggregate,
        'count'
    >
    catalogueWeddingRings: Array<
        {
            __typename: 'CatalogueWeddingRing'
        } & ProductGrid_CatalogueWeddingRing_Fragment
    >
    pageProductListingFacetedContent: Maybe<
        {
            __typename: 'ProductPageFacetedContent'
        } & ProductPageFacetedContentFragment
    >
    pageProductListing: Maybe<
        { __typename: 'ProductPageListing' } & ProductPageListingFragment
    >
}

export type MyOrdersQueryVariables = Exact<{
    locale: Scalars['Locale']['input']
}>

export type MyOrdersQuery = { __typename: 'Query' } & {
    me: Maybe<
        { __typename: 'User' } & Pick<User, 'id'> & {
                customer: Maybe<
                    { __typename: 'Customer' } & Pick<Customer, 'id'> & {
                            orders: Array<
                                {
                                    __typename: 'Order'
                                } & OrderListViewFragment &
                                    OrderDetailedViewFragment &
                                    LinkOrderFragment
                            >
                        }
                >
            }
    >
}

export type OrderListViewFragment = { __typename: 'Order' } & Pick<
    Order,
    'id' | 'placementDate'
> & {
        totalAmount: { __typename: 'Money' } & MoneyFragment
        status: { __typename: 'OrderStatus' } & Pick<OrderStatus, 'name'>
    }

export type OrderDetailedViewFragment = { __typename: 'Order' } & Pick<
    Order,
    'isPayable'
> & {
        products: Array<
            { __typename: 'OrderProduct' } & Pick<
                OrderProduct,
                'id' | 'name'
            > & {
                    designStudioProduct: Maybe<
                        | ({
                              __typename: 'DesignStudioProductAdditionalResize'
                          } & Pick<
                              DesignStudioProductAdditionalResize,
                              'name'
                          > &
                              LinkDesignStudioProduct_DesignStudioProductAdditionalResize_Fragment)
                        | ({ __typename: 'DesignStudioProductCustom' } & Pick<
                              DesignStudioProductCustom,
                              'name'
                          > &
                              LinkDesignStudioProduct_DesignStudioProductCustom_Fragment)
                        | ({
                              __typename: 'DesignStudioProductEngagementRing'
                          } & Pick<DesignStudioProductEngagementRing, 'name'> &
                              LinkDesignStudioProduct_DesignStudioProductEngagementRing_Fragment)
                        | ({ __typename: 'DesignStudioProductGeneric' } & Pick<
                              DesignStudioProductGeneric,
                              'name'
                          > &
                              LinkDesignStudioProduct_DesignStudioProductGeneric_Fragment)
                        | ({
                              __typename: 'DesignStudioProductLooseStone'
                          } & Pick<DesignStudioProductLooseStone, 'name'> &
                              LinkDesignStudioProduct_DesignStudioProductLooseStone_Fragment)
                        | ({
                              __typename: 'DesignStudioProductWeddingRing'
                          } & Pick<DesignStudioProductWeddingRing, 'name'> &
                              LinkDesignStudioProduct_DesignStudioProductWeddingRing_Fragment)
                    >
                }
        >
        paidAmount: { __typename: 'Money' } & MoneyFragment
        remainingAmount: { __typename: 'Money' } & MoneyFragment
        paymentPlan: { __typename: 'PaymentPlan' } & {
            paid: Array<
                { __typename: 'PaymentPlanPaidRecord' } & {
                    amount: { __typename: 'Money' } & MoneyFragment
                }
            >
            upcoming: Array<
                { __typename: 'PaymentPlanUpcomingRecord' } & {
                    amount: { __typename: 'Money' } & MoneyFragment
                }
            >
            current: Maybe<
                { __typename: 'PaymentPlanUpcomingRecord' } & {
                    amount: { __typename: 'Money' } & MoneyFragment
                }
            >
        }
        prediscountTotalAmount: { __typename: 'Money' } & MoneyFragment
        totalAmount: { __typename: 'Money' } & MoneyFragment
        promoCode: Maybe<{ __typename: 'PromoCode' } & Pick<PromoCode, 'id'>>
        shippingAddress: { __typename: 'OrderAddress' } & Pick<
            OrderAddress,
            | 'id'
            | 'firstName'
            | 'lastName'
            | 'addressLine1'
            | 'addressLine2'
            | 'city'
            | 'postalCode'
            | 'country'
        > & {
                phoneNumber: Maybe<
                    { __typename: 'PhoneNumberType' } & Pick<
                        PhoneNumberType,
                        'formatted'
                    >
                >
            }
        shipmentTrackingInformation: Maybe<
            { __typename: 'ShipmentTrackingInformation' } & Pick<
                ShipmentTrackingInformation,
                'dispatchedAt' | 'shippingCompany' | 'trackingNumber'
            >
        >
        transactions: Array<
            | ({ __typename: 'AffirmTransaction' } & Pick<
                  AffirmTransaction,
                  'id' | 'createdAt'
              > & {
                      status: { __typename: 'TransactionStatus' } & Pick<
                          TransactionStatus,
                          'systemCode' | 'name'
                      >
                      amount: { __typename: 'Money' } & MoneyFragment
                  })
            | ({ __typename: 'AllocationTransaction' } & Pick<
                  AllocationTransaction,
                  'id' | 'createdAt'
              > & {
                      status: { __typename: 'TransactionStatus' } & Pick<
                          TransactionStatus,
                          'systemCode' | 'name'
                      >
                      amount: { __typename: 'Money' } & MoneyFragment
                  })
            | ({ __typename: 'BankTransaction' } & Pick<
                  BankTransaction,
                  'id' | 'createdAt'
              > & {
                      status: { __typename: 'TransactionStatus' } & Pick<
                          TransactionStatus,
                          'systemCode' | 'name'
                      >
                      amount: { __typename: 'Money' } & MoneyFragment
                  })
            | ({ __typename: 'CheckoutcomTransaction' } & Pick<
                  CheckoutcomTransaction,
                  'id' | 'createdAt'
              > & {
                      status: { __typename: 'TransactionStatus' } & Pick<
                          TransactionStatus,
                          'systemCode' | 'name'
                      >
                      amount: { __typename: 'Money' } & MoneyFragment
                  })
            | ({ __typename: 'KlarnaTransaction' } & Pick<
                  KlarnaTransaction,
                  'id' | 'createdAt'
              > & {
                      status: { __typename: 'TransactionStatus' } & Pick<
                          TransactionStatus,
                          'systemCode' | 'name'
                      >
                      amount: { __typename: 'Money' } & MoneyFragment
                  })
            | ({ __typename: 'LegacyTransaction' } & Pick<
                  LegacyTransaction,
                  'paymentMethodName' | 'id' | 'createdAt'
              > & {
                      status: { __typename: 'TransactionStatus' } & Pick<
                          TransactionStatus,
                          'systemCode' | 'name'
                      >
                      amount: { __typename: 'Money' } & MoneyFragment
                  })
            | ({ __typename: 'StripeTransaction' } & Pick<
                  StripeTransaction,
                  'id' | 'createdAt'
              > & {
                      status: { __typename: 'TransactionStatus' } & Pick<
                          TransactionStatus,
                          'systemCode' | 'name'
                      >
                      amount: { __typename: 'Money' } & MoneyFragment
                  })
        >
    } & OrderListViewFragment

export type RedirectDiamondSearchStoneByLabAndNumberQueryVariables = Exact<{
    number: Scalars['String']['input']
}>

export type RedirectDiamondSearchStoneByLabAndNumberQuery = {
    __typename: 'Query'
} & {
    GemsApi_getGiaStone: Maybe<
        { __typename: 'GemsApi_Stone' } & Pick<GemsApi_Stone, 'identifier'>
    >
}

export type GemstoneSearchQueryVariables = Exact<{
    filters: NonSkuGemstoneFilters
    sort: NonSkuGemstoneSortInput
    currency: CurrencyInput
    region: RegionCode
    locale: Scalars['Locale']['input']
    contentPath: Scalars['String']['input']
}>

export type GemstoneSearchQuery = { __typename: 'Query' } & {
    nonSkuGemStones: Array<
        { __typename: 'NonSkuGemstone' } & NonSkuGemstoneFragment
    >
    nonSkuGemStonesBounds: {
        __typename: 'NonSkuGemstonesBounds'
    } & NonSkuGemstoneBoundsFragment
    pageProductListing: Maybe<
        { __typename: 'ProductPageListing' } & ProductPageListingFragment
    >
}

export type LabGrownSearchQueryVariables = Exact<{
    filters: NonSkuLabGrownDiamondsFilters
    sort: NonSkuLabGrownDiamondSortInput
    currency: CurrencyInput
    region: RegionCode
    locale: Scalars['Locale']['input']
    contentPath: Scalars['String']['input']
}>

export type LabGrownSearchQuery = { __typename: 'Query' } & {
    nonSkuLabGrownDiamonds: Array<
        { __typename: 'NonSkuLabGrown' } & NonSkuLabGrownFragment
    >
    nonSkuLabGrownDiamondsBounds: {
        __typename: 'NonSkuLabGrownDiamondsBounds'
    } & NonSkuLabGrownDiamondBoundsFragment
    pageProductListing: Maybe<
        { __typename: 'ProductPageListing' } & ProductPageListingFragment
    >
}

export const ShopWithConfidenceProductFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'shopWithConfidenceProduct' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'CatalogueProduct' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'isReturnable' },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueEngagementRing',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'isResizeable',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'signatureStone',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': '__typename',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueWeddingRing',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'isResizeable',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'signatureStone',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': '__typename',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryRing',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'isResizeable',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'signatureStone',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': '__typename',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryBracelet',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'signatureStone',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': '__typename',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryEarrings',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'signatureStone',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': '__typename',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryNecklace',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'signatureStone',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': '__typename',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueReadyToGoRing',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'signatureStone',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': '__typename',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const BlockAnchorFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'blockAnchor' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'BlockAnchor' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'title' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'slug' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ImageCommonFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'imageCommon' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Image' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'alt' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ImageSizeFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'imageSize' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ImageSize' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'url' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'sources' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'url' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'mimeType',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ImageMediumFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'imageMedium' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Image' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'imageCommon' },
                    },
                    {
                        'kind': 'Field',
                        'alias': { 'kind': 'Name', 'value': 'size' },
                        'name': { 'kind': 'Name', 'value': 'size' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'name' },
                                'value': {
                                    'kind': 'EnumValue',
                                    'value': 'MEDIUM',
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageSize',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'alias': { 'kind': 'Name', 'value': 'size_x2' },
                        'name': { 'kind': 'Name', 'value': 'size' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'name' },
                                'value': {
                                    'kind': 'EnumValue',
                                    'value': 'MEDIUM_X2',
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageSize',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentRoundedImageFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentRoundedImage' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentRoundedImage' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'backgroundColor' },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'backgroundImageColor',
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'backgroundImage' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageMedium',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'roundedImage' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageMedium',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentTitleAmpersandFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentTitleAmpersand' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentTitleAmpersand' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'null' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentTitleTextFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentTitleText' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentTitleText' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'text' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentTitleComponentFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentTitleComponent' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentTitleComponent' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'ComponentTitleAmpersand',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'componentTitleAmpersand',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'ComponentTitleText',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'componentTitleText',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentTitleFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentTitle' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentTitle' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'alignment' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'tag' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'text' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'texts' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'componentTitleComponent',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'color' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'titleSize' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'titleStyle' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'titleWidth' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentTextFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentText' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentText' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'alignment' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'text' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'textSize' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const PageLinkFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'pageLink' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Page' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'path' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const PostLinkFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'postLink' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Post' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'slug' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const CustomLinkFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'customLink' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'LinkItemCustom' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'url' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const LinkQuestionnaireFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'linkQuestionnaire' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Questionnaire' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const LinkItemOpenEnquiryFormFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'linkItemOpenEnquiryForm' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'LinkItemOpenEnquiryForm' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'enquiryType' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const LinkItemOpenContactFormFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'linkItemOpenContactForm' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'LinkItemOpenContactForm' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const LinkItemOpenSpeakToExpertModalFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'linkItemOpenSpeakToExpertModal',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'LinkItemOpenSpeakToExpertModal',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const LinkItemFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'linkItem' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'LinkItem' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'pageLink' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'postLink' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'customLink' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'linkQuestionnaire',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'linkItemOpenEnquiryForm',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'linkItemOpenContactForm',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'linkItemOpenSpeakToExpertModal',
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const LinkFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'link' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Link' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'text' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'target' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'item' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'linkItem',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentButtonFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentButton' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentButton' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'text' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'link' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': { 'kind': 'Name', 'value': 'link' },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'alignment' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'style' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'type' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'size' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'color',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'width',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'linkSize',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'topSpacing',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'bottomSpacing',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'icon' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'position',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'icon' },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'eventTracking' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'event',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'category',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'action',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'label',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentSpacerFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentSpacer' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentSpacer' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'spacing' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ImageLargeFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'imageLarge' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Image' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'imageCommon' },
                    },
                    {
                        'kind': 'Field',
                        'alias': { 'kind': 'Name', 'value': 'size' },
                        'name': { 'kind': 'Name', 'value': 'size' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'name' },
                                'value': {
                                    'kind': 'EnumValue',
                                    'value': 'LARGE',
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageSize',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'alias': { 'kind': 'Name', 'value': 'size_x2' },
                        'name': { 'kind': 'Name', 'value': 'size' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'name' },
                                'value': {
                                    'kind': 'EnumValue',
                                    'value': 'LARGE_X2',
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageSize',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentImageFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentImage' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentImage' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'image' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageLarge',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const OrderedListItemFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'orderedListItem' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'OrderedListItem' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'title' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'description' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentOrderedListFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentOrderedList' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentOrderedList' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'items' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'orderedListItem',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ContentComponentItemFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'contentComponentItem' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ContentComponentItem' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'componentTitle' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'componentText' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'componentButton' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'componentSpacer' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'componentImage' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'componentOrderedList',
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentRoundedImageContentFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentRoundedImageContent' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'ComponentRoundedImageContent',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'content' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'contentComponentItem',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'roundedImage' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'componentRoundedImage',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentContentFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentContent' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentContent' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'content' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'contentComponentItem',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentCardFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentCard' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentCard' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'alias': { 'kind': 'Name', 'value': 'cardImage' },
                        'name': { 'kind': 'Name', 'value': 'image' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageLarge',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'content' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'contentComponentItem',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'backgroundColor' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentTextOverImageFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentTextOverImage' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentTextOverImage' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'content' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'contentComponentItem',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'image' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageLarge',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const CustomProductCarouselCardFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'customProductCarouselCard' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'CarouselCustomProduct' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'image' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageLarge',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'description' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'link' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': { 'kind': 'Name', 'value': 'link' },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'title' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentCustomProductCarouselFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'componentCustomProductCarousel',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'ComponentCustomProductCarousel',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'products' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'customProductCarouselCard',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const EngagementRingLinkFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'engagementRingLink' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'CatalogueEngagementRing' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'catalogueCode' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'primaryMetal' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'centreStoneConstraints',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'shape',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'systemCode',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'suffixSlug' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'slug' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const JewelleryLinkFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'jewelleryLink' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'CatalogueJewellery' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'slug' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'suffixSlug' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'primaryMetal' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ReadyToGoRingLinkFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'readyToGoRingLink' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'CatalogueReadyToGoRing' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'slug' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'primaryMetal' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const WeddingRingLinkFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'weddingRingLink' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'CatalogueWeddingRing' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'catalogueCode' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'primaryMetal' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'suffixSlug' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'slug' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ProductLinkFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'productLink' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'CatalogueProduct' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'engagementRingLink',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'jewelleryLink' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'readyToGoRingLink',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'weddingRingLink' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const MetalFilterMetalFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'metalFilterMetal' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Metal' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'systemCode' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'translation' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'name' },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'karat' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'color' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'name',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'element' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'name',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const MetalVariationFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'metalVariation' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'CatalogueProduct' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'primaryMetal' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'metalFilterMetal',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const GetIsLabGrownFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'getIsLabGrown' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'CatalogueProduct' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'suffix' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const MoneyFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'money' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Money' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'amount' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'currency' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const MonolithImageSizeFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'monolithImageSize' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'MonolithImageSize' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'url' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'sources' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'url' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'mimeType',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ProductCardFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'productCard' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'CatalogueProduct' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'catalogueCode' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'productName' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'productLink' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'metalVariation' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'getIsLabGrown' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'salePrice' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'currency' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'currency',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'region' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'region',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'total',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'money',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'images' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'limit' },
                                'value': { 'kind': 'IntValue', 'value': '4' },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'url' },
                                },
                                {
                                    'kind': 'Field',
                                    'alias': {
                                        'kind': 'Name',
                                        'value': 'medium',
                                    },
                                    'name': { 'kind': 'Name', 'value': 'size' },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'name',
                                            },
                                            'value': {
                                                'kind': 'EnumValue',
                                                'value': 'MEDIUM',
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'monolithImageSize',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'alias': {
                                        'kind': 'Name',
                                        'value': 'medium_x2',
                                    },
                                    'name': { 'kind': 'Name', 'value': 'size' },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'name',
                                            },
                                            'value': {
                                                'kind': 'EnumValue',
                                                'value': 'MEDIUM_X2',
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'monolithImageSize',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueReadyToGoRing',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'shortName',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'shortDescription',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueWeddingRing',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'seoText',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueEngagementRing',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'centreStoneConstraints',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'shape',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'systemCode',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'seoText',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryBracelet',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryEarrings',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryNecklace',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryRing',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentCatalogueProductCarouselFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'componentCatalogueProductCarousel',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'ComponentCatalogueProductCarousel',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'items' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'catalogueCode',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'product',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'productCard',
                                                },
                                            },
                                            {
                                                'kind': 'InlineFragment',
                                                'typeCondition': {
                                                    'kind': 'NamedType',
                                                    'name': {
                                                        'kind': 'Name',
                                                        'value':
                                                            'CatalogueEngagementRing',
                                                    },
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'variationsByPrimaryMetal',
                                                            },
                                                            'selectionSet': {
                                                                'kind': 'SelectionSet',
                                                                'selections': [
                                                                    {
                                                                        'kind': 'FragmentSpread',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'productCard',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                'kind': 'InlineFragment',
                                                'typeCondition': {
                                                    'kind': 'NamedType',
                                                    'name': {
                                                        'kind': 'Name',
                                                        'value':
                                                            'CatalogueWeddingRing',
                                                    },
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'variations',
                                                            },
                                                            'selectionSet': {
                                                                'kind': 'SelectionSet',
                                                                'selections': [
                                                                    {
                                                                        'kind': 'FragmentSpread',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'productCard',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                'kind': 'InlineFragment',
                                                'typeCondition': {
                                                    'kind': 'NamedType',
                                                    'name': {
                                                        'kind': 'Name',
                                                        'value':
                                                            'CatalogueJewelleryRing',
                                                    },
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'variations',
                                                            },
                                                            'selectionSet': {
                                                                'kind': 'SelectionSet',
                                                                'selections': [
                                                                    {
                                                                        'kind': 'FragmentSpread',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'productCard',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                'kind': 'InlineFragment',
                                                'typeCondition': {
                                                    'kind': 'NamedType',
                                                    'name': {
                                                        'kind': 'Name',
                                                        'value':
                                                            'CatalogueJewelleryBracelet',
                                                    },
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'variations',
                                                            },
                                                            'selectionSet': {
                                                                'kind': 'SelectionSet',
                                                                'selections': [
                                                                    {
                                                                        'kind': 'FragmentSpread',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'productCard',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                'kind': 'InlineFragment',
                                                'typeCondition': {
                                                    'kind': 'NamedType',
                                                    'name': {
                                                        'kind': 'Name',
                                                        'value':
                                                            'CatalogueJewelleryNecklace',
                                                    },
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'variations',
                                                            },
                                                            'selectionSet': {
                                                                'kind': 'SelectionSet',
                                                                'selections': [
                                                                    {
                                                                        'kind': 'FragmentSpread',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'productCard',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                'kind': 'InlineFragment',
                                                'typeCondition': {
                                                    'kind': 'NamedType',
                                                    'name': {
                                                        'kind': 'Name',
                                                        'value':
                                                            'CatalogueJewelleryEarrings',
                                                    },
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'variations',
                                                            },
                                                            'selectionSet': {
                                                                'kind': 'SelectionSet',
                                                                'selections': [
                                                                    {
                                                                        'kind': 'FragmentSpread',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'productCard',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentReviewCarouselFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentReviewCarousel' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentReviewCarousel' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'reviews' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'author',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'date' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'review',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'starsCount',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ImageCoverFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'imageCover' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Image' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'imageCommon' },
                    },
                    {
                        'kind': 'Field',
                        'alias': { 'kind': 'Name', 'value': 'size' },
                        'name': { 'kind': 'Name', 'value': 'size' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'name' },
                                'value': {
                                    'kind': 'EnumValue',
                                    'value': 'COVER',
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageSize',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'alias': { 'kind': 'Name', 'value': 'size_x2' },
                        'name': { 'kind': 'Name', 'value': 'size' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'name' },
                                'value': {
                                    'kind': 'EnumValue',
                                    'value': 'COVER_X2',
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageSize',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentMainCoverFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentMainCover' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentMainCover' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'alias': { 'kind': 'Name', 'value': 'mainCoverImage' },
                        'name': { 'kind': 'Name', 'value': 'backgroundImage' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageCover',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'mobileBackgroundImage',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageLarge',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'content' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'contentComponentItem',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const VideoFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'video' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Video' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'url' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentVideoFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentVideo' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentVideo' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'video' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'video',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'alias': { 'kind': 'Name', 'value': 'videoWidth' },
                        'name': { 'kind': 'Name', 'value': 'width' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentVideoWithContentFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentVideoWithContent' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'ComponentVideoWithContent',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'coverImage' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageLarge',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'content' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'contentComponentItem',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'video' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'video',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'videoPosition' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentInstagramPostsFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentInstagramPosts' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentInstagramPosts' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'preTitle' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'title' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'componentTitle',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'instagramUser' },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'instagramUserLink',
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'posts' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'image',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'imageLarge',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'link' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentLogosFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentLogos' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentLogos' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'logos' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'image',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'imageLarge',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'link' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentLogosCarouselFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentLogosCarousel' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentLogosCarousel' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'logos' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'image',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'imageLarge',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'link' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentTextWithImageFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentTextWithImage' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentTextWithImage' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'image' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageLarge',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'padding' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'imageFormat' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'imagePosition' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'content' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'contentComponentItem',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const GalleryCarouselCardFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'galleryCarouselCard' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'GalleryCarouselCard' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'image' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageLarge',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'link' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': { 'kind': 'Name', 'value': 'link' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentGalleryCarouselFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentGalleryCarousel' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentGalleryCarousel' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'items' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'galleryCarouselCard',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const CardCarouselCardFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'cardCarouselCard' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'CardCarouselCard' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'backgroundColor' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'image' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageLarge',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'title' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'description' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentCardCarouselFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentCardCarousel' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentCardCarousel' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'items' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'cardCarouselCard',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentFullWidthImageFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentFullWidthImage' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentFullWidthImage' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'width' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'image' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageLarge',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'link' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': { 'kind': 'Name', 'value': 'link' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentSideBySideImageFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentSideBySideImage' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentSideBySideImage' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'image' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageLarge',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'caption' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'content' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'contentComponentItem',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'link' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': { 'kind': 'Name', 'value': 'link' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentSideBySideImagesFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentSideBySideImages' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'ComponentSideBySideImages',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'images' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'componentSideBySideImage',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ArticlePreviewFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'articlePreview' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ArticlePreview' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'title' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'subtitle' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'image' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageLarge',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'link' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': { 'kind': 'Name', 'value': 'link' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentArticlePreviewsFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentArticlePreviews' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentArticlePreviews' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'articles' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'articlePreview',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentInstagramWithContentFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'componentInstagramWithContent',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'ComponentInstagramWithContent',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'alias': {
                            'kind': 'Name',
                            'value': 'instagramWithContentWidth',
                        },
                        'name': { 'kind': 'Name', 'value': 'width' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'useImage' },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'instagramEmbedCode',
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'instagramUsername',
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'instagramLink' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'instagramImage' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageLarge',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'instagramPosition',
                        },
                    },
                    {
                        'kind': 'Field',
                        'alias': { 'kind': 'Name', 'value': 'optionalContent' },
                        'name': { 'kind': 'Name', 'value': 'content' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'contentComponentItem',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentBannerTitleFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentBannerTitle' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentBannerTitle' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'image' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageLarge',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'date' },
                    },
                    {
                        'kind': 'Field',
                        'alias': { 'kind': 'Name', 'value': 'bannerTitle' },
                        'name': { 'kind': 'Name', 'value': 'title' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'description' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'tag' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentQuoteFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentQuote' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentQuote' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'hasBackgroundImage',
                        },
                    },
                    {
                        'kind': 'Field',
                        'alias': { 'kind': 'Name', 'value': 'quoteImage' },
                        'name': { 'kind': 'Name', 'value': 'image' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageLarge',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'quote' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'author' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'size' },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'showQuotationMarks',
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentBannerSkinnyFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentBannerSkinny' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentBannerSkinny' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'useBackgroundImage',
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'backgroundImage' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageCover',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'backgroundColor' },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'backgroundGraphic',
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'title' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'componentTitle',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentGlobalSpacerFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentGlobalSpacer' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentGlobalSpacer' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'spacing' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentTextWithImageCarouselFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'componentTextWithImageCarousel',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'ComponentTextWithImageCarousel',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'slidePadding' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'slides' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'componentTextWithImage',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentContentWithGalleryFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentContentWithGallery' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'ComponentContentWithGallery',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'content' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'contentComponentItem',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'gallery' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'InlineFragment',
                                    'typeCondition': {
                                        'kind': 'NamedType',
                                        'name': {
                                            'kind': 'Name',
                                            'value': 'GalleryItem',
                                        },
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'image',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'imageLarge',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentIconCarouselFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentIconCarousel' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentIconCarousel' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'items' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'icon' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'text' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentTextCarouselFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentTextCarousel' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentTextCarousel' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'items' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'title',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'alias': {
                                        'kind': 'Name',
                                        'value': 'carouselItemText',
                                    },
                                    'name': { 'kind': 'Name', 'value': 'text' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const FaqQuestionFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'faqQuestion' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'FaqQuestion' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'question' },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'expandedByDefault',
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'content' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'contentComponentItem',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const FaqSectionFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'faqSection' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'FaqSection' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'title' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'questions' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'faqQuestion',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentFaqFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentFaq' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentFaq' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'showNavigation' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'sections' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'faqSection',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentContentTwoColumnsFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentContentTwoColumns' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'ComponentContentTwoColumns',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'leftColumnBackgroundColor',
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'leftColumnContent',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'contentComponentItem',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'rightColumnBackgroundColor',
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'rightColumnContent',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'contentComponentItem',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentTableFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentTable' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentTable' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'table' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'header',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'cells',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'body' },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'rows',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'cells',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ArticleGridItemFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'articleGridItem' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ArticleGridItem' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'title' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'description' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'image' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageLarge',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'link' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': { 'kind': 'Name', 'value': 'link' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentArticleGridFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentArticleGrid' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentArticleGrid' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'articles' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'articleGridItem',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentOnThisPageFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentOnThisPage' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentOnThisPage' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const GalleryWithEnquiryCardFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'galleryWithEnquiryCard' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'GalleryWithEnquiryCard' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'image' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageLarge',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'caption' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'slug' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentGalleryWithEnquiryFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentGalleryWithEnquiry' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'ComponentGalleryWithEnquiry',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'type' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'items' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'galleryWithEnquiryCard',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const SquareTextBoxFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'squareTextBox' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'SquareTextBox' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'backgroundColor' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'content' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'contentComponentItem',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const SquareImageBoxFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'squareImageBox' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'SquareImageBox' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'image' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageMedium',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'link' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': { 'kind': 'Name', 'value': 'link' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const SquareBoxesFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'squareBoxes' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'SquareBoxes' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'SquareTextBox',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'squareTextBox',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'SquareImageBox',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'squareImageBox',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentSquareBoxesFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentSquareBoxes' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentSquareBoxes' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'items' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'squareBoxes',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentShopWithConfidenceFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentShopWithConfidence' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'ComponentShopWithConfidence',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'alias': {
                            'kind': 'Name',
                            'value': 'shopWithConfidenceTitle',
                        },
                        'name': { 'kind': 'Name', 'value': 'title' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'componentTitle',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'components' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'content',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'contentComponentItem',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'component' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Component' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'componentRoundedImage',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'componentRoundedImageContent',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'componentContent' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'componentCard' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'componentTextOverImage',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'componentRoundedImage',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'componentCustomProductCarousel',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'componentCatalogueProductCarousel',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'componentReviewCarousel',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'componentMainCover',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'componentVideo' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'componentVideoWithContent',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'componentInstagramPosts',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'componentLogos' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'componentLogosCarousel',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'componentTextWithImage',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'componentGalleryCarousel',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'componentCardCarousel',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'componentFullWidthImage',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'componentSideBySideImages',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'componentArticlePreviews',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'componentInstagramWithContent',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'componentBannerTitle',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'componentQuote' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'componentBannerSkinny',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'componentGlobalSpacer',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'componentTextWithImageCarousel',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'componentContentWithGallery',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'componentIconCarousel',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'componentTextCarousel',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'componentFaq' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'componentContentTwoColumns',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'componentTable' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'componentArticleGrid',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'componentOnThisPage',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'componentGalleryWithEnquiry',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'componentSquareBoxes',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'componentShopWithConfidence',
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ComponentGlobalComponentFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'componentGlobalComponent' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ComponentGlobalComponent' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'backgroundColor' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'components' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'component',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const BlockFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'block' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Block' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'width' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'backgroundColor' },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'backgroundOverflow',
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'verticalSpacing' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'display' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'anchor' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'blockAnchor',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'isCollapsible' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'collapsibleTitle' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'isOpenByDefault' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'components' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'component',
                                    },
                                },
                                {
                                    'kind': 'InlineFragment',
                                    'typeCondition': {
                                        'kind': 'NamedType',
                                        'name': {
                                            'kind': 'Name',
                                            'value': 'ComponentGlobalComponent',
                                        },
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'componentGlobalComponent',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const QuestionnaireConditionIsEmptyFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'questionnaireConditionIsEmpty',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'QuestionnaireConditionIsEmpty',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'question' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const QuestionnaireConditionIsEqualToFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'questionnaireConditionIsEqualTo',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'QuestionnaireConditionIsEqualTo',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'question' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'alias': { 'kind': 'Name', 'value': 'valueString' },
                        'name': { 'kind': 'Name', 'value': 'value' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const QuestionnaireConditionIsGreaterThanFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'questionnaireConditionIsGreaterThan',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'QuestionnaireConditionIsGreaterThan',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'question' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'value' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const QuestionnaireConditionIsLessThanFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'questionnaireConditionIsLessThan',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'QuestionnaireConditionIsLessThan',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'question' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'value' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const QuestionnaireConditionIsNotEmptyFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'questionnaireConditionIsNotEmpty',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'QuestionnaireConditionIsNotEmpty',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'question' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const QuestionnaireConditionNotIsEqualToFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'questionnaireConditionNotIsEqualTo',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'QuestionnaireConditionNotIsEqualTo',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'question' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'alias': { 'kind': 'Name', 'value': 'valueString' },
                        'name': { 'kind': 'Name', 'value': 'value' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const QuestionnaireConditionEqualToChoiceFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'questionnaireConditionEqualToChoice',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'QuestionnaireConditionEqualToChoice',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'question' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'choice' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const QuestionnaireConditionFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'questionnaireCondition' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'QuestionnaireCondition' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'type' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'rules' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'questionnaireConditionIsEmpty',
                                    },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'questionnaireConditionIsEqualTo',
                                    },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'questionnaireConditionIsGreaterThan',
                                    },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'questionnaireConditionIsLessThan',
                                    },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'questionnaireConditionIsNotEmpty',
                                    },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'questionnaireConditionNotIsEqualTo',
                                    },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'questionnaireConditionEqualToChoice',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const QuestionnaireStepContentContentFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'questionnaireStepContentContent',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'QuestionnaireStepContentContent',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'blocks' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'block',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'conditions' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'questionnaireCondition',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const QuestionnaireQuestionChoiceOptionContentImageCardConditionalFragmentDoc =
    {
        'kind': 'Document',
        'definitions': [
            {
                'kind': 'FragmentDefinition',
                'name': {
                    'kind': 'Name',
                    'value':
                        'questionnaireQuestionChoiceOptionContentImageCardConditional',
                },
                'typeCondition': {
                    'kind': 'NamedType',
                    'name': {
                        'kind': 'Name',
                        'value':
                            'QuestionnaireQuestionChoiceOptionContentImageCardConditional',
                    },
                },
                'selectionSet': {
                    'kind': 'SelectionSet',
                    'selections': [
                        {
                            'kind': 'Field',
                            'name': { 'kind': 'Name', 'value': 'image' },
                            'selectionSet': {
                                'kind': 'SelectionSet',
                                'selections': [
                                    {
                                        'kind': 'FragmentSpread',
                                        'name': {
                                            'kind': 'Name',
                                            'value': 'imageLarge',
                                        },
                                    },
                                ],
                            },
                        },
                        {
                            'kind': 'Field',
                            'name': { 'kind': 'Name', 'value': 'title' },
                        },
                        {
                            'kind': 'Field',
                            'name': { 'kind': 'Name', 'value': 'description' },
                        },
                        {
                            'kind': 'Field',
                            'name': { 'kind': 'Name', 'value': 'conditions' },
                            'selectionSet': {
                                'kind': 'SelectionSet',
                                'selections': [
                                    {
                                        'kind': 'FragmentSpread',
                                        'name': {
                                            'kind': 'Name',
                                            'value': 'questionnaireCondition',
                                        },
                                    },
                                ],
                            },
                        },
                    ],
                },
            },
        ],
    } as unknown as DocumentNode
export const QuestionnaireQuestionChoiceOptionContentImageCardFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'questionnaireQuestionChoiceOptionContentImageCard',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value':
                        'QuestionnaireQuestionChoiceOptionContentImageCard',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'image' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'url' },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageLarge',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'title' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'description' },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'conditionalContent',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'questionnaireQuestionChoiceOptionContentImageCardConditional',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const QuestionnaireQuestionChoiceOptionContentIconCardConditionalFragmentDoc =
    {
        'kind': 'Document',
        'definitions': [
            {
                'kind': 'FragmentDefinition',
                'name': {
                    'kind': 'Name',
                    'value':
                        'questionnaireQuestionChoiceOptionContentIconCardConditional',
                },
                'typeCondition': {
                    'kind': 'NamedType',
                    'name': {
                        'kind': 'Name',
                        'value':
                            'QuestionnaireQuestionChoiceOptionContentIconCardConditional',
                    },
                },
                'selectionSet': {
                    'kind': 'SelectionSet',
                    'selections': [
                        {
                            'kind': 'Field',
                            'name': { 'kind': 'Name', 'value': 'icon' },
                            'selectionSet': {
                                'kind': 'SelectionSet',
                                'selections': [
                                    {
                                        'kind': 'FragmentSpread',
                                        'name': {
                                            'kind': 'Name',
                                            'value': 'imageLarge',
                                        },
                                    },
                                ],
                            },
                        },
                        {
                            'kind': 'Field',
                            'name': { 'kind': 'Name', 'value': 'title' },
                        },
                        {
                            'kind': 'Field',
                            'name': { 'kind': 'Name', 'value': 'description' },
                        },
                        {
                            'kind': 'Field',
                            'name': { 'kind': 'Name', 'value': 'conditions' },
                            'selectionSet': {
                                'kind': 'SelectionSet',
                                'selections': [
                                    {
                                        'kind': 'FragmentSpread',
                                        'name': {
                                            'kind': 'Name',
                                            'value': 'questionnaireCondition',
                                        },
                                    },
                                ],
                            },
                        },
                    ],
                },
            },
        ],
    } as unknown as DocumentNode
export const QuestionnaireQuestionChoiceOptionContentIconCardFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'questionnaireQuestionChoiceOptionContentIconCard',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'QuestionnaireQuestionChoiceOptionContentIconCard',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'icon' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'url' },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageLarge',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'title' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'description' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'backgroundColor' },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'conditionalContent',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'questionnaireQuestionChoiceOptionContentIconCardConditional',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const QuestionnaireQuestionChoiceOptionContentImageConditionalFragmentDoc =
    {
        'kind': 'Document',
        'definitions': [
            {
                'kind': 'FragmentDefinition',
                'name': {
                    'kind': 'Name',
                    'value':
                        'questionnaireQuestionChoiceOptionContentImageConditional',
                },
                'typeCondition': {
                    'kind': 'NamedType',
                    'name': {
                        'kind': 'Name',
                        'value':
                            'QuestionnaireQuestionChoiceOptionContentImageConditional',
                    },
                },
                'selectionSet': {
                    'kind': 'SelectionSet',
                    'selections': [
                        {
                            'kind': 'Field',
                            'name': { 'kind': 'Name', 'value': 'image' },
                            'selectionSet': {
                                'kind': 'SelectionSet',
                                'selections': [
                                    {
                                        'kind': 'FragmentSpread',
                                        'name': {
                                            'kind': 'Name',
                                            'value': 'imageLarge',
                                        },
                                    },
                                ],
                            },
                        },
                        {
                            'kind': 'Field',
                            'name': { 'kind': 'Name', 'value': 'conditions' },
                            'selectionSet': {
                                'kind': 'SelectionSet',
                                'selections': [
                                    {
                                        'kind': 'FragmentSpread',
                                        'name': {
                                            'kind': 'Name',
                                            'value': 'questionnaireCondition',
                                        },
                                    },
                                ],
                            },
                        },
                    ],
                },
            },
        ],
    } as unknown as DocumentNode
export const QuestionnaireQuestionChoiceOptionContentImageFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'questionnaireQuestionChoiceOptionContentImage',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'QuestionnaireQuestionChoiceOptionContentImage',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'image' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'url' },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageLarge',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'conditionalContent',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'questionnaireQuestionChoiceOptionContentImageConditional',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const QuestionnaireQuestionChoiceOptionContentTextConditionalFragmentDoc =
    {
        'kind': 'Document',
        'definitions': [
            {
                'kind': 'FragmentDefinition',
                'name': {
                    'kind': 'Name',
                    'value':
                        'questionnaireQuestionChoiceOptionContentTextConditional',
                },
                'typeCondition': {
                    'kind': 'NamedType',
                    'name': {
                        'kind': 'Name',
                        'value':
                            'QuestionnaireQuestionChoiceOptionContentTextConditional',
                    },
                },
                'selectionSet': {
                    'kind': 'SelectionSet',
                    'selections': [
                        {
                            'kind': 'Field',
                            'name': { 'kind': 'Name', 'value': 'title' },
                        },
                        {
                            'kind': 'Field',
                            'name': { 'kind': 'Name', 'value': 'description' },
                        },
                        {
                            'kind': 'Field',
                            'name': { 'kind': 'Name', 'value': 'conditions' },
                            'selectionSet': {
                                'kind': 'SelectionSet',
                                'selections': [
                                    {
                                        'kind': 'FragmentSpread',
                                        'name': {
                                            'kind': 'Name',
                                            'value': 'questionnaireCondition',
                                        },
                                    },
                                ],
                            },
                        },
                    ],
                },
            },
        ],
    } as unknown as DocumentNode
export const QuestionnaireQuestionChoiceOptionContentTextFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'questionnaireQuestionChoiceOptionContentText',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'QuestionnaireQuestionChoiceOptionContentText',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'title' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'description' },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'conditionalContent',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'questionnaireQuestionChoiceOptionContentTextConditional',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const QuestionnaireQuestionChoiceOptionContentFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'questionnaireQuestionChoiceOptionContent',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'QuestionnaireQuestionChoiceOptionContent',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value':
                                'questionnaireQuestionChoiceOptionContentImageCard',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value':
                                'questionnaireQuestionChoiceOptionContentIconCard',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value':
                                'questionnaireQuestionChoiceOptionContentImage',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value':
                                'questionnaireQuestionChoiceOptionContentText',
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const QuestionnaireQuestionChoiceOptionBehaviourFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'questionnaireQuestionChoiceOptionBehaviour',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'QuestionnaireQuestionChoiceOptionBehaviour',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'metal' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'ringStyle' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'designStyle' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'designFeature' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'shape' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const QuestionnaireQuestionChoiceOptionFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'questionnaireQuestionChoiceOption',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'QuestionnaireQuestionChoiceOption',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'content' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'questionnaireQuestionChoiceOptionContent',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'behaviour' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'questionnaireQuestionChoiceOptionBehaviour',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const QuestionnaireQuestionChoiceFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'questionnaireQuestionChoice' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'QuestionnaireQuestionChoice',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'title' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'multiple' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'required' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'options' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'questionnaireQuestionChoiceOption',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const QuestionnaireQuestionPriceFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'questionnaireQuestionPrice' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'QuestionnaireQuestionPrice',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'title' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'required' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'tooltip' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'min' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'max' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const QuestionnaireQuestionTextFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'questionnaireQuestionText' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'QuestionnaireQuestionText',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'title' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'required' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'textarea' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const QuestionnaireQuestionFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'questionnaireQuestion' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'QuestionnaireQuestion' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'title' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'required' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'questionnaireQuestionChoice',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'questionnaireQuestionPrice',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'questionnaireQuestionText',
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const QuestionnaireStepContentQuestionsFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'questionnaireStepContentQuestions',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'QuestionnaireStepContentQuestions',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'questions' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'questionnaireQuestion',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'conditions' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'questionnaireCondition',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const QuestionnaireStepFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'questionnaireStep' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'QuestionnaireStep' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'title' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'description' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'content' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'questionnaireStepContentContent',
                                    },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'questionnaireStepContentQuestions',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'conditions' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'questionnaireCondition',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'help' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'block',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'excludeFromProgressIndicator',
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const QuestionnaireSignUpStepFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'questionnaireSignUpStep' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'QuestionnaireSignUpStep' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'title' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'description' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'backgroundColor' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'image' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageLarge',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const QuestionnaireFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'questionnaire' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Questionnaire' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'title' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'type' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'steps' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'questionnaireStep',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'signUpStep' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'questionnaireSignUpStep',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'redirectLink' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'linkItem',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const EnquiryResponseExistingCustomerFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'enquiryResponseExistingCustomer',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'EnquiryResponseExistingCustomer',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'marketingCloudForm',
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const CostumerConsultantFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'costumerConsultant' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Consultant' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'avatarImage' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'url' },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'firstName' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'user' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'email',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const MeFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'me' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'User' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'firstName' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'lastName' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'email' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'isConsultant' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'createdAt' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'customer' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'billingAddress',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'phoneNumber',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'e164',
                                                            },
                                                        },
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'nationalNumber',
                                                            },
                                                        },
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'countryCode',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'consultant',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'costumerConsultant',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'disabledThirdPartyCookies',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'adminProfileUrl',
                                    },
                                    'directives': [
                                        {
                                            'kind': 'Directive',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'include',
                                            },
                                            'arguments': [
                                                {
                                                    'kind': 'Argument',
                                                    'name': {
                                                        'kind': 'Name',
                                                        'value': 'if',
                                                    },
                                                    'value': {
                                                        'kind': 'Variable',
                                                        'name': {
                                                            'kind': 'Name',
                                                            'value':
                                                                'isConsultant',
                                                        },
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'salesforceProfileUrl',
                                    },
                                    'directives': [
                                        {
                                            'kind': 'Directive',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'include',
                                            },
                                            'arguments': [
                                                {
                                                    'kind': 'Argument',
                                                    'name': {
                                                        'kind': 'Name',
                                                        'value': 'if',
                                                    },
                                                    'value': {
                                                        'kind': 'Variable',
                                                        'name': {
                                                            'kind': 'Name',
                                                            'value':
                                                                'isConsultant',
                                                        },
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const LoginResponseSuccessFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'loginResponseSuccess' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'LoginResponseSuccess' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'jwt' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'user' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': { 'kind': 'Name', 'value': 'me' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const CustomerRegistrationResponseFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'customerRegistrationResponse' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'CustomerRegistrationResponse',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'login' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'loginResponseSuccess',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const EnquiryResponseNewCustomerFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'enquiryResponseNewCustomer' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'EnquiryResponseNewCustomer',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'customer' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'customerRegistrationResponse',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const AvatarStackItemFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'avatarStackItem' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'AvatarStackItem' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'image' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageLarge',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const FooterItemTitleFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'footerItemTitle' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'FooterColumnItemTitle' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'title' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const FooterItemLinkListFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'footerItemLinkList' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'FooterColumnItemLinkList' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'links' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'text' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'link' },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'link',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const FooterItemTextFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'footerItemText' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'FooterColumnItemText' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'text' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const FooterItemDividerFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'footerItemDivider' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'FooterColumnItemSeparator',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'line' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const WorkingHoursFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'workingHours' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'WorkingHours' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'weekDays' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'opening' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'closing' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const FooterItemWorkingHoursFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'footerItemWorkingHours' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'FooterColumnItemWorkingHours',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'workingHours' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'workingHours',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const FooterMenuItemFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'footerMenuItem' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'FooterColumnItem' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'footerItemTitle' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'footerItemLinkList',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'footerItemText' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'footerItemDivider',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'footerItemWorkingHours',
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const FooterMenuFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'footerMenu' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'FooterColumn' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'items' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'footerMenuItem',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const FooterFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'footer' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Footer' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'columns' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'footerMenu',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'copyright' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'logos' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'link' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'logo' },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'imageLarge',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const SubMenuItemFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'subMenuItem' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'SubMenuItem' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'title' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'link' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': { 'kind': 'Name', 'value': 'link' },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'media' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageLarge',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'icon' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageLarge',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'style' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const SubMenuSectionFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'subMenuSection' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'SubMenuSection' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'title' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'items' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'subMenuItem',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const SubMenuEditorialContentFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'subMenuEditorialContent' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'SubMenuEditorialContent' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'text' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'link' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': { 'kind': 'Name', 'value': 'link' },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'image' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageLarge',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const SubMenuFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'subMenu' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'SubMenu' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'title' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'description' },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'useLargeFormatItems',
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'sections' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'subMenuSection',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'editorialContent' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'subMenuEditorialContent',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const HeaderMenuFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'headerMenu' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'MenuItem' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'title' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'hideOnMobile' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'hideOnDesktop' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'link' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': { 'kind': 'Name', 'value': 'link' },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'subMenu' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'subMenu',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const PreHeaderFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'preHeader' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'PreHeader' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'link' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': { 'kind': 'Name', 'value': 'link' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const TopBarSiteWideMessageFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'topBarSiteWideMessage' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'TopBarSiteWideMessage' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'message' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'link' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': { 'kind': 'Name', 'value': 'link' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const TopBarConsultationPromptFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'topBarConsultationPrompt' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'TopBarConsultationPrompt' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'link' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': { 'kind': 'Name', 'value': 'link' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const TopBarFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'topBar' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'TopBar' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'siteWideMessage' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'topBarSiteWideMessage',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'consultationPrompt',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'topBarConsultationPrompt',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const TooltipFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'tooltip' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Tooltip' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'title' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'content' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'contentComponentItem',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const PageTooltipFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'pageTooltip' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'PageTooltip' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'triggerText' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'tooltip' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'tooltip',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ProductListAnalyticsFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'productListAnalytics' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'CatalogueProduct' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'catalogueCode' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'segmentName' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'productLink' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'salePrice' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'currency' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'currency',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'region' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'region',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'total',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'currency',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'amount',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'primaryMetal' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'segmentName',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueEngagementRing',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueReadyToGoRing',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueWeddingRing',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewellery',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'alias': {
                                        'kind': 'Name',
                                        'value': 'jewellerySku',
                                    },
                                    'name': { 'kind': 'Name', 'value': 'sku' },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryEarrings',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryNecklace',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryBracelet',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryRing',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ProductGridFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'productGrid' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'CatalogueProduct' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'productCard' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'productListAnalytics',
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueEngagementRing',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'variationsByPrimaryMetal',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'productCard',
                                                },
                                            },
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'productListAnalytics',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueWeddingRing',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'variations',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'productCard',
                                                },
                                            },
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'productListAnalytics',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryRing',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'variations',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'productCard',
                                                },
                                            },
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'productListAnalytics',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryBracelet',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'variations',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'productCard',
                                                },
                                            },
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'productListAnalytics',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryNecklace',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'variations',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'productCard',
                                                },
                                            },
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'productListAnalytics',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryEarrings',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'variations',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'productCard',
                                                },
                                            },
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'productListAnalytics',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const AlternateTagFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'alternateTag' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Region' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'code' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'locales' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const RegionPluginFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'regionPlugin' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Region' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'code' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'isActive' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'currency' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'language' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const LoginResponseFailureFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'loginResponseFailure' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'LoginResponseFailure' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'code' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'message' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const LoginResponseFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'loginResponse' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'LoginResponse' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'LoginResponseSuccess',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'loginResponseSuccess',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'LoginResponseFailure',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'loginResponseFailure',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ShowroomLocationFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'showroomLocation' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ShowroomLocation' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'postalCode' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'city' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'addressLine1' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'addressLine2' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'country' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'subdivision' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'geoLocation' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'latitude',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'longitude',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ShowroomFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'showroom' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Showroom' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'location' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'showroomLocation',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'isAccessible' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'translation' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'name' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const BookingConsultationSlotFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'bookingConsultationSlot' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'BookingConsultationSlot' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'showroom' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'showroom',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'startTime' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const BookingConsultationSlotsResponseFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'bookingConsultationSlotsResponse',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'BookingConsultationSlotsResponse',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'slots' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'bookingConsultationSlot',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const AssetFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'asset' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Asset' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'url' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const BookingConsultationComplexityFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'bookingConsultationComplexity',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'BookingConsultationComplexity',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'systemCode' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'translation' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'name' },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'icon' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'asset',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const BookingConsultationPurposeFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'bookingConsultationPurpose' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'BookingConsultationPurpose',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'systemCode' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'name' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'duration' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'icon' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'asset',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'type' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'name' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const BookingConsultationMethodFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'bookingConsultationMethod' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'BookingConsultationMethod',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'systemCode' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'name' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'icon' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'asset',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const BookingConsultationFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'bookingConsultation' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'BookingConsultation' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'purpose' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'bookingConsultationPurpose',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'method' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'bookingConsultationMethod',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'description' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'showroom' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'showroom',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'startsAt' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'isCancelled' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'canBeCancelled' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const BookingCreateConsultationSuccessExistingCustomerFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'bookingCreateConsultationSuccessExistingCustomer',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'BookingCreateConsultationSuccessExistingCustomer',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'consultation' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'bookingConsultation',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const BookingCreateConsultationErrorNoAvailableConsultantsFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'bookingCreateConsultationErrorNoAvailableConsultants',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value':
                        'BookingCreateConsultationErrorNoAvailableConsultants',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'message' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const BookingCreateConsultationExistingCustomerResponseFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'bookingCreateConsultationExistingCustomerResponse',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value':
                        'BookingCreateConsultationExistingCustomerResponse',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value':
                                    'BookingCreateConsultationSuccessExistingCustomer',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'bookingCreateConsultationSuccessExistingCustomer',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value':
                                    'BookingCreateConsultationErrorNoAvailableConsultants',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'bookingCreateConsultationErrorNoAvailableConsultants',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const BookingCreateConsultationSuccessNewCustomerFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'bookingCreateConsultationSuccessNewCustomer',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'BookingCreateConsultationSuccessNewCustomer',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'customerRegistrationResponse',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'customerRegistrationResponse',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'consultation' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'bookingConsultation',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const BookingCreateConsultationNewCustomerResponseFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'bookingCreateConsultationNewCustomerResponse',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'BookingCreateConsultationNewCustomerResponse',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value':
                                    'BookingCreateConsultationSuccessNewCustomer',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'bookingCreateConsultationSuccessNewCustomer',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value':
                                    'BookingCreateConsultationErrorNoAvailableConsultants',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'bookingCreateConsultationErrorNoAvailableConsultants',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const BookingOrdersFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'bookingOrders' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Order' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const DesignStudioEngagementRingErrorRootShapeMismatchFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'designStudioEngagementRingErrorRootShapeMismatch',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'DesignStudioEngagementRingErrorShapeMismatch',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'message' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const AddToCartReadyToGoRingSuccessNewCustomerFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'addToCartReadyToGoRingSuccessNewCustomer',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'AddToCartReadyToGoRingSuccessNewCustomer',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'customer' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'customerRegistrationResponse',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const AddToCartReadyToGoRingNewCustomerResponseFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'addToCartReadyToGoRingNewCustomerResponse',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'AddToCartReadyToGoRingNewCustomerResponse',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'addToCartReadyToGoRingSuccessNewCustomer',
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const DesignStudioWeddingRingSuccessNewCustomerFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'designStudioWeddingRingSuccessNewCustomer',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value':
                        'CatalogueDesignStudioCheckoutWeddingRingSuccessNewCustomer',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'customer' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'customerRegistrationResponse',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const DesignStudioWeddingRingNewCustomerResponseFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'designStudioWeddingRingNewCustomerResponse',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value':
                        'CatalogueDesignStudioCheckoutWeddingRingNewCustomerResponse',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value':
                                'designStudioWeddingRingSuccessNewCustomer',
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const AddressFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'address' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Address' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'country' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const OrderProductFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'orderProduct' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'OrderProduct' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'image' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'name' },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'prediscountTotalSaleAmount',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'money',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'totalSaleAmount' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'money',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const PaymentPlanPaidRecordFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'paymentPlanPaidRecord' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'PaymentPlanPaidRecord' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'amount' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'money',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'paidOn' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const PaymentPlanUpcomingRecordFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'paymentPlanUpcomingRecord' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'PaymentPlanUpcomingRecord',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'amount' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'money',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const PaymentPlanFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'paymentPlan' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'PaymentPlan' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'paid' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'paymentPlanPaidRecord',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'current' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'paymentPlanUpcomingRecord',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'upcoming' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'paymentPlanUpcomingRecord',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const TransactionStatusFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'transactionStatus' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'TransactionStatus' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'name' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const TransactionInterfaceFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'transactionInterface' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'TransactionInterface' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'LegacyTransaction',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'paymentMethodName',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'createdAt' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'amount' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'money',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'status' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'transactionStatus',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const PromoCodeFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'promoCode' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'PromoCode' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'code' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const NoPaymentMethodFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'noPaymentMethod' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'NoPaymentMethod' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'systemCode' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const BankPaymentMethodFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'bankPaymentMethod' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'BankPaymentMethod' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'systemCode' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const AllocationPaymentMethodFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'allocationPaymentMethod' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'AllocationPaymentMethod' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'systemCode' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'maxAmount' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'money',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const CheckoutcomPaymentMethodFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'checkoutcomPaymentMethod' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'CheckoutcomPaymentMethod' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'systemCode' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'debugMode' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'publicKey' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const AffirmPaymentMethodFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'affirmPaymentMethod' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'AffirmPaymentMethod' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'systemCode' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'publicKey' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'scriptUrl' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const KlarnaPaymentMethodFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'klarnaPaymentMethod' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'KlarnaPaymentMethod' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'systemCode' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const PaymentMethodContainerFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'paymentMethodContainer' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'PaymentMethodContainer' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'noPayment' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'noPaymentMethod',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'bankPayment' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'bankPaymentMethod',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'allocationPayment',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'allocationPaymentMethod',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'checkoutcomPayment',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'checkoutcomPaymentMethod',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'affirmPayment' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'affirmPaymentMethod',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'klarnaPayment' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'klarnaPaymentMethod',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const OrderAddressFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'orderAddress' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'OrderAddress' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'firstName' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'lastName' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'email' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'phoneNumber' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'countryCode',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'nationalNumber',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'e164' },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'addressLine1' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'addressLine2' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'city' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'postalCode' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'country' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'subdivision' },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'deliveryInstructions',
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ShipmentTrackingInformationFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'shipmentTrackingInformation' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'ShipmentTrackingInformation',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'dispatchedAt' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'shippingCompany' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'trackingNumber' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'trackingUrl' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const DeliveryTimeframeFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'deliveryTimeframe' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'DeliveryDate' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'date' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'validUntil' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const OrderFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'order' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Order' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'placementDate' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'products' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'orderProduct',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'paymentPlan' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'paymentPlan',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'subtotalAmount' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'money',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'prediscountSubtotalAmount',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'money',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'prediscountTotalAmount',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'money',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'savedAmount' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'money',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'vatAmount' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'money',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'salesTaxAmount' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'money',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'shippingAmount' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'money',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'totalAmount' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'money',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'paidAmount' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'money',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'transactions' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'transactionInterface',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'promoCode' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'promoCode',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'paymentMethods' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'paymentMethodContainer',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'availableShowroomsForCollection',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'showroom',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'shippingAddress' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'orderAddress',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'billingAddress' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'orderAddress',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'desiredDeliveryDate',
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'isAsarEnabled' },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'isShippingAddressReadonly',
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'shipmentTrackingInformation',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'shipmentTrackingInformation',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'isDeliveryConfirmed',
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'isCompleted' },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'firstAvailableDeliveryDate',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'deliveryTimeframe',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'allowedWeekdays' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'disabledDates' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'status' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'name' },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ConsultantFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'consultant' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Consultant' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'firstName' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'avatar' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'user' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': { 'kind': 'Name', 'value': 'me' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const CustomerFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'customer' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Customer' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'shippingAddress' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'address',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'billingAddress' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'address',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'cart' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'order',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'consultant' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'consultant',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'orders' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'order',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const SetDeliveryInformationSuccessResponseFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'setDeliveryInformationSuccessResponse',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'SetDeliveryInformationSuccessResponse',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'order' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'order',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const SetDeliveryInformationErrorFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'setDeliveryInformationError' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'SetDeliveryInformationError',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'OrderAlreadyCompletedError',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'message',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const SetDeliveryInformationFailureResponseFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'setDeliveryInformationFailureResponse',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'SetDeliveryInformationFailureResponse',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'errors' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'setDeliveryInformationError',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const SetDeliveryInformationResponseFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'setDeliveryInformationResponse',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'SetDeliveryInformationResponse',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'setDeliveryInformationSuccessResponse',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'setDeliveryInformationFailureResponse',
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const AffirmCompleteTransactionResponseFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'affirmCompleteTransactionResponse',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'AffirmCompleteTransactionResponse',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'errors' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'order' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'order',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const AffirmPaymentResponseFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'affirmPaymentResponse' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'AffirmPaymentResponse' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'errors' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'order' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'order',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const AffirmTransactionFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'affirmTransaction' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'AffirmTransaction' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'transactionInterface',
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'checkoutObject' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'ObjectValue',
                                    'fields': [
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'cancelUrl',
                                            },
                                            'value': {
                                                'kind': 'StringValue',
                                                'value': 'https://todo.com',
                                                'block': false,
                                            },
                                        },
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'confirmationUrl',
                                            },
                                            'value': {
                                                'kind': 'StringValue',
                                                'value': 'https://todo.com',
                                                'block': false,
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const AllocationTransactionFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'allocationTransaction' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'AllocationTransaction' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'transactionInterface',
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const BankTransactionFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'bankTransaction' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'BankTransaction' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'transactionInterface',
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const KlarnaPaymentResponseFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'klarnaPaymentResponse' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'KlarnaPaymentResponse' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'errors' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'order' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'order',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const KlarnaTransactionFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'klarnaTransaction' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'KlarnaTransaction' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'transactionInterface',
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'sessionData' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const LegacyTransactionFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'legacyTransaction' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'LegacyTransaction' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'transactionInterface',
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'paymentMethodName',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const PromoCodeApplicationResultFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'promoCodeApplicationResult' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'PromoCodeApplicationResult',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'error' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const BlogPostPreviewFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'blogPostPreview' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Post' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'title' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'slug' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'excerpt' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'date' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'featuredImage' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageLarge',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const AuthorPostsFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'authorPosts' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Author' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'name' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'slug' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'posts' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'page' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': { 'kind': 'Name', 'value': 'page' },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'limit' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'limit',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'blogPostPreview',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'postAggregation' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'count',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const BlogAuthorRouteFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'blogAuthorRoute' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Author' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'slug' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const BlogCategoryRouteFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'blogCategoryRoute' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'PostCategory' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'slug' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const BlogMenuFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'blogMenu' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'PostCategory' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'name' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'slug' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'children' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'name' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'slug' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const PostCategoriesFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'postCategories' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Query' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'postCategories' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'blogMenu',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const BlogPostsFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'blogPosts' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Query' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'postCategories' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'posts' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': {
                                    'kind': 'Name',
                                    'value': 'pagination',
                                },
                                'value': {
                                    'kind': 'ObjectValue',
                                    'fields': [
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'page',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'page',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'limit',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'limit',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'filter' },
                                'value': {
                                    'kind': 'ObjectValue',
                                    'fields': [
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'blogPostPreview',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'postsAggregation' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'filter' },
                                'value': {
                                    'kind': 'ObjectValue',
                                    'fields': [
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'count',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const BlogTagRouteFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'blogTagRoute' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'PostTag' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'slug' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const CategoryPostsFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'categoryPosts' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'PostCategory' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'name' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'slug' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'posts' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'page' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': { 'kind': 'Name', 'value': 'page' },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'limit' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'limit',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'blogPostPreview',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'postAggregation' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'count',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const TagPostsFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'tagPosts' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'PostTag' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'name' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'slug' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'posts' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'page' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': { 'kind': 'Name', 'value': 'page' },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'limit' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'limit',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'blogPostPreview',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'postAggregation' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'count',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const LinkOrderFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'linkOrder' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Order' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const MetaFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'meta' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Meta' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'title' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'description' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'image' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageLarge',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const PageFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'page' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Page' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'title' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'path' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'blocks' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'block',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'meta' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': { 'kind': 'Name', 'value': 'meta' },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'pageSettings' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'showRingBuilder',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const Banner1FragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'banner1' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Banner1' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'backgroundColor' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'backgroundImage' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageMedium',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'preTitle' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'title' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'text' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'button' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'componentButton',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const Banner2FragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'banner2' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Banner2' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'backgroundColor' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'preTitle' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'title' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'text' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'button' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'componentButton',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'image' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageMedium',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ProductPageListingFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'productPageListing' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ProductPageListing' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'beforeFilters' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'block',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'afterGrid' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'block',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'banner1' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'banner1',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'banner2' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'banner2',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'meta' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': { 'kind': 'Name', 'value': 'meta' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const PaymentIconFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'paymentIcon' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'PaymentIcon' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'name' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'icon' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'imageLarge',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const SocialNetworkFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'socialNetwork' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'SocialNetwork' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'name' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'icon' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'link' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const TranslationFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'translation' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Translation' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'translation' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'token' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ProductPageFacetedContentLongDescriptionFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'productPageFacetedContentLongDescription',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'ProductPageFacetedContentLongDescription',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value':
                                    'ProductPageFacetedContentLongDescriptionBlock',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'blocks',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'block',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value':
                                    'ProductPageFacetedContentLongDescriptionText',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'text' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ProductPageFacetedContentFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'productPageFacetedContent' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'ProductPageFacetedContent',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'title' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'contentTitle' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'description' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'longDescription' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'productPageFacetedContentLongDescription',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'productString' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'meta' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': { 'kind': 'Name', 'value': 'meta' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ProductPageFacetedContentLongDescriptionBlockFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'productPageFacetedContentLongDescriptionBlock',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'ProductPageFacetedContentLongDescriptionBlock',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'blocks' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'block',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const FilterPriceRangeFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'filterPriceRange' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'CataloguePriceRangeFilter',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'currentRange' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'min' },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'money',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'max' },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'money',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const FacetedContentProductLabelTranslationFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'facetedContentProductLabelTranslation',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ProductLabelTranslation' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'name' },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'facetedContentName',
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const FilterEngagementRingStyleFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'filterEngagementRingStyle' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'CatalogueFilterEngagementRingStylesItem',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'label' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'name',
                                                },
                                            },
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'facetedContentProductLabelTranslation',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'icon' },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': '__typename',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'id',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'url',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'totalResults' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const FilterEngagementRingDesignFeatureFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'filterEngagementRingDesignFeature',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'CatalogueFilterEngagementRingDesignFeatureItem',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'label' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'name',
                                                },
                                            },
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'facetedContentProductLabelTranslation',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'icon' },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': '__typename',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'id',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'url',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'totalResults' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const FilterEngagementRingDesignStyleFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'filterEngagementRingDesignStyle',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'CatalogueFilterEngagementRingDesingStyleItem',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'label' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'name',
                                                },
                                            },
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'facetedContentProductLabelTranslation',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'icon' },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': '__typename',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'id',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'url',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'totalResults' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const FilterShapeFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'filterShape' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'CatalogueFilterShapeItem' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'shape' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'name',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'icon' },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': '__typename',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'id',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'url',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'totalResults' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const MetalFilterFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'metalFilter' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'CatalogueFilterMetalItem' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'metal' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'metalFilterMetal',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'totalResults' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const EngagementRingFiltersFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'engagementRingFilters' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'CatalogueEngagementRingFilters',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'price' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'ObjectValue',
                                    'fields': [
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'currency',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'currency',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'filterPriceRange',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'ringStyles' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'filterEngagementRingStyle',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'designFeatures' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'filterEngagementRingDesignFeature',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'designStyles' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'filterEngagementRingDesignStyle',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'centreStoneShapes',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'filterShape',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'primaryMetals' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'metalFilter',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const RelatedProductFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'relatedProduct' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'CatalogueProduct' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'productCard' },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueEngagementRing',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'variationsByPrimaryMetal',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'productCard',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueWeddingRing',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'variations',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'productCard',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryRing',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'variations',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'productCard',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryBracelet',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'variations',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'productCard',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryNecklace',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'variations',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'productCard',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryEarrings',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'variations',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'productCard',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const CatalogueProductFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'catalogueProduct' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'CatalogueProduct' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'catalogueCode' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'productName' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'suffix' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'customTitleTag' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'relatedProducts' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'relatedProduct',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'metalVariation' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ThreeSixtyFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'threeSixty' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'GenericImage' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'url' },
                    },
                    {
                        'kind': 'Field',
                        'alias': { 'kind': 'Name', 'value': 'size' },
                        'name': { 'kind': 'Name', 'value': 'size' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'name' },
                                'value': {
                                    'kind': 'EnumValue',
                                    'value': 'LARGE',
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'monolithImageSize',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'alias': { 'kind': 'Name', 'value': 'size_x2' },
                        'name': { 'kind': 'Name', 'value': 'size' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'name' },
                                'value': {
                                    'kind': 'EnumValue',
                                    'value': 'LARGE_X2',
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'monolithImageSize',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const CatalogueVideoFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'catalogueVideo' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'CatalogueVideo' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'uri' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'type' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ProductGalleryFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'productGallery' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'CatalogueProduct' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'productName' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'suffix' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'images' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                                {
                                    'kind': 'Field',
                                    'alias': {
                                        'kind': 'Name',
                                        'value': 'large',
                                    },
                                    'name': { 'kind': 'Name', 'value': 'size' },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'name',
                                            },
                                            'value': {
                                                'kind': 'EnumValue',
                                                'value': 'LARGE',
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'monolithImageSize',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'alias': {
                                        'kind': 'Name',
                                        'value': 'large_x2',
                                    },
                                    'name': { 'kind': 'Name', 'value': 'size' },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'name',
                                            },
                                            'value': {
                                                'kind': 'EnumValue',
                                                'value': 'LARGE_X2',
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'monolithImageSize',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewellery',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'images360',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'threeSixty',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'video',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'catalogueVideo',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueEngagementRing',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'images360',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'threeSixty',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'video',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'catalogueVideo',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'centreStoneConstraints',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'shape',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'translation',
                                                            },
                                                            'arguments': [
                                                                {
                                                                    'kind': 'Argument',
                                                                    'name': {
                                                                        'kind': 'Name',
                                                                        'value':
                                                                            'locale',
                                                                    },
                                                                    'value': {
                                                                        'kind': 'Variable',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'locale',
                                                                        },
                                                                    },
                                                                },
                                                            ],
                                                            'selectionSet': {
                                                                'kind': 'SelectionSet',
                                                                'selections': [
                                                                    {
                                                                        'kind': 'Field',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'name',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueWeddingRing',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'images360',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'threeSixty',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'video',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'catalogueVideo',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ProductAnalyticsFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'productAnalytics' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'CatalogueProduct' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'catalogueCode' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'productName' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'suffix' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'segmentName' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'salePrice' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'currency' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'currency',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'region' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'region',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'total',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'currency',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'amount',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'primaryMetal' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'element',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'systemCode',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'millesimalFineness',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'karat',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'segmentName',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueEngagementRing',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'bandWidth',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'segmentName',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'deliveryDays',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'hasEngraving',
                                            },
                                            'value': {
                                                'kind': 'BooleanValue',
                                                'value': false,
                                            },
                                        },
                                    ],
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueReadyToGoRing',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'segmentName',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'deliveryDays',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                    ],
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueWeddingRing',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'segmentName',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'deliveryDays',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'hasEngraving',
                                            },
                                            'value': {
                                                'kind': 'BooleanValue',
                                                'value': false,
                                            },
                                        },
                                    ],
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'categories',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'systemCode',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'bandWidth',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'ringStyles',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'systemCode',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'signatureStone',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'id',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'width',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'caratWeight',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'shape',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'systemCode',
                                                            },
                                                        },
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'translation',
                                                            },
                                                            'arguments': [
                                                                {
                                                                    'kind': 'Argument',
                                                                    'name': {
                                                                        'kind': 'Name',
                                                                        'value':
                                                                            'locale',
                                                                    },
                                                                    'value': {
                                                                        'kind': 'Variable',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'locale',
                                                                        },
                                                                    },
                                                                },
                                                            ],
                                                            'selectionSet': {
                                                                'kind': 'SelectionSet',
                                                                'selections': [
                                                                    {
                                                                        'kind': 'Field',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'name',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'crystal',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'systemCode',
                                                            },
                                                        },
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'translation',
                                                            },
                                                            'arguments': [
                                                                {
                                                                    'kind': 'Argument',
                                                                    'name': {
                                                                        'kind': 'Name',
                                                                        'value':
                                                                            'locale',
                                                                    },
                                                                    'value': {
                                                                        'kind': 'Variable',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'locale',
                                                                        },
                                                                    },
                                                                },
                                                            ],
                                                            'selectionSet': {
                                                                'kind': 'SelectionSet',
                                                                'selections': [
                                                                    {
                                                                        'kind': 'Field',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'name',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'grade',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'systemCode',
                                                            },
                                                        },
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'translation',
                                                            },
                                                            'arguments': [
                                                                {
                                                                    'kind': 'Argument',
                                                                    'name': {
                                                                        'kind': 'Name',
                                                                        'value':
                                                                            'locale',
                                                                    },
                                                                    'value': {
                                                                        'kind': 'Variable',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'locale',
                                                                        },
                                                                    },
                                                                },
                                                            ],
                                                            'selectionSet': {
                                                                'kind': 'SelectionSet',
                                                                'selections': [
                                                                    {
                                                                        'kind': 'Field',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'name',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'colors',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'systemCode',
                                                            },
                                                        },
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'translation',
                                                            },
                                                            'arguments': [
                                                                {
                                                                    'kind': 'Argument',
                                                                    'name': {
                                                                        'kind': 'Name',
                                                                        'value':
                                                                            'locale',
                                                                    },
                                                                    'value': {
                                                                        'kind': 'Variable',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'locale',
                                                                        },
                                                                    },
                                                                },
                                                            ],
                                                            'selectionSet': {
                                                                'kind': 'SelectionSet',
                                                                'selections': [
                                                                    {
                                                                        'kind': 'Field',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'name',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'clarities',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'systemCode',
                                                            },
                                                        },
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'translation',
                                                            },
                                                            'arguments': [
                                                                {
                                                                    'kind': 'Argument',
                                                                    'name': {
                                                                        'kind': 'Name',
                                                                        'value':
                                                                            'locale',
                                                                    },
                                                                    'value': {
                                                                        'kind': 'Variable',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'locale',
                                                                        },
                                                                    },
                                                                },
                                                            ],
                                                            'selectionSet': {
                                                                'kind': 'SelectionSet',
                                                                'selections': [
                                                                    {
                                                                        'kind': 'Field',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'name',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewellery',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'segmentName',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'alias': {
                                        'kind': 'Name',
                                        'value': 'jewellerySku',
                                    },
                                    'name': { 'kind': 'Name', 'value': 'sku' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'designStyles',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'systemCode',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryEarrings',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'deliveryDays',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'hasEngraving',
                                            },
                                            'value': {
                                                'kind': 'BooleanValue',
                                                'value': false,
                                            },
                                        },
                                    ],
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'alias': {
                                        'kind': 'Name',
                                        'value': 'earringsProductStyles',
                                    },
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productStyles',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'systemCode',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryNecklace',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'deliveryDays',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'hasEngraving',
                                            },
                                            'value': {
                                                'kind': 'BooleanValue',
                                                'value': false,
                                            },
                                        },
                                    ],
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'alias': {
                                        'kind': 'Name',
                                        'value': 'necklaceProductStyles',
                                    },
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productStyles',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'systemCode',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryBracelet',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'deliveryDays',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'hasEngraving',
                                            },
                                            'value': {
                                                'kind': 'BooleanValue',
                                                'value': false,
                                            },
                                        },
                                    ],
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'alias': {
                                        'kind': 'Name',
                                        'value': 'braceletProductStyles',
                                    },
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productStyles',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'systemCode',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryRing',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'deliveryDays',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'hasEngraving',
                                            },
                                            'value': {
                                                'kind': 'BooleanValue',
                                                'value': false,
                                            },
                                        },
                                    ],
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'alias': {
                                        'kind': 'Name',
                                        'value': 'jewelleryRingProductStyles',
                                    },
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productStyles',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'systemCode',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ProductPageMetaFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'productPageMeta' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'CatalogueProduct' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'catalogueCode' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'productName' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'customTitleTag' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'reviews' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'name' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'comment',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'date' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'rating',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'picture',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'asset',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'primaryMetal' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'metalFilterMetal',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'images' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'url' },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'salePrice' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'currency' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'currency',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'region' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'region',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'total',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'money',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueWeddingRing',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'categories',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'systemCode',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'translation',
                                                },
                                                'arguments': [
                                                    {
                                                        'kind': 'Argument',
                                                        'name': {
                                                            'kind': 'Name',
                                                            'value': 'locale',
                                                        },
                                                        'value': {
                                                            'kind': 'Variable',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'locale',
                                                            },
                                                        },
                                                    },
                                                ],
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'name',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'alias': {
                                        'kind': 'Name',
                                        'value': 'wrRingStyles',
                                    },
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'ringStyles',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'systemCode',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'translation',
                                                },
                                                'arguments': [
                                                    {
                                                        'kind': 'Argument',
                                                        'name': {
                                                            'kind': 'Name',
                                                            'value': 'locale',
                                                        },
                                                        'value': {
                                                            'kind': 'Variable',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'locale',
                                                            },
                                                        },
                                                    },
                                                ],
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'name',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueEngagementRing',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'alias': {
                                        'kind': 'Name',
                                        'value': 'erRingStyles',
                                    },
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'ringStyles',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'systemCode',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'translation',
                                                },
                                                'arguments': [
                                                    {
                                                        'kind': 'Argument',
                                                        'name': {
                                                            'kind': 'Name',
                                                            'value': 'locale',
                                                        },
                                                        'value': {
                                                            'kind': 'Variable',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'locale',
                                                            },
                                                        },
                                                    },
                                                ],
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'name',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueReadyToGoRing',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'sku' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryNecklace',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryBracelet',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryEarrings',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryRing',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const JewelleryDesignStyleLabelFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'jewelleryDesignStyleLabel' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'JewelleryDesignStyleLabel',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'systemCode' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'translation' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'name' },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'facetedContentProductLabelTranslation',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'icon' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'asset',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const TaxSnippetFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'taxSnippet' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'SalePrice' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'total' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'money',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'tax' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'type' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const JewelleryNecklaceProductStyleLabelFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'jewelleryNecklaceProductStyleLabel',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'JewelleryNecklaceProductStyleLabel',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'systemCode' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'translation' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'name' },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'facetedContentProductLabelTranslation',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'icon' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'asset',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const JewelleryEarringsProductStyleLabelFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'jewelleryEarringsProductStyleLabel',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'JewelleryEarringsProductStyleLabel',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'systemCode' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'translation' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'name' },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'facetedContentProductLabelTranslation',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'icon' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'asset',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const JewelleryBraceletProductStyleLabelFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'jewelleryBraceletProductStyleLabel',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'JewelleryBraceletProductStyleLabel',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'systemCode' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'translation' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'name' },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'facetedContentProductLabelTranslation',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'icon' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'asset',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const JewelleryRingProductStyleLabelFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'jewelleryRingProductStyleLabel',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'JewelleryRingProductStyleLabel',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'systemCode' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'translation' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'name' },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'facetedContentProductLabelTranslation',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'icon' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'asset',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const RingSizeFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'ringSize' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'RingSize' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'alias': { 'kind': 'Name', 'value': 'ringSizeLabel' },
                        'name': { 'kind': 'Name', 'value': 'label' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'region' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'region',
                                    },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const RecommendedRingSizeFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'recommendedRingSize' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'RecommendedRingSize' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'label' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'region' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'region',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'ringSize' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'ringSize',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const JewelleryFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'jewellery' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'CatalogueJewellery' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'catalogueProduct' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'productGallery' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'productAnalytics' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'productPageMeta' },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'engravingDisabled',
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'designStyles' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'jewelleryDesignStyleLabel',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'gemstones' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'name',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'salePrice' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'region' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'region',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'currency' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'currency',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'total',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'money',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'taxSnippet',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryNecklace',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'seoText',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'alias': {
                                        'kind': 'Name',
                                        'value': 'necklaceProductStyles',
                                    },
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productStyles',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'jewelleryNecklaceProductStyleLabel',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'alias': {
                                        'kind': 'Name',
                                        'value':
                                            'firstAvailableDeliveryDateHasEngraving',
                                    },
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'firstAvailableDeliveryDate',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'hasEngraving',
                                            },
                                            'value': {
                                                'kind': 'BooleanValue',
                                                'value': true,
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'deliveryTimeframe',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'firstAvailableDeliveryDate',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'hasEngraving',
                                            },
                                            'value': {
                                                'kind': 'BooleanValue',
                                                'value': false,
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'deliveryTimeframe',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'variations',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'metalVariation',
                                                },
                                            },
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'jewelleryLink',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryEarrings',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'seoText',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'alias': {
                                        'kind': 'Name',
                                        'value': 'earringsProductStyles',
                                    },
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productStyles',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'jewelleryEarringsProductStyleLabel',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'alias': {
                                        'kind': 'Name',
                                        'value':
                                            'firstAvailableDeliveryDateHasEngraving',
                                    },
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'firstAvailableDeliveryDate',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'hasEngraving',
                                            },
                                            'value': {
                                                'kind': 'BooleanValue',
                                                'value': true,
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'deliveryTimeframe',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'firstAvailableDeliveryDate',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'hasEngraving',
                                            },
                                            'value': {
                                                'kind': 'BooleanValue',
                                                'value': false,
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'deliveryTimeframe',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'variations',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'metalVariation',
                                                },
                                            },
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'jewelleryLink',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryBracelet',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'seoText',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'alias': {
                                        'kind': 'Name',
                                        'value': 'braceletProductStyles',
                                    },
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productStyles',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'jewelleryBraceletProductStyleLabel',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'alias': {
                                        'kind': 'Name',
                                        'value':
                                            'firstAvailableDeliveryDateHasEngraving',
                                    },
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'firstAvailableDeliveryDate',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'hasEngraving',
                                            },
                                            'value': {
                                                'kind': 'BooleanValue',
                                                'value': true,
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'deliveryTimeframe',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'firstAvailableDeliveryDate',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'hasEngraving',
                                            },
                                            'value': {
                                                'kind': 'BooleanValue',
                                                'value': false,
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'deliveryTimeframe',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'variations',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'metalVariation',
                                                },
                                            },
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'jewelleryLink',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryRing',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'seoText',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'alias': {
                                        'kind': 'Name',
                                        'value': 'jewelleryRingProductStyles',
                                    },
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productStyles',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'jewelleryRingProductStyleLabel',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'alias': {
                                        'kind': 'Name',
                                        'value':
                                            'firstAvailableDeliveryDateHasEngraving',
                                    },
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'firstAvailableDeliveryDate',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'hasEngraving',
                                            },
                                            'value': {
                                                'kind': 'BooleanValue',
                                                'value': true,
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'deliveryTimeframe',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'firstAvailableDeliveryDate',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'hasEngraving',
                                            },
                                            'value': {
                                                'kind': 'BooleanValue',
                                                'value': false,
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'deliveryTimeframe',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'variations',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'metalVariation',
                                                },
                                            },
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'jewelleryLink',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'sizes',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'InlineFragment',
                                                'typeCondition': {
                                                    'kind': 'NamedType',
                                                    'name': {
                                                        'kind': 'Name',
                                                        'value': 'RingSize',
                                                    },
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'ringSize',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                'kind': 'InlineFragment',
                                                'typeCondition': {
                                                    'kind': 'NamedType',
                                                    'name': {
                                                        'kind': 'Name',
                                                        'value':
                                                            'RecommendedRingSize',
                                                    },
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'recommendedRingSize',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ReadyToGoRingFiltersFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'readyToGoRingFilters' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'CatalogueReadyToGoRingFilters',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'price' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'ObjectValue',
                                    'fields': [
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'currency',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'currency',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'filterPriceRange',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'primaryMetals' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'metalFilter',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const FilterWeddingRingStyleFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'filterWeddingRingStyle' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'CatalogueFilterWeddingRingStylesItem',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'label' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'name',
                                                },
                                            },
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'facetedContentProductLabelTranslation',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'icon' },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': '__typename',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'id',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'url',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'totalResults' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const FilterWeddingRingCategoryFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'filterWeddingRingCategory' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'CatalogueFilterWeddingRingCategoriesItem',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'label' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'name',
                                                },
                                            },
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'facetedContentProductLabelTranslation',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'icon' },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': '__typename',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'id',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'url',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'totalResults' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const WeddingRingFiltersFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'weddingRingFilters' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'CatalogueWeddingRingFilters',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'price' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'ObjectValue',
                                    'fields': [
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'currency',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'currency',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'filterPriceRange',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'ringStyles' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'filterWeddingRingStyle',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'categories' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'filterWeddingRingCategory',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'primaryMetals' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'metalFilter',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const CatalogueEngagementRingInputFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'catalogueEngagementRingInput' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'CatalogueEngagementRing' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'catalogueCode' },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'centreStoneConstraints',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'shape',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'systemCode',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'slug' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'primaryMetal' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'suffixSlug' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const RingBuilderMountEngagementRingFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'ringBuilderMountEngagementRing',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'CatalogueEngagementRing' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'engagementRingLink',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueEngagementRingInput',
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'productName' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'catalogueCode' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'images' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'alias': {
                                        'kind': 'Name',
                                        'value': 'small_x2',
                                    },
                                    'name': { 'kind': 'Name', 'value': 'size' },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'name',
                                            },
                                            'value': {
                                                'kind': 'EnumValue',
                                                'value': 'SMALL_X2',
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'monolithImageSize',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'alias': {
                                        'kind': 'Name',
                                        'value': 'large_x2',
                                    },
                                    'name': { 'kind': 'Name', 'value': 'size' },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'name',
                                            },
                                            'value': {
                                                'kind': 'EnumValue',
                                                'value': 'LARGE_X2',
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'monolithImageSize',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'primaryMetal' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'name',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'suffix' },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'centreStoneConstraints',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'shape',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'systemCode',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'translation',
                                                },
                                                'arguments': [
                                                    {
                                                        'kind': 'Argument',
                                                        'name': {
                                                            'kind': 'Name',
                                                            'value': 'locale',
                                                        },
                                                        'value': {
                                                            'kind': 'Variable',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'locale',
                                                            },
                                                        },
                                                    },
                                                ],
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'name',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'weight',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'max',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'min',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'sizes' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'region' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'region',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'recommendedRingSize',
                                    },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'ringSize',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const SignatureStoneInputFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'signatureStoneInput' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'CatalogueEngagementRingSignatureStone',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'color' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'crystal' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'width' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const RingBuilderMountFragmentFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'ringBuilderMountFragment' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'RingBuilderMountFragment' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'ring' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'ringBuilderMountEngagementRing',
                                    },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'engagementRingLink',
                                    },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productPageMeta',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'variationsByCentreStoneShape',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'catalogueEngagementRingInput',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'centreStoneConstraints',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'shape',
                                                            },
                                                            'selectionSet': {
                                                                'kind': 'SelectionSet',
                                                                'selections': [
                                                                    {
                                                                        'kind': 'Field',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'systemCode',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'signatureStone' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'signatureStoneInput',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'image',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'crystal',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': '__typename',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'translation',
                                                },
                                                'arguments': [
                                                    {
                                                        'kind': 'Argument',
                                                        'name': {
                                                            'kind': 'Name',
                                                            'value': 'locale',
                                                        },
                                                        'value': {
                                                            'kind': 'Variable',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'locale',
                                                            },
                                                        },
                                                    },
                                                ],
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'name',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'color',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': '__typename',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'translation',
                                                },
                                                'arguments': [
                                                    {
                                                        'kind': 'Argument',
                                                        'name': {
                                                            'kind': 'Name',
                                                            'value': 'locale',
                                                        },
                                                        'value': {
                                                            'kind': 'Variable',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'locale',
                                                            },
                                                        },
                                                    },
                                                ],
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'name',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'segmentName',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'totalSalePrice' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'region' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'region',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'currency' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'currency',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'money',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const StoneCategoryTranslationFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'stoneCategoryTranslation' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'StoneCategoryTranslation' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'name' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const StoneCategoryFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'stoneCategory' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'StoneCategory' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'systemCode' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'translation' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'stoneCategoryTranslation',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ClarityTranslationFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'clarityTranslation' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'StoneClarityTranslation' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'name' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const StoneClarityFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'stoneClarity' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'StoneClarity' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'abbreviation' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'systemCode' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'translation' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'clarityTranslation',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const StoneColorTranslationFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'stoneColorTranslation' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'StoneColorTranslation' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'name' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const StoneColorFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'stoneColor' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'StoneColor' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'systemCode' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'translation' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'stoneColorTranslation',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const StoneImageFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'StoneImage' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'GemsApi_StoneImage' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'url' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'isB2B' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const GemsApiCertificateFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'gemsApiCertificate' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'GemsApi_Stone' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'certificates' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'gcal' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'gia' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'igi' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const StoneFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'stone' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'GemsApi_Stone' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'identifier' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'blackInclusion' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'categoryWithInfo' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'code' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'info' },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'stoneCategory',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'clarityWithInfo' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'code' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'info' },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'stoneClarity',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'colorWithInfo' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'code' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'info' },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'stoneColor',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'colourShade' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'crystal' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'culet' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'cutWithInfo' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'code' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'info' },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'abbreviation',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'systemCode',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'translation',
                                                },
                                                'arguments': [
                                                    {
                                                        'kind': 'Argument',
                                                        'name': {
                                                            'kind': 'Name',
                                                            'value': 'locale',
                                                        },
                                                        'value': {
                                                            'kind': 'Variable',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'locale',
                                                            },
                                                        },
                                                    },
                                                ],
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'name',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'eyeClean' },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'fluorescenceWithInfo',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'code' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'info' },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'abbreviation',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'systemCode',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'translation',
                                                },
                                                'arguments': [
                                                    {
                                                        'kind': 'Argument',
                                                        'name': {
                                                            'kind': 'Name',
                                                            'value': 'locale',
                                                        },
                                                        'value': {
                                                            'kind': 'Variable',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'locale',
                                                            },
                                                        },
                                                    },
                                                ],
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'name',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'fluorescenceColour',
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'girdleMin' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'girdleMax' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'gradeWithInfo' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'code' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'info' },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'systemCode',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'translation',
                                                },
                                                'arguments': [
                                                    {
                                                        'kind': 'Argument',
                                                        'name': {
                                                            'kind': 'Name',
                                                            'value': 'locale',
                                                        },
                                                        'value': {
                                                            'kind': 'Variable',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'locale',
                                                            },
                                                        },
                                                    },
                                                ],
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'name',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'growthMethod' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'polishWithInfo' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'code' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'info' },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'abbreviation',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'systemCode',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'translation',
                                                },
                                                'arguments': [
                                                    {
                                                        'kind': 'Argument',
                                                        'name': {
                                                            'kind': 'Name',
                                                            'value': 'locale',
                                                        },
                                                        'value': {
                                                            'kind': 'Variable',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'locale',
                                                            },
                                                        },
                                                    },
                                                ],
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'name',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'shapeWithInfo' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'code' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'info' },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'systemCode',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'samplePhoto',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'id',
                                                            },
                                                        },
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'url',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'icon',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'id',
                                                            },
                                                        },
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'url',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'translation',
                                                },
                                                'arguments': [
                                                    {
                                                        'kind': 'Argument',
                                                        'name': {
                                                            'kind': 'Name',
                                                            'value': 'locale',
                                                        },
                                                        'value': {
                                                            'kind': 'Variable',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'locale',
                                                            },
                                                        },
                                                    },
                                                ],
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'name',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'symmetryWithInfo' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'code' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'info' },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'abbreviation',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'systemCode',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'translation',
                                                },
                                                'arguments': [
                                                    {
                                                        'kind': 'Argument',
                                                        'name': {
                                                            'kind': 'Name',
                                                            'value': 'locale',
                                                        },
                                                        'value': {
                                                            'kind': 'Variable',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'locale',
                                                            },
                                                        },
                                                    },
                                                ],
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'name',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'shippingFromCountry',
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'originCountry' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'length' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'width' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'depth' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'weight' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'ratio' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'pavilionDepth' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'pavilionAngle' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'tablePercent' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'depthPercent' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'crownAngle' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'crownHeight' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'image' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'StoneImage',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'images' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'StoneImage',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'v360Url' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'isMilky' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'isTreated' },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'isCertificateVerified',
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'isCanadaMark' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'isB2B' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'isValidB2C' },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'isHideCertificateNumber',
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'isHideMeasurements',
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'deliveryDays' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'gemsApiCertificate',
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'dtlReport' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'url' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'code' },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'scsReport' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'salePrice' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'currency' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'currency',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'region' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'region',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'money',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const GemsApiStoneAnalyticsFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'gemsApiStoneAnalytics' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'GemsApi_Stone' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'crystalWithInfo' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'info' },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'systemCode',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'translation',
                                                },
                                                'arguments': [
                                                    {
                                                        'kind': 'Argument',
                                                        'name': {
                                                            'kind': 'Name',
                                                            'value': 'locale',
                                                        },
                                                        'value': {
                                                            'kind': 'Variable',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'locale',
                                                            },
                                                        },
                                                    },
                                                ],
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'name',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'shapeWithInfo' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'info' },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'systemCode',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'translation',
                                                },
                                                'arguments': [
                                                    {
                                                        'kind': 'Argument',
                                                        'name': {
                                                            'kind': 'Name',
                                                            'value': 'locale',
                                                        },
                                                        'value': {
                                                            'kind': 'Variable',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'locale',
                                                            },
                                                        },
                                                    },
                                                ],
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'name',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'colorWithInfo' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'info' },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'systemCode',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'translation',
                                                },
                                                'arguments': [
                                                    {
                                                        'kind': 'Argument',
                                                        'name': {
                                                            'kind': 'Name',
                                                            'value': 'locale',
                                                        },
                                                        'value': {
                                                            'kind': 'Variable',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'locale',
                                                            },
                                                        },
                                                    },
                                                ],
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'name',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'clarityWithInfo' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'info' },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'systemCode',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'translation',
                                                },
                                                'arguments': [
                                                    {
                                                        'kind': 'Argument',
                                                        'name': {
                                                            'kind': 'Name',
                                                            'value': 'locale',
                                                        },
                                                        'value': {
                                                            'kind': 'Variable',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'locale',
                                                            },
                                                        },
                                                    },
                                                ],
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'name',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'cutWithInfo' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'info' },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'systemCode',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'translation',
                                                },
                                                'arguments': [
                                                    {
                                                        'kind': 'Argument',
                                                        'name': {
                                                            'kind': 'Name',
                                                            'value': 'locale',
                                                        },
                                                        'value': {
                                                            'kind': 'Variable',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'locale',
                                                            },
                                                        },
                                                    },
                                                ],
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'name',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'gradeWithInfo' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'info' },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'systemCode',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'translation',
                                                },
                                                'arguments': [
                                                    {
                                                        'kind': 'Argument',
                                                        'name': {
                                                            'kind': 'Name',
                                                            'value': 'locale',
                                                        },
                                                        'value': {
                                                            'kind': 'Variable',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'locale',
                                                            },
                                                        },
                                                    },
                                                ],
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'name',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'weight' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'originCountry' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const StoneShapeTranslationFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'stoneShapeTranslation' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'StoneShapeTranslation' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'name' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const StoneShapeFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'stoneShape' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'StoneShape' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'systemCode' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'icon' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'asset',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'samplePhoto' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'asset',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'translation' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'stoneShapeTranslation',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const StoneCutTranslationFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'stoneCutTranslation' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'StoneCutTranslation' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'name' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const StoneCutFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'stoneCut' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'StoneCut' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'systemCode' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'translation' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'stoneCutTranslation',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const StoneCrystalTranslationFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'stoneCrystalTranslation' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'StoneCrystalTranslation' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'name' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const StoneCrystalFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'stoneCrystal' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'StoneCrystal' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'systemCode' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'translation' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'stoneCrystalTranslation',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const StoneGradeFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'stoneGrade' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'StoneGrade' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'systemCode' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'translation' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'name' },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'category' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'stoneCategory',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const NonSkuGemstoneImageFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'nonSkuGemstoneImage' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'NonSkuGemstone' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'image' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'url' },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'shapeDimension' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'shape',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': '__typename',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'systemCode',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'samplePhoto',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    '__typename',
                                                            },
                                                        },
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'id',
                                                            },
                                                        },
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'url',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const NonSkuGemstoneFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'nonSkuGemstone' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'NonSkuGemstone' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'shape' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'stoneShape',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'salePrice' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'currency' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'currency',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'region' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'region',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'money',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'cut' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'stoneCut',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'caratWeight' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'crystal' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'stoneCrystal',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'color' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'stoneColor',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'colorGrade' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'stoneGrade',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'clarity' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'stoneClarity',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'image' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'url' },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'nonSkuGemstoneImage',
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const NonSkuLabGrownStoneImageFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'nonSkuLabGrownStoneImage' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'NonSkuLabGrown' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'image' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'url' },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'shapeDimension' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'image',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': '__typename',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'id',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'url',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'shape',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': '__typename',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'systemCode',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'samplePhoto',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    '__typename',
                                                            },
                                                        },
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'id',
                                                            },
                                                        },
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'url',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const NonSkuLabGrownFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'nonSkuLabGrown' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'NonSkuLabGrown' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'salePrice' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'currency' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'currency',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'region' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'region',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'money',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'shape' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'stoneShape',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'caratWeight' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'color' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'stoneColor',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'clarity' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'stoneClarity',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'image' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'url' },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'nonSkuLabGrownStoneImage',
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const NonSkuGemstoneAnalyticsFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'nonSkuGemstoneAnalytics' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'NonSkuGemstone' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'crystal' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'name',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'shape' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'name',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'color' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'name',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'clarity' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'name',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'cut' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'name',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'colorGrade' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'name',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'caratWeight' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const NonSkuLabGrownAnalyticsFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'nonSkuLabGrownAnalytics' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'NonSkuLabGrown' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'crystal' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'name',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'shape' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'name',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'color' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'name',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'clarity' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'name',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'cut' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'name',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'caratWeight' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const RingBuilderCentreStoneFragmentFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'ringBuilderCentreStoneFragment',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'RingBuilderCentreStoneFragment',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'stone' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                                {
                                    'kind': 'InlineFragment',
                                    'typeCondition': {
                                        'kind': 'NamedType',
                                        'name': {
                                            'kind': 'Name',
                                            'value': 'GemsApiStone',
                                        },
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'stone',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'stone',
                                                            },
                                                        },
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'gemsApiStoneAnalytics',
                                                            },
                                                        },
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'gemsApiCertificate',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'nonSkuGemstone',
                                    },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'nonSkuLabGrown',
                                    },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'nonSkuGemstoneAnalytics',
                                    },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'nonSkuLabGrownAnalytics',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'totalSalePrice' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'region' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'region',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'currency' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'currency',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'money',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const RingBuilderFragmentFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'ringBuilderFragment' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'RingBuilderFragment' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'RingBuilderMountFragment',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'ringBuilderMountFragment',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'RingBuilderCentreStoneFragment',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'ringBuilderCentreStoneFragment',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const AffirmFinanceOptionsFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'affirmFinanceOptions' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'AffirmFinanceOption' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'price' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'money',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const KlarnaFinanceOptionsFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'klarnaFinanceOptions' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'KlarnaFinanceOption' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'perMonth' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'money',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const RbFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'rb' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'RingBuilder' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'productId' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'position1' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'ringBuilderFragment',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'position2' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'ringBuilderFragment',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'image' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'alias': {
                                        'kind': 'Name',
                                        'value': 'small_x2',
                                    },
                                    'name': { 'kind': 'Name', 'value': 'size' },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'name',
                                            },
                                            'value': {
                                                'kind': 'EnumValue',
                                                'value': 'SMALL_X2',
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'monolithImageSize',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'alias': {
                                        'kind': 'Name',
                                        'value': 'large_x2',
                                    },
                                    'name': { 'kind': 'Name', 'value': 'size' },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'name',
                                            },
                                            'value': {
                                                'kind': 'EnumValue',
                                                'value': 'LARGE_X2',
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'monolithImageSize',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'salePrice' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'currency' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'currency',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'region' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'region',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'taxSnippet',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'financeOptionsAffirm',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'currency' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'currency',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'region' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'region',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'affirmFinanceOptions',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'financeOptionsKlarna',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'currency' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'currency',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'region' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'region',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'klarnaFinanceOptions',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'failure' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'errors',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': '__typename',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const GemsApiStoneCrystalWithInfoFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'GemsApiStoneCrystalWithInfo' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'GemsApi_StoneCrystalInfo' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'code' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'info' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const GemsApiStoneShapeWithInfoFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'GemsApiStoneShapeWithInfo' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'GemsApi_StoneShapeInfo' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'code' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'info' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'stoneShape',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const GemsRangeFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'gemsRange' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'GemsApi_Range' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'min' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'max' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const GemsIntRangeFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'gemsIntRange' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'GemsApi_IntRange' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'min' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'max' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const GemsPriceRangeInLocalCurrencyFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'gemsPriceRangeInLocalCurrency',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'GemsApi_PriceRange' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'min' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'max' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'minInCurrency' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'currency' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'currency',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'region' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'region',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'money',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'maxInCurrency' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'currency' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'currency',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'region' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'region',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'money',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const GemsBoundsFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'gemsBounds' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'GemsApi_Bounds' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'colour' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'grade' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'shape' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'shapes' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'GemsApiStoneShapeWithInfo',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'clarity' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'fluorescence' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'cut' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'polish' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'symmetry' },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'shippingFromCountry',
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'originCountry' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'category' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'crystal' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'weight' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'gemsRange',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'depthPercent' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'gemsRange',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'tablePercent' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'gemsRange',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'ratio' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'gemsRange',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'length' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'gemsRange',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'width' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'gemsRange',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'depth' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'gemsRange',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'deliveryDays' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'gemsIntRange',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'price' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'gemsPriceRangeInLocalCurrency',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'priceByShape' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'shape',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'range',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'gemsPriceRangeInLocalCurrency',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const GemsPriceRangeFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'gemsPriceRange' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'GemsApi_PriceRange' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'min' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'max' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const GemsSelectedRangeFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'GemsSelectedRange' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'GemsApi_SelectedRange' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'min' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'max' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const GemsSelectedFiltersFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'GemsSelectedFilters' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'GemsApi_SelectedStoneFilters',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'category' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'crystal' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'colour' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'grade' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'shape' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'clarity' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'fluorescence' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'symmetry' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'cut' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'polish' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'shippingFrom' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'originCountry' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'notColour' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'notClarity' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'notSymmetry' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'lab' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'collection' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'hasPhoto' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'isCanadaMark' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'isDtlReport' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'isScsReport' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'withVideo' },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'withOriginCountry',
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'isStock' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'isRtg' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'price' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'GemsSelectedRange',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'costPrice' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'GemsSelectedRange',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'weight' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'GemsSelectedRange',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'depthPercent' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'GemsSelectedRange',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'tablePercent' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'GemsSelectedRange',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'ratio' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'GemsSelectedRange',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'length' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'GemsSelectedRange',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'width' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'GemsSelectedRange',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'depth' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'GemsSelectedRange',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'sorting' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'field',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'direction',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'priceIndex' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const NonSkuCaratWeightRangeFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'nonSkuCaratWeightRange' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'NonSkuCaratWeightRange' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'min' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'max' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const NonSkuPriceRangeFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'nonSkuPriceRange' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'NonSkuPriceRange' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'min' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'money',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'max' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'money',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const NonSkuGemstoneBoundsFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'nonSkuGemstoneBounds' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'NonSkuGemstonesBounds' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'caratWeight' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'nonSkuCaratWeightRange',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'price' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'currency' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'currency',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'region' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'region',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'nonSkuPriceRange',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'shapes' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'stoneShape',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'types' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'crystal',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'stoneCrystal',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'color',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'stoneColor',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const NonSkuLabGrownDiamondBoundsFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'nonSkuLabGrownDiamondBounds' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'NonSkuLabGrownDiamondsBounds',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'caratWeight' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'nonSkuCaratWeightRange',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'price' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'currency' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'currency',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'region' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'region',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'nonSkuPriceRange',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'shapes' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'stoneShape',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'colors' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'stoneColor',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ProductExportFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'productExport' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'CatalogueProduct' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'catalogueCode' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'productName' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'productLink' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'salePrice' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'currency' },
                                'value': {
                                    'kind': 'ObjectValue',
                                    'fields': [
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'region' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'region',
                                    },
                                },
                            },
                        ],
                        'directives': [
                            {
                                'kind': 'Directive',
                                'name': { 'kind': 'Name', 'value': 'skip' },
                                'arguments': [
                                    {
                                        'kind': 'Argument',
                                        'name': {
                                            'kind': 'Name',
                                            'value': 'if',
                                        },
                                        'value': {
                                            'kind': 'Variable',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'rbProduct',
                                            },
                                        },
                                    },
                                ],
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'total',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'money',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'mainImage' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'url' },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'images' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'url' },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'primaryMetal' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'element',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'systemCode',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'translation',
                                                },
                                                'arguments': [
                                                    {
                                                        'kind': 'Argument',
                                                        'name': {
                                                            'kind': 'Name',
                                                            'value': 'locale',
                                                        },
                                                        'value': {
                                                            'kind': 'Variable',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'locale',
                                                            },
                                                        },
                                                    },
                                                ],
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'name',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'color',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'systemCode',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'translation',
                                                },
                                                'arguments': [
                                                    {
                                                        'kind': 'Argument',
                                                        'name': {
                                                            'kind': 'Name',
                                                            'value': 'locale',
                                                        },
                                                        'value': {
                                                            'kind': 'Variable',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'locale',
                                                            },
                                                        },
                                                    },
                                                ],
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'name',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryBracelet',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryEarrings',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryNecklace',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryRing',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueEngagementRing',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueWeddingRing',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'categories',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'systemCode',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueReadyToGoRing',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'description',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const LabGrownRouteFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'labGrownRoute' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'NonSkuLabGrown' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'color' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'clarity' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'caratWeight' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const GemstoneRouteFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'gemstoneRoute' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'NonSkuGemstone' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'color' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'crystal' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'colorGrade' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'clarity' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'caratWeight' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ExportsRingBuilderPositionFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'exportsRingBuilderPosition' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'RingBuilderFragment' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'RingBuilderCentreStoneFragment',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'stone',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': '__typename',
                                                },
                                            },
                                            {
                                                'kind': 'InlineFragment',
                                                'typeCondition': {
                                                    'kind': 'NamedType',
                                                    'name': {
                                                        'kind': 'Name',
                                                        'value':
                                                            'NonSkuLabGrown',
                                                    },
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'labGrownRoute',
                                                            },
                                                        },
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'shape',
                                                            },
                                                            'selectionSet': {
                                                                'kind': 'SelectionSet',
                                                                'selections': [
                                                                    {
                                                                        'kind': 'Field',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'translation',
                                                                        },
                                                                        'arguments':
                                                                            [
                                                                                {
                                                                                    'kind': 'Argument',
                                                                                    'name': {
                                                                                        'kind': 'Name',
                                                                                        'value':
                                                                                            'locale',
                                                                                    },
                                                                                    'value':
                                                                                        {
                                                                                            'kind': 'Variable',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'locale',
                                                                                            },
                                                                                        },
                                                                                },
                                                                            ],
                                                                        'selectionSet':
                                                                            {
                                                                                'kind': 'SelectionSet',
                                                                                'selections':
                                                                                    [
                                                                                        {
                                                                                            'kind': 'Field',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'name',
                                                                                            },
                                                                                        },
                                                                                    ],
                                                                            },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                'kind': 'InlineFragment',
                                                'typeCondition': {
                                                    'kind': 'NamedType',
                                                    'name': {
                                                        'kind': 'Name',
                                                        'value':
                                                            'NonSkuGemstone',
                                                    },
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'gemstoneRoute',
                                                            },
                                                        },
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'shape',
                                                            },
                                                            'selectionSet': {
                                                                'kind': 'SelectionSet',
                                                                'selections': [
                                                                    {
                                                                        'kind': 'Field',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'translation',
                                                                        },
                                                                        'arguments':
                                                                            [
                                                                                {
                                                                                    'kind': 'Argument',
                                                                                    'name': {
                                                                                        'kind': 'Name',
                                                                                        'value':
                                                                                            'locale',
                                                                                    },
                                                                                    'value':
                                                                                        {
                                                                                            'kind': 'Variable',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'locale',
                                                                                            },
                                                                                        },
                                                                                },
                                                                            ],
                                                                        'selectionSet':
                                                                            {
                                                                                'kind': 'SelectionSet',
                                                                                'selections':
                                                                                    [
                                                                                        {
                                                                                            'kind': 'Field',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'name',
                                                                                            },
                                                                                        },
                                                                                    ],
                                                                            },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'color',
                                                            },
                                                            'selectionSet': {
                                                                'kind': 'SelectionSet',
                                                                'selections': [
                                                                    {
                                                                        'kind': 'Field',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'translation',
                                                                        },
                                                                        'arguments':
                                                                            [
                                                                                {
                                                                                    'kind': 'Argument',
                                                                                    'name': {
                                                                                        'kind': 'Name',
                                                                                        'value':
                                                                                            'locale',
                                                                                    },
                                                                                    'value':
                                                                                        {
                                                                                            'kind': 'Variable',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'locale',
                                                                                            },
                                                                                        },
                                                                                },
                                                                            ],
                                                                        'selectionSet':
                                                                            {
                                                                                'kind': 'SelectionSet',
                                                                                'selections':
                                                                                    [
                                                                                        {
                                                                                            'kind': 'Field',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'name',
                                                                                            },
                                                                                        },
                                                                                    ],
                                                                            },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'crystal',
                                                            },
                                                            'selectionSet': {
                                                                'kind': 'SelectionSet',
                                                                'selections': [
                                                                    {
                                                                        'kind': 'Field',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'translation',
                                                                        },
                                                                        'arguments':
                                                                            [
                                                                                {
                                                                                    'kind': 'Argument',
                                                                                    'name': {
                                                                                        'kind': 'Name',
                                                                                        'value':
                                                                                            'locale',
                                                                                    },
                                                                                    'value':
                                                                                        {
                                                                                            'kind': 'Variable',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'locale',
                                                                                            },
                                                                                        },
                                                                                },
                                                                            ],
                                                                        'selectionSet':
                                                                            {
                                                                                'kind': 'SelectionSet',
                                                                                'selections':
                                                                                    [
                                                                                        {
                                                                                            'kind': 'Field',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'name',
                                                                                            },
                                                                                        },
                                                                                    ],
                                                                            },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const EngagementRingRingBuilderExportFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'engagementRingRingBuilderExport',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'CatalogueEngagementRing' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'productExport' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'ringStyles' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'name',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'ringBuilderProducts',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'ObjectValue',
                                    'fields': [
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'type',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'type',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'currency',
                                            },
                                            'value': {
                                                'kind': 'ObjectValue',
                                                'fields': [
                                                    {
                                                        'kind': 'ObjectField',
                                                        'name': {
                                                            'kind': 'Name',
                                                            'value': 'region',
                                                        },
                                                        'value': {
                                                            'kind': 'Variable',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'region',
                                                            },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productId',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'position1',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'exportsRingBuilderPosition',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'position2',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'exportsRingBuilderPosition',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'image',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'url',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'totalSalePrice',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'currency',
                                            },
                                            'value': {
                                                'kind': 'ObjectValue',
                                                'fields': [
                                                    {
                                                        'kind': 'ObjectField',
                                                        'name': {
                                                            'kind': 'Name',
                                                            'value': 'region',
                                                        },
                                                        'value': {
                                                            'kind': 'Variable',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'region',
                                                            },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'money',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ReviewFeedFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'reviewFeed' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Review' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'name' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'date' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'comment' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'picture' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'url' },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'rating' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ContentImageSitemapFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'contentImageSitemap' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'ContentComponentItem' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'ComponentTitle',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'texts',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': '__typename',
                                                },
                                            },
                                            {
                                                'kind': 'InlineFragment',
                                                'typeCondition': {
                                                    'kind': 'NamedType',
                                                    'name': {
                                                        'kind': 'Name',
                                                        'value':
                                                            'ComponentTitleText',
                                                    },
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'text',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const SitemapRegionFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'sitemapRegion' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Region' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'code' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'isActive' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const EngagementRingAndSignatureStoneFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'engagementRingAndSignatureStone',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'CatalogueEngagementRingAndSignatureStone',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'salePrice' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'region' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'region',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'currency' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'currency',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'taxSnippet',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'signatureStone' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'signatureStoneInput',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'isDefault',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'crystal',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'systemCode',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'translation',
                                                },
                                                'arguments': [
                                                    {
                                                        'kind': 'Argument',
                                                        'name': {
                                                            'kind': 'Name',
                                                            'value': 'locale',
                                                        },
                                                        'value': {
                                                            'kind': 'Variable',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'locale',
                                                            },
                                                        },
                                                    },
                                                ],
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'name',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'color',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'systemCode',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'translation',
                                                },
                                                'arguments': [
                                                    {
                                                        'kind': 'Argument',
                                                        'name': {
                                                            'kind': 'Name',
                                                            'value': 'locale',
                                                        },
                                                        'value': {
                                                            'kind': 'Variable',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'locale',
                                                            },
                                                        },
                                                    },
                                                ],
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'name',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'image',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'price',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'currency',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'currency',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'money',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const StoneRecommendationsNotFoundFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'stoneRecommendationsNotFound' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'StoneRecommendationNotFound',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'haveWithoutPricingRange',
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const StoneRecommendationsFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'stoneRecommendations' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'StoneRecommendationsResponse',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'StoneRecommendationsResponseSuccess',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'priceBounds',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'min',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'money',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'max',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'money',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'priceInitialValues',
                                    },
                                    'directives': [
                                        {
                                            'kind': 'Directive',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'skip',
                                            },
                                            'arguments': [
                                                {
                                                    'kind': 'Argument',
                                                    'name': {
                                                        'kind': 'Name',
                                                        'value': 'if',
                                                    },
                                                    'value': {
                                                        'kind': 'Variable',
                                                        'name': {
                                                            'kind': 'Name',
                                                            'value': 'hasPrice',
                                                        },
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'min',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'money',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'max',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'money',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'naturalDiamondBestForBalance',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'InlineFragment',
                                                'typeCondition': {
                                                    'kind': 'NamedType',
                                                    'name': {
                                                        'kind': 'Name',
                                                        'value':
                                                            'GemsApi_Stone',
                                                    },
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'stone',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                'kind': 'InlineFragment',
                                                'typeCondition': {
                                                    'kind': 'NamedType',
                                                    'name': {
                                                        'kind': 'Name',
                                                        'value':
                                                            'StoneRecommendationNotFound',
                                                    },
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'stoneRecommendationsNotFound',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'naturalDiamondBestForSize',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'InlineFragment',
                                                'typeCondition': {
                                                    'kind': 'NamedType',
                                                    'name': {
                                                        'kind': 'Name',
                                                        'value':
                                                            'GemsApi_Stone',
                                                    },
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'stone',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                'kind': 'InlineFragment',
                                                'typeCondition': {
                                                    'kind': 'NamedType',
                                                    'name': {
                                                        'kind': 'Name',
                                                        'value':
                                                            'StoneRecommendationNotFound',
                                                    },
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'stoneRecommendationsNotFound',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'nonSkuGemStones',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'colorCodes',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'colorCodes',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'color',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'systemCode',
                                                            },
                                                        },
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'translation',
                                                            },
                                                            'arguments': [
                                                                {
                                                                    'kind': 'Argument',
                                                                    'name': {
                                                                        'kind': 'Name',
                                                                        'value':
                                                                            'locale',
                                                                    },
                                                                    'value': {
                                                                        'kind': 'Variable',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'locale',
                                                                        },
                                                                    },
                                                                },
                                                            ],
                                                            'selectionSet': {
                                                                'kind': 'SelectionSet',
                                                                'selections': [
                                                                    {
                                                                        'kind': 'Field',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'name',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'item',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'InlineFragment',
                                                            'typeCondition': {
                                                                'kind': 'NamedType',
                                                                'name': {
                                                                    'kind': 'Name',
                                                                    'value':
                                                                        'NonSkuGemstone',
                                                                },
                                                            },
                                                            'selectionSet': {
                                                                'kind': 'SelectionSet',
                                                                'selections': [
                                                                    {
                                                                        'kind': 'FragmentSpread',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'nonSkuGemstone',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            'kind': 'InlineFragment',
                                                            'typeCondition': {
                                                                'kind': 'NamedType',
                                                                'name': {
                                                                    'kind': 'Name',
                                                                    'value':
                                                                        'StoneRecommendationNotFound',
                                                                },
                                                            },
                                                            'selectionSet': {
                                                                'kind': 'SelectionSet',
                                                                'selections': [
                                                                    {
                                                                        'kind': 'FragmentSpread',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'stoneRecommendationsNotFound',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'nonSkuLabGrownBestForPrice',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'InlineFragment',
                                                'typeCondition': {
                                                    'kind': 'NamedType',
                                                    'name': {
                                                        'kind': 'Name',
                                                        'value':
                                                            'NonSkuLabGrown',
                                                    },
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'nonSkuLabGrown',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                'kind': 'InlineFragment',
                                                'typeCondition': {
                                                    'kind': 'NamedType',
                                                    'name': {
                                                        'kind': 'Name',
                                                        'value':
                                                            'StoneRecommendationNotFound',
                                                    },
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'stoneRecommendationsNotFound',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'nonSkuLabGrownBestForSize',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'InlineFragment',
                                                'typeCondition': {
                                                    'kind': 'NamedType',
                                                    'name': {
                                                        'kind': 'Name',
                                                        'value':
                                                            'NonSkuLabGrown',
                                                    },
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'nonSkuLabGrown',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                'kind': 'InlineFragment',
                                                'typeCondition': {
                                                    'kind': 'NamedType',
                                                    'name': {
                                                        'kind': 'Name',
                                                        'value':
                                                            'StoneRecommendationNotFound',
                                                    },
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'stoneRecommendationsNotFound',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'StoneRecommendationsResponseFailure',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'error',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const RingBuilderStoneRecommendationsFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'ringBuilderStoneRecommendations',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'RingBuilderFragment' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'RingBuilderMountFragment',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'stoneRecommendations',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'minPrice',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'minPrice',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'maxPrice',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'maxPrice',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'currency',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'currency',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': '__typename',
                                                },
                                            },
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'stoneRecommendations',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'InlineFragment',
                        'typeCondition': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'RingBuilderCentreStoneFragment',
                            },
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const EngagementRingStoneRecommendationCardFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'engagementRingStoneRecommendationCard',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'EngagementRingStoneRecommendationCard',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'title' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'description' },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'notSupportedContent',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'contentComponentItem',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'notFoundContent' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'contentComponentItem',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const JewelleryDesignStyleFilterFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'jewelleryDesignStyleFilter' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'CatalogueFilterJewelleryDesignStyleLabel',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'label' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'jewelleryDesignStyleLabel',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'totalResults' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const JewelleryDesignFeatureLabelFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'jewelleryDesignFeatureLabel' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'JewelleryDesignFeatureLabel',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'systemCode' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'translation' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'name' },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'facetedContentProductLabelTranslation',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'icon' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'asset',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const CatalogueFilterJewelleryDesignFeatureLabelFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'catalogueFilterJewelleryDesignFeatureLabel',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'CatalogueFilterJewelleryDesignFeatureLabel',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'label' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'jewelleryDesignFeatureLabel',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'totalResults' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const JewelleryGemstoneLabelFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'jewelleryGemstoneLabel' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'JewelleryGemstoneLabel' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'systemCode' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'translation' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'name' },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'facetedContentProductLabelTranslation',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'icon' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'asset',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const CatalogueFilterJewelleryGemstoneLabelFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'catalogueFilterJewelleryGemstoneLabel',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'CatalogueFilterJewelleryGemstoneLabel',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'label' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'jewelleryGemstoneLabel',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'totalResults' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const JewelleryFiltersFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'jewelleryFilters' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'CatalogueJewelleriesFilters',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'price' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'ObjectValue',
                                    'fields': [
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'currency',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'currency',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'filterPriceRange',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'primaryMetals' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'metalFilter',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'designStyles' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'jewelleryDesignStyleFilter',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'designFeatures' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'catalogueFilterJewelleryDesignFeatureLabel',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'gemstones' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'catalogueFilterJewelleryGemstoneLabel',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const JewelleryNecklaceFiltersFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'jewelleryNecklaceFilters' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'CatalogueJewelleryNecklacesFilters',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'price' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'ObjectValue',
                                    'fields': [
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'currency',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'currency',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'filterPriceRange',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'primaryMetals' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'metalFilter',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'productStyles' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'label',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'jewelleryNecklaceProductStyleLabel',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'totalResults',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'designStyles' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'jewelleryDesignStyleFilter',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'designFeatures' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'catalogueFilterJewelleryDesignFeatureLabel',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'gemstones' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'catalogueFilterJewelleryGemstoneLabel',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const JewelleryBraceletFiltersFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'jewelleryBraceletFilters' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'CatalogueJewelleryBraceletsFilters',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'price' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'ObjectValue',
                                    'fields': [
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'currency',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'currency',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'filterPriceRange',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'primaryMetals' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'metalFilter',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'productStyles' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'label',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'jewelleryBraceletProductStyleLabel',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'totalResults',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'designStyles' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'jewelleryDesignStyleFilter',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'designFeatures' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'catalogueFilterJewelleryDesignFeatureLabel',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'gemstones' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'catalogueFilterJewelleryGemstoneLabel',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const JewelleryEarringsFiltersFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'jewelleryEarringsFilters' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'CatalogueJewelleryEarringsFilters',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'price' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'ObjectValue',
                                    'fields': [
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'currency',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'currency',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'filterPriceRange',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'primaryMetals' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'metalFilter',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'productStyles' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'label',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'jewelleryEarringsProductStyleLabel',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'totalResults',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'designStyles' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'jewelleryDesignStyleFilter',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'designFeatures' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'catalogueFilterJewelleryDesignFeatureLabel',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'gemstones' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'catalogueFilterJewelleryGemstoneLabel',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const JewelleryRingsFiltersFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'jewelleryRingsFilters' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'CatalogueJewelleryRingsFilters',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'price' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'ObjectValue',
                                    'fields': [
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'currency',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'currency',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'filterPriceRange',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'primaryMetals' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'metalFilter',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'productStyles' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'label',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'jewelleryRingProductStyleLabel',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'totalResults',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'designStyles' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'jewelleryDesignStyleFilter',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'designFeatures' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'catalogueFilterJewelleryDesignFeatureLabel',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'gemstones' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'catalogueFilterJewelleryGemstoneLabel',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ReadyToGoRingVariationsFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'readyToGoRingVariations' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'CatalogueReadyToGoRing' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'catalogueCode' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'gemType' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'carat' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'readyToGoRingLink',
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const CatalogueReadyToGoRingTranslationFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': {
                'kind': 'Name',
                'value': 'catalogueReadyToGoRingTranslation',
            },
            'typeCondition': {
                'kind': 'NamedType',
                'name': {
                    'kind': 'Name',
                    'value': 'CatalogueReadyToGoRingTranslation',
                },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'description' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'seoText' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ReviewsFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'reviews' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Review' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'name' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'comment' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'date' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'picture' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                                {
                                    'kind': 'Field',
                                    'alias': {
                                        'kind': 'Name',
                                        'value': 'small',
                                    },
                                    'name': { 'kind': 'Name', 'value': 'size' },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'name',
                                            },
                                            'value': {
                                                'kind': 'EnumValue',
                                                'value': 'SMALL',
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'monolithImageSize',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'alias': {
                                        'kind': 'Name',
                                        'value': 'small_x2',
                                    },
                                    'name': { 'kind': 'Name', 'value': 'size' },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'name',
                                            },
                                            'value': {
                                                'kind': 'EnumValue',
                                                'value': 'SMALL_X2',
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'monolithImageSize',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'rating' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const ReadyToGoRingFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'readyToGoRing' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'CatalogueReadyToGoRing' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'catalogueProduct' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'carat' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'gemType' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'sku' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'productGallery' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': {
                            'kind': 'Name',
                            'value': 'readyToGoRingLink',
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'productPageMeta' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'salePrice' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'region' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'region',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'currency' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'currency',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'taxSnippet',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'sizes' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'recommendedRingSize',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'variations' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'readyToGoRingVariations',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'translation' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'catalogueReadyToGoRingTranslation',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'isReadyToShip' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'reviews' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'reviews',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const MeleeFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'melee' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'CatalogueMelee' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': '__typename' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'melee' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'grade',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'category',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'systemCode',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'colors',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'systemCode',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'translation',
                                                },
                                                'arguments': [
                                                    {
                                                        'kind': 'Argument',
                                                        'name': {
                                                            'kind': 'Name',
                                                            'value': 'locale',
                                                        },
                                                        'value': {
                                                            'kind': 'Variable',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'locale',
                                                            },
                                                        },
                                                    },
                                                ],
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'name',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'clarities',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'systemCode',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'translation',
                                                },
                                                'arguments': [
                                                    {
                                                        'kind': 'Argument',
                                                        'name': {
                                                            'kind': 'Name',
                                                            'value': 'locale',
                                                        },
                                                        'value': {
                                                            'kind': 'Variable',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'locale',
                                                            },
                                                        },
                                                    },
                                                ],
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'name',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'caratWeight',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'width',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'quantity' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const WeddingRingFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'weddingRing' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'CatalogueWeddingRing' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'catalogueProduct' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'productGallery' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'productPageMeta' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'video' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'catalogueVideo',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'meleeItems' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'melee',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'categories' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'name',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'ringStyles' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'name',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'systemCode',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'bandWidth' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'bandThickness' },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'weddingRingLink' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'variations' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'primaryMetal',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'metalFilterMetal',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'catalogueCode',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'suffix',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productName',
                                    },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'weddingRingLink',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'translation' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'seoText',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'description',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'salePrice' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'currency' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'currency',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'region' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'region',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'total',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'money',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'taxSnippet',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'sizes' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'region' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'region',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'InlineFragment',
                                    'typeCondition': {
                                        'kind': 'NamedType',
                                        'name': {
                                            'kind': 'Name',
                                            'value': 'RingSize',
                                        },
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'ringSize',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'InlineFragment',
                                    'typeCondition': {
                                        'kind': 'NamedType',
                                        'name': {
                                            'kind': 'Name',
                                            'value': 'RecommendedRingSize',
                                        },
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'recommendedRingSize',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const OrderListViewFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'orderListView' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Order' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'placementDate' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'totalAmount' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'money',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'status' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'name' },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const LinkDesignStudioProductFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'linkDesignStudioProduct' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'DesignStudioProduct' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const OrderDetailedViewFragmentDoc = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'FragmentDefinition',
            'name': { 'kind': 'Name', 'value': 'orderDetailedView' },
            'typeCondition': {
                'kind': 'NamedType',
                'name': { 'kind': 'Name', 'value': 'Order' },
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'orderListView' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'products' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'name' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'designStudioProduct',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'name',
                                                },
                                            },
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'linkDesignStudioProduct',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'paidAmount' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'money',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'remainingAmount' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'money',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'isPayable' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'paymentPlan' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'paid' },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'amount',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'money',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'upcoming',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'amount',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'money',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'current',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'amount',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'money',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'prediscountTotalAmount',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'money',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'totalAmount' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'money',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'promoCode' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'shippingAddress' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'firstName',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'lastName',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'addressLine1',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'addressLine2',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'city' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'postalCode',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'country',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'phoneNumber',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'formatted',
                                                },
                                                'arguments': [
                                                    {
                                                        'kind': 'Argument',
                                                        'name': {
                                                            'kind': 'Name',
                                                            'value': 'format',
                                                        },
                                                        'value': {
                                                            'kind': 'EnumValue',
                                                            'value':
                                                                'INTERNATIONAL',
                                                        },
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'shipmentTrackingInformation',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'dispatchedAt',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'shippingCompany',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'trackingNumber',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'transactions' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                                {
                                    'kind': 'InlineFragment',
                                    'typeCondition': {
                                        'kind': 'NamedType',
                                        'name': {
                                            'kind': 'Name',
                                            'value': 'LegacyTransaction',
                                        },
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'paymentMethodName',
                                                },
                                                'arguments': [
                                                    {
                                                        'kind': 'Argument',
                                                        'name': {
                                                            'kind': 'Name',
                                                            'value': 'locale',
                                                        },
                                                        'value': {
                                                            'kind': 'Variable',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'locale',
                                                            },
                                                        },
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'createdAt',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'status',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'systemCode',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'name',
                                                },
                                                'arguments': [
                                                    {
                                                        'kind': 'Argument',
                                                        'name': {
                                                            'kind': 'Name',
                                                            'value': 'locale',
                                                        },
                                                        'value': {
                                                            'kind': 'Variable',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'locale',
                                                            },
                                                        },
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'amount',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'money',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode
export const CreateEnquiryContactUsExistingCustomerDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': {
                'kind': 'Name',
                'value': 'createEnquiryContactUsExistingCustomer',
            },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'EnquiryContactUsInput',
                            },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'createEnquiryContactUsExistingCustomer',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode

export function useCreateEnquiryContactUsExistingCustomerMutation() {
    return Urql.useMutation<
        CreateEnquiryContactUsExistingCustomerMutation,
        CreateEnquiryContactUsExistingCustomerMutationVariables
    >(CreateEnquiryContactUsExistingCustomerDocument)
}
export const CreateEnquiryContactUsNewCustomerDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': {
                'kind': 'Name',
                'value': 'createEnquiryContactUsNewCustomer',
            },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'EnquiryContactUsInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'customer' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CustomerRegistrationInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'isConsultant' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Boolean' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'createEnquiryContactUsNewCustomer',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'customer' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'customer',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'enquiryResponseNewCustomer',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...EnquiryResponseNewCustomerFragmentDoc.definitions,
        ...CustomerRegistrationResponseFragmentDoc.definitions,
        ...LoginResponseSuccessFragmentDoc.definitions,
        ...MeFragmentDoc.definitions,
        ...CostumerConsultantFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useCreateEnquiryContactUsNewCustomerMutation() {
    return Urql.useMutation<
        CreateEnquiryContactUsNewCustomerMutation,
        CreateEnquiryContactUsNewCustomerMutationVariables
    >(CreateEnquiryContactUsNewCustomerDocument)
}
export const CreateEnquiryExistingCustomerDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': {
                'kind': 'Name',
                'value': 'createEnquiryExistingCustomer',
            },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'EnquiryInput' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'createEnquiryExistingCustomer',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode

export function useCreateEnquiryExistingCustomerMutation() {
    return Urql.useMutation<
        CreateEnquiryExistingCustomerMutation,
        CreateEnquiryExistingCustomerMutationVariables
    >(CreateEnquiryExistingCustomerDocument)
}
export const CreateEnquiryNewCustomerDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': { 'kind': 'Name', 'value': 'createEnquiryNewCustomer' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'EnquiryInput' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'customer' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CustomerRegistrationInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'isConsultant' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Boolean' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'createEnquiryNewCustomer',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'customer' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'customer',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'enquiryResponseNewCustomer',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...EnquiryResponseNewCustomerFragmentDoc.definitions,
        ...CustomerRegistrationResponseFragmentDoc.definitions,
        ...LoginResponseSuccessFragmentDoc.definitions,
        ...MeFragmentDoc.definitions,
        ...CostumerConsultantFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useCreateEnquiryNewCustomerMutation() {
    return Urql.useMutation<
        CreateEnquiryNewCustomerMutation,
        CreateEnquiryNewCustomerMutationVariables
    >(CreateEnquiryNewCustomerDocument)
}
export const MarketingDataDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': { 'kind': 'Name', 'value': 'marketingData' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'MarketingDataInput',
                            },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'marketingData' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'success',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode

export function useMarketingDataMutation() {
    return Urql.useMutation<
        MarketingDataMutation,
        MarketingDataMutationVariables
    >(MarketingDataDocument)
}
export const InitDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'init' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'currency' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CurrencyInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'region' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'RegionCode' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': {
                            'kind': 'Name',
                            'value': 'fetchRegionSuggest',
                        },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Boolean' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'isConsultant' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Boolean' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'ringBuilder' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': { 'kind': 'Name', 'value': 'rb' },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'me' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': { 'kind': 'Name', 'value': 'me' },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'workingHours' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'weekDays',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'opening',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'closing',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'regionSuggest' },
                        'directives': [
                            {
                                'kind': 'Directive',
                                'name': { 'kind': 'Name', 'value': 'include' },
                                'arguments': [
                                    {
                                        'kind': 'Argument',
                                        'name': {
                                            'kind': 'Name',
                                            'value': 'if',
                                        },
                                        'value': {
                                            'kind': 'Variable',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'fetchRegionSuggest',
                                            },
                                        },
                                    },
                                ],
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'code' },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'defaultAlternateRegion',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'alternateTag',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'regions' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'alternateTag',
                                    },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'regionPlugin',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'language' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translations',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'translation',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'topBar' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'topBar',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'preHeader' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'preHeader',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'mainMenu' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'headerMenu',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'socialNetworks' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'socialNetwork',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'paymentIcons' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'paymentIcon',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'footer' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'footer',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'avatarStack' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'avatarStackItem',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...RbFragmentDoc.definitions,
        ...RingBuilderFragmentFragmentDoc.definitions,
        ...RingBuilderMountFragmentFragmentDoc.definitions,
        ...RingBuilderMountEngagementRingFragmentDoc.definitions,
        ...EngagementRingLinkFragmentDoc.definitions,
        ...CatalogueEngagementRingInputFragmentDoc.definitions,
        ...MonolithImageSizeFragmentDoc.definitions,
        ...RecommendedRingSizeFragmentDoc.definitions,
        ...RingSizeFragmentDoc.definitions,
        ...ProductPageMetaFragmentDoc.definitions,
        ...AssetFragmentDoc.definitions,
        ...MetalFilterMetalFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...SignatureStoneInputFragmentDoc.definitions,
        ...RingBuilderCentreStoneFragmentFragmentDoc.definitions,
        ...StoneFragmentDoc.definitions,
        ...StoneCategoryFragmentDoc.definitions,
        ...StoneCategoryTranslationFragmentDoc.definitions,
        ...StoneClarityFragmentDoc.definitions,
        ...ClarityTranslationFragmentDoc.definitions,
        ...StoneColorFragmentDoc.definitions,
        ...StoneColorTranslationFragmentDoc.definitions,
        ...StoneImageFragmentDoc.definitions,
        ...GemsApiCertificateFragmentDoc.definitions,
        ...GemsApiStoneAnalyticsFragmentDoc.definitions,
        ...NonSkuGemstoneFragmentDoc.definitions,
        ...StoneShapeFragmentDoc.definitions,
        ...StoneShapeTranslationFragmentDoc.definitions,
        ...StoneCutFragmentDoc.definitions,
        ...StoneCutTranslationFragmentDoc.definitions,
        ...StoneCrystalFragmentDoc.definitions,
        ...StoneCrystalTranslationFragmentDoc.definitions,
        ...StoneGradeFragmentDoc.definitions,
        ...NonSkuGemstoneImageFragmentDoc.definitions,
        ...NonSkuLabGrownFragmentDoc.definitions,
        ...NonSkuLabGrownStoneImageFragmentDoc.definitions,
        ...NonSkuGemstoneAnalyticsFragmentDoc.definitions,
        ...NonSkuLabGrownAnalyticsFragmentDoc.definitions,
        ...TaxSnippetFragmentDoc.definitions,
        ...AffirmFinanceOptionsFragmentDoc.definitions,
        ...KlarnaFinanceOptionsFragmentDoc.definitions,
        ...MeFragmentDoc.definitions,
        ...CostumerConsultantFragmentDoc.definitions,
        ...AlternateTagFragmentDoc.definitions,
        ...RegionPluginFragmentDoc.definitions,
        ...TranslationFragmentDoc.definitions,
        ...TopBarFragmentDoc.definitions,
        ...TopBarSiteWideMessageFragmentDoc.definitions,
        ...LinkFragmentDoc.definitions,
        ...LinkItemFragmentDoc.definitions,
        ...PageLinkFragmentDoc.definitions,
        ...PostLinkFragmentDoc.definitions,
        ...CustomLinkFragmentDoc.definitions,
        ...LinkQuestionnaireFragmentDoc.definitions,
        ...LinkItemOpenEnquiryFormFragmentDoc.definitions,
        ...LinkItemOpenContactFormFragmentDoc.definitions,
        ...LinkItemOpenSpeakToExpertModalFragmentDoc.definitions,
        ...TopBarConsultationPromptFragmentDoc.definitions,
        ...PreHeaderFragmentDoc.definitions,
        ...HeaderMenuFragmentDoc.definitions,
        ...SubMenuFragmentDoc.definitions,
        ...SubMenuSectionFragmentDoc.definitions,
        ...SubMenuItemFragmentDoc.definitions,
        ...ImageLargeFragmentDoc.definitions,
        ...ImageCommonFragmentDoc.definitions,
        ...ImageSizeFragmentDoc.definitions,
        ...SubMenuEditorialContentFragmentDoc.definitions,
        ...SocialNetworkFragmentDoc.definitions,
        ...PaymentIconFragmentDoc.definitions,
        ...FooterFragmentDoc.definitions,
        ...FooterMenuFragmentDoc.definitions,
        ...FooterMenuItemFragmentDoc.definitions,
        ...FooterItemTitleFragmentDoc.definitions,
        ...FooterItemLinkListFragmentDoc.definitions,
        ...FooterItemTextFragmentDoc.definitions,
        ...FooterItemDividerFragmentDoc.definitions,
        ...FooterItemWorkingHoursFragmentDoc.definitions,
        ...WorkingHoursFragmentDoc.definitions,
        ...AvatarStackItemFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useInitQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, InitQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<InitQuery, InitQueryVariables | undefined>({
        query: InitDocument,
        variables: undefined,
        ...options,
    })
}
export const AutologinDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': { 'kind': 'Name', 'value': 'autologin' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'authToken' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'String' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'isConsultant' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Boolean' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'autologin' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': {
                                    'kind': 'Name',
                                    'value': 'authToken',
                                },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'authToken',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                                {
                                    'kind': 'InlineFragment',
                                    'typeCondition': {
                                        'kind': 'NamedType',
                                        'name': {
                                            'kind': 'Name',
                                            'value': 'LoginResponseSuccess',
                                        },
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'loginResponseSuccess',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...LoginResponseSuccessFragmentDoc.definitions,
        ...MeFragmentDoc.definitions,
        ...CostumerConsultantFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useAutologinMutation() {
    return Urql.useMutation<AutologinMutation, AutologinMutationVariables>(
        AutologinDocument
    )
}
export const LoginDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': { 'kind': 'Name', 'value': 'login' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'credentials' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CredentialsInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'isConsultant' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Boolean' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'login' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': {
                                    'kind': 'Name',
                                    'value': 'credentials',
                                },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'credentials',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'loginResponse',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...LoginResponseFragmentDoc.definitions,
        ...LoginResponseSuccessFragmentDoc.definitions,
        ...MeFragmentDoc.definitions,
        ...CostumerConsultantFragmentDoc.definitions,
        ...LoginResponseFailureFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useLoginMutation() {
    return Urql.useMutation<LoginMutation, LoginMutationVariables>(
        LoginDocument
    )
}
export const LoginWithGoogleDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': { 'kind': 'Name', 'value': 'loginWithGoogle' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'credentials' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CustomerRegistrationByGoogleInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'isConsultant' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Boolean' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'loginWithGoogle' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': {
                                    'kind': 'Name',
                                    'value': 'credentials',
                                },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'credentials',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'loginResponse',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...LoginResponseFragmentDoc.definitions,
        ...LoginResponseSuccessFragmentDoc.definitions,
        ...MeFragmentDoc.definitions,
        ...CostumerConsultantFragmentDoc.definitions,
        ...LoginResponseFailureFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useLoginWithGoogleMutation() {
    return Urql.useMutation<
        LoginWithGoogleMutation,
        LoginWithGoogleMutationVariables
    >(LoginWithGoogleDocument)
}
export const LogoutDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': { 'kind': 'Name', 'value': 'logout' },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'logout' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode

export function useLogoutMutation() {
    return Urql.useMutation<LogoutMutation, LogoutMutationVariables>(
        LogoutDocument
    )
}
export const RefreshTokenDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': { 'kind': 'Name', 'value': 'refreshToken' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'token' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'String' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'refreshToken' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'token' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'token',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'InlineFragment',
                                    'typeCondition': {
                                        'kind': 'NamedType',
                                        'name': {
                                            'kind': 'Name',
                                            'value': 'LoginResponseSuccess',
                                        },
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'refreshToken',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'InlineFragment',
                                    'typeCondition': {
                                        'kind': 'NamedType',
                                        'name': {
                                            'kind': 'Name',
                                            'value': 'LoginResponseFailure',
                                        },
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'code',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'message',
                                                },
                                                'arguments': [
                                                    {
                                                        'kind': 'Argument',
                                                        'name': {
                                                            'kind': 'Name',
                                                            'value': 'locale',
                                                        },
                                                        'value': {
                                                            'kind': 'Variable',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'locale',
                                                            },
                                                        },
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode

export function useRefreshTokenMutation() {
    return Urql.useMutation<
        RefreshTokenMutation,
        RefreshTokenMutationVariables
    >(RefreshTokenDocument)
}
export const BookingConsultationAvailableSlotsDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': {
                'kind': 'Name',
                'value': 'bookingConsultationAvailableSlots',
            },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'BookingConsultationSlotInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'bookingConsultationAvailableSlots',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'bookingConsultationSlotsResponse',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...BookingConsultationSlotsResponseFragmentDoc.definitions,
        ...BookingConsultationSlotFragmentDoc.definitions,
        ...ShowroomFragmentDoc.definitions,
        ...ShowroomLocationFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useBookingConsultationAvailableSlotsQuery(
    options?: Omit<
        Urql.UseQueryArgs<
            never,
            BookingConsultationAvailableSlotsQueryVariables | undefined
        >,
        'query'
    >
) {
    return Urql.useQuery<
        BookingConsultationAvailableSlotsQuery,
        BookingConsultationAvailableSlotsQueryVariables | undefined
    >({
        query: BookingConsultationAvailableSlotsDocument,
        variables: undefined,
        ...options,
    })
}
export const BookingInitDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'bookingInit' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'bookingConsultationShowPhone',
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'bookingConsultationPurposes',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'bookingConsultationPurpose',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'bookingConsultationComplexities',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'bookingConsultationComplexity',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...BookingConsultationPurposeFragmentDoc.definitions,
        ...AssetFragmentDoc.definitions,
        ...BookingConsultationComplexityFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useBookingInitQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, BookingInitQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<
        BookingInitQuery,
        BookingInitQueryVariables | undefined
    >({ query: BookingInitDocument, variables: undefined, ...options })
}
export const CreateConsultationExistingCustomerDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': {
                'kind': 'Name',
                'value': 'createConsultationExistingCustomer',
            },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'BookingCreateConsultationInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'createConsultationExistingCustomer',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'bookingCreateConsultationExistingCustomerResponse',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...BookingCreateConsultationExistingCustomerResponseFragmentDoc.definitions,
        ...BookingCreateConsultationSuccessExistingCustomerFragmentDoc.definitions,
        ...BookingConsultationFragmentDoc.definitions,
        ...BookingConsultationPurposeFragmentDoc.definitions,
        ...AssetFragmentDoc.definitions,
        ...BookingConsultationMethodFragmentDoc.definitions,
        ...ShowroomFragmentDoc.definitions,
        ...ShowroomLocationFragmentDoc.definitions,
        ...BookingCreateConsultationErrorNoAvailableConsultantsFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useCreateConsultationExistingCustomerMutation() {
    return Urql.useMutation<
        CreateConsultationExistingCustomerMutation,
        CreateConsultationExistingCustomerMutationVariables
    >(CreateConsultationExistingCustomerDocument)
}
export const CreateConsultationNewCustomerDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': {
                'kind': 'Name',
                'value': 'createConsultationNewCustomer',
            },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'BookingCreateConsultationInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'customer' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CustomerRegistrationInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'isConsultant' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Boolean' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'createConsultationNewCustomer',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'customer' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'customer',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'bookingCreateConsultationNewCustomerResponse',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...BookingCreateConsultationNewCustomerResponseFragmentDoc.definitions,
        ...BookingCreateConsultationSuccessNewCustomerFragmentDoc.definitions,
        ...CustomerRegistrationResponseFragmentDoc.definitions,
        ...LoginResponseSuccessFragmentDoc.definitions,
        ...MeFragmentDoc.definitions,
        ...CostumerConsultantFragmentDoc.definitions,
        ...BookingConsultationFragmentDoc.definitions,
        ...BookingConsultationPurposeFragmentDoc.definitions,
        ...AssetFragmentDoc.definitions,
        ...BookingConsultationMethodFragmentDoc.definitions,
        ...ShowroomFragmentDoc.definitions,
        ...ShowroomLocationFragmentDoc.definitions,
        ...BookingCreateConsultationErrorNoAvailableConsultantsFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useCreateConsultationNewCustomerMutation() {
    return Urql.useMutation<
        CreateConsultationNewCustomerMutation,
        CreateConsultationNewCustomerMutationVariables
    >(CreateConsultationNewCustomerDocument)
}
export const CustomerExistsDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'customerExists' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'email' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Email' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'customerExists' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'email' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'email',
                                    },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode

export function useCustomerExistsQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, CustomerExistsQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<
        CustomerExistsQuery,
        CustomerExistsQueryVariables | undefined
    >({ query: CustomerExistsDocument, variables: undefined, ...options })
}
export const OrdersDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'orders' },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'me' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'customer',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'id',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'orders',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'bookingOrders',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...BookingOrdersFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useOrdersQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, OrdersQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<OrdersQuery, OrdersQueryVariables | undefined>({
        query: OrdersDocument,
        variables: undefined,
        ...options,
    })
}
export const ValidateConsultationInputDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'validateConsultationInput' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'BookingCreateConsultationInput',
                            },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'validateConsultationInput',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode

export function useValidateConsultationInputQuery(
    options?: Omit<
        Urql.UseQueryArgs<
            never,
            ValidateConsultationInputQueryVariables | undefined
        >,
        'query'
    >
) {
    return Urql.useQuery<
        ValidateConsultationInputQuery,
        ValidateConsultationInputQueryVariables | undefined
    >({
        query: ValidateConsultationInputDocument,
        variables: undefined,
        ...options,
    })
}
export const ValidateCustomerRegistrationInputDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': {
                'kind': 'Name',
                'value': 'validateCustomerRegistrationInput',
            },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CustomerRegistrationInput',
                            },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'validateCustomerRegistrationInput',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode

export function useValidateCustomerRegistrationInputQuery(
    options?: Omit<
        Urql.UseQueryArgs<
            never,
            ValidateCustomerRegistrationInputQueryVariables | undefined
        >,
        'query'
    >
) {
    return Urql.useQuery<
        ValidateCustomerRegistrationInputQuery,
        ValidateCustomerRegistrationInputQueryVariables | undefined
    >({
        query: ValidateCustomerRegistrationInputDocument,
        variables: undefined,
        ...options,
    })
}
export const CartDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'cart' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'me' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'customer',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'cart',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'order',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...OrderFragmentDoc.definitions,
        ...OrderProductFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...PaymentPlanFragmentDoc.definitions,
        ...PaymentPlanPaidRecordFragmentDoc.definitions,
        ...PaymentPlanUpcomingRecordFragmentDoc.definitions,
        ...TransactionInterfaceFragmentDoc.definitions,
        ...TransactionStatusFragmentDoc.definitions,
        ...PromoCodeFragmentDoc.definitions,
        ...PaymentMethodContainerFragmentDoc.definitions,
        ...NoPaymentMethodFragmentDoc.definitions,
        ...BankPaymentMethodFragmentDoc.definitions,
        ...AllocationPaymentMethodFragmentDoc.definitions,
        ...CheckoutcomPaymentMethodFragmentDoc.definitions,
        ...AffirmPaymentMethodFragmentDoc.definitions,
        ...KlarnaPaymentMethodFragmentDoc.definitions,
        ...ShowroomFragmentDoc.definitions,
        ...ShowroomLocationFragmentDoc.definitions,
        ...OrderAddressFragmentDoc.definitions,
        ...ShipmentTrackingInformationFragmentDoc.definitions,
        ...DeliveryTimeframeFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useCartQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, CartQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<CartQuery, CartQueryVariables | undefined>({
        query: CartDocument,
        variables: undefined,
        ...options,
    })
}
export const AddToCartJewelleryExistingCustomerDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': {
                'kind': 'Name',
                'value': 'addToCartJewelleryExistingCustomer',
            },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'DesignStudioJewelleryInput',
                            },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value':
                                'createDesignStudioProductAndAddToCartJewelleryExistingCustomer',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode

export function useAddToCartJewelleryExistingCustomerMutation() {
    return Urql.useMutation<
        AddToCartJewelleryExistingCustomerMutation,
        AddToCartJewelleryExistingCustomerMutationVariables
    >(AddToCartJewelleryExistingCustomerDocument)
}
export const AddToCartJewelleryNewCustomerDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': {
                'kind': 'Name',
                'value': 'addToCartJewelleryNewCustomer',
            },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'DesignStudioJewelleryInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'customer' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CustomerRegistrationInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'isConsultant' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Boolean' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value':
                                'createDesignStudioProductAndAddToCartJewelleryNewCustomer',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'customer' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'customer',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                                {
                                    'kind': 'InlineFragment',
                                    'typeCondition': {
                                        'kind': 'NamedType',
                                        'name': {
                                            'kind': 'Name',
                                            'value':
                                                'CatalogueDesignStudioCheckoutJewellerySuccessNewCustomer',
                                        },
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'customer',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'customerRegistrationResponse',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...CustomerRegistrationResponseFragmentDoc.definitions,
        ...LoginResponseSuccessFragmentDoc.definitions,
        ...MeFragmentDoc.definitions,
        ...CostumerConsultantFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useAddToCartJewelleryNewCustomerMutation() {
    return Urql.useMutation<
        AddToCartJewelleryNewCustomerMutation,
        AddToCartJewelleryNewCustomerMutationVariables
    >(AddToCartJewelleryNewCustomerDocument)
}
export const OrderByIdDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'orderById' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'ID' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'me' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'customer',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'order',
                                                },
                                                'arguments': [
                                                    {
                                                        'kind': 'Argument',
                                                        'name': {
                                                            'kind': 'Name',
                                                            'value': 'id',
                                                        },
                                                        'value': {
                                                            'kind': 'Variable',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'id',
                                                            },
                                                        },
                                                    },
                                                ],
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'order',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...OrderFragmentDoc.definitions,
        ...OrderProductFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...PaymentPlanFragmentDoc.definitions,
        ...PaymentPlanPaidRecordFragmentDoc.definitions,
        ...PaymentPlanUpcomingRecordFragmentDoc.definitions,
        ...TransactionInterfaceFragmentDoc.definitions,
        ...TransactionStatusFragmentDoc.definitions,
        ...PromoCodeFragmentDoc.definitions,
        ...PaymentMethodContainerFragmentDoc.definitions,
        ...NoPaymentMethodFragmentDoc.definitions,
        ...BankPaymentMethodFragmentDoc.definitions,
        ...AllocationPaymentMethodFragmentDoc.definitions,
        ...CheckoutcomPaymentMethodFragmentDoc.definitions,
        ...AffirmPaymentMethodFragmentDoc.definitions,
        ...KlarnaPaymentMethodFragmentDoc.definitions,
        ...ShowroomFragmentDoc.definitions,
        ...ShowroomLocationFragmentDoc.definitions,
        ...OrderAddressFragmentDoc.definitions,
        ...ShipmentTrackingInformationFragmentDoc.definitions,
        ...DeliveryTimeframeFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useOrderByIdQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, OrderByIdQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<OrderByIdQuery, OrderByIdQueryVariables | undefined>({
        query: OrderByIdDocument,
        variables: undefined,
        ...options,
    })
}
export const AddToCartReadyToGoRingExistingCustomerDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': {
                'kind': 'Name',
                'value': 'addToCartReadyToGoRingExistingCustomer',
            },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'AddToCartReadyToGoRingInput',
                            },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'addToCartReadyToGoRingExistingCustomer',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode

export function useAddToCartReadyToGoRingExistingCustomerMutation() {
    return Urql.useMutation<
        AddToCartReadyToGoRingExistingCustomerMutation,
        AddToCartReadyToGoRingExistingCustomerMutationVariables
    >(AddToCartReadyToGoRingExistingCustomerDocument)
}
export const AddToCartReadyToGoRingNewCustomerDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': {
                'kind': 'Name',
                'value': 'addToCartReadyToGoRingNewCustomer',
            },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'AddToCartReadyToGoRingInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'customer' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CustomerRegistrationInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'isConsultant' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Boolean' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'addToCartReadyToGoRingNewCustomer',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'customer' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'customer',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'addToCartReadyToGoRingNewCustomerResponse',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...AddToCartReadyToGoRingNewCustomerResponseFragmentDoc.definitions,
        ...AddToCartReadyToGoRingSuccessNewCustomerFragmentDoc.definitions,
        ...CustomerRegistrationResponseFragmentDoc.definitions,
        ...LoginResponseSuccessFragmentDoc.definitions,
        ...MeFragmentDoc.definitions,
        ...CostumerConsultantFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useAddToCartReadyToGoRingNewCustomerMutation() {
    return Urql.useMutation<
        AddToCartReadyToGoRingNewCustomerMutation,
        AddToCartReadyToGoRingNewCustomerMutationVariables
    >(AddToCartReadyToGoRingNewCustomerDocument)
}
export const CreateDesignStudioProductAndAddToCartWeddingRingExistingCustomerDocument =
    {
        'kind': 'Document',
        'definitions': [
            {
                'kind': 'OperationDefinition',
                'operation': 'mutation',
                'name': {
                    'kind': 'Name',
                    'value':
                        'createDesignStudioProductAndAddToCartWeddingRingExistingCustomer',
                },
                'variableDefinitions': [
                    {
                        'kind': 'VariableDefinition',
                        'variable': {
                            'kind': 'Variable',
                            'name': { 'kind': 'Name', 'value': 'input' },
                        },
                        'type': {
                            'kind': 'NonNullType',
                            'type': {
                                'kind': 'NamedType',
                                'name': {
                                    'kind': 'Name',
                                    'value': 'DesignStudioWeddingRingInput',
                                },
                            },
                        },
                    },
                ],
                'selectionSet': {
                    'kind': 'SelectionSet',
                    'selections': [
                        {
                            'kind': 'Field',
                            'name': {
                                'kind': 'Name',
                                'value':
                                    'createDesignStudioProductAndAddToCartWeddingRingExistingCustomer',
                            },
                            'arguments': [
                                {
                                    'kind': 'Argument',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                    'value': {
                                        'kind': 'Variable',
                                        'name': {
                                            'kind': 'Name',
                                            'value': 'input',
                                        },
                                    },
                                },
                            ],
                            'selectionSet': {
                                'kind': 'SelectionSet',
                                'selections': [
                                    {
                                        'kind': 'Field',
                                        'name': {
                                            'kind': 'Name',
                                            'value': '__typename',
                                        },
                                    },
                                ],
                            },
                        },
                    ],
                },
            },
        ],
    } as unknown as DocumentNode

export function useCreateDesignStudioProductAndAddToCartWeddingRingExistingCustomerMutation() {
    return Urql.useMutation<
        CreateDesignStudioProductAndAddToCartWeddingRingExistingCustomerMutation,
        CreateDesignStudioProductAndAddToCartWeddingRingExistingCustomerMutationVariables
    >(CreateDesignStudioProductAndAddToCartWeddingRingExistingCustomerDocument)
}
export const CreateDesignStudioProductAndAddToCartWeddingRingNewCustomerDocument =
    {
        'kind': 'Document',
        'definitions': [
            {
                'kind': 'OperationDefinition',
                'operation': 'mutation',
                'name': {
                    'kind': 'Name',
                    'value':
                        'createDesignStudioProductAndAddToCartWeddingRingNewCustomer',
                },
                'variableDefinitions': [
                    {
                        'kind': 'VariableDefinition',
                        'variable': {
                            'kind': 'Variable',
                            'name': { 'kind': 'Name', 'value': 'input' },
                        },
                        'type': {
                            'kind': 'NonNullType',
                            'type': {
                                'kind': 'NamedType',
                                'name': {
                                    'kind': 'Name',
                                    'value': 'DesignStudioWeddingRingInput',
                                },
                            },
                        },
                    },
                    {
                        'kind': 'VariableDefinition',
                        'variable': {
                            'kind': 'Variable',
                            'name': { 'kind': 'Name', 'value': 'customer' },
                        },
                        'type': {
                            'kind': 'NonNullType',
                            'type': {
                                'kind': 'NamedType',
                                'name': {
                                    'kind': 'Name',
                                    'value': 'CustomerRegistrationInput',
                                },
                            },
                        },
                    },
                    {
                        'kind': 'VariableDefinition',
                        'variable': {
                            'kind': 'Variable',
                            'name': { 'kind': 'Name', 'value': 'isConsultant' },
                        },
                        'type': {
                            'kind': 'NonNullType',
                            'type': {
                                'kind': 'NamedType',
                                'name': { 'kind': 'Name', 'value': 'Boolean' },
                            },
                        },
                    },
                ],
                'selectionSet': {
                    'kind': 'SelectionSet',
                    'selections': [
                        {
                            'kind': 'Field',
                            'name': {
                                'kind': 'Name',
                                'value':
                                    'createDesignStudioProductAndAddToCartWeddingRingNewCustomer',
                            },
                            'arguments': [
                                {
                                    'kind': 'Argument',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                    'value': {
                                        'kind': 'Variable',
                                        'name': {
                                            'kind': 'Name',
                                            'value': 'input',
                                        },
                                    },
                                },
                                {
                                    'kind': 'Argument',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'customer',
                                    },
                                    'value': {
                                        'kind': 'Variable',
                                        'name': {
                                            'kind': 'Name',
                                            'value': 'customer',
                                        },
                                    },
                                },
                            ],
                            'selectionSet': {
                                'kind': 'SelectionSet',
                                'selections': [
                                    {
                                        'kind': 'FragmentSpread',
                                        'name': {
                                            'kind': 'Name',
                                            'value':
                                                'designStudioWeddingRingNewCustomerResponse',
                                        },
                                    },
                                ],
                            },
                        },
                    ],
                },
            },
            ...DesignStudioWeddingRingNewCustomerResponseFragmentDoc.definitions,
            ...DesignStudioWeddingRingSuccessNewCustomerFragmentDoc.definitions,
            ...CustomerRegistrationResponseFragmentDoc.definitions,
            ...LoginResponseSuccessFragmentDoc.definitions,
            ...MeFragmentDoc.definitions,
            ...CostumerConsultantFragmentDoc.definitions,
        ],
    } as unknown as DocumentNode

export function useCreateDesignStudioProductAndAddToCartWeddingRingNewCustomerMutation() {
    return Urql.useMutation<
        CreateDesignStudioProductAndAddToCartWeddingRingNewCustomerMutation,
        CreateDesignStudioProductAndAddToCartWeddingRingNewCustomerMutationVariables
    >(CreateDesignStudioProductAndAddToCartWeddingRingNewCustomerDocument)
}
export const SetOrderCollectFromShowroomInformationDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': {
                'kind': 'Name',
                'value': 'setOrderCollectFromShowroomInformation',
            },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CollectFromShowroomInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'setOrderCollectFromShowroomInformation',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'setDeliveryInformationResponse',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...SetDeliveryInformationResponseFragmentDoc.definitions,
        ...SetDeliveryInformationSuccessResponseFragmentDoc.definitions,
        ...OrderFragmentDoc.definitions,
        ...OrderProductFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...PaymentPlanFragmentDoc.definitions,
        ...PaymentPlanPaidRecordFragmentDoc.definitions,
        ...PaymentPlanUpcomingRecordFragmentDoc.definitions,
        ...TransactionInterfaceFragmentDoc.definitions,
        ...TransactionStatusFragmentDoc.definitions,
        ...PromoCodeFragmentDoc.definitions,
        ...PaymentMethodContainerFragmentDoc.definitions,
        ...NoPaymentMethodFragmentDoc.definitions,
        ...BankPaymentMethodFragmentDoc.definitions,
        ...AllocationPaymentMethodFragmentDoc.definitions,
        ...CheckoutcomPaymentMethodFragmentDoc.definitions,
        ...AffirmPaymentMethodFragmentDoc.definitions,
        ...KlarnaPaymentMethodFragmentDoc.definitions,
        ...ShowroomFragmentDoc.definitions,
        ...ShowroomLocationFragmentDoc.definitions,
        ...OrderAddressFragmentDoc.definitions,
        ...ShipmentTrackingInformationFragmentDoc.definitions,
        ...DeliveryTimeframeFragmentDoc.definitions,
        ...SetDeliveryInformationFailureResponseFragmentDoc.definitions,
        ...SetDeliveryInformationErrorFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useSetOrderCollectFromShowroomInformationMutation() {
    return Urql.useMutation<
        SetOrderCollectFromShowroomInformationMutation,
        SetOrderCollectFromShowroomInformationMutationVariables
    >(SetOrderCollectFromShowroomInformationDocument)
}
export const SetOrderDeliverToAddressInformationDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': {
                'kind': 'Name',
                'value': 'setOrderDeliverToAddressInformation',
            },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'DeliverToAddressInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'setOrderDeliverToAddressInformation',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'setDeliveryInformationResponse',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...SetDeliveryInformationResponseFragmentDoc.definitions,
        ...SetDeliveryInformationSuccessResponseFragmentDoc.definitions,
        ...OrderFragmentDoc.definitions,
        ...OrderProductFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...PaymentPlanFragmentDoc.definitions,
        ...PaymentPlanPaidRecordFragmentDoc.definitions,
        ...PaymentPlanUpcomingRecordFragmentDoc.definitions,
        ...TransactionInterfaceFragmentDoc.definitions,
        ...TransactionStatusFragmentDoc.definitions,
        ...PromoCodeFragmentDoc.definitions,
        ...PaymentMethodContainerFragmentDoc.definitions,
        ...NoPaymentMethodFragmentDoc.definitions,
        ...BankPaymentMethodFragmentDoc.definitions,
        ...AllocationPaymentMethodFragmentDoc.definitions,
        ...CheckoutcomPaymentMethodFragmentDoc.definitions,
        ...AffirmPaymentMethodFragmentDoc.definitions,
        ...KlarnaPaymentMethodFragmentDoc.definitions,
        ...ShowroomFragmentDoc.definitions,
        ...ShowroomLocationFragmentDoc.definitions,
        ...OrderAddressFragmentDoc.definitions,
        ...ShipmentTrackingInformationFragmentDoc.definitions,
        ...DeliveryTimeframeFragmentDoc.definitions,
        ...SetDeliveryInformationFailureResponseFragmentDoc.definitions,
        ...SetDeliveryInformationErrorFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useSetOrderDeliverToAddressInformationMutation() {
    return Urql.useMutation<
        SetOrderDeliverToAddressInformationMutation,
        SetOrderDeliverToAddressInformationMutationVariables
    >(SetOrderDeliverToAddressInformationDocument)
}
export const BlogDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'blog' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'path' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'String' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'page' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Int' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'limit' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Int' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'currency' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CurrencyInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'region' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'RegionCode' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'pageByPath' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'path' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': { 'kind': 'Name', 'value': 'path' },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': { 'kind': 'Name', 'value': 'page' },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'blogPosts' },
                    },
                ],
            },
        },
        ...PageFragmentDoc.definitions,
        ...BlockFragmentDoc.definitions,
        ...BlockAnchorFragmentDoc.definitions,
        ...ComponentFragmentDoc.definitions,
        ...ComponentRoundedImageFragmentDoc.definitions,
        ...ImageMediumFragmentDoc.definitions,
        ...ImageCommonFragmentDoc.definitions,
        ...ImageSizeFragmentDoc.definitions,
        ...ComponentRoundedImageContentFragmentDoc.definitions,
        ...ContentComponentItemFragmentDoc.definitions,
        ...ComponentTitleFragmentDoc.definitions,
        ...ComponentTitleComponentFragmentDoc.definitions,
        ...ComponentTitleAmpersandFragmentDoc.definitions,
        ...ComponentTitleTextFragmentDoc.definitions,
        ...ComponentTextFragmentDoc.definitions,
        ...ComponentButtonFragmentDoc.definitions,
        ...LinkFragmentDoc.definitions,
        ...LinkItemFragmentDoc.definitions,
        ...PageLinkFragmentDoc.definitions,
        ...PostLinkFragmentDoc.definitions,
        ...CustomLinkFragmentDoc.definitions,
        ...LinkQuestionnaireFragmentDoc.definitions,
        ...LinkItemOpenEnquiryFormFragmentDoc.definitions,
        ...LinkItemOpenContactFormFragmentDoc.definitions,
        ...LinkItemOpenSpeakToExpertModalFragmentDoc.definitions,
        ...ComponentSpacerFragmentDoc.definitions,
        ...ComponentImageFragmentDoc.definitions,
        ...ImageLargeFragmentDoc.definitions,
        ...ComponentOrderedListFragmentDoc.definitions,
        ...OrderedListItemFragmentDoc.definitions,
        ...ComponentContentFragmentDoc.definitions,
        ...ComponentCardFragmentDoc.definitions,
        ...ComponentTextOverImageFragmentDoc.definitions,
        ...ComponentCustomProductCarouselFragmentDoc.definitions,
        ...CustomProductCarouselCardFragmentDoc.definitions,
        ...ComponentCatalogueProductCarouselFragmentDoc.definitions,
        ...ProductCardFragmentDoc.definitions,
        ...ProductLinkFragmentDoc.definitions,
        ...EngagementRingLinkFragmentDoc.definitions,
        ...JewelleryLinkFragmentDoc.definitions,
        ...ReadyToGoRingLinkFragmentDoc.definitions,
        ...WeddingRingLinkFragmentDoc.definitions,
        ...MetalVariationFragmentDoc.definitions,
        ...MetalFilterMetalFragmentDoc.definitions,
        ...GetIsLabGrownFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...MonolithImageSizeFragmentDoc.definitions,
        ...ComponentReviewCarouselFragmentDoc.definitions,
        ...ComponentMainCoverFragmentDoc.definitions,
        ...ImageCoverFragmentDoc.definitions,
        ...ComponentVideoFragmentDoc.definitions,
        ...VideoFragmentDoc.definitions,
        ...ComponentVideoWithContentFragmentDoc.definitions,
        ...ComponentInstagramPostsFragmentDoc.definitions,
        ...ComponentLogosFragmentDoc.definitions,
        ...ComponentLogosCarouselFragmentDoc.definitions,
        ...ComponentTextWithImageFragmentDoc.definitions,
        ...ComponentGalleryCarouselFragmentDoc.definitions,
        ...GalleryCarouselCardFragmentDoc.definitions,
        ...ComponentCardCarouselFragmentDoc.definitions,
        ...CardCarouselCardFragmentDoc.definitions,
        ...ComponentFullWidthImageFragmentDoc.definitions,
        ...ComponentSideBySideImagesFragmentDoc.definitions,
        ...ComponentSideBySideImageFragmentDoc.definitions,
        ...ComponentArticlePreviewsFragmentDoc.definitions,
        ...ArticlePreviewFragmentDoc.definitions,
        ...ComponentInstagramWithContentFragmentDoc.definitions,
        ...ComponentBannerTitleFragmentDoc.definitions,
        ...ComponentQuoteFragmentDoc.definitions,
        ...ComponentBannerSkinnyFragmentDoc.definitions,
        ...ComponentGlobalSpacerFragmentDoc.definitions,
        ...ComponentTextWithImageCarouselFragmentDoc.definitions,
        ...ComponentContentWithGalleryFragmentDoc.definitions,
        ...ComponentIconCarouselFragmentDoc.definitions,
        ...ComponentTextCarouselFragmentDoc.definitions,
        ...ComponentFaqFragmentDoc.definitions,
        ...FaqSectionFragmentDoc.definitions,
        ...FaqQuestionFragmentDoc.definitions,
        ...ComponentContentTwoColumnsFragmentDoc.definitions,
        ...ComponentTableFragmentDoc.definitions,
        ...ComponentArticleGridFragmentDoc.definitions,
        ...ArticleGridItemFragmentDoc.definitions,
        ...ComponentOnThisPageFragmentDoc.definitions,
        ...ComponentGalleryWithEnquiryFragmentDoc.definitions,
        ...GalleryWithEnquiryCardFragmentDoc.definitions,
        ...ComponentSquareBoxesFragmentDoc.definitions,
        ...SquareBoxesFragmentDoc.definitions,
        ...SquareTextBoxFragmentDoc.definitions,
        ...SquareImageBoxFragmentDoc.definitions,
        ...ComponentShopWithConfidenceFragmentDoc.definitions,
        ...ComponentGlobalComponentFragmentDoc.definitions,
        ...MetaFragmentDoc.definitions,
        ...BlogPostsFragmentDoc.definitions,
        ...PostCategoriesFragmentDoc.definitions,
        ...BlogMenuFragmentDoc.definitions,
        ...BlogPostPreviewFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useBlogQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, BlogQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<BlogQuery, BlogQueryVariables | undefined>({
        query: BlogDocument,
        variables: undefined,
        ...options,
    })
}
export const PostsByCategoryDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'postsByCategory' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'slug' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'String' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'page' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Int' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'limit' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Int' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'postCategories' },
                    },
                    {
                        'kind': 'Field',
                        'alias': { 'kind': 'Name', 'value': 'collection' },
                        'name': {
                            'kind': 'Name',
                            'value': 'postCategoryBySlug',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'slug' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': { 'kind': 'Name', 'value': 'slug' },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'categoryPosts',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...PostCategoriesFragmentDoc.definitions,
        ...BlogMenuFragmentDoc.definitions,
        ...CategoryPostsFragmentDoc.definitions,
        ...BlogPostPreviewFragmentDoc.definitions,
        ...ImageLargeFragmentDoc.definitions,
        ...ImageCommonFragmentDoc.definitions,
        ...ImageSizeFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function usePostsByCategoryQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, PostsByCategoryQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<
        PostsByCategoryQuery,
        PostsByCategoryQueryVariables | undefined
    >({ query: PostsByCategoryDocument, variables: undefined, ...options })
}
export const PostsByTagDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'postsByTag' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'slug' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'String' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'page' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Int' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'limit' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Int' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'postCategories' },
                    },
                    {
                        'kind': 'Field',
                        'alias': { 'kind': 'Name', 'value': 'collection' },
                        'name': { 'kind': 'Name', 'value': 'postTagBySlug' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'slug' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': { 'kind': 'Name', 'value': 'slug' },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'tagPosts',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...PostCategoriesFragmentDoc.definitions,
        ...BlogMenuFragmentDoc.definitions,
        ...TagPostsFragmentDoc.definitions,
        ...BlogPostPreviewFragmentDoc.definitions,
        ...ImageLargeFragmentDoc.definitions,
        ...ImageCommonFragmentDoc.definitions,
        ...ImageSizeFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function usePostsByTagQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, PostsByTagQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<PostsByTagQuery, PostsByTagQueryVariables | undefined>(
        { query: PostsByTagDocument, variables: undefined, ...options }
    )
}
export const PageByPathDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'pageByPath' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'path' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'String' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'currency' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CurrencyInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'region' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'RegionCode' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'pageByPath' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'path' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': { 'kind': 'Name', 'value': 'path' },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': { 'kind': 'Name', 'value': 'page' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...PageFragmentDoc.definitions,
        ...BlockFragmentDoc.definitions,
        ...BlockAnchorFragmentDoc.definitions,
        ...ComponentFragmentDoc.definitions,
        ...ComponentRoundedImageFragmentDoc.definitions,
        ...ImageMediumFragmentDoc.definitions,
        ...ImageCommonFragmentDoc.definitions,
        ...ImageSizeFragmentDoc.definitions,
        ...ComponentRoundedImageContentFragmentDoc.definitions,
        ...ContentComponentItemFragmentDoc.definitions,
        ...ComponentTitleFragmentDoc.definitions,
        ...ComponentTitleComponentFragmentDoc.definitions,
        ...ComponentTitleAmpersandFragmentDoc.definitions,
        ...ComponentTitleTextFragmentDoc.definitions,
        ...ComponentTextFragmentDoc.definitions,
        ...ComponentButtonFragmentDoc.definitions,
        ...LinkFragmentDoc.definitions,
        ...LinkItemFragmentDoc.definitions,
        ...PageLinkFragmentDoc.definitions,
        ...PostLinkFragmentDoc.definitions,
        ...CustomLinkFragmentDoc.definitions,
        ...LinkQuestionnaireFragmentDoc.definitions,
        ...LinkItemOpenEnquiryFormFragmentDoc.definitions,
        ...LinkItemOpenContactFormFragmentDoc.definitions,
        ...LinkItemOpenSpeakToExpertModalFragmentDoc.definitions,
        ...ComponentSpacerFragmentDoc.definitions,
        ...ComponentImageFragmentDoc.definitions,
        ...ImageLargeFragmentDoc.definitions,
        ...ComponentOrderedListFragmentDoc.definitions,
        ...OrderedListItemFragmentDoc.definitions,
        ...ComponentContentFragmentDoc.definitions,
        ...ComponentCardFragmentDoc.definitions,
        ...ComponentTextOverImageFragmentDoc.definitions,
        ...ComponentCustomProductCarouselFragmentDoc.definitions,
        ...CustomProductCarouselCardFragmentDoc.definitions,
        ...ComponentCatalogueProductCarouselFragmentDoc.definitions,
        ...ProductCardFragmentDoc.definitions,
        ...ProductLinkFragmentDoc.definitions,
        ...EngagementRingLinkFragmentDoc.definitions,
        ...JewelleryLinkFragmentDoc.definitions,
        ...ReadyToGoRingLinkFragmentDoc.definitions,
        ...WeddingRingLinkFragmentDoc.definitions,
        ...MetalVariationFragmentDoc.definitions,
        ...MetalFilterMetalFragmentDoc.definitions,
        ...GetIsLabGrownFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...MonolithImageSizeFragmentDoc.definitions,
        ...ComponentReviewCarouselFragmentDoc.definitions,
        ...ComponentMainCoverFragmentDoc.definitions,
        ...ImageCoverFragmentDoc.definitions,
        ...ComponentVideoFragmentDoc.definitions,
        ...VideoFragmentDoc.definitions,
        ...ComponentVideoWithContentFragmentDoc.definitions,
        ...ComponentInstagramPostsFragmentDoc.definitions,
        ...ComponentLogosFragmentDoc.definitions,
        ...ComponentLogosCarouselFragmentDoc.definitions,
        ...ComponentTextWithImageFragmentDoc.definitions,
        ...ComponentGalleryCarouselFragmentDoc.definitions,
        ...GalleryCarouselCardFragmentDoc.definitions,
        ...ComponentCardCarouselFragmentDoc.definitions,
        ...CardCarouselCardFragmentDoc.definitions,
        ...ComponentFullWidthImageFragmentDoc.definitions,
        ...ComponentSideBySideImagesFragmentDoc.definitions,
        ...ComponentSideBySideImageFragmentDoc.definitions,
        ...ComponentArticlePreviewsFragmentDoc.definitions,
        ...ArticlePreviewFragmentDoc.definitions,
        ...ComponentInstagramWithContentFragmentDoc.definitions,
        ...ComponentBannerTitleFragmentDoc.definitions,
        ...ComponentQuoteFragmentDoc.definitions,
        ...ComponentBannerSkinnyFragmentDoc.definitions,
        ...ComponentGlobalSpacerFragmentDoc.definitions,
        ...ComponentTextWithImageCarouselFragmentDoc.definitions,
        ...ComponentContentWithGalleryFragmentDoc.definitions,
        ...ComponentIconCarouselFragmentDoc.definitions,
        ...ComponentTextCarouselFragmentDoc.definitions,
        ...ComponentFaqFragmentDoc.definitions,
        ...FaqSectionFragmentDoc.definitions,
        ...FaqQuestionFragmentDoc.definitions,
        ...ComponentContentTwoColumnsFragmentDoc.definitions,
        ...ComponentTableFragmentDoc.definitions,
        ...ComponentArticleGridFragmentDoc.definitions,
        ...ArticleGridItemFragmentDoc.definitions,
        ...ComponentOnThisPageFragmentDoc.definitions,
        ...ComponentGalleryWithEnquiryFragmentDoc.definitions,
        ...GalleryWithEnquiryCardFragmentDoc.definitions,
        ...ComponentSquareBoxesFragmentDoc.definitions,
        ...SquareBoxesFragmentDoc.definitions,
        ...SquareTextBoxFragmentDoc.definitions,
        ...SquareImageBoxFragmentDoc.definitions,
        ...ComponentShopWithConfidenceFragmentDoc.definitions,
        ...ComponentGlobalComponentFragmentDoc.definitions,
        ...MetaFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function usePageByPathQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, PageByPathQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<PageByPathQuery, PageByPathQueryVariables | undefined>(
        { query: PageByPathDocument, variables: undefined, ...options }
    )
}
export const TooltipDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'tooltip' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'path' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'String' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'tooltip' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'path' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': { 'kind': 'Name', 'value': 'path' },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'title',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'content',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'contentComponentItem',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...ContentComponentItemFragmentDoc.definitions,
        ...ComponentTitleFragmentDoc.definitions,
        ...ComponentTitleComponentFragmentDoc.definitions,
        ...ComponentTitleAmpersandFragmentDoc.definitions,
        ...ComponentTitleTextFragmentDoc.definitions,
        ...ComponentTextFragmentDoc.definitions,
        ...ComponentButtonFragmentDoc.definitions,
        ...LinkFragmentDoc.definitions,
        ...LinkItemFragmentDoc.definitions,
        ...PageLinkFragmentDoc.definitions,
        ...PostLinkFragmentDoc.definitions,
        ...CustomLinkFragmentDoc.definitions,
        ...LinkQuestionnaireFragmentDoc.definitions,
        ...LinkItemOpenEnquiryFormFragmentDoc.definitions,
        ...LinkItemOpenContactFormFragmentDoc.definitions,
        ...LinkItemOpenSpeakToExpertModalFragmentDoc.definitions,
        ...ComponentSpacerFragmentDoc.definitions,
        ...ComponentImageFragmentDoc.definitions,
        ...ImageLargeFragmentDoc.definitions,
        ...ImageCommonFragmentDoc.definitions,
        ...ImageSizeFragmentDoc.definitions,
        ...ComponentOrderedListFragmentDoc.definitions,
        ...OrderedListItemFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useTooltipQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, TooltipQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<TooltipQuery, TooltipQueryVariables | undefined>({
        query: TooltipDocument,
        variables: undefined,
        ...options,
    })
}
export const MagicLinkConsumeDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': { 'kind': 'Name', 'value': 'magicLinkConsume' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'MagicLinkConsume',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'isConsultant' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Boolean' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'magicLinkConsume' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                                {
                                    'kind': 'InlineFragment',
                                    'typeCondition': {
                                        'kind': 'NamedType',
                                        'name': {
                                            'kind': 'Name',
                                            'value': 'MagicLinkConsumeSuccess',
                                        },
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'login',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'loginResponseSuccess',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'InlineFragment',
                                    'typeCondition': {
                                        'kind': 'NamedType',
                                        'name': {
                                            'kind': 'Name',
                                            'value': 'MagicLinkConsumeError',
                                        },
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'message',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...LoginResponseSuccessFragmentDoc.definitions,
        ...MeFragmentDoc.definitions,
        ...CostumerConsultantFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useMagicLinkConsumeMutation() {
    return Urql.useMutation<
        MagicLinkConsumeMutation,
        MagicLinkConsumeMutationVariables
    >(MagicLinkConsumeDocument)
}
export const MagicLinkRequestDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': { 'kind': 'Name', 'value': 'magicLinkRequest' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'MagicLinkRequest',
                            },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'magicLinkRequest' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode

export function useMagicLinkRequestMutation() {
    return Urql.useMutation<
        MagicLinkRequestMutation,
        MagicLinkRequestMutationVariables
    >(MagicLinkRequestDocument)
}
export const ApplyPromoCodeDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': { 'kind': 'Name', 'value': 'applyPromoCode' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'promoCode' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'String' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'applyPromoCode' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': {
                                    'kind': 'Name',
                                    'value': 'promoCode',
                                },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'promoCode',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'promoCodeApplicationResult',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...PromoCodeApplicationResultFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useApplyPromoCodeMutation() {
    return Urql.useMutation<
        ApplyPromoCodeMutation,
        ApplyPromoCodeMutationVariables
    >(ApplyPromoCodeDocument)
}
export const CompleteAffirmTransactionPostIframeDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': {
                'kind': 'Name',
                'value': 'completeAffirmTransactionPostIframe',
            },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'AffirmCompleteTransactionInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'completeAffirmTransactionPostIframe',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'affirmCompleteTransactionResponse',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...AffirmCompleteTransactionResponseFragmentDoc.definitions,
        ...OrderFragmentDoc.definitions,
        ...OrderProductFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...PaymentPlanFragmentDoc.definitions,
        ...PaymentPlanPaidRecordFragmentDoc.definitions,
        ...PaymentPlanUpcomingRecordFragmentDoc.definitions,
        ...TransactionInterfaceFragmentDoc.definitions,
        ...TransactionStatusFragmentDoc.definitions,
        ...PromoCodeFragmentDoc.definitions,
        ...PaymentMethodContainerFragmentDoc.definitions,
        ...NoPaymentMethodFragmentDoc.definitions,
        ...BankPaymentMethodFragmentDoc.definitions,
        ...AllocationPaymentMethodFragmentDoc.definitions,
        ...CheckoutcomPaymentMethodFragmentDoc.definitions,
        ...AffirmPaymentMethodFragmentDoc.definitions,
        ...KlarnaPaymentMethodFragmentDoc.definitions,
        ...ShowroomFragmentDoc.definitions,
        ...ShowroomLocationFragmentDoc.definitions,
        ...OrderAddressFragmentDoc.definitions,
        ...ShipmentTrackingInformationFragmentDoc.definitions,
        ...DeliveryTimeframeFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useCompleteAffirmTransactionPostIframeMutation() {
    return Urql.useMutation<
        CompleteAffirmTransactionPostIframeMutation,
        CompleteAffirmTransactionPostIframeMutationVariables
    >(CompleteAffirmTransactionPostIframeDocument)
}
export const CreateAffirmTransactionDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': { 'kind': 'Name', 'value': 'createAffirmTransaction' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'AffirmTransactionInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'createAffirmTransaction',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'affirmTransaction',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...AffirmTransactionFragmentDoc.definitions,
        ...TransactionInterfaceFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...TransactionStatusFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useCreateAffirmTransactionMutation() {
    return Urql.useMutation<
        CreateAffirmTransactionMutation,
        CreateAffirmTransactionMutationVariables
    >(CreateAffirmTransactionDocument)
}
export const PayViaAffirmDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': { 'kind': 'Name', 'value': 'payViaAffirm' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'AffirmPaymentInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'payViaAffirm' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'affirmPaymentResponse',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...AffirmPaymentResponseFragmentDoc.definitions,
        ...OrderFragmentDoc.definitions,
        ...OrderProductFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...PaymentPlanFragmentDoc.definitions,
        ...PaymentPlanPaidRecordFragmentDoc.definitions,
        ...PaymentPlanUpcomingRecordFragmentDoc.definitions,
        ...TransactionInterfaceFragmentDoc.definitions,
        ...TransactionStatusFragmentDoc.definitions,
        ...PromoCodeFragmentDoc.definitions,
        ...PaymentMethodContainerFragmentDoc.definitions,
        ...NoPaymentMethodFragmentDoc.definitions,
        ...BankPaymentMethodFragmentDoc.definitions,
        ...AllocationPaymentMethodFragmentDoc.definitions,
        ...CheckoutcomPaymentMethodFragmentDoc.definitions,
        ...AffirmPaymentMethodFragmentDoc.definitions,
        ...KlarnaPaymentMethodFragmentDoc.definitions,
        ...ShowroomFragmentDoc.definitions,
        ...ShowroomLocationFragmentDoc.definitions,
        ...OrderAddressFragmentDoc.definitions,
        ...ShipmentTrackingInformationFragmentDoc.definitions,
        ...DeliveryTimeframeFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function usePayViaAffirmMutation() {
    return Urql.useMutation<
        PayViaAffirmMutation,
        PayViaAffirmMutationVariables
    >(PayViaAffirmDocument)
}
export const CreateAllocationTransactionDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': { 'kind': 'Name', 'value': 'createAllocationTransaction' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'AllocationTransactionInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'createAllocationTransaction',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'allocationTransaction',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...AllocationTransactionFragmentDoc.definitions,
        ...TransactionInterfaceFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...TransactionStatusFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useCreateAllocationTransactionMutation() {
    return Urql.useMutation<
        CreateAllocationTransactionMutation,
        CreateAllocationTransactionMutationVariables
    >(CreateAllocationTransactionDocument)
}
export const PayViaAllocationDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': { 'kind': 'Name', 'value': 'payViaAllocation' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': {
                            'kind': 'Name',
                            'value': 'allocationTransactionId',
                        },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'ID' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'payViaAllocation' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': {
                                    'kind': 'Name',
                                    'value': 'allocationTransactionId',
                                },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'allocationTransactionId',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'order',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...OrderFragmentDoc.definitions,
        ...OrderProductFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...PaymentPlanFragmentDoc.definitions,
        ...PaymentPlanPaidRecordFragmentDoc.definitions,
        ...PaymentPlanUpcomingRecordFragmentDoc.definitions,
        ...TransactionInterfaceFragmentDoc.definitions,
        ...TransactionStatusFragmentDoc.definitions,
        ...PromoCodeFragmentDoc.definitions,
        ...PaymentMethodContainerFragmentDoc.definitions,
        ...NoPaymentMethodFragmentDoc.definitions,
        ...BankPaymentMethodFragmentDoc.definitions,
        ...AllocationPaymentMethodFragmentDoc.definitions,
        ...CheckoutcomPaymentMethodFragmentDoc.definitions,
        ...AffirmPaymentMethodFragmentDoc.definitions,
        ...KlarnaPaymentMethodFragmentDoc.definitions,
        ...ShowroomFragmentDoc.definitions,
        ...ShowroomLocationFragmentDoc.definitions,
        ...OrderAddressFragmentDoc.definitions,
        ...ShipmentTrackingInformationFragmentDoc.definitions,
        ...DeliveryTimeframeFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function usePayViaAllocationMutation() {
    return Urql.useMutation<
        PayViaAllocationMutation,
        PayViaAllocationMutationVariables
    >(PayViaAllocationDocument)
}
export const CreateBankTransactionDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': { 'kind': 'Name', 'value': 'createBankTransaction' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'orderId' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'ID' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'createBankTransaction',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'orderId' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'orderId',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'bankTransaction',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...BankTransactionFragmentDoc.definitions,
        ...TransactionInterfaceFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...TransactionStatusFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useCreateBankTransactionMutation() {
    return Urql.useMutation<
        CreateBankTransactionMutation,
        CreateBankTransactionMutationVariables
    >(CreateBankTransactionDocument)
}
export const PayViaBankDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': { 'kind': 'Name', 'value': 'payViaBank' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': {
                            'kind': 'Name',
                            'value': 'bankTransactionId',
                        },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'ID' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'payViaBank' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': {
                                    'kind': 'Name',
                                    'value': 'bankTransactionId',
                                },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'bankTransactionId',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'order',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...OrderFragmentDoc.definitions,
        ...OrderProductFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...PaymentPlanFragmentDoc.definitions,
        ...PaymentPlanPaidRecordFragmentDoc.definitions,
        ...PaymentPlanUpcomingRecordFragmentDoc.definitions,
        ...TransactionInterfaceFragmentDoc.definitions,
        ...TransactionStatusFragmentDoc.definitions,
        ...PromoCodeFragmentDoc.definitions,
        ...PaymentMethodContainerFragmentDoc.definitions,
        ...NoPaymentMethodFragmentDoc.definitions,
        ...BankPaymentMethodFragmentDoc.definitions,
        ...AllocationPaymentMethodFragmentDoc.definitions,
        ...CheckoutcomPaymentMethodFragmentDoc.definitions,
        ...AffirmPaymentMethodFragmentDoc.definitions,
        ...KlarnaPaymentMethodFragmentDoc.definitions,
        ...ShowroomFragmentDoc.definitions,
        ...ShowroomLocationFragmentDoc.definitions,
        ...OrderAddressFragmentDoc.definitions,
        ...ShipmentTrackingInformationFragmentDoc.definitions,
        ...DeliveryTimeframeFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function usePayViaBankMutation() {
    return Urql.useMutation<PayViaBankMutation, PayViaBankMutationVariables>(
        PayViaBankDocument
    )
}
export const CompleteCheckoutcomTransactionPost3dsDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': {
                'kind': 'Name',
                'value': 'completeCheckoutcomTransactionPost3ds',
            },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CompleteCheckoutcomTransactionInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'completeCheckoutcomTransactionPost3ds',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                                {
                                    'kind': 'InlineFragment',
                                    'typeCondition': {
                                        'kind': 'NamedType',
                                        'name': {
                                            'kind': 'Name',
                                            'value':
                                                'CompleteCheckoutcomTransactionPost3dsFailureResponse',
                                        },
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'errors',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    '__typename',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'InlineFragment',
                                    'typeCondition': {
                                        'kind': 'NamedType',
                                        'name': {
                                            'kind': 'Name',
                                            'value':
                                                'CompleteCheckoutcomTransactionPost3dsSuccessResponse',
                                        },
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'order',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'order',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...OrderFragmentDoc.definitions,
        ...OrderProductFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...PaymentPlanFragmentDoc.definitions,
        ...PaymentPlanPaidRecordFragmentDoc.definitions,
        ...PaymentPlanUpcomingRecordFragmentDoc.definitions,
        ...TransactionInterfaceFragmentDoc.definitions,
        ...TransactionStatusFragmentDoc.definitions,
        ...PromoCodeFragmentDoc.definitions,
        ...PaymentMethodContainerFragmentDoc.definitions,
        ...NoPaymentMethodFragmentDoc.definitions,
        ...BankPaymentMethodFragmentDoc.definitions,
        ...AllocationPaymentMethodFragmentDoc.definitions,
        ...CheckoutcomPaymentMethodFragmentDoc.definitions,
        ...AffirmPaymentMethodFragmentDoc.definitions,
        ...KlarnaPaymentMethodFragmentDoc.definitions,
        ...ShowroomFragmentDoc.definitions,
        ...ShowroomLocationFragmentDoc.definitions,
        ...OrderAddressFragmentDoc.definitions,
        ...ShipmentTrackingInformationFragmentDoc.definitions,
        ...DeliveryTimeframeFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useCompleteCheckoutcomTransactionPost3dsMutation() {
    return Urql.useMutation<
        CompleteCheckoutcomTransactionPost3dsMutation,
        CompleteCheckoutcomTransactionPost3dsMutationVariables
    >(CompleteCheckoutcomTransactionPost3dsDocument)
}
export const CreateCheckoutcomTransactionDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': { 'kind': 'Name', 'value': 'createCheckoutcomTransaction' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CreateCheckoutcomTransactionInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'createCheckoutcomTransaction',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                                {
                                    'kind': 'InlineFragment',
                                    'typeCondition': {
                                        'kind': 'NamedType',
                                        'name': {
                                            'kind': 'Name',
                                            'value':
                                                'CreateCheckoutcomTransactionSuccessResponse',
                                        },
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'transaction',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'transactionInterface',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'InlineFragment',
                                    'typeCondition': {
                                        'kind': 'NamedType',
                                        'name': {
                                            'kind': 'Name',
                                            'value':
                                                'CreateCheckoutcomTransactionFailureResponse',
                                        },
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'errors',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    '__typename',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...TransactionInterfaceFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...TransactionStatusFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useCreateCheckoutcomTransactionMutation() {
    return Urql.useMutation<
        CreateCheckoutcomTransactionMutation,
        CreateCheckoutcomTransactionMutationVariables
    >(CreateCheckoutcomTransactionDocument)
}
export const PayViaCheckoutcomDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': { 'kind': 'Name', 'value': 'payViaCheckoutcom' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'PayViaCheckoutcomInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'payViaCheckoutcom',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                                {
                                    'kind': 'InlineFragment',
                                    'typeCondition': {
                                        'kind': 'NamedType',
                                        'name': {
                                            'kind': 'Name',
                                            'value':
                                                'PayViaCheckoutcomSuccessResponse',
                                        },
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'redirectUrl',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'order',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'order',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'InlineFragment',
                                    'typeCondition': {
                                        'kind': 'NamedType',
                                        'name': {
                                            'kind': 'Name',
                                            'value':
                                                'PayViaCheckoutcomFailureResponse',
                                        },
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'errors',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    '__typename',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...OrderFragmentDoc.definitions,
        ...OrderProductFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...PaymentPlanFragmentDoc.definitions,
        ...PaymentPlanPaidRecordFragmentDoc.definitions,
        ...PaymentPlanUpcomingRecordFragmentDoc.definitions,
        ...TransactionInterfaceFragmentDoc.definitions,
        ...TransactionStatusFragmentDoc.definitions,
        ...PromoCodeFragmentDoc.definitions,
        ...PaymentMethodContainerFragmentDoc.definitions,
        ...NoPaymentMethodFragmentDoc.definitions,
        ...BankPaymentMethodFragmentDoc.definitions,
        ...AllocationPaymentMethodFragmentDoc.definitions,
        ...CheckoutcomPaymentMethodFragmentDoc.definitions,
        ...AffirmPaymentMethodFragmentDoc.definitions,
        ...KlarnaPaymentMethodFragmentDoc.definitions,
        ...ShowroomFragmentDoc.definitions,
        ...ShowroomLocationFragmentDoc.definitions,
        ...OrderAddressFragmentDoc.definitions,
        ...ShipmentTrackingInformationFragmentDoc.definitions,
        ...DeliveryTimeframeFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function usePayViaCheckoutcomMutation() {
    return Urql.useMutation<
        PayViaCheckoutcomMutation,
        PayViaCheckoutcomMutationVariables
    >(PayViaCheckoutcomDocument)
}
export const CreateKlarnaTransactionDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': { 'kind': 'Name', 'value': 'createKlarnaTransaction' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'KlarnaTransactionInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'createKlarnaTransaction',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'klarnaTransaction',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...KlarnaTransactionFragmentDoc.definitions,
        ...TransactionInterfaceFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...TransactionStatusFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useCreateKlarnaTransactionMutation() {
    return Urql.useMutation<
        CreateKlarnaTransactionMutation,
        CreateKlarnaTransactionMutationVariables
    >(CreateKlarnaTransactionDocument)
}
export const PayViaKlarnaDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': { 'kind': 'Name', 'value': 'payViaKlarna' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'KlarnaPaymentInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'payViaKlarna' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'klarnaPaymentResponse',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...KlarnaPaymentResponseFragmentDoc.definitions,
        ...OrderFragmentDoc.definitions,
        ...OrderProductFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...PaymentPlanFragmentDoc.definitions,
        ...PaymentPlanPaidRecordFragmentDoc.definitions,
        ...PaymentPlanUpcomingRecordFragmentDoc.definitions,
        ...TransactionInterfaceFragmentDoc.definitions,
        ...TransactionStatusFragmentDoc.definitions,
        ...PromoCodeFragmentDoc.definitions,
        ...PaymentMethodContainerFragmentDoc.definitions,
        ...NoPaymentMethodFragmentDoc.definitions,
        ...BankPaymentMethodFragmentDoc.definitions,
        ...AllocationPaymentMethodFragmentDoc.definitions,
        ...CheckoutcomPaymentMethodFragmentDoc.definitions,
        ...AffirmPaymentMethodFragmentDoc.definitions,
        ...KlarnaPaymentMethodFragmentDoc.definitions,
        ...ShowroomFragmentDoc.definitions,
        ...ShowroomLocationFragmentDoc.definitions,
        ...OrderAddressFragmentDoc.definitions,
        ...ShipmentTrackingInformationFragmentDoc.definitions,
        ...DeliveryTimeframeFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function usePayViaKlarnaMutation() {
    return Urql.useMutation<
        PayViaKlarnaMutation,
        PayViaKlarnaMutationVariables
    >(PayViaKlarnaDocument)
}
export const PayViaNoPaymentDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': { 'kind': 'Name', 'value': 'payViaNoPayment' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'orderId' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'ID' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'payViaNoPayment' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'orderId' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'orderId',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'order',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...OrderFragmentDoc.definitions,
        ...OrderProductFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...PaymentPlanFragmentDoc.definitions,
        ...PaymentPlanPaidRecordFragmentDoc.definitions,
        ...PaymentPlanUpcomingRecordFragmentDoc.definitions,
        ...TransactionInterfaceFragmentDoc.definitions,
        ...TransactionStatusFragmentDoc.definitions,
        ...PromoCodeFragmentDoc.definitions,
        ...PaymentMethodContainerFragmentDoc.definitions,
        ...NoPaymentMethodFragmentDoc.definitions,
        ...BankPaymentMethodFragmentDoc.definitions,
        ...AllocationPaymentMethodFragmentDoc.definitions,
        ...CheckoutcomPaymentMethodFragmentDoc.definitions,
        ...AffirmPaymentMethodFragmentDoc.definitions,
        ...KlarnaPaymentMethodFragmentDoc.definitions,
        ...ShowroomFragmentDoc.definitions,
        ...ShowroomLocationFragmentDoc.definitions,
        ...OrderAddressFragmentDoc.definitions,
        ...ShipmentTrackingInformationFragmentDoc.definitions,
        ...DeliveryTimeframeFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function usePayViaNoPaymentMutation() {
    return Urql.useMutation<
        PayViaNoPaymentMutation,
        PayViaNoPaymentMutationVariables
    >(PayViaNoPaymentDocument)
}
export const RemoveFromMyCartDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': { 'kind': 'Name', 'value': 'removeFromMyCart' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'productId' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'ID' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'removeFromMyCart' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': {
                                    'kind': 'Name',
                                    'value': 'productId',
                                },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productId',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'order',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...OrderFragmentDoc.definitions,
        ...OrderProductFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...PaymentPlanFragmentDoc.definitions,
        ...PaymentPlanPaidRecordFragmentDoc.definitions,
        ...PaymentPlanUpcomingRecordFragmentDoc.definitions,
        ...TransactionInterfaceFragmentDoc.definitions,
        ...TransactionStatusFragmentDoc.definitions,
        ...PromoCodeFragmentDoc.definitions,
        ...PaymentMethodContainerFragmentDoc.definitions,
        ...NoPaymentMethodFragmentDoc.definitions,
        ...BankPaymentMethodFragmentDoc.definitions,
        ...AllocationPaymentMethodFragmentDoc.definitions,
        ...CheckoutcomPaymentMethodFragmentDoc.definitions,
        ...AffirmPaymentMethodFragmentDoc.definitions,
        ...KlarnaPaymentMethodFragmentDoc.definitions,
        ...ShowroomFragmentDoc.definitions,
        ...ShowroomLocationFragmentDoc.definitions,
        ...OrderAddressFragmentDoc.definitions,
        ...ShipmentTrackingInformationFragmentDoc.definitions,
        ...DeliveryTimeframeFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useRemoveFromMyCartMutation() {
    return Urql.useMutation<
        RemoveFromMyCartMutation,
        RemoveFromMyCartMutationVariables
    >(RemoveFromMyCartDocument)
}
export const DesignStudioUploadDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': { 'kind': 'Name', 'value': 'designStudioUpload' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'file' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Upload' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'createDesignInspiration',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'file' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': { 'kind': 'Name', 'value': 'file' },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'url' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode

export function useDesignStudioUploadMutation() {
    return Urql.useMutation<
        DesignStudioUploadMutation,
        DesignStudioUploadMutationVariables
    >(DesignStudioUploadDocument)
}
export const QuestionnaireCompleteExistingCustomerDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': {
                'kind': 'Name',
                'value': 'questionnaireCompleteExistingCustomer',
            },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'QuestionnaireCompleteInput',
                            },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'questionnaireCompleteExistingCustomer',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode

export function useQuestionnaireCompleteExistingCustomerMutation() {
    return Urql.useMutation<
        QuestionnaireCompleteExistingCustomerMutation,
        QuestionnaireCompleteExistingCustomerMutationVariables
    >(QuestionnaireCompleteExistingCustomerDocument)
}
export const QuestionnaireCompleteNewCustomerDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': {
                'kind': 'Name',
                'value': 'questionnaireCompleteNewCustomer',
            },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'QuestionnaireCompleteInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'customer' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CustomerRegistrationInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'isConsultant' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Boolean' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'questionnaireCompleteNewCustomer',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'customer' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'customer',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'customer',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'customerRegistrationResponse',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...CustomerRegistrationResponseFragmentDoc.definitions,
        ...LoginResponseSuccessFragmentDoc.definitions,
        ...MeFragmentDoc.definitions,
        ...CostumerConsultantFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useQuestionnaireCompleteNewCustomerMutation() {
    return Urql.useMutation<
        QuestionnaireCompleteNewCustomerMutation,
        QuestionnaireCompleteNewCustomerMutationVariables
    >(QuestionnaireCompleteNewCustomerDocument)
}
export const RingBuilderResolveExistingCustomerDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': {
                'kind': 'Name',
                'value': 'ringBuilderResolveExistingCustomer',
            },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'RingBuilderResolveInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'currency' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CurrencyInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'region' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'RegionCode' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'ringBuilderResolveExistingCustomer',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                                {
                                    'kind': 'InlineFragment',
                                    'typeCondition': {
                                        'kind': 'NamedType',
                                        'name': {
                                            'kind': 'Name',
                                            'value':
                                                'RingBuilderResolvedExistingCustomerSuccess',
                                        },
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'ringBuilder',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'rb',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'redirect',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...RbFragmentDoc.definitions,
        ...RingBuilderFragmentFragmentDoc.definitions,
        ...RingBuilderMountFragmentFragmentDoc.definitions,
        ...RingBuilderMountEngagementRingFragmentDoc.definitions,
        ...EngagementRingLinkFragmentDoc.definitions,
        ...CatalogueEngagementRingInputFragmentDoc.definitions,
        ...MonolithImageSizeFragmentDoc.definitions,
        ...RecommendedRingSizeFragmentDoc.definitions,
        ...RingSizeFragmentDoc.definitions,
        ...ProductPageMetaFragmentDoc.definitions,
        ...AssetFragmentDoc.definitions,
        ...MetalFilterMetalFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...SignatureStoneInputFragmentDoc.definitions,
        ...RingBuilderCentreStoneFragmentFragmentDoc.definitions,
        ...StoneFragmentDoc.definitions,
        ...StoneCategoryFragmentDoc.definitions,
        ...StoneCategoryTranslationFragmentDoc.definitions,
        ...StoneClarityFragmentDoc.definitions,
        ...ClarityTranslationFragmentDoc.definitions,
        ...StoneColorFragmentDoc.definitions,
        ...StoneColorTranslationFragmentDoc.definitions,
        ...StoneImageFragmentDoc.definitions,
        ...GemsApiCertificateFragmentDoc.definitions,
        ...GemsApiStoneAnalyticsFragmentDoc.definitions,
        ...NonSkuGemstoneFragmentDoc.definitions,
        ...StoneShapeFragmentDoc.definitions,
        ...StoneShapeTranslationFragmentDoc.definitions,
        ...StoneCutFragmentDoc.definitions,
        ...StoneCutTranslationFragmentDoc.definitions,
        ...StoneCrystalFragmentDoc.definitions,
        ...StoneCrystalTranslationFragmentDoc.definitions,
        ...StoneGradeFragmentDoc.definitions,
        ...NonSkuGemstoneImageFragmentDoc.definitions,
        ...NonSkuLabGrownFragmentDoc.definitions,
        ...NonSkuLabGrownStoneImageFragmentDoc.definitions,
        ...NonSkuGemstoneAnalyticsFragmentDoc.definitions,
        ...NonSkuLabGrownAnalyticsFragmentDoc.definitions,
        ...TaxSnippetFragmentDoc.definitions,
        ...AffirmFinanceOptionsFragmentDoc.definitions,
        ...KlarnaFinanceOptionsFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useRingBuilderResolveExistingCustomerMutation() {
    return Urql.useMutation<
        RingBuilderResolveExistingCustomerMutation,
        RingBuilderResolveExistingCustomerMutationVariables
    >(RingBuilderResolveExistingCustomerDocument)
}
export const RingBuilderResolveNewCustomerDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': {
                'kind': 'Name',
                'value': 'ringBuilderResolveNewCustomer',
            },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'RingBuilderResolveInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'customer' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CustomerRegistrationInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'currency' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CurrencyInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'region' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'RegionCode' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'isConsultant' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Boolean' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'ringBuilderResolveNewCustomer',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'customer' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'customer',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                                {
                                    'kind': 'InlineFragment',
                                    'typeCondition': {
                                        'kind': 'NamedType',
                                        'name': {
                                            'kind': 'Name',
                                            'value':
                                                'RingBuilderResolvedNewCustomerSuccess',
                                        },
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'customer',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'customerRegistrationResponse',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'ringBuilder',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'rb',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'redirect',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...CustomerRegistrationResponseFragmentDoc.definitions,
        ...LoginResponseSuccessFragmentDoc.definitions,
        ...MeFragmentDoc.definitions,
        ...CostumerConsultantFragmentDoc.definitions,
        ...RbFragmentDoc.definitions,
        ...RingBuilderFragmentFragmentDoc.definitions,
        ...RingBuilderMountFragmentFragmentDoc.definitions,
        ...RingBuilderMountEngagementRingFragmentDoc.definitions,
        ...EngagementRingLinkFragmentDoc.definitions,
        ...CatalogueEngagementRingInputFragmentDoc.definitions,
        ...MonolithImageSizeFragmentDoc.definitions,
        ...RecommendedRingSizeFragmentDoc.definitions,
        ...RingSizeFragmentDoc.definitions,
        ...ProductPageMetaFragmentDoc.definitions,
        ...AssetFragmentDoc.definitions,
        ...MetalFilterMetalFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...SignatureStoneInputFragmentDoc.definitions,
        ...RingBuilderCentreStoneFragmentFragmentDoc.definitions,
        ...StoneFragmentDoc.definitions,
        ...StoneCategoryFragmentDoc.definitions,
        ...StoneCategoryTranslationFragmentDoc.definitions,
        ...StoneClarityFragmentDoc.definitions,
        ...ClarityTranslationFragmentDoc.definitions,
        ...StoneColorFragmentDoc.definitions,
        ...StoneColorTranslationFragmentDoc.definitions,
        ...StoneImageFragmentDoc.definitions,
        ...GemsApiCertificateFragmentDoc.definitions,
        ...GemsApiStoneAnalyticsFragmentDoc.definitions,
        ...NonSkuGemstoneFragmentDoc.definitions,
        ...StoneShapeFragmentDoc.definitions,
        ...StoneShapeTranslationFragmentDoc.definitions,
        ...StoneCutFragmentDoc.definitions,
        ...StoneCutTranslationFragmentDoc.definitions,
        ...StoneCrystalFragmentDoc.definitions,
        ...StoneCrystalTranslationFragmentDoc.definitions,
        ...StoneGradeFragmentDoc.definitions,
        ...NonSkuGemstoneImageFragmentDoc.definitions,
        ...NonSkuLabGrownFragmentDoc.definitions,
        ...NonSkuLabGrownStoneImageFragmentDoc.definitions,
        ...NonSkuGemstoneAnalyticsFragmentDoc.definitions,
        ...NonSkuLabGrownAnalyticsFragmentDoc.definitions,
        ...TaxSnippetFragmentDoc.definitions,
        ...AffirmFinanceOptionsFragmentDoc.definitions,
        ...KlarnaFinanceOptionsFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useRingBuilderResolveNewCustomerMutation() {
    return Urql.useMutation<
        RingBuilderResolveNewCustomerMutation,
        RingBuilderResolveNewCustomerMutationVariables
    >(RingBuilderResolveNewCustomerDocument)
}
export const RingBuilderSetDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': { 'kind': 'Name', 'value': 'ringBuilderSet' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'RingBuilderInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'currency' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CurrencyInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'region' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'RegionCode' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'ringBuilderSet' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'ringBuilder',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'rb',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...RbFragmentDoc.definitions,
        ...RingBuilderFragmentFragmentDoc.definitions,
        ...RingBuilderMountFragmentFragmentDoc.definitions,
        ...RingBuilderMountEngagementRingFragmentDoc.definitions,
        ...EngagementRingLinkFragmentDoc.definitions,
        ...CatalogueEngagementRingInputFragmentDoc.definitions,
        ...MonolithImageSizeFragmentDoc.definitions,
        ...RecommendedRingSizeFragmentDoc.definitions,
        ...RingSizeFragmentDoc.definitions,
        ...ProductPageMetaFragmentDoc.definitions,
        ...AssetFragmentDoc.definitions,
        ...MetalFilterMetalFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...SignatureStoneInputFragmentDoc.definitions,
        ...RingBuilderCentreStoneFragmentFragmentDoc.definitions,
        ...StoneFragmentDoc.definitions,
        ...StoneCategoryFragmentDoc.definitions,
        ...StoneCategoryTranslationFragmentDoc.definitions,
        ...StoneClarityFragmentDoc.definitions,
        ...ClarityTranslationFragmentDoc.definitions,
        ...StoneColorFragmentDoc.definitions,
        ...StoneColorTranslationFragmentDoc.definitions,
        ...StoneImageFragmentDoc.definitions,
        ...GemsApiCertificateFragmentDoc.definitions,
        ...GemsApiStoneAnalyticsFragmentDoc.definitions,
        ...NonSkuGemstoneFragmentDoc.definitions,
        ...StoneShapeFragmentDoc.definitions,
        ...StoneShapeTranslationFragmentDoc.definitions,
        ...StoneCutFragmentDoc.definitions,
        ...StoneCutTranslationFragmentDoc.definitions,
        ...StoneCrystalFragmentDoc.definitions,
        ...StoneCrystalTranslationFragmentDoc.definitions,
        ...StoneGradeFragmentDoc.definitions,
        ...NonSkuGemstoneImageFragmentDoc.definitions,
        ...NonSkuLabGrownFragmentDoc.definitions,
        ...NonSkuLabGrownStoneImageFragmentDoc.definitions,
        ...NonSkuGemstoneAnalyticsFragmentDoc.definitions,
        ...NonSkuLabGrownAnalyticsFragmentDoc.definitions,
        ...TaxSnippetFragmentDoc.definitions,
        ...AffirmFinanceOptionsFragmentDoc.definitions,
        ...KlarnaFinanceOptionsFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useRingBuilderSetMutation() {
    return Urql.useMutation<
        RingBuilderSetMutation,
        RingBuilderSetMutationVariables
    >(RingBuilderSetDocument)
}
export const CreateEnquiryCustomEngagementRingExistingCustomerDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': {
                'kind': 'Name',
                'value': 'createEnquiryCustomEngagementRingExistingCustomer',
            },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'EnquiryCustomEngagementRing',
                            },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value':
                                'createEnquiryCustomEngagementRingExistingCustomer',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode

export function useCreateEnquiryCustomEngagementRingExistingCustomerMutation() {
    return Urql.useMutation<
        CreateEnquiryCustomEngagementRingExistingCustomerMutation,
        CreateEnquiryCustomEngagementRingExistingCustomerMutationVariables
    >(CreateEnquiryCustomEngagementRingExistingCustomerDocument)
}
export const CreateEnquiryCustomEngagementRingNewCustomerDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': {
                'kind': 'Name',
                'value': 'createEnquiryCustomEngagementRingNewCustomer',
            },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'EnquiryCustomEngagementRing',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'customer' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CustomerRegistrationInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'isConsultant' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Boolean' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value':
                                'createEnquiryCustomEngagementRingNewCustomer',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'customer' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'customer',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'enquiryResponseNewCustomer',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...EnquiryResponseNewCustomerFragmentDoc.definitions,
        ...CustomerRegistrationResponseFragmentDoc.definitions,
        ...LoginResponseSuccessFragmentDoc.definitions,
        ...MeFragmentDoc.definitions,
        ...CostumerConsultantFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useCreateEnquiryCustomEngagementRingNewCustomerMutation() {
    return Urql.useMutation<
        CreateEnquiryCustomEngagementRingNewCustomerMutation,
        CreateEnquiryCustomEngagementRingNewCustomerMutationVariables
    >(CreateEnquiryCustomEngagementRingNewCustomerDocument)
}
export const CreateShapeEnquiryEngagementRingCollectionExistingCustomerDocument =
    {
        'kind': 'Document',
        'definitions': [
            {
                'kind': 'OperationDefinition',
                'operation': 'mutation',
                'name': {
                    'kind': 'Name',
                    'value':
                        'createShapeEnquiryEngagementRingCollectionExistingCustomer',
                },
                'variableDefinitions': [
                    {
                        'kind': 'VariableDefinition',
                        'variable': {
                            'kind': 'Variable',
                            'name': { 'kind': 'Name', 'value': 'input' },
                        },
                        'type': {
                            'kind': 'NonNullType',
                            'type': {
                                'kind': 'NamedType',
                                'name': {
                                    'kind': 'Name',
                                    'value':
                                        'EnquiryEngagementRingCollectionInput',
                                },
                            },
                        },
                    },
                ],
                'selectionSet': {
                    'kind': 'SelectionSet',
                    'selections': [
                        {
                            'kind': 'Field',
                            'name': {
                                'kind': 'Name',
                                'value':
                                    'createEnquiryEngagementRingPreferAnotherShapeExistingCustomer',
                            },
                            'arguments': [
                                {
                                    'kind': 'Argument',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                    'value': {
                                        'kind': 'Variable',
                                        'name': {
                                            'kind': 'Name',
                                            'value': 'input',
                                        },
                                    },
                                },
                            ],
                            'selectionSet': {
                                'kind': 'SelectionSet',
                                'selections': [
                                    {
                                        'kind': 'Field',
                                        'name': {
                                            'kind': 'Name',
                                            'value': '__typename',
                                        },
                                    },
                                ],
                            },
                        },
                    ],
                },
            },
        ],
    } as unknown as DocumentNode

export function useCreateShapeEnquiryEngagementRingCollectionExistingCustomerMutation() {
    return Urql.useMutation<
        CreateShapeEnquiryEngagementRingCollectionExistingCustomerMutation,
        CreateShapeEnquiryEngagementRingCollectionExistingCustomerMutationVariables
    >(CreateShapeEnquiryEngagementRingCollectionExistingCustomerDocument)
}
export const CreateShapeEnquiryEngagementRingCollectionNewCustomerDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': {
                'kind': 'Name',
                'value':
                    'createShapeEnquiryEngagementRingCollectionNewCustomer',
            },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'EnquiryEngagementRingCollectionInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'customer' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CustomerRegistrationInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'isConsultant' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Boolean' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value':
                                'createEnquiryEngagementRingPreferAnotherShapeNewCustomer',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'customer' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'customer',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'enquiryResponseNewCustomer',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...EnquiryResponseNewCustomerFragmentDoc.definitions,
        ...CustomerRegistrationResponseFragmentDoc.definitions,
        ...LoginResponseSuccessFragmentDoc.definitions,
        ...MeFragmentDoc.definitions,
        ...CostumerConsultantFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useCreateShapeEnquiryEngagementRingCollectionNewCustomerMutation() {
    return Urql.useMutation<
        CreateShapeEnquiryEngagementRingCollectionNewCustomerMutation,
        CreateShapeEnquiryEngagementRingCollectionNewCustomerMutationVariables
    >(CreateShapeEnquiryEngagementRingCollectionNewCustomerDocument)
}
export const CreateDiamondSearchProductEnquiryExistingCustomerDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': {
                'kind': 'Name',
                'value': 'createDiamondSearchProductEnquiryExistingCustomer',
            },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'EnquiryDiamondSearchProduct',
                            },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value':
                                'createEnquiryDiamondSearchProductExistingCustomer',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode

export function useCreateDiamondSearchProductEnquiryExistingCustomerMutation() {
    return Urql.useMutation<
        CreateDiamondSearchProductEnquiryExistingCustomerMutation,
        CreateDiamondSearchProductEnquiryExistingCustomerMutationVariables
    >(CreateDiamondSearchProductEnquiryExistingCustomerDocument)
}
export const CreateDiamondSearchProductEnquiryNewCustomerDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'mutation',
            'name': {
                'kind': 'Name',
                'value': 'createDiamondSearchProductEnquiryNewCustomer',
            },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'input' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'EnquiryDiamondSearchProduct',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'customer' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CustomerRegistrationInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'isConsultant' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Boolean' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value':
                                'createEnquiryDiamondSearchProductNewCustomer',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'input',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'customer' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'customer',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'enquiryResponseNewCustomer',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...EnquiryResponseNewCustomerFragmentDoc.definitions,
        ...CustomerRegistrationResponseFragmentDoc.definitions,
        ...LoginResponseSuccessFragmentDoc.definitions,
        ...MeFragmentDoc.definitions,
        ...CostumerConsultantFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useCreateDiamondSearchProductEnquiryNewCustomerMutation() {
    return Urql.useMutation<
        CreateDiamondSearchProductEnquiryNewCustomerMutation,
        CreateDiamondSearchProductEnquiryNewCustomerMutationVariables
    >(CreateDiamondSearchProductEnquiryNewCustomerDocument)
}
export const QuestionnaireDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'questionnaire' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'id' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'ID' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'currency' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CurrencyInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'region' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'RegionCode' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'questionnaire' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'id' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'questionnaire',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...QuestionnaireFragmentDoc.definitions,
        ...QuestionnaireStepFragmentDoc.definitions,
        ...QuestionnaireStepContentContentFragmentDoc.definitions,
        ...BlockFragmentDoc.definitions,
        ...BlockAnchorFragmentDoc.definitions,
        ...ComponentFragmentDoc.definitions,
        ...ComponentRoundedImageFragmentDoc.definitions,
        ...ImageMediumFragmentDoc.definitions,
        ...ImageCommonFragmentDoc.definitions,
        ...ImageSizeFragmentDoc.definitions,
        ...ComponentRoundedImageContentFragmentDoc.definitions,
        ...ContentComponentItemFragmentDoc.definitions,
        ...ComponentTitleFragmentDoc.definitions,
        ...ComponentTitleComponentFragmentDoc.definitions,
        ...ComponentTitleAmpersandFragmentDoc.definitions,
        ...ComponentTitleTextFragmentDoc.definitions,
        ...ComponentTextFragmentDoc.definitions,
        ...ComponentButtonFragmentDoc.definitions,
        ...LinkFragmentDoc.definitions,
        ...LinkItemFragmentDoc.definitions,
        ...PageLinkFragmentDoc.definitions,
        ...PostLinkFragmentDoc.definitions,
        ...CustomLinkFragmentDoc.definitions,
        ...LinkQuestionnaireFragmentDoc.definitions,
        ...LinkItemOpenEnquiryFormFragmentDoc.definitions,
        ...LinkItemOpenContactFormFragmentDoc.definitions,
        ...LinkItemOpenSpeakToExpertModalFragmentDoc.definitions,
        ...ComponentSpacerFragmentDoc.definitions,
        ...ComponentImageFragmentDoc.definitions,
        ...ImageLargeFragmentDoc.definitions,
        ...ComponentOrderedListFragmentDoc.definitions,
        ...OrderedListItemFragmentDoc.definitions,
        ...ComponentContentFragmentDoc.definitions,
        ...ComponentCardFragmentDoc.definitions,
        ...ComponentTextOverImageFragmentDoc.definitions,
        ...ComponentCustomProductCarouselFragmentDoc.definitions,
        ...CustomProductCarouselCardFragmentDoc.definitions,
        ...ComponentCatalogueProductCarouselFragmentDoc.definitions,
        ...ProductCardFragmentDoc.definitions,
        ...ProductLinkFragmentDoc.definitions,
        ...EngagementRingLinkFragmentDoc.definitions,
        ...JewelleryLinkFragmentDoc.definitions,
        ...ReadyToGoRingLinkFragmentDoc.definitions,
        ...WeddingRingLinkFragmentDoc.definitions,
        ...MetalVariationFragmentDoc.definitions,
        ...MetalFilterMetalFragmentDoc.definitions,
        ...GetIsLabGrownFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...MonolithImageSizeFragmentDoc.definitions,
        ...ComponentReviewCarouselFragmentDoc.definitions,
        ...ComponentMainCoverFragmentDoc.definitions,
        ...ImageCoverFragmentDoc.definitions,
        ...ComponentVideoFragmentDoc.definitions,
        ...VideoFragmentDoc.definitions,
        ...ComponentVideoWithContentFragmentDoc.definitions,
        ...ComponentInstagramPostsFragmentDoc.definitions,
        ...ComponentLogosFragmentDoc.definitions,
        ...ComponentLogosCarouselFragmentDoc.definitions,
        ...ComponentTextWithImageFragmentDoc.definitions,
        ...ComponentGalleryCarouselFragmentDoc.definitions,
        ...GalleryCarouselCardFragmentDoc.definitions,
        ...ComponentCardCarouselFragmentDoc.definitions,
        ...CardCarouselCardFragmentDoc.definitions,
        ...ComponentFullWidthImageFragmentDoc.definitions,
        ...ComponentSideBySideImagesFragmentDoc.definitions,
        ...ComponentSideBySideImageFragmentDoc.definitions,
        ...ComponentArticlePreviewsFragmentDoc.definitions,
        ...ArticlePreviewFragmentDoc.definitions,
        ...ComponentInstagramWithContentFragmentDoc.definitions,
        ...ComponentBannerTitleFragmentDoc.definitions,
        ...ComponentQuoteFragmentDoc.definitions,
        ...ComponentBannerSkinnyFragmentDoc.definitions,
        ...ComponentGlobalSpacerFragmentDoc.definitions,
        ...ComponentTextWithImageCarouselFragmentDoc.definitions,
        ...ComponentContentWithGalleryFragmentDoc.definitions,
        ...ComponentIconCarouselFragmentDoc.definitions,
        ...ComponentTextCarouselFragmentDoc.definitions,
        ...ComponentFaqFragmentDoc.definitions,
        ...FaqSectionFragmentDoc.definitions,
        ...FaqQuestionFragmentDoc.definitions,
        ...ComponentContentTwoColumnsFragmentDoc.definitions,
        ...ComponentTableFragmentDoc.definitions,
        ...ComponentArticleGridFragmentDoc.definitions,
        ...ArticleGridItemFragmentDoc.definitions,
        ...ComponentOnThisPageFragmentDoc.definitions,
        ...ComponentGalleryWithEnquiryFragmentDoc.definitions,
        ...GalleryWithEnquiryCardFragmentDoc.definitions,
        ...ComponentSquareBoxesFragmentDoc.definitions,
        ...SquareBoxesFragmentDoc.definitions,
        ...SquareTextBoxFragmentDoc.definitions,
        ...SquareImageBoxFragmentDoc.definitions,
        ...ComponentShopWithConfidenceFragmentDoc.definitions,
        ...ComponentGlobalComponentFragmentDoc.definitions,
        ...QuestionnaireConditionFragmentDoc.definitions,
        ...QuestionnaireConditionIsEmptyFragmentDoc.definitions,
        ...QuestionnaireConditionIsEqualToFragmentDoc.definitions,
        ...QuestionnaireConditionIsGreaterThanFragmentDoc.definitions,
        ...QuestionnaireConditionIsLessThanFragmentDoc.definitions,
        ...QuestionnaireConditionIsNotEmptyFragmentDoc.definitions,
        ...QuestionnaireConditionNotIsEqualToFragmentDoc.definitions,
        ...QuestionnaireConditionEqualToChoiceFragmentDoc.definitions,
        ...QuestionnaireStepContentQuestionsFragmentDoc.definitions,
        ...QuestionnaireQuestionFragmentDoc.definitions,
        ...QuestionnaireQuestionChoiceFragmentDoc.definitions,
        ...QuestionnaireQuestionChoiceOptionFragmentDoc.definitions,
        ...QuestionnaireQuestionChoiceOptionContentFragmentDoc.definitions,
        ...QuestionnaireQuestionChoiceOptionContentImageCardFragmentDoc.definitions,
        ...QuestionnaireQuestionChoiceOptionContentImageCardConditionalFragmentDoc.definitions,
        ...QuestionnaireQuestionChoiceOptionContentIconCardFragmentDoc.definitions,
        ...QuestionnaireQuestionChoiceOptionContentIconCardConditionalFragmentDoc.definitions,
        ...QuestionnaireQuestionChoiceOptionContentImageFragmentDoc.definitions,
        ...QuestionnaireQuestionChoiceOptionContentImageConditionalFragmentDoc.definitions,
        ...QuestionnaireQuestionChoiceOptionContentTextFragmentDoc.definitions,
        ...QuestionnaireQuestionChoiceOptionContentTextConditionalFragmentDoc.definitions,
        ...QuestionnaireQuestionChoiceOptionBehaviourFragmentDoc.definitions,
        ...QuestionnaireQuestionPriceFragmentDoc.definitions,
        ...QuestionnaireQuestionTextFragmentDoc.definitions,
        ...QuestionnaireSignUpStepFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useQuestionnaireQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, QuestionnaireQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<
        QuestionnaireQuery,
        QuestionnaireQueryVariables | undefined
    >({ query: QuestionnaireDocument, variables: undefined, ...options })
}
export const GemsFindStonesDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'GemsFindStones' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'filters' },
                    },
                    'type': {
                        'kind': 'NamedType',
                        'name': {
                            'kind': 'Name',
                            'value': 'GemsApi_StoneFilters',
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'market' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'String' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'categories' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'ListType',
                            'type': {
                                'kind': 'NonNullType',
                                'type': {
                                    'kind': 'NamedType',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'GemsApi_StoneCategory',
                                    },
                                },
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'notClarity' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'ListType',
                            'type': {
                                'kind': 'NonNullType',
                                'type': {
                                    'kind': 'NamedType',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'GemsApi_StoneClarity',
                                    },
                                },
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'notColour' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'ListType',
                            'type': {
                                'kind': 'NonNullType',
                                'type': {
                                    'kind': 'NamedType',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'GemsApi_StoneColour',
                                    },
                                },
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'notSymmetry' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'ListType',
                            'type': {
                                'kind': 'NonNullType',
                                'type': {
                                    'kind': 'NamedType',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'GemsApi_StoneSymmetry',
                                    },
                                },
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'currency' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CurrencyInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'region' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'RegionCode' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'getBound' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Boolean' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'getStones' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Boolean' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'isConsultant' },
                    },
                    'type': {
                        'kind': 'NamedType',
                        'name': { 'kind': 'Name', 'value': 'Boolean' },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'contentPath' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'String' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'GemsApi_findStones',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'filters' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'filters',
                                    },
                                },
                            },
                        ],
                        'directives': [
                            {
                                'kind': 'Directive',
                                'name': { 'kind': 'Name', 'value': 'include' },
                                'arguments': [
                                    {
                                        'kind': 'Argument',
                                        'name': {
                                            'kind': 'Name',
                                            'value': 'if',
                                        },
                                        'value': {
                                            'kind': 'Variable',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'getStones',
                                            },
                                        },
                                    },
                                ],
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'collection',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'stone',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'pagination',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'limit',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'pages',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'total',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'filters',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'GemsSelectedFilters',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'GemsApi_getBounds',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'market' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'market',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': {
                                    'kind': 'Name',
                                    'value': 'categories',
                                },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'categories',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': {
                                    'kind': 'Name',
                                    'value': 'notClarity',
                                },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'notClarity',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': {
                                    'kind': 'Name',
                                    'value': 'notColour',
                                },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'notColour',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': {
                                    'kind': 'Name',
                                    'value': 'notSymmetry',
                                },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'notSymmetry',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': {
                                    'kind': 'Name',
                                    'value': 'isConsultant',
                                },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'isConsultant',
                                    },
                                },
                            },
                        ],
                        'directives': [
                            {
                                'kind': 'Directive',
                                'name': { 'kind': 'Name', 'value': 'include' },
                                'arguments': [
                                    {
                                        'kind': 'Argument',
                                        'name': {
                                            'kind': 'Name',
                                            'value': 'if',
                                        },
                                        'value': {
                                            'kind': 'Variable',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'getBound',
                                            },
                                        },
                                    },
                                ],
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'gemsBounds',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'pageProductListing',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'path' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'contentPath',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productPageListing',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...StoneFragmentDoc.definitions,
        ...StoneCategoryFragmentDoc.definitions,
        ...StoneCategoryTranslationFragmentDoc.definitions,
        ...StoneClarityFragmentDoc.definitions,
        ...ClarityTranslationFragmentDoc.definitions,
        ...StoneColorFragmentDoc.definitions,
        ...StoneColorTranslationFragmentDoc.definitions,
        ...StoneImageFragmentDoc.definitions,
        ...GemsApiCertificateFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...GemsSelectedFiltersFragmentDoc.definitions,
        ...GemsSelectedRangeFragmentDoc.definitions,
        ...GemsBoundsFragmentDoc.definitions,
        ...GemsApiStoneShapeWithInfoFragmentDoc.definitions,
        ...StoneShapeFragmentDoc.definitions,
        ...AssetFragmentDoc.definitions,
        ...StoneShapeTranslationFragmentDoc.definitions,
        ...GemsRangeFragmentDoc.definitions,
        ...GemsIntRangeFragmentDoc.definitions,
        ...GemsPriceRangeInLocalCurrencyFragmentDoc.definitions,
        ...ProductPageListingFragmentDoc.definitions,
        ...BlockFragmentDoc.definitions,
        ...BlockAnchorFragmentDoc.definitions,
        ...ComponentFragmentDoc.definitions,
        ...ComponentRoundedImageFragmentDoc.definitions,
        ...ImageMediumFragmentDoc.definitions,
        ...ImageCommonFragmentDoc.definitions,
        ...ImageSizeFragmentDoc.definitions,
        ...ComponentRoundedImageContentFragmentDoc.definitions,
        ...ContentComponentItemFragmentDoc.definitions,
        ...ComponentTitleFragmentDoc.definitions,
        ...ComponentTitleComponentFragmentDoc.definitions,
        ...ComponentTitleAmpersandFragmentDoc.definitions,
        ...ComponentTitleTextFragmentDoc.definitions,
        ...ComponentTextFragmentDoc.definitions,
        ...ComponentButtonFragmentDoc.definitions,
        ...LinkFragmentDoc.definitions,
        ...LinkItemFragmentDoc.definitions,
        ...PageLinkFragmentDoc.definitions,
        ...PostLinkFragmentDoc.definitions,
        ...CustomLinkFragmentDoc.definitions,
        ...LinkQuestionnaireFragmentDoc.definitions,
        ...LinkItemOpenEnquiryFormFragmentDoc.definitions,
        ...LinkItemOpenContactFormFragmentDoc.definitions,
        ...LinkItemOpenSpeakToExpertModalFragmentDoc.definitions,
        ...ComponentSpacerFragmentDoc.definitions,
        ...ComponentImageFragmentDoc.definitions,
        ...ImageLargeFragmentDoc.definitions,
        ...ComponentOrderedListFragmentDoc.definitions,
        ...OrderedListItemFragmentDoc.definitions,
        ...ComponentContentFragmentDoc.definitions,
        ...ComponentCardFragmentDoc.definitions,
        ...ComponentTextOverImageFragmentDoc.definitions,
        ...ComponentCustomProductCarouselFragmentDoc.definitions,
        ...CustomProductCarouselCardFragmentDoc.definitions,
        ...ComponentCatalogueProductCarouselFragmentDoc.definitions,
        ...ProductCardFragmentDoc.definitions,
        ...ProductLinkFragmentDoc.definitions,
        ...EngagementRingLinkFragmentDoc.definitions,
        ...JewelleryLinkFragmentDoc.definitions,
        ...ReadyToGoRingLinkFragmentDoc.definitions,
        ...WeddingRingLinkFragmentDoc.definitions,
        ...MetalVariationFragmentDoc.definitions,
        ...MetalFilterMetalFragmentDoc.definitions,
        ...GetIsLabGrownFragmentDoc.definitions,
        ...MonolithImageSizeFragmentDoc.definitions,
        ...ComponentReviewCarouselFragmentDoc.definitions,
        ...ComponentMainCoverFragmentDoc.definitions,
        ...ImageCoverFragmentDoc.definitions,
        ...ComponentVideoFragmentDoc.definitions,
        ...VideoFragmentDoc.definitions,
        ...ComponentVideoWithContentFragmentDoc.definitions,
        ...ComponentInstagramPostsFragmentDoc.definitions,
        ...ComponentLogosFragmentDoc.definitions,
        ...ComponentLogosCarouselFragmentDoc.definitions,
        ...ComponentTextWithImageFragmentDoc.definitions,
        ...ComponentGalleryCarouselFragmentDoc.definitions,
        ...GalleryCarouselCardFragmentDoc.definitions,
        ...ComponentCardCarouselFragmentDoc.definitions,
        ...CardCarouselCardFragmentDoc.definitions,
        ...ComponentFullWidthImageFragmentDoc.definitions,
        ...ComponentSideBySideImagesFragmentDoc.definitions,
        ...ComponentSideBySideImageFragmentDoc.definitions,
        ...ComponentArticlePreviewsFragmentDoc.definitions,
        ...ArticlePreviewFragmentDoc.definitions,
        ...ComponentInstagramWithContentFragmentDoc.definitions,
        ...ComponentBannerTitleFragmentDoc.definitions,
        ...ComponentQuoteFragmentDoc.definitions,
        ...ComponentBannerSkinnyFragmentDoc.definitions,
        ...ComponentGlobalSpacerFragmentDoc.definitions,
        ...ComponentTextWithImageCarouselFragmentDoc.definitions,
        ...ComponentContentWithGalleryFragmentDoc.definitions,
        ...ComponentIconCarouselFragmentDoc.definitions,
        ...ComponentTextCarouselFragmentDoc.definitions,
        ...ComponentFaqFragmentDoc.definitions,
        ...FaqSectionFragmentDoc.definitions,
        ...FaqQuestionFragmentDoc.definitions,
        ...ComponentContentTwoColumnsFragmentDoc.definitions,
        ...ComponentTableFragmentDoc.definitions,
        ...ComponentArticleGridFragmentDoc.definitions,
        ...ArticleGridItemFragmentDoc.definitions,
        ...ComponentOnThisPageFragmentDoc.definitions,
        ...ComponentGalleryWithEnquiryFragmentDoc.definitions,
        ...GalleryWithEnquiryCardFragmentDoc.definitions,
        ...ComponentSquareBoxesFragmentDoc.definitions,
        ...SquareBoxesFragmentDoc.definitions,
        ...SquareTextBoxFragmentDoc.definitions,
        ...SquareImageBoxFragmentDoc.definitions,
        ...ComponentShopWithConfidenceFragmentDoc.definitions,
        ...ComponentGlobalComponentFragmentDoc.definitions,
        ...Banner1FragmentDoc.definitions,
        ...Banner2FragmentDoc.definitions,
        ...MetaFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useGemsFindStonesQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, GemsFindStonesQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<
        GemsFindStonesQuery,
        GemsFindStonesQueryVariables | undefined
    >({ query: GemsFindStonesDocument, variables: undefined, ...options })
}
export const GetBoundsDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'GetBounds' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'currency' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CurrencyInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'region' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'RegionCode' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'market' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'String' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'categories' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'ListType',
                            'type': {
                                'kind': 'NonNullType',
                                'type': {
                                    'kind': 'NamedType',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'GemsApi_StoneCategory',
                                    },
                                },
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'GemsApi_getBounds',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'market' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'market',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': {
                                    'kind': 'Name',
                                    'value': 'categories',
                                },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'categories',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'gemsBounds',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...GemsBoundsFragmentDoc.definitions,
        ...GemsApiStoneShapeWithInfoFragmentDoc.definitions,
        ...StoneShapeFragmentDoc.definitions,
        ...AssetFragmentDoc.definitions,
        ...StoneShapeTranslationFragmentDoc.definitions,
        ...GemsRangeFragmentDoc.definitions,
        ...GemsIntRangeFragmentDoc.definitions,
        ...GemsPriceRangeInLocalCurrencyFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useGetBoundsQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, GetBoundsQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<GetBoundsQuery, GetBoundsQueryVariables | undefined>({
        query: GetBoundsDocument,
        variables: undefined,
        ...options,
    })
}
export const GetStoneDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'GetStone' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'identifier' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'GemsApi_StoneIdentifier',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'currency' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CurrencyInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'region' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'RegionCode' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'GemsApi_getStone' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': {
                                    'kind': 'Name',
                                    'value': 'identifier',
                                },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'identifier',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'stone',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'containsEngagementRings',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...StoneFragmentDoc.definitions,
        ...StoneCategoryFragmentDoc.definitions,
        ...StoneCategoryTranslationFragmentDoc.definitions,
        ...StoneClarityFragmentDoc.definitions,
        ...ClarityTranslationFragmentDoc.definitions,
        ...StoneColorFragmentDoc.definitions,
        ...StoneColorTranslationFragmentDoc.definitions,
        ...StoneImageFragmentDoc.definitions,
        ...GemsApiCertificateFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useGetStoneQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, GetStoneQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<GetStoneQuery, GetStoneQueryVariables | undefined>({
        query: GetStoneDocument,
        variables: undefined,
        ...options,
    })
}
export const GetStoneByGiaDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'GetStoneByGia' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'giaNumber' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'String' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'currency' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CurrencyInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'region' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'RegionCode' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'GemsApi_getGiaStone',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': {
                                    'kind': 'Name',
                                    'value': 'giaCertificate',
                                },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'giaNumber',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'stone',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...StoneFragmentDoc.definitions,
        ...StoneCategoryFragmentDoc.definitions,
        ...StoneCategoryTranslationFragmentDoc.definitions,
        ...StoneClarityFragmentDoc.definitions,
        ...ClarityTranslationFragmentDoc.definitions,
        ...StoneColorFragmentDoc.definitions,
        ...StoneColorTranslationFragmentDoc.definitions,
        ...StoneImageFragmentDoc.definitions,
        ...GemsApiCertificateFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useGetStoneByGiaQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, GetStoneByGiaQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<
        GetStoneByGiaQuery,
        GetStoneByGiaQueryVariables | undefined
    >({ query: GetStoneByGiaDocument, variables: undefined, ...options })
}
export const FindStoneByExternalIdDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'findStoneByExternalId' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'feedIdentifier' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'String' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'externalId' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'String' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'currency' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CurrencyInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'region' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'RegionCode' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'GemsApi_getStoneByExternalId',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': {
                                    'kind': 'Name',
                                    'value': 'feedIdentifier',
                                },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'feedIdentifier',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': {
                                    'kind': 'Name',
                                    'value': 'externalId',
                                },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'externalId',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'stone',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...StoneFragmentDoc.definitions,
        ...StoneCategoryFragmentDoc.definitions,
        ...StoneCategoryTranslationFragmentDoc.definitions,
        ...StoneClarityFragmentDoc.definitions,
        ...ClarityTranslationFragmentDoc.definitions,
        ...StoneColorFragmentDoc.definitions,
        ...StoneColorTranslationFragmentDoc.definitions,
        ...StoneImageFragmentDoc.definitions,
        ...GemsApiCertificateFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useFindStoneByExternalIdQuery(
    options?: Omit<
        Urql.UseQueryArgs<
            never,
            FindStoneByExternalIdQueryVariables | undefined
        >,
        'query'
    >
) {
    return Urql.useQuery<
        FindStoneByExternalIdQuery,
        FindStoneByExternalIdQueryVariables | undefined
    >({
        query: FindStoneByExternalIdDocument,
        variables: undefined,
        ...options,
    })
}
export const BraceletExportDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'braceletExport' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'region' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'RegionCode' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'rbProduct' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Boolean' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueJewelleryBracelets',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productExport',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...ProductExportFragmentDoc.definitions,
        ...ProductLinkFragmentDoc.definitions,
        ...EngagementRingLinkFragmentDoc.definitions,
        ...JewelleryLinkFragmentDoc.definitions,
        ...ReadyToGoRingLinkFragmentDoc.definitions,
        ...WeddingRingLinkFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useBraceletExportQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, BraceletExportQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<
        BraceletExportQuery,
        BraceletExportQueryVariables | undefined
    >({ query: BraceletExportDocument, variables: undefined, ...options })
}
export const EarringsExportDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'earringsExport' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'region' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'RegionCode' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'rbProduct' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Boolean' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueJewelleryEarrings',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productExport',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...ProductExportFragmentDoc.definitions,
        ...ProductLinkFragmentDoc.definitions,
        ...EngagementRingLinkFragmentDoc.definitions,
        ...JewelleryLinkFragmentDoc.definitions,
        ...ReadyToGoRingLinkFragmentDoc.definitions,
        ...WeddingRingLinkFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useEarringsExportQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, EarringsExportQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<
        EarringsExportQuery,
        EarringsExportQueryVariables | undefined
    >({ query: EarringsExportDocument, variables: undefined, ...options })
}
export const EngagementRingsExportDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'engagementRingsExport' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'region' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'RegionCode' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'rbProduct' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Boolean' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueEngagementRings',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productExport',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...ProductExportFragmentDoc.definitions,
        ...ProductLinkFragmentDoc.definitions,
        ...EngagementRingLinkFragmentDoc.definitions,
        ...JewelleryLinkFragmentDoc.definitions,
        ...ReadyToGoRingLinkFragmentDoc.definitions,
        ...WeddingRingLinkFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useEngagementRingsExportQuery(
    options?: Omit<
        Urql.UseQueryArgs<
            never,
            EngagementRingsExportQueryVariables | undefined
        >,
        'query'
    >
) {
    return Urql.useQuery<
        EngagementRingsExportQuery,
        EngagementRingsExportQueryVariables | undefined
    >({
        query: EngagementRingsExportDocument,
        variables: undefined,
        ...options,
    })
}
export const EngagementRingsGemstoneExportDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': {
                'kind': 'Name',
                'value': 'engagementRingsGemstoneExport',
            },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'region' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'RegionCode' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'rbProduct' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Boolean' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'type' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'RingBuilderProductType',
                            },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueEngagementRings',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'engagementRingRingBuilderExport',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...EngagementRingRingBuilderExportFragmentDoc.definitions,
        ...ProductExportFragmentDoc.definitions,
        ...ProductLinkFragmentDoc.definitions,
        ...EngagementRingLinkFragmentDoc.definitions,
        ...JewelleryLinkFragmentDoc.definitions,
        ...ReadyToGoRingLinkFragmentDoc.definitions,
        ...WeddingRingLinkFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...ExportsRingBuilderPositionFragmentDoc.definitions,
        ...LabGrownRouteFragmentDoc.definitions,
        ...GemstoneRouteFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useEngagementRingsGemstoneExportQuery(
    options?: Omit<
        Urql.UseQueryArgs<
            never,
            EngagementRingsGemstoneExportQueryVariables | undefined
        >,
        'query'
    >
) {
    return Urql.useQuery<
        EngagementRingsGemstoneExportQuery,
        EngagementRingsGemstoneExportQueryVariables | undefined
    >({
        query: EngagementRingsGemstoneExportDocument,
        variables: undefined,
        ...options,
    })
}
export const EngagementRingsLabGrownExportDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': {
                'kind': 'Name',
                'value': 'engagementRingsLabGrownExport',
            },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'region' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'RegionCode' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'rbProduct' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Boolean' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'type' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'RingBuilderProductType',
                            },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueEngagementRings',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value':
                                            'engagementRingRingBuilderExport',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...EngagementRingRingBuilderExportFragmentDoc.definitions,
        ...ProductExportFragmentDoc.definitions,
        ...ProductLinkFragmentDoc.definitions,
        ...EngagementRingLinkFragmentDoc.definitions,
        ...JewelleryLinkFragmentDoc.definitions,
        ...ReadyToGoRingLinkFragmentDoc.definitions,
        ...WeddingRingLinkFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...ExportsRingBuilderPositionFragmentDoc.definitions,
        ...LabGrownRouteFragmentDoc.definitions,
        ...GemstoneRouteFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useEngagementRingsLabGrownExportQuery(
    options?: Omit<
        Urql.UseQueryArgs<
            never,
            EngagementRingsLabGrownExportQueryVariables | undefined
        >,
        'query'
    >
) {
    return Urql.useQuery<
        EngagementRingsLabGrownExportQuery,
        EngagementRingsLabGrownExportQueryVariables | undefined
    >({
        query: EngagementRingsLabGrownExportDocument,
        variables: undefined,
        ...options,
    })
}
export const NecklaceExportDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'necklaceExport' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'region' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'RegionCode' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'rbProduct' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Boolean' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueJewelleryNecklaces',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productExport',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...ProductExportFragmentDoc.definitions,
        ...ProductLinkFragmentDoc.definitions,
        ...EngagementRingLinkFragmentDoc.definitions,
        ...JewelleryLinkFragmentDoc.definitions,
        ...ReadyToGoRingLinkFragmentDoc.definitions,
        ...WeddingRingLinkFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useNecklaceExportQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, NecklaceExportQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<
        NecklaceExportQuery,
        NecklaceExportQueryVariables | undefined
    >({ query: NecklaceExportDocument, variables: undefined, ...options })
}
export const RingExportsDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'ringExports' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'region' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'RegionCode' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'rbProduct' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Boolean' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueJewelleryRings',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productExport',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...ProductExportFragmentDoc.definitions,
        ...ProductLinkFragmentDoc.definitions,
        ...EngagementRingLinkFragmentDoc.definitions,
        ...JewelleryLinkFragmentDoc.definitions,
        ...ReadyToGoRingLinkFragmentDoc.definitions,
        ...WeddingRingLinkFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useRingExportsQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, RingExportsQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<
        RingExportsQuery,
        RingExportsQueryVariables | undefined
    >({ query: RingExportsDocument, variables: undefined, ...options })
}
export const WeddingRingsExportDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'weddingRingsExport' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'region' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'RegionCode' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'rbProduct' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Boolean' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueWeddingRings',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productExport',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...ProductExportFragmentDoc.definitions,
        ...ProductLinkFragmentDoc.definitions,
        ...EngagementRingLinkFragmentDoc.definitions,
        ...JewelleryLinkFragmentDoc.definitions,
        ...ReadyToGoRingLinkFragmentDoc.definitions,
        ...WeddingRingLinkFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useWeddingRingsExportQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, WeddingRingsExportQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<
        WeddingRingsExportQuery,
        WeddingRingsExportQueryVariables | undefined
    >({ query: WeddingRingsExportDocument, variables: undefined, ...options })
}
export const ReviewsFeedDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'reviewsFeed' },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'reviews' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'reviewFeed',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'products',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'catalogueCode',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'productName',
                                                },
                                            },
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'productLink',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...ReviewFeedFragmentDoc.definitions,
        ...ProductLinkFragmentDoc.definitions,
        ...EngagementRingLinkFragmentDoc.definitions,
        ...JewelleryLinkFragmentDoc.definitions,
        ...ReadyToGoRingLinkFragmentDoc.definitions,
        ...WeddingRingLinkFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useReviewsFeedQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, ReviewsFeedQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<
        ReviewsFeedQuery,
        ReviewsFeedQueryVariables | undefined
    >({ query: ReviewsFeedDocument, variables: undefined, ...options })
}
export const ReviewsFeedEngagementRingGemstoneDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': {
                'kind': 'Name',
                'value': 'reviewsFeedEngagementRingGemstone',
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'reviews' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'filter' },
                                'value': {
                                    'kind': 'ObjectValue',
                                    'fields': [
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'withProductsOfType',
                                            },
                                            'value': {
                                                'kind': 'ListValue',
                                                'values': [
                                                    {
                                                        'kind': 'EnumValue',
                                                        'value':
                                                            'ENGAGEMENT_RING',
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'reviewFeed',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'products',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'types',
                                            },
                                            'value': {
                                                'kind': 'ListValue',
                                                'values': [
                                                    {
                                                        'kind': 'EnumValue',
                                                        'value':
                                                            'ENGAGEMENT_RING',
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'catalogueCode',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'productName',
                                                },
                                            },
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'productLink',
                                                },
                                            },
                                            {
                                                'kind': 'InlineFragment',
                                                'typeCondition': {
                                                    'kind': 'NamedType',
                                                    'name': {
                                                        'kind': 'Name',
                                                        'value':
                                                            'CatalogueEngagementRing',
                                                    },
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'ringBuilderProducts',
                                                            },
                                                            'arguments': [
                                                                {
                                                                    'kind': 'Argument',
                                                                    'name': {
                                                                        'kind': 'Name',
                                                                        'value':
                                                                            'input',
                                                                    },
                                                                    'value': {
                                                                        'kind': 'ObjectValue',
                                                                        'fields':
                                                                            [
                                                                                {
                                                                                    'kind': 'ObjectField',
                                                                                    'name': {
                                                                                        'kind': 'Name',
                                                                                        'value':
                                                                                            'region',
                                                                                    },
                                                                                    'value':
                                                                                        {
                                                                                            'kind': 'EnumValue',
                                                                                            'value':
                                                                                                'UK',
                                                                                        },
                                                                                },
                                                                                {
                                                                                    'kind': 'ObjectField',
                                                                                    'name': {
                                                                                        'kind': 'Name',
                                                                                        'value':
                                                                                            'currency',
                                                                                    },
                                                                                    'value':
                                                                                        {
                                                                                            'kind': 'ObjectValue',
                                                                                            'fields':
                                                                                                [
                                                                                                    {
                                                                                                        'kind': 'ObjectField',
                                                                                                        'name': {
                                                                                                            'kind': 'Name',
                                                                                                            'value':
                                                                                                                'region',
                                                                                                        },
                                                                                                        'value':
                                                                                                            {
                                                                                                                'kind': 'EnumValue',
                                                                                                                'value':
                                                                                                                    'UK',
                                                                                                            },
                                                                                                    },
                                                                                                ],
                                                                                        },
                                                                                },
                                                                                {
                                                                                    'kind': 'ObjectField',
                                                                                    'name': {
                                                                                        'kind': 'Name',
                                                                                        'value':
                                                                                            'type',
                                                                                    },
                                                                                    'value':
                                                                                        {
                                                                                            'kind': 'EnumValue',
                                                                                            'value':
                                                                                                'NON_SKU_GEMSTONE',
                                                                                        },
                                                                                },
                                                                            ],
                                                                    },
                                                                },
                                                            ],
                                                            'selectionSet': {
                                                                'kind': 'SelectionSet',
                                                                'selections': [
                                                                    {
                                                                        'kind': 'Field',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'productId',
                                                                        },
                                                                    },
                                                                    {
                                                                        'kind': 'Field',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'position1',
                                                                        },
                                                                        'selectionSet':
                                                                            {
                                                                                'kind': 'SelectionSet',
                                                                                'selections':
                                                                                    [
                                                                                        {
                                                                                            'kind': 'Field',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    '__typename',
                                                                                            },
                                                                                        },
                                                                                        {
                                                                                            'kind': 'InlineFragment',
                                                                                            'typeCondition':
                                                                                                {
                                                                                                    'kind': 'NamedType',
                                                                                                    'name': {
                                                                                                        'kind': 'Name',
                                                                                                        'value':
                                                                                                            'RingBuilderCentreStoneFragment',
                                                                                                    },
                                                                                                },
                                                                                            'selectionSet':
                                                                                                {
                                                                                                    'kind': 'SelectionSet',
                                                                                                    'selections':
                                                                                                        [
                                                                                                            {
                                                                                                                'kind': 'Field',
                                                                                                                'name': {
                                                                                                                    'kind': 'Name',
                                                                                                                    'value':
                                                                                                                        'stone',
                                                                                                                },
                                                                                                                'selectionSet':
                                                                                                                    {
                                                                                                                        'kind': 'SelectionSet',
                                                                                                                        'selections':
                                                                                                                            [
                                                                                                                                {
                                                                                                                                    'kind': 'Field',
                                                                                                                                    'name': {
                                                                                                                                        'kind': 'Name',
                                                                                                                                        'value':
                                                                                                                                            '__typename',
                                                                                                                                    },
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    'kind': 'FragmentSpread',
                                                                                                                                    'name': {
                                                                                                                                        'kind': 'Name',
                                                                                                                                        'value':
                                                                                                                                            'gemstoneRoute',
                                                                                                                                    },
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    'kind': 'FragmentSpread',
                                                                                                                                    'name': {
                                                                                                                                        'kind': 'Name',
                                                                                                                                        'value':
                                                                                                                                            'labGrownRoute',
                                                                                                                                    },
                                                                                                                                },
                                                                                                                            ],
                                                                                                                    },
                                                                                                            },
                                                                                                        ],
                                                                                                },
                                                                                        },
                                                                                    ],
                                                                            },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...ReviewFeedFragmentDoc.definitions,
        ...ProductLinkFragmentDoc.definitions,
        ...EngagementRingLinkFragmentDoc.definitions,
        ...JewelleryLinkFragmentDoc.definitions,
        ...ReadyToGoRingLinkFragmentDoc.definitions,
        ...WeddingRingLinkFragmentDoc.definitions,
        ...GemstoneRouteFragmentDoc.definitions,
        ...LabGrownRouteFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useReviewsFeedEngagementRingGemstoneQuery(
    options?: Omit<
        Urql.UseQueryArgs<
            never,
            ReviewsFeedEngagementRingGemstoneQueryVariables | undefined
        >,
        'query'
    >
) {
    return Urql.useQuery<
        ReviewsFeedEngagementRingGemstoneQuery,
        ReviewsFeedEngagementRingGemstoneQueryVariables | undefined
    >({
        query: ReviewsFeedEngagementRingGemstoneDocument,
        variables: undefined,
        ...options,
    })
}
export const ReviewsFeedEngagementRingLabGrownDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': {
                'kind': 'Name',
                'value': 'reviewsFeedEngagementRingLabGrown',
            },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'reviews' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'filter' },
                                'value': {
                                    'kind': 'ObjectValue',
                                    'fields': [
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'withProductsOfType',
                                            },
                                            'value': {
                                                'kind': 'ListValue',
                                                'values': [
                                                    {
                                                        'kind': 'EnumValue',
                                                        'value':
                                                            'ENGAGEMENT_RING',
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'reviewFeed',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'products',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'types',
                                            },
                                            'value': {
                                                'kind': 'ListValue',
                                                'values': [
                                                    {
                                                        'kind': 'EnumValue',
                                                        'value':
                                                            'ENGAGEMENT_RING',
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'catalogueCode',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'productName',
                                                },
                                            },
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'productLink',
                                                },
                                            },
                                            {
                                                'kind': 'InlineFragment',
                                                'typeCondition': {
                                                    'kind': 'NamedType',
                                                    'name': {
                                                        'kind': 'Name',
                                                        'value':
                                                            'CatalogueEngagementRing',
                                                    },
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'ringBuilderProducts',
                                                            },
                                                            'arguments': [
                                                                {
                                                                    'kind': 'Argument',
                                                                    'name': {
                                                                        'kind': 'Name',
                                                                        'value':
                                                                            'input',
                                                                    },
                                                                    'value': {
                                                                        'kind': 'ObjectValue',
                                                                        'fields':
                                                                            [
                                                                                {
                                                                                    'kind': 'ObjectField',
                                                                                    'name': {
                                                                                        'kind': 'Name',
                                                                                        'value':
                                                                                            'region',
                                                                                    },
                                                                                    'value':
                                                                                        {
                                                                                            'kind': 'EnumValue',
                                                                                            'value':
                                                                                                'UK',
                                                                                        },
                                                                                },
                                                                                {
                                                                                    'kind': 'ObjectField',
                                                                                    'name': {
                                                                                        'kind': 'Name',
                                                                                        'value':
                                                                                            'currency',
                                                                                    },
                                                                                    'value':
                                                                                        {
                                                                                            'kind': 'ObjectValue',
                                                                                            'fields':
                                                                                                [
                                                                                                    {
                                                                                                        'kind': 'ObjectField',
                                                                                                        'name': {
                                                                                                            'kind': 'Name',
                                                                                                            'value':
                                                                                                                'region',
                                                                                                        },
                                                                                                        'value':
                                                                                                            {
                                                                                                                'kind': 'EnumValue',
                                                                                                                'value':
                                                                                                                    'UK',
                                                                                                            },
                                                                                                    },
                                                                                                ],
                                                                                        },
                                                                                },
                                                                                {
                                                                                    'kind': 'ObjectField',
                                                                                    'name': {
                                                                                        'kind': 'Name',
                                                                                        'value':
                                                                                            'type',
                                                                                    },
                                                                                    'value':
                                                                                        {
                                                                                            'kind': 'EnumValue',
                                                                                            'value':
                                                                                                'NON_SKU_LAB_GROWN_DIAMOND',
                                                                                        },
                                                                                },
                                                                            ],
                                                                    },
                                                                },
                                                            ],
                                                            'selectionSet': {
                                                                'kind': 'SelectionSet',
                                                                'selections': [
                                                                    {
                                                                        'kind': 'Field',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'productId',
                                                                        },
                                                                    },
                                                                    {
                                                                        'kind': 'Field',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'position1',
                                                                        },
                                                                        'selectionSet':
                                                                            {
                                                                                'kind': 'SelectionSet',
                                                                                'selections':
                                                                                    [
                                                                                        {
                                                                                            'kind': 'Field',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    '__typename',
                                                                                            },
                                                                                        },
                                                                                        {
                                                                                            'kind': 'InlineFragment',
                                                                                            'typeCondition':
                                                                                                {
                                                                                                    'kind': 'NamedType',
                                                                                                    'name': {
                                                                                                        'kind': 'Name',
                                                                                                        'value':
                                                                                                            'RingBuilderCentreStoneFragment',
                                                                                                    },
                                                                                                },
                                                                                            'selectionSet':
                                                                                                {
                                                                                                    'kind': 'SelectionSet',
                                                                                                    'selections':
                                                                                                        [
                                                                                                            {
                                                                                                                'kind': 'Field',
                                                                                                                'name': {
                                                                                                                    'kind': 'Name',
                                                                                                                    'value':
                                                                                                                        'stone',
                                                                                                                },
                                                                                                                'selectionSet':
                                                                                                                    {
                                                                                                                        'kind': 'SelectionSet',
                                                                                                                        'selections':
                                                                                                                            [
                                                                                                                                {
                                                                                                                                    'kind': 'Field',
                                                                                                                                    'name': {
                                                                                                                                        'kind': 'Name',
                                                                                                                                        'value':
                                                                                                                                            '__typename',
                                                                                                                                    },
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    'kind': 'FragmentSpread',
                                                                                                                                    'name': {
                                                                                                                                        'kind': 'Name',
                                                                                                                                        'value':
                                                                                                                                            'gemstoneRoute',
                                                                                                                                    },
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    'kind': 'FragmentSpread',
                                                                                                                                    'name': {
                                                                                                                                        'kind': 'Name',
                                                                                                                                        'value':
                                                                                                                                            'labGrownRoute',
                                                                                                                                    },
                                                                                                                                },
                                                                                                                            ],
                                                                                                                    },
                                                                                                            },
                                                                                                        ],
                                                                                                },
                                                                                        },
                                                                                    ],
                                                                            },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...ReviewFeedFragmentDoc.definitions,
        ...ProductLinkFragmentDoc.definitions,
        ...EngagementRingLinkFragmentDoc.definitions,
        ...JewelleryLinkFragmentDoc.definitions,
        ...ReadyToGoRingLinkFragmentDoc.definitions,
        ...WeddingRingLinkFragmentDoc.definitions,
        ...GemstoneRouteFragmentDoc.definitions,
        ...LabGrownRouteFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useReviewsFeedEngagementRingLabGrownQuery(
    options?: Omit<
        Urql.UseQueryArgs<
            never,
            ReviewsFeedEngagementRingLabGrownQueryVariables | undefined
        >,
        'query'
    >
) {
    return Urql.useQuery<
        ReviewsFeedEngagementRingLabGrownQuery,
        ReviewsFeedEngagementRingLabGrownQueryVariables | undefined
    >({
        query: ReviewsFeedEngagementRingLabGrownDocument,
        variables: undefined,
        ...options,
    })
}
export const SitemapEngagementRingDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'sitemapEngagementRing' },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'regions' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'sitemapRegion',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueEngagementRingFiltersVariations',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'maxSlots' },
                                'value': { 'kind': 'IntValue', 'value': '2' },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'primaryMetal',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'ringStyle',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'centreStoneShape',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'designStyle',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueEngagementRings',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'engagementRingLink',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'images',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'url',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'images360',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'url',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productName',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...SitemapRegionFragmentDoc.definitions,
        ...EngagementRingLinkFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useSitemapEngagementRingQuery(
    options?: Omit<
        Urql.UseQueryArgs<
            never,
            SitemapEngagementRingQueryVariables | undefined
        >,
        'query'
    >
) {
    return Urql.useQuery<
        SitemapEngagementRingQuery,
        SitemapEngagementRingQueryVariables | undefined
    >({
        query: SitemapEngagementRingDocument,
        variables: undefined,
        ...options,
    })
}
export const SitemapJewelleryDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'sitemapJewellery' },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'regions' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'sitemapRegion',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueJewelleriesFiltersVariations',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'maxSlots' },
                                'value': { 'kind': 'IntValue', 'value': '2' },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'primaryMetal',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'designStyle',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'gemstone',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value':
                                'catalogueJewelleryNecklacesFiltersVariations',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'maxSlots' },
                                'value': { 'kind': 'IntValue', 'value': '1' },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'primaryMetal',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productStyle',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'designStyle',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'gemstone',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value':
                                'catalogueJewelleryEarringsFiltersVariations',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'maxSlots' },
                                'value': { 'kind': 'IntValue', 'value': '1' },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'primaryMetal',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productStyle',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'designStyle',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'gemstone',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value':
                                'catalogueJewelleryBraceletFiltersVariations',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'maxSlots' },
                                'value': { 'kind': 'IntValue', 'value': '1' },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'primaryMetal',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productStyle',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'designStyle',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'gemstone',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueJewelleryRingsFiltersVariations',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'maxSlots' },
                                'value': { 'kind': 'IntValue', 'value': '1' },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'primaryMetal',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productStyle',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'designStyle',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'gemstone',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueJewelleries',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'jewelleryLink',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'images',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'url',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'images360',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'url',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productName',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...SitemapRegionFragmentDoc.definitions,
        ...JewelleryLinkFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useSitemapJewelleryQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, SitemapJewelleryQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<
        SitemapJewelleryQuery,
        SitemapJewelleryQueryVariables | undefined
    >({ query: SitemapJewelleryDocument, variables: undefined, ...options })
}
export const SitemapPagesDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'sitemapPages' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'regions' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'sitemapRegion',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'pages' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'pageLink',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'meta' },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'robots',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'blocks',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'components',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    '__typename',
                                                            },
                                                        },
                                                        {
                                                            'kind': 'InlineFragment',
                                                            'typeCondition': {
                                                                'kind': 'NamedType',
                                                                'name': {
                                                                    'kind': 'Name',
                                                                    'value':
                                                                        'ComponentTextOverImage',
                                                                },
                                                            },
                                                            'selectionSet': {
                                                                'kind': 'SelectionSet',
                                                                'selections': [
                                                                    {
                                                                        'kind': 'Field',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'content',
                                                                        },
                                                                        'selectionSet':
                                                                            {
                                                                                'kind': 'SelectionSet',
                                                                                'selections':
                                                                                    [
                                                                                        {
                                                                                            'kind': 'FragmentSpread',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'contentImageSitemap',
                                                                                            },
                                                                                        },
                                                                                    ],
                                                                            },
                                                                    },
                                                                    {
                                                                        'kind': 'Field',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'image',
                                                                        },
                                                                        'selectionSet':
                                                                            {
                                                                                'kind': 'SelectionSet',
                                                                                'selections':
                                                                                    [
                                                                                        {
                                                                                            'kind': 'Field',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'url',
                                                                                            },
                                                                                        },
                                                                                        {
                                                                                            'kind': 'Field',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'title',
                                                                                            },
                                                                                        },
                                                                                        {
                                                                                            'kind': 'Field',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'caption',
                                                                                            },
                                                                                        },
                                                                                    ],
                                                                            },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            'kind': 'InlineFragment',
                                                            'typeCondition': {
                                                                'kind': 'NamedType',
                                                                'name': {
                                                                    'kind': 'Name',
                                                                    'value':
                                                                        'ComponentRoundedImage',
                                                                },
                                                            },
                                                            'selectionSet': {
                                                                'kind': 'SelectionSet',
                                                                'selections': [
                                                                    {
                                                                        'kind': 'Field',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'backgroundImage',
                                                                        },
                                                                        'selectionSet':
                                                                            {
                                                                                'kind': 'SelectionSet',
                                                                                'selections':
                                                                                    [
                                                                                        {
                                                                                            'kind': 'Field',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'url',
                                                                                            },
                                                                                        },
                                                                                        {
                                                                                            'kind': 'Field',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'title',
                                                                                            },
                                                                                        },
                                                                                        {
                                                                                            'kind': 'Field',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'caption',
                                                                                            },
                                                                                        },
                                                                                    ],
                                                                            },
                                                                    },
                                                                    {
                                                                        'kind': 'Field',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'roundedImage',
                                                                        },
                                                                        'selectionSet':
                                                                            {
                                                                                'kind': 'SelectionSet',
                                                                                'selections':
                                                                                    [
                                                                                        {
                                                                                            'kind': 'Field',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'url',
                                                                                            },
                                                                                        },
                                                                                        {
                                                                                            'kind': 'Field',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'title',
                                                                                            },
                                                                                        },
                                                                                        {
                                                                                            'kind': 'Field',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'caption',
                                                                                            },
                                                                                        },
                                                                                    ],
                                                                            },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            'kind': 'InlineFragment',
                                                            'typeCondition': {
                                                                'kind': 'NamedType',
                                                                'name': {
                                                                    'kind': 'Name',
                                                                    'value':
                                                                        'ComponentFullWidthImage',
                                                                },
                                                            },
                                                            'selectionSet': {
                                                                'kind': 'SelectionSet',
                                                                'selections': [
                                                                    {
                                                                        'kind': 'Field',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'image',
                                                                        },
                                                                        'selectionSet':
                                                                            {
                                                                                'kind': 'SelectionSet',
                                                                                'selections':
                                                                                    [
                                                                                        {
                                                                                            'kind': 'Field',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'url',
                                                                                            },
                                                                                        },
                                                                                        {
                                                                                            'kind': 'Field',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'title',
                                                                                            },
                                                                                        },
                                                                                        {
                                                                                            'kind': 'Field',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'caption',
                                                                                            },
                                                                                        },
                                                                                    ],
                                                                            },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            'kind': 'InlineFragment',
                                                            'typeCondition': {
                                                                'kind': 'NamedType',
                                                                'name': {
                                                                    'kind': 'Name',
                                                                    'value':
                                                                        'ComponentSideBySideImages',
                                                                },
                                                            },
                                                            'selectionSet': {
                                                                'kind': 'SelectionSet',
                                                                'selections': [
                                                                    {
                                                                        'kind': 'Field',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'images',
                                                                        },
                                                                        'selectionSet':
                                                                            {
                                                                                'kind': 'SelectionSet',
                                                                                'selections':
                                                                                    [
                                                                                        {
                                                                                            'kind': 'Field',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'caption',
                                                                                            },
                                                                                        },
                                                                                        {
                                                                                            'kind': 'Field',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'image',
                                                                                            },
                                                                                            'selectionSet':
                                                                                                {
                                                                                                    'kind': 'SelectionSet',
                                                                                                    'selections':
                                                                                                        [
                                                                                                            {
                                                                                                                'kind': 'Field',
                                                                                                                'name': {
                                                                                                                    'kind': 'Name',
                                                                                                                    'value':
                                                                                                                        'url',
                                                                                                                },
                                                                                                            },
                                                                                                            {
                                                                                                                'kind': 'Field',
                                                                                                                'name': {
                                                                                                                    'kind': 'Name',
                                                                                                                    'value':
                                                                                                                        'title',
                                                                                                                },
                                                                                                            },
                                                                                                            {
                                                                                                                'kind': 'Field',
                                                                                                                'name': {
                                                                                                                    'kind': 'Name',
                                                                                                                    'value':
                                                                                                                        'caption',
                                                                                                                },
                                                                                                            },
                                                                                                        ],
                                                                                                },
                                                                                        },
                                                                                    ],
                                                                            },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            'kind': 'InlineFragment',
                                                            'typeCondition': {
                                                                'kind': 'NamedType',
                                                                'name': {
                                                                    'kind': 'Name',
                                                                    'value':
                                                                        'ComponentTextWithImage',
                                                                },
                                                            },
                                                            'selectionSet': {
                                                                'kind': 'SelectionSet',
                                                                'selections': [
                                                                    {
                                                                        'kind': 'Field',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'content',
                                                                        },
                                                                        'selectionSet':
                                                                            {
                                                                                'kind': 'SelectionSet',
                                                                                'selections':
                                                                                    [
                                                                                        {
                                                                                            'kind': 'FragmentSpread',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'contentImageSitemap',
                                                                                            },
                                                                                        },
                                                                                    ],
                                                                            },
                                                                    },
                                                                    {
                                                                        'kind': 'Field',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'image',
                                                                        },
                                                                        'selectionSet':
                                                                            {
                                                                                'kind': 'SelectionSet',
                                                                                'selections':
                                                                                    [
                                                                                        {
                                                                                            'kind': 'Field',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'url',
                                                                                            },
                                                                                        },
                                                                                        {
                                                                                            'kind': 'Field',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'title',
                                                                                            },
                                                                                        },
                                                                                        {
                                                                                            'kind': 'Field',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'caption',
                                                                                            },
                                                                                        },
                                                                                    ],
                                                                            },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            'kind': 'InlineFragment',
                                                            'typeCondition': {
                                                                'kind': 'NamedType',
                                                                'name': {
                                                                    'kind': 'Name',
                                                                    'value':
                                                                        'ComponentRoundedImageContent',
                                                                },
                                                            },
                                                            'selectionSet': {
                                                                'kind': 'SelectionSet',
                                                                'selections': [
                                                                    {
                                                                        'kind': 'Field',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'content',
                                                                        },
                                                                        'selectionSet':
                                                                            {
                                                                                'kind': 'SelectionSet',
                                                                                'selections':
                                                                                    [
                                                                                        {
                                                                                            'kind': 'FragmentSpread',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'contentImageSitemap',
                                                                                            },
                                                                                        },
                                                                                    ],
                                                                            },
                                                                    },
                                                                    {
                                                                        'kind': 'Field',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'roundedImage',
                                                                        },
                                                                        'selectionSet':
                                                                            {
                                                                                'kind': 'SelectionSet',
                                                                                'selections':
                                                                                    [
                                                                                        {
                                                                                            'kind': 'Field',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'roundedImage',
                                                                                            },
                                                                                            'selectionSet':
                                                                                                {
                                                                                                    'kind': 'SelectionSet',
                                                                                                    'selections':
                                                                                                        [
                                                                                                            {
                                                                                                                'kind': 'Field',
                                                                                                                'name': {
                                                                                                                    'kind': 'Name',
                                                                                                                    'value':
                                                                                                                        'url',
                                                                                                                },
                                                                                                            },
                                                                                                            {
                                                                                                                'kind': 'Field',
                                                                                                                'name': {
                                                                                                                    'kind': 'Name',
                                                                                                                    'value':
                                                                                                                        'title',
                                                                                                                },
                                                                                                            },
                                                                                                            {
                                                                                                                'kind': 'Field',
                                                                                                                'name': {
                                                                                                                    'kind': 'Name',
                                                                                                                    'value':
                                                                                                                        'caption',
                                                                                                                },
                                                                                                            },
                                                                                                        ],
                                                                                                },
                                                                                        },
                                                                                        {
                                                                                            'kind': 'Field',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'backgroundImage',
                                                                                            },
                                                                                            'selectionSet':
                                                                                                {
                                                                                                    'kind': 'SelectionSet',
                                                                                                    'selections':
                                                                                                        [
                                                                                                            {
                                                                                                                'kind': 'Field',
                                                                                                                'name': {
                                                                                                                    'kind': 'Name',
                                                                                                                    'value':
                                                                                                                        'url',
                                                                                                                },
                                                                                                            },
                                                                                                            {
                                                                                                                'kind': 'Field',
                                                                                                                'name': {
                                                                                                                    'kind': 'Name',
                                                                                                                    'value':
                                                                                                                        'title',
                                                                                                                },
                                                                                                            },
                                                                                                            {
                                                                                                                'kind': 'Field',
                                                                                                                'name': {
                                                                                                                    'kind': 'Name',
                                                                                                                    'value':
                                                                                                                        'caption',
                                                                                                                },
                                                                                                            },
                                                                                                        ],
                                                                                                },
                                                                                        },
                                                                                    ],
                                                                            },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            'kind': 'InlineFragment',
                                                            'typeCondition': {
                                                                'kind': 'NamedType',
                                                                'name': {
                                                                    'kind': 'Name',
                                                                    'value':
                                                                        'ComponentTextWithImageCarousel',
                                                                },
                                                            },
                                                            'selectionSet': {
                                                                'kind': 'SelectionSet',
                                                                'selections': [
                                                                    {
                                                                        'kind': 'Field',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'slides',
                                                                        },
                                                                        'selectionSet':
                                                                            {
                                                                                'kind': 'SelectionSet',
                                                                                'selections':
                                                                                    [
                                                                                        {
                                                                                            'kind': 'Field',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'content',
                                                                                            },
                                                                                            'selectionSet':
                                                                                                {
                                                                                                    'kind': 'SelectionSet',
                                                                                                    'selections':
                                                                                                        [
                                                                                                            {
                                                                                                                'kind': 'FragmentSpread',
                                                                                                                'name': {
                                                                                                                    'kind': 'Name',
                                                                                                                    'value':
                                                                                                                        'contentImageSitemap',
                                                                                                                },
                                                                                                            },
                                                                                                        ],
                                                                                                },
                                                                                        },
                                                                                        {
                                                                                            'kind': 'Field',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'image',
                                                                                            },
                                                                                            'selectionSet':
                                                                                                {
                                                                                                    'kind': 'SelectionSet',
                                                                                                    'selections':
                                                                                                        [
                                                                                                            {
                                                                                                                'kind': 'Field',
                                                                                                                'name': {
                                                                                                                    'kind': 'Name',
                                                                                                                    'value':
                                                                                                                        'url',
                                                                                                                },
                                                                                                            },
                                                                                                            {
                                                                                                                'kind': 'Field',
                                                                                                                'name': {
                                                                                                                    'kind': 'Name',
                                                                                                                    'value':
                                                                                                                        'title',
                                                                                                                },
                                                                                                            },
                                                                                                            {
                                                                                                                'kind': 'Field',
                                                                                                                'name': {
                                                                                                                    'kind': 'Name',
                                                                                                                    'value':
                                                                                                                        'caption',
                                                                                                                },
                                                                                                            },
                                                                                                        ],
                                                                                                },
                                                                                        },
                                                                                    ],
                                                                            },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            'kind': 'InlineFragment',
                                                            'typeCondition': {
                                                                'kind': 'NamedType',
                                                                'name': {
                                                                    'kind': 'Name',
                                                                    'value':
                                                                        'ComponentGalleryCarousel',
                                                                },
                                                            },
                                                            'selectionSet': {
                                                                'kind': 'SelectionSet',
                                                                'selections': [
                                                                    {
                                                                        'kind': 'Field',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'items',
                                                                        },
                                                                        'selectionSet':
                                                                            {
                                                                                'kind': 'SelectionSet',
                                                                                'selections':
                                                                                    [
                                                                                        {
                                                                                            'kind': 'Field',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'image',
                                                                                            },
                                                                                            'selectionSet':
                                                                                                {
                                                                                                    'kind': 'SelectionSet',
                                                                                                    'selections':
                                                                                                        [
                                                                                                            {
                                                                                                                'kind': 'Field',
                                                                                                                'name': {
                                                                                                                    'kind': 'Name',
                                                                                                                    'value':
                                                                                                                        'url',
                                                                                                                },
                                                                                                            },
                                                                                                            {
                                                                                                                'kind': 'Field',
                                                                                                                'name': {
                                                                                                                    'kind': 'Name',
                                                                                                                    'value':
                                                                                                                        'title',
                                                                                                                },
                                                                                                            },
                                                                                                            {
                                                                                                                'kind': 'Field',
                                                                                                                'name': {
                                                                                                                    'kind': 'Name',
                                                                                                                    'value':
                                                                                                                        'caption',
                                                                                                                },
                                                                                                            },
                                                                                                        ],
                                                                                                },
                                                                                        },
                                                                                    ],
                                                                            },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            'kind': 'InlineFragment',
                                                            'typeCondition': {
                                                                'kind': 'NamedType',
                                                                'name': {
                                                                    'kind': 'Name',
                                                                    'value':
                                                                        'ComponentContentWithGallery',
                                                                },
                                                            },
                                                            'selectionSet': {
                                                                'kind': 'SelectionSet',
                                                                'selections': [
                                                                    {
                                                                        'kind': 'Field',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'content',
                                                                        },
                                                                        'selectionSet':
                                                                            {
                                                                                'kind': 'SelectionSet',
                                                                                'selections':
                                                                                    [
                                                                                        {
                                                                                            'kind': 'FragmentSpread',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'contentImageSitemap',
                                                                                            },
                                                                                        },
                                                                                    ],
                                                                            },
                                                                    },
                                                                    {
                                                                        'kind': 'Field',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'gallery',
                                                                        },
                                                                        'selectionSet':
                                                                            {
                                                                                'kind': 'SelectionSet',
                                                                                'selections':
                                                                                    [
                                                                                        {
                                                                                            'kind': 'Field',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'image',
                                                                                            },
                                                                                            'selectionSet':
                                                                                                {
                                                                                                    'kind': 'SelectionSet',
                                                                                                    'selections':
                                                                                                        [
                                                                                                            {
                                                                                                                'kind': 'Field',
                                                                                                                'name': {
                                                                                                                    'kind': 'Name',
                                                                                                                    'value':
                                                                                                                        'url',
                                                                                                                },
                                                                                                            },
                                                                                                            {
                                                                                                                'kind': 'Field',
                                                                                                                'name': {
                                                                                                                    'kind': 'Name',
                                                                                                                    'value':
                                                                                                                        'title',
                                                                                                                },
                                                                                                            },
                                                                                                            {
                                                                                                                'kind': 'Field',
                                                                                                                'name': {
                                                                                                                    'kind': 'Name',
                                                                                                                    'value':
                                                                                                                        'caption',
                                                                                                                },
                                                                                                            },
                                                                                                        ],
                                                                                                },
                                                                                        },
                                                                                    ],
                                                                            },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            'kind': 'InlineFragment',
                                                            'typeCondition': {
                                                                'kind': 'NamedType',
                                                                'name': {
                                                                    'kind': 'Name',
                                                                    'value':
                                                                        'ComponentGalleryWithEnquiry',
                                                                },
                                                            },
                                                            'selectionSet': {
                                                                'kind': 'SelectionSet',
                                                                'selections': [
                                                                    {
                                                                        'kind': 'Field',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'items',
                                                                        },
                                                                        'selectionSet':
                                                                            {
                                                                                'kind': 'SelectionSet',
                                                                                'selections':
                                                                                    [
                                                                                        {
                                                                                            'kind': 'Field',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'image',
                                                                                            },
                                                                                            'selectionSet':
                                                                                                {
                                                                                                    'kind': 'SelectionSet',
                                                                                                    'selections':
                                                                                                        [
                                                                                                            {
                                                                                                                'kind': 'Field',
                                                                                                                'name': {
                                                                                                                    'kind': 'Name',
                                                                                                                    'value':
                                                                                                                        'url',
                                                                                                                },
                                                                                                            },
                                                                                                            {
                                                                                                                'kind': 'Field',
                                                                                                                'name': {
                                                                                                                    'kind': 'Name',
                                                                                                                    'value':
                                                                                                                        'title',
                                                                                                                },
                                                                                                            },
                                                                                                            {
                                                                                                                'kind': 'Field',
                                                                                                                'name': {
                                                                                                                    'kind': 'Name',
                                                                                                                    'value':
                                                                                                                        'caption',
                                                                                                                },
                                                                                                            },
                                                                                                        ],
                                                                                                },
                                                                                        },
                                                                                        {
                                                                                            'kind': 'Field',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'caption',
                                                                                            },
                                                                                        },
                                                                                    ],
                                                                            },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...SitemapRegionFragmentDoc.definitions,
        ...PageLinkFragmentDoc.definitions,
        ...ContentImageSitemapFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useSitemapPagesQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, SitemapPagesQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<
        SitemapPagesQuery,
        SitemapPagesQueryVariables | undefined
    >({ query: SitemapPagesDocument, variables: undefined, ...options })
}
export const SitemapReadyToGoDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'sitemapReadyToGo' },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'regions' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'sitemapRegion',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueReadyToGoRingsFilters',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'ObjectValue',
                                    'fields': [],
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'primaryMetals',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'metal',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'systemCode',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueReadyToGoRings',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'readyToGoRingLink',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'images',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'url',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productName',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...SitemapRegionFragmentDoc.definitions,
        ...ReadyToGoRingLinkFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useSitemapReadyToGoQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, SitemapReadyToGoQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<
        SitemapReadyToGoQuery,
        SitemapReadyToGoQueryVariables | undefined
    >({ query: SitemapReadyToGoDocument, variables: undefined, ...options })
}
export const SitemapWeddingRingDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'sitemapWeddingRing' },
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'regions' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'sitemapRegion',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueWeddingRingFilterVariations',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'maxSlots' },
                                'value': { 'kind': 'IntValue', 'value': '2' },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'primaryMetal',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'ringStyle',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'category',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueWeddingRings',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'weddingRingLink',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'images',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'url',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'images360',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'url',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productName',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...SitemapRegionFragmentDoc.definitions,
        ...WeddingRingLinkFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useSitemapWeddingRingQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, SitemapWeddingRingQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<
        SitemapWeddingRingQuery,
        SitemapWeddingRingQueryVariables | undefined
    >({ query: SitemapWeddingRingDocument, variables: undefined, ...options })
}
export const BlogAuthorDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'blogAuthor' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'slug' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'String' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'page' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Int' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'limit' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Int' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'postCategories' },
                    },
                    {
                        'kind': 'Field',
                        'alias': { 'kind': 'Name', 'value': 'collection' },
                        'name': { 'kind': 'Name', 'value': 'authorBySlug' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'slug' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': { 'kind': 'Name', 'value': 'slug' },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'authorPosts',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...PostCategoriesFragmentDoc.definitions,
        ...BlogMenuFragmentDoc.definitions,
        ...AuthorPostsFragmentDoc.definitions,
        ...BlogPostPreviewFragmentDoc.definitions,
        ...ImageLargeFragmentDoc.definitions,
        ...ImageCommonFragmentDoc.definitions,
        ...ImageSizeFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useBlogAuthorQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, BlogAuthorQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<BlogAuthorQuery, BlogAuthorQueryVariables | undefined>(
        { query: BlogAuthorDocument, variables: undefined, ...options }
    )
}
export const BlogPostDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'blogPost' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'slug' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'String' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'currency' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CurrencyInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'region' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'RegionCode' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'FragmentSpread',
                        'name': { 'kind': 'Name', 'value': 'postCategories' },
                    },
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'postBySlug' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'slug' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': { 'kind': 'Name', 'value': 'slug' },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'title',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'slug' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'excerpt',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'date' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'featuredImage',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'imageLarge',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'blocks',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'block',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'tags' },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'id',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'name',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'slug',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'author',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'id',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'name',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'image',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'imageLarge',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'blogAuthorRoute',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'categories',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'id',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'name',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'slug',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'relatedPosts',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'limit',
                                            },
                                            'value': {
                                                'kind': 'IntValue',
                                                'value': '3',
                                            },
                                        },
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'blogPostPreview',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'postLink',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'meta' },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'meta',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...PostCategoriesFragmentDoc.definitions,
        ...BlogMenuFragmentDoc.definitions,
        ...ImageLargeFragmentDoc.definitions,
        ...ImageCommonFragmentDoc.definitions,
        ...ImageSizeFragmentDoc.definitions,
        ...BlockFragmentDoc.definitions,
        ...BlockAnchorFragmentDoc.definitions,
        ...ComponentFragmentDoc.definitions,
        ...ComponentRoundedImageFragmentDoc.definitions,
        ...ImageMediumFragmentDoc.definitions,
        ...ComponentRoundedImageContentFragmentDoc.definitions,
        ...ContentComponentItemFragmentDoc.definitions,
        ...ComponentTitleFragmentDoc.definitions,
        ...ComponentTitleComponentFragmentDoc.definitions,
        ...ComponentTitleAmpersandFragmentDoc.definitions,
        ...ComponentTitleTextFragmentDoc.definitions,
        ...ComponentTextFragmentDoc.definitions,
        ...ComponentButtonFragmentDoc.definitions,
        ...LinkFragmentDoc.definitions,
        ...LinkItemFragmentDoc.definitions,
        ...PageLinkFragmentDoc.definitions,
        ...PostLinkFragmentDoc.definitions,
        ...CustomLinkFragmentDoc.definitions,
        ...LinkQuestionnaireFragmentDoc.definitions,
        ...LinkItemOpenEnquiryFormFragmentDoc.definitions,
        ...LinkItemOpenContactFormFragmentDoc.definitions,
        ...LinkItemOpenSpeakToExpertModalFragmentDoc.definitions,
        ...ComponentSpacerFragmentDoc.definitions,
        ...ComponentImageFragmentDoc.definitions,
        ...ComponentOrderedListFragmentDoc.definitions,
        ...OrderedListItemFragmentDoc.definitions,
        ...ComponentContentFragmentDoc.definitions,
        ...ComponentCardFragmentDoc.definitions,
        ...ComponentTextOverImageFragmentDoc.definitions,
        ...ComponentCustomProductCarouselFragmentDoc.definitions,
        ...CustomProductCarouselCardFragmentDoc.definitions,
        ...ComponentCatalogueProductCarouselFragmentDoc.definitions,
        ...ProductCardFragmentDoc.definitions,
        ...ProductLinkFragmentDoc.definitions,
        ...EngagementRingLinkFragmentDoc.definitions,
        ...JewelleryLinkFragmentDoc.definitions,
        ...ReadyToGoRingLinkFragmentDoc.definitions,
        ...WeddingRingLinkFragmentDoc.definitions,
        ...MetalVariationFragmentDoc.definitions,
        ...MetalFilterMetalFragmentDoc.definitions,
        ...GetIsLabGrownFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...MonolithImageSizeFragmentDoc.definitions,
        ...ComponentReviewCarouselFragmentDoc.definitions,
        ...ComponentMainCoverFragmentDoc.definitions,
        ...ImageCoverFragmentDoc.definitions,
        ...ComponentVideoFragmentDoc.definitions,
        ...VideoFragmentDoc.definitions,
        ...ComponentVideoWithContentFragmentDoc.definitions,
        ...ComponentInstagramPostsFragmentDoc.definitions,
        ...ComponentLogosFragmentDoc.definitions,
        ...ComponentLogosCarouselFragmentDoc.definitions,
        ...ComponentTextWithImageFragmentDoc.definitions,
        ...ComponentGalleryCarouselFragmentDoc.definitions,
        ...GalleryCarouselCardFragmentDoc.definitions,
        ...ComponentCardCarouselFragmentDoc.definitions,
        ...CardCarouselCardFragmentDoc.definitions,
        ...ComponentFullWidthImageFragmentDoc.definitions,
        ...ComponentSideBySideImagesFragmentDoc.definitions,
        ...ComponentSideBySideImageFragmentDoc.definitions,
        ...ComponentArticlePreviewsFragmentDoc.definitions,
        ...ArticlePreviewFragmentDoc.definitions,
        ...ComponentInstagramWithContentFragmentDoc.definitions,
        ...ComponentBannerTitleFragmentDoc.definitions,
        ...ComponentQuoteFragmentDoc.definitions,
        ...ComponentBannerSkinnyFragmentDoc.definitions,
        ...ComponentGlobalSpacerFragmentDoc.definitions,
        ...ComponentTextWithImageCarouselFragmentDoc.definitions,
        ...ComponentContentWithGalleryFragmentDoc.definitions,
        ...ComponentIconCarouselFragmentDoc.definitions,
        ...ComponentTextCarouselFragmentDoc.definitions,
        ...ComponentFaqFragmentDoc.definitions,
        ...FaqSectionFragmentDoc.definitions,
        ...FaqQuestionFragmentDoc.definitions,
        ...ComponentContentTwoColumnsFragmentDoc.definitions,
        ...ComponentTableFragmentDoc.definitions,
        ...ComponentArticleGridFragmentDoc.definitions,
        ...ArticleGridItemFragmentDoc.definitions,
        ...ComponentOnThisPageFragmentDoc.definitions,
        ...ComponentGalleryWithEnquiryFragmentDoc.definitions,
        ...GalleryWithEnquiryCardFragmentDoc.definitions,
        ...ComponentSquareBoxesFragmentDoc.definitions,
        ...SquareBoxesFragmentDoc.definitions,
        ...SquareTextBoxFragmentDoc.definitions,
        ...SquareImageBoxFragmentDoc.definitions,
        ...ComponentShopWithConfidenceFragmentDoc.definitions,
        ...ComponentGlobalComponentFragmentDoc.definitions,
        ...BlogAuthorRouteFragmentDoc.definitions,
        ...BlogPostPreviewFragmentDoc.definitions,
        ...MetaFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useBlogPostQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, BlogPostQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<BlogPostQuery, BlogPostQueryVariables | undefined>({
        query: BlogPostDocument,
        variables: undefined,
        ...options,
    })
}
export const EngagementRingPageDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'engagementRingPage' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'currency' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CurrencyInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'region' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'RegionCode' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'page' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'String' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'pageFallback' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'String' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': {
                            'kind': 'Name',
                            'value': 'engagementRingFilter',
                        },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueEngagementRingFilterInput',
                            },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueEngagementRing',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'filter' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'engagementRingFilter',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'engagementRingLink',
                                    },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productPageMeta',
                                    },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productGallery',
                                    },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productAnalytics',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'meleeItems',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'melee',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'shopWithConfidenceProduct',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'alias': {
                                        'kind': 'Name',
                                        'value': 'noEngravingDeliveryDate',
                                    },
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'firstAvailableDeliveryDate',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'hasEngraving',
                                            },
                                            'value': {
                                                'kind': 'BooleanValue',
                                                'value': false,
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'deliveryTimeframe',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'alias': {
                                        'kind': 'Name',
                                        'value': 'hasEngravingDeliveryDate',
                                    },
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'firstAvailableDeliveryDate',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'hasEngraving',
                                            },
                                            'value': {
                                                'kind': 'BooleanValue',
                                                'value': true,
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'deliveryTimeframe',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'reviews',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'reviews',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'catalogueCode',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'salePrice',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'currency',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'currency',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'taxSnippet',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productName',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'variationsByCentreStoneShape',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'engagementRingLink',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'centreStoneConstraints',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'shape',
                                                            },
                                                            'selectionSet': {
                                                                'kind': 'SelectionSet',
                                                                'selections': [
                                                                    {
                                                                        'kind': 'Field',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'systemCode',
                                                                        },
                                                                    },
                                                                    {
                                                                        'kind': 'Field',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'translation',
                                                                        },
                                                                        'arguments':
                                                                            [
                                                                                {
                                                                                    'kind': 'Argument',
                                                                                    'name': {
                                                                                        'kind': 'Name',
                                                                                        'value':
                                                                                            'locale',
                                                                                    },
                                                                                    'value':
                                                                                        {
                                                                                            'kind': 'Variable',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'locale',
                                                                                            },
                                                                                        },
                                                                                },
                                                                            ],
                                                                        'selectionSet':
                                                                            {
                                                                                'kind': 'SelectionSet',
                                                                                'selections':
                                                                                    [
                                                                                        {
                                                                                            'kind': 'Field',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'name',
                                                                                            },
                                                                                        },
                                                                                    ],
                                                                            },
                                                                    },
                                                                    {
                                                                        'kind': 'Field',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'icon',
                                                                        },
                                                                        'selectionSet':
                                                                            {
                                                                                'kind': 'SelectionSet',
                                                                                'selections':
                                                                                    [
                                                                                        {
                                                                                            'kind': 'Field',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'id',
                                                                                            },
                                                                                        },
                                                                                        {
                                                                                            'kind': 'Field',
                                                                                            'name': {
                                                                                                'kind': 'Name',
                                                                                                'value':
                                                                                                    'url',
                                                                                            },
                                                                                        },
                                                                                    ],
                                                                            },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'variationsByPrimaryMetal',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'metalVariation',
                                                },
                                            },
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'engagementRingLink',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'bandWidth',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'relatedProducts',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'relatedProduct',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'primaryMetal',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'translation',
                                                },
                                                'arguments': [
                                                    {
                                                        'kind': 'Argument',
                                                        'name': {
                                                            'kind': 'Name',
                                                            'value': 'locale',
                                                        },
                                                        'value': {
                                                            'kind': 'Variable',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'locale',
                                                            },
                                                        },
                                                    },
                                                ],
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value': 'name',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'translation',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'locale',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'locale',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'seoText',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'centreStoneConstraints',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'shape',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'translation',
                                                            },
                                                            'arguments': [
                                                                {
                                                                    'kind': 'Argument',
                                                                    'name': {
                                                                        'kind': 'Name',
                                                                        'value':
                                                                            'locale',
                                                                    },
                                                                    'value': {
                                                                        'kind': 'Variable',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'locale',
                                                                        },
                                                                    },
                                                                },
                                                            ],
                                                            'selectionSet': {
                                                                'kind': 'SelectionSet',
                                                                'selections': [
                                                                    {
                                                                        'kind': 'Field',
                                                                        'name': {
                                                                            'kind': 'Name',
                                                                            'value':
                                                                                'name',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'signatureStone',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'colors',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'systemCode',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'crystal',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'Field',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'systemCode',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'width',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'signatureStones',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'engagementRingAndSignatureStone',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'pageProductDetails',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'path' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': { 'kind': 'Name', 'value': 'page' },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'fallback' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'pageFallback',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'blocks',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'block',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'meta' },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'meta',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'priceExplainedTooltip',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'pageTooltip',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...EngagementRingLinkFragmentDoc.definitions,
        ...ProductPageMetaFragmentDoc.definitions,
        ...AssetFragmentDoc.definitions,
        ...MetalFilterMetalFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...ProductGalleryFragmentDoc.definitions,
        ...MonolithImageSizeFragmentDoc.definitions,
        ...ThreeSixtyFragmentDoc.definitions,
        ...CatalogueVideoFragmentDoc.definitions,
        ...ProductAnalyticsFragmentDoc.definitions,
        ...MeleeFragmentDoc.definitions,
        ...ShopWithConfidenceProductFragmentDoc.definitions,
        ...DeliveryTimeframeFragmentDoc.definitions,
        ...ReviewsFragmentDoc.definitions,
        ...TaxSnippetFragmentDoc.definitions,
        ...MetalVariationFragmentDoc.definitions,
        ...RelatedProductFragmentDoc.definitions,
        ...ProductCardFragmentDoc.definitions,
        ...ProductLinkFragmentDoc.definitions,
        ...JewelleryLinkFragmentDoc.definitions,
        ...ReadyToGoRingLinkFragmentDoc.definitions,
        ...WeddingRingLinkFragmentDoc.definitions,
        ...GetIsLabGrownFragmentDoc.definitions,
        ...EngagementRingAndSignatureStoneFragmentDoc.definitions,
        ...SignatureStoneInputFragmentDoc.definitions,
        ...BlockFragmentDoc.definitions,
        ...BlockAnchorFragmentDoc.definitions,
        ...ComponentFragmentDoc.definitions,
        ...ComponentRoundedImageFragmentDoc.definitions,
        ...ImageMediumFragmentDoc.definitions,
        ...ImageCommonFragmentDoc.definitions,
        ...ImageSizeFragmentDoc.definitions,
        ...ComponentRoundedImageContentFragmentDoc.definitions,
        ...ContentComponentItemFragmentDoc.definitions,
        ...ComponentTitleFragmentDoc.definitions,
        ...ComponentTitleComponentFragmentDoc.definitions,
        ...ComponentTitleAmpersandFragmentDoc.definitions,
        ...ComponentTitleTextFragmentDoc.definitions,
        ...ComponentTextFragmentDoc.definitions,
        ...ComponentButtonFragmentDoc.definitions,
        ...LinkFragmentDoc.definitions,
        ...LinkItemFragmentDoc.definitions,
        ...PageLinkFragmentDoc.definitions,
        ...PostLinkFragmentDoc.definitions,
        ...CustomLinkFragmentDoc.definitions,
        ...LinkQuestionnaireFragmentDoc.definitions,
        ...LinkItemOpenEnquiryFormFragmentDoc.definitions,
        ...LinkItemOpenContactFormFragmentDoc.definitions,
        ...LinkItemOpenSpeakToExpertModalFragmentDoc.definitions,
        ...ComponentSpacerFragmentDoc.definitions,
        ...ComponentImageFragmentDoc.definitions,
        ...ImageLargeFragmentDoc.definitions,
        ...ComponentOrderedListFragmentDoc.definitions,
        ...OrderedListItemFragmentDoc.definitions,
        ...ComponentContentFragmentDoc.definitions,
        ...ComponentCardFragmentDoc.definitions,
        ...ComponentTextOverImageFragmentDoc.definitions,
        ...ComponentCustomProductCarouselFragmentDoc.definitions,
        ...CustomProductCarouselCardFragmentDoc.definitions,
        ...ComponentCatalogueProductCarouselFragmentDoc.definitions,
        ...ComponentReviewCarouselFragmentDoc.definitions,
        ...ComponentMainCoverFragmentDoc.definitions,
        ...ImageCoverFragmentDoc.definitions,
        ...ComponentVideoFragmentDoc.definitions,
        ...VideoFragmentDoc.definitions,
        ...ComponentVideoWithContentFragmentDoc.definitions,
        ...ComponentInstagramPostsFragmentDoc.definitions,
        ...ComponentLogosFragmentDoc.definitions,
        ...ComponentLogosCarouselFragmentDoc.definitions,
        ...ComponentTextWithImageFragmentDoc.definitions,
        ...ComponentGalleryCarouselFragmentDoc.definitions,
        ...GalleryCarouselCardFragmentDoc.definitions,
        ...ComponentCardCarouselFragmentDoc.definitions,
        ...CardCarouselCardFragmentDoc.definitions,
        ...ComponentFullWidthImageFragmentDoc.definitions,
        ...ComponentSideBySideImagesFragmentDoc.definitions,
        ...ComponentSideBySideImageFragmentDoc.definitions,
        ...ComponentArticlePreviewsFragmentDoc.definitions,
        ...ArticlePreviewFragmentDoc.definitions,
        ...ComponentInstagramWithContentFragmentDoc.definitions,
        ...ComponentBannerTitleFragmentDoc.definitions,
        ...ComponentQuoteFragmentDoc.definitions,
        ...ComponentBannerSkinnyFragmentDoc.definitions,
        ...ComponentGlobalSpacerFragmentDoc.definitions,
        ...ComponentTextWithImageCarouselFragmentDoc.definitions,
        ...ComponentContentWithGalleryFragmentDoc.definitions,
        ...ComponentIconCarouselFragmentDoc.definitions,
        ...ComponentTextCarouselFragmentDoc.definitions,
        ...ComponentFaqFragmentDoc.definitions,
        ...FaqSectionFragmentDoc.definitions,
        ...FaqQuestionFragmentDoc.definitions,
        ...ComponentContentTwoColumnsFragmentDoc.definitions,
        ...ComponentTableFragmentDoc.definitions,
        ...ComponentArticleGridFragmentDoc.definitions,
        ...ArticleGridItemFragmentDoc.definitions,
        ...ComponentOnThisPageFragmentDoc.definitions,
        ...ComponentGalleryWithEnquiryFragmentDoc.definitions,
        ...GalleryWithEnquiryCardFragmentDoc.definitions,
        ...ComponentSquareBoxesFragmentDoc.definitions,
        ...SquareBoxesFragmentDoc.definitions,
        ...SquareTextBoxFragmentDoc.definitions,
        ...SquareImageBoxFragmentDoc.definitions,
        ...ComponentShopWithConfidenceFragmentDoc.definitions,
        ...ComponentGlobalComponentFragmentDoc.definitions,
        ...MetaFragmentDoc.definitions,
        ...PageTooltipFragmentDoc.definitions,
        ...TooltipFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useEngagementRingPageQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, EngagementRingPageQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<
        EngagementRingPageQuery,
        EngagementRingPageQueryVariables | undefined
    >({ query: EngagementRingPageDocument, variables: undefined, ...options })
}
export const EngagementRingBrowseDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'engagementRingBrowse' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'currency' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CurrencyInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'region' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'RegionCode' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'filter' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueEngagementRingsFilterInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'page' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Int' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'limit' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Int' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'path' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'String' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': {
                            'kind': 'Name',
                            'value': 'facetedContentInput',
                        },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'ProductPageFacetedContentInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'sortBy' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueSortOrder',
                            },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueEngagementRingFilters',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'filter',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'engagementRingFilters',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueEngagementRingsAggregate',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'filter' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'filter',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'count',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueEngagementRings',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'filter' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'filter',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'sort' },
                                'value': {
                                    'kind': 'ObjectValue',
                                    'fields': [
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'by',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'sortBy',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'currency',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'currency',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': {
                                    'kind': 'Name',
                                    'value': 'pagination',
                                },
                                'value': {
                                    'kind': 'ObjectValue',
                                    'fields': [
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'page',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'page',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'limit',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'limit',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productGrid',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'pageProductListingFacetedContent',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'facetedContentInput',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productPageFacetedContent',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'pageProductListing',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'path' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': { 'kind': 'Name', 'value': 'path' },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productPageListing',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...EngagementRingFiltersFragmentDoc.definitions,
        ...FilterPriceRangeFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...FilterEngagementRingStyleFragmentDoc.definitions,
        ...FacetedContentProductLabelTranslationFragmentDoc.definitions,
        ...FilterEngagementRingDesignFeatureFragmentDoc.definitions,
        ...FilterEngagementRingDesignStyleFragmentDoc.definitions,
        ...FilterShapeFragmentDoc.definitions,
        ...MetalFilterFragmentDoc.definitions,
        ...MetalFilterMetalFragmentDoc.definitions,
        ...ProductGridFragmentDoc.definitions,
        ...ProductCardFragmentDoc.definitions,
        ...ProductLinkFragmentDoc.definitions,
        ...EngagementRingLinkFragmentDoc.definitions,
        ...JewelleryLinkFragmentDoc.definitions,
        ...ReadyToGoRingLinkFragmentDoc.definitions,
        ...WeddingRingLinkFragmentDoc.definitions,
        ...MetalVariationFragmentDoc.definitions,
        ...GetIsLabGrownFragmentDoc.definitions,
        ...MonolithImageSizeFragmentDoc.definitions,
        ...ProductListAnalyticsFragmentDoc.definitions,
        ...ProductPageFacetedContentFragmentDoc.definitions,
        ...ProductPageFacetedContentLongDescriptionFragmentDoc.definitions,
        ...BlockFragmentDoc.definitions,
        ...BlockAnchorFragmentDoc.definitions,
        ...ComponentFragmentDoc.definitions,
        ...ComponentRoundedImageFragmentDoc.definitions,
        ...ImageMediumFragmentDoc.definitions,
        ...ImageCommonFragmentDoc.definitions,
        ...ImageSizeFragmentDoc.definitions,
        ...ComponentRoundedImageContentFragmentDoc.definitions,
        ...ContentComponentItemFragmentDoc.definitions,
        ...ComponentTitleFragmentDoc.definitions,
        ...ComponentTitleComponentFragmentDoc.definitions,
        ...ComponentTitleAmpersandFragmentDoc.definitions,
        ...ComponentTitleTextFragmentDoc.definitions,
        ...ComponentTextFragmentDoc.definitions,
        ...ComponentButtonFragmentDoc.definitions,
        ...LinkFragmentDoc.definitions,
        ...LinkItemFragmentDoc.definitions,
        ...PageLinkFragmentDoc.definitions,
        ...PostLinkFragmentDoc.definitions,
        ...CustomLinkFragmentDoc.definitions,
        ...LinkQuestionnaireFragmentDoc.definitions,
        ...LinkItemOpenEnquiryFormFragmentDoc.definitions,
        ...LinkItemOpenContactFormFragmentDoc.definitions,
        ...LinkItemOpenSpeakToExpertModalFragmentDoc.definitions,
        ...ComponentSpacerFragmentDoc.definitions,
        ...ComponentImageFragmentDoc.definitions,
        ...ImageLargeFragmentDoc.definitions,
        ...ComponentOrderedListFragmentDoc.definitions,
        ...OrderedListItemFragmentDoc.definitions,
        ...ComponentContentFragmentDoc.definitions,
        ...ComponentCardFragmentDoc.definitions,
        ...ComponentTextOverImageFragmentDoc.definitions,
        ...ComponentCustomProductCarouselFragmentDoc.definitions,
        ...CustomProductCarouselCardFragmentDoc.definitions,
        ...ComponentCatalogueProductCarouselFragmentDoc.definitions,
        ...ComponentReviewCarouselFragmentDoc.definitions,
        ...ComponentMainCoverFragmentDoc.definitions,
        ...ImageCoverFragmentDoc.definitions,
        ...ComponentVideoFragmentDoc.definitions,
        ...VideoFragmentDoc.definitions,
        ...ComponentVideoWithContentFragmentDoc.definitions,
        ...ComponentInstagramPostsFragmentDoc.definitions,
        ...ComponentLogosFragmentDoc.definitions,
        ...ComponentLogosCarouselFragmentDoc.definitions,
        ...ComponentTextWithImageFragmentDoc.definitions,
        ...ComponentGalleryCarouselFragmentDoc.definitions,
        ...GalleryCarouselCardFragmentDoc.definitions,
        ...ComponentCardCarouselFragmentDoc.definitions,
        ...CardCarouselCardFragmentDoc.definitions,
        ...ComponentFullWidthImageFragmentDoc.definitions,
        ...ComponentSideBySideImagesFragmentDoc.definitions,
        ...ComponentSideBySideImageFragmentDoc.definitions,
        ...ComponentArticlePreviewsFragmentDoc.definitions,
        ...ArticlePreviewFragmentDoc.definitions,
        ...ComponentInstagramWithContentFragmentDoc.definitions,
        ...ComponentBannerTitleFragmentDoc.definitions,
        ...ComponentQuoteFragmentDoc.definitions,
        ...ComponentBannerSkinnyFragmentDoc.definitions,
        ...ComponentGlobalSpacerFragmentDoc.definitions,
        ...ComponentTextWithImageCarouselFragmentDoc.definitions,
        ...ComponentContentWithGalleryFragmentDoc.definitions,
        ...ComponentIconCarouselFragmentDoc.definitions,
        ...ComponentTextCarouselFragmentDoc.definitions,
        ...ComponentFaqFragmentDoc.definitions,
        ...FaqSectionFragmentDoc.definitions,
        ...FaqQuestionFragmentDoc.definitions,
        ...ComponentContentTwoColumnsFragmentDoc.definitions,
        ...ComponentTableFragmentDoc.definitions,
        ...ComponentArticleGridFragmentDoc.definitions,
        ...ArticleGridItemFragmentDoc.definitions,
        ...ComponentOnThisPageFragmentDoc.definitions,
        ...ComponentGalleryWithEnquiryFragmentDoc.definitions,
        ...GalleryWithEnquiryCardFragmentDoc.definitions,
        ...ComponentSquareBoxesFragmentDoc.definitions,
        ...SquareBoxesFragmentDoc.definitions,
        ...SquareTextBoxFragmentDoc.definitions,
        ...SquareImageBoxFragmentDoc.definitions,
        ...ComponentShopWithConfidenceFragmentDoc.definitions,
        ...ComponentGlobalComponentFragmentDoc.definitions,
        ...MetaFragmentDoc.definitions,
        ...ProductPageListingFragmentDoc.definitions,
        ...Banner1FragmentDoc.definitions,
        ...Banner2FragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useEngagementRingBrowseQuery(
    options?: Omit<
        Urql.UseQueryArgs<
            never,
            EngagementRingBrowseQueryVariables | undefined
        >,
        'query'
    >
) {
    return Urql.useQuery<
        EngagementRingBrowseQuery,
        EngagementRingBrowseQueryVariables | undefined
    >({ query: EngagementRingBrowseDocument, variables: undefined, ...options })
}
export const StoneRecommendationsDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'stoneRecommendations' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'minPrice' },
                    },
                    'type': {
                        'kind': 'NamedType',
                        'name': { 'kind': 'Name', 'value': 'MoneyInput' },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'maxPrice' },
                    },
                    'type': {
                        'kind': 'NamedType',
                        'name': { 'kind': 'Name', 'value': 'MoneyInput' },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'currency' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CurrencyInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'region' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'RegionCode' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'hasPrice' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Boolean' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'colorCodes' },
                    },
                    'type': {
                        'kind': 'ListType',
                        'type': {
                            'kind': 'NonNullType',
                            'type': {
                                'kind': 'NamedType',
                                'name': {
                                    'kind': 'Name',
                                    'value': 'StoneColorCode',
                                },
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'colorCodesCms' },
                    },
                    'type': {
                        'kind': 'ListType',
                        'type': {
                            'kind': 'NonNullType',
                            'type': {
                                'kind': 'NamedType',
                                'name': {
                                    'kind': 'Name',
                                    'value': 'CmsGemstoneColorCode',
                                },
                            },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'ringBuilder' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'position1',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'ringBuilderStoneRecommendations',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'position2',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'ringBuilderStoneRecommendations',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'alias': { 'kind': 'Name', 'value': 'cms' },
                        'name': {
                            'kind': 'Name',
                            'value': 'engagementRingStoneRecommendations',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': '__typename',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'fullSearchButtonText',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'blocks',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'block',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'naturalDiamonds',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'forSizeCard',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'engagementRingStoneRecommendationCard',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'forBalanceCard',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'engagementRingStoneRecommendationCard',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'labGrownAlternative',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'engagementRingStoneRecommendationCard',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'nonSkuLabGrown',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'forSizeCard',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'engagementRingStoneRecommendationCard',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'forPriceCard',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'engagementRingStoneRecommendationCard',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'naturalDiamondAlternative',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'engagementRingStoneRecommendationCard',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'nonSkuGemStones',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'colorCodes',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'colorCodesCms',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'content',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'engagementRingStoneRecommendationCard',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'color',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...RingBuilderStoneRecommendationsFragmentDoc.definitions,
        ...StoneRecommendationsFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...StoneFragmentDoc.definitions,
        ...StoneCategoryFragmentDoc.definitions,
        ...StoneCategoryTranslationFragmentDoc.definitions,
        ...StoneClarityFragmentDoc.definitions,
        ...ClarityTranslationFragmentDoc.definitions,
        ...StoneColorFragmentDoc.definitions,
        ...StoneColorTranslationFragmentDoc.definitions,
        ...StoneImageFragmentDoc.definitions,
        ...GemsApiCertificateFragmentDoc.definitions,
        ...StoneRecommendationsNotFoundFragmentDoc.definitions,
        ...NonSkuGemstoneFragmentDoc.definitions,
        ...StoneShapeFragmentDoc.definitions,
        ...AssetFragmentDoc.definitions,
        ...StoneShapeTranslationFragmentDoc.definitions,
        ...StoneCutFragmentDoc.definitions,
        ...StoneCutTranslationFragmentDoc.definitions,
        ...StoneCrystalFragmentDoc.definitions,
        ...StoneCrystalTranslationFragmentDoc.definitions,
        ...StoneGradeFragmentDoc.definitions,
        ...NonSkuGemstoneImageFragmentDoc.definitions,
        ...NonSkuLabGrownFragmentDoc.definitions,
        ...NonSkuLabGrownStoneImageFragmentDoc.definitions,
        ...BlockFragmentDoc.definitions,
        ...BlockAnchorFragmentDoc.definitions,
        ...ComponentFragmentDoc.definitions,
        ...ComponentRoundedImageFragmentDoc.definitions,
        ...ImageMediumFragmentDoc.definitions,
        ...ImageCommonFragmentDoc.definitions,
        ...ImageSizeFragmentDoc.definitions,
        ...ComponentRoundedImageContentFragmentDoc.definitions,
        ...ContentComponentItemFragmentDoc.definitions,
        ...ComponentTitleFragmentDoc.definitions,
        ...ComponentTitleComponentFragmentDoc.definitions,
        ...ComponentTitleAmpersandFragmentDoc.definitions,
        ...ComponentTitleTextFragmentDoc.definitions,
        ...ComponentTextFragmentDoc.definitions,
        ...ComponentButtonFragmentDoc.definitions,
        ...LinkFragmentDoc.definitions,
        ...LinkItemFragmentDoc.definitions,
        ...PageLinkFragmentDoc.definitions,
        ...PostLinkFragmentDoc.definitions,
        ...CustomLinkFragmentDoc.definitions,
        ...LinkQuestionnaireFragmentDoc.definitions,
        ...LinkItemOpenEnquiryFormFragmentDoc.definitions,
        ...LinkItemOpenContactFormFragmentDoc.definitions,
        ...LinkItemOpenSpeakToExpertModalFragmentDoc.definitions,
        ...ComponentSpacerFragmentDoc.definitions,
        ...ComponentImageFragmentDoc.definitions,
        ...ImageLargeFragmentDoc.definitions,
        ...ComponentOrderedListFragmentDoc.definitions,
        ...OrderedListItemFragmentDoc.definitions,
        ...ComponentContentFragmentDoc.definitions,
        ...ComponentCardFragmentDoc.definitions,
        ...ComponentTextOverImageFragmentDoc.definitions,
        ...ComponentCustomProductCarouselFragmentDoc.definitions,
        ...CustomProductCarouselCardFragmentDoc.definitions,
        ...ComponentCatalogueProductCarouselFragmentDoc.definitions,
        ...ProductCardFragmentDoc.definitions,
        ...ProductLinkFragmentDoc.definitions,
        ...EngagementRingLinkFragmentDoc.definitions,
        ...JewelleryLinkFragmentDoc.definitions,
        ...ReadyToGoRingLinkFragmentDoc.definitions,
        ...WeddingRingLinkFragmentDoc.definitions,
        ...MetalVariationFragmentDoc.definitions,
        ...MetalFilterMetalFragmentDoc.definitions,
        ...GetIsLabGrownFragmentDoc.definitions,
        ...MonolithImageSizeFragmentDoc.definitions,
        ...ComponentReviewCarouselFragmentDoc.definitions,
        ...ComponentMainCoverFragmentDoc.definitions,
        ...ImageCoverFragmentDoc.definitions,
        ...ComponentVideoFragmentDoc.definitions,
        ...VideoFragmentDoc.definitions,
        ...ComponentVideoWithContentFragmentDoc.definitions,
        ...ComponentInstagramPostsFragmentDoc.definitions,
        ...ComponentLogosFragmentDoc.definitions,
        ...ComponentLogosCarouselFragmentDoc.definitions,
        ...ComponentTextWithImageFragmentDoc.definitions,
        ...ComponentGalleryCarouselFragmentDoc.definitions,
        ...GalleryCarouselCardFragmentDoc.definitions,
        ...ComponentCardCarouselFragmentDoc.definitions,
        ...CardCarouselCardFragmentDoc.definitions,
        ...ComponentFullWidthImageFragmentDoc.definitions,
        ...ComponentSideBySideImagesFragmentDoc.definitions,
        ...ComponentSideBySideImageFragmentDoc.definitions,
        ...ComponentArticlePreviewsFragmentDoc.definitions,
        ...ArticlePreviewFragmentDoc.definitions,
        ...ComponentInstagramWithContentFragmentDoc.definitions,
        ...ComponentBannerTitleFragmentDoc.definitions,
        ...ComponentQuoteFragmentDoc.definitions,
        ...ComponentBannerSkinnyFragmentDoc.definitions,
        ...ComponentGlobalSpacerFragmentDoc.definitions,
        ...ComponentTextWithImageCarouselFragmentDoc.definitions,
        ...ComponentContentWithGalleryFragmentDoc.definitions,
        ...ComponentIconCarouselFragmentDoc.definitions,
        ...ComponentTextCarouselFragmentDoc.definitions,
        ...ComponentFaqFragmentDoc.definitions,
        ...FaqSectionFragmentDoc.definitions,
        ...FaqQuestionFragmentDoc.definitions,
        ...ComponentContentTwoColumnsFragmentDoc.definitions,
        ...ComponentTableFragmentDoc.definitions,
        ...ComponentArticleGridFragmentDoc.definitions,
        ...ArticleGridItemFragmentDoc.definitions,
        ...ComponentOnThisPageFragmentDoc.definitions,
        ...ComponentGalleryWithEnquiryFragmentDoc.definitions,
        ...GalleryWithEnquiryCardFragmentDoc.definitions,
        ...ComponentSquareBoxesFragmentDoc.definitions,
        ...SquareBoxesFragmentDoc.definitions,
        ...SquareTextBoxFragmentDoc.definitions,
        ...SquareImageBoxFragmentDoc.definitions,
        ...ComponentShopWithConfidenceFragmentDoc.definitions,
        ...ComponentGlobalComponentFragmentDoc.definitions,
        ...EngagementRingStoneRecommendationCardFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useStoneRecommendationsQuery(
    options?: Omit<
        Urql.UseQueryArgs<
            never,
            StoneRecommendationsQueryVariables | undefined
        >,
        'query'
    >
) {
    return Urql.useQuery<
        StoneRecommendationsQuery,
        StoneRecommendationsQueryVariables | undefined
    >({ query: StoneRecommendationsDocument, variables: undefined, ...options })
}
export const JewelleryBrowseDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'jewelleryBrowse' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'currency' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CurrencyInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'region' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'RegionCode' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'filter' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleriesFilterInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'braceletFilter' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value':
                                    'CatalogueJewelleriesBraceletsFilterInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'necklaceFilter' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value':
                                    'CatalogueJewelleriesNecklacesFilterInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'earringsFilter' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value':
                                    'CatalogueJewelleriesEarringsFilterInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'ringsFilter' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleriesRingsFilterInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'isJewellery' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Boolean' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'isBracelet' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Boolean' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'isNecklace' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Boolean' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'isEarrings' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Boolean' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'isRing' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Boolean' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'page' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Int' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'limit' },
                    },
                    'type': {
                        'kind': 'NamedType',
                        'name': { 'kind': 'Name', 'value': 'Int' },
                    },
                    'defaultValue': { 'kind': 'IntValue', 'value': '24' },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'path' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'String' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': {
                            'kind': 'Name',
                            'value': 'facetedContentInput',
                        },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'ProductPageFacetedContentInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'sortBy' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueSortOrder',
                            },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueJewelleriesFilters',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'filter',
                                    },
                                },
                            },
                        ],
                        'directives': [
                            {
                                'kind': 'Directive',
                                'name': { 'kind': 'Name', 'value': 'include' },
                                'arguments': [
                                    {
                                        'kind': 'Argument',
                                        'name': {
                                            'kind': 'Name',
                                            'value': 'if',
                                        },
                                        'value': {
                                            'kind': 'Variable',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'isJewellery',
                                            },
                                        },
                                    },
                                ],
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'jewelleryFilters',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueJewelleries',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'filter' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'filter',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'sort' },
                                'value': {
                                    'kind': 'ObjectValue',
                                    'fields': [
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'currency',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'currency',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'by',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'sortBy',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': {
                                    'kind': 'Name',
                                    'value': 'pagination',
                                },
                                'value': {
                                    'kind': 'ObjectValue',
                                    'fields': [
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'page',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'page',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'limit',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'limit',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        'directives': [
                            {
                                'kind': 'Directive',
                                'name': { 'kind': 'Name', 'value': 'include' },
                                'arguments': [
                                    {
                                        'kind': 'Argument',
                                        'name': {
                                            'kind': 'Name',
                                            'value': 'if',
                                        },
                                        'value': {
                                            'kind': 'Variable',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'isJewellery',
                                            },
                                        },
                                    },
                                ],
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productGrid',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueJewelleryNecklacesFilters',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'necklaceFilter',
                                    },
                                },
                            },
                        ],
                        'directives': [
                            {
                                'kind': 'Directive',
                                'name': { 'kind': 'Name', 'value': 'include' },
                                'arguments': [
                                    {
                                        'kind': 'Argument',
                                        'name': {
                                            'kind': 'Name',
                                            'value': 'if',
                                        },
                                        'value': {
                                            'kind': 'Variable',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'isNecklace',
                                            },
                                        },
                                    },
                                ],
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'jewelleryNecklaceFilters',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueJewelleryNecklaces',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'filter' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'necklaceFilter',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'sort' },
                                'value': {
                                    'kind': 'ObjectValue',
                                    'fields': [
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'currency',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'currency',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'by',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'sortBy',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': {
                                    'kind': 'Name',
                                    'value': 'pagination',
                                },
                                'value': {
                                    'kind': 'ObjectValue',
                                    'fields': [
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'page',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'page',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'limit',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'limit',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        'directives': [
                            {
                                'kind': 'Directive',
                                'name': { 'kind': 'Name', 'value': 'include' },
                                'arguments': [
                                    {
                                        'kind': 'Argument',
                                        'name': {
                                            'kind': 'Name',
                                            'value': 'if',
                                        },
                                        'value': {
                                            'kind': 'Variable',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'isNecklace',
                                            },
                                        },
                                    },
                                ],
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productGrid',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueJewelleryBraceletsFilters',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'braceletFilter',
                                    },
                                },
                            },
                        ],
                        'directives': [
                            {
                                'kind': 'Directive',
                                'name': { 'kind': 'Name', 'value': 'include' },
                                'arguments': [
                                    {
                                        'kind': 'Argument',
                                        'name': {
                                            'kind': 'Name',
                                            'value': 'if',
                                        },
                                        'value': {
                                            'kind': 'Variable',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'isBracelet',
                                            },
                                        },
                                    },
                                ],
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'jewelleryBraceletFilters',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueJewelleryBracelets',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'filter' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'braceletFilter',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'sort' },
                                'value': {
                                    'kind': 'ObjectValue',
                                    'fields': [
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'currency',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'currency',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'by',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'sortBy',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': {
                                    'kind': 'Name',
                                    'value': 'pagination',
                                },
                                'value': {
                                    'kind': 'ObjectValue',
                                    'fields': [
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'page',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'page',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'limit',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'limit',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        'directives': [
                            {
                                'kind': 'Directive',
                                'name': { 'kind': 'Name', 'value': 'include' },
                                'arguments': [
                                    {
                                        'kind': 'Argument',
                                        'name': {
                                            'kind': 'Name',
                                            'value': 'if',
                                        },
                                        'value': {
                                            'kind': 'Variable',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'isBracelet',
                                            },
                                        },
                                    },
                                ],
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productGrid',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueJewelleryEarringsFilters',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'earringsFilter',
                                    },
                                },
                            },
                        ],
                        'directives': [
                            {
                                'kind': 'Directive',
                                'name': { 'kind': 'Name', 'value': 'include' },
                                'arguments': [
                                    {
                                        'kind': 'Argument',
                                        'name': {
                                            'kind': 'Name',
                                            'value': 'if',
                                        },
                                        'value': {
                                            'kind': 'Variable',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'isEarrings',
                                            },
                                        },
                                    },
                                ],
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'jewelleryEarringsFilters',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueJewelleryEarrings',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'filter' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'earringsFilter',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'sort' },
                                'value': {
                                    'kind': 'ObjectValue',
                                    'fields': [
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'currency',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'currency',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'by',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'sortBy',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': {
                                    'kind': 'Name',
                                    'value': 'pagination',
                                },
                                'value': {
                                    'kind': 'ObjectValue',
                                    'fields': [
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'page',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'page',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'limit',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'limit',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        'directives': [
                            {
                                'kind': 'Directive',
                                'name': { 'kind': 'Name', 'value': 'include' },
                                'arguments': [
                                    {
                                        'kind': 'Argument',
                                        'name': {
                                            'kind': 'Name',
                                            'value': 'if',
                                        },
                                        'value': {
                                            'kind': 'Variable',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'isEarrings',
                                            },
                                        },
                                    },
                                ],
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productGrid',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueJewelleryRingsFilters',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'ringsFilter',
                                    },
                                },
                            },
                        ],
                        'directives': [
                            {
                                'kind': 'Directive',
                                'name': { 'kind': 'Name', 'value': 'include' },
                                'arguments': [
                                    {
                                        'kind': 'Argument',
                                        'name': {
                                            'kind': 'Name',
                                            'value': 'if',
                                        },
                                        'value': {
                                            'kind': 'Variable',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'isRing',
                                            },
                                        },
                                    },
                                ],
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'jewelleryRingsFilters',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueJewelleryRings',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'filter' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'ringsFilter',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'sort' },
                                'value': {
                                    'kind': 'ObjectValue',
                                    'fields': [
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'currency',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'currency',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'by',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'sortBy',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': {
                                    'kind': 'Name',
                                    'value': 'pagination',
                                },
                                'value': {
                                    'kind': 'ObjectValue',
                                    'fields': [
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'page',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'page',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'limit',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'limit',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        'directives': [
                            {
                                'kind': 'Directive',
                                'name': { 'kind': 'Name', 'value': 'include' },
                                'arguments': [
                                    {
                                        'kind': 'Argument',
                                        'name': {
                                            'kind': 'Name',
                                            'value': 'if',
                                        },
                                        'value': {
                                            'kind': 'Variable',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'isRing',
                                            },
                                        },
                                    },
                                ],
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productGrid',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueJewelleriesAggregate',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'filter' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'filter',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'count',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueJewelleryBraceletsAggregate',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'filter' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'braceletFilter',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'count',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueJewelleryEarringsAggregate',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'filter' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'earringsFilter',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'count',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueJewelleryNecklacesAggregate',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'filter' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'necklaceFilter',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'count',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueJewelleryRingsAggregate',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'filter' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'ringsFilter',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'count',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'pageProductListingFacetedContent',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'facetedContentInput',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productPageFacetedContent',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'pageProductListing',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'path' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': { 'kind': 'Name', 'value': 'path' },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productPageListing',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...JewelleryFiltersFragmentDoc.definitions,
        ...FilterPriceRangeFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...MetalFilterFragmentDoc.definitions,
        ...MetalFilterMetalFragmentDoc.definitions,
        ...JewelleryDesignStyleFilterFragmentDoc.definitions,
        ...JewelleryDesignStyleLabelFragmentDoc.definitions,
        ...FacetedContentProductLabelTranslationFragmentDoc.definitions,
        ...AssetFragmentDoc.definitions,
        ...CatalogueFilterJewelleryDesignFeatureLabelFragmentDoc.definitions,
        ...JewelleryDesignFeatureLabelFragmentDoc.definitions,
        ...CatalogueFilterJewelleryGemstoneLabelFragmentDoc.definitions,
        ...JewelleryGemstoneLabelFragmentDoc.definitions,
        ...ProductGridFragmentDoc.definitions,
        ...ProductCardFragmentDoc.definitions,
        ...ProductLinkFragmentDoc.definitions,
        ...EngagementRingLinkFragmentDoc.definitions,
        ...JewelleryLinkFragmentDoc.definitions,
        ...ReadyToGoRingLinkFragmentDoc.definitions,
        ...WeddingRingLinkFragmentDoc.definitions,
        ...MetalVariationFragmentDoc.definitions,
        ...GetIsLabGrownFragmentDoc.definitions,
        ...MonolithImageSizeFragmentDoc.definitions,
        ...ProductListAnalyticsFragmentDoc.definitions,
        ...JewelleryNecklaceFiltersFragmentDoc.definitions,
        ...JewelleryNecklaceProductStyleLabelFragmentDoc.definitions,
        ...JewelleryBraceletFiltersFragmentDoc.definitions,
        ...JewelleryBraceletProductStyleLabelFragmentDoc.definitions,
        ...JewelleryEarringsFiltersFragmentDoc.definitions,
        ...JewelleryEarringsProductStyleLabelFragmentDoc.definitions,
        ...JewelleryRingsFiltersFragmentDoc.definitions,
        ...JewelleryRingProductStyleLabelFragmentDoc.definitions,
        ...ProductPageFacetedContentFragmentDoc.definitions,
        ...ProductPageFacetedContentLongDescriptionFragmentDoc.definitions,
        ...BlockFragmentDoc.definitions,
        ...BlockAnchorFragmentDoc.definitions,
        ...ComponentFragmentDoc.definitions,
        ...ComponentRoundedImageFragmentDoc.definitions,
        ...ImageMediumFragmentDoc.definitions,
        ...ImageCommonFragmentDoc.definitions,
        ...ImageSizeFragmentDoc.definitions,
        ...ComponentRoundedImageContentFragmentDoc.definitions,
        ...ContentComponentItemFragmentDoc.definitions,
        ...ComponentTitleFragmentDoc.definitions,
        ...ComponentTitleComponentFragmentDoc.definitions,
        ...ComponentTitleAmpersandFragmentDoc.definitions,
        ...ComponentTitleTextFragmentDoc.definitions,
        ...ComponentTextFragmentDoc.definitions,
        ...ComponentButtonFragmentDoc.definitions,
        ...LinkFragmentDoc.definitions,
        ...LinkItemFragmentDoc.definitions,
        ...PageLinkFragmentDoc.definitions,
        ...PostLinkFragmentDoc.definitions,
        ...CustomLinkFragmentDoc.definitions,
        ...LinkQuestionnaireFragmentDoc.definitions,
        ...LinkItemOpenEnquiryFormFragmentDoc.definitions,
        ...LinkItemOpenContactFormFragmentDoc.definitions,
        ...LinkItemOpenSpeakToExpertModalFragmentDoc.definitions,
        ...ComponentSpacerFragmentDoc.definitions,
        ...ComponentImageFragmentDoc.definitions,
        ...ImageLargeFragmentDoc.definitions,
        ...ComponentOrderedListFragmentDoc.definitions,
        ...OrderedListItemFragmentDoc.definitions,
        ...ComponentContentFragmentDoc.definitions,
        ...ComponentCardFragmentDoc.definitions,
        ...ComponentTextOverImageFragmentDoc.definitions,
        ...ComponentCustomProductCarouselFragmentDoc.definitions,
        ...CustomProductCarouselCardFragmentDoc.definitions,
        ...ComponentCatalogueProductCarouselFragmentDoc.definitions,
        ...ComponentReviewCarouselFragmentDoc.definitions,
        ...ComponentMainCoverFragmentDoc.definitions,
        ...ImageCoverFragmentDoc.definitions,
        ...ComponentVideoFragmentDoc.definitions,
        ...VideoFragmentDoc.definitions,
        ...ComponentVideoWithContentFragmentDoc.definitions,
        ...ComponentInstagramPostsFragmentDoc.definitions,
        ...ComponentLogosFragmentDoc.definitions,
        ...ComponentLogosCarouselFragmentDoc.definitions,
        ...ComponentTextWithImageFragmentDoc.definitions,
        ...ComponentGalleryCarouselFragmentDoc.definitions,
        ...GalleryCarouselCardFragmentDoc.definitions,
        ...ComponentCardCarouselFragmentDoc.definitions,
        ...CardCarouselCardFragmentDoc.definitions,
        ...ComponentFullWidthImageFragmentDoc.definitions,
        ...ComponentSideBySideImagesFragmentDoc.definitions,
        ...ComponentSideBySideImageFragmentDoc.definitions,
        ...ComponentArticlePreviewsFragmentDoc.definitions,
        ...ArticlePreviewFragmentDoc.definitions,
        ...ComponentInstagramWithContentFragmentDoc.definitions,
        ...ComponentBannerTitleFragmentDoc.definitions,
        ...ComponentQuoteFragmentDoc.definitions,
        ...ComponentBannerSkinnyFragmentDoc.definitions,
        ...ComponentGlobalSpacerFragmentDoc.definitions,
        ...ComponentTextWithImageCarouselFragmentDoc.definitions,
        ...ComponentContentWithGalleryFragmentDoc.definitions,
        ...ComponentIconCarouselFragmentDoc.definitions,
        ...ComponentTextCarouselFragmentDoc.definitions,
        ...ComponentFaqFragmentDoc.definitions,
        ...FaqSectionFragmentDoc.definitions,
        ...FaqQuestionFragmentDoc.definitions,
        ...ComponentContentTwoColumnsFragmentDoc.definitions,
        ...ComponentTableFragmentDoc.definitions,
        ...ComponentArticleGridFragmentDoc.definitions,
        ...ArticleGridItemFragmentDoc.definitions,
        ...ComponentOnThisPageFragmentDoc.definitions,
        ...ComponentGalleryWithEnquiryFragmentDoc.definitions,
        ...GalleryWithEnquiryCardFragmentDoc.definitions,
        ...ComponentSquareBoxesFragmentDoc.definitions,
        ...SquareBoxesFragmentDoc.definitions,
        ...SquareTextBoxFragmentDoc.definitions,
        ...SquareImageBoxFragmentDoc.definitions,
        ...ComponentShopWithConfidenceFragmentDoc.definitions,
        ...ComponentGlobalComponentFragmentDoc.definitions,
        ...MetaFragmentDoc.definitions,
        ...ProductPageListingFragmentDoc.definitions,
        ...Banner1FragmentDoc.definitions,
        ...Banner2FragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useJewelleryBrowseQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, JewelleryBrowseQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<
        JewelleryBrowseQuery,
        JewelleryBrowseQueryVariables | undefined
    >({ query: JewelleryBrowseDocument, variables: undefined, ...options })
}
export const JewelleryDetailsDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'jewelleryDetails' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'slug' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'String' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'metal' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'MetalCode' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'suffixSlug' },
                    },
                    'type': {
                        'kind': 'NamedType',
                        'name': { 'kind': 'Name', 'value': 'String' },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'region' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'RegionCode' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'currency' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CurrencyInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'page' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'String' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'pageFallback' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'String' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'type' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueJewelleryType',
                            },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueJewellery',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'filter' },
                                'value': {
                                    'kind': 'ObjectValue',
                                    'fields': [
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'slug',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'slug',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'suffixSlug',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'suffixSlug',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'primaryMetalCode',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'metal',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'type' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': { 'kind': 'Name', 'value': 'type' },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'jewellery',
                                    },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'jewelleryLink',
                                    },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'shopWithConfidenceProduct',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'financeOptionsAffirm',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'currency',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'currency',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'affirmFinanceOptions',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'financeOptionsKlarna',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'currency',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'currency',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'klarnaFinanceOptions',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'reviews',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'reviews',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'pageProductDetails',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'path' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': { 'kind': 'Name', 'value': 'page' },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'fallback' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'pageFallback',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'blocks',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'block',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'meta' },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'meta',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'priceExplainedTooltip',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'pageTooltip',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...JewelleryFragmentDoc.definitions,
        ...CatalogueProductFragmentDoc.definitions,
        ...RelatedProductFragmentDoc.definitions,
        ...ProductCardFragmentDoc.definitions,
        ...ProductLinkFragmentDoc.definitions,
        ...EngagementRingLinkFragmentDoc.definitions,
        ...JewelleryLinkFragmentDoc.definitions,
        ...ReadyToGoRingLinkFragmentDoc.definitions,
        ...WeddingRingLinkFragmentDoc.definitions,
        ...MetalVariationFragmentDoc.definitions,
        ...MetalFilterMetalFragmentDoc.definitions,
        ...GetIsLabGrownFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...MonolithImageSizeFragmentDoc.definitions,
        ...ProductGalleryFragmentDoc.definitions,
        ...ThreeSixtyFragmentDoc.definitions,
        ...CatalogueVideoFragmentDoc.definitions,
        ...ProductAnalyticsFragmentDoc.definitions,
        ...ProductPageMetaFragmentDoc.definitions,
        ...AssetFragmentDoc.definitions,
        ...JewelleryDesignStyleLabelFragmentDoc.definitions,
        ...FacetedContentProductLabelTranslationFragmentDoc.definitions,
        ...TaxSnippetFragmentDoc.definitions,
        ...JewelleryNecklaceProductStyleLabelFragmentDoc.definitions,
        ...DeliveryTimeframeFragmentDoc.definitions,
        ...JewelleryEarringsProductStyleLabelFragmentDoc.definitions,
        ...JewelleryBraceletProductStyleLabelFragmentDoc.definitions,
        ...JewelleryRingProductStyleLabelFragmentDoc.definitions,
        ...RingSizeFragmentDoc.definitions,
        ...RecommendedRingSizeFragmentDoc.definitions,
        ...ShopWithConfidenceProductFragmentDoc.definitions,
        ...AffirmFinanceOptionsFragmentDoc.definitions,
        ...KlarnaFinanceOptionsFragmentDoc.definitions,
        ...ReviewsFragmentDoc.definitions,
        ...BlockFragmentDoc.definitions,
        ...BlockAnchorFragmentDoc.definitions,
        ...ComponentFragmentDoc.definitions,
        ...ComponentRoundedImageFragmentDoc.definitions,
        ...ImageMediumFragmentDoc.definitions,
        ...ImageCommonFragmentDoc.definitions,
        ...ImageSizeFragmentDoc.definitions,
        ...ComponentRoundedImageContentFragmentDoc.definitions,
        ...ContentComponentItemFragmentDoc.definitions,
        ...ComponentTitleFragmentDoc.definitions,
        ...ComponentTitleComponentFragmentDoc.definitions,
        ...ComponentTitleAmpersandFragmentDoc.definitions,
        ...ComponentTitleTextFragmentDoc.definitions,
        ...ComponentTextFragmentDoc.definitions,
        ...ComponentButtonFragmentDoc.definitions,
        ...LinkFragmentDoc.definitions,
        ...LinkItemFragmentDoc.definitions,
        ...PageLinkFragmentDoc.definitions,
        ...PostLinkFragmentDoc.definitions,
        ...CustomLinkFragmentDoc.definitions,
        ...LinkQuestionnaireFragmentDoc.definitions,
        ...LinkItemOpenEnquiryFormFragmentDoc.definitions,
        ...LinkItemOpenContactFormFragmentDoc.definitions,
        ...LinkItemOpenSpeakToExpertModalFragmentDoc.definitions,
        ...ComponentSpacerFragmentDoc.definitions,
        ...ComponentImageFragmentDoc.definitions,
        ...ImageLargeFragmentDoc.definitions,
        ...ComponentOrderedListFragmentDoc.definitions,
        ...OrderedListItemFragmentDoc.definitions,
        ...ComponentContentFragmentDoc.definitions,
        ...ComponentCardFragmentDoc.definitions,
        ...ComponentTextOverImageFragmentDoc.definitions,
        ...ComponentCustomProductCarouselFragmentDoc.definitions,
        ...CustomProductCarouselCardFragmentDoc.definitions,
        ...ComponentCatalogueProductCarouselFragmentDoc.definitions,
        ...ComponentReviewCarouselFragmentDoc.definitions,
        ...ComponentMainCoverFragmentDoc.definitions,
        ...ImageCoverFragmentDoc.definitions,
        ...ComponentVideoFragmentDoc.definitions,
        ...VideoFragmentDoc.definitions,
        ...ComponentVideoWithContentFragmentDoc.definitions,
        ...ComponentInstagramPostsFragmentDoc.definitions,
        ...ComponentLogosFragmentDoc.definitions,
        ...ComponentLogosCarouselFragmentDoc.definitions,
        ...ComponentTextWithImageFragmentDoc.definitions,
        ...ComponentGalleryCarouselFragmentDoc.definitions,
        ...GalleryCarouselCardFragmentDoc.definitions,
        ...ComponentCardCarouselFragmentDoc.definitions,
        ...CardCarouselCardFragmentDoc.definitions,
        ...ComponentFullWidthImageFragmentDoc.definitions,
        ...ComponentSideBySideImagesFragmentDoc.definitions,
        ...ComponentSideBySideImageFragmentDoc.definitions,
        ...ComponentArticlePreviewsFragmentDoc.definitions,
        ...ArticlePreviewFragmentDoc.definitions,
        ...ComponentInstagramWithContentFragmentDoc.definitions,
        ...ComponentBannerTitleFragmentDoc.definitions,
        ...ComponentQuoteFragmentDoc.definitions,
        ...ComponentBannerSkinnyFragmentDoc.definitions,
        ...ComponentGlobalSpacerFragmentDoc.definitions,
        ...ComponentTextWithImageCarouselFragmentDoc.definitions,
        ...ComponentContentWithGalleryFragmentDoc.definitions,
        ...ComponentIconCarouselFragmentDoc.definitions,
        ...ComponentTextCarouselFragmentDoc.definitions,
        ...ComponentFaqFragmentDoc.definitions,
        ...FaqSectionFragmentDoc.definitions,
        ...FaqQuestionFragmentDoc.definitions,
        ...ComponentContentTwoColumnsFragmentDoc.definitions,
        ...ComponentTableFragmentDoc.definitions,
        ...ComponentArticleGridFragmentDoc.definitions,
        ...ArticleGridItemFragmentDoc.definitions,
        ...ComponentOnThisPageFragmentDoc.definitions,
        ...ComponentGalleryWithEnquiryFragmentDoc.definitions,
        ...GalleryWithEnquiryCardFragmentDoc.definitions,
        ...ComponentSquareBoxesFragmentDoc.definitions,
        ...SquareBoxesFragmentDoc.definitions,
        ...SquareTextBoxFragmentDoc.definitions,
        ...SquareImageBoxFragmentDoc.definitions,
        ...ComponentShopWithConfidenceFragmentDoc.definitions,
        ...ComponentGlobalComponentFragmentDoc.definitions,
        ...MetaFragmentDoc.definitions,
        ...PageTooltipFragmentDoc.definitions,
        ...TooltipFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useJewelleryDetailsQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, JewelleryDetailsQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<
        JewelleryDetailsQuery,
        JewelleryDetailsQueryVariables | undefined
    >({ query: JewelleryDetailsDocument, variables: undefined, ...options })
}
export const GetReadyToGoRingDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'getReadyToGoRing' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'slug' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'String' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'metal' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'MetalCode' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'currency' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CurrencyInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'region' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'RegionCode' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'page' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'String' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'pageFallback' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'String' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueReadyToGoRing',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'filter' },
                                'value': {
                                    'kind': 'ObjectValue',
                                    'fields': [
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'slug',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'slug',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'primaryMetalCode',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'metal',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'readyToGoRing',
                                    },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'shopWithConfidenceProduct',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'firstAvailableDeliveryDate',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'deliveryTimeframe',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'financeOptionsAffirm',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'currency',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'currency',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'affirmFinanceOptions',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'financeOptionsKlarna',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'currency',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'currency',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'klarnaFinanceOptions',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productAnalytics',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'reviews',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'reviews',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'pageProductDetails',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'path' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': { 'kind': 'Name', 'value': 'page' },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'fallback' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'pageFallback',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'blocks',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'block',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'meta' },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'meta',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...ReadyToGoRingFragmentDoc.definitions,
        ...CatalogueProductFragmentDoc.definitions,
        ...RelatedProductFragmentDoc.definitions,
        ...ProductCardFragmentDoc.definitions,
        ...ProductLinkFragmentDoc.definitions,
        ...EngagementRingLinkFragmentDoc.definitions,
        ...JewelleryLinkFragmentDoc.definitions,
        ...ReadyToGoRingLinkFragmentDoc.definitions,
        ...WeddingRingLinkFragmentDoc.definitions,
        ...MetalVariationFragmentDoc.definitions,
        ...MetalFilterMetalFragmentDoc.definitions,
        ...GetIsLabGrownFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...MonolithImageSizeFragmentDoc.definitions,
        ...ProductGalleryFragmentDoc.definitions,
        ...ThreeSixtyFragmentDoc.definitions,
        ...CatalogueVideoFragmentDoc.definitions,
        ...ProductPageMetaFragmentDoc.definitions,
        ...AssetFragmentDoc.definitions,
        ...TaxSnippetFragmentDoc.definitions,
        ...RecommendedRingSizeFragmentDoc.definitions,
        ...RingSizeFragmentDoc.definitions,
        ...ReadyToGoRingVariationsFragmentDoc.definitions,
        ...CatalogueReadyToGoRingTranslationFragmentDoc.definitions,
        ...ReviewsFragmentDoc.definitions,
        ...ShopWithConfidenceProductFragmentDoc.definitions,
        ...DeliveryTimeframeFragmentDoc.definitions,
        ...AffirmFinanceOptionsFragmentDoc.definitions,
        ...KlarnaFinanceOptionsFragmentDoc.definitions,
        ...ProductAnalyticsFragmentDoc.definitions,
        ...BlockFragmentDoc.definitions,
        ...BlockAnchorFragmentDoc.definitions,
        ...ComponentFragmentDoc.definitions,
        ...ComponentRoundedImageFragmentDoc.definitions,
        ...ImageMediumFragmentDoc.definitions,
        ...ImageCommonFragmentDoc.definitions,
        ...ImageSizeFragmentDoc.definitions,
        ...ComponentRoundedImageContentFragmentDoc.definitions,
        ...ContentComponentItemFragmentDoc.definitions,
        ...ComponentTitleFragmentDoc.definitions,
        ...ComponentTitleComponentFragmentDoc.definitions,
        ...ComponentTitleAmpersandFragmentDoc.definitions,
        ...ComponentTitleTextFragmentDoc.definitions,
        ...ComponentTextFragmentDoc.definitions,
        ...ComponentButtonFragmentDoc.definitions,
        ...LinkFragmentDoc.definitions,
        ...LinkItemFragmentDoc.definitions,
        ...PageLinkFragmentDoc.definitions,
        ...PostLinkFragmentDoc.definitions,
        ...CustomLinkFragmentDoc.definitions,
        ...LinkQuestionnaireFragmentDoc.definitions,
        ...LinkItemOpenEnquiryFormFragmentDoc.definitions,
        ...LinkItemOpenContactFormFragmentDoc.definitions,
        ...LinkItemOpenSpeakToExpertModalFragmentDoc.definitions,
        ...ComponentSpacerFragmentDoc.definitions,
        ...ComponentImageFragmentDoc.definitions,
        ...ImageLargeFragmentDoc.definitions,
        ...ComponentOrderedListFragmentDoc.definitions,
        ...OrderedListItemFragmentDoc.definitions,
        ...ComponentContentFragmentDoc.definitions,
        ...ComponentCardFragmentDoc.definitions,
        ...ComponentTextOverImageFragmentDoc.definitions,
        ...ComponentCustomProductCarouselFragmentDoc.definitions,
        ...CustomProductCarouselCardFragmentDoc.definitions,
        ...ComponentCatalogueProductCarouselFragmentDoc.definitions,
        ...ComponentReviewCarouselFragmentDoc.definitions,
        ...ComponentMainCoverFragmentDoc.definitions,
        ...ImageCoverFragmentDoc.definitions,
        ...ComponentVideoFragmentDoc.definitions,
        ...VideoFragmentDoc.definitions,
        ...ComponentVideoWithContentFragmentDoc.definitions,
        ...ComponentInstagramPostsFragmentDoc.definitions,
        ...ComponentLogosFragmentDoc.definitions,
        ...ComponentLogosCarouselFragmentDoc.definitions,
        ...ComponentTextWithImageFragmentDoc.definitions,
        ...ComponentGalleryCarouselFragmentDoc.definitions,
        ...GalleryCarouselCardFragmentDoc.definitions,
        ...ComponentCardCarouselFragmentDoc.definitions,
        ...CardCarouselCardFragmentDoc.definitions,
        ...ComponentFullWidthImageFragmentDoc.definitions,
        ...ComponentSideBySideImagesFragmentDoc.definitions,
        ...ComponentSideBySideImageFragmentDoc.definitions,
        ...ComponentArticlePreviewsFragmentDoc.definitions,
        ...ArticlePreviewFragmentDoc.definitions,
        ...ComponentInstagramWithContentFragmentDoc.definitions,
        ...ComponentBannerTitleFragmentDoc.definitions,
        ...ComponentQuoteFragmentDoc.definitions,
        ...ComponentBannerSkinnyFragmentDoc.definitions,
        ...ComponentGlobalSpacerFragmentDoc.definitions,
        ...ComponentTextWithImageCarouselFragmentDoc.definitions,
        ...ComponentContentWithGalleryFragmentDoc.definitions,
        ...ComponentIconCarouselFragmentDoc.definitions,
        ...ComponentTextCarouselFragmentDoc.definitions,
        ...ComponentFaqFragmentDoc.definitions,
        ...FaqSectionFragmentDoc.definitions,
        ...FaqQuestionFragmentDoc.definitions,
        ...ComponentContentTwoColumnsFragmentDoc.definitions,
        ...ComponentTableFragmentDoc.definitions,
        ...ComponentArticleGridFragmentDoc.definitions,
        ...ArticleGridItemFragmentDoc.definitions,
        ...ComponentOnThisPageFragmentDoc.definitions,
        ...ComponentGalleryWithEnquiryFragmentDoc.definitions,
        ...GalleryWithEnquiryCardFragmentDoc.definitions,
        ...ComponentSquareBoxesFragmentDoc.definitions,
        ...SquareBoxesFragmentDoc.definitions,
        ...SquareTextBoxFragmentDoc.definitions,
        ...SquareImageBoxFragmentDoc.definitions,
        ...ComponentShopWithConfidenceFragmentDoc.definitions,
        ...ComponentGlobalComponentFragmentDoc.definitions,
        ...MetaFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useGetReadyToGoRingQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, GetReadyToGoRingQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<
        GetReadyToGoRingQuery,
        GetReadyToGoRingQueryVariables | undefined
    >({ query: GetReadyToGoRingDocument, variables: undefined, ...options })
}
export const ReadyToGoRingBrowseDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'readyToGoRingBrowse' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'currency' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CurrencyInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'region' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'RegionCode' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'filter' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueReadyToGoRingsFilterInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'page' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Int' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'limit' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Int' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'path' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'String' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'sortBy' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueSortOrder',
                            },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueReadyToGoRingsFilters',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'filter',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'readyToGoRingFilters',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueReadyToGoRingsAggregate',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'filter' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'filter',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'count',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueReadyToGoRings',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'filter' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'filter',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'sort' },
                                'value': {
                                    'kind': 'ObjectValue',
                                    'fields': [
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'by',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'sortBy',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'currency',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'currency',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': {
                                    'kind': 'Name',
                                    'value': 'pagination',
                                },
                                'value': {
                                    'kind': 'ObjectValue',
                                    'fields': [
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'page',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'page',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'limit',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'limit',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productGrid',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'pageProductListing',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'path' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': { 'kind': 'Name', 'value': 'path' },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productPageListing',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...ReadyToGoRingFiltersFragmentDoc.definitions,
        ...FilterPriceRangeFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...MetalFilterFragmentDoc.definitions,
        ...MetalFilterMetalFragmentDoc.definitions,
        ...ProductGridFragmentDoc.definitions,
        ...ProductCardFragmentDoc.definitions,
        ...ProductLinkFragmentDoc.definitions,
        ...EngagementRingLinkFragmentDoc.definitions,
        ...JewelleryLinkFragmentDoc.definitions,
        ...ReadyToGoRingLinkFragmentDoc.definitions,
        ...WeddingRingLinkFragmentDoc.definitions,
        ...MetalVariationFragmentDoc.definitions,
        ...GetIsLabGrownFragmentDoc.definitions,
        ...MonolithImageSizeFragmentDoc.definitions,
        ...ProductListAnalyticsFragmentDoc.definitions,
        ...ProductPageListingFragmentDoc.definitions,
        ...BlockFragmentDoc.definitions,
        ...BlockAnchorFragmentDoc.definitions,
        ...ComponentFragmentDoc.definitions,
        ...ComponentRoundedImageFragmentDoc.definitions,
        ...ImageMediumFragmentDoc.definitions,
        ...ImageCommonFragmentDoc.definitions,
        ...ImageSizeFragmentDoc.definitions,
        ...ComponentRoundedImageContentFragmentDoc.definitions,
        ...ContentComponentItemFragmentDoc.definitions,
        ...ComponentTitleFragmentDoc.definitions,
        ...ComponentTitleComponentFragmentDoc.definitions,
        ...ComponentTitleAmpersandFragmentDoc.definitions,
        ...ComponentTitleTextFragmentDoc.definitions,
        ...ComponentTextFragmentDoc.definitions,
        ...ComponentButtonFragmentDoc.definitions,
        ...LinkFragmentDoc.definitions,
        ...LinkItemFragmentDoc.definitions,
        ...PageLinkFragmentDoc.definitions,
        ...PostLinkFragmentDoc.definitions,
        ...CustomLinkFragmentDoc.definitions,
        ...LinkQuestionnaireFragmentDoc.definitions,
        ...LinkItemOpenEnquiryFormFragmentDoc.definitions,
        ...LinkItemOpenContactFormFragmentDoc.definitions,
        ...LinkItemOpenSpeakToExpertModalFragmentDoc.definitions,
        ...ComponentSpacerFragmentDoc.definitions,
        ...ComponentImageFragmentDoc.definitions,
        ...ImageLargeFragmentDoc.definitions,
        ...ComponentOrderedListFragmentDoc.definitions,
        ...OrderedListItemFragmentDoc.definitions,
        ...ComponentContentFragmentDoc.definitions,
        ...ComponentCardFragmentDoc.definitions,
        ...ComponentTextOverImageFragmentDoc.definitions,
        ...ComponentCustomProductCarouselFragmentDoc.definitions,
        ...CustomProductCarouselCardFragmentDoc.definitions,
        ...ComponentCatalogueProductCarouselFragmentDoc.definitions,
        ...ComponentReviewCarouselFragmentDoc.definitions,
        ...ComponentMainCoverFragmentDoc.definitions,
        ...ImageCoverFragmentDoc.definitions,
        ...ComponentVideoFragmentDoc.definitions,
        ...VideoFragmentDoc.definitions,
        ...ComponentVideoWithContentFragmentDoc.definitions,
        ...ComponentInstagramPostsFragmentDoc.definitions,
        ...ComponentLogosFragmentDoc.definitions,
        ...ComponentLogosCarouselFragmentDoc.definitions,
        ...ComponentTextWithImageFragmentDoc.definitions,
        ...ComponentGalleryCarouselFragmentDoc.definitions,
        ...GalleryCarouselCardFragmentDoc.definitions,
        ...ComponentCardCarouselFragmentDoc.definitions,
        ...CardCarouselCardFragmentDoc.definitions,
        ...ComponentFullWidthImageFragmentDoc.definitions,
        ...ComponentSideBySideImagesFragmentDoc.definitions,
        ...ComponentSideBySideImageFragmentDoc.definitions,
        ...ComponentArticlePreviewsFragmentDoc.definitions,
        ...ArticlePreviewFragmentDoc.definitions,
        ...ComponentInstagramWithContentFragmentDoc.definitions,
        ...ComponentBannerTitleFragmentDoc.definitions,
        ...ComponentQuoteFragmentDoc.definitions,
        ...ComponentBannerSkinnyFragmentDoc.definitions,
        ...ComponentGlobalSpacerFragmentDoc.definitions,
        ...ComponentTextWithImageCarouselFragmentDoc.definitions,
        ...ComponentContentWithGalleryFragmentDoc.definitions,
        ...ComponentIconCarouselFragmentDoc.definitions,
        ...ComponentTextCarouselFragmentDoc.definitions,
        ...ComponentFaqFragmentDoc.definitions,
        ...FaqSectionFragmentDoc.definitions,
        ...FaqQuestionFragmentDoc.definitions,
        ...ComponentContentTwoColumnsFragmentDoc.definitions,
        ...ComponentTableFragmentDoc.definitions,
        ...ComponentArticleGridFragmentDoc.definitions,
        ...ArticleGridItemFragmentDoc.definitions,
        ...ComponentOnThisPageFragmentDoc.definitions,
        ...ComponentGalleryWithEnquiryFragmentDoc.definitions,
        ...GalleryWithEnquiryCardFragmentDoc.definitions,
        ...ComponentSquareBoxesFragmentDoc.definitions,
        ...SquareBoxesFragmentDoc.definitions,
        ...SquareTextBoxFragmentDoc.definitions,
        ...SquareImageBoxFragmentDoc.definitions,
        ...ComponentShopWithConfidenceFragmentDoc.definitions,
        ...ComponentGlobalComponentFragmentDoc.definitions,
        ...Banner1FragmentDoc.definitions,
        ...Banner2FragmentDoc.definitions,
        ...MetaFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useReadyToGoRingBrowseQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, ReadyToGoRingBrowseQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<
        ReadyToGoRingBrowseQuery,
        ReadyToGoRingBrowseQueryVariables | undefined
    >({ query: ReadyToGoRingBrowseDocument, variables: undefined, ...options })
}
export const GetWeddingRingDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'getWeddingRing' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'slug' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'String' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'metal' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'MetalCode' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'suffixSlug' },
                    },
                    'type': {
                        'kind': 'NamedType',
                        'name': { 'kind': 'Name', 'value': 'String' },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'currency' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CurrencyInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'region' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'RegionCode' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'page' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'String' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'pageFallback' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'String' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueWeddingRing',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'filter' },
                                'value': {
                                    'kind': 'ObjectValue',
                                    'fields': [
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'slug',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'slug',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'primaryMetalCodes',
                                            },
                                            'value': {
                                                'kind': 'ListValue',
                                                'values': [
                                                    {
                                                        'kind': 'Variable',
                                                        'name': {
                                                            'kind': 'Name',
                                                            'value': 'metal',
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'suffixSlug',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'suffixSlug',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'weddingRing',
                                    },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'shopWithConfidenceProduct',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'alias': {
                                        'kind': 'Name',
                                        'value':
                                            'firstAvailableDeliveryDateWithoutEngraving',
                                    },
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'firstAvailableDeliveryDate',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'hasEngraving',
                                            },
                                            'value': {
                                                'kind': 'BooleanValue',
                                                'value': false,
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'deliveryTimeframe',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'alias': {
                                        'kind': 'Name',
                                        'value':
                                            'firstAvailableDeliveryDateWithEngraving',
                                    },
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'firstAvailableDeliveryDate',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'hasEngraving',
                                            },
                                            'value': {
                                                'kind': 'BooleanValue',
                                                'value': true,
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'deliveryTimeframe',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'financeOptionsAffirm',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'currency',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'currency',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'affirmFinanceOptions',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'financeOptionsKlarna',
                                    },
                                    'arguments': [
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'currency',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'currency',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'Argument',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'region',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'region',
                                                },
                                            },
                                        },
                                    ],
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value':
                                                        'klarnaFinanceOptions',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productAnalytics',
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'reviews',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'reviews',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'pageProductDetails',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'path' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': { 'kind': 'Name', 'value': 'page' },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'fallback' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'pageFallback',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'blocks',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'block',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'meta' },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'meta',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'priceExplainedTooltip',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'FragmentSpread',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'pageTooltip',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...WeddingRingFragmentDoc.definitions,
        ...CatalogueProductFragmentDoc.definitions,
        ...RelatedProductFragmentDoc.definitions,
        ...ProductCardFragmentDoc.definitions,
        ...ProductLinkFragmentDoc.definitions,
        ...EngagementRingLinkFragmentDoc.definitions,
        ...JewelleryLinkFragmentDoc.definitions,
        ...ReadyToGoRingLinkFragmentDoc.definitions,
        ...WeddingRingLinkFragmentDoc.definitions,
        ...MetalVariationFragmentDoc.definitions,
        ...MetalFilterMetalFragmentDoc.definitions,
        ...GetIsLabGrownFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...MonolithImageSizeFragmentDoc.definitions,
        ...ProductGalleryFragmentDoc.definitions,
        ...ThreeSixtyFragmentDoc.definitions,
        ...CatalogueVideoFragmentDoc.definitions,
        ...ProductPageMetaFragmentDoc.definitions,
        ...AssetFragmentDoc.definitions,
        ...MeleeFragmentDoc.definitions,
        ...TaxSnippetFragmentDoc.definitions,
        ...RingSizeFragmentDoc.definitions,
        ...RecommendedRingSizeFragmentDoc.definitions,
        ...ShopWithConfidenceProductFragmentDoc.definitions,
        ...DeliveryTimeframeFragmentDoc.definitions,
        ...AffirmFinanceOptionsFragmentDoc.definitions,
        ...KlarnaFinanceOptionsFragmentDoc.definitions,
        ...ProductAnalyticsFragmentDoc.definitions,
        ...ReviewsFragmentDoc.definitions,
        ...BlockFragmentDoc.definitions,
        ...BlockAnchorFragmentDoc.definitions,
        ...ComponentFragmentDoc.definitions,
        ...ComponentRoundedImageFragmentDoc.definitions,
        ...ImageMediumFragmentDoc.definitions,
        ...ImageCommonFragmentDoc.definitions,
        ...ImageSizeFragmentDoc.definitions,
        ...ComponentRoundedImageContentFragmentDoc.definitions,
        ...ContentComponentItemFragmentDoc.definitions,
        ...ComponentTitleFragmentDoc.definitions,
        ...ComponentTitleComponentFragmentDoc.definitions,
        ...ComponentTitleAmpersandFragmentDoc.definitions,
        ...ComponentTitleTextFragmentDoc.definitions,
        ...ComponentTextFragmentDoc.definitions,
        ...ComponentButtonFragmentDoc.definitions,
        ...LinkFragmentDoc.definitions,
        ...LinkItemFragmentDoc.definitions,
        ...PageLinkFragmentDoc.definitions,
        ...PostLinkFragmentDoc.definitions,
        ...CustomLinkFragmentDoc.definitions,
        ...LinkQuestionnaireFragmentDoc.definitions,
        ...LinkItemOpenEnquiryFormFragmentDoc.definitions,
        ...LinkItemOpenContactFormFragmentDoc.definitions,
        ...LinkItemOpenSpeakToExpertModalFragmentDoc.definitions,
        ...ComponentSpacerFragmentDoc.definitions,
        ...ComponentImageFragmentDoc.definitions,
        ...ImageLargeFragmentDoc.definitions,
        ...ComponentOrderedListFragmentDoc.definitions,
        ...OrderedListItemFragmentDoc.definitions,
        ...ComponentContentFragmentDoc.definitions,
        ...ComponentCardFragmentDoc.definitions,
        ...ComponentTextOverImageFragmentDoc.definitions,
        ...ComponentCustomProductCarouselFragmentDoc.definitions,
        ...CustomProductCarouselCardFragmentDoc.definitions,
        ...ComponentCatalogueProductCarouselFragmentDoc.definitions,
        ...ComponentReviewCarouselFragmentDoc.definitions,
        ...ComponentMainCoverFragmentDoc.definitions,
        ...ImageCoverFragmentDoc.definitions,
        ...ComponentVideoFragmentDoc.definitions,
        ...VideoFragmentDoc.definitions,
        ...ComponentVideoWithContentFragmentDoc.definitions,
        ...ComponentInstagramPostsFragmentDoc.definitions,
        ...ComponentLogosFragmentDoc.definitions,
        ...ComponentLogosCarouselFragmentDoc.definitions,
        ...ComponentTextWithImageFragmentDoc.definitions,
        ...ComponentGalleryCarouselFragmentDoc.definitions,
        ...GalleryCarouselCardFragmentDoc.definitions,
        ...ComponentCardCarouselFragmentDoc.definitions,
        ...CardCarouselCardFragmentDoc.definitions,
        ...ComponentFullWidthImageFragmentDoc.definitions,
        ...ComponentSideBySideImagesFragmentDoc.definitions,
        ...ComponentSideBySideImageFragmentDoc.definitions,
        ...ComponentArticlePreviewsFragmentDoc.definitions,
        ...ArticlePreviewFragmentDoc.definitions,
        ...ComponentInstagramWithContentFragmentDoc.definitions,
        ...ComponentBannerTitleFragmentDoc.definitions,
        ...ComponentQuoteFragmentDoc.definitions,
        ...ComponentBannerSkinnyFragmentDoc.definitions,
        ...ComponentGlobalSpacerFragmentDoc.definitions,
        ...ComponentTextWithImageCarouselFragmentDoc.definitions,
        ...ComponentContentWithGalleryFragmentDoc.definitions,
        ...ComponentIconCarouselFragmentDoc.definitions,
        ...ComponentTextCarouselFragmentDoc.definitions,
        ...ComponentFaqFragmentDoc.definitions,
        ...FaqSectionFragmentDoc.definitions,
        ...FaqQuestionFragmentDoc.definitions,
        ...ComponentContentTwoColumnsFragmentDoc.definitions,
        ...ComponentTableFragmentDoc.definitions,
        ...ComponentArticleGridFragmentDoc.definitions,
        ...ArticleGridItemFragmentDoc.definitions,
        ...ComponentOnThisPageFragmentDoc.definitions,
        ...ComponentGalleryWithEnquiryFragmentDoc.definitions,
        ...GalleryWithEnquiryCardFragmentDoc.definitions,
        ...ComponentSquareBoxesFragmentDoc.definitions,
        ...SquareBoxesFragmentDoc.definitions,
        ...SquareTextBoxFragmentDoc.definitions,
        ...SquareImageBoxFragmentDoc.definitions,
        ...ComponentShopWithConfidenceFragmentDoc.definitions,
        ...ComponentGlobalComponentFragmentDoc.definitions,
        ...MetaFragmentDoc.definitions,
        ...PageTooltipFragmentDoc.definitions,
        ...TooltipFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useGetWeddingRingQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, GetWeddingRingQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<
        GetWeddingRingQuery,
        GetWeddingRingQueryVariables | undefined
    >({ query: GetWeddingRingDocument, variables: undefined, ...options })
}
export const WeddingRingBrowseDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'weddingRingBrowse' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'currency' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CurrencyInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'region' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'RegionCode' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'filter' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueWeddingRingFilterInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'page' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Int' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'limit' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Int' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'path' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'String' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': {
                            'kind': 'Name',
                            'value': 'facetedContentInput',
                        },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'ProductPageFacetedContentInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'sortBy' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CatalogueSortOrder',
                            },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueWeddingRingFilters',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'filter',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'weddingRingFilters',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueWeddingRingsAggregate',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'filter' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'filter',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'count',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'catalogueWeddingRings',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'filter' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'filter',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': {
                                    'kind': 'Name',
                                    'value': 'pagination',
                                },
                                'value': {
                                    'kind': 'ObjectValue',
                                    'fields': [
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'page',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'page',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'limit',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'limit',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'sort' },
                                'value': {
                                    'kind': 'ObjectValue',
                                    'fields': [
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'currency',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'currency',
                                                },
                                            },
                                        },
                                        {
                                            'kind': 'ObjectField',
                                            'name': {
                                                'kind': 'Name',
                                                'value': 'by',
                                            },
                                            'value': {
                                                'kind': 'Variable',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'sortBy',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productGrid',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'pageProductListingFacetedContent',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'input' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'facetedContentInput',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productPageFacetedContent',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'pageProductListing',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'path' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': { 'kind': 'Name', 'value': 'path' },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productPageListing',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...WeddingRingFiltersFragmentDoc.definitions,
        ...FilterPriceRangeFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...FilterWeddingRingStyleFragmentDoc.definitions,
        ...FacetedContentProductLabelTranslationFragmentDoc.definitions,
        ...FilterWeddingRingCategoryFragmentDoc.definitions,
        ...MetalFilterFragmentDoc.definitions,
        ...MetalFilterMetalFragmentDoc.definitions,
        ...ProductGridFragmentDoc.definitions,
        ...ProductCardFragmentDoc.definitions,
        ...ProductLinkFragmentDoc.definitions,
        ...EngagementRingLinkFragmentDoc.definitions,
        ...JewelleryLinkFragmentDoc.definitions,
        ...ReadyToGoRingLinkFragmentDoc.definitions,
        ...WeddingRingLinkFragmentDoc.definitions,
        ...MetalVariationFragmentDoc.definitions,
        ...GetIsLabGrownFragmentDoc.definitions,
        ...MonolithImageSizeFragmentDoc.definitions,
        ...ProductListAnalyticsFragmentDoc.definitions,
        ...ProductPageFacetedContentFragmentDoc.definitions,
        ...ProductPageFacetedContentLongDescriptionFragmentDoc.definitions,
        ...BlockFragmentDoc.definitions,
        ...BlockAnchorFragmentDoc.definitions,
        ...ComponentFragmentDoc.definitions,
        ...ComponentRoundedImageFragmentDoc.definitions,
        ...ImageMediumFragmentDoc.definitions,
        ...ImageCommonFragmentDoc.definitions,
        ...ImageSizeFragmentDoc.definitions,
        ...ComponentRoundedImageContentFragmentDoc.definitions,
        ...ContentComponentItemFragmentDoc.definitions,
        ...ComponentTitleFragmentDoc.definitions,
        ...ComponentTitleComponentFragmentDoc.definitions,
        ...ComponentTitleAmpersandFragmentDoc.definitions,
        ...ComponentTitleTextFragmentDoc.definitions,
        ...ComponentTextFragmentDoc.definitions,
        ...ComponentButtonFragmentDoc.definitions,
        ...LinkFragmentDoc.definitions,
        ...LinkItemFragmentDoc.definitions,
        ...PageLinkFragmentDoc.definitions,
        ...PostLinkFragmentDoc.definitions,
        ...CustomLinkFragmentDoc.definitions,
        ...LinkQuestionnaireFragmentDoc.definitions,
        ...LinkItemOpenEnquiryFormFragmentDoc.definitions,
        ...LinkItemOpenContactFormFragmentDoc.definitions,
        ...LinkItemOpenSpeakToExpertModalFragmentDoc.definitions,
        ...ComponentSpacerFragmentDoc.definitions,
        ...ComponentImageFragmentDoc.definitions,
        ...ImageLargeFragmentDoc.definitions,
        ...ComponentOrderedListFragmentDoc.definitions,
        ...OrderedListItemFragmentDoc.definitions,
        ...ComponentContentFragmentDoc.definitions,
        ...ComponentCardFragmentDoc.definitions,
        ...ComponentTextOverImageFragmentDoc.definitions,
        ...ComponentCustomProductCarouselFragmentDoc.definitions,
        ...CustomProductCarouselCardFragmentDoc.definitions,
        ...ComponentCatalogueProductCarouselFragmentDoc.definitions,
        ...ComponentReviewCarouselFragmentDoc.definitions,
        ...ComponentMainCoverFragmentDoc.definitions,
        ...ImageCoverFragmentDoc.definitions,
        ...ComponentVideoFragmentDoc.definitions,
        ...VideoFragmentDoc.definitions,
        ...ComponentVideoWithContentFragmentDoc.definitions,
        ...ComponentInstagramPostsFragmentDoc.definitions,
        ...ComponentLogosFragmentDoc.definitions,
        ...ComponentLogosCarouselFragmentDoc.definitions,
        ...ComponentTextWithImageFragmentDoc.definitions,
        ...ComponentGalleryCarouselFragmentDoc.definitions,
        ...GalleryCarouselCardFragmentDoc.definitions,
        ...ComponentCardCarouselFragmentDoc.definitions,
        ...CardCarouselCardFragmentDoc.definitions,
        ...ComponentFullWidthImageFragmentDoc.definitions,
        ...ComponentSideBySideImagesFragmentDoc.definitions,
        ...ComponentSideBySideImageFragmentDoc.definitions,
        ...ComponentArticlePreviewsFragmentDoc.definitions,
        ...ArticlePreviewFragmentDoc.definitions,
        ...ComponentInstagramWithContentFragmentDoc.definitions,
        ...ComponentBannerTitleFragmentDoc.definitions,
        ...ComponentQuoteFragmentDoc.definitions,
        ...ComponentBannerSkinnyFragmentDoc.definitions,
        ...ComponentGlobalSpacerFragmentDoc.definitions,
        ...ComponentTextWithImageCarouselFragmentDoc.definitions,
        ...ComponentContentWithGalleryFragmentDoc.definitions,
        ...ComponentIconCarouselFragmentDoc.definitions,
        ...ComponentTextCarouselFragmentDoc.definitions,
        ...ComponentFaqFragmentDoc.definitions,
        ...FaqSectionFragmentDoc.definitions,
        ...FaqQuestionFragmentDoc.definitions,
        ...ComponentContentTwoColumnsFragmentDoc.definitions,
        ...ComponentTableFragmentDoc.definitions,
        ...ComponentArticleGridFragmentDoc.definitions,
        ...ArticleGridItemFragmentDoc.definitions,
        ...ComponentOnThisPageFragmentDoc.definitions,
        ...ComponentGalleryWithEnquiryFragmentDoc.definitions,
        ...GalleryWithEnquiryCardFragmentDoc.definitions,
        ...ComponentSquareBoxesFragmentDoc.definitions,
        ...SquareBoxesFragmentDoc.definitions,
        ...SquareTextBoxFragmentDoc.definitions,
        ...SquareImageBoxFragmentDoc.definitions,
        ...ComponentShopWithConfidenceFragmentDoc.definitions,
        ...ComponentGlobalComponentFragmentDoc.definitions,
        ...MetaFragmentDoc.definitions,
        ...ProductPageListingFragmentDoc.definitions,
        ...Banner1FragmentDoc.definitions,
        ...Banner2FragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useWeddingRingBrowseQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, WeddingRingBrowseQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<
        WeddingRingBrowseQuery,
        WeddingRingBrowseQueryVariables | undefined
    >({ query: WeddingRingBrowseDocument, variables: undefined, ...options })
}
export const MyOrdersDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'myOrders' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'me' },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': { 'kind': 'Name', 'value': 'id' },
                                },
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'customer',
                                    },
                                    'selectionSet': {
                                        'kind': 'SelectionSet',
                                        'selections': [
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'id',
                                                },
                                            },
                                            {
                                                'kind': 'Field',
                                                'name': {
                                                    'kind': 'Name',
                                                    'value': 'orders',
                                                },
                                                'selectionSet': {
                                                    'kind': 'SelectionSet',
                                                    'selections': [
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'orderListView',
                                                            },
                                                        },
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'orderDetailedView',
                                                            },
                                                        },
                                                        {
                                                            'kind': 'FragmentSpread',
                                                            'name': {
                                                                'kind': 'Name',
                                                                'value':
                                                                    'linkOrder',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...OrderListViewFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...OrderDetailedViewFragmentDoc.definitions,
        ...LinkDesignStudioProductFragmentDoc.definitions,
        ...LinkOrderFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useMyOrdersQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, MyOrdersQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<MyOrdersQuery, MyOrdersQueryVariables | undefined>({
        query: MyOrdersDocument,
        variables: undefined,
        ...options,
    })
}
export const RedirectDiamondSearchStoneByLabAndNumberDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': {
                'kind': 'Name',
                'value': 'redirectDiamondSearchStoneByLabAndNumber',
            },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'number' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'String' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'GemsApi_getGiaStone',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': {
                                    'kind': 'Name',
                                    'value': 'giaCertificate',
                                },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'number',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'Field',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'identifier',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode

export function useRedirectDiamondSearchStoneByLabAndNumberQuery(
    options?: Omit<
        Urql.UseQueryArgs<
            never,
            RedirectDiamondSearchStoneByLabAndNumberQueryVariables | undefined
        >,
        'query'
    >
) {
    return Urql.useQuery<
        RedirectDiamondSearchStoneByLabAndNumberQuery,
        RedirectDiamondSearchStoneByLabAndNumberQueryVariables | undefined
    >({
        query: RedirectDiamondSearchStoneByLabAndNumberDocument,
        variables: undefined,
        ...options,
    })
}
export const GemstoneSearchDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'gemstoneSearch' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'filters' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'NonSkuGemstoneFilters',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'sort' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'NonSkuGemstoneSortInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'currency' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CurrencyInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'region' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'RegionCode' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'contentPath' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'String' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': { 'kind': 'Name', 'value': 'nonSkuGemStones' },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'region' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'region',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'currency' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'currency',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'filters' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'filters',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'sort' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': { 'kind': 'Name', 'value': 'sort' },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'nonSkuGemstone',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'nonSkuGemStonesBounds',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'nonSkuGemstoneBounds',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'pageProductListing',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'path' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'contentPath',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productPageListing',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...NonSkuGemstoneFragmentDoc.definitions,
        ...StoneShapeFragmentDoc.definitions,
        ...AssetFragmentDoc.definitions,
        ...StoneShapeTranslationFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...StoneCutFragmentDoc.definitions,
        ...StoneCutTranslationFragmentDoc.definitions,
        ...StoneCrystalFragmentDoc.definitions,
        ...StoneCrystalTranslationFragmentDoc.definitions,
        ...StoneColorFragmentDoc.definitions,
        ...StoneColorTranslationFragmentDoc.definitions,
        ...StoneGradeFragmentDoc.definitions,
        ...StoneCategoryFragmentDoc.definitions,
        ...StoneCategoryTranslationFragmentDoc.definitions,
        ...StoneClarityFragmentDoc.definitions,
        ...ClarityTranslationFragmentDoc.definitions,
        ...NonSkuGemstoneImageFragmentDoc.definitions,
        ...NonSkuGemstoneBoundsFragmentDoc.definitions,
        ...NonSkuCaratWeightRangeFragmentDoc.definitions,
        ...NonSkuPriceRangeFragmentDoc.definitions,
        ...ProductPageListingFragmentDoc.definitions,
        ...BlockFragmentDoc.definitions,
        ...BlockAnchorFragmentDoc.definitions,
        ...ComponentFragmentDoc.definitions,
        ...ComponentRoundedImageFragmentDoc.definitions,
        ...ImageMediumFragmentDoc.definitions,
        ...ImageCommonFragmentDoc.definitions,
        ...ImageSizeFragmentDoc.definitions,
        ...ComponentRoundedImageContentFragmentDoc.definitions,
        ...ContentComponentItemFragmentDoc.definitions,
        ...ComponentTitleFragmentDoc.definitions,
        ...ComponentTitleComponentFragmentDoc.definitions,
        ...ComponentTitleAmpersandFragmentDoc.definitions,
        ...ComponentTitleTextFragmentDoc.definitions,
        ...ComponentTextFragmentDoc.definitions,
        ...ComponentButtonFragmentDoc.definitions,
        ...LinkFragmentDoc.definitions,
        ...LinkItemFragmentDoc.definitions,
        ...PageLinkFragmentDoc.definitions,
        ...PostLinkFragmentDoc.definitions,
        ...CustomLinkFragmentDoc.definitions,
        ...LinkQuestionnaireFragmentDoc.definitions,
        ...LinkItemOpenEnquiryFormFragmentDoc.definitions,
        ...LinkItemOpenContactFormFragmentDoc.definitions,
        ...LinkItemOpenSpeakToExpertModalFragmentDoc.definitions,
        ...ComponentSpacerFragmentDoc.definitions,
        ...ComponentImageFragmentDoc.definitions,
        ...ImageLargeFragmentDoc.definitions,
        ...ComponentOrderedListFragmentDoc.definitions,
        ...OrderedListItemFragmentDoc.definitions,
        ...ComponentContentFragmentDoc.definitions,
        ...ComponentCardFragmentDoc.definitions,
        ...ComponentTextOverImageFragmentDoc.definitions,
        ...ComponentCustomProductCarouselFragmentDoc.definitions,
        ...CustomProductCarouselCardFragmentDoc.definitions,
        ...ComponentCatalogueProductCarouselFragmentDoc.definitions,
        ...ProductCardFragmentDoc.definitions,
        ...ProductLinkFragmentDoc.definitions,
        ...EngagementRingLinkFragmentDoc.definitions,
        ...JewelleryLinkFragmentDoc.definitions,
        ...ReadyToGoRingLinkFragmentDoc.definitions,
        ...WeddingRingLinkFragmentDoc.definitions,
        ...MetalVariationFragmentDoc.definitions,
        ...MetalFilterMetalFragmentDoc.definitions,
        ...GetIsLabGrownFragmentDoc.definitions,
        ...MonolithImageSizeFragmentDoc.definitions,
        ...ComponentReviewCarouselFragmentDoc.definitions,
        ...ComponentMainCoverFragmentDoc.definitions,
        ...ImageCoverFragmentDoc.definitions,
        ...ComponentVideoFragmentDoc.definitions,
        ...VideoFragmentDoc.definitions,
        ...ComponentVideoWithContentFragmentDoc.definitions,
        ...ComponentInstagramPostsFragmentDoc.definitions,
        ...ComponentLogosFragmentDoc.definitions,
        ...ComponentLogosCarouselFragmentDoc.definitions,
        ...ComponentTextWithImageFragmentDoc.definitions,
        ...ComponentGalleryCarouselFragmentDoc.definitions,
        ...GalleryCarouselCardFragmentDoc.definitions,
        ...ComponentCardCarouselFragmentDoc.definitions,
        ...CardCarouselCardFragmentDoc.definitions,
        ...ComponentFullWidthImageFragmentDoc.definitions,
        ...ComponentSideBySideImagesFragmentDoc.definitions,
        ...ComponentSideBySideImageFragmentDoc.definitions,
        ...ComponentArticlePreviewsFragmentDoc.definitions,
        ...ArticlePreviewFragmentDoc.definitions,
        ...ComponentInstagramWithContentFragmentDoc.definitions,
        ...ComponentBannerTitleFragmentDoc.definitions,
        ...ComponentQuoteFragmentDoc.definitions,
        ...ComponentBannerSkinnyFragmentDoc.definitions,
        ...ComponentGlobalSpacerFragmentDoc.definitions,
        ...ComponentTextWithImageCarouselFragmentDoc.definitions,
        ...ComponentContentWithGalleryFragmentDoc.definitions,
        ...ComponentIconCarouselFragmentDoc.definitions,
        ...ComponentTextCarouselFragmentDoc.definitions,
        ...ComponentFaqFragmentDoc.definitions,
        ...FaqSectionFragmentDoc.definitions,
        ...FaqQuestionFragmentDoc.definitions,
        ...ComponentContentTwoColumnsFragmentDoc.definitions,
        ...ComponentTableFragmentDoc.definitions,
        ...ComponentArticleGridFragmentDoc.definitions,
        ...ArticleGridItemFragmentDoc.definitions,
        ...ComponentOnThisPageFragmentDoc.definitions,
        ...ComponentGalleryWithEnquiryFragmentDoc.definitions,
        ...GalleryWithEnquiryCardFragmentDoc.definitions,
        ...ComponentSquareBoxesFragmentDoc.definitions,
        ...SquareBoxesFragmentDoc.definitions,
        ...SquareTextBoxFragmentDoc.definitions,
        ...SquareImageBoxFragmentDoc.definitions,
        ...ComponentShopWithConfidenceFragmentDoc.definitions,
        ...ComponentGlobalComponentFragmentDoc.definitions,
        ...Banner1FragmentDoc.definitions,
        ...Banner2FragmentDoc.definitions,
        ...MetaFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useGemstoneSearchQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, GemstoneSearchQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<
        GemstoneSearchQuery,
        GemstoneSearchQueryVariables | undefined
    >({ query: GemstoneSearchDocument, variables: undefined, ...options })
}
export const LabGrownSearchDocument = {
    'kind': 'Document',
    'definitions': [
        {
            'kind': 'OperationDefinition',
            'operation': 'query',
            'name': { 'kind': 'Name', 'value': 'labGrownSearch' },
            'variableDefinitions': [
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'filters' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'NonSkuLabGrownDiamondsFilters',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'sort' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'NonSkuLabGrownDiamondSortInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'currency' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': {
                                'kind': 'Name',
                                'value': 'CurrencyInput',
                            },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'region' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'RegionCode' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'locale' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'Locale' },
                        },
                    },
                },
                {
                    'kind': 'VariableDefinition',
                    'variable': {
                        'kind': 'Variable',
                        'name': { 'kind': 'Name', 'value': 'contentPath' },
                    },
                    'type': {
                        'kind': 'NonNullType',
                        'type': {
                            'kind': 'NamedType',
                            'name': { 'kind': 'Name', 'value': 'String' },
                        },
                    },
                },
            ],
            'selectionSet': {
                'kind': 'SelectionSet',
                'selections': [
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'nonSkuLabGrownDiamonds',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'region' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'region',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'currency' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'currency',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'filters' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'filters',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'sort' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': { 'kind': 'Name', 'value': 'sort' },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'nonSkuLabGrown',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'nonSkuLabGrownDiamondsBounds',
                        },
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'nonSkuLabGrownDiamondBounds',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'kind': 'Field',
                        'name': {
                            'kind': 'Name',
                            'value': 'pageProductListing',
                        },
                        'arguments': [
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'path' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'contentPath',
                                    },
                                },
                            },
                            {
                                'kind': 'Argument',
                                'name': { 'kind': 'Name', 'value': 'locale' },
                                'value': {
                                    'kind': 'Variable',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'locale',
                                    },
                                },
                            },
                        ],
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [
                                {
                                    'kind': 'FragmentSpread',
                                    'name': {
                                        'kind': 'Name',
                                        'value': 'productPageListing',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...NonSkuLabGrownFragmentDoc.definitions,
        ...MoneyFragmentDoc.definitions,
        ...StoneShapeFragmentDoc.definitions,
        ...AssetFragmentDoc.definitions,
        ...StoneShapeTranslationFragmentDoc.definitions,
        ...StoneColorFragmentDoc.definitions,
        ...StoneColorTranslationFragmentDoc.definitions,
        ...StoneClarityFragmentDoc.definitions,
        ...ClarityTranslationFragmentDoc.definitions,
        ...NonSkuLabGrownStoneImageFragmentDoc.definitions,
        ...NonSkuLabGrownDiamondBoundsFragmentDoc.definitions,
        ...NonSkuCaratWeightRangeFragmentDoc.definitions,
        ...NonSkuPriceRangeFragmentDoc.definitions,
        ...ProductPageListingFragmentDoc.definitions,
        ...BlockFragmentDoc.definitions,
        ...BlockAnchorFragmentDoc.definitions,
        ...ComponentFragmentDoc.definitions,
        ...ComponentRoundedImageFragmentDoc.definitions,
        ...ImageMediumFragmentDoc.definitions,
        ...ImageCommonFragmentDoc.definitions,
        ...ImageSizeFragmentDoc.definitions,
        ...ComponentRoundedImageContentFragmentDoc.definitions,
        ...ContentComponentItemFragmentDoc.definitions,
        ...ComponentTitleFragmentDoc.definitions,
        ...ComponentTitleComponentFragmentDoc.definitions,
        ...ComponentTitleAmpersandFragmentDoc.definitions,
        ...ComponentTitleTextFragmentDoc.definitions,
        ...ComponentTextFragmentDoc.definitions,
        ...ComponentButtonFragmentDoc.definitions,
        ...LinkFragmentDoc.definitions,
        ...LinkItemFragmentDoc.definitions,
        ...PageLinkFragmentDoc.definitions,
        ...PostLinkFragmentDoc.definitions,
        ...CustomLinkFragmentDoc.definitions,
        ...LinkQuestionnaireFragmentDoc.definitions,
        ...LinkItemOpenEnquiryFormFragmentDoc.definitions,
        ...LinkItemOpenContactFormFragmentDoc.definitions,
        ...LinkItemOpenSpeakToExpertModalFragmentDoc.definitions,
        ...ComponentSpacerFragmentDoc.definitions,
        ...ComponentImageFragmentDoc.definitions,
        ...ImageLargeFragmentDoc.definitions,
        ...ComponentOrderedListFragmentDoc.definitions,
        ...OrderedListItemFragmentDoc.definitions,
        ...ComponentContentFragmentDoc.definitions,
        ...ComponentCardFragmentDoc.definitions,
        ...ComponentTextOverImageFragmentDoc.definitions,
        ...ComponentCustomProductCarouselFragmentDoc.definitions,
        ...CustomProductCarouselCardFragmentDoc.definitions,
        ...ComponentCatalogueProductCarouselFragmentDoc.definitions,
        ...ProductCardFragmentDoc.definitions,
        ...ProductLinkFragmentDoc.definitions,
        ...EngagementRingLinkFragmentDoc.definitions,
        ...JewelleryLinkFragmentDoc.definitions,
        ...ReadyToGoRingLinkFragmentDoc.definitions,
        ...WeddingRingLinkFragmentDoc.definitions,
        ...MetalVariationFragmentDoc.definitions,
        ...MetalFilterMetalFragmentDoc.definitions,
        ...GetIsLabGrownFragmentDoc.definitions,
        ...MonolithImageSizeFragmentDoc.definitions,
        ...ComponentReviewCarouselFragmentDoc.definitions,
        ...ComponentMainCoverFragmentDoc.definitions,
        ...ImageCoverFragmentDoc.definitions,
        ...ComponentVideoFragmentDoc.definitions,
        ...VideoFragmentDoc.definitions,
        ...ComponentVideoWithContentFragmentDoc.definitions,
        ...ComponentInstagramPostsFragmentDoc.definitions,
        ...ComponentLogosFragmentDoc.definitions,
        ...ComponentLogosCarouselFragmentDoc.definitions,
        ...ComponentTextWithImageFragmentDoc.definitions,
        ...ComponentGalleryCarouselFragmentDoc.definitions,
        ...GalleryCarouselCardFragmentDoc.definitions,
        ...ComponentCardCarouselFragmentDoc.definitions,
        ...CardCarouselCardFragmentDoc.definitions,
        ...ComponentFullWidthImageFragmentDoc.definitions,
        ...ComponentSideBySideImagesFragmentDoc.definitions,
        ...ComponentSideBySideImageFragmentDoc.definitions,
        ...ComponentArticlePreviewsFragmentDoc.definitions,
        ...ArticlePreviewFragmentDoc.definitions,
        ...ComponentInstagramWithContentFragmentDoc.definitions,
        ...ComponentBannerTitleFragmentDoc.definitions,
        ...ComponentQuoteFragmentDoc.definitions,
        ...ComponentBannerSkinnyFragmentDoc.definitions,
        ...ComponentGlobalSpacerFragmentDoc.definitions,
        ...ComponentTextWithImageCarouselFragmentDoc.definitions,
        ...ComponentContentWithGalleryFragmentDoc.definitions,
        ...ComponentIconCarouselFragmentDoc.definitions,
        ...ComponentTextCarouselFragmentDoc.definitions,
        ...ComponentFaqFragmentDoc.definitions,
        ...FaqSectionFragmentDoc.definitions,
        ...FaqQuestionFragmentDoc.definitions,
        ...ComponentContentTwoColumnsFragmentDoc.definitions,
        ...ComponentTableFragmentDoc.definitions,
        ...ComponentArticleGridFragmentDoc.definitions,
        ...ArticleGridItemFragmentDoc.definitions,
        ...ComponentOnThisPageFragmentDoc.definitions,
        ...ComponentGalleryWithEnquiryFragmentDoc.definitions,
        ...GalleryWithEnquiryCardFragmentDoc.definitions,
        ...ComponentSquareBoxesFragmentDoc.definitions,
        ...SquareBoxesFragmentDoc.definitions,
        ...SquareTextBoxFragmentDoc.definitions,
        ...SquareImageBoxFragmentDoc.definitions,
        ...ComponentShopWithConfidenceFragmentDoc.definitions,
        ...ComponentGlobalComponentFragmentDoc.definitions,
        ...Banner1FragmentDoc.definitions,
        ...Banner2FragmentDoc.definitions,
        ...MetaFragmentDoc.definitions,
    ],
} as unknown as DocumentNode

export function useLabGrownSearchQuery(
    options?: Omit<
        Urql.UseQueryArgs<never, LabGrownSearchQueryVariables | undefined>,
        'query'
    >
) {
    return Urql.useQuery<
        LabGrownSearchQuery,
        LabGrownSearchQueryVariables | undefined
    >({ query: LabGrownSearchDocument, variables: undefined, ...options })
}
export type WithTypename<T extends { __typename?: any }> = Partial<T> & {
    __typename: NonNullable<T['__typename']>
}

export type GraphCacheKeysConfig = {
    AddToCartReadyToGoRingSuccessExistingCustomer?: (
        data: WithTypename<AddToCartReadyToGoRingSuccessExistingCustomer>
    ) => null | string
    AddToCartReadyToGoRingSuccessNewCustomer?: (
        data: WithTypename<AddToCartReadyToGoRingSuccessNewCustomer>
    ) => null | string
    Address?: (data: WithTypename<Address>) => null | string
    AffirmCompleteTransactionResponse?: (
        data: WithTypename<AffirmCompleteTransactionResponse>
    ) => null | string
    AffirmFinanceOption?: (
        data: WithTypename<AffirmFinanceOption>
    ) => null | string
    AffirmPaymentMethod?: (
        data: WithTypename<AffirmPaymentMethod>
    ) => null | string
    AffirmPaymentResponse?: (
        data: WithTypename<AffirmPaymentResponse>
    ) => null | string
    AffirmTransaction?: (data: WithTypename<AffirmTransaction>) => null | string
    AllocationPaymentMethod?: (
        data: WithTypename<AllocationPaymentMethod>
    ) => null | string
    AllocationTransaction?: (
        data: WithTypename<AllocationTransaction>
    ) => null | string
    ArticleGridItem?: (data: WithTypename<ArticleGridItem>) => null | string
    ArticlePreview?: (data: WithTypename<ArticlePreview>) => null | string
    Asset?: (data: WithTypename<Asset>) => null | string
    Author?: (data: WithTypename<Author>) => null | string
    AuthorsAggregation?: (
        data: WithTypename<AuthorsAggregation>
    ) => null | string
    AvatarStackItem?: (data: WithTypename<AvatarStackItem>) => null | string
    AvataxAddressInvalidError?: (
        data: WithTypename<AvataxAddressInvalidError>
    ) => null | string
    BankPaymentMethod?: (data: WithTypename<BankPaymentMethod>) => null | string
    BankTransaction?: (data: WithTypename<BankTransaction>) => null | string
    Banner1?: (data: WithTypename<Banner1>) => null | string
    Banner2?: (data: WithTypename<Banner2>) => null | string
    Block?: (data: WithTypename<Block>) => null | string
    BlockAnchor?: (data: WithTypename<BlockAnchor>) => null | string
    BookingConsultation?: (
        data: WithTypename<BookingConsultation>
    ) => null | string
    BookingConsultationAvailableDate?: (
        data: WithTypename<BookingConsultationAvailableDate>
    ) => null | string
    BookingConsultationAvailableShowroom?: (
        data: WithTypename<BookingConsultationAvailableShowroom>
    ) => null | string
    BookingConsultationComplexity?: (
        data: WithTypename<BookingConsultationComplexity>
    ) => null | string
    BookingConsultationComplexityTranslation?: (
        data: WithTypename<BookingConsultationComplexityTranslation>
    ) => null | string
    BookingConsultationMethod?: (
        data: WithTypename<BookingConsultationMethod>
    ) => null | string
    BookingConsultationPurpose?: (
        data: WithTypename<BookingConsultationPurpose>
    ) => null | string
    BookingConsultationPurposeOrder?: (
        data: WithTypename<BookingConsultationPurposeOrder>
    ) => null | string
    BookingConsultationSlot?: (
        data: WithTypename<BookingConsultationSlot>
    ) => null | string
    BookingConsultationSlotsResponse?: (
        data: WithTypename<BookingConsultationSlotsResponse>
    ) => null | string
    BookingConsultationType?: (
        data: WithTypename<BookingConsultationType>
    ) => null | string
    BookingCreateConsultationErrorNoAvailableConsultants?: (
        data: WithTypename<BookingCreateConsultationErrorNoAvailableConsultants>
    ) => null | string
    BookingCreateConsultationSuccessExistingCustomer?: (
        data: WithTypename<BookingCreateConsultationSuccessExistingCustomer>
    ) => null | string
    BookingCreateConsultationSuccessNewCustomer?: (
        data: WithTypename<BookingCreateConsultationSuccessNewCustomer>
    ) => null | string
    BookingInPersonConsultationRoom?: (
        data: WithTypename<BookingInPersonConsultationRoom>
    ) => null | string
    BookingVirtualConsultationRoom?: (
        data: WithTypename<BookingVirtualConsultationRoom>
    ) => null | string
    ButtonEventTracking?: (
        data: WithTypename<ButtonEventTracking>
    ) => null | string
    ButtonIcon?: (data: WithTypename<ButtonIcon>) => null | string
    ButtonStyle?: (data: WithTypename<ButtonStyle>) => null | string
    CardCarouselCard?: (data: WithTypename<CardCarouselCard>) => null | string
    CarouselCustomProduct?: (
        data: WithTypename<CarouselCustomProduct>
    ) => null | string
    CatalogueAggregate?: (
        data: WithTypename<CatalogueAggregate>
    ) => null | string
    CatalogueBandType?: (data: WithTypename<CatalogueBandType>) => null | string
    CatalogueBandTypeTranslation?: (
        data: WithTypename<CatalogueBandTypeTranslation>
    ) => null | string
    CatalogueDesignStudioCheckoutEngagementRingAddedToDesignStudio?: (
        data: WithTypename<CatalogueDesignStudioCheckoutEngagementRingAddedToDesignStudio>
    ) => null | string
    CatalogueDesignStudioCheckoutEngagementRingAddedToDesignStudioAndCart?: (
        data: WithTypename<CatalogueDesignStudioCheckoutEngagementRingAddedToDesignStudioAndCart>
    ) => null | string
    CatalogueDesignStudioCheckoutJewellerySuccessExistingCustomer?: (
        data: WithTypename<CatalogueDesignStudioCheckoutJewellerySuccessExistingCustomer>
    ) => null | string
    CatalogueDesignStudioCheckoutJewellerySuccessNewCustomer?: (
        data: WithTypename<CatalogueDesignStudioCheckoutJewellerySuccessNewCustomer>
    ) => null | string
    CatalogueDesignStudioCheckoutWeddingRingSuccessExistingCustomer?: (
        data: WithTypename<CatalogueDesignStudioCheckoutWeddingRingSuccessExistingCustomer>
    ) => null | string
    CatalogueDesignStudioCheckoutWeddingRingSuccessNewCustomer?: (
        data: WithTypename<CatalogueDesignStudioCheckoutWeddingRingSuccessNewCustomer>
    ) => null | string
    CatalogueEngagementRing?: (
        data: WithTypename<CatalogueEngagementRing>
    ) => null | string
    CatalogueEngagementRingAndSignatureStone?: (
        data: WithTypename<CatalogueEngagementRingAndSignatureStone>
    ) => null | string
    CatalogueEngagementRingCentreStoneConstraints?: (
        data: WithTypename<CatalogueEngagementRingCentreStoneConstraints>
    ) => null | string
    CatalogueEngagementRingCentreStoneWeightConstraint?: (
        data: WithTypename<CatalogueEngagementRingCentreStoneWeightConstraint>
    ) => null | string
    CatalogueEngagementRingFilters?: (
        data: WithTypename<CatalogueEngagementRingFilters>
    ) => null | string
    CatalogueEngagementRingFiltersVariation?: (
        data: WithTypename<CatalogueEngagementRingFiltersVariation>
    ) => null | string
    CatalogueEngagementRingSignatureStone?: (
        data: WithTypename<CatalogueEngagementRingSignatureStone>
    ) => null | string
    CatalogueEngagementRingTranslation?: (
        data: WithTypename<CatalogueEngagementRingTranslation>
    ) => null | string
    CatalogueFilterEngagementRingDesignFeatureItem?: (
        data: WithTypename<CatalogueFilterEngagementRingDesignFeatureItem>
    ) => null | string
    CatalogueFilterEngagementRingDesingStyleItem?: (
        data: WithTypename<CatalogueFilterEngagementRingDesingStyleItem>
    ) => null | string
    CatalogueFilterEngagementRingStylesItem?: (
        data: WithTypename<CatalogueFilterEngagementRingStylesItem>
    ) => null | string
    CatalogueFilterJewelleryBraceletProductStyleLabel?: (
        data: WithTypename<CatalogueFilterJewelleryBraceletProductStyleLabel>
    ) => null | string
    CatalogueFilterJewelleryDesignFeatureLabel?: (
        data: WithTypename<CatalogueFilterJewelleryDesignFeatureLabel>
    ) => null | string
    CatalogueFilterJewelleryDesignStyleLabel?: (
        data: WithTypename<CatalogueFilterJewelleryDesignStyleLabel>
    ) => null | string
    CatalogueFilterJewelleryEarringsProductStyleLabel?: (
        data: WithTypename<CatalogueFilterJewelleryEarringsProductStyleLabel>
    ) => null | string
    CatalogueFilterJewelleryGemstoneLabel?: (
        data: WithTypename<CatalogueFilterJewelleryGemstoneLabel>
    ) => null | string
    CatalogueFilterJewelleryNecklaceProductStyleLabel?: (
        data: WithTypename<CatalogueFilterJewelleryNecklaceProductStyleLabel>
    ) => null | string
    CatalogueFilterJewelleryRingProductStyleLabel?: (
        data: WithTypename<CatalogueFilterJewelleryRingProductStyleLabel>
    ) => null | string
    CatalogueFilterMetalItem?: (
        data: WithTypename<CatalogueFilterMetalItem>
    ) => null | string
    CatalogueFilterShapeItem?: (
        data: WithTypename<CatalogueFilterShapeItem>
    ) => null | string
    CatalogueFilterWeddingRingCategoriesItem?: (
        data: WithTypename<CatalogueFilterWeddingRingCategoriesItem>
    ) => null | string
    CatalogueFilterWeddingRingStylesItem?: (
        data: WithTypename<CatalogueFilterWeddingRingStylesItem>
    ) => null | string
    CatalogueImage?: (data: WithTypename<CatalogueImage>) => null | string
    CatalogueJewelleriesBraceletsFiltersVariation?: (
        data: WithTypename<CatalogueJewelleriesBraceletsFiltersVariation>
    ) => null | string
    CatalogueJewelleriesEarringsFiltersVariation?: (
        data: WithTypename<CatalogueJewelleriesEarringsFiltersVariation>
    ) => null | string
    CatalogueJewelleriesFilters?: (
        data: WithTypename<CatalogueJewelleriesFilters>
    ) => null | string
    CatalogueJewelleriesFiltersVariation?: (
        data: WithTypename<CatalogueJewelleriesFiltersVariation>
    ) => null | string
    CatalogueJewelleriesNecklacesFiltersVariation?: (
        data: WithTypename<CatalogueJewelleriesNecklacesFiltersVariation>
    ) => null | string
    CatalogueJewelleriesRingsFiltersVariation?: (
        data: WithTypename<CatalogueJewelleriesRingsFiltersVariation>
    ) => null | string
    CatalogueJewelleryBracelet?: (
        data: WithTypename<CatalogueJewelleryBracelet>
    ) => null | string
    CatalogueJewelleryBraceletTranslation?: (
        data: WithTypename<CatalogueJewelleryBraceletTranslation>
    ) => null | string
    CatalogueJewelleryBraceletsFilters?: (
        data: WithTypename<CatalogueJewelleryBraceletsFilters>
    ) => null | string
    CatalogueJewelleryEarrings?: (
        data: WithTypename<CatalogueJewelleryEarrings>
    ) => null | string
    CatalogueJewelleryEarringsFilters?: (
        data: WithTypename<CatalogueJewelleryEarringsFilters>
    ) => null | string
    CatalogueJewelleryEarringsTranslation?: (
        data: WithTypename<CatalogueJewelleryEarringsTranslation>
    ) => null | string
    CatalogueJewelleryNecklace?: (
        data: WithTypename<CatalogueJewelleryNecklace>
    ) => null | string
    CatalogueJewelleryNecklaceTranslation?: (
        data: WithTypename<CatalogueJewelleryNecklaceTranslation>
    ) => null | string
    CatalogueJewelleryNecklacesFilters?: (
        data: WithTypename<CatalogueJewelleryNecklacesFilters>
    ) => null | string
    CatalogueJewelleryRing?: (
        data: WithTypename<CatalogueJewelleryRing>
    ) => null | string
    CatalogueJewelleryRingTranslation?: (
        data: WithTypename<CatalogueJewelleryRingTranslation>
    ) => null | string
    CatalogueJewelleryRingsFilters?: (
        data: WithTypename<CatalogueJewelleryRingsFilters>
    ) => null | string
    CatalogueMelee?: (data: WithTypename<CatalogueMelee>) => null | string
    CataloguePriceRange?: (
        data: WithTypename<CataloguePriceRange>
    ) => null | string
    CataloguePriceRangeBar?: (
        data: WithTypename<CataloguePriceRangeBar>
    ) => null | string
    CataloguePriceRangeFilter?: (
        data: WithTypename<CataloguePriceRangeFilter>
    ) => null | string
    CatalogueReadyToGoRing?: (
        data: WithTypename<CatalogueReadyToGoRing>
    ) => null | string
    CatalogueReadyToGoRingFilters?: (
        data: WithTypename<CatalogueReadyToGoRingFilters>
    ) => null | string
    CatalogueReadyToGoRingTranslation?: (
        data: WithTypename<CatalogueReadyToGoRingTranslation>
    ) => null | string
    CatalogueVideo?: (data: WithTypename<CatalogueVideo>) => null | string
    CatalogueWeddingRing?: (
        data: WithTypename<CatalogueWeddingRing>
    ) => null | string
    CatalogueWeddingRingFilters?: (
        data: WithTypename<CatalogueWeddingRingFilters>
    ) => null | string
    CatalogueWeddingRingFiltersVariation?: (
        data: WithTypename<CatalogueWeddingRingFiltersVariation>
    ) => null | string
    CatalogueWeddingRingTranslation?: (
        data: WithTypename<CatalogueWeddingRingTranslation>
    ) => null | string
    CheckoutcomOperationDeclinedError?: (
        data: WithTypename<CheckoutcomOperationDeclinedError>
    ) => null | string
    CheckoutcomPaymentMethod?: (
        data: WithTypename<CheckoutcomPaymentMethod>
    ) => null | string
    CheckoutcomTransaction?: (
        data: WithTypename<CheckoutcomTransaction>
    ) => null | string
    CompleteCheckoutcomTransactionPost3dsFailureResponse?: (
        data: WithTypename<CompleteCheckoutcomTransactionPost3dsFailureResponse>
    ) => null | string
    CompleteCheckoutcomTransactionPost3dsSuccessResponse?: (
        data: WithTypename<CompleteCheckoutcomTransactionPost3dsSuccessResponse>
    ) => null | string
    ComponentArticleGrid?: (
        data: WithTypename<ComponentArticleGrid>
    ) => null | string
    ComponentArticlePreviews?: (
        data: WithTypename<ComponentArticlePreviews>
    ) => null | string
    ComponentBannerSkinny?: (
        data: WithTypename<ComponentBannerSkinny>
    ) => null | string
    ComponentBannerTitle?: (
        data: WithTypename<ComponentBannerTitle>
    ) => null | string
    ComponentButton?: (data: WithTypename<ComponentButton>) => null | string
    ComponentCard?: (data: WithTypename<ComponentCard>) => null | string
    ComponentCardCarousel?: (
        data: WithTypename<ComponentCardCarousel>
    ) => null | string
    ComponentCatalogueProductCarousel?: (
        data: WithTypename<ComponentCatalogueProductCarousel>
    ) => null | string
    ComponentCatalogueProductCarouselItem?: (
        data: WithTypename<ComponentCatalogueProductCarouselItem>
    ) => null | string
    ComponentContent?: (data: WithTypename<ComponentContent>) => null | string
    ComponentContentTwoColumns?: (
        data: WithTypename<ComponentContentTwoColumns>
    ) => null | string
    ComponentContentWithGallery?: (
        data: WithTypename<ComponentContentWithGallery>
    ) => null | string
    ComponentCustomProductCarousel?: (
        data: WithTypename<ComponentCustomProductCarousel>
    ) => null | string
    ComponentFaq?: (data: WithTypename<ComponentFaq>) => null | string
    ComponentFullWidthImage?: (
        data: WithTypename<ComponentFullWidthImage>
    ) => null | string
    ComponentGalleryCarousel?: (
        data: WithTypename<ComponentGalleryCarousel>
    ) => null | string
    ComponentGalleryWithEnquiry?: (
        data: WithTypename<ComponentGalleryWithEnquiry>
    ) => null | string
    ComponentGlobalComponent?: (
        data: WithTypename<ComponentGlobalComponent>
    ) => null | string
    ComponentGlobalSpacer?: (
        data: WithTypename<ComponentGlobalSpacer>
    ) => null | string
    ComponentIconCarousel?: (
        data: WithTypename<ComponentIconCarousel>
    ) => null | string
    ComponentImage?: (data: WithTypename<ComponentImage>) => null | string
    ComponentInstagramPosts?: (
        data: WithTypename<ComponentInstagramPosts>
    ) => null | string
    ComponentInstagramWithContent?: (
        data: WithTypename<ComponentInstagramWithContent>
    ) => null | string
    ComponentLogos?: (data: WithTypename<ComponentLogos>) => null | string
    ComponentLogosCarousel?: (
        data: WithTypename<ComponentLogosCarousel>
    ) => null | string
    ComponentMainCover?: (
        data: WithTypename<ComponentMainCover>
    ) => null | string
    ComponentOnThisPage?: (
        data: WithTypename<ComponentOnThisPage>
    ) => null | string
    ComponentOrderedList?: (
        data: WithTypename<ComponentOrderedList>
    ) => null | string
    ComponentQuote?: (data: WithTypename<ComponentQuote>) => null | string
    ComponentRelatedProducts?: (
        data: WithTypename<ComponentRelatedProducts>
    ) => null | string
    ComponentReviewCarousel?: (
        data: WithTypename<ComponentReviewCarousel>
    ) => null | string
    ComponentRoundedImage?: (
        data: WithTypename<ComponentRoundedImage>
    ) => null | string
    ComponentRoundedImageContent?: (
        data: WithTypename<ComponentRoundedImageContent>
    ) => null | string
    ComponentShopWithConfidence?: (
        data: WithTypename<ComponentShopWithConfidence>
    ) => null | string
    ComponentSideBySideImage?: (
        data: WithTypename<ComponentSideBySideImage>
    ) => null | string
    ComponentSideBySideImages?: (
        data: WithTypename<ComponentSideBySideImages>
    ) => null | string
    ComponentSpacer?: (data: WithTypename<ComponentSpacer>) => null | string
    ComponentSquareBoxes?: (
        data: WithTypename<ComponentSquareBoxes>
    ) => null | string
    ComponentTable?: (data: WithTypename<ComponentTable>) => null | string
    ComponentText?: (data: WithTypename<ComponentText>) => null | string
    ComponentTextCarousel?: (
        data: WithTypename<ComponentTextCarousel>
    ) => null | string
    ComponentTextOverImage?: (
        data: WithTypename<ComponentTextOverImage>
    ) => null | string
    ComponentTextWithImage?: (
        data: WithTypename<ComponentTextWithImage>
    ) => null | string
    ComponentTextWithImageCarousel?: (
        data: WithTypename<ComponentTextWithImageCarousel>
    ) => null | string
    ComponentTitle?: (data: WithTypename<ComponentTitle>) => null | string
    ComponentTitleAmpersand?: (
        data: WithTypename<ComponentTitleAmpersand>
    ) => null | string
    ComponentTitleText?: (
        data: WithTypename<ComponentTitleText>
    ) => null | string
    ComponentVideo?: (data: WithTypename<ComponentVideo>) => null | string
    ComponentVideoWithContent?: (
        data: WithTypename<ComponentVideoWithContent>
    ) => null | string
    Consultant?: (data: WithTypename<Consultant>) => null | string
    CreateCheckoutcomTransactionFailureResponse?: (
        data: WithTypename<CreateCheckoutcomTransactionFailureResponse>
    ) => null | string
    CreateCheckoutcomTransactionSuccessResponse?: (
        data: WithTypename<CreateCheckoutcomTransactionSuccessResponse>
    ) => null | string
    Customer?: (data: WithTypename<Customer>) => null | string
    CustomerRegistrationResponse?: (
        data: WithTypename<CustomerRegistrationResponse>
    ) => null | string
    DeliveryDate?: (data: WithTypename<DeliveryDate>) => null | string
    DesignInspiration?: (data: WithTypename<DesignInspiration>) => null | string
    DesignStudioEngagementRingCentreStone?: (
        data: WithTypename<DesignStudioEngagementRingCentreStone>
    ) => null | string
    DesignStudioEngagementRingErrorGeneric?: (
        data: WithTypename<DesignStudioEngagementRingErrorGeneric>
    ) => null | string
    DesignStudioEngagementRingErrorMaxCaratWeight?: (
        data: WithTypename<DesignStudioEngagementRingErrorMaxCaratWeight>
    ) => null | string
    DesignStudioEngagementRingErrorMinCaratWeight?: (
        data: WithTypename<DesignStudioEngagementRingErrorMinCaratWeight>
    ) => null | string
    DesignStudioEngagementRingErrorShapeMismatch?: (
        data: WithTypename<DesignStudioEngagementRingErrorShapeMismatch>
    ) => null | string
    DesignStudioEngagementRingFailure?: (
        data: WithTypename<DesignStudioEngagementRingFailure>
    ) => null | string
    DesignStudioEngagementRingMount?: (
        data: WithTypename<DesignStudioEngagementRingMount>
    ) => null | string
    DesignStudioExternalCentreStone?: (
        data: WithTypename<DesignStudioExternalCentreStone>
    ) => null | string
    DesignStudioExternalSideStone?: (
        data: WithTypename<DesignStudioExternalSideStone>
    ) => null | string
    DesignStudioInternalCentreStone?: (
        data: WithTypename<DesignStudioInternalCentreStone>
    ) => null | string
    DesignStudioInternalSideStone?: (
        data: WithTypename<DesignStudioInternalSideStone>
    ) => null | string
    DesignStudioMeleeItem?: (
        data: WithTypename<DesignStudioMeleeItem>
    ) => null | string
    DesignStudioProductAdditionalResize?: (
        data: WithTypename<DesignStudioProductAdditionalResize>
    ) => null | string
    DesignStudioProductCustom?: (
        data: WithTypename<DesignStudioProductCustom>
    ) => null | string
    DesignStudioProductEngagementRing?: (
        data: WithTypename<DesignStudioProductEngagementRing>
    ) => null | string
    DesignStudioProductGeneric?: (
        data: WithTypename<DesignStudioProductGeneric>
    ) => null | string
    DesignStudioProductLooseStone?: (
        data: WithTypename<DesignStudioProductLooseStone>
    ) => null | string
    DesignStudioProductWeddingRing?: (
        data: WithTypename<DesignStudioProductWeddingRing>
    ) => null | string
    DesignStudioSignatureStone?: (
        data: WithTypename<DesignStudioSignatureStone>
    ) => null | string
    DesiredDeliveryDateInvalidError?: (
        data: WithTypename<DesiredDeliveryDateInvalidError>
    ) => null | string
    EngagementRingDesignFeatureLabel?: (
        data: WithTypename<EngagementRingDesignFeatureLabel>
    ) => null | string
    EngagementRingDesignStyleLabel?: (
        data: WithTypename<EngagementRingDesignStyleLabel>
    ) => null | string
    EngagementRingStoneRecommendationCard?: (
        data: WithTypename<EngagementRingStoneRecommendationCard>
    ) => null | string
    EngagementRingStoneRecommendationNaturalDiamonds?: (
        data: WithTypename<EngagementRingStoneRecommendationNaturalDiamonds>
    ) => null | string
    EngagementRingStoneRecommendationNonSkuGemStoneCard?: (
        data: WithTypename<EngagementRingStoneRecommendationNonSkuGemStoneCard>
    ) => null | string
    EngagementRingStoneRecommendationNonSkuLabGrown?: (
        data: WithTypename<EngagementRingStoneRecommendationNonSkuLabGrown>
    ) => null | string
    EngagementRingStoneRecommendations?: (
        data: WithTypename<EngagementRingStoneRecommendations>
    ) => null | string
    EngagementRingStyleLabel?: (
        data: WithTypename<EngagementRingStyleLabel>
    ) => null | string
    EnquiryConsultation?: (
        data: WithTypename<EnquiryConsultation>
    ) => null | string
    EnquiryEngagementRingAddToCart?: (
        data: WithTypename<EnquiryEngagementRingAddToCart>
    ) => null | string
    EnquiryResponseExistingCustomer?: (
        data: WithTypename<EnquiryResponseExistingCustomer>
    ) => null | string
    EnquiryResponseNewCustomer?: (
        data: WithTypename<EnquiryResponseNewCustomer>
    ) => null | string
    EnquiryWeddingRingAddToCart?: (
        data: WithTypename<EnquiryWeddingRingAddToCart>
    ) => null | string
    FaqQuestion?: (data: WithTypename<FaqQuestion>) => null | string
    FaqSection?: (data: WithTypename<FaqSection>) => null | string
    Footer?: (data: WithTypename<Footer>) => null | string
    FooterColumn?: (data: WithTypename<FooterColumn>) => null | string
    FooterColumnItemLink?: (
        data: WithTypename<FooterColumnItemLink>
    ) => null | string
    FooterColumnItemLinkList?: (
        data: WithTypename<FooterColumnItemLinkList>
    ) => null | string
    FooterColumnItemSeparator?: (
        data: WithTypename<FooterColumnItemSeparator>
    ) => null | string
    FooterColumnItemText?: (
        data: WithTypename<FooterColumnItemText>
    ) => null | string
    FooterColumnItemTitle?: (
        data: WithTypename<FooterColumnItemTitle>
    ) => null | string
    FooterColumnItemWorkingHours?: (
        data: WithTypename<FooterColumnItemWorkingHours>
    ) => null | string
    FooterLogo?: (data: WithTypename<FooterLogo>) => null | string
    GalleryCarouselCard?: (
        data: WithTypename<GalleryCarouselCard>
    ) => null | string
    GalleryItem?: (data: WithTypename<GalleryItem>) => null | string
    GalleryWithEnquiryCard?: (
        data: WithTypename<GalleryWithEnquiryCard>
    ) => null | string
    GemsApiPriceBounds?: (
        data: WithTypename<GemsApiPriceBounds>
    ) => null | string
    GemsApiStone?: (data: WithTypename<GemsApiStone>) => null | string
    GemsApi_Bounds?: (data: WithTypename<GemsApi_Bounds>) => null | string
    GemsApi_IntRange?: (data: WithTypename<GemsApi_IntRange>) => null | string
    GemsApi_Pagination?: (
        data: WithTypename<GemsApi_Pagination>
    ) => null | string
    GemsApi_PricePoint?: (
        data: WithTypename<GemsApi_PricePoint>
    ) => null | string
    GemsApi_PriceRange?: (
        data: WithTypename<GemsApi_PriceRange>
    ) => null | string
    GemsApi_PriceRangeByShape?: (
        data: WithTypename<GemsApi_PriceRangeByShape>
    ) => null | string
    GemsApi_Range?: (data: WithTypename<GemsApi_Range>) => null | string
    GemsApi_SelectedRange?: (
        data: WithTypename<GemsApi_SelectedRange>
    ) => null | string
    GemsApi_SelectedSorting?: (
        data: WithTypename<GemsApi_SelectedSorting>
    ) => null | string
    GemsApi_SelectedStoneFilters?: (
        data: WithTypename<GemsApi_SelectedStoneFilters>
    ) => null | string
    GemsApi_Stone?: (data: WithTypename<GemsApi_Stone>) => null | string
    GemsApi_StoneCategoryInfo?: (
        data: WithTypename<GemsApi_StoneCategoryInfo>
    ) => null | string
    GemsApi_StoneCertificates?: (
        data: WithTypename<GemsApi_StoneCertificates>
    ) => null | string
    GemsApi_StoneClarityInfo?: (
        data: WithTypename<GemsApi_StoneClarityInfo>
    ) => null | string
    GemsApi_StoneCollection?: (
        data: WithTypename<GemsApi_StoneCollection>
    ) => null | string
    GemsApi_StoneColorInfo?: (
        data: WithTypename<GemsApi_StoneColorInfo>
    ) => null | string
    GemsApi_StoneCrystalInfo?: (
        data: WithTypename<GemsApi_StoneCrystalInfo>
    ) => null | string
    GemsApi_StoneCutInfo?: (
        data: WithTypename<GemsApi_StoneCutInfo>
    ) => null | string
    GemsApi_StoneFluorescenceInfo?: (
        data: WithTypename<GemsApi_StoneFluorescenceInfo>
    ) => null | string
    GemsApi_StoneGradeInfo?: (
        data: WithTypename<GemsApi_StoneGradeInfo>
    ) => null | string
    GemsApi_StoneImage?: (
        data: WithTypename<GemsApi_StoneImage>
    ) => null | string
    GemsApi_StonePolishInfo?: (
        data: WithTypename<GemsApi_StonePolishInfo>
    ) => null | string
    GemsApi_StoneShapeInfo?: (
        data: WithTypename<GemsApi_StoneShapeInfo>
    ) => null | string
    GemsApi_StoneSymmetryInfo?: (
        data: WithTypename<GemsApi_StoneSymmetryInfo>
    ) => null | string
    GemsApi_dtlReport?: (data: WithTypename<GemsApi_DtlReport>) => null | string
    GenericImage?: (data: WithTypename<GenericImage>) => null | string
    GeoPoint?: (data: WithTypename<GeoPoint>) => null | string
    HistoricalNonSkuGemstone?: (
        data: WithTypename<HistoricalNonSkuGemstone>
    ) => null | string
    HistoricalNonSkuLabGrown?: (
        data: WithTypename<HistoricalNonSkuLabGrown>
    ) => null | string
    IconCarouselItem?: (data: WithTypename<IconCarouselItem>) => null | string
    Image?: (data: WithTypename<Image>) => null | string
    ImageSize?: (data: WithTypename<ImageSize>) => null | string
    ImageSrc?: (data: WithTypename<ImageSrc>) => null | string
    InstagramPost?: (data: WithTypename<InstagramPost>) => null | string
    InvalidateCacheResult?: (
        data: WithTypename<InvalidateCacheResult>
    ) => null | string
    InvalidateCacheResultError?: (
        data: WithTypename<InvalidateCacheResultError>
    ) => null | string
    InvalidateCacheResultSuccess?: (
        data: WithTypename<InvalidateCacheResultSuccess>
    ) => null | string
    JewelleryBraceletProductStyleLabel?: (
        data: WithTypename<JewelleryBraceletProductStyleLabel>
    ) => null | string
    JewelleryDesignFeatureLabel?: (
        data: WithTypename<JewelleryDesignFeatureLabel>
    ) => null | string
    JewelleryDesignStyleLabel?: (
        data: WithTypename<JewelleryDesignStyleLabel>
    ) => null | string
    JewelleryEarringsProductStyleLabel?: (
        data: WithTypename<JewelleryEarringsProductStyleLabel>
    ) => null | string
    JewelleryGemstoneLabel?: (
        data: WithTypename<JewelleryGemstoneLabel>
    ) => null | string
    JewelleryNecklaceProductStyleLabel?: (
        data: WithTypename<JewelleryNecklaceProductStyleLabel>
    ) => null | string
    JewelleryRingProductStyleLabel?: (
        data: WithTypename<JewelleryRingProductStyleLabel>
    ) => null | string
    KlarnaFinanceOption?: (
        data: WithTypename<KlarnaFinanceOption>
    ) => null | string
    KlarnaPaymentMethod?: (
        data: WithTypename<KlarnaPaymentMethod>
    ) => null | string
    KlarnaPaymentResponse?: (
        data: WithTypename<KlarnaPaymentResponse>
    ) => null | string
    KlarnaTransaction?: (data: WithTypename<KlarnaTransaction>) => null | string
    Language?: (data: WithTypename<Language>) => null | string
    LegacyTransaction?: (data: WithTypename<LegacyTransaction>) => null | string
    Link?: (data: WithTypename<Link>) => null | string
    LinkItemAffirm?: (data: WithTypename<LinkItemAffirm>) => null | string
    LinkItemBookingForm?: (
        data: WithTypename<LinkItemBookingForm>
    ) => null | string
    LinkItemCustom?: (data: WithTypename<LinkItemCustom>) => null | string
    LinkItemOpenContactForm?: (
        data: WithTypename<LinkItemOpenContactForm>
    ) => null | string
    LinkItemOpenEnquiryForm?: (
        data: WithTypename<LinkItemOpenEnquiryForm>
    ) => null | string
    LinkItemOpenSpeakToExpertModal?: (
        data: WithTypename<LinkItemOpenSpeakToExpertModal>
    ) => null | string
    LoginResponseFailure?: (
        data: WithTypename<LoginResponseFailure>
    ) => null | string
    LoginResponseSuccess?: (
        data: WithTypename<LoginResponseSuccess>
    ) => null | string
    Logo?: (data: WithTypename<Logo>) => null | string
    MagicLinkConsumeError?: (
        data: WithTypename<MagicLinkConsumeError>
    ) => null | string
    MagicLinkConsumeSuccess?: (
        data: WithTypename<MagicLinkConsumeSuccess>
    ) => null | string
    MarketingDataResponse?: (
        data: WithTypename<MarketingDataResponse>
    ) => null | string
    Melee?: (data: WithTypename<Melee>) => null | string
    MenuItem?: (data: WithTypename<MenuItem>) => null | string
    Meta?: (data: WithTypename<Meta>) => null | string
    Metal?: (data: WithTypename<Metal>) => null | string
    MetalColor?: (data: WithTypename<MetalColor>) => null | string
    MetalColorTranslation?: (
        data: WithTypename<MetalColorTranslation>
    ) => null | string
    MetalElement?: (data: WithTypename<MetalElement>) => null | string
    MetalElementTranslation?: (
        data: WithTypename<MetalElementTranslation>
    ) => null | string
    MetalTranslation?: (data: WithTypename<MetalTranslation>) => null | string
    Money?: (data: WithTypename<Money>) => null | string
    MonolithImageSize?: (data: WithTypename<MonolithImageSize>) => null | string
    NoPaymentMethod?: (data: WithTypename<NoPaymentMethod>) => null | string
    NonSkuCaratWeightRange?: (
        data: WithTypename<NonSkuCaratWeightRange>
    ) => null | string
    NonSkuGemstone?: (data: WithTypename<NonSkuGemstone>) => null | string
    NonSkuGemstoneCaratDimension?: (
        data: WithTypename<NonSkuGemstoneCaratDimension>
    ) => null | string
    NonSkuGemstoneGradeClarityDimension?: (
        data: WithTypename<NonSkuGemstoneGradeClarityDimension>
    ) => null | string
    NonSkuGemstoneImage?: (
        data: WithTypename<NonSkuGemstoneImage>
    ) => null | string
    NonSkuGemstoneShapeDimension?: (
        data: WithTypename<NonSkuGemstoneShapeDimension>
    ) => null | string
    NonSkuGemstoneType?: (
        data: WithTypename<NonSkuGemstoneType>
    ) => null | string
    NonSkuGemstonesBounds?: (
        data: WithTypename<NonSkuGemstonesBounds>
    ) => null | string
    NonSkuImage?: (data: WithTypename<NonSkuImage>) => null | string
    NonSkuLabGrown?: (data: WithTypename<NonSkuLabGrown>) => null | string
    NonSkuLabGrownCaratDimension?: (
        data: WithTypename<NonSkuLabGrownCaratDimension>
    ) => null | string
    NonSkuLabGrownDiamondsBounds?: (
        data: WithTypename<NonSkuLabGrownDiamondsBounds>
    ) => null | string
    NonSkuLabGrownGradeDimension?: (
        data: WithTypename<NonSkuLabGrownGradeDimension>
    ) => null | string
    NonSkuLabGrownShapeDimension?: (
        data: WithTypename<NonSkuLabGrownShapeDimension>
    ) => null | string
    NonSkuPriceRange?: (data: WithTypename<NonSkuPriceRange>) => null | string
    Order?: (data: WithTypename<Order>) => null | string
    OrderAddress?: (data: WithTypename<OrderAddress>) => null | string
    OrderAddressNotConfirmedError?: (
        data: WithTypename<OrderAddressNotConfirmedError>
    ) => null | string
    OrderAlreadyCompletedError?: (
        data: WithTypename<OrderAlreadyCompletedError>
    ) => null | string
    OrderEmptyError?: (data: WithTypename<OrderEmptyError>) => null | string
    OrderProduct?: (data: WithTypename<OrderProduct>) => null | string
    OrderStatus?: (data: WithTypename<OrderStatus>) => null | string
    OrderedListItem?: (data: WithTypename<OrderedListItem>) => null | string
    Page?: (data: WithTypename<Page>) => null | string
    PageSettings?: (data: WithTypename<PageSettings>) => null | string
    PageTooltip?: (data: WithTypename<PageTooltip>) => null | string
    PayViaCheckoutcomFailureResponse?: (
        data: WithTypename<PayViaCheckoutcomFailureResponse>
    ) => null | string
    PayViaCheckoutcomSuccessResponse?: (
        data: WithTypename<PayViaCheckoutcomSuccessResponse>
    ) => null | string
    PaymentAmountInvalidError?: (
        data: WithTypename<PaymentAmountInvalidError>
    ) => null | string
    PaymentIcon?: (data: WithTypename<PaymentIcon>) => null | string
    PaymentMethodContainer?: (
        data: WithTypename<PaymentMethodContainer>
    ) => null | string
    PaymentMethodNotAllowedError?: (
        data: WithTypename<PaymentMethodNotAllowedError>
    ) => null | string
    PaymentPlan?: (data: WithTypename<PaymentPlan>) => null | string
    PaymentPlanPaidRecord?: (
        data: WithTypename<PaymentPlanPaidRecord>
    ) => null | string
    PaymentPlanUpcomingRecord?: (
        data: WithTypename<PaymentPlanUpcomingRecord>
    ) => null | string
    PhoneNumberType?: (data: WithTypename<PhoneNumberType>) => null | string
    Post?: (data: WithTypename<Post>) => null | string
    PostCategoriesAggregation?: (
        data: WithTypename<PostCategoriesAggregation>
    ) => null | string
    PostCategory?: (data: WithTypename<PostCategory>) => null | string
    PostTag?: (data: WithTypename<PostTag>) => null | string
    PostTagsAggregation?: (
        data: WithTypename<PostTagsAggregation>
    ) => null | string
    PostsAggregation?: (data: WithTypename<PostsAggregation>) => null | string
    PreHeader?: (data: WithTypename<PreHeader>) => null | string
    ProductLabelTranslation?: (
        data: WithTypename<ProductLabelTranslation>
    ) => null | string
    ProductPageDetails?: (
        data: WithTypename<ProductPageDetails>
    ) => null | string
    ProductPageFacetedContent?: (
        data: WithTypename<ProductPageFacetedContent>
    ) => null | string
    ProductPageFacetedContentLongDescriptionBlock?: (
        data: WithTypename<ProductPageFacetedContentLongDescriptionBlock>
    ) => null | string
    ProductPageFacetedContentLongDescriptionText?: (
        data: WithTypename<ProductPageFacetedContentLongDescriptionText>
    ) => null | string
    ProductPageListing?: (
        data: WithTypename<ProductPageListing>
    ) => null | string
    PromoCode?: (data: WithTypename<PromoCode>) => null | string
    PromoCodeApplicationResult?: (
        data: WithTypename<PromoCodeApplicationResult>
    ) => null | string
    Questionnaire?: (data: WithTypename<Questionnaire>) => null | string
    QuestionnaireCompletedExistingCustomerResponse?: (
        data: WithTypename<QuestionnaireCompletedExistingCustomerResponse>
    ) => null | string
    QuestionnaireCompletedNewCustomerResponse?: (
        data: WithTypename<QuestionnaireCompletedNewCustomerResponse>
    ) => null | string
    QuestionnaireCompletedQuestionnaire?: (
        data: WithTypename<QuestionnaireCompletedQuestionnaire>
    ) => null | string
    QuestionnaireCompletedQuestionnaireStepSnapshot?: (
        data: WithTypename<QuestionnaireCompletedQuestionnaireStepSnapshot>
    ) => null | string
    QuestionnaireCondition?: (
        data: WithTypename<QuestionnaireCondition>
    ) => null | string
    QuestionnaireConditionEqualToChoice?: (
        data: WithTypename<QuestionnaireConditionEqualToChoice>
    ) => null | string
    QuestionnaireConditionIsEmpty?: (
        data: WithTypename<QuestionnaireConditionIsEmpty>
    ) => null | string
    QuestionnaireConditionIsEqualTo?: (
        data: WithTypename<QuestionnaireConditionIsEqualTo>
    ) => null | string
    QuestionnaireConditionIsGreaterThan?: (
        data: WithTypename<QuestionnaireConditionIsGreaterThan>
    ) => null | string
    QuestionnaireConditionIsLessThan?: (
        data: WithTypename<QuestionnaireConditionIsLessThan>
    ) => null | string
    QuestionnaireConditionIsNotEmpty?: (
        data: WithTypename<QuestionnaireConditionIsNotEmpty>
    ) => null | string
    QuestionnaireConditionNotIsEqualTo?: (
        data: WithTypename<QuestionnaireConditionNotIsEqualTo>
    ) => null | string
    QuestionnaireCustomerNotification?: (
        data: WithTypename<QuestionnaireCustomerNotification>
    ) => null | string
    QuestionnaireQuestionAnswerMultiChoice?: (
        data: WithTypename<QuestionnaireQuestionAnswerMultiChoice>
    ) => null | string
    QuestionnaireQuestionAnswerNumber?: (
        data: WithTypename<QuestionnaireQuestionAnswerNumber>
    ) => null | string
    QuestionnaireQuestionAnswerSingleChoice?: (
        data: WithTypename<QuestionnaireQuestionAnswerSingleChoice>
    ) => null | string
    QuestionnaireQuestionAnswerText?: (
        data: WithTypename<QuestionnaireQuestionAnswerText>
    ) => null | string
    QuestionnaireQuestionChoice?: (
        data: WithTypename<QuestionnaireQuestionChoice>
    ) => null | string
    QuestionnaireQuestionChoiceOption?: (
        data: WithTypename<QuestionnaireQuestionChoiceOption>
    ) => null | string
    QuestionnaireQuestionChoiceOptionBehaviour?: (
        data: WithTypename<QuestionnaireQuestionChoiceOptionBehaviour>
    ) => null | string
    QuestionnaireQuestionChoiceOptionContentIconCard?: (
        data: WithTypename<QuestionnaireQuestionChoiceOptionContentIconCard>
    ) => null | string
    QuestionnaireQuestionChoiceOptionContentIconCardConditional?: (
        data: WithTypename<QuestionnaireQuestionChoiceOptionContentIconCardConditional>
    ) => null | string
    QuestionnaireQuestionChoiceOptionContentImage?: (
        data: WithTypename<QuestionnaireQuestionChoiceOptionContentImage>
    ) => null | string
    QuestionnaireQuestionChoiceOptionContentImageCard?: (
        data: WithTypename<QuestionnaireQuestionChoiceOptionContentImageCard>
    ) => null | string
    QuestionnaireQuestionChoiceOptionContentImageCardConditional?: (
        data: WithTypename<QuestionnaireQuestionChoiceOptionContentImageCardConditional>
    ) => null | string
    QuestionnaireQuestionChoiceOptionContentImageConditional?: (
        data: WithTypename<QuestionnaireQuestionChoiceOptionContentImageConditional>
    ) => null | string
    QuestionnaireQuestionChoiceOptionContentText?: (
        data: WithTypename<QuestionnaireQuestionChoiceOptionContentText>
    ) => null | string
    QuestionnaireQuestionChoiceOptionContentTextConditional?: (
        data: WithTypename<QuestionnaireQuestionChoiceOptionContentTextConditional>
    ) => null | string
    QuestionnaireQuestionChoiceOptionLayoutSnapshotIconCard?: (
        data: WithTypename<QuestionnaireQuestionChoiceOptionLayoutSnapshotIconCard>
    ) => null | string
    QuestionnaireQuestionChoiceOptionLayoutSnapshotImage?: (
        data: WithTypename<QuestionnaireQuestionChoiceOptionLayoutSnapshotImage>
    ) => null | string
    QuestionnaireQuestionChoiceOptionLayoutSnapshotImageCard?: (
        data: WithTypename<QuestionnaireQuestionChoiceOptionLayoutSnapshotImageCard>
    ) => null | string
    QuestionnaireQuestionChoiceOptionLayoutSnapshotText?: (
        data: WithTypename<QuestionnaireQuestionChoiceOptionLayoutSnapshotText>
    ) => null | string
    QuestionnaireQuestionChoiceOptionSnapshot?: (
        data: WithTypename<QuestionnaireQuestionChoiceOptionSnapshot>
    ) => null | string
    QuestionnaireQuestionPrice?: (
        data: WithTypename<QuestionnaireQuestionPrice>
    ) => null | string
    QuestionnaireQuestionSnapshot?: (
        data: WithTypename<QuestionnaireQuestionSnapshot>
    ) => null | string
    QuestionnaireQuestionText?: (
        data: WithTypename<QuestionnaireQuestionText>
    ) => null | string
    QuestionnaireSignUpStep?: (
        data: WithTypename<QuestionnaireSignUpStep>
    ) => null | string
    QuestionnaireStep?: (data: WithTypename<QuestionnaireStep>) => null | string
    QuestionnaireStepContentContent?: (
        data: WithTypename<QuestionnaireStepContentContent>
    ) => null | string
    QuestionnaireStepContentQuestions?: (
        data: WithTypename<QuestionnaireStepContentQuestions>
    ) => null | string
    QuestionnaireSubmissionNotification?: (
        data: WithTypename<QuestionnaireSubmissionNotification>
    ) => null | string
    QuotationEngagementRing?: (
        data: WithTypename<QuotationEngagementRing>
    ) => null | string
    QuotationManualSurcharge?: (
        data: WithTypename<QuotationManualSurcharge>
    ) => null | string
    QuotationPercentageSurcharge?: (
        data: WithTypename<QuotationPercentageSurcharge>
    ) => null | string
    QuotationWeddingRing?: (
        data: WithTypename<QuotationWeddingRing>
    ) => null | string
    RecommendedRingSize?: (
        data: WithTypename<RecommendedRingSize>
    ) => null | string
    Region?: (data: WithTypename<Region>) => null | string
    Review?: (data: WithTypename<Review>) => null | string
    ReviewCarouselCard?: (
        data: WithTypename<ReviewCarouselCard>
    ) => null | string
    RingBuilder?: (data: WithTypename<RingBuilder>) => null | string
    RingBuilderCentreStoneFragment?: (
        data: WithTypename<RingBuilderCentreStoneFragment>
    ) => null | string
    RingBuilderMountFragment?: (
        data: WithTypename<RingBuilderMountFragment>
    ) => null | string
    RingBuilderResolvedExistingCustomerSuccess?: (
        data: WithTypename<RingBuilderResolvedExistingCustomerSuccess>
    ) => null | string
    RingBuilderResolvedFailure?: (
        data: WithTypename<RingBuilderResolvedFailure>
    ) => null | string
    RingBuilderResolvedNewCustomerSuccess?: (
        data: WithTypename<RingBuilderResolvedNewCustomerSuccess>
    ) => null | string
    RingBuilderSetResult?: (
        data: WithTypename<RingBuilderSetResult>
    ) => null | string
    RingSize?: (data: WithTypename<RingSize>) => null | string
    SalePrice?: (data: WithTypename<SalePrice>) => null | string
    SearchEverywhereResponse?: (
        data: WithTypename<SearchEverywhereResponse>
    ) => null | string
    SetDeliveryInformationFailureResponse?: (
        data: WithTypename<SetDeliveryInformationFailureResponse>
    ) => null | string
    SetDeliveryInformationSuccessResponse?: (
        data: WithTypename<SetDeliveryInformationSuccessResponse>
    ) => null | string
    ShipmentTrackingInformation?: (
        data: WithTypename<ShipmentTrackingInformation>
    ) => null | string
    ShopWithConfidenceEthnicallySourcedDiamonds?: (
        data: WithTypename<ShopWithConfidenceEthnicallySourcedDiamonds>
    ) => null | string
    ShopWithConfidenceFinancingOptions?: (
        data: WithTypename<ShopWithConfidenceFinancingOptions>
    ) => null | string
    ShopWithConfidenceGreenlandRuby?: (
        data: WithTypename<ShopWithConfidenceGreenlandRuby>
    ) => null | string
    ShopWithConfidenceHandFinished?: (
        data: WithTypename<ShopWithConfidenceHandFinished>
    ) => null | string
    ShopWithConfidenceResize?: (
        data: WithTypename<ShopWithConfidenceResize>
    ) => null | string
    ShopWithConfidenceReturnPolicy?: (
        data: WithTypename<ShopWithConfidenceReturnPolicy>
    ) => null | string
    ShopWithConfidenceShipping?: (
        data: WithTypename<ShopWithConfidenceShipping>
    ) => null | string
    Showroom?: (data: WithTypename<Showroom>) => null | string
    ShowroomLocation?: (data: WithTypename<ShowroomLocation>) => null | string
    ShowroomTranslation?: (
        data: WithTypename<ShowroomTranslation>
    ) => null | string
    SocialNetwork?: (data: WithTypename<SocialNetwork>) => null | string
    SquareImageBox?: (data: WithTypename<SquareImageBox>) => null | string
    SquareTextBox?: (data: WithTypename<SquareTextBox>) => null | string
    Stone?: (data: WithTypename<Stone>) => null | string
    StoneCategory?: (data: WithTypename<StoneCategory>) => null | string
    StoneCategoryTranslation?: (
        data: WithTypename<StoneCategoryTranslation>
    ) => null | string
    StoneCertificate?: (data: WithTypename<StoneCertificate>) => null | string
    StoneClarity?: (data: WithTypename<StoneClarity>) => null | string
    StoneClarityTranslation?: (
        data: WithTypename<StoneClarityTranslation>
    ) => null | string
    StoneColor?: (data: WithTypename<StoneColor>) => null | string
    StoneColorTranslation?: (
        data: WithTypename<StoneColorTranslation>
    ) => null | string
    StoneCrystal?: (data: WithTypename<StoneCrystal>) => null | string
    StoneCrystalTranslation?: (
        data: WithTypename<StoneCrystalTranslation>
    ) => null | string
    StoneCut?: (data: WithTypename<StoneCut>) => null | string
    StoneCutTranslation?: (
        data: WithTypename<StoneCutTranslation>
    ) => null | string
    StoneFluorescence?: (data: WithTypename<StoneFluorescence>) => null | string
    StoneFluorescenceTranslation?: (
        data: WithTypename<StoneFluorescenceTranslation>
    ) => null | string
    StoneGrade?: (data: WithTypename<StoneGrade>) => null | string
    StoneGradeTranslation?: (
        data: WithTypename<StoneGradeTranslation>
    ) => null | string
    StoneMeasurements?: (data: WithTypename<StoneMeasurements>) => null | string
    StonePolish?: (data: WithTypename<StonePolish>) => null | string
    StonePolishTranslation?: (
        data: WithTypename<StonePolishTranslation>
    ) => null | string
    StoneRecommendationNonSkuGemstone?: (
        data: WithTypename<StoneRecommendationNonSkuGemstone>
    ) => null | string
    StoneRecommendationNotFound?: (
        data: WithTypename<StoneRecommendationNotFound>
    ) => null | string
    StoneRecommendationsNaturalDiamondFilters?: (
        data: WithTypename<StoneRecommendationsNaturalDiamondFilters>
    ) => null | string
    StoneRecommendationsPercentRange?: (
        data: WithTypename<StoneRecommendationsPercentRange>
    ) => null | string
    StoneRecommendationsPriceRange?: (
        data: WithTypename<StoneRecommendationsPriceRange>
    ) => null | string
    StoneRecommendationsResponseFailure?: (
        data: WithTypename<StoneRecommendationsResponseFailure>
    ) => null | string
    StoneRecommendationsResponseSuccess?: (
        data: WithTypename<StoneRecommendationsResponseSuccess>
    ) => null | string
    StoneShape?: (data: WithTypename<StoneShape>) => null | string
    StoneShapeTranslation?: (
        data: WithTypename<StoneShapeTranslation>
    ) => null | string
    StoneSymmetry?: (data: WithTypename<StoneSymmetry>) => null | string
    StoneSymmetryTranslation?: (
        data: WithTypename<StoneSymmetryTranslation>
    ) => null | string
    StripeTransaction?: (data: WithTypename<StripeTransaction>) => null | string
    SubMenu?: (data: WithTypename<SubMenu>) => null | string
    SubMenuEditorialContent?: (
        data: WithTypename<SubMenuEditorialContent>
    ) => null | string
    SubMenuItem?: (data: WithTypename<SubMenuItem>) => null | string
    SubMenuSection?: (data: WithTypename<SubMenuSection>) => null | string
    Table?: (data: WithTypename<Table>) => null | string
    TableBody?: (data: WithTypename<TableBody>) => null | string
    TableHeader?: (data: WithTypename<TableHeader>) => null | string
    TableRow?: (data: WithTypename<TableRow>) => null | string
    Tax?: (data: WithTypename<Tax>) => null | string
    TextCarouselItem?: (data: WithTypename<TextCarouselItem>) => null | string
    Tooltip?: (data: WithTypename<Tooltip>) => null | string
    TopBar?: (data: WithTypename<TopBar>) => null | string
    TopBarConsultationPrompt?: (
        data: WithTypename<TopBarConsultationPrompt>
    ) => null | string
    TopBarSiteWideMessage?: (
        data: WithTypename<TopBarSiteWideMessage>
    ) => null | string
    TransactionStatus?: (data: WithTypename<TransactionStatus>) => null | string
    Translation?: (data: WithTypename<Translation>) => null | string
    User?: (data: WithTypename<User>) => null | string
    UserCustomerEngagementRingRecommendations?: (
        data: WithTypename<UserCustomerEngagementRingRecommendations>
    ) => null | string
    Video?: (data: WithTypename<Video>) => null | string
    WeddingRingCategoryLabel?: (
        data: WithTypename<WeddingRingCategoryLabel>
    ) => null | string
    WeddingRingStyleLabel?: (
        data: WithTypename<WeddingRingStyleLabel>
    ) => null | string
    WorkingHours?: (data: WithTypename<WorkingHours>) => null | string
}

export type GraphCacheResolvers = {
    Query?: {
        GemsApi_findStones?: GraphCacheResolver<
            WithTypename<Query>,
            QueryGemsApi_FindStonesArgs,
            WithTypename<GemsApi_StoneCollection> | string
        >
        GemsApi_getBounds?: GraphCacheResolver<
            WithTypename<Query>,
            QueryGemsApi_GetBoundsArgs,
            WithTypename<GemsApi_Bounds> | string
        >
        GemsApi_getGiaStone?: GraphCacheResolver<
            WithTypename<Query>,
            QueryGemsApi_GetGiaStoneArgs,
            WithTypename<GemsApi_Stone> | string
        >
        GemsApi_getStone?: GraphCacheResolver<
            WithTypename<Query>,
            QueryGemsApi_GetStoneArgs,
            WithTypename<GemsApi_Stone> | string
        >
        GemsApi_getStoneByExternalId?: GraphCacheResolver<
            WithTypename<Query>,
            QueryGemsApi_GetStoneByExternalIdArgs,
            WithTypename<GemsApi_Stone> | string
        >
        GemsApi_getStones?: GraphCacheResolver<
            WithTypename<Query>,
            QueryGemsApi_GetStonesArgs,
            Array<WithTypename<GemsApi_Stone> | string>
        >
        authorById?: GraphCacheResolver<
            WithTypename<Query>,
            QueryAuthorByIdArgs,
            WithTypename<Author> | string
        >
        authorBySlug?: GraphCacheResolver<
            WithTypename<Query>,
            QueryAuthorBySlugArgs,
            WithTypename<Author> | string
        >
        authors?: GraphCacheResolver<
            WithTypename<Query>,
            QueryAuthorsArgs,
            Array<WithTypename<Author> | string>
        >
        authorsAggregation?: GraphCacheResolver<
            WithTypename<Query>,
            QueryAuthorsAggregationArgs,
            WithTypename<AuthorsAggregation> | string
        >
        avatarStack?: GraphCacheResolver<
            WithTypename<Query>,
            QueryAvatarStackArgs,
            Array<WithTypename<AvatarStackItem> | string>
        >
        bookingAvailableTransitions?: GraphCacheResolver<
            WithTypename<Query>,
            QueryBookingAvailableTransitionsArgs,
            Array<BookingConsultationTransition | string>
        >
        bookingConsultants?: GraphCacheResolver<
            WithTypename<Query>,
            Record<string, never>,
            Array<WithTypename<Consultant> | string>
        >
        bookingConsultation?: GraphCacheResolver<
            WithTypename<Query>,
            QueryBookingConsultationArgs,
            WithTypename<BookingConsultation> | string
        >
        bookingConsultationAvailableSlots?: GraphCacheResolver<
            WithTypename<Query>,
            QueryBookingConsultationAvailableSlotsArgs,
            WithTypename<BookingConsultationSlotsResponse> | string
        >
        bookingConsultationAvailableSlotsByConsultant?: GraphCacheResolver<
            WithTypename<Query>,
            QueryBookingConsultationAvailableSlotsByConsultantArgs,
            Array<WithTypename<BookingConsultationAvailableDate> | string>
        >
        bookingConsultationComplexities?: GraphCacheResolver<
            WithTypename<Query>,
            Record<string, never>,
            Array<WithTypename<BookingConsultationComplexity> | string>
        >
        bookingConsultationPurposes?: GraphCacheResolver<
            WithTypename<Query>,
            Record<string, never>,
            Array<WithTypename<BookingConsultationPurpose> | string>
        >
        bookingConsultationShowPhone?: GraphCacheResolver<
            WithTypename<Query>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        bookingCustomer?: GraphCacheResolver<
            WithTypename<Query>,
            QueryBookingCustomerArgs,
            WithTypename<Customer> | string
        >
        bookingInPersonConsultationRooms?: GraphCacheResolver<
            WithTypename<Query>,
            QueryBookingInPersonConsultationRoomsArgs,
            Array<
                | WithTypename<BookingInPersonConsultationRoom>
                | WithTypename<BookingVirtualConsultationRoom>
                | string
            >
        >
        bookingShowrooms?: GraphCacheResolver<
            WithTypename<Query>,
            Record<string, never>,
            Array<WithTypename<Showroom> | string>
        >
        bookingVirtualConsultationRooms?: GraphCacheResolver<
            WithTypename<Query>,
            QueryBookingVirtualConsultationRoomsArgs,
            Array<
                | WithTypename<BookingInPersonConsultationRoom>
                | WithTypename<BookingVirtualConsultationRoom>
                | string
            >
        >
        calculateGemsApiStoneTotalSalePrices?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCalculateGemsApiStoneTotalSalePricesArgs,
            Array<WithTypename<Money> | string>
        >
        catalogueEngagementRing?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueEngagementRingArgs,
            WithTypename<CatalogueEngagementRing> | string
        >
        catalogueEngagementRingContainsProducts?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueEngagementRingContainsProductsArgs,
            Array<Scalars['Boolean'] | string>
        >
        catalogueEngagementRingFilters?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueEngagementRingFiltersArgs,
            WithTypename<CatalogueEngagementRingFilters> | string
        >
        catalogueEngagementRingFiltersVariations?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueEngagementRingFiltersVariationsArgs,
            Array<
                WithTypename<CatalogueEngagementRingFiltersVariation> | string
            >
        >
        catalogueEngagementRings?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueEngagementRingsArgs,
            Array<WithTypename<CatalogueEngagementRing> | string>
        >
        catalogueEngagementRingsAggregate?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueEngagementRingsAggregateArgs,
            WithTypename<CatalogueAggregate> | string
        >
        catalogueJewelleries?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueJewelleriesArgs,
            Array<
                | WithTypename<CatalogueJewelleryBracelet>
                | WithTypename<CatalogueJewelleryEarrings>
                | WithTypename<CatalogueJewelleryNecklace>
                | WithTypename<CatalogueJewelleryRing>
                | string
            >
        >
        catalogueJewelleriesAggregate?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueJewelleriesAggregateArgs,
            WithTypename<CatalogueAggregate> | string
        >
        catalogueJewelleriesFilters?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueJewelleriesFiltersArgs,
            WithTypename<CatalogueJewelleriesFilters> | string
        >
        catalogueJewelleriesFiltersVariations?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueJewelleriesFiltersVariationsArgs,
            Array<WithTypename<CatalogueJewelleriesFiltersVariation> | string>
        >
        catalogueJewellery?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueJewelleryArgs,
            | WithTypename<CatalogueJewelleryBracelet>
            | WithTypename<CatalogueJewelleryEarrings>
            | WithTypename<CatalogueJewelleryNecklace>
            | WithTypename<CatalogueJewelleryRing>
            | string
        >
        catalogueJewelleryBracelet?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueJewelleryBraceletArgs,
            WithTypename<CatalogueJewelleryBracelet> | string
        >
        catalogueJewelleryBraceletFiltersVariations?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueJewelleryBraceletFiltersVariationsArgs,
            Array<
                | WithTypename<CatalogueJewelleriesBraceletsFiltersVariation>
                | string
            >
        >
        catalogueJewelleryBracelets?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueJewelleryBraceletsArgs,
            Array<WithTypename<CatalogueJewelleryBracelet> | string>
        >
        catalogueJewelleryBraceletsAggregate?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueJewelleryBraceletsAggregateArgs,
            WithTypename<CatalogueAggregate> | string
        >
        catalogueJewelleryBraceletsFilters?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueJewelleryBraceletsFiltersArgs,
            WithTypename<CatalogueJewelleryBraceletsFilters> | string
        >
        catalogueJewelleryEarring?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueJewelleryEarringArgs,
            WithTypename<CatalogueJewelleryEarrings> | string
        >
        catalogueJewelleryEarrings?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueJewelleryEarringsArgs,
            Array<WithTypename<CatalogueJewelleryEarrings> | string>
        >
        catalogueJewelleryEarringsAggregate?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueJewelleryEarringsAggregateArgs,
            WithTypename<CatalogueAggregate> | string
        >
        catalogueJewelleryEarringsFilters?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueJewelleryEarringsFiltersArgs,
            WithTypename<CatalogueJewelleryEarringsFilters> | string
        >
        catalogueJewelleryEarringsFiltersVariations?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueJewelleryEarringsFiltersVariationsArgs,
            Array<
                | WithTypename<CatalogueJewelleriesEarringsFiltersVariation>
                | string
            >
        >
        catalogueJewelleryNecklace?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueJewelleryNecklaceArgs,
            WithTypename<CatalogueJewelleryNecklace> | string
        >
        catalogueJewelleryNecklaces?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueJewelleryNecklacesArgs,
            Array<WithTypename<CatalogueJewelleryNecklace> | string>
        >
        catalogueJewelleryNecklacesAggregate?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueJewelleryNecklacesAggregateArgs,
            WithTypename<CatalogueAggregate> | string
        >
        catalogueJewelleryNecklacesFilters?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueJewelleryNecklacesFiltersArgs,
            WithTypename<CatalogueJewelleryNecklacesFilters> | string
        >
        catalogueJewelleryNecklacesFiltersVariations?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueJewelleryNecklacesFiltersVariationsArgs,
            Array<
                | WithTypename<CatalogueJewelleriesNecklacesFiltersVariation>
                | string
            >
        >
        catalogueJewelleryRing?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueJewelleryRingArgs,
            WithTypename<CatalogueJewelleryRing> | string
        >
        catalogueJewelleryRings?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueJewelleryRingsArgs,
            Array<WithTypename<CatalogueJewelleryRing> | string>
        >
        catalogueJewelleryRingsAggregate?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueJewelleryRingsAggregateArgs,
            WithTypename<CatalogueAggregate> | string
        >
        catalogueJewelleryRingsFilters?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueJewelleryRingsFiltersArgs,
            WithTypename<CatalogueJewelleryRingsFilters> | string
        >
        catalogueJewelleryRingsFiltersVariations?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueJewelleryRingsFiltersVariationsArgs,
            Array<
                WithTypename<CatalogueJewelleriesRingsFiltersVariation> | string
            >
        >
        catalogueProducts?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueProductsArgs,
            Array<
                | WithTypename<CatalogueEngagementRing>
                | WithTypename<CatalogueJewelleryBracelet>
                | WithTypename<CatalogueJewelleryEarrings>
                | WithTypename<CatalogueJewelleryNecklace>
                | WithTypename<CatalogueJewelleryRing>
                | WithTypename<CatalogueReadyToGoRing>
                | WithTypename<CatalogueWeddingRing>
                | string
            >
        >
        catalogueReadyToGoRing?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueReadyToGoRingArgs,
            WithTypename<CatalogueReadyToGoRing> | string
        >
        catalogueReadyToGoRings?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueReadyToGoRingsArgs,
            Array<WithTypename<CatalogueReadyToGoRing> | string>
        >
        catalogueReadyToGoRingsAggregate?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueReadyToGoRingsAggregateArgs,
            WithTypename<CatalogueAggregate> | string
        >
        catalogueReadyToGoRingsFilters?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueReadyToGoRingsFiltersArgs,
            WithTypename<CatalogueReadyToGoRingFilters> | string
        >
        catalogueWeddingRing?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueWeddingRingArgs,
            WithTypename<CatalogueWeddingRing> | string
        >
        catalogueWeddingRingFilterVariations?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueWeddingRingFilterVariationsArgs,
            Array<WithTypename<CatalogueWeddingRingFiltersVariation> | string>
        >
        catalogueWeddingRingFilters?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueWeddingRingFiltersArgs,
            WithTypename<CatalogueWeddingRingFilters> | string
        >
        catalogueWeddingRings?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueWeddingRingsArgs,
            Array<WithTypename<CatalogueWeddingRing> | string>
        >
        catalogueWeddingRingsAggregate?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCatalogueWeddingRingsAggregateArgs,
            WithTypename<CatalogueAggregate> | string
        >
        convertPriceBoundsForGems?: GraphCacheResolver<
            WithTypename<Query>,
            QueryConvertPriceBoundsForGemsArgs,
            WithTypename<GemsApiPriceBounds> | string
        >
        convertPriceBoundsForGemsMulti?: GraphCacheResolver<
            WithTypename<Query>,
            QueryConvertPriceBoundsForGemsMultiArgs,
            Array<WithTypename<GemsApiPriceBounds> | string>
        >
        customerExists?: GraphCacheResolver<
            WithTypename<Query>,
            QueryCustomerExistsArgs,
            Scalars['Boolean'] | string
        >
        defaultAlternateRegion?: GraphCacheResolver<
            WithTypename<Query>,
            Record<string, never>,
            WithTypename<Region> | string
        >
        defaultRegion?: GraphCacheResolver<
            WithTypename<Query>,
            Record<string, never>,
            WithTypename<Region> | string
        >
        deliveryDaysForBespokeEngagementRings?: GraphCacheResolver<
            WithTypename<Query>,
            Record<string, never>,
            Scalars['Int'] | string
        >
        engagementRingStoneRecommendations?: GraphCacheResolver<
            WithTypename<Query>,
            QueryEngagementRingStoneRecommendationsArgs,
            WithTypename<EngagementRingStoneRecommendations> | string
        >
        footer?: GraphCacheResolver<
            WithTypename<Query>,
            QueryFooterArgs,
            WithTypename<Footer> | string
        >
        language?: GraphCacheResolver<
            WithTypename<Query>,
            QueryLanguageArgs,
            WithTypename<Language> | string
        >
        languages?: GraphCacheResolver<
            WithTypename<Query>,
            Record<string, never>,
            Array<WithTypename<Language> | string>
        >
        mainMenu?: GraphCacheResolver<
            WithTypename<Query>,
            QueryMainMenuArgs,
            Array<WithTypename<MenuItem> | string>
        >
        me?: GraphCacheResolver<
            WithTypename<Query>,
            Record<string, never>,
            WithTypename<User> | string
        >
        metals?: GraphCacheResolver<
            WithTypename<Query>,
            Record<string, never>,
            Array<WithTypename<Metal> | string>
        >
        nonSkuGemStone?: GraphCacheResolver<
            WithTypename<Query>,
            QueryNonSkuGemStoneArgs,
            WithTypename<NonSkuGemstone> | string
        >
        nonSkuGemStones?: GraphCacheResolver<
            WithTypename<Query>,
            QueryNonSkuGemStonesArgs,
            Array<WithTypename<NonSkuGemstone> | string>
        >
        nonSkuGemStonesBounds?: GraphCacheResolver<
            WithTypename<Query>,
            Record<string, never>,
            WithTypename<NonSkuGemstonesBounds> | string
        >
        nonSkuGemStonesPricingCells?: GraphCacheResolver<
            WithTypename<Query>,
            QueryNonSkuGemStonesPricingCellsArgs,
            Array<WithTypename<NonSkuGemstone> | string>
        >
        nonSkuGemstoneCaratDimensions?: GraphCacheResolver<
            WithTypename<Query>,
            Record<string, never>,
            Array<WithTypename<NonSkuGemstoneCaratDimension> | string>
        >
        nonSkuGemstoneColorCrystalDimensions?: GraphCacheResolver<
            WithTypename<Query>,
            Record<string, never>,
            Array<WithTypename<NonSkuGemstoneType> | string>
        >
        nonSkuGemstoneGradeClarityDimensions?: GraphCacheResolver<
            WithTypename<Query>,
            Record<string, never>,
            Array<WithTypename<NonSkuGemstoneGradeClarityDimension> | string>
        >
        nonSkuGemstoneImages?: GraphCacheResolver<
            WithTypename<Query>,
            Record<string, never>,
            Array<WithTypename<NonSkuGemstoneImage> | string>
        >
        nonSkuGemstoneShapeDimensions?: GraphCacheResolver<
            WithTypename<Query>,
            Record<string, never>,
            Array<WithTypename<NonSkuGemstoneShapeDimension> | string>
        >
        nonSkuLabGrownCaratDimensions?: GraphCacheResolver<
            WithTypename<Query>,
            Record<string, never>,
            Array<WithTypename<NonSkuLabGrownCaratDimension> | string>
        >
        nonSkuLabGrownDiamond?: GraphCacheResolver<
            WithTypename<Query>,
            QueryNonSkuLabGrownDiamondArgs,
            WithTypename<NonSkuLabGrown> | string
        >
        nonSkuLabGrownDiamonds?: GraphCacheResolver<
            WithTypename<Query>,
            QueryNonSkuLabGrownDiamondsArgs,
            Array<WithTypename<NonSkuLabGrown> | string>
        >
        nonSkuLabGrownDiamondsBounds?: GraphCacheResolver<
            WithTypename<Query>,
            Record<string, never>,
            WithTypename<NonSkuLabGrownDiamondsBounds> | string
        >
        nonSkuLabGrownGradeDimensions?: GraphCacheResolver<
            WithTypename<Query>,
            Record<string, never>,
            Array<WithTypename<NonSkuLabGrownGradeDimension> | string>
        >
        nonSkuLabGrownPricingCells?: GraphCacheResolver<
            WithTypename<Query>,
            QueryNonSkuLabGrownPricingCellsArgs,
            Array<WithTypename<NonSkuLabGrown> | string>
        >
        nonSkuLabGrownShapeDimensions?: GraphCacheResolver<
            WithTypename<Query>,
            Record<string, never>,
            Array<WithTypename<NonSkuLabGrownShapeDimension> | string>
        >
        pageByPath?: GraphCacheResolver<
            WithTypename<Query>,
            QueryPageByPathArgs,
            WithTypename<Page> | string
        >
        pageProductDetails?: GraphCacheResolver<
            WithTypename<Query>,
            QueryPageProductDetailsArgs,
            WithTypename<ProductPageDetails> | string
        >
        pageProductListing?: GraphCacheResolver<
            WithTypename<Query>,
            QueryPageProductListingArgs,
            WithTypename<ProductPageListing> | string
        >
        pageProductListingFacetedContent?: GraphCacheResolver<
            WithTypename<Query>,
            QueryPageProductListingFacetedContentArgs,
            WithTypename<ProductPageFacetedContent> | string
        >
        pages?: GraphCacheResolver<
            WithTypename<Query>,
            QueryPagesArgs,
            Array<WithTypename<Page> | string>
        >
        paymentIcons?: GraphCacheResolver<
            WithTypename<Query>,
            QueryPaymentIconsArgs,
            Array<WithTypename<PaymentIcon> | string>
        >
        ping?: GraphCacheResolver<
            WithTypename<Query>,
            Record<string, never>,
            Scalars['String'] | string
        >
        postBySlug?: GraphCacheResolver<
            WithTypename<Query>,
            QueryPostBySlugArgs,
            WithTypename<Post> | string
        >
        postCategories?: GraphCacheResolver<
            WithTypename<Query>,
            QueryPostCategoriesArgs,
            Array<WithTypename<PostCategory> | string>
        >
        postCategoriesAggregation?: GraphCacheResolver<
            WithTypename<Query>,
            QueryPostCategoriesAggregationArgs,
            WithTypename<PostCategoriesAggregation> | string
        >
        postCategoryBySlug?: GraphCacheResolver<
            WithTypename<Query>,
            QueryPostCategoryBySlugArgs,
            WithTypename<PostCategory> | string
        >
        postTagAggregation?: GraphCacheResolver<
            WithTypename<Query>,
            QueryPostTagAggregationArgs,
            WithTypename<PostTagsAggregation> | string
        >
        postTagBySlug?: GraphCacheResolver<
            WithTypename<Query>,
            QueryPostTagBySlugArgs,
            WithTypename<PostTag> | string
        >
        postTags?: GraphCacheResolver<
            WithTypename<Query>,
            QueryPostTagsArgs,
            Array<WithTypename<PostTag> | string>
        >
        posts?: GraphCacheResolver<
            WithTypename<Query>,
            QueryPostsArgs,
            Array<WithTypename<Post> | string>
        >
        postsAggregation?: GraphCacheResolver<
            WithTypename<Query>,
            QueryPostsAggregationArgs,
            WithTypename<PostsAggregation> | string
        >
        preHeader?: GraphCacheResolver<
            WithTypename<Query>,
            QueryPreHeaderArgs,
            WithTypename<PreHeader> | string
        >
        questionnaire?: GraphCacheResolver<
            WithTypename<Query>,
            QueryQuestionnaireArgs,
            WithTypename<Questionnaire> | string
        >
        questionnaires?: GraphCacheResolver<
            WithTypename<Query>,
            Record<string, never>,
            Array<WithTypename<Questionnaire> | string>
        >
        region?: GraphCacheResolver<
            WithTypename<Query>,
            QueryRegionArgs,
            WithTypename<Region> | string
        >
        regionSuggest?: GraphCacheResolver<
            WithTypename<Query>,
            Record<string, never>,
            WithTypename<Region> | string
        >
        regions?: GraphCacheResolver<
            WithTypename<Query>,
            Record<string, never>,
            Array<WithTypename<Region> | string>
        >
        reviews?: GraphCacheResolver<
            WithTypename<Query>,
            QueryReviewsArgs,
            Array<WithTypename<Review> | string>
        >
        ringBuilder?: GraphCacheResolver<
            WithTypename<Query>,
            QueryRingBuilderArgs,
            WithTypename<RingBuilder> | string
        >
        searchEverywhere?: GraphCacheResolver<
            WithTypename<Query>,
            QuerySearchEverywhereArgs,
            WithTypename<SearchEverywhereResponse> | string
        >
        socialNetworks?: GraphCacheResolver<
            WithTypename<Query>,
            QuerySocialNetworksArgs,
            Array<WithTypename<SocialNetwork> | string>
        >
        stoneCategoriesBySystemCode?: GraphCacheResolver<
            WithTypename<Query>,
            QueryStoneCategoriesBySystemCodeArgs,
            Array<WithTypename<StoneCategory> | string>
        >
        stoneCategoryBySystemCode?: GraphCacheResolver<
            WithTypename<Query>,
            QueryStoneCategoryBySystemCodeArgs,
            WithTypename<StoneCategory> | string
        >
        stoneClarities?: GraphCacheResolver<
            WithTypename<Query>,
            QueryStoneClaritiesArgs,
            Array<WithTypename<StoneClarity> | string>
        >
        stoneClaritiesBySystemCode?: GraphCacheResolver<
            WithTypename<Query>,
            QueryStoneClaritiesBySystemCodeArgs,
            Array<WithTypename<StoneClarity> | string>
        >
        stoneClarityBySystemCode?: GraphCacheResolver<
            WithTypename<Query>,
            QueryStoneClarityBySystemCodeArgs,
            WithTypename<StoneClarity> | string
        >
        stoneColorBySystemCode?: GraphCacheResolver<
            WithTypename<Query>,
            QueryStoneColorBySystemCodeArgs,
            WithTypename<StoneColor> | string
        >
        stoneColors?: GraphCacheResolver<
            WithTypename<Query>,
            QueryStoneColorsArgs,
            Array<WithTypename<StoneColor> | string>
        >
        stoneColorsBySystemCode?: GraphCacheResolver<
            WithTypename<Query>,
            QueryStoneColorsBySystemCodeArgs,
            Array<WithTypename<StoneColor> | string>
        >
        stoneCrystals?: GraphCacheResolver<
            WithTypename<Query>,
            QueryStoneCrystalsArgs,
            Array<WithTypename<StoneCrystal> | string>
        >
        stoneCrystalsBySystemCode?: GraphCacheResolver<
            WithTypename<Query>,
            QueryStoneCrystalsBySystemCodeArgs,
            Array<WithTypename<StoneCrystal> | string>
        >
        stoneCutsBySystemCodes?: GraphCacheResolver<
            WithTypename<Query>,
            QueryStoneCutsBySystemCodesArgs,
            Array<WithTypename<StoneCut> | string>
        >
        stoneFluorescencesBySystemCodes?: GraphCacheResolver<
            WithTypename<Query>,
            QueryStoneFluorescencesBySystemCodesArgs,
            Array<WithTypename<StoneFluorescence> | string>
        >
        stoneGrades?: GraphCacheResolver<
            WithTypename<Query>,
            QueryStoneGradesArgs,
            Array<WithTypename<StoneGrade> | string>
        >
        stoneGradesBySystemCodes?: GraphCacheResolver<
            WithTypename<Query>,
            QueryStoneGradesBySystemCodesArgs,
            Array<WithTypename<StoneGrade> | string>
        >
        stonePolishesBySystemCodes?: GraphCacheResolver<
            WithTypename<Query>,
            QueryStonePolishesBySystemCodesArgs,
            Array<WithTypename<StonePolish> | string>
        >
        stoneShapeBySystemCodes?: GraphCacheResolver<
            WithTypename<Query>,
            QueryStoneShapeBySystemCodesArgs,
            Array<WithTypename<StoneShape> | string>
        >
        stoneShapes?: GraphCacheResolver<
            WithTypename<Query>,
            QueryStoneShapesArgs,
            Array<WithTypename<StoneShape> | string>
        >
        stoneSymmetriesBySystemCodes?: GraphCacheResolver<
            WithTypename<Query>,
            QueryStoneSymmetriesBySystemCodesArgs,
            Array<WithTypename<StoneSymmetry> | string>
        >
        tooltip?: GraphCacheResolver<
            WithTypename<Query>,
            QueryTooltipArgs,
            WithTypename<Tooltip> | string
        >
        topBar?: GraphCacheResolver<
            WithTypename<Query>,
            QueryTopBarArgs,
            WithTypename<TopBar> | string
        >
        validateConsultationInput?: GraphCacheResolver<
            WithTypename<Query>,
            QueryValidateConsultationInputArgs,
            Scalars['Boolean'] | string
        >
        validateCustomerRegistrationInput?: GraphCacheResolver<
            WithTypename<Query>,
            QueryValidateCustomerRegistrationInputArgs,
            Scalars['Boolean'] | string
        >
        workingHours?: GraphCacheResolver<
            WithTypename<Query>,
            QueryWorkingHoursArgs,
            Array<WithTypename<WorkingHours> | string>
        >
    }
    AddToCartReadyToGoRingSuccessExistingCustomer?: {
        order?: GraphCacheResolver<
            WithTypename<AddToCartReadyToGoRingSuccessExistingCustomer>,
            Record<string, never>,
            WithTypename<Order> | string
        >
        product?: GraphCacheResolver<
            WithTypename<AddToCartReadyToGoRingSuccessExistingCustomer>,
            Record<string, never>,
            WithTypename<OrderProduct> | string
        >
    }
    AddToCartReadyToGoRingSuccessNewCustomer?: {
        customer?: GraphCacheResolver<
            WithTypename<AddToCartReadyToGoRingSuccessNewCustomer>,
            Record<string, never>,
            WithTypename<CustomerRegistrationResponse> | string
        >
        order?: GraphCacheResolver<
            WithTypename<AddToCartReadyToGoRingSuccessNewCustomer>,
            Record<string, never>,
            WithTypename<Order> | string
        >
        product?: GraphCacheResolver<
            WithTypename<AddToCartReadyToGoRingSuccessNewCustomer>,
            Record<string, never>,
            WithTypename<OrderProduct> | string
        >
    }
    Address?: {
        country?: GraphCacheResolver<
            WithTypename<Address>,
            Record<string, never>,
            Scalars['Country'] | string
        >
        phoneNumber?: GraphCacheResolver<
            WithTypename<Address>,
            Record<string, never>,
            WithTypename<PhoneNumberType> | string
        >
    }
    AffirmCompleteTransactionResponse?: {
        errors?: GraphCacheResolver<
            WithTypename<AffirmCompleteTransactionResponse>,
            Record<string, never>,
            Array<Scalars['String'] | string>
        >
        order?: GraphCacheResolver<
            WithTypename<AffirmCompleteTransactionResponse>,
            Record<string, never>,
            WithTypename<Order> | string
        >
    }
    AffirmFinanceOption?: {
        months?: GraphCacheResolver<
            WithTypename<AffirmFinanceOption>,
            Record<string, never>,
            Scalars['Int'] | string
        >
        perMonth?: GraphCacheResolver<
            WithTypename<AffirmFinanceOption>,
            Record<string, never>,
            WithTypename<Money> | string
        >
        price?: GraphCacheResolver<
            WithTypename<AffirmFinanceOption>,
            Record<string, never>,
            WithTypename<Money> | string
        >
    }
    AffirmPaymentMethod?: {
        publicKey?: GraphCacheResolver<
            WithTypename<AffirmPaymentMethod>,
            Record<string, never>,
            Scalars['String'] | string
        >
        scriptUrl?: GraphCacheResolver<
            WithTypename<AffirmPaymentMethod>,
            Record<string, never>,
            Scalars['String'] | string
        >
        systemCode?: GraphCacheResolver<
            WithTypename<AffirmPaymentMethod>,
            Record<string, never>,
            Scalars['ID'] | string
        >
    }
    AffirmPaymentResponse?: {
        errors?: GraphCacheResolver<
            WithTypename<AffirmPaymentResponse>,
            Record<string, never>,
            Array<Scalars['String'] | string>
        >
        order?: GraphCacheResolver<
            WithTypename<AffirmPaymentResponse>,
            Record<string, never>,
            WithTypename<Order> | string
        >
    }
    AffirmTransaction?: {
        amount?: GraphCacheResolver<
            WithTypename<AffirmTransaction>,
            Record<string, never>,
            WithTypename<Money> | string
        >
        checkoutObject?: GraphCacheResolver<
            WithTypename<AffirmTransaction>,
            AffirmTransactionCheckoutObjectArgs,
            Scalars['JSON'] | string
        >
        createdAt?: GraphCacheResolver<
            WithTypename<AffirmTransaction>,
            Record<string, never>,
            Scalars['DateTime'] | string
        >
        id?: GraphCacheResolver<
            WithTypename<AffirmTransaction>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        status?: GraphCacheResolver<
            WithTypename<AffirmTransaction>,
            Record<string, never>,
            WithTypename<TransactionStatus> | string
        >
    }
    AllocationPaymentMethod?: {
        maxAmount?: GraphCacheResolver<
            WithTypename<AllocationPaymentMethod>,
            Record<string, never>,
            WithTypename<Money> | string
        >
        systemCode?: GraphCacheResolver<
            WithTypename<AllocationPaymentMethod>,
            Record<string, never>,
            Scalars['ID'] | string
        >
    }
    AllocationTransaction?: {
        amount?: GraphCacheResolver<
            WithTypename<AllocationTransaction>,
            Record<string, never>,
            WithTypename<Money> | string
        >
        createdAt?: GraphCacheResolver<
            WithTypename<AllocationTransaction>,
            Record<string, never>,
            Scalars['DateTime'] | string
        >
        id?: GraphCacheResolver<
            WithTypename<AllocationTransaction>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        status?: GraphCacheResolver<
            WithTypename<AllocationTransaction>,
            Record<string, never>,
            WithTypename<TransactionStatus> | string
        >
    }
    ArticleGridItem?: {
        description?: GraphCacheResolver<
            WithTypename<ArticleGridItem>,
            Record<string, never>,
            Scalars['String'] | string
        >
        image?: GraphCacheResolver<
            WithTypename<ArticleGridItem>,
            Record<string, never>,
            WithTypename<Image> | string
        >
        link?: GraphCacheResolver<
            WithTypename<ArticleGridItem>,
            Record<string, never>,
            WithTypename<Link> | string
        >
        title?: GraphCacheResolver<
            WithTypename<ArticleGridItem>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    ArticlePreview?: {
        image?: GraphCacheResolver<
            WithTypename<ArticlePreview>,
            Record<string, never>,
            WithTypename<Image> | string
        >
        link?: GraphCacheResolver<
            WithTypename<ArticlePreview>,
            Record<string, never>,
            WithTypename<Link> | string
        >
        subtitle?: GraphCacheResolver<
            WithTypename<ArticlePreview>,
            Record<string, never>,
            Scalars['String'] | string
        >
        title?: GraphCacheResolver<
            WithTypename<ArticlePreview>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    Asset?: {
        id?: GraphCacheResolver<
            WithTypename<Asset>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        mimeType?: GraphCacheResolver<
            WithTypename<Asset>,
            Record<string, never>,
            Scalars['String'] | string
        >
        size?: GraphCacheResolver<
            WithTypename<Asset>,
            AssetSizeArgs,
            WithTypename<MonolithImageSize> | string
        >
        sources?: GraphCacheResolver<
            WithTypename<Asset>,
            Record<string, never>,
            Array<WithTypename<ImageSrc> | string>
        >
        url?: GraphCacheResolver<
            WithTypename<Asset>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    Author?: {
        id?: GraphCacheResolver<
            WithTypename<Author>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        image?: GraphCacheResolver<
            WithTypename<Author>,
            Record<string, never>,
            WithTypename<Image> | string
        >
        name?: GraphCacheResolver<
            WithTypename<Author>,
            Record<string, never>,
            Scalars['String'] | string
        >
        postAggregation?: GraphCacheResolver<
            WithTypename<Author>,
            AuthorPostAggregationArgs,
            WithTypename<PostsAggregation> | string
        >
        posts?: GraphCacheResolver<
            WithTypename<Author>,
            AuthorPostsArgs,
            Array<WithTypename<Post> | string>
        >
        slug?: GraphCacheResolver<
            WithTypename<Author>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    AuthorsAggregation?: {
        count?: GraphCacheResolver<
            WithTypename<AuthorsAggregation>,
            Record<string, never>,
            Scalars['Int'] | string
        >
    }
    AvatarStackItem?: {
        image?: GraphCacheResolver<
            WithTypename<AvatarStackItem>,
            Record<string, never>,
            WithTypename<Image> | string
        >
    }
    AvataxAddressInvalidError?: {
        message?: GraphCacheResolver<
            WithTypename<AvataxAddressInvalidError>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    BankPaymentMethod?: {
        systemCode?: GraphCacheResolver<
            WithTypename<BankPaymentMethod>,
            Record<string, never>,
            Scalars['ID'] | string
        >
    }
    BankTransaction?: {
        amount?: GraphCacheResolver<
            WithTypename<BankTransaction>,
            Record<string, never>,
            WithTypename<Money> | string
        >
        createdAt?: GraphCacheResolver<
            WithTypename<BankTransaction>,
            Record<string, never>,
            Scalars['DateTime'] | string
        >
        id?: GraphCacheResolver<
            WithTypename<BankTransaction>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        status?: GraphCacheResolver<
            WithTypename<BankTransaction>,
            Record<string, never>,
            WithTypename<TransactionStatus> | string
        >
    }
    Banner1?: {
        backgroundColor?: GraphCacheResolver<
            WithTypename<Banner1>,
            Record<string, never>,
            Color | string
        >
        backgroundImage?: GraphCacheResolver<
            WithTypename<Banner1>,
            Record<string, never>,
            WithTypename<Image> | string
        >
        button?: GraphCacheResolver<
            WithTypename<Banner1>,
            Record<string, never>,
            WithTypename<ComponentButton> | string
        >
        preTitle?: GraphCacheResolver<
            WithTypename<Banner1>,
            Record<string, never>,
            Scalars['String'] | string
        >
        text?: GraphCacheResolver<
            WithTypename<Banner1>,
            Record<string, never>,
            Scalars['String'] | string
        >
        title?: GraphCacheResolver<
            WithTypename<Banner1>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    Banner2?: {
        backgroundColor?: GraphCacheResolver<
            WithTypename<Banner2>,
            Record<string, never>,
            Color | string
        >
        button?: GraphCacheResolver<
            WithTypename<Banner2>,
            Record<string, never>,
            WithTypename<ComponentButton> | string
        >
        image?: GraphCacheResolver<
            WithTypename<Banner2>,
            Record<string, never>,
            WithTypename<Image> | string
        >
        preTitle?: GraphCacheResolver<
            WithTypename<Banner2>,
            Record<string, never>,
            Scalars['String'] | string
        >
        text?: GraphCacheResolver<
            WithTypename<Banner2>,
            Record<string, never>,
            Scalars['String'] | string
        >
        title?: GraphCacheResolver<
            WithTypename<Banner2>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    Block?: {
        anchor?: GraphCacheResolver<
            WithTypename<Block>,
            Record<string, never>,
            WithTypename<BlockAnchor> | string
        >
        backgroundColor?: GraphCacheResolver<
            WithTypename<Block>,
            Record<string, never>,
            Color | string
        >
        backgroundOverflow?: GraphCacheResolver<
            WithTypename<Block>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        collapsibleTitle?: GraphCacheResolver<
            WithTypename<Block>,
            Record<string, never>,
            Scalars['String'] | string
        >
        components?: GraphCacheResolver<
            WithTypename<Block>,
            Record<string, never>,
            Array<WithTypename<Component> | string>
        >
        display?: GraphCacheResolver<
            WithTypename<Block>,
            Record<string, never>,
            Display | string
        >
        isCollapsible?: GraphCacheResolver<
            WithTypename<Block>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        isOpenByDefault?: GraphCacheResolver<
            WithTypename<Block>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        verticalSpacing?: GraphCacheResolver<
            WithTypename<Block>,
            Record<string, never>,
            VerticalSpacing | string
        >
        width?: GraphCacheResolver<
            WithTypename<Block>,
            Record<string, never>,
            Width | string
        >
    }
    BlockAnchor?: {
        slug?: GraphCacheResolver<
            WithTypename<BlockAnchor>,
            Record<string, never>,
            Scalars['String'] | string
        >
        title?: GraphCacheResolver<
            WithTypename<BlockAnchor>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    BookingConsultation?: {
        canBeCancelled?: GraphCacheResolver<
            WithTypename<BookingConsultation>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        consultant?: GraphCacheResolver<
            WithTypename<BookingConsultation>,
            Record<string, never>,
            WithTypename<Consultant> | string
        >
        consultationRoom?: GraphCacheResolver<
            WithTypename<BookingConsultation>,
            Record<string, never>,
            | WithTypename<BookingInPersonConsultationRoom>
            | WithTypename<BookingVirtualConsultationRoom>
            | string
        >
        customer?: GraphCacheResolver<
            WithTypename<BookingConsultation>,
            Record<string, never>,
            WithTypename<Customer> | string
        >
        description?: GraphCacheResolver<
            WithTypename<BookingConsultation>,
            Record<string, never>,
            Scalars['String'] | string
        >
        id?: GraphCacheResolver<
            WithTypename<BookingConsultation>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        isCancelled?: GraphCacheResolver<
            WithTypename<BookingConsultation>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        method?: GraphCacheResolver<
            WithTypename<BookingConsultation>,
            Record<string, never>,
            WithTypename<BookingConsultationMethod> | string
        >
        note?: GraphCacheResolver<
            WithTypename<BookingConsultation>,
            Record<string, never>,
            Scalars['String'] | string
        >
        order?: GraphCacheResolver<
            WithTypename<BookingConsultation>,
            Record<string, never>,
            WithTypename<Order> | string
        >
        purpose?: GraphCacheResolver<
            WithTypename<BookingConsultation>,
            Record<string, never>,
            WithTypename<BookingConsultationPurpose> | string
        >
        salesforceId?: GraphCacheResolver<
            WithTypename<BookingConsultation>,
            Record<string, never>,
            Scalars['String'] | string
        >
        showroom?: GraphCacheResolver<
            WithTypename<BookingConsultation>,
            Record<string, never>,
            WithTypename<Showroom> | string
        >
        startsAt?: GraphCacheResolver<
            WithTypename<BookingConsultation>,
            Record<string, never>,
            Scalars['DateTime'] | string
        >
        state?: GraphCacheResolver<
            WithTypename<BookingConsultation>,
            Record<string, never>,
            BookingConsultationState | string
        >
    }
    BookingConsultationAvailableDate?: {
        consultationAvailableShowrooms?: GraphCacheResolver<
            WithTypename<BookingConsultationAvailableDate>,
            Record<string, never>,
            Array<WithTypename<BookingConsultationAvailableShowroom> | string>
        >
        date?: GraphCacheResolver<
            WithTypename<BookingConsultationAvailableDate>,
            Record<string, never>,
            Scalars['DateTime'] | string
        >
    }
    BookingConsultationAvailableShowroom?: {
        consultationSlots?: GraphCacheResolver<
            WithTypename<BookingConsultationAvailableShowroom>,
            Record<string, never>,
            Array<WithTypename<BookingConsultationSlot> | string>
        >
    }
    BookingConsultationComplexity?: {
        icon?: GraphCacheResolver<
            WithTypename<BookingConsultationComplexity>,
            Record<string, never>,
            WithTypename<Asset> | string
        >
        systemCode?: GraphCacheResolver<
            WithTypename<BookingConsultationComplexity>,
            Record<string, never>,
            BookingConsultationComplexityCode | string
        >
        translation?: GraphCacheResolver<
            WithTypename<BookingConsultationComplexity>,
            BookingConsultationComplexityTranslationArgs,
            WithTypename<BookingConsultationComplexityTranslation> | string
        >
    }
    BookingConsultationComplexityTranslation?: {
        locale?: GraphCacheResolver<
            WithTypename<BookingConsultationComplexityTranslation>,
            Record<string, never>,
            Scalars['Locale'] | string
        >
        name?: GraphCacheResolver<
            WithTypename<BookingConsultationComplexityTranslation>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    BookingConsultationMethod?: {
        icon?: GraphCacheResolver<
            WithTypename<BookingConsultationMethod>,
            Record<string, never>,
            WithTypename<Asset> | string
        >
        id?: GraphCacheResolver<
            WithTypename<BookingConsultationMethod>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        isVirtual?: GraphCacheResolver<
            WithTypename<BookingConsultationMethod>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        name?: GraphCacheResolver<
            WithTypename<BookingConsultationMethod>,
            Record<string, never>,
            Scalars['String'] | string
        >
        systemCode?: GraphCacheResolver<
            WithTypename<BookingConsultationMethod>,
            Record<string, never>,
            BookingConsultationMethodCode | string
        >
        takesRoom?: GraphCacheResolver<
            WithTypename<BookingConsultationMethod>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
    }
    BookingConsultationPurpose?: {
        duration?: GraphCacheResolver<
            WithTypename<BookingConsultationPurpose>,
            Record<string, never>,
            Scalars['Int'] | string
        >
        icon?: GraphCacheResolver<
            WithTypename<BookingConsultationPurpose>,
            Record<string, never>,
            WithTypename<Asset> | string
        >
        id?: GraphCacheResolver<
            WithTypename<BookingConsultationPurpose>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        methods?: GraphCacheResolver<
            WithTypename<BookingConsultationPurpose>,
            Record<string, never>,
            Array<WithTypename<BookingConsultationMethod> | string>
        >
        name?: GraphCacheResolver<
            WithTypename<BookingConsultationPurpose>,
            Record<string, never>,
            Scalars['String'] | string
        >
        requireConsultant?: GraphCacheResolver<
            WithTypename<BookingConsultationPurpose>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        requireOrder?: GraphCacheResolver<
            WithTypename<BookingConsultationPurpose>,
            Record<string, never>,
            WithTypename<BookingConsultationPurposeOrder> | string
        >
        slotLengthInMinutes?: GraphCacheResolver<
            WithTypename<BookingConsultationPurpose>,
            Record<string, never>,
            Scalars['Int'] | string
        >
        systemCode?: GraphCacheResolver<
            WithTypename<BookingConsultationPurpose>,
            Record<string, never>,
            BookingConsultationPurposeCode | string
        >
        takesRoom?: GraphCacheResolver<
            WithTypename<BookingConsultationPurpose>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        type?: GraphCacheResolver<
            WithTypename<BookingConsultationPurpose>,
            Record<string, never>,
            WithTypename<BookingConsultationType> | string
        >
    }
    BookingConsultationPurposeOrder?: {
        orders?: GraphCacheResolver<
            WithTypename<BookingConsultationPurposeOrder>,
            Record<string, never>,
            Array<WithTypename<Order> | string>
        >
        statuses?: GraphCacheResolver<
            WithTypename<BookingConsultationPurposeOrder>,
            Record<string, never>,
            Array<WithTypename<OrderStatus> | string>
        >
    }
    BookingConsultationSlot?: {
        showroom?: GraphCacheResolver<
            WithTypename<BookingConsultationSlot>,
            Record<string, never>,
            WithTypename<Showroom> | string
        >
        startTime?: GraphCacheResolver<
            WithTypename<BookingConsultationSlot>,
            Record<string, never>,
            Scalars['DateTime'] | string
        >
    }
    BookingConsultationSlotsResponse?: {
        slots?: GraphCacheResolver<
            WithTypename<BookingConsultationSlotsResponse>,
            Record<string, never>,
            Array<WithTypename<BookingConsultationSlot> | string>
        >
    }
    BookingConsultationType?: {
        name?: GraphCacheResolver<
            WithTypename<BookingConsultationType>,
            Record<string, never>,
            Scalars['String'] | string
        >
        systemCode?: GraphCacheResolver<
            WithTypename<BookingConsultationType>,
            Record<string, never>,
            BookingConsultationTypeCode | string
        >
    }
    BookingCreateConsultationErrorNoAvailableConsultants?: {
        message?: GraphCacheResolver<
            WithTypename<BookingCreateConsultationErrorNoAvailableConsultants>,
            BookingCreateConsultationErrorNoAvailableConsultantsMessageArgs,
            Scalars['String'] | string
        >
    }
    BookingCreateConsultationSuccessExistingCustomer?: {
        consultation?: GraphCacheResolver<
            WithTypename<BookingCreateConsultationSuccessExistingCustomer>,
            Record<string, never>,
            WithTypename<BookingConsultation> | string
        >
    }
    BookingCreateConsultationSuccessNewCustomer?: {
        consultation?: GraphCacheResolver<
            WithTypename<BookingCreateConsultationSuccessNewCustomer>,
            Record<string, never>,
            WithTypename<BookingConsultation> | string
        >
        customerRegistrationResponse?: GraphCacheResolver<
            WithTypename<BookingCreateConsultationSuccessNewCustomer>,
            Record<string, never>,
            WithTypename<CustomerRegistrationResponse> | string
        >
    }
    BookingInPersonConsultationRoom?: {
        id?: GraphCacheResolver<
            WithTypename<BookingInPersonConsultationRoom>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        kind?: GraphCacheResolver<
            WithTypename<BookingInPersonConsultationRoom>,
            Record<string, never>,
            BookingConsultationRoomKind | string
        >
        name?: GraphCacheResolver<
            WithTypename<BookingInPersonConsultationRoom>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    BookingVirtualConsultationRoom?: {
        id?: GraphCacheResolver<
            WithTypename<BookingVirtualConsultationRoom>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        kind?: GraphCacheResolver<
            WithTypename<BookingVirtualConsultationRoom>,
            Record<string, never>,
            BookingConsultationRoomKind | string
        >
        name?: GraphCacheResolver<
            WithTypename<BookingVirtualConsultationRoom>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    ButtonEventTracking?: {
        action?: GraphCacheResolver<
            WithTypename<ButtonEventTracking>,
            Record<string, never>,
            Scalars['String'] | string
        >
        category?: GraphCacheResolver<
            WithTypename<ButtonEventTracking>,
            Record<string, never>,
            Scalars['String'] | string
        >
        event?: GraphCacheResolver<
            WithTypename<ButtonEventTracking>,
            Record<string, never>,
            Scalars['String'] | string
        >
        label?: GraphCacheResolver<
            WithTypename<ButtonEventTracking>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    ButtonIcon?: {
        icon?: GraphCacheResolver<
            WithTypename<ButtonIcon>,
            Record<string, never>,
            Icon | string
        >
        position?: GraphCacheResolver<
            WithTypename<ButtonIcon>,
            Record<string, never>,
            HorizontalAlignment | string
        >
    }
    ButtonStyle?: {
        bottomSpacing?: GraphCacheResolver<
            WithTypename<ButtonStyle>,
            Record<string, never>,
            VerticalSpacing | string
        >
        color?: GraphCacheResolver<
            WithTypename<ButtonStyle>,
            Record<string, never>,
            Color | string
        >
        linkSize?: GraphCacheResolver<
            WithTypename<ButtonStyle>,
            Record<string, never>,
            Scalars['Int'] | string
        >
        size?: GraphCacheResolver<
            WithTypename<ButtonStyle>,
            Record<string, never>,
            ButtonSize | string
        >
        topSpacing?: GraphCacheResolver<
            WithTypename<ButtonStyle>,
            Record<string, never>,
            VerticalSpacing | string
        >
        type?: GraphCacheResolver<
            WithTypename<ButtonStyle>,
            Record<string, never>,
            ButtonType | string
        >
        width?: GraphCacheResolver<
            WithTypename<ButtonStyle>,
            Record<string, never>,
            ButtonWidth | string
        >
    }
    CardCarouselCard?: {
        backgroundColor?: GraphCacheResolver<
            WithTypename<CardCarouselCard>,
            Record<string, never>,
            Color | string
        >
        description?: GraphCacheResolver<
            WithTypename<CardCarouselCard>,
            Record<string, never>,
            Scalars['String'] | string
        >
        image?: GraphCacheResolver<
            WithTypename<CardCarouselCard>,
            Record<string, never>,
            WithTypename<Image> | string
        >
        link?: GraphCacheResolver<
            WithTypename<CardCarouselCard>,
            Record<string, never>,
            WithTypename<Link> | string
        >
        title?: GraphCacheResolver<
            WithTypename<CardCarouselCard>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    CarouselCustomProduct?: {
        description?: GraphCacheResolver<
            WithTypename<CarouselCustomProduct>,
            Record<string, never>,
            Scalars['String'] | string
        >
        image?: GraphCacheResolver<
            WithTypename<CarouselCustomProduct>,
            Record<string, never>,
            WithTypename<Image> | string
        >
        link?: GraphCacheResolver<
            WithTypename<CarouselCustomProduct>,
            Record<string, never>,
            WithTypename<Link> | string
        >
        title?: GraphCacheResolver<
            WithTypename<CarouselCustomProduct>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    CatalogueAggregate?: {
        count?: GraphCacheResolver<
            WithTypename<CatalogueAggregate>,
            Record<string, never>,
            Scalars['Int'] | string
        >
    }
    CatalogueBandType?: {
        id?: GraphCacheResolver<
            WithTypename<CatalogueBandType>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        translation?: GraphCacheResolver<
            WithTypename<CatalogueBandType>,
            CatalogueBandTypeTranslationArgs,
            WithTypename<CatalogueBandTypeTranslation> | string
        >
    }
    CatalogueBandTypeTranslation?: {
        name?: GraphCacheResolver<
            WithTypename<CatalogueBandTypeTranslation>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    CatalogueDesignStudioCheckoutEngagementRingAddedToDesignStudio?: {
        product?: GraphCacheResolver<
            WithTypename<CatalogueDesignStudioCheckoutEngagementRingAddedToDesignStudio>,
            Record<string, never>,
            WithTypename<DesignStudioProductEngagementRing> | string
        >
    }
    CatalogueDesignStudioCheckoutEngagementRingAddedToDesignStudioAndCart?: {
        checkoutProduct?: GraphCacheResolver<
            WithTypename<CatalogueDesignStudioCheckoutEngagementRingAddedToDesignStudioAndCart>,
            Record<string, never>,
            WithTypename<OrderProduct> | string
        >
        designStudioProduct?: GraphCacheResolver<
            WithTypename<CatalogueDesignStudioCheckoutEngagementRingAddedToDesignStudioAndCart>,
            Record<string, never>,
            WithTypename<DesignStudioProductEngagementRing> | string
        >
        order?: GraphCacheResolver<
            WithTypename<CatalogueDesignStudioCheckoutEngagementRingAddedToDesignStudioAndCart>,
            Record<string, never>,
            WithTypename<Order> | string
        >
    }
    CatalogueDesignStudioCheckoutJewellerySuccessExistingCustomer?: {
        order?: GraphCacheResolver<
            WithTypename<CatalogueDesignStudioCheckoutJewellerySuccessExistingCustomer>,
            Record<string, never>,
            WithTypename<Order> | string
        >
        product?: GraphCacheResolver<
            WithTypename<CatalogueDesignStudioCheckoutJewellerySuccessExistingCustomer>,
            Record<string, never>,
            WithTypename<OrderProduct> | string
        >
    }
    CatalogueDesignStudioCheckoutJewellerySuccessNewCustomer?: {
        customer?: GraphCacheResolver<
            WithTypename<CatalogueDesignStudioCheckoutJewellerySuccessNewCustomer>,
            Record<string, never>,
            WithTypename<CustomerRegistrationResponse> | string
        >
        order?: GraphCacheResolver<
            WithTypename<CatalogueDesignStudioCheckoutJewellerySuccessNewCustomer>,
            Record<string, never>,
            WithTypename<Order> | string
        >
        product?: GraphCacheResolver<
            WithTypename<CatalogueDesignStudioCheckoutJewellerySuccessNewCustomer>,
            Record<string, never>,
            WithTypename<OrderProduct> | string
        >
    }
    CatalogueDesignStudioCheckoutWeddingRingSuccessExistingCustomer?: {
        order?: GraphCacheResolver<
            WithTypename<CatalogueDesignStudioCheckoutWeddingRingSuccessExistingCustomer>,
            Record<string, never>,
            WithTypename<Order> | string
        >
        product?: GraphCacheResolver<
            WithTypename<CatalogueDesignStudioCheckoutWeddingRingSuccessExistingCustomer>,
            Record<string, never>,
            WithTypename<OrderProduct> | string
        >
    }
    CatalogueDesignStudioCheckoutWeddingRingSuccessNewCustomer?: {
        customer?: GraphCacheResolver<
            WithTypename<CatalogueDesignStudioCheckoutWeddingRingSuccessNewCustomer>,
            Record<string, never>,
            WithTypename<CustomerRegistrationResponse> | string
        >
        order?: GraphCacheResolver<
            WithTypename<CatalogueDesignStudioCheckoutWeddingRingSuccessNewCustomer>,
            Record<string, never>,
            WithTypename<Order> | string
        >
        product?: GraphCacheResolver<
            WithTypename<CatalogueDesignStudioCheckoutWeddingRingSuccessNewCustomer>,
            Record<string, never>,
            WithTypename<OrderProduct> | string
        >
    }
    CatalogueEngagementRing?: {
        bandThickness?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            Record<string, never>,
            Scalars['Float'] | string
        >
        bandWidth?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            Record<string, never>,
            Scalars['Float'] | string
        >
        catalogueCode?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            Record<string, never>,
            Scalars['CatalogueCode'] | string
        >
        centreStoneConstraints?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            Record<string, never>,
            WithTypename<CatalogueEngagementRingCentreStoneConstraints> | string
        >
        customTitleTag?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        deliveryDays?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            CatalogueEngagementRingDeliveryDaysArgs,
            Scalars['Int'] | string
        >
        designFeatures?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            Record<string, never>,
            Array<WithTypename<EngagementRingDesignFeatureLabel> | string>
        >
        designStyle?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            Record<string, never>,
            WithTypename<EngagementRingDesignStyleLabel> | string
        >
        financeOptionsAffirm?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            CatalogueEngagementRingFinanceOptionsAffirmArgs,
            WithTypename<AffirmFinanceOption> | string
        >
        financeOptionsKlarna?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            CatalogueEngagementRingFinanceOptionsKlarnaArgs,
            WithTypename<KlarnaFinanceOption> | string
        >
        firstAvailableDeliveryDate?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            CatalogueEngagementRingFirstAvailableDeliveryDateArgs,
            WithTypename<DeliveryDate> | string
        >
        images?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            CatalogueEngagementRingImagesArgs,
            Array<WithTypename<CatalogueImage> | string>
        >
        images360?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            Record<string, never>,
            Array<WithTypename<GenericImage> | string>
        >
        isAvailableForRingBuilder?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        isResizeable?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        isReturnable?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        mainImage?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            Record<string, never>,
            WithTypename<GenericImage> | string
        >
        meleeItems?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            Record<string, never>,
            Array<WithTypename<CatalogueMelee> | string>
        >
        primaryMetal?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            Record<string, never>,
            WithTypename<Metal> | string
        >
        productName?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        relatedProducts?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            Record<string, never>,
            Array<WithTypename<CatalogueEngagementRing> | string>
        >
        reviews?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            Record<string, never>,
            Array<WithTypename<Review> | string>
        >
        ringBuilderProducts?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            CatalogueEngagementRingRingBuilderProductsArgs,
            Array<WithTypename<RingBuilder> | string>
        >
        ringStyles?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            Record<string, never>,
            Array<WithTypename<EngagementRingStyleLabel> | string>
        >
        salePrice?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            CatalogueEngagementRingSalePriceArgs,
            WithTypename<SalePrice> | string
        >
        segmentName?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        signatureStone?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            Record<string, never>,
            WithTypename<Melee> | string
        >
        signatureStones?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            Record<string, never>,
            Array<
                WithTypename<CatalogueEngagementRingAndSignatureStone> | string
            >
        >
        sizes?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            CatalogueEngagementRingSizesArgs,
            Array<WithTypename<RingSizeOrRecommendedRingSize> | string>
        >
        slug?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        suffix?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        suffixSlug?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        translation?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            CatalogueEngagementRingTranslationArgs,
            WithTypename<CatalogueEngagementRingTranslation> | string
        >
        updatedAt?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            Record<string, never>,
            Scalars['DateTime'] | string
        >
        variations?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            Record<string, never>,
            Array<WithTypename<CatalogueEngagementRing> | string>
        >
        variationsByCentreStoneShape?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            Record<string, never>,
            Array<WithTypename<CatalogueEngagementRing> | string>
        >
        variationsByPrimaryMetal?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            Record<string, never>,
            Array<WithTypename<CatalogueEngagementRing> | string>
        >
        video?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRing>,
            Record<string, never>,
            WithTypename<CatalogueVideo> | string
        >
    }
    CatalogueEngagementRingAndSignatureStone?: {
        salePrice?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRingAndSignatureStone>,
            CatalogueEngagementRingAndSignatureStoneSalePriceArgs,
            WithTypename<SalePrice> | string
        >
        signatureStone?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRingAndSignatureStone>,
            Record<string, never>,
            WithTypename<CatalogueEngagementRingSignatureStone> | string
        >
    }
    CatalogueEngagementRingCentreStoneConstraints?: {
        shape?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRingCentreStoneConstraints>,
            Record<string, never>,
            WithTypename<StoneShape> | string
        >
        weight?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRingCentreStoneConstraints>,
            Record<string, never>,
            | WithTypename<CatalogueEngagementRingCentreStoneWeightConstraint>
            | string
        >
    }
    CatalogueEngagementRingCentreStoneWeightConstraint?: {
        max?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRingCentreStoneWeightConstraint>,
            Record<string, never>,
            Scalars['Decimal'] | string
        >
        min?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRingCentreStoneWeightConstraint>,
            Record<string, never>,
            Scalars['Decimal'] | string
        >
    }
    CatalogueEngagementRingFilters?: {
        centreStoneShapes?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRingFilters>,
            Record<string, never>,
            Array<WithTypename<CatalogueFilterShapeItem> | string>
        >
        designFeatures?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRingFilters>,
            Record<string, never>,
            Array<
                | WithTypename<CatalogueFilterEngagementRingDesignFeatureItem>
                | string
            >
        >
        designStyles?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRingFilters>,
            Record<string, never>,
            Array<
                | WithTypename<CatalogueFilterEngagementRingDesingStyleItem>
                | string
            >
        >
        price?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRingFilters>,
            CatalogueEngagementRingFiltersPriceArgs,
            WithTypename<CataloguePriceRangeFilter> | string
        >
        primaryMetals?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRingFilters>,
            Record<string, never>,
            Array<WithTypename<CatalogueFilterMetalItem> | string>
        >
        ringStyles?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRingFilters>,
            Record<string, never>,
            Array<
                WithTypename<CatalogueFilterEngagementRingStylesItem> | string
            >
        >
    }
    CatalogueEngagementRingFiltersVariation?: {
        centreStoneShape?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRingFiltersVariation>,
            Record<string, never>,
            StoneShapeCode | string
        >
        designFeature?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRingFiltersVariation>,
            Record<string, never>,
            EngagementRingDesignFeatureLabelCode | string
        >
        designStyle?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRingFiltersVariation>,
            Record<string, never>,
            EngagementRingDesignStyleLabelCode | string
        >
        primaryMetal?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRingFiltersVariation>,
            Record<string, never>,
            MetalCode | string
        >
        ringStyle?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRingFiltersVariation>,
            Record<string, never>,
            EngagementRingStyleLabelCode | string
        >
    }
    CatalogueEngagementRingSignatureStone?: {
        color?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRingSignatureStone>,
            Record<string, never>,
            WithTypename<StoneColor> | string
        >
        crystal?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRingSignatureStone>,
            Record<string, never>,
            WithTypename<StoneCrystal> | string
        >
        id?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRingSignatureStone>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        image?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRingSignatureStone>,
            Record<string, never>,
            Scalars['Uri'] | string
        >
        isDefault?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRingSignatureStone>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        price?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRingSignatureStone>,
            CatalogueEngagementRingSignatureStonePriceArgs,
            WithTypename<Money> | string
        >
        segmentName?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRingSignatureStone>,
            Record<string, never>,
            Scalars['String'] | string
        >
        width?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRingSignatureStone>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    CatalogueEngagementRingTranslation?: {
        description?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRingTranslation>,
            Record<string, never>,
            Scalars['String'] | string
        >
        locale?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRingTranslation>,
            Record<string, never>,
            Scalars['Locale'] | string
        >
        seoText?: GraphCacheResolver<
            WithTypename<CatalogueEngagementRingTranslation>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    CatalogueFilterEngagementRingDesignFeatureItem?: {
        label?: GraphCacheResolver<
            WithTypename<CatalogueFilterEngagementRingDesignFeatureItem>,
            Record<string, never>,
            WithTypename<EngagementRingDesignFeatureLabel> | string
        >
        totalResults?: GraphCacheResolver<
            WithTypename<CatalogueFilterEngagementRingDesignFeatureItem>,
            Record<string, never>,
            Scalars['Int'] | string
        >
    }
    CatalogueFilterEngagementRingDesingStyleItem?: {
        label?: GraphCacheResolver<
            WithTypename<CatalogueFilterEngagementRingDesingStyleItem>,
            Record<string, never>,
            WithTypename<EngagementRingDesignStyleLabel> | string
        >
        totalResults?: GraphCacheResolver<
            WithTypename<CatalogueFilterEngagementRingDesingStyleItem>,
            Record<string, never>,
            Scalars['Int'] | string
        >
    }
    CatalogueFilterEngagementRingStylesItem?: {
        label?: GraphCacheResolver<
            WithTypename<CatalogueFilterEngagementRingStylesItem>,
            Record<string, never>,
            WithTypename<EngagementRingStyleLabel> | string
        >
        totalResults?: GraphCacheResolver<
            WithTypename<CatalogueFilterEngagementRingStylesItem>,
            Record<string, never>,
            Scalars['Int'] | string
        >
    }
    CatalogueFilterJewelleryBraceletProductStyleLabel?: {
        label?: GraphCacheResolver<
            WithTypename<CatalogueFilterJewelleryBraceletProductStyleLabel>,
            Record<string, never>,
            WithTypename<JewelleryBraceletProductStyleLabel> | string
        >
        totalResults?: GraphCacheResolver<
            WithTypename<CatalogueFilterJewelleryBraceletProductStyleLabel>,
            Record<string, never>,
            Scalars['Int'] | string
        >
    }
    CatalogueFilterJewelleryDesignFeatureLabel?: {
        label?: GraphCacheResolver<
            WithTypename<CatalogueFilterJewelleryDesignFeatureLabel>,
            Record<string, never>,
            WithTypename<JewelleryDesignFeatureLabel> | string
        >
        totalResults?: GraphCacheResolver<
            WithTypename<CatalogueFilterJewelleryDesignFeatureLabel>,
            Record<string, never>,
            Scalars['Int'] | string
        >
    }
    CatalogueFilterJewelleryDesignStyleLabel?: {
        label?: GraphCacheResolver<
            WithTypename<CatalogueFilterJewelleryDesignStyleLabel>,
            Record<string, never>,
            WithTypename<JewelleryDesignStyleLabel> | string
        >
        totalResults?: GraphCacheResolver<
            WithTypename<CatalogueFilterJewelleryDesignStyleLabel>,
            Record<string, never>,
            Scalars['Int'] | string
        >
    }
    CatalogueFilterJewelleryEarringsProductStyleLabel?: {
        label?: GraphCacheResolver<
            WithTypename<CatalogueFilterJewelleryEarringsProductStyleLabel>,
            Record<string, never>,
            WithTypename<JewelleryEarringsProductStyleLabel> | string
        >
        totalResults?: GraphCacheResolver<
            WithTypename<CatalogueFilterJewelleryEarringsProductStyleLabel>,
            Record<string, never>,
            Scalars['Int'] | string
        >
    }
    CatalogueFilterJewelleryGemstoneLabel?: {
        label?: GraphCacheResolver<
            WithTypename<CatalogueFilterJewelleryGemstoneLabel>,
            Record<string, never>,
            WithTypename<JewelleryGemstoneLabel> | string
        >
        totalResults?: GraphCacheResolver<
            WithTypename<CatalogueFilterJewelleryGemstoneLabel>,
            Record<string, never>,
            Scalars['Int'] | string
        >
    }
    CatalogueFilterJewelleryNecklaceProductStyleLabel?: {
        label?: GraphCacheResolver<
            WithTypename<CatalogueFilterJewelleryNecklaceProductStyleLabel>,
            Record<string, never>,
            WithTypename<JewelleryNecklaceProductStyleLabel> | string
        >
        totalResults?: GraphCacheResolver<
            WithTypename<CatalogueFilterJewelleryNecklaceProductStyleLabel>,
            Record<string, never>,
            Scalars['Int'] | string
        >
    }
    CatalogueFilterJewelleryRingProductStyleLabel?: {
        label?: GraphCacheResolver<
            WithTypename<CatalogueFilterJewelleryRingProductStyleLabel>,
            Record<string, never>,
            WithTypename<JewelleryRingProductStyleLabel> | string
        >
        totalResults?: GraphCacheResolver<
            WithTypename<CatalogueFilterJewelleryRingProductStyleLabel>,
            Record<string, never>,
            Scalars['Int'] | string
        >
    }
    CatalogueFilterMetalItem?: {
        metal?: GraphCacheResolver<
            WithTypename<CatalogueFilterMetalItem>,
            Record<string, never>,
            WithTypename<Metal> | string
        >
        totalResults?: GraphCacheResolver<
            WithTypename<CatalogueFilterMetalItem>,
            Record<string, never>,
            Scalars['Int'] | string
        >
    }
    CatalogueFilterShapeItem?: {
        shape?: GraphCacheResolver<
            WithTypename<CatalogueFilterShapeItem>,
            Record<string, never>,
            WithTypename<StoneShape> | string
        >
        totalResults?: GraphCacheResolver<
            WithTypename<CatalogueFilterShapeItem>,
            Record<string, never>,
            Scalars['Int'] | string
        >
    }
    CatalogueFilterWeddingRingCategoriesItem?: {
        label?: GraphCacheResolver<
            WithTypename<CatalogueFilterWeddingRingCategoriesItem>,
            Record<string, never>,
            WithTypename<WeddingRingCategoryLabel> | string
        >
        totalResults?: GraphCacheResolver<
            WithTypename<CatalogueFilterWeddingRingCategoriesItem>,
            Record<string, never>,
            Scalars['Int'] | string
        >
    }
    CatalogueFilterWeddingRingStylesItem?: {
        label?: GraphCacheResolver<
            WithTypename<CatalogueFilterWeddingRingStylesItem>,
            Record<string, never>,
            WithTypename<WeddingRingStyleLabel> | string
        >
        totalResults?: GraphCacheResolver<
            WithTypename<CatalogueFilterWeddingRingStylesItem>,
            Record<string, never>,
            Scalars['Int'] | string
        >
    }
    CatalogueImage?: {
        id?: GraphCacheResolver<
            WithTypename<CatalogueImage>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        mimeType?: GraphCacheResolver<
            WithTypename<CatalogueImage>,
            Record<string, never>,
            Scalars['String'] | string
        >
        size?: GraphCacheResolver<
            WithTypename<CatalogueImage>,
            CatalogueImageSizeArgs,
            WithTypename<MonolithImageSize> | string
        >
        sources?: GraphCacheResolver<
            WithTypename<CatalogueImage>,
            Record<string, never>,
            Array<WithTypename<ImageSrc> | string>
        >
        url?: GraphCacheResolver<
            WithTypename<CatalogueImage>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    CatalogueJewelleriesBraceletsFiltersVariation?: {
        designFeature?: GraphCacheResolver<
            WithTypename<CatalogueJewelleriesBraceletsFiltersVariation>,
            Record<string, never>,
            JewelleryDesignFeature | string
        >
        designStyle?: GraphCacheResolver<
            WithTypename<CatalogueJewelleriesBraceletsFiltersVariation>,
            Record<string, never>,
            JewelleryDesignStyle | string
        >
        gemstone?: GraphCacheResolver<
            WithTypename<CatalogueJewelleriesBraceletsFiltersVariation>,
            Record<string, never>,
            JewelleryGemstoneCode | string
        >
        primaryMetal?: GraphCacheResolver<
            WithTypename<CatalogueJewelleriesBraceletsFiltersVariation>,
            Record<string, never>,
            MetalCode | string
        >
        productStyle?: GraphCacheResolver<
            WithTypename<CatalogueJewelleriesBraceletsFiltersVariation>,
            Record<string, never>,
            JewelleryBraceletProductStyle | string
        >
    }
    CatalogueJewelleriesEarringsFiltersVariation?: {
        designFeature?: GraphCacheResolver<
            WithTypename<CatalogueJewelleriesEarringsFiltersVariation>,
            Record<string, never>,
            JewelleryDesignFeature | string
        >
        designStyle?: GraphCacheResolver<
            WithTypename<CatalogueJewelleriesEarringsFiltersVariation>,
            Record<string, never>,
            JewelleryDesignStyle | string
        >
        gemstone?: GraphCacheResolver<
            WithTypename<CatalogueJewelleriesEarringsFiltersVariation>,
            Record<string, never>,
            JewelleryGemstoneCode | string
        >
        primaryMetal?: GraphCacheResolver<
            WithTypename<CatalogueJewelleriesEarringsFiltersVariation>,
            Record<string, never>,
            MetalCode | string
        >
        productStyle?: GraphCacheResolver<
            WithTypename<CatalogueJewelleriesEarringsFiltersVariation>,
            Record<string, never>,
            JewelleryEarringsProductStyle | string
        >
    }
    CatalogueJewelleriesFilters?: {
        designFeatures?: GraphCacheResolver<
            WithTypename<CatalogueJewelleriesFilters>,
            Record<string, never>,
            Array<
                | WithTypename<CatalogueFilterJewelleryDesignFeatureLabel>
                | string
            >
        >
        designStyles?: GraphCacheResolver<
            WithTypename<CatalogueJewelleriesFilters>,
            Record<string, never>,
            Array<
                WithTypename<CatalogueFilterJewelleryDesignStyleLabel> | string
            >
        >
        gemstones?: GraphCacheResolver<
            WithTypename<CatalogueJewelleriesFilters>,
            Record<string, never>,
            Array<WithTypename<CatalogueFilterJewelleryGemstoneLabel> | string>
        >
        price?: GraphCacheResolver<
            WithTypename<CatalogueJewelleriesFilters>,
            CatalogueJewelleriesFiltersPriceArgs,
            WithTypename<CataloguePriceRangeFilter> | string
        >
        primaryMetals?: GraphCacheResolver<
            WithTypename<CatalogueJewelleriesFilters>,
            Record<string, never>,
            Array<WithTypename<CatalogueFilterMetalItem> | string>
        >
    }
    CatalogueJewelleriesFiltersVariation?: {
        designFeature?: GraphCacheResolver<
            WithTypename<CatalogueJewelleriesFiltersVariation>,
            Record<string, never>,
            JewelleryDesignFeature | string
        >
        designStyle?: GraphCacheResolver<
            WithTypename<CatalogueJewelleriesFiltersVariation>,
            Record<string, never>,
            JewelleryDesignStyle | string
        >
        gemstone?: GraphCacheResolver<
            WithTypename<CatalogueJewelleriesFiltersVariation>,
            Record<string, never>,
            JewelleryGemstoneCode | string
        >
        primaryMetal?: GraphCacheResolver<
            WithTypename<CatalogueJewelleriesFiltersVariation>,
            Record<string, never>,
            MetalCode | string
        >
    }
    CatalogueJewelleriesNecklacesFiltersVariation?: {
        designFeature?: GraphCacheResolver<
            WithTypename<CatalogueJewelleriesNecklacesFiltersVariation>,
            Record<string, never>,
            JewelleryDesignFeature | string
        >
        designStyle?: GraphCacheResolver<
            WithTypename<CatalogueJewelleriesNecklacesFiltersVariation>,
            Record<string, never>,
            JewelleryDesignStyle | string
        >
        gemstone?: GraphCacheResolver<
            WithTypename<CatalogueJewelleriesNecklacesFiltersVariation>,
            Record<string, never>,
            JewelleryGemstoneCode | string
        >
        primaryMetal?: GraphCacheResolver<
            WithTypename<CatalogueJewelleriesNecklacesFiltersVariation>,
            Record<string, never>,
            MetalCode | string
        >
        productStyle?: GraphCacheResolver<
            WithTypename<CatalogueJewelleriesNecklacesFiltersVariation>,
            Record<string, never>,
            JewelleryNecklaceProductStyle | string
        >
    }
    CatalogueJewelleriesRingsFiltersVariation?: {
        designFeature?: GraphCacheResolver<
            WithTypename<CatalogueJewelleriesRingsFiltersVariation>,
            Record<string, never>,
            JewelleryDesignFeature | string
        >
        designStyle?: GraphCacheResolver<
            WithTypename<CatalogueJewelleriesRingsFiltersVariation>,
            Record<string, never>,
            JewelleryDesignStyle | string
        >
        gemstone?: GraphCacheResolver<
            WithTypename<CatalogueJewelleriesRingsFiltersVariation>,
            Record<string, never>,
            JewelleryGemstoneCode | string
        >
        primaryMetal?: GraphCacheResolver<
            WithTypename<CatalogueJewelleriesRingsFiltersVariation>,
            Record<string, never>,
            MetalCode | string
        >
        productStyle?: GraphCacheResolver<
            WithTypename<CatalogueJewelleriesRingsFiltersVariation>,
            Record<string, never>,
            JewelleryRingProductStyle | string
        >
    }
    CatalogueJewelleryBracelet?: {
        catalogueCode?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBracelet>,
            Record<string, never>,
            Scalars['CatalogueCode'] | string
        >
        customTitleTag?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBracelet>,
            Record<string, never>,
            Scalars['String'] | string
        >
        deliveryDays?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBracelet>,
            CatalogueJewelleryBraceletDeliveryDaysArgs,
            Scalars['Int'] | string
        >
        designFeatures?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBracelet>,
            Record<string, never>,
            Array<WithTypename<JewelleryDesignFeatureLabel> | string>
        >
        designStyles?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBracelet>,
            Record<string, never>,
            Array<WithTypename<JewelleryDesignStyleLabel> | string>
        >
        engravingDisabled?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBracelet>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        financeOptionsAffirm?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBracelet>,
            CatalogueJewelleryBraceletFinanceOptionsAffirmArgs,
            WithTypename<AffirmFinanceOption> | string
        >
        financeOptionsKlarna?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBracelet>,
            CatalogueJewelleryBraceletFinanceOptionsKlarnaArgs,
            WithTypename<KlarnaFinanceOption> | string
        >
        firstAvailableDeliveryDate?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBracelet>,
            CatalogueJewelleryBraceletFirstAvailableDeliveryDateArgs,
            WithTypename<DeliveryDate> | string
        >
        gemstones?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBracelet>,
            Record<string, never>,
            Array<WithTypename<JewelleryGemstoneLabel> | string>
        >
        images?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBracelet>,
            CatalogueJewelleryBraceletImagesArgs,
            Array<WithTypename<CatalogueImage> | string>
        >
        images360?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBracelet>,
            Record<string, never>,
            Array<WithTypename<GenericImage> | string>
        >
        isReturnable?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBracelet>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        mainImage?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBracelet>,
            Record<string, never>,
            WithTypename<GenericImage> | string
        >
        primaryMetal?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBracelet>,
            Record<string, never>,
            WithTypename<Metal> | string
        >
        productName?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBracelet>,
            Record<string, never>,
            Scalars['String'] | string
        >
        productStyles?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBracelet>,
            Record<string, never>,
            Array<WithTypename<JewelleryBraceletProductStyleLabel> | string>
        >
        relatedProducts?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBracelet>,
            Record<string, never>,
            Array<WithTypename<CatalogueJewelleryBracelet> | string>
        >
        reviews?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBracelet>,
            Record<string, never>,
            Array<WithTypename<Review> | string>
        >
        salePrice?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBracelet>,
            CatalogueJewelleryBraceletSalePriceArgs,
            WithTypename<SalePrice> | string
        >
        segmentName?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBracelet>,
            Record<string, never>,
            Scalars['String'] | string
        >
        signatureStone?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBracelet>,
            Record<string, never>,
            WithTypename<Melee> | string
        >
        sku?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBracelet>,
            Record<string, never>,
            Scalars['String'] | string
        >
        slug?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBracelet>,
            Record<string, never>,
            Scalars['String'] | string
        >
        suffix?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBracelet>,
            Record<string, never>,
            Scalars['String'] | string
        >
        suffixSlug?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBracelet>,
            Record<string, never>,
            Scalars['String'] | string
        >
        translation?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBracelet>,
            CatalogueJewelleryBraceletTranslationArgs,
            WithTypename<CatalogueJewelleryBraceletTranslation> | string
        >
        updatedAt?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBracelet>,
            Record<string, never>,
            Scalars['DateTime'] | string
        >
        variations?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBracelet>,
            Record<string, never>,
            Array<WithTypename<CatalogueJewelleryBracelet> | string>
        >
        video?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBracelet>,
            Record<string, never>,
            WithTypename<CatalogueVideo> | string
        >
    }
    CatalogueJewelleryBraceletTranslation?: {
        description?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBraceletTranslation>,
            Record<string, never>,
            Scalars['String'] | string
        >
        seoText?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBraceletTranslation>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    CatalogueJewelleryBraceletsFilters?: {
        designFeatures?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBraceletsFilters>,
            Record<string, never>,
            Array<
                | WithTypename<CatalogueFilterJewelleryDesignFeatureLabel>
                | string
            >
        >
        designStyles?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBraceletsFilters>,
            Record<string, never>,
            Array<
                WithTypename<CatalogueFilterJewelleryDesignStyleLabel> | string
            >
        >
        gemstones?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBraceletsFilters>,
            Record<string, never>,
            Array<WithTypename<CatalogueFilterJewelleryGemstoneLabel> | string>
        >
        price?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBraceletsFilters>,
            CatalogueJewelleryBraceletsFiltersPriceArgs,
            WithTypename<CataloguePriceRangeFilter> | string
        >
        primaryMetals?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBraceletsFilters>,
            Record<string, never>,
            Array<WithTypename<CatalogueFilterMetalItem> | string>
        >
        productStyles?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryBraceletsFilters>,
            Record<string, never>,
            Array<
                | WithTypename<CatalogueFilterJewelleryBraceletProductStyleLabel>
                | string
            >
        >
    }
    CatalogueJewelleryEarrings?: {
        catalogueCode?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarrings>,
            Record<string, never>,
            Scalars['CatalogueCode'] | string
        >
        customTitleTag?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarrings>,
            Record<string, never>,
            Scalars['String'] | string
        >
        deliveryDays?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarrings>,
            CatalogueJewelleryEarringsDeliveryDaysArgs,
            Scalars['Int'] | string
        >
        designFeatures?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarrings>,
            Record<string, never>,
            Array<WithTypename<JewelleryDesignFeatureLabel> | string>
        >
        designStyles?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarrings>,
            Record<string, never>,
            Array<WithTypename<JewelleryDesignStyleLabel> | string>
        >
        engravingDisabled?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarrings>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        financeOptionsAffirm?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarrings>,
            CatalogueJewelleryEarringsFinanceOptionsAffirmArgs,
            WithTypename<AffirmFinanceOption> | string
        >
        financeOptionsKlarna?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarrings>,
            CatalogueJewelleryEarringsFinanceOptionsKlarnaArgs,
            WithTypename<KlarnaFinanceOption> | string
        >
        firstAvailableDeliveryDate?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarrings>,
            CatalogueJewelleryEarringsFirstAvailableDeliveryDateArgs,
            WithTypename<DeliveryDate> | string
        >
        gemstones?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarrings>,
            Record<string, never>,
            Array<WithTypename<JewelleryGemstoneLabel> | string>
        >
        images?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarrings>,
            CatalogueJewelleryEarringsImagesArgs,
            Array<WithTypename<CatalogueImage> | string>
        >
        images360?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarrings>,
            Record<string, never>,
            Array<WithTypename<GenericImage> | string>
        >
        isReturnable?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarrings>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        mainImage?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarrings>,
            Record<string, never>,
            WithTypename<GenericImage> | string
        >
        primaryMetal?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarrings>,
            Record<string, never>,
            WithTypename<Metal> | string
        >
        productName?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarrings>,
            Record<string, never>,
            Scalars['String'] | string
        >
        productStyles?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarrings>,
            Record<string, never>,
            Array<WithTypename<JewelleryEarringsProductStyleLabel> | string>
        >
        relatedProducts?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarrings>,
            Record<string, never>,
            Array<WithTypename<CatalogueJewelleryEarrings> | string>
        >
        reviews?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarrings>,
            Record<string, never>,
            Array<WithTypename<Review> | string>
        >
        salePrice?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarrings>,
            CatalogueJewelleryEarringsSalePriceArgs,
            WithTypename<SalePrice> | string
        >
        segmentName?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarrings>,
            Record<string, never>,
            Scalars['String'] | string
        >
        signatureStone?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarrings>,
            Record<string, never>,
            WithTypename<Melee> | string
        >
        sku?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarrings>,
            Record<string, never>,
            Scalars['String'] | string
        >
        slug?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarrings>,
            Record<string, never>,
            Scalars['String'] | string
        >
        suffix?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarrings>,
            Record<string, never>,
            Scalars['String'] | string
        >
        suffixSlug?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarrings>,
            Record<string, never>,
            Scalars['String'] | string
        >
        translation?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarrings>,
            CatalogueJewelleryEarringsTranslationArgs,
            WithTypename<CatalogueJewelleryEarringsTranslation> | string
        >
        updatedAt?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarrings>,
            Record<string, never>,
            Scalars['DateTime'] | string
        >
        variations?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarrings>,
            Record<string, never>,
            Array<WithTypename<CatalogueJewelleryEarrings> | string>
        >
        video?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarrings>,
            Record<string, never>,
            WithTypename<CatalogueVideo> | string
        >
    }
    CatalogueJewelleryEarringsFilters?: {
        designFeatures?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarringsFilters>,
            Record<string, never>,
            Array<
                | WithTypename<CatalogueFilterJewelleryDesignFeatureLabel>
                | string
            >
        >
        designStyles?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarringsFilters>,
            Record<string, never>,
            Array<
                WithTypename<CatalogueFilterJewelleryDesignStyleLabel> | string
            >
        >
        gemstones?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarringsFilters>,
            Record<string, never>,
            Array<WithTypename<CatalogueFilterJewelleryGemstoneLabel> | string>
        >
        price?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarringsFilters>,
            CatalogueJewelleryEarringsFiltersPriceArgs,
            WithTypename<CataloguePriceRangeFilter> | string
        >
        primaryMetals?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarringsFilters>,
            Record<string, never>,
            Array<WithTypename<CatalogueFilterMetalItem> | string>
        >
        productStyles?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarringsFilters>,
            Record<string, never>,
            Array<
                | WithTypename<CatalogueFilterJewelleryEarringsProductStyleLabel>
                | string
            >
        >
    }
    CatalogueJewelleryEarringsTranslation?: {
        description?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarringsTranslation>,
            Record<string, never>,
            Scalars['String'] | string
        >
        seoText?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryEarringsTranslation>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    CatalogueJewelleryNecklace?: {
        catalogueCode?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklace>,
            Record<string, never>,
            Scalars['CatalogueCode'] | string
        >
        customTitleTag?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklace>,
            Record<string, never>,
            Scalars['String'] | string
        >
        deliveryDays?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklace>,
            CatalogueJewelleryNecklaceDeliveryDaysArgs,
            Scalars['Int'] | string
        >
        designFeatures?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklace>,
            Record<string, never>,
            Array<WithTypename<JewelleryDesignFeatureLabel> | string>
        >
        designStyles?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklace>,
            Record<string, never>,
            Array<WithTypename<JewelleryDesignStyleLabel> | string>
        >
        engravingDisabled?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklace>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        financeOptionsAffirm?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklace>,
            CatalogueJewelleryNecklaceFinanceOptionsAffirmArgs,
            WithTypename<AffirmFinanceOption> | string
        >
        financeOptionsKlarna?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklace>,
            CatalogueJewelleryNecklaceFinanceOptionsKlarnaArgs,
            WithTypename<KlarnaFinanceOption> | string
        >
        firstAvailableDeliveryDate?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklace>,
            CatalogueJewelleryNecklaceFirstAvailableDeliveryDateArgs,
            WithTypename<DeliveryDate> | string
        >
        gemstones?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklace>,
            Record<string, never>,
            Array<WithTypename<JewelleryGemstoneLabel> | string>
        >
        images?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklace>,
            CatalogueJewelleryNecklaceImagesArgs,
            Array<WithTypename<CatalogueImage> | string>
        >
        images360?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklace>,
            Record<string, never>,
            Array<WithTypename<GenericImage> | string>
        >
        isReturnable?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklace>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        mainImage?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklace>,
            Record<string, never>,
            WithTypename<GenericImage> | string
        >
        primaryMetal?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklace>,
            Record<string, never>,
            WithTypename<Metal> | string
        >
        productName?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklace>,
            Record<string, never>,
            Scalars['String'] | string
        >
        productStyles?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklace>,
            Record<string, never>,
            Array<WithTypename<JewelleryNecklaceProductStyleLabel> | string>
        >
        relatedProducts?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklace>,
            Record<string, never>,
            Array<WithTypename<CatalogueJewelleryNecklace> | string>
        >
        reviews?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklace>,
            Record<string, never>,
            Array<WithTypename<Review> | string>
        >
        salePrice?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklace>,
            CatalogueJewelleryNecklaceSalePriceArgs,
            WithTypename<SalePrice> | string
        >
        segmentName?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklace>,
            Record<string, never>,
            Scalars['String'] | string
        >
        signatureStone?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklace>,
            Record<string, never>,
            WithTypename<Melee> | string
        >
        sku?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklace>,
            Record<string, never>,
            Scalars['String'] | string
        >
        slug?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklace>,
            Record<string, never>,
            Scalars['String'] | string
        >
        suffix?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklace>,
            Record<string, never>,
            Scalars['String'] | string
        >
        suffixSlug?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklace>,
            Record<string, never>,
            Scalars['String'] | string
        >
        translation?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklace>,
            CatalogueJewelleryNecklaceTranslationArgs,
            WithTypename<CatalogueJewelleryNecklaceTranslation> | string
        >
        updatedAt?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklace>,
            Record<string, never>,
            Scalars['DateTime'] | string
        >
        variations?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklace>,
            Record<string, never>,
            Array<WithTypename<CatalogueJewelleryNecklace> | string>
        >
        video?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklace>,
            Record<string, never>,
            WithTypename<CatalogueVideo> | string
        >
    }
    CatalogueJewelleryNecklaceTranslation?: {
        description?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklaceTranslation>,
            Record<string, never>,
            Scalars['String'] | string
        >
        seoText?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklaceTranslation>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    CatalogueJewelleryNecklacesFilters?: {
        designFeatures?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklacesFilters>,
            Record<string, never>,
            Array<
                | WithTypename<CatalogueFilterJewelleryDesignFeatureLabel>
                | string
            >
        >
        designStyles?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklacesFilters>,
            Record<string, never>,
            Array<
                WithTypename<CatalogueFilterJewelleryDesignStyleLabel> | string
            >
        >
        gemstones?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklacesFilters>,
            Record<string, never>,
            Array<WithTypename<CatalogueFilterJewelleryGemstoneLabel> | string>
        >
        price?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklacesFilters>,
            CatalogueJewelleryNecklacesFiltersPriceArgs,
            WithTypename<CataloguePriceRangeFilter> | string
        >
        primaryMetals?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklacesFilters>,
            Record<string, never>,
            Array<WithTypename<CatalogueFilterMetalItem> | string>
        >
        productStyles?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryNecklacesFilters>,
            Record<string, never>,
            Array<
                | WithTypename<CatalogueFilterJewelleryNecklaceProductStyleLabel>
                | string
            >
        >
    }
    CatalogueJewelleryRing?: {
        catalogueCode?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRing>,
            Record<string, never>,
            Scalars['CatalogueCode'] | string
        >
        customTitleTag?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        deliveryDays?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRing>,
            CatalogueJewelleryRingDeliveryDaysArgs,
            Scalars['Int'] | string
        >
        designFeatures?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRing>,
            Record<string, never>,
            Array<WithTypename<JewelleryDesignFeatureLabel> | string>
        >
        designStyles?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRing>,
            Record<string, never>,
            Array<WithTypename<JewelleryDesignStyleLabel> | string>
        >
        engravingDisabled?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRing>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        financeOptionsAffirm?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRing>,
            CatalogueJewelleryRingFinanceOptionsAffirmArgs,
            WithTypename<AffirmFinanceOption> | string
        >
        financeOptionsKlarna?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRing>,
            CatalogueJewelleryRingFinanceOptionsKlarnaArgs,
            WithTypename<KlarnaFinanceOption> | string
        >
        firstAvailableDeliveryDate?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRing>,
            CatalogueJewelleryRingFirstAvailableDeliveryDateArgs,
            WithTypename<DeliveryDate> | string
        >
        gemstones?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRing>,
            Record<string, never>,
            Array<WithTypename<JewelleryGemstoneLabel> | string>
        >
        images?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRing>,
            CatalogueJewelleryRingImagesArgs,
            Array<WithTypename<CatalogueImage> | string>
        >
        images360?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRing>,
            Record<string, never>,
            Array<WithTypename<GenericImage> | string>
        >
        isResizeable?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRing>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        isReturnable?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRing>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        mainImage?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRing>,
            Record<string, never>,
            WithTypename<GenericImage> | string
        >
        primaryMetal?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRing>,
            Record<string, never>,
            WithTypename<Metal> | string
        >
        productName?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        productStyles?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRing>,
            Record<string, never>,
            Array<WithTypename<JewelleryRingProductStyleLabel> | string>
        >
        relatedProducts?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRing>,
            Record<string, never>,
            Array<WithTypename<CatalogueJewelleryRing> | string>
        >
        reviews?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRing>,
            Record<string, never>,
            Array<WithTypename<Review> | string>
        >
        salePrice?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRing>,
            CatalogueJewelleryRingSalePriceArgs,
            WithTypename<SalePrice> | string
        >
        segmentName?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        signatureStone?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRing>,
            Record<string, never>,
            WithTypename<Melee> | string
        >
        sizes?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRing>,
            CatalogueJewelleryRingSizesArgs,
            Array<WithTypename<RingSizeOrRecommendedRingSize> | string>
        >
        sku?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        slug?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        suffix?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        suffixSlug?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        translation?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRing>,
            CatalogueJewelleryRingTranslationArgs,
            WithTypename<CatalogueJewelleryRingTranslation> | string
        >
        updatedAt?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRing>,
            Record<string, never>,
            Scalars['DateTime'] | string
        >
        variations?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRing>,
            Record<string, never>,
            Array<WithTypename<CatalogueJewelleryRing> | string>
        >
        video?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRing>,
            Record<string, never>,
            WithTypename<CatalogueVideo> | string
        >
    }
    CatalogueJewelleryRingTranslation?: {
        description?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRingTranslation>,
            Record<string, never>,
            Scalars['String'] | string
        >
        seoText?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRingTranslation>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    CatalogueJewelleryRingsFilters?: {
        designFeatures?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRingsFilters>,
            Record<string, never>,
            Array<
                | WithTypename<CatalogueFilterJewelleryDesignFeatureLabel>
                | string
            >
        >
        designStyles?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRingsFilters>,
            Record<string, never>,
            Array<
                WithTypename<CatalogueFilterJewelleryDesignStyleLabel> | string
            >
        >
        gemstones?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRingsFilters>,
            Record<string, never>,
            Array<WithTypename<CatalogueFilterJewelleryGemstoneLabel> | string>
        >
        price?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRingsFilters>,
            CatalogueJewelleryRingsFiltersPriceArgs,
            WithTypename<CataloguePriceRangeFilter> | string
        >
        primaryMetals?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRingsFilters>,
            Record<string, never>,
            Array<WithTypename<CatalogueFilterMetalItem> | string>
        >
        productStyles?: GraphCacheResolver<
            WithTypename<CatalogueJewelleryRingsFilters>,
            Record<string, never>,
            Array<
                | WithTypename<CatalogueFilterJewelleryRingProductStyleLabel>
                | string
            >
        >
    }
    CatalogueMelee?: {
        melee?: GraphCacheResolver<
            WithTypename<CatalogueMelee>,
            Record<string, never>,
            WithTypename<Melee> | string
        >
        quantity?: GraphCacheResolver<
            WithTypename<CatalogueMelee>,
            Record<string, never>,
            Scalars['Int'] | string
        >
    }
    CataloguePriceRange?: {
        max?: GraphCacheResolver<
            WithTypename<CataloguePriceRange>,
            Record<string, never>,
            WithTypename<Money> | string
        >
        min?: GraphCacheResolver<
            WithTypename<CataloguePriceRange>,
            Record<string, never>,
            WithTypename<Money> | string
        >
    }
    CataloguePriceRangeBar?: {
        range?: GraphCacheResolver<
            WithTypename<CataloguePriceRangeBar>,
            Record<string, never>,
            WithTypename<CataloguePriceRange> | string
        >
        totalResults?: GraphCacheResolver<
            WithTypename<CataloguePriceRangeBar>,
            Record<string, never>,
            Scalars['Int'] | string
        >
    }
    CataloguePriceRangeFilter?: {
        absoluteRange?: GraphCacheResolver<
            WithTypename<CataloguePriceRangeFilter>,
            Record<string, never>,
            WithTypename<CataloguePriceRange> | string
        >
        bars?: GraphCacheResolver<
            WithTypename<CataloguePriceRangeFilter>,
            CataloguePriceRangeFilterBarsArgs,
            Array<WithTypename<CataloguePriceRangeBar> | string>
        >
        currentRange?: GraphCacheResolver<
            WithTypename<CataloguePriceRangeFilter>,
            Record<string, never>,
            WithTypename<CataloguePriceRange> | string
        >
    }
    CatalogueReadyToGoRing?: {
        carat?: GraphCacheResolver<
            WithTypename<CatalogueReadyToGoRing>,
            Record<string, never>,
            Scalars['Float'] | string
        >
        catalogueCode?: GraphCacheResolver<
            WithTypename<CatalogueReadyToGoRing>,
            Record<string, never>,
            Scalars['CatalogueCode'] | string
        >
        customTitleTag?: GraphCacheResolver<
            WithTypename<CatalogueReadyToGoRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        deliveryDays?: GraphCacheResolver<
            WithTypename<CatalogueReadyToGoRing>,
            CatalogueReadyToGoRingDeliveryDaysArgs,
            Scalars['Int'] | string
        >
        financeOptionsAffirm?: GraphCacheResolver<
            WithTypename<CatalogueReadyToGoRing>,
            CatalogueReadyToGoRingFinanceOptionsAffirmArgs,
            WithTypename<AffirmFinanceOption> | string
        >
        financeOptionsKlarna?: GraphCacheResolver<
            WithTypename<CatalogueReadyToGoRing>,
            CatalogueReadyToGoRingFinanceOptionsKlarnaArgs,
            WithTypename<KlarnaFinanceOption> | string
        >
        firstAvailableDeliveryDate?: GraphCacheResolver<
            WithTypename<CatalogueReadyToGoRing>,
            CatalogueReadyToGoRingFirstAvailableDeliveryDateArgs,
            WithTypename<DeliveryDate> | string
        >
        gemType?: GraphCacheResolver<
            WithTypename<CatalogueReadyToGoRing>,
            Record<string, never>,
            GemType | string
        >
        images?: GraphCacheResolver<
            WithTypename<CatalogueReadyToGoRing>,
            CatalogueReadyToGoRingImagesArgs,
            Array<WithTypename<CatalogueImage> | string>
        >
        isReadyToShip?: GraphCacheResolver<
            WithTypename<CatalogueReadyToGoRing>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        isReturnable?: GraphCacheResolver<
            WithTypename<CatalogueReadyToGoRing>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        mainImage?: GraphCacheResolver<
            WithTypename<CatalogueReadyToGoRing>,
            Record<string, never>,
            WithTypename<GenericImage> | string
        >
        primaryMetal?: GraphCacheResolver<
            WithTypename<CatalogueReadyToGoRing>,
            Record<string, never>,
            WithTypename<Metal> | string
        >
        productName?: GraphCacheResolver<
            WithTypename<CatalogueReadyToGoRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        relatedProducts?: GraphCacheResolver<
            WithTypename<CatalogueReadyToGoRing>,
            Record<string, never>,
            Array<WithTypename<CatalogueReadyToGoRing> | string>
        >
        reviews?: GraphCacheResolver<
            WithTypename<CatalogueReadyToGoRing>,
            Record<string, never>,
            Array<WithTypename<Review> | string>
        >
        salePrice?: GraphCacheResolver<
            WithTypename<CatalogueReadyToGoRing>,
            CatalogueReadyToGoRingSalePriceArgs,
            WithTypename<SalePrice> | string
        >
        segmentName?: GraphCacheResolver<
            WithTypename<CatalogueReadyToGoRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        shortDescription?: GraphCacheResolver<
            WithTypename<CatalogueReadyToGoRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        shortName?: GraphCacheResolver<
            WithTypename<CatalogueReadyToGoRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        signatureStone?: GraphCacheResolver<
            WithTypename<CatalogueReadyToGoRing>,
            Record<string, never>,
            WithTypename<Melee> | string
        >
        sizes?: GraphCacheResolver<
            WithTypename<CatalogueReadyToGoRing>,
            Record<string, never>,
            Array<WithTypename<RecommendedRingSize> | string>
        >
        sku?: GraphCacheResolver<
            WithTypename<CatalogueReadyToGoRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        slug?: GraphCacheResolver<
            WithTypename<CatalogueReadyToGoRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        suffix?: GraphCacheResolver<
            WithTypename<CatalogueReadyToGoRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        suffixSlug?: GraphCacheResolver<
            WithTypename<CatalogueReadyToGoRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        translation?: GraphCacheResolver<
            WithTypename<CatalogueReadyToGoRing>,
            CatalogueReadyToGoRingTranslationArgs,
            WithTypename<CatalogueReadyToGoRingTranslation> | string
        >
        updatedAt?: GraphCacheResolver<
            WithTypename<CatalogueReadyToGoRing>,
            Record<string, never>,
            Scalars['DateTime'] | string
        >
        variations?: GraphCacheResolver<
            WithTypename<CatalogueReadyToGoRing>,
            Record<string, never>,
            Array<WithTypename<CatalogueReadyToGoRing> | string>
        >
    }
    CatalogueReadyToGoRingFilters?: {
        price?: GraphCacheResolver<
            WithTypename<CatalogueReadyToGoRingFilters>,
            CatalogueReadyToGoRingFiltersPriceArgs,
            WithTypename<CataloguePriceRangeFilter> | string
        >
        primaryMetals?: GraphCacheResolver<
            WithTypename<CatalogueReadyToGoRingFilters>,
            Record<string, never>,
            Array<WithTypename<CatalogueFilterMetalItem> | string>
        >
    }
    CatalogueReadyToGoRingTranslation?: {
        description?: GraphCacheResolver<
            WithTypename<CatalogueReadyToGoRingTranslation>,
            Record<string, never>,
            Scalars['String'] | string
        >
        seoText?: GraphCacheResolver<
            WithTypename<CatalogueReadyToGoRingTranslation>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    CatalogueVideo?: {
        type?: GraphCacheResolver<
            WithTypename<CatalogueVideo>,
            Record<string, never>,
            Scalars['String'] | string
        >
        uri?: GraphCacheResolver<
            WithTypename<CatalogueVideo>,
            Record<string, never>,
            Scalars['Uri'] | string
        >
    }
    CatalogueWeddingRing?: {
        bandThickness?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRing>,
            Record<string, never>,
            Scalars['Float'] | string
        >
        bandType?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRing>,
            Record<string, never>,
            WithTypename<CatalogueBandType> | string
        >
        bandWidth?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRing>,
            Record<string, never>,
            Scalars['Float'] | string
        >
        catalogueCode?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRing>,
            Record<string, never>,
            Scalars['CatalogueCode'] | string
        >
        categories?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRing>,
            Record<string, never>,
            Array<WithTypename<WeddingRingCategoryLabel> | string>
        >
        customTitleTag?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        deliveryDays?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRing>,
            CatalogueWeddingRingDeliveryDaysArgs,
            Scalars['Int'] | string
        >
        financeOptionsAffirm?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRing>,
            CatalogueWeddingRingFinanceOptionsAffirmArgs,
            WithTypename<AffirmFinanceOption> | string
        >
        financeOptionsKlarna?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRing>,
            CatalogueWeddingRingFinanceOptionsKlarnaArgs,
            WithTypename<KlarnaFinanceOption> | string
        >
        firstAvailableDeliveryDate?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRing>,
            CatalogueWeddingRingFirstAvailableDeliveryDateArgs,
            WithTypename<DeliveryDate> | string
        >
        images?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRing>,
            CatalogueWeddingRingImagesArgs,
            Array<WithTypename<CatalogueImage> | string>
        >
        images360?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRing>,
            Record<string, never>,
            Array<WithTypename<GenericImage> | string>
        >
        isResizeable?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRing>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        isReturnable?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRing>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        mainImage?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRing>,
            Record<string, never>,
            WithTypename<GenericImage> | string
        >
        meleeItems?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRing>,
            Record<string, never>,
            Array<WithTypename<CatalogueMelee> | string>
        >
        primaryMetal?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRing>,
            Record<string, never>,
            WithTypename<Metal> | string
        >
        productName?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        relatedProducts?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRing>,
            Record<string, never>,
            Array<WithTypename<CatalogueWeddingRing> | string>
        >
        reviews?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRing>,
            Record<string, never>,
            Array<WithTypename<Review> | string>
        >
        ringStyles?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRing>,
            Record<string, never>,
            Array<WithTypename<WeddingRingStyleLabel> | string>
        >
        salePrice?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRing>,
            CatalogueWeddingRingSalePriceArgs,
            WithTypename<SalePrice> | string
        >
        segmentName?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        signatureStone?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRing>,
            Record<string, never>,
            WithTypename<Melee> | string
        >
        sizes?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRing>,
            CatalogueWeddingRingSizesArgs,
            Array<WithTypename<RingSizeOrRecommendedRingSize> | string>
        >
        slug?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        suffix?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        suffixSlug?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        translation?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRing>,
            CatalogueWeddingRingTranslationArgs,
            WithTypename<CatalogueWeddingRingTranslation> | string
        >
        updatedAt?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRing>,
            Record<string, never>,
            Scalars['DateTime'] | string
        >
        variations?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRing>,
            Record<string, never>,
            Array<WithTypename<CatalogueWeddingRing> | string>
        >
        video?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRing>,
            Record<string, never>,
            WithTypename<CatalogueVideo> | string
        >
    }
    CatalogueWeddingRingFilters?: {
        categories?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRingFilters>,
            Record<string, never>,
            Array<
                WithTypename<CatalogueFilterWeddingRingCategoriesItem> | string
            >
        >
        price?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRingFilters>,
            CatalogueWeddingRingFiltersPriceArgs,
            WithTypename<CataloguePriceRangeFilter> | string
        >
        primaryMetals?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRingFilters>,
            Record<string, never>,
            Array<WithTypename<CatalogueFilterMetalItem> | string>
        >
        ringStyles?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRingFilters>,
            Record<string, never>,
            Array<WithTypename<CatalogueFilterWeddingRingStylesItem> | string>
        >
    }
    CatalogueWeddingRingFiltersVariation?: {
        category?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRingFiltersVariation>,
            Record<string, never>,
            WeddingRingCategoryLabelCode | string
        >
        primaryMetal?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRingFiltersVariation>,
            Record<string, never>,
            MetalCode | string
        >
        ringStyle?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRingFiltersVariation>,
            Record<string, never>,
            WeddingRingStyleLabelCode | string
        >
    }
    CatalogueWeddingRingTranslation?: {
        description?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRingTranslation>,
            Record<string, never>,
            Scalars['String'] | string
        >
        locale?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRingTranslation>,
            Record<string, never>,
            Scalars['Locale'] | string
        >
        seoText?: GraphCacheResolver<
            WithTypename<CatalogueWeddingRingTranslation>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    CheckoutcomOperationDeclinedError?: {
        message?: GraphCacheResolver<
            WithTypename<CheckoutcomOperationDeclinedError>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    CheckoutcomPaymentMethod?: {
        debugMode?: GraphCacheResolver<
            WithTypename<CheckoutcomPaymentMethod>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        publicKey?: GraphCacheResolver<
            WithTypename<CheckoutcomPaymentMethod>,
            Record<string, never>,
            Scalars['String'] | string
        >
        systemCode?: GraphCacheResolver<
            WithTypename<CheckoutcomPaymentMethod>,
            Record<string, never>,
            Scalars['ID'] | string
        >
    }
    CheckoutcomTransaction?: {
        amount?: GraphCacheResolver<
            WithTypename<CheckoutcomTransaction>,
            Record<string, never>,
            WithTypename<Money> | string
        >
        createdAt?: GraphCacheResolver<
            WithTypename<CheckoutcomTransaction>,
            Record<string, never>,
            Scalars['DateTime'] | string
        >
        id?: GraphCacheResolver<
            WithTypename<CheckoutcomTransaction>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        status?: GraphCacheResolver<
            WithTypename<CheckoutcomTransaction>,
            Record<string, never>,
            WithTypename<TransactionStatus> | string
        >
    }
    CompleteCheckoutcomTransactionPost3dsFailureResponse?: {
        errors?: GraphCacheResolver<
            WithTypename<CompleteCheckoutcomTransactionPost3dsFailureResponse>,
            Record<string, never>,
            Array<
                | WithTypename<CompleteCheckoutcomTransactionPost3dsError>
                | string
            >
        >
    }
    CompleteCheckoutcomTransactionPost3dsSuccessResponse?: {
        order?: GraphCacheResolver<
            WithTypename<CompleteCheckoutcomTransactionPost3dsSuccessResponse>,
            Record<string, never>,
            WithTypename<Order> | string
        >
    }
    ComponentArticleGrid?: {
        articles?: GraphCacheResolver<
            WithTypename<ComponentArticleGrid>,
            ComponentArticleGridArticlesArgs,
            Array<WithTypename<ArticleGridItem> | string>
        >
    }
    ComponentArticlePreviews?: {
        articles?: GraphCacheResolver<
            WithTypename<ComponentArticlePreviews>,
            ComponentArticlePreviewsArticlesArgs,
            Array<WithTypename<ArticlePreview> | string>
        >
    }
    ComponentBannerSkinny?: {
        backgroundColor?: GraphCacheResolver<
            WithTypename<ComponentBannerSkinny>,
            Record<string, never>,
            Color | string
        >
        backgroundGraphic?: GraphCacheResolver<
            WithTypename<ComponentBannerSkinny>,
            Record<string, never>,
            BannerSkinnyBackgroundGraphic | string
        >
        backgroundImage?: GraphCacheResolver<
            WithTypename<ComponentBannerSkinny>,
            Record<string, never>,
            WithTypename<Image> | string
        >
        title?: GraphCacheResolver<
            WithTypename<ComponentBannerSkinny>,
            Record<string, never>,
            WithTypename<ComponentTitle> | string
        >
        useBackgroundImage?: GraphCacheResolver<
            WithTypename<ComponentBannerSkinny>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
    }
    ComponentBannerTitle?: {
        date?: GraphCacheResolver<
            WithTypename<ComponentBannerTitle>,
            Record<string, never>,
            Scalars['String'] | string
        >
        description?: GraphCacheResolver<
            WithTypename<ComponentBannerTitle>,
            Record<string, never>,
            Scalars['String'] | string
        >
        image?: GraphCacheResolver<
            WithTypename<ComponentBannerTitle>,
            Record<string, never>,
            WithTypename<Image> | string
        >
        tag?: GraphCacheResolver<
            WithTypename<ComponentBannerTitle>,
            Record<string, never>,
            HtmlTag | string
        >
        title?: GraphCacheResolver<
            WithTypename<ComponentBannerTitle>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    ComponentButton?: {
        alignment?: GraphCacheResolver<
            WithTypename<ComponentButton>,
            Record<string, never>,
            HorizontalAlignment | string
        >
        eventTracking?: GraphCacheResolver<
            WithTypename<ComponentButton>,
            Record<string, never>,
            WithTypename<ButtonEventTracking> | string
        >
        icon?: GraphCacheResolver<
            WithTypename<ComponentButton>,
            Record<string, never>,
            WithTypename<ButtonIcon> | string
        >
        link?: GraphCacheResolver<
            WithTypename<ComponentButton>,
            Record<string, never>,
            WithTypename<Link> | string
        >
        style?: GraphCacheResolver<
            WithTypename<ComponentButton>,
            Record<string, never>,
            WithTypename<ButtonStyle> | string
        >
        text?: GraphCacheResolver<
            WithTypename<ComponentButton>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    ComponentCard?: {
        backgroundColor?: GraphCacheResolver<
            WithTypename<ComponentCard>,
            Record<string, never>,
            Color | string
        >
        content?: GraphCacheResolver<
            WithTypename<ComponentCard>,
            Record<string, never>,
            Array<WithTypename<ContentComponentItem> | string>
        >
        image?: GraphCacheResolver<
            WithTypename<ComponentCard>,
            Record<string, never>,
            WithTypename<Image> | string
        >
    }
    ComponentCardCarousel?: {
        items?: GraphCacheResolver<
            WithTypename<ComponentCardCarousel>,
            Record<string, never>,
            Array<WithTypename<CardCarouselCard> | string>
        >
    }
    ComponentCatalogueProductCarousel?: {
        items?: GraphCacheResolver<
            WithTypename<ComponentCatalogueProductCarousel>,
            Record<string, never>,
            Array<WithTypename<ComponentCatalogueProductCarouselItem> | string>
        >
    }
    ComponentCatalogueProductCarouselItem?: {
        catalogueCode?: GraphCacheResolver<
            WithTypename<ComponentCatalogueProductCarouselItem>,
            Record<string, never>,
            Scalars['String'] | string
        >
        product?: GraphCacheResolver<
            WithTypename<ComponentCatalogueProductCarouselItem>,
            Record<string, never>,
            | WithTypename<CatalogueEngagementRing>
            | WithTypename<CatalogueJewelleryBracelet>
            | WithTypename<CatalogueJewelleryEarrings>
            | WithTypename<CatalogueJewelleryNecklace>
            | WithTypename<CatalogueJewelleryRing>
            | WithTypename<CatalogueReadyToGoRing>
            | WithTypename<CatalogueWeddingRing>
            | string
        >
    }
    ComponentContent?: {
        content?: GraphCacheResolver<
            WithTypename<ComponentContent>,
            Record<string, never>,
            Array<WithTypename<ContentComponentItem> | string>
        >
    }
    ComponentContentTwoColumns?: {
        leftColumnBackgroundColor?: GraphCacheResolver<
            WithTypename<ComponentContentTwoColumns>,
            Record<string, never>,
            Color | string
        >
        leftColumnContent?: GraphCacheResolver<
            WithTypename<ComponentContentTwoColumns>,
            Record<string, never>,
            Array<WithTypename<ContentComponentItem> | string>
        >
        rightColumnBackgroundColor?: GraphCacheResolver<
            WithTypename<ComponentContentTwoColumns>,
            Record<string, never>,
            Color | string
        >
        rightColumnContent?: GraphCacheResolver<
            WithTypename<ComponentContentTwoColumns>,
            Record<string, never>,
            Array<WithTypename<ContentComponentItem> | string>
        >
    }
    ComponentContentWithGallery?: {
        content?: GraphCacheResolver<
            WithTypename<ComponentContentWithGallery>,
            Record<string, never>,
            Array<WithTypename<ContentComponentItem> | string>
        >
        gallery?: GraphCacheResolver<
            WithTypename<ComponentContentWithGallery>,
            Record<string, never>,
            Array<WithTypename<GalleryItem> | string>
        >
    }
    ComponentCustomProductCarousel?: {
        products?: GraphCacheResolver<
            WithTypename<ComponentCustomProductCarousel>,
            Record<string, never>,
            Array<WithTypename<CarouselCustomProduct> | string>
        >
    }
    ComponentFaq?: {
        sections?: GraphCacheResolver<
            WithTypename<ComponentFaq>,
            Record<string, never>,
            Array<WithTypename<FaqSection> | string>
        >
        showNavigation?: GraphCacheResolver<
            WithTypename<ComponentFaq>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
    }
    ComponentFullWidthImage?: {
        image?: GraphCacheResolver<
            WithTypename<ComponentFullWidthImage>,
            Record<string, never>,
            WithTypename<Image> | string
        >
        link?: GraphCacheResolver<
            WithTypename<ComponentFullWidthImage>,
            Record<string, never>,
            WithTypename<Link> | string
        >
        width?: GraphCacheResolver<
            WithTypename<ComponentFullWidthImage>,
            Record<string, never>,
            ImageWidth | string
        >
    }
    ComponentGalleryCarousel?: {
        items?: GraphCacheResolver<
            WithTypename<ComponentGalleryCarousel>,
            Record<string, never>,
            Array<WithTypename<GalleryCarouselCard> | string>
        >
    }
    ComponentGalleryWithEnquiry?: {
        items?: GraphCacheResolver<
            WithTypename<ComponentGalleryWithEnquiry>,
            Record<string, never>,
            Array<WithTypename<GalleryWithEnquiryCard> | string>
        >
        type?: GraphCacheResolver<
            WithTypename<ComponentGalleryWithEnquiry>,
            Record<string, never>,
            CmsEnquiryFormType | string
        >
    }
    ComponentGlobalComponent?: {
        backgroundColor?: GraphCacheResolver<
            WithTypename<ComponentGlobalComponent>,
            Record<string, never>,
            Color | string
        >
        components?: GraphCacheResolver<
            WithTypename<ComponentGlobalComponent>,
            Record<string, never>,
            Array<WithTypename<Component> | string>
        >
    }
    ComponentGlobalSpacer?: {
        spacing?: GraphCacheResolver<
            WithTypename<ComponentGlobalSpacer>,
            Record<string, never>,
            Spacing | string
        >
    }
    ComponentIconCarousel?: {
        items?: GraphCacheResolver<
            WithTypename<ComponentIconCarousel>,
            Record<string, never>,
            Array<WithTypename<IconCarouselItem> | string>
        >
    }
    ComponentImage?: {
        image?: GraphCacheResolver<
            WithTypename<ComponentImage>,
            Record<string, never>,
            WithTypename<Image> | string
        >
    }
    ComponentInstagramPosts?: {
        instagramUser?: GraphCacheResolver<
            WithTypename<ComponentInstagramPosts>,
            Record<string, never>,
            Scalars['String'] | string
        >
        instagramUserLink?: GraphCacheResolver<
            WithTypename<ComponentInstagramPosts>,
            Record<string, never>,
            Scalars['String'] | string
        >
        posts?: GraphCacheResolver<
            WithTypename<ComponentInstagramPosts>,
            Record<string, never>,
            Array<WithTypename<InstagramPost> | string>
        >
        preTitle?: GraphCacheResolver<
            WithTypename<ComponentInstagramPosts>,
            Record<string, never>,
            Scalars['String'] | string
        >
        title?: GraphCacheResolver<
            WithTypename<ComponentInstagramPosts>,
            Record<string, never>,
            WithTypename<ComponentTitle> | string
        >
    }
    ComponentInstagramWithContent?: {
        content?: GraphCacheResolver<
            WithTypename<ComponentInstagramWithContent>,
            Record<string, never>,
            Array<WithTypename<ContentComponentItem> | string>
        >
        instagramEmbedCode?: GraphCacheResolver<
            WithTypename<ComponentInstagramWithContent>,
            Record<string, never>,
            Scalars['String'] | string
        >
        instagramImage?: GraphCacheResolver<
            WithTypename<ComponentInstagramWithContent>,
            Record<string, never>,
            WithTypename<Image> | string
        >
        instagramLink?: GraphCacheResolver<
            WithTypename<ComponentInstagramWithContent>,
            Record<string, never>,
            Scalars['String'] | string
        >
        instagramPosition?: GraphCacheResolver<
            WithTypename<ComponentInstagramWithContent>,
            Record<string, never>,
            ImagePosition | string
        >
        instagramUsername?: GraphCacheResolver<
            WithTypename<ComponentInstagramWithContent>,
            Record<string, never>,
            Scalars['String'] | string
        >
        useImage?: GraphCacheResolver<
            WithTypename<ComponentInstagramWithContent>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        width?: GraphCacheResolver<
            WithTypename<ComponentInstagramWithContent>,
            Record<string, never>,
            InstagramWithContentWidth | string
        >
    }
    ComponentLogos?: {
        logos?: GraphCacheResolver<
            WithTypename<ComponentLogos>,
            Record<string, never>,
            Array<WithTypename<Logo> | string>
        >
    }
    ComponentLogosCarousel?: {
        logos?: GraphCacheResolver<
            WithTypename<ComponentLogosCarousel>,
            Record<string, never>,
            Array<WithTypename<Logo> | string>
        >
    }
    ComponentMainCover?: {
        backgroundImage?: GraphCacheResolver<
            WithTypename<ComponentMainCover>,
            Record<string, never>,
            WithTypename<Image> | string
        >
        content?: GraphCacheResolver<
            WithTypename<ComponentMainCover>,
            Record<string, never>,
            Array<WithTypename<ContentComponentItem> | string>
        >
        mobileBackgroundImage?: GraphCacheResolver<
            WithTypename<ComponentMainCover>,
            Record<string, never>,
            WithTypename<Image> | string
        >
    }
    ComponentOnThisPage?: {
        null?: GraphCacheResolver<
            WithTypename<ComponentOnThisPage>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    ComponentOrderedList?: {
        items?: GraphCacheResolver<
            WithTypename<ComponentOrderedList>,
            Record<string, never>,
            Array<WithTypename<OrderedListItem> | string>
        >
    }
    ComponentQuote?: {
        author?: GraphCacheResolver<
            WithTypename<ComponentQuote>,
            Record<string, never>,
            Scalars['String'] | string
        >
        hasBackgroundImage?: GraphCacheResolver<
            WithTypename<ComponentQuote>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        image?: GraphCacheResolver<
            WithTypename<ComponentQuote>,
            Record<string, never>,
            WithTypename<Image> | string
        >
        quote?: GraphCacheResolver<
            WithTypename<ComponentQuote>,
            Record<string, never>,
            Scalars['String'] | string
        >
        showQuotationMarks?: GraphCacheResolver<
            WithTypename<ComponentQuote>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        size?: GraphCacheResolver<
            WithTypename<ComponentQuote>,
            Record<string, never>,
            QuoteSize | string
        >
    }
    ComponentRelatedProducts?: {
        null?: GraphCacheResolver<
            WithTypename<ComponentRelatedProducts>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    ComponentReviewCarousel?: {
        reviews?: GraphCacheResolver<
            WithTypename<ComponentReviewCarousel>,
            Record<string, never>,
            Array<WithTypename<ReviewCarouselCard> | string>
        >
    }
    ComponentRoundedImage?: {
        backgroundColor?: GraphCacheResolver<
            WithTypename<ComponentRoundedImage>,
            Record<string, never>,
            Color | string
        >
        backgroundImage?: GraphCacheResolver<
            WithTypename<ComponentRoundedImage>,
            Record<string, never>,
            WithTypename<Image> | string
        >
        backgroundImageColor?: GraphCacheResolver<
            WithTypename<ComponentRoundedImage>,
            Record<string, never>,
            Color | string
        >
        roundedImage?: GraphCacheResolver<
            WithTypename<ComponentRoundedImage>,
            Record<string, never>,
            WithTypename<Image> | string
        >
    }
    ComponentRoundedImageContent?: {
        content?: GraphCacheResolver<
            WithTypename<ComponentRoundedImageContent>,
            Record<string, never>,
            Array<WithTypename<ContentComponentItem> | string>
        >
        roundedImage?: GraphCacheResolver<
            WithTypename<ComponentRoundedImageContent>,
            Record<string, never>,
            WithTypename<ComponentRoundedImage> | string
        >
    }
    ComponentShopWithConfidence?: {
        components?: GraphCacheResolver<
            WithTypename<ComponentShopWithConfidence>,
            Record<string, never>,
            Array<
                | WithTypename<ShopWithConfidenceEthnicallySourcedDiamonds>
                | WithTypename<ShopWithConfidenceFinancingOptions>
                | WithTypename<ShopWithConfidenceGreenlandRuby>
                | WithTypename<ShopWithConfidenceHandFinished>
                | WithTypename<ShopWithConfidenceResize>
                | WithTypename<ShopWithConfidenceReturnPolicy>
                | WithTypename<ShopWithConfidenceShipping>
                | string
            >
        >
        ethnicallySourcedDiamonds?: GraphCacheResolver<
            WithTypename<ComponentShopWithConfidence>,
            Record<string, never>,
            Array<WithTypename<ContentComponentItem> | string>
        >
        financingOptions?: GraphCacheResolver<
            WithTypename<ComponentShopWithConfidence>,
            Record<string, never>,
            Array<WithTypename<ContentComponentItem> | string>
        >
        greenlandRuby?: GraphCacheResolver<
            WithTypename<ComponentShopWithConfidence>,
            Record<string, never>,
            Array<WithTypename<ContentComponentItem> | string>
        >
        handFinished?: GraphCacheResolver<
            WithTypename<ComponentShopWithConfidence>,
            Record<string, never>,
            Array<WithTypename<ContentComponentItem> | string>
        >
        resize?: GraphCacheResolver<
            WithTypename<ComponentShopWithConfidence>,
            Record<string, never>,
            Array<WithTypename<ContentComponentItem> | string>
        >
        returnPolicy?: GraphCacheResolver<
            WithTypename<ComponentShopWithConfidence>,
            Record<string, never>,
            Array<WithTypename<ContentComponentItem> | string>
        >
        shipping?: GraphCacheResolver<
            WithTypename<ComponentShopWithConfidence>,
            Record<string, never>,
            Array<WithTypename<ContentComponentItem> | string>
        >
        title?: GraphCacheResolver<
            WithTypename<ComponentShopWithConfidence>,
            Record<string, never>,
            WithTypename<ComponentTitle> | string
        >
    }
    ComponentSideBySideImage?: {
        caption?: GraphCacheResolver<
            WithTypename<ComponentSideBySideImage>,
            Record<string, never>,
            Scalars['String'] | string
        >
        content?: GraphCacheResolver<
            WithTypename<ComponentSideBySideImage>,
            Record<string, never>,
            Array<WithTypename<ContentComponentItem> | string>
        >
        image?: GraphCacheResolver<
            WithTypename<ComponentSideBySideImage>,
            Record<string, never>,
            WithTypename<Image> | string
        >
        link?: GraphCacheResolver<
            WithTypename<ComponentSideBySideImage>,
            Record<string, never>,
            WithTypename<Link> | string
        >
    }
    ComponentSideBySideImages?: {
        images?: GraphCacheResolver<
            WithTypename<ComponentSideBySideImages>,
            Record<string, never>,
            Array<WithTypename<ComponentSideBySideImage> | string>
        >
    }
    ComponentSpacer?: {
        spacing?: GraphCacheResolver<
            WithTypename<ComponentSpacer>,
            Record<string, never>,
            Spacing | string
        >
    }
    ComponentSquareBoxes?: {
        items?: GraphCacheResolver<
            WithTypename<ComponentSquareBoxes>,
            Record<string, never>,
            Array<WithTypename<SquareBoxes> | string>
        >
    }
    ComponentTable?: {
        table?: GraphCacheResolver<
            WithTypename<ComponentTable>,
            Record<string, never>,
            WithTypename<Table> | string
        >
    }
    ComponentText?: {
        alignment?: GraphCacheResolver<
            WithTypename<ComponentText>,
            Record<string, never>,
            HorizontalAlignment | string
        >
        text?: GraphCacheResolver<
            WithTypename<ComponentText>,
            Record<string, never>,
            Scalars['String'] | string
        >
        textSize?: GraphCacheResolver<
            WithTypename<ComponentText>,
            Record<string, never>,
            TextSize | string
        >
    }
    ComponentTextCarousel?: {
        items?: GraphCacheResolver<
            WithTypename<ComponentTextCarousel>,
            Record<string, never>,
            Array<WithTypename<TextCarouselItem> | string>
        >
    }
    ComponentTextOverImage?: {
        content?: GraphCacheResolver<
            WithTypename<ComponentTextOverImage>,
            Record<string, never>,
            Array<WithTypename<ContentComponentItem> | string>
        >
        image?: GraphCacheResolver<
            WithTypename<ComponentTextOverImage>,
            Record<string, never>,
            WithTypename<Image> | string
        >
    }
    ComponentTextWithImage?: {
        content?: GraphCacheResolver<
            WithTypename<ComponentTextWithImage>,
            Record<string, never>,
            Array<WithTypename<ContentComponentItem> | string>
        >
        image?: GraphCacheResolver<
            WithTypename<ComponentTextWithImage>,
            Record<string, never>,
            WithTypename<Image> | string
        >
        imageFormat?: GraphCacheResolver<
            WithTypename<ComponentTextWithImage>,
            Record<string, never>,
            ImageFormat | string
        >
        imagePosition?: GraphCacheResolver<
            WithTypename<ComponentTextWithImage>,
            Record<string, never>,
            ImagePosition | string
        >
        padding?: GraphCacheResolver<
            WithTypename<ComponentTextWithImage>,
            Record<string, never>,
            Padding | string
        >
    }
    ComponentTextWithImageCarousel?: {
        slidePadding?: GraphCacheResolver<
            WithTypename<ComponentTextWithImageCarousel>,
            Record<string, never>,
            SlidePadding | string
        >
        slides?: GraphCacheResolver<
            WithTypename<ComponentTextWithImageCarousel>,
            Record<string, never>,
            Array<WithTypename<ComponentTextWithImage> | string>
        >
    }
    ComponentTitle?: {
        alignment?: GraphCacheResolver<
            WithTypename<ComponentTitle>,
            Record<string, never>,
            HorizontalAlignment | string
        >
        color?: GraphCacheResolver<
            WithTypename<ComponentTitle>,
            Record<string, never>,
            Color | string
        >
        tag?: GraphCacheResolver<
            WithTypename<ComponentTitle>,
            Record<string, never>,
            HtmlTag | string
        >
        text?: GraphCacheResolver<
            WithTypename<ComponentTitle>,
            Record<string, never>,
            Scalars['String'] | string
        >
        texts?: GraphCacheResolver<
            WithTypename<ComponentTitle>,
            Record<string, never>,
            Array<WithTypename<ComponentTitleComponent> | string>
        >
        titleSize?: GraphCacheResolver<
            WithTypename<ComponentTitle>,
            Record<string, never>,
            TitleSize | string
        >
        titleStyle?: GraphCacheResolver<
            WithTypename<ComponentTitle>,
            Record<string, never>,
            TitleStyle | string
        >
        titleWidth?: GraphCacheResolver<
            WithTypename<ComponentTitle>,
            Record<string, never>,
            TitleWidth | string
        >
    }
    ComponentTitleAmpersand?: {
        null?: GraphCacheResolver<
            WithTypename<ComponentTitleAmpersand>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    ComponentTitleText?: {
        text?: GraphCacheResolver<
            WithTypename<ComponentTitleText>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    ComponentVideo?: {
        video?: GraphCacheResolver<
            WithTypename<ComponentVideo>,
            Record<string, never>,
            WithTypename<Video> | string
        >
        width?: GraphCacheResolver<
            WithTypename<ComponentVideo>,
            Record<string, never>,
            VideoWidth | string
        >
    }
    ComponentVideoWithContent?: {
        content?: GraphCacheResolver<
            WithTypename<ComponentVideoWithContent>,
            Record<string, never>,
            Array<WithTypename<ContentComponentItem> | string>
        >
        coverImage?: GraphCacheResolver<
            WithTypename<ComponentVideoWithContent>,
            Record<string, never>,
            WithTypename<Image> | string
        >
        video?: GraphCacheResolver<
            WithTypename<ComponentVideoWithContent>,
            Record<string, never>,
            WithTypename<Video> | string
        >
        videoPosition?: GraphCacheResolver<
            WithTypename<ComponentVideoWithContent>,
            Record<string, never>,
            VideoPosition | string
        >
    }
    Consultant?: {
        avatar?: GraphCacheResolver<
            WithTypename<Consultant>,
            Record<string, never>,
            Scalars['Uri'] | string
        >
        avatarImage?: GraphCacheResolver<
            WithTypename<Consultant>,
            Record<string, never>,
            WithTypename<GenericImage> | string
        >
        canTakeConsultations?: GraphCacheResolver<
            WithTypename<Consultant>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        firstName?: GraphCacheResolver<
            WithTypename<Consultant>,
            Record<string, never>,
            Scalars['String'] | string
        >
        id?: GraphCacheResolver<
            WithTypename<Consultant>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        showroom?: GraphCacheResolver<
            WithTypename<Consultant>,
            Record<string, never>,
            WithTypename<Showroom> | string
        >
        user?: GraphCacheResolver<
            WithTypename<Consultant>,
            Record<string, never>,
            WithTypename<User> | string
        >
    }
    CreateCheckoutcomTransactionFailureResponse?: {
        errors?: GraphCacheResolver<
            WithTypename<CreateCheckoutcomTransactionFailureResponse>,
            Record<string, never>,
            Array<WithTypename<CreateCheckoutcomTransactionError> | string>
        >
    }
    CreateCheckoutcomTransactionSuccessResponse?: {
        transaction?: GraphCacheResolver<
            WithTypename<CreateCheckoutcomTransactionSuccessResponse>,
            Record<string, never>,
            WithTypename<CheckoutcomTransaction> | string
        >
    }
    Customer?: {
        adminProfileUrl?: GraphCacheResolver<
            WithTypename<Customer>,
            Record<string, never>,
            Scalars['Uri'] | string
        >
        billingAddress?: GraphCacheResolver<
            WithTypename<Customer>,
            Record<string, never>,
            WithTypename<Address> | string
        >
        cart?: GraphCacheResolver<
            WithTypename<Customer>,
            Record<string, never>,
            WithTypename<Order> | string
        >
        consultant?: GraphCacheResolver<
            WithTypename<Customer>,
            Record<string, never>,
            WithTypename<Consultant> | string
        >
        designInspiration?: GraphCacheResolver<
            WithTypename<Customer>,
            Record<string, never>,
            WithTypename<DesignInspiration> | string
        >
        designStudioProduct?: GraphCacheResolver<
            WithTypename<Customer>,
            CustomerDesignStudioProductArgs,
            | WithTypename<DesignStudioProductAdditionalResize>
            | WithTypename<DesignStudioProductCustom>
            | WithTypename<DesignStudioProductEngagementRing>
            | WithTypename<DesignStudioProductGeneric>
            | WithTypename<DesignStudioProductLooseStone>
            | WithTypename<DesignStudioProductWeddingRing>
            | string
        >
        designStudioProducts?: GraphCacheResolver<
            WithTypename<Customer>,
            Record<string, never>,
            Array<
                | WithTypename<DesignStudioProductAdditionalResize>
                | WithTypename<DesignStudioProductCustom>
                | WithTypename<DesignStudioProductEngagementRing>
                | WithTypename<DesignStudioProductGeneric>
                | WithTypename<DesignStudioProductLooseStone>
                | WithTypename<DesignStudioProductWeddingRing>
                | string
            >
        >
        disabledThirdPartyCookies?: GraphCacheResolver<
            WithTypename<Customer>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        engagementRingRecommendations?: GraphCacheResolver<
            WithTypename<Customer>,
            Record<string, never>,
            WithTypename<UserCustomerEngagementRingRecommendations> | string
        >
        enquiries?: GraphCacheResolver<
            WithTypename<Customer>,
            Record<string, never>,
            Array<WithTypename<Enquiry> | string>
        >
        id?: GraphCacheResolver<
            WithTypename<Customer>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        order?: GraphCacheResolver<
            WithTypename<Customer>,
            CustomerOrderArgs,
            WithTypename<Order> | string
        >
        orders?: GraphCacheResolver<
            WithTypename<Customer>,
            Record<string, never>,
            Array<WithTypename<Order> | string>
        >
        ordersByConsultationPurpose?: GraphCacheResolver<
            WithTypename<Customer>,
            CustomerOrdersByConsultationPurposeArgs,
            Array<WithTypename<Order> | string>
        >
        questionnaireByType?: GraphCacheResolver<
            WithTypename<Customer>,
            CustomerQuestionnaireByTypeArgs,
            WithTypename<QuestionnaireCompletedQuestionnaire> | string
        >
        salesforceProfileUrl?: GraphCacheResolver<
            WithTypename<Customer>,
            Record<string, never>,
            Scalars['Uri'] | string
        >
        shippingAddress?: GraphCacheResolver<
            WithTypename<Customer>,
            Record<string, never>,
            WithTypename<Address> | string
        >
        user?: GraphCacheResolver<
            WithTypename<Customer>,
            Record<string, never>,
            WithTypename<User> | string
        >
    }
    CustomerRegistrationResponse?: {
        login?: GraphCacheResolver<
            WithTypename<CustomerRegistrationResponse>,
            Record<string, never>,
            WithTypename<LoginResponseSuccess> | string
        >
    }
    DeliveryDate?: {
        date?: GraphCacheResolver<
            WithTypename<DeliveryDate>,
            Record<string, never>,
            Scalars['DateTime'] | string
        >
        validUntil?: GraphCacheResolver<
            WithTypename<DeliveryDate>,
            Record<string, never>,
            Scalars['DateTime'] | string
        >
    }
    DesignInspiration?: {
        id?: GraphCacheResolver<
            WithTypename<DesignInspiration>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        url?: GraphCacheResolver<
            WithTypename<DesignInspiration>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    DesignStudioEngagementRingCentreStone?: {
        approved?: GraphCacheResolver<
            WithTypename<DesignStudioEngagementRingCentreStone>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        comment?: GraphCacheResolver<
            WithTypename<DesignStudioEngagementRingCentreStone>,
            Record<string, never>,
            Scalars['String'] | string
        >
        id?: GraphCacheResolver<
            WithTypename<DesignStudioEngagementRingCentreStone>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        manualSurcharges?: GraphCacheResolver<
            WithTypename<DesignStudioEngagementRingCentreStone>,
            Record<string, never>,
            Array<WithTypename<QuotationManualSurcharge> | string>
        >
        percentageSurcharge?: GraphCacheResolver<
            WithTypename<DesignStudioEngagementRingCentreStone>,
            Record<string, never>,
            WithTypename<QuotationPercentageSurcharge> | string
        >
        salePrice?: GraphCacheResolver<
            WithTypename<DesignStudioEngagementRingCentreStone>,
            Record<string, never>,
            WithTypename<Money> | string
        >
        stone?: GraphCacheResolver<
            WithTypename<DesignStudioEngagementRingCentreStone>,
            Record<string, never>,
            WithTypename<DesignStudioCentreStone> | string
        >
    }
    DesignStudioEngagementRingErrorGeneric?: {
        message?: GraphCacheResolver<
            WithTypename<DesignStudioEngagementRingErrorGeneric>,
            DesignStudioEngagementRingErrorGenericMessageArgs,
            Scalars['String'] | string
        >
    }
    DesignStudioEngagementRingErrorMaxCaratWeight?: {
        message?: GraphCacheResolver<
            WithTypename<DesignStudioEngagementRingErrorMaxCaratWeight>,
            DesignStudioEngagementRingErrorMaxCaratWeightMessageArgs,
            Scalars['String'] | string
        >
    }
    DesignStudioEngagementRingErrorMinCaratWeight?: {
        message?: GraphCacheResolver<
            WithTypename<DesignStudioEngagementRingErrorMinCaratWeight>,
            DesignStudioEngagementRingErrorMinCaratWeightMessageArgs,
            Scalars['String'] | string
        >
    }
    DesignStudioEngagementRingErrorShapeMismatch?: {
        matchingVariation?: GraphCacheResolver<
            WithTypename<DesignStudioEngagementRingErrorShapeMismatch>,
            Record<string, never>,
            WithTypename<CatalogueEngagementRing> | string
        >
        message?: GraphCacheResolver<
            WithTypename<DesignStudioEngagementRingErrorShapeMismatch>,
            DesignStudioEngagementRingErrorShapeMismatchMessageArgs,
            Scalars['String'] | string
        >
    }
    DesignStudioEngagementRingFailure?: {
        errors?: GraphCacheResolver<
            WithTypename<DesignStudioEngagementRingFailure>,
            Record<string, never>,
            Array<WithTypename<DesignStudioEngagementRingError> | string>
        >
    }
    DesignStudioEngagementRingMount?: {
        approved?: GraphCacheResolver<
            WithTypename<DesignStudioEngagementRingMount>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        comment?: GraphCacheResolver<
            WithTypename<DesignStudioEngagementRingMount>,
            Record<string, never>,
            Scalars['String'] | string
        >
        id?: GraphCacheResolver<
            WithTypename<DesignStudioEngagementRingMount>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        manualSurcharges?: GraphCacheResolver<
            WithTypename<DesignStudioEngagementRingMount>,
            Record<string, never>,
            Array<WithTypename<QuotationManualSurcharge> | string>
        >
        melees?: GraphCacheResolver<
            WithTypename<DesignStudioEngagementRingMount>,
            Record<string, never>,
            Array<WithTypename<DesignStudioMeleeItem> | string>
        >
        metals?: GraphCacheResolver<
            WithTypename<DesignStudioEngagementRingMount>,
            Record<string, never>,
            Array<WithTypename<Metal> | string>
        >
        percentageSurcharge?: GraphCacheResolver<
            WithTypename<DesignStudioEngagementRingMount>,
            Record<string, never>,
            WithTypename<QuotationPercentageSurcharge> | string
        >
        salePrice?: GraphCacheResolver<
            WithTypename<DesignStudioEngagementRingMount>,
            Record<string, never>,
            WithTypename<Money> | string
        >
        sideStones?: GraphCacheResolver<
            WithTypename<DesignStudioEngagementRingMount>,
            Record<string, never>,
            Array<WithTypename<DesignStudioSideStone> | string>
        >
        signatureStones?: GraphCacheResolver<
            WithTypename<DesignStudioEngagementRingMount>,
            Record<string, never>,
            Array<WithTypename<DesignStudioSignatureStone> | string>
        >
    }
    DesignStudioExternalCentreStone?: {
        crystal?: GraphCacheResolver<
            WithTypename<DesignStudioExternalCentreStone>,
            Record<string, never>,
            WithTypename<StoneCrystal> | string
        >
        id?: GraphCacheResolver<
            WithTypename<DesignStudioExternalCentreStone>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        weight?: GraphCacheResolver<
            WithTypename<DesignStudioExternalCentreStone>,
            Record<string, never>,
            Scalars['Decimal'] | string
        >
    }
    DesignStudioExternalSideStone?: {
        crystal?: GraphCacheResolver<
            WithTypename<DesignStudioExternalSideStone>,
            Record<string, never>,
            WithTypename<StoneCrystal> | string
        >
        id?: GraphCacheResolver<
            WithTypename<DesignStudioExternalSideStone>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        weight?: GraphCacheResolver<
            WithTypename<DesignStudioExternalSideStone>,
            Record<string, never>,
            Scalars['Decimal'] | string
        >
    }
    DesignStudioInternalCentreStone?: {
        id?: GraphCacheResolver<
            WithTypename<DesignStudioInternalCentreStone>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        nonSku?: GraphCacheResolver<
            WithTypename<DesignStudioInternalCentreStone>,
            Record<string, never>,
            WithTypename<HistoricalNonSku> | string
        >
        sku?: GraphCacheResolver<
            WithTypename<DesignStudioInternalCentreStone>,
            Record<string, never>,
            WithTypename<Stone> | string
        >
    }
    DesignStudioInternalSideStone?: {
        id?: GraphCacheResolver<
            WithTypename<DesignStudioInternalSideStone>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        item?: GraphCacheResolver<
            WithTypename<DesignStudioInternalSideStone>,
            Record<string, never>,
            WithTypename<DesignStudioSideStoneItem> | string
        >
        quantity?: GraphCacheResolver<
            WithTypename<DesignStudioInternalSideStone>,
            Record<string, never>,
            Scalars['Int'] | string
        >
    }
    DesignStudioMeleeItem?: {
        id?: GraphCacheResolver<
            WithTypename<DesignStudioMeleeItem>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        melee?: GraphCacheResolver<
            WithTypename<DesignStudioMeleeItem>,
            Record<string, never>,
            WithTypename<Melee> | string
        >
        quantity?: GraphCacheResolver<
            WithTypename<DesignStudioMeleeItem>,
            Record<string, never>,
            Scalars['Int'] | string
        >
    }
    DesignStudioProductAdditionalResize?: {
        cantBeResized?: GraphCacheResolver<
            WithTypename<DesignStudioProductAdditionalResize>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        cantBeReturned?: GraphCacheResolver<
            WithTypename<DesignStudioProductAdditionalResize>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        finalQuotation?: GraphCacheResolver<
            WithTypename<DesignStudioProductAdditionalResize>,
            Record<string, never>,
            | WithTypename<QuotationEngagementRing>
            | WithTypename<QuotationWeddingRing>
            | string
        >
        id?: GraphCacheResolver<
            WithTypename<DesignStudioProductAdditionalResize>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        isAutofinalizable?: GraphCacheResolver<
            WithTypename<DesignStudioProductAdditionalResize>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        name?: GraphCacheResolver<
            WithTypename<DesignStudioProductAdditionalResize>,
            Record<string, never>,
            Scalars['String'] | string
        >
        orderProduct?: GraphCacheResolver<
            WithTypename<DesignStudioProductAdditionalResize>,
            Record<string, never>,
            WithTypename<OrderProduct> | string
        >
        quotations?: GraphCacheResolver<
            WithTypename<DesignStudioProductAdditionalResize>,
            Record<string, never>,
            Array<
                | WithTypename<QuotationEngagementRing>
                | WithTypename<QuotationWeddingRing>
                | string
            >
        >
    }
    DesignStudioProductCustom?: {
        cantBeResized?: GraphCacheResolver<
            WithTypename<DesignStudioProductCustom>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        cantBeReturned?: GraphCacheResolver<
            WithTypename<DesignStudioProductCustom>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        finalQuotation?: GraphCacheResolver<
            WithTypename<DesignStudioProductCustom>,
            Record<string, never>,
            | WithTypename<QuotationEngagementRing>
            | WithTypename<QuotationWeddingRing>
            | string
        >
        id?: GraphCacheResolver<
            WithTypename<DesignStudioProductCustom>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        isAutofinalizable?: GraphCacheResolver<
            WithTypename<DesignStudioProductCustom>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        name?: GraphCacheResolver<
            WithTypename<DesignStudioProductCustom>,
            Record<string, never>,
            Scalars['String'] | string
        >
        orderProduct?: GraphCacheResolver<
            WithTypename<DesignStudioProductCustom>,
            Record<string, never>,
            WithTypename<OrderProduct> | string
        >
        quotations?: GraphCacheResolver<
            WithTypename<DesignStudioProductCustom>,
            Record<string, never>,
            Array<
                | WithTypename<QuotationEngagementRing>
                | WithTypename<QuotationWeddingRing>
                | string
            >
        >
    }
    DesignStudioProductEngagementRing?: {
        availableSizes?: GraphCacheResolver<
            WithTypename<DesignStudioProductEngagementRing>,
            Record<string, never>,
            Array<WithTypename<RingSizeOrRecommendedRingSize> | string>
        >
        cantBeResized?: GraphCacheResolver<
            WithTypename<DesignStudioProductEngagementRing>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        cantBeReturned?: GraphCacheResolver<
            WithTypename<DesignStudioProductEngagementRing>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        engraving?: GraphCacheResolver<
            WithTypename<DesignStudioProductEngagementRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        finalQuotation?: GraphCacheResolver<
            WithTypename<DesignStudioProductEngagementRing>,
            Record<string, never>,
            | WithTypename<QuotationEngagementRing>
            | WithTypename<QuotationWeddingRing>
            | string
        >
        id?: GraphCacheResolver<
            WithTypename<DesignStudioProductEngagementRing>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        isAutofinalizable?: GraphCacheResolver<
            WithTypename<DesignStudioProductEngagementRing>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        name?: GraphCacheResolver<
            WithTypename<DesignStudioProductEngagementRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        orderProduct?: GraphCacheResolver<
            WithTypename<DesignStudioProductEngagementRing>,
            Record<string, never>,
            WithTypename<OrderProduct> | string
        >
        quotations?: GraphCacheResolver<
            WithTypename<DesignStudioProductEngagementRing>,
            Record<string, never>,
            Array<WithTypename<QuotationEngagementRing> | string>
        >
        size?: GraphCacheResolver<
            WithTypename<DesignStudioProductEngagementRing>,
            Record<string, never>,
            WithTypename<RingSizeOrRecommendedRingSize> | string
        >
    }
    DesignStudioProductGeneric?: {
        cantBeResized?: GraphCacheResolver<
            WithTypename<DesignStudioProductGeneric>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        cantBeReturned?: GraphCacheResolver<
            WithTypename<DesignStudioProductGeneric>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        customer?: GraphCacheResolver<
            WithTypename<DesignStudioProductGeneric>,
            Record<string, never>,
            WithTypename<Customer> | string
        >
        finalQuotation?: GraphCacheResolver<
            WithTypename<DesignStudioProductGeneric>,
            Record<string, never>,
            | WithTypename<QuotationEngagementRing>
            | WithTypename<QuotationWeddingRing>
            | string
        >
        id?: GraphCacheResolver<
            WithTypename<DesignStudioProductGeneric>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        isAutofinalizable?: GraphCacheResolver<
            WithTypename<DesignStudioProductGeneric>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        name?: GraphCacheResolver<
            WithTypename<DesignStudioProductGeneric>,
            Record<string, never>,
            Scalars['String'] | string
        >
        orderProduct?: GraphCacheResolver<
            WithTypename<DesignStudioProductGeneric>,
            Record<string, never>,
            WithTypename<OrderProduct> | string
        >
        quotations?: GraphCacheResolver<
            WithTypename<DesignStudioProductGeneric>,
            Record<string, never>,
            Array<
                | WithTypename<QuotationEngagementRing>
                | WithTypename<QuotationWeddingRing>
                | string
            >
        >
    }
    DesignStudioProductLooseStone?: {
        cantBeResized?: GraphCacheResolver<
            WithTypename<DesignStudioProductLooseStone>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        cantBeReturned?: GraphCacheResolver<
            WithTypename<DesignStudioProductLooseStone>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        finalQuotation?: GraphCacheResolver<
            WithTypename<DesignStudioProductLooseStone>,
            Record<string, never>,
            | WithTypename<QuotationEngagementRing>
            | WithTypename<QuotationWeddingRing>
            | string
        >
        id?: GraphCacheResolver<
            WithTypename<DesignStudioProductLooseStone>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        isAutofinalizable?: GraphCacheResolver<
            WithTypename<DesignStudioProductLooseStone>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        name?: GraphCacheResolver<
            WithTypename<DesignStudioProductLooseStone>,
            Record<string, never>,
            Scalars['String'] | string
        >
        orderProduct?: GraphCacheResolver<
            WithTypename<DesignStudioProductLooseStone>,
            Record<string, never>,
            WithTypename<OrderProduct> | string
        >
        quotations?: GraphCacheResolver<
            WithTypename<DesignStudioProductLooseStone>,
            Record<string, never>,
            Array<
                | WithTypename<QuotationEngagementRing>
                | WithTypename<QuotationWeddingRing>
                | string
            >
        >
    }
    DesignStudioProductWeddingRing?: {
        availableSizes?: GraphCacheResolver<
            WithTypename<DesignStudioProductWeddingRing>,
            Record<string, never>,
            Array<WithTypename<RingSizeOrRecommendedRingSize> | string>
        >
        cantBeResized?: GraphCacheResolver<
            WithTypename<DesignStudioProductWeddingRing>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        cantBeReturned?: GraphCacheResolver<
            WithTypename<DesignStudioProductWeddingRing>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        engraving?: GraphCacheResolver<
            WithTypename<DesignStudioProductWeddingRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        finalQuotation?: GraphCacheResolver<
            WithTypename<DesignStudioProductWeddingRing>,
            Record<string, never>,
            | WithTypename<QuotationEngagementRing>
            | WithTypename<QuotationWeddingRing>
            | string
        >
        id?: GraphCacheResolver<
            WithTypename<DesignStudioProductWeddingRing>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        isAutofinalizable?: GraphCacheResolver<
            WithTypename<DesignStudioProductWeddingRing>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        name?: GraphCacheResolver<
            WithTypename<DesignStudioProductWeddingRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        orderProduct?: GraphCacheResolver<
            WithTypename<DesignStudioProductWeddingRing>,
            Record<string, never>,
            WithTypename<OrderProduct> | string
        >
        quotations?: GraphCacheResolver<
            WithTypename<DesignStudioProductWeddingRing>,
            Record<string, never>,
            Array<WithTypename<QuotationWeddingRing> | string>
        >
        size?: GraphCacheResolver<
            WithTypename<DesignStudioProductWeddingRing>,
            Record<string, never>,
            WithTypename<RingSizeOrRecommendedRingSize> | string
        >
    }
    DesignStudioSignatureStone?: {
        id?: GraphCacheResolver<
            WithTypename<DesignStudioSignatureStone>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        melee?: GraphCacheResolver<
            WithTypename<DesignStudioSignatureStone>,
            Record<string, never>,
            WithTypename<Melee> | string
        >
    }
    DesiredDeliveryDateInvalidError?: {
        message?: GraphCacheResolver<
            WithTypename<DesiredDeliveryDateInvalidError>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    EngagementRingDesignFeatureLabel?: {
        icon?: GraphCacheResolver<
            WithTypename<EngagementRingDesignFeatureLabel>,
            Record<string, never>,
            WithTypename<Asset> | string
        >
        systemCode?: GraphCacheResolver<
            WithTypename<EngagementRingDesignFeatureLabel>,
            Record<string, never>,
            EngagementRingDesignFeatureLabelCode | string
        >
        translation?: GraphCacheResolver<
            WithTypename<EngagementRingDesignFeatureLabel>,
            EngagementRingDesignFeatureLabelTranslationArgs,
            WithTypename<ProductLabelTranslation> | string
        >
    }
    EngagementRingDesignStyleLabel?: {
        icon?: GraphCacheResolver<
            WithTypename<EngagementRingDesignStyleLabel>,
            Record<string, never>,
            WithTypename<Asset> | string
        >
        systemCode?: GraphCacheResolver<
            WithTypename<EngagementRingDesignStyleLabel>,
            Record<string, never>,
            EngagementRingDesignStyleLabelCode | string
        >
        translation?: GraphCacheResolver<
            WithTypename<EngagementRingDesignStyleLabel>,
            EngagementRingDesignStyleLabelTranslationArgs,
            WithTypename<ProductLabelTranslation> | string
        >
    }
    EngagementRingStoneRecommendationCard?: {
        description?: GraphCacheResolver<
            WithTypename<EngagementRingStoneRecommendationCard>,
            Record<string, never>,
            Scalars['String'] | string
        >
        notFoundContent?: GraphCacheResolver<
            WithTypename<EngagementRingStoneRecommendationCard>,
            Record<string, never>,
            Array<WithTypename<ContentComponentItem> | string>
        >
        notSupportedContent?: GraphCacheResolver<
            WithTypename<EngagementRingStoneRecommendationCard>,
            Record<string, never>,
            Array<WithTypename<ContentComponentItem> | string>
        >
        title?: GraphCacheResolver<
            WithTypename<EngagementRingStoneRecommendationCard>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    EngagementRingStoneRecommendationNaturalDiamonds?: {
        forBalanceCard?: GraphCacheResolver<
            WithTypename<EngagementRingStoneRecommendationNaturalDiamonds>,
            Record<string, never>,
            WithTypename<EngagementRingStoneRecommendationCard> | string
        >
        forSizeCard?: GraphCacheResolver<
            WithTypename<EngagementRingStoneRecommendationNaturalDiamonds>,
            Record<string, never>,
            WithTypename<EngagementRingStoneRecommendationCard> | string
        >
        labGrownAlternative?: GraphCacheResolver<
            WithTypename<EngagementRingStoneRecommendationNaturalDiamonds>,
            Record<string, never>,
            WithTypename<EngagementRingStoneRecommendationCard> | string
        >
    }
    EngagementRingStoneRecommendationNonSkuGemStoneCard?: {
        color?: GraphCacheResolver<
            WithTypename<EngagementRingStoneRecommendationNonSkuGemStoneCard>,
            Record<string, never>,
            CmsGemstoneColorCode | string
        >
        content?: GraphCacheResolver<
            WithTypename<EngagementRingStoneRecommendationNonSkuGemStoneCard>,
            Record<string, never>,
            WithTypename<EngagementRingStoneRecommendationCard> | string
        >
    }
    EngagementRingStoneRecommendationNonSkuLabGrown?: {
        forPriceCard?: GraphCacheResolver<
            WithTypename<EngagementRingStoneRecommendationNonSkuLabGrown>,
            Record<string, never>,
            WithTypename<EngagementRingStoneRecommendationCard> | string
        >
        forSizeCard?: GraphCacheResolver<
            WithTypename<EngagementRingStoneRecommendationNonSkuLabGrown>,
            Record<string, never>,
            WithTypename<EngagementRingStoneRecommendationCard> | string
        >
        naturalDiamondAlternative?: GraphCacheResolver<
            WithTypename<EngagementRingStoneRecommendationNonSkuLabGrown>,
            Record<string, never>,
            WithTypename<EngagementRingStoneRecommendationCard> | string
        >
    }
    EngagementRingStoneRecommendations?: {
        blocks?: GraphCacheResolver<
            WithTypename<EngagementRingStoneRecommendations>,
            Record<string, never>,
            Array<WithTypename<Block> | string>
        >
        fullSearchButtonText?: GraphCacheResolver<
            WithTypename<EngagementRingStoneRecommendations>,
            Record<string, never>,
            Scalars['String'] | string
        >
        introductionText?: GraphCacheResolver<
            WithTypename<EngagementRingStoneRecommendations>,
            Record<string, never>,
            Scalars['String'] | string
        >
        naturalDiamonds?: GraphCacheResolver<
            WithTypename<EngagementRingStoneRecommendations>,
            Record<string, never>,
            | WithTypename<EngagementRingStoneRecommendationNaturalDiamonds>
            | string
        >
        nonSkuGemStones?: GraphCacheResolver<
            WithTypename<EngagementRingStoneRecommendations>,
            EngagementRingStoneRecommendationsNonSkuGemStonesArgs,
            Array<
                | WithTypename<EngagementRingStoneRecommendationNonSkuGemStoneCard>
                | string
            >
        >
        nonSkuLabGrown?: GraphCacheResolver<
            WithTypename<EngagementRingStoneRecommendations>,
            Record<string, never>,
            | WithTypename<EngagementRingStoneRecommendationNonSkuLabGrown>
            | string
        >
    }
    EngagementRingStyleLabel?: {
        icon?: GraphCacheResolver<
            WithTypename<EngagementRingStyleLabel>,
            Record<string, never>,
            WithTypename<Asset> | string
        >
        systemCode?: GraphCacheResolver<
            WithTypename<EngagementRingStyleLabel>,
            Record<string, never>,
            EngagementRingStyleLabelCode | string
        >
        translation?: GraphCacheResolver<
            WithTypename<EngagementRingStyleLabel>,
            EngagementRingStyleLabelTranslationArgs,
            WithTypename<ProductLabelTranslation> | string
        >
    }
    EnquiryConsultation?: {
        consultation?: GraphCacheResolver<
            WithTypename<EnquiryConsultation>,
            Record<string, never>,
            WithTypename<BookingConsultation> | string
        >
        id?: GraphCacheResolver<
            WithTypename<EnquiryConsultation>,
            Record<string, never>,
            Scalars['ID'] | string
        >
    }
    EnquiryEngagementRingAddToCart?: {
        product?: GraphCacheResolver<
            WithTypename<EnquiryEngagementRingAddToCart>,
            Record<string, never>,
            WithTypename<DesignStudioProductEngagementRing> | string
        >
    }
    EnquiryResponseExistingCustomer?: {
        marketingCloudForm?: GraphCacheResolver<
            WithTypename<EnquiryResponseExistingCustomer>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    EnquiryResponseNewCustomer?: {
        customer?: GraphCacheResolver<
            WithTypename<EnquiryResponseNewCustomer>,
            Record<string, never>,
            WithTypename<CustomerRegistrationResponse> | string
        >
        marketingCloudForm?: GraphCacheResolver<
            WithTypename<EnquiryResponseNewCustomer>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    EnquiryWeddingRingAddToCart?: {
        product?: GraphCacheResolver<
            WithTypename<EnquiryWeddingRingAddToCart>,
            Record<string, never>,
            WithTypename<DesignStudioProductWeddingRing> | string
        >
    }
    FaqQuestion?: {
        content?: GraphCacheResolver<
            WithTypename<FaqQuestion>,
            Record<string, never>,
            Array<WithTypename<ContentComponentItem> | string>
        >
        expandedByDefault?: GraphCacheResolver<
            WithTypename<FaqQuestion>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        question?: GraphCacheResolver<
            WithTypename<FaqQuestion>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    FaqSection?: {
        questions?: GraphCacheResolver<
            WithTypename<FaqSection>,
            Record<string, never>,
            Array<WithTypename<FaqQuestion> | string>
        >
        title?: GraphCacheResolver<
            WithTypename<FaqSection>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    Footer?: {
        columns?: GraphCacheResolver<
            WithTypename<Footer>,
            Record<string, never>,
            Array<WithTypename<FooterColumn> | string>
        >
        copyright?: GraphCacheResolver<
            WithTypename<Footer>,
            Record<string, never>,
            Scalars['String'] | string
        >
        logos?: GraphCacheResolver<
            WithTypename<Footer>,
            Record<string, never>,
            Array<WithTypename<FooterLogo> | string>
        >
    }
    FooterColumn?: {
        items?: GraphCacheResolver<
            WithTypename<FooterColumn>,
            Record<string, never>,
            Array<WithTypename<FooterColumnItem> | string>
        >
    }
    FooterColumnItemLink?: {
        link?: GraphCacheResolver<
            WithTypename<FooterColumnItemLink>,
            Record<string, never>,
            WithTypename<Link> | string
        >
        text?: GraphCacheResolver<
            WithTypename<FooterColumnItemLink>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    FooterColumnItemLinkList?: {
        links?: GraphCacheResolver<
            WithTypename<FooterColumnItemLinkList>,
            Record<string, never>,
            Array<WithTypename<FooterColumnItemLink> | string>
        >
    }
    FooterColumnItemSeparator?: {
        line?: GraphCacheResolver<
            WithTypename<FooterColumnItemSeparator>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
    }
    FooterColumnItemText?: {
        text?: GraphCacheResolver<
            WithTypename<FooterColumnItemText>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    FooterColumnItemTitle?: {
        title?: GraphCacheResolver<
            WithTypename<FooterColumnItemTitle>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    FooterColumnItemWorkingHours?: {
        workingHours?: GraphCacheResolver<
            WithTypename<FooterColumnItemWorkingHours>,
            FooterColumnItemWorkingHoursWorkingHoursArgs,
            Array<WithTypename<WorkingHours> | string>
        >
    }
    FooterLogo?: {
        link?: GraphCacheResolver<
            WithTypename<FooterLogo>,
            Record<string, never>,
            Scalars['String'] | string
        >
        logo?: GraphCacheResolver<
            WithTypename<FooterLogo>,
            Record<string, never>,
            WithTypename<Image> | string
        >
    }
    GalleryCarouselCard?: {
        image?: GraphCacheResolver<
            WithTypename<GalleryCarouselCard>,
            Record<string, never>,
            WithTypename<Image> | string
        >
        link?: GraphCacheResolver<
            WithTypename<GalleryCarouselCard>,
            Record<string, never>,
            WithTypename<Link> | string
        >
    }
    GalleryItem?: {
        image?: GraphCacheResolver<
            WithTypename<GalleryItem>,
            Record<string, never>,
            WithTypename<Image> | string
        >
    }
    GalleryWithEnquiryCard?: {
        caption?: GraphCacheResolver<
            WithTypename<GalleryWithEnquiryCard>,
            Record<string, never>,
            Scalars['String'] | string
        >
        image?: GraphCacheResolver<
            WithTypename<GalleryWithEnquiryCard>,
            Record<string, never>,
            WithTypename<Image> | string
        >
        slug?: GraphCacheResolver<
            WithTypename<GalleryWithEnquiryCard>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    GemsApiPriceBounds?: {
        max?: GraphCacheResolver<
            WithTypename<GemsApiPriceBounds>,
            Record<string, never>,
            Scalars['Float'] | string
        >
        min?: GraphCacheResolver<
            WithTypename<GemsApiPriceBounds>,
            Record<string, never>,
            Scalars['Float'] | string
        >
    }
    GemsApiStone?: {
        identifier?: GraphCacheResolver<
            WithTypename<GemsApiStone>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        stone?: GraphCacheResolver<
            WithTypename<GemsApiStone>,
            Record<string, never>,
            WithTypename<GemsApi_Stone> | string
        >
    }
    GemsApi_Bounds?: {
        categories?: GraphCacheResolver<
            WithTypename<GemsApi_Bounds>,
            Record<string, never>,
            Array<WithTypename<GemsApi_StoneCategoryInfo> | string>
        >
        category?: GraphCacheResolver<
            WithTypename<GemsApi_Bounds>,
            Record<string, never>,
            Array<GemsApi_StoneCategory | string>
        >
        clarities?: GraphCacheResolver<
            WithTypename<GemsApi_Bounds>,
            Record<string, never>,
            Array<WithTypename<GemsApi_StoneClarityInfo> | string>
        >
        clarity?: GraphCacheResolver<
            WithTypename<GemsApi_Bounds>,
            Record<string, never>,
            Array<GemsApi_StoneClarity | string>
        >
        colors?: GraphCacheResolver<
            WithTypename<GemsApi_Bounds>,
            Record<string, never>,
            Array<WithTypename<GemsApi_StoneColorInfo> | string>
        >
        colour?: GraphCacheResolver<
            WithTypename<GemsApi_Bounds>,
            Record<string, never>,
            Array<GemsApi_StoneColour | string>
        >
        crystal?: GraphCacheResolver<
            WithTypename<GemsApi_Bounds>,
            Record<string, never>,
            Array<GemsApi_StoneCrystal | string>
        >
        crystals?: GraphCacheResolver<
            WithTypename<GemsApi_Bounds>,
            Record<string, never>,
            Array<WithTypename<GemsApi_StoneCrystalInfo> | string>
        >
        cut?: GraphCacheResolver<
            WithTypename<GemsApi_Bounds>,
            Record<string, never>,
            Array<GemsApi_StoneCut | string>
        >
        cuts?: GraphCacheResolver<
            WithTypename<GemsApi_Bounds>,
            Record<string, never>,
            Array<WithTypename<GemsApi_StoneCutInfo> | string>
        >
        deliveryDays?: GraphCacheResolver<
            WithTypename<GemsApi_Bounds>,
            Record<string, never>,
            WithTypename<GemsApi_IntRange> | string
        >
        depth?: GraphCacheResolver<
            WithTypename<GemsApi_Bounds>,
            Record<string, never>,
            WithTypename<GemsApi_Range> | string
        >
        depthPercent?: GraphCacheResolver<
            WithTypename<GemsApi_Bounds>,
            Record<string, never>,
            WithTypename<GemsApi_Range> | string
        >
        fluorescence?: GraphCacheResolver<
            WithTypename<GemsApi_Bounds>,
            Record<string, never>,
            Array<GemsApi_StoneFluorescence | string>
        >
        fluorescences?: GraphCacheResolver<
            WithTypename<GemsApi_Bounds>,
            Record<string, never>,
            Array<WithTypename<GemsApi_StoneFluorescenceInfo> | string>
        >
        grade?: GraphCacheResolver<
            WithTypename<GemsApi_Bounds>,
            Record<string, never>,
            Array<GemsApi_StoneGrade | string>
        >
        grades?: GraphCacheResolver<
            WithTypename<GemsApi_Bounds>,
            Record<string, never>,
            Array<WithTypename<GemsApi_StoneGradeInfo> | string>
        >
        length?: GraphCacheResolver<
            WithTypename<GemsApi_Bounds>,
            Record<string, never>,
            WithTypename<GemsApi_Range> | string
        >
        originCountry?: GraphCacheResolver<
            WithTypename<GemsApi_Bounds>,
            Record<string, never>,
            Array<GemsApi_Country | string>
        >
        polish?: GraphCacheResolver<
            WithTypename<GemsApi_Bounds>,
            Record<string, never>,
            Array<GemsApi_StonePolish | string>
        >
        polishes?: GraphCacheResolver<
            WithTypename<GemsApi_Bounds>,
            Record<string, never>,
            Array<WithTypename<GemsApi_StonePolishInfo> | string>
        >
        price?: GraphCacheResolver<
            WithTypename<GemsApi_Bounds>,
            Record<string, never>,
            WithTypename<GemsApi_PriceRange> | string
        >
        priceByShape?: GraphCacheResolver<
            WithTypename<GemsApi_Bounds>,
            Record<string, never>,
            Array<WithTypename<GemsApi_PriceRangeByShape> | string>
        >
        ratio?: GraphCacheResolver<
            WithTypename<GemsApi_Bounds>,
            Record<string, never>,
            WithTypename<GemsApi_Range> | string
        >
        shape?: GraphCacheResolver<
            WithTypename<GemsApi_Bounds>,
            Record<string, never>,
            Array<GemsApi_StoneShape | string>
        >
        shapes?: GraphCacheResolver<
            WithTypename<GemsApi_Bounds>,
            Record<string, never>,
            Array<WithTypename<GemsApi_StoneShapeInfo> | string>
        >
        shippingFromCountry?: GraphCacheResolver<
            WithTypename<GemsApi_Bounds>,
            Record<string, never>,
            Array<GemsApi_Country | string>
        >
        symmetries?: GraphCacheResolver<
            WithTypename<GemsApi_Bounds>,
            Record<string, never>,
            Array<WithTypename<GemsApi_StoneSymmetryInfo> | string>
        >
        symmetry?: GraphCacheResolver<
            WithTypename<GemsApi_Bounds>,
            Record<string, never>,
            Array<GemsApi_StoneSymmetry | string>
        >
        tablePercent?: GraphCacheResolver<
            WithTypename<GemsApi_Bounds>,
            Record<string, never>,
            WithTypename<GemsApi_Range> | string
        >
        weight?: GraphCacheResolver<
            WithTypename<GemsApi_Bounds>,
            Record<string, never>,
            WithTypename<GemsApi_Range> | string
        >
        width?: GraphCacheResolver<
            WithTypename<GemsApi_Bounds>,
            Record<string, never>,
            WithTypename<GemsApi_Range> | string
        >
    }
    GemsApi_IntRange?: {
        max?: GraphCacheResolver<
            WithTypename<GemsApi_IntRange>,
            Record<string, never>,
            Scalars['Int'] | string
        >
        min?: GraphCacheResolver<
            WithTypename<GemsApi_IntRange>,
            Record<string, never>,
            Scalars['Int'] | string
        >
    }
    GemsApi_Pagination?: {
        limit?: GraphCacheResolver<
            WithTypename<GemsApi_Pagination>,
            Record<string, never>,
            Scalars['Int'] | string
        >
        page?: GraphCacheResolver<
            WithTypename<GemsApi_Pagination>,
            Record<string, never>,
            Scalars['Int'] | string
        >
        pages?: GraphCacheResolver<
            WithTypename<GemsApi_Pagination>,
            Record<string, never>,
            Scalars['Int'] | string
        >
        total?: GraphCacheResolver<
            WithTypename<GemsApi_Pagination>,
            Record<string, never>,
            Scalars['Int'] | string
        >
    }
    GemsApi_PricePoint?: {
        market?: GraphCacheResolver<
            WithTypename<GemsApi_PricePoint>,
            Record<string, never>,
            Scalars['String'] | string
        >
        price?: GraphCacheResolver<
            WithTypename<GemsApi_PricePoint>,
            Record<string, never>,
            Scalars['Float'] | string
        >
    }
    GemsApi_PriceRange?: {
        max?: GraphCacheResolver<
            WithTypename<GemsApi_PriceRange>,
            Record<string, never>,
            Scalars['Float'] | string
        >
        maxInCurrency?: GraphCacheResolver<
            WithTypename<GemsApi_PriceRange>,
            GemsApi_PriceRangeMaxInCurrencyArgs,
            WithTypename<Money> | string
        >
        min?: GraphCacheResolver<
            WithTypename<GemsApi_PriceRange>,
            Record<string, never>,
            Scalars['Float'] | string
        >
        minInCurrency?: GraphCacheResolver<
            WithTypename<GemsApi_PriceRange>,
            GemsApi_PriceRangeMinInCurrencyArgs,
            WithTypename<Money> | string
        >
    }
    GemsApi_PriceRangeByShape?: {
        range?: GraphCacheResolver<
            WithTypename<GemsApi_PriceRangeByShape>,
            Record<string, never>,
            WithTypename<GemsApi_PriceRange> | string
        >
        shape?: GraphCacheResolver<
            WithTypename<GemsApi_PriceRangeByShape>,
            Record<string, never>,
            GemsApi_StoneShape | string
        >
    }
    GemsApi_Range?: {
        max?: GraphCacheResolver<
            WithTypename<GemsApi_Range>,
            Record<string, never>,
            Scalars['Float'] | string
        >
        min?: GraphCacheResolver<
            WithTypename<GemsApi_Range>,
            Record<string, never>,
            Scalars['Float'] | string
        >
    }
    GemsApi_SelectedRange?: {
        max?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedRange>,
            Record<string, never>,
            Scalars['Float'] | string
        >
        min?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedRange>,
            Record<string, never>,
            Scalars['Float'] | string
        >
    }
    GemsApi_SelectedSorting?: {
        direction?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedSorting>,
            Record<string, never>,
            GemsApi_SortingDirection | string
        >
        field?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedSorting>,
            Record<string, never>,
            GemsApi_SortingField | string
        >
    }
    GemsApi_SelectedStoneFilters?: {
        category?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedStoneFilters>,
            Record<string, never>,
            Array<GemsApi_StoneCategory | string>
        >
        clarity?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedStoneFilters>,
            Record<string, never>,
            Array<GemsApi_StoneClarity | string>
        >
        collection?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedStoneFilters>,
            Record<string, never>,
            Array<Scalars['String'] | string>
        >
        colour?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedStoneFilters>,
            Record<string, never>,
            Array<GemsApi_StoneColour | string>
        >
        costPrice?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedStoneFilters>,
            Record<string, never>,
            WithTypename<GemsApi_SelectedRange> | string
        >
        crystal?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedStoneFilters>,
            Record<string, never>,
            Array<GemsApi_StoneCrystal | string>
        >
        cut?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedStoneFilters>,
            Record<string, never>,
            Array<GemsApi_StoneCut | string>
        >
        depth?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedStoneFilters>,
            Record<string, never>,
            WithTypename<GemsApi_SelectedRange> | string
        >
        depthPercent?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedStoneFilters>,
            Record<string, never>,
            WithTypename<GemsApi_SelectedRange> | string
        >
        fluorescence?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedStoneFilters>,
            Record<string, never>,
            Array<GemsApi_StoneFluorescence | string>
        >
        grade?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedStoneFilters>,
            Record<string, never>,
            Array<GemsApi_StoneGrade | string>
        >
        hasPhoto?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedStoneFilters>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        isCanadaMark?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedStoneFilters>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        isDtlReport?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedStoneFilters>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        isRtg?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedStoneFilters>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        isScsReport?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedStoneFilters>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        isStock?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedStoneFilters>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        lab?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedStoneFilters>,
            Record<string, never>,
            Array<GemsApi_CertificateLab | string>
        >
        length?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedStoneFilters>,
            Record<string, never>,
            WithTypename<GemsApi_SelectedRange> | string
        >
        notClarity?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedStoneFilters>,
            Record<string, never>,
            Array<GemsApi_StoneClarity | string>
        >
        notColour?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedStoneFilters>,
            Record<string, never>,
            Array<GemsApi_StoneColour | string>
        >
        notSymmetry?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedStoneFilters>,
            Record<string, never>,
            Array<GemsApi_StoneSymmetry | string>
        >
        originCountry?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedStoneFilters>,
            Record<string, never>,
            Array<GemsApi_Country | string>
        >
        polish?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedStoneFilters>,
            Record<string, never>,
            Array<GemsApi_StonePolish | string>
        >
        price?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedStoneFilters>,
            Record<string, never>,
            WithTypename<GemsApi_SelectedRange> | string
        >
        priceIndex?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedStoneFilters>,
            Record<string, never>,
            Scalars['String'] | string
        >
        ratio?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedStoneFilters>,
            Record<string, never>,
            WithTypename<GemsApi_SelectedRange> | string
        >
        shape?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedStoneFilters>,
            Record<string, never>,
            Array<GemsApi_StoneShape | string>
        >
        shippingFrom?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedStoneFilters>,
            Record<string, never>,
            Array<GemsApi_Country | string>
        >
        sorting?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedStoneFilters>,
            Record<string, never>,
            WithTypename<GemsApi_SelectedSorting> | string
        >
        symmetry?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedStoneFilters>,
            Record<string, never>,
            Array<GemsApi_StoneSymmetry | string>
        >
        tablePercent?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedStoneFilters>,
            Record<string, never>,
            WithTypename<GemsApi_SelectedRange> | string
        >
        weight?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedStoneFilters>,
            Record<string, never>,
            WithTypename<GemsApi_SelectedRange> | string
        >
        width?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedStoneFilters>,
            Record<string, never>,
            WithTypename<GemsApi_SelectedRange> | string
        >
        withOriginCountry?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedStoneFilters>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        withVideo?: GraphCacheResolver<
            WithTypename<GemsApi_SelectedStoneFilters>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
    }
    GemsApi_Stone?: {
        blackInclusion?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            GemsApi_StoneBlackInclusion | string
        >
        category?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            GemsApi_StoneCategory | string
        >
        categoryWithInfo?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            WithTypename<GemsApi_StoneCategoryInfo> | string
        >
        certificates?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            WithTypename<GemsApi_StoneCertificates> | string
        >
        clarity?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            GemsApi_StoneClarity | string
        >
        clarityWithInfo?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            WithTypename<GemsApi_StoneClarityInfo> | string
        >
        colorWithInfo?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            WithTypename<GemsApi_StoneColorInfo> | string
        >
        colour?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            GemsApi_StoneColour | string
        >
        colourShade?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            GemsApi_StoneColourShade | string
        >
        containsEngagementRings?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        crownAngle?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            Scalars['Float'] | string
        >
        crownHeight?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            Scalars['Float'] | string
        >
        crystal?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            GemsApi_StoneCrystal | string
        >
        crystalWithInfo?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            WithTypename<GemsApi_StoneCrystalInfo> | string
        >
        culet?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            GemsApi_StoneCulet | string
        >
        cut?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            GemsApi_StoneCut | string
        >
        cutWithInfo?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            WithTypename<GemsApi_StoneCutInfo> | string
        >
        deliveryDays?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            Scalars['Int'] | string
        >
        depth?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            Scalars['Float'] | string
        >
        depthPercent?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            Scalars['Float'] | string
        >
        dtlReport?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            WithTypename<GemsApi_DtlReport> | string
        >
        externalId?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            Scalars['String'] | string
        >
        eyeClean?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            GemsApi_StoneEyeClean | string
        >
        feedIdentifier?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            Scalars['String'] | string
        >
        fluorescence?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            GemsApi_StoneFluorescence | string
        >
        fluorescenceColour?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            GemsApi_StoneFluorescenceColour | string
        >
        fluorescenceWithInfo?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            WithTypename<GemsApi_StoneFluorescenceInfo> | string
        >
        girdleMax?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            GemsApi_StoneGirdle | string
        >
        girdleMin?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            GemsApi_StoneGirdle | string
        >
        grade?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            GemsApi_StoneGrade | string
        >
        gradeWithInfo?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            WithTypename<GemsApi_StoneGradeInfo> | string
        >
        growthMethod?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            GemsApi_StoneGrowthMethod | string
        >
        hasPublicImages?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        identifier?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            Scalars['GemsApi_StoneIdentifier'] | string
        >
        image?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            WithTypename<GemsApi_StoneImage> | string
        >
        images?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            Array<WithTypename<GemsApi_StoneImage> | string>
        >
        isB2B?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        isCanadaMark?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        isCertificateVerified?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        isHideCertificateNumber?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        isHideMeasurements?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        isMilky?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        isTreated?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        isValidB2C?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        length?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            Scalars['Float'] | string
        >
        originCountry?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            GemsApi_Country | string
        >
        pavilionAngle?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            Scalars['Float'] | string
        >
        pavilionDepth?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            Scalars['Float'] | string
        >
        polish?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            GemsApi_StonePolish | string
        >
        polishWithInfo?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            WithTypename<GemsApi_StonePolishInfo> | string
        >
        pricingNoVat?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            Array<WithTypename<GemsApi_PricePoint> | string>
        >
        ratio?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            Scalars['Float'] | string
        >
        salePrice?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            GemsApi_StoneSalePriceArgs,
            WithTypename<Money> | string
        >
        scsReport?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            Scalars['String'] | string
        >
        shape?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            GemsApi_StoneShape | string
        >
        shapeWithInfo?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            WithTypename<GemsApi_StoneShapeInfo> | string
        >
        shippingFromCountry?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            GemsApi_Country | string
        >
        symmetry?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            GemsApi_StoneSymmetry | string
        >
        symmetryWithInfo?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            WithTypename<GemsApi_StoneSymmetryInfo> | string
        >
        tablePercent?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            Scalars['Float'] | string
        >
        v360Url?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            Scalars['String'] | string
        >
        weight?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            Scalars['Float'] | string
        >
        width?: GraphCacheResolver<
            WithTypename<GemsApi_Stone>,
            Record<string, never>,
            Scalars['Float'] | string
        >
    }
    GemsApi_StoneCategoryInfo?: {
        code?: GraphCacheResolver<
            WithTypename<GemsApi_StoneCategoryInfo>,
            Record<string, never>,
            GemsApi_StoneCategory | string
        >
        info?: GraphCacheResolver<
            WithTypename<GemsApi_StoneCategoryInfo>,
            Record<string, never>,
            WithTypename<StoneCategory> | string
        >
    }
    GemsApi_StoneCertificates?: {
        gcal?: GraphCacheResolver<
            WithTypename<GemsApi_StoneCertificates>,
            Record<string, never>,
            Scalars['String'] | string
        >
        gia?: GraphCacheResolver<
            WithTypename<GemsApi_StoneCertificates>,
            Record<string, never>,
            Scalars['String'] | string
        >
        igi?: GraphCacheResolver<
            WithTypename<GemsApi_StoneCertificates>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    GemsApi_StoneClarityInfo?: {
        code?: GraphCacheResolver<
            WithTypename<GemsApi_StoneClarityInfo>,
            Record<string, never>,
            GemsApi_StoneClarity | string
        >
        info?: GraphCacheResolver<
            WithTypename<GemsApi_StoneClarityInfo>,
            Record<string, never>,
            WithTypename<StoneClarity> | string
        >
    }
    GemsApi_StoneCollection?: {
        collection?: GraphCacheResolver<
            WithTypename<GemsApi_StoneCollection>,
            Record<string, never>,
            Array<WithTypename<GemsApi_Stone> | string>
        >
        filters?: GraphCacheResolver<
            WithTypename<GemsApi_StoneCollection>,
            Record<string, never>,
            WithTypename<GemsApi_SelectedStoneFilters> | string
        >
        pagination?: GraphCacheResolver<
            WithTypename<GemsApi_StoneCollection>,
            Record<string, never>,
            WithTypename<GemsApi_Pagination> | string
        >
    }
    GemsApi_StoneColorInfo?: {
        code?: GraphCacheResolver<
            WithTypename<GemsApi_StoneColorInfo>,
            Record<string, never>,
            GemsApi_StoneColour | string
        >
        info?: GraphCacheResolver<
            WithTypename<GemsApi_StoneColorInfo>,
            Record<string, never>,
            WithTypename<StoneColor> | string
        >
    }
    GemsApi_StoneCrystalInfo?: {
        code?: GraphCacheResolver<
            WithTypename<GemsApi_StoneCrystalInfo>,
            Record<string, never>,
            GemsApi_StoneCrystal | string
        >
        info?: GraphCacheResolver<
            WithTypename<GemsApi_StoneCrystalInfo>,
            Record<string, never>,
            WithTypename<StoneCrystal> | string
        >
    }
    GemsApi_StoneCutInfo?: {
        code?: GraphCacheResolver<
            WithTypename<GemsApi_StoneCutInfo>,
            Record<string, never>,
            GemsApi_StoneCut | string
        >
        info?: GraphCacheResolver<
            WithTypename<GemsApi_StoneCutInfo>,
            Record<string, never>,
            WithTypename<StoneCut> | string
        >
    }
    GemsApi_StoneFluorescenceInfo?: {
        code?: GraphCacheResolver<
            WithTypename<GemsApi_StoneFluorescenceInfo>,
            Record<string, never>,
            GemsApi_StoneFluorescence | string
        >
        info?: GraphCacheResolver<
            WithTypename<GemsApi_StoneFluorescenceInfo>,
            Record<string, never>,
            WithTypename<StoneFluorescence> | string
        >
    }
    GemsApi_StoneGradeInfo?: {
        code?: GraphCacheResolver<
            WithTypename<GemsApi_StoneGradeInfo>,
            Record<string, never>,
            GemsApi_StoneGrade | string
        >
        info?: GraphCacheResolver<
            WithTypename<GemsApi_StoneGradeInfo>,
            Record<string, never>,
            WithTypename<StoneGrade> | string
        >
    }
    GemsApi_StoneImage?: {
        isB2B?: GraphCacheResolver<
            WithTypename<GemsApi_StoneImage>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        url?: GraphCacheResolver<
            WithTypename<GemsApi_StoneImage>,
            Record<string, never>,
            Scalars['GemsApi_Uri'] | string
        >
    }
    GemsApi_StonePolishInfo?: {
        code?: GraphCacheResolver<
            WithTypename<GemsApi_StonePolishInfo>,
            Record<string, never>,
            GemsApi_StonePolish | string
        >
        info?: GraphCacheResolver<
            WithTypename<GemsApi_StonePolishInfo>,
            Record<string, never>,
            WithTypename<StonePolish> | string
        >
    }
    GemsApi_StoneShapeInfo?: {
        code?: GraphCacheResolver<
            WithTypename<GemsApi_StoneShapeInfo>,
            Record<string, never>,
            GemsApi_StoneShape | string
        >
        info?: GraphCacheResolver<
            WithTypename<GemsApi_StoneShapeInfo>,
            Record<string, never>,
            WithTypename<StoneShape> | string
        >
    }
    GemsApi_StoneSymmetryInfo?: {
        code?: GraphCacheResolver<
            WithTypename<GemsApi_StoneSymmetryInfo>,
            Record<string, never>,
            GemsApi_StoneSymmetry | string
        >
        info?: GraphCacheResolver<
            WithTypename<GemsApi_StoneSymmetryInfo>,
            Record<string, never>,
            WithTypename<StoneSymmetry> | string
        >
    }
    GemsApi_dtlReport?: {
        code?: GraphCacheResolver<
            WithTypename<GemsApi_DtlReport>,
            Record<string, never>,
            Scalars['String'] | string
        >
        url?: GraphCacheResolver<
            WithTypename<GemsApi_DtlReport>,
            Record<string, never>,
            Scalars['GemsApi_Uri'] | string
        >
    }
    GenericImage?: {
        mimeType?: GraphCacheResolver<
            WithTypename<GenericImage>,
            Record<string, never>,
            Scalars['String'] | string
        >
        size?: GraphCacheResolver<
            WithTypename<GenericImage>,
            GenericImageSizeArgs,
            WithTypename<MonolithImageSize> | string
        >
        sources?: GraphCacheResolver<
            WithTypename<GenericImage>,
            Record<string, never>,
            Array<WithTypename<ImageSrc> | string>
        >
        url?: GraphCacheResolver<
            WithTypename<GenericImage>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    GeoPoint?: {
        id?: GraphCacheResolver<
            WithTypename<GeoPoint>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        latitude?: GraphCacheResolver<
            WithTypename<GeoPoint>,
            Record<string, never>,
            Scalars['Float'] | string
        >
        longitude?: GraphCacheResolver<
            WithTypename<GeoPoint>,
            Record<string, never>,
            Scalars['Float'] | string
        >
    }
    HistoricalNonSkuGemstone?: {
        caratWeight?: GraphCacheResolver<
            WithTypename<HistoricalNonSkuGemstone>,
            Record<string, never>,
            Scalars['Decimal'] | string
        >
        clarity?: GraphCacheResolver<
            WithTypename<HistoricalNonSkuGemstone>,
            Record<string, never>,
            WithTypename<StoneClarity> | string
        >
        color?: GraphCacheResolver<
            WithTypename<HistoricalNonSkuGemstone>,
            Record<string, never>,
            WithTypename<StoneColor> | string
        >
        colorGrade?: GraphCacheResolver<
            WithTypename<HistoricalNonSkuGemstone>,
            Record<string, never>,
            WithTypename<StoneGrade> | string
        >
        crystal?: GraphCacheResolver<
            WithTypename<HistoricalNonSkuGemstone>,
            Record<string, never>,
            WithTypename<StoneCrystal> | string
        >
        cut?: GraphCacheResolver<
            WithTypename<HistoricalNonSkuGemstone>,
            Record<string, never>,
            WithTypename<StoneCut> | string
        >
        id?: GraphCacheResolver<
            WithTypename<HistoricalNonSkuGemstone>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        image?: GraphCacheResolver<
            WithTypename<HistoricalNonSkuGemstone>,
            Record<string, never>,
            WithTypename<NonSkuImage> | string
        >
        salePrice?: GraphCacheResolver<
            WithTypename<HistoricalNonSkuGemstone>,
            HistoricalNonSkuGemstoneSalePriceArgs,
            WithTypename<Money> | string
        >
        shape?: GraphCacheResolver<
            WithTypename<HistoricalNonSkuGemstone>,
            Record<string, never>,
            WithTypename<StoneShape> | string
        >
    }
    HistoricalNonSkuLabGrown?: {
        caratWeight?: GraphCacheResolver<
            WithTypename<HistoricalNonSkuLabGrown>,
            Record<string, never>,
            Scalars['Decimal'] | string
        >
        clarity?: GraphCacheResolver<
            WithTypename<HistoricalNonSkuLabGrown>,
            Record<string, never>,
            WithTypename<StoneClarity> | string
        >
        color?: GraphCacheResolver<
            WithTypename<HistoricalNonSkuLabGrown>,
            Record<string, never>,
            WithTypename<StoneColor> | string
        >
        crystal?: GraphCacheResolver<
            WithTypename<HistoricalNonSkuLabGrown>,
            Record<string, never>,
            WithTypename<StoneCrystal> | string
        >
        cut?: GraphCacheResolver<
            WithTypename<HistoricalNonSkuLabGrown>,
            Record<string, never>,
            WithTypename<StoneCut> | string
        >
        id?: GraphCacheResolver<
            WithTypename<HistoricalNonSkuLabGrown>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        image?: GraphCacheResolver<
            WithTypename<HistoricalNonSkuLabGrown>,
            Record<string, never>,
            WithTypename<NonSkuImage> | string
        >
        salePrice?: GraphCacheResolver<
            WithTypename<HistoricalNonSkuLabGrown>,
            HistoricalNonSkuLabGrownSalePriceArgs,
            WithTypename<Money> | string
        >
        shape?: GraphCacheResolver<
            WithTypename<HistoricalNonSkuLabGrown>,
            Record<string, never>,
            WithTypename<StoneShape> | string
        >
    }
    IconCarouselItem?: {
        icon?: GraphCacheResolver<
            WithTypename<IconCarouselItem>,
            Record<string, never>,
            Icon | string
        >
        text?: GraphCacheResolver<
            WithTypename<IconCarouselItem>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    Image?: {
        alt?: GraphCacheResolver<
            WithTypename<Image>,
            Record<string, never>,
            Scalars['String'] | string
        >
        caption?: GraphCacheResolver<
            WithTypename<Image>,
            Record<string, never>,
            Scalars['String'] | string
        >
        description?: GraphCacheResolver<
            WithTypename<Image>,
            Record<string, never>,
            Scalars['String'] | string
        >
        filename?: GraphCacheResolver<
            WithTypename<Image>,
            Record<string, never>,
            Scalars['String'] | string
        >
        filesize?: GraphCacheResolver<
            WithTypename<Image>,
            Record<string, never>,
            Scalars['Int'] | string
        >
        height?: GraphCacheResolver<
            WithTypename<Image>,
            Record<string, never>,
            Scalars['Int'] | string
        >
        id?: GraphCacheResolver<
            WithTypename<Image>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        mimeType?: GraphCacheResolver<
            WithTypename<Image>,
            Record<string, never>,
            Scalars['String'] | string
        >
        name?: GraphCacheResolver<
            WithTypename<Image>,
            Record<string, never>,
            Scalars['String'] | string
        >
        size?: GraphCacheResolver<
            WithTypename<Image>,
            ImageSizeArgs,
            WithTypename<ImageSize> | string
        >
        sizes?: GraphCacheResolver<
            WithTypename<Image>,
            Record<string, never>,
            Array<WithTypename<ImageSize> | string>
        >
        sources?: GraphCacheResolver<
            WithTypename<Image>,
            Record<string, never>,
            Array<WithTypename<ImageSrc> | string>
        >
        title?: GraphCacheResolver<
            WithTypename<Image>,
            Record<string, never>,
            Scalars['String'] | string
        >
        url?: GraphCacheResolver<
            WithTypename<Image>,
            Record<string, never>,
            Scalars['String'] | string
        >
        width?: GraphCacheResolver<
            WithTypename<Image>,
            Record<string, never>,
            Scalars['Int'] | string
        >
    }
    ImageSize?: {
        mimeType?: GraphCacheResolver<
            WithTypename<ImageSize>,
            Record<string, never>,
            Scalars['String'] | string
        >
        name?: GraphCacheResolver<
            WithTypename<ImageSize>,
            Record<string, never>,
            ImageSizeName | string
        >
        sources?: GraphCacheResolver<
            WithTypename<ImageSize>,
            Record<string, never>,
            Array<WithTypename<ImageSrc> | string>
        >
        url?: GraphCacheResolver<
            WithTypename<ImageSize>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    ImageSrc?: {
        mimeType?: GraphCacheResolver<
            WithTypename<ImageSrc>,
            Record<string, never>,
            Scalars['String'] | string
        >
        url?: GraphCacheResolver<
            WithTypename<ImageSrc>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    InstagramPost?: {
        image?: GraphCacheResolver<
            WithTypename<InstagramPost>,
            Record<string, never>,
            WithTypename<Image> | string
        >
        link?: GraphCacheResolver<
            WithTypename<InstagramPost>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    InvalidateCacheResult?: {
        errors?: GraphCacheResolver<
            WithTypename<InvalidateCacheResult>,
            Record<string, never>,
            Array<WithTypename<InvalidateCacheResultError> | string>
        >
        success?: GraphCacheResolver<
            WithTypename<InvalidateCacheResult>,
            Record<string, never>,
            Array<WithTypename<InvalidateCacheResultSuccess> | string>
        >
    }
    InvalidateCacheResultError?: {
        error?: GraphCacheResolver<
            WithTypename<InvalidateCacheResultError>,
            Record<string, never>,
            Scalars['String'] | string
        >
        key?: GraphCacheResolver<
            WithTypename<InvalidateCacheResultError>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    InvalidateCacheResultSuccess?: {
        key?: GraphCacheResolver<
            WithTypename<InvalidateCacheResultSuccess>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    JewelleryBraceletProductStyleLabel?: {
        icon?: GraphCacheResolver<
            WithTypename<JewelleryBraceletProductStyleLabel>,
            Record<string, never>,
            WithTypename<Asset> | string
        >
        systemCode?: GraphCacheResolver<
            WithTypename<JewelleryBraceletProductStyleLabel>,
            Record<string, never>,
            JewelleryBraceletProductStyle | string
        >
        translation?: GraphCacheResolver<
            WithTypename<JewelleryBraceletProductStyleLabel>,
            JewelleryBraceletProductStyleLabelTranslationArgs,
            WithTypename<ProductLabelTranslation> | string
        >
    }
    JewelleryDesignFeatureLabel?: {
        icon?: GraphCacheResolver<
            WithTypename<JewelleryDesignFeatureLabel>,
            Record<string, never>,
            WithTypename<Asset> | string
        >
        systemCode?: GraphCacheResolver<
            WithTypename<JewelleryDesignFeatureLabel>,
            Record<string, never>,
            JewelleryDesignFeature | string
        >
        translation?: GraphCacheResolver<
            WithTypename<JewelleryDesignFeatureLabel>,
            JewelleryDesignFeatureLabelTranslationArgs,
            WithTypename<ProductLabelTranslation> | string
        >
    }
    JewelleryDesignStyleLabel?: {
        icon?: GraphCacheResolver<
            WithTypename<JewelleryDesignStyleLabel>,
            Record<string, never>,
            WithTypename<Asset> | string
        >
        systemCode?: GraphCacheResolver<
            WithTypename<JewelleryDesignStyleLabel>,
            Record<string, never>,
            JewelleryDesignStyle | string
        >
        translation?: GraphCacheResolver<
            WithTypename<JewelleryDesignStyleLabel>,
            JewelleryDesignStyleLabelTranslationArgs,
            WithTypename<ProductLabelTranslation> | string
        >
    }
    JewelleryEarringsProductStyleLabel?: {
        icon?: GraphCacheResolver<
            WithTypename<JewelleryEarringsProductStyleLabel>,
            Record<string, never>,
            WithTypename<Asset> | string
        >
        systemCode?: GraphCacheResolver<
            WithTypename<JewelleryEarringsProductStyleLabel>,
            Record<string, never>,
            JewelleryEarringsProductStyle | string
        >
        translation?: GraphCacheResolver<
            WithTypename<JewelleryEarringsProductStyleLabel>,
            JewelleryEarringsProductStyleLabelTranslationArgs,
            WithTypename<ProductLabelTranslation> | string
        >
    }
    JewelleryGemstoneLabel?: {
        icon?: GraphCacheResolver<
            WithTypename<JewelleryGemstoneLabel>,
            Record<string, never>,
            WithTypename<Asset> | string
        >
        systemCode?: GraphCacheResolver<
            WithTypename<JewelleryGemstoneLabel>,
            Record<string, never>,
            JewelleryGemstoneCode | string
        >
        translation?: GraphCacheResolver<
            WithTypename<JewelleryGemstoneLabel>,
            JewelleryGemstoneLabelTranslationArgs,
            WithTypename<ProductLabelTranslation> | string
        >
    }
    JewelleryNecklaceProductStyleLabel?: {
        icon?: GraphCacheResolver<
            WithTypename<JewelleryNecklaceProductStyleLabel>,
            Record<string, never>,
            WithTypename<Asset> | string
        >
        systemCode?: GraphCacheResolver<
            WithTypename<JewelleryNecklaceProductStyleLabel>,
            Record<string, never>,
            JewelleryNecklaceProductStyle | string
        >
        translation?: GraphCacheResolver<
            WithTypename<JewelleryNecklaceProductStyleLabel>,
            JewelleryNecklaceProductStyleLabelTranslationArgs,
            WithTypename<ProductLabelTranslation> | string
        >
    }
    JewelleryRingProductStyleLabel?: {
        icon?: GraphCacheResolver<
            WithTypename<JewelleryRingProductStyleLabel>,
            Record<string, never>,
            WithTypename<Asset> | string
        >
        systemCode?: GraphCacheResolver<
            WithTypename<JewelleryRingProductStyleLabel>,
            Record<string, never>,
            JewelleryRingProductStyle | string
        >
        translation?: GraphCacheResolver<
            WithTypename<JewelleryRingProductStyleLabel>,
            JewelleryRingProductStyleLabelTranslationArgs,
            WithTypename<ProductLabelTranslation> | string
        >
    }
    KlarnaFinanceOption?: {
        months?: GraphCacheResolver<
            WithTypename<KlarnaFinanceOption>,
            Record<string, never>,
            Scalars['Int'] | string
        >
        perMonth?: GraphCacheResolver<
            WithTypename<KlarnaFinanceOption>,
            Record<string, never>,
            WithTypename<Money> | string
        >
        price?: GraphCacheResolver<
            WithTypename<KlarnaFinanceOption>,
            Record<string, never>,
            WithTypename<Money> | string
        >
    }
    KlarnaPaymentMethod?: {
        systemCode?: GraphCacheResolver<
            WithTypename<KlarnaPaymentMethod>,
            Record<string, never>,
            Scalars['ID'] | string
        >
    }
    KlarnaPaymentResponse?: {
        errors?: GraphCacheResolver<
            WithTypename<KlarnaPaymentResponse>,
            Record<string, never>,
            Array<Scalars['String'] | string>
        >
        order?: GraphCacheResolver<
            WithTypename<KlarnaPaymentResponse>,
            Record<string, never>,
            WithTypename<Order> | string
        >
    }
    KlarnaTransaction?: {
        amount?: GraphCacheResolver<
            WithTypename<KlarnaTransaction>,
            Record<string, never>,
            WithTypename<Money> | string
        >
        createdAt?: GraphCacheResolver<
            WithTypename<KlarnaTransaction>,
            Record<string, never>,
            Scalars['DateTime'] | string
        >
        id?: GraphCacheResolver<
            WithTypename<KlarnaTransaction>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        sessionData?: GraphCacheResolver<
            WithTypename<KlarnaTransaction>,
            Record<string, never>,
            Scalars['JSON'] | string
        >
        status?: GraphCacheResolver<
            WithTypename<KlarnaTransaction>,
            Record<string, never>,
            WithTypename<TransactionStatus> | string
        >
    }
    Language?: {
        locale?: GraphCacheResolver<
            WithTypename<Language>,
            Record<string, never>,
            Scalars['Locale'] | string
        >
        translations?: GraphCacheResolver<
            WithTypename<Language>,
            Record<string, never>,
            Array<WithTypename<Translation> | string>
        >
    }
    LegacyTransaction?: {
        amount?: GraphCacheResolver<
            WithTypename<LegacyTransaction>,
            Record<string, never>,
            WithTypename<Money> | string
        >
        createdAt?: GraphCacheResolver<
            WithTypename<LegacyTransaction>,
            Record<string, never>,
            Scalars['DateTime'] | string
        >
        id?: GraphCacheResolver<
            WithTypename<LegacyTransaction>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        paymentMethodName?: GraphCacheResolver<
            WithTypename<LegacyTransaction>,
            LegacyTransactionPaymentMethodNameArgs,
            Scalars['String'] | string
        >
        status?: GraphCacheResolver<
            WithTypename<LegacyTransaction>,
            Record<string, never>,
            WithTypename<TransactionStatus> | string
        >
    }
    Link?: {
        item?: GraphCacheResolver<
            WithTypename<Link>,
            Record<string, never>,
            WithTypename<LinkItem> | string
        >
        target?: GraphCacheResolver<
            WithTypename<Link>,
            Record<string, never>,
            LinkTarget | string
        >
        text?: GraphCacheResolver<
            WithTypename<Link>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    LinkItemAffirm?: {
        emptyField?: GraphCacheResolver<
            WithTypename<LinkItemAffirm>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    LinkItemBookingForm?: {
        emptyField?: GraphCacheResolver<
            WithTypename<LinkItemBookingForm>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    LinkItemCustom?: {
        url?: GraphCacheResolver<
            WithTypename<LinkItemCustom>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    LinkItemOpenContactForm?: {
        emptyField?: GraphCacheResolver<
            WithTypename<LinkItemOpenContactForm>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    LinkItemOpenEnquiryForm?: {
        cmsEnquiryFormType?: GraphCacheResolver<
            WithTypename<LinkItemOpenEnquiryForm>,
            Record<string, never>,
            CmsEnquiryFormType | string
        >
        enquiryType?: GraphCacheResolver<
            WithTypename<LinkItemOpenEnquiryForm>,
            Record<string, never>,
            EnquiryType | string
        >
    }
    LinkItemOpenSpeakToExpertModal?: {
        emptyField?: GraphCacheResolver<
            WithTypename<LinkItemOpenSpeakToExpertModal>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    LoginResponseFailure?: {
        code?: GraphCacheResolver<
            WithTypename<LoginResponseFailure>,
            Record<string, never>,
            LoginResponseErrorCode | string
        >
        message?: GraphCacheResolver<
            WithTypename<LoginResponseFailure>,
            LoginResponseFailureMessageArgs,
            Scalars['String'] | string
        >
    }
    LoginResponseSuccess?: {
        jwt?: GraphCacheResolver<
            WithTypename<LoginResponseSuccess>,
            Record<string, never>,
            Scalars['String'] | string
        >
        refreshToken?: GraphCacheResolver<
            WithTypename<LoginResponseSuccess>,
            Record<string, never>,
            Scalars['String'] | string
        >
        user?: GraphCacheResolver<
            WithTypename<LoginResponseSuccess>,
            Record<string, never>,
            WithTypename<User> | string
        >
    }
    Logo?: {
        image?: GraphCacheResolver<
            WithTypename<Logo>,
            Record<string, never>,
            WithTypename<Image> | string
        >
        link?: GraphCacheResolver<
            WithTypename<Logo>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    MagicLinkConsumeError?: {
        message?: GraphCacheResolver<
            WithTypename<MagicLinkConsumeError>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    MagicLinkConsumeSuccess?: {
        login?: GraphCacheResolver<
            WithTypename<MagicLinkConsumeSuccess>,
            Record<string, never>,
            WithTypename<LoginResponseSuccess> | string
        >
    }
    MarketingDataResponse?: {
        success?: GraphCacheResolver<
            WithTypename<MarketingDataResponse>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
    }
    Melee?: {
        caratWeight?: GraphCacheResolver<
            WithTypename<Melee>,
            Record<string, never>,
            Scalars['Decimal'] | string
        >
        clarities?: GraphCacheResolver<
            WithTypename<Melee>,
            Record<string, never>,
            Array<WithTypename<StoneClarity> | string>
        >
        colors?: GraphCacheResolver<
            WithTypename<Melee>,
            Record<string, never>,
            Array<WithTypename<StoneColor> | string>
        >
        crystal?: GraphCacheResolver<
            WithTypename<Melee>,
            Record<string, never>,
            WithTypename<StoneCrystal> | string
        >
        grade?: GraphCacheResolver<
            WithTypename<Melee>,
            Record<string, never>,
            WithTypename<StoneGrade> | string
        >
        id?: GraphCacheResolver<
            WithTypename<Melee>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        segmentName?: GraphCacheResolver<
            WithTypename<Melee>,
            Record<string, never>,
            Scalars['String'] | string
        >
        shape?: GraphCacheResolver<
            WithTypename<Melee>,
            Record<string, never>,
            WithTypename<StoneShape> | string
        >
        width?: GraphCacheResolver<
            WithTypename<Melee>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    MenuItem?: {
        hideOnDesktop?: GraphCacheResolver<
            WithTypename<MenuItem>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        hideOnMobile?: GraphCacheResolver<
            WithTypename<MenuItem>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        link?: GraphCacheResolver<
            WithTypename<MenuItem>,
            Record<string, never>,
            WithTypename<Link> | string
        >
        subMenu?: GraphCacheResolver<
            WithTypename<MenuItem>,
            Record<string, never>,
            WithTypename<SubMenu> | string
        >
        title?: GraphCacheResolver<
            WithTypename<MenuItem>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    Meta?: {
        description?: GraphCacheResolver<
            WithTypename<Meta>,
            Record<string, never>,
            Scalars['String'] | string
        >
        image?: GraphCacheResolver<
            WithTypename<Meta>,
            Record<string, never>,
            WithTypename<Image> | string
        >
        robots?: GraphCacheResolver<
            WithTypename<Meta>,
            Record<string, never>,
            Robots | string
        >
        title?: GraphCacheResolver<
            WithTypename<Meta>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    Metal?: {
        color?: GraphCacheResolver<
            WithTypename<Metal>,
            Record<string, never>,
            WithTypename<MetalColor> | string
        >
        element?: GraphCacheResolver<
            WithTypename<Metal>,
            Record<string, never>,
            WithTypename<MetalElement> | string
        >
        karat?: GraphCacheResolver<
            WithTypename<Metal>,
            Record<string, never>,
            Scalars['Int'] | string
        >
        millesimalFineness?: GraphCacheResolver<
            WithTypename<Metal>,
            Record<string, never>,
            Scalars['Decimal'] | string
        >
        orderIndex?: GraphCacheResolver<
            WithTypename<Metal>,
            Record<string, never>,
            Scalars['Int'] | string
        >
        segmentName?: GraphCacheResolver<
            WithTypename<Metal>,
            Record<string, never>,
            Scalars['String'] | string
        >
        systemCode?: GraphCacheResolver<
            WithTypename<Metal>,
            Record<string, never>,
            MetalCode | string
        >
        translation?: GraphCacheResolver<
            WithTypename<Metal>,
            MetalTranslationArgs,
            WithTypename<MetalTranslation> | string
        >
    }
    MetalColor?: {
        systemCode?: GraphCacheResolver<
            WithTypename<MetalColor>,
            Record<string, never>,
            MetalColorCode | string
        >
        translation?: GraphCacheResolver<
            WithTypename<MetalColor>,
            MetalColorTranslationArgs,
            WithTypename<MetalColorTranslation> | string
        >
    }
    MetalColorTranslation?: {
        name?: GraphCacheResolver<
            WithTypename<MetalColorTranslation>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    MetalElement?: {
        systemCode?: GraphCacheResolver<
            WithTypename<MetalElement>,
            Record<string, never>,
            MetalElementCode | string
        >
        translation?: GraphCacheResolver<
            WithTypename<MetalElement>,
            MetalElementTranslationArgs,
            WithTypename<MetalElementTranslation> | string
        >
    }
    MetalElementTranslation?: {
        name?: GraphCacheResolver<
            WithTypename<MetalElementTranslation>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    MetalTranslation?: {
        name?: GraphCacheResolver<
            WithTypename<MetalTranslation>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    Money?: {
        amount?: GraphCacheResolver<
            WithTypename<Money>,
            Record<string, never>,
            Scalars['Decimal'] | string
        >
        currency?: GraphCacheResolver<
            WithTypename<Money>,
            Record<string, never>,
            Scalars['Currency'] | string
        >
    }
    MonolithImageSize?: {
        name?: GraphCacheResolver<
            WithTypename<MonolithImageSize>,
            Record<string, never>,
            MonolithImageSizeName | string
        >
        sources?: GraphCacheResolver<
            WithTypename<MonolithImageSize>,
            Record<string, never>,
            Array<WithTypename<ImageSrc> | string>
        >
        url?: GraphCacheResolver<
            WithTypename<MonolithImageSize>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    NoPaymentMethod?: {
        systemCode?: GraphCacheResolver<
            WithTypename<NoPaymentMethod>,
            Record<string, never>,
            Scalars['ID'] | string
        >
    }
    NonSkuCaratWeightRange?: {
        max?: GraphCacheResolver<
            WithTypename<NonSkuCaratWeightRange>,
            Record<string, never>,
            Scalars['Decimal'] | string
        >
        min?: GraphCacheResolver<
            WithTypename<NonSkuCaratWeightRange>,
            Record<string, never>,
            Scalars['Decimal'] | string
        >
    }
    NonSkuGemstone?: {
        caratDimension?: GraphCacheResolver<
            WithTypename<NonSkuGemstone>,
            Record<string, never>,
            WithTypename<NonSkuGemstoneCaratDimension> | string
        >
        caratWeight?: GraphCacheResolver<
            WithTypename<NonSkuGemstone>,
            Record<string, never>,
            Scalars['Decimal'] | string
        >
        clarity?: GraphCacheResolver<
            WithTypename<NonSkuGemstone>,
            Record<string, never>,
            WithTypename<StoneClarity> | string
        >
        color?: GraphCacheResolver<
            WithTypename<NonSkuGemstone>,
            Record<string, never>,
            WithTypename<StoneColor> | string
        >
        colorCrystalDimension?: GraphCacheResolver<
            WithTypename<NonSkuGemstone>,
            Record<string, never>,
            WithTypename<NonSkuGemstoneType> | string
        >
        colorGrade?: GraphCacheResolver<
            WithTypename<NonSkuGemstone>,
            Record<string, never>,
            WithTypename<StoneGrade> | string
        >
        crystal?: GraphCacheResolver<
            WithTypename<NonSkuGemstone>,
            Record<string, never>,
            WithTypename<StoneCrystal> | string
        >
        cut?: GraphCacheResolver<
            WithTypename<NonSkuGemstone>,
            Record<string, never>,
            WithTypename<StoneCut> | string
        >
        gradeClarityDimension?: GraphCacheResolver<
            WithTypename<NonSkuGemstone>,
            Record<string, never>,
            WithTypename<NonSkuGemstoneGradeClarityDimension> | string
        >
        id?: GraphCacheResolver<
            WithTypename<NonSkuGemstone>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        image?: GraphCacheResolver<
            WithTypename<NonSkuGemstone>,
            Record<string, never>,
            WithTypename<NonSkuImage> | string
        >
        salePrice?: GraphCacheResolver<
            WithTypename<NonSkuGemstone>,
            NonSkuGemstoneSalePriceArgs,
            WithTypename<Money> | string
        >
        sampleImage?: GraphCacheResolver<
            WithTypename<NonSkuGemstone>,
            Record<string, never>,
            WithTypename<NonSkuImage> | string
        >
        shape?: GraphCacheResolver<
            WithTypename<NonSkuGemstone>,
            Record<string, never>,
            WithTypename<StoneShape> | string
        >
        shapeDimension?: GraphCacheResolver<
            WithTypename<NonSkuGemstone>,
            Record<string, never>,
            WithTypename<NonSkuGemstoneShapeDimension> | string
        >
        uniqueImage?: GraphCacheResolver<
            WithTypename<NonSkuGemstone>,
            Record<string, never>,
            WithTypename<NonSkuImage> | string
        >
    }
    NonSkuGemstoneCaratDimension?: {
        caratWeight?: GraphCacheResolver<
            WithTypename<NonSkuGemstoneCaratDimension>,
            Record<string, never>,
            Scalars['Decimal'] | string
        >
        id?: GraphCacheResolver<
            WithTypename<NonSkuGemstoneCaratDimension>,
            Record<string, never>,
            Scalars['ID'] | string
        >
    }
    NonSkuGemstoneGradeClarityDimension?: {
        clarity?: GraphCacheResolver<
            WithTypename<NonSkuGemstoneGradeClarityDimension>,
            Record<string, never>,
            WithTypename<StoneClarity> | string
        >
        grade?: GraphCacheResolver<
            WithTypename<NonSkuGemstoneGradeClarityDimension>,
            Record<string, never>,
            WithTypename<StoneGrade> | string
        >
        id?: GraphCacheResolver<
            WithTypename<NonSkuGemstoneGradeClarityDimension>,
            Record<string, never>,
            Scalars['ID'] | string
        >
    }
    NonSkuGemstoneImage?: {
        colorCrystalDimension?: GraphCacheResolver<
            WithTypename<NonSkuGemstoneImage>,
            Record<string, never>,
            WithTypename<NonSkuGemstoneType> | string
        >
        id?: GraphCacheResolver<
            WithTypename<NonSkuGemstoneImage>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        image?: GraphCacheResolver<
            WithTypename<NonSkuGemstoneImage>,
            Record<string, never>,
            WithTypename<NonSkuImage> | string
        >
        shapeDimension?: GraphCacheResolver<
            WithTypename<NonSkuGemstoneImage>,
            Record<string, never>,
            WithTypename<NonSkuGemstoneShapeDimension> | string
        >
    }
    NonSkuGemstoneShapeDimension?: {
        id?: GraphCacheResolver<
            WithTypename<NonSkuGemstoneShapeDimension>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        shape?: GraphCacheResolver<
            WithTypename<NonSkuGemstoneShapeDimension>,
            Record<string, never>,
            WithTypename<StoneShape> | string
        >
    }
    NonSkuGemstoneType?: {
        color?: GraphCacheResolver<
            WithTypename<NonSkuGemstoneType>,
            Record<string, never>,
            WithTypename<StoneColor> | string
        >
        crystal?: GraphCacheResolver<
            WithTypename<NonSkuGemstoneType>,
            Record<string, never>,
            WithTypename<StoneCrystal> | string
        >
        id?: GraphCacheResolver<
            WithTypename<NonSkuGemstoneType>,
            Record<string, never>,
            Scalars['ID'] | string
        >
    }
    NonSkuGemstonesBounds?: {
        caratWeight?: GraphCacheResolver<
            WithTypename<NonSkuGemstonesBounds>,
            Record<string, never>,
            WithTypename<NonSkuCaratWeightRange> | string
        >
        price?: GraphCacheResolver<
            WithTypename<NonSkuGemstonesBounds>,
            NonSkuGemstonesBoundsPriceArgs,
            WithTypename<NonSkuPriceRange> | string
        >
        shapes?: GraphCacheResolver<
            WithTypename<NonSkuGemstonesBounds>,
            Record<string, never>,
            Array<WithTypename<StoneShape> | string>
        >
        types?: GraphCacheResolver<
            WithTypename<NonSkuGemstonesBounds>,
            Record<string, never>,
            Array<WithTypename<NonSkuGemstoneType> | string>
        >
    }
    NonSkuImage?: {
        id?: GraphCacheResolver<
            WithTypename<NonSkuImage>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        mimeType?: GraphCacheResolver<
            WithTypename<NonSkuImage>,
            Record<string, never>,
            Scalars['String'] | string
        >
        size?: GraphCacheResolver<
            WithTypename<NonSkuImage>,
            NonSkuImageSizeArgs,
            WithTypename<MonolithImageSize> | string
        >
        sources?: GraphCacheResolver<
            WithTypename<NonSkuImage>,
            Record<string, never>,
            Array<WithTypename<ImageSrc> | string>
        >
        url?: GraphCacheResolver<
            WithTypename<NonSkuImage>,
            Record<string, never>,
            Scalars['Uri'] | string
        >
    }
    NonSkuLabGrown?: {
        caratDimension?: GraphCacheResolver<
            WithTypename<NonSkuLabGrown>,
            Record<string, never>,
            WithTypename<NonSkuLabGrownCaratDimension> | string
        >
        caratWeight?: GraphCacheResolver<
            WithTypename<NonSkuLabGrown>,
            Record<string, never>,
            Scalars['Decimal'] | string
        >
        clarity?: GraphCacheResolver<
            WithTypename<NonSkuLabGrown>,
            Record<string, never>,
            WithTypename<StoneClarity> | string
        >
        color?: GraphCacheResolver<
            WithTypename<NonSkuLabGrown>,
            Record<string, never>,
            WithTypename<StoneColor> | string
        >
        crystal?: GraphCacheResolver<
            WithTypename<NonSkuLabGrown>,
            Record<string, never>,
            WithTypename<StoneCrystal> | string
        >
        cut?: GraphCacheResolver<
            WithTypename<NonSkuLabGrown>,
            Record<string, never>,
            WithTypename<StoneCut> | string
        >
        gradeDimension?: GraphCacheResolver<
            WithTypename<NonSkuLabGrown>,
            Record<string, never>,
            WithTypename<NonSkuLabGrownGradeDimension> | string
        >
        id?: GraphCacheResolver<
            WithTypename<NonSkuLabGrown>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        image?: GraphCacheResolver<
            WithTypename<NonSkuLabGrown>,
            Record<string, never>,
            WithTypename<NonSkuImage> | string
        >
        salePrice?: GraphCacheResolver<
            WithTypename<NonSkuLabGrown>,
            NonSkuLabGrownSalePriceArgs,
            WithTypename<Money> | string
        >
        sampleImage?: GraphCacheResolver<
            WithTypename<NonSkuLabGrown>,
            Record<string, never>,
            WithTypename<NonSkuImage> | string
        >
        shape?: GraphCacheResolver<
            WithTypename<NonSkuLabGrown>,
            Record<string, never>,
            WithTypename<StoneShape> | string
        >
        shapeDimension?: GraphCacheResolver<
            WithTypename<NonSkuLabGrown>,
            Record<string, never>,
            WithTypename<NonSkuLabGrownShapeDimension> | string
        >
        uniqueImage?: GraphCacheResolver<
            WithTypename<NonSkuLabGrown>,
            Record<string, never>,
            WithTypename<NonSkuImage> | string
        >
    }
    NonSkuLabGrownCaratDimension?: {
        caratWeight?: GraphCacheResolver<
            WithTypename<NonSkuLabGrownCaratDimension>,
            Record<string, never>,
            Scalars['Decimal'] | string
        >
        id?: GraphCacheResolver<
            WithTypename<NonSkuLabGrownCaratDimension>,
            Record<string, never>,
            Scalars['ID'] | string
        >
    }
    NonSkuLabGrownDiamondsBounds?: {
        caratWeight?: GraphCacheResolver<
            WithTypename<NonSkuLabGrownDiamondsBounds>,
            Record<string, never>,
            WithTypename<NonSkuCaratWeightRange> | string
        >
        colors?: GraphCacheResolver<
            WithTypename<NonSkuLabGrownDiamondsBounds>,
            Record<string, never>,
            Array<WithTypename<StoneColor> | string>
        >
        price?: GraphCacheResolver<
            WithTypename<NonSkuLabGrownDiamondsBounds>,
            NonSkuLabGrownDiamondsBoundsPriceArgs,
            WithTypename<NonSkuPriceRange> | string
        >
        shapes?: GraphCacheResolver<
            WithTypename<NonSkuLabGrownDiamondsBounds>,
            Record<string, never>,
            Array<WithTypename<StoneShape> | string>
        >
    }
    NonSkuLabGrownGradeDimension?: {
        clarity?: GraphCacheResolver<
            WithTypename<NonSkuLabGrownGradeDimension>,
            Record<string, never>,
            WithTypename<StoneClarity> | string
        >
        color?: GraphCacheResolver<
            WithTypename<NonSkuLabGrownGradeDimension>,
            Record<string, never>,
            WithTypename<StoneColor> | string
        >
        id?: GraphCacheResolver<
            WithTypename<NonSkuLabGrownGradeDimension>,
            Record<string, never>,
            Scalars['ID'] | string
        >
    }
    NonSkuLabGrownShapeDimension?: {
        id?: GraphCacheResolver<
            WithTypename<NonSkuLabGrownShapeDimension>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        image?: GraphCacheResolver<
            WithTypename<NonSkuLabGrownShapeDimension>,
            Record<string, never>,
            WithTypename<NonSkuImage> | string
        >
        shape?: GraphCacheResolver<
            WithTypename<NonSkuLabGrownShapeDimension>,
            Record<string, never>,
            WithTypename<StoneShape> | string
        >
    }
    NonSkuPriceRange?: {
        max?: GraphCacheResolver<
            WithTypename<NonSkuPriceRange>,
            Record<string, never>,
            WithTypename<Money> | string
        >
        min?: GraphCacheResolver<
            WithTypename<NonSkuPriceRange>,
            Record<string, never>,
            WithTypename<Money> | string
        >
    }
    Order?: {
        allowedWeekdays?: GraphCacheResolver<
            WithTypename<Order>,
            Record<string, never>,
            Scalars['Int'] | string
        >
        availableShowroomsForCollection?: GraphCacheResolver<
            WithTypename<Order>,
            Record<string, never>,
            Array<WithTypename<Showroom> | string>
        >
        billingAddress?: GraphCacheResolver<
            WithTypename<Order>,
            Record<string, never>,
            WithTypename<OrderAddress> | string
        >
        customer?: GraphCacheResolver<
            WithTypename<Order>,
            Record<string, never>,
            WithTypename<Customer> | string
        >
        desiredDeliveryDate?: GraphCacheResolver<
            WithTypename<Order>,
            Record<string, never>,
            Scalars['DateTime'] | string
        >
        disabledDates?: GraphCacheResolver<
            WithTypename<Order>,
            Record<string, never>,
            Array<Scalars['DateTime'] | string>
        >
        firstAvailableDeliveryDate?: GraphCacheResolver<
            WithTypename<Order>,
            Record<string, never>,
            WithTypename<DeliveryDate> | string
        >
        id?: GraphCacheResolver<
            WithTypename<Order>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        isAsarEnabled?: GraphCacheResolver<
            WithTypename<Order>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        isCompleted?: GraphCacheResolver<
            WithTypename<Order>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        isDeliveryConfirmed?: GraphCacheResolver<
            WithTypename<Order>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        isPayable?: GraphCacheResolver<
            WithTypename<Order>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        isShippingAddressReadonly?: GraphCacheResolver<
            WithTypename<Order>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        paidAmount?: GraphCacheResolver<
            WithTypename<Order>,
            Record<string, never>,
            WithTypename<Money> | string
        >
        paymentMethods?: GraphCacheResolver<
            WithTypename<Order>,
            Record<string, never>,
            WithTypename<PaymentMethodContainer> | string
        >
        paymentPlan?: GraphCacheResolver<
            WithTypename<Order>,
            Record<string, never>,
            WithTypename<PaymentPlan> | string
        >
        placementDate?: GraphCacheResolver<
            WithTypename<Order>,
            Record<string, never>,
            Scalars['DateTime'] | string
        >
        prediscountSubtotalAmount?: GraphCacheResolver<
            WithTypename<Order>,
            Record<string, never>,
            WithTypename<Money> | string
        >
        prediscountTotalAmount?: GraphCacheResolver<
            WithTypename<Order>,
            Record<string, never>,
            WithTypename<Money> | string
        >
        products?: GraphCacheResolver<
            WithTypename<Order>,
            Record<string, never>,
            Array<WithTypename<OrderProduct> | string>
        >
        promoCode?: GraphCacheResolver<
            WithTypename<Order>,
            Record<string, never>,
            WithTypename<PromoCode> | string
        >
        remainingAmount?: GraphCacheResolver<
            WithTypename<Order>,
            Record<string, never>,
            WithTypename<Money> | string
        >
        salesTaxAmount?: GraphCacheResolver<
            WithTypename<Order>,
            Record<string, never>,
            WithTypename<Money> | string
        >
        savedAmount?: GraphCacheResolver<
            WithTypename<Order>,
            Record<string, never>,
            WithTypename<Money> | string
        >
        shipmentTrackingInformation?: GraphCacheResolver<
            WithTypename<Order>,
            Record<string, never>,
            WithTypename<ShipmentTrackingInformation> | string
        >
        shippingAddress?: GraphCacheResolver<
            WithTypename<Order>,
            Record<string, never>,
            WithTypename<OrderAddress> | string
        >
        shippingAmount?: GraphCacheResolver<
            WithTypename<Order>,
            Record<string, never>,
            WithTypename<Money> | string
        >
        status?: GraphCacheResolver<
            WithTypename<Order>,
            Record<string, never>,
            WithTypename<OrderStatus> | string
        >
        subtotalAmount?: GraphCacheResolver<
            WithTypename<Order>,
            Record<string, never>,
            WithTypename<Money> | string
        >
        totalAmount?: GraphCacheResolver<
            WithTypename<Order>,
            Record<string, never>,
            WithTypename<Money> | string
        >
        transactions?: GraphCacheResolver<
            WithTypename<Order>,
            Record<string, never>,
            Array<
                | WithTypename<AffirmTransaction>
                | WithTypename<AllocationTransaction>
                | WithTypename<BankTransaction>
                | WithTypename<CheckoutcomTransaction>
                | WithTypename<KlarnaTransaction>
                | WithTypename<LegacyTransaction>
                | WithTypename<StripeTransaction>
                | string
            >
        >
        vatAmount?: GraphCacheResolver<
            WithTypename<Order>,
            Record<string, never>,
            WithTypename<Money> | string
        >
    }
    OrderAddress?: {
        addressLine1?: GraphCacheResolver<
            WithTypename<OrderAddress>,
            Record<string, never>,
            Scalars['String'] | string
        >
        addressLine2?: GraphCacheResolver<
            WithTypename<OrderAddress>,
            Record<string, never>,
            Scalars['String'] | string
        >
        city?: GraphCacheResolver<
            WithTypename<OrderAddress>,
            Record<string, never>,
            Scalars['String'] | string
        >
        country?: GraphCacheResolver<
            WithTypename<OrderAddress>,
            Record<string, never>,
            Scalars['Country'] | string
        >
        deliveryInstructions?: GraphCacheResolver<
            WithTypename<OrderAddress>,
            Record<string, never>,
            Scalars['String'] | string
        >
        email?: GraphCacheResolver<
            WithTypename<OrderAddress>,
            Record<string, never>,
            Scalars['String'] | string
        >
        firstName?: GraphCacheResolver<
            WithTypename<OrderAddress>,
            Record<string, never>,
            Scalars['String'] | string
        >
        id?: GraphCacheResolver<
            WithTypename<OrderAddress>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        lastName?: GraphCacheResolver<
            WithTypename<OrderAddress>,
            Record<string, never>,
            Scalars['String'] | string
        >
        phoneNumber?: GraphCacheResolver<
            WithTypename<OrderAddress>,
            Record<string, never>,
            WithTypename<PhoneNumberType> | string
        >
        postalCode?: GraphCacheResolver<
            WithTypename<OrderAddress>,
            Record<string, never>,
            Scalars['String'] | string
        >
        subdivision?: GraphCacheResolver<
            WithTypename<OrderAddress>,
            Record<string, never>,
            Scalars['CountrySubdivision'] | string
        >
    }
    OrderAddressNotConfirmedError?: {
        message?: GraphCacheResolver<
            WithTypename<OrderAddressNotConfirmedError>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    OrderAlreadyCompletedError?: {
        message?: GraphCacheResolver<
            WithTypename<OrderAlreadyCompletedError>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    OrderEmptyError?: {
        message?: GraphCacheResolver<
            WithTypename<OrderEmptyError>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    OrderProduct?: {
        customer?: GraphCacheResolver<
            WithTypename<OrderProduct>,
            Record<string, never>,
            WithTypename<Customer> | string
        >
        designStudioProduct?: GraphCacheResolver<
            WithTypename<OrderProduct>,
            Record<string, never>,
            | WithTypename<DesignStudioProductAdditionalResize>
            | WithTypename<DesignStudioProductCustom>
            | WithTypename<DesignStudioProductEngagementRing>
            | WithTypename<DesignStudioProductGeneric>
            | WithTypename<DesignStudioProductLooseStone>
            | WithTypename<DesignStudioProductWeddingRing>
            | string
        >
        id?: GraphCacheResolver<
            WithTypename<OrderProduct>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        image?: GraphCacheResolver<
            WithTypename<OrderProduct>,
            Record<string, never>,
            Scalars['String'] | string
        >
        name?: GraphCacheResolver<
            WithTypename<OrderProduct>,
            Record<string, never>,
            Scalars['String'] | string
        >
        order?: GraphCacheResolver<
            WithTypename<OrderProduct>,
            Record<string, never>,
            WithTypename<Order> | string
        >
        prediscountTotalSaleAmount?: GraphCacheResolver<
            WithTypename<OrderProduct>,
            Record<string, never>,
            WithTypename<Money> | string
        >
        totalSaleAmount?: GraphCacheResolver<
            WithTypename<OrderProduct>,
            Record<string, never>,
            WithTypename<Money> | string
        >
    }
    OrderStatus?: {
        name?: GraphCacheResolver<
            WithTypename<OrderStatus>,
            OrderStatusNameArgs,
            Scalars['String'] | string
        >
        systemCode?: GraphCacheResolver<
            WithTypename<OrderStatus>,
            Record<string, never>,
            OrderStatusCode | string
        >
    }
    OrderedListItem?: {
        description?: GraphCacheResolver<
            WithTypename<OrderedListItem>,
            Record<string, never>,
            Scalars['String'] | string
        >
        title?: GraphCacheResolver<
            WithTypename<OrderedListItem>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    Page?: {
        author?: GraphCacheResolver<
            WithTypename<Page>,
            Record<string, never>,
            WithTypename<Author> | string
        >
        blocks?: GraphCacheResolver<
            WithTypename<Page>,
            Record<string, never>,
            Array<WithTypename<Block> | string>
        >
        id?: GraphCacheResolver<
            WithTypename<Page>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        meta?: GraphCacheResolver<
            WithTypename<Page>,
            Record<string, never>,
            WithTypename<Meta> | string
        >
        pageSettings?: GraphCacheResolver<
            WithTypename<Page>,
            Record<string, never>,
            WithTypename<PageSettings> | string
        >
        parent?: GraphCacheResolver<
            WithTypename<Page>,
            Record<string, never>,
            WithTypename<Page> | string
        >
        path?: GraphCacheResolver<
            WithTypename<Page>,
            Record<string, never>,
            Scalars['String'] | string
        >
        slug?: GraphCacheResolver<
            WithTypename<Page>,
            Record<string, never>,
            Scalars['String'] | string
        >
        title?: GraphCacheResolver<
            WithTypename<Page>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    PageSettings?: {
        showRingBuilder?: GraphCacheResolver<
            WithTypename<PageSettings>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
    }
    PageTooltip?: {
        tooltip?: GraphCacheResolver<
            WithTypename<PageTooltip>,
            Record<string, never>,
            WithTypename<Tooltip> | string
        >
        triggerText?: GraphCacheResolver<
            WithTypename<PageTooltip>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    PayViaCheckoutcomFailureResponse?: {
        errors?: GraphCacheResolver<
            WithTypename<PayViaCheckoutcomFailureResponse>,
            Record<string, never>,
            Array<WithTypename<PayViaCheckoutcomError> | string>
        >
    }
    PayViaCheckoutcomSuccessResponse?: {
        order?: GraphCacheResolver<
            WithTypename<PayViaCheckoutcomSuccessResponse>,
            Record<string, never>,
            WithTypename<Order> | string
        >
        redirectUrl?: GraphCacheResolver<
            WithTypename<PayViaCheckoutcomSuccessResponse>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    PaymentAmountInvalidError?: {
        message?: GraphCacheResolver<
            WithTypename<PaymentAmountInvalidError>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    PaymentIcon?: {
        icon?: GraphCacheResolver<
            WithTypename<PaymentIcon>,
            Record<string, never>,
            WithTypename<Image> | string
        >
        name?: GraphCacheResolver<
            WithTypename<PaymentIcon>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    PaymentMethodContainer?: {
        affirmPayment?: GraphCacheResolver<
            WithTypename<PaymentMethodContainer>,
            Record<string, never>,
            WithTypename<AffirmPaymentMethod> | string
        >
        allocationPayment?: GraphCacheResolver<
            WithTypename<PaymentMethodContainer>,
            Record<string, never>,
            WithTypename<AllocationPaymentMethod> | string
        >
        bankPayment?: GraphCacheResolver<
            WithTypename<PaymentMethodContainer>,
            Record<string, never>,
            WithTypename<BankPaymentMethod> | string
        >
        checkoutcomPayment?: GraphCacheResolver<
            WithTypename<PaymentMethodContainer>,
            Record<string, never>,
            WithTypename<CheckoutcomPaymentMethod> | string
        >
        klarnaPayment?: GraphCacheResolver<
            WithTypename<PaymentMethodContainer>,
            Record<string, never>,
            WithTypename<KlarnaPaymentMethod> | string
        >
        noPayment?: GraphCacheResolver<
            WithTypename<PaymentMethodContainer>,
            Record<string, never>,
            WithTypename<NoPaymentMethod> | string
        >
    }
    PaymentMethodNotAllowedError?: {
        message?: GraphCacheResolver<
            WithTypename<PaymentMethodNotAllowedError>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    PaymentPlan?: {
        current?: GraphCacheResolver<
            WithTypename<PaymentPlan>,
            Record<string, never>,
            WithTypename<PaymentPlanUpcomingRecord> | string
        >
        paid?: GraphCacheResolver<
            WithTypename<PaymentPlan>,
            Record<string, never>,
            Array<WithTypename<PaymentPlanPaidRecord> | string>
        >
        upcoming?: GraphCacheResolver<
            WithTypename<PaymentPlan>,
            Record<string, never>,
            Array<WithTypename<PaymentPlanUpcomingRecord> | string>
        >
    }
    PaymentPlanPaidRecord?: {
        amount?: GraphCacheResolver<
            WithTypename<PaymentPlanPaidRecord>,
            Record<string, never>,
            WithTypename<Money> | string
        >
        paidOn?: GraphCacheResolver<
            WithTypename<PaymentPlanPaidRecord>,
            Record<string, never>,
            Scalars['DateTime'] | string
        >
    }
    PaymentPlanUpcomingRecord?: {
        amount?: GraphCacheResolver<
            WithTypename<PaymentPlanUpcomingRecord>,
            Record<string, never>,
            WithTypename<Money> | string
        >
    }
    PhoneNumberType?: {
        countryCode?: GraphCacheResolver<
            WithTypename<PhoneNumberType>,
            Record<string, never>,
            Scalars['String'] | string
        >
        e164?: GraphCacheResolver<
            WithTypename<PhoneNumberType>,
            Record<string, never>,
            Scalars['PhoneNumber'] | string
        >
        formatted?: GraphCacheResolver<
            WithTypename<PhoneNumberType>,
            PhoneNumberTypeFormattedArgs,
            Scalars['String'] | string
        >
        nationalNumber?: GraphCacheResolver<
            WithTypename<PhoneNumberType>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    Post?: {
        author?: GraphCacheResolver<
            WithTypename<Post>,
            PostAuthorArgs,
            WithTypename<Author> | string
        >
        blocks?: GraphCacheResolver<
            WithTypename<Post>,
            Record<string, never>,
            Array<WithTypename<Block> | string>
        >
        categories?: GraphCacheResolver<
            WithTypename<Post>,
            PostCategoriesArgs,
            Array<WithTypename<PostCategory> | string>
        >
        createdAt?: GraphCacheResolver<
            WithTypename<Post>,
            Record<string, never>,
            Scalars['Date'] | string
        >
        date?: GraphCacheResolver<
            WithTypename<Post>,
            Record<string, never>,
            Scalars['Date'] | string
        >
        excerpt?: GraphCacheResolver<
            WithTypename<Post>,
            Record<string, never>,
            Scalars['String'] | string
        >
        featuredImage?: GraphCacheResolver<
            WithTypename<Post>,
            Record<string, never>,
            WithTypename<Image> | string
        >
        id?: GraphCacheResolver<
            WithTypename<Post>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        meta?: GraphCacheResolver<
            WithTypename<Post>,
            Record<string, never>,
            WithTypename<Meta> | string
        >
        modifiedAt?: GraphCacheResolver<
            WithTypename<Post>,
            Record<string, never>,
            Scalars['Date'] | string
        >
        relatedPosts?: GraphCacheResolver<
            WithTypename<Post>,
            PostRelatedPostsArgs,
            Array<WithTypename<Post> | string>
        >
        showModifiedDate?: GraphCacheResolver<
            WithTypename<Post>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        slug?: GraphCacheResolver<
            WithTypename<Post>,
            Record<string, never>,
            Scalars['String'] | string
        >
        tags?: GraphCacheResolver<
            WithTypename<Post>,
            PostTagsArgs,
            Array<WithTypename<PostTag> | string>
        >
        title?: GraphCacheResolver<
            WithTypename<Post>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    PostCategoriesAggregation?: {
        count?: GraphCacheResolver<
            WithTypename<PostCategoriesAggregation>,
            Record<string, never>,
            Scalars['Int'] | string
        >
    }
    PostCategory?: {
        children?: GraphCacheResolver<
            WithTypename<PostCategory>,
            PostCategoryChildrenArgs,
            Array<WithTypename<PostCategory> | string>
        >
        id?: GraphCacheResolver<
            WithTypename<PostCategory>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        name?: GraphCacheResolver<
            WithTypename<PostCategory>,
            Record<string, never>,
            Scalars['String'] | string
        >
        parent?: GraphCacheResolver<
            WithTypename<PostCategory>,
            PostCategoryParentArgs,
            WithTypename<PostCategory> | string
        >
        postAggregation?: GraphCacheResolver<
            WithTypename<PostCategory>,
            PostCategoryPostAggregationArgs,
            WithTypename<PostsAggregation> | string
        >
        posts?: GraphCacheResolver<
            WithTypename<PostCategory>,
            PostCategoryPostsArgs,
            Array<WithTypename<Post> | string>
        >
        slug?: GraphCacheResolver<
            WithTypename<PostCategory>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    PostTag?: {
        id?: GraphCacheResolver<
            WithTypename<PostTag>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        name?: GraphCacheResolver<
            WithTypename<PostTag>,
            Record<string, never>,
            Scalars['String'] | string
        >
        postAggregation?: GraphCacheResolver<
            WithTypename<PostTag>,
            PostTagPostAggregationArgs,
            WithTypename<PostsAggregation> | string
        >
        posts?: GraphCacheResolver<
            WithTypename<PostTag>,
            PostTagPostsArgs,
            Array<WithTypename<Post> | string>
        >
        slug?: GraphCacheResolver<
            WithTypename<PostTag>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    PostTagsAggregation?: {
        count?: GraphCacheResolver<
            WithTypename<PostTagsAggregation>,
            Record<string, never>,
            Scalars['Int'] | string
        >
    }
    PostsAggregation?: {
        count?: GraphCacheResolver<
            WithTypename<PostsAggregation>,
            Record<string, never>,
            Scalars['Int'] | string
        >
    }
    PreHeader?: {
        link?: GraphCacheResolver<
            WithTypename<PreHeader>,
            Record<string, never>,
            WithTypename<Link> | string
        >
    }
    ProductLabelTranslation?: {
        facetedContentName?: GraphCacheResolver<
            WithTypename<ProductLabelTranslation>,
            Record<string, never>,
            Scalars['String'] | string
        >
        name?: GraphCacheResolver<
            WithTypename<ProductLabelTranslation>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    ProductPageDetails?: {
        blocks?: GraphCacheResolver<
            WithTypename<ProductPageDetails>,
            Record<string, never>,
            Array<WithTypename<Block> | string>
        >
        id?: GraphCacheResolver<
            WithTypename<ProductPageDetails>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        meta?: GraphCacheResolver<
            WithTypename<ProductPageDetails>,
            Record<string, never>,
            WithTypename<Meta> | string
        >
        path?: GraphCacheResolver<
            WithTypename<ProductPageDetails>,
            Record<string, never>,
            Scalars['String'] | string
        >
        priceExplainedTooltip?: GraphCacheResolver<
            WithTypename<ProductPageDetails>,
            Record<string, never>,
            WithTypename<PageTooltip> | string
        >
        slug?: GraphCacheResolver<
            WithTypename<ProductPageDetails>,
            Record<string, never>,
            Scalars['String'] | string
        >
        title?: GraphCacheResolver<
            WithTypename<ProductPageDetails>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    ProductPageFacetedContent?: {
        contentTitle?: GraphCacheResolver<
            WithTypename<ProductPageFacetedContent>,
            Record<string, never>,
            Scalars['RenderableTemplate'] | string
        >
        description?: GraphCacheResolver<
            WithTypename<ProductPageFacetedContent>,
            Record<string, never>,
            Scalars['RenderableTemplate'] | string
        >
        longDescription?: GraphCacheResolver<
            WithTypename<ProductPageFacetedContent>,
            Record<string, never>,
            WithTypename<ProductPageFacetedContentLongDescription> | string
        >
        meta?: GraphCacheResolver<
            WithTypename<ProductPageFacetedContent>,
            Record<string, never>,
            WithTypename<Meta> | string
        >
        productString?: GraphCacheResolver<
            WithTypename<ProductPageFacetedContent>,
            Record<string, never>,
            Scalars['RenderableTemplate'] | string
        >
        title?: GraphCacheResolver<
            WithTypename<ProductPageFacetedContent>,
            Record<string, never>,
            Scalars['RenderableTemplate'] | string
        >
    }
    ProductPageFacetedContentLongDescriptionBlock?: {
        blocks?: GraphCacheResolver<
            WithTypename<ProductPageFacetedContentLongDescriptionBlock>,
            Record<string, never>,
            Array<WithTypename<Block> | string>
        >
    }
    ProductPageFacetedContentLongDescriptionText?: {
        text?: GraphCacheResolver<
            WithTypename<ProductPageFacetedContentLongDescriptionText>,
            Record<string, never>,
            Scalars['RenderableTemplate'] | string
        >
    }
    ProductPageListing?: {
        afterGrid?: GraphCacheResolver<
            WithTypename<ProductPageListing>,
            Record<string, never>,
            Array<WithTypename<Block> | string>
        >
        banner1?: GraphCacheResolver<
            WithTypename<ProductPageListing>,
            Record<string, never>,
            WithTypename<Banner1> | string
        >
        banner2?: GraphCacheResolver<
            WithTypename<ProductPageListing>,
            Record<string, never>,
            WithTypename<Banner2> | string
        >
        beforeFilters?: GraphCacheResolver<
            WithTypename<ProductPageListing>,
            Record<string, never>,
            Array<WithTypename<Block> | string>
        >
        id?: GraphCacheResolver<
            WithTypename<ProductPageListing>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        meta?: GraphCacheResolver<
            WithTypename<ProductPageListing>,
            Record<string, never>,
            WithTypename<Meta> | string
        >
        path?: GraphCacheResolver<
            WithTypename<ProductPageListing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        slug?: GraphCacheResolver<
            WithTypename<ProductPageListing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        title?: GraphCacheResolver<
            WithTypename<ProductPageListing>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    PromoCode?: {
        code?: GraphCacheResolver<
            WithTypename<PromoCode>,
            Record<string, never>,
            Scalars['String'] | string
        >
        id?: GraphCacheResolver<
            WithTypename<PromoCode>,
            Record<string, never>,
            Scalars['ID'] | string
        >
    }
    PromoCodeApplicationResult?: {
        error?: GraphCacheResolver<
            WithTypename<PromoCodeApplicationResult>,
            Record<string, never>,
            PromoCodeApplicationError | string
        >
    }
    Questionnaire?: {
        id?: GraphCacheResolver<
            WithTypename<Questionnaire>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        redirectLink?: GraphCacheResolver<
            WithTypename<Questionnaire>,
            Record<string, never>,
            WithTypename<LinkItem> | string
        >
        signUpStep?: GraphCacheResolver<
            WithTypename<Questionnaire>,
            Record<string, never>,
            WithTypename<QuestionnaireSignUpStep> | string
        >
        steps?: GraphCacheResolver<
            WithTypename<Questionnaire>,
            Record<string, never>,
            Array<WithTypename<QuestionnaireStep> | string>
        >
        title?: GraphCacheResolver<
            WithTypename<Questionnaire>,
            Record<string, never>,
            Scalars['String'] | string
        >
        type?: GraphCacheResolver<
            WithTypename<Questionnaire>,
            Record<string, never>,
            QuestionnaireType | string
        >
    }
    QuestionnaireCompletedExistingCustomerResponse?: {
        questionnaire?: GraphCacheResolver<
            WithTypename<QuestionnaireCompletedExistingCustomerResponse>,
            Record<string, never>,
            WithTypename<QuestionnaireCompletedQuestionnaire> | string
        >
    }
    QuestionnaireCompletedNewCustomerResponse?: {
        customer?: GraphCacheResolver<
            WithTypename<QuestionnaireCompletedNewCustomerResponse>,
            Record<string, never>,
            WithTypename<CustomerRegistrationResponse> | string
        >
        questionnaire?: GraphCacheResolver<
            WithTypename<QuestionnaireCompletedNewCustomerResponse>,
            Record<string, never>,
            WithTypename<QuestionnaireCompletedQuestionnaire> | string
        >
    }
    QuestionnaireCompletedQuestionnaire?: {
        id?: GraphCacheResolver<
            WithTypename<QuestionnaireCompletedQuestionnaire>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        referenceId?: GraphCacheResolver<
            WithTypename<QuestionnaireCompletedQuestionnaire>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        steps?: GraphCacheResolver<
            WithTypename<QuestionnaireCompletedQuestionnaire>,
            Record<string, never>,
            Array<
                | WithTypename<QuestionnaireCompletedQuestionnaireStepSnapshot>
                | string
            >
        >
        type?: GraphCacheResolver<
            WithTypename<QuestionnaireCompletedQuestionnaire>,
            Record<string, never>,
            QuestionnaireType | string
        >
    }
    QuestionnaireCompletedQuestionnaireStepSnapshot?: {
        answers?: GraphCacheResolver<
            WithTypename<QuestionnaireCompletedQuestionnaireStepSnapshot>,
            Record<string, never>,
            Array<
                | WithTypename<QuestionnaireQuestionAnswerMultiChoice>
                | WithTypename<QuestionnaireQuestionAnswerNumber>
                | WithTypename<QuestionnaireQuestionAnswerSingleChoice>
                | WithTypename<QuestionnaireQuestionAnswerText>
                | string
            >
        >
        id?: GraphCacheResolver<
            WithTypename<QuestionnaireCompletedQuestionnaireStepSnapshot>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        title?: GraphCacheResolver<
            WithTypename<QuestionnaireCompletedQuestionnaireStepSnapshot>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    QuestionnaireCondition?: {
        rules?: GraphCacheResolver<
            WithTypename<QuestionnaireCondition>,
            Record<string, never>,
            Array<WithTypename<QuestionnaireConditionRule> | string>
        >
        type?: GraphCacheResolver<
            WithTypename<QuestionnaireCondition>,
            Record<string, never>,
            QuestionnaireConditionType | string
        >
    }
    QuestionnaireConditionEqualToChoice?: {
        choice?: GraphCacheResolver<
            WithTypename<QuestionnaireConditionEqualToChoice>,
            Record<string, never>,
            WithTypename<QuestionnaireQuestionChoiceOption> | string
        >
        question?: GraphCacheResolver<
            WithTypename<QuestionnaireConditionEqualToChoice>,
            Record<string, never>,
            | WithTypename<QuestionnaireQuestionChoice>
            | WithTypename<QuestionnaireQuestionPrice>
            | WithTypename<QuestionnaireQuestionText>
            | string
        >
    }
    QuestionnaireConditionIsEmpty?: {
        question?: GraphCacheResolver<
            WithTypename<QuestionnaireConditionIsEmpty>,
            Record<string, never>,
            | WithTypename<QuestionnaireQuestionChoice>
            | WithTypename<QuestionnaireQuestionPrice>
            | WithTypename<QuestionnaireQuestionText>
            | string
        >
    }
    QuestionnaireConditionIsEqualTo?: {
        question?: GraphCacheResolver<
            WithTypename<QuestionnaireConditionIsEqualTo>,
            Record<string, never>,
            | WithTypename<QuestionnaireQuestionChoice>
            | WithTypename<QuestionnaireQuestionPrice>
            | WithTypename<QuestionnaireQuestionText>
            | string
        >
        value?: GraphCacheResolver<
            WithTypename<QuestionnaireConditionIsEqualTo>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    QuestionnaireConditionIsGreaterThan?: {
        question?: GraphCacheResolver<
            WithTypename<QuestionnaireConditionIsGreaterThan>,
            Record<string, never>,
            | WithTypename<QuestionnaireQuestionChoice>
            | WithTypename<QuestionnaireQuestionPrice>
            | WithTypename<QuestionnaireQuestionText>
            | string
        >
        value?: GraphCacheResolver<
            WithTypename<QuestionnaireConditionIsGreaterThan>,
            Record<string, never>,
            Scalars['Float'] | string
        >
    }
    QuestionnaireConditionIsLessThan?: {
        question?: GraphCacheResolver<
            WithTypename<QuestionnaireConditionIsLessThan>,
            Record<string, never>,
            | WithTypename<QuestionnaireQuestionChoice>
            | WithTypename<QuestionnaireQuestionPrice>
            | WithTypename<QuestionnaireQuestionText>
            | string
        >
        value?: GraphCacheResolver<
            WithTypename<QuestionnaireConditionIsLessThan>,
            Record<string, never>,
            Scalars['Float'] | string
        >
    }
    QuestionnaireConditionIsNotEmpty?: {
        question?: GraphCacheResolver<
            WithTypename<QuestionnaireConditionIsNotEmpty>,
            Record<string, never>,
            | WithTypename<QuestionnaireQuestionChoice>
            | WithTypename<QuestionnaireQuestionPrice>
            | WithTypename<QuestionnaireQuestionText>
            | string
        >
    }
    QuestionnaireConditionNotIsEqualTo?: {
        question?: GraphCacheResolver<
            WithTypename<QuestionnaireConditionNotIsEqualTo>,
            Record<string, never>,
            | WithTypename<QuestionnaireQuestionChoice>
            | WithTypename<QuestionnaireQuestionPrice>
            | WithTypename<QuestionnaireQuestionText>
            | string
        >
        value?: GraphCacheResolver<
            WithTypename<QuestionnaireConditionNotIsEqualTo>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    QuestionnaireCustomerNotification?: {
        subject?: GraphCacheResolver<
            WithTypename<QuestionnaireCustomerNotification>,
            Record<string, never>,
            Scalars['String'] | string
        >
        text?: GraphCacheResolver<
            WithTypename<QuestionnaireCustomerNotification>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    QuestionnaireQuestionAnswerMultiChoice?: {
        choices?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionAnswerMultiChoice>,
            Record<string, never>,
            Array<
                WithTypename<QuestionnaireQuestionChoiceOptionSnapshot> | string
            >
        >
        id?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionAnswerMultiChoice>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        question?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionAnswerMultiChoice>,
            Record<string, never>,
            WithTypename<QuestionnaireQuestionSnapshot> | string
        >
    }
    QuestionnaireQuestionAnswerNumber?: {
        id?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionAnswerNumber>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        number?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionAnswerNumber>,
            Record<string, never>,
            Scalars['Float'] | string
        >
        question?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionAnswerNumber>,
            Record<string, never>,
            WithTypename<QuestionnaireQuestionSnapshot> | string
        >
    }
    QuestionnaireQuestionAnswerSingleChoice?: {
        choice?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionAnswerSingleChoice>,
            Record<string, never>,
            WithTypename<QuestionnaireQuestionChoiceOptionSnapshot> | string
        >
        id?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionAnswerSingleChoice>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        question?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionAnswerSingleChoice>,
            Record<string, never>,
            WithTypename<QuestionnaireQuestionSnapshot> | string
        >
    }
    QuestionnaireQuestionAnswerText?: {
        id?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionAnswerText>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        question?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionAnswerText>,
            Record<string, never>,
            WithTypename<QuestionnaireQuestionSnapshot> | string
        >
        text?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionAnswerText>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    QuestionnaireQuestionChoice?: {
        id?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoice>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        multiple?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoice>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        options?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoice>,
            Record<string, never>,
            Array<WithTypename<QuestionnaireQuestionChoiceOption> | string>
        >
        required?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoice>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        title?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoice>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    QuestionnaireQuestionChoiceOption?: {
        behaviour?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOption>,
            Record<string, never>,
            WithTypename<QuestionnaireQuestionChoiceOptionBehaviour> | string
        >
        content?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOption>,
            Record<string, never>,
            WithTypename<QuestionnaireQuestionChoiceOptionContent> | string
        >
        id?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOption>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        systemCode?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOption>,
            Record<string, never>,
            QuestionnaireQuestionChoiceSystemCode | string
        >
    }
    QuestionnaireQuestionChoiceOptionBehaviour?: {
        designFeature?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionBehaviour>,
            Record<string, never>,
            | QuestionnaireQuestionChoiceOptionBehaviourEngagementDesignFeatureCode
            | string
        >
        designStyle?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionBehaviour>,
            Record<string, never>,
            | QuestionnaireQuestionChoiceOptionBehaviourEngagementDesignStyleCode
            | string
        >
        metal?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionBehaviour>,
            Record<string, never>,
            | QuestionnaireQuestionChoiceOptionBehaviourEngagementRingMetalCode
            | string
        >
        ringStyle?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionBehaviour>,
            Record<string, never>,
            | QuestionnaireQuestionChoiceOptionBehaviourEngagementRingStyleCode
            | string
        >
        shape?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionBehaviour>,
            Record<string, never>,
            | QuestionnaireQuestionChoiceOptionBehaviourEngagementShapeCode
            | string
        >
    }
    QuestionnaireQuestionChoiceOptionContentIconCard?: {
        backgroundColor?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionContentIconCard>,
            Record<string, never>,
            Color | string
        >
        conditionalContent?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionContentIconCard>,
            Record<string, never>,
            Array<
                | WithTypename<QuestionnaireQuestionChoiceOptionContentIconCardConditional>
                | string
            >
        >
        description?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionContentIconCard>,
            Record<string, never>,
            Scalars['String'] | string
        >
        icon?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionContentIconCard>,
            Record<string, never>,
            WithTypename<Image> | string
        >
        title?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionContentIconCard>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    QuestionnaireQuestionChoiceOptionContentIconCardConditional?: {
        backgroundColor?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionContentIconCardConditional>,
            Record<string, never>,
            Color | string
        >
        conditions?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionContentIconCardConditional>,
            Record<string, never>,
            Array<WithTypename<QuestionnaireCondition> | string>
        >
        description?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionContentIconCardConditional>,
            Record<string, never>,
            Scalars['String'] | string
        >
        icon?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionContentIconCardConditional>,
            Record<string, never>,
            WithTypename<Image> | string
        >
        title?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionContentIconCardConditional>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    QuestionnaireQuestionChoiceOptionContentImage?: {
        conditionalContent?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionContentImage>,
            Record<string, never>,
            Array<
                | WithTypename<QuestionnaireQuestionChoiceOptionContentImageConditional>
                | string
            >
        >
        image?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionContentImage>,
            Record<string, never>,
            WithTypename<Image> | string
        >
    }
    QuestionnaireQuestionChoiceOptionContentImageCard?: {
        conditionalContent?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionContentImageCard>,
            Record<string, never>,
            Array<
                | WithTypename<QuestionnaireQuestionChoiceOptionContentImageCardConditional>
                | string
            >
        >
        description?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionContentImageCard>,
            Record<string, never>,
            Scalars['String'] | string
        >
        image?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionContentImageCard>,
            Record<string, never>,
            WithTypename<Image> | string
        >
        title?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionContentImageCard>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    QuestionnaireQuestionChoiceOptionContentImageCardConditional?: {
        conditions?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionContentImageCardConditional>,
            Record<string, never>,
            Array<WithTypename<QuestionnaireCondition> | string>
        >
        description?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionContentImageCardConditional>,
            Record<string, never>,
            Scalars['String'] | string
        >
        image?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionContentImageCardConditional>,
            Record<string, never>,
            WithTypename<Image> | string
        >
        title?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionContentImageCardConditional>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    QuestionnaireQuestionChoiceOptionContentImageConditional?: {
        conditions?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionContentImageConditional>,
            Record<string, never>,
            Array<WithTypename<QuestionnaireCondition> | string>
        >
        image?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionContentImageConditional>,
            Record<string, never>,
            WithTypename<Image> | string
        >
    }
    QuestionnaireQuestionChoiceOptionContentText?: {
        conditionalContent?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionContentText>,
            Record<string, never>,
            Array<
                | WithTypename<QuestionnaireQuestionChoiceOptionContentTextConditional>
                | string
            >
        >
        description?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionContentText>,
            Record<string, never>,
            Scalars['String'] | string
        >
        title?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionContentText>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    QuestionnaireQuestionChoiceOptionContentTextConditional?: {
        conditions?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionContentTextConditional>,
            Record<string, never>,
            Array<WithTypename<QuestionnaireCondition> | string>
        >
        description?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionContentTextConditional>,
            Record<string, never>,
            Scalars['String'] | string
        >
        title?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionContentTextConditional>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    QuestionnaireQuestionChoiceOptionLayoutSnapshotIconCard?: {
        backgroundColor?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionLayoutSnapshotIconCard>,
            Record<string, never>,
            QuestionnaireBackgroundColor | string
        >
        description?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionLayoutSnapshotIconCard>,
            Record<string, never>,
            Scalars['String'] | string
        >
        icon?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionLayoutSnapshotIconCard>,
            Record<string, never>,
            WithTypename<Asset> | string
        >
        title?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionLayoutSnapshotIconCard>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    QuestionnaireQuestionChoiceOptionLayoutSnapshotImage?: {
        icon?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionLayoutSnapshotImage>,
            Record<string, never>,
            WithTypename<Asset> | string
        >
    }
    QuestionnaireQuestionChoiceOptionLayoutSnapshotImageCard?: {
        description?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionLayoutSnapshotImageCard>,
            Record<string, never>,
            Scalars['String'] | string
        >
        icon?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionLayoutSnapshotImageCard>,
            Record<string, never>,
            WithTypename<Asset> | string
        >
        title?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionLayoutSnapshotImageCard>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    QuestionnaireQuestionChoiceOptionLayoutSnapshotText?: {
        description?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionLayoutSnapshotText>,
            Record<string, never>,
            Scalars['String'] | string
        >
        title?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionLayoutSnapshotText>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    QuestionnaireQuestionChoiceOptionSnapshot?: {
        id?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionSnapshot>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        layout?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionSnapshot>,
            Record<string, never>,
            | WithTypename<QuestionnaireQuestionChoiceOptionLayoutSnapshot>
            | string
        >
        referenceId?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionChoiceOptionSnapshot>,
            Record<string, never>,
            Scalars['ID'] | string
        >
    }
    QuestionnaireQuestionPrice?: {
        id?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionPrice>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        max?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionPrice>,
            Record<string, never>,
            Scalars['Float'] | string
        >
        min?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionPrice>,
            Record<string, never>,
            Scalars['Float'] | string
        >
        required?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionPrice>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        systemCode?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionPrice>,
            Record<string, never>,
            QuestionnaireQuestionPriceSystemCode | string
        >
        title?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionPrice>,
            Record<string, never>,
            Scalars['String'] | string
        >
        tooltip?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionPrice>,
            Record<string, never>,
            Scalars['RenderableTemplate'] | string
        >
    }
    QuestionnaireQuestionSnapshot?: {
        referenceId?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionSnapshot>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        title?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionSnapshot>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    QuestionnaireQuestionText?: {
        id?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionText>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        required?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionText>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        systemCode?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionText>,
            Record<string, never>,
            QuestionnaireQuestionTextSystemCode | string
        >
        textarea?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionText>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        title?: GraphCacheResolver<
            WithTypename<QuestionnaireQuestionText>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    QuestionnaireSignUpStep?: {
        backgroundColor?: GraphCacheResolver<
            WithTypename<QuestionnaireSignUpStep>,
            Record<string, never>,
            Color | string
        >
        description?: GraphCacheResolver<
            WithTypename<QuestionnaireSignUpStep>,
            Record<string, never>,
            Scalars['String'] | string
        >
        image?: GraphCacheResolver<
            WithTypename<QuestionnaireSignUpStep>,
            Record<string, never>,
            WithTypename<Image> | string
        >
        title?: GraphCacheResolver<
            WithTypename<QuestionnaireSignUpStep>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    QuestionnaireStep?: {
        conditions?: GraphCacheResolver<
            WithTypename<QuestionnaireStep>,
            Record<string, never>,
            Array<WithTypename<QuestionnaireCondition> | string>
        >
        content?: GraphCacheResolver<
            WithTypename<QuestionnaireStep>,
            Record<string, never>,
            Array<WithTypename<QuestionnaireStepContent> | string>
        >
        description?: GraphCacheResolver<
            WithTypename<QuestionnaireStep>,
            Record<string, never>,
            Scalars['String'] | string
        >
        excludeFromProgressIndicator?: GraphCacheResolver<
            WithTypename<QuestionnaireStep>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        help?: GraphCacheResolver<
            WithTypename<QuestionnaireStep>,
            Record<string, never>,
            Array<WithTypename<Block> | string>
        >
        title?: GraphCacheResolver<
            WithTypename<QuestionnaireStep>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    QuestionnaireStepContentContent?: {
        blocks?: GraphCacheResolver<
            WithTypename<QuestionnaireStepContentContent>,
            Record<string, never>,
            Array<WithTypename<Block> | string>
        >
        conditions?: GraphCacheResolver<
            WithTypename<QuestionnaireStepContentContent>,
            Record<string, never>,
            Array<WithTypename<QuestionnaireCondition> | string>
        >
    }
    QuestionnaireStepContentQuestions?: {
        conditions?: GraphCacheResolver<
            WithTypename<QuestionnaireStepContentQuestions>,
            Record<string, never>,
            Array<WithTypename<QuestionnaireCondition> | string>
        >
        questions?: GraphCacheResolver<
            WithTypename<QuestionnaireStepContentQuestions>,
            Record<string, never>,
            Array<
                | WithTypename<QuestionnaireQuestionChoice>
                | WithTypename<QuestionnaireQuestionPrice>
                | WithTypename<QuestionnaireQuestionText>
                | string
            >
        >
    }
    QuestionnaireSubmissionNotification?: {
        emails?: GraphCacheResolver<
            WithTypename<QuestionnaireSubmissionNotification>,
            Record<string, never>,
            Array<Scalars['String'] | string>
        >
    }
    QuotationEngagementRing?: {
        baseTemplate?: GraphCacheResolver<
            WithTypename<QuotationEngagementRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        centreStone?: GraphCacheResolver<
            WithTypename<QuotationEngagementRing>,
            Record<string, never>,
            WithTypename<DesignStudioEngagementRingCentreStone> | string
        >
        customName?: GraphCacheResolver<
            WithTypename<QuotationEngagementRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        finalUntil?: GraphCacheResolver<
            WithTypename<QuotationEngagementRing>,
            Record<string, never>,
            Scalars['DateTime'] | string
        >
        firstAvailableDeliveryDate?: GraphCacheResolver<
            WithTypename<QuotationEngagementRing>,
            Record<string, never>,
            WithTypename<DeliveryDate> | string
        >
        id?: GraphCacheResolver<
            WithTypename<QuotationEngagementRing>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        image?: GraphCacheResolver<
            WithTypename<QuotationEngagementRing>,
            Record<string, never>,
            Scalars['Uri'] | string
        >
        images?: GraphCacheResolver<
            WithTypename<QuotationEngagementRing>,
            Record<string, never>,
            Array<Scalars['Uri'] | string>
        >
        isRecommended?: GraphCacheResolver<
            WithTypename<QuotationEngagementRing>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        isSalesTaxApplicable?: GraphCacheResolver<
            WithTypename<QuotationEngagementRing>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        isVatApplicable?: GraphCacheResolver<
            WithTypename<QuotationEngagementRing>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        mount?: GraphCacheResolver<
            WithTypename<QuotationEngagementRing>,
            Record<string, never>,
            WithTypename<DesignStudioEngagementRingMount> | string
        >
        totalSalePrice?: GraphCacheResolver<
            WithTypename<QuotationEngagementRing>,
            Record<string, never>,
            WithTypename<Money> | string
        >
    }
    QuotationManualSurcharge?: {
        amount?: GraphCacheResolver<
            WithTypename<QuotationManualSurcharge>,
            Record<string, never>,
            WithTypename<Money> | string
        >
        description?: GraphCacheResolver<
            WithTypename<QuotationManualSurcharge>,
            Record<string, never>,
            Scalars['String'] | string
        >
        id?: GraphCacheResolver<
            WithTypename<QuotationManualSurcharge>,
            Record<string, never>,
            Scalars['ID'] | string
        >
    }
    QuotationPercentageSurcharge?: {
        description?: GraphCacheResolver<
            WithTypename<QuotationPercentageSurcharge>,
            Record<string, never>,
            Scalars['String'] | string
        >
        id?: GraphCacheResolver<
            WithTypename<QuotationPercentageSurcharge>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        percent?: GraphCacheResolver<
            WithTypename<QuotationPercentageSurcharge>,
            Record<string, never>,
            Scalars['Decimal'] | string
        >
    }
    QuotationWeddingRing?: {
        baseTemplate?: GraphCacheResolver<
            WithTypename<QuotationWeddingRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        comment?: GraphCacheResolver<
            WithTypename<QuotationWeddingRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        customName?: GraphCacheResolver<
            WithTypename<QuotationWeddingRing>,
            Record<string, never>,
            Scalars['String'] | string
        >
        finalUntil?: GraphCacheResolver<
            WithTypename<QuotationWeddingRing>,
            Record<string, never>,
            Scalars['DateTime'] | string
        >
        firstAvailableDeliveryDate?: GraphCacheResolver<
            WithTypename<QuotationWeddingRing>,
            Record<string, never>,
            WithTypename<DeliveryDate> | string
        >
        id?: GraphCacheResolver<
            WithTypename<QuotationWeddingRing>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        image?: GraphCacheResolver<
            WithTypename<QuotationWeddingRing>,
            Record<string, never>,
            Scalars['Uri'] | string
        >
        images?: GraphCacheResolver<
            WithTypename<QuotationWeddingRing>,
            Record<string, never>,
            Array<Scalars['Uri'] | string>
        >
        isRecommended?: GraphCacheResolver<
            WithTypename<QuotationWeddingRing>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        isSalesTaxApplicable?: GraphCacheResolver<
            WithTypename<QuotationWeddingRing>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        isVatApplicable?: GraphCacheResolver<
            WithTypename<QuotationWeddingRing>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        manualSurcharges?: GraphCacheResolver<
            WithTypename<QuotationWeddingRing>,
            Record<string, never>,
            Array<WithTypename<QuotationManualSurcharge> | string>
        >
        metals?: GraphCacheResolver<
            WithTypename<QuotationWeddingRing>,
            Record<string, never>,
            Array<WithTypename<Metal> | string>
        >
        percentageSurcharge?: GraphCacheResolver<
            WithTypename<QuotationWeddingRing>,
            Record<string, never>,
            WithTypename<QuotationPercentageSurcharge> | string
        >
        signatureStones?: GraphCacheResolver<
            WithTypename<QuotationWeddingRing>,
            Record<string, never>,
            Array<WithTypename<DesignStudioSignatureStone> | string>
        >
        totalSalePrice?: GraphCacheResolver<
            WithTypename<QuotationWeddingRing>,
            Record<string, never>,
            WithTypename<Money> | string
        >
    }
    RecommendedRingSize?: {
        id?: GraphCacheResolver<
            WithTypename<RecommendedRingSize>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        label?: GraphCacheResolver<
            WithTypename<RecommendedRingSize>,
            RecommendedRingSizeLabelArgs,
            Scalars['String'] | string
        >
        ringSize?: GraphCacheResolver<
            WithTypename<RecommendedRingSize>,
            Record<string, never>,
            WithTypename<RingSize> | string
        >
    }
    Region?: {
        code?: GraphCacheResolver<
            WithTypename<Region>,
            Record<string, never>,
            RegionCode | string
        >
        currency?: GraphCacheResolver<
            WithTypename<Region>,
            Record<string, never>,
            Scalars['Currency'] | string
        >
        isActive?: GraphCacheResolver<
            WithTypename<Region>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        language?: GraphCacheResolver<
            WithTypename<Region>,
            Record<string, never>,
            WithTypename<Language> | string
        >
        locales?: GraphCacheResolver<
            WithTypename<Region>,
            Record<string, never>,
            Array<Scalars['Locale'] | string>
        >
        representingCountry?: GraphCacheResolver<
            WithTypename<Region>,
            Record<string, never>,
            Scalars['Country'] | string
        >
    }
    Review?: {
        comment?: GraphCacheResolver<
            WithTypename<Review>,
            Record<string, never>,
            Scalars['String'] | string
        >
        date?: GraphCacheResolver<
            WithTypename<Review>,
            Record<string, never>,
            Scalars['DateTime'] | string
        >
        id?: GraphCacheResolver<
            WithTypename<Review>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        name?: GraphCacheResolver<
            WithTypename<Review>,
            Record<string, never>,
            Scalars['String'] | string
        >
        picture?: GraphCacheResolver<
            WithTypename<Review>,
            Record<string, never>,
            WithTypename<Asset> | string
        >
        products?: GraphCacheResolver<
            WithTypename<Review>,
            ReviewProductsArgs,
            Array<
                | WithTypename<CatalogueEngagementRing>
                | WithTypename<CatalogueJewelleryBracelet>
                | WithTypename<CatalogueJewelleryEarrings>
                | WithTypename<CatalogueJewelleryNecklace>
                | WithTypename<CatalogueJewelleryRing>
                | WithTypename<CatalogueReadyToGoRing>
                | WithTypename<CatalogueWeddingRing>
                | string
            >
        >
        rating?: GraphCacheResolver<
            WithTypename<Review>,
            Record<string, never>,
            Scalars['Int'] | string
        >
    }
    ReviewCarouselCard?: {
        author?: GraphCacheResolver<
            WithTypename<ReviewCarouselCard>,
            Record<string, never>,
            Scalars['String'] | string
        >
        date?: GraphCacheResolver<
            WithTypename<ReviewCarouselCard>,
            Record<string, never>,
            Scalars['String'] | string
        >
        review?: GraphCacheResolver<
            WithTypename<ReviewCarouselCard>,
            Record<string, never>,
            Scalars['String'] | string
        >
        starsCount?: GraphCacheResolver<
            WithTypename<ReviewCarouselCard>,
            Record<string, never>,
            Scalars['Int'] | string
        >
    }
    RingBuilder?: {
        failure?: GraphCacheResolver<
            WithTypename<RingBuilder>,
            Record<string, never>,
            WithTypename<DesignStudioEngagementRingFailure> | string
        >
        financeOptionsAffirm?: GraphCacheResolver<
            WithTypename<RingBuilder>,
            RingBuilderFinanceOptionsAffirmArgs,
            WithTypename<AffirmFinanceOption> | string
        >
        financeOptionsKlarna?: GraphCacheResolver<
            WithTypename<RingBuilder>,
            RingBuilderFinanceOptionsKlarnaArgs,
            WithTypename<KlarnaFinanceOption> | string
        >
        id?: GraphCacheResolver<
            WithTypename<RingBuilder>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        image?: GraphCacheResolver<
            WithTypename<RingBuilder>,
            Record<string, never>,
            WithTypename<GenericImage> | string
        >
        position1?: GraphCacheResolver<
            WithTypename<RingBuilder>,
            Record<string, never>,
            WithTypename<RingBuilderFragment> | string
        >
        position2?: GraphCacheResolver<
            WithTypename<RingBuilder>,
            Record<string, never>,
            WithTypename<RingBuilderFragment> | string
        >
        productId?: GraphCacheResolver<
            WithTypename<RingBuilder>,
            Record<string, never>,
            Scalars['String'] | string
        >
        salePrice?: GraphCacheResolver<
            WithTypename<RingBuilder>,
            RingBuilderSalePriceArgs,
            WithTypename<SalePrice> | string
        >
        stoneRecommendations?: GraphCacheResolver<
            WithTypename<RingBuilder>,
            RingBuilderStoneRecommendationsArgs,
            WithTypename<StoneRecommendationsResponse> | string
        >
        totalSalePrice?: GraphCacheResolver<
            WithTypename<RingBuilder>,
            RingBuilderTotalSalePriceArgs,
            WithTypename<Money> | string
        >
    }
    RingBuilderCentreStoneFragment?: {
        id?: GraphCacheResolver<
            WithTypename<RingBuilderCentreStoneFragment>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        stone?: GraphCacheResolver<
            WithTypename<RingBuilderCentreStoneFragment>,
            Record<string, never>,
            WithTypename<RingBuilderCentreStone> | string
        >
        totalSalePrice?: GraphCacheResolver<
            WithTypename<RingBuilderCentreStoneFragment>,
            RingBuilderCentreStoneFragmentTotalSalePriceArgs,
            WithTypename<Money> | string
        >
    }
    RingBuilderMountFragment?: {
        id?: GraphCacheResolver<
            WithTypename<RingBuilderMountFragment>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        ring?: GraphCacheResolver<
            WithTypename<RingBuilderMountFragment>,
            Record<string, never>,
            WithTypename<CatalogueEngagementRing> | string
        >
        signatureStone?: GraphCacheResolver<
            WithTypename<RingBuilderMountFragment>,
            Record<string, never>,
            WithTypename<CatalogueEngagementRingSignatureStone> | string
        >
        stoneRecommendations?: GraphCacheResolver<
            WithTypename<RingBuilderMountFragment>,
            RingBuilderMountFragmentStoneRecommendationsArgs,
            WithTypename<StoneRecommendationsResponse> | string
        >
        totalSalePrice?: GraphCacheResolver<
            WithTypename<RingBuilderMountFragment>,
            RingBuilderMountFragmentTotalSalePriceArgs,
            WithTypename<Money> | string
        >
    }
    RingBuilderResolvedExistingCustomerSuccess?: {
        data?: GraphCacheResolver<
            WithTypename<RingBuilderResolvedExistingCustomerSuccess>,
            Record<string, never>,
            WithTypename<RingBuilderResolveResult> | string
        >
        redirect?: GraphCacheResolver<
            WithTypename<RingBuilderResolvedExistingCustomerSuccess>,
            Record<string, never>,
            Scalars['Uri'] | string
        >
        ringBuilder?: GraphCacheResolver<
            WithTypename<RingBuilderResolvedExistingCustomerSuccess>,
            Record<string, never>,
            WithTypename<RingBuilder> | string
        >
    }
    RingBuilderResolvedFailure?: {
        errors?: GraphCacheResolver<
            WithTypename<RingBuilderResolvedFailure>,
            Record<string, never>,
            Array<RingBuilderResolvedFailureError | string>
        >
        ringBuilder?: GraphCacheResolver<
            WithTypename<RingBuilderResolvedFailure>,
            Record<string, never>,
            WithTypename<RingBuilder> | string
        >
    }
    RingBuilderResolvedNewCustomerSuccess?: {
        customer?: GraphCacheResolver<
            WithTypename<RingBuilderResolvedNewCustomerSuccess>,
            Record<string, never>,
            WithTypename<CustomerRegistrationResponse> | string
        >
        data?: GraphCacheResolver<
            WithTypename<RingBuilderResolvedNewCustomerSuccess>,
            Record<string, never>,
            WithTypename<RingBuilderResolveResult> | string
        >
        redirect?: GraphCacheResolver<
            WithTypename<RingBuilderResolvedNewCustomerSuccess>,
            Record<string, never>,
            Scalars['Uri'] | string
        >
        ringBuilder?: GraphCacheResolver<
            WithTypename<RingBuilderResolvedNewCustomerSuccess>,
            Record<string, never>,
            WithTypename<RingBuilder> | string
        >
    }
    RingBuilderSetResult?: {
        errors?: GraphCacheResolver<
            WithTypename<RingBuilderSetResult>,
            Record<string, never>,
            Array<RingBuilderSetError | string>
        >
        ringBuilder?: GraphCacheResolver<
            WithTypename<RingBuilderSetResult>,
            Record<string, never>,
            WithTypename<RingBuilder> | string
        >
    }
    RingSize?: {
        id?: GraphCacheResolver<
            WithTypename<RingSize>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        label?: GraphCacheResolver<
            WithTypename<RingSize>,
            RingSizeLabelArgs,
            Scalars['String'] | string
        >
    }
    SalePrice?: {
        tax?: GraphCacheResolver<
            WithTypename<SalePrice>,
            Record<string, never>,
            WithTypename<Tax> | string
        >
        total?: GraphCacheResolver<
            WithTypename<SalePrice>,
            Record<string, never>,
            WithTypename<Money> | string
        >
    }
    SearchEverywhereResponse?: {
        customers?: GraphCacheResolver<
            WithTypename<SearchEverywhereResponse>,
            Record<string, never>,
            Array<WithTypename<Customer> | string>
        >
        orders?: GraphCacheResolver<
            WithTypename<SearchEverywhereResponse>,
            Record<string, never>,
            Array<WithTypename<Order> | string>
        >
        products?: GraphCacheResolver<
            WithTypename<SearchEverywhereResponse>,
            Record<string, never>,
            Array<WithTypename<DesignStudioProductGeneric> | string>
        >
    }
    SetDeliveryInformationFailureResponse?: {
        errors?: GraphCacheResolver<
            WithTypename<SetDeliveryInformationFailureResponse>,
            Record<string, never>,
            Array<WithTypename<SetDeliveryInformationError> | string>
        >
    }
    SetDeliveryInformationSuccessResponse?: {
        order?: GraphCacheResolver<
            WithTypename<SetDeliveryInformationSuccessResponse>,
            Record<string, never>,
            WithTypename<Order> | string
        >
    }
    ShipmentTrackingInformation?: {
        dispatchedAt?: GraphCacheResolver<
            WithTypename<ShipmentTrackingInformation>,
            Record<string, never>,
            Scalars['DateTime'] | string
        >
        shippingCompany?: GraphCacheResolver<
            WithTypename<ShipmentTrackingInformation>,
            Record<string, never>,
            Scalars['String'] | string
        >
        trackingNumber?: GraphCacheResolver<
            WithTypename<ShipmentTrackingInformation>,
            Record<string, never>,
            Scalars['String'] | string
        >
        trackingUrl?: GraphCacheResolver<
            WithTypename<ShipmentTrackingInformation>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    ShopWithConfidenceEthnicallySourcedDiamonds?: {
        content?: GraphCacheResolver<
            WithTypename<ShopWithConfidenceEthnicallySourcedDiamonds>,
            Record<string, never>,
            Array<WithTypename<ContentComponentItem> | string>
        >
    }
    ShopWithConfidenceFinancingOptions?: {
        content?: GraphCacheResolver<
            WithTypename<ShopWithConfidenceFinancingOptions>,
            Record<string, never>,
            Array<WithTypename<ContentComponentItem> | string>
        >
    }
    ShopWithConfidenceGreenlandRuby?: {
        content?: GraphCacheResolver<
            WithTypename<ShopWithConfidenceGreenlandRuby>,
            Record<string, never>,
            Array<WithTypename<ContentComponentItem> | string>
        >
    }
    ShopWithConfidenceHandFinished?: {
        content?: GraphCacheResolver<
            WithTypename<ShopWithConfidenceHandFinished>,
            Record<string, never>,
            Array<WithTypename<ContentComponentItem> | string>
        >
    }
    ShopWithConfidenceResize?: {
        content?: GraphCacheResolver<
            WithTypename<ShopWithConfidenceResize>,
            Record<string, never>,
            Array<WithTypename<ContentComponentItem> | string>
        >
    }
    ShopWithConfidenceReturnPolicy?: {
        content?: GraphCacheResolver<
            WithTypename<ShopWithConfidenceReturnPolicy>,
            Record<string, never>,
            Array<WithTypename<ContentComponentItem> | string>
        >
    }
    ShopWithConfidenceShipping?: {
        content?: GraphCacheResolver<
            WithTypename<ShopWithConfidenceShipping>,
            Record<string, never>,
            Array<WithTypename<ContentComponentItem> | string>
        >
    }
    Showroom?: {
        id?: GraphCacheResolver<
            WithTypename<Showroom>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        isAccessible?: GraphCacheResolver<
            WithTypename<Showroom>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        location?: GraphCacheResolver<
            WithTypename<Showroom>,
            Record<string, never>,
            WithTypename<ShowroomLocation> | string
        >
        timezone?: GraphCacheResolver<
            WithTypename<Showroom>,
            Record<string, never>,
            Scalars['String'] | string
        >
        translation?: GraphCacheResolver<
            WithTypename<Showroom>,
            ShowroomTranslationArgs,
            WithTypename<ShowroomTranslation> | string
        >
    }
    ShowroomLocation?: {
        addressLine1?: GraphCacheResolver<
            WithTypename<ShowroomLocation>,
            Record<string, never>,
            Scalars['String'] | string
        >
        addressLine2?: GraphCacheResolver<
            WithTypename<ShowroomLocation>,
            Record<string, never>,
            Scalars['String'] | string
        >
        city?: GraphCacheResolver<
            WithTypename<ShowroomLocation>,
            Record<string, never>,
            Scalars['String'] | string
        >
        country?: GraphCacheResolver<
            WithTypename<ShowroomLocation>,
            Record<string, never>,
            Scalars['Country'] | string
        >
        geoLocation?: GraphCacheResolver<
            WithTypename<ShowroomLocation>,
            Record<string, never>,
            WithTypename<GeoPoint> | string
        >
        id?: GraphCacheResolver<
            WithTypename<ShowroomLocation>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        postalCode?: GraphCacheResolver<
            WithTypename<ShowroomLocation>,
            Record<string, never>,
            Scalars['String'] | string
        >
        subdivision?: GraphCacheResolver<
            WithTypename<ShowroomLocation>,
            Record<string, never>,
            Scalars['CountrySubdivision'] | string
        >
    }
    ShowroomTranslation?: {
        name?: GraphCacheResolver<
            WithTypename<ShowroomTranslation>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    SocialNetwork?: {
        icon?: GraphCacheResolver<
            WithTypename<SocialNetwork>,
            Record<string, never>,
            Icon | string
        >
        link?: GraphCacheResolver<
            WithTypename<SocialNetwork>,
            Record<string, never>,
            Scalars['String'] | string
        >
        name?: GraphCacheResolver<
            WithTypename<SocialNetwork>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    SquareImageBox?: {
        image?: GraphCacheResolver<
            WithTypename<SquareImageBox>,
            Record<string, never>,
            WithTypename<Image> | string
        >
        link?: GraphCacheResolver<
            WithTypename<SquareImageBox>,
            Record<string, never>,
            WithTypename<Link> | string
        >
    }
    SquareTextBox?: {
        backgroundColor?: GraphCacheResolver<
            WithTypename<SquareTextBox>,
            Record<string, never>,
            Color | string
        >
        content?: GraphCacheResolver<
            WithTypename<SquareTextBox>,
            Record<string, never>,
            Array<WithTypename<ContentComponentItem> | string>
        >
    }
    Stone?: {
        caratWeight?: GraphCacheResolver<
            WithTypename<Stone>,
            Record<string, never>,
            Scalars['Decimal'] | string
        >
        certificate?: GraphCacheResolver<
            WithTypename<Stone>,
            Record<string, never>,
            WithTypename<StoneCertificate> | string
        >
        clarity?: GraphCacheResolver<
            WithTypename<Stone>,
            Record<string, never>,
            WithTypename<StoneClarity> | string
        >
        color?: GraphCacheResolver<
            WithTypename<Stone>,
            Record<string, never>,
            WithTypename<StoneColor> | string
        >
        colorGrade?: GraphCacheResolver<
            WithTypename<Stone>,
            Record<string, never>,
            WithTypename<StoneGrade> | string
        >
        crystal?: GraphCacheResolver<
            WithTypename<Stone>,
            Record<string, never>,
            WithTypename<StoneCrystal> | string
        >
        cut?: GraphCacheResolver<
            WithTypename<Stone>,
            Record<string, never>,
            WithTypename<StoneCut> | string
        >
        depthPercent?: GraphCacheResolver<
            WithTypename<Stone>,
            Record<string, never>,
            Scalars['Decimal'] | string
        >
        fluorescence?: GraphCacheResolver<
            WithTypename<Stone>,
            Record<string, never>,
            WithTypename<StoneFluorescence> | string
        >
        id?: GraphCacheResolver<
            WithTypename<Stone>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        measurements?: GraphCacheResolver<
            WithTypename<Stone>,
            Record<string, never>,
            WithTypename<StoneMeasurements> | string
        >
        photo?: GraphCacheResolver<
            WithTypename<Stone>,
            Record<string, never>,
            Scalars['Uri'] | string
        >
        polish?: GraphCacheResolver<
            WithTypename<Stone>,
            Record<string, never>,
            WithTypename<StonePolish> | string
        >
        ratio?: GraphCacheResolver<
            WithTypename<Stone>,
            Record<string, never>,
            Scalars['Decimal'] | string
        >
        shape?: GraphCacheResolver<
            WithTypename<Stone>,
            Record<string, never>,
            WithTypename<StoneShape> | string
        >
        symmetry?: GraphCacheResolver<
            WithTypename<Stone>,
            Record<string, never>,
            WithTypename<StoneSymmetry> | string
        >
        tablePercent?: GraphCacheResolver<
            WithTypename<Stone>,
            Record<string, never>,
            Scalars['Decimal'] | string
        >
    }
    StoneCategory?: {
        systemCode?: GraphCacheResolver<
            WithTypename<StoneCategory>,
            Record<string, never>,
            StoneCategoryCode | string
        >
        translation?: GraphCacheResolver<
            WithTypename<StoneCategory>,
            StoneCategoryTranslationArgs,
            WithTypename<StoneCategoryTranslation> | string
        >
    }
    StoneCategoryTranslation?: {
        name?: GraphCacheResolver<
            WithTypename<StoneCategoryTranslation>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    StoneCertificate?: {
        number?: GraphCacheResolver<
            WithTypename<StoneCertificate>,
            Record<string, never>,
            Scalars['String'] | string
        >
        uri?: GraphCacheResolver<
            WithTypename<StoneCertificate>,
            Record<string, never>,
            Scalars['Uri'] | string
        >
    }
    StoneClarity?: {
        abbreviation?: GraphCacheResolver<
            WithTypename<StoneClarity>,
            Record<string, never>,
            Scalars['String'] | string
        >
        systemCode?: GraphCacheResolver<
            WithTypename<StoneClarity>,
            Record<string, never>,
            StoneClarityCode | string
        >
        translation?: GraphCacheResolver<
            WithTypename<StoneClarity>,
            StoneClarityTranslationArgs,
            WithTypename<StoneClarityTranslation> | string
        >
    }
    StoneClarityTranslation?: {
        name?: GraphCacheResolver<
            WithTypename<StoneClarityTranslation>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    StoneColor?: {
        systemCode?: GraphCacheResolver<
            WithTypename<StoneColor>,
            Record<string, never>,
            StoneColorCode | string
        >
        translation?: GraphCacheResolver<
            WithTypename<StoneColor>,
            StoneColorTranslationArgs,
            WithTypename<StoneColorTranslation> | string
        >
    }
    StoneColorTranslation?: {
        name?: GraphCacheResolver<
            WithTypename<StoneColorTranslation>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    StoneCrystal?: {
        systemCode?: GraphCacheResolver<
            WithTypename<StoneCrystal>,
            Record<string, never>,
            StoneCrystalCode | string
        >
        translation?: GraphCacheResolver<
            WithTypename<StoneCrystal>,
            StoneCrystalTranslationArgs,
            WithTypename<StoneCrystalTranslation> | string
        >
    }
    StoneCrystalTranslation?: {
        name?: GraphCacheResolver<
            WithTypename<StoneCrystalTranslation>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    StoneCut?: {
        abbreviation?: GraphCacheResolver<
            WithTypename<StoneCut>,
            Record<string, never>,
            Scalars['String'] | string
        >
        systemCode?: GraphCacheResolver<
            WithTypename<StoneCut>,
            Record<string, never>,
            StoneCutCode | string
        >
        translation?: GraphCacheResolver<
            WithTypename<StoneCut>,
            StoneCutTranslationArgs,
            WithTypename<StoneCutTranslation> | string
        >
    }
    StoneCutTranslation?: {
        name?: GraphCacheResolver<
            WithTypename<StoneCutTranslation>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    StoneFluorescence?: {
        abbreviation?: GraphCacheResolver<
            WithTypename<StoneFluorescence>,
            Record<string, never>,
            Scalars['String'] | string
        >
        systemCode?: GraphCacheResolver<
            WithTypename<StoneFluorescence>,
            Record<string, never>,
            StoneFluorescenceCode | string
        >
        translation?: GraphCacheResolver<
            WithTypename<StoneFluorescence>,
            StoneFluorescenceTranslationArgs,
            WithTypename<StoneFluorescenceTranslation> | string
        >
    }
    StoneFluorescenceTranslation?: {
        name?: GraphCacheResolver<
            WithTypename<StoneFluorescenceTranslation>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    StoneGrade?: {
        category?: GraphCacheResolver<
            WithTypename<StoneGrade>,
            Record<string, never>,
            WithTypename<StoneCategory> | string
        >
        systemCode?: GraphCacheResolver<
            WithTypename<StoneGrade>,
            Record<string, never>,
            StoneGradeCode | string
        >
        translation?: GraphCacheResolver<
            WithTypename<StoneGrade>,
            StoneGradeTranslationArgs,
            WithTypename<StoneGradeTranslation> | string
        >
    }
    StoneGradeTranslation?: {
        name?: GraphCacheResolver<
            WithTypename<StoneGradeTranslation>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    StoneMeasurements?: {
        depth?: GraphCacheResolver<
            WithTypename<StoneMeasurements>,
            Record<string, never>,
            Scalars['Decimal'] | string
        >
        length?: GraphCacheResolver<
            WithTypename<StoneMeasurements>,
            Record<string, never>,
            Scalars['Decimal'] | string
        >
        width?: GraphCacheResolver<
            WithTypename<StoneMeasurements>,
            Record<string, never>,
            Scalars['Decimal'] | string
        >
    }
    StonePolish?: {
        abbreviation?: GraphCacheResolver<
            WithTypename<StonePolish>,
            Record<string, never>,
            Scalars['String'] | string
        >
        systemCode?: GraphCacheResolver<
            WithTypename<StonePolish>,
            Record<string, never>,
            StonePolishCode | string
        >
        translation?: GraphCacheResolver<
            WithTypename<StonePolish>,
            StonePolishTranslationArgs,
            WithTypename<StonePolishTranslation> | string
        >
    }
    StonePolishTranslation?: {
        name?: GraphCacheResolver<
            WithTypename<StonePolishTranslation>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    StoneRecommendationNonSkuGemstone?: {
        color?: GraphCacheResolver<
            WithTypename<StoneRecommendationNonSkuGemstone>,
            Record<string, never>,
            WithTypename<StoneColor> | string
        >
        item?: GraphCacheResolver<
            WithTypename<StoneRecommendationNonSkuGemstone>,
            Record<string, never>,
            WithTypename<StoneRecommendationNonSkuGemstoneItem> | string
        >
    }
    StoneRecommendationNotFound?: {
        haveWithoutPricingRange?: GraphCacheResolver<
            WithTypename<StoneRecommendationNotFound>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
    }
    StoneRecommendationsNaturalDiamondFilters?: {
        clarities?: GraphCacheResolver<
            WithTypename<StoneRecommendationsNaturalDiamondFilters>,
            Record<string, never>,
            Array<WithTypename<StoneClarity> | string>
        >
        colors?: GraphCacheResolver<
            WithTypename<StoneRecommendationsNaturalDiamondFilters>,
            Record<string, never>,
            Array<WithTypename<StoneColor> | string>
        >
        cuts?: GraphCacheResolver<
            WithTypename<StoneRecommendationsNaturalDiamondFilters>,
            Record<string, never>,
            Array<WithTypename<StoneCut> | string>
        >
        depthPercentRange?: GraphCacheResolver<
            WithTypename<StoneRecommendationsNaturalDiamondFilters>,
            Record<string, never>,
            WithTypename<StoneRecommendationsPercentRange> | string
        >
        fluorescences?: GraphCacheResolver<
            WithTypename<StoneRecommendationsNaturalDiamondFilters>,
            Record<string, never>,
            Array<WithTypename<StoneFluorescence> | string>
        >
        maxCaratWeight?: GraphCacheResolver<
            WithTypename<StoneRecommendationsNaturalDiamondFilters>,
            Record<string, never>,
            Scalars['Decimal'] | string
        >
        minCaratWeight?: GraphCacheResolver<
            WithTypename<StoneRecommendationsNaturalDiamondFilters>,
            Record<string, never>,
            Scalars['Decimal'] | string
        >
        polishes?: GraphCacheResolver<
            WithTypename<StoneRecommendationsNaturalDiamondFilters>,
            Record<string, never>,
            Array<WithTypename<StonePolish> | string>
        >
        priceMax?: GraphCacheResolver<
            WithTypename<StoneRecommendationsNaturalDiamondFilters>,
            StoneRecommendationsNaturalDiamondFiltersPriceMaxArgs,
            WithTypename<Money> | string
        >
        priceMin?: GraphCacheResolver<
            WithTypename<StoneRecommendationsNaturalDiamondFilters>,
            StoneRecommendationsNaturalDiamondFiltersPriceMinArgs,
            WithTypename<Money> | string
        >
        region?: GraphCacheResolver<
            WithTypename<StoneRecommendationsNaturalDiamondFilters>,
            Record<string, never>,
            WithTypename<Region> | string
        >
        shape?: GraphCacheResolver<
            WithTypename<StoneRecommendationsNaturalDiamondFilters>,
            Record<string, never>,
            WithTypename<StoneShape> | string
        >
        symmetries?: GraphCacheResolver<
            WithTypename<StoneRecommendationsNaturalDiamondFilters>,
            Record<string, never>,
            Array<WithTypename<StoneSymmetry> | string>
        >
        tablePercentRange?: GraphCacheResolver<
            WithTypename<StoneRecommendationsNaturalDiamondFilters>,
            Record<string, never>,
            WithTypename<StoneRecommendationsPercentRange> | string
        >
    }
    StoneRecommendationsPercentRange?: {
        max?: GraphCacheResolver<
            WithTypename<StoneRecommendationsPercentRange>,
            Record<string, never>,
            Scalars['Int'] | string
        >
        min?: GraphCacheResolver<
            WithTypename<StoneRecommendationsPercentRange>,
            Record<string, never>,
            Scalars['Int'] | string
        >
    }
    StoneRecommendationsPriceRange?: {
        max?: GraphCacheResolver<
            WithTypename<StoneRecommendationsPriceRange>,
            Record<string, never>,
            WithTypename<Money> | string
        >
        min?: GraphCacheResolver<
            WithTypename<StoneRecommendationsPriceRange>,
            Record<string, never>,
            WithTypename<Money> | string
        >
    }
    StoneRecommendationsResponseFailure?: {
        error?: GraphCacheResolver<
            WithTypename<StoneRecommendationsResponseFailure>,
            Record<string, never>,
            StoneRecommendationsResponseError | string
        >
    }
    StoneRecommendationsResponseSuccess?: {
        naturalDiamondBestForBalance?: GraphCacheResolver<
            WithTypename<StoneRecommendationsResponseSuccess>,
            Record<string, never>,
            WithTypename<StoneRecommendationGemsApiStone> | string
        >
        naturalDiamondBestForBalanceFilters?: GraphCacheResolver<
            WithTypename<StoneRecommendationsResponseSuccess>,
            Record<string, never>,
            WithTypename<StoneRecommendationsNaturalDiamondFilters> | string
        >
        naturalDiamondBestForSize?: GraphCacheResolver<
            WithTypename<StoneRecommendationsResponseSuccess>,
            Record<string, never>,
            WithTypename<StoneRecommendationGemsApiStone> | string
        >
        naturalDiamondBestForSizeFilters?: GraphCacheResolver<
            WithTypename<StoneRecommendationsResponseSuccess>,
            Record<string, never>,
            WithTypename<StoneRecommendationsNaturalDiamondFilters> | string
        >
        nonSkuGemStones?: GraphCacheResolver<
            WithTypename<StoneRecommendationsResponseSuccess>,
            StoneRecommendationsResponseSuccessNonSkuGemStonesArgs,
            Array<WithTypename<StoneRecommendationNonSkuGemstone> | string>
        >
        nonSkuLabGrownBestForPrice?: GraphCacheResolver<
            WithTypename<StoneRecommendationsResponseSuccess>,
            Record<string, never>,
            WithTypename<StoneRecommendationNonSkuLabGrownItem> | string
        >
        nonSkuLabGrownBestForSize?: GraphCacheResolver<
            WithTypename<StoneRecommendationsResponseSuccess>,
            Record<string, never>,
            WithTypename<StoneRecommendationNonSkuLabGrownItem> | string
        >
        priceBounds?: GraphCacheResolver<
            WithTypename<StoneRecommendationsResponseSuccess>,
            Record<string, never>,
            WithTypename<StoneRecommendationsPriceRange> | string
        >
        priceInitialValues?: GraphCacheResolver<
            WithTypename<StoneRecommendationsResponseSuccess>,
            Record<string, never>,
            WithTypename<StoneRecommendationsPriceRange> | string
        >
    }
    StoneShape?: {
        icon?: GraphCacheResolver<
            WithTypename<StoneShape>,
            Record<string, never>,
            WithTypename<Asset> | string
        >
        samplePhoto?: GraphCacheResolver<
            WithTypename<StoneShape>,
            Record<string, never>,
            WithTypename<Asset> | string
        >
        systemCode?: GraphCacheResolver<
            WithTypename<StoneShape>,
            Record<string, never>,
            StoneShapeCode | string
        >
        translation?: GraphCacheResolver<
            WithTypename<StoneShape>,
            StoneShapeTranslationArgs,
            WithTypename<StoneShapeTranslation> | string
        >
    }
    StoneShapeTranslation?: {
        name?: GraphCacheResolver<
            WithTypename<StoneShapeTranslation>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    StoneSymmetry?: {
        abbreviation?: GraphCacheResolver<
            WithTypename<StoneSymmetry>,
            Record<string, never>,
            Scalars['String'] | string
        >
        systemCode?: GraphCacheResolver<
            WithTypename<StoneSymmetry>,
            Record<string, never>,
            StoneSymmetryCode | string
        >
        translation?: GraphCacheResolver<
            WithTypename<StoneSymmetry>,
            StoneSymmetryTranslationArgs,
            WithTypename<StoneSymmetryTranslation> | string
        >
    }
    StoneSymmetryTranslation?: {
        name?: GraphCacheResolver<
            WithTypename<StoneSymmetryTranslation>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    StripeTransaction?: {
        amount?: GraphCacheResolver<
            WithTypename<StripeTransaction>,
            Record<string, never>,
            WithTypename<Money> | string
        >
        createdAt?: GraphCacheResolver<
            WithTypename<StripeTransaction>,
            Record<string, never>,
            Scalars['DateTime'] | string
        >
        id?: GraphCacheResolver<
            WithTypename<StripeTransaction>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        status?: GraphCacheResolver<
            WithTypename<StripeTransaction>,
            Record<string, never>,
            WithTypename<TransactionStatus> | string
        >
    }
    SubMenu?: {
        description?: GraphCacheResolver<
            WithTypename<SubMenu>,
            Record<string, never>,
            Scalars['String'] | string
        >
        editorialContent?: GraphCacheResolver<
            WithTypename<SubMenu>,
            Record<string, never>,
            WithTypename<SubMenuEditorialContent> | string
        >
        sections?: GraphCacheResolver<
            WithTypename<SubMenu>,
            Record<string, never>,
            Array<WithTypename<SubMenuSection> | string>
        >
        title?: GraphCacheResolver<
            WithTypename<SubMenu>,
            Record<string, never>,
            Scalars['String'] | string
        >
        useLargeFormatItems?: GraphCacheResolver<
            WithTypename<SubMenu>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
    }
    SubMenuEditorialContent?: {
        image?: GraphCacheResolver<
            WithTypename<SubMenuEditorialContent>,
            Record<string, never>,
            WithTypename<Image> | string
        >
        link?: GraphCacheResolver<
            WithTypename<SubMenuEditorialContent>,
            Record<string, never>,
            WithTypename<Link> | string
        >
        text?: GraphCacheResolver<
            WithTypename<SubMenuEditorialContent>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    SubMenuItem?: {
        icon?: GraphCacheResolver<
            WithTypename<SubMenuItem>,
            Record<string, never>,
            WithTypename<Image> | string
        >
        link?: GraphCacheResolver<
            WithTypename<SubMenuItem>,
            Record<string, never>,
            WithTypename<Link> | string
        >
        media?: GraphCacheResolver<
            WithTypename<SubMenuItem>,
            Record<string, never>,
            WithTypename<Image> | string
        >
        style?: GraphCacheResolver<
            WithTypename<SubMenuItem>,
            Record<string, never>,
            SubMenuItemStyle | string
        >
        title?: GraphCacheResolver<
            WithTypename<SubMenuItem>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    SubMenuSection?: {
        items?: GraphCacheResolver<
            WithTypename<SubMenuSection>,
            Record<string, never>,
            Array<WithTypename<SubMenuItem> | string>
        >
        title?: GraphCacheResolver<
            WithTypename<SubMenuSection>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    Table?: {
        body?: GraphCacheResolver<
            WithTypename<Table>,
            Record<string, never>,
            WithTypename<TableBody> | string
        >
        header?: GraphCacheResolver<
            WithTypename<Table>,
            Record<string, never>,
            WithTypename<TableHeader> | string
        >
    }
    TableBody?: {
        rows?: GraphCacheResolver<
            WithTypename<TableBody>,
            Record<string, never>,
            Array<WithTypename<TableRow> | string>
        >
    }
    TableHeader?: {
        cells?: GraphCacheResolver<
            WithTypename<TableHeader>,
            Record<string, never>,
            Array<Scalars['String'] | string>
        >
    }
    TableRow?: {
        cells?: GraphCacheResolver<
            WithTypename<TableRow>,
            Record<string, never>,
            Array<Scalars['String'] | string>
        >
    }
    Tax?: {
        price?: GraphCacheResolver<
            WithTypename<Tax>,
            Record<string, never>,
            WithTypename<Money> | string
        >
        type?: GraphCacheResolver<
            WithTypename<Tax>,
            Record<string, never>,
            TaxType | string
        >
    }
    TextCarouselItem?: {
        text?: GraphCacheResolver<
            WithTypename<TextCarouselItem>,
            Record<string, never>,
            Scalars['String'] | string
        >
        title?: GraphCacheResolver<
            WithTypename<TextCarouselItem>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    Tooltip?: {
        content?: GraphCacheResolver<
            WithTypename<Tooltip>,
            Record<string, never>,
            Array<WithTypename<ContentComponentItem> | string>
        >
        title?: GraphCacheResolver<
            WithTypename<Tooltip>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    TopBar?: {
        consultationPrompt?: GraphCacheResolver<
            WithTypename<TopBar>,
            Record<string, never>,
            WithTypename<TopBarConsultationPrompt> | string
        >
        siteWideMessage?: GraphCacheResolver<
            WithTypename<TopBar>,
            Record<string, never>,
            WithTypename<TopBarSiteWideMessage> | string
        >
    }
    TopBarConsultationPrompt?: {
        link?: GraphCacheResolver<
            WithTypename<TopBarConsultationPrompt>,
            Record<string, never>,
            WithTypename<Link> | string
        >
    }
    TopBarSiteWideMessage?: {
        link?: GraphCacheResolver<
            WithTypename<TopBarSiteWideMessage>,
            Record<string, never>,
            WithTypename<Link> | string
        >
        message?: GraphCacheResolver<
            WithTypename<TopBarSiteWideMessage>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    TransactionStatus?: {
        name?: GraphCacheResolver<
            WithTypename<TransactionStatus>,
            TransactionStatusNameArgs,
            Scalars['String'] | string
        >
        systemCode?: GraphCacheResolver<
            WithTypename<TransactionStatus>,
            Record<string, never>,
            TransactionStatusCode | string
        >
    }
    Translation?: {
        token?: GraphCacheResolver<
            WithTypename<Translation>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        translation?: GraphCacheResolver<
            WithTypename<Translation>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    User?: {
        createdAt?: GraphCacheResolver<
            WithTypename<User>,
            Record<string, never>,
            Scalars['DateTime'] | string
        >
        customer?: GraphCacheResolver<
            WithTypename<User>,
            Record<string, never>,
            WithTypename<Customer> | string
        >
        email?: GraphCacheResolver<
            WithTypename<User>,
            Record<string, never>,
            Scalars['Email'] | string
        >
        firstName?: GraphCacheResolver<
            WithTypename<User>,
            Record<string, never>,
            Scalars['String'] | string
        >
        id?: GraphCacheResolver<
            WithTypename<User>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        isConsultant?: GraphCacheResolver<
            WithTypename<User>,
            Record<string, never>,
            Scalars['Boolean'] | string
        >
        lastName?: GraphCacheResolver<
            WithTypename<User>,
            Record<string, never>,
            Scalars['String'] | string
        >
    }
    UserCustomerEngagementRingRecommendations?: {
        designFeature?: GraphCacheResolver<
            WithTypename<UserCustomerEngagementRingRecommendations>,
            Record<string, never>,
            WithTypename<EngagementRingDesignFeatureLabel> | string
        >
        designStyle?: GraphCacheResolver<
            WithTypename<UserCustomerEngagementRingRecommendations>,
            Record<string, never>,
            WithTypename<EngagementRingDesignStyleLabel> | string
        >
        items?: GraphCacheResolver<
            WithTypename<UserCustomerEngagementRingRecommendations>,
            UserCustomerEngagementRingRecommendationsItemsArgs,
            Array<WithTypename<CatalogueEngagementRing> | string>
        >
        metal?: GraphCacheResolver<
            WithTypename<UserCustomerEngagementRingRecommendations>,
            Record<string, never>,
            WithTypename<Metal> | string
        >
        ringStyle?: GraphCacheResolver<
            WithTypename<UserCustomerEngagementRingRecommendations>,
            Record<string, never>,
            WithTypename<EngagementRingStyleLabel> | string
        >
        shape?: GraphCacheResolver<
            WithTypename<UserCustomerEngagementRingRecommendations>,
            Record<string, never>,
            WithTypename<StoneShape> | string
        >
    }
    Video?: {
        alt?: GraphCacheResolver<
            WithTypename<Video>,
            Record<string, never>,
            Scalars['String'] | string
        >
        caption?: GraphCacheResolver<
            WithTypename<Video>,
            Record<string, never>,
            Scalars['String'] | string
        >
        description?: GraphCacheResolver<
            WithTypename<Video>,
            Record<string, never>,
            Scalars['String'] | string
        >
        filename?: GraphCacheResolver<
            WithTypename<Video>,
            Record<string, never>,
            Scalars['String'] | string
        >
        filesize?: GraphCacheResolver<
            WithTypename<Video>,
            Record<string, never>,
            Scalars['Int'] | string
        >
        height?: GraphCacheResolver<
            WithTypename<Video>,
            Record<string, never>,
            Scalars['Int'] | string
        >
        id?: GraphCacheResolver<
            WithTypename<Video>,
            Record<string, never>,
            Scalars['ID'] | string
        >
        mimeType?: GraphCacheResolver<
            WithTypename<Video>,
            Record<string, never>,
            Scalars['String'] | string
        >
        name?: GraphCacheResolver<
            WithTypename<Video>,
            Record<string, never>,
            Scalars['String'] | string
        >
        title?: GraphCacheResolver<
            WithTypename<Video>,
            Record<string, never>,
            Scalars['String'] | string
        >
        url?: GraphCacheResolver<
            WithTypename<Video>,
            Record<string, never>,
            Scalars['String'] | string
        >
        width?: GraphCacheResolver<
            WithTypename<Video>,
            Record<string, never>,
            Scalars['Int'] | string
        >
    }
    WeddingRingCategoryLabel?: {
        icon?: GraphCacheResolver<
            WithTypename<WeddingRingCategoryLabel>,
            Record<string, never>,
            WithTypename<Asset> | string
        >
        systemCode?: GraphCacheResolver<
            WithTypename<WeddingRingCategoryLabel>,
            Record<string, never>,
            WeddingRingCategoryLabelCode | string
        >
        translation?: GraphCacheResolver<
            WithTypename<WeddingRingCategoryLabel>,
            WeddingRingCategoryLabelTranslationArgs,
            WithTypename<ProductLabelTranslation> | string
        >
    }
    WeddingRingStyleLabel?: {
        icon?: GraphCacheResolver<
            WithTypename<WeddingRingStyleLabel>,
            Record<string, never>,
            WithTypename<Asset> | string
        >
        systemCode?: GraphCacheResolver<
            WithTypename<WeddingRingStyleLabel>,
            Record<string, never>,
            WeddingRingStyleLabelCode | string
        >
        translation?: GraphCacheResolver<
            WithTypename<WeddingRingStyleLabel>,
            WeddingRingStyleLabelTranslationArgs,
            WithTypename<ProductLabelTranslation> | string
        >
    }
    WorkingHours?: {
        closing?: GraphCacheResolver<
            WithTypename<WorkingHours>,
            Record<string, never>,
            Scalars['Time'] | string
        >
        opening?: GraphCacheResolver<
            WithTypename<WorkingHours>,
            Record<string, never>,
            Scalars['Time'] | string
        >
        weekDays?: GraphCacheResolver<
            WithTypename<WorkingHours>,
            Record<string, never>,
            Array<WeekDay | string>
        >
    }
}

export type GraphCacheOptimisticUpdaters = {
    addDesignStudioProductToMyCart?: GraphCacheOptimisticMutationResolver<
        MutationAddDesignStudioProductToMyCartArgs,
        WithTypename<Order>
    >
    addToCartReadyToGoRingExistingCustomer?: GraphCacheOptimisticMutationResolver<
        MutationAddToCartReadyToGoRingExistingCustomerArgs,
        WithTypename<AddToCartReadyToGoRingExistingCustomerResponse>
    >
    addToCartReadyToGoRingNewCustomer?: GraphCacheOptimisticMutationResolver<
        MutationAddToCartReadyToGoRingNewCustomerArgs,
        WithTypename<AddToCartReadyToGoRingNewCustomerResponse>
    >
    applyPromoCode?: GraphCacheOptimisticMutationResolver<
        MutationApplyPromoCodeArgs,
        Maybe<WithTypename<PromoCodeApplicationResult>>
    >
    applyTransitionToConsultationByConsultant?: GraphCacheOptimisticMutationResolver<
        MutationApplyTransitionToConsultationByConsultantArgs,
        Maybe<WithTypename<BookingConsultation>>
    >
    autologin?: GraphCacheOptimisticMutationResolver<
        MutationAutologinArgs,
        WithTypename<LoginResponse>
    >
    cancelConsultation?: GraphCacheOptimisticMutationResolver<
        MutationCancelConsultationArgs,
        Scalars['Boolean']
    >
    completeAffirmTransactionPostIframe?: GraphCacheOptimisticMutationResolver<
        MutationCompleteAffirmTransactionPostIframeArgs,
        WithTypename<AffirmCompleteTransactionResponse>
    >
    completeCheckoutcomTransactionPost3ds?: GraphCacheOptimisticMutationResolver<
        MutationCompleteCheckoutcomTransactionPost3dsArgs,
        WithTypename<CompleteCheckoutcomTransactionPost3dsResponse>
    >
    createAffirmTransaction?: GraphCacheOptimisticMutationResolver<
        MutationCreateAffirmTransactionArgs,
        WithTypename<AffirmTransaction>
    >
    createAllocationTransaction?: GraphCacheOptimisticMutationResolver<
        MutationCreateAllocationTransactionArgs,
        WithTypename<AllocationTransaction>
    >
    createBankTransaction?: GraphCacheOptimisticMutationResolver<
        MutationCreateBankTransactionArgs,
        WithTypename<BankTransaction>
    >
    createCheckoutcomTransaction?: GraphCacheOptimisticMutationResolver<
        MutationCreateCheckoutcomTransactionArgs,
        WithTypename<CreateCheckoutcomTransactionResponse>
    >
    createConsultationByConsultant?: GraphCacheOptimisticMutationResolver<
        MutationCreateConsultationByConsultantArgs,
        Maybe<WithTypename<BookingConsultation>>
    >
    createConsultationExistingCustomer?: GraphCacheOptimisticMutationResolver<
        MutationCreateConsultationExistingCustomerArgs,
        WithTypename<BookingCreateConsultationExistingCustomerResponse>
    >
    createConsultationNewCustomer?: GraphCacheOptimisticMutationResolver<
        MutationCreateConsultationNewCustomerArgs,
        WithTypename<BookingCreateConsultationNewCustomerResponse>
    >
    createDesignInspiration?: GraphCacheOptimisticMutationResolver<
        MutationCreateDesignInspirationArgs,
        WithTypename<DesignInspiration>
    >
    createDesignStudioProductAndAddToCartJewelleryExistingCustomer?: GraphCacheOptimisticMutationResolver<
        MutationCreateDesignStudioProductAndAddToCartJewelleryExistingCustomerArgs,
        WithTypename<CatalogueDesignStudioCheckoutJewelleryExistingCustomerResponse>
    >
    createDesignStudioProductAndAddToCartJewelleryNewCustomer?: GraphCacheOptimisticMutationResolver<
        MutationCreateDesignStudioProductAndAddToCartJewelleryNewCustomerArgs,
        WithTypename<CatalogueDesignStudioCheckoutJewelleryNewCustomerResponse>
    >
    createDesignStudioProductAndAddToCartWeddingRingExistingCustomer?: GraphCacheOptimisticMutationResolver<
        MutationCreateDesignStudioProductAndAddToCartWeddingRingExistingCustomerArgs,
        WithTypename<CatalogueDesignStudioCheckoutWeddingRingExistingCustomerResponse>
    >
    createDesignStudioProductAndAddToCartWeddingRingNewCustomer?: GraphCacheOptimisticMutationResolver<
        MutationCreateDesignStudioProductAndAddToCartWeddingRingNewCustomerArgs,
        WithTypename<CatalogueDesignStudioCheckoutWeddingRingNewCustomerResponse>
    >
    createEnquiryContactUsExistingCustomer?: GraphCacheOptimisticMutationResolver<
        MutationCreateEnquiryContactUsExistingCustomerArgs,
        WithTypename<EnquiryResponseExistingCustomer>
    >
    createEnquiryContactUsNewCustomer?: GraphCacheOptimisticMutationResolver<
        MutationCreateEnquiryContactUsNewCustomerArgs,
        WithTypename<EnquiryResponseNewCustomer>
    >
    createEnquiryCustomEngagementRingExistingCustomer?: GraphCacheOptimisticMutationResolver<
        MutationCreateEnquiryCustomEngagementRingExistingCustomerArgs,
        WithTypename<EnquiryResponseExistingCustomer>
    >
    createEnquiryCustomEngagementRingNewCustomer?: GraphCacheOptimisticMutationResolver<
        MutationCreateEnquiryCustomEngagementRingNewCustomerArgs,
        WithTypename<EnquiryResponseNewCustomer>
    >
    createEnquiryDiamondSearchProductExistingCustomer?: GraphCacheOptimisticMutationResolver<
        MutationCreateEnquiryDiamondSearchProductExistingCustomerArgs,
        WithTypename<EnquiryResponseExistingCustomer>
    >
    createEnquiryDiamondSearchProductNewCustomer?: GraphCacheOptimisticMutationResolver<
        MutationCreateEnquiryDiamondSearchProductNewCustomerArgs,
        WithTypename<EnquiryResponseNewCustomer>
    >
    createEnquiryEngagementRingPreferAnotherShapeExistingCustomer?: GraphCacheOptimisticMutationResolver<
        MutationCreateEnquiryEngagementRingPreferAnotherShapeExistingCustomerArgs,
        WithTypename<EnquiryResponseExistingCustomer>
    >
    createEnquiryEngagementRingPreferAnotherShapeNewCustomer?: GraphCacheOptimisticMutationResolver<
        MutationCreateEnquiryEngagementRingPreferAnotherShapeNewCustomerArgs,
        WithTypename<EnquiryResponseNewCustomer>
    >
    createEnquiryExistingCustomer?: GraphCacheOptimisticMutationResolver<
        MutationCreateEnquiryExistingCustomerArgs,
        WithTypename<EnquiryResponseExistingCustomer>
    >
    createEnquiryNewCustomer?: GraphCacheOptimisticMutationResolver<
        MutationCreateEnquiryNewCustomerArgs,
        WithTypename<EnquiryResponseNewCustomer>
    >
    createKlarnaTransaction?: GraphCacheOptimisticMutationResolver<
        MutationCreateKlarnaTransactionArgs,
        WithTypename<KlarnaTransaction>
    >
    designStudioProductEngagementRingUpdate?: GraphCacheOptimisticMutationResolver<
        MutationDesignStudioProductEngagementRingUpdateArgs,
        WithTypename<DesignStudioProductEngagementRing>
    >
    designStudioProductWeddingRingUpdate?: GraphCacheOptimisticMutationResolver<
        MutationDesignStudioProductWeddingRingUpdateArgs,
        WithTypename<DesignStudioProductWeddingRing>
    >
    designStudioQuotationEngagementRingUpdate?: GraphCacheOptimisticMutationResolver<
        MutationDesignStudioQuotationEngagementRingUpdateArgs,
        WithTypename<QuotationEngagementRing>
    >
    impersonate?: GraphCacheOptimisticMutationResolver<
        MutationImpersonateArgs,
        WithTypename<LoginResponse>
    >
    invalidateCache?: GraphCacheOptimisticMutationResolver<
        MutationInvalidateCacheArgs,
        WithTypename<InvalidateCacheResult>
    >
    login?: GraphCacheOptimisticMutationResolver<
        MutationLoginArgs,
        WithTypename<LoginResponse>
    >
    loginWithGoogle?: GraphCacheOptimisticMutationResolver<
        MutationLoginWithGoogleArgs,
        WithTypename<LoginResponse>
    >
    logout?: GraphCacheOptimisticMutationResolver<
        Record<string, never>,
        Scalars['Boolean']
    >
    magicLinkConsume?: GraphCacheOptimisticMutationResolver<
        MutationMagicLinkConsumeArgs,
        WithTypename<MagicLinkConsumeResponse>
    >
    magicLinkRequest?: GraphCacheOptimisticMutationResolver<
        MutationMagicLinkRequestArgs,
        Maybe<Scalars['Void']>
    >
    marketingData?: GraphCacheOptimisticMutationResolver<
        MutationMarketingDataArgs,
        WithTypename<MarketingDataResponse>
    >
    nonSkuGemStoneChangeImage?: GraphCacheOptimisticMutationResolver<
        MutationNonSkuGemStoneChangeImageArgs,
        WithTypename<NonSkuGemstone>
    >
    nonSkuGemStoneCreate?: GraphCacheOptimisticMutationResolver<
        MutationNonSkuGemStoneCreateArgs,
        WithTypename<NonSkuGemstone>
    >
    nonSkuGemStoneDelete?: GraphCacheOptimisticMutationResolver<
        MutationNonSkuGemStoneDeleteArgs,
        WithTypename<NonSkuGemstone>
    >
    nonSkuGemStoneDeleteImage?: GraphCacheOptimisticMutationResolver<
        MutationNonSkuGemStoneDeleteImageArgs,
        WithTypename<NonSkuGemstone>
    >
    nonSkuGemstoneCaratDimensionCreate?: GraphCacheOptimisticMutationResolver<
        MutationNonSkuGemstoneCaratDimensionCreateArgs,
        WithTypename<NonSkuGemstoneCaratDimension>
    >
    nonSkuGemstoneCaratDimensionDelete?: GraphCacheOptimisticMutationResolver<
        MutationNonSkuGemstoneCaratDimensionDeleteArgs,
        WithTypename<NonSkuGemstoneCaratDimension>
    >
    nonSkuGemstoneColorCrystalDimensionCreate?: GraphCacheOptimisticMutationResolver<
        MutationNonSkuGemstoneColorCrystalDimensionCreateArgs,
        WithTypename<NonSkuGemstoneType>
    >
    nonSkuGemstoneColorCrystalDimensionDelete?: GraphCacheOptimisticMutationResolver<
        MutationNonSkuGemstoneColorCrystalDimensionDeleteArgs,
        WithTypename<NonSkuGemstoneType>
    >
    nonSkuGemstoneGradeClarityDimensionCreate?: GraphCacheOptimisticMutationResolver<
        MutationNonSkuGemstoneGradeClarityDimensionCreateArgs,
        WithTypename<NonSkuGemstoneGradeClarityDimension>
    >
    nonSkuGemstoneGradeClarityDimensionDelete?: GraphCacheOptimisticMutationResolver<
        MutationNonSkuGemstoneGradeClarityDimensionDeleteArgs,
        WithTypename<NonSkuGemstoneGradeClarityDimension>
    >
    nonSkuGemstoneImageCreate?: GraphCacheOptimisticMutationResolver<
        MutationNonSkuGemstoneImageCreateArgs,
        WithTypename<NonSkuGemstoneImage>
    >
    nonSkuGemstoneImageDelete?: GraphCacheOptimisticMutationResolver<
        MutationNonSkuGemstoneImageDeleteArgs,
        WithTypename<NonSkuGemstoneImage>
    >
    nonSkuGemstoneImageUpdate?: GraphCacheOptimisticMutationResolver<
        MutationNonSkuGemstoneImageUpdateArgs,
        WithTypename<NonSkuGemstoneImage>
    >
    nonSkuGemstoneShapeDimensionCreate?: GraphCacheOptimisticMutationResolver<
        MutationNonSkuGemstoneShapeDimensionCreateArgs,
        WithTypename<NonSkuGemstoneShapeDimension>
    >
    nonSkuGemstoneShapeDimensionDelete?: GraphCacheOptimisticMutationResolver<
        MutationNonSkuGemstoneShapeDimensionDeleteArgs,
        WithTypename<NonSkuGemstoneShapeDimension>
    >
    nonSkuLabGrownCaratDimensionCreate?: GraphCacheOptimisticMutationResolver<
        MutationNonSkuLabGrownCaratDimensionCreateArgs,
        WithTypename<NonSkuLabGrownCaratDimension>
    >
    nonSkuLabGrownCaratDimensionDelete?: GraphCacheOptimisticMutationResolver<
        MutationNonSkuLabGrownCaratDimensionDeleteArgs,
        WithTypename<NonSkuLabGrownCaratDimension>
    >
    nonSkuLabGrownDiamondChangeImage?: GraphCacheOptimisticMutationResolver<
        MutationNonSkuLabGrownDiamondChangeImageArgs,
        WithTypename<NonSkuLabGrown>
    >
    nonSkuLabGrownDiamondCreate?: GraphCacheOptimisticMutationResolver<
        MutationNonSkuLabGrownDiamondCreateArgs,
        WithTypename<NonSkuLabGrown>
    >
    nonSkuLabGrownDiamondDelete?: GraphCacheOptimisticMutationResolver<
        MutationNonSkuLabGrownDiamondDeleteArgs,
        WithTypename<NonSkuLabGrown>
    >
    nonSkuLabGrownDiamondDeleteImage?: GraphCacheOptimisticMutationResolver<
        MutationNonSkuLabGrownDiamondDeleteImageArgs,
        WithTypename<NonSkuLabGrown>
    >
    nonSkuLabGrownGradeDimensionCreate?: GraphCacheOptimisticMutationResolver<
        MutationNonSkuLabGrownGradeDimensionCreateArgs,
        WithTypename<NonSkuLabGrownGradeDimension>
    >
    nonSkuLabGrownGradeDimensionDelete?: GraphCacheOptimisticMutationResolver<
        MutationNonSkuLabGrownGradeDimensionDeleteArgs,
        WithTypename<NonSkuLabGrownGradeDimension>
    >
    nonSkuLabGrownShapeDimensionCreate?: GraphCacheOptimisticMutationResolver<
        MutationNonSkuLabGrownShapeDimensionCreateArgs,
        WithTypename<NonSkuLabGrownShapeDimension>
    >
    nonSkuLabGrownShapeDimensionDelete?: GraphCacheOptimisticMutationResolver<
        MutationNonSkuLabGrownShapeDimensionDeleteArgs,
        WithTypename<NonSkuLabGrownShapeDimension>
    >
    nonSkuLabGrownShapeDimensionUpdate?: GraphCacheOptimisticMutationResolver<
        MutationNonSkuLabGrownShapeDimensionUpdateArgs,
        WithTypename<NonSkuLabGrownShapeDimension>
    >
    payViaAffirm?: GraphCacheOptimisticMutationResolver<
        MutationPayViaAffirmArgs,
        WithTypename<AffirmPaymentResponse>
    >
    payViaAllocation?: GraphCacheOptimisticMutationResolver<
        MutationPayViaAllocationArgs,
        WithTypename<Order>
    >
    payViaBank?: GraphCacheOptimisticMutationResolver<
        MutationPayViaBankArgs,
        WithTypename<Order>
    >
    payViaCheckoutcom?: GraphCacheOptimisticMutationResolver<
        MutationPayViaCheckoutcomArgs,
        WithTypename<PayViaCheckoutcomResponse>
    >
    payViaKlarna?: GraphCacheOptimisticMutationResolver<
        MutationPayViaKlarnaArgs,
        WithTypename<KlarnaPaymentResponse>
    >
    payViaNoPayment?: GraphCacheOptimisticMutationResolver<
        MutationPayViaNoPaymentArgs,
        WithTypename<Order>
    >
    ping?: GraphCacheOptimisticMutationResolver<
        Record<string, never>,
        Scalars['String']
    >
    questionnaireCompleteExistingCustomer?: GraphCacheOptimisticMutationResolver<
        MutationQuestionnaireCompleteExistingCustomerArgs,
        WithTypename<QuestionnaireCompletedExistingCustomerResponse>
    >
    questionnaireCompleteNewCustomer?: GraphCacheOptimisticMutationResolver<
        MutationQuestionnaireCompleteNewCustomerArgs,
        WithTypename<QuestionnaireCompletedNewCustomerResponse>
    >
    refreshToken?: GraphCacheOptimisticMutationResolver<
        MutationRefreshTokenArgs,
        WithTypename<LoginResponse>
    >
    removeFromMyCart?: GraphCacheOptimisticMutationResolver<
        MutationRemoveFromMyCartArgs,
        WithTypename<Order>
    >
    ringBuilder?: GraphCacheOptimisticMutationResolver<
        MutationRingBuilderArgs,
        WithTypename<RingBuilder>
    >
    ringBuilderResolveExistingCustomer?: GraphCacheOptimisticMutationResolver<
        MutationRingBuilderResolveExistingCustomerArgs,
        WithTypename<RingBuilderResolvedExistingCustomer>
    >
    ringBuilderResolveNewCustomer?: GraphCacheOptimisticMutationResolver<
        MutationRingBuilderResolveNewCustomerArgs,
        WithTypename<RingBuilderResolvedNewCustomer>
    >
    ringBuilderSet?: GraphCacheOptimisticMutationResolver<
        MutationRingBuilderSetArgs,
        WithTypename<RingBuilderSetResult>
    >
    setOrderCollectFromShowroomInformation?: GraphCacheOptimisticMutationResolver<
        MutationSetOrderCollectFromShowroomInformationArgs,
        WithTypename<SetDeliveryInformationResponse>
    >
    setOrderDeliverToAddressInformation?: GraphCacheOptimisticMutationResolver<
        MutationSetOrderDeliverToAddressInformationArgs,
        WithTypename<SetDeliveryInformationResponse>
    >
    updateConsultationByConsultant?: GraphCacheOptimisticMutationResolver<
        MutationUpdateConsultationByConsultantArgs,
        Maybe<WithTypename<BookingConsultation>>
    >
}

export type GraphCacheUpdaters = {
    Query?: {
        GemsApi_findStones?: GraphCacheUpdateResolver<
            {
                GemsApi_findStones: Maybe<WithTypename<GemsApi_StoneCollection>>
            },
            QueryGemsApi_FindStonesArgs
        >
        GemsApi_getBounds?: GraphCacheUpdateResolver<
            { GemsApi_getBounds: Maybe<WithTypename<GemsApi_Bounds>> },
            QueryGemsApi_GetBoundsArgs
        >
        GemsApi_getGiaStone?: GraphCacheUpdateResolver<
            { GemsApi_getGiaStone: Maybe<WithTypename<GemsApi_Stone>> },
            QueryGemsApi_GetGiaStoneArgs
        >
        GemsApi_getStone?: GraphCacheUpdateResolver<
            { GemsApi_getStone: Maybe<WithTypename<GemsApi_Stone>> },
            QueryGemsApi_GetStoneArgs
        >
        GemsApi_getStoneByExternalId?: GraphCacheUpdateResolver<
            {
                GemsApi_getStoneByExternalId: Maybe<WithTypename<GemsApi_Stone>>
            },
            QueryGemsApi_GetStoneByExternalIdArgs
        >
        GemsApi_getStones?: GraphCacheUpdateResolver<
            { GemsApi_getStones: Array<WithTypename<GemsApi_Stone>> },
            QueryGemsApi_GetStonesArgs
        >
        authorById?: GraphCacheUpdateResolver<
            { authorById: Maybe<WithTypename<Author>> },
            QueryAuthorByIdArgs
        >
        authorBySlug?: GraphCacheUpdateResolver<
            { authorBySlug: Maybe<WithTypename<Author>> },
            QueryAuthorBySlugArgs
        >
        authors?: GraphCacheUpdateResolver<
            { authors: Array<WithTypename<Author>> },
            QueryAuthorsArgs
        >
        authorsAggregation?: GraphCacheUpdateResolver<
            { authorsAggregation: Maybe<WithTypename<AuthorsAggregation>> },
            QueryAuthorsAggregationArgs
        >
        avatarStack?: GraphCacheUpdateResolver<
            { avatarStack: Array<WithTypename<AvatarStackItem>> },
            QueryAvatarStackArgs
        >
        bookingAvailableTransitions?: GraphCacheUpdateResolver<
            {
                bookingAvailableTransitions: Array<BookingConsultationTransition>
            },
            QueryBookingAvailableTransitionsArgs
        >
        bookingConsultants?: GraphCacheUpdateResolver<
            { bookingConsultants: Array<WithTypename<Consultant>> },
            Record<string, never>
        >
        bookingConsultation?: GraphCacheUpdateResolver<
            { bookingConsultation: Maybe<WithTypename<BookingConsultation>> },
            QueryBookingConsultationArgs
        >
        bookingConsultationAvailableSlots?: GraphCacheUpdateResolver<
            {
                bookingConsultationAvailableSlots: WithTypename<BookingConsultationSlotsResponse>
            },
            QueryBookingConsultationAvailableSlotsArgs
        >
        bookingConsultationAvailableSlotsByConsultant?: GraphCacheUpdateResolver<
            {
                bookingConsultationAvailableSlotsByConsultant: Array<
                    WithTypename<BookingConsultationAvailableDate>
                >
            },
            QueryBookingConsultationAvailableSlotsByConsultantArgs
        >
        bookingConsultationComplexities?: GraphCacheUpdateResolver<
            {
                bookingConsultationComplexities: Array<
                    WithTypename<BookingConsultationComplexity>
                >
            },
            Record<string, never>
        >
        bookingConsultationPurposes?: GraphCacheUpdateResolver<
            {
                bookingConsultationPurposes: Array<
                    WithTypename<BookingConsultationPurpose>
                >
            },
            Record<string, never>
        >
        bookingConsultationShowPhone?: GraphCacheUpdateResolver<
            { bookingConsultationShowPhone: Scalars['Boolean'] },
            Record<string, never>
        >
        bookingCustomer?: GraphCacheUpdateResolver<
            { bookingCustomer: WithTypename<Customer> },
            QueryBookingCustomerArgs
        >
        bookingInPersonConsultationRooms?: GraphCacheUpdateResolver<
            {
                bookingInPersonConsultationRooms: Array<
                    | WithTypename<BookingInPersonConsultationRoom>
                    | WithTypename<BookingVirtualConsultationRoom>
                >
            },
            QueryBookingInPersonConsultationRoomsArgs
        >
        bookingShowrooms?: GraphCacheUpdateResolver<
            { bookingShowrooms: Array<WithTypename<Showroom>> },
            Record<string, never>
        >
        bookingVirtualConsultationRooms?: GraphCacheUpdateResolver<
            {
                bookingVirtualConsultationRooms: Array<
                    | WithTypename<BookingInPersonConsultationRoom>
                    | WithTypename<BookingVirtualConsultationRoom>
                >
            },
            QueryBookingVirtualConsultationRoomsArgs
        >
        calculateGemsApiStoneTotalSalePrices?: GraphCacheUpdateResolver<
            {
                calculateGemsApiStoneTotalSalePrices: Array<WithTypename<Money>>
            },
            QueryCalculateGemsApiStoneTotalSalePricesArgs
        >
        catalogueEngagementRing?: GraphCacheUpdateResolver<
            {
                catalogueEngagementRing: Maybe<
                    WithTypename<CatalogueEngagementRing>
                >
            },
            QueryCatalogueEngagementRingArgs
        >
        catalogueEngagementRingContainsProducts?: GraphCacheUpdateResolver<
            {
                catalogueEngagementRingContainsProducts: Array<
                    Scalars['Boolean']
                >
            },
            QueryCatalogueEngagementRingContainsProductsArgs
        >
        catalogueEngagementRingFilters?: GraphCacheUpdateResolver<
            {
                catalogueEngagementRingFilters: WithTypename<CatalogueEngagementRingFilters>
            },
            QueryCatalogueEngagementRingFiltersArgs
        >
        catalogueEngagementRingFiltersVariations?: GraphCacheUpdateResolver<
            {
                catalogueEngagementRingFiltersVariations: Array<
                    WithTypename<CatalogueEngagementRingFiltersVariation>
                >
            },
            QueryCatalogueEngagementRingFiltersVariationsArgs
        >
        catalogueEngagementRings?: GraphCacheUpdateResolver<
            {
                catalogueEngagementRings: Array<
                    WithTypename<CatalogueEngagementRing>
                >
            },
            QueryCatalogueEngagementRingsArgs
        >
        catalogueEngagementRingsAggregate?: GraphCacheUpdateResolver<
            {
                catalogueEngagementRingsAggregate: WithTypename<CatalogueAggregate>
            },
            QueryCatalogueEngagementRingsAggregateArgs
        >
        catalogueJewelleries?: GraphCacheUpdateResolver<
            {
                catalogueJewelleries: Array<
                    | WithTypename<CatalogueJewelleryBracelet>
                    | WithTypename<CatalogueJewelleryEarrings>
                    | WithTypename<CatalogueJewelleryNecklace>
                    | WithTypename<CatalogueJewelleryRing>
                >
            },
            QueryCatalogueJewelleriesArgs
        >
        catalogueJewelleriesAggregate?: GraphCacheUpdateResolver<
            { catalogueJewelleriesAggregate: WithTypename<CatalogueAggregate> },
            QueryCatalogueJewelleriesAggregateArgs
        >
        catalogueJewelleriesFilters?: GraphCacheUpdateResolver<
            {
                catalogueJewelleriesFilters: WithTypename<CatalogueJewelleriesFilters>
            },
            QueryCatalogueJewelleriesFiltersArgs
        >
        catalogueJewelleriesFiltersVariations?: GraphCacheUpdateResolver<
            {
                catalogueJewelleriesFiltersVariations: Array<
                    WithTypename<CatalogueJewelleriesFiltersVariation>
                >
            },
            QueryCatalogueJewelleriesFiltersVariationsArgs
        >
        catalogueJewellery?: GraphCacheUpdateResolver<
            {
                catalogueJewellery: Maybe<
                    | WithTypename<CatalogueJewelleryBracelet>
                    | WithTypename<CatalogueJewelleryEarrings>
                    | WithTypename<CatalogueJewelleryNecklace>
                    | WithTypename<CatalogueJewelleryRing>
                >
            },
            QueryCatalogueJewelleryArgs
        >
        catalogueJewelleryBracelet?: GraphCacheUpdateResolver<
            {
                catalogueJewelleryBracelet: Maybe<
                    WithTypename<CatalogueJewelleryBracelet>
                >
            },
            QueryCatalogueJewelleryBraceletArgs
        >
        catalogueJewelleryBraceletFiltersVariations?: GraphCacheUpdateResolver<
            {
                catalogueJewelleryBraceletFiltersVariations: Array<
                    WithTypename<CatalogueJewelleriesBraceletsFiltersVariation>
                >
            },
            QueryCatalogueJewelleryBraceletFiltersVariationsArgs
        >
        catalogueJewelleryBracelets?: GraphCacheUpdateResolver<
            {
                catalogueJewelleryBracelets: Array<
                    WithTypename<CatalogueJewelleryBracelet>
                >
            },
            QueryCatalogueJewelleryBraceletsArgs
        >
        catalogueJewelleryBraceletsAggregate?: GraphCacheUpdateResolver<
            {
                catalogueJewelleryBraceletsAggregate: WithTypename<CatalogueAggregate>
            },
            QueryCatalogueJewelleryBraceletsAggregateArgs
        >
        catalogueJewelleryBraceletsFilters?: GraphCacheUpdateResolver<
            {
                catalogueJewelleryBraceletsFilters: WithTypename<CatalogueJewelleryBraceletsFilters>
            },
            QueryCatalogueJewelleryBraceletsFiltersArgs
        >
        catalogueJewelleryEarring?: GraphCacheUpdateResolver<
            {
                catalogueJewelleryEarring: Maybe<
                    WithTypename<CatalogueJewelleryEarrings>
                >
            },
            QueryCatalogueJewelleryEarringArgs
        >
        catalogueJewelleryEarrings?: GraphCacheUpdateResolver<
            {
                catalogueJewelleryEarrings: Array<
                    WithTypename<CatalogueJewelleryEarrings>
                >
            },
            QueryCatalogueJewelleryEarringsArgs
        >
        catalogueJewelleryEarringsAggregate?: GraphCacheUpdateResolver<
            {
                catalogueJewelleryEarringsAggregate: WithTypename<CatalogueAggregate>
            },
            QueryCatalogueJewelleryEarringsAggregateArgs
        >
        catalogueJewelleryEarringsFilters?: GraphCacheUpdateResolver<
            {
                catalogueJewelleryEarringsFilters: WithTypename<CatalogueJewelleryEarringsFilters>
            },
            QueryCatalogueJewelleryEarringsFiltersArgs
        >
        catalogueJewelleryEarringsFiltersVariations?: GraphCacheUpdateResolver<
            {
                catalogueJewelleryEarringsFiltersVariations: Array<
                    WithTypename<CatalogueJewelleriesEarringsFiltersVariation>
                >
            },
            QueryCatalogueJewelleryEarringsFiltersVariationsArgs
        >
        catalogueJewelleryNecklace?: GraphCacheUpdateResolver<
            {
                catalogueJewelleryNecklace: Maybe<
                    WithTypename<CatalogueJewelleryNecklace>
                >
            },
            QueryCatalogueJewelleryNecklaceArgs
        >
        catalogueJewelleryNecklaces?: GraphCacheUpdateResolver<
            {
                catalogueJewelleryNecklaces: Array<
                    WithTypename<CatalogueJewelleryNecklace>
                >
            },
            QueryCatalogueJewelleryNecklacesArgs
        >
        catalogueJewelleryNecklacesAggregate?: GraphCacheUpdateResolver<
            {
                catalogueJewelleryNecklacesAggregate: WithTypename<CatalogueAggregate>
            },
            QueryCatalogueJewelleryNecklacesAggregateArgs
        >
        catalogueJewelleryNecklacesFilters?: GraphCacheUpdateResolver<
            {
                catalogueJewelleryNecklacesFilters: WithTypename<CatalogueJewelleryNecklacesFilters>
            },
            QueryCatalogueJewelleryNecklacesFiltersArgs
        >
        catalogueJewelleryNecklacesFiltersVariations?: GraphCacheUpdateResolver<
            {
                catalogueJewelleryNecklacesFiltersVariations: Array<
                    WithTypename<CatalogueJewelleriesNecklacesFiltersVariation>
                >
            },
            QueryCatalogueJewelleryNecklacesFiltersVariationsArgs
        >
        catalogueJewelleryRing?: GraphCacheUpdateResolver<
            {
                catalogueJewelleryRing: Maybe<
                    WithTypename<CatalogueJewelleryRing>
                >
            },
            QueryCatalogueJewelleryRingArgs
        >
        catalogueJewelleryRings?: GraphCacheUpdateResolver<
            {
                catalogueJewelleryRings: Array<
                    WithTypename<CatalogueJewelleryRing>
                >
            },
            QueryCatalogueJewelleryRingsArgs
        >
        catalogueJewelleryRingsAggregate?: GraphCacheUpdateResolver<
            {
                catalogueJewelleryRingsAggregate: WithTypename<CatalogueAggregate>
            },
            QueryCatalogueJewelleryRingsAggregateArgs
        >
        catalogueJewelleryRingsFilters?: GraphCacheUpdateResolver<
            {
                catalogueJewelleryRingsFilters: WithTypename<CatalogueJewelleryRingsFilters>
            },
            QueryCatalogueJewelleryRingsFiltersArgs
        >
        catalogueJewelleryRingsFiltersVariations?: GraphCacheUpdateResolver<
            {
                catalogueJewelleryRingsFiltersVariations: Array<
                    WithTypename<CatalogueJewelleriesRingsFiltersVariation>
                >
            },
            QueryCatalogueJewelleryRingsFiltersVariationsArgs
        >
        catalogueProducts?: GraphCacheUpdateResolver<
            {
                catalogueProducts: Array<
                    | WithTypename<CatalogueEngagementRing>
                    | WithTypename<CatalogueJewelleryBracelet>
                    | WithTypename<CatalogueJewelleryEarrings>
                    | WithTypename<CatalogueJewelleryNecklace>
                    | WithTypename<CatalogueJewelleryRing>
                    | WithTypename<CatalogueReadyToGoRing>
                    | WithTypename<CatalogueWeddingRing>
                >
            },
            QueryCatalogueProductsArgs
        >
        catalogueReadyToGoRing?: GraphCacheUpdateResolver<
            {
                catalogueReadyToGoRing: Maybe<
                    WithTypename<CatalogueReadyToGoRing>
                >
            },
            QueryCatalogueReadyToGoRingArgs
        >
        catalogueReadyToGoRings?: GraphCacheUpdateResolver<
            {
                catalogueReadyToGoRings: Array<
                    WithTypename<CatalogueReadyToGoRing>
                >
            },
            QueryCatalogueReadyToGoRingsArgs
        >
        catalogueReadyToGoRingsAggregate?: GraphCacheUpdateResolver<
            {
                catalogueReadyToGoRingsAggregate: WithTypename<CatalogueAggregate>
            },
            QueryCatalogueReadyToGoRingsAggregateArgs
        >
        catalogueReadyToGoRingsFilters?: GraphCacheUpdateResolver<
            {
                catalogueReadyToGoRingsFilters: WithTypename<CatalogueReadyToGoRingFilters>
            },
            QueryCatalogueReadyToGoRingsFiltersArgs
        >
        catalogueWeddingRing?: GraphCacheUpdateResolver<
            { catalogueWeddingRing: Maybe<WithTypename<CatalogueWeddingRing>> },
            QueryCatalogueWeddingRingArgs
        >
        catalogueWeddingRingFilterVariations?: GraphCacheUpdateResolver<
            {
                catalogueWeddingRingFilterVariations: Array<
                    WithTypename<CatalogueWeddingRingFiltersVariation>
                >
            },
            QueryCatalogueWeddingRingFilterVariationsArgs
        >
        catalogueWeddingRingFilters?: GraphCacheUpdateResolver<
            {
                catalogueWeddingRingFilters: WithTypename<CatalogueWeddingRingFilters>
            },
            QueryCatalogueWeddingRingFiltersArgs
        >
        catalogueWeddingRings?: GraphCacheUpdateResolver<
            {
                catalogueWeddingRings: Array<WithTypename<CatalogueWeddingRing>>
            },
            QueryCatalogueWeddingRingsArgs
        >
        catalogueWeddingRingsAggregate?: GraphCacheUpdateResolver<
            {
                catalogueWeddingRingsAggregate: WithTypename<CatalogueAggregate>
            },
            QueryCatalogueWeddingRingsAggregateArgs
        >
        convertPriceBoundsForGems?: GraphCacheUpdateResolver<
            { convertPriceBoundsForGems: WithTypename<GemsApiPriceBounds> },
            QueryConvertPriceBoundsForGemsArgs
        >
        convertPriceBoundsForGemsMulti?: GraphCacheUpdateResolver<
            {
                convertPriceBoundsForGemsMulti: Array<
                    WithTypename<GemsApiPriceBounds>
                >
            },
            QueryConvertPriceBoundsForGemsMultiArgs
        >
        customerExists?: GraphCacheUpdateResolver<
            { customerExists: Scalars['Boolean'] },
            QueryCustomerExistsArgs
        >
        defaultAlternateRegion?: GraphCacheUpdateResolver<
            { defaultAlternateRegion: WithTypename<Region> },
            Record<string, never>
        >
        defaultRegion?: GraphCacheUpdateResolver<
            { defaultRegion: WithTypename<Region> },
            Record<string, never>
        >
        deliveryDaysForBespokeEngagementRings?: GraphCacheUpdateResolver<
            { deliveryDaysForBespokeEngagementRings: Scalars['Int'] },
            Record<string, never>
        >
        engagementRingStoneRecommendations?: GraphCacheUpdateResolver<
            {
                engagementRingStoneRecommendations: Maybe<
                    WithTypename<EngagementRingStoneRecommendations>
                >
            },
            QueryEngagementRingStoneRecommendationsArgs
        >
        footer?: GraphCacheUpdateResolver<
            { footer: Maybe<WithTypename<Footer>> },
            QueryFooterArgs
        >
        language?: GraphCacheUpdateResolver<
            { language: Maybe<WithTypename<Language>> },
            QueryLanguageArgs
        >
        languages?: GraphCacheUpdateResolver<
            { languages: Array<WithTypename<Language>> },
            Record<string, never>
        >
        mainMenu?: GraphCacheUpdateResolver<
            { mainMenu: Array<WithTypename<MenuItem>> },
            QueryMainMenuArgs
        >
        me?: GraphCacheUpdateResolver<
            { me: Maybe<WithTypename<User>> },
            Record<string, never>
        >
        metals?: GraphCacheUpdateResolver<
            { metals: Array<WithTypename<Metal>> },
            Record<string, never>
        >
        nonSkuGemStone?: GraphCacheUpdateResolver<
            { nonSkuGemStone: Maybe<WithTypename<NonSkuGemstone>> },
            QueryNonSkuGemStoneArgs
        >
        nonSkuGemStones?: GraphCacheUpdateResolver<
            { nonSkuGemStones: Array<WithTypename<NonSkuGemstone>> },
            QueryNonSkuGemStonesArgs
        >
        nonSkuGemStonesBounds?: GraphCacheUpdateResolver<
            { nonSkuGemStonesBounds: WithTypename<NonSkuGemstonesBounds> },
            Record<string, never>
        >
        nonSkuGemStonesPricingCells?: GraphCacheUpdateResolver<
            {
                nonSkuGemStonesPricingCells: Array<WithTypename<NonSkuGemstone>>
            },
            QueryNonSkuGemStonesPricingCellsArgs
        >
        nonSkuGemstoneCaratDimensions?: GraphCacheUpdateResolver<
            {
                nonSkuGemstoneCaratDimensions: Array<
                    WithTypename<NonSkuGemstoneCaratDimension>
                >
            },
            Record<string, never>
        >
        nonSkuGemstoneColorCrystalDimensions?: GraphCacheUpdateResolver<
            {
                nonSkuGemstoneColorCrystalDimensions: Array<
                    WithTypename<NonSkuGemstoneType>
                >
            },
            Record<string, never>
        >
        nonSkuGemstoneGradeClarityDimensions?: GraphCacheUpdateResolver<
            {
                nonSkuGemstoneGradeClarityDimensions: Array<
                    WithTypename<NonSkuGemstoneGradeClarityDimension>
                >
            },
            Record<string, never>
        >
        nonSkuGemstoneImages?: GraphCacheUpdateResolver<
            { nonSkuGemstoneImages: Array<WithTypename<NonSkuGemstoneImage>> },
            Record<string, never>
        >
        nonSkuGemstoneShapeDimensions?: GraphCacheUpdateResolver<
            {
                nonSkuGemstoneShapeDimensions: Array<
                    WithTypename<NonSkuGemstoneShapeDimension>
                >
            },
            Record<string, never>
        >
        nonSkuLabGrownCaratDimensions?: GraphCacheUpdateResolver<
            {
                nonSkuLabGrownCaratDimensions: Array<
                    WithTypename<NonSkuLabGrownCaratDimension>
                >
            },
            Record<string, never>
        >
        nonSkuLabGrownDiamond?: GraphCacheUpdateResolver<
            { nonSkuLabGrownDiamond: Maybe<WithTypename<NonSkuLabGrown>> },
            QueryNonSkuLabGrownDiamondArgs
        >
        nonSkuLabGrownDiamonds?: GraphCacheUpdateResolver<
            { nonSkuLabGrownDiamonds: Array<WithTypename<NonSkuLabGrown>> },
            QueryNonSkuLabGrownDiamondsArgs
        >
        nonSkuLabGrownDiamondsBounds?: GraphCacheUpdateResolver<
            {
                nonSkuLabGrownDiamondsBounds: WithTypename<NonSkuLabGrownDiamondsBounds>
            },
            Record<string, never>
        >
        nonSkuLabGrownGradeDimensions?: GraphCacheUpdateResolver<
            {
                nonSkuLabGrownGradeDimensions: Array<
                    WithTypename<NonSkuLabGrownGradeDimension>
                >
            },
            Record<string, never>
        >
        nonSkuLabGrownPricingCells?: GraphCacheUpdateResolver<
            { nonSkuLabGrownPricingCells: Array<WithTypename<NonSkuLabGrown>> },
            QueryNonSkuLabGrownPricingCellsArgs
        >
        nonSkuLabGrownShapeDimensions?: GraphCacheUpdateResolver<
            {
                nonSkuLabGrownShapeDimensions: Array<
                    WithTypename<NonSkuLabGrownShapeDimension>
                >
            },
            Record<string, never>
        >
        pageByPath?: GraphCacheUpdateResolver<
            { pageByPath: Maybe<WithTypename<Page>> },
            QueryPageByPathArgs
        >
        pageProductDetails?: GraphCacheUpdateResolver<
            { pageProductDetails: Maybe<WithTypename<ProductPageDetails>> },
            QueryPageProductDetailsArgs
        >
        pageProductListing?: GraphCacheUpdateResolver<
            { pageProductListing: Maybe<WithTypename<ProductPageListing>> },
            QueryPageProductListingArgs
        >
        pageProductListingFacetedContent?: GraphCacheUpdateResolver<
            {
                pageProductListingFacetedContent: Maybe<
                    WithTypename<ProductPageFacetedContent>
                >
            },
            QueryPageProductListingFacetedContentArgs
        >
        pages?: GraphCacheUpdateResolver<
            { pages: Array<WithTypename<Page>> },
            QueryPagesArgs
        >
        paymentIcons?: GraphCacheUpdateResolver<
            { paymentIcons: Array<WithTypename<PaymentIcon>> },
            QueryPaymentIconsArgs
        >
        ping?: GraphCacheUpdateResolver<
            { ping: Scalars['String'] },
            Record<string, never>
        >
        postBySlug?: GraphCacheUpdateResolver<
            { postBySlug: Maybe<WithTypename<Post>> },
            QueryPostBySlugArgs
        >
        postCategories?: GraphCacheUpdateResolver<
            { postCategories: Array<WithTypename<PostCategory>> },
            QueryPostCategoriesArgs
        >
        postCategoriesAggregation?: GraphCacheUpdateResolver<
            {
                postCategoriesAggregation: WithTypename<PostCategoriesAggregation>
            },
            QueryPostCategoriesAggregationArgs
        >
        postCategoryBySlug?: GraphCacheUpdateResolver<
            { postCategoryBySlug: Maybe<WithTypename<PostCategory>> },
            QueryPostCategoryBySlugArgs
        >
        postTagAggregation?: GraphCacheUpdateResolver<
            { postTagAggregation: WithTypename<PostTagsAggregation> },
            QueryPostTagAggregationArgs
        >
        postTagBySlug?: GraphCacheUpdateResolver<
            { postTagBySlug: Maybe<WithTypename<PostTag>> },
            QueryPostTagBySlugArgs
        >
        postTags?: GraphCacheUpdateResolver<
            { postTags: Array<WithTypename<PostTag>> },
            QueryPostTagsArgs
        >
        posts?: GraphCacheUpdateResolver<
            { posts: Array<WithTypename<Post>> },
            QueryPostsArgs
        >
        postsAggregation?: GraphCacheUpdateResolver<
            { postsAggregation: WithTypename<PostsAggregation> },
            QueryPostsAggregationArgs
        >
        preHeader?: GraphCacheUpdateResolver<
            { preHeader: Maybe<WithTypename<PreHeader>> },
            QueryPreHeaderArgs
        >
        questionnaire?: GraphCacheUpdateResolver<
            { questionnaire: Maybe<WithTypename<Questionnaire>> },
            QueryQuestionnaireArgs
        >
        questionnaires?: GraphCacheUpdateResolver<
            { questionnaires: Array<WithTypename<Questionnaire>> },
            Record<string, never>
        >
        region?: GraphCacheUpdateResolver<
            { region: WithTypename<Region> },
            QueryRegionArgs
        >
        regionSuggest?: GraphCacheUpdateResolver<
            { regionSuggest: WithTypename<Region> },
            Record<string, never>
        >
        regions?: GraphCacheUpdateResolver<
            { regions: Array<WithTypename<Region>> },
            Record<string, never>
        >
        reviews?: GraphCacheUpdateResolver<
            { reviews: Array<WithTypename<Review>> },
            QueryReviewsArgs
        >
        ringBuilder?: GraphCacheUpdateResolver<
            { ringBuilder: WithTypename<RingBuilder> },
            QueryRingBuilderArgs
        >
        searchEverywhere?: GraphCacheUpdateResolver<
            { searchEverywhere: WithTypename<SearchEverywhereResponse> },
            QuerySearchEverywhereArgs
        >
        socialNetworks?: GraphCacheUpdateResolver<
            { socialNetworks: Array<WithTypename<SocialNetwork>> },
            QuerySocialNetworksArgs
        >
        stoneCategoriesBySystemCode?: GraphCacheUpdateResolver<
            { stoneCategoriesBySystemCode: Array<WithTypename<StoneCategory>> },
            QueryStoneCategoriesBySystemCodeArgs
        >
        stoneCategoryBySystemCode?: GraphCacheUpdateResolver<
            { stoneCategoryBySystemCode: WithTypename<StoneCategory> },
            QueryStoneCategoryBySystemCodeArgs
        >
        stoneClarities?: GraphCacheUpdateResolver<
            { stoneClarities: Array<WithTypename<StoneClarity>> },
            QueryStoneClaritiesArgs
        >
        stoneClaritiesBySystemCode?: GraphCacheUpdateResolver<
            { stoneClaritiesBySystemCode: Array<WithTypename<StoneClarity>> },
            QueryStoneClaritiesBySystemCodeArgs
        >
        stoneClarityBySystemCode?: GraphCacheUpdateResolver<
            { stoneClarityBySystemCode: WithTypename<StoneClarity> },
            QueryStoneClarityBySystemCodeArgs
        >
        stoneColorBySystemCode?: GraphCacheUpdateResolver<
            { stoneColorBySystemCode: WithTypename<StoneColor> },
            QueryStoneColorBySystemCodeArgs
        >
        stoneColors?: GraphCacheUpdateResolver<
            { stoneColors: Array<WithTypename<StoneColor>> },
            QueryStoneColorsArgs
        >
        stoneColorsBySystemCode?: GraphCacheUpdateResolver<
            { stoneColorsBySystemCode: Array<WithTypename<StoneColor>> },
            QueryStoneColorsBySystemCodeArgs
        >
        stoneCrystals?: GraphCacheUpdateResolver<
            { stoneCrystals: Array<WithTypename<StoneCrystal>> },
            QueryStoneCrystalsArgs
        >
        stoneCrystalsBySystemCode?: GraphCacheUpdateResolver<
            { stoneCrystalsBySystemCode: Array<WithTypename<StoneCrystal>> },
            QueryStoneCrystalsBySystemCodeArgs
        >
        stoneCutsBySystemCodes?: GraphCacheUpdateResolver<
            { stoneCutsBySystemCodes: Array<WithTypename<StoneCut>> },
            QueryStoneCutsBySystemCodesArgs
        >
        stoneFluorescencesBySystemCodes?: GraphCacheUpdateResolver<
            {
                stoneFluorescencesBySystemCodes: Array<
                    WithTypename<StoneFluorescence>
                >
            },
            QueryStoneFluorescencesBySystemCodesArgs
        >
        stoneGrades?: GraphCacheUpdateResolver<
            { stoneGrades: Array<WithTypename<StoneGrade>> },
            QueryStoneGradesArgs
        >
        stoneGradesBySystemCodes?: GraphCacheUpdateResolver<
            { stoneGradesBySystemCodes: Array<WithTypename<StoneGrade>> },
            QueryStoneGradesBySystemCodesArgs
        >
        stonePolishesBySystemCodes?: GraphCacheUpdateResolver<
            { stonePolishesBySystemCodes: Array<WithTypename<StonePolish>> },
            QueryStonePolishesBySystemCodesArgs
        >
        stoneShapeBySystemCodes?: GraphCacheUpdateResolver<
            { stoneShapeBySystemCodes: Array<WithTypename<StoneShape>> },
            QueryStoneShapeBySystemCodesArgs
        >
        stoneShapes?: GraphCacheUpdateResolver<
            { stoneShapes: Array<WithTypename<StoneShape>> },
            QueryStoneShapesArgs
        >
        stoneSymmetriesBySystemCodes?: GraphCacheUpdateResolver<
            {
                stoneSymmetriesBySystemCodes: Array<WithTypename<StoneSymmetry>>
            },
            QueryStoneSymmetriesBySystemCodesArgs
        >
        tooltip?: GraphCacheUpdateResolver<
            { tooltip: Maybe<WithTypename<Tooltip>> },
            QueryTooltipArgs
        >
        topBar?: GraphCacheUpdateResolver<
            { topBar: Maybe<WithTypename<TopBar>> },
            QueryTopBarArgs
        >
        validateConsultationInput?: GraphCacheUpdateResolver<
            { validateConsultationInput: Scalars['Boolean'] },
            QueryValidateConsultationInputArgs
        >
        validateCustomerRegistrationInput?: GraphCacheUpdateResolver<
            { validateCustomerRegistrationInput: Scalars['Boolean'] },
            QueryValidateCustomerRegistrationInputArgs
        >
        workingHours?: GraphCacheUpdateResolver<
            { workingHours: Array<WithTypename<WorkingHours>> },
            QueryWorkingHoursArgs
        >
    }
    Mutation?: {
        addDesignStudioProductToMyCart?: GraphCacheUpdateResolver<
            { addDesignStudioProductToMyCart: WithTypename<Order> },
            MutationAddDesignStudioProductToMyCartArgs
        >
        addToCartReadyToGoRingExistingCustomer?: GraphCacheUpdateResolver<
            {
                addToCartReadyToGoRingExistingCustomer: WithTypename<AddToCartReadyToGoRingExistingCustomerResponse>
            },
            MutationAddToCartReadyToGoRingExistingCustomerArgs
        >
        addToCartReadyToGoRingNewCustomer?: GraphCacheUpdateResolver<
            {
                addToCartReadyToGoRingNewCustomer: WithTypename<AddToCartReadyToGoRingNewCustomerResponse>
            },
            MutationAddToCartReadyToGoRingNewCustomerArgs
        >
        applyPromoCode?: GraphCacheUpdateResolver<
            { applyPromoCode: Maybe<WithTypename<PromoCodeApplicationResult>> },
            MutationApplyPromoCodeArgs
        >
        applyTransitionToConsultationByConsultant?: GraphCacheUpdateResolver<
            {
                applyTransitionToConsultationByConsultant: Maybe<
                    WithTypename<BookingConsultation>
                >
            },
            MutationApplyTransitionToConsultationByConsultantArgs
        >
        autologin?: GraphCacheUpdateResolver<
            { autologin: WithTypename<LoginResponse> },
            MutationAutologinArgs
        >
        cancelConsultation?: GraphCacheUpdateResolver<
            { cancelConsultation: Scalars['Boolean'] },
            MutationCancelConsultationArgs
        >
        completeAffirmTransactionPostIframe?: GraphCacheUpdateResolver<
            {
                completeAffirmTransactionPostIframe: WithTypename<AffirmCompleteTransactionResponse>
            },
            MutationCompleteAffirmTransactionPostIframeArgs
        >
        completeCheckoutcomTransactionPost3ds?: GraphCacheUpdateResolver<
            {
                completeCheckoutcomTransactionPost3ds: WithTypename<CompleteCheckoutcomTransactionPost3dsResponse>
            },
            MutationCompleteCheckoutcomTransactionPost3dsArgs
        >
        createAffirmTransaction?: GraphCacheUpdateResolver<
            { createAffirmTransaction: WithTypename<AffirmTransaction> },
            MutationCreateAffirmTransactionArgs
        >
        createAllocationTransaction?: GraphCacheUpdateResolver<
            {
                createAllocationTransaction: WithTypename<AllocationTransaction>
            },
            MutationCreateAllocationTransactionArgs
        >
        createBankTransaction?: GraphCacheUpdateResolver<
            { createBankTransaction: WithTypename<BankTransaction> },
            MutationCreateBankTransactionArgs
        >
        createCheckoutcomTransaction?: GraphCacheUpdateResolver<
            {
                createCheckoutcomTransaction: WithTypename<CreateCheckoutcomTransactionResponse>
            },
            MutationCreateCheckoutcomTransactionArgs
        >
        createConsultationByConsultant?: GraphCacheUpdateResolver<
            {
                createConsultationByConsultant: Maybe<
                    WithTypename<BookingConsultation>
                >
            },
            MutationCreateConsultationByConsultantArgs
        >
        createConsultationExistingCustomer?: GraphCacheUpdateResolver<
            {
                createConsultationExistingCustomer: WithTypename<BookingCreateConsultationExistingCustomerResponse>
            },
            MutationCreateConsultationExistingCustomerArgs
        >
        createConsultationNewCustomer?: GraphCacheUpdateResolver<
            {
                createConsultationNewCustomer: WithTypename<BookingCreateConsultationNewCustomerResponse>
            },
            MutationCreateConsultationNewCustomerArgs
        >
        createDesignInspiration?: GraphCacheUpdateResolver<
            { createDesignInspiration: WithTypename<DesignInspiration> },
            MutationCreateDesignInspirationArgs
        >
        createDesignStudioProductAndAddToCartJewelleryExistingCustomer?: GraphCacheUpdateResolver<
            {
                createDesignStudioProductAndAddToCartJewelleryExistingCustomer: WithTypename<CatalogueDesignStudioCheckoutJewelleryExistingCustomerResponse>
            },
            MutationCreateDesignStudioProductAndAddToCartJewelleryExistingCustomerArgs
        >
        createDesignStudioProductAndAddToCartJewelleryNewCustomer?: GraphCacheUpdateResolver<
            {
                createDesignStudioProductAndAddToCartJewelleryNewCustomer: WithTypename<CatalogueDesignStudioCheckoutJewelleryNewCustomerResponse>
            },
            MutationCreateDesignStudioProductAndAddToCartJewelleryNewCustomerArgs
        >
        createDesignStudioProductAndAddToCartWeddingRingExistingCustomer?: GraphCacheUpdateResolver<
            {
                createDesignStudioProductAndAddToCartWeddingRingExistingCustomer: WithTypename<CatalogueDesignStudioCheckoutWeddingRingExistingCustomerResponse>
            },
            MutationCreateDesignStudioProductAndAddToCartWeddingRingExistingCustomerArgs
        >
        createDesignStudioProductAndAddToCartWeddingRingNewCustomer?: GraphCacheUpdateResolver<
            {
                createDesignStudioProductAndAddToCartWeddingRingNewCustomer: WithTypename<CatalogueDesignStudioCheckoutWeddingRingNewCustomerResponse>
            },
            MutationCreateDesignStudioProductAndAddToCartWeddingRingNewCustomerArgs
        >
        createEnquiryContactUsExistingCustomer?: GraphCacheUpdateResolver<
            {
                createEnquiryContactUsExistingCustomer: WithTypename<EnquiryResponseExistingCustomer>
            },
            MutationCreateEnquiryContactUsExistingCustomerArgs
        >
        createEnquiryContactUsNewCustomer?: GraphCacheUpdateResolver<
            {
                createEnquiryContactUsNewCustomer: WithTypename<EnquiryResponseNewCustomer>
            },
            MutationCreateEnquiryContactUsNewCustomerArgs
        >
        createEnquiryCustomEngagementRingExistingCustomer?: GraphCacheUpdateResolver<
            {
                createEnquiryCustomEngagementRingExistingCustomer: WithTypename<EnquiryResponseExistingCustomer>
            },
            MutationCreateEnquiryCustomEngagementRingExistingCustomerArgs
        >
        createEnquiryCustomEngagementRingNewCustomer?: GraphCacheUpdateResolver<
            {
                createEnquiryCustomEngagementRingNewCustomer: WithTypename<EnquiryResponseNewCustomer>
            },
            MutationCreateEnquiryCustomEngagementRingNewCustomerArgs
        >
        createEnquiryDiamondSearchProductExistingCustomer?: GraphCacheUpdateResolver<
            {
                createEnquiryDiamondSearchProductExistingCustomer: WithTypename<EnquiryResponseExistingCustomer>
            },
            MutationCreateEnquiryDiamondSearchProductExistingCustomerArgs
        >
        createEnquiryDiamondSearchProductNewCustomer?: GraphCacheUpdateResolver<
            {
                createEnquiryDiamondSearchProductNewCustomer: WithTypename<EnquiryResponseNewCustomer>
            },
            MutationCreateEnquiryDiamondSearchProductNewCustomerArgs
        >
        createEnquiryEngagementRingPreferAnotherShapeExistingCustomer?: GraphCacheUpdateResolver<
            {
                createEnquiryEngagementRingPreferAnotherShapeExistingCustomer: WithTypename<EnquiryResponseExistingCustomer>
            },
            MutationCreateEnquiryEngagementRingPreferAnotherShapeExistingCustomerArgs
        >
        createEnquiryEngagementRingPreferAnotherShapeNewCustomer?: GraphCacheUpdateResolver<
            {
                createEnquiryEngagementRingPreferAnotherShapeNewCustomer: WithTypename<EnquiryResponseNewCustomer>
            },
            MutationCreateEnquiryEngagementRingPreferAnotherShapeNewCustomerArgs
        >
        createEnquiryExistingCustomer?: GraphCacheUpdateResolver<
            {
                createEnquiryExistingCustomer: WithTypename<EnquiryResponseExistingCustomer>
            },
            MutationCreateEnquiryExistingCustomerArgs
        >
        createEnquiryNewCustomer?: GraphCacheUpdateResolver<
            {
                createEnquiryNewCustomer: WithTypename<EnquiryResponseNewCustomer>
            },
            MutationCreateEnquiryNewCustomerArgs
        >
        createKlarnaTransaction?: GraphCacheUpdateResolver<
            { createKlarnaTransaction: WithTypename<KlarnaTransaction> },
            MutationCreateKlarnaTransactionArgs
        >
        designStudioProductEngagementRingUpdate?: GraphCacheUpdateResolver<
            {
                designStudioProductEngagementRingUpdate: WithTypename<DesignStudioProductEngagementRing>
            },
            MutationDesignStudioProductEngagementRingUpdateArgs
        >
        designStudioProductWeddingRingUpdate?: GraphCacheUpdateResolver<
            {
                designStudioProductWeddingRingUpdate: WithTypename<DesignStudioProductWeddingRing>
            },
            MutationDesignStudioProductWeddingRingUpdateArgs
        >
        designStudioQuotationEngagementRingUpdate?: GraphCacheUpdateResolver<
            {
                designStudioQuotationEngagementRingUpdate: WithTypename<QuotationEngagementRing>
            },
            MutationDesignStudioQuotationEngagementRingUpdateArgs
        >
        impersonate?: GraphCacheUpdateResolver<
            { impersonate: WithTypename<LoginResponse> },
            MutationImpersonateArgs
        >
        invalidateCache?: GraphCacheUpdateResolver<
            { invalidateCache: WithTypename<InvalidateCacheResult> },
            MutationInvalidateCacheArgs
        >
        login?: GraphCacheUpdateResolver<
            { login: WithTypename<LoginResponse> },
            MutationLoginArgs
        >
        loginWithGoogle?: GraphCacheUpdateResolver<
            { loginWithGoogle: WithTypename<LoginResponse> },
            MutationLoginWithGoogleArgs
        >
        logout?: GraphCacheUpdateResolver<
            { logout: Scalars['Boolean'] },
            Record<string, never>
        >
        magicLinkConsume?: GraphCacheUpdateResolver<
            { magicLinkConsume: WithTypename<MagicLinkConsumeResponse> },
            MutationMagicLinkConsumeArgs
        >
        magicLinkRequest?: GraphCacheUpdateResolver<
            { magicLinkRequest: Maybe<Scalars['Void']> },
            MutationMagicLinkRequestArgs
        >
        marketingData?: GraphCacheUpdateResolver<
            { marketingData: WithTypename<MarketingDataResponse> },
            MutationMarketingDataArgs
        >
        nonSkuGemStoneChangeImage?: GraphCacheUpdateResolver<
            { nonSkuGemStoneChangeImage: WithTypename<NonSkuGemstone> },
            MutationNonSkuGemStoneChangeImageArgs
        >
        nonSkuGemStoneCreate?: GraphCacheUpdateResolver<
            { nonSkuGemStoneCreate: WithTypename<NonSkuGemstone> },
            MutationNonSkuGemStoneCreateArgs
        >
        nonSkuGemStoneDelete?: GraphCacheUpdateResolver<
            { nonSkuGemStoneDelete: WithTypename<NonSkuGemstone> },
            MutationNonSkuGemStoneDeleteArgs
        >
        nonSkuGemStoneDeleteImage?: GraphCacheUpdateResolver<
            { nonSkuGemStoneDeleteImage: WithTypename<NonSkuGemstone> },
            MutationNonSkuGemStoneDeleteImageArgs
        >
        nonSkuGemstoneCaratDimensionCreate?: GraphCacheUpdateResolver<
            {
                nonSkuGemstoneCaratDimensionCreate: WithTypename<NonSkuGemstoneCaratDimension>
            },
            MutationNonSkuGemstoneCaratDimensionCreateArgs
        >
        nonSkuGemstoneCaratDimensionDelete?: GraphCacheUpdateResolver<
            {
                nonSkuGemstoneCaratDimensionDelete: WithTypename<NonSkuGemstoneCaratDimension>
            },
            MutationNonSkuGemstoneCaratDimensionDeleteArgs
        >
        nonSkuGemstoneColorCrystalDimensionCreate?: GraphCacheUpdateResolver<
            {
                nonSkuGemstoneColorCrystalDimensionCreate: WithTypename<NonSkuGemstoneType>
            },
            MutationNonSkuGemstoneColorCrystalDimensionCreateArgs
        >
        nonSkuGemstoneColorCrystalDimensionDelete?: GraphCacheUpdateResolver<
            {
                nonSkuGemstoneColorCrystalDimensionDelete: WithTypename<NonSkuGemstoneType>
            },
            MutationNonSkuGemstoneColorCrystalDimensionDeleteArgs
        >
        nonSkuGemstoneGradeClarityDimensionCreate?: GraphCacheUpdateResolver<
            {
                nonSkuGemstoneGradeClarityDimensionCreate: WithTypename<NonSkuGemstoneGradeClarityDimension>
            },
            MutationNonSkuGemstoneGradeClarityDimensionCreateArgs
        >
        nonSkuGemstoneGradeClarityDimensionDelete?: GraphCacheUpdateResolver<
            {
                nonSkuGemstoneGradeClarityDimensionDelete: WithTypename<NonSkuGemstoneGradeClarityDimension>
            },
            MutationNonSkuGemstoneGradeClarityDimensionDeleteArgs
        >
        nonSkuGemstoneImageCreate?: GraphCacheUpdateResolver<
            { nonSkuGemstoneImageCreate: WithTypename<NonSkuGemstoneImage> },
            MutationNonSkuGemstoneImageCreateArgs
        >
        nonSkuGemstoneImageDelete?: GraphCacheUpdateResolver<
            { nonSkuGemstoneImageDelete: WithTypename<NonSkuGemstoneImage> },
            MutationNonSkuGemstoneImageDeleteArgs
        >
        nonSkuGemstoneImageUpdate?: GraphCacheUpdateResolver<
            { nonSkuGemstoneImageUpdate: WithTypename<NonSkuGemstoneImage> },
            MutationNonSkuGemstoneImageUpdateArgs
        >
        nonSkuGemstoneShapeDimensionCreate?: GraphCacheUpdateResolver<
            {
                nonSkuGemstoneShapeDimensionCreate: WithTypename<NonSkuGemstoneShapeDimension>
            },
            MutationNonSkuGemstoneShapeDimensionCreateArgs
        >
        nonSkuGemstoneShapeDimensionDelete?: GraphCacheUpdateResolver<
            {
                nonSkuGemstoneShapeDimensionDelete: WithTypename<NonSkuGemstoneShapeDimension>
            },
            MutationNonSkuGemstoneShapeDimensionDeleteArgs
        >
        nonSkuLabGrownCaratDimensionCreate?: GraphCacheUpdateResolver<
            {
                nonSkuLabGrownCaratDimensionCreate: WithTypename<NonSkuLabGrownCaratDimension>
            },
            MutationNonSkuLabGrownCaratDimensionCreateArgs
        >
        nonSkuLabGrownCaratDimensionDelete?: GraphCacheUpdateResolver<
            {
                nonSkuLabGrownCaratDimensionDelete: WithTypename<NonSkuLabGrownCaratDimension>
            },
            MutationNonSkuLabGrownCaratDimensionDeleteArgs
        >
        nonSkuLabGrownDiamondChangeImage?: GraphCacheUpdateResolver<
            { nonSkuLabGrownDiamondChangeImage: WithTypename<NonSkuLabGrown> },
            MutationNonSkuLabGrownDiamondChangeImageArgs
        >
        nonSkuLabGrownDiamondCreate?: GraphCacheUpdateResolver<
            { nonSkuLabGrownDiamondCreate: WithTypename<NonSkuLabGrown> },
            MutationNonSkuLabGrownDiamondCreateArgs
        >
        nonSkuLabGrownDiamondDelete?: GraphCacheUpdateResolver<
            { nonSkuLabGrownDiamondDelete: WithTypename<NonSkuLabGrown> },
            MutationNonSkuLabGrownDiamondDeleteArgs
        >
        nonSkuLabGrownDiamondDeleteImage?: GraphCacheUpdateResolver<
            { nonSkuLabGrownDiamondDeleteImage: WithTypename<NonSkuLabGrown> },
            MutationNonSkuLabGrownDiamondDeleteImageArgs
        >
        nonSkuLabGrownGradeDimensionCreate?: GraphCacheUpdateResolver<
            {
                nonSkuLabGrownGradeDimensionCreate: WithTypename<NonSkuLabGrownGradeDimension>
            },
            MutationNonSkuLabGrownGradeDimensionCreateArgs
        >
        nonSkuLabGrownGradeDimensionDelete?: GraphCacheUpdateResolver<
            {
                nonSkuLabGrownGradeDimensionDelete: WithTypename<NonSkuLabGrownGradeDimension>
            },
            MutationNonSkuLabGrownGradeDimensionDeleteArgs
        >
        nonSkuLabGrownShapeDimensionCreate?: GraphCacheUpdateResolver<
            {
                nonSkuLabGrownShapeDimensionCreate: WithTypename<NonSkuLabGrownShapeDimension>
            },
            MutationNonSkuLabGrownShapeDimensionCreateArgs
        >
        nonSkuLabGrownShapeDimensionDelete?: GraphCacheUpdateResolver<
            {
                nonSkuLabGrownShapeDimensionDelete: WithTypename<NonSkuLabGrownShapeDimension>
            },
            MutationNonSkuLabGrownShapeDimensionDeleteArgs
        >
        nonSkuLabGrownShapeDimensionUpdate?: GraphCacheUpdateResolver<
            {
                nonSkuLabGrownShapeDimensionUpdate: WithTypename<NonSkuLabGrownShapeDimension>
            },
            MutationNonSkuLabGrownShapeDimensionUpdateArgs
        >
        payViaAffirm?: GraphCacheUpdateResolver<
            { payViaAffirm: WithTypename<AffirmPaymentResponse> },
            MutationPayViaAffirmArgs
        >
        payViaAllocation?: GraphCacheUpdateResolver<
            { payViaAllocation: WithTypename<Order> },
            MutationPayViaAllocationArgs
        >
        payViaBank?: GraphCacheUpdateResolver<
            { payViaBank: WithTypename<Order> },
            MutationPayViaBankArgs
        >
        payViaCheckoutcom?: GraphCacheUpdateResolver<
            { payViaCheckoutcom: WithTypename<PayViaCheckoutcomResponse> },
            MutationPayViaCheckoutcomArgs
        >
        payViaKlarna?: GraphCacheUpdateResolver<
            { payViaKlarna: WithTypename<KlarnaPaymentResponse> },
            MutationPayViaKlarnaArgs
        >
        payViaNoPayment?: GraphCacheUpdateResolver<
            { payViaNoPayment: WithTypename<Order> },
            MutationPayViaNoPaymentArgs
        >
        ping?: GraphCacheUpdateResolver<
            { ping: Scalars['String'] },
            Record<string, never>
        >
        questionnaireCompleteExistingCustomer?: GraphCacheUpdateResolver<
            {
                questionnaireCompleteExistingCustomer: WithTypename<QuestionnaireCompletedExistingCustomerResponse>
            },
            MutationQuestionnaireCompleteExistingCustomerArgs
        >
        questionnaireCompleteNewCustomer?: GraphCacheUpdateResolver<
            {
                questionnaireCompleteNewCustomer: WithTypename<QuestionnaireCompletedNewCustomerResponse>
            },
            MutationQuestionnaireCompleteNewCustomerArgs
        >
        refreshToken?: GraphCacheUpdateResolver<
            { refreshToken: WithTypename<LoginResponse> },
            MutationRefreshTokenArgs
        >
        removeFromMyCart?: GraphCacheUpdateResolver<
            { removeFromMyCart: WithTypename<Order> },
            MutationRemoveFromMyCartArgs
        >
        ringBuilder?: GraphCacheUpdateResolver<
            { ringBuilder: WithTypename<RingBuilder> },
            MutationRingBuilderArgs
        >
        ringBuilderResolveExistingCustomer?: GraphCacheUpdateResolver<
            {
                ringBuilderResolveExistingCustomer: WithTypename<RingBuilderResolvedExistingCustomer>
            },
            MutationRingBuilderResolveExistingCustomerArgs
        >
        ringBuilderResolveNewCustomer?: GraphCacheUpdateResolver<
            {
                ringBuilderResolveNewCustomer: WithTypename<RingBuilderResolvedNewCustomer>
            },
            MutationRingBuilderResolveNewCustomerArgs
        >
        ringBuilderSet?: GraphCacheUpdateResolver<
            { ringBuilderSet: WithTypename<RingBuilderSetResult> },
            MutationRingBuilderSetArgs
        >
        setOrderCollectFromShowroomInformation?: GraphCacheUpdateResolver<
            {
                setOrderCollectFromShowroomInformation: WithTypename<SetDeliveryInformationResponse>
            },
            MutationSetOrderCollectFromShowroomInformationArgs
        >
        setOrderDeliverToAddressInformation?: GraphCacheUpdateResolver<
            {
                setOrderDeliverToAddressInformation: WithTypename<SetDeliveryInformationResponse>
            },
            MutationSetOrderDeliverToAddressInformationArgs
        >
        updateConsultationByConsultant?: GraphCacheUpdateResolver<
            {
                updateConsultationByConsultant: Maybe<
                    WithTypename<BookingConsultation>
                >
            },
            MutationUpdateConsultationByConsultantArgs
        >
    }
    Subscription?: {}
    AddToCartReadyToGoRingSuccessExistingCustomer?: {
        order?: GraphCacheUpdateResolver<
            Maybe<WithTypename<AddToCartReadyToGoRingSuccessExistingCustomer>>,
            Record<string, never>
        >
        product?: GraphCacheUpdateResolver<
            Maybe<WithTypename<AddToCartReadyToGoRingSuccessExistingCustomer>>,
            Record<string, never>
        >
    }
    AddToCartReadyToGoRingSuccessNewCustomer?: {
        customer?: GraphCacheUpdateResolver<
            Maybe<WithTypename<AddToCartReadyToGoRingSuccessNewCustomer>>,
            Record<string, never>
        >
        order?: GraphCacheUpdateResolver<
            Maybe<WithTypename<AddToCartReadyToGoRingSuccessNewCustomer>>,
            Record<string, never>
        >
        product?: GraphCacheUpdateResolver<
            Maybe<WithTypename<AddToCartReadyToGoRingSuccessNewCustomer>>,
            Record<string, never>
        >
    }
    Address?: {
        country?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Address>>,
            Record<string, never>
        >
        phoneNumber?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Address>>,
            Record<string, never>
        >
    }
    AffirmCompleteTransactionResponse?: {
        errors?: GraphCacheUpdateResolver<
            Maybe<WithTypename<AffirmCompleteTransactionResponse>>,
            Record<string, never>
        >
        order?: GraphCacheUpdateResolver<
            Maybe<WithTypename<AffirmCompleteTransactionResponse>>,
            Record<string, never>
        >
    }
    AffirmFinanceOption?: {
        months?: GraphCacheUpdateResolver<
            Maybe<WithTypename<AffirmFinanceOption>>,
            Record<string, never>
        >
        perMonth?: GraphCacheUpdateResolver<
            Maybe<WithTypename<AffirmFinanceOption>>,
            Record<string, never>
        >
        price?: GraphCacheUpdateResolver<
            Maybe<WithTypename<AffirmFinanceOption>>,
            Record<string, never>
        >
    }
    AffirmPaymentMethod?: {
        publicKey?: GraphCacheUpdateResolver<
            Maybe<WithTypename<AffirmPaymentMethod>>,
            Record<string, never>
        >
        scriptUrl?: GraphCacheUpdateResolver<
            Maybe<WithTypename<AffirmPaymentMethod>>,
            Record<string, never>
        >
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<AffirmPaymentMethod>>,
            Record<string, never>
        >
    }
    AffirmPaymentResponse?: {
        errors?: GraphCacheUpdateResolver<
            Maybe<WithTypename<AffirmPaymentResponse>>,
            Record<string, never>
        >
        order?: GraphCacheUpdateResolver<
            Maybe<WithTypename<AffirmPaymentResponse>>,
            Record<string, never>
        >
    }
    AffirmTransaction?: {
        amount?: GraphCacheUpdateResolver<
            Maybe<WithTypename<AffirmTransaction>>,
            Record<string, never>
        >
        checkoutObject?: GraphCacheUpdateResolver<
            Maybe<WithTypename<AffirmTransaction>>,
            AffirmTransactionCheckoutObjectArgs
        >
        createdAt?: GraphCacheUpdateResolver<
            Maybe<WithTypename<AffirmTransaction>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<AffirmTransaction>>,
            Record<string, never>
        >
        status?: GraphCacheUpdateResolver<
            Maybe<WithTypename<AffirmTransaction>>,
            Record<string, never>
        >
    }
    AllocationPaymentMethod?: {
        maxAmount?: GraphCacheUpdateResolver<
            Maybe<WithTypename<AllocationPaymentMethod>>,
            Record<string, never>
        >
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<AllocationPaymentMethod>>,
            Record<string, never>
        >
    }
    AllocationTransaction?: {
        amount?: GraphCacheUpdateResolver<
            Maybe<WithTypename<AllocationTransaction>>,
            Record<string, never>
        >
        createdAt?: GraphCacheUpdateResolver<
            Maybe<WithTypename<AllocationTransaction>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<AllocationTransaction>>,
            Record<string, never>
        >
        status?: GraphCacheUpdateResolver<
            Maybe<WithTypename<AllocationTransaction>>,
            Record<string, never>
        >
    }
    ArticleGridItem?: {
        description?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ArticleGridItem>>,
            Record<string, never>
        >
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ArticleGridItem>>,
            Record<string, never>
        >
        link?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ArticleGridItem>>,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ArticleGridItem>>,
            Record<string, never>
        >
    }
    ArticlePreview?: {
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ArticlePreview>>,
            Record<string, never>
        >
        link?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ArticlePreview>>,
            Record<string, never>
        >
        subtitle?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ArticlePreview>>,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ArticlePreview>>,
            Record<string, never>
        >
    }
    Asset?: {
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Asset>>,
            Record<string, never>
        >
        mimeType?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Asset>>,
            Record<string, never>
        >
        size?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Asset>>,
            AssetSizeArgs
        >
        sources?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Asset>>,
            Record<string, never>
        >
        url?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Asset>>,
            Record<string, never>
        >
    }
    Author?: {
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Author>>,
            Record<string, never>
        >
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Author>>,
            Record<string, never>
        >
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Author>>,
            Record<string, never>
        >
        postAggregation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Author>>,
            AuthorPostAggregationArgs
        >
        posts?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Author>>,
            AuthorPostsArgs
        >
        slug?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Author>>,
            Record<string, never>
        >
    }
    AuthorsAggregation?: {
        count?: GraphCacheUpdateResolver<
            Maybe<WithTypename<AuthorsAggregation>>,
            Record<string, never>
        >
    }
    AvatarStackItem?: {
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<AvatarStackItem>>,
            Record<string, never>
        >
    }
    AvataxAddressInvalidError?: {
        message?: GraphCacheUpdateResolver<
            Maybe<WithTypename<AvataxAddressInvalidError>>,
            Record<string, never>
        >
    }
    BankPaymentMethod?: {
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BankPaymentMethod>>,
            Record<string, never>
        >
    }
    BankTransaction?: {
        amount?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BankTransaction>>,
            Record<string, never>
        >
        createdAt?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BankTransaction>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BankTransaction>>,
            Record<string, never>
        >
        status?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BankTransaction>>,
            Record<string, never>
        >
    }
    Banner1?: {
        backgroundColor?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Banner1>>,
            Record<string, never>
        >
        backgroundImage?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Banner1>>,
            Record<string, never>
        >
        button?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Banner1>>,
            Record<string, never>
        >
        preTitle?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Banner1>>,
            Record<string, never>
        >
        text?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Banner1>>,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Banner1>>,
            Record<string, never>
        >
    }
    Banner2?: {
        backgroundColor?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Banner2>>,
            Record<string, never>
        >
        button?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Banner2>>,
            Record<string, never>
        >
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Banner2>>,
            Record<string, never>
        >
        preTitle?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Banner2>>,
            Record<string, never>
        >
        text?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Banner2>>,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Banner2>>,
            Record<string, never>
        >
    }
    Block?: {
        anchor?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Block>>,
            Record<string, never>
        >
        backgroundColor?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Block>>,
            Record<string, never>
        >
        backgroundOverflow?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Block>>,
            Record<string, never>
        >
        collapsibleTitle?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Block>>,
            Record<string, never>
        >
        components?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Block>>,
            Record<string, never>
        >
        display?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Block>>,
            Record<string, never>
        >
        isCollapsible?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Block>>,
            Record<string, never>
        >
        isOpenByDefault?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Block>>,
            Record<string, never>
        >
        verticalSpacing?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Block>>,
            Record<string, never>
        >
        width?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Block>>,
            Record<string, never>
        >
    }
    BlockAnchor?: {
        slug?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BlockAnchor>>,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BlockAnchor>>,
            Record<string, never>
        >
    }
    BookingConsultation?: {
        canBeCancelled?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultation>>,
            Record<string, never>
        >
        consultant?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultation>>,
            Record<string, never>
        >
        consultationRoom?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultation>>,
            Record<string, never>
        >
        customer?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultation>>,
            Record<string, never>
        >
        description?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultation>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultation>>,
            Record<string, never>
        >
        isCancelled?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultation>>,
            Record<string, never>
        >
        method?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultation>>,
            Record<string, never>
        >
        note?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultation>>,
            Record<string, never>
        >
        order?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultation>>,
            Record<string, never>
        >
        purpose?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultation>>,
            Record<string, never>
        >
        salesforceId?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultation>>,
            Record<string, never>
        >
        showroom?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultation>>,
            Record<string, never>
        >
        startsAt?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultation>>,
            Record<string, never>
        >
        state?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultation>>,
            Record<string, never>
        >
    }
    BookingConsultationAvailableDate?: {
        consultationAvailableShowrooms?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultationAvailableDate>>,
            Record<string, never>
        >
        date?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultationAvailableDate>>,
            Record<string, never>
        >
    }
    BookingConsultationAvailableShowroom?: {
        consultationSlots?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultationAvailableShowroom>>,
            Record<string, never>
        >
    }
    BookingConsultationComplexity?: {
        icon?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultationComplexity>>,
            Record<string, never>
        >
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultationComplexity>>,
            Record<string, never>
        >
        translation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultationComplexity>>,
            BookingConsultationComplexityTranslationArgs
        >
    }
    BookingConsultationComplexityTranslation?: {
        locale?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultationComplexityTranslation>>,
            Record<string, never>
        >
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultationComplexityTranslation>>,
            Record<string, never>
        >
    }
    BookingConsultationMethod?: {
        icon?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultationMethod>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultationMethod>>,
            Record<string, never>
        >
        isVirtual?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultationMethod>>,
            Record<string, never>
        >
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultationMethod>>,
            Record<string, never>
        >
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultationMethod>>,
            Record<string, never>
        >
        takesRoom?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultationMethod>>,
            Record<string, never>
        >
    }
    BookingConsultationPurpose?: {
        duration?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultationPurpose>>,
            Record<string, never>
        >
        icon?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultationPurpose>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultationPurpose>>,
            Record<string, never>
        >
        methods?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultationPurpose>>,
            Record<string, never>
        >
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultationPurpose>>,
            Record<string, never>
        >
        requireConsultant?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultationPurpose>>,
            Record<string, never>
        >
        requireOrder?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultationPurpose>>,
            Record<string, never>
        >
        slotLengthInMinutes?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultationPurpose>>,
            Record<string, never>
        >
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultationPurpose>>,
            Record<string, never>
        >
        takesRoom?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultationPurpose>>,
            Record<string, never>
        >
        type?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultationPurpose>>,
            Record<string, never>
        >
    }
    BookingConsultationPurposeOrder?: {
        orders?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultationPurposeOrder>>,
            Record<string, never>
        >
        statuses?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultationPurposeOrder>>,
            Record<string, never>
        >
    }
    BookingConsultationSlot?: {
        showroom?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultationSlot>>,
            Record<string, never>
        >
        startTime?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultationSlot>>,
            Record<string, never>
        >
    }
    BookingConsultationSlotsResponse?: {
        slots?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultationSlotsResponse>>,
            Record<string, never>
        >
    }
    BookingConsultationType?: {
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultationType>>,
            Record<string, never>
        >
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingConsultationType>>,
            Record<string, never>
        >
    }
    BookingCreateConsultationErrorNoAvailableConsultants?: {
        message?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<BookingCreateConsultationErrorNoAvailableConsultants>
            >,
            BookingCreateConsultationErrorNoAvailableConsultantsMessageArgs
        >
    }
    BookingCreateConsultationSuccessExistingCustomer?: {
        consultation?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<BookingCreateConsultationSuccessExistingCustomer>
            >,
            Record<string, never>
        >
    }
    BookingCreateConsultationSuccessNewCustomer?: {
        consultation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingCreateConsultationSuccessNewCustomer>>,
            Record<string, never>
        >
        customerRegistrationResponse?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingCreateConsultationSuccessNewCustomer>>,
            Record<string, never>
        >
    }
    BookingInPersonConsultationRoom?: {
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingInPersonConsultationRoom>>,
            Record<string, never>
        >
        kind?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingInPersonConsultationRoom>>,
            Record<string, never>
        >
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingInPersonConsultationRoom>>,
            Record<string, never>
        >
    }
    BookingVirtualConsultationRoom?: {
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingVirtualConsultationRoom>>,
            Record<string, never>
        >
        kind?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingVirtualConsultationRoom>>,
            Record<string, never>
        >
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<BookingVirtualConsultationRoom>>,
            Record<string, never>
        >
    }
    ButtonEventTracking?: {
        action?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ButtonEventTracking>>,
            Record<string, never>
        >
        category?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ButtonEventTracking>>,
            Record<string, never>
        >
        event?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ButtonEventTracking>>,
            Record<string, never>
        >
        label?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ButtonEventTracking>>,
            Record<string, never>
        >
    }
    ButtonIcon?: {
        icon?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ButtonIcon>>,
            Record<string, never>
        >
        position?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ButtonIcon>>,
            Record<string, never>
        >
    }
    ButtonStyle?: {
        bottomSpacing?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ButtonStyle>>,
            Record<string, never>
        >
        color?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ButtonStyle>>,
            Record<string, never>
        >
        linkSize?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ButtonStyle>>,
            Record<string, never>
        >
        size?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ButtonStyle>>,
            Record<string, never>
        >
        topSpacing?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ButtonStyle>>,
            Record<string, never>
        >
        type?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ButtonStyle>>,
            Record<string, never>
        >
        width?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ButtonStyle>>,
            Record<string, never>
        >
    }
    CardCarouselCard?: {
        backgroundColor?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CardCarouselCard>>,
            Record<string, never>
        >
        description?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CardCarouselCard>>,
            Record<string, never>
        >
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CardCarouselCard>>,
            Record<string, never>
        >
        link?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CardCarouselCard>>,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CardCarouselCard>>,
            Record<string, never>
        >
    }
    CarouselCustomProduct?: {
        description?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CarouselCustomProduct>>,
            Record<string, never>
        >
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CarouselCustomProduct>>,
            Record<string, never>
        >
        link?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CarouselCustomProduct>>,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CarouselCustomProduct>>,
            Record<string, never>
        >
    }
    CatalogueAggregate?: {
        count?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueAggregate>>,
            Record<string, never>
        >
    }
    CatalogueBandType?: {
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueBandType>>,
            Record<string, never>
        >
        translation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueBandType>>,
            CatalogueBandTypeTranslationArgs
        >
    }
    CatalogueBandTypeTranslation?: {
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueBandTypeTranslation>>,
            Record<string, never>
        >
    }
    CatalogueDesignStudioCheckoutEngagementRingAddedToDesignStudio?: {
        product?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<CatalogueDesignStudioCheckoutEngagementRingAddedToDesignStudio>
            >,
            Record<string, never>
        >
    }
    CatalogueDesignStudioCheckoutEngagementRingAddedToDesignStudioAndCart?: {
        checkoutProduct?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<CatalogueDesignStudioCheckoutEngagementRingAddedToDesignStudioAndCart>
            >,
            Record<string, never>
        >
        designStudioProduct?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<CatalogueDesignStudioCheckoutEngagementRingAddedToDesignStudioAndCart>
            >,
            Record<string, never>
        >
        order?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<CatalogueDesignStudioCheckoutEngagementRingAddedToDesignStudioAndCart>
            >,
            Record<string, never>
        >
    }
    CatalogueDesignStudioCheckoutJewellerySuccessExistingCustomer?: {
        order?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<CatalogueDesignStudioCheckoutJewellerySuccessExistingCustomer>
            >,
            Record<string, never>
        >
        product?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<CatalogueDesignStudioCheckoutJewellerySuccessExistingCustomer>
            >,
            Record<string, never>
        >
    }
    CatalogueDesignStudioCheckoutJewellerySuccessNewCustomer?: {
        customer?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<CatalogueDesignStudioCheckoutJewellerySuccessNewCustomer>
            >,
            Record<string, never>
        >
        order?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<CatalogueDesignStudioCheckoutJewellerySuccessNewCustomer>
            >,
            Record<string, never>
        >
        product?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<CatalogueDesignStudioCheckoutJewellerySuccessNewCustomer>
            >,
            Record<string, never>
        >
    }
    CatalogueDesignStudioCheckoutWeddingRingSuccessExistingCustomer?: {
        order?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<CatalogueDesignStudioCheckoutWeddingRingSuccessExistingCustomer>
            >,
            Record<string, never>
        >
        product?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<CatalogueDesignStudioCheckoutWeddingRingSuccessExistingCustomer>
            >,
            Record<string, never>
        >
    }
    CatalogueDesignStudioCheckoutWeddingRingSuccessNewCustomer?: {
        customer?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<CatalogueDesignStudioCheckoutWeddingRingSuccessNewCustomer>
            >,
            Record<string, never>
        >
        order?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<CatalogueDesignStudioCheckoutWeddingRingSuccessNewCustomer>
            >,
            Record<string, never>
        >
        product?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<CatalogueDesignStudioCheckoutWeddingRingSuccessNewCustomer>
            >,
            Record<string, never>
        >
    }
    CatalogueEngagementRing?: {
        bandThickness?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            Record<string, never>
        >
        bandWidth?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            Record<string, never>
        >
        catalogueCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            Record<string, never>
        >
        centreStoneConstraints?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            Record<string, never>
        >
        customTitleTag?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            Record<string, never>
        >
        deliveryDays?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            CatalogueEngagementRingDeliveryDaysArgs
        >
        designFeatures?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            Record<string, never>
        >
        designStyle?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            Record<string, never>
        >
        financeOptionsAffirm?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            CatalogueEngagementRingFinanceOptionsAffirmArgs
        >
        financeOptionsKlarna?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            CatalogueEngagementRingFinanceOptionsKlarnaArgs
        >
        firstAvailableDeliveryDate?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            CatalogueEngagementRingFirstAvailableDeliveryDateArgs
        >
        images?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            CatalogueEngagementRingImagesArgs
        >
        images360?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            Record<string, never>
        >
        isAvailableForRingBuilder?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            Record<string, never>
        >
        isResizeable?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            Record<string, never>
        >
        isReturnable?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            Record<string, never>
        >
        mainImage?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            Record<string, never>
        >
        meleeItems?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            Record<string, never>
        >
        primaryMetal?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            Record<string, never>
        >
        productName?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            Record<string, never>
        >
        relatedProducts?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            Record<string, never>
        >
        reviews?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            Record<string, never>
        >
        ringBuilderProducts?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            CatalogueEngagementRingRingBuilderProductsArgs
        >
        ringStyles?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            Record<string, never>
        >
        salePrice?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            CatalogueEngagementRingSalePriceArgs
        >
        segmentName?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            Record<string, never>
        >
        signatureStone?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            Record<string, never>
        >
        signatureStones?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            Record<string, never>
        >
        sizes?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            CatalogueEngagementRingSizesArgs
        >
        slug?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            Record<string, never>
        >
        suffix?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            Record<string, never>
        >
        suffixSlug?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            Record<string, never>
        >
        translation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            CatalogueEngagementRingTranslationArgs
        >
        updatedAt?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            Record<string, never>
        >
        variations?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            Record<string, never>
        >
        variationsByCentreStoneShape?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            Record<string, never>
        >
        variationsByPrimaryMetal?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            Record<string, never>
        >
        video?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRing>>,
            Record<string, never>
        >
    }
    CatalogueEngagementRingAndSignatureStone?: {
        salePrice?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRingAndSignatureStone>>,
            CatalogueEngagementRingAndSignatureStoneSalePriceArgs
        >
        signatureStone?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRingAndSignatureStone>>,
            Record<string, never>
        >
    }
    CatalogueEngagementRingCentreStoneConstraints?: {
        shape?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRingCentreStoneConstraints>>,
            Record<string, never>
        >
        weight?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRingCentreStoneConstraints>>,
            Record<string, never>
        >
    }
    CatalogueEngagementRingCentreStoneWeightConstraint?: {
        max?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<CatalogueEngagementRingCentreStoneWeightConstraint>
            >,
            Record<string, never>
        >
        min?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<CatalogueEngagementRingCentreStoneWeightConstraint>
            >,
            Record<string, never>
        >
    }
    CatalogueEngagementRingFilters?: {
        centreStoneShapes?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRingFilters>>,
            Record<string, never>
        >
        designFeatures?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRingFilters>>,
            Record<string, never>
        >
        designStyles?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRingFilters>>,
            Record<string, never>
        >
        price?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRingFilters>>,
            CatalogueEngagementRingFiltersPriceArgs
        >
        primaryMetals?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRingFilters>>,
            Record<string, never>
        >
        ringStyles?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRingFilters>>,
            Record<string, never>
        >
    }
    CatalogueEngagementRingFiltersVariation?: {
        centreStoneShape?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRingFiltersVariation>>,
            Record<string, never>
        >
        designFeature?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRingFiltersVariation>>,
            Record<string, never>
        >
        designStyle?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRingFiltersVariation>>,
            Record<string, never>
        >
        primaryMetal?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRingFiltersVariation>>,
            Record<string, never>
        >
        ringStyle?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRingFiltersVariation>>,
            Record<string, never>
        >
    }
    CatalogueEngagementRingSignatureStone?: {
        color?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRingSignatureStone>>,
            Record<string, never>
        >
        crystal?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRingSignatureStone>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRingSignatureStone>>,
            Record<string, never>
        >
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRingSignatureStone>>,
            Record<string, never>
        >
        isDefault?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRingSignatureStone>>,
            Record<string, never>
        >
        price?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRingSignatureStone>>,
            CatalogueEngagementRingSignatureStonePriceArgs
        >
        segmentName?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRingSignatureStone>>,
            Record<string, never>
        >
        width?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRingSignatureStone>>,
            Record<string, never>
        >
    }
    CatalogueEngagementRingTranslation?: {
        description?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRingTranslation>>,
            Record<string, never>
        >
        locale?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRingTranslation>>,
            Record<string, never>
        >
        seoText?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueEngagementRingTranslation>>,
            Record<string, never>
        >
    }
    CatalogueFilterEngagementRingDesignFeatureItem?: {
        label?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueFilterEngagementRingDesignFeatureItem>>,
            Record<string, never>
        >
        totalResults?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueFilterEngagementRingDesignFeatureItem>>,
            Record<string, never>
        >
    }
    CatalogueFilterEngagementRingDesingStyleItem?: {
        label?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueFilterEngagementRingDesingStyleItem>>,
            Record<string, never>
        >
        totalResults?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueFilterEngagementRingDesingStyleItem>>,
            Record<string, never>
        >
    }
    CatalogueFilterEngagementRingStylesItem?: {
        label?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueFilterEngagementRingStylesItem>>,
            Record<string, never>
        >
        totalResults?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueFilterEngagementRingStylesItem>>,
            Record<string, never>
        >
    }
    CatalogueFilterJewelleryBraceletProductStyleLabel?: {
        label?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<CatalogueFilterJewelleryBraceletProductStyleLabel>
            >,
            Record<string, never>
        >
        totalResults?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<CatalogueFilterJewelleryBraceletProductStyleLabel>
            >,
            Record<string, never>
        >
    }
    CatalogueFilterJewelleryDesignFeatureLabel?: {
        label?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueFilterJewelleryDesignFeatureLabel>>,
            Record<string, never>
        >
        totalResults?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueFilterJewelleryDesignFeatureLabel>>,
            Record<string, never>
        >
    }
    CatalogueFilterJewelleryDesignStyleLabel?: {
        label?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueFilterJewelleryDesignStyleLabel>>,
            Record<string, never>
        >
        totalResults?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueFilterJewelleryDesignStyleLabel>>,
            Record<string, never>
        >
    }
    CatalogueFilterJewelleryEarringsProductStyleLabel?: {
        label?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<CatalogueFilterJewelleryEarringsProductStyleLabel>
            >,
            Record<string, never>
        >
        totalResults?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<CatalogueFilterJewelleryEarringsProductStyleLabel>
            >,
            Record<string, never>
        >
    }
    CatalogueFilterJewelleryGemstoneLabel?: {
        label?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueFilterJewelleryGemstoneLabel>>,
            Record<string, never>
        >
        totalResults?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueFilterJewelleryGemstoneLabel>>,
            Record<string, never>
        >
    }
    CatalogueFilterJewelleryNecklaceProductStyleLabel?: {
        label?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<CatalogueFilterJewelleryNecklaceProductStyleLabel>
            >,
            Record<string, never>
        >
        totalResults?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<CatalogueFilterJewelleryNecklaceProductStyleLabel>
            >,
            Record<string, never>
        >
    }
    CatalogueFilterJewelleryRingProductStyleLabel?: {
        label?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueFilterJewelleryRingProductStyleLabel>>,
            Record<string, never>
        >
        totalResults?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueFilterJewelleryRingProductStyleLabel>>,
            Record<string, never>
        >
    }
    CatalogueFilterMetalItem?: {
        metal?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueFilterMetalItem>>,
            Record<string, never>
        >
        totalResults?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueFilterMetalItem>>,
            Record<string, never>
        >
    }
    CatalogueFilterShapeItem?: {
        shape?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueFilterShapeItem>>,
            Record<string, never>
        >
        totalResults?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueFilterShapeItem>>,
            Record<string, never>
        >
    }
    CatalogueFilterWeddingRingCategoriesItem?: {
        label?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueFilterWeddingRingCategoriesItem>>,
            Record<string, never>
        >
        totalResults?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueFilterWeddingRingCategoriesItem>>,
            Record<string, never>
        >
    }
    CatalogueFilterWeddingRingStylesItem?: {
        label?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueFilterWeddingRingStylesItem>>,
            Record<string, never>
        >
        totalResults?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueFilterWeddingRingStylesItem>>,
            Record<string, never>
        >
    }
    CatalogueImage?: {
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueImage>>,
            Record<string, never>
        >
        mimeType?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueImage>>,
            Record<string, never>
        >
        size?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueImage>>,
            CatalogueImageSizeArgs
        >
        sources?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueImage>>,
            Record<string, never>
        >
        url?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueImage>>,
            Record<string, never>
        >
    }
    CatalogueJewelleriesBraceletsFiltersVariation?: {
        designFeature?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleriesBraceletsFiltersVariation>>,
            Record<string, never>
        >
        designStyle?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleriesBraceletsFiltersVariation>>,
            Record<string, never>
        >
        gemstone?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleriesBraceletsFiltersVariation>>,
            Record<string, never>
        >
        primaryMetal?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleriesBraceletsFiltersVariation>>,
            Record<string, never>
        >
        productStyle?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleriesBraceletsFiltersVariation>>,
            Record<string, never>
        >
    }
    CatalogueJewelleriesEarringsFiltersVariation?: {
        designFeature?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleriesEarringsFiltersVariation>>,
            Record<string, never>
        >
        designStyle?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleriesEarringsFiltersVariation>>,
            Record<string, never>
        >
        gemstone?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleriesEarringsFiltersVariation>>,
            Record<string, never>
        >
        primaryMetal?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleriesEarringsFiltersVariation>>,
            Record<string, never>
        >
        productStyle?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleriesEarringsFiltersVariation>>,
            Record<string, never>
        >
    }
    CatalogueJewelleriesFilters?: {
        designFeatures?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleriesFilters>>,
            Record<string, never>
        >
        designStyles?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleriesFilters>>,
            Record<string, never>
        >
        gemstones?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleriesFilters>>,
            Record<string, never>
        >
        price?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleriesFilters>>,
            CatalogueJewelleriesFiltersPriceArgs
        >
        primaryMetals?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleriesFilters>>,
            Record<string, never>
        >
    }
    CatalogueJewelleriesFiltersVariation?: {
        designFeature?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleriesFiltersVariation>>,
            Record<string, never>
        >
        designStyle?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleriesFiltersVariation>>,
            Record<string, never>
        >
        gemstone?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleriesFiltersVariation>>,
            Record<string, never>
        >
        primaryMetal?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleriesFiltersVariation>>,
            Record<string, never>
        >
    }
    CatalogueJewelleriesNecklacesFiltersVariation?: {
        designFeature?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleriesNecklacesFiltersVariation>>,
            Record<string, never>
        >
        designStyle?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleriesNecklacesFiltersVariation>>,
            Record<string, never>
        >
        gemstone?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleriesNecklacesFiltersVariation>>,
            Record<string, never>
        >
        primaryMetal?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleriesNecklacesFiltersVariation>>,
            Record<string, never>
        >
        productStyle?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleriesNecklacesFiltersVariation>>,
            Record<string, never>
        >
    }
    CatalogueJewelleriesRingsFiltersVariation?: {
        designFeature?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleriesRingsFiltersVariation>>,
            Record<string, never>
        >
        designStyle?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleriesRingsFiltersVariation>>,
            Record<string, never>
        >
        gemstone?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleriesRingsFiltersVariation>>,
            Record<string, never>
        >
        primaryMetal?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleriesRingsFiltersVariation>>,
            Record<string, never>
        >
        productStyle?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleriesRingsFiltersVariation>>,
            Record<string, never>
        >
    }
    CatalogueJewelleryBracelet?: {
        catalogueCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBracelet>>,
            Record<string, never>
        >
        customTitleTag?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBracelet>>,
            Record<string, never>
        >
        deliveryDays?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBracelet>>,
            CatalogueJewelleryBraceletDeliveryDaysArgs
        >
        designFeatures?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBracelet>>,
            Record<string, never>
        >
        designStyles?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBracelet>>,
            Record<string, never>
        >
        engravingDisabled?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBracelet>>,
            Record<string, never>
        >
        financeOptionsAffirm?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBracelet>>,
            CatalogueJewelleryBraceletFinanceOptionsAffirmArgs
        >
        financeOptionsKlarna?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBracelet>>,
            CatalogueJewelleryBraceletFinanceOptionsKlarnaArgs
        >
        firstAvailableDeliveryDate?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBracelet>>,
            CatalogueJewelleryBraceletFirstAvailableDeliveryDateArgs
        >
        gemstones?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBracelet>>,
            Record<string, never>
        >
        images?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBracelet>>,
            CatalogueJewelleryBraceletImagesArgs
        >
        images360?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBracelet>>,
            Record<string, never>
        >
        isReturnable?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBracelet>>,
            Record<string, never>
        >
        mainImage?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBracelet>>,
            Record<string, never>
        >
        primaryMetal?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBracelet>>,
            Record<string, never>
        >
        productName?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBracelet>>,
            Record<string, never>
        >
        productStyles?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBracelet>>,
            Record<string, never>
        >
        relatedProducts?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBracelet>>,
            Record<string, never>
        >
        reviews?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBracelet>>,
            Record<string, never>
        >
        salePrice?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBracelet>>,
            CatalogueJewelleryBraceletSalePriceArgs
        >
        segmentName?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBracelet>>,
            Record<string, never>
        >
        signatureStone?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBracelet>>,
            Record<string, never>
        >
        sku?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBracelet>>,
            Record<string, never>
        >
        slug?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBracelet>>,
            Record<string, never>
        >
        suffix?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBracelet>>,
            Record<string, never>
        >
        suffixSlug?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBracelet>>,
            Record<string, never>
        >
        translation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBracelet>>,
            CatalogueJewelleryBraceletTranslationArgs
        >
        updatedAt?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBracelet>>,
            Record<string, never>
        >
        variations?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBracelet>>,
            Record<string, never>
        >
        video?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBracelet>>,
            Record<string, never>
        >
    }
    CatalogueJewelleryBraceletTranslation?: {
        description?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBraceletTranslation>>,
            Record<string, never>
        >
        seoText?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBraceletTranslation>>,
            Record<string, never>
        >
    }
    CatalogueJewelleryBraceletsFilters?: {
        designFeatures?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBraceletsFilters>>,
            Record<string, never>
        >
        designStyles?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBraceletsFilters>>,
            Record<string, never>
        >
        gemstones?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBraceletsFilters>>,
            Record<string, never>
        >
        price?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBraceletsFilters>>,
            CatalogueJewelleryBraceletsFiltersPriceArgs
        >
        primaryMetals?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBraceletsFilters>>,
            Record<string, never>
        >
        productStyles?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryBraceletsFilters>>,
            Record<string, never>
        >
    }
    CatalogueJewelleryEarrings?: {
        catalogueCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarrings>>,
            Record<string, never>
        >
        customTitleTag?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarrings>>,
            Record<string, never>
        >
        deliveryDays?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarrings>>,
            CatalogueJewelleryEarringsDeliveryDaysArgs
        >
        designFeatures?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarrings>>,
            Record<string, never>
        >
        designStyles?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarrings>>,
            Record<string, never>
        >
        engravingDisabled?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarrings>>,
            Record<string, never>
        >
        financeOptionsAffirm?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarrings>>,
            CatalogueJewelleryEarringsFinanceOptionsAffirmArgs
        >
        financeOptionsKlarna?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarrings>>,
            CatalogueJewelleryEarringsFinanceOptionsKlarnaArgs
        >
        firstAvailableDeliveryDate?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarrings>>,
            CatalogueJewelleryEarringsFirstAvailableDeliveryDateArgs
        >
        gemstones?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarrings>>,
            Record<string, never>
        >
        images?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarrings>>,
            CatalogueJewelleryEarringsImagesArgs
        >
        images360?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarrings>>,
            Record<string, never>
        >
        isReturnable?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarrings>>,
            Record<string, never>
        >
        mainImage?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarrings>>,
            Record<string, never>
        >
        primaryMetal?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarrings>>,
            Record<string, never>
        >
        productName?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarrings>>,
            Record<string, never>
        >
        productStyles?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarrings>>,
            Record<string, never>
        >
        relatedProducts?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarrings>>,
            Record<string, never>
        >
        reviews?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarrings>>,
            Record<string, never>
        >
        salePrice?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarrings>>,
            CatalogueJewelleryEarringsSalePriceArgs
        >
        segmentName?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarrings>>,
            Record<string, never>
        >
        signatureStone?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarrings>>,
            Record<string, never>
        >
        sku?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarrings>>,
            Record<string, never>
        >
        slug?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarrings>>,
            Record<string, never>
        >
        suffix?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarrings>>,
            Record<string, never>
        >
        suffixSlug?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarrings>>,
            Record<string, never>
        >
        translation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarrings>>,
            CatalogueJewelleryEarringsTranslationArgs
        >
        updatedAt?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarrings>>,
            Record<string, never>
        >
        variations?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarrings>>,
            Record<string, never>
        >
        video?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarrings>>,
            Record<string, never>
        >
    }
    CatalogueJewelleryEarringsFilters?: {
        designFeatures?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarringsFilters>>,
            Record<string, never>
        >
        designStyles?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarringsFilters>>,
            Record<string, never>
        >
        gemstones?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarringsFilters>>,
            Record<string, never>
        >
        price?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarringsFilters>>,
            CatalogueJewelleryEarringsFiltersPriceArgs
        >
        primaryMetals?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarringsFilters>>,
            Record<string, never>
        >
        productStyles?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarringsFilters>>,
            Record<string, never>
        >
    }
    CatalogueJewelleryEarringsTranslation?: {
        description?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarringsTranslation>>,
            Record<string, never>
        >
        seoText?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryEarringsTranslation>>,
            Record<string, never>
        >
    }
    CatalogueJewelleryNecklace?: {
        catalogueCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklace>>,
            Record<string, never>
        >
        customTitleTag?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklace>>,
            Record<string, never>
        >
        deliveryDays?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklace>>,
            CatalogueJewelleryNecklaceDeliveryDaysArgs
        >
        designFeatures?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklace>>,
            Record<string, never>
        >
        designStyles?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklace>>,
            Record<string, never>
        >
        engravingDisabled?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklace>>,
            Record<string, never>
        >
        financeOptionsAffirm?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklace>>,
            CatalogueJewelleryNecklaceFinanceOptionsAffirmArgs
        >
        financeOptionsKlarna?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklace>>,
            CatalogueJewelleryNecklaceFinanceOptionsKlarnaArgs
        >
        firstAvailableDeliveryDate?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklace>>,
            CatalogueJewelleryNecklaceFirstAvailableDeliveryDateArgs
        >
        gemstones?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklace>>,
            Record<string, never>
        >
        images?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklace>>,
            CatalogueJewelleryNecklaceImagesArgs
        >
        images360?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklace>>,
            Record<string, never>
        >
        isReturnable?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklace>>,
            Record<string, never>
        >
        mainImage?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklace>>,
            Record<string, never>
        >
        primaryMetal?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklace>>,
            Record<string, never>
        >
        productName?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklace>>,
            Record<string, never>
        >
        productStyles?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklace>>,
            Record<string, never>
        >
        relatedProducts?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklace>>,
            Record<string, never>
        >
        reviews?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklace>>,
            Record<string, never>
        >
        salePrice?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklace>>,
            CatalogueJewelleryNecklaceSalePriceArgs
        >
        segmentName?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklace>>,
            Record<string, never>
        >
        signatureStone?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklace>>,
            Record<string, never>
        >
        sku?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklace>>,
            Record<string, never>
        >
        slug?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklace>>,
            Record<string, never>
        >
        suffix?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklace>>,
            Record<string, never>
        >
        suffixSlug?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklace>>,
            Record<string, never>
        >
        translation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklace>>,
            CatalogueJewelleryNecklaceTranslationArgs
        >
        updatedAt?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklace>>,
            Record<string, never>
        >
        variations?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklace>>,
            Record<string, never>
        >
        video?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklace>>,
            Record<string, never>
        >
    }
    CatalogueJewelleryNecklaceTranslation?: {
        description?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklaceTranslation>>,
            Record<string, never>
        >
        seoText?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklaceTranslation>>,
            Record<string, never>
        >
    }
    CatalogueJewelleryNecklacesFilters?: {
        designFeatures?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklacesFilters>>,
            Record<string, never>
        >
        designStyles?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklacesFilters>>,
            Record<string, never>
        >
        gemstones?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklacesFilters>>,
            Record<string, never>
        >
        price?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklacesFilters>>,
            CatalogueJewelleryNecklacesFiltersPriceArgs
        >
        primaryMetals?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklacesFilters>>,
            Record<string, never>
        >
        productStyles?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryNecklacesFilters>>,
            Record<string, never>
        >
    }
    CatalogueJewelleryRing?: {
        catalogueCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRing>>,
            Record<string, never>
        >
        customTitleTag?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRing>>,
            Record<string, never>
        >
        deliveryDays?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRing>>,
            CatalogueJewelleryRingDeliveryDaysArgs
        >
        designFeatures?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRing>>,
            Record<string, never>
        >
        designStyles?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRing>>,
            Record<string, never>
        >
        engravingDisabled?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRing>>,
            Record<string, never>
        >
        financeOptionsAffirm?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRing>>,
            CatalogueJewelleryRingFinanceOptionsAffirmArgs
        >
        financeOptionsKlarna?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRing>>,
            CatalogueJewelleryRingFinanceOptionsKlarnaArgs
        >
        firstAvailableDeliveryDate?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRing>>,
            CatalogueJewelleryRingFirstAvailableDeliveryDateArgs
        >
        gemstones?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRing>>,
            Record<string, never>
        >
        images?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRing>>,
            CatalogueJewelleryRingImagesArgs
        >
        images360?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRing>>,
            Record<string, never>
        >
        isResizeable?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRing>>,
            Record<string, never>
        >
        isReturnable?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRing>>,
            Record<string, never>
        >
        mainImage?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRing>>,
            Record<string, never>
        >
        primaryMetal?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRing>>,
            Record<string, never>
        >
        productName?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRing>>,
            Record<string, never>
        >
        productStyles?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRing>>,
            Record<string, never>
        >
        relatedProducts?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRing>>,
            Record<string, never>
        >
        reviews?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRing>>,
            Record<string, never>
        >
        salePrice?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRing>>,
            CatalogueJewelleryRingSalePriceArgs
        >
        segmentName?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRing>>,
            Record<string, never>
        >
        signatureStone?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRing>>,
            Record<string, never>
        >
        sizes?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRing>>,
            CatalogueJewelleryRingSizesArgs
        >
        sku?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRing>>,
            Record<string, never>
        >
        slug?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRing>>,
            Record<string, never>
        >
        suffix?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRing>>,
            Record<string, never>
        >
        suffixSlug?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRing>>,
            Record<string, never>
        >
        translation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRing>>,
            CatalogueJewelleryRingTranslationArgs
        >
        updatedAt?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRing>>,
            Record<string, never>
        >
        variations?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRing>>,
            Record<string, never>
        >
        video?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRing>>,
            Record<string, never>
        >
    }
    CatalogueJewelleryRingTranslation?: {
        description?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRingTranslation>>,
            Record<string, never>
        >
        seoText?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRingTranslation>>,
            Record<string, never>
        >
    }
    CatalogueJewelleryRingsFilters?: {
        designFeatures?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRingsFilters>>,
            Record<string, never>
        >
        designStyles?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRingsFilters>>,
            Record<string, never>
        >
        gemstones?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRingsFilters>>,
            Record<string, never>
        >
        price?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRingsFilters>>,
            CatalogueJewelleryRingsFiltersPriceArgs
        >
        primaryMetals?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRingsFilters>>,
            Record<string, never>
        >
        productStyles?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueJewelleryRingsFilters>>,
            Record<string, never>
        >
    }
    CatalogueMelee?: {
        melee?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueMelee>>,
            Record<string, never>
        >
        quantity?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueMelee>>,
            Record<string, never>
        >
    }
    CataloguePriceRange?: {
        max?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CataloguePriceRange>>,
            Record<string, never>
        >
        min?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CataloguePriceRange>>,
            Record<string, never>
        >
    }
    CataloguePriceRangeBar?: {
        range?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CataloguePriceRangeBar>>,
            Record<string, never>
        >
        totalResults?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CataloguePriceRangeBar>>,
            Record<string, never>
        >
    }
    CataloguePriceRangeFilter?: {
        absoluteRange?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CataloguePriceRangeFilter>>,
            Record<string, never>
        >
        bars?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CataloguePriceRangeFilter>>,
            CataloguePriceRangeFilterBarsArgs
        >
        currentRange?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CataloguePriceRangeFilter>>,
            Record<string, never>
        >
    }
    CatalogueReadyToGoRing?: {
        carat?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueReadyToGoRing>>,
            Record<string, never>
        >
        catalogueCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueReadyToGoRing>>,
            Record<string, never>
        >
        customTitleTag?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueReadyToGoRing>>,
            Record<string, never>
        >
        deliveryDays?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueReadyToGoRing>>,
            CatalogueReadyToGoRingDeliveryDaysArgs
        >
        financeOptionsAffirm?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueReadyToGoRing>>,
            CatalogueReadyToGoRingFinanceOptionsAffirmArgs
        >
        financeOptionsKlarna?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueReadyToGoRing>>,
            CatalogueReadyToGoRingFinanceOptionsKlarnaArgs
        >
        firstAvailableDeliveryDate?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueReadyToGoRing>>,
            CatalogueReadyToGoRingFirstAvailableDeliveryDateArgs
        >
        gemType?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueReadyToGoRing>>,
            Record<string, never>
        >
        images?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueReadyToGoRing>>,
            CatalogueReadyToGoRingImagesArgs
        >
        isReadyToShip?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueReadyToGoRing>>,
            Record<string, never>
        >
        isReturnable?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueReadyToGoRing>>,
            Record<string, never>
        >
        mainImage?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueReadyToGoRing>>,
            Record<string, never>
        >
        primaryMetal?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueReadyToGoRing>>,
            Record<string, never>
        >
        productName?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueReadyToGoRing>>,
            Record<string, never>
        >
        relatedProducts?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueReadyToGoRing>>,
            Record<string, never>
        >
        reviews?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueReadyToGoRing>>,
            Record<string, never>
        >
        salePrice?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueReadyToGoRing>>,
            CatalogueReadyToGoRingSalePriceArgs
        >
        segmentName?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueReadyToGoRing>>,
            Record<string, never>
        >
        shortDescription?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueReadyToGoRing>>,
            Record<string, never>
        >
        shortName?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueReadyToGoRing>>,
            Record<string, never>
        >
        signatureStone?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueReadyToGoRing>>,
            Record<string, never>
        >
        sizes?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueReadyToGoRing>>,
            Record<string, never>
        >
        sku?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueReadyToGoRing>>,
            Record<string, never>
        >
        slug?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueReadyToGoRing>>,
            Record<string, never>
        >
        suffix?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueReadyToGoRing>>,
            Record<string, never>
        >
        suffixSlug?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueReadyToGoRing>>,
            Record<string, never>
        >
        translation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueReadyToGoRing>>,
            CatalogueReadyToGoRingTranslationArgs
        >
        updatedAt?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueReadyToGoRing>>,
            Record<string, never>
        >
        variations?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueReadyToGoRing>>,
            Record<string, never>
        >
    }
    CatalogueReadyToGoRingFilters?: {
        price?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueReadyToGoRingFilters>>,
            CatalogueReadyToGoRingFiltersPriceArgs
        >
        primaryMetals?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueReadyToGoRingFilters>>,
            Record<string, never>
        >
    }
    CatalogueReadyToGoRingTranslation?: {
        description?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueReadyToGoRingTranslation>>,
            Record<string, never>
        >
        seoText?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueReadyToGoRingTranslation>>,
            Record<string, never>
        >
    }
    CatalogueVideo?: {
        type?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueVideo>>,
            Record<string, never>
        >
        uri?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueVideo>>,
            Record<string, never>
        >
    }
    CatalogueWeddingRing?: {
        bandThickness?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRing>>,
            Record<string, never>
        >
        bandType?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRing>>,
            Record<string, never>
        >
        bandWidth?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRing>>,
            Record<string, never>
        >
        catalogueCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRing>>,
            Record<string, never>
        >
        categories?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRing>>,
            Record<string, never>
        >
        customTitleTag?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRing>>,
            Record<string, never>
        >
        deliveryDays?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRing>>,
            CatalogueWeddingRingDeliveryDaysArgs
        >
        financeOptionsAffirm?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRing>>,
            CatalogueWeddingRingFinanceOptionsAffirmArgs
        >
        financeOptionsKlarna?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRing>>,
            CatalogueWeddingRingFinanceOptionsKlarnaArgs
        >
        firstAvailableDeliveryDate?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRing>>,
            CatalogueWeddingRingFirstAvailableDeliveryDateArgs
        >
        images?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRing>>,
            CatalogueWeddingRingImagesArgs
        >
        images360?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRing>>,
            Record<string, never>
        >
        isResizeable?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRing>>,
            Record<string, never>
        >
        isReturnable?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRing>>,
            Record<string, never>
        >
        mainImage?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRing>>,
            Record<string, never>
        >
        meleeItems?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRing>>,
            Record<string, never>
        >
        primaryMetal?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRing>>,
            Record<string, never>
        >
        productName?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRing>>,
            Record<string, never>
        >
        relatedProducts?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRing>>,
            Record<string, never>
        >
        reviews?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRing>>,
            Record<string, never>
        >
        ringStyles?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRing>>,
            Record<string, never>
        >
        salePrice?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRing>>,
            CatalogueWeddingRingSalePriceArgs
        >
        segmentName?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRing>>,
            Record<string, never>
        >
        signatureStone?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRing>>,
            Record<string, never>
        >
        sizes?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRing>>,
            CatalogueWeddingRingSizesArgs
        >
        slug?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRing>>,
            Record<string, never>
        >
        suffix?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRing>>,
            Record<string, never>
        >
        suffixSlug?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRing>>,
            Record<string, never>
        >
        translation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRing>>,
            CatalogueWeddingRingTranslationArgs
        >
        updatedAt?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRing>>,
            Record<string, never>
        >
        variations?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRing>>,
            Record<string, never>
        >
        video?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRing>>,
            Record<string, never>
        >
    }
    CatalogueWeddingRingFilters?: {
        categories?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRingFilters>>,
            Record<string, never>
        >
        price?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRingFilters>>,
            CatalogueWeddingRingFiltersPriceArgs
        >
        primaryMetals?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRingFilters>>,
            Record<string, never>
        >
        ringStyles?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRingFilters>>,
            Record<string, never>
        >
    }
    CatalogueWeddingRingFiltersVariation?: {
        category?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRingFiltersVariation>>,
            Record<string, never>
        >
        primaryMetal?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRingFiltersVariation>>,
            Record<string, never>
        >
        ringStyle?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRingFiltersVariation>>,
            Record<string, never>
        >
    }
    CatalogueWeddingRingTranslation?: {
        description?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRingTranslation>>,
            Record<string, never>
        >
        locale?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRingTranslation>>,
            Record<string, never>
        >
        seoText?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CatalogueWeddingRingTranslation>>,
            Record<string, never>
        >
    }
    CheckoutcomOperationDeclinedError?: {
        message?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CheckoutcomOperationDeclinedError>>,
            Record<string, never>
        >
    }
    CheckoutcomPaymentMethod?: {
        debugMode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CheckoutcomPaymentMethod>>,
            Record<string, never>
        >
        publicKey?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CheckoutcomPaymentMethod>>,
            Record<string, never>
        >
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CheckoutcomPaymentMethod>>,
            Record<string, never>
        >
    }
    CheckoutcomTransaction?: {
        amount?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CheckoutcomTransaction>>,
            Record<string, never>
        >
        createdAt?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CheckoutcomTransaction>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CheckoutcomTransaction>>,
            Record<string, never>
        >
        status?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CheckoutcomTransaction>>,
            Record<string, never>
        >
    }
    CompleteCheckoutcomTransactionPost3dsFailureResponse?: {
        errors?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<CompleteCheckoutcomTransactionPost3dsFailureResponse>
            >,
            Record<string, never>
        >
    }
    CompleteCheckoutcomTransactionPost3dsSuccessResponse?: {
        order?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<CompleteCheckoutcomTransactionPost3dsSuccessResponse>
            >,
            Record<string, never>
        >
    }
    ComponentArticleGrid?: {
        articles?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentArticleGrid>>,
            ComponentArticleGridArticlesArgs
        >
    }
    ComponentArticlePreviews?: {
        articles?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentArticlePreviews>>,
            ComponentArticlePreviewsArticlesArgs
        >
    }
    ComponentBannerSkinny?: {
        backgroundColor?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentBannerSkinny>>,
            Record<string, never>
        >
        backgroundGraphic?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentBannerSkinny>>,
            Record<string, never>
        >
        backgroundImage?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentBannerSkinny>>,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentBannerSkinny>>,
            Record<string, never>
        >
        useBackgroundImage?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentBannerSkinny>>,
            Record<string, never>
        >
    }
    ComponentBannerTitle?: {
        date?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentBannerTitle>>,
            Record<string, never>
        >
        description?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentBannerTitle>>,
            Record<string, never>
        >
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentBannerTitle>>,
            Record<string, never>
        >
        tag?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentBannerTitle>>,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentBannerTitle>>,
            Record<string, never>
        >
    }
    ComponentButton?: {
        alignment?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentButton>>,
            Record<string, never>
        >
        eventTracking?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentButton>>,
            Record<string, never>
        >
        icon?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentButton>>,
            Record<string, never>
        >
        link?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentButton>>,
            Record<string, never>
        >
        style?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentButton>>,
            Record<string, never>
        >
        text?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentButton>>,
            Record<string, never>
        >
    }
    ComponentCard?: {
        backgroundColor?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentCard>>,
            Record<string, never>
        >
        content?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentCard>>,
            Record<string, never>
        >
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentCard>>,
            Record<string, never>
        >
    }
    ComponentCardCarousel?: {
        items?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentCardCarousel>>,
            Record<string, never>
        >
    }
    ComponentCatalogueProductCarousel?: {
        items?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentCatalogueProductCarousel>>,
            Record<string, never>
        >
    }
    ComponentCatalogueProductCarouselItem?: {
        catalogueCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentCatalogueProductCarouselItem>>,
            Record<string, never>
        >
        product?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentCatalogueProductCarouselItem>>,
            Record<string, never>
        >
    }
    ComponentContent?: {
        content?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentContent>>,
            Record<string, never>
        >
    }
    ComponentContentTwoColumns?: {
        leftColumnBackgroundColor?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentContentTwoColumns>>,
            Record<string, never>
        >
        leftColumnContent?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentContentTwoColumns>>,
            Record<string, never>
        >
        rightColumnBackgroundColor?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentContentTwoColumns>>,
            Record<string, never>
        >
        rightColumnContent?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentContentTwoColumns>>,
            Record<string, never>
        >
    }
    ComponentContentWithGallery?: {
        content?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentContentWithGallery>>,
            Record<string, never>
        >
        gallery?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentContentWithGallery>>,
            Record<string, never>
        >
    }
    ComponentCustomProductCarousel?: {
        products?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentCustomProductCarousel>>,
            Record<string, never>
        >
    }
    ComponentFaq?: {
        sections?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentFaq>>,
            Record<string, never>
        >
        showNavigation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentFaq>>,
            Record<string, never>
        >
    }
    ComponentFullWidthImage?: {
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentFullWidthImage>>,
            Record<string, never>
        >
        link?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentFullWidthImage>>,
            Record<string, never>
        >
        width?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentFullWidthImage>>,
            Record<string, never>
        >
    }
    ComponentGalleryCarousel?: {
        items?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentGalleryCarousel>>,
            Record<string, never>
        >
    }
    ComponentGalleryWithEnquiry?: {
        items?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentGalleryWithEnquiry>>,
            Record<string, never>
        >
        type?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentGalleryWithEnquiry>>,
            Record<string, never>
        >
    }
    ComponentGlobalComponent?: {
        backgroundColor?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentGlobalComponent>>,
            Record<string, never>
        >
        components?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentGlobalComponent>>,
            Record<string, never>
        >
    }
    ComponentGlobalSpacer?: {
        spacing?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentGlobalSpacer>>,
            Record<string, never>
        >
    }
    ComponentIconCarousel?: {
        items?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentIconCarousel>>,
            Record<string, never>
        >
    }
    ComponentImage?: {
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentImage>>,
            Record<string, never>
        >
    }
    ComponentInstagramPosts?: {
        instagramUser?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentInstagramPosts>>,
            Record<string, never>
        >
        instagramUserLink?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentInstagramPosts>>,
            Record<string, never>
        >
        posts?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentInstagramPosts>>,
            Record<string, never>
        >
        preTitle?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentInstagramPosts>>,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentInstagramPosts>>,
            Record<string, never>
        >
    }
    ComponentInstagramWithContent?: {
        content?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentInstagramWithContent>>,
            Record<string, never>
        >
        instagramEmbedCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentInstagramWithContent>>,
            Record<string, never>
        >
        instagramImage?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentInstagramWithContent>>,
            Record<string, never>
        >
        instagramLink?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentInstagramWithContent>>,
            Record<string, never>
        >
        instagramPosition?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentInstagramWithContent>>,
            Record<string, never>
        >
        instagramUsername?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentInstagramWithContent>>,
            Record<string, never>
        >
        useImage?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentInstagramWithContent>>,
            Record<string, never>
        >
        width?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentInstagramWithContent>>,
            Record<string, never>
        >
    }
    ComponentLogos?: {
        logos?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentLogos>>,
            Record<string, never>
        >
    }
    ComponentLogosCarousel?: {
        logos?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentLogosCarousel>>,
            Record<string, never>
        >
    }
    ComponentMainCover?: {
        backgroundImage?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentMainCover>>,
            Record<string, never>
        >
        content?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentMainCover>>,
            Record<string, never>
        >
        mobileBackgroundImage?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentMainCover>>,
            Record<string, never>
        >
    }
    ComponentOnThisPage?: {
        null?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentOnThisPage>>,
            Record<string, never>
        >
    }
    ComponentOrderedList?: {
        items?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentOrderedList>>,
            Record<string, never>
        >
    }
    ComponentQuote?: {
        author?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentQuote>>,
            Record<string, never>
        >
        hasBackgroundImage?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentQuote>>,
            Record<string, never>
        >
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentQuote>>,
            Record<string, never>
        >
        quote?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentQuote>>,
            Record<string, never>
        >
        showQuotationMarks?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentQuote>>,
            Record<string, never>
        >
        size?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentQuote>>,
            Record<string, never>
        >
    }
    ComponentRelatedProducts?: {
        null?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentRelatedProducts>>,
            Record<string, never>
        >
    }
    ComponentReviewCarousel?: {
        reviews?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentReviewCarousel>>,
            Record<string, never>
        >
    }
    ComponentRoundedImage?: {
        backgroundColor?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentRoundedImage>>,
            Record<string, never>
        >
        backgroundImage?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentRoundedImage>>,
            Record<string, never>
        >
        backgroundImageColor?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentRoundedImage>>,
            Record<string, never>
        >
        roundedImage?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentRoundedImage>>,
            Record<string, never>
        >
    }
    ComponentRoundedImageContent?: {
        content?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentRoundedImageContent>>,
            Record<string, never>
        >
        roundedImage?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentRoundedImageContent>>,
            Record<string, never>
        >
    }
    ComponentShopWithConfidence?: {
        components?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentShopWithConfidence>>,
            Record<string, never>
        >
        ethnicallySourcedDiamonds?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentShopWithConfidence>>,
            Record<string, never>
        >
        financingOptions?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentShopWithConfidence>>,
            Record<string, never>
        >
        greenlandRuby?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentShopWithConfidence>>,
            Record<string, never>
        >
        handFinished?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentShopWithConfidence>>,
            Record<string, never>
        >
        resize?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentShopWithConfidence>>,
            Record<string, never>
        >
        returnPolicy?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentShopWithConfidence>>,
            Record<string, never>
        >
        shipping?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentShopWithConfidence>>,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentShopWithConfidence>>,
            Record<string, never>
        >
    }
    ComponentSideBySideImage?: {
        caption?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentSideBySideImage>>,
            Record<string, never>
        >
        content?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentSideBySideImage>>,
            Record<string, never>
        >
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentSideBySideImage>>,
            Record<string, never>
        >
        link?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentSideBySideImage>>,
            Record<string, never>
        >
    }
    ComponentSideBySideImages?: {
        images?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentSideBySideImages>>,
            Record<string, never>
        >
    }
    ComponentSpacer?: {
        spacing?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentSpacer>>,
            Record<string, never>
        >
    }
    ComponentSquareBoxes?: {
        items?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentSquareBoxes>>,
            Record<string, never>
        >
    }
    ComponentTable?: {
        table?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentTable>>,
            Record<string, never>
        >
    }
    ComponentText?: {
        alignment?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentText>>,
            Record<string, never>
        >
        text?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentText>>,
            Record<string, never>
        >
        textSize?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentText>>,
            Record<string, never>
        >
    }
    ComponentTextCarousel?: {
        items?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentTextCarousel>>,
            Record<string, never>
        >
    }
    ComponentTextOverImage?: {
        content?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentTextOverImage>>,
            Record<string, never>
        >
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentTextOverImage>>,
            Record<string, never>
        >
    }
    ComponentTextWithImage?: {
        content?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentTextWithImage>>,
            Record<string, never>
        >
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentTextWithImage>>,
            Record<string, never>
        >
        imageFormat?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentTextWithImage>>,
            Record<string, never>
        >
        imagePosition?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentTextWithImage>>,
            Record<string, never>
        >
        padding?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentTextWithImage>>,
            Record<string, never>
        >
    }
    ComponentTextWithImageCarousel?: {
        slidePadding?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentTextWithImageCarousel>>,
            Record<string, never>
        >
        slides?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentTextWithImageCarousel>>,
            Record<string, never>
        >
    }
    ComponentTitle?: {
        alignment?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentTitle>>,
            Record<string, never>
        >
        color?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentTitle>>,
            Record<string, never>
        >
        tag?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentTitle>>,
            Record<string, never>
        >
        text?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentTitle>>,
            Record<string, never>
        >
        texts?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentTitle>>,
            Record<string, never>
        >
        titleSize?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentTitle>>,
            Record<string, never>
        >
        titleStyle?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentTitle>>,
            Record<string, never>
        >
        titleWidth?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentTitle>>,
            Record<string, never>
        >
    }
    ComponentTitleAmpersand?: {
        null?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentTitleAmpersand>>,
            Record<string, never>
        >
    }
    ComponentTitleText?: {
        text?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentTitleText>>,
            Record<string, never>
        >
    }
    ComponentVideo?: {
        video?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentVideo>>,
            Record<string, never>
        >
        width?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentVideo>>,
            Record<string, never>
        >
    }
    ComponentVideoWithContent?: {
        content?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentVideoWithContent>>,
            Record<string, never>
        >
        coverImage?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentVideoWithContent>>,
            Record<string, never>
        >
        video?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentVideoWithContent>>,
            Record<string, never>
        >
        videoPosition?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ComponentVideoWithContent>>,
            Record<string, never>
        >
    }
    Consultant?: {
        avatar?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Consultant>>,
            Record<string, never>
        >
        avatarImage?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Consultant>>,
            Record<string, never>
        >
        canTakeConsultations?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Consultant>>,
            Record<string, never>
        >
        firstName?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Consultant>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Consultant>>,
            Record<string, never>
        >
        showroom?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Consultant>>,
            Record<string, never>
        >
        user?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Consultant>>,
            Record<string, never>
        >
    }
    CreateCheckoutcomTransactionFailureResponse?: {
        errors?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CreateCheckoutcomTransactionFailureResponse>>,
            Record<string, never>
        >
    }
    CreateCheckoutcomTransactionSuccessResponse?: {
        transaction?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CreateCheckoutcomTransactionSuccessResponse>>,
            Record<string, never>
        >
    }
    Customer?: {
        adminProfileUrl?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Customer>>,
            Record<string, never>
        >
        billingAddress?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Customer>>,
            Record<string, never>
        >
        cart?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Customer>>,
            Record<string, never>
        >
        consultant?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Customer>>,
            Record<string, never>
        >
        designInspiration?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Customer>>,
            Record<string, never>
        >
        designStudioProduct?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Customer>>,
            CustomerDesignStudioProductArgs
        >
        designStudioProducts?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Customer>>,
            Record<string, never>
        >
        disabledThirdPartyCookies?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Customer>>,
            Record<string, never>
        >
        engagementRingRecommendations?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Customer>>,
            Record<string, never>
        >
        enquiries?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Customer>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Customer>>,
            Record<string, never>
        >
        order?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Customer>>,
            CustomerOrderArgs
        >
        orders?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Customer>>,
            Record<string, never>
        >
        ordersByConsultationPurpose?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Customer>>,
            CustomerOrdersByConsultationPurposeArgs
        >
        questionnaireByType?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Customer>>,
            CustomerQuestionnaireByTypeArgs
        >
        salesforceProfileUrl?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Customer>>,
            Record<string, never>
        >
        shippingAddress?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Customer>>,
            Record<string, never>
        >
        user?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Customer>>,
            Record<string, never>
        >
    }
    CustomerRegistrationResponse?: {
        login?: GraphCacheUpdateResolver<
            Maybe<WithTypename<CustomerRegistrationResponse>>,
            Record<string, never>
        >
    }
    DeliveryDate?: {
        date?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DeliveryDate>>,
            Record<string, never>
        >
        validUntil?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DeliveryDate>>,
            Record<string, never>
        >
    }
    DesignInspiration?: {
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignInspiration>>,
            Record<string, never>
        >
        url?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignInspiration>>,
            Record<string, never>
        >
    }
    DesignStudioEngagementRingCentreStone?: {
        approved?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioEngagementRingCentreStone>>,
            Record<string, never>
        >
        comment?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioEngagementRingCentreStone>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioEngagementRingCentreStone>>,
            Record<string, never>
        >
        manualSurcharges?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioEngagementRingCentreStone>>,
            Record<string, never>
        >
        percentageSurcharge?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioEngagementRingCentreStone>>,
            Record<string, never>
        >
        salePrice?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioEngagementRingCentreStone>>,
            Record<string, never>
        >
        stone?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioEngagementRingCentreStone>>,
            Record<string, never>
        >
    }
    DesignStudioEngagementRingErrorGeneric?: {
        message?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioEngagementRingErrorGeneric>>,
            DesignStudioEngagementRingErrorGenericMessageArgs
        >
    }
    DesignStudioEngagementRingErrorMaxCaratWeight?: {
        message?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioEngagementRingErrorMaxCaratWeight>>,
            DesignStudioEngagementRingErrorMaxCaratWeightMessageArgs
        >
    }
    DesignStudioEngagementRingErrorMinCaratWeight?: {
        message?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioEngagementRingErrorMinCaratWeight>>,
            DesignStudioEngagementRingErrorMinCaratWeightMessageArgs
        >
    }
    DesignStudioEngagementRingErrorShapeMismatch?: {
        matchingVariation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioEngagementRingErrorShapeMismatch>>,
            Record<string, never>
        >
        message?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioEngagementRingErrorShapeMismatch>>,
            DesignStudioEngagementRingErrorShapeMismatchMessageArgs
        >
    }
    DesignStudioEngagementRingFailure?: {
        errors?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioEngagementRingFailure>>,
            Record<string, never>
        >
    }
    DesignStudioEngagementRingMount?: {
        approved?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioEngagementRingMount>>,
            Record<string, never>
        >
        comment?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioEngagementRingMount>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioEngagementRingMount>>,
            Record<string, never>
        >
        manualSurcharges?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioEngagementRingMount>>,
            Record<string, never>
        >
        melees?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioEngagementRingMount>>,
            Record<string, never>
        >
        metals?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioEngagementRingMount>>,
            Record<string, never>
        >
        percentageSurcharge?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioEngagementRingMount>>,
            Record<string, never>
        >
        salePrice?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioEngagementRingMount>>,
            Record<string, never>
        >
        sideStones?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioEngagementRingMount>>,
            Record<string, never>
        >
        signatureStones?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioEngagementRingMount>>,
            Record<string, never>
        >
    }
    DesignStudioExternalCentreStone?: {
        crystal?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioExternalCentreStone>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioExternalCentreStone>>,
            Record<string, never>
        >
        weight?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioExternalCentreStone>>,
            Record<string, never>
        >
    }
    DesignStudioExternalSideStone?: {
        crystal?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioExternalSideStone>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioExternalSideStone>>,
            Record<string, never>
        >
        weight?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioExternalSideStone>>,
            Record<string, never>
        >
    }
    DesignStudioInternalCentreStone?: {
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioInternalCentreStone>>,
            Record<string, never>
        >
        nonSku?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioInternalCentreStone>>,
            Record<string, never>
        >
        sku?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioInternalCentreStone>>,
            Record<string, never>
        >
    }
    DesignStudioInternalSideStone?: {
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioInternalSideStone>>,
            Record<string, never>
        >
        item?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioInternalSideStone>>,
            Record<string, never>
        >
        quantity?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioInternalSideStone>>,
            Record<string, never>
        >
    }
    DesignStudioMeleeItem?: {
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioMeleeItem>>,
            Record<string, never>
        >
        melee?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioMeleeItem>>,
            Record<string, never>
        >
        quantity?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioMeleeItem>>,
            Record<string, never>
        >
    }
    DesignStudioProductAdditionalResize?: {
        cantBeResized?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductAdditionalResize>>,
            Record<string, never>
        >
        cantBeReturned?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductAdditionalResize>>,
            Record<string, never>
        >
        finalQuotation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductAdditionalResize>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductAdditionalResize>>,
            Record<string, never>
        >
        isAutofinalizable?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductAdditionalResize>>,
            Record<string, never>
        >
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductAdditionalResize>>,
            Record<string, never>
        >
        orderProduct?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductAdditionalResize>>,
            Record<string, never>
        >
        quotations?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductAdditionalResize>>,
            Record<string, never>
        >
    }
    DesignStudioProductCustom?: {
        cantBeResized?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductCustom>>,
            Record<string, never>
        >
        cantBeReturned?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductCustom>>,
            Record<string, never>
        >
        finalQuotation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductCustom>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductCustom>>,
            Record<string, never>
        >
        isAutofinalizable?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductCustom>>,
            Record<string, never>
        >
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductCustom>>,
            Record<string, never>
        >
        orderProduct?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductCustom>>,
            Record<string, never>
        >
        quotations?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductCustom>>,
            Record<string, never>
        >
    }
    DesignStudioProductEngagementRing?: {
        availableSizes?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductEngagementRing>>,
            Record<string, never>
        >
        cantBeResized?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductEngagementRing>>,
            Record<string, never>
        >
        cantBeReturned?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductEngagementRing>>,
            Record<string, never>
        >
        engraving?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductEngagementRing>>,
            Record<string, never>
        >
        finalQuotation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductEngagementRing>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductEngagementRing>>,
            Record<string, never>
        >
        isAutofinalizable?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductEngagementRing>>,
            Record<string, never>
        >
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductEngagementRing>>,
            Record<string, never>
        >
        orderProduct?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductEngagementRing>>,
            Record<string, never>
        >
        quotations?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductEngagementRing>>,
            Record<string, never>
        >
        size?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductEngagementRing>>,
            Record<string, never>
        >
    }
    DesignStudioProductGeneric?: {
        cantBeResized?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductGeneric>>,
            Record<string, never>
        >
        cantBeReturned?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductGeneric>>,
            Record<string, never>
        >
        customer?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductGeneric>>,
            Record<string, never>
        >
        finalQuotation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductGeneric>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductGeneric>>,
            Record<string, never>
        >
        isAutofinalizable?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductGeneric>>,
            Record<string, never>
        >
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductGeneric>>,
            Record<string, never>
        >
        orderProduct?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductGeneric>>,
            Record<string, never>
        >
        quotations?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductGeneric>>,
            Record<string, never>
        >
    }
    DesignStudioProductLooseStone?: {
        cantBeResized?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductLooseStone>>,
            Record<string, never>
        >
        cantBeReturned?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductLooseStone>>,
            Record<string, never>
        >
        finalQuotation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductLooseStone>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductLooseStone>>,
            Record<string, never>
        >
        isAutofinalizable?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductLooseStone>>,
            Record<string, never>
        >
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductLooseStone>>,
            Record<string, never>
        >
        orderProduct?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductLooseStone>>,
            Record<string, never>
        >
        quotations?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductLooseStone>>,
            Record<string, never>
        >
    }
    DesignStudioProductWeddingRing?: {
        availableSizes?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductWeddingRing>>,
            Record<string, never>
        >
        cantBeResized?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductWeddingRing>>,
            Record<string, never>
        >
        cantBeReturned?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductWeddingRing>>,
            Record<string, never>
        >
        engraving?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductWeddingRing>>,
            Record<string, never>
        >
        finalQuotation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductWeddingRing>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductWeddingRing>>,
            Record<string, never>
        >
        isAutofinalizable?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductWeddingRing>>,
            Record<string, never>
        >
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductWeddingRing>>,
            Record<string, never>
        >
        orderProduct?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductWeddingRing>>,
            Record<string, never>
        >
        quotations?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductWeddingRing>>,
            Record<string, never>
        >
        size?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioProductWeddingRing>>,
            Record<string, never>
        >
    }
    DesignStudioSignatureStone?: {
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioSignatureStone>>,
            Record<string, never>
        >
        melee?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesignStudioSignatureStone>>,
            Record<string, never>
        >
    }
    DesiredDeliveryDateInvalidError?: {
        message?: GraphCacheUpdateResolver<
            Maybe<WithTypename<DesiredDeliveryDateInvalidError>>,
            Record<string, never>
        >
    }
    EngagementRingDesignFeatureLabel?: {
        icon?: GraphCacheUpdateResolver<
            Maybe<WithTypename<EngagementRingDesignFeatureLabel>>,
            Record<string, never>
        >
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<EngagementRingDesignFeatureLabel>>,
            Record<string, never>
        >
        translation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<EngagementRingDesignFeatureLabel>>,
            EngagementRingDesignFeatureLabelTranslationArgs
        >
    }
    EngagementRingDesignStyleLabel?: {
        icon?: GraphCacheUpdateResolver<
            Maybe<WithTypename<EngagementRingDesignStyleLabel>>,
            Record<string, never>
        >
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<EngagementRingDesignStyleLabel>>,
            Record<string, never>
        >
        translation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<EngagementRingDesignStyleLabel>>,
            EngagementRingDesignStyleLabelTranslationArgs
        >
    }
    EngagementRingStoneRecommendationCard?: {
        description?: GraphCacheUpdateResolver<
            Maybe<WithTypename<EngagementRingStoneRecommendationCard>>,
            Record<string, never>
        >
        notFoundContent?: GraphCacheUpdateResolver<
            Maybe<WithTypename<EngagementRingStoneRecommendationCard>>,
            Record<string, never>
        >
        notSupportedContent?: GraphCacheUpdateResolver<
            Maybe<WithTypename<EngagementRingStoneRecommendationCard>>,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<EngagementRingStoneRecommendationCard>>,
            Record<string, never>
        >
    }
    EngagementRingStoneRecommendationNaturalDiamonds?: {
        forBalanceCard?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<EngagementRingStoneRecommendationNaturalDiamonds>
            >,
            Record<string, never>
        >
        forSizeCard?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<EngagementRingStoneRecommendationNaturalDiamonds>
            >,
            Record<string, never>
        >
        labGrownAlternative?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<EngagementRingStoneRecommendationNaturalDiamonds>
            >,
            Record<string, never>
        >
    }
    EngagementRingStoneRecommendationNonSkuGemStoneCard?: {
        color?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<EngagementRingStoneRecommendationNonSkuGemStoneCard>
            >,
            Record<string, never>
        >
        content?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<EngagementRingStoneRecommendationNonSkuGemStoneCard>
            >,
            Record<string, never>
        >
    }
    EngagementRingStoneRecommendationNonSkuLabGrown?: {
        forPriceCard?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<EngagementRingStoneRecommendationNonSkuLabGrown>
            >,
            Record<string, never>
        >
        forSizeCard?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<EngagementRingStoneRecommendationNonSkuLabGrown>
            >,
            Record<string, never>
        >
        naturalDiamondAlternative?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<EngagementRingStoneRecommendationNonSkuLabGrown>
            >,
            Record<string, never>
        >
    }
    EngagementRingStoneRecommendations?: {
        blocks?: GraphCacheUpdateResolver<
            Maybe<WithTypename<EngagementRingStoneRecommendations>>,
            Record<string, never>
        >
        fullSearchButtonText?: GraphCacheUpdateResolver<
            Maybe<WithTypename<EngagementRingStoneRecommendations>>,
            Record<string, never>
        >
        introductionText?: GraphCacheUpdateResolver<
            Maybe<WithTypename<EngagementRingStoneRecommendations>>,
            Record<string, never>
        >
        naturalDiamonds?: GraphCacheUpdateResolver<
            Maybe<WithTypename<EngagementRingStoneRecommendations>>,
            Record<string, never>
        >
        nonSkuGemStones?: GraphCacheUpdateResolver<
            Maybe<WithTypename<EngagementRingStoneRecommendations>>,
            EngagementRingStoneRecommendationsNonSkuGemStonesArgs
        >
        nonSkuLabGrown?: GraphCacheUpdateResolver<
            Maybe<WithTypename<EngagementRingStoneRecommendations>>,
            Record<string, never>
        >
    }
    EngagementRingStyleLabel?: {
        icon?: GraphCacheUpdateResolver<
            Maybe<WithTypename<EngagementRingStyleLabel>>,
            Record<string, never>
        >
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<EngagementRingStyleLabel>>,
            Record<string, never>
        >
        translation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<EngagementRingStyleLabel>>,
            EngagementRingStyleLabelTranslationArgs
        >
    }
    EnquiryConsultation?: {
        consultation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<EnquiryConsultation>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<EnquiryConsultation>>,
            Record<string, never>
        >
    }
    EnquiryEngagementRingAddToCart?: {
        product?: GraphCacheUpdateResolver<
            Maybe<WithTypename<EnquiryEngagementRingAddToCart>>,
            Record<string, never>
        >
    }
    EnquiryResponseExistingCustomer?: {
        marketingCloudForm?: GraphCacheUpdateResolver<
            Maybe<WithTypename<EnquiryResponseExistingCustomer>>,
            Record<string, never>
        >
    }
    EnquiryResponseNewCustomer?: {
        customer?: GraphCacheUpdateResolver<
            Maybe<WithTypename<EnquiryResponseNewCustomer>>,
            Record<string, never>
        >
        marketingCloudForm?: GraphCacheUpdateResolver<
            Maybe<WithTypename<EnquiryResponseNewCustomer>>,
            Record<string, never>
        >
    }
    EnquiryWeddingRingAddToCart?: {
        product?: GraphCacheUpdateResolver<
            Maybe<WithTypename<EnquiryWeddingRingAddToCart>>,
            Record<string, never>
        >
    }
    FaqQuestion?: {
        content?: GraphCacheUpdateResolver<
            Maybe<WithTypename<FaqQuestion>>,
            Record<string, never>
        >
        expandedByDefault?: GraphCacheUpdateResolver<
            Maybe<WithTypename<FaqQuestion>>,
            Record<string, never>
        >
        question?: GraphCacheUpdateResolver<
            Maybe<WithTypename<FaqQuestion>>,
            Record<string, never>
        >
    }
    FaqSection?: {
        questions?: GraphCacheUpdateResolver<
            Maybe<WithTypename<FaqSection>>,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<FaqSection>>,
            Record<string, never>
        >
    }
    Footer?: {
        columns?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Footer>>,
            Record<string, never>
        >
        copyright?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Footer>>,
            Record<string, never>
        >
        logos?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Footer>>,
            Record<string, never>
        >
    }
    FooterColumn?: {
        items?: GraphCacheUpdateResolver<
            Maybe<WithTypename<FooterColumn>>,
            Record<string, never>
        >
    }
    FooterColumnItemLink?: {
        link?: GraphCacheUpdateResolver<
            Maybe<WithTypename<FooterColumnItemLink>>,
            Record<string, never>
        >
        text?: GraphCacheUpdateResolver<
            Maybe<WithTypename<FooterColumnItemLink>>,
            Record<string, never>
        >
    }
    FooterColumnItemLinkList?: {
        links?: GraphCacheUpdateResolver<
            Maybe<WithTypename<FooterColumnItemLinkList>>,
            Record<string, never>
        >
    }
    FooterColumnItemSeparator?: {
        line?: GraphCacheUpdateResolver<
            Maybe<WithTypename<FooterColumnItemSeparator>>,
            Record<string, never>
        >
    }
    FooterColumnItemText?: {
        text?: GraphCacheUpdateResolver<
            Maybe<WithTypename<FooterColumnItemText>>,
            Record<string, never>
        >
    }
    FooterColumnItemTitle?: {
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<FooterColumnItemTitle>>,
            Record<string, never>
        >
    }
    FooterColumnItemWorkingHours?: {
        workingHours?: GraphCacheUpdateResolver<
            Maybe<WithTypename<FooterColumnItemWorkingHours>>,
            FooterColumnItemWorkingHoursWorkingHoursArgs
        >
    }
    FooterLogo?: {
        link?: GraphCacheUpdateResolver<
            Maybe<WithTypename<FooterLogo>>,
            Record<string, never>
        >
        logo?: GraphCacheUpdateResolver<
            Maybe<WithTypename<FooterLogo>>,
            Record<string, never>
        >
    }
    GalleryCarouselCard?: {
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GalleryCarouselCard>>,
            Record<string, never>
        >
        link?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GalleryCarouselCard>>,
            Record<string, never>
        >
    }
    GalleryItem?: {
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GalleryItem>>,
            Record<string, never>
        >
    }
    GalleryWithEnquiryCard?: {
        caption?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GalleryWithEnquiryCard>>,
            Record<string, never>
        >
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GalleryWithEnquiryCard>>,
            Record<string, never>
        >
        slug?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GalleryWithEnquiryCard>>,
            Record<string, never>
        >
    }
    GemsApiPriceBounds?: {
        max?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApiPriceBounds>>,
            Record<string, never>
        >
        min?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApiPriceBounds>>,
            Record<string, never>
        >
    }
    GemsApiStone?: {
        identifier?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApiStone>>,
            Record<string, never>
        >
        stone?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApiStone>>,
            Record<string, never>
        >
    }
    GemsApi_Bounds?: {
        categories?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Bounds>>,
            Record<string, never>
        >
        category?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Bounds>>,
            Record<string, never>
        >
        clarities?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Bounds>>,
            Record<string, never>
        >
        clarity?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Bounds>>,
            Record<string, never>
        >
        colors?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Bounds>>,
            Record<string, never>
        >
        colour?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Bounds>>,
            Record<string, never>
        >
        crystal?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Bounds>>,
            Record<string, never>
        >
        crystals?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Bounds>>,
            Record<string, never>
        >
        cut?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Bounds>>,
            Record<string, never>
        >
        cuts?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Bounds>>,
            Record<string, never>
        >
        deliveryDays?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Bounds>>,
            Record<string, never>
        >
        depth?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Bounds>>,
            Record<string, never>
        >
        depthPercent?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Bounds>>,
            Record<string, never>
        >
        fluorescence?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Bounds>>,
            Record<string, never>
        >
        fluorescences?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Bounds>>,
            Record<string, never>
        >
        grade?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Bounds>>,
            Record<string, never>
        >
        grades?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Bounds>>,
            Record<string, never>
        >
        length?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Bounds>>,
            Record<string, never>
        >
        originCountry?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Bounds>>,
            Record<string, never>
        >
        polish?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Bounds>>,
            Record<string, never>
        >
        polishes?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Bounds>>,
            Record<string, never>
        >
        price?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Bounds>>,
            Record<string, never>
        >
        priceByShape?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Bounds>>,
            Record<string, never>
        >
        ratio?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Bounds>>,
            Record<string, never>
        >
        shape?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Bounds>>,
            Record<string, never>
        >
        shapes?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Bounds>>,
            Record<string, never>
        >
        shippingFromCountry?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Bounds>>,
            Record<string, never>
        >
        symmetries?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Bounds>>,
            Record<string, never>
        >
        symmetry?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Bounds>>,
            Record<string, never>
        >
        tablePercent?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Bounds>>,
            Record<string, never>
        >
        weight?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Bounds>>,
            Record<string, never>
        >
        width?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Bounds>>,
            Record<string, never>
        >
    }
    GemsApi_IntRange?: {
        max?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_IntRange>>,
            Record<string, never>
        >
        min?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_IntRange>>,
            Record<string, never>
        >
    }
    GemsApi_Pagination?: {
        limit?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Pagination>>,
            Record<string, never>
        >
        page?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Pagination>>,
            Record<string, never>
        >
        pages?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Pagination>>,
            Record<string, never>
        >
        total?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Pagination>>,
            Record<string, never>
        >
    }
    GemsApi_PricePoint?: {
        market?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_PricePoint>>,
            Record<string, never>
        >
        price?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_PricePoint>>,
            Record<string, never>
        >
    }
    GemsApi_PriceRange?: {
        max?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_PriceRange>>,
            Record<string, never>
        >
        maxInCurrency?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_PriceRange>>,
            GemsApi_PriceRangeMaxInCurrencyArgs
        >
        min?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_PriceRange>>,
            Record<string, never>
        >
        minInCurrency?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_PriceRange>>,
            GemsApi_PriceRangeMinInCurrencyArgs
        >
    }
    GemsApi_PriceRangeByShape?: {
        range?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_PriceRangeByShape>>,
            Record<string, never>
        >
        shape?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_PriceRangeByShape>>,
            Record<string, never>
        >
    }
    GemsApi_Range?: {
        max?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Range>>,
            Record<string, never>
        >
        min?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Range>>,
            Record<string, never>
        >
    }
    GemsApi_SelectedRange?: {
        max?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedRange>>,
            Record<string, never>
        >
        min?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedRange>>,
            Record<string, never>
        >
    }
    GemsApi_SelectedSorting?: {
        direction?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedSorting>>,
            Record<string, never>
        >
        field?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedSorting>>,
            Record<string, never>
        >
    }
    GemsApi_SelectedStoneFilters?: {
        category?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedStoneFilters>>,
            Record<string, never>
        >
        clarity?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedStoneFilters>>,
            Record<string, never>
        >
        collection?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedStoneFilters>>,
            Record<string, never>
        >
        colour?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedStoneFilters>>,
            Record<string, never>
        >
        costPrice?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedStoneFilters>>,
            Record<string, never>
        >
        crystal?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedStoneFilters>>,
            Record<string, never>
        >
        cut?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedStoneFilters>>,
            Record<string, never>
        >
        depth?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedStoneFilters>>,
            Record<string, never>
        >
        depthPercent?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedStoneFilters>>,
            Record<string, never>
        >
        fluorescence?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedStoneFilters>>,
            Record<string, never>
        >
        grade?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedStoneFilters>>,
            Record<string, never>
        >
        hasPhoto?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedStoneFilters>>,
            Record<string, never>
        >
        isCanadaMark?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedStoneFilters>>,
            Record<string, never>
        >
        isDtlReport?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedStoneFilters>>,
            Record<string, never>
        >
        isRtg?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedStoneFilters>>,
            Record<string, never>
        >
        isScsReport?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedStoneFilters>>,
            Record<string, never>
        >
        isStock?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedStoneFilters>>,
            Record<string, never>
        >
        lab?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedStoneFilters>>,
            Record<string, never>
        >
        length?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedStoneFilters>>,
            Record<string, never>
        >
        notClarity?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedStoneFilters>>,
            Record<string, never>
        >
        notColour?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedStoneFilters>>,
            Record<string, never>
        >
        notSymmetry?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedStoneFilters>>,
            Record<string, never>
        >
        originCountry?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedStoneFilters>>,
            Record<string, never>
        >
        polish?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedStoneFilters>>,
            Record<string, never>
        >
        price?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedStoneFilters>>,
            Record<string, never>
        >
        priceIndex?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedStoneFilters>>,
            Record<string, never>
        >
        ratio?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedStoneFilters>>,
            Record<string, never>
        >
        shape?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedStoneFilters>>,
            Record<string, never>
        >
        shippingFrom?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedStoneFilters>>,
            Record<string, never>
        >
        sorting?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedStoneFilters>>,
            Record<string, never>
        >
        symmetry?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedStoneFilters>>,
            Record<string, never>
        >
        tablePercent?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedStoneFilters>>,
            Record<string, never>
        >
        weight?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedStoneFilters>>,
            Record<string, never>
        >
        width?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedStoneFilters>>,
            Record<string, never>
        >
        withOriginCountry?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedStoneFilters>>,
            Record<string, never>
        >
        withVideo?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_SelectedStoneFilters>>,
            Record<string, never>
        >
    }
    GemsApi_Stone?: {
        blackInclusion?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        category?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        categoryWithInfo?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        certificates?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        clarity?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        clarityWithInfo?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        colorWithInfo?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        colour?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        colourShade?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        containsEngagementRings?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        crownAngle?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        crownHeight?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        crystal?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        crystalWithInfo?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        culet?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        cut?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        cutWithInfo?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        deliveryDays?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        depth?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        depthPercent?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        dtlReport?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        externalId?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        eyeClean?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        feedIdentifier?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        fluorescence?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        fluorescenceColour?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        fluorescenceWithInfo?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        girdleMax?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        girdleMin?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        grade?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        gradeWithInfo?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        growthMethod?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        hasPublicImages?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        identifier?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        images?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        isB2B?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        isCanadaMark?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        isCertificateVerified?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        isHideCertificateNumber?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        isHideMeasurements?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        isMilky?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        isTreated?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        isValidB2C?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        length?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        originCountry?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        pavilionAngle?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        pavilionDepth?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        polish?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        polishWithInfo?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        pricingNoVat?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        ratio?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        salePrice?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            GemsApi_StoneSalePriceArgs
        >
        scsReport?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        shape?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        shapeWithInfo?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        shippingFromCountry?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        symmetry?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        symmetryWithInfo?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        tablePercent?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        v360Url?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        weight?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
        width?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_Stone>>,
            Record<string, never>
        >
    }
    GemsApi_StoneCategoryInfo?: {
        code?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_StoneCategoryInfo>>,
            Record<string, never>
        >
        info?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_StoneCategoryInfo>>,
            Record<string, never>
        >
    }
    GemsApi_StoneCertificates?: {
        gcal?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_StoneCertificates>>,
            Record<string, never>
        >
        gia?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_StoneCertificates>>,
            Record<string, never>
        >
        igi?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_StoneCertificates>>,
            Record<string, never>
        >
    }
    GemsApi_StoneClarityInfo?: {
        code?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_StoneClarityInfo>>,
            Record<string, never>
        >
        info?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_StoneClarityInfo>>,
            Record<string, never>
        >
    }
    GemsApi_StoneCollection?: {
        collection?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_StoneCollection>>,
            Record<string, never>
        >
        filters?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_StoneCollection>>,
            Record<string, never>
        >
        pagination?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_StoneCollection>>,
            Record<string, never>
        >
    }
    GemsApi_StoneColorInfo?: {
        code?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_StoneColorInfo>>,
            Record<string, never>
        >
        info?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_StoneColorInfo>>,
            Record<string, never>
        >
    }
    GemsApi_StoneCrystalInfo?: {
        code?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_StoneCrystalInfo>>,
            Record<string, never>
        >
        info?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_StoneCrystalInfo>>,
            Record<string, never>
        >
    }
    GemsApi_StoneCutInfo?: {
        code?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_StoneCutInfo>>,
            Record<string, never>
        >
        info?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_StoneCutInfo>>,
            Record<string, never>
        >
    }
    GemsApi_StoneFluorescenceInfo?: {
        code?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_StoneFluorescenceInfo>>,
            Record<string, never>
        >
        info?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_StoneFluorescenceInfo>>,
            Record<string, never>
        >
    }
    GemsApi_StoneGradeInfo?: {
        code?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_StoneGradeInfo>>,
            Record<string, never>
        >
        info?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_StoneGradeInfo>>,
            Record<string, never>
        >
    }
    GemsApi_StoneImage?: {
        isB2B?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_StoneImage>>,
            Record<string, never>
        >
        url?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_StoneImage>>,
            Record<string, never>
        >
    }
    GemsApi_StonePolishInfo?: {
        code?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_StonePolishInfo>>,
            Record<string, never>
        >
        info?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_StonePolishInfo>>,
            Record<string, never>
        >
    }
    GemsApi_StoneShapeInfo?: {
        code?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_StoneShapeInfo>>,
            Record<string, never>
        >
        info?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_StoneShapeInfo>>,
            Record<string, never>
        >
    }
    GemsApi_StoneSymmetryInfo?: {
        code?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_StoneSymmetryInfo>>,
            Record<string, never>
        >
        info?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_StoneSymmetryInfo>>,
            Record<string, never>
        >
    }
    GemsApi_dtlReport?: {
        code?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_DtlReport>>,
            Record<string, never>
        >
        url?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GemsApi_DtlReport>>,
            Record<string, never>
        >
    }
    GenericImage?: {
        mimeType?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GenericImage>>,
            Record<string, never>
        >
        size?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GenericImage>>,
            GenericImageSizeArgs
        >
        sources?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GenericImage>>,
            Record<string, never>
        >
        url?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GenericImage>>,
            Record<string, never>
        >
    }
    GeoPoint?: {
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GeoPoint>>,
            Record<string, never>
        >
        latitude?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GeoPoint>>,
            Record<string, never>
        >
        longitude?: GraphCacheUpdateResolver<
            Maybe<WithTypename<GeoPoint>>,
            Record<string, never>
        >
    }
    HistoricalNonSkuGemstone?: {
        caratWeight?: GraphCacheUpdateResolver<
            Maybe<WithTypename<HistoricalNonSkuGemstone>>,
            Record<string, never>
        >
        clarity?: GraphCacheUpdateResolver<
            Maybe<WithTypename<HistoricalNonSkuGemstone>>,
            Record<string, never>
        >
        color?: GraphCacheUpdateResolver<
            Maybe<WithTypename<HistoricalNonSkuGemstone>>,
            Record<string, never>
        >
        colorGrade?: GraphCacheUpdateResolver<
            Maybe<WithTypename<HistoricalNonSkuGemstone>>,
            Record<string, never>
        >
        crystal?: GraphCacheUpdateResolver<
            Maybe<WithTypename<HistoricalNonSkuGemstone>>,
            Record<string, never>
        >
        cut?: GraphCacheUpdateResolver<
            Maybe<WithTypename<HistoricalNonSkuGemstone>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<HistoricalNonSkuGemstone>>,
            Record<string, never>
        >
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<HistoricalNonSkuGemstone>>,
            Record<string, never>
        >
        salePrice?: GraphCacheUpdateResolver<
            Maybe<WithTypename<HistoricalNonSkuGemstone>>,
            HistoricalNonSkuGemstoneSalePriceArgs
        >
        shape?: GraphCacheUpdateResolver<
            Maybe<WithTypename<HistoricalNonSkuGemstone>>,
            Record<string, never>
        >
    }
    HistoricalNonSkuLabGrown?: {
        caratWeight?: GraphCacheUpdateResolver<
            Maybe<WithTypename<HistoricalNonSkuLabGrown>>,
            Record<string, never>
        >
        clarity?: GraphCacheUpdateResolver<
            Maybe<WithTypename<HistoricalNonSkuLabGrown>>,
            Record<string, never>
        >
        color?: GraphCacheUpdateResolver<
            Maybe<WithTypename<HistoricalNonSkuLabGrown>>,
            Record<string, never>
        >
        crystal?: GraphCacheUpdateResolver<
            Maybe<WithTypename<HistoricalNonSkuLabGrown>>,
            Record<string, never>
        >
        cut?: GraphCacheUpdateResolver<
            Maybe<WithTypename<HistoricalNonSkuLabGrown>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<HistoricalNonSkuLabGrown>>,
            Record<string, never>
        >
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<HistoricalNonSkuLabGrown>>,
            Record<string, never>
        >
        salePrice?: GraphCacheUpdateResolver<
            Maybe<WithTypename<HistoricalNonSkuLabGrown>>,
            HistoricalNonSkuLabGrownSalePriceArgs
        >
        shape?: GraphCacheUpdateResolver<
            Maybe<WithTypename<HistoricalNonSkuLabGrown>>,
            Record<string, never>
        >
    }
    IconCarouselItem?: {
        icon?: GraphCacheUpdateResolver<
            Maybe<WithTypename<IconCarouselItem>>,
            Record<string, never>
        >
        text?: GraphCacheUpdateResolver<
            Maybe<WithTypename<IconCarouselItem>>,
            Record<string, never>
        >
    }
    Image?: {
        alt?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Image>>,
            Record<string, never>
        >
        caption?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Image>>,
            Record<string, never>
        >
        description?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Image>>,
            Record<string, never>
        >
        filename?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Image>>,
            Record<string, never>
        >
        filesize?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Image>>,
            Record<string, never>
        >
        height?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Image>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Image>>,
            Record<string, never>
        >
        mimeType?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Image>>,
            Record<string, never>
        >
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Image>>,
            Record<string, never>
        >
        size?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Image>>,
            ImageSizeArgs
        >
        sizes?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Image>>,
            Record<string, never>
        >
        sources?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Image>>,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Image>>,
            Record<string, never>
        >
        url?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Image>>,
            Record<string, never>
        >
        width?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Image>>,
            Record<string, never>
        >
    }
    ImageSize?: {
        mimeType?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ImageSize>>,
            Record<string, never>
        >
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ImageSize>>,
            Record<string, never>
        >
        sources?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ImageSize>>,
            Record<string, never>
        >
        url?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ImageSize>>,
            Record<string, never>
        >
    }
    ImageSrc?: {
        mimeType?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ImageSrc>>,
            Record<string, never>
        >
        url?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ImageSrc>>,
            Record<string, never>
        >
    }
    InstagramPost?: {
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<InstagramPost>>,
            Record<string, never>
        >
        link?: GraphCacheUpdateResolver<
            Maybe<WithTypename<InstagramPost>>,
            Record<string, never>
        >
    }
    InvalidateCacheResult?: {
        errors?: GraphCacheUpdateResolver<
            Maybe<WithTypename<InvalidateCacheResult>>,
            Record<string, never>
        >
        success?: GraphCacheUpdateResolver<
            Maybe<WithTypename<InvalidateCacheResult>>,
            Record<string, never>
        >
    }
    InvalidateCacheResultError?: {
        error?: GraphCacheUpdateResolver<
            Maybe<WithTypename<InvalidateCacheResultError>>,
            Record<string, never>
        >
        key?: GraphCacheUpdateResolver<
            Maybe<WithTypename<InvalidateCacheResultError>>,
            Record<string, never>
        >
    }
    InvalidateCacheResultSuccess?: {
        key?: GraphCacheUpdateResolver<
            Maybe<WithTypename<InvalidateCacheResultSuccess>>,
            Record<string, never>
        >
    }
    JewelleryBraceletProductStyleLabel?: {
        icon?: GraphCacheUpdateResolver<
            Maybe<WithTypename<JewelleryBraceletProductStyleLabel>>,
            Record<string, never>
        >
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<JewelleryBraceletProductStyleLabel>>,
            Record<string, never>
        >
        translation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<JewelleryBraceletProductStyleLabel>>,
            JewelleryBraceletProductStyleLabelTranslationArgs
        >
    }
    JewelleryDesignFeatureLabel?: {
        icon?: GraphCacheUpdateResolver<
            Maybe<WithTypename<JewelleryDesignFeatureLabel>>,
            Record<string, never>
        >
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<JewelleryDesignFeatureLabel>>,
            Record<string, never>
        >
        translation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<JewelleryDesignFeatureLabel>>,
            JewelleryDesignFeatureLabelTranslationArgs
        >
    }
    JewelleryDesignStyleLabel?: {
        icon?: GraphCacheUpdateResolver<
            Maybe<WithTypename<JewelleryDesignStyleLabel>>,
            Record<string, never>
        >
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<JewelleryDesignStyleLabel>>,
            Record<string, never>
        >
        translation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<JewelleryDesignStyleLabel>>,
            JewelleryDesignStyleLabelTranslationArgs
        >
    }
    JewelleryEarringsProductStyleLabel?: {
        icon?: GraphCacheUpdateResolver<
            Maybe<WithTypename<JewelleryEarringsProductStyleLabel>>,
            Record<string, never>
        >
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<JewelleryEarringsProductStyleLabel>>,
            Record<string, never>
        >
        translation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<JewelleryEarringsProductStyleLabel>>,
            JewelleryEarringsProductStyleLabelTranslationArgs
        >
    }
    JewelleryGemstoneLabel?: {
        icon?: GraphCacheUpdateResolver<
            Maybe<WithTypename<JewelleryGemstoneLabel>>,
            Record<string, never>
        >
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<JewelleryGemstoneLabel>>,
            Record<string, never>
        >
        translation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<JewelleryGemstoneLabel>>,
            JewelleryGemstoneLabelTranslationArgs
        >
    }
    JewelleryNecklaceProductStyleLabel?: {
        icon?: GraphCacheUpdateResolver<
            Maybe<WithTypename<JewelleryNecklaceProductStyleLabel>>,
            Record<string, never>
        >
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<JewelleryNecklaceProductStyleLabel>>,
            Record<string, never>
        >
        translation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<JewelleryNecklaceProductStyleLabel>>,
            JewelleryNecklaceProductStyleLabelTranslationArgs
        >
    }
    JewelleryRingProductStyleLabel?: {
        icon?: GraphCacheUpdateResolver<
            Maybe<WithTypename<JewelleryRingProductStyleLabel>>,
            Record<string, never>
        >
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<JewelleryRingProductStyleLabel>>,
            Record<string, never>
        >
        translation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<JewelleryRingProductStyleLabel>>,
            JewelleryRingProductStyleLabelTranslationArgs
        >
    }
    KlarnaFinanceOption?: {
        months?: GraphCacheUpdateResolver<
            Maybe<WithTypename<KlarnaFinanceOption>>,
            Record<string, never>
        >
        perMonth?: GraphCacheUpdateResolver<
            Maybe<WithTypename<KlarnaFinanceOption>>,
            Record<string, never>
        >
        price?: GraphCacheUpdateResolver<
            Maybe<WithTypename<KlarnaFinanceOption>>,
            Record<string, never>
        >
    }
    KlarnaPaymentMethod?: {
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<KlarnaPaymentMethod>>,
            Record<string, never>
        >
    }
    KlarnaPaymentResponse?: {
        errors?: GraphCacheUpdateResolver<
            Maybe<WithTypename<KlarnaPaymentResponse>>,
            Record<string, never>
        >
        order?: GraphCacheUpdateResolver<
            Maybe<WithTypename<KlarnaPaymentResponse>>,
            Record<string, never>
        >
    }
    KlarnaTransaction?: {
        amount?: GraphCacheUpdateResolver<
            Maybe<WithTypename<KlarnaTransaction>>,
            Record<string, never>
        >
        createdAt?: GraphCacheUpdateResolver<
            Maybe<WithTypename<KlarnaTransaction>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<KlarnaTransaction>>,
            Record<string, never>
        >
        sessionData?: GraphCacheUpdateResolver<
            Maybe<WithTypename<KlarnaTransaction>>,
            Record<string, never>
        >
        status?: GraphCacheUpdateResolver<
            Maybe<WithTypename<KlarnaTransaction>>,
            Record<string, never>
        >
    }
    Language?: {
        locale?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Language>>,
            Record<string, never>
        >
        translations?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Language>>,
            Record<string, never>
        >
    }
    LegacyTransaction?: {
        amount?: GraphCacheUpdateResolver<
            Maybe<WithTypename<LegacyTransaction>>,
            Record<string, never>
        >
        createdAt?: GraphCacheUpdateResolver<
            Maybe<WithTypename<LegacyTransaction>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<LegacyTransaction>>,
            Record<string, never>
        >
        paymentMethodName?: GraphCacheUpdateResolver<
            Maybe<WithTypename<LegacyTransaction>>,
            LegacyTransactionPaymentMethodNameArgs
        >
        status?: GraphCacheUpdateResolver<
            Maybe<WithTypename<LegacyTransaction>>,
            Record<string, never>
        >
    }
    Link?: {
        item?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Link>>,
            Record<string, never>
        >
        target?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Link>>,
            Record<string, never>
        >
        text?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Link>>,
            Record<string, never>
        >
    }
    LinkItemAffirm?: {
        emptyField?: GraphCacheUpdateResolver<
            Maybe<WithTypename<LinkItemAffirm>>,
            Record<string, never>
        >
    }
    LinkItemBookingForm?: {
        emptyField?: GraphCacheUpdateResolver<
            Maybe<WithTypename<LinkItemBookingForm>>,
            Record<string, never>
        >
    }
    LinkItemCustom?: {
        url?: GraphCacheUpdateResolver<
            Maybe<WithTypename<LinkItemCustom>>,
            Record<string, never>
        >
    }
    LinkItemOpenContactForm?: {
        emptyField?: GraphCacheUpdateResolver<
            Maybe<WithTypename<LinkItemOpenContactForm>>,
            Record<string, never>
        >
    }
    LinkItemOpenEnquiryForm?: {
        cmsEnquiryFormType?: GraphCacheUpdateResolver<
            Maybe<WithTypename<LinkItemOpenEnquiryForm>>,
            Record<string, never>
        >
        enquiryType?: GraphCacheUpdateResolver<
            Maybe<WithTypename<LinkItemOpenEnquiryForm>>,
            Record<string, never>
        >
    }
    LinkItemOpenSpeakToExpertModal?: {
        emptyField?: GraphCacheUpdateResolver<
            Maybe<WithTypename<LinkItemOpenSpeakToExpertModal>>,
            Record<string, never>
        >
    }
    LoginResponseFailure?: {
        code?: GraphCacheUpdateResolver<
            Maybe<WithTypename<LoginResponseFailure>>,
            Record<string, never>
        >
        message?: GraphCacheUpdateResolver<
            Maybe<WithTypename<LoginResponseFailure>>,
            LoginResponseFailureMessageArgs
        >
    }
    LoginResponseSuccess?: {
        jwt?: GraphCacheUpdateResolver<
            Maybe<WithTypename<LoginResponseSuccess>>,
            Record<string, never>
        >
        refreshToken?: GraphCacheUpdateResolver<
            Maybe<WithTypename<LoginResponseSuccess>>,
            Record<string, never>
        >
        user?: GraphCacheUpdateResolver<
            Maybe<WithTypename<LoginResponseSuccess>>,
            Record<string, never>
        >
    }
    Logo?: {
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Logo>>,
            Record<string, never>
        >
        link?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Logo>>,
            Record<string, never>
        >
    }
    MagicLinkConsumeError?: {
        message?: GraphCacheUpdateResolver<
            Maybe<WithTypename<MagicLinkConsumeError>>,
            Record<string, never>
        >
    }
    MagicLinkConsumeSuccess?: {
        login?: GraphCacheUpdateResolver<
            Maybe<WithTypename<MagicLinkConsumeSuccess>>,
            Record<string, never>
        >
    }
    MarketingDataResponse?: {
        success?: GraphCacheUpdateResolver<
            Maybe<WithTypename<MarketingDataResponse>>,
            Record<string, never>
        >
    }
    Melee?: {
        caratWeight?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Melee>>,
            Record<string, never>
        >
        clarities?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Melee>>,
            Record<string, never>
        >
        colors?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Melee>>,
            Record<string, never>
        >
        crystal?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Melee>>,
            Record<string, never>
        >
        grade?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Melee>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Melee>>,
            Record<string, never>
        >
        segmentName?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Melee>>,
            Record<string, never>
        >
        shape?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Melee>>,
            Record<string, never>
        >
        width?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Melee>>,
            Record<string, never>
        >
    }
    MenuItem?: {
        hideOnDesktop?: GraphCacheUpdateResolver<
            Maybe<WithTypename<MenuItem>>,
            Record<string, never>
        >
        hideOnMobile?: GraphCacheUpdateResolver<
            Maybe<WithTypename<MenuItem>>,
            Record<string, never>
        >
        link?: GraphCacheUpdateResolver<
            Maybe<WithTypename<MenuItem>>,
            Record<string, never>
        >
        subMenu?: GraphCacheUpdateResolver<
            Maybe<WithTypename<MenuItem>>,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<MenuItem>>,
            Record<string, never>
        >
    }
    Meta?: {
        description?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Meta>>,
            Record<string, never>
        >
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Meta>>,
            Record<string, never>
        >
        robots?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Meta>>,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Meta>>,
            Record<string, never>
        >
    }
    Metal?: {
        color?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Metal>>,
            Record<string, never>
        >
        element?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Metal>>,
            Record<string, never>
        >
        karat?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Metal>>,
            Record<string, never>
        >
        millesimalFineness?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Metal>>,
            Record<string, never>
        >
        orderIndex?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Metal>>,
            Record<string, never>
        >
        segmentName?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Metal>>,
            Record<string, never>
        >
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Metal>>,
            Record<string, never>
        >
        translation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Metal>>,
            MetalTranslationArgs
        >
    }
    MetalColor?: {
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<MetalColor>>,
            Record<string, never>
        >
        translation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<MetalColor>>,
            MetalColorTranslationArgs
        >
    }
    MetalColorTranslation?: {
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<MetalColorTranslation>>,
            Record<string, never>
        >
    }
    MetalElement?: {
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<MetalElement>>,
            Record<string, never>
        >
        translation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<MetalElement>>,
            MetalElementTranslationArgs
        >
    }
    MetalElementTranslation?: {
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<MetalElementTranslation>>,
            Record<string, never>
        >
    }
    MetalTranslation?: {
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<MetalTranslation>>,
            Record<string, never>
        >
    }
    Money?: {
        amount?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Money>>,
            Record<string, never>
        >
        currency?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Money>>,
            Record<string, never>
        >
    }
    MonolithImageSize?: {
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<MonolithImageSize>>,
            Record<string, never>
        >
        sources?: GraphCacheUpdateResolver<
            Maybe<WithTypename<MonolithImageSize>>,
            Record<string, never>
        >
        url?: GraphCacheUpdateResolver<
            Maybe<WithTypename<MonolithImageSize>>,
            Record<string, never>
        >
    }
    NoPaymentMethod?: {
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NoPaymentMethod>>,
            Record<string, never>
        >
    }
    NonSkuCaratWeightRange?: {
        max?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuCaratWeightRange>>,
            Record<string, never>
        >
        min?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuCaratWeightRange>>,
            Record<string, never>
        >
    }
    NonSkuGemstone?: {
        caratDimension?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuGemstone>>,
            Record<string, never>
        >
        caratWeight?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuGemstone>>,
            Record<string, never>
        >
        clarity?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuGemstone>>,
            Record<string, never>
        >
        color?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuGemstone>>,
            Record<string, never>
        >
        colorCrystalDimension?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuGemstone>>,
            Record<string, never>
        >
        colorGrade?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuGemstone>>,
            Record<string, never>
        >
        crystal?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuGemstone>>,
            Record<string, never>
        >
        cut?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuGemstone>>,
            Record<string, never>
        >
        gradeClarityDimension?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuGemstone>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuGemstone>>,
            Record<string, never>
        >
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuGemstone>>,
            Record<string, never>
        >
        salePrice?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuGemstone>>,
            NonSkuGemstoneSalePriceArgs
        >
        sampleImage?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuGemstone>>,
            Record<string, never>
        >
        shape?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuGemstone>>,
            Record<string, never>
        >
        shapeDimension?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuGemstone>>,
            Record<string, never>
        >
        uniqueImage?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuGemstone>>,
            Record<string, never>
        >
    }
    NonSkuGemstoneCaratDimension?: {
        caratWeight?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuGemstoneCaratDimension>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuGemstoneCaratDimension>>,
            Record<string, never>
        >
    }
    NonSkuGemstoneGradeClarityDimension?: {
        clarity?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuGemstoneGradeClarityDimension>>,
            Record<string, never>
        >
        grade?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuGemstoneGradeClarityDimension>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuGemstoneGradeClarityDimension>>,
            Record<string, never>
        >
    }
    NonSkuGemstoneImage?: {
        colorCrystalDimension?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuGemstoneImage>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuGemstoneImage>>,
            Record<string, never>
        >
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuGemstoneImage>>,
            Record<string, never>
        >
        shapeDimension?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuGemstoneImage>>,
            Record<string, never>
        >
    }
    NonSkuGemstoneShapeDimension?: {
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuGemstoneShapeDimension>>,
            Record<string, never>
        >
        shape?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuGemstoneShapeDimension>>,
            Record<string, never>
        >
    }
    NonSkuGemstoneType?: {
        color?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuGemstoneType>>,
            Record<string, never>
        >
        crystal?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuGemstoneType>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuGemstoneType>>,
            Record<string, never>
        >
    }
    NonSkuGemstonesBounds?: {
        caratWeight?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuGemstonesBounds>>,
            Record<string, never>
        >
        price?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuGemstonesBounds>>,
            NonSkuGemstonesBoundsPriceArgs
        >
        shapes?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuGemstonesBounds>>,
            Record<string, never>
        >
        types?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuGemstonesBounds>>,
            Record<string, never>
        >
    }
    NonSkuImage?: {
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuImage>>,
            Record<string, never>
        >
        mimeType?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuImage>>,
            Record<string, never>
        >
        size?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuImage>>,
            NonSkuImageSizeArgs
        >
        sources?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuImage>>,
            Record<string, never>
        >
        url?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuImage>>,
            Record<string, never>
        >
    }
    NonSkuLabGrown?: {
        caratDimension?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuLabGrown>>,
            Record<string, never>
        >
        caratWeight?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuLabGrown>>,
            Record<string, never>
        >
        clarity?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuLabGrown>>,
            Record<string, never>
        >
        color?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuLabGrown>>,
            Record<string, never>
        >
        crystal?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuLabGrown>>,
            Record<string, never>
        >
        cut?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuLabGrown>>,
            Record<string, never>
        >
        gradeDimension?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuLabGrown>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuLabGrown>>,
            Record<string, never>
        >
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuLabGrown>>,
            Record<string, never>
        >
        salePrice?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuLabGrown>>,
            NonSkuLabGrownSalePriceArgs
        >
        sampleImage?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuLabGrown>>,
            Record<string, never>
        >
        shape?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuLabGrown>>,
            Record<string, never>
        >
        shapeDimension?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuLabGrown>>,
            Record<string, never>
        >
        uniqueImage?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuLabGrown>>,
            Record<string, never>
        >
    }
    NonSkuLabGrownCaratDimension?: {
        caratWeight?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuLabGrownCaratDimension>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuLabGrownCaratDimension>>,
            Record<string, never>
        >
    }
    NonSkuLabGrownDiamondsBounds?: {
        caratWeight?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuLabGrownDiamondsBounds>>,
            Record<string, never>
        >
        colors?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuLabGrownDiamondsBounds>>,
            Record<string, never>
        >
        price?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuLabGrownDiamondsBounds>>,
            NonSkuLabGrownDiamondsBoundsPriceArgs
        >
        shapes?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuLabGrownDiamondsBounds>>,
            Record<string, never>
        >
    }
    NonSkuLabGrownGradeDimension?: {
        clarity?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuLabGrownGradeDimension>>,
            Record<string, never>
        >
        color?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuLabGrownGradeDimension>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuLabGrownGradeDimension>>,
            Record<string, never>
        >
    }
    NonSkuLabGrownShapeDimension?: {
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuLabGrownShapeDimension>>,
            Record<string, never>
        >
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuLabGrownShapeDimension>>,
            Record<string, never>
        >
        shape?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuLabGrownShapeDimension>>,
            Record<string, never>
        >
    }
    NonSkuPriceRange?: {
        max?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuPriceRange>>,
            Record<string, never>
        >
        min?: GraphCacheUpdateResolver<
            Maybe<WithTypename<NonSkuPriceRange>>,
            Record<string, never>
        >
    }
    Order?: {
        allowedWeekdays?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Order>>,
            Record<string, never>
        >
        availableShowroomsForCollection?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Order>>,
            Record<string, never>
        >
        billingAddress?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Order>>,
            Record<string, never>
        >
        customer?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Order>>,
            Record<string, never>
        >
        desiredDeliveryDate?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Order>>,
            Record<string, never>
        >
        disabledDates?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Order>>,
            Record<string, never>
        >
        firstAvailableDeliveryDate?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Order>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Order>>,
            Record<string, never>
        >
        isAsarEnabled?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Order>>,
            Record<string, never>
        >
        isCompleted?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Order>>,
            Record<string, never>
        >
        isDeliveryConfirmed?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Order>>,
            Record<string, never>
        >
        isPayable?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Order>>,
            Record<string, never>
        >
        isShippingAddressReadonly?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Order>>,
            Record<string, never>
        >
        paidAmount?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Order>>,
            Record<string, never>
        >
        paymentMethods?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Order>>,
            Record<string, never>
        >
        paymentPlan?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Order>>,
            Record<string, never>
        >
        placementDate?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Order>>,
            Record<string, never>
        >
        prediscountSubtotalAmount?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Order>>,
            Record<string, never>
        >
        prediscountTotalAmount?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Order>>,
            Record<string, never>
        >
        products?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Order>>,
            Record<string, never>
        >
        promoCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Order>>,
            Record<string, never>
        >
        remainingAmount?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Order>>,
            Record<string, never>
        >
        salesTaxAmount?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Order>>,
            Record<string, never>
        >
        savedAmount?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Order>>,
            Record<string, never>
        >
        shipmentTrackingInformation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Order>>,
            Record<string, never>
        >
        shippingAddress?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Order>>,
            Record<string, never>
        >
        shippingAmount?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Order>>,
            Record<string, never>
        >
        status?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Order>>,
            Record<string, never>
        >
        subtotalAmount?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Order>>,
            Record<string, never>
        >
        totalAmount?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Order>>,
            Record<string, never>
        >
        transactions?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Order>>,
            Record<string, never>
        >
        vatAmount?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Order>>,
            Record<string, never>
        >
    }
    OrderAddress?: {
        addressLine1?: GraphCacheUpdateResolver<
            Maybe<WithTypename<OrderAddress>>,
            Record<string, never>
        >
        addressLine2?: GraphCacheUpdateResolver<
            Maybe<WithTypename<OrderAddress>>,
            Record<string, never>
        >
        city?: GraphCacheUpdateResolver<
            Maybe<WithTypename<OrderAddress>>,
            Record<string, never>
        >
        country?: GraphCacheUpdateResolver<
            Maybe<WithTypename<OrderAddress>>,
            Record<string, never>
        >
        deliveryInstructions?: GraphCacheUpdateResolver<
            Maybe<WithTypename<OrderAddress>>,
            Record<string, never>
        >
        email?: GraphCacheUpdateResolver<
            Maybe<WithTypename<OrderAddress>>,
            Record<string, never>
        >
        firstName?: GraphCacheUpdateResolver<
            Maybe<WithTypename<OrderAddress>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<OrderAddress>>,
            Record<string, never>
        >
        lastName?: GraphCacheUpdateResolver<
            Maybe<WithTypename<OrderAddress>>,
            Record<string, never>
        >
        phoneNumber?: GraphCacheUpdateResolver<
            Maybe<WithTypename<OrderAddress>>,
            Record<string, never>
        >
        postalCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<OrderAddress>>,
            Record<string, never>
        >
        subdivision?: GraphCacheUpdateResolver<
            Maybe<WithTypename<OrderAddress>>,
            Record<string, never>
        >
    }
    OrderAddressNotConfirmedError?: {
        message?: GraphCacheUpdateResolver<
            Maybe<WithTypename<OrderAddressNotConfirmedError>>,
            Record<string, never>
        >
    }
    OrderAlreadyCompletedError?: {
        message?: GraphCacheUpdateResolver<
            Maybe<WithTypename<OrderAlreadyCompletedError>>,
            Record<string, never>
        >
    }
    OrderEmptyError?: {
        message?: GraphCacheUpdateResolver<
            Maybe<WithTypename<OrderEmptyError>>,
            Record<string, never>
        >
    }
    OrderProduct?: {
        customer?: GraphCacheUpdateResolver<
            Maybe<WithTypename<OrderProduct>>,
            Record<string, never>
        >
        designStudioProduct?: GraphCacheUpdateResolver<
            Maybe<WithTypename<OrderProduct>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<OrderProduct>>,
            Record<string, never>
        >
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<OrderProduct>>,
            Record<string, never>
        >
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<OrderProduct>>,
            Record<string, never>
        >
        order?: GraphCacheUpdateResolver<
            Maybe<WithTypename<OrderProduct>>,
            Record<string, never>
        >
        prediscountTotalSaleAmount?: GraphCacheUpdateResolver<
            Maybe<WithTypename<OrderProduct>>,
            Record<string, never>
        >
        totalSaleAmount?: GraphCacheUpdateResolver<
            Maybe<WithTypename<OrderProduct>>,
            Record<string, never>
        >
    }
    OrderStatus?: {
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<OrderStatus>>,
            OrderStatusNameArgs
        >
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<OrderStatus>>,
            Record<string, never>
        >
    }
    OrderedListItem?: {
        description?: GraphCacheUpdateResolver<
            Maybe<WithTypename<OrderedListItem>>,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<OrderedListItem>>,
            Record<string, never>
        >
    }
    Page?: {
        author?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Page>>,
            Record<string, never>
        >
        blocks?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Page>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Page>>,
            Record<string, never>
        >
        meta?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Page>>,
            Record<string, never>
        >
        pageSettings?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Page>>,
            Record<string, never>
        >
        parent?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Page>>,
            Record<string, never>
        >
        path?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Page>>,
            Record<string, never>
        >
        slug?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Page>>,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Page>>,
            Record<string, never>
        >
    }
    PageSettings?: {
        showRingBuilder?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PageSettings>>,
            Record<string, never>
        >
    }
    PageTooltip?: {
        tooltip?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PageTooltip>>,
            Record<string, never>
        >
        triggerText?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PageTooltip>>,
            Record<string, never>
        >
    }
    PayViaCheckoutcomFailureResponse?: {
        errors?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PayViaCheckoutcomFailureResponse>>,
            Record<string, never>
        >
    }
    PayViaCheckoutcomSuccessResponse?: {
        order?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PayViaCheckoutcomSuccessResponse>>,
            Record<string, never>
        >
        redirectUrl?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PayViaCheckoutcomSuccessResponse>>,
            Record<string, never>
        >
    }
    PaymentAmountInvalidError?: {
        message?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PaymentAmountInvalidError>>,
            Record<string, never>
        >
    }
    PaymentIcon?: {
        icon?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PaymentIcon>>,
            Record<string, never>
        >
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PaymentIcon>>,
            Record<string, never>
        >
    }
    PaymentMethodContainer?: {
        affirmPayment?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PaymentMethodContainer>>,
            Record<string, never>
        >
        allocationPayment?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PaymentMethodContainer>>,
            Record<string, never>
        >
        bankPayment?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PaymentMethodContainer>>,
            Record<string, never>
        >
        checkoutcomPayment?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PaymentMethodContainer>>,
            Record<string, never>
        >
        klarnaPayment?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PaymentMethodContainer>>,
            Record<string, never>
        >
        noPayment?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PaymentMethodContainer>>,
            Record<string, never>
        >
    }
    PaymentMethodNotAllowedError?: {
        message?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PaymentMethodNotAllowedError>>,
            Record<string, never>
        >
    }
    PaymentPlan?: {
        current?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PaymentPlan>>,
            Record<string, never>
        >
        paid?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PaymentPlan>>,
            Record<string, never>
        >
        upcoming?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PaymentPlan>>,
            Record<string, never>
        >
    }
    PaymentPlanPaidRecord?: {
        amount?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PaymentPlanPaidRecord>>,
            Record<string, never>
        >
        paidOn?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PaymentPlanPaidRecord>>,
            Record<string, never>
        >
    }
    PaymentPlanUpcomingRecord?: {
        amount?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PaymentPlanUpcomingRecord>>,
            Record<string, never>
        >
    }
    PhoneNumberType?: {
        countryCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PhoneNumberType>>,
            Record<string, never>
        >
        e164?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PhoneNumberType>>,
            Record<string, never>
        >
        formatted?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PhoneNumberType>>,
            PhoneNumberTypeFormattedArgs
        >
        nationalNumber?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PhoneNumberType>>,
            Record<string, never>
        >
    }
    Post?: {
        author?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Post>>,
            PostAuthorArgs
        >
        blocks?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Post>>,
            Record<string, never>
        >
        categories?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Post>>,
            PostCategoriesArgs
        >
        createdAt?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Post>>,
            Record<string, never>
        >
        date?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Post>>,
            Record<string, never>
        >
        excerpt?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Post>>,
            Record<string, never>
        >
        featuredImage?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Post>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Post>>,
            Record<string, never>
        >
        meta?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Post>>,
            Record<string, never>
        >
        modifiedAt?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Post>>,
            Record<string, never>
        >
        relatedPosts?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Post>>,
            PostRelatedPostsArgs
        >
        showModifiedDate?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Post>>,
            Record<string, never>
        >
        slug?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Post>>,
            Record<string, never>
        >
        tags?: GraphCacheUpdateResolver<Maybe<WithTypename<Post>>, PostTagsArgs>
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Post>>,
            Record<string, never>
        >
    }
    PostCategoriesAggregation?: {
        count?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PostCategoriesAggregation>>,
            Record<string, never>
        >
    }
    PostCategory?: {
        children?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PostCategory>>,
            PostCategoryChildrenArgs
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PostCategory>>,
            Record<string, never>
        >
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PostCategory>>,
            Record<string, never>
        >
        parent?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PostCategory>>,
            PostCategoryParentArgs
        >
        postAggregation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PostCategory>>,
            PostCategoryPostAggregationArgs
        >
        posts?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PostCategory>>,
            PostCategoryPostsArgs
        >
        slug?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PostCategory>>,
            Record<string, never>
        >
    }
    PostTag?: {
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PostTag>>,
            Record<string, never>
        >
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PostTag>>,
            Record<string, never>
        >
        postAggregation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PostTag>>,
            PostTagPostAggregationArgs
        >
        posts?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PostTag>>,
            PostTagPostsArgs
        >
        slug?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PostTag>>,
            Record<string, never>
        >
    }
    PostTagsAggregation?: {
        count?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PostTagsAggregation>>,
            Record<string, never>
        >
    }
    PostsAggregation?: {
        count?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PostsAggregation>>,
            Record<string, never>
        >
    }
    PreHeader?: {
        link?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PreHeader>>,
            Record<string, never>
        >
    }
    ProductLabelTranslation?: {
        facetedContentName?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ProductLabelTranslation>>,
            Record<string, never>
        >
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ProductLabelTranslation>>,
            Record<string, never>
        >
    }
    ProductPageDetails?: {
        blocks?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ProductPageDetails>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ProductPageDetails>>,
            Record<string, never>
        >
        meta?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ProductPageDetails>>,
            Record<string, never>
        >
        path?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ProductPageDetails>>,
            Record<string, never>
        >
        priceExplainedTooltip?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ProductPageDetails>>,
            Record<string, never>
        >
        slug?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ProductPageDetails>>,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ProductPageDetails>>,
            Record<string, never>
        >
    }
    ProductPageFacetedContent?: {
        contentTitle?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ProductPageFacetedContent>>,
            Record<string, never>
        >
        description?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ProductPageFacetedContent>>,
            Record<string, never>
        >
        longDescription?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ProductPageFacetedContent>>,
            Record<string, never>
        >
        meta?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ProductPageFacetedContent>>,
            Record<string, never>
        >
        productString?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ProductPageFacetedContent>>,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ProductPageFacetedContent>>,
            Record<string, never>
        >
    }
    ProductPageFacetedContentLongDescriptionBlock?: {
        blocks?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ProductPageFacetedContentLongDescriptionBlock>>,
            Record<string, never>
        >
    }
    ProductPageFacetedContentLongDescriptionText?: {
        text?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ProductPageFacetedContentLongDescriptionText>>,
            Record<string, never>
        >
    }
    ProductPageListing?: {
        afterGrid?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ProductPageListing>>,
            Record<string, never>
        >
        banner1?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ProductPageListing>>,
            Record<string, never>
        >
        banner2?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ProductPageListing>>,
            Record<string, never>
        >
        beforeFilters?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ProductPageListing>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ProductPageListing>>,
            Record<string, never>
        >
        meta?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ProductPageListing>>,
            Record<string, never>
        >
        path?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ProductPageListing>>,
            Record<string, never>
        >
        slug?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ProductPageListing>>,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ProductPageListing>>,
            Record<string, never>
        >
    }
    PromoCode?: {
        code?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PromoCode>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PromoCode>>,
            Record<string, never>
        >
    }
    PromoCodeApplicationResult?: {
        error?: GraphCacheUpdateResolver<
            Maybe<WithTypename<PromoCodeApplicationResult>>,
            Record<string, never>
        >
    }
    Questionnaire?: {
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Questionnaire>>,
            Record<string, never>
        >
        redirectLink?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Questionnaire>>,
            Record<string, never>
        >
        signUpStep?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Questionnaire>>,
            Record<string, never>
        >
        steps?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Questionnaire>>,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Questionnaire>>,
            Record<string, never>
        >
        type?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Questionnaire>>,
            Record<string, never>
        >
    }
    QuestionnaireCompletedExistingCustomerResponse?: {
        questionnaire?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireCompletedExistingCustomerResponse>>,
            Record<string, never>
        >
    }
    QuestionnaireCompletedNewCustomerResponse?: {
        customer?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireCompletedNewCustomerResponse>>,
            Record<string, never>
        >
        questionnaire?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireCompletedNewCustomerResponse>>,
            Record<string, never>
        >
    }
    QuestionnaireCompletedQuestionnaire?: {
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireCompletedQuestionnaire>>,
            Record<string, never>
        >
        referenceId?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireCompletedQuestionnaire>>,
            Record<string, never>
        >
        steps?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireCompletedQuestionnaire>>,
            Record<string, never>
        >
        type?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireCompletedQuestionnaire>>,
            Record<string, never>
        >
    }
    QuestionnaireCompletedQuestionnaireStepSnapshot?: {
        answers?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<QuestionnaireCompletedQuestionnaireStepSnapshot>
            >,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<QuestionnaireCompletedQuestionnaireStepSnapshot>
            >,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<QuestionnaireCompletedQuestionnaireStepSnapshot>
            >,
            Record<string, never>
        >
    }
    QuestionnaireCondition?: {
        rules?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireCondition>>,
            Record<string, never>
        >
        type?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireCondition>>,
            Record<string, never>
        >
    }
    QuestionnaireConditionEqualToChoice?: {
        choice?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireConditionEqualToChoice>>,
            Record<string, never>
        >
        question?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireConditionEqualToChoice>>,
            Record<string, never>
        >
    }
    QuestionnaireConditionIsEmpty?: {
        question?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireConditionIsEmpty>>,
            Record<string, never>
        >
    }
    QuestionnaireConditionIsEqualTo?: {
        question?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireConditionIsEqualTo>>,
            Record<string, never>
        >
        value?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireConditionIsEqualTo>>,
            Record<string, never>
        >
    }
    QuestionnaireConditionIsGreaterThan?: {
        question?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireConditionIsGreaterThan>>,
            Record<string, never>
        >
        value?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireConditionIsGreaterThan>>,
            Record<string, never>
        >
    }
    QuestionnaireConditionIsLessThan?: {
        question?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireConditionIsLessThan>>,
            Record<string, never>
        >
        value?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireConditionIsLessThan>>,
            Record<string, never>
        >
    }
    QuestionnaireConditionIsNotEmpty?: {
        question?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireConditionIsNotEmpty>>,
            Record<string, never>
        >
    }
    QuestionnaireConditionNotIsEqualTo?: {
        question?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireConditionNotIsEqualTo>>,
            Record<string, never>
        >
        value?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireConditionNotIsEqualTo>>,
            Record<string, never>
        >
    }
    QuestionnaireCustomerNotification?: {
        subject?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireCustomerNotification>>,
            Record<string, never>
        >
        text?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireCustomerNotification>>,
            Record<string, never>
        >
    }
    QuestionnaireQuestionAnswerMultiChoice?: {
        choices?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionAnswerMultiChoice>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionAnswerMultiChoice>>,
            Record<string, never>
        >
        question?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionAnswerMultiChoice>>,
            Record<string, never>
        >
    }
    QuestionnaireQuestionAnswerNumber?: {
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionAnswerNumber>>,
            Record<string, never>
        >
        number?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionAnswerNumber>>,
            Record<string, never>
        >
        question?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionAnswerNumber>>,
            Record<string, never>
        >
    }
    QuestionnaireQuestionAnswerSingleChoice?: {
        choice?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionAnswerSingleChoice>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionAnswerSingleChoice>>,
            Record<string, never>
        >
        question?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionAnswerSingleChoice>>,
            Record<string, never>
        >
    }
    QuestionnaireQuestionAnswerText?: {
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionAnswerText>>,
            Record<string, never>
        >
        question?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionAnswerText>>,
            Record<string, never>
        >
        text?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionAnswerText>>,
            Record<string, never>
        >
    }
    QuestionnaireQuestionChoice?: {
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionChoice>>,
            Record<string, never>
        >
        multiple?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionChoice>>,
            Record<string, never>
        >
        options?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionChoice>>,
            Record<string, never>
        >
        required?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionChoice>>,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionChoice>>,
            Record<string, never>
        >
    }
    QuestionnaireQuestionChoiceOption?: {
        behaviour?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionChoiceOption>>,
            Record<string, never>
        >
        content?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionChoiceOption>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionChoiceOption>>,
            Record<string, never>
        >
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionChoiceOption>>,
            Record<string, never>
        >
    }
    QuestionnaireQuestionChoiceOptionBehaviour?: {
        designFeature?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionChoiceOptionBehaviour>>,
            Record<string, never>
        >
        designStyle?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionChoiceOptionBehaviour>>,
            Record<string, never>
        >
        metal?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionChoiceOptionBehaviour>>,
            Record<string, never>
        >
        ringStyle?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionChoiceOptionBehaviour>>,
            Record<string, never>
        >
        shape?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionChoiceOptionBehaviour>>,
            Record<string, never>
        >
    }
    QuestionnaireQuestionChoiceOptionContentIconCard?: {
        backgroundColor?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<QuestionnaireQuestionChoiceOptionContentIconCard>
            >,
            Record<string, never>
        >
        conditionalContent?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<QuestionnaireQuestionChoiceOptionContentIconCard>
            >,
            Record<string, never>
        >
        description?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<QuestionnaireQuestionChoiceOptionContentIconCard>
            >,
            Record<string, never>
        >
        icon?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<QuestionnaireQuestionChoiceOptionContentIconCard>
            >,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<QuestionnaireQuestionChoiceOptionContentIconCard>
            >,
            Record<string, never>
        >
    }
    QuestionnaireQuestionChoiceOptionContentIconCardConditional?: {
        backgroundColor?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<QuestionnaireQuestionChoiceOptionContentIconCardConditional>
            >,
            Record<string, never>
        >
        conditions?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<QuestionnaireQuestionChoiceOptionContentIconCardConditional>
            >,
            Record<string, never>
        >
        description?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<QuestionnaireQuestionChoiceOptionContentIconCardConditional>
            >,
            Record<string, never>
        >
        icon?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<QuestionnaireQuestionChoiceOptionContentIconCardConditional>
            >,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<QuestionnaireQuestionChoiceOptionContentIconCardConditional>
            >,
            Record<string, never>
        >
    }
    QuestionnaireQuestionChoiceOptionContentImage?: {
        conditionalContent?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionChoiceOptionContentImage>>,
            Record<string, never>
        >
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionChoiceOptionContentImage>>,
            Record<string, never>
        >
    }
    QuestionnaireQuestionChoiceOptionContentImageCard?: {
        conditionalContent?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<QuestionnaireQuestionChoiceOptionContentImageCard>
            >,
            Record<string, never>
        >
        description?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<QuestionnaireQuestionChoiceOptionContentImageCard>
            >,
            Record<string, never>
        >
        image?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<QuestionnaireQuestionChoiceOptionContentImageCard>
            >,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<QuestionnaireQuestionChoiceOptionContentImageCard>
            >,
            Record<string, never>
        >
    }
    QuestionnaireQuestionChoiceOptionContentImageCardConditional?: {
        conditions?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<QuestionnaireQuestionChoiceOptionContentImageCardConditional>
            >,
            Record<string, never>
        >
        description?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<QuestionnaireQuestionChoiceOptionContentImageCardConditional>
            >,
            Record<string, never>
        >
        image?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<QuestionnaireQuestionChoiceOptionContentImageCardConditional>
            >,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<QuestionnaireQuestionChoiceOptionContentImageCardConditional>
            >,
            Record<string, never>
        >
    }
    QuestionnaireQuestionChoiceOptionContentImageConditional?: {
        conditions?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<QuestionnaireQuestionChoiceOptionContentImageConditional>
            >,
            Record<string, never>
        >
        image?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<QuestionnaireQuestionChoiceOptionContentImageConditional>
            >,
            Record<string, never>
        >
    }
    QuestionnaireQuestionChoiceOptionContentText?: {
        conditionalContent?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionChoiceOptionContentText>>,
            Record<string, never>
        >
        description?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionChoiceOptionContentText>>,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionChoiceOptionContentText>>,
            Record<string, never>
        >
    }
    QuestionnaireQuestionChoiceOptionContentTextConditional?: {
        conditions?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<QuestionnaireQuestionChoiceOptionContentTextConditional>
            >,
            Record<string, never>
        >
        description?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<QuestionnaireQuestionChoiceOptionContentTextConditional>
            >,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<QuestionnaireQuestionChoiceOptionContentTextConditional>
            >,
            Record<string, never>
        >
    }
    QuestionnaireQuestionChoiceOptionLayoutSnapshotIconCard?: {
        backgroundColor?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<QuestionnaireQuestionChoiceOptionLayoutSnapshotIconCard>
            >,
            Record<string, never>
        >
        description?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<QuestionnaireQuestionChoiceOptionLayoutSnapshotIconCard>
            >,
            Record<string, never>
        >
        icon?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<QuestionnaireQuestionChoiceOptionLayoutSnapshotIconCard>
            >,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<QuestionnaireQuestionChoiceOptionLayoutSnapshotIconCard>
            >,
            Record<string, never>
        >
    }
    QuestionnaireQuestionChoiceOptionLayoutSnapshotImage?: {
        icon?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<QuestionnaireQuestionChoiceOptionLayoutSnapshotImage>
            >,
            Record<string, never>
        >
    }
    QuestionnaireQuestionChoiceOptionLayoutSnapshotImageCard?: {
        description?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<QuestionnaireQuestionChoiceOptionLayoutSnapshotImageCard>
            >,
            Record<string, never>
        >
        icon?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<QuestionnaireQuestionChoiceOptionLayoutSnapshotImageCard>
            >,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<QuestionnaireQuestionChoiceOptionLayoutSnapshotImageCard>
            >,
            Record<string, never>
        >
    }
    QuestionnaireQuestionChoiceOptionLayoutSnapshotText?: {
        description?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<QuestionnaireQuestionChoiceOptionLayoutSnapshotText>
            >,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<
                WithTypename<QuestionnaireQuestionChoiceOptionLayoutSnapshotText>
            >,
            Record<string, never>
        >
    }
    QuestionnaireQuestionChoiceOptionSnapshot?: {
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionChoiceOptionSnapshot>>,
            Record<string, never>
        >
        layout?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionChoiceOptionSnapshot>>,
            Record<string, never>
        >
        referenceId?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionChoiceOptionSnapshot>>,
            Record<string, never>
        >
    }
    QuestionnaireQuestionPrice?: {
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionPrice>>,
            Record<string, never>
        >
        max?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionPrice>>,
            Record<string, never>
        >
        min?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionPrice>>,
            Record<string, never>
        >
        required?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionPrice>>,
            Record<string, never>
        >
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionPrice>>,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionPrice>>,
            Record<string, never>
        >
        tooltip?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionPrice>>,
            Record<string, never>
        >
    }
    QuestionnaireQuestionSnapshot?: {
        referenceId?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionSnapshot>>,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionSnapshot>>,
            Record<string, never>
        >
    }
    QuestionnaireQuestionText?: {
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionText>>,
            Record<string, never>
        >
        required?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionText>>,
            Record<string, never>
        >
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionText>>,
            Record<string, never>
        >
        textarea?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionText>>,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireQuestionText>>,
            Record<string, never>
        >
    }
    QuestionnaireSignUpStep?: {
        backgroundColor?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireSignUpStep>>,
            Record<string, never>
        >
        description?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireSignUpStep>>,
            Record<string, never>
        >
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireSignUpStep>>,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireSignUpStep>>,
            Record<string, never>
        >
    }
    QuestionnaireStep?: {
        conditions?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireStep>>,
            Record<string, never>
        >
        content?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireStep>>,
            Record<string, never>
        >
        description?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireStep>>,
            Record<string, never>
        >
        excludeFromProgressIndicator?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireStep>>,
            Record<string, never>
        >
        help?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireStep>>,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireStep>>,
            Record<string, never>
        >
    }
    QuestionnaireStepContentContent?: {
        blocks?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireStepContentContent>>,
            Record<string, never>
        >
        conditions?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireStepContentContent>>,
            Record<string, never>
        >
    }
    QuestionnaireStepContentQuestions?: {
        conditions?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireStepContentQuestions>>,
            Record<string, never>
        >
        questions?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireStepContentQuestions>>,
            Record<string, never>
        >
    }
    QuestionnaireSubmissionNotification?: {
        emails?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuestionnaireSubmissionNotification>>,
            Record<string, never>
        >
    }
    QuotationEngagementRing?: {
        baseTemplate?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuotationEngagementRing>>,
            Record<string, never>
        >
        centreStone?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuotationEngagementRing>>,
            Record<string, never>
        >
        customName?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuotationEngagementRing>>,
            Record<string, never>
        >
        finalUntil?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuotationEngagementRing>>,
            Record<string, never>
        >
        firstAvailableDeliveryDate?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuotationEngagementRing>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuotationEngagementRing>>,
            Record<string, never>
        >
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuotationEngagementRing>>,
            Record<string, never>
        >
        images?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuotationEngagementRing>>,
            Record<string, never>
        >
        isRecommended?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuotationEngagementRing>>,
            Record<string, never>
        >
        isSalesTaxApplicable?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuotationEngagementRing>>,
            Record<string, never>
        >
        isVatApplicable?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuotationEngagementRing>>,
            Record<string, never>
        >
        mount?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuotationEngagementRing>>,
            Record<string, never>
        >
        totalSalePrice?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuotationEngagementRing>>,
            Record<string, never>
        >
    }
    QuotationManualSurcharge?: {
        amount?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuotationManualSurcharge>>,
            Record<string, never>
        >
        description?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuotationManualSurcharge>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuotationManualSurcharge>>,
            Record<string, never>
        >
    }
    QuotationPercentageSurcharge?: {
        description?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuotationPercentageSurcharge>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuotationPercentageSurcharge>>,
            Record<string, never>
        >
        percent?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuotationPercentageSurcharge>>,
            Record<string, never>
        >
    }
    QuotationWeddingRing?: {
        baseTemplate?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuotationWeddingRing>>,
            Record<string, never>
        >
        comment?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuotationWeddingRing>>,
            Record<string, never>
        >
        customName?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuotationWeddingRing>>,
            Record<string, never>
        >
        finalUntil?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuotationWeddingRing>>,
            Record<string, never>
        >
        firstAvailableDeliveryDate?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuotationWeddingRing>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuotationWeddingRing>>,
            Record<string, never>
        >
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuotationWeddingRing>>,
            Record<string, never>
        >
        images?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuotationWeddingRing>>,
            Record<string, never>
        >
        isRecommended?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuotationWeddingRing>>,
            Record<string, never>
        >
        isSalesTaxApplicable?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuotationWeddingRing>>,
            Record<string, never>
        >
        isVatApplicable?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuotationWeddingRing>>,
            Record<string, never>
        >
        manualSurcharges?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuotationWeddingRing>>,
            Record<string, never>
        >
        metals?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuotationWeddingRing>>,
            Record<string, never>
        >
        percentageSurcharge?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuotationWeddingRing>>,
            Record<string, never>
        >
        signatureStones?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuotationWeddingRing>>,
            Record<string, never>
        >
        totalSalePrice?: GraphCacheUpdateResolver<
            Maybe<WithTypename<QuotationWeddingRing>>,
            Record<string, never>
        >
    }
    RecommendedRingSize?: {
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<RecommendedRingSize>>,
            Record<string, never>
        >
        label?: GraphCacheUpdateResolver<
            Maybe<WithTypename<RecommendedRingSize>>,
            RecommendedRingSizeLabelArgs
        >
        ringSize?: GraphCacheUpdateResolver<
            Maybe<WithTypename<RecommendedRingSize>>,
            Record<string, never>
        >
    }
    Region?: {
        code?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Region>>,
            Record<string, never>
        >
        currency?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Region>>,
            Record<string, never>
        >
        isActive?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Region>>,
            Record<string, never>
        >
        language?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Region>>,
            Record<string, never>
        >
        locales?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Region>>,
            Record<string, never>
        >
        representingCountry?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Region>>,
            Record<string, never>
        >
    }
    Review?: {
        comment?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Review>>,
            Record<string, never>
        >
        date?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Review>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Review>>,
            Record<string, never>
        >
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Review>>,
            Record<string, never>
        >
        picture?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Review>>,
            Record<string, never>
        >
        products?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Review>>,
            ReviewProductsArgs
        >
        rating?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Review>>,
            Record<string, never>
        >
    }
    ReviewCarouselCard?: {
        author?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ReviewCarouselCard>>,
            Record<string, never>
        >
        date?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ReviewCarouselCard>>,
            Record<string, never>
        >
        review?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ReviewCarouselCard>>,
            Record<string, never>
        >
        starsCount?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ReviewCarouselCard>>,
            Record<string, never>
        >
    }
    RingBuilder?: {
        failure?: GraphCacheUpdateResolver<
            Maybe<WithTypename<RingBuilder>>,
            Record<string, never>
        >
        financeOptionsAffirm?: GraphCacheUpdateResolver<
            Maybe<WithTypename<RingBuilder>>,
            RingBuilderFinanceOptionsAffirmArgs
        >
        financeOptionsKlarna?: GraphCacheUpdateResolver<
            Maybe<WithTypename<RingBuilder>>,
            RingBuilderFinanceOptionsKlarnaArgs
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<RingBuilder>>,
            Record<string, never>
        >
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<RingBuilder>>,
            Record<string, never>
        >
        position1?: GraphCacheUpdateResolver<
            Maybe<WithTypename<RingBuilder>>,
            Record<string, never>
        >
        position2?: GraphCacheUpdateResolver<
            Maybe<WithTypename<RingBuilder>>,
            Record<string, never>
        >
        productId?: GraphCacheUpdateResolver<
            Maybe<WithTypename<RingBuilder>>,
            Record<string, never>
        >
        salePrice?: GraphCacheUpdateResolver<
            Maybe<WithTypename<RingBuilder>>,
            RingBuilderSalePriceArgs
        >
        stoneRecommendations?: GraphCacheUpdateResolver<
            Maybe<WithTypename<RingBuilder>>,
            RingBuilderStoneRecommendationsArgs
        >
        totalSalePrice?: GraphCacheUpdateResolver<
            Maybe<WithTypename<RingBuilder>>,
            RingBuilderTotalSalePriceArgs
        >
    }
    RingBuilderCentreStoneFragment?: {
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<RingBuilderCentreStoneFragment>>,
            Record<string, never>
        >
        stone?: GraphCacheUpdateResolver<
            Maybe<WithTypename<RingBuilderCentreStoneFragment>>,
            Record<string, never>
        >
        totalSalePrice?: GraphCacheUpdateResolver<
            Maybe<WithTypename<RingBuilderCentreStoneFragment>>,
            RingBuilderCentreStoneFragmentTotalSalePriceArgs
        >
    }
    RingBuilderMountFragment?: {
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<RingBuilderMountFragment>>,
            Record<string, never>
        >
        ring?: GraphCacheUpdateResolver<
            Maybe<WithTypename<RingBuilderMountFragment>>,
            Record<string, never>
        >
        signatureStone?: GraphCacheUpdateResolver<
            Maybe<WithTypename<RingBuilderMountFragment>>,
            Record<string, never>
        >
        stoneRecommendations?: GraphCacheUpdateResolver<
            Maybe<WithTypename<RingBuilderMountFragment>>,
            RingBuilderMountFragmentStoneRecommendationsArgs
        >
        totalSalePrice?: GraphCacheUpdateResolver<
            Maybe<WithTypename<RingBuilderMountFragment>>,
            RingBuilderMountFragmentTotalSalePriceArgs
        >
    }
    RingBuilderResolvedExistingCustomerSuccess?: {
        data?: GraphCacheUpdateResolver<
            Maybe<WithTypename<RingBuilderResolvedExistingCustomerSuccess>>,
            Record<string, never>
        >
        redirect?: GraphCacheUpdateResolver<
            Maybe<WithTypename<RingBuilderResolvedExistingCustomerSuccess>>,
            Record<string, never>
        >
        ringBuilder?: GraphCacheUpdateResolver<
            Maybe<WithTypename<RingBuilderResolvedExistingCustomerSuccess>>,
            Record<string, never>
        >
    }
    RingBuilderResolvedFailure?: {
        errors?: GraphCacheUpdateResolver<
            Maybe<WithTypename<RingBuilderResolvedFailure>>,
            Record<string, never>
        >
        ringBuilder?: GraphCacheUpdateResolver<
            Maybe<WithTypename<RingBuilderResolvedFailure>>,
            Record<string, never>
        >
    }
    RingBuilderResolvedNewCustomerSuccess?: {
        customer?: GraphCacheUpdateResolver<
            Maybe<WithTypename<RingBuilderResolvedNewCustomerSuccess>>,
            Record<string, never>
        >
        data?: GraphCacheUpdateResolver<
            Maybe<WithTypename<RingBuilderResolvedNewCustomerSuccess>>,
            Record<string, never>
        >
        redirect?: GraphCacheUpdateResolver<
            Maybe<WithTypename<RingBuilderResolvedNewCustomerSuccess>>,
            Record<string, never>
        >
        ringBuilder?: GraphCacheUpdateResolver<
            Maybe<WithTypename<RingBuilderResolvedNewCustomerSuccess>>,
            Record<string, never>
        >
    }
    RingBuilderSetResult?: {
        errors?: GraphCacheUpdateResolver<
            Maybe<WithTypename<RingBuilderSetResult>>,
            Record<string, never>
        >
        ringBuilder?: GraphCacheUpdateResolver<
            Maybe<WithTypename<RingBuilderSetResult>>,
            Record<string, never>
        >
    }
    RingSize?: {
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<RingSize>>,
            Record<string, never>
        >
        label?: GraphCacheUpdateResolver<
            Maybe<WithTypename<RingSize>>,
            RingSizeLabelArgs
        >
    }
    SalePrice?: {
        tax?: GraphCacheUpdateResolver<
            Maybe<WithTypename<SalePrice>>,
            Record<string, never>
        >
        total?: GraphCacheUpdateResolver<
            Maybe<WithTypename<SalePrice>>,
            Record<string, never>
        >
    }
    SearchEverywhereResponse?: {
        customers?: GraphCacheUpdateResolver<
            Maybe<WithTypename<SearchEverywhereResponse>>,
            Record<string, never>
        >
        orders?: GraphCacheUpdateResolver<
            Maybe<WithTypename<SearchEverywhereResponse>>,
            Record<string, never>
        >
        products?: GraphCacheUpdateResolver<
            Maybe<WithTypename<SearchEverywhereResponse>>,
            Record<string, never>
        >
    }
    SetDeliveryInformationFailureResponse?: {
        errors?: GraphCacheUpdateResolver<
            Maybe<WithTypename<SetDeliveryInformationFailureResponse>>,
            Record<string, never>
        >
    }
    SetDeliveryInformationSuccessResponse?: {
        order?: GraphCacheUpdateResolver<
            Maybe<WithTypename<SetDeliveryInformationSuccessResponse>>,
            Record<string, never>
        >
    }
    ShipmentTrackingInformation?: {
        dispatchedAt?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ShipmentTrackingInformation>>,
            Record<string, never>
        >
        shippingCompany?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ShipmentTrackingInformation>>,
            Record<string, never>
        >
        trackingNumber?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ShipmentTrackingInformation>>,
            Record<string, never>
        >
        trackingUrl?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ShipmentTrackingInformation>>,
            Record<string, never>
        >
    }
    ShopWithConfidenceEthnicallySourcedDiamonds?: {
        content?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ShopWithConfidenceEthnicallySourcedDiamonds>>,
            Record<string, never>
        >
    }
    ShopWithConfidenceFinancingOptions?: {
        content?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ShopWithConfidenceFinancingOptions>>,
            Record<string, never>
        >
    }
    ShopWithConfidenceGreenlandRuby?: {
        content?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ShopWithConfidenceGreenlandRuby>>,
            Record<string, never>
        >
    }
    ShopWithConfidenceHandFinished?: {
        content?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ShopWithConfidenceHandFinished>>,
            Record<string, never>
        >
    }
    ShopWithConfidenceResize?: {
        content?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ShopWithConfidenceResize>>,
            Record<string, never>
        >
    }
    ShopWithConfidenceReturnPolicy?: {
        content?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ShopWithConfidenceReturnPolicy>>,
            Record<string, never>
        >
    }
    ShopWithConfidenceShipping?: {
        content?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ShopWithConfidenceShipping>>,
            Record<string, never>
        >
    }
    Showroom?: {
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Showroom>>,
            Record<string, never>
        >
        isAccessible?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Showroom>>,
            Record<string, never>
        >
        location?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Showroom>>,
            Record<string, never>
        >
        timezone?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Showroom>>,
            Record<string, never>
        >
        translation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Showroom>>,
            ShowroomTranslationArgs
        >
    }
    ShowroomLocation?: {
        addressLine1?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ShowroomLocation>>,
            Record<string, never>
        >
        addressLine2?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ShowroomLocation>>,
            Record<string, never>
        >
        city?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ShowroomLocation>>,
            Record<string, never>
        >
        country?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ShowroomLocation>>,
            Record<string, never>
        >
        geoLocation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ShowroomLocation>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ShowroomLocation>>,
            Record<string, never>
        >
        postalCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ShowroomLocation>>,
            Record<string, never>
        >
        subdivision?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ShowroomLocation>>,
            Record<string, never>
        >
    }
    ShowroomTranslation?: {
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<ShowroomTranslation>>,
            Record<string, never>
        >
    }
    SocialNetwork?: {
        icon?: GraphCacheUpdateResolver<
            Maybe<WithTypename<SocialNetwork>>,
            Record<string, never>
        >
        link?: GraphCacheUpdateResolver<
            Maybe<WithTypename<SocialNetwork>>,
            Record<string, never>
        >
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<SocialNetwork>>,
            Record<string, never>
        >
    }
    SquareImageBox?: {
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<SquareImageBox>>,
            Record<string, never>
        >
        link?: GraphCacheUpdateResolver<
            Maybe<WithTypename<SquareImageBox>>,
            Record<string, never>
        >
    }
    SquareTextBox?: {
        backgroundColor?: GraphCacheUpdateResolver<
            Maybe<WithTypename<SquareTextBox>>,
            Record<string, never>
        >
        content?: GraphCacheUpdateResolver<
            Maybe<WithTypename<SquareTextBox>>,
            Record<string, never>
        >
    }
    Stone?: {
        caratWeight?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Stone>>,
            Record<string, never>
        >
        certificate?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Stone>>,
            Record<string, never>
        >
        clarity?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Stone>>,
            Record<string, never>
        >
        color?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Stone>>,
            Record<string, never>
        >
        colorGrade?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Stone>>,
            Record<string, never>
        >
        crystal?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Stone>>,
            Record<string, never>
        >
        cut?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Stone>>,
            Record<string, never>
        >
        depthPercent?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Stone>>,
            Record<string, never>
        >
        fluorescence?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Stone>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Stone>>,
            Record<string, never>
        >
        measurements?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Stone>>,
            Record<string, never>
        >
        photo?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Stone>>,
            Record<string, never>
        >
        polish?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Stone>>,
            Record<string, never>
        >
        ratio?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Stone>>,
            Record<string, never>
        >
        shape?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Stone>>,
            Record<string, never>
        >
        symmetry?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Stone>>,
            Record<string, never>
        >
        tablePercent?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Stone>>,
            Record<string, never>
        >
    }
    StoneCategory?: {
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneCategory>>,
            Record<string, never>
        >
        translation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneCategory>>,
            StoneCategoryTranslationArgs
        >
    }
    StoneCategoryTranslation?: {
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneCategoryTranslation>>,
            Record<string, never>
        >
    }
    StoneCertificate?: {
        number?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneCertificate>>,
            Record<string, never>
        >
        uri?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneCertificate>>,
            Record<string, never>
        >
    }
    StoneClarity?: {
        abbreviation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneClarity>>,
            Record<string, never>
        >
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneClarity>>,
            Record<string, never>
        >
        translation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneClarity>>,
            StoneClarityTranslationArgs
        >
    }
    StoneClarityTranslation?: {
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneClarityTranslation>>,
            Record<string, never>
        >
    }
    StoneColor?: {
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneColor>>,
            Record<string, never>
        >
        translation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneColor>>,
            StoneColorTranslationArgs
        >
    }
    StoneColorTranslation?: {
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneColorTranslation>>,
            Record<string, never>
        >
    }
    StoneCrystal?: {
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneCrystal>>,
            Record<string, never>
        >
        translation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneCrystal>>,
            StoneCrystalTranslationArgs
        >
    }
    StoneCrystalTranslation?: {
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneCrystalTranslation>>,
            Record<string, never>
        >
    }
    StoneCut?: {
        abbreviation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneCut>>,
            Record<string, never>
        >
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneCut>>,
            Record<string, never>
        >
        translation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneCut>>,
            StoneCutTranslationArgs
        >
    }
    StoneCutTranslation?: {
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneCutTranslation>>,
            Record<string, never>
        >
    }
    StoneFluorescence?: {
        abbreviation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneFluorescence>>,
            Record<string, never>
        >
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneFluorescence>>,
            Record<string, never>
        >
        translation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneFluorescence>>,
            StoneFluorescenceTranslationArgs
        >
    }
    StoneFluorescenceTranslation?: {
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneFluorescenceTranslation>>,
            Record<string, never>
        >
    }
    StoneGrade?: {
        category?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneGrade>>,
            Record<string, never>
        >
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneGrade>>,
            Record<string, never>
        >
        translation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneGrade>>,
            StoneGradeTranslationArgs
        >
    }
    StoneGradeTranslation?: {
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneGradeTranslation>>,
            Record<string, never>
        >
    }
    StoneMeasurements?: {
        depth?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneMeasurements>>,
            Record<string, never>
        >
        length?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneMeasurements>>,
            Record<string, never>
        >
        width?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneMeasurements>>,
            Record<string, never>
        >
    }
    StonePolish?: {
        abbreviation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StonePolish>>,
            Record<string, never>
        >
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StonePolish>>,
            Record<string, never>
        >
        translation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StonePolish>>,
            StonePolishTranslationArgs
        >
    }
    StonePolishTranslation?: {
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StonePolishTranslation>>,
            Record<string, never>
        >
    }
    StoneRecommendationNonSkuGemstone?: {
        color?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneRecommendationNonSkuGemstone>>,
            Record<string, never>
        >
        item?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneRecommendationNonSkuGemstone>>,
            Record<string, never>
        >
    }
    StoneRecommendationNotFound?: {
        haveWithoutPricingRange?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneRecommendationNotFound>>,
            Record<string, never>
        >
    }
    StoneRecommendationsNaturalDiamondFilters?: {
        clarities?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneRecommendationsNaturalDiamondFilters>>,
            Record<string, never>
        >
        colors?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneRecommendationsNaturalDiamondFilters>>,
            Record<string, never>
        >
        cuts?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneRecommendationsNaturalDiamondFilters>>,
            Record<string, never>
        >
        depthPercentRange?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneRecommendationsNaturalDiamondFilters>>,
            Record<string, never>
        >
        fluorescences?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneRecommendationsNaturalDiamondFilters>>,
            Record<string, never>
        >
        maxCaratWeight?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneRecommendationsNaturalDiamondFilters>>,
            Record<string, never>
        >
        minCaratWeight?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneRecommendationsNaturalDiamondFilters>>,
            Record<string, never>
        >
        polishes?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneRecommendationsNaturalDiamondFilters>>,
            Record<string, never>
        >
        priceMax?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneRecommendationsNaturalDiamondFilters>>,
            StoneRecommendationsNaturalDiamondFiltersPriceMaxArgs
        >
        priceMin?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneRecommendationsNaturalDiamondFilters>>,
            StoneRecommendationsNaturalDiamondFiltersPriceMinArgs
        >
        region?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneRecommendationsNaturalDiamondFilters>>,
            Record<string, never>
        >
        shape?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneRecommendationsNaturalDiamondFilters>>,
            Record<string, never>
        >
        symmetries?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneRecommendationsNaturalDiamondFilters>>,
            Record<string, never>
        >
        tablePercentRange?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneRecommendationsNaturalDiamondFilters>>,
            Record<string, never>
        >
    }
    StoneRecommendationsPercentRange?: {
        max?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneRecommendationsPercentRange>>,
            Record<string, never>
        >
        min?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneRecommendationsPercentRange>>,
            Record<string, never>
        >
    }
    StoneRecommendationsPriceRange?: {
        max?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneRecommendationsPriceRange>>,
            Record<string, never>
        >
        min?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneRecommendationsPriceRange>>,
            Record<string, never>
        >
    }
    StoneRecommendationsResponseFailure?: {
        error?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneRecommendationsResponseFailure>>,
            Record<string, never>
        >
    }
    StoneRecommendationsResponseSuccess?: {
        naturalDiamondBestForBalance?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneRecommendationsResponseSuccess>>,
            Record<string, never>
        >
        naturalDiamondBestForBalanceFilters?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneRecommendationsResponseSuccess>>,
            Record<string, never>
        >
        naturalDiamondBestForSize?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneRecommendationsResponseSuccess>>,
            Record<string, never>
        >
        naturalDiamondBestForSizeFilters?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneRecommendationsResponseSuccess>>,
            Record<string, never>
        >
        nonSkuGemStones?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneRecommendationsResponseSuccess>>,
            StoneRecommendationsResponseSuccessNonSkuGemStonesArgs
        >
        nonSkuLabGrownBestForPrice?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneRecommendationsResponseSuccess>>,
            Record<string, never>
        >
        nonSkuLabGrownBestForSize?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneRecommendationsResponseSuccess>>,
            Record<string, never>
        >
        priceBounds?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneRecommendationsResponseSuccess>>,
            Record<string, never>
        >
        priceInitialValues?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneRecommendationsResponseSuccess>>,
            Record<string, never>
        >
    }
    StoneShape?: {
        icon?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneShape>>,
            Record<string, never>
        >
        samplePhoto?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneShape>>,
            Record<string, never>
        >
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneShape>>,
            Record<string, never>
        >
        translation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneShape>>,
            StoneShapeTranslationArgs
        >
    }
    StoneShapeTranslation?: {
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneShapeTranslation>>,
            Record<string, never>
        >
    }
    StoneSymmetry?: {
        abbreviation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneSymmetry>>,
            Record<string, never>
        >
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneSymmetry>>,
            Record<string, never>
        >
        translation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneSymmetry>>,
            StoneSymmetryTranslationArgs
        >
    }
    StoneSymmetryTranslation?: {
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StoneSymmetryTranslation>>,
            Record<string, never>
        >
    }
    StripeTransaction?: {
        amount?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StripeTransaction>>,
            Record<string, never>
        >
        createdAt?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StripeTransaction>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StripeTransaction>>,
            Record<string, never>
        >
        status?: GraphCacheUpdateResolver<
            Maybe<WithTypename<StripeTransaction>>,
            Record<string, never>
        >
    }
    SubMenu?: {
        description?: GraphCacheUpdateResolver<
            Maybe<WithTypename<SubMenu>>,
            Record<string, never>
        >
        editorialContent?: GraphCacheUpdateResolver<
            Maybe<WithTypename<SubMenu>>,
            Record<string, never>
        >
        sections?: GraphCacheUpdateResolver<
            Maybe<WithTypename<SubMenu>>,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<SubMenu>>,
            Record<string, never>
        >
        useLargeFormatItems?: GraphCacheUpdateResolver<
            Maybe<WithTypename<SubMenu>>,
            Record<string, never>
        >
    }
    SubMenuEditorialContent?: {
        image?: GraphCacheUpdateResolver<
            Maybe<WithTypename<SubMenuEditorialContent>>,
            Record<string, never>
        >
        link?: GraphCacheUpdateResolver<
            Maybe<WithTypename<SubMenuEditorialContent>>,
            Record<string, never>
        >
        text?: GraphCacheUpdateResolver<
            Maybe<WithTypename<SubMenuEditorialContent>>,
            Record<string, never>
        >
    }
    SubMenuItem?: {
        icon?: GraphCacheUpdateResolver<
            Maybe<WithTypename<SubMenuItem>>,
            Record<string, never>
        >
        link?: GraphCacheUpdateResolver<
            Maybe<WithTypename<SubMenuItem>>,
            Record<string, never>
        >
        media?: GraphCacheUpdateResolver<
            Maybe<WithTypename<SubMenuItem>>,
            Record<string, never>
        >
        style?: GraphCacheUpdateResolver<
            Maybe<WithTypename<SubMenuItem>>,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<SubMenuItem>>,
            Record<string, never>
        >
    }
    SubMenuSection?: {
        items?: GraphCacheUpdateResolver<
            Maybe<WithTypename<SubMenuSection>>,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<SubMenuSection>>,
            Record<string, never>
        >
    }
    Table?: {
        body?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Table>>,
            Record<string, never>
        >
        header?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Table>>,
            Record<string, never>
        >
    }
    TableBody?: {
        rows?: GraphCacheUpdateResolver<
            Maybe<WithTypename<TableBody>>,
            Record<string, never>
        >
    }
    TableHeader?: {
        cells?: GraphCacheUpdateResolver<
            Maybe<WithTypename<TableHeader>>,
            Record<string, never>
        >
    }
    TableRow?: {
        cells?: GraphCacheUpdateResolver<
            Maybe<WithTypename<TableRow>>,
            Record<string, never>
        >
    }
    Tax?: {
        price?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Tax>>,
            Record<string, never>
        >
        type?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Tax>>,
            Record<string, never>
        >
    }
    TextCarouselItem?: {
        text?: GraphCacheUpdateResolver<
            Maybe<WithTypename<TextCarouselItem>>,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<TextCarouselItem>>,
            Record<string, never>
        >
    }
    Tooltip?: {
        content?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Tooltip>>,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Tooltip>>,
            Record<string, never>
        >
    }
    TopBar?: {
        consultationPrompt?: GraphCacheUpdateResolver<
            Maybe<WithTypename<TopBar>>,
            Record<string, never>
        >
        siteWideMessage?: GraphCacheUpdateResolver<
            Maybe<WithTypename<TopBar>>,
            Record<string, never>
        >
    }
    TopBarConsultationPrompt?: {
        link?: GraphCacheUpdateResolver<
            Maybe<WithTypename<TopBarConsultationPrompt>>,
            Record<string, never>
        >
    }
    TopBarSiteWideMessage?: {
        link?: GraphCacheUpdateResolver<
            Maybe<WithTypename<TopBarSiteWideMessage>>,
            Record<string, never>
        >
        message?: GraphCacheUpdateResolver<
            Maybe<WithTypename<TopBarSiteWideMessage>>,
            Record<string, never>
        >
    }
    TransactionStatus?: {
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<TransactionStatus>>,
            TransactionStatusNameArgs
        >
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<TransactionStatus>>,
            Record<string, never>
        >
    }
    Translation?: {
        token?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Translation>>,
            Record<string, never>
        >
        translation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Translation>>,
            Record<string, never>
        >
    }
    User?: {
        createdAt?: GraphCacheUpdateResolver<
            Maybe<WithTypename<User>>,
            Record<string, never>
        >
        customer?: GraphCacheUpdateResolver<
            Maybe<WithTypename<User>>,
            Record<string, never>
        >
        email?: GraphCacheUpdateResolver<
            Maybe<WithTypename<User>>,
            Record<string, never>
        >
        firstName?: GraphCacheUpdateResolver<
            Maybe<WithTypename<User>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<User>>,
            Record<string, never>
        >
        isConsultant?: GraphCacheUpdateResolver<
            Maybe<WithTypename<User>>,
            Record<string, never>
        >
        lastName?: GraphCacheUpdateResolver<
            Maybe<WithTypename<User>>,
            Record<string, never>
        >
    }
    UserCustomerEngagementRingRecommendations?: {
        designFeature?: GraphCacheUpdateResolver<
            Maybe<WithTypename<UserCustomerEngagementRingRecommendations>>,
            Record<string, never>
        >
        designStyle?: GraphCacheUpdateResolver<
            Maybe<WithTypename<UserCustomerEngagementRingRecommendations>>,
            Record<string, never>
        >
        items?: GraphCacheUpdateResolver<
            Maybe<WithTypename<UserCustomerEngagementRingRecommendations>>,
            UserCustomerEngagementRingRecommendationsItemsArgs
        >
        metal?: GraphCacheUpdateResolver<
            Maybe<WithTypename<UserCustomerEngagementRingRecommendations>>,
            Record<string, never>
        >
        ringStyle?: GraphCacheUpdateResolver<
            Maybe<WithTypename<UserCustomerEngagementRingRecommendations>>,
            Record<string, never>
        >
        shape?: GraphCacheUpdateResolver<
            Maybe<WithTypename<UserCustomerEngagementRingRecommendations>>,
            Record<string, never>
        >
    }
    Video?: {
        alt?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Video>>,
            Record<string, never>
        >
        caption?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Video>>,
            Record<string, never>
        >
        description?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Video>>,
            Record<string, never>
        >
        filename?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Video>>,
            Record<string, never>
        >
        filesize?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Video>>,
            Record<string, never>
        >
        height?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Video>>,
            Record<string, never>
        >
        id?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Video>>,
            Record<string, never>
        >
        mimeType?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Video>>,
            Record<string, never>
        >
        name?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Video>>,
            Record<string, never>
        >
        title?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Video>>,
            Record<string, never>
        >
        url?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Video>>,
            Record<string, never>
        >
        width?: GraphCacheUpdateResolver<
            Maybe<WithTypename<Video>>,
            Record<string, never>
        >
    }
    WeddingRingCategoryLabel?: {
        icon?: GraphCacheUpdateResolver<
            Maybe<WithTypename<WeddingRingCategoryLabel>>,
            Record<string, never>
        >
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<WeddingRingCategoryLabel>>,
            Record<string, never>
        >
        translation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<WeddingRingCategoryLabel>>,
            WeddingRingCategoryLabelTranslationArgs
        >
    }
    WeddingRingStyleLabel?: {
        icon?: GraphCacheUpdateResolver<
            Maybe<WithTypename<WeddingRingStyleLabel>>,
            Record<string, never>
        >
        systemCode?: GraphCacheUpdateResolver<
            Maybe<WithTypename<WeddingRingStyleLabel>>,
            Record<string, never>
        >
        translation?: GraphCacheUpdateResolver<
            Maybe<WithTypename<WeddingRingStyleLabel>>,
            WeddingRingStyleLabelTranslationArgs
        >
    }
    WorkingHours?: {
        closing?: GraphCacheUpdateResolver<
            Maybe<WithTypename<WorkingHours>>,
            Record<string, never>
        >
        opening?: GraphCacheUpdateResolver<
            Maybe<WithTypename<WorkingHours>>,
            Record<string, never>
        >
        weekDays?: GraphCacheUpdateResolver<
            Maybe<WithTypename<WorkingHours>>,
            Record<string, never>
        >
    }
}

export type GraphCacheConfig = Parameters<typeof cacheExchange>[0] & {
    updates?: GraphCacheUpdaters
    keys?: GraphCacheKeysConfig
    optimistic?: GraphCacheOptimisticUpdaters
    resolvers?: GraphCacheResolvers
}
